var o9 = Object.defineProperty;
var a9 = (e, t, o) => t in e ? o9(e, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[t] = o;
var zt = (e, t, o) => a9(e, typeof t != "symbol" ? t + "" : t, o);
import { jsx as D, jsxs as ne, Fragment as Et } from "react/jsx-runtime";
import * as ue from "react";
import sr, { useState as Xe, useEffect as St, useRef as _r, useMemo as Ce, useCallback as ht, useContext as wa, isValidElement as j0, cloneElement as O0, Children as s9, forwardRef as c9, createContext as l9, memo as Sn, Component as f9 } from "react";
import { d as fe, g as Yi, s as Gt, c as Wt, a as u9, b as Wr, e as Y1, r as sg, U as lo, f as Ll, h as Sl, i as Do, j as Ya, k as Ic, l as d9, W as un, m as Wi, n as Vr, o as h9, p as cg, q as p9, t as ki, R as lg, w as oi, u as yn, v as cr, E as g9, x as y9, y as M9, z as fg, A as Pd, T as Xo, B as Ud, C as Yd, D as Co, F as ai, G as W1, H as H1, P as Ko, I as m9, J as v9, K as ug, L as b9, M as x9, N as vn, O as Wd, Q as w9, S as C9, V as El, X as Dl, Y as ao } from "./address-CmQhtpW5.mjs";
import { C as I9, a as N9, b as l2, W as dg } from "./constants-JcJZbG9m.mjs";
import { R as A9, A as T9, C as L9, a as S9, T as E9, b as D9, c as j9, r as O9 } from "./address-BMye0hhZ.mjs";
import { i as z9, a as k9, b as _9 } from "./address-Rw63xjyN.mjs";
import { useTheme as er, Box as ut, createSvgIcon as dn, Collapse as hg, Select as B9, MenuItem as f2, CircularProgress as Z1, Typography as ln, useMediaQuery as Hi, Tooltip as ws, Skeleton as ea, Card as Q1, CardContent as pg, Stack as yo, ListItemButton as gg, IconButton as F9, Button as R9, TextField as P9 } from "@mui/material";
import { unstable_createGetCssVar as U9, createSpacing as Y9, useTheme as W9, GlobalStyles as H9, unstable_memoTheme as Z9, ThemeProvider as Q9, unstable_createCssVarsProvider as V9, createBox as G9, css as jo, keyframes as fi, createStack as $9, alpha as q9 } from "@mui/system";
import { g as q0, T as J9, a as X9, b as K9, N as e7 } from "./mint-BcPtpVRv.mjs";
import t7, { internal_serializeStyles as Mo, internal_mutateStyles as r7 } from "@mui/styled-engine";
var Hd = { exports: {} }, pr = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var u2;
function n7() {
  if (u2) return pr;
  u2 = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), n = Symbol.for("react.consumer"), d = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), M = Symbol.for("react.view_transition"), C = Symbol.for("react.client.reference");
  function N(w) {
    if (typeof w == "object" && w !== null) {
      var S = w.$$typeof;
      switch (S) {
        case e:
          switch (w = w.type, w) {
            case o:
            case c:
            case i:
            case p:
            case l:
            case M:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case d:
                case f:
                case y:
                case h:
                  return w;
                case n:
                  return w;
                default:
                  return S;
              }
          }
        case t:
          return S;
      }
    }
  }
  return pr.ContextConsumer = n, pr.ContextProvider = d, pr.Element = e, pr.ForwardRef = f, pr.Fragment = o, pr.Lazy = y, pr.Memo = h, pr.Portal = t, pr.Profiler = c, pr.StrictMode = i, pr.Suspense = p, pr.SuspenseList = l, pr.isContextConsumer = function(w) {
    return N(w) === n;
  }, pr.isContextProvider = function(w) {
    return N(w) === d;
  }, pr.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === e;
  }, pr.isForwardRef = function(w) {
    return N(w) === f;
  }, pr.isFragment = function(w) {
    return N(w) === o;
  }, pr.isLazy = function(w) {
    return N(w) === y;
  }, pr.isMemo = function(w) {
    return N(w) === h;
  }, pr.isPortal = function(w) {
    return N(w) === t;
  }, pr.isProfiler = function(w) {
    return N(w) === c;
  }, pr.isStrictMode = function(w) {
    return N(w) === i;
  }, pr.isSuspense = function(w) {
    return N(w) === p;
  }, pr.isSuspenseList = function(w) {
    return N(w) === l;
  }, pr.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === o || w === c || w === i || w === p || w === l || typeof w == "object" && w !== null && (w.$$typeof === y || w.$$typeof === h || w.$$typeof === d || w.$$typeof === n || w.$$typeof === f || w.$$typeof === C || w.getModuleId !== void 0);
  }, pr.typeOf = N, pr;
}
var gr = {}, d2;
function i7() {
  return d2 || (d2 = 1, fe.process.env.NODE_ENV !== "production" && function() {
    function e(w) {
      if (typeof w == "object" && w !== null) {
        var S = w.$$typeof;
        switch (S) {
          case t:
            switch (w = w.type, w) {
              case i:
              case n:
              case c:
              case l:
              case h:
              case C:
                return w;
              default:
                switch (w = w && w.$$typeof, w) {
                  case f:
                  case p:
                  case M:
                  case y:
                    return w;
                  case d:
                    return w;
                  default:
                    return S;
                }
            }
          case o:
            return S;
        }
      }
    }
    var t = Symbol.for("react.transitional.element"), o = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), c = Symbol.for("react.strict_mode"), n = Symbol.for("react.profiler"), d = Symbol.for("react.consumer"), f = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), M = Symbol.for("react.lazy"), C = Symbol.for("react.view_transition"), N = Symbol.for("react.client.reference");
    gr.ContextConsumer = d, gr.ContextProvider = f, gr.Element = t, gr.ForwardRef = p, gr.Fragment = i, gr.Lazy = M, gr.Memo = y, gr.Portal = o, gr.Profiler = n, gr.StrictMode = c, gr.Suspense = l, gr.SuspenseList = h, gr.isContextConsumer = function(w) {
      return e(w) === d;
    }, gr.isContextProvider = function(w) {
      return e(w) === f;
    }, gr.isElement = function(w) {
      return typeof w == "object" && w !== null && w.$$typeof === t;
    }, gr.isForwardRef = function(w) {
      return e(w) === p;
    }, gr.isFragment = function(w) {
      return e(w) === i;
    }, gr.isLazy = function(w) {
      return e(w) === M;
    }, gr.isMemo = function(w) {
      return e(w) === y;
    }, gr.isPortal = function(w) {
      return e(w) === o;
    }, gr.isProfiler = function(w) {
      return e(w) === n;
    }, gr.isStrictMode = function(w) {
      return e(w) === c;
    }, gr.isSuspense = function(w) {
      return e(w) === l;
    }, gr.isSuspenseList = function(w) {
      return e(w) === h;
    }, gr.isValidElementType = function(w) {
      return typeof w == "string" || typeof w == "function" || w === i || w === n || w === c || w === l || w === h || typeof w == "object" && w !== null && (w.$$typeof === M || w.$$typeof === y || w.$$typeof === f || w.$$typeof === d || w.$$typeof === p || w.$$typeof === N || w.getModuleId !== void 0);
    }, gr.typeOf = e;
  }()), gr;
}
fe.process.env.NODE_ENV === "production" ? Hd.exports = n7() : Hd.exports = i7();
var _i = Hd.exports;
function ti(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function yg(e) {
  if (/* @__PURE__ */ ue.isValidElement(e) || _i.isValidElementType(e) || !ti(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((o) => {
    t[o] = yg(e[o]);
  }), t;
}
function on(e, t, o = {
  clone: !0
}) {
  const i = o.clone ? {
    ...e
  } : e;
  return ti(e) && ti(t) && Object.keys(t).forEach((c) => {
    /* @__PURE__ */ ue.isValidElement(t[c]) || _i.isValidElementType(t[c]) ? i[c] = t[c] : ti(t[c]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, c) && ti(e[c]) ? i[c] = on(e[c], t[c], o) : o.clone ? i[c] = ti(t[c]) ? yg(t[c]) : t[c] : i[c] = t[c];
  }), i;
}
function si(e, ...t) {
  const o = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((i) => o.searchParams.append("args[]", i)), `Minified MUI error #${e}; visit ${o} for the full message.`;
}
function it(e) {
  if (typeof e != "string")
    throw new Error(fe.process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : si(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Mg(e, t = "") {
  return e.displayName || e.name || t;
}
function h2(e, t, o) {
  const i = Mg(t);
  return e.displayName || (i !== "" ? `${o}(${i})` : o);
}
function o7(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return Mg(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case _i.ForwardRef:
          return h2(e, e.render, "ForwardRef");
        case _i.Memo:
          return h2(e, e.type, "memo");
        default:
          return;
      }
  }
}
const a7 = (e) => {
  const t = Object.keys(e).map((o) => ({
    key: o,
    val: e[o]
  })) || [];
  return t.sort((o, i) => o.val - i.val), t.reduce((o, i) => ({
    ...o,
    [i.key]: i.val
  }), {});
};
function s7(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: o = "px",
    step: i = 5,
    ...c
  } = e, n = a7(t), d = Object.keys(n);
  function f(M) {
    return `@media (min-width:${typeof t[M] == "number" ? t[M] : M}${o})`;
  }
  function p(M) {
    return `@media (max-width:${(typeof t[M] == "number" ? t[M] : M) - i / 100}${o})`;
  }
  function l(M, C) {
    const N = d.indexOf(C);
    return `@media (min-width:${typeof t[M] == "number" ? t[M] : M}${o}) and (max-width:${(N !== -1 && typeof t[d[N]] == "number" ? t[d[N]] : C) - i / 100}${o})`;
  }
  function h(M) {
    return d.indexOf(M) + 1 < d.length ? l(M, d[d.indexOf(M) + 1]) : f(M);
  }
  function y(M) {
    const C = d.indexOf(M);
    return C === 0 ? f(d[1]) : C === d.length - 1 ? p(d[C]) : l(M, d[d.indexOf(M) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: d,
    values: n,
    up: f,
    down: p,
    between: l,
    only: h,
    not: y,
    unit: o,
    ...c
  };
}
function p2(e, t) {
  if (!e.containerQueries)
    return t;
  const o = Object.keys(t).filter((i) => i.startsWith("@container")).sort((i, c) => {
    var d, f;
    const n = /min-width:\s*([0-9.]+)/;
    return +(((d = i.match(n)) == null ? void 0 : d[1]) || 0) - +(((f = c.match(n)) == null ? void 0 : f[1]) || 0);
  });
  return o.length ? o.reduce((i, c) => {
    const n = t[c];
    return delete i[c], i[c] = n, i;
  }, {
    ...t
  }) : t;
}
function c7(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((o) => t.startsWith(`@${o}`)) || !!t.match(/^@\d/));
}
function l7(e, t) {
  const o = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!o) {
    if (fe.process.env.NODE_ENV !== "production")
      throw new Error(fe.process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${t})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : si(18, `(${t})`));
    return null;
  }
  const [, i, c] = o, n = Number.isNaN(+i) ? i || 0 : +i;
  return e.containerQueries(c).up(n);
}
function f7(e) {
  const t = (n, d) => n.replace("@media", d ? `@container ${d}` : "@container");
  function o(n, d) {
    n.up = (...f) => t(e.breakpoints.up(...f), d), n.down = (...f) => t(e.breakpoints.down(...f), d), n.between = (...f) => t(e.breakpoints.between(...f), d), n.only = (...f) => t(e.breakpoints.only(...f), d), n.not = (...f) => {
      const p = t(e.breakpoints.not(...f), d);
      return p.includes("not all and") ? p.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : p;
    };
  }
  const i = {}, c = (n) => (o(i, n), i);
  return o(c), {
    ...e,
    containerQueries: c
  };
}
const u7 = {
  borderRadius: 4
};
var Zd = { exports: {} }, Ks = { exports: {} }, lr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var g2;
function d7() {
  if (g2) return lr;
  g2 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, o = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, c = e ? Symbol.for("react.strict_mode") : 60108, n = e ? Symbol.for("react.profiler") : 60114, d = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, M = e ? Symbol.for("react.suspense_list") : 60120, C = e ? Symbol.for("react.memo") : 60115, N = e ? Symbol.for("react.lazy") : 60116, w = e ? Symbol.for("react.block") : 60121, S = e ? Symbol.for("react.fundamental") : 60117, T = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function j(z) {
    if (typeof z == "object" && z !== null) {
      var k = z.$$typeof;
      switch (k) {
        case t:
          switch (z = z.type, z) {
            case p:
            case l:
            case i:
            case n:
            case c:
            case y:
              return z;
            default:
              switch (z = z && z.$$typeof, z) {
                case f:
                case h:
                case N:
                case C:
                case d:
                  return z;
                default:
                  return k;
              }
          }
        case o:
          return k;
      }
    }
  }
  function O(z) {
    return j(z) === l;
  }
  return lr.AsyncMode = p, lr.ConcurrentMode = l, lr.ContextConsumer = f, lr.ContextProvider = d, lr.Element = t, lr.ForwardRef = h, lr.Fragment = i, lr.Lazy = N, lr.Memo = C, lr.Portal = o, lr.Profiler = n, lr.StrictMode = c, lr.Suspense = y, lr.isAsyncMode = function(z) {
    return O(z) || j(z) === p;
  }, lr.isConcurrentMode = O, lr.isContextConsumer = function(z) {
    return j(z) === f;
  }, lr.isContextProvider = function(z) {
    return j(z) === d;
  }, lr.isElement = function(z) {
    return typeof z == "object" && z !== null && z.$$typeof === t;
  }, lr.isForwardRef = function(z) {
    return j(z) === h;
  }, lr.isFragment = function(z) {
    return j(z) === i;
  }, lr.isLazy = function(z) {
    return j(z) === N;
  }, lr.isMemo = function(z) {
    return j(z) === C;
  }, lr.isPortal = function(z) {
    return j(z) === o;
  }, lr.isProfiler = function(z) {
    return j(z) === n;
  }, lr.isStrictMode = function(z) {
    return j(z) === c;
  }, lr.isSuspense = function(z) {
    return j(z) === y;
  }, lr.isValidElementType = function(z) {
    return typeof z == "string" || typeof z == "function" || z === i || z === l || z === n || z === c || z === y || z === M || typeof z == "object" && z !== null && (z.$$typeof === N || z.$$typeof === C || z.$$typeof === d || z.$$typeof === f || z.$$typeof === h || z.$$typeof === S || z.$$typeof === T || z.$$typeof === E || z.$$typeof === w);
  }, lr.typeOf = j, lr;
}
var fr = {}, y2;
function h7() {
  return y2 || (y2 = 1, fe.process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, o = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, c = e ? Symbol.for("react.strict_mode") : 60108, n = e ? Symbol.for("react.profiler") : 60114, d = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, M = e ? Symbol.for("react.suspense_list") : 60120, C = e ? Symbol.for("react.memo") : 60115, N = e ? Symbol.for("react.lazy") : 60116, w = e ? Symbol.for("react.block") : 60121, S = e ? Symbol.for("react.fundamental") : 60117, T = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function j(_) {
      return typeof _ == "string" || typeof _ == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      _ === i || _ === l || _ === n || _ === c || _ === y || _ === M || typeof _ == "object" && _ !== null && (_.$$typeof === N || _.$$typeof === C || _.$$typeof === d || _.$$typeof === f || _.$$typeof === h || _.$$typeof === S || _.$$typeof === T || _.$$typeof === E || _.$$typeof === w);
    }
    function O(_) {
      if (typeof _ == "object" && _ !== null) {
        var X = _.$$typeof;
        switch (X) {
          case t:
            var le = _.type;
            switch (le) {
              case p:
              case l:
              case i:
              case n:
              case c:
              case y:
                return le;
              default:
                var ie = le && le.$$typeof;
                switch (ie) {
                  case f:
                  case h:
                  case N:
                  case C:
                  case d:
                    return ie;
                  default:
                    return X;
                }
            }
          case o:
            return X;
        }
      }
    }
    var z = p, k = l, H = f, W = d, U = t, B = h, I = i, r = N, s = C, u = o, g = n, v = c, A = y, L = !1;
    function m(_) {
      return L || (L = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), a(_) || O(_) === p;
    }
    function a(_) {
      return O(_) === l;
    }
    function x(_) {
      return O(_) === f;
    }
    function V(_) {
      return O(_) === d;
    }
    function G(_) {
      return typeof _ == "object" && _ !== null && _.$$typeof === t;
    }
    function Z(_) {
      return O(_) === h;
    }
    function te(_) {
      return O(_) === i;
    }
    function q(_) {
      return O(_) === N;
    }
    function R(_) {
      return O(_) === C;
    }
    function Q(_) {
      return O(_) === o;
    }
    function $(_) {
      return O(_) === n;
    }
    function F(_) {
      return O(_) === c;
    }
    function P(_) {
      return O(_) === y;
    }
    fr.AsyncMode = z, fr.ConcurrentMode = k, fr.ContextConsumer = H, fr.ContextProvider = W, fr.Element = U, fr.ForwardRef = B, fr.Fragment = I, fr.Lazy = r, fr.Memo = s, fr.Portal = u, fr.Profiler = g, fr.StrictMode = v, fr.Suspense = A, fr.isAsyncMode = m, fr.isConcurrentMode = a, fr.isContextConsumer = x, fr.isContextProvider = V, fr.isElement = G, fr.isForwardRef = Z, fr.isFragment = te, fr.isLazy = q, fr.isMemo = R, fr.isPortal = Q, fr.isProfiler = $, fr.isStrictMode = F, fr.isSuspense = P, fr.isValidElementType = j, fr.typeOf = O;
  }()), fr;
}
var M2;
function mg() {
  return M2 || (M2 = 1, fe.process.env.NODE_ENV === "production" ? Ks.exports = d7() : Ks.exports = h7()), Ks.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var jl, m2;
function p7() {
  if (m2) return jl;
  m2 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, o = Object.prototype.propertyIsEnumerable;
  function i(n) {
    if (n == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(n);
  }
  function c() {
    try {
      if (!Object.assign)
        return !1;
      var n = new String("abc");
      if (n[5] = "de", Object.getOwnPropertyNames(n)[0] === "5")
        return !1;
      for (var d = {}, f = 0; f < 10; f++)
        d["_" + String.fromCharCode(f)] = f;
      var p = Object.getOwnPropertyNames(d).map(function(h) {
        return d[h];
      });
      if (p.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(h) {
        l[h] = h;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return jl = c() ? Object.assign : function(n, d) {
    for (var f, p = i(n), l, h = 1; h < arguments.length; h++) {
      f = Object(arguments[h]);
      for (var y in f)
        t.call(f, y) && (p[y] = f[y]);
      if (e) {
        l = e(f);
        for (var M = 0; M < l.length; M++)
          o.call(f, l[M]) && (p[l[M]] = f[l[M]]);
      }
    }
    return p;
  }, jl;
}
var Ol, v2;
function V1() {
  if (v2) return Ol;
  v2 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ol = e, Ol;
}
var zl, b2;
function vg() {
  return b2 || (b2 = 1, zl = Function.call.bind(Object.prototype.hasOwnProperty)), zl;
}
var kl, x2;
function g7() {
  if (x2) return kl;
  x2 = 1;
  var e = function() {
  };
  if (fe.process.env.NODE_ENV !== "production") {
    var t = V1(), o = {}, i = vg();
    e = function(n) {
      var d = "Warning: " + n;
      typeof console < "u" && console.error(d);
      try {
        throw new Error(d);
      } catch {
      }
    };
  }
  function c(n, d, f, p, l) {
    if (fe.process.env.NODE_ENV !== "production") {
      for (var h in n)
        if (i(n, h)) {
          var y;
          try {
            if (typeof n[h] != "function") {
              var M = Error(
                (p || "React class") + ": " + f + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw M.name = "Invariant Violation", M;
            }
            y = n[h](d, h, p, f, null, t);
          } catch (N) {
            y = N;
          }
          if (y && !(y instanceof Error) && e(
            (p || "React class") + ": type specification of " + f + " `" + h + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof y + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), y instanceof Error && !(y.message in o)) {
            o[y.message] = !0;
            var C = l ? l() : "";
            e(
              "Failed " + f + " type: " + y.message + (C ?? "")
            );
          }
        }
    }
  }
  return c.resetWarningCache = function() {
    fe.process.env.NODE_ENV !== "production" && (o = {});
  }, kl = c, kl;
}
var _l, w2;
function y7() {
  if (w2) return _l;
  w2 = 1;
  var e = mg(), t = p7(), o = V1(), i = vg(), c = g7(), n = function() {
  };
  fe.process.env.NODE_ENV !== "production" && (n = function(f) {
    var p = "Warning: " + f;
    typeof console < "u" && console.error(p);
    try {
      throw new Error(p);
    } catch {
    }
  });
  function d() {
    return null;
  }
  return _l = function(f, p) {
    var l = typeof Symbol == "function" && Symbol.iterator, h = "@@iterator";
    function y(a) {
      var x = a && (l && a[l] || a[h]);
      if (typeof x == "function")
        return x;
    }
    var M = "<<anonymous>>", C = {
      array: T("array"),
      bigint: T("bigint"),
      bool: T("boolean"),
      func: T("function"),
      number: T("number"),
      object: T("object"),
      string: T("string"),
      symbol: T("symbol"),
      any: E(),
      arrayOf: j,
      element: O(),
      elementType: z(),
      instanceOf: k,
      node: B(),
      objectOf: W,
      oneOf: H,
      oneOfType: U,
      shape: r,
      exact: s
    };
    function N(a, x) {
      return a === x ? a !== 0 || 1 / a === 1 / x : a !== a && x !== x;
    }
    function w(a, x) {
      this.message = a, this.data = x && typeof x == "object" ? x : {}, this.stack = "";
    }
    w.prototype = Error.prototype;
    function S(a) {
      if (fe.process.env.NODE_ENV !== "production")
        var x = {}, V = 0;
      function G(te, q, R, Q, $, F, P) {
        if (Q = Q || M, F = F || R, P !== o) {
          if (p) {
            var _ = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw _.name = "Invariant Violation", _;
          } else if (fe.process.env.NODE_ENV !== "production" && typeof console < "u") {
            var X = Q + ":" + R;
            !x[X] && // Avoid spamming the console because they are often not actionable except for lib authors
            V < 3 && (n(
              "You are manually calling a React.PropTypes validation function for the `" + F + "` prop on `" + Q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), x[X] = !0, V++);
          }
        }
        return q[R] == null ? te ? q[R] === null ? new w("The " + $ + " `" + F + "` is marked as required " + ("in `" + Q + "`, but its value is `null`.")) : new w("The " + $ + " `" + F + "` is marked as required in " + ("`" + Q + "`, but its value is `undefined`.")) : null : a(q, R, Q, $, F);
      }
      var Z = G.bind(null, !1);
      return Z.isRequired = G.bind(null, !0), Z;
    }
    function T(a) {
      function x(V, G, Z, te, q, R) {
        var Q = V[G], $ = v(Q);
        if ($ !== a) {
          var F = A(Q);
          return new w(
            "Invalid " + te + " `" + q + "` of type " + ("`" + F + "` supplied to `" + Z + "`, expected ") + ("`" + a + "`."),
            { expectedType: a }
          );
        }
        return null;
      }
      return S(x);
    }
    function E() {
      return S(d);
    }
    function j(a) {
      function x(V, G, Z, te, q) {
        if (typeof a != "function")
          return new w("Property `" + q + "` of component `" + Z + "` has invalid PropType notation inside arrayOf.");
        var R = V[G];
        if (!Array.isArray(R)) {
          var Q = v(R);
          return new w("Invalid " + te + " `" + q + "` of type " + ("`" + Q + "` supplied to `" + Z + "`, expected an array."));
        }
        for (var $ = 0; $ < R.length; $++) {
          var F = a(R, $, Z, te, q + "[" + $ + "]", o);
          if (F instanceof Error)
            return F;
        }
        return null;
      }
      return S(x);
    }
    function O() {
      function a(x, V, G, Z, te) {
        var q = x[V];
        if (!f(q)) {
          var R = v(q);
          return new w("Invalid " + Z + " `" + te + "` of type " + ("`" + R + "` supplied to `" + G + "`, expected a single ReactElement."));
        }
        return null;
      }
      return S(a);
    }
    function z() {
      function a(x, V, G, Z, te) {
        var q = x[V];
        if (!e.isValidElementType(q)) {
          var R = v(q);
          return new w("Invalid " + Z + " `" + te + "` of type " + ("`" + R + "` supplied to `" + G + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return S(a);
    }
    function k(a) {
      function x(V, G, Z, te, q) {
        if (!(V[G] instanceof a)) {
          var R = a.name || M, Q = m(V[G]);
          return new w("Invalid " + te + " `" + q + "` of type " + ("`" + Q + "` supplied to `" + Z + "`, expected ") + ("instance of `" + R + "`."));
        }
        return null;
      }
      return S(x);
    }
    function H(a) {
      if (!Array.isArray(a))
        return fe.process.env.NODE_ENV !== "production" && (arguments.length > 1 ? n(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : n("Invalid argument supplied to oneOf, expected an array.")), d;
      function x(V, G, Z, te, q) {
        for (var R = V[G], Q = 0; Q < a.length; Q++)
          if (N(R, a[Q]))
            return null;
        var $ = JSON.stringify(a, function(P, _) {
          var X = A(_);
          return X === "symbol" ? String(_) : _;
        });
        return new w("Invalid " + te + " `" + q + "` of value `" + String(R) + "` " + ("supplied to `" + Z + "`, expected one of " + $ + "."));
      }
      return S(x);
    }
    function W(a) {
      function x(V, G, Z, te, q) {
        if (typeof a != "function")
          return new w("Property `" + q + "` of component `" + Z + "` has invalid PropType notation inside objectOf.");
        var R = V[G], Q = v(R);
        if (Q !== "object")
          return new w("Invalid " + te + " `" + q + "` of type " + ("`" + Q + "` supplied to `" + Z + "`, expected an object."));
        for (var $ in R)
          if (i(R, $)) {
            var F = a(R, $, Z, te, q + "." + $, o);
            if (F instanceof Error)
              return F;
          }
        return null;
      }
      return S(x);
    }
    function U(a) {
      if (!Array.isArray(a))
        return fe.process.env.NODE_ENV !== "production" && n("Invalid argument supplied to oneOfType, expected an instance of array."), d;
      for (var x = 0; x < a.length; x++) {
        var V = a[x];
        if (typeof V != "function")
          return n(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + L(V) + " at index " + x + "."
          ), d;
      }
      function G(Z, te, q, R, Q) {
        for (var $ = [], F = 0; F < a.length; F++) {
          var P = a[F], _ = P(Z, te, q, R, Q, o);
          if (_ == null)
            return null;
          _.data && i(_.data, "expectedType") && $.push(_.data.expectedType);
        }
        var X = $.length > 0 ? ", expected one of type [" + $.join(", ") + "]" : "";
        return new w("Invalid " + R + " `" + Q + "` supplied to " + ("`" + q + "`" + X + "."));
      }
      return S(G);
    }
    function B() {
      function a(x, V, G, Z, te) {
        return u(x[V]) ? null : new w("Invalid " + Z + " `" + te + "` supplied to " + ("`" + G + "`, expected a ReactNode."));
      }
      return S(a);
    }
    function I(a, x, V, G, Z) {
      return new w(
        (a || "React class") + ": " + x + " type `" + V + "." + G + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Z + "`."
      );
    }
    function r(a) {
      function x(V, G, Z, te, q) {
        var R = V[G], Q = v(R);
        if (Q !== "object")
          return new w("Invalid " + te + " `" + q + "` of type `" + Q + "` " + ("supplied to `" + Z + "`, expected `object`."));
        for (var $ in a) {
          var F = a[$];
          if (typeof F != "function")
            return I(Z, te, q, $, A(F));
          var P = F(R, $, Z, te, q + "." + $, o);
          if (P)
            return P;
        }
        return null;
      }
      return S(x);
    }
    function s(a) {
      function x(V, G, Z, te, q) {
        var R = V[G], Q = v(R);
        if (Q !== "object")
          return new w("Invalid " + te + " `" + q + "` of type `" + Q + "` " + ("supplied to `" + Z + "`, expected `object`."));
        var $ = t({}, V[G], a);
        for (var F in $) {
          var P = a[F];
          if (i(a, F) && typeof P != "function")
            return I(Z, te, q, F, A(P));
          if (!P)
            return new w(
              "Invalid " + te + " `" + q + "` key `" + F + "` supplied to `" + Z + "`.\nBad object: " + JSON.stringify(V[G], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(a), null, "  ")
            );
          var _ = P(R, F, Z, te, q + "." + F, o);
          if (_)
            return _;
        }
        return null;
      }
      return S(x);
    }
    function u(a) {
      switch (typeof a) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !a;
        case "object":
          if (Array.isArray(a))
            return a.every(u);
          if (a === null || f(a))
            return !0;
          var x = y(a);
          if (x) {
            var V = x.call(a), G;
            if (x !== a.entries) {
              for (; !(G = V.next()).done; )
                if (!u(G.value))
                  return !1;
            } else
              for (; !(G = V.next()).done; ) {
                var Z = G.value;
                if (Z && !u(Z[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function g(a, x) {
      return a === "symbol" ? !0 : x ? x["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && x instanceof Symbol : !1;
    }
    function v(a) {
      var x = typeof a;
      return Array.isArray(a) ? "array" : a instanceof RegExp ? "object" : g(x, a) ? "symbol" : x;
    }
    function A(a) {
      if (typeof a > "u" || a === null)
        return "" + a;
      var x = v(a);
      if (x === "object") {
        if (a instanceof Date)
          return "date";
        if (a instanceof RegExp)
          return "regexp";
      }
      return x;
    }
    function L(a) {
      var x = A(a);
      switch (x) {
        case "array":
        case "object":
          return "an " + x;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + x;
        default:
          return x;
      }
    }
    function m(a) {
      return !a.constructor || !a.constructor.name ? M : a.constructor.name;
    }
    return C.checkPropTypes = c, C.resetWarningCache = c.resetWarningCache, C.PropTypes = C, C;
  }, _l;
}
var Bl, C2;
function M7() {
  if (C2) return Bl;
  C2 = 1;
  var e = V1();
  function t() {
  }
  function o() {
  }
  return o.resetWarningCache = t, Bl = function() {
    function i(d, f, p, l, h, y) {
      if (y !== e) {
        var M = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw M.name = "Invariant Violation", M;
      }
    }
    i.isRequired = i;
    function c() {
      return i;
    }
    var n = {
      array: i,
      bigint: i,
      bool: i,
      func: i,
      number: i,
      object: i,
      string: i,
      symbol: i,
      any: i,
      arrayOf: c,
      element: i,
      elementType: i,
      instanceOf: c,
      node: i,
      objectOf: c,
      oneOf: c,
      oneOfType: c,
      shape: c,
      exact: c,
      checkPropTypes: o,
      resetWarningCache: t
    };
    return n.PropTypes = n, n;
  }, Bl;
}
if (fe.process.env.NODE_ENV !== "production") {
  var m7 = mg(), v7 = !0;
  Zd.exports = y7()(m7.isElement, v7);
} else
  Zd.exports = M7()();
var b7 = Zd.exports;
const b = /* @__PURE__ */ Yi(b7), Zi = fe.process.env.NODE_ENV !== "production" ? b.oneOfType([b.number, b.string, b.object, b.array]) : {};
function $a(e, t) {
  return t ? on(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Nc = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, I2 = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Nc[e]}px)`
}, x7 = {
  containerQueries: (e) => ({
    up: (t) => {
      let o = typeof t == "number" ? t : Nc[t] || t;
      return typeof o == "number" && (o = `${o}px`), e ? `@container ${e} (min-width:${o})` : `@container (min-width:${o})`;
    }
  })
};
function bi(e, t, o) {
  const i = e.theme || {};
  if (Array.isArray(t)) {
    const n = i.breakpoints || I2;
    return t.reduce((d, f, p) => (d[n.up(n.keys[p])] = o(t[p]), d), {});
  }
  if (typeof t == "object") {
    const n = i.breakpoints || I2;
    return Object.keys(t).reduce((d, f) => {
      if (c7(n.keys, f)) {
        const p = l7(i.containerQueries ? i : x7, f);
        p && (d[p] = o(t[f], f));
      } else if (Object.keys(n.values || Nc).includes(f)) {
        const p = n.up(f);
        d[p] = o(t[f], f);
      } else {
        const p = f;
        d[p] = t[p];
      }
      return d;
    }, {});
  }
  return o(t);
}
function w7(e = {}) {
  var o;
  return ((o = e.keys) == null ? void 0 : o.reduce((i, c) => {
    const n = e.up(c);
    return i[n] = {}, i;
  }, {})) || {};
}
function N2(e, t) {
  return e.reduce((o, i) => {
    const c = o[i];
    return (!c || Object.keys(c).length === 0) && delete o[i], o;
  }, t);
}
function Ei(e, t, o = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && o) {
    const i = `vars.${t}`.split(".").reduce((c, n) => c && c[n] ? c[n] : null, e);
    if (i != null)
      return i;
  }
  return t.split(".").reduce((i, c) => i && i[c] != null ? i[c] : null, e);
}
function J0(e, t, o, i = o) {
  let c;
  return typeof e == "function" ? c = e(o) : Array.isArray(e) ? c = e[o] || i : c = Ei(e, o) || i, t && (c = t(c, i, e)), c;
}
function Br(e) {
  const {
    prop: t,
    cssProperty: o = e.prop,
    themeKey: i,
    transform: c
  } = e, n = (d) => {
    if (d[t] == null)
      return null;
    const f = d[t], p = d.theme, l = Ei(p, i) || {};
    return bi(d, f, (y) => {
      let M = J0(l, c, y);
      return y === M && typeof y == "string" && (M = J0(l, c, `${t}${y === "default" ? "" : it(y)}`, y)), o === !1 ? M : {
        [o]: M
      };
    });
  };
  return n.propTypes = fe.process.env.NODE_ENV !== "production" ? {
    [t]: Zi
  } : {}, n.filterProps = [t], n;
}
function C7(e) {
  const t = {};
  return (o) => (t[o] === void 0 && (t[o] = e(o)), t[o]);
}
const I7 = {
  m: "margin",
  p: "padding"
}, N7 = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, A2 = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, A7 = C7((e) => {
  if (e.length > 2)
    if (A2[e])
      e = A2[e];
    else
      return [e];
  const [t, o] = e.split(""), i = I7[t], c = N7[o] || "";
  return Array.isArray(c) ? c.map((n) => i + n) : [i + c];
}), Ac = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Tc = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], T7 = [...Ac, ...Tc];
function Cs(e, t, o, i) {
  const c = Ei(e, t, !0) ?? o;
  return typeof c == "number" || typeof c == "string" ? (n) => typeof n == "string" ? n : (fe.process.env.NODE_ENV !== "production" && typeof n != "number" && console.error(`MUI: Expected ${i} argument to be a number or a string, got ${n}.`), typeof c == "string" ? `calc(${n} * ${c})` : c * n) : Array.isArray(c) ? (n) => {
    if (typeof n == "string")
      return n;
    const d = Math.abs(n);
    fe.process.env.NODE_ENV !== "production" && (Number.isInteger(d) ? d > c.length - 1 && console.error([`MUI: The value provided (${d}) overflows.`, `The supported values are: ${JSON.stringify(c)}.`, `${d} > ${c.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`)));
    const f = c[d];
    return n >= 0 ? f : typeof f == "number" ? -f : `-${f}`;
  } : typeof c == "function" ? c : (fe.process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${c}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function G1(e) {
  return Cs(e, "spacing", 8, "spacing");
}
function Is(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function L7(e, t) {
  return (o) => e.reduce((i, c) => (i[c] = Is(t, o), i), {});
}
function S7(e, t, o, i) {
  if (!t.includes(o))
    return null;
  const c = A7(o), n = L7(c, i), d = e[o];
  return bi(e, d, n);
}
function bg(e, t) {
  const o = G1(e.theme);
  return Object.keys(e).map((i) => S7(e, t, i, o)).reduce($a, {});
}
function Er(e) {
  return bg(e, Ac);
}
Er.propTypes = fe.process.env.NODE_ENV !== "production" ? Ac.reduce((e, t) => (e[t] = Zi, e), {}) : {};
Er.filterProps = Ac;
function Dr(e) {
  return bg(e, Tc);
}
Dr.propTypes = fe.process.env.NODE_ENV !== "production" ? Tc.reduce((e, t) => (e[t] = Zi, e), {}) : {};
Dr.filterProps = Tc;
fe.process.env.NODE_ENV !== "production" && T7.reduce((e, t) => (e[t] = Zi, e), {});
function E7(e = 8, t = G1({
  spacing: e
})) {
  if (e.mui)
    return e;
  const o = (...i) => (fe.process.env.NODE_ENV !== "production" && (i.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${i.length}`)), (i.length === 0 ? [1] : i).map((n) => {
    const d = t(n);
    return typeof d == "number" ? `${d}px` : d;
  }).join(" "));
  return o.mui = !0, o;
}
function Lc(...e) {
  const t = e.reduce((i, c) => (c.filterProps.forEach((n) => {
    i[n] = c;
  }), i), {}), o = (i) => Object.keys(i).reduce((c, n) => t[n] ? $a(c, t[n](i)) : c, {});
  return o.propTypes = fe.process.env.NODE_ENV !== "production" ? e.reduce((i, c) => Object.assign(i, c.propTypes), {}) : {}, o.filterProps = e.reduce((i, c) => i.concat(c.filterProps), []), o;
}
function kn(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function Hn(e, t) {
  return Br({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const D7 = Hn("border", kn), j7 = Hn("borderTop", kn), O7 = Hn("borderRight", kn), z7 = Hn("borderBottom", kn), k7 = Hn("borderLeft", kn), _7 = Hn("borderColor"), B7 = Hn("borderTopColor"), F7 = Hn("borderRightColor"), R7 = Hn("borderBottomColor"), P7 = Hn("borderLeftColor"), U7 = Hn("outline", kn), Y7 = Hn("outlineColor"), Sc = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = Cs(e.theme, "shape.borderRadius", 4, "borderRadius"), o = (i) => ({
      borderRadius: Is(t, i)
    });
    return bi(e, e.borderRadius, o);
  }
  return null;
};
Sc.propTypes = fe.process.env.NODE_ENV !== "production" ? {
  borderRadius: Zi
} : {};
Sc.filterProps = ["borderRadius"];
Lc(D7, j7, O7, z7, k7, _7, B7, F7, R7, P7, Sc, U7, Y7);
const Ec = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = Cs(e.theme, "spacing", 8, "gap"), o = (i) => ({
      gap: Is(t, i)
    });
    return bi(e, e.gap, o);
  }
  return null;
};
Ec.propTypes = fe.process.env.NODE_ENV !== "production" ? {
  gap: Zi
} : {};
Ec.filterProps = ["gap"];
const Dc = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = Cs(e.theme, "spacing", 8, "columnGap"), o = (i) => ({
      columnGap: Is(t, i)
    });
    return bi(e, e.columnGap, o);
  }
  return null;
};
Dc.propTypes = fe.process.env.NODE_ENV !== "production" ? {
  columnGap: Zi
} : {};
Dc.filterProps = ["columnGap"];
const jc = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = Cs(e.theme, "spacing", 8, "rowGap"), o = (i) => ({
      rowGap: Is(t, i)
    });
    return bi(e, e.rowGap, o);
  }
  return null;
};
jc.propTypes = fe.process.env.NODE_ENV !== "production" ? {
  rowGap: Zi
} : {};
jc.filterProps = ["rowGap"];
const W7 = Br({
  prop: "gridColumn"
}), H7 = Br({
  prop: "gridRow"
}), Z7 = Br({
  prop: "gridAutoFlow"
}), Q7 = Br({
  prop: "gridAutoColumns"
}), V7 = Br({
  prop: "gridAutoRows"
}), G7 = Br({
  prop: "gridTemplateColumns"
}), $7 = Br({
  prop: "gridTemplateRows"
}), q7 = Br({
  prop: "gridTemplateAreas"
}), J7 = Br({
  prop: "gridArea"
});
Lc(Ec, Dc, jc, W7, H7, Z7, Q7, V7, G7, $7, q7, J7);
function ta(e, t) {
  return t === "grey" ? t : e;
}
const X7 = Br({
  prop: "color",
  themeKey: "palette",
  transform: ta
}), K7 = Br({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: ta
}), ev = Br({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: ta
});
Lc(X7, K7, ev);
function Cn(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const tv = Br({
  prop: "width",
  transform: Cn
}), $1 = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (o) => {
      var c, n, d, f, p;
      const i = ((d = (n = (c = e.theme) == null ? void 0 : c.breakpoints) == null ? void 0 : n.values) == null ? void 0 : d[o]) || Nc[o];
      return i ? ((p = (f = e.theme) == null ? void 0 : f.breakpoints) == null ? void 0 : p.unit) !== "px" ? {
        maxWidth: `${i}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: i
      } : {
        maxWidth: Cn(o)
      };
    };
    return bi(e, e.maxWidth, t);
  }
  return null;
};
$1.filterProps = ["maxWidth"];
const rv = Br({
  prop: "minWidth",
  transform: Cn
}), nv = Br({
  prop: "height",
  transform: Cn
}), iv = Br({
  prop: "maxHeight",
  transform: Cn
}), ov = Br({
  prop: "minHeight",
  transform: Cn
});
Br({
  prop: "size",
  cssProperty: "width",
  transform: Cn
});
Br({
  prop: "size",
  cssProperty: "height",
  transform: Cn
});
const av = Br({
  prop: "boxSizing"
});
Lc(tv, $1, rv, nv, iv, ov, av);
const Ns = {
  // borders
  border: {
    themeKey: "borders",
    transform: kn
  },
  borderTop: {
    themeKey: "borders",
    transform: kn
  },
  borderRight: {
    themeKey: "borders",
    transform: kn
  },
  borderBottom: {
    themeKey: "borders",
    transform: kn
  },
  borderLeft: {
    themeKey: "borders",
    transform: kn
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: kn
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Sc
  },
  // palette
  color: {
    themeKey: "palette",
    transform: ta
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: ta
  },
  backgroundColor: {
    themeKey: "palette",
    transform: ta
  },
  // spacing
  p: {
    style: Dr
  },
  pt: {
    style: Dr
  },
  pr: {
    style: Dr
  },
  pb: {
    style: Dr
  },
  pl: {
    style: Dr
  },
  px: {
    style: Dr
  },
  py: {
    style: Dr
  },
  padding: {
    style: Dr
  },
  paddingTop: {
    style: Dr
  },
  paddingRight: {
    style: Dr
  },
  paddingBottom: {
    style: Dr
  },
  paddingLeft: {
    style: Dr
  },
  paddingX: {
    style: Dr
  },
  paddingY: {
    style: Dr
  },
  paddingInline: {
    style: Dr
  },
  paddingInlineStart: {
    style: Dr
  },
  paddingInlineEnd: {
    style: Dr
  },
  paddingBlock: {
    style: Dr
  },
  paddingBlockStart: {
    style: Dr
  },
  paddingBlockEnd: {
    style: Dr
  },
  m: {
    style: Er
  },
  mt: {
    style: Er
  },
  mr: {
    style: Er
  },
  mb: {
    style: Er
  },
  ml: {
    style: Er
  },
  mx: {
    style: Er
  },
  my: {
    style: Er
  },
  margin: {
    style: Er
  },
  marginTop: {
    style: Er
  },
  marginRight: {
    style: Er
  },
  marginBottom: {
    style: Er
  },
  marginLeft: {
    style: Er
  },
  marginX: {
    style: Er
  },
  marginY: {
    style: Er
  },
  marginInline: {
    style: Er
  },
  marginInlineStart: {
    style: Er
  },
  marginInlineEnd: {
    style: Er
  },
  marginBlock: {
    style: Er
  },
  marginBlockStart: {
    style: Er
  },
  marginBlockEnd: {
    style: Er
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Ec
  },
  rowGap: {
    style: jc
  },
  columnGap: {
    style: Dc
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: Cn
  },
  maxWidth: {
    style: $1
  },
  minWidth: {
    transform: Cn
  },
  height: {
    transform: Cn
  },
  maxHeight: {
    transform: Cn
  },
  minHeight: {
    transform: Cn
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function sv(...e) {
  const t = e.reduce((i, c) => i.concat(Object.keys(c)), []), o = new Set(t);
  return e.every((i) => o.size === Object.keys(i).length);
}
function cv(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function lv() {
  function e(o, i, c, n) {
    const d = {
      [o]: i,
      theme: c
    }, f = n[o];
    if (!f)
      return {
        [o]: i
      };
    const {
      cssProperty: p = o,
      themeKey: l,
      transform: h,
      style: y
    } = f;
    if (i == null)
      return null;
    if (l === "typography" && i === "inherit")
      return {
        [o]: i
      };
    const M = Ei(c, l) || {};
    return y ? y(d) : bi(d, i, (N) => {
      let w = J0(M, h, N);
      return N === w && typeof N == "string" && (w = J0(M, h, `${o}${N === "default" ? "" : it(N)}`, N)), p === !1 ? w : {
        [p]: w
      };
    });
  }
  function t(o) {
    const {
      sx: i,
      theme: c = {},
      nested: n
    } = o || {};
    if (!i)
      return null;
    const d = c.unstable_sxConfig ?? Ns;
    function f(p) {
      let l = p;
      if (typeof p == "function")
        l = p(c);
      else if (typeof p != "object")
        return p;
      if (!l)
        return null;
      const h = w7(c.breakpoints), y = Object.keys(h);
      let M = h;
      return Object.keys(l).forEach((C) => {
        const N = cv(l[C], c);
        if (N != null)
          if (typeof N == "object")
            if (d[C])
              M = $a(M, e(C, N, c, d));
            else {
              const w = bi({
                theme: c
              }, N, (S) => ({
                [C]: S
              }));
              sv(w, N) ? M[C] = t({
                sx: N,
                theme: c,
                nested: !0
              }) : M = $a(M, w);
            }
          else
            M = $a(M, e(C, N, c, d));
      }), !n && c.modularCssLayers ? {
        "@layer sx": p2(c, N2(y, M))
      } : p2(c, N2(y, M));
    }
    return Array.isArray(i) ? i.map(f) : f(i);
  }
  return t;
}
const Io = lv();
Io.filterProps = ["sx"];
function fv(e, t) {
  var i;
  const o = this;
  if (o.vars) {
    if (!((i = o.colorSchemes) != null && i[e]) || typeof o.getColorSchemeSelector != "function")
      return {};
    let c = o.getColorSchemeSelector(e);
    return c === "&" ? t : ((c.includes("data-") || c.includes(".")) && (c = `*:where(${c.replace(/\s*&$/, "")}) &`), {
      [c]: t
    });
  }
  return o.palette.mode === e ? t : {};
}
function xg(e = {}, ...t) {
  const {
    breakpoints: o = {},
    palette: i = {},
    spacing: c,
    shape: n = {},
    ...d
  } = e, f = s7(o), p = E7(c);
  let l = on({
    breakpoints: f,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...i
    },
    spacing: p,
    shape: {
      ...u7,
      ...n
    }
  }, d);
  return l = f7(l), l.applyStyles = fv, l = t.reduce((h, y) => on(h, y), l), l.unstable_sxConfig = {
    ...Ns,
    ...d == null ? void 0 : d.unstable_sxConfig
  }, l.unstable_sx = function(y) {
    return Io({
      sx: y,
      theme: this
    });
  }, l;
}
const uv = (e) => {
  var i;
  const t = {
    systemProps: {},
    otherProps: {}
  }, o = ((i = e == null ? void 0 : e.theme) == null ? void 0 : i.unstable_sxConfig) ?? Ns;
  return Object.keys(e).forEach((c) => {
    o[c] ? t.systemProps[c] = e[c] : t.otherProps[c] = e[c];
  }), t;
};
function dv(e) {
  const {
    sx: t,
    ...o
  } = e, {
    systemProps: i,
    otherProps: c
  } = uv(o);
  let n;
  return Array.isArray(t) ? n = [i, ...t] : typeof t == "function" ? n = (...d) => {
    const f = t(...d);
    return ti(f) ? {
      ...i,
      ...f
    } : i;
  } : n = {
    ...i,
    ...t
  }, {
    ...c,
    sx: n
  };
}
function hv(e) {
  const {
    variants: t,
    ...o
  } = e, i = {
    variants: t,
    style: Mo(o),
    isProcessed: !0
  };
  return i.style === o || t && t.forEach((c) => {
    typeof c.style != "function" && (c.style = Mo(c.style));
  }), i;
}
const pv = xg();
function Fl(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function fo(e, t) {
  return t && e && typeof e == "object" && e.styles && !e.styles.startsWith("@layer") && (e.styles = `@layer ${t}{${String(e.styles)}}`), e;
}
function gv(e) {
  return e ? (t, o) => o[e] : null;
}
function yv(e, t, o) {
  e.theme = bv(e.theme) ? o : e.theme[t] || e.theme;
}
function z0(e, t, o) {
  const i = typeof t == "function" ? t(e) : t;
  if (Array.isArray(i))
    return i.flatMap((c) => z0(e, c, o));
  if (Array.isArray(i == null ? void 0 : i.variants)) {
    let c;
    if (i.isProcessed)
      c = o ? fo(i.style, o) : i.style;
    else {
      const {
        variants: n,
        ...d
      } = i;
      c = o ? fo(Mo(d), o) : d;
    }
    return wg(e, i.variants, [c], o);
  }
  return i != null && i.isProcessed ? o ? fo(Mo(i.style), o) : i.style : o ? fo(Mo(i), o) : i;
}
function wg(e, t, o = [], i = void 0) {
  var n;
  let c;
  e: for (let d = 0; d < t.length; d += 1) {
    const f = t[d];
    if (typeof f.props == "function") {
      if (c ?? (c = {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }), !f.props(c))
        continue;
    } else
      for (const p in f.props)
        if (e[p] !== f.props[p] && ((n = e.ownerState) == null ? void 0 : n[p]) !== f.props[p])
          continue e;
    typeof f.style == "function" ? (c ?? (c = {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }), o.push(i ? fo(Mo(f.style(c)), i) : f.style(c))) : o.push(i ? fo(Mo(f.style), i) : f.style);
  }
  return o;
}
function Mv(e = {}) {
  const {
    themeId: t,
    defaultTheme: o = pv,
    rootShouldForwardProp: i = Fl,
    slotShouldForwardProp: c = Fl
  } = e;
  function n(f) {
    yv(f, t, o);
  }
  return (f, p = {}) => {
    r7(f, (k) => k.filter((H) => H !== Io));
    const {
      name: l,
      slot: h,
      skipVariantsResolver: y,
      skipSx: M,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: C = gv(Cg(h)),
      ...N
    } = p, w = l && l.startsWith("Mui") || h ? "components" : "custom", S = y !== void 0 ? y : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      h && h !== "Root" && h !== "root" || !1
    ), T = M || !1;
    let E = Fl;
    h === "Root" || h === "root" ? E = i : h ? E = c : xv(f) && (E = void 0);
    const j = t7(f, {
      shouldForwardProp: E,
      label: vv(l, h),
      ...N
    }), O = (k) => {
      if (k.__emotion_real === k)
        return k;
      if (typeof k == "function")
        return function(W) {
          return z0(W, k, W.theme.modularCssLayers ? w : void 0);
        };
      if (ti(k)) {
        const H = hv(k);
        return function(U) {
          return H.variants ? z0(U, H, U.theme.modularCssLayers ? w : void 0) : U.theme.modularCssLayers ? fo(H.style, w) : H.style;
        };
      }
      return k;
    }, z = (...k) => {
      const H = [], W = k.map(O), U = [];
      if (H.push(n), l && C && U.push(function(s) {
        var A, L;
        const g = (L = (A = s.theme.components) == null ? void 0 : A[l]) == null ? void 0 : L.styleOverrides;
        if (!g)
          return null;
        const v = {};
        for (const m in g)
          v[m] = z0(s, g[m], s.theme.modularCssLayers ? "theme" : void 0);
        return C(s, v);
      }), l && !S && U.push(function(s) {
        var v, A;
        const u = s.theme, g = (A = (v = u == null ? void 0 : u.components) == null ? void 0 : v[l]) == null ? void 0 : A.variants;
        return g ? wg(s, g, [], s.theme.modularCssLayers ? "theme" : void 0) : null;
      }), T || U.push(Io), Array.isArray(W[0])) {
        const r = W.shift(), s = new Array(H.length).fill(""), u = new Array(U.length).fill("");
        let g;
        g = [...s, ...r, ...u], g.raw = [...s, ...r.raw, ...u], H.unshift(g);
      }
      const B = [...H, ...W, ...U], I = j(...B);
      return f.muiName && (I.muiName = f.muiName), fe.process.env.NODE_ENV !== "production" && (I.displayName = mv(l, h, f)), I;
    };
    return j.withConfig && (z.withConfig = j.withConfig), z;
  };
}
function mv(e, t, o) {
  return e ? `${e}${it(t || "")}` : `Styled(${o7(o)})`;
}
function vv(e, t) {
  let o;
  return fe.process.env.NODE_ENV !== "production" && e && (o = `${e}-${Cg(t || "Root")}`), o;
}
function bv(e) {
  for (const t in e)
    return !1;
  return !0;
}
function xv(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function Cg(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
function wv(e, t = Number.MIN_SAFE_INTEGER, o = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, o));
}
function q1(e, t = 0, o = 1) {
  return fe.process.env.NODE_ENV !== "production" && (e < t || e > o) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${o}].`), wv(e, t, o);
}
function Cv(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let o = e.match(t);
  return o && o[0].length === 1 && (o = o.map((i) => i + i)), fe.process.env.NODE_ENV !== "production" && e.length !== e.trim().length && console.error(`MUI: The color: "${e}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), o ? `rgb${o.length === 4 ? "a" : ""}(${o.map((i, c) => c < 3 ? parseInt(i, 16) : Math.round(parseInt(i, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Bi(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Bi(Cv(e));
  const t = e.indexOf("("), o = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(o))
    throw new Error(fe.process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : si(9, e));
  let i = e.substring(t + 1, e.length - 1), c;
  if (o === "color") {
    if (i = i.split(" "), c = i.shift(), i.length === 4 && i[3].charAt(0) === "/" && (i[3] = i[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(c))
      throw new Error(fe.process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${c}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : si(10, c));
  } else
    i = i.split(",");
  return i = i.map((n) => parseFloat(n)), {
    type: o,
    values: i,
    colorSpace: c
  };
}
const Iv = (e) => {
  const t = Bi(e);
  return t.values.slice(0, 3).map((o, i) => t.type.includes("hsl") && i !== 0 ? `${o}%` : o).join(" ");
}, Wa = (e, t) => {
  try {
    return Iv(e);
  } catch {
    return t && fe.process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
function Oc(e) {
  const {
    type: t,
    colorSpace: o
  } = e;
  let {
    values: i
  } = e;
  return t.includes("rgb") ? i = i.map((c, n) => n < 3 ? parseInt(c, 10) : c) : t.includes("hsl") && (i[1] = `${i[1]}%`, i[2] = `${i[2]}%`), t.includes("color") ? i = `${o} ${i.join(" ")}` : i = `${i.join(", ")}`, `${t}(${i})`;
}
function Ig(e) {
  e = Bi(e);
  const {
    values: t
  } = e, o = t[0], i = t[1] / 100, c = t[2] / 100, n = i * Math.min(c, 1 - c), d = (l, h = (l + o / 30) % 12) => c - n * Math.max(Math.min(h - 3, 9 - h, 1), -1);
  let f = "rgb";
  const p = [Math.round(d(0) * 255), Math.round(d(8) * 255), Math.round(d(4) * 255)];
  return e.type === "hsla" && (f += "a", p.push(t[3])), Oc({
    type: f,
    values: p
  });
}
function Qd(e) {
  e = Bi(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Bi(Ig(e)).values : e.values;
  return t = t.map((o) => (e.type !== "color" && (o /= 255), o <= 0.03928 ? o / 12.92 : ((o + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function T2(e, t) {
  const o = Qd(e), i = Qd(t);
  return (Math.max(o, i) + 0.05) / (Math.min(o, i) + 0.05);
}
function ur(e, t) {
  return e = Bi(e), t = q1(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, Oc(e);
}
function e0(e, t, o) {
  try {
    return ur(e, t);
  } catch {
    return e;
  }
}
function As(e, t) {
  if (e = Bi(e), t = q1(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let o = 0; o < 3; o += 1)
      e.values[o] *= 1 - t;
  return Oc(e);
}
function br(e, t, o) {
  try {
    return As(e, t);
  } catch {
    return e;
  }
}
function Ts(e, t) {
  if (e = Bi(e), t = q1(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let o = 0; o < 3; o += 1)
      e.values[o] += (255 - e.values[o]) * t;
  else if (e.type.includes("color"))
    for (let o = 0; o < 3; o += 1)
      e.values[o] += (1 - e.values[o]) * t;
  return Oc(e);
}
function xr(e, t, o) {
  try {
    return Ts(e, t);
  } catch {
    return e;
  }
}
function Nv(e, t = 0.15) {
  return Qd(e) > 0.5 ? As(e, t) : Ts(e, t);
}
function t0(e, t, o) {
  try {
    return Nv(e, t);
  } catch {
    return e;
  }
}
const ss = {
  black: "#000",
  white: "#fff"
}, k0 = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, Ro = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, Po = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, Da = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, Uo = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, Yo = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, Wo = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
};
function Ng() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: ss.white,
      default: ss.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const Av = Ng();
function Ag() {
  return {
    text: {
      primary: ss.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: ss.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const L2 = Ag();
function S2(e, t, o, i) {
  const c = i.light || i, n = i.dark || i * 1.5;
  e[t] || (e.hasOwnProperty(o) ? e[t] = e[o] : t === "light" ? e.light = Ts(e.main, c) : t === "dark" && (e.dark = As(e.main, n)));
}
function Tv(e = "light") {
  return e === "dark" ? {
    main: Uo[200],
    light: Uo[50],
    dark: Uo[400]
  } : {
    main: Uo[700],
    light: Uo[400],
    dark: Uo[800]
  };
}
function Lv(e = "light") {
  return e === "dark" ? {
    main: Ro[200],
    light: Ro[50],
    dark: Ro[400]
  } : {
    main: Ro[500],
    light: Ro[300],
    dark: Ro[700]
  };
}
function Sv(e = "light") {
  return e === "dark" ? {
    main: Po[500],
    light: Po[300],
    dark: Po[700]
  } : {
    main: Po[700],
    light: Po[400],
    dark: Po[800]
  };
}
function Ev(e = "light") {
  return e === "dark" ? {
    main: Yo[400],
    light: Yo[300],
    dark: Yo[700]
  } : {
    main: Yo[700],
    light: Yo[500],
    dark: Yo[900]
  };
}
function Dv(e = "light") {
  return e === "dark" ? {
    main: Wo[400],
    light: Wo[300],
    dark: Wo[700]
  } : {
    main: Wo[800],
    light: Wo[500],
    dark: Wo[900]
  };
}
function jv(e = "light") {
  return e === "dark" ? {
    main: Da[400],
    light: Da[300],
    dark: Da[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Da[500],
    dark: Da[900]
  };
}
function J1(e) {
  const {
    mode: t = "light",
    contrastThreshold: o = 3,
    tonalOffset: i = 0.2,
    ...c
  } = e, n = e.primary || Tv(t), d = e.secondary || Lv(t), f = e.error || Sv(t), p = e.info || Ev(t), l = e.success || Dv(t), h = e.warning || jv(t);
  function y(w) {
    const S = T2(w, L2.text.primary) >= o ? L2.text.primary : Av.text.primary;
    if (fe.process.env.NODE_ENV !== "production") {
      const T = T2(w, S);
      T < 3 && console.error([`MUI: The contrast ratio of ${T}:1 for ${S} on ${w}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return S;
  }
  const M = ({
    color: w,
    name: S,
    mainShade: T = 500,
    lightShade: E = 300,
    darkShade: j = 700
  }) => {
    if (w = {
      ...w
    }, !w.main && w[T] && (w.main = w[T]), !w.hasOwnProperty("main"))
      throw new Error(fe.process.env.NODE_ENV !== "production" ? `MUI: The color${S ? ` (${S})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${T}\` property.` : si(11, S ? ` (${S})` : "", T));
    if (typeof w.main != "string")
      throw new Error(fe.process.env.NODE_ENV !== "production" ? `MUI: The color${S ? ` (${S})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(w.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : si(12, S ? ` (${S})` : "", JSON.stringify(w.main)));
    return S2(w, "light", E, i), S2(w, "dark", j, i), w.contrastText || (w.contrastText = y(w.main)), w;
  };
  let C;
  return t === "light" ? C = Ng() : t === "dark" && (C = Ag()), fe.process.env.NODE_ENV !== "production" && (C || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), on({
    // A collection of common colors.
    common: {
      ...ss
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: M({
      color: n,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: M({
      color: d,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: M({
      color: f,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: M({
      color: h,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: M({
      color: p,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: M({
      color: l,
      name: "success"
    }),
    // The grey colors.
    grey: k0,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: o,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: y,
    // Generate a rich color object.
    augmentColor: M,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: i,
    // The light and dark mode object.
    ...C
  }, c);
}
function qn(e, t) {
  return fe.process.env.NODE_ENV === "production" ? () => null : function(...i) {
    return e(...i) || t(...i);
  };
}
function Ov(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function Tg(e, t, o, i, c) {
  const n = e[t], d = c || t;
  if (n == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let f;
  const p = n.type;
  return typeof p == "function" && !Ov(p) && (f = "Did you accidentally use a plain function component for an element instead?"), f !== void 0 ? new Error(`Invalid ${i} \`${d}\` supplied to \`${o}\`. Expected an element that can hold a ref. ${f} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Oo = qn(b.element, Tg);
Oo.isRequired = qn(b.element.isRequired, Tg);
function zv(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function kv(e, t, o, i, c) {
  const n = e[t], d = c || t;
  if (n == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let f;
  return typeof n == "function" && !zv(n) && (f = "Did you accidentally provide a plain function component instead?"), f !== void 0 ? new Error(`Invalid ${i} \`${d}\` supplied to \`${o}\`. Expected an element type that can hold a ref. ${f} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Fi = qn(b.elementType, kv), _v = "exact-prop: ​";
function X1(e) {
  return fe.process.env.NODE_ENV === "production" ? e : {
    ...e,
    [_v]: (t) => {
      const o = Object.keys(t).filter((i) => !e.hasOwnProperty(i));
      return o.length > 0 ? new Error(`The following props are not supported: ${o.map((i) => `\`${i}\``).join(", ")}. Please remove them.`) : null;
    }
  };
}
function ci(e, t, o, i, c) {
  if (fe.process.env.NODE_ENV === "production")
    return null;
  const n = e[t], d = c || t;
  return n == null ? null : n && n.nodeType !== 1 ? new Error(`Invalid ${i} \`${d}\` supplied to \`${o}\`. Expected an HTMLElement.`) : null;
}
const En = b.oneOfType([b.func, b.object]);
function E2(...e) {
  return e.reduce((t, o) => o == null ? t : function(...c) {
    t.apply(this, c), o.apply(this, c);
  }, () => {
  });
}
function K1(e, t = 166) {
  let o;
  function i(...c) {
    const n = () => {
      e.apply(this, c);
    };
    clearTimeout(o), o = setTimeout(n, t);
  }
  return i.clear = () => {
    clearTimeout(o);
  }, i;
}
function qa(e, t) {
  var o, i, c;
  return /* @__PURE__ */ ue.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    e.type.muiName ?? ((c = (i = (o = e.type) == null ? void 0 : o._payload) == null ? void 0 : i.value) == null ? void 0 : c.muiName)
  ) !== -1;
}
function Xr(e) {
  return e && e.ownerDocument || document;
}
function fn(e) {
  return Xr(e).defaultView || window;
}
function D2(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const Rn = typeof window < "u" ? ue.useLayoutEffect : ue.useEffect;
let j2 = 0;
function Bv(e) {
  const [t, o] = ue.useState(e), i = e || t;
  return ue.useEffect(() => {
    t == null && (j2 += 1, o(`mui-${j2}`));
  }, [t]), i;
}
const Fv = {
  ...ue
}, O2 = Fv.useId;
function Ls(e) {
  if (O2 !== void 0) {
    const t = O2();
    return e ?? t;
  }
  return Bv(e);
}
function X0({
  controlled: e,
  default: t,
  name: o,
  state: i = "value"
}) {
  const {
    current: c
  } = ue.useRef(e !== void 0), [n, d] = ue.useState(t), f = c ? e : n;
  if (fe.process.env.NODE_ENV !== "production") {
    ue.useEffect(() => {
      c !== (e !== void 0) && console.error([`MUI: A component is changing the ${c ? "" : "un"}controlled ${i} state of ${o} to be ${c ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${o} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [i, o, e]);
    const {
      current: l
    } = ue.useRef(t);
    ue.useEffect(() => {
      !c && !Object.is(l, t) && console.error([`MUI: A component is changing the default ${i} state of an uncontrolled ${o} after being initialized. To suppress this warning opt to use a controlled ${o}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const p = ue.useCallback((l) => {
    c || d(l);
  }, []);
  return [f, p];
}
function _n(e) {
  const t = ue.useRef(e);
  return Rn(() => {
    t.current = e;
  }), ue.useRef((...o) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...o)
  )).current;
}
function zr(...e) {
  const t = ue.useRef(void 0), o = ue.useCallback((i) => {
    const c = e.map((n) => {
      if (n == null)
        return null;
      if (typeof n == "function") {
        const d = n, f = d(i);
        return typeof f == "function" ? f : () => {
          d(null);
        };
      }
      return n.current = i, () => {
        n.current = null;
      };
    });
    return () => {
      c.forEach((n) => n == null ? void 0 : n());
    };
  }, e);
  return ue.useMemo(() => e.every((i) => i == null) ? null : (i) => {
    t.current && (t.current(), t.current = void 0), i != null && (t.current = o(i));
  }, e);
}
const z2 = {};
function Lg(e, t) {
  const o = ue.useRef(z2);
  return o.current === z2 && (o.current = e(t)), o;
}
const Rv = [];
function Pv(e) {
  ue.useEffect(e, Rv);
}
class zc {
  constructor() {
    zt(this, "currentId", null);
    zt(this, "clear", () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    });
    zt(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new zc();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, o) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, o();
    }, t);
  }
}
function uo() {
  const e = Lg(zc.create).current;
  return Pv(e.disposeEffect), e;
}
function ca(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
    fe.process.env.NODE_ENV !== "production" && !/jsdom/.test(window.navigator.userAgent) && console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join(`
`));
  }
  return !1;
}
function Sg(e = window) {
  const t = e.document.documentElement.clientWidth;
  return e.innerWidth - t;
}
const Eg = (e) => {
  const t = ue.useRef({});
  return ue.useEffect(() => {
    t.current = e;
  }), t.current;
};
function Uv(e) {
  return ue.Children.toArray(e).filter((t) => /* @__PURE__ */ ue.isValidElement(t));
}
function Yv(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function Dg(e, t, o, i) {
  const c = e[t];
  if (c == null || !Number.isInteger(c)) {
    const n = Yv(c);
    return new RangeError(`Invalid ${i} \`${t}\` of type \`${n}\` supplied to \`${o}\`, expected \`integer\`.`);
  }
  return null;
}
function jg(e, t, ...o) {
  return e[t] === void 0 ? null : Dg(e, t, ...o);
}
function Vd() {
  return null;
}
jg.isRequired = Dg;
Vd.isRequired = Vd;
const eh = fe.process.env.NODE_ENV === "production" ? Vd : jg;
function cs(e, t) {
  const o = {
    ...t
  };
  for (const i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      const c = i;
      if (c === "components" || c === "slots")
        o[c] = {
          ...e[c],
          ...o[c]
        };
      else if (c === "componentsProps" || c === "slotProps") {
        const n = e[c], d = t[c];
        if (!d)
          o[c] = n || {};
        else if (!n)
          o[c] = d;
        else {
          o[c] = {
            ...d
          };
          for (const f in n)
            if (Object.prototype.hasOwnProperty.call(n, f)) {
              const p = f;
              o[c][p] = cs(n[p], d[p]);
            }
        }
      } else o[c] === void 0 && (o[c] = e[c]);
    }
  return o;
}
function Rt(e, t, o = void 0) {
  const i = {};
  for (const c in e) {
    const n = e[c];
    let d = "", f = !0;
    for (let p = 0; p < n.length; p += 1) {
      const l = n[p];
      l && (d += (f === !0 ? "" : " ") + t(l), f = !1, o && o[l] && (d += " " + o[l]));
    }
    i[c] = d;
  }
  return i;
}
const k2 = (e) => e, Wv = () => {
  let e = k2;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = k2;
    }
  };
}, Og = Wv(), Hv = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function Bt(e, t, o = "Mui") {
  const i = Hv[t];
  return i ? `${o}-${i}` : `${Og.generate(e)}-${t}`;
}
function Ft(e, t, o = "Mui") {
  const i = {};
  return t.forEach((c) => {
    i[c] = Bt(e, c, o);
  }), i;
}
function Zv(e) {
  return typeof e == "string";
}
function zg(e, t, o) {
  return e === void 0 || Zv(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...o
    }
  };
}
function kg(e) {
  var t, o, i = "";
  if (typeof e == "string" || typeof e == "number") i += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var c = e.length;
    for (t = 0; t < c; t++) e[t] && (o = kg(e[t])) && (i && (i += " "), i += o);
  } else for (o in e) e[o] && (i && (i += " "), i += o);
  return i;
}
function It() {
  for (var e, t, o = 0, i = "", c = arguments.length; o < c; o++) (e = arguments[o]) && (t = kg(e)) && (i && (i += " "), i += t);
  return i;
}
function _g(e, t = []) {
  if (e === void 0)
    return {};
  const o = {};
  return Object.keys(e).filter((i) => i.match(/^on[A-Z]/) && typeof e[i] == "function" && !t.includes(i)).forEach((i) => {
    o[i] = e[i];
  }), o;
}
function _2(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((o) => !(o.match(/^on[A-Z]/) && typeof e[o] == "function")).forEach((o) => {
    t[o] = e[o];
  }), t;
}
function Bg(e) {
  const {
    getSlotProps: t,
    additionalProps: o,
    externalSlotProps: i,
    externalForwardedProps: c,
    className: n
  } = e;
  if (!t) {
    const C = It(o == null ? void 0 : o.className, n, c == null ? void 0 : c.className, i == null ? void 0 : i.className), N = {
      ...o == null ? void 0 : o.style,
      ...c == null ? void 0 : c.style,
      ...i == null ? void 0 : i.style
    }, w = {
      ...o,
      ...c,
      ...i
    };
    return C.length > 0 && (w.className = C), Object.keys(N).length > 0 && (w.style = N), {
      props: w,
      internalRef: void 0
    };
  }
  const d = _g({
    ...c,
    ...i
  }), f = _2(i), p = _2(c), l = t(d), h = It(l == null ? void 0 : l.className, o == null ? void 0 : o.className, n, c == null ? void 0 : c.className, i == null ? void 0 : i.className), y = {
    ...l == null ? void 0 : l.style,
    ...o == null ? void 0 : o.style,
    ...c == null ? void 0 : c.style,
    ...i == null ? void 0 : i.style
  }, M = {
    ...l,
    ...o,
    ...p,
    ...f
  };
  return h.length > 0 && (M.className = h), Object.keys(y).length > 0 && (M.style = y), {
    props: M,
    internalRef: l.ref
  };
}
function Fg(e, t, o) {
  return typeof e == "function" ? e(t, o) : e;
}
function Rg(e) {
  var y;
  const {
    elementType: t,
    externalSlotProps: o,
    ownerState: i,
    skipResolvingSlotProps: c = !1,
    ...n
  } = e, d = c ? {} : Fg(o, i), {
    props: f,
    internalRef: p
  } = Bg({
    ...n,
    externalSlotProps: d
  }), l = zr(p, d == null ? void 0 : d.ref, (y = e.additionalProps) == null ? void 0 : y.ref);
  return zg(t, {
    ...f,
    ref: l
  }, i);
}
function zo(e) {
  var t;
  return parseInt(ue.version, 10) >= 19 ? ((t = e == null ? void 0 : e.props) == null ? void 0 : t.ref) || null : (e == null ? void 0 : e.ref) || null;
}
const Qv = /* @__PURE__ */ ue.createContext();
fe.process.env.NODE_ENV !== "production" && (b.node, b.bool);
const Ss = () => ue.useContext(Qv) ?? !1, Vv = /* @__PURE__ */ ue.createContext(void 0);
fe.process.env.NODE_ENV !== "production" && (b.node, b.object);
function Gv(e) {
  const {
    theme: t,
    name: o,
    props: i
  } = e;
  if (!t || !t.components || !t.components[o])
    return i;
  const c = t.components[o];
  return c.defaultProps ? cs(c.defaultProps, i) : !c.styleOverrides && !c.variants ? cs(c, i) : i;
}
function $v({
  props: e,
  name: t
}) {
  const o = ue.useContext(Vv);
  return Gv({
    props: e,
    name: t,
    theme: {
      components: o
    }
  });
}
const B2 = (e, t, o, i = []) => {
  let c = e;
  t.forEach((n, d) => {
    d === t.length - 1 ? Array.isArray(c) ? c[Number(n)] = o : c && typeof c == "object" && (c[n] = o) : c && typeof c == "object" && (c[n] || (c[n] = i.includes(n) ? [] : {}), c = c[n]);
  });
}, qv = (e, t, o) => {
  function i(c, n = [], d = []) {
    Object.entries(c).forEach(([f, p]) => {
      (!o || o && !o([...n, f])) && p != null && (typeof p == "object" && Object.keys(p).length > 0 ? i(p, [...n, f], Array.isArray(p) ? [...d, f] : d) : t([...n, f], p, d));
    });
  }
  i(e);
}, Jv = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((i) => e.includes(i)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function Rl(e, t) {
  const {
    prefix: o,
    shouldSkipGeneratingVar: i
  } = t || {}, c = {}, n = {}, d = {};
  return qv(
    e,
    (f, p, l) => {
      if ((typeof p == "string" || typeof p == "number") && (!i || !i(f, p))) {
        const h = `--${o ? `${o}-` : ""}${f.join("-")}`, y = Jv(f, p);
        Object.assign(c, {
          [h]: y
        }), B2(n, f, `var(${h})`, l), B2(d, f, `var(${h}, ${y})`, l);
      }
    },
    (f) => f[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: c,
    vars: n,
    varsWithDefaults: d
  };
}
function Xv(e, t = {}) {
  const {
    getSelector: o = S,
    disableCssColorScheme: i,
    colorSchemeSelector: c
  } = t, {
    colorSchemes: n = {},
    components: d,
    defaultColorScheme: f = "light",
    ...p
  } = e, {
    vars: l,
    css: h,
    varsWithDefaults: y
  } = Rl(p, t);
  let M = y;
  const C = {}, {
    [f]: N,
    ...w
  } = n;
  if (Object.entries(w || {}).forEach(([j, O]) => {
    const {
      vars: z,
      css: k,
      varsWithDefaults: H
    } = Rl(O, t);
    M = on(M, H), C[j] = {
      css: k,
      vars: z
    };
  }), N) {
    const {
      css: j,
      vars: O,
      varsWithDefaults: z
    } = Rl(N, t);
    M = on(M, z), C[f] = {
      css: j,
      vars: O
    };
  }
  function S(j, O) {
    var k, H;
    let z = c;
    if (c === "class" && (z = ".%s"), c === "data" && (z = "[data-%s]"), c != null && c.startsWith("data-") && !c.includes("%s") && (z = `[${c}="%s"]`), j) {
      if (z === "media")
        return e.defaultColorScheme === j ? ":root" : {
          [`@media (prefers-color-scheme: ${((H = (k = n[j]) == null ? void 0 : k.palette) == null ? void 0 : H.mode) || j})`]: {
            ":root": O
          }
        };
      if (z)
        return e.defaultColorScheme === j ? `:root, ${z.replace("%s", String(j))}` : z.replace("%s", String(j));
    }
    return ":root";
  }
  return {
    vars: M,
    generateThemeVars: () => {
      let j = {
        ...l
      };
      return Object.entries(C).forEach(([, {
        vars: O
      }]) => {
        j = on(j, O);
      }), j;
    },
    generateStyleSheets: () => {
      var W, U;
      const j = [], O = e.defaultColorScheme || "light";
      function z(B, I) {
        Object.keys(I).length && j.push(typeof B == "string" ? {
          [B]: {
            ...I
          }
        } : B);
      }
      z(o(void 0, {
        ...h
      }), h);
      const {
        [O]: k,
        ...H
      } = C;
      if (k) {
        const {
          css: B
        } = k, I = (U = (W = n[O]) == null ? void 0 : W.palette) == null ? void 0 : U.mode, r = !i && I ? {
          colorScheme: I,
          ...B
        } : {
          ...B
        };
        z(o(O, {
          ...r
        }), r);
      }
      return Object.entries(H).forEach(([B, {
        css: I
      }]) => {
        var u, g;
        const r = (g = (u = n[B]) == null ? void 0 : u.palette) == null ? void 0 : g.mode, s = !i && r ? {
          colorScheme: r,
          ...I
        } : {
          ...I
        };
        z(o(B, {
          ...s
        }), s);
      }), j;
    }
  };
}
function Kv(e) {
  const t = {};
  return Object.entries(e).forEach((i) => {
    const [c, n] = i;
    typeof n == "object" && (t[c] = `${n.fontStyle ? `${n.fontStyle} ` : ""}${n.fontVariant ? `${n.fontVariant} ` : ""}${n.fontWeight ? `${n.fontWeight} ` : ""}${n.fontStretch ? `${n.fontStretch} ` : ""}${n.fontSize || ""}${n.lineHeight ? `/${n.lineHeight} ` : ""}${n.fontFamily || ""}`);
  }), t;
}
function eb(e) {
  return function(o) {
    return e === "media" ? (fe.process.env.NODE_ENV !== "production" && o !== "light" && o !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${o}'.`), `@media (prefers-color-scheme: ${o})`) : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${o}"] &` : e === "class" ? `.${o} &` : e === "data" ? `[data-${o}] &` : `${e.replace("%s", o)} &` : "&";
  };
}
function tb(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function rb(e) {
  return Math.round(e * 1e5) / 1e5;
}
const F2 = {
  textTransform: "uppercase"
}, R2 = '"Roboto", "Helvetica", "Arial", sans-serif';
function Pg(e, t) {
  const {
    fontFamily: o = R2,
    // The default font size of the Material Specification.
    fontSize: i = 14,
    // px
    fontWeightLight: c = 300,
    fontWeightRegular: n = 400,
    fontWeightMedium: d = 500,
    fontWeightBold: f = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: p = 16,
    // Apply the CSS properties to all the variants.
    allVariants: l,
    pxToRem: h,
    ...y
  } = typeof t == "function" ? t(e) : t;
  fe.process.env.NODE_ENV !== "production" && (typeof i != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof p != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const M = i / 14, C = h || ((S) => `${S / p * M}rem`), N = (S, T, E, j, O) => ({
    fontFamily: o,
    fontWeight: S,
    fontSize: C(T),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: E,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...o === R2 ? {
      letterSpacing: `${rb(j / T)}em`
    } : {},
    ...O,
    ...l
  }), w = {
    h1: N(c, 96, 1.167, -1.5),
    h2: N(c, 60, 1.2, -0.5),
    h3: N(n, 48, 1.167, 0),
    h4: N(n, 34, 1.235, 0.25),
    h5: N(n, 24, 1.334, 0),
    h6: N(d, 20, 1.6, 0.15),
    subtitle1: N(n, 16, 1.75, 0.15),
    subtitle2: N(d, 14, 1.57, 0.1),
    body1: N(n, 16, 1.5, 0.15),
    body2: N(n, 14, 1.43, 0.15),
    button: N(d, 14, 1.75, 0.4, F2),
    caption: N(n, 12, 1.66, 0.4),
    overline: N(n, 12, 2.66, 1, F2),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return on({
    htmlFontSize: p,
    pxToRem: C,
    fontFamily: o,
    fontSize: i,
    fontWeightLight: c,
    fontWeightRegular: n,
    fontWeightMedium: d,
    fontWeightBold: f,
    ...w
  }, y, {
    clone: !1
    // No need to clone deep
  });
}
const nb = 0.2, ib = 0.14, ob = 0.12;
function Nr(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${nb})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${ib})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${ob})`].join(",");
}
const ab = ["none", Nr(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Nr(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Nr(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Nr(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Nr(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Nr(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Nr(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Nr(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Nr(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Nr(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Nr(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Nr(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Nr(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Nr(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Nr(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Nr(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Nr(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Nr(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Nr(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Nr(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Nr(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Nr(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Nr(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Nr(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], sb = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, Ug = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function P2(e) {
  return `${Math.round(e)}ms`;
}
function cb(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function lb(e) {
  const t = {
    ...sb,
    ...e.easing
  }, o = {
    ...Ug,
    ...e.duration
  };
  return {
    getAutoHeightDuration: cb,
    create: (c = ["all"], n = {}) => {
      const {
        duration: d = o.standard,
        easing: f = t.easeInOut,
        delay: p = 0,
        ...l
      } = n;
      if (fe.process.env.NODE_ENV !== "production") {
        const h = (M) => typeof M == "string", y = (M) => !Number.isNaN(parseFloat(M));
        !h(c) && !Array.isArray(c) && console.error('MUI: Argument "props" must be a string or Array.'), !y(d) && !h(d) && console.error(`MUI: Argument "duration" must be a number or a string but found ${d}.`), h(f) || console.error('MUI: Argument "easing" must be a string.'), !y(p) && !h(p) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof n != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(l).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(l).join(",")}].`);
      }
      return (Array.isArray(c) ? c : [c]).map((h) => `${h} ${typeof d == "string" ? d : P2(d)} ${f} ${typeof p == "string" ? p : P2(p)}`).join(",");
    },
    ...e,
    easing: t,
    duration: o
  };
}
const fb = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function ub(e) {
  return ti(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function Yg(e = {}) {
  const t = {
    ...e
  };
  function o(i) {
    const c = Object.entries(i);
    for (let n = 0; n < c.length; n++) {
      const [d, f] = c[n];
      !ub(f) || d.startsWith("unstable_") ? delete i[d] : ti(f) && (i[d] = {
        ...f
      }, o(i[d]));
    }
  }
  return o(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function Gd(e = {}, ...t) {
  const {
    breakpoints: o,
    mixins: i = {},
    spacing: c,
    palette: n = {},
    transitions: d = {},
    typography: f = {},
    shape: p,
    ...l
  } = e;
  if (e.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  e.generateThemeVars === void 0)
    throw new Error(fe.process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature." : si(20));
  const h = J1(n), y = xg(e);
  let M = on(y, {
    mixins: tb(y.breakpoints, i),
    palette: h,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: ab.slice(),
    typography: Pg(h, f),
    transitions: lb(d),
    zIndex: {
      ...fb
    }
  });
  if (M = on(M, l), M = t.reduce((C, N) => on(C, N), M), fe.process.env.NODE_ENV !== "production") {
    const C = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], N = (w, S) => {
      let T;
      for (T in w) {
        const E = w[T];
        if (C.includes(T) && Object.keys(E).length > 0) {
          if (fe.process.env.NODE_ENV !== "production") {
            const j = Bt("", T);
            console.error([`MUI: The \`${S}\` component increases the CSS specificity of the \`${T}\` internal state.`, "You can not override it like this: ", JSON.stringify(w, null, 2), "", `Instead, you need to use the '&.${j}' syntax:`, JSON.stringify({
              root: {
                [`&.${j}`]: E
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          w[T] = {};
        }
      }
    };
    Object.keys(M.components).forEach((w) => {
      const S = M.components[w].styleOverrides;
      S && w.startsWith("Mui") && N(S, w);
    });
  }
  return M.unstable_sxConfig = {
    ...Ns,
    ...l == null ? void 0 : l.unstable_sxConfig
  }, M.unstable_sx = function(N) {
    return Io({
      sx: N,
      theme: this
    });
  }, M.toRuntimeSource = Yg, M;
}
function $d(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const db = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const o = $d(t);
  return `linear-gradient(rgba(255 255 255 / ${o}), rgba(255 255 255 / ${o}))`;
});
function Wg(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function Hg(e) {
  return e === "dark" ? db : [];
}
function hb(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: o,
    overlays: i,
    ...c
  } = e, n = J1(t);
  return {
    palette: n,
    opacity: {
      ...Wg(n.mode),
      ...o
    },
    overlays: i || Hg(n.mode),
    ...c
  };
}
function pb(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
const gb = (e) => [...[...Array(25)].map((t, o) => `--${e ? `${e}-` : ""}overlays-${o}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], yb = (e) => (t, o) => {
  const i = e.rootSelector || ":root", c = e.colorSchemeSelector;
  let n = c;
  if (c === "class" && (n = ".%s"), c === "data" && (n = "[data-%s]"), c != null && c.startsWith("data-") && !c.includes("%s") && (n = `[${c}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const d = {};
      return gb(e.cssVarPrefix).forEach((f) => {
        d[f] = o[f], delete o[f];
      }), n === "media" ? {
        [i]: o,
        "@media (prefers-color-scheme: dark)": {
          [i]: d
        }
      } : n ? {
        [n.replace("%s", t)]: d,
        [`${i}, ${n.replace("%s", t)}`]: o
      } : {
        [i]: {
          ...o,
          ...d
        }
      };
    }
    if (n && n !== "media")
      return `${i}, ${n.replace("%s", String(t))}`;
  } else if (t) {
    if (n === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [i]: o
        }
      };
    if (n)
      return n.replace("%s", String(t));
  }
  return i;
};
function Mb(e, t) {
  t.forEach((o) => {
    e[o] || (e[o] = {});
  });
}
function Ve(e, t, o) {
  !e[t] && o && (e[t] = o);
}
function Ha(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : Ig(e);
}
function pi(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = Wa(Ha(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function mb(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const Jn = (e) => {
  try {
    return e();
  } catch {
  }
}, vb = (e = "mui") => U9(e);
function Pl(e, t, o, i) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const c = i === "dark" ? "dark" : "light";
  if (!o) {
    e[i] = hb({
      ...t,
      palette: {
        mode: c,
        ...t == null ? void 0 : t.palette
      }
    });
    return;
  }
  const {
    palette: n,
    ...d
  } = Gd({
    ...o,
    palette: {
      mode: c,
      ...t == null ? void 0 : t.palette
    }
  });
  return e[i] = {
    ...t,
    palette: n,
    opacity: {
      ...Wg(c),
      ...t == null ? void 0 : t.opacity
    },
    overlays: (t == null ? void 0 : t.overlays) || Hg(c)
  }, d;
}
function bb(e = {}, ...t) {
  const {
    colorSchemes: o = {
      light: !0
    },
    defaultColorScheme: i,
    disableCssColorScheme: c = !1,
    cssVarPrefix: n = "mui",
    shouldSkipGeneratingVar: d = pb,
    colorSchemeSelector: f = o.light && o.dark ? "media" : void 0,
    rootSelector: p = ":root",
    ...l
  } = e, h = Object.keys(o)[0], y = i || (o.light && h !== "light" ? "light" : h), M = vb(n), {
    [y]: C,
    light: N,
    dark: w,
    ...S
  } = o, T = {
    ...S
  };
  let E = C;
  if ((y === "dark" && !("dark" in o) || y === "light" && !("light" in o)) && (E = !0), !E)
    throw new Error(fe.process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${y}\` option is either missing or invalid.` : si(21, y));
  const j = Pl(T, E, l, y);
  N && !T.light && Pl(T, N, void 0, "light"), w && !T.dark && Pl(T, w, void 0, "dark");
  let O = {
    defaultColorScheme: y,
    ...j,
    cssVarPrefix: n,
    colorSchemeSelector: f,
    rootSelector: p,
    getCssVar: M,
    colorSchemes: T,
    font: {
      ...Kv(j.typography),
      ...j.font
    },
    spacing: mb(l.spacing)
  };
  Object.keys(O.colorSchemes).forEach((U) => {
    const B = O.colorSchemes[U].palette, I = (r) => {
      const s = r.split("-"), u = s[1], g = s[2];
      return M(r, B[u][g]);
    };
    if (B.mode === "light" && (Ve(B.common, "background", "#fff"), Ve(B.common, "onBackground", "#000")), B.mode === "dark" && (Ve(B.common, "background", "#000"), Ve(B.common, "onBackground", "#fff")), Mb(B, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), B.mode === "light") {
      Ve(B.Alert, "errorColor", br(B.error.light, 0.6)), Ve(B.Alert, "infoColor", br(B.info.light, 0.6)), Ve(B.Alert, "successColor", br(B.success.light, 0.6)), Ve(B.Alert, "warningColor", br(B.warning.light, 0.6)), Ve(B.Alert, "errorFilledBg", I("palette-error-main")), Ve(B.Alert, "infoFilledBg", I("palette-info-main")), Ve(B.Alert, "successFilledBg", I("palette-success-main")), Ve(B.Alert, "warningFilledBg", I("palette-warning-main")), Ve(B.Alert, "errorFilledColor", Jn(() => B.getContrastText(B.error.main))), Ve(B.Alert, "infoFilledColor", Jn(() => B.getContrastText(B.info.main))), Ve(B.Alert, "successFilledColor", Jn(() => B.getContrastText(B.success.main))), Ve(B.Alert, "warningFilledColor", Jn(() => B.getContrastText(B.warning.main))), Ve(B.Alert, "errorStandardBg", xr(B.error.light, 0.9)), Ve(B.Alert, "infoStandardBg", xr(B.info.light, 0.9)), Ve(B.Alert, "successStandardBg", xr(B.success.light, 0.9)), Ve(B.Alert, "warningStandardBg", xr(B.warning.light, 0.9)), Ve(B.Alert, "errorIconColor", I("palette-error-main")), Ve(B.Alert, "infoIconColor", I("palette-info-main")), Ve(B.Alert, "successIconColor", I("palette-success-main")), Ve(B.Alert, "warningIconColor", I("palette-warning-main")), Ve(B.AppBar, "defaultBg", I("palette-grey-100")), Ve(B.Avatar, "defaultBg", I("palette-grey-400")), Ve(B.Button, "inheritContainedBg", I("palette-grey-300")), Ve(B.Button, "inheritContainedHoverBg", I("palette-grey-A100")), Ve(B.Chip, "defaultBorder", I("palette-grey-400")), Ve(B.Chip, "defaultAvatarColor", I("palette-grey-700")), Ve(B.Chip, "defaultIconColor", I("palette-grey-700")), Ve(B.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), Ve(B.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), Ve(B.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), Ve(B.LinearProgress, "primaryBg", xr(B.primary.main, 0.62)), Ve(B.LinearProgress, "secondaryBg", xr(B.secondary.main, 0.62)), Ve(B.LinearProgress, "errorBg", xr(B.error.main, 0.62)), Ve(B.LinearProgress, "infoBg", xr(B.info.main, 0.62)), Ve(B.LinearProgress, "successBg", xr(B.success.main, 0.62)), Ve(B.LinearProgress, "warningBg", xr(B.warning.main, 0.62)), Ve(B.Skeleton, "bg", `rgba(${I("palette-text-primaryChannel")} / 0.11)`), Ve(B.Slider, "primaryTrack", xr(B.primary.main, 0.62)), Ve(B.Slider, "secondaryTrack", xr(B.secondary.main, 0.62)), Ve(B.Slider, "errorTrack", xr(B.error.main, 0.62)), Ve(B.Slider, "infoTrack", xr(B.info.main, 0.62)), Ve(B.Slider, "successTrack", xr(B.success.main, 0.62)), Ve(B.Slider, "warningTrack", xr(B.warning.main, 0.62));
      const r = t0(B.background.default, 0.8);
      Ve(B.SnackbarContent, "bg", r), Ve(B.SnackbarContent, "color", Jn(() => B.getContrastText(r))), Ve(B.SpeedDialAction, "fabHoverBg", t0(B.background.paper, 0.15)), Ve(B.StepConnector, "border", I("palette-grey-400")), Ve(B.StepContent, "border", I("palette-grey-400")), Ve(B.Switch, "defaultColor", I("palette-common-white")), Ve(B.Switch, "defaultDisabledColor", I("palette-grey-100")), Ve(B.Switch, "primaryDisabledColor", xr(B.primary.main, 0.62)), Ve(B.Switch, "secondaryDisabledColor", xr(B.secondary.main, 0.62)), Ve(B.Switch, "errorDisabledColor", xr(B.error.main, 0.62)), Ve(B.Switch, "infoDisabledColor", xr(B.info.main, 0.62)), Ve(B.Switch, "successDisabledColor", xr(B.success.main, 0.62)), Ve(B.Switch, "warningDisabledColor", xr(B.warning.main, 0.62)), Ve(B.TableCell, "border", xr(e0(B.divider, 1), 0.88)), Ve(B.Tooltip, "bg", e0(B.grey[700], 0.92));
    }
    if (B.mode === "dark") {
      Ve(B.Alert, "errorColor", xr(B.error.light, 0.6)), Ve(B.Alert, "infoColor", xr(B.info.light, 0.6)), Ve(B.Alert, "successColor", xr(B.success.light, 0.6)), Ve(B.Alert, "warningColor", xr(B.warning.light, 0.6)), Ve(B.Alert, "errorFilledBg", I("palette-error-dark")), Ve(B.Alert, "infoFilledBg", I("palette-info-dark")), Ve(B.Alert, "successFilledBg", I("palette-success-dark")), Ve(B.Alert, "warningFilledBg", I("palette-warning-dark")), Ve(B.Alert, "errorFilledColor", Jn(() => B.getContrastText(B.error.dark))), Ve(B.Alert, "infoFilledColor", Jn(() => B.getContrastText(B.info.dark))), Ve(B.Alert, "successFilledColor", Jn(() => B.getContrastText(B.success.dark))), Ve(B.Alert, "warningFilledColor", Jn(() => B.getContrastText(B.warning.dark))), Ve(B.Alert, "errorStandardBg", br(B.error.light, 0.9)), Ve(B.Alert, "infoStandardBg", br(B.info.light, 0.9)), Ve(B.Alert, "successStandardBg", br(B.success.light, 0.9)), Ve(B.Alert, "warningStandardBg", br(B.warning.light, 0.9)), Ve(B.Alert, "errorIconColor", I("palette-error-main")), Ve(B.Alert, "infoIconColor", I("palette-info-main")), Ve(B.Alert, "successIconColor", I("palette-success-main")), Ve(B.Alert, "warningIconColor", I("palette-warning-main")), Ve(B.AppBar, "defaultBg", I("palette-grey-900")), Ve(B.AppBar, "darkBg", I("palette-background-paper")), Ve(B.AppBar, "darkColor", I("palette-text-primary")), Ve(B.Avatar, "defaultBg", I("palette-grey-600")), Ve(B.Button, "inheritContainedBg", I("palette-grey-800")), Ve(B.Button, "inheritContainedHoverBg", I("palette-grey-700")), Ve(B.Chip, "defaultBorder", I("palette-grey-700")), Ve(B.Chip, "defaultAvatarColor", I("palette-grey-300")), Ve(B.Chip, "defaultIconColor", I("palette-grey-300")), Ve(B.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), Ve(B.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), Ve(B.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), Ve(B.LinearProgress, "primaryBg", br(B.primary.main, 0.5)), Ve(B.LinearProgress, "secondaryBg", br(B.secondary.main, 0.5)), Ve(B.LinearProgress, "errorBg", br(B.error.main, 0.5)), Ve(B.LinearProgress, "infoBg", br(B.info.main, 0.5)), Ve(B.LinearProgress, "successBg", br(B.success.main, 0.5)), Ve(B.LinearProgress, "warningBg", br(B.warning.main, 0.5)), Ve(B.Skeleton, "bg", `rgba(${I("palette-text-primaryChannel")} / 0.13)`), Ve(B.Slider, "primaryTrack", br(B.primary.main, 0.5)), Ve(B.Slider, "secondaryTrack", br(B.secondary.main, 0.5)), Ve(B.Slider, "errorTrack", br(B.error.main, 0.5)), Ve(B.Slider, "infoTrack", br(B.info.main, 0.5)), Ve(B.Slider, "successTrack", br(B.success.main, 0.5)), Ve(B.Slider, "warningTrack", br(B.warning.main, 0.5));
      const r = t0(B.background.default, 0.98);
      Ve(B.SnackbarContent, "bg", r), Ve(B.SnackbarContent, "color", Jn(() => B.getContrastText(r))), Ve(B.SpeedDialAction, "fabHoverBg", t0(B.background.paper, 0.15)), Ve(B.StepConnector, "border", I("palette-grey-600")), Ve(B.StepContent, "border", I("palette-grey-600")), Ve(B.Switch, "defaultColor", I("palette-grey-300")), Ve(B.Switch, "defaultDisabledColor", I("palette-grey-600")), Ve(B.Switch, "primaryDisabledColor", br(B.primary.main, 0.55)), Ve(B.Switch, "secondaryDisabledColor", br(B.secondary.main, 0.55)), Ve(B.Switch, "errorDisabledColor", br(B.error.main, 0.55)), Ve(B.Switch, "infoDisabledColor", br(B.info.main, 0.55)), Ve(B.Switch, "successDisabledColor", br(B.success.main, 0.55)), Ve(B.Switch, "warningDisabledColor", br(B.warning.main, 0.55)), Ve(B.TableCell, "border", br(e0(B.divider, 1), 0.68)), Ve(B.Tooltip, "bg", e0(B.grey[700], 0.92));
    }
    pi(B.background, "default"), pi(B.background, "paper"), pi(B.common, "background"), pi(B.common, "onBackground"), pi(B, "divider"), Object.keys(B).forEach((r) => {
      const s = B[r];
      r !== "tonalOffset" && s && typeof s == "object" && (s.main && Ve(B[r], "mainChannel", Wa(Ha(s.main))), s.light && Ve(B[r], "lightChannel", Wa(Ha(s.light))), s.dark && Ve(B[r], "darkChannel", Wa(Ha(s.dark))), s.contrastText && Ve(B[r], "contrastTextChannel", Wa(Ha(s.contrastText))), r === "text" && (pi(B[r], "primary"), pi(B[r], "secondary")), r === "action" && (s.active && pi(B[r], "active"), s.selected && pi(B[r], "selected")));
    });
  }), O = t.reduce((U, B) => on(U, B), O);
  const z = {
    prefix: n,
    disableCssColorScheme: c,
    shouldSkipGeneratingVar: d,
    getSelector: yb(O)
  }, {
    vars: k,
    generateThemeVars: H,
    generateStyleSheets: W
  } = Xv(O, z);
  return O.vars = k, Object.entries(O.colorSchemes[O.defaultColorScheme]).forEach(([U, B]) => {
    O[U] = B;
  }), O.generateThemeVars = H, O.generateStyleSheets = W, O.generateSpacing = function() {
    return Y9(l.spacing, G1(this));
  }, O.getColorSchemeSelector = eb(f), O.spacing = O.generateSpacing(), O.shouldSkipGeneratingVar = d, O.unstable_sxConfig = {
    ...Ns,
    ...l == null ? void 0 : l.unstable_sxConfig
  }, O.unstable_sx = function(B) {
    return Io({
      sx: B,
      theme: this
    });
  }, O.toRuntimeSource = Yg, O;
}
function U2(e, t, o) {
  e.colorSchemes && o && (e.colorSchemes[t] = {
    ...o !== !0 && o,
    palette: J1({
      ...o === !0 ? {} : o.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function kc(e = {}, ...t) {
  const {
    palette: o,
    cssVariables: i = !1,
    colorSchemes: c = o ? void 0 : {
      light: !0
    },
    defaultColorScheme: n = o == null ? void 0 : o.mode,
    ...d
  } = e, f = n || "light", p = c == null ? void 0 : c[f], l = {
    ...c,
    ...o ? {
      [f]: {
        ...typeof p != "boolean" && p,
        palette: o
      }
    } : void 0
  };
  if (i === !1) {
    if (!("colorSchemes" in e))
      return Gd(e, ...t);
    let h = o;
    "palette" in e || l[f] && (l[f] !== !0 ? h = l[f].palette : f === "dark" && (h = {
      mode: "dark"
    }));
    const y = Gd({
      ...e,
      palette: h
    }, ...t);
    return y.defaultColorScheme = f, y.colorSchemes = l, y.palette.mode === "light" && (y.colorSchemes.light = {
      ...l.light !== !0 && l.light,
      palette: y.palette
    }, U2(y, "dark", l.dark)), y.palette.mode === "dark" && (y.colorSchemes.dark = {
      ...l.dark !== !0 && l.dark,
      palette: y.palette
    }, U2(y, "light", l.light)), y;
  }
  return !o && !("light" in l) && f === "light" && (l.light = !0), bb({
    ...d,
    colorSchemes: l,
    defaultColorScheme: f,
    ...typeof i != "boolean" && i
  }, ...t);
}
const th = kc(), ni = "$$material";
function Zg(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const hn = (e) => Zg(e) && e !== "classes", Ke = Mv({
  themeId: ni,
  defaultTheme: th,
  rootShouldForwardProp: hn
});
var qd = { exports: {} }, Ul = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Y2;
function xb() {
  if (Y2) return Ul;
  Y2 = 1;
  var e = sr;
  function t(p, l) {
    return p === l && (p !== 0 || 1 / p === 1 / l) || p !== p && l !== l;
  }
  var o = typeof Object.is == "function" ? Object.is : t, i = e.useSyncExternalStore, c = e.useRef, n = e.useEffect, d = e.useMemo, f = e.useDebugValue;
  return Ul.useSyncExternalStoreWithSelector = function(p, l, h, y, M) {
    var C = c(null);
    if (C.current === null) {
      var N = { hasValue: !1, value: null };
      C.current = N;
    } else N = C.current;
    C = d(
      function() {
        function S(z) {
          if (!T) {
            if (T = !0, E = z, z = y(z), M !== void 0 && N.hasValue) {
              var k = N.value;
              if (M(k, z))
                return j = k;
            }
            return j = z;
          }
          if (k = j, o(E, z)) return k;
          var H = y(z);
          return M !== void 0 && M(k, H) ? (E = z, k) : (E = z, j = H);
        }
        var T = !1, E, j, O = h === void 0 ? null : h;
        return [
          function() {
            return S(l());
          },
          O === null ? void 0 : function() {
            return S(O());
          }
        ];
      },
      [l, h, y, M]
    );
    var w = i(p, C[0], C[1]);
    return n(
      function() {
        N.hasValue = !0, N.value = w;
      },
      [w]
    ), f(w), w;
  }, Ul;
}
var Yl = {}, W2;
function wb() {
  return W2 || (W2 = 1, fe.process.env.NODE_ENV !== "production" && function() {
    function e(p, l) {
      return p === l && (p !== 0 || 1 / p === 1 / l) || p !== p && l !== l;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = sr, o = typeof Object.is == "function" ? Object.is : e, i = t.useSyncExternalStore, c = t.useRef, n = t.useEffect, d = t.useMemo, f = t.useDebugValue;
    Yl.useSyncExternalStoreWithSelector = function(p, l, h, y, M) {
      var C = c(null);
      if (C.current === null) {
        var N = { hasValue: !1, value: null };
        C.current = N;
      } else N = C.current;
      C = d(
        function() {
          function S(z) {
            if (!T) {
              if (T = !0, E = z, z = y(z), M !== void 0 && N.hasValue) {
                var k = N.value;
                if (M(k, z))
                  return j = k;
              }
              return j = z;
            }
            if (k = j, o(E, z))
              return k;
            var H = y(z);
            return M !== void 0 && M(k, H) ? (E = z, k) : (E = z, j = H);
          }
          var T = !1, E, j, O = h === void 0 ? null : h;
          return [
            function() {
              return S(l());
            },
            O === null ? void 0 : function() {
              return S(O());
            }
          ];
        },
        [l, h, y, M]
      );
      var w = i(p, C[0], C[1]);
      return n(
        function() {
          N.hasValue = !0, N.value = w;
        },
        [w]
      ), f(w), w;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Yl;
}
fe.process.env.NODE_ENV === "production" ? qd.exports = xb() : qd.exports = wb();
var Cb = qd.exports;
function Ib(e) {
  e();
}
function Nb() {
  let e = null, t = null;
  return {
    clear() {
      e = null, t = null;
    },
    notify() {
      Ib(() => {
        let o = e;
        for (; o; )
          o.callback(), o = o.next;
      });
    },
    get() {
      const o = [];
      let i = e;
      for (; i; )
        o.push(i), i = i.next;
      return o;
    },
    subscribe(o) {
      let i = !0;
      const c = t = {
        callback: o,
        next: null,
        prev: t
      };
      return c.prev ? c.prev.next = c : e = c, function() {
        !i || e === null || (i = !1, c.next ? c.next.prev = c.prev : t = c.prev, c.prev ? c.prev.next = c.next : e = c.next);
      };
    }
  };
}
var H2 = {
  notify() {
  },
  get: () => []
};
function Ab(e, t) {
  let o, i = H2, c = 0, n = !1;
  function d(w) {
    h();
    const S = i.subscribe(w);
    let T = !1;
    return () => {
      T || (T = !0, S(), y());
    };
  }
  function f() {
    i.notify();
  }
  function p() {
    N.onStateChange && N.onStateChange();
  }
  function l() {
    return n;
  }
  function h() {
    c++, o || (o = e.subscribe(p), i = Nb());
  }
  function y() {
    c--, o && c === 0 && (o(), o = void 0, i.clear(), i = H2);
  }
  function M() {
    n || (n = !0, h());
  }
  function C() {
    n && (n = !1, y());
  }
  const N = {
    addNestedSub: d,
    notifyNestedSubs: f,
    handleChangeWrapper: p,
    isSubscribed: l,
    trySubscribe: M,
    tryUnsubscribe: C,
    getListeners: () => i
  };
  return N;
}
var Tb = () => typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Lb = /* @__PURE__ */ Tb(), Sb = () => typeof navigator < "u" && navigator.product === "ReactNative", Eb = /* @__PURE__ */ Sb(), Db = () => Lb || Eb ? ue.useLayoutEffect : ue.useEffect, jb = /* @__PURE__ */ Db(), Wl = /* @__PURE__ */ Symbol.for("react-redux-context"), Hl = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function Ob() {
  if (!ue.createContext) return {};
  const e = Hl[Wl] ?? (Hl[Wl] = /* @__PURE__ */ new Map());
  let t = e.get(ue.createContext);
  return t || (t = ue.createContext(
    null
  ), fe.process.env.NODE_ENV !== "production" && (t.displayName = "ReactRedux"), e.set(ue.createContext, t)), t;
}
var Ri = /* @__PURE__ */ Ob();
function zb(e) {
  const { children: t, context: o, serverState: i, store: c } = e, n = ue.useMemo(() => {
    const p = Ab(c), l = {
      store: c,
      subscription: p,
      getServerState: i ? () => i : void 0
    };
    if (fe.process.env.NODE_ENV === "production")
      return l;
    {
      const { identityFunctionCheck: h = "once", stabilityCheck: y = "once" } = e;
      return /* @__PURE__ */ Object.assign(l, {
        stabilityCheck: y,
        identityFunctionCheck: h
      });
    }
  }, [c, i]), d = ue.useMemo(() => c.getState(), [c]);
  jb(() => {
    const { subscription: p } = n;
    return p.onStateChange = p.notifyNestedSubs, p.trySubscribe(), d !== c.getState() && p.notifyNestedSubs(), () => {
      p.tryUnsubscribe(), p.onStateChange = void 0;
    };
  }, [n, d]);
  const f = o || Ri;
  return /* @__PURE__ */ ue.createElement(f.Provider, { value: n }, t);
}
var kb = zb;
function rh(e = Ri) {
  return function() {
    const o = ue.useContext(e);
    if (fe.process.env.NODE_ENV !== "production" && !o)
      throw new Error(
        "could not find react-redux context value; please ensure the component is wrapped in a <Provider>"
      );
    return o;
  };
}
var Qg = /* @__PURE__ */ rh();
function Vg(e = Ri) {
  const t = e === Ri ? Qg : (
    // @ts-ignore
    rh(e)
  ), o = () => {
    const { store: i } = t();
    return i;
  };
  return Object.assign(o, {
    withTypes: () => o
  }), o;
}
var _b = /* @__PURE__ */ Vg();
function Bb(e = Ri) {
  const t = e === Ri ? _b : Vg(e), o = () => t().dispatch;
  return Object.assign(o, {
    withTypes: () => o
  }), o;
}
var Cr = /* @__PURE__ */ Bb(), Fb = (e, t) => e === t;
function Rb(e = Ri) {
  const t = e === Ri ? Qg : rh(e), o = (i, c = {}) => {
    const { equalityFn: n = Fb } = typeof c == "function" ? { equalityFn: c } : c;
    if (fe.process.env.NODE_ENV !== "production") {
      if (!i)
        throw new Error("You must pass a selector to useSelector");
      if (typeof i != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof n != "function")
        throw new Error(
          "You must pass a function as an equality function to useSelector"
        );
    }
    const d = t(), { store: f, subscription: p, getServerState: l } = d, h = ue.useRef(!0), y = ue.useCallback(
      {
        [i.name](C) {
          const N = i(C);
          if (fe.process.env.NODE_ENV !== "production") {
            const { devModeChecks: w = {} } = typeof c == "function" ? {} : c, { identityFunctionCheck: S, stabilityCheck: T } = d, {
              identityFunctionCheck: E,
              stabilityCheck: j
            } = {
              stabilityCheck: T,
              identityFunctionCheck: S,
              ...w
            };
            if (j === "always" || j === "once" && h.current) {
              const O = i(C);
              if (!n(N, O)) {
                let z;
                try {
                  throw new Error();
                } catch (k) {
                  ({ stack: z } = k);
                }
                console.warn(
                  "Selector " + (i.name || "unknown") + ` returned a different result when called with the same parameters. This can lead to unnecessary rerenders.
Selectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization`,
                  {
                    state: C,
                    selected: N,
                    selected2: O,
                    stack: z
                  }
                );
              }
            }
            if ((E === "always" || E === "once" && h.current) && N === C) {
              let O;
              try {
                throw new Error();
              } catch (z) {
                ({ stack: O } = z);
              }
              console.warn(
                "Selector " + (i.name || "unknown") + ` returned the root state when called. This can lead to unnecessary rerenders.
Selectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.`,
                { stack: O }
              );
            }
            h.current && (h.current = !1);
          }
          return N;
        }
      }[i.name],
      [i]
    ), M = Cb.useSyncExternalStoreWithSelector(
      p.addNestedSub,
      f.getState,
      l || f.getState,
      y,
      n
    );
    return ue.useDebugValue(M), M;
  };
  return Object.assign(o, {
    withTypes: () => o
  }), o;
}
var Ut = /* @__PURE__ */ Rb();
function or() {
  const e = W9(th);
  return fe.process.env.NODE_ENV !== "production" && ue.useDebugValue(e), e[ni] || e;
}
function Gg(e) {
  return /* @__PURE__ */ D(H9, {
    ...e,
    defaultTheme: th,
    themeId: ni
  });
}
fe.process.env.NODE_ENV !== "production" && (Gg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: b.oneOfType([b.array, b.func, b.number, b.object, b.string, b.bool])
});
function Pb(e) {
  return function(o) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ D(Gg, {
        styles: typeof e == "function" ? (i) => e({
          theme: i,
          ...o
        }) : e
      })
    );
  };
}
function Ub() {
  return dv;
}
const kt = Z9;
fe.process.env.NODE_ENV !== "production" && (b.node, b.object.isRequired);
function Pt(e) {
  return $v(e);
}
const Yb = (e, t) => ({
  WebkitFontSmoothing: "antialiased",
  // Antialiasing.
  MozOsxFontSmoothing: "grayscale",
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: "border-box",
  // Fix font resize problem in iOS
  WebkitTextSizeAdjust: "100%",
  // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
  ...t
}), Wb = (e) => ({
  color: (e.vars || e).palette.text.primary,
  ...e.typography.body1,
  backgroundColor: (e.vars || e).palette.background.default,
  "@media print": {
    // Save printer ink.
    backgroundColor: (e.vars || e).palette.common.white
  }
});
fe.process.env.NODE_ENV !== "production" && (b.node, b.bool);
function Hb(e) {
  return Bt("MuiScopedCssBaseline", e);
}
Ft("MuiScopedCssBaseline", ["root"]);
const Zb = (e) => {
  const {
    classes: t
  } = e;
  return Rt({
    root: ["root"]
  }, Hb, t);
}, Qb = Ke("div", {
  name: "MuiScopedCssBaseline",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(kt(({
  theme: e
}) => {
  const t = {};
  return e.colorSchemes && Object.entries(e.colorSchemes).forEach(([o, i]) => {
    var n, d;
    const c = e.getColorSchemeSelector(o);
    c.startsWith("@") ? t[c] = {
      colorScheme: (n = i.palette) == null ? void 0 : n.mode
    } : t[`&${c.replace(/\s*&/, "")}`] = {
      colorScheme: (d = i.palette) == null ? void 0 : d.mode
    };
  }), {
    ...Yb(e, !1),
    ...Wb(e),
    "& *, & *::before, & *::after": {
      boxSizing: "inherit"
    },
    "& strong, & b": {
      fontWeight: e.typography.fontWeightBold
    },
    variants: [{
      props: {
        enableColorScheme: !0
      },
      style: e.vars ? t : {
        colorScheme: e.palette.mode
      }
    }]
  };
})), $g = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiScopedCssBaseline"
  }), {
    className: c,
    component: n = "div",
    enableColorScheme: d,
    ...f
  } = i, p = {
    ...i,
    component: n
  }, l = Zb(p);
  return /* @__PURE__ */ D(Qb, {
    as: n,
    className: It(l.root, c),
    ref: o,
    ownerState: p,
    ...f
  });
});
fe.process.env.NODE_ENV !== "production" && ($g.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * Enable `color-scheme` CSS property to use `theme.palette.mode`.
   * For more details, check out https://developer.mozilla.org/en-US/docs/Web/CSS/color-scheme
   * For browser support, check out https://caniuse.com/?search=color-scheme
   */
  enableColorScheme: b.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object])
});
function Vb(e) {
  return String(e).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function Gb(e) {
  return parseFloat(e);
}
function $b({
  theme: e,
  ...t
}) {
  const o = ni in e ? e[ni] : void 0;
  return /* @__PURE__ */ D(Q9, {
    ...t,
    themeId: o ? ni : void 0,
    theme: o || e
  });
}
const r0 = {
  colorSchemeStorageKey: "mui-color-scheme",
  defaultLightColorScheme: "light",
  defaultDarkColorScheme: "dark",
  modeStorageKey: "mui-mode"
}, {
  CssVarsProvider: qb,
  useColorScheme: IR,
  getInitColorSchemeScript: NR
} = V9({
  themeId: ni,
  // @ts-ignore ignore module augmentation tests
  theme: () => kc({
    cssVariables: !0
  }),
  colorSchemeStorageKey: r0.colorSchemeStorageKey,
  modeStorageKey: r0.modeStorageKey,
  defaultColorScheme: {
    light: r0.defaultLightColorScheme,
    dark: r0.defaultDarkColorScheme
  },
  resolveTheme: (e) => {
    const t = {
      ...e,
      typography: Pg(e.palette, e.typography)
    };
    return t.unstable_sx = function(i) {
      return Io({
        sx: i,
        theme: this
      });
    }, t;
  }
}), Jb = qb;
function Xb({
  theme: e,
  ...t
}) {
  const o = ue.useMemo(() => {
    if (typeof e == "function")
      return e;
    const i = ni in e ? e[ni] : e;
    return "colorSchemes" in i ? null : "vars" in i ? e : {
      ...e,
      vars: null
    };
  }, [e]);
  return o ? /* @__PURE__ */ D($b, {
    theme: o,
    ...t
  }) : /* @__PURE__ */ D(Jb, {
    theme: e,
    ...t
  });
}
function Jr(e) {
  return `Minified Redux error #${e}; visit https://redux.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var Kb = typeof Symbol == "function" && Symbol.observable || "@@observable", Z2 = Kb, Zl = () => Math.random().toString(36).substring(7).split("").join("."), ex = {
  INIT: `@@redux/INIT${/* @__PURE__ */ Zl()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ Zl()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${Zl()}`
}, mo = ex;
function Es(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function tx(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  const t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (ix(e))
    return "date";
  if (nx(e))
    return "error";
  const o = rx(e);
  switch (o) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return o;
  }
  return Object.prototype.toString.call(e).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function rx(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function nx(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function ix(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function Si(e) {
  let t = typeof e;
  return fe.process.env.NODE_ENV !== "production" && (t = tx(e)), t;
}
function qg(e, t, o) {
  if (typeof e != "function")
    throw new Error(fe.process.env.NODE_ENV === "production" ? Jr(2) : `Expected the root reducer to be a function. Instead, received: '${Si(e)}'`);
  if (typeof t == "function" && typeof o == "function" || typeof o == "function" && typeof arguments[3] == "function")
    throw new Error(fe.process.env.NODE_ENV === "production" ? Jr(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof o > "u" && (o = t, t = void 0), typeof o < "u") {
    if (typeof o != "function")
      throw new Error(fe.process.env.NODE_ENV === "production" ? Jr(1) : `Expected the enhancer to be a function. Instead, received: '${Si(o)}'`);
    return o(qg)(e, t);
  }
  let i = e, c = t, n = /* @__PURE__ */ new Map(), d = n, f = 0, p = !1;
  function l() {
    d === n && (d = /* @__PURE__ */ new Map(), n.forEach((S, T) => {
      d.set(T, S);
    }));
  }
  function h() {
    if (p)
      throw new Error(fe.process.env.NODE_ENV === "production" ? Jr(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return c;
  }
  function y(S) {
    if (typeof S != "function")
      throw new Error(fe.process.env.NODE_ENV === "production" ? Jr(4) : `Expected the listener to be a function. Instead, received: '${Si(S)}'`);
    if (p)
      throw new Error(fe.process.env.NODE_ENV === "production" ? Jr(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    let T = !0;
    l();
    const E = f++;
    return d.set(E, S), function() {
      if (T) {
        if (p)
          throw new Error(fe.process.env.NODE_ENV === "production" ? Jr(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        T = !1, l(), d.delete(E), n = null;
      }
    };
  }
  function M(S) {
    if (!Es(S))
      throw new Error(fe.process.env.NODE_ENV === "production" ? Jr(7) : `Actions must be plain objects. Instead, the actual type was: '${Si(S)}'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.`);
    if (typeof S.type > "u")
      throw new Error(fe.process.env.NODE_ENV === "production" ? Jr(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (typeof S.type != "string")
      throw new Error(fe.process.env.NODE_ENV === "production" ? Jr(17) : `Action "type" property must be a string. Instead, the actual type was: '${Si(S.type)}'. Value was: '${S.type}' (stringified)`);
    if (p)
      throw new Error(fe.process.env.NODE_ENV === "production" ? Jr(9) : "Reducers may not dispatch actions.");
    try {
      p = !0, c = i(c, S);
    } finally {
      p = !1;
    }
    return (n = d).forEach((E) => {
      E();
    }), S;
  }
  function C(S) {
    if (typeof S != "function")
      throw new Error(fe.process.env.NODE_ENV === "production" ? Jr(10) : `Expected the nextReducer to be a function. Instead, received: '${Si(S)}`);
    i = S, M({
      type: mo.REPLACE
    });
  }
  function N() {
    const S = y;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(T) {
        if (typeof T != "object" || T === null)
          throw new Error(fe.process.env.NODE_ENV === "production" ? Jr(11) : `Expected the observer to be an object. Instead, received: '${Si(T)}'`);
        function E() {
          const O = T;
          O.next && O.next(h());
        }
        return E(), {
          unsubscribe: S(E)
        };
      },
      [Z2]() {
        return this;
      }
    };
  }
  return M({
    type: mo.INIT
  }), {
    dispatch: M,
    subscribe: y,
    getState: h,
    replaceReducer: C,
    [Z2]: N
  };
}
function Q2(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function ox(e, t, o, i) {
  const c = Object.keys(t), n = o && o.type === mo.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (c.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!Es(e))
    return `The ${n} has unexpected type of "${Si(e)}". Expected argument to be an object with the following keys: "${c.join('", "')}"`;
  const d = Object.keys(e).filter((f) => !t.hasOwnProperty(f) && !i[f]);
  if (d.forEach((f) => {
    i[f] = !0;
  }), !(o && o.type === mo.REPLACE) && d.length > 0)
    return `Unexpected ${d.length > 1 ? "keys" : "key"} "${d.join('", "')}" found in ${n}. Expected to find one of the known reducer keys instead: "${c.join('", "')}". Unexpected keys will be ignored.`;
}
function ax(e) {
  Object.keys(e).forEach((t) => {
    const o = e[t];
    if (typeof o(void 0, {
      type: mo.INIT
    }) > "u")
      throw new Error(fe.process.env.NODE_ENV === "production" ? Jr(12) : `The slice reducer for key "${t}" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof o(void 0, {
      type: mo.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(fe.process.env.NODE_ENV === "production" ? Jr(13) : `The slice reducer for key "${t}" returned undefined when probed with a random type. Don't try to handle '${mo.INIT}' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.`);
  });
}
function sx(e) {
  const t = Object.keys(e), o = {};
  for (let d = 0; d < t.length; d++) {
    const f = t[d];
    fe.process.env.NODE_ENV !== "production" && typeof e[f] > "u" && Q2(`No reducer provided for key "${f}"`), typeof e[f] == "function" && (o[f] = e[f]);
  }
  const i = Object.keys(o);
  let c;
  fe.process.env.NODE_ENV !== "production" && (c = {});
  let n;
  try {
    ax(o);
  } catch (d) {
    n = d;
  }
  return function(f = {}, p) {
    if (n)
      throw n;
    if (fe.process.env.NODE_ENV !== "production") {
      const y = ox(f, o, p, c);
      y && Q2(y);
    }
    let l = !1;
    const h = {};
    for (let y = 0; y < i.length; y++) {
      const M = i[y], C = o[M], N = f[M], w = C(N, p);
      if (typeof w > "u") {
        const S = p && p.type;
        throw new Error(fe.process.env.NODE_ENV === "production" ? Jr(14) : `When called with an action of type ${S ? `"${String(S)}"` : "(unknown type)"}, the slice reducer for key "${M}" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.`);
      }
      h[M] = w, l = l || w !== N;
    }
    return l = l || i.length !== Object.keys(f).length, l ? h : f;
  };
}
function K0(...e) {
  return e.length === 0 ? (t) => t : e.length === 1 ? e[0] : e.reduce((t, o) => (...i) => t(o(...i)));
}
function cx(...e) {
  return (t) => (o, i) => {
    const c = t(o, i);
    let n = () => {
      throw new Error(fe.process.env.NODE_ENV === "production" ? Jr(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
    };
    const d = {
      getState: c.getState,
      dispatch: (p, ...l) => n(p, ...l)
    }, f = e.map((p) => p(d));
    return n = K0(...f)(c.dispatch), {
      ...c,
      dispatch: n
    };
  };
}
function Jg(e) {
  return Es(e) && "type" in e && typeof e.type == "string";
}
var Xg = Symbol.for("immer-nothing"), V2 = Symbol.for("immer-draftable"), An = Symbol.for("immer-state"), lx = fe.process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function pn(e, ...t) {
  if (fe.process.env.NODE_ENV !== "production") {
    const o = lx[e], i = typeof o == "function" ? o.apply(null, t) : o;
    throw new Error(`[Immer] ${i}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var la = Object.getPrototypeOf;
function No(e) {
  return !!e && !!e[An];
}
function xi(e) {
  var t;
  return e ? Kg(e) || Array.isArray(e) || !!e[V2] || !!((t = e.constructor) != null && t[V2]) || Bc(e) || Fc(e) : !1;
}
var fx = Object.prototype.constructor.toString();
function Kg(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = la(e);
  if (t === null)
    return !0;
  const o = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return o === Object ? !0 : typeof o == "function" && Function.toString.call(o) === fx;
}
function ec(e, t) {
  _c(e) === 0 ? Reflect.ownKeys(e).forEach((o) => {
    t(o, e[o], e);
  }) : e.forEach((o, i) => t(i, o, e));
}
function _c(e) {
  const t = e[An];
  return t ? t.type_ : Array.isArray(e) ? 1 : Bc(e) ? 2 : Fc(e) ? 3 : 0;
}
function Jd(e, t) {
  return _c(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function ey(e, t, o) {
  const i = _c(e);
  i === 2 ? e.set(t, o) : i === 3 ? e.add(o) : e[t] = o;
}
function ux(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function Bc(e) {
  return e instanceof Map;
}
function Fc(e) {
  return e instanceof Set;
}
function no(e) {
  return e.copy_ || e.base_;
}
function Xd(e, t) {
  if (Bc(e))
    return new Map(e);
  if (Fc(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const o = Kg(e);
  if (t === !0 || t === "class_only" && !o) {
    const i = Object.getOwnPropertyDescriptors(e);
    delete i[An];
    let c = Reflect.ownKeys(i);
    for (let n = 0; n < c.length; n++) {
      const d = c[n], f = i[d];
      f.writable === !1 && (f.writable = !0, f.configurable = !0), (f.get || f.set) && (i[d] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: f.enumerable,
        value: e[d]
      });
    }
    return Object.create(la(e), i);
  } else {
    const i = la(e);
    if (i !== null && o)
      return { ...e };
    const c = Object.create(i);
    return Object.assign(c, e);
  }
}
function nh(e, t = !1) {
  return Rc(e) || No(e) || !xi(e) || (_c(e) > 1 && (e.set = e.add = e.clear = e.delete = dx), Object.freeze(e), t && Object.entries(e).forEach(([o, i]) => nh(i, !0))), e;
}
function dx() {
  pn(2);
}
function Rc(e) {
  return Object.isFrozen(e);
}
var hx = {};
function Ao(e) {
  const t = hx[e];
  return t || pn(0, e), t;
}
var ls;
function ty() {
  return ls;
}
function px(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function G2(e, t) {
  t && (Ao("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function Kd(e) {
  e1(e), e.drafts_.forEach(gx), e.drafts_ = null;
}
function e1(e) {
  e === ls && (ls = e.parent_);
}
function $2(e) {
  return ls = px(ls, e);
}
function gx(e) {
  const t = e[An];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function q2(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const o = t.drafts_[0];
  return e !== void 0 && e !== o ? (o[An].modified_ && (Kd(t), pn(4)), xi(e) && (e = tc(t, e), t.parent_ || rc(t, e)), t.patches_ && Ao("Patches").generateReplacementPatches_(
    o[An].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = tc(t, o, []), Kd(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== Xg ? e : void 0;
}
function tc(e, t, o) {
  if (Rc(t))
    return t;
  const i = t[An];
  if (!i)
    return ec(
      t,
      (c, n) => J2(e, i, t, c, n, o)
    ), t;
  if (i.scope_ !== e)
    return t;
  if (!i.modified_)
    return rc(e, i.base_, !0), i.base_;
  if (!i.finalized_) {
    i.finalized_ = !0, i.scope_.unfinalizedDrafts_--;
    const c = i.copy_;
    let n = c, d = !1;
    i.type_ === 3 && (n = new Set(c), c.clear(), d = !0), ec(
      n,
      (f, p) => J2(e, i, c, f, p, o, d)
    ), rc(e, c, !1), o && e.patches_ && Ao("Patches").generatePatches_(
      i,
      o,
      e.patches_,
      e.inversePatches_
    );
  }
  return i.copy_;
}
function J2(e, t, o, i, c, n, d) {
  if (fe.process.env.NODE_ENV !== "production" && c === o && pn(5), No(c)) {
    const f = n && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !Jd(t.assigned_, i) ? n.concat(i) : void 0, p = tc(e, c, f);
    if (ey(o, i, p), No(p))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else d && o.add(c);
  if (xi(c) && !Rc(c)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    tc(e, c), (!t || !t.scope_.parent_) && typeof i != "symbol" && Object.prototype.propertyIsEnumerable.call(o, i) && rc(e, c);
  }
}
function rc(e, t, o = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && nh(t, o);
}
function yx(e, t) {
  const o = Array.isArray(e), i = {
    type_: o ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : ty(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let c = i, n = ih;
  o && (c = [i], n = fs);
  const { revoke: d, proxy: f } = Proxy.revocable(c, n);
  return i.draft_ = f, i.revoke_ = d, f;
}
var ih = {
  get(e, t) {
    if (t === An)
      return e;
    const o = no(e);
    if (!Jd(o, t))
      return Mx(e, o, t);
    const i = o[t];
    return e.finalized_ || !xi(i) ? i : i === Ql(e.base_, t) ? (Vl(e), e.copy_[t] = r1(i, e)) : i;
  },
  has(e, t) {
    return t in no(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(no(e));
  },
  set(e, t, o) {
    const i = ry(no(e), t);
    if (i != null && i.set)
      return i.set.call(e.draft_, o), !0;
    if (!e.modified_) {
      const c = Ql(no(e), t), n = c == null ? void 0 : c[An];
      if (n && n.base_ === o)
        return e.copy_[t] = o, e.assigned_[t] = !1, !0;
      if (ux(o, c) && (o !== void 0 || Jd(e.base_, t)))
        return !0;
      Vl(e), t1(e);
    }
    return e.copy_[t] === o && // special case: handle new props with value 'undefined'
    (o !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(o) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = o, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return Ql(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, Vl(e), t1(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const o = no(e), i = Reflect.getOwnPropertyDescriptor(o, t);
    return i && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: i.enumerable,
      value: o[t]
    };
  },
  defineProperty() {
    pn(11);
  },
  getPrototypeOf(e) {
    return la(e.base_);
  },
  setPrototypeOf() {
    pn(12);
  }
}, fs = {};
ec(ih, (e, t) => {
  fs[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
fs.deleteProperty = function(e, t) {
  return fe.process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && pn(13), fs.set.call(this, e, t, void 0);
};
fs.set = function(e, t, o) {
  return fe.process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && pn(14), ih.set.call(this, e[0], t, o, e[0]);
};
function Ql(e, t) {
  const o = e[An];
  return (o ? no(o) : e)[t];
}
function Mx(e, t, o) {
  var c;
  const i = ry(t, o);
  return i ? "value" in i ? i.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (c = i.get) == null ? void 0 : c.call(e.draft_)
  ) : void 0;
}
function ry(e, t) {
  if (!(t in e))
    return;
  let o = la(e);
  for (; o; ) {
    const i = Object.getOwnPropertyDescriptor(o, t);
    if (i)
      return i;
    o = la(o);
  }
}
function t1(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && t1(e.parent_));
}
function Vl(e) {
  e.copy_ || (e.copy_ = Xd(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var mx = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, o, i) => {
      if (typeof t == "function" && typeof o != "function") {
        const n = o;
        o = t;
        const d = this;
        return function(p = n, ...l) {
          return d.produce(p, (h) => o.call(this, h, ...l));
        };
      }
      typeof o != "function" && pn(6), i !== void 0 && typeof i != "function" && pn(7);
      let c;
      if (xi(t)) {
        const n = $2(this), d = r1(t, void 0);
        let f = !0;
        try {
          c = o(d), f = !1;
        } finally {
          f ? Kd(n) : e1(n);
        }
        return G2(n, i), q2(c, n);
      } else if (!t || typeof t != "object") {
        if (c = o(t), c === void 0 && (c = t), c === Xg && (c = void 0), this.autoFreeze_ && nh(c, !0), i) {
          const n = [], d = [];
          Ao("Patches").generateReplacementPatches_(t, c, n, d), i(n, d);
        }
        return c;
      } else
        pn(1, t);
    }, this.produceWithPatches = (t, o) => {
      if (typeof t == "function")
        return (d, ...f) => this.produceWithPatches(d, (p) => t(p, ...f));
      let i, c;
      return [this.produce(t, o, (d, f) => {
        i = d, c = f;
      }), i, c];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    xi(e) || pn(8), No(e) && (e = vx(e));
    const t = $2(this), o = r1(e, void 0);
    return o[An].isManual_ = !0, e1(t), o;
  }
  finishDraft(e, t) {
    const o = e && e[An];
    (!o || !o.isManual_) && pn(9);
    const { scope_: i } = o;
    return G2(i, t), q2(void 0, i);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let o;
    for (o = t.length - 1; o >= 0; o--) {
      const c = t[o];
      if (c.path.length === 0 && c.op === "replace") {
        e = c.value;
        break;
      }
    }
    o > -1 && (t = t.slice(o + 1));
    const i = Ao("Patches").applyPatches_;
    return No(e) ? i(e, t) : this.produce(
      e,
      (c) => i(c, t)
    );
  }
};
function r1(e, t) {
  const o = Bc(e) ? Ao("MapSet").proxyMap_(e, t) : Fc(e) ? Ao("MapSet").proxySet_(e, t) : yx(e, t);
  return (t ? t.scope_ : ty()).drafts_.push(o), o;
}
function vx(e) {
  return No(e) || pn(10, e), ny(e);
}
function ny(e) {
  if (!xi(e) || Rc(e))
    return e;
  const t = e[An];
  let o;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, o = Xd(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    o = Xd(e, !0);
  return ec(o, (i, c) => {
    ey(o, i, ny(c));
  }), t && (t.finalized_ = !1), o;
}
var Tn = new mx(), iy = Tn.produce;
Tn.produceWithPatches.bind(
  Tn
);
Tn.setAutoFreeze.bind(Tn);
Tn.setUseStrictShallowCopy.bind(Tn);
Tn.applyPatches.bind(Tn);
Tn.createDraft.bind(Tn);
Tn.finishDraft.bind(Tn);
function oy(e) {
  return ({ dispatch: o, getState: i }) => (c) => (n) => typeof n == "function" ? n(o, i, e) : c(n);
}
var bx = oy(), xx = oy, wx = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? K0 : K0.apply(null, arguments);
}, Cx = (e) => e && typeof e.match == "function";
function X2(e, t) {
  function o(...i) {
    if (t) {
      let c = t(...i);
      if (!c)
        throw new Error(fe.process.env.NODE_ENV === "production" ? wr(0) : "prepareAction did not return an object");
      return {
        type: e,
        payload: c.payload,
        ..."meta" in c && {
          meta: c.meta
        },
        ..."error" in c && {
          error: c.error
        }
      };
    }
    return {
      type: e,
      payload: i[0]
    };
  }
  return o.toString = () => `${e}`, o.type = e, o.match = (i) => Jg(i) && i.type === e, o;
}
function Ix(e) {
  return typeof e == "function" && "type" in e && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
  Cx(e);
}
function Nx(e) {
  const t = e ? `${e}`.split("/") : [], o = t[t.length - 1] || "actionCreator";
  return `Detected an action creator with type "${e || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${o}())\` instead of \`dispatch(${o})\`. This is necessary even if the action has no payload.`;
}
function Ax(e = {}) {
  if (fe.process.env.NODE_ENV === "production")
    return () => (o) => (i) => o(i);
  const {
    isActionCreator: t = Ix
  } = e;
  return () => (o) => (i) => (t(i) && console.warn(Nx(i.type)), o(i));
}
function ay(e, t) {
  let o = 0;
  return {
    measureTime(i) {
      const c = Date.now();
      try {
        return i();
      } finally {
        const n = Date.now();
        o += n - c;
      }
    },
    warnIfExceeded() {
      o > e && console.warn(`${t} took ${o}ms, which is more than the warning threshold of ${e}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
    }
  };
}
var sy = class Za extends Array {
  constructor(...t) {
    super(...t), Object.setPrototypeOf(this, Za.prototype);
  }
  static get [Symbol.species]() {
    return Za;
  }
  concat(...t) {
    return super.concat.apply(this, t);
  }
  prepend(...t) {
    return t.length === 1 && Array.isArray(t[0]) ? new Za(...t[0].concat(this)) : new Za(...t.concat(this));
  }
};
function K2(e) {
  return xi(e) ? iy(e, () => {
  }) : e;
}
function n0(e, t, o) {
  return e.has(t) ? e.get(t) : e.set(t, o(t)).get(t);
}
function Tx(e) {
  return typeof e != "object" || e == null || Object.isFrozen(e);
}
function Lx(e, t, o) {
  const i = cy(e, t, o);
  return {
    detectMutations() {
      return ly(e, t, i, o);
    }
  };
}
function cy(e, t = [], o, i = "", c = /* @__PURE__ */ new Set()) {
  const n = {
    value: o
  };
  if (!e(o) && !c.has(o)) {
    c.add(o), n.children = {};
    for (const d in o) {
      const f = i ? i + "." + d : d;
      t.length && t.indexOf(f) !== -1 || (n.children[d] = cy(e, t, o[d], f));
    }
  }
  return n;
}
function ly(e, t = [], o, i, c = !1, n = "") {
  const d = o ? o.value : void 0, f = d === i;
  if (c && !f && !Number.isNaN(i))
    return {
      wasMutated: !0,
      path: n
    };
  if (e(d) || e(i))
    return {
      wasMutated: !1
    };
  const p = {};
  for (let h in o.children)
    p[h] = !0;
  for (let h in i)
    p[h] = !0;
  const l = t.length > 0;
  for (let h in p) {
    const y = n ? n + "." + h : h;
    if (l && t.some((N) => N instanceof RegExp ? N.test(y) : y === N))
      continue;
    const M = ly(e, t, o.children[h], i[h], f, y);
    if (M.wasMutated)
      return M;
  }
  return {
    wasMutated: !1
  };
}
function Sx(e = {}) {
  if (fe.process.env.NODE_ENV === "production")
    return () => (t) => (o) => t(o);
  {
    let t = function(f, p, l, h) {
      return JSON.stringify(f, o(p, h), l);
    }, o = function(f, p) {
      let l = [], h = [];
      return p || (p = function(y, M) {
        return l[0] === M ? "[Circular ~]" : "[Circular ~." + h.slice(0, l.indexOf(M)).join(".") + "]";
      }), function(y, M) {
        if (l.length > 0) {
          var C = l.indexOf(this);
          ~C ? l.splice(C + 1) : l.push(this), ~C ? h.splice(C, 1 / 0, y) : h.push(y), ~l.indexOf(M) && (M = p.call(this, y, M));
        } else l.push(M);
        return f == null ? M : f.call(this, y, M);
      };
    }, {
      isImmutable: i = Tx,
      ignoredPaths: c,
      warnAfter: n = 32
    } = e;
    const d = Lx.bind(null, i, c);
    return ({
      getState: f
    }) => {
      let p = f(), l = d(p), h;
      return (y) => (M) => {
        const C = ay(n, "ImmutableStateInvariantMiddleware");
        C.measureTime(() => {
          if (p = f(), h = l.detectMutations(), l = d(p), h.wasMutated)
            throw new Error(fe.process.env.NODE_ENV === "production" ? wr(19) : `A state mutation was detected between dispatches, in the path '${h.path || ""}'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
        });
        const N = y(M);
        return C.measureTime(() => {
          if (p = f(), h = l.detectMutations(), l = d(p), h.wasMutated)
            throw new Error(fe.process.env.NODE_ENV === "production" ? wr(20) : `A state mutation was detected inside a dispatch, in the path: ${h.path || ""}. Take a look at the reducer(s) handling the action ${t(M)}. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
        }), C.warnIfExceeded(), N;
      };
    };
  }
}
function fy(e) {
  const t = typeof e;
  return e == null || t === "string" || t === "boolean" || t === "number" || Array.isArray(e) || Es(e);
}
function n1(e, t = "", o = fy, i, c = [], n) {
  let d;
  if (!o(e))
    return {
      keyPath: t || "<root>",
      value: e
    };
  if (typeof e != "object" || e === null || n != null && n.has(e)) return !1;
  const f = i != null ? i(e) : Object.entries(e), p = c.length > 0;
  for (const [l, h] of f) {
    const y = t ? t + "." + l : l;
    if (!(p && c.some((C) => C instanceof RegExp ? C.test(y) : y === C))) {
      if (!o(h))
        return {
          keyPath: y,
          value: h
        };
      if (typeof h == "object" && (d = n1(h, y, o, i, c, n), d))
        return d;
    }
  }
  return n && uy(e) && n.add(e), !1;
}
function uy(e) {
  if (!Object.isFrozen(e)) return !1;
  for (const t of Object.values(e))
    if (!(typeof t != "object" || t === null) && !uy(t))
      return !1;
  return !0;
}
function Ex(e = {}) {
  if (fe.process.env.NODE_ENV === "production")
    return () => (t) => (o) => t(o);
  {
    const {
      isSerializable: t = fy,
      getEntries: o,
      ignoredActions: i = [],
      ignoredActionPaths: c = ["meta.arg", "meta.baseQueryMeta"],
      ignoredPaths: n = [],
      warnAfter: d = 32,
      ignoreState: f = !1,
      ignoreActions: p = !1,
      disableCache: l = !1
    } = e, h = !l && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
    return (y) => (M) => (C) => {
      if (!Jg(C))
        return M(C);
      const N = M(C), w = ay(d, "SerializableStateInvariantMiddleware");
      return !p && !(i.length && i.indexOf(C.type) !== -1) && w.measureTime(() => {
        const S = n1(C, "", t, o, c, h);
        if (S) {
          const {
            keyPath: T,
            value: E
          } = S;
          console.error(`A non-serializable value was detected in an action, in the path: \`${T}\`. Value:`, E, `
Take a look at the logic that dispatched this action: `, C, `
(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)`, `
(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)`);
        }
      }), f || (w.measureTime(() => {
        const S = y.getState(), T = n1(S, "", t, o, n, h);
        if (T) {
          const {
            keyPath: E,
            value: j
          } = T;
          console.error(`A non-serializable value was detected in the state, in the path: \`${E}\`. Value:`, j, `
Take a look at the reducer(s) handling this action type: ${C.type}.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
        }
      }), w.warnIfExceeded()), N;
    };
  }
}
function i0(e) {
  return typeof e == "boolean";
}
var Dx = () => function(t) {
  const {
    thunk: o = !0,
    immutableCheck: i = !0,
    serializableCheck: c = !0,
    actionCreatorCheck: n = !0
  } = t ?? {};
  let d = new sy();
  if (o && (i0(o) ? d.push(bx) : d.push(xx(o.extraArgument))), fe.process.env.NODE_ENV !== "production") {
    if (i) {
      let f = {};
      i0(i) || (f = i), d.unshift(Sx(f));
    }
    if (c) {
      let f = {};
      i0(c) || (f = c), d.push(Ex(f));
    }
    if (n) {
      let f = {};
      i0(n) || (f = n), d.unshift(Ax(f));
    }
  }
  return d;
}, jx = "RTK_autoBatch", e4 = (e) => (t) => {
  setTimeout(t, e);
}, Ox = (e = {
  type: "raf"
}) => (t) => (...o) => {
  const i = t(...o);
  let c = !0, n = !1, d = !1;
  const f = /* @__PURE__ */ new Set(), p = e.type === "tick" ? queueMicrotask : e.type === "raf" ? (
    // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
    typeof window < "u" && window.requestAnimationFrame ? window.requestAnimationFrame : e4(10)
  ) : e.type === "callback" ? e.queueNotification : e4(e.timeout), l = () => {
    d = !1, n && (n = !1, f.forEach((h) => h()));
  };
  return Object.assign({}, i, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(h) {
      const y = () => c && h(), M = i.subscribe(y);
      return f.add(h), () => {
        M(), f.delete(h);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(h) {
      var y;
      try {
        return c = !((y = h == null ? void 0 : h.meta) != null && y[jx]), n = !c, n && (d || (d = !0, p(l))), i.dispatch(h);
      } finally {
        c = !0;
      }
    }
  });
}, zx = (e) => function(o) {
  const {
    autoBatch: i = !0
  } = o ?? {};
  let c = new sy(e);
  return i && c.push(Ox(typeof i == "object" ? i : void 0)), c;
};
function kx(e) {
  const t = Dx(), {
    reducer: o = void 0,
    middleware: i,
    devTools: c = !0,
    duplicateMiddlewareCheck: n = !0,
    preloadedState: d = void 0,
    enhancers: f = void 0
  } = e || {};
  let p;
  if (typeof o == "function")
    p = o;
  else if (Es(o))
    p = sx(o);
  else
    throw new Error(fe.process.env.NODE_ENV === "production" ? wr(1) : "`reducer` is a required argument, and must be a function or an object of functions that can be passed to combineReducers");
  if (fe.process.env.NODE_ENV !== "production" && i && typeof i != "function")
    throw new Error(fe.process.env.NODE_ENV === "production" ? wr(2) : "`middleware` field must be a callback");
  let l;
  if (typeof i == "function") {
    if (l = i(t), fe.process.env.NODE_ENV !== "production" && !Array.isArray(l))
      throw new Error(fe.process.env.NODE_ENV === "production" ? wr(3) : "when using a middleware builder function, an array of middleware must be returned");
  } else
    l = t();
  if (fe.process.env.NODE_ENV !== "production" && l.some((w) => typeof w != "function"))
    throw new Error(fe.process.env.NODE_ENV === "production" ? wr(4) : "each middleware provided to configureStore must be a function");
  if (fe.process.env.NODE_ENV !== "production" && n) {
    let w = /* @__PURE__ */ new Set();
    l.forEach((S) => {
      if (w.has(S))
        throw new Error(fe.process.env.NODE_ENV === "production" ? wr(42) : "Duplicate middleware references found when creating the store. Ensure that each middleware is only included once.");
      w.add(S);
    });
  }
  let h = K0;
  c && (h = wx({
    // Enable capture of stack traces for dispatched Redux actions
    trace: fe.process.env.NODE_ENV !== "production",
    ...typeof c == "object" && c
  }));
  const y = cx(...l), M = zx(y);
  if (fe.process.env.NODE_ENV !== "production" && f && typeof f != "function")
    throw new Error(fe.process.env.NODE_ENV === "production" ? wr(5) : "`enhancers` field must be a callback");
  let C = typeof f == "function" ? f(M) : M();
  if (fe.process.env.NODE_ENV !== "production" && !Array.isArray(C))
    throw new Error(fe.process.env.NODE_ENV === "production" ? wr(6) : "`enhancers` callback must return an array");
  if (fe.process.env.NODE_ENV !== "production" && C.some((w) => typeof w != "function"))
    throw new Error(fe.process.env.NODE_ENV === "production" ? wr(7) : "each enhancer provided to configureStore must be a function");
  fe.process.env.NODE_ENV !== "production" && l.length && !C.includes(y) && console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
  const N = h(...C);
  return qg(p, d, N);
}
function dy(e) {
  const t = {}, o = [];
  let i;
  const c = {
    addCase(n, d) {
      if (fe.process.env.NODE_ENV !== "production") {
        if (o.length > 0)
          throw new Error(fe.process.env.NODE_ENV === "production" ? wr(26) : "`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (i)
          throw new Error(fe.process.env.NODE_ENV === "production" ? wr(27) : "`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      const f = typeof n == "string" ? n : n.type;
      if (!f)
        throw new Error(fe.process.env.NODE_ENV === "production" ? wr(28) : "`builder.addCase` cannot be called with an empty action type");
      if (f in t)
        throw new Error(fe.process.env.NODE_ENV === "production" ? wr(29) : `\`builder.addCase\` cannot be called with two reducers for the same action type '${f}'`);
      return t[f] = d, c;
    },
    addMatcher(n, d) {
      if (fe.process.env.NODE_ENV !== "production" && i)
        throw new Error(fe.process.env.NODE_ENV === "production" ? wr(30) : "`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return o.push({
        matcher: n,
        reducer: d
      }), c;
    },
    addDefaultCase(n) {
      if (fe.process.env.NODE_ENV !== "production" && i)
        throw new Error(fe.process.env.NODE_ENV === "production" ? wr(31) : "`builder.addDefaultCase` can only be called once");
      return i = n, c;
    }
  };
  return e(c), [t, o, i];
}
function _x(e) {
  return typeof e == "function";
}
function Bx(e, t) {
  if (fe.process.env.NODE_ENV !== "production" && typeof t == "object")
    throw new Error(fe.process.env.NODE_ENV === "production" ? wr(8) : "The object notation for `createReducer` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
  let [o, i, c] = dy(t), n;
  if (_x(e))
    n = () => K2(e());
  else {
    const f = K2(e);
    n = () => f;
  }
  function d(f = n(), p) {
    let l = [o[p.type], ...i.filter(({
      matcher: h
    }) => h(p)).map(({
      reducer: h
    }) => h)];
    return l.filter((h) => !!h).length === 0 && (l = [c]), l.reduce((h, y) => {
      if (y)
        if (No(h)) {
          const C = y(h, p);
          return C === void 0 ? h : C;
        } else {
          if (xi(h))
            return iy(h, (M) => y(M, p));
          {
            const M = y(h, p);
            if (M === void 0) {
              if (h === null)
                return h;
              throw Error("A case reducer on a non-draftable value must not return undefined");
            }
            return M;
          }
        }
      return h;
    }, f);
  }
  return d.getInitialState = n, d;
}
var Fx = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function Rx(e, t) {
  return `${e}/${t}`;
}
function Px({
  creators: e
} = {}) {
  var o;
  const t = (o = e == null ? void 0 : e.asyncThunk) == null ? void 0 : o[Fx];
  return function(c) {
    const {
      name: n,
      reducerPath: d = n
    } = c;
    if (!n)
      throw new Error(fe.process.env.NODE_ENV === "production" ? wr(11) : "`name` is a required option for createSlice");
    typeof fe.process < "u" && fe.process.env.NODE_ENV === "development" && c.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
    const f = (typeof c.reducers == "function" ? c.reducers(Yx()) : c.reducers) || {}, p = Object.keys(f), l = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    }, h = {
      addCase(O, z) {
        const k = typeof O == "string" ? O : O.type;
        if (!k)
          throw new Error(fe.process.env.NODE_ENV === "production" ? wr(12) : "`context.addCase` cannot be called with an empty action type");
        if (k in l.sliceCaseReducersByType)
          throw new Error(fe.process.env.NODE_ENV === "production" ? wr(13) : "`context.addCase` cannot be called with two reducers for the same action type: " + k);
        return l.sliceCaseReducersByType[k] = z, h;
      },
      addMatcher(O, z) {
        return l.sliceMatchers.push({
          matcher: O,
          reducer: z
        }), h;
      },
      exposeAction(O, z) {
        return l.actionCreators[O] = z, h;
      },
      exposeCaseReducer(O, z) {
        return l.sliceCaseReducersByName[O] = z, h;
      }
    };
    p.forEach((O) => {
      const z = f[O], k = {
        reducerName: O,
        type: Rx(n, O),
        createNotation: typeof c.reducers == "function"
      };
      Hx(z) ? Qx(k, z, h, t) : Wx(k, z, h);
    });
    function y() {
      if (fe.process.env.NODE_ENV !== "production" && typeof c.extraReducers == "object")
        throw new Error(fe.process.env.NODE_ENV === "production" ? wr(14) : "The object notation for `createSlice.extraReducers` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
      const [O = {}, z = [], k = void 0] = typeof c.extraReducers == "function" ? dy(c.extraReducers) : [c.extraReducers], H = {
        ...O,
        ...l.sliceCaseReducersByType
      };
      return Bx(c.initialState, (W) => {
        for (let U in H)
          W.addCase(U, H[U]);
        for (let U of l.sliceMatchers)
          W.addMatcher(U.matcher, U.reducer);
        for (let U of z)
          W.addMatcher(U.matcher, U.reducer);
        k && W.addDefaultCase(k);
      });
    }
    const M = (O) => O, C = /* @__PURE__ */ new Map(), N = /* @__PURE__ */ new WeakMap();
    let w;
    function S(O, z) {
      return w || (w = y()), w(O, z);
    }
    function T() {
      return w || (w = y()), w.getInitialState();
    }
    function E(O, z = !1) {
      function k(W) {
        let U = W[O];
        if (typeof U > "u") {
          if (z)
            U = n0(N, k, T);
          else if (fe.process.env.NODE_ENV !== "production")
            throw new Error(fe.process.env.NODE_ENV === "production" ? wr(15) : "selectSlice returned undefined for an uninjected slice reducer");
        }
        return U;
      }
      function H(W = M) {
        const U = n0(C, z, () => /* @__PURE__ */ new WeakMap());
        return n0(U, W, () => {
          const B = {};
          for (const [I, r] of Object.entries(c.selectors ?? {}))
            B[I] = Ux(r, W, () => n0(N, W, T), z);
          return B;
        });
      }
      return {
        reducerPath: O,
        getSelectors: H,
        get selectors() {
          return H(k);
        },
        selectSlice: k
      };
    }
    const j = {
      name: n,
      reducer: S,
      actions: l.actionCreators,
      caseReducers: l.sliceCaseReducersByName,
      getInitialState: T,
      ...E(d),
      injectInto(O, {
        reducerPath: z,
        ...k
      } = {}) {
        const H = z ?? d;
        return O.inject({
          reducerPath: H,
          reducer: S
        }, k), {
          ...j,
          ...E(H, !0)
        };
      }
    };
    return j;
  };
}
function Ux(e, t, o, i) {
  function c(n, ...d) {
    let f = t(n);
    if (typeof f > "u") {
      if (i)
        f = o();
      else if (fe.process.env.NODE_ENV !== "production")
        throw new Error(fe.process.env.NODE_ENV === "production" ? wr(16) : "selectState returned undefined for an uninjected slice reducer");
    }
    return e(f, ...d);
  }
  return c.unwrapped = e, c;
}
var Ca = /* @__PURE__ */ Px();
function Yx() {
  function e(t, o) {
    return {
      _reducerDefinitionType: "asyncThunk",
      payloadCreator: t,
      ...o
    };
  }
  return e.withTypes = () => e, {
    reducer(t) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [t.name](...o) {
          return t(...o);
        }
      }[t.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(t, o) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare: t,
        reducer: o
      };
    },
    asyncThunk: e
  };
}
function Wx({
  type: e,
  reducerName: t,
  createNotation: o
}, i, c) {
  let n, d;
  if ("reducer" in i) {
    if (o && !Zx(i))
      throw new Error(fe.process.env.NODE_ENV === "production" ? wr(17) : "Please use the `create.preparedReducer` notation for prepared action creators with the `create` notation.");
    n = i.reducer, d = i.prepare;
  } else
    n = i;
  c.addCase(e, n).exposeCaseReducer(t, n).exposeAction(t, d ? X2(e, d) : X2(e));
}
function Hx(e) {
  return e._reducerDefinitionType === "asyncThunk";
}
function Zx(e) {
  return e._reducerDefinitionType === "reducerWithPrepare";
}
function Qx({
  type: e,
  reducerName: t
}, o, i, c) {
  if (!c)
    throw new Error(fe.process.env.NODE_ENV === "production" ? wr(18) : "Cannot use `create.asyncThunk` in the built-in `createSlice`. Use `buildCreateSlice({ creators: { asyncThunk: asyncThunkCreator } })` to create a customised version of `createSlice`.");
  const {
    payloadCreator: n,
    fulfilled: d,
    pending: f,
    rejected: p,
    settled: l,
    options: h
  } = o, y = c(e, n, h);
  i.exposeAction(t, y), d && i.addCase(y.fulfilled, d), f && i.addCase(y.pending, f), p && i.addCase(y.rejected, p), l && i.addMatcher(y.settled, l), i.exposeCaseReducer(t, {
    fulfilled: d || o0,
    pending: f || o0,
    rejected: p || o0,
    settled: l || o0
  });
}
function o0() {
}
function wr(e) {
  return `Minified Redux Toolkit error #${e}; visit https://redux-toolkit.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
const t4 = {
  txData: void 0,
  sendTx: "",
  redeemTx: "",
  transferComplete: !1,
  route: void 0,
  isResumeTx: !1,
  timestamp: 0
}, hy = Ca({
  name: "redeem",
  initialState: t4,
  reducers: {
    setTxDetails: (e, { payload: t }) => {
      e.txData = t;
    },
    setSendTx: (e, { payload: t }) => {
      e.sendTx = t;
    },
    setRoute: (e, { payload: t }) => {
      e.route = t;
    },
    clearRedeem: (e) => {
      Object.keys(e).forEach((t) => {
        e[t] = t4[t];
      });
    },
    setIsResumeTx: (e, { payload: t }) => {
      e.isResumeTx = t;
    },
    setTimestamp: (e, { payload: t }) => {
      e.timestamp = t;
    }
  }
}), {
  setTxDetails: Pc,
  setSendTx: Vx,
  clearRedeem: i1,
  setRoute: Uc,
  setIsResumeTx: oh,
  setTimestamp: ah
} = hy.actions, Gx = hy.reducer, $x = {
  env: "Testnet",
  rpcs: {
    Bsc: "https://data-seed-prebsc-1-s3.binance.org:8545",
    Avalanche: "https://api.avax-test.network/ext/bc/C/rpc",
    Fantom: "https://rpc.testnet.fantom.network",
    Celo: "https://alfajores-forno.celo-testnet.org",
    Solana: "https://api.devnet.solana.com",
    Moonbeam: "https://rpc.api.moonbase.moonbeam.network",
    Sui: "https://fullnode.testnet.sui.io",
    Aptos: "https://fullnode.testnet.aptoslabs.com/v1",
    Sei: "https://rpc.atlantic-2.seinetwork.io",
    Klaytn: "https://public-en-kairos.node.kaia.io",
    Sepolia: "https://ethereum-sepolia-rpc.publicnode.com",
    ArbitrumSepolia: "https://sepolia-rollup.arbitrum.io/rpc",
    BaseSepolia: "https://base-sepolia-rpc.publicnode.com",
    OptimismSepolia: "https://sepolia.optimism.io",
    Scroll: "https://scroll-sepolia-rpc.publicnode.com",
    Xlayer: "https://testrpc.xlayer.tech",
    Mantle: "https://rpc.sepolia.mantle.xyz",
    Worldchain: "https://worldchain-sepolia.g.alchemy.com/public",
    Unichain: "https://sepolia.unichain.org",
    Mezo: "https://rpc.test.mezo.org",
    Linea: "https://linea-sepolia-rpc.publicnode.com",
    Sonic: "https://sonic-blaze-rpc.publicnode.com"
  }
}, qx = {
  env: "Mainnet",
  rpcs: {
    Ethereum: "https://ethereum-rpc.publicnode.com",
    Solana: "https://solana-rpc.publicnode.com",
    Polygon: "https://polygon-bor-rpc.publicnode.com",
    Bsc: "https://bscrpc.com",
    Avalanche: "https://avalanche-c-chain-rpc.publicnode.com",
    Fantom: "https://rpcapi.fantom.network",
    Celo: "https://celo-rpc.publicnode.com",
    Moonbeam: "https://moonbeam-rpc.publicnode.com",
    Sui: "https://rpc.mainnet.sui.io",
    Aptos: "https://fullnode.mainnet.aptoslabs.com/v1",
    Arbitrum: "https://arbitrum-one-rpc.publicnode.com",
    Optimism: "https://optimism-rpc.publicnode.com",
    Base: "https://base.publicnode.com",
    Sei: "",
    // TODO: fill in
    Klaytn: "https://public-en.node.kaia.io",
    Scroll: "https://scroll-rpc.publicnode.com",
    Xlayer: "https://rpc.xlayer.tech",
    Mantle: "https://rpc.mantle.xyz",
    Worldchain: "https://worldchain-mainnet.g.alchemy.com/public",
    Unichain: "https://mainnet.unichain.org",
    Berachain: "https://rpc.berachain.com",
    Linea: "https://linea-rpc.publicnode.com",
    Sonic: "https://sonic-rpc.publicnode.com"
  }
}, Jx = {
  env: "Devnet",
  rpcs: {
    Ethereum: "http://localhost:8545"
  }
}, as = class as extends Error {
  constructor() {
    super(as.MESSAGE);
  }
};
zt(as, "MESSAGE", "Insufficient funds for gas"), zt(as, "MESSAGE_REGEX", /insufficient funds|Insufficient funds for gas/gm);
let o1 = as;
const Xx = {
  MAINNET: qx,
  TESTNET: $x,
  DEVNET: Jx
}, Kx = {
  Ethereum: {
    displayName: "Ethereum",
    sdkName: "Ethereum",
    explorerUrl: "https://etherscan.io/",
    explorerName: "Etherscan",
    icon: "Ethereum",
    symbol: "ETH"
  },
  Bsc: {
    displayName: "BSC",
    sdkName: "Bsc",
    explorerUrl: "https://bscscan.com/",
    explorerName: "BscScan",
    icon: "Bsc",
    symbol: "BSC"
  },
  Polygon: {
    displayName: "Polygon",
    sdkName: "Polygon",
    explorerUrl: "https://polygonscan.com/",
    explorerName: "PolygonScan",
    icon: "Polygon",
    symbol: "POL"
  },
  Avalanche: {
    displayName: "Avalanche",
    sdkName: "Avalanche",
    explorerUrl: "https://snowtrace.io/",
    explorerName: "Snowtrace",
    icon: "Avalanche",
    symbol: "AVAX"
  },
  Fantom: {
    displayName: "Fantom",
    sdkName: "Fantom",
    explorerUrl: "https://explorer.fantom.network/",
    explorerName: "Fantom Explorer",
    icon: "Fantom",
    symbol: "FTM"
  },
  Celo: {
    displayName: "Celo",
    sdkName: "Celo",
    explorerUrl: "https://explorer.celo.org/mainnet/",
    explorerName: "Celo Explorer",
    icon: "Celo",
    symbol: "CELO"
  },
  Moonbeam: {
    displayName: "Moonbeam",
    sdkName: "Moonbeam",
    explorerUrl: "https://moonscan.io/",
    explorerName: "Moonscan",
    icon: "Moonbeam",
    symbol: "GLMR"
  },
  Solana: {
    displayName: "Solana",
    sdkName: "Solana",
    explorerUrl: "https://explorer.solana.com/",
    explorerName: "Solana Explorer",
    icon: "Solana",
    symbol: "SOL"
  },
  Sui: {
    displayName: "Sui",
    sdkName: "Sui",
    explorerUrl: "https://suiscan.xyz/",
    explorerName: "Suiscan",
    icon: "Sui",
    symbol: "SUI"
  },
  Aptos: {
    displayName: "Aptos",
    sdkName: "Aptos",
    explorerUrl: "https://explorer.aptoslabs.com/",
    explorerName: "Aptos Explorer",
    icon: "Aptos",
    symbol: "APT"
  },
  Base: {
    displayName: "Base",
    sdkName: "Base",
    explorerUrl: "https://basescan.org/",
    explorerName: "BaseScan",
    icon: "Base",
    symbol: "BASE"
  },
  Arbitrum: {
    displayName: "Arbitrum",
    sdkName: "Arbitrum",
    explorerUrl: "https://arbiscan.io/",
    explorerName: "Arbitrum Explorer",
    icon: "Arbitrum",
    symbol: "ARB"
  },
  Optimism: {
    displayName: "Optimism",
    sdkName: "Optimism",
    explorerUrl: "https://optimistic.etherscan.io/",
    explorerName: "Optimistic Etherscan",
    icon: "Optimism",
    symbol: "OP"
  },
  Klaytn: {
    displayName: "Kaia",
    sdkName: "Klaytn",
    explorerUrl: "https://kaiascope.com/",
    explorerName: "Kaia Scope",
    icon: "Klaytn",
    symbol: "KAIA"
  },
  Scroll: {
    displayName: "Scroll",
    sdkName: "Scroll",
    explorerUrl: "https://scrollscan.com/",
    explorerName: "Scrollscan",
    icon: "Scroll",
    symbol: "SCR"
  },
  Xlayer: {
    displayName: "X Layer",
    sdkName: "Xlayer",
    explorerUrl: "https://www.okx.com/web3/explorer/xlayer/",
    explorerName: "OKX Explorer",
    icon: "Xlayer",
    symbol: "OKX"
  },
  Mantle: {
    displayName: "Mantle",
    sdkName: "Mantle",
    explorerUrl: "https://explorer.mantle.xyz/",
    explorerName: "Mantle Explorer",
    icon: "Mantle",
    symbol: "MNT"
  },
  Worldchain: {
    displayName: "World Chain",
    sdkName: "Worldchain",
    explorerUrl: "https://worldscan.org/",
    explorerName: "World Scan",
    icon: "Worldchain",
    symbol: "WORLD"
  },
  Unichain: {
    displayName: "Unichain",
    sdkName: "Unichain",
    explorerUrl: "https://uniscan.xyz/",
    explorerName: "Uniscan",
    icon: "Unichain",
    symbol: "UNI"
  },
  Berachain: {
    displayName: "Berachain",
    sdkName: "Berachain",
    explorerUrl: "https://berascan.com/",
    explorerName: "Berascan",
    icon: "Berachain",
    symbol: "BERA"
  },
  Linea: {
    displayName: "Linea",
    sdkName: "Linea",
    explorerUrl: "https://lineascan.build/",
    explorerName: "Lineascan",
    icon: "Linea",
    symbol: "LINEA"
  },
  Sonic: {
    displayName: "Sonic",
    sdkName: "Sonic",
    explorerUrl: "https://sonicscan.org/",
    explorerName: "Sonicscan",
    icon: "Sonic",
    symbol: "S"
  },
  Mezo: {
    displayName: "Mezo",
    sdkName: "Mezo",
    explorerUrl: "https://explorer.mezo.org",
    explorerName: "Mezo Explorer",
    icon: "Mezo",
    symbol: "BTC"
  },
  Seievm: {
    displayName: "SeiEVM",
    sdkName: "Seievm",
    explorerUrl: "https://seitrace.com/?chain=pacific-1",
    explorerName: "Seitrace",
    icon: "Seievm",
    symbol: "SEI"
  },
  Plume: {
    displayName: "Plume",
    sdkName: "Plume",
    explorerUrl: "https://explorer.plume.org",
    explorerName: "Plume Explorer",
    icon: "Plume",
    symbol: "PLUME"
  }
}, Ji = (e) => {
  console.error(`Wormhole Connect: ${e}`);
}, _t = (e, t) => t ? { [e]: t } : {}, ew = (e, t) => {
  if (!t) return e;
  for (const o in t)
    for (const i in t[o])
      e[o] || (e[o] = {}), e[o][i] = {
        ...t[o][i],
        // Prevent overwriting built-in wrapped token addresses
        ...e[o][i]
      };
  return e;
}, tw = (e, t, o) => {
  if (e)
    return e.fromChain && (t[e.fromChain] || (Ji(
      `Invalid chain name "${e.fromChain}" specified for defaultInputs.fromChain`
    ), delete e.fromChain)), e.toChain && (t[e.toChain] || (Ji(
      `Invalid chain name "${e.toChain}" specified for defaultInputs.toChain`
    ), delete e.fromChain)), e.fromChain && e.toChain && e.fromChain === e.toChain && Ji(
      "Source and destination chain cannot be the same, check the defaultInputs configuration"
    ), e.fromChain && e.toChain && e.requiredChain && (t[e.requiredChain] || Ji(
      `Invalid network value "${e.requiredChain}" specified for defaultInputs.requiredChain`
    ), e.toChain !== e.requiredChain && e.fromChain !== e.requiredChain && Ji(
      "Source chain or destination chain must equal the required network"
    )), e.fromChain && e.fromToken && (o.findByAddressOrSymbol(
      e.fromChain,
      e.fromToken
    ) || (Ji(
      `Invalid token "${e.fromToken}" specified for defaultInputs.fromToken`
    ), delete e.fromToken)), e.toChain && e.toToken && (o.findByAddressOrSymbol(
      e.toChain,
      e.toToken
    ) || (Ji(
      `Invalid token "${e.toToken}" specified for defaultInputs.toToken`
    ), delete e.toToken)), e;
}, rw = (e) => e[0].toUpperCase() + e.slice(1), nw = {}, {
  REACT_APP_ETHEREUM_RPC: iw,
  REACT_APP_SOLANA_RPC: ow,
  REACT_APP_POLYGON_RPC: aw,
  REACT_APP_BSC_RPC: sw,
  REACT_APP_AVALANCHE_RPC: cw,
  REACT_APP_FANTOM_RPC: lw,
  REACT_APP_CELO_RPC: fw,
  REACT_APP_MOONBEAM_RPC: uw,
  REACT_APP_SUI_RPC: dw,
  REACT_APP_APTOS_RPC: hw,
  REACT_APP_BASE_RPC: pw,
  REACT_APP_KLAYTN_RPC: gw,
  REACT_APP_ARBITRUM_RPC: yw,
  REACT_APP_OPTIMISM_RPC: Mw,
  REACT_APP_SCROLL_RPC: mw,
  REACT_APP_XLAYER_RPC: vw,
  REACT_APP_MANTLE_RPC: bw,
  REACT_APP_WORLDCHAIN_RPC: xw,
  REACT_APP_UNICHAIN_RPC: ww,
  REACT_APP_BERACHAIN_RPC: Cw,
  REACT_APP_LINEA_RPC: Iw,
  REACT_APP_SONIC_RPC: Nw,
  REACT_APP_SEIEVM_RPC: Aw,
  REACT_APP_MEZO_RPC: Tw,
  REACT_APP_PLUME_RPC: Lw
} = nw, Sw = {
  ..._t("Ethereum", iw),
  ..._t("Solana", ow),
  ..._t("Polygon", aw),
  ..._t("Bsc", sw),
  ..._t("Avalanche", cw),
  ..._t("Fantom", lw),
  ..._t("Celo", fw),
  ..._t("Moonbeam", uw),
  ..._t("Sui", dw),
  ..._t("Aptos", hw),
  ..._t("Base", pw),
  ..._t("Arbitrum", yw),
  ..._t("Optimism", Mw),
  ..._t("Klaytn", gw),
  ..._t("Scroll", mw),
  ..._t("Xlayer", vw),
  ..._t("Mantle", bw),
  ..._t("Worldchain", xw),
  ..._t("Unichain", ww),
  ..._t("Berachain", Cw),
  ..._t("Linea", Iw),
  ..._t("Sonic", Nw),
  ..._t("Seievm", Aw),
  ..._t("Mezo", Tw),
  ..._t("Plume", Lw)
};
function a1(e) {
  return {
    ...e,
    experimental: e.experimental ?? {},
    walletConnectProjectId: (e == null ? void 0 : e.walletConnectProjectId) ?? void 0
  };
}
var Ee = /* @__PURE__ */ ((e) => (e[e.AVAX = 1] = "AVAX", e[e.BNB = 2] = "BNB", e[e.BSC = 3] = "BSC", e[e.CELO = 4] = "CELO", e[e.ETH = 5] = "ETH", e[e.FANTOM = 6] = "FANTOM", e[e.POLYGON = 7] = "POLYGON", e[e.SOLANA = 8] = "SOLANA", e[e.USDC = 9] = "USDC", e[e.GLMR = 10] = "GLMR", e[e.DAI = 11] = "DAI", e[e.USDT = 12] = "USDT", e[e.BUSD = 13] = "BUSD", e[e.WBTC = 14] = "WBTC", e[e.SUI = 15] = "SUI", e[e.APT = 16] = "APT", e[e.SEI = 17] = "SEI", e[e.BASE = 18] = "BASE", e[e.OSMO = 19] = "OSMO", e[e.TBTC = 20] = "TBTC", e[e.WSTETH = 21] = "WSTETH", e[e.ARBITRUM = 22] = "ARBITRUM", e[e.OPTIMISM = 23] = "OPTIMISM", e[e.ATOM = 24] = "ATOM", e[e.EVMOS = 25] = "EVMOS", e[e.KUJI = 26] = "KUJI", e[e.PYTH = 27] = "PYTH", e[e.INJ = 28] = "INJ", e[e.KLAY = 29] = "KLAY", e[e.NTT = 30] = "NTT", e[e.SCROLL = 31] = "SCROLL", e[e.XLAYER = 32] = "XLAYER", e[e.MANTLE = 33] = "MANTLE", e[e.WORLDCHAIN = 34] = "WORLDCHAIN", e[e.BERA = 35] = "BERA", e[e.BTC = 36] = "BTC", e[e.SONIC = 37] = "SONIC", e[e.PLUME = 38] = "PLUME", e))(Ee || {});
const AR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TokenIcon: Ee,
  createUiConfig: a1
}, Symbol.toStringTag, { value: "Module" })), Ew = [
  {
    symbol: "ETH",
    decimals: 18,
    icon: Ee.ETH,
    tokenId: { chain: "Ethereum", address: "native" }
  },
  {
    symbol: "WETH",
    decimals: 18,
    icon: Ee.ETH,
    tokenId: {
      chain: "Ethereum",
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2"
    }
  },
  {
    symbol: "USDC",
    decimals: 6,
    icon: Ee.USDC,
    tokenId: {
      chain: "Ethereum",
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
    }
  },
  {
    symbol: "WBTC",
    decimals: 8,
    icon: Ee.WBTC,
    tokenId: {
      chain: "Ethereum",
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
    }
  },
  {
    symbol: "USDT",
    decimals: 6,
    icon: Ee.USDT,
    tokenId: {
      chain: "Ethereum",
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7"
    }
  },
  {
    symbol: "DAI",
    decimals: 18,
    icon: Ee.DAI,
    tokenId: {
      chain: "Ethereum",
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F"
    }
  },
  {
    symbol: "BUSD",
    decimals: 18,
    icon: Ee.BUSD,
    tokenId: {
      chain: "Ethereum",
      address: "0x4Fabb145d64652a948d72533023f6E7A623C7C53"
    }
  },
  {
    symbol: "POL",
    decimals: 18,
    icon: Ee.POLYGON,
    tokenId: { chain: "Polygon", address: "native" }
  },
  {
    symbol: "WPOL",
    decimals: 18,
    icon: Ee.POLYGON,
    tokenId: {
      chain: "Polygon",
      address: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270"
    }
  },
  {
    symbol: "WETH",
    decimals: 18,
    icon: Ee.ETH,
    tokenId: {
      chain: "Polygon",
      address: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619"
    }
  },
  {
    symbol: "USDC",
    decimals: 6,
    icon: Ee.USDC,
    tokenId: {
      chain: "Polygon",
      address: "0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359"
    }
  },
  {
    symbol: "USDT",
    decimals: 6,
    icon: Ee.USDT,
    tokenId: {
      chain: "Polygon",
      address: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F"
    }
  },
  {
    symbol: "BNB",
    decimals: 18,
    icon: Ee.BNB,
    tokenId: { chain: "Bsc", address: "native" }
  },
  {
    symbol: "WBNB",
    decimals: 18,
    icon: Ee.BNB,
    tokenId: {
      chain: "Bsc",
      address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"
    }
  },
  {
    symbol: "USDC",
    decimals: 18,
    icon: Ee.USDC,
    tokenId: {
      chain: "Bsc",
      address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d"
    }
  },
  {
    symbol: "AVAX",
    decimals: 18,
    icon: Ee.AVAX,
    tokenId: { chain: "Avalanche", address: "native" }
  },
  {
    symbol: "WAVAX",
    decimals: 18,
    icon: Ee.AVAX,
    tokenId: {
      chain: "Avalanche",
      address: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7"
    }
  },
  {
    symbol: "USDC",
    decimals: 6,
    icon: Ee.USDC,
    tokenId: {
      chain: "Avalanche",
      address: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E"
    }
  },
  {
    symbol: "USDT",
    decimals: 6,
    icon: Ee.USDT,
    tokenId: {
      chain: "Avalanche",
      address: "0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7"
    }
  },
  {
    symbol: "WETH",
    decimals: 18,
    icon: Ee.ETH,
    tokenId: {
      chain: "Avalanche",
      address: "0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB"
    }
  },
  {
    symbol: "FTM",
    decimals: 18,
    icon: Ee.FANTOM,
    tokenId: { chain: "Fantom", address: "native" }
  },
  {
    symbol: "WFTM",
    name: "Wrapped Fantom",
    decimals: 18,
    icon: Ee.FANTOM,
    tokenId: {
      chain: "Fantom",
      address: "0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83"
    }
  },
  {
    symbol: "USDC.e",
    decimals: 6,
    icon: Ee.USDC,
    tokenId: {
      chain: "Fantom",
      address: "0x2F733095B80A04b38b0D10cC884524a3d09b836a"
    }
  },
  {
    symbol: "CELO",
    decimals: 18,
    icon: Ee.CELO,
    tokenId: {
      chain: "Celo",
      address: "0x471EcE3750Da237f93B8E339c536989b8978a438"
    }
  },
  {
    symbol: "USDT",
    decimals: 6,
    icon: Ee.USDT,
    tokenId: {
      chain: "Celo",
      address: "0x48065fbBE25f71C9282ddf5e1cD6D6A887483D5e"
    }
  },
  {
    symbol: "GLMR",
    decimals: 18,
    icon: Ee.GLMR,
    tokenId: { chain: "Moonbeam", address: "native" }
  },
  {
    symbol: "WGLMR",
    decimals: 18,
    icon: Ee.GLMR,
    tokenId: {
      chain: "Moonbeam",
      address: "0xAcc15dC74880C9944775448304B263D191c6077F"
    }
  },
  {
    symbol: "SOL",
    decimals: 9,
    icon: Ee.SOLANA,
    tokenId: { chain: "Solana", address: "native" }
  },
  {
    symbol: "WSOL",
    decimals: 9,
    tokenId: {
      chain: "Solana",
      address: "So11111111111111111111111111111111111111112"
    },
    icon: Ee.SOLANA
  },
  {
    symbol: "USDC",
    decimals: 6,
    tokenId: {
      chain: "Solana",
      address: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"
    },
    icon: Ee.USDC
  },
  {
    symbol: "USDT",
    decimals: 6,
    icon: Ee.USDT,
    tokenId: {
      chain: "Solana",
      address: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB"
    }
  },
  {
    symbol: "SUI",
    decimals: 9,
    tokenId: { chain: "Sui", address: "native" },
    icon: Ee.SUI
  },
  {
    symbol: "USDC",
    decimals: 6,
    tokenId: {
      chain: "Sui",
      address: "0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC"
    },
    icon: Ee.USDC
  },
  {
    symbol: "APT",
    decimals: 8,
    tokenId: { chain: "Aptos", address: "native" },
    icon: Ee.APT
  },
  {
    symbol: "USDC",
    decimals: 6,
    tokenId: {
      chain: "Aptos",
      address: "0xbae207659db88bea0cbead6da0ed00aac12edcdda169e591cd41c94180b46f3b"
    },
    icon: Ee.USDC
  },
  {
    symbol: "ETH",
    decimals: 18,
    icon: Ee.ETH,
    tokenId: { chain: "Arbitrum", address: "native" }
  },
  {
    symbol: "WETH",
    decimals: 18,
    icon: Ee.ETH,
    tokenId: {
      chain: "Arbitrum",
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1"
    }
  },
  {
    symbol: "USDC",
    decimals: 6,
    icon: Ee.USDC,
    tokenId: {
      chain: "Arbitrum",
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831"
    }
  },
  {
    symbol: "USDT",
    decimals: 6,
    icon: Ee.USDT,
    tokenId: {
      chain: "Arbitrum",
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9"
    }
  },
  {
    symbol: "ETH",
    decimals: 18,
    icon: Ee.ETH,
    tokenId: { chain: "Optimism", address: "native" }
  },
  {
    symbol: "WETH",
    decimals: 18,
    icon: Ee.ETH,
    tokenId: {
      chain: "Optimism",
      address: "0x4200000000000000000000000000000000000006"
    }
  },
  {
    symbol: "USDC",
    decimals: 6,
    icon: Ee.USDC,
    tokenId: {
      chain: "Optimism",
      address: "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85"
    }
  },
  {
    symbol: "USDT",
    decimals: 6,
    icon: Ee.USDT,
    tokenId: {
      chain: "Optimism",
      address: "0x94b008aA00579c1307B0EF2c499aD98a8ce58e58"
    }
  },
  {
    symbol: "WETH",
    decimals: 18,
    icon: Ee.ETH,
    tokenId: {
      chain: "Bsc",
      address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8"
    }
  },
  {
    symbol: "USDT",
    decimals: 18,
    icon: Ee.USDT,
    tokenId: {
      chain: "Bsc",
      address: "0x55d398326f99059fF775485246999027B3197955"
    }
  },
  {
    symbol: "ETH",
    decimals: 18,
    icon: Ee.ETH,
    tokenId: { chain: "Base", address: "native" }
  },
  {
    symbol: "WETH",
    decimals: 18,
    icon: Ee.ETH,
    tokenId: {
      chain: "Base",
      address: "0x4200000000000000000000000000000000000006"
    }
  },
  {
    symbol: "USDC",
    decimals: 6,
    icon: Ee.USDC,
    tokenId: {
      chain: "Base",
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913"
    }
  },
  {
    symbol: "USDT",
    decimals: 6,
    icon: Ee.USDT,
    tokenId: {
      chain: "Base",
      address: "0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2"
    }
  },
  {
    symbol: "wstETH",
    decimals: 18,
    tokenId: {
      chain: "Base",
      address: "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452"
    },
    icon: Ee.WSTETH
  },
  {
    symbol: "wstETH",
    decimals: 18,
    tokenId: {
      chain: "Ethereum",
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0"
    },
    icon: Ee.WSTETH
  },
  {
    symbol: "wstETH",
    decimals: 18,
    tokenId: {
      chain: "Arbitrum",
      address: "0x5979D7b546E38E414F7E9822514be443A4800529"
    },
    icon: Ee.WSTETH
  },
  {
    symbol: "wstETH",
    decimals: 18,
    tokenId: {
      chain: "Optimism",
      address: "0x1F32b1c2345538c0c6f582fCB022739c4A194Ebb"
    },
    icon: Ee.WSTETH
  },
  {
    symbol: "wstETH",
    decimals: 18,
    tokenId: {
      chain: "Polygon",
      address: "0x03b54A6e9a984069379fae1a4fC4dBAE93B3bCCD"
    },
    icon: Ee.WSTETH
  },
  {
    symbol: "KAIA",
    decimals: 18,
    icon: Ee.KLAY,
    tokenId: { chain: "Klaytn", address: "native" }
  },
  {
    symbol: "wKAIA",
    decimals: 18,
    name: "wKAIA",
    icon: Ee.KLAY,
    tokenId: {
      chain: "Klaytn",
      address: "0xe4f05A66Ec68B54A58B17c22107b02e0232cC817"
    }
  },
  {
    symbol: "PYTH",
    decimals: 6,
    tokenId: {
      chain: "Solana",
      address: "HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3"
    },
    icon: Ee.PYTH
  },
  {
    symbol: "ETH",
    decimals: 18,
    icon: Ee.SCROLL,
    tokenId: { chain: "Scroll", address: "native" }
  },
  {
    symbol: "WETH",
    decimals: 18,
    icon: Ee.SCROLL,
    tokenId: {
      chain: "Scroll",
      address: "0x5300000000000000000000000000000000000004"
    }
  },
  {
    symbol: "OKB",
    decimals: 18,
    icon: Ee.XLAYER,
    tokenId: { chain: "Xlayer", address: "native" }
  },
  {
    symbol: "WOKB",
    decimals: 18,
    icon: Ee.XLAYER,
    tokenId: {
      chain: "Xlayer",
      address: "0xe538905cf8410324e03A5A23C1c177a474D59b2b"
    }
  },
  {
    symbol: "MNT",
    decimals: 18,
    icon: Ee.MANTLE,
    tokenId: { chain: "Mantle", address: "native" }
  },
  {
    symbol: "WMNT",
    decimals: 18,
    icon: Ee.MANTLE,
    tokenId: {
      chain: "Mantle",
      address: "0x78c1b0C915c4FAA5FffA6CAbf0219DA63d7f4cb8"
    }
  },
  {
    symbol: "tBTC",
    decimals: 18,
    tokenId: {
      chain: "Ethereum",
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88"
    },
    icon: Ee.TBTC
  },
  {
    symbol: "tBTC",
    decimals: 18,
    tokenId: {
      chain: "Polygon",
      address: "0x236aa50979D5f3De3Bd1Eeb40E81137F22ab794b"
    },
    icon: Ee.TBTC
  },
  {
    symbol: "tBTC",
    decimals: 18,
    tokenId: {
      chain: "Optimism",
      address: "0x6c84a8f1c29108F47a79964b5Fe888D4f4D0dE40"
    },
    icon: Ee.TBTC
  },
  {
    symbol: "tBTC",
    decimals: 18,
    tokenId: {
      chain: "Arbitrum",
      address: "0x6c84a8f1c29108F47a79964b5Fe888D4f4D0dE40"
    },
    icon: Ee.TBTC
  },
  {
    symbol: "tBTC",
    decimals: 18,
    tokenId: {
      chain: "Base",
      address: "0x236aa50979D5f3De3Bd1Eeb40E81137F22ab794b"
    },
    icon: Ee.TBTC
  },
  {
    symbol: "tBTC",
    decimals: 8,
    tokenId: {
      chain: "Solana",
      address: "6DNSN2BJsaPFdFFc1zP37kkeNe4Usc1Sqkzr9C9vPWcU"
    },
    icon: Ee.TBTC
  },
  {
    symbol: "ETH",
    tokenId: {
      chain: "Worldchain",
      address: "native"
    },
    decimals: 18,
    icon: Ee.WORLDCHAIN
  },
  {
    symbol: "WETH",
    tokenId: {
      chain: "Worldchain",
      address: "0x4200000000000000000000000000000000000006"
    },
    decimals: 18,
    icon: Ee.WORLDCHAIN
  },
  {
    symbol: "USDC",
    tokenId: {
      chain: "Worldchain",
      address: "0x79A02482A880bCE3F13e09Da970dC34db4CD24d1"
    },
    decimals: 6,
    icon: Ee.USDC
  },
  {
    symbol: "ETH",
    tokenId: {
      chain: "Unichain",
      address: "native"
    },
    decimals: 18,
    icon: Ee.ETH
  },
  {
    symbol: "WETH",
    tokenId: {
      chain: "Unichain",
      address: "0x4200000000000000000000000000000000000006"
    },
    decimals: 18,
    icon: Ee.ETH
  },
  {
    symbol: "USDC",
    tokenId: {
      chain: "Unichain",
      address: "0x078D782b760474a361dDA0AF3839290b0EF57AD6"
    },
    decimals: 6,
    icon: Ee.USDC
  },
  {
    symbol: "BERA",
    tokenId: {
      chain: "Berachain",
      address: "native"
    },
    decimals: 18,
    icon: Ee.BERA
  },
  {
    symbol: "WBERA",
    tokenId: {
      chain: "Berachain",
      address: "0x6969696969696969696969696969696969696969"
    },
    decimals: 18,
    icon: Ee.BERA
  },
  {
    symbol: "ETH",
    tokenId: {
      chain: "Linea",
      address: "native"
    },
    decimals: 18,
    icon: Ee.ETH
  },
  {
    symbol: "USDC",
    tokenId: {
      chain: "Linea",
      address: "0x176211869cA2b568f2A7D4EE941E073a821EE1ff"
    },
    decimals: 6,
    icon: Ee.USDC
  },
  {
    symbol: "S",
    tokenId: {
      chain: "Sonic",
      address: "native"
    },
    decimals: 18,
    icon: Ee.SONIC
  },
  {
    symbol: "USDC",
    tokenId: {
      chain: "Sonic",
      address: "0x29219dd400f2Bf60E5a23d13Be72B486D4038894"
    },
    decimals: 6,
    icon: Ee.USDC
  },
  {
    symbol: "SEI",
    tokenId: {
      chain: "Seievm",
      address: "native"
    },
    decimals: 18,
    icon: Ee.SEI
  },
  {
    symbol: "PLUME",
    tokenId: {
      chain: "Plume",
      address: "native"
    },
    decimals: 18,
    icon: Ee.PLUME
  },
  {
    symbol: "BTC",
    tokenId: {
      chain: "Mezo",
      address: "native"
    },
    decimals: 18,
    icon: Ee.BTC
  }
], Dw = {
  Ethereum: {
    "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2": {
      Bsc: "0x4DB5a66E937A9F4473fA95b1cAF1d1E1D62E29EA",
      Polygon: "0x11CD37bb86F65419713f30673A480EA33c826872",
      Avalanche: "0x8b82A291F83ca07Af22120ABa21632088fC92931",
      Fantom: "0x2A126f043BDEBe5A0A9841c51915E562D9B07289",
      Celo: "0x66803FB87aBd4aaC3cbB3fAd7C3aa01f6F3FB207",
      Moonbeam: "0xab3f0245B83feB11d15AAffeFD7AD465a59817eD",
      Solana: "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs",
      Sui: "0xaf8cd5edc19c4512f4259f0bee101a40d41ebed738ade5874359610ef8eeced5::coin::COIN",
      Aptos: "0xcc8a89c8dce9693d354449f1f73e60e14e347417854f029db5bc8e7454008abb::coin::T",
      Base: "0x71b35ECb35104773537f849FBC353F81303A5860",
      Arbitrum: "0xD8369C2EDA18dD6518eABb1F85BD60606dEb39Ec",
      Optimism: "0xb47bC3ed6D70F04fe759b2529c9bc7377889678f",
      Mantle: "0x115Fcc627AcE0457fbeb7Af3b8BcAcE7Ff6211A4",
      Klaytn: "0x98A8345bB9D3DDa9D808Ca1c9142a28F6b0430E1",
      Worldchain: "0x6938c3EfFEf84E5C69e3d7cc41eBC6Cff99EF8A7"
    },
    "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48": {
      Bsc: "0xB04906e95AB5D797aDA81508115611fee694c2b3",
      Polygon: "0x4318CB63A2b8edf2De971E2F17F77097e499459D",
      Avalanche: "0xB24CA28D4e2742907115fECda335b40dbda07a4C",
      Fantom: "0x2Ec752329c3EB419136ca5e4432Aa2CDb1eA23e6",
      Celo: "0x37f750B7cC259A2f741AF45294f6a16572CF5cAd",
      Moonbeam: "0x931715FEE2d06333043d11F658C8CE934aC61D0c",
      Solana: "A9mUU4qviSctJVPJdBJWkb28deg915LYJKrzQ19ji3FM",
      Sui: "0x5d4b302506645c37ff133b98c4b50a5ae14841659738d6d733d59d0d217a93bf::coin::COIN",
      Aptos: "0x5e156f1207d0ebfa19a9eeff00d62a282278fb8719f4fab3a586a0a2c0fffbea::coin::T",
      Base: "0xec267C53f53807c2337C257f8AC3Fc3cC07cc0ed",
      Arbitrum: "0xC96F2715E2a242d50D1b0bC923dbe1740b8eCf18",
      Optimism: "0x711e53D031ea9B0bb0C24dD506df11b41AEA419e",
      Klaytn: "0x608792Deb376CCE1c9FA4D0E6B7b44f507CfFa6A",
      Worldchain: "0x2cbD3491d687A76bb9C53c30B212855520D47b52"
    },
    "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599": {
      Bsc: "0x43359676E1A3F9FbB5de095333f8e9c1B46dFA44",
      Polygon: "0x5D49c278340655B56609FdF8976eb0612aF3a0C3",
      Avalanche: "0x1C0e79C5292c59bbC13C9F9f209D204cf4d65aD6",
      Fantom: "0x87e9E225aD8a0755B9958fd95BE43DD6A91FF3A7",
      Celo: "0xd71Ffd0940c920786eC4DbB5A12306669b5b81EF",
      Moonbeam: "0xE57eBd2d67B462E9926e04a8e33f01cD0D64346D",
      Solana: "3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh",
      Sui: "0x027792d9fed7f9844eb4839566001bb6f6cb4804f66aa2da6fe1ee242d896881::coin::COIN",
      Aptos: "0xae478ff7d83ed072dbc5e264250e67ef58f57c99d89b447efd8a0a2e8b2be76e::coin::T",
      Base: "0xE6396f780b543dF16ee3b784D789c75B68319db0",
      Arbitrum: "0x397846a8078d4845c7f5c6Ca76aeBbcFDc044fAe",
      Optimism: "0xB214C19d81c99E75e84706a3aa0A757319023e26",
      Klaytn: "0x981846bE8d2d697f4dfeF6689a161A25FfbAb8F9",
      Worldchain: "0x06c9ec7E18A7900E79Ad5BeCc6Cc29E3eebD81EC"
    },
    "0xdAC17F958D2ee523a2206206994597C13D831ec7": {
      Bsc: "0x524bC91Dc82d6b90EF29F76A3ECAaBAffFD490Bc",
      Polygon: "0x9417669fBF23357D2774e9D421307bd5eA1006d2",
      Avalanche: "0x9d228444FC4B7E15A2C481b48E10247A03351FD8",
      Fantom: "0x14BCb86aEed6a74D3452550a25D37f1c30AA0A66",
      Celo: "0x617f3112bf5397D0467D315cC709EF968D9ba546",
      Moonbeam: "0xc30E9cA94CF52f3Bf5692aaCF81353a27052c46f",
      Solana: "Dn4noZ5jgGfkntzcQSUZ8czkreiZ1ForXYoV2H8Dm7S1",
      Sui: "0xc060006111016b8a020ad5b33834984a437aaa7d3c74c18e09a95d48aceab08c::coin::COIN",
      Aptos: "0xa2eda21a58856fda86451436513b867c97eecb4ba099da5775520e0f7492e852::coin::T",
      Base: "0xFf0C62A4979400841eFaA6faADb07Ac7d5C98b27",
      Arbitrum: "0xE4728F3E48E94C6DA2B53610E677cc241DAFB134",
      Optimism: "0xf6B4185FCf8aF291c0E3927fbEab7046b4f6A8CA",
      Klaytn: "0x5C13E303a62Fc5DEdf5B52D66873f2E59fEdADC2",
      Xlayer: "0x5866709f926f26C5870191F40333ac462B917bC0",
      Worldchain: "0x95dd0680Fd6B6c7546e75C1A4E6A3256072C0593"
    },
    "0x6B175474E89094C44Da98b954EedeAC495271d0F": {
      Bsc: "0x3413a030EF81a3dD5a302F4B4D11d911e12ed337",
      Polygon: "0x732EB1747ecCFC431fF19bc359ffc83755B1918c",
      Avalanche: "0xca319f81D147559e19A522A0a0310Dd43A96cA0F",
      Fantom: "0xEE786D3D73Ea645365c7248E4e40eDba08B1169F",
      Celo: "0x97926a82930bb7B33178E3c2f4ED1BFDc91A9FBF",
      Moonbeam: "0x06e605775296e851FF43b4dAa541Bb0984E9D6fD",
      Solana: "EjmyN6qEC1Tf1JxiG1ae7UTJhUxSwk1TCWNWqxWV4J6o",
      Aptos: "0x407a220699982ebb514568d007938d2447d33667e4418372ffec1ddb24491b6c::coin::T",
      Base: "0x617Edadb51BfB43A44Bb91C7402129C23bA52381",
      Arbitrum: "0x5c4f2FEFB97F7DF09E762d95C83f0Ccf8bCe8234",
      Optimism: "0x098EA47D630b46df1E08e389e5e4466119c7dd30",
      Sui: "0xc01c54cd767a60835bf100b0a8f7aae66ac9f4e374f76746af60f02493b6f2cf::coin::COIN",
      Klaytn: "0xCB2C7998696Ef7a582dFD0aAFadCd008D03E791A",
      Worldchain: "0x69635e59E89000e08a13C3F7B9f7293160Dc83a2"
    },
    "0x4Fabb145d64652a948d72533023f6E7A623C7C53": {
      Bsc: "0x035de3679E692C471072d1A09bEb9298fBB2BD31",
      Polygon: "0x95ea750420da26bE1Ab0891e209e921bCd84763f",
      Celo: "0x1dd42c0785ca90B677adc2ABad01dfc5ECcD0b4d",
      Moonbeam: "0xa2284e1F98E4d0B7Eb6a6b4f3C57f1b209C755F3",
      Solana: "33fsBLA8djQm82RpHmE3SuVrPGtZBWNYExsEUeKX1HXX",
      Aptos: "0x77400d2f56a01bad2d7c8c6fa282f62647ce3c03f43f2a8742e47ea01a91e24a::coin::T",
      Worldchain: "0x276719Fc6a38E62B717c6FF6E39d1C336ee633AB"
    },
    "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0": {
      Polygon: "0xe082a7Fc696De18172Ad08D956569Ee80BC37f06",
      Solana: "ZScHuTtqZukUrtZS43teTKGs2VqkKL8k4QCouR2n6Uo",
      Arbitrum: "0xf2717122Dfdbe988ae811E7eFB157aAa07Ff9D0F",
      Optimism: "0x855CFcEEe998c8ca34F9c914F584AbF72dC88B87",
      Base: "0xEd4e2FD35161c3c0e33cA187fce64C70d44Ce32b",
      Bsc: "0xad80E1A9B5824234afA9dE1F3bbDb8a994796169",
      Avalanche: "0x11449fd2F05D93827972b40adE96F6ffBE42E35a",
      Fantom: "0x2a2Ec6Ad3e47C536F47934F63b95BD647F1C730E",
      Worldchain: "0xd977e0251db8d38155dC5d212944AB7B7a6777Ad"
    }
  },
  Polygon: {
    "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270": {
      Ethereum: "0x7c9f4C87d911613Fe9ca58b579f737911AAD2D43",
      Bsc: "0xc836d8dC361E44DbE64c4862D55BA041F88Ddd39",
      Avalanche: "0xf2f13f0B7008ab2FA4A2418F4ccC3684E49D20Eb",
      Fantom: "0xb88A6064B1F3FF5B9AE4A82fFD52560b0dF9FBD3",
      Celo: "0x9C234706292b1144133ED509ccc5B3CD193BF712",
      Moonbeam: "0x82DbDa803bb52434B1f4F41A6F0Acb1242A7dFa3",
      Solana: "Gz7VkD4MacbEB6yC5XD3HcumEiYx2EtDYYrfikGsvopG",
      Sui: "0xdbe380b13a6d0f5cdedd58de8f04625263f113b3f9db32b3e1983f49e2841676::coin::COIN",
      Aptos: "0x6781088e2a1629d38eda521467af4a8ca7bfa7e5516338017940389595c85c0f::coin::T",
      Base: "0xc863399E5c5C4011B1DC3fB602902C77BA72B709",
      Arbitrum: "0x3ab0E28C3F56616aD7061b4db38aE337E3809AEA",
      Optimism: "0x8f02B6a32cebcAe44D2Fd17d87966f5B5dD14c6d",
      Mantle: "0x1d15Dc3B3DB5A182eA8E3091F21EB0549d4a72E0",
      Klaytn: "0x9858e5A4f8202baD619D4BD39382CA67F4CA0E63",
      Scroll: "0x982D057feCD66c3af27b16EBC67C4db24810bcD8",
      Xlayer: "0xc97E2b2d7730C34adC389563721d9dF52EDA4A2a",
      Worldchain: "0xDcB507ECEA06724d8c4F2f03964f7EE4da504E8C"
    },
    "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619": {
      Bsc: "0x1384284E16e3375522Be54F50909Bc52A69e90e4",
      Solana: "DQyeU3oFezEGia761GQ4iPcMCnxnH8fuLrmHZUvTYuby",
      Aptos: "0x2692323828f627a45a75a05eba8281dd46690c538b4f6ccb7a35ffe8199a28b7::coin::T",
      Sui: "0xa1ed6e76b06ff8f959cc479fbbd423820a3349dad8707b98ff4309c677fa20ad::coin::COIN",
      Arbitrum: "0xd2b299eD76d1369Ac8762CFEc85245fFD302FC17",
      Ethereum: "0x32d222E1f6386B3dF7065d639870bE0ef76D3599",
      Avalanche: "0x061FE51530768889dc20Ac7fCD29b5307b823395",
      Optimism: "0x2740220fFa4b206280907ce12b7cDC57445f3B92",
      Fantom: "0x1cAFd8d3301E4E54Fc1462E7117Eb678bF50C765",
      Base: "0x7A79923734eDA9c7f7ff69ad9ec1e234F67E7CD6",
      Moonbeam: "0xf1BB9A987B9edC360580b0c9F28069C808c2a7da",
      Celo: "0x8Ed68859f162970258992168293232e3Bdd987d0",
      Klaytn: "0x3eb25C7098AC38a852Cd2366161c5e216af50Df3"
    },
    "0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359": {
      Aptos: "0xc5fd7820e9f053e6dd8e7dd8ca3ce8e9b10d200ba1692bdeb7a035217180ad4a::coin::T",
      Base: "0xFe1579BAc60363c8572CB30Bf4DD1Fd85811BBF8",
      Moonbeam: "0x4415BfBDee669446550d55c749007EF60B520FC8",
      Sui: "0x5c8c9082401982e8c2519a5c12883a5475295bf5cec4a0a13c26d35dd9a20d73::coin::COIN",
      Bsc: "0xe6d82Bbe75041E42E51d755e922cE1BA91af9c4d",
      Celo: "0x42c76808f3179A091Ee007A2955aF2522978ADE7",
      Fantom: "0xB4DcfD221048a1Dad989D39456BBd87762c26F06",
      Avalanche: "0xDb2d08f5A9C9ADBBA0DE5a69bbB1E9Ca03411692",
      Arbitrum: "0x599ADB10E6A012dF34935D47407450f6D7170e3C",
      Optimism: "0xbB1EaB9Eb8fDf65F0E291D013DA07B4b65a27a01",
      Solana: "C321jHPwWBzgfSGndosDTp5pBsiXPyMU1irxKLVcedRB",
      Ethereum: "0xFbcE0f9e92AD1003e893Ba647bC055D845aAa507",
      Klaytn: "0x59AEaD999e018a00B162D34de7a81AFFAB88bAbB"
    },
    "0x03b54A6e9a984069379fae1a4fC4dBAE93B3bCCD": {
      Base: "0xcB6D47199d60747152d7671D6497ce8D23cc1D75",
      Arbitrum: "0x23D3901A635fDd98D8d6509bc0720281f80a8E6D",
      Ethereum: "0x302F636d723c8Ed75C0d1E9D9C714009184C5624",
      Optimism: "0x4fad81d2268a7D9E1e0fE7dB38af07FFFA0aA56E",
      Celo: "0xA4c7302659eCF88a90e62e915Bd486E66B616A4C"
    }
  },
  Bsc: {
    "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c": {
      Ethereum: "0x418D75f65a02b3D53B2418FB8E1fe493759c7605",
      Polygon: "0xeCDCB5B88F8e3C15f95c720C51c71c9E2080525d",
      Avalanche: "0x442F7f22b1EE2c842bEAFf52880d4573E9201158",
      Fantom: "0xc033551e05907Ddd643AE14b6D4a9CA72BfF509B",
      Celo: "0xBf2554ce8A4D1351AFeB1aC3E5545AaF7591042d",
      Moonbeam: "0xE3b841C3f96e647E6dc01b468d6D0AD3562a9eeb",
      Solana: "9gP2kCy3wA1ctvYWQk75guqXuHfrEomqydHLtcTCqiLa",
      Sui: "0xb848cce11ef3a8f62eccea6eb5b35a12c4c2b1ee1af7755d02d7bd6218e8226f::coin::COIN",
      Aptos: "0x6312bc0a484bc4e37013befc9949df2d7c8a78e01c6fe14a34018449d136ba86::coin::T",
      Base: "0x7fdAa50d7399ac436943028edA6ed9a1BD89509f",
      Arbitrum: "0x7AF00405916D823eDb1121546EfA6F4972B51b84",
      Optimism: "0x6A09fE65ACa27C12573F04aAFa290bD75497E1BC",
      Mantle: "0x9a7E85260d6F5d3c3d2a1FdDc3D980DBC78e508d",
      Klaytn: "0xaC9C1E4787139aF4c751B1C0fadfb513C44Ed833",
      Scroll: "0x5b0da0a36DC415714B53A4f24b56921332F42E7C",
      Xlayer: "0x8bC46166E06122603bA10D2bCA63b75091c25cAe",
      Worldchain: "0x59163d9c70E9b3852a504c5F1458e2daD33516Ff"
    },
    "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d": {
      Ethereum: "0x7cd167B101D2808Cfd2C45d17b2E7EA9F46b74B6",
      Polygon: "0x4B3a922c773BDCF3BA8f1A4FDAc2029E1D0E9868",
      Avalanche: "0x6145E8a910aE937913426BF32De2b26039728ACF",
      Fantom: "0x0FcbDAC44c67A43607D3E95886dB19871ADc985F",
      Celo: "0x9d9abAE97a9344e3854527b4efbB366a1564bfEb",
      Moonbeam: "0x7f433E22366E03a3758CE22cCf82887d828078f8",
      Solana: "FCqfQSujuPxy6V42UvafBhsysWtEq1vhjfMN1PUbgaxA",
      Sui: "0x909cba62ce96d54de25bec9502de5ca7b4f28901747bbf96b76c2e63ec5f1cba::coin::COIN",
      Aptos: "0x79a6ed7a0607fdad2d18d67d1a0e552d4b09ebce5951f1e5c851732c02437595::coin::T",
      Base: "0x68E2b07F92ed506f92935d7359ECA84D5342dbb4",
      Arbitrum: "0x1a0590F951bc9C3818Ce75ba5Bbe92831b2cf57e",
      Optimism: "0x1C15057d1F3794C934a6cBC1f7EceE934050F219",
      Klaytn: "0x01B342d26FEF5749E87CBe412e16163771b0277c"
    },
    "0x2170Ed0880ac9A755fd29B2688956BD959F933F8": {
      Aptos: "0xd9fc4259ec5def95477dba9f0861c2882d1f8bee9a4138b476dd0720a3444547::coin::T",
      Solana: "FzjTz2cD1DfqYvafrbHWZvf1dK9qjwXGLuaU7xYXQjxP",
      Sui: "0x5029d5a94429a73b8036cd67192d9c5e09bbc2c0fee942d50075a9edba66744f::coin::COIN",
      Base: "0xf50509Bb6aF76E20c6E1eD493699c5f70764BcCC",
      Arbitrum: "0x6478377A399bE8c92bD35254aA7bF287836de32e",
      Ethereum: "0x5DbBB101CDc29443d12055eCDDdD7ca037Dce721",
      Fantom: "0xc511E3aec79CABD605021C237c475Ec553B002d4",
      Celo: "0x09F236D3708894581b1Cf679e582ba9eA5BE16f0",
      Klaytn: "0x4C07075BB44076106f3389766946b79784Fb5C58",
      Avalanche: "0xf0e509144CfA602d0A5e8C75d76FF74077f52f2b",
      Optimism: "0x8088Bc767c392b5769b94c9ec1D07c62874c8d5f",
      Polygon: "0x2D291e940DbDdaa9E847Ba5cC49451575f086b27",
      Moonbeam: "0xBefd7902B682938b29B3FD3D4AdECD9A984D5930"
    }
  },
  Avalanche: {
    "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7": {
      Ethereum: "0x85f138bfEE4ef8e540890CFb48F620571d67Eda3",
      Bsc: "0x96412902aa9aFf61E13f085e70D3152C6ef2a817",
      Polygon: "0x7Bb11E7f8b10E9e571E5d8Eace04735fDFB2358a",
      Fantom: "0x358CE030DC6116Cc296E8B9F002728e65459C146",
      Celo: "0xFFdb274b4909fC2efE26C8e4Ddc9fe91963cAA4d",
      Moonbeam: "0xd4937A95BeC789CC1AE1640714C61c160279B22F",
      Solana: "KgV1GvrHQmRBY8sHQQeUKwTm2r2h8t4C8qt12Cw1HVE",
      Sui: "0x1e8b532cca6569cab9f9b9ebc73f8c13885012ade714729aa3b450e0339ac766::coin::COIN",
      Aptos: "0x5b1bbc25524d41b17a95dac402cf2f584f56400bf5cc06b53c36b331b1ec6e8f::coin::T",
      Base: "0xc449A60A31E1eebFE83c42E9465fd4Dc318aE9a7",
      Arbitrum: "0x565609fAF65B92F7be02468acF86f8979423e514",
      Optimism: "0x8418C1d909842f458c9394886b83F19d62bF1A0D",
      Mantle: "0x2cAb4233d42043AEBbbb1445af362Ef686f3C133",
      Klaytn: "0x45830b92443a8f750247da2A76C85c70d0f1EBF3",
      Scroll: "0xC043c8A3672f397e7b52bF0a04F47d6f1aA952Ed",
      Xlayer: "0x5208Fb676B2DBab7aFaFB56e8997237F0ceECF71",
      Worldchain: "0x5Bf2A0622aa1254D963A3074b593A379784C116a"
    },
    "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E": {
      Ethereum: "0x39EbF69137D98FB7659Ef8D4ea21ec26394389d7",
      Bsc: "0xc88Dc63bf0c8c8198C97Db0945E3eF25Ca89A8e4",
      Polygon: "0xAEA5CC14DefbC1b845FDE729E563B717Ee6825ae",
      Fantom: "0xEfE7701cb2B80664385Be226d0300912CA92f66A",
      Celo: "0x62FFf2D2D1692D52eAf043AeeC727F7918d269D3",
      Moonbeam: "0xd4918c40cA9f02d42Cb53d06587aF42017Bc345D",
      Solana: "FHfba3ov5P3RjaiLVgh8FTv4oirxQDoVXuoUUDvHuXax",
      Sui: "0xe596782fbaebef51ae99ffac8731aed98a80642b9dc193ed659c97fbc2cc0f84::coin::COIN",
      Aptos: "0x39d84c2af3b0c9895b45d4da098049e382c451ba63bec0ce0396ff7af4bb5dff::coin::T",
      Arbitrum: "0x93e0FcbEd43CD6fC30DF00CcBD4669718dc74e77",
      Optimism: "0x355f0a8a7ecAeD971b8Fbd50994558291ff2413a",
      Base: "0xD83385fE100E20c269a5975D4Bf92525BcE09F87",
      Klaytn: "0x9C97D4c09679Dfd00A39681f6d3b61A285312B13",
      Scroll: "0xbEFc3d0457fB88f82364Dd982F7BA195FEE96b74"
    },
    "0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB": {
      Aptos: "0x25ff8e0c07552c392c9e5dd4c9c07cf0382765c1bca560e80b6296a702034219::coin::T",
      Solana: "F9B9qLwUN3TAWGV9EGsuzFzS2PxWvKAmLhvfeqYNaS7J",
      Bsc: "0xBDfe278268524de38Da89B3023C1F49deBDFdA8A",
      Sui: "0xc1ea686a329e35808c61484d95904d50522f1d1616cab4b416d9cfa9b274bc6c::coin::COIN",
      Base: "0xEfe64b52bc0bDfa109790736F25cefb79724adF0",
      Arbitrum: "0xdF64fB41b7f45304a786695E0D5daD8d033C01eF",
      Polygon: "0x2912b3a9586Fc2AB177dC869e878c688DAA7d06E",
      Ethereum: "0xD85a87Edbe9fB3Baf6a1Bbd1E46f1C04B291331d",
      Optimism: "0xBe6EA3e70e2bbB0dbD093B657fbbc0DFF0BA67eC",
      Moonbeam: "0x9C673c6b651D6FDEF57441125A6AC16b08bba939",
      Celo: "0xDac2C97b5E64d7C79d040cd2906EBe02341F1Ab5",
      Klaytn: "0x9971F9d9170D787C4e4E01c56E1BDB308291CacF",
      Fantom: "0x86a09597fc91b116511B990D29CB46ddedC0fCb0"
    }
  },
  Fantom: {
    "0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83": {
      Ethereum: "0x4cD2690d86284e044cb63E60F1EB218a825a7e92",
      Bsc: "0xbF8413EE8612E0E4f66Aa63B5ebE27f3C5883d47",
      Polygon: "0x3726831304D77f585f1Aca9d9841cc3Ef80dAa62",
      Avalanche: "0xd19abc09B7b36F7558929b97a866f499a26c2f83",
      Celo: "0xd1A342eE2210238233a347FEd61EE7Faf9f251ce",
      Moonbeam: "0x609AedD990bf45926bca9E4eE988b4Fb98587D3A",
      Solana: "DRQBDBEWmwWGK13fRTLhSPzjbvMSUavhV6nW4RUH8W6T",
      Sui: "0x6081300950a4f1e2081580e919c210436a1bed49080502834950d31ee55a2396::coin::COIN",
      Aptos: "0xd1aa2ff36a0e93e1b4e4fecdecf8bb95bc5de399061c5e84b515281f48718842::coin::T",
      Base: "0x936Fa2DE8380Dc5BF34C80F1BaD53a9f3630263B",
      Arbitrum: "0x7f7dcDb91930033a4Eb269196EBb6fd5f0644E4B",
      Optimism: "0x0b0ecbe5C3995541876d27633B63296570FB34Af",
      Mantle: "0x6BFDc59ECBC5503aE16F71851064597D0a75dA76",
      Klaytn: "0xF3AebeA789F30C22F3657F70f4CaA0f8b49ed676",
      Scroll: "0x16f077e2e9bF99Adfb1FEEc8360ee002842C44A2",
      Xlayer: "0x956b5E88c311b976C76CB415C7E030A5Af87373b"
    },
    "0x2F733095B80A04b38b0D10cC884524a3d09b836a": {
      Bsc: "0x521af8b1c43B503BE91F542d82EEFEabc0C93340",
      Arbitrum: "0xF68734163731ad6A6108f76A8e09862C1d412B42",
      Ethereum: "0xfcC349c14013EdeFAAcAE09Ba30F4ef2571b8D2c"
    }
  },
  Celo: {
    "0x471EcE3750Da237f93B8E339c536989b8978a438": {
      Ethereum: "0x3294395e62F4eB6aF3f1Fcf89f5602D90Fb3Ef69",
      Bsc: "0x2A335e327a55b177f5B40132fEC5D7298aa0D7e6",
      Polygon: "0x922F49a9911effc034eE756196E59BE7b90D43b3",
      Avalanche: "0x494317B8521c5a5287a06DEE467dd6fe285dA4a8",
      Fantom: "0xF432490C6c96C9d3bF523a499a1CEaFd8208A373",
      Moonbeam: "0xc1a792041985F65c17Eb65E66E254DC879CF380b",
      Solana: "9kvAcwQbqejuJMd59mKuw2bfSsLRaQ7zuvaTVHEeBBec",
      Sui: "0xa198f3be41cda8c07b3bf3fee02263526e535d682499806979a111e88a5a8d0f::coin::COIN",
      Aptos: "0xac0c3c35d50f6ef00e3b4db6998732fe9ed6331384925fe8ec95fcd7745a9112::coin::T",
      Base: "0x74df3823aA29D278cAD0A3632fCB56C896a38eD4",
      Arbitrum: "0x4E51aC49bC5e2d87e0EF713E9e5AB2D71EF4F336",
      Optimism: "0x9b88D293b7a791E40d36A39765FFd5A1B9b5c349",
      Klaytn: "0xB2b5bC9bc872c7107CBC8E8e0E2805Db0ac4FBc2",
      Worldchain: "0x2250A0E2532A745b585B69dd2CdC75207384917c"
    }
  },
  Moonbeam: {
    "0xAcc15dC74880C9944775448304B263D191c6077F": {
      Ethereum: "0x93d3696A9F879b331f40CB5059e37015423A3Bd0",
      Bsc: "0x1C063db3c621BF901FC6C1D03328b08b2F9bbfba",
      Polygon: "0xcC48d6CF842083fEc0E01d913fB964b585975F05",
      Avalanche: "0x375aA6C67BF499fBf01804A9f92C03c0776F372d",
      Fantom: "0xBF227E92D6754EB4BFE26C40cb299ff2809Da45f",
      Celo: "0x383A5513AbE4Fe36e0E00d484F710148E348Aa9D",
      Solana: "7ixSaXGsHAFy34wogPk2YXiUX3BMmQMFdercdaHLnBby",
      Sui: "0x66f87084e49c38f76502d17f87d17f943f183bb94117561eb573e075fdc5ff75::coin::COIN",
      Aptos: "0x7ab1283a7b13c4254d4e1f803d7ce6578442c1d7a40d0faee41cd48ba4884c8a::coin::T",
      Base: "0xfdB7311BeC3b2CcCF8407d0585f81B97b3b5eff1",
      Arbitrum: "0x944C5b67a03e6Cb93Ae1E4B70081f13b04CDB6Bd",
      Optimism: "0xbffD46DFDb8d3a02b8D2E0F864a2cD712090a4D3",
      Klaytn: "0x52a4558f98dDc7cb40cd9114C005f0B9571258Fc",
      Scroll: "0x2Aba1Ed24EaFC17F801b1A7dF1c3a06737F8aB72",
      Xlayer: "0xE2a44Dad57004517738FbD84cdf09Bd1451b4e43",
      Worldchain: "0xaAe2Bd4EB640f02dD3a53bd994ad19110b4191b0"
    }
  },
  Solana: {
    So11111111111111111111111111111111111111112: {
      Ethereum: "0xD31a59c85aE9D8edEFeC411D448f90841571b89c",
      Bsc: "0xfA54fF1a158B5189Ebba6ae130CEd6bbd3aEA76e",
      Polygon: "0xd93f7E271cB87c23AaA73edC008A79646d1F9912",
      Avalanche: "0xFE6B19286885a4F7F55AdAD09C3Cd1f906D2478F",
      Fantom: "0xd99021C2A33e4Cf243010539c9e9b7c52E0236c1",
      Celo: "0x4581E64115d46CcdeE65Be2336bEc86c9BA54C01",
      Moonbeam: "0x99Fec54a5Ad36D50A4Bba3a41CAB983a5BB86A7d",
      Sui: "0xb7844e289a8410e50fb3ca48d69eb9cf29e27d223ef90353fe1bd8e27ff8f3f8::coin::COIN",
      Aptos: "0xdd89c0e695df0692205912fb69fc290418bed0dbe6e4573d744a6d5e6bab6c13::coin::T",
      Base: "0x1C61629598e4a901136a81BC138E5828dc150d67",
      Arbitrum: "0x2bcC6D6CdBbDC0a4071e48bb3B969b06B3330c07",
      Optimism: "0xba1Cf949c382A32a09A17B2AdF3587fc7fA664f1",
      Mantle: "0xDA03239f428c76A527e1ceCa0ecA6cC367A2D945",
      Klaytn: "0xfAA03A2AC2d1B8481Ec3fF44A0152eA818340e6d",
      Xlayer: "0x3a859D92da2E16Ad32C5C6F3ADAddFBa4dE3A47e",
      Scroll: "0xCDf95E1F720caade4b1DC83ABfE15400D2a458AD",
      Worldchain: "0xEfae32D1c15EDBaEA3ebdDe1e2C51003AED04d30"
    },
    EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v: {
      Ethereum: "0x41f7B8b9b897276b7AAE926a9016935280b44E97",
      Bsc: "0x91Ca579B0D47E5cfD5D0862c21D5659d39C8eCf0",
      Polygon: "0x576Cf361711cd940CD9C397BB98C4C896cBd38De",
      Avalanche: "0x0950Fc1AD509358dAeaD5eB8020a3c7d8b43b9DA",
      Fantom: "0xb8398DA4FB3BC4306B9D9d9d13d9573e7d0E299f",
      Celo: "0x8B6eef6C449D3Ac723a9C06a9eaE2dCd7d308BA9",
      Moonbeam: "0x098d6eE48341D6a0a0A72dE5baaF80A10E0F6082",
      Sui: "0xb231fcda8bbddb31f2ef02e6161444aec64a514e2c89279584ac9806ce9cf037::coin::COIN",
      Aptos: "0xc91d826e29a3183eb3b6f6aa3a722089fdffb8e9642b94c5fcd4c48d035c0080::coin::T",
      Arbitrum: "0x3870546cfd600ba87e4180686d29dC993A45d3B7",
      Optimism: "0x6F974A6dfD5B166731704Be226795901c45Bb815",
      Base: "0xe8CE40EBBB844142400D21558a2F1c9683d69139",
      Klaytn: "0xa1a7feeD29EbFa38079D943486c23f401939Ce80",
      Scroll: "0x883Ccb5aEfD0084f1e4D04b133675acd6D5F123F"
    },
    HZ1JovNiVvGrGNiiYvEozEVgZ58xaU3RKwX8eACQBCt3: {
      Aptos: "0x770211b47954e15bec1a4271bf33bacebc2d2adb43b7dc1ca45efa787615dd4c::coin::T",
      Bsc: "0xb0188B0bb2cD4a6D2744637fC83C94a284B247Da",
      Base: "0x4c5d8A75F3762c1561D96f177694f67378705E98",
      Celo: "0x985aa4814419ba338379A634785216301e51113D",
      Avalanche: "0x8A0691e602B7a5FCc51a27E4a08376dE50889B42",
      Polygon: "0xFa4B761A1e07909Ba31331a5dfa12390E3ff5583",
      Fantom: "0x77ad3B2dA29FBd208F12c3C701E969F4422aAD79",
      Optimism: "0x99C59ACeBFEF3BBFB7129DC90D1a11DB0E91187f",
      Ethereum: "0xeFc0CED4B3D536103e76a1c4c74F0385C8F4Bdd3",
      Arbitrum: "0xE4D5c6aE46ADFAF04313081e8C0052A30b6Dd724",
      Sui: "0x9c6d76eb273e6b5ba2ec8d708b7fa336a5531f6be59f326b5be8d4d8b12348a4::coin::COIN",
      Moonbeam: "0x27cc3FDbDD1F415b09a41232D0fD71345DAB8030",
      Xlayer: "0x057b766b3fB76527cf815c3b5C38Dfa8144335CF",
      Worldchain: "0x838f3045F3B2dcDFF8cB4e5CaB0c0092A69B790a"
    }
  },
  Sui: {
    native: {
      Ethereum: "0x84074EA631dEc7a4edcD5303d164D5dEa4c653D6",
      Bsc: "0x8314f6Bf1B4dd8604A0fC33C84F9AF2fc07AABC8",
      Polygon: "0x34bE049fEbfc6C64Ffd82Da08a8931A9a45f2cc8",
      Avalanche: "0x1703CB0F762D2a435199B64Ea47E5349B7C17480",
      Fantom: "0xC277423a21F6e32D886BF85Ef6cCB945d5D28347",
      Celo: "0x1Cb9859B1A16A67ef83A0c7b9A21eeC17d9a97Dc",
      Moonbeam: "0x484eCCE6775143D3335Ed2C7bCB22151C53B9F49",
      Solana: "G1vJEgzepqhnVu35BN4jrkv3wVwkujYWFFCxhbEZ1CZr",
      Aptos: "0xa72a97e872be9ee3d2f14d56fd511eb7e4a53f4055be3a267d8602e7685b41c0::coin::T",
      Base: "0x36c6FBF7B49bF65f5F82b674af219C05b2a4aDD1",
      Arbitrum: "0xCF79d86B8a830030aF6D835737d6eac3bE823fD7",
      Optimism: "0x27A533e438892DA192725b4C9AcA51447F457212",
      Mantle: "0x9ef1BB6072d7d6B9C935d9c040133036aD532119",
      Klaytn: "0xB0B40516293e0204fB376A18aA230A210cbE0305",
      Xlayer: "0xEa76dBFE6e449420f294e74E057518F750E99A16",
      Worldchain: "0xf69005c35B5d9AcC22E4DbCf52f892cAE21F83B0"
    }
  },
  Aptos: {
    native: {
      Ethereum: "0x8CDf7AF57E4c8B930e1B23c477c22f076530585e",
      Bsc: "0x2Ba98cf7Edd2c5C794e21bc3Dc6973D3C2585eE3",
      Polygon: "0xa4ef199d3ad524E9C3C51Ac46B303B103A307Cef",
      Avalanche: "0x43c588459b3243fA541B98CC4B2E995b3de553A2",
      Fantom: "0x3Cd9162Ca5256b8E26A0e3Ad14CCfF7C0Da0F174",
      Celo: "0x89F2b718Ca518db39d377F0ABBa6B42582b549F7",
      Moonbeam: "0x25331575641d35D9765e1934acC8F0991c58e904",
      Solana: "6LNeTYMqtNm1pBFN8PfhQaoLyegAH8GD32WmHU9erXKN",
      Sui: "0x3a5143bb1196e3bcdfab6203d1683ae29edd26294fc8bfeafe4aaa9d2704df37::coin::COIN",
      Base: "0x1d36126289Be1658297A35CC3EB2BB80A7D7A04b",
      Arbitrum: "0x4EdeF400eDe5309240814b5FC403F224504604e9",
      Optimism: "0xC5B3AC2DF8D8D7AC851F763a5b3Ff23B4A696d59",
      Klaytn: "0x68d5254007BE3a6d3d2A37e2C1ad3921D049F46D",
      Xlayer: "0xEdF2AEaCE382A3c0722f110c4927d34b78bce34F",
      Worldchain: "0xfC5011f2037f2Dad9c9aC05CbB6749B383C3099c"
    }
  },
  Arbitrum: {
    "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1": {
      Ethereum: "0xb945E3F853B5f8033C8513Cf3cE9F8AD9beBB1c9",
      Bsc: "0xaA1eEdABC48D078350ccBdD620bD088848e299E5",
      Polygon: "0x6a5c59AB16268d2c872916054C50440B999e417C",
      Avalanche: "0xDfDA518A1612030536bD77Fd67eAcbe90dDC52Ab",
      Fantom: "0xE8367853A0823515D37b1538331B4704089becb4",
      Celo: "0xc6F962fCcb140ece554AfD0E589f971532A57f14",
      Solana: "CSD6JQMvLi46psjHdpfFdr826mF336pEVMJgjwcoS1m4",
      Sui: "0x33744e7df340a4d01c23f6b18c13563f767545ea95f976f8045f056358419da3::coin::COIN",
      Aptos: "0xe977796d7bfb3263609b90dffd264c7bd078ce35dac42b55302858d9fa3452b::coin::T",
      Base: "0x9D36e0edb8BBaBeec5edE8a218dc2B9a6Fce494F",
      Optimism: "0x825206E1D29456337769e6f1384101E997C6A732",
      Moonbeam: "0x18872b45c603eD2EbC508b9C5514a85c2e2791FB",
      Klaytn: "0x3CF1751E32c4225CB12ba953786C260C2cE89008"
    },
    "0xaf88d065e77c8cC2239327C5EDb3A432268e5831": {
      Ethereum: "0xCFc006a32a98031C2338BF9d5ff8ED2c0Cae4a9e",
      Bsc: "0x5caa170b465122D15a6D20FD9A804a9613CE7882",
      Polygon: "0x7800FE8951cdc1cDea748d878fAce63018D97960",
      Avalanche: "0x4b5fE357Eb11c735078e47526D6e853DBff18541",
      Celo: "0xA41a62567d9eb960D84b72663FdaeBE0BCdE2683",
      Solana: "CR4xnGrhsu1fWNPoX4KbTUUtqGMF3mzRLfj4S6YEs1Yo",
      Sui: "0xc3f8927de33d3deb52c282a836082a413bc73c6ee0bd4d7ec7e3b6b4c28e9abf::coin::COIN",
      Aptos: "0xca3a2c28bc8c6c762f752dd2a4ebbfd00356ca99977ce6636e3af5897124a87a::coin::T",
      Optimism: "0xa6252F56cc6eEA21165d56744C795F91c8a3Cf68",
      Base: "0xb96B82Cd6D45d98Fb6897D16A5E4EE888329C513",
      Fantom: "0x2228703672906fEe5eD681Ec28e42B4506b8c336",
      Moonbeam: "0xbd2B6D665439514EEaA8519f4fE87CC8C46e9167",
      Klaytn: "0x3d5973fF7288f47857dAa5a32C53976A9A968928",
      Xlayer: "0xd53bD30985B4125fc561774e388d9f679BB84117"
    },
    "0x5979D7b546E38E414F7E9822514be443A4800529": {
      Bsc: "0x159167e842C586a81f02E55bc043AC8EdB033E0b",
      Aptos: "0xd2ca17516bc4ca57c1c69577e0c9cc0129153286695b46b97f438ecc138c225e::coin::T",
      Solana: "8wJakbZuv7WApfHmRo2sdkeQfu6hXqfEqjb7BYXDKpKe",
      Sui: "0xb607aed1c09e676384d14ae638dbcb08523fc691d309e71c856c7fdcb60d4430::coin::COIN",
      Base: "0xbE3981b37CcE5eCb6925d2ad9D9E28dE7b165793",
      Optimism: "0xEae5ccc3c36beF59f6794b467e7e228CB3720415",
      Fantom: "0xf65BF40A3299Df500D440520dF7e6ce1BEa53E73",
      Ethereum: "0x906310cE867C22c5016248Bd791FA5dd162c9D6d",
      Polygon: "0xcf0aa97c2fD78Ee0f0C3090B9EB65d2bd6C1D81a"
    }
  },
  Optimism: {
    "0x4200000000000000000000000000000000000006": {
      Fantom: "0xe8E8f941377A955bFA72880ec0dc2319dbC827a8",
      Celo: "0x8d53771b1Ec7461f8e45Bca2609c45bC0bbd0677",
      Solana: "8M6d63oL7dvMZ1gNbgGe3h8afMSWJEKEhtPTFM2u8h3c",
      Sui: "0x0aab14ec22908de73d1b0619f5e03842398f8e68262981bd35ef44b42d22b23a::coin::COIN",
      Aptos: "0x6a7a7f36ef5e2d0e65fcf72669c20d514d68298b0f76c7554517208f73260aaf::coin::T",
      Arbitrum: "0xB1fC645a86fB5085e12D8BDDb77702F728D2A26F",
      Avalanche: "0xDf11535274c0FD2Fe41A88bd1bBF802D72296037",
      Bsc: "0x94AEc09B5e2CE591e39DC6aa58A3A6E85Ed45265",
      Ethereum: "0x8B5653Ae095529155462eDa8CF664eD96773F557",
      Polygon: "0x8182De59485Bb646542Db8C7E5958148Dc699319",
      Base: "0xCb725aC8d9985D3bE306Dd9e1517d3702929176c",
      Moonbeam: "0xd4870F7F5AD8Ae5139E1a5D8AD4ac55204aE4490",
      Klaytn: "0x4ab77AF7059435b71dBC3B7c5255983C8628eFdf"
    },
    "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85": {
      Fantom: "0x385b219f0C4fa2e84EfE5aaf9692a821C57B8248",
      Celo: "0xEe48963C003e21EaCEdFA8a0A19BB3cbF7E776Fe",
      Moonbeam: "0x7143e8EA96e158381057a58AfdDF44601c7e532C",
      Base: "0xc6bfBeb3002aD563D2d1f72614C61C83Bf147Acd",
      Arbitrum: "0x3A5C2Da9E30741cb59a5e9446A23A86886fC9DC2",
      Aptos: "0x4f6ecb05a797902d472abc2f5804bde93a53d8b75f14f767824cdb1623a4ee83::coin::T",
      Bsc: "0xa41ae127D04F7ee73B5058E2C60Fb7c7A2D21F79",
      Avalanche: "0xBe04f76A0ba2100c3F2d6Aa1FD8484F415469573",
      Polygon: "0x31F12aCb60C3c32EE884F3894a873347C097D925",
      Sui: "0x6037801f060f0f54b3817bca05e3c8b9b9ffaa2da8e93fd5b80fa662aa3c9e55::coin::COIN",
      Solana: "J8kcD4Wnd1ehne1dpL8WNtgZQR6Jpui2cTZcrmg5ybAa",
      Klaytn: "0x7Ee2AB1443fDB59AECEa3aDD8F81296d68c2D1e3",
      Ethereum: "0xe77C99b64414e0fd9aeEA48AFFBBD2E97A895020"
    },
    "0x1F32b1c2345538c0c6f582fCB022739c4A194Ebb": {
      Bsc: "0x1f29fAD000255BF49D72803b2A8FaC8e31947eF8",
      Base: "0xBb0BeaB819dEAf091C193bE4bBEeA9D5b0F5227C",
      Arbitrum: "0xf99C5EEd186601955a9a1027536D1b46b1f909F8",
      Polygon: "0x9065e1D25E65F7A1D60bb6197154386B52faA469",
      Ethereum: "0xB3ceE6DCa1dD528CB7CC258e32D8B50ce9Ee46f5"
    }
  },
  Base: {
    "0x4200000000000000000000000000000000000006": {
      Ethereum: "0x1D4241F7370253C0f12EFC536B7e16E462Fb3526",
      Bsc: "0x9dc152F4941cE1A138326e70c3600385bf0C22dD",
      Polygon: "0x5BCf8d8c097FbB35C371F921E3FF3e6F6Eb54B41",
      Avalanche: "0xFA83178c66fE51ee99109b5cC912f8098Ff812eF",
      Fantom: "0xd3365E7355230c78098b44B172eE27DAB95B041A",
      Celo: "0x905CADB645684140E285e2D09D39dF5a2082BC87",
      Moonbeam: "0x6C6f83366A42fcA4D30a2D3f1914284de995Ac3a",
      Solana: "DWXe1hxpnb8LAH21iyXcjvMbiAGzoYyuCVQtRLvZdLYd",
      Sui: "0xaecbc804fa7ca7cffc74c9a05eb6ae86fda0c68375b5c1724204a1065bcb239a::coin::COIN",
      Aptos: "0x5b5f14781164cf77185a7b6acd8e4f3cbb7e7cfb1cd5760d2b8af81075fc153d::coin::T",
      Arbitrum: "0xBAfbCB010D920e0Dab9DFdcF634De1B777028a85",
      Optimism: "0x3F369a664fa665e01e8EB9f20bFcE03A0CAb8971",
      Mantle: "0x4a2176DE2Fb36485704965bd1Cc471854f21303B",
      Klaytn: "0x7Bf9ad1D104dEAE4B59Ef1be6a273Cb46BA16362"
    },
    "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913": {
      Solana: "EfqRM8ZGWhDTKJ7BHmFvNagKVu3AxQRDQs8WMMaoBCu6",
      Moonbeam: "0xE6d02a875CcC153c076fe418f33De3A5C420f505",
      Celo: "0x2e2acb1782Aad0490f8446b6fD4626C467987bD6",
      Bsc: "0x55CaD531c8E303Cab8B3BE4bB4744Db4f896ac81",
      Optimism: "0xb931c7BbD87A6e249EaA7355B13927F9c99Bce87",
      Arbitrum: "0x8619F97D4d08382548F536E5CE1D3e0D9bA40326",
      Polygon: "0x1eeCaB0F75fE93abbFa0cDFfb4fB13d1dC8706c8",
      Avalanche: "0xab933e939a9236BD439F7d29b87CE712f42bAC06",
      Fantom: "0xd9E4C283d8A49Dc3767A6F5a4dFdc1d0cEf21604",
      Sui: "0x7e3e74afcc1913aa9491c8cee89b02131a6e5519b090f16b54321835c1241cfb::coin::COIN",
      Aptos: "0xfcc4fcd734d5b8578fb629d238d15264a49eca6165c7444c21feec3b4962eb88::coin::T",
      Mantle: "0x5D628a3285a10fdd93AEa704007957F294e05F91",
      Ethereum: "0xc38261846c42C1E1D59E04dA675Eb1974E9cE7b1",
      Klaytn: "0x0a2330c1C46E9A74e8651F7117a1264410eA3C88",
      Scroll: "0x22C9bde4Ad49C4b6CCFB8D394B5ED42A57853d58"
    },
    "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452": {
      Arbitrum: "0x09E79693E44c8813A8CA25EeD7A40e5E24cD9c01",
      Ethereum: "0x187175c7a526f48c905202Bd2Bf8D25A457F479F",
      Polygon: "0x95d4C8e851D9E8c6B92aa518474E991c373E9Fb2",
      Optimism: "0x6ee40855c0BaB20585d17D2b9dd8d2Cd1cd41801",
      Avalanche: "0x5e513CA12DbD8424bDFc5B50711dF4AE999a8C58"
    }
  },
  Klaytn: {
    "0xe4f05A66Ec68B54A58B17c22107b02e0232cC817": {
      Aptos: "0x539b652f8230a0e42adaeda4706b5639893d22362eda6ea897493c210cb48219::coin::T",
      Ethereum: "0x9AEA32B459e96C8eF5010f69130bf95fd129ac05",
      Celo: "0xe304254de5c2048F9bFb042dDFB54f84d1d77730",
      Polygon: "0x415ce980fde17F1FF102e1c6e4ce860Acc615D74",
      Base: "0x41c433c146c47Dc53FC48cDc69e406e365e298E1",
      Arbitrum: "0xFA95f6c796E54F9C4a99392CAE84410a25794BB3",
      Moonbeam: "0xf0a9476E4712123A807859f9Fd25fe98213379BD",
      Fantom: "0x787e2F3509583C0F03A339Be0826463C839CBE5E",
      Sui: "0xa5ec915864d7f37b25ca9144b2db6ebcf29e73603c2ccf9d0e765adcd9049a98::coin::COIN",
      Avalanche: "0x126C03982Ad6D7ef7E6aF020bF219e87185a6BC3",
      Bsc: "0xEA970e7b7D131Ea36c3051C9Ca11e785462fE00c",
      Optimism: "0xbbeF8233a0d10EEAb84E913FaDB337ab9b62F683",
      Solana: "2b8fZGLBZjpxFugCdnJbbLLBYxvx23rsrsvLYYueiHb7",
      Scroll: "0xA55FB7A046454998b2f6d8D99Df5F0E108b38229",
      Worldchain: "0xC080f0082029fC6e8A4Bb33a9B0655B8d4f2BAB0"
    }
  },
  Scroll: {
    "0x5300000000000000000000000000000000000004": {
      Arbitrum: "0xAe81a542e20270b48Bd5297E3e0f280f79E46C42"
    }
  },
  Mantle: {
    "0x78c1b0C915c4FAA5FffA6CAbf0219DA63d7f4cb8": {
      Optimism: "0xf704F6a3241609Cfb3E44Db1237E68EB6CaC7C04"
    }
  }
}, jw = {
  chains: Kx,
  tokens: Ew,
  wrappedTokens: Dw,
  rpcs: Sw,
  // From VAA https://wormholescan.io/#/tx/1/0000000000000000000000000000000000000000000000000000000000000004/18252082506122526004
  guardianSet: {
    index: 4,
    keys: [
      "0x5893b5a76c3f739645648885bdccc06cd70a3cd3",
      "0xff6cb952589bde862c25ef4392132fb9d4a42157",
      "0x114de8460193bdf3a2fcf81f86a09765f4762fd1",
      "0x107a0086b32d7a0977926a205131d8731d39cbeb",
      "0x8c82b2fd82faed2711d59af0f2499d16e726f6b2",
      "0x11b39756c042441be6d8650b69b54ebe715e2343",
      "0x54ce5b4d348fb74b958e8966e2ec3dbd4958a7cd",
      "0x15e7caf07c4e3dc8e7c469f92c8cd88fb8005a20",
      "0x74a3bf913953d695260d88bc1aa25a4eee363ef0",
      "0x000ac0076727b35fbea2dac28fee5ccb0fea768e",
      "0xaf45ced136b9d9e24903464ae889f5c8a723fc14",
      "0xf93124b7c738843cbb89e864c862c38cddcccf95",
      "0xd2cc37a4dc036a8d232b48f62cdd4731412f4890",
      "0xda798f6896a3331f64b48c12d1d57fd9cbe70811",
      "0x71aa1be1d36cafe3867910f99c09e347899c19c3",
      "0x8192b6e7387ccd768277c17dab1b7a5027c0b3cf",
      "0x178e21ad2e77ae06711549cfbb1f9c7a9d8096e8",
      "0x5e1487f35515d02a92753504a8d75471b9f49edb",
      "0x6fbebc898f403e4773e95feb15e80c9a99c8348d"
    ]
  }
}, Ow = {
  Bsc: {
    displayName: "BSC",
    explorerUrl: "https://testnet.bscscan.com/",
    explorerName: "BscScan",
    icon: "Bsc",
    symbol: "BSC",
    sdkName: "Bsc"
  },
  Avalanche: {
    displayName: "Fuji",
    explorerUrl: "https://testnet.snowtrace.io/",
    explorerName: "Snowtrace",
    icon: "Avalanche",
    symbol: "AVAX",
    sdkName: "Avalanche"
  },
  Fantom: {
    displayName: "Fantom",
    explorerUrl: "https://testnet.ftmscan.com/",
    explorerName: "FtmScan",
    icon: "Fantom",
    symbol: "FTM",
    sdkName: "Fantom"
  },
  Celo: {
    displayName: "Alfajores",
    explorerUrl: "https://explorer.celo.org/alfajores/",
    explorerName: "Celo Explorer",
    icon: "Celo",
    symbol: "CELO",
    sdkName: "Celo"
  },
  Moonbeam: {
    displayName: "Moonbase",
    explorerUrl: "https://moonbase.moonscan.io/",
    explorerName: "Moonscan",
    icon: "Moonbeam",
    symbol: "GLMR",
    sdkName: "Moonbeam"
  },
  Solana: {
    displayName: "Solana",
    explorerUrl: "https://explorer.solana.com/",
    explorerName: "Solana Explorer",
    icon: "Solana",
    symbol: "SOL",
    sdkName: "Solana"
  },
  Sui: {
    displayName: "Sui",
    explorerUrl: "https://suiscan.xyz/testnet/",
    explorerName: "Suiscan",
    icon: "Sui",
    symbol: "SUI",
    sdkName: "Sui"
  },
  Aptos: {
    displayName: "Aptos",
    explorerUrl: "https://explorer.aptoslabs.com/",
    explorerName: "Aptos Explorer",
    icon: "Aptos",
    symbol: "APT",
    sdkName: "Aptos"
  },
  Klaytn: {
    displayName: "Kaia",
    explorerUrl: "https://kairos.kaiascope.com/",
    explorerName: "Kaia Scope",
    icon: "Klaytn",
    symbol: "KAIA",
    sdkName: "Klaytn"
  },
  Sepolia: {
    displayName: "Sepolia",
    explorerUrl: "https://sepolia.etherscan.io/",
    explorerName: "Etherscan",
    icon: "Ethereum",
    symbol: "ETH",
    sdkName: "Sepolia"
  },
  ArbitrumSepolia: {
    displayName: "Arbitrum Sepolia",
    explorerUrl: "https://sepolia.arbiscan.io/",
    explorerName: "Etherscan",
    icon: "Arbitrum",
    symbol: "ARB",
    sdkName: "ArbitrumSepolia"
  },
  BaseSepolia: {
    displayName: "Base Sepolia",
    explorerUrl: "https://base-sepolia.blockscout.com/",
    explorerName: "Etherscan",
    icon: "Base",
    symbol: "BASE",
    sdkName: "BaseSepolia"
  },
  OptimismSepolia: {
    displayName: "Optimism Sepolia",
    explorerUrl: "https://sepolia-optimistic.etherscan.io/",
    explorerName: "Etherscan",
    icon: "Optimism",
    symbol: "OP",
    sdkName: "OptimismSepolia"
  },
  Scroll: {
    displayName: "Scroll",
    explorerUrl: "https://sepolia.scrollscan.dev/",
    explorerName: "Scrollscan",
    icon: "Scroll",
    symbol: "SCR",
    sdkName: "Scroll"
  },
  Xlayer: {
    displayName: "X Layer",
    explorerUrl: "https://www.okx.com/web3/explorer/xlayer-test/",
    explorerName: "OKX Explorer",
    icon: "Xlayer",
    symbol: "OKX",
    sdkName: "Xlayer"
  },
  Mantle: {
    displayName: "Mantle",
    explorerUrl: "https://explorer.testnet.mantle.xyz/",
    explorerName: "Mantle Explorer",
    icon: "Mantle",
    symbol: "MNT",
    sdkName: "Mantle"
  },
  Worldchain: {
    displayName: "World Chain",
    explorerUrl: "https://worldchain-sepolia.explorer.alchemy.com/",
    explorerName: "World Scan",
    icon: "Worldchain",
    sdkName: "Worldchain",
    symbol: "WORLD"
  },
  Unichain: {
    displayName: "Unichain",
    explorerUrl: "https://unichain-sepolia.blockscout.com/",
    explorerName: "Unichain Explorer",
    icon: "Unichain",
    symbol: "UNI",
    sdkName: "Unichain"
  },
  Mezo: {
    displayName: "Mezo",
    explorerUrl: "https://explorer.test.mezo.org/",
    explorerName: "Mezo Explorer",
    icon: "Mezo",
    sdkName: "Mezo",
    symbol: "MEZO"
  },
  Linea: {
    displayName: "Linea",
    sdkName: "Linea",
    explorerUrl: "https://sepolia.lineascan.build/",
    explorerName: "Lineascan",
    icon: "Linea",
    symbol: "LINEA"
  },
  Sonic: {
    displayName: "Sonic",
    sdkName: "Sonic",
    explorerUrl: "https://testnet.sonicscan.org/",
    explorerName: "Sonicscan",
    icon: "Sonic",
    symbol: "S"
  },
  Seievm: {
    displayName: "SeiEVM",
    explorerUrl: "https://seitrace.com/?chain=atlantic-2",
    explorerName: "Seitrace",
    icon: "Seievm",
    sdkName: "Seievm",
    symbol: "SEI"
  },
  Plume: {
    displayName: "Plume",
    sdkName: "Plume",
    explorerUrl: "https://testnet-explorer.plume.org",
    explorerName: "Plume Explorer",
    icon: "Plume",
    symbol: "PLUME"
  }
}, zw = {}, {
  REACT_APP_SEPOLIA_RPC: kw,
  REACT_APP_BSC_TESTNET_RPC: _w,
  REACT_APP_FUJI_RPC: Bw,
  REACT_APP_FANTOM_TESTNET_RPC: Fw,
  REACT_APP_ALFAJORES_RPC: Rw,
  REACT_APP_SOLANA_DEVNET_RPC: Pw,
  REACT_APP_MOONBASE_RPC: Uw,
  REACT_APP_SUI_TESTNET_RPC: Yw,
  REACT_APP_APTOS_TESTNET_RPC: Ww,
  REACT_APP_BASE_SEPOLIA_RPC: Hw,
  REACT_APP_KLAYTN_TESTNET_RPC: Zw,
  REACT_APP_ARBITRUM_SEPOLIA_RPC: Qw,
  REACT_APP_OPTIMISM_SEPOLIA_RPC: Vw,
  REACT_APP_SCROLL_TESTNET_RPC: Gw,
  REACT_APP_XLAYER_TESTNET_RPC: $w,
  REACT_APP_MANTLE_TESTNET_RPC: qw,
  REACT_APP_WORLDCHAIN_TESTNET_RPC: Jw,
  REACT_APP_UNICHAIN_TESTNET_RPC: Xw,
  REACT_APP_MEZO_TESTNET_RPC: Kw,
  REACT_APP_LINEA_TESTNET_RPC: eC,
  REACT_APP_SONIC_TESTNET_RPC: tC,
  REACT_APP_SEIEVM_TESTNET_RPC: rC,
  REACT_APP_PLUME_RPC: nC
} = zw, iC = {
  ..._t("Sepolia", kw),
  ..._t("Bsc", _w),
  ..._t("Avalanche", Bw),
  ..._t("Fantom", Fw),
  ..._t("Celo", Rw),
  ..._t("Solana", Pw),
  ..._t("Moonbeam", Uw),
  ..._t("Sui", Yw),
  ..._t("Aptos", Ww),
  ..._t("BaseSepolia", Hw),
  ..._t("ArbitrumSepolia", Qw),
  ..._t("OptimismSepolia", Vw),
  ..._t("Klaytn", Zw),
  ..._t("Scroll", Gw),
  ..._t("Xlayer", $w),
  ..._t("Mantle", qw),
  ..._t("Worldchain", Jw),
  ..._t("Unichain", Xw),
  ..._t("Mezo", Kw),
  ..._t("Linea", eC),
  ..._t("Sonic", tC),
  ..._t("Seievm", rC),
  ..._t("Plume", nC)
}, oC = [
  {
    symbol: "BNB",
    icon: Ee.BNB,
    decimals: 18,
    tokenId: { chain: "Bsc", address: "native" }
  },
  {
    symbol: "WBNB",
    icon: Ee.BNB,
    decimals: 18,
    tokenId: {
      chain: "Bsc",
      address: "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd"
    }
  },
  {
    symbol: "AVAX",
    icon: Ee.AVAX,
    decimals: 18,
    tokenId: { chain: "Avalanche", address: "native" }
  },
  {
    symbol: "WAVAX",
    icon: Ee.AVAX,
    decimals: 18,
    tokenId: {
      chain: "Avalanche",
      address: "0xd00ae08403B9bbb9124bB305C09058E32C39A48c"
    }
  },
  {
    symbol: "USDC",
    icon: Ee.USDC,
    decimals: 6,
    tokenId: {
      chain: "Avalanche",
      address: "0x5425890298aed601595a70AB815c96711a31Bc65"
    }
  },
  {
    symbol: "FTM",
    icon: Ee.FANTOM,
    decimals: 18,
    tokenId: { chain: "Fantom", address: "native" }
  },
  {
    symbol: "WFTM",
    icon: Ee.FANTOM,
    decimals: 18,
    tokenId: {
      chain: "Fantom",
      address: "0xf1277d1Ed8AD466beddF92ef448A132661956621"
    }
  },
  {
    symbol: "CELO",
    icon: Ee.CELO,
    decimals: 18,
    tokenId: {
      chain: "Celo",
      address: "0xF194afDf50B03e69Bd7D057c1Aa9e10c9954E4C9"
    }
  },
  {
    symbol: "USDC.e",
    icon: Ee.USDC,
    decimals: 6,
    tokenId: {
      chain: "Celo",
      address: "0x72CAaa7e9889E0a63e016748179b43911A3ec9e5"
    }
  },
  {
    symbol: "GLMR",
    icon: Ee.GLMR,
    decimals: 18,
    tokenId: { chain: "Moonbeam", address: "native" }
  },
  {
    symbol: "WGLMR",
    icon: Ee.GLMR,
    decimals: 18,
    tokenId: {
      chain: "Moonbeam",
      address: "0xD909178CC99d318e4D46e7E66a972955859670E1"
    }
  },
  {
    symbol: "SOL",
    icon: Ee.SOLANA,
    decimals: 9,
    tokenId: { chain: "Solana", address: "native" }
  },
  {
    symbol: "WSOL",
    tokenId: {
      chain: "Solana",
      address: "So11111111111111111111111111111111111111112"
    },
    icon: Ee.SOLANA,
    decimals: 9
  },
  {
    symbol: "USDC",
    tokenId: {
      chain: "Solana",
      address: "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU"
    },
    icon: Ee.USDC,
    decimals: 6
  },
  {
    symbol: "SUI",
    tokenId: { chain: "Sui", address: "native" },
    icon: Ee.SUI,
    decimals: 9
  },
  {
    symbol: "USDC",
    decimals: 6,
    tokenId: {
      chain: "Sui",
      address: "0xa1ec7fc00a6f40db9693ad1415d0c193ad3906494428cf252621037bd7117e29::usdc::USDC"
    },
    icon: Ee.USDC
  },
  {
    symbol: "APT",
    tokenId: { chain: "Aptos", address: "native" },
    icon: Ee.APT,
    decimals: 8
  },
  {
    symbol: "USDC",
    decimals: 6,
    tokenId: {
      chain: "Aptos",
      address: "0x69091fbab5f7d635ee7ac5098cf0c1efbe31d68fec0f2cd565e8d168daf52832"
    },
    icon: Ee.USDC
  },
  {
    symbol: "KAIA",
    icon: Ee.KLAY,
    decimals: 18,
    tokenId: { chain: "Klaytn", address: "native" }
  },
  {
    symbol: "wKAIA",
    name: "wKAIA",
    icon: Ee.KLAY,
    decimals: 18,
    tokenId: {
      chain: "Klaytn",
      address: "0x0339d5Eb6D195Ba90B13ed1BCeAa97EbD198b106"
    }
  },
  {
    symbol: "ETH",
    icon: Ee.ETH,
    decimals: 18,
    tokenId: { chain: "Sepolia", address: "native" }
  },
  {
    symbol: "WETH",
    icon: Ee.ETH,
    decimals: 18,
    tokenId: {
      chain: "Sepolia",
      address: "0xeef12A83EE5b7161D3873317c8E0E7B76e0B5D9c"
    }
  },
  {
    symbol: "USDC",
    icon: Ee.USDC,
    decimals: 6,
    tokenId: {
      chain: "Sepolia",
      address: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238"
    }
  },
  {
    symbol: "ETH",
    icon: Ee.ETH,
    decimals: 18,
    tokenId: { chain: "ArbitrumSepolia", address: "native" }
  },
  {
    symbol: "WETH",
    icon: Ee.ETH,
    decimals: 18,
    tokenId: {
      chain: "ArbitrumSepolia",
      address: "0x980B62Da83eFf3D4576C647993b0c1D7faf17c73"
    }
  },
  {
    symbol: "ETH",
    icon: Ee.ETH,
    decimals: 18,
    tokenId: { chain: "BaseSepolia", address: "native" }
  },
  {
    symbol: "WETH",
    icon: Ee.ETH,
    decimals: 18,
    tokenId: {
      chain: "BaseSepolia",
      address: "0x4200000000000000000000000000000000000006"
    }
  },
  {
    symbol: "USDC",
    icon: Ee.USDC,
    decimals: 6,
    tokenId: {
      chain: "BaseSepolia",
      address: "0x036CbD53842c5426634e7929541eC2318f3dCF7e"
    }
  },
  {
    symbol: "ETH",
    icon: Ee.ETH,
    decimals: 18,
    tokenId: { chain: "OptimismSepolia", address: "native" }
  },
  {
    symbol: "WETH",
    icon: Ee.ETH,
    decimals: 18,
    tokenId: {
      chain: "OptimismSepolia",
      address: "0x4200000000000000000000000000000000000006"
    }
  },
  {
    symbol: "ETH",
    icon: Ee.SCROLL,
    decimals: 18,
    tokenId: { chain: "Scroll", address: "native" }
  },
  {
    symbol: "WETH",
    icon: Ee.SCROLL,
    decimals: 18,
    tokenId: {
      chain: "Scroll",
      address: "0x5300000000000000000000000000000000000004"
    }
  },
  {
    symbol: "OKB",
    icon: Ee.XLAYER,
    decimals: 18,
    tokenId: { chain: "Xlayer", address: "native" }
  },
  {
    symbol: "WOKB",
    icon: Ee.XLAYER,
    decimals: 18,
    tokenId: {
      chain: "Xlayer",
      address: "0xa2aFfd8301BfB3c5b815829f2F509f053556D21B"
    }
  },
  {
    symbol: "MNT",
    icon: Ee.MANTLE,
    decimals: 18,
    tokenId: { chain: "Mantle", address: "native" }
  },
  {
    symbol: "WMNT",
    icon: Ee.MANTLE,
    decimals: 18,
    tokenId: {
      chain: "Mantle",
      address: "0xa4c4cb2A072eE99f77212Fa18c2B7Ca26DA23905"
    }
  },
  {
    symbol: "ETH",
    tokenId: {
      chain: "Worldchain",
      address: "native"
    },
    decimals: 18,
    icon: Ee.WORLDCHAIN
  },
  {
    symbol: "WETH",
    tokenId: {
      chain: "Worldchain",
      address: "0x4200000000000000000000000000000000000006"
    },
    decimals: 18,
    icon: Ee.WORLDCHAIN
  },
  {
    symbol: "ETH",
    tokenId: {
      chain: "Unichain",
      address: "native"
    },
    decimals: 18,
    icon: Ee.ETH
  },
  {
    symbol: "WETH",
    tokenId: {
      chain: "Unichain",
      address: "0x4200000000000000000000000000000000000006"
    },
    decimals: 18,
    icon: Ee.ETH
  },
  {
    symbol: "USDC",
    tokenId: {
      chain: "Unichain",
      address: "0x31d0220469e10c4E71834a79b1f276d740d3768F"
    },
    decimals: 6,
    icon: Ee.USDC
  },
  {
    symbol: "BTC",
    tokenId: {
      chain: "Mezo",
      address: "native"
    },
    decimals: 18,
    icon: Ee.BTC
  },
  {
    symbol: "ETH",
    tokenId: {
      chain: "Linea",
      address: "native"
    },
    decimals: 18,
    icon: Ee.ETH
  },
  {
    symbol: "USDC",
    tokenId: {
      chain: "Linea",
      address: "0xFEce4462D57bD51A6A552365A011b95f0E16d9B7"
    },
    decimals: 6,
    icon: Ee.USDC
  },
  {
    symbol: "S",
    tokenId: {
      chain: "Sonic",
      address: "native"
    },
    decimals: 18,
    icon: Ee.SONIC
  },
  {
    symbol: "USDC",
    tokenId: {
      chain: "Sonic",
      address: "0xA4879Fed32Ecbef99399e5cbC247E533421C4eC6"
    },
    decimals: 6,
    icon: Ee.USDC
  },
  {
    symbol: "SEI",
    tokenId: {
      chain: "Seievm",
      address: "native"
    },
    decimals: 18,
    icon: Ee.SEI
  },
  {
    symbol: "PLUME",
    decimals: 18,
    icon: Ee.PLUME,
    tokenId: { chain: "Plume", address: "native" }
  }
], aC = {
  Bsc: {
    "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd": {
      Avalanche: "0x10F1053bF2884b28ee0Bd7a2dDBa237Af3511d29",
      Fantom: "0xfB174b43228950C2055CFc25AE93f2DCe8E2beF0",
      Celo: "0xa8050be9389466c3c524F10F131f244ACbf21A0D",
      Moonbeam: "0x6097E80331B0c6aF4F74D7F2363E70Cb2Fd078A5",
      Solana: "BaGfF51MQ3a61papTRDYaNefBgTQ9ywnVne5fCff4bxT",
      Sui: "0xddcf8680a8a4b8a527d8c85ec203274991590c2ea898d1c4635b70164d9c584b::coin::COIN",
      Aptos: "0xa5894f5ddb8647e6143102aa336ff07374f7b32e88c1c703aef5b7c9a370bf80::coin::T",
      Klaytn: "0xEFa3626825C33C4cd83850920Ad7Ac0a392E1faE",
      Sepolia: "0x02CdD5eB55934663F0aD8fbA3516dC7DE4E22894"
    }
  },
  Avalanche: {
    "0xd00ae08403B9bbb9124bB305C09058E32C39A48c": {
      Bsc: "0x6cE9E2c8b59bbcf65dA375D3d8AB503c8524caf7",
      Fantom: "0x0f545Be981C37fB15ab7c65404648761e99016e4",
      Celo: "0x502c8C83008D9Dd812a7C5fB886C063060C73Dbf",
      Moonbeam: "0x2E8afeCC19842229358f3650cc3F091908dcbaB4",
      Solana: "3Ftc5hTz9sG4huk79onufGiebJNDMZNL8HYgdMJ9E7JR",
      Sui: "0xa600741c469fb57ed01497ddf101e798fa79a9c529bd176675c5c4d970811f80::coin::COIN",
      Aptos: "0xbe8f4301c0b54e870902b9a23eeb95ce74ac190531782aa3262337ceb145401a::coin::T",
      Klaytn: "0x10257392a2B5e3C4D4bEe1607650a1C0C738202a",
      Scroll: "0x5Bd1ba0040C16b13894A6EbE3d55708c91eF08bb",
      Xlayer: "0xb13a464ceE7455A9b2941bFAe1bB1eB5A6833867"
    },
    "0x5425890298aed601595a70AB815c96711a31Bc65": {
      Bsc: "0x1cfeCf72bcBE1E429A21A5B11E708C7c397AaC54",
      Fantom: "0x6BC4E8D8c1d54656D1DeBCa96efc53aFd1408aD2",
      Celo: "0xDDB349c976cA2C873644F21f594767Eb5390C831",
      Moonbeam: "0x6533CE14804D113b1F494dC56c5D60A43cb5C3b5",
      Solana: "GQtMXZxnuacCFTXVeTvyHi6P9F6chbtzhVc8JgD8hv7c",
      Sui: "0x2aa8c885d04e676c4e87b7d0f94d4f3b243b1b5d93239d1cc41d5528ce1714c1::coin::COIN",
      Aptos: "0x2ef7697bdb33361ca39d228671203afc0dea3202e792d79d2072b761d87c834::coin::T"
    }
  },
  Fantom: {
    "0xf1277d1Ed8AD466beddF92ef448A132661956621": {
      Bsc: "0x9aB305B792DBdb8253bEE909E7006611Cb45175b",
      Avalanche: "0x094cB577C21Ab1360178beE74B9591fa12216dAD",
      Celo: "0xE6F8710cA14CFe7F5aAAD3A799C3d1D92dCba938",
      Moonbeam: "0x566c1cebc6A4AFa1C122E039C4BEBe77043148Ee",
      Solana: "DMw2tLaq1bVoAEKtkoUtieSk9bfCPUvubYLatTMsSVop",
      Sui: "0x14e756ff65e0ac810a5f69ca5276ef5b899a6df3c4717de1f85559d8b5ae6ea6::coin::COIN",
      Aptos: "0x533c6ade00d15d1e014c41e29e34853e87df92c4e01a6a3f41318dbd098048d6::coin::T",
      Klaytn: "0x097c8878A0d852581Dc4D8820151094Ddd3663Ac",
      Sepolia: "0x852132647d301B7EED02589B1dc73545E73c8596"
    }
  },
  Celo: {
    "0xF194afDf50B03e69Bd7D057c1Aa9e10c9954E4C9": {
      Bsc: "0x1471698cBD9cAB0228F2EEA9303A2b3aA0ABDC2B",
      Avalanche: "0xC66d9c2b33c347d4A4441975f4688fcD5DD4c441",
      Fantom: "0xB18E73a69c3Aaea39a610372537Cf8482622d199",
      Moonbeam: "0x3406a9b09adf0cb36DC04c1523C4b294C6b79513",
      Solana: "84F2QX9278ToDmA98u4A86xSV9hz1ovazr8zwGaX6qjS",
      Sui: "0x81868174a6b11e1acc337b3414f9912455435d486609fb8d50b34312865085f2::coin::COIN",
      Aptos: "0xecbb0f7e7d049499ca83ca1358344f56557886f6f7adc740d6734cce7bfc9a14::coin::T",
      Klaytn: "0xC951826bbB310a8160BB78c2eEe6C98246292ba7",
      Sepolia: "0x648f226f3bDcAEdc844622d604F76935DC05bC24"
    }
  },
  Moonbeam: {
    "0xD909178CC99d318e4D46e7E66a972955859670E1": {
      Bsc: "0x5C31B36599ED7f06b09c0ffC7A2F928cE496F046",
      Avalanche: "0xf080782DF38eD5228D2FC2882d13D56c8f1D6f21",
      Fantom: "0x41E3CFDFC255A4bF3C8D3560Bc8D3D9b5080338e",
      Celo: "0x132D2172D89cd9CfD480A8887c6bF92360fB460e",
      Solana: "8987WGkYa5viiZ9DD8sS3PB5XghKmWjkEgmzvwDuoAEc",
      Sui: "0xeffae382de96981f7ddd2d294429924827e8f325d612487a12d6a0b249171002::coin::COIN",
      Aptos: "0x338373b6694f71dbeac5ca4a30503bf5f083888d71678aed31255de416be37c0::coin::T",
      Sepolia: "0x3F7CD70ECd402BBe71f45A95156A2CAC0d6A822E"
    }
  },
  Solana: {
    So11111111111111111111111111111111111111112: {
      Bsc: "0x30f19eBba919954FDc020B8A20aEF13ab5e02Af0",
      Avalanche: "0xb10563644a6AB8948ee6d7f5b0a1fb15AaEa1E03",
      Fantom: "0xED1a08Fc69A7008d225890A96aaE258c465CC7ad",
      Celo: "0x05EEF2AE1A7A938D78598F7d9e8b97A9bED0c9eC",
      Sui: "0xbc03aaab4c11eb84df8bf39fdc714fa5d5b65b16eb7d155e22c74a68c8d4e17f::coin::COIN",
      Aptos: "0xdd89c0e695df0692205912fb69fc290418bed0dbe6e4573d744a6d5e6bab6c13::coin::T",
      Klaytn: "0x48D99C16638E6FFD2ED60375cD35ef6c139e5f41",
      Moonbeam: "0x5babD0d267Adf2081626654E51d1cABF8c477440",
      Sepolia: "0x824CB8fC742F8D3300d29f16cA8beE94471169f5"
    },
    "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU": {
      Bsc: "0x51a3cc54eA30Da607974C5D07B8502599801AC08"
    }
  },
  Sui: {
    native: {
      Bsc: "0x5A73D76e09Af2E428EC64aE10F91B78AC990B298",
      Avalanche: "0xfc5128F8556a6F059466E67740e6cC31EE5C2C47",
      Fantom: "0xd882AB49372eC093E8697B5153f54ab5e7738e3b",
      Celo: "0xa40d9E69ca9867C4bFbeC11Ce79C939991e9bf26",
      Solana: "BJZ72CjPQojVoH68mzrd4VQ4nr6KuhbAGnhZEZCujKxY",
      Aptos: "0x7b22d0e02f653d4fd1caddcfa4719a2b329da56eb81d8f27db703f02466c26a5::coin::T",
      Moonbeam: "0x2ed4B5B1071A3C676664E9085C0e3826542C1b27",
      Klaytn: "0xbA5F07a20681Add3A396E7606c6DC9B03d71d28A"
    }
  },
  Aptos: {
    native: {
      Bsc: "0x4A7Bd5E135f421057F97BbA8BCeeE5c18334f454",
      Avalanche: "0x996a3f12C1FcD7339Ea8801f629201e4d42EAD04",
      Fantom: "0xAb2297E8994149BA91737944E40891881aF762a4",
      Celo: "0xAC0a2fF7DD597de863878a3372142b07B614C125",
      Moonbeam: "0xCaa2A1d3BbbA0D1466571e83b4E2CbE04252593D",
      Solana: "7EvFD3JKCJVdtkAYdaSVKJsrPEJCzy2neJha7TREGrCa",
      Sui: "0x812d6feb8b84e55d47a0bfcae9fb6a4e7e09be5ec86ce0a729e0f67d5f59f477::coin::COIN"
    }
  },
  Klaytn: {
    "0x0339d5Eb6D195Ba90B13ed1BCeAa97EbD198b106": {
      Bsc: "0x79D34FDb686B5D139949E4F92D83EEe376489176",
      Aptos: "0xa8ffe1ffe3057756019345cdf9cf3d1f1a3d9a355147dd9440878c448a057579::coin::T",
      Celo: "0x8e50fC4b7F8B7018E72475f78C640F973218C8Cf",
      Avalanche: "0x84f3298Bcc019BD5B995756494095e1Eb72B565C",
      Solana: "6p7qTfX4tRFtQovxwT77Jn9HFQEV7nxLbux9C31Tgm23",
      Fantom: "0x72A1C24dA7F08d11a7668E228Ec287Fc6ec16E48",
      Sepolia: "0x142D0E977768cA4De6f2161D9E5B5C9F00435F9e",
      Moonbeam: "0x6eFf019D79D4136e57A7FC141967F3D0AD41089a",
      Sui: "0xd4a59fb612b162df75a9d190c0f72098dcae883e88bd0eb28667c31f8208dc3c::coin::COIN"
    }
  },
  Sepolia: {
    "0xeef12A83EE5b7161D3873317c8E0E7B76e0B5D9c": {
      Solana: "6F5YWWrUMNpee8C6BDUc6DmRvYRMDDTgJHwKhbXuifWs",
      Celo: "0x890ad4a7eD5bD08b7d6638515157dF3bF4BaD1Bc",
      Bsc: "0x667a61Efa611399970AE927637dD6f9A16f51e40",
      Moonbeam: "0xa7276055a1d45fB9982575411801e10ac9970Da8",
      ArbitrumSepolia: "0x97Ee87C7Db6049669a518730a2Ee60d1Fc58844E",
      Avalanche: "0x12bFE94230daaE3d48067577F45b7b031dD357f3",
      Fantom: "0x7F96D67186561Aa17cEb699494E94bEE3F3499D4"
    },
    "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238": {
      Aptos: "0x3f2912a313c5bea312dbf19f9080101d2e762df6546a6fe9f60a4de72c93d015::coin::T",
      Solana: "23Adx8na44L3M1Nf9RrUpQPb41eufdRXKseg25FfcJtw",
      Celo: "0xD6A34325e5F6BE27b7006bf06651444196Da579a",
      Bsc: "0xb8850F591019F0794F813426d4A4A9b5fB8f23C8",
      BaseSepolia: "0x3F872340B6A75397aa9b0A463000349962a8795D",
      ArbitrumSepolia: "0x27B8F40Cf0915e729ae5A96970E91045Fe9724dF",
      Fantom: "0xa686203C86140142230f44A724281E1BEd09c369",
      Klaytn: "0x25f2a470a2e1E75DDAc40289AB277eDE4DD98aFa",
      Sui: "0x6529fef82a8a09470c550a3129bbd889030b62306f0c14161224b1a40ef1346f::coin::COIN"
    }
  },
  OptimismSepolia: {
    "0x4200000000000000000000000000000000000006": {
      ArbitrumSepolia: "0xa2610700cCA8361DECD27dB2564848C530f20813"
    }
  }
}, sC = {
  chains: Ow,
  tokens: oC,
  wrappedTokens: aC,
  rpcs: iC,
  guardianSet: {
    index: 0,
    keys: ["0x13947Bd48b18E53fdAeEe77F3473391aC727C638"]
  }
}, cC = {
  Ethereum: {
    sdkName: "Ethereum",
    displayName: "EVM",
    explorerUrl: "",
    explorerName: "",
    icon: "Ethereum",
    symbol: "ETH"
  }
}, lC = {}, { REACT_APP_ETHEREUM_DEVNET_RPC: fC } = lC, uC = {
  ..._t("Ethereum", fC)
}, dC = [
  {
    symbol: "ETH",
    icon: Ee.ETH,
    decimals: 18,
    tokenId: {
      chain: "Ethereum",
      address: "native"
    }
  },
  {
    symbol: "WETH",
    icon: Ee.ETH,
    decimals: 18,
    tokenId: {
      chain: "Ethereum",
      address: "0xDDb64fE46a91D46ee29420539FC25FD07c5FEa3E"
    }
  },
  {
    symbol: "TKN",
    icon: Ee.ETH,
    decimals: 18,
    tokenId: {
      chain: "Ethereum",
      address: "0x2D8BE6BF0baA74e0A907016679CaE9190e80dD0A"
    }
  }
], hC = {
  chains: cC,
  tokens: dC,
  wrappedTokens: {},
  rpcs: uC,
  guardianSet: {
    index: 0,
    keys: ["0x13947Bd48b18E53fdAeEe77F3473391aC727C638"]
  }
};
function pC(e) {
  var o;
  const t = typeof window > "u" || (o = window.location) == null ? void 0 : o.host;
  return function(i) {
    const c = {
      meta: {
        version: N9,
        hash: I9,
        host: t
      },
      ...i
    };
    if (console.debug("Wormhole Connect event:", c), e)
      try {
        e(c);
      } catch (n) {
        console.error("Error handling event:", n);
      }
  };
}
function gC(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var py = { exports: {} }, Vt = {}, a0 = { exports: {} }, r4;
function Ia() {
  if (r4) return a0.exports;
  r4 = 1;
  var e = 65536, t = 4294967295;
  function o() {
    throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
  }
  var i = Gt.Buffer, c = Wt.crypto || Wt.msCrypto;
  c && c.getRandomValues ? a0.exports = n : a0.exports = o;
  function n(d, f) {
    if (d > t) throw new RangeError("requested too many random bytes");
    var p = i.allocUnsafe(d);
    if (d > 0)
      if (d > e)
        for (var l = 0; l < d; l += e)
          c.getRandomValues(p.slice(l, l + e));
      else
        c.getRandomValues(p);
    return typeof f == "function" ? fe.process.nextTick(function() {
      f(null, p);
    }) : p;
  }
  return a0.exports;
}
var s1 = { exports: {} };
typeof Object.create == "function" ? s1.exports = function(t, o) {
  o && (t.super_ = o, t.prototype = Object.create(o.prototype, {
    constructor: {
      value: t,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : s1.exports = function(t, o) {
  if (o) {
    t.super_ = o;
    var i = function() {
    };
    i.prototype = o.prototype, t.prototype = new i(), t.prototype.constructor = t;
  }
};
var Yt = s1.exports, sh = { exports: {} }, ra = typeof Reflect == "object" ? Reflect : null, n4 = ra && typeof ra.apply == "function" ? ra.apply : function(t, o, i) {
  return Function.prototype.apply.call(t, o, i);
}, _0;
ra && typeof ra.ownKeys == "function" ? _0 = ra.ownKeys : Object.getOwnPropertySymbols ? _0 = function(t) {
  return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
} : _0 = function(t) {
  return Object.getOwnPropertyNames(t);
};
function yC(e) {
  console && console.warn && console.warn(e);
}
var gy = Number.isNaN || function(t) {
  return t !== t;
};
function mr() {
  mr.init.call(this);
}
sh.exports = mr;
sh.exports.once = bC;
mr.EventEmitter = mr;
mr.prototype._events = void 0;
mr.prototype._eventsCount = 0;
mr.prototype._maxListeners = void 0;
var i4 = 10;
function Yc(e) {
  if (typeof e != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
}
Object.defineProperty(mr, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return i4;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || gy(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    i4 = e;
  }
});
mr.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
mr.prototype.setMaxListeners = function(t) {
  if (typeof t != "number" || t < 0 || gy(t))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
  return this._maxListeners = t, this;
};
function yy(e) {
  return e._maxListeners === void 0 ? mr.defaultMaxListeners : e._maxListeners;
}
mr.prototype.getMaxListeners = function() {
  return yy(this);
};
mr.prototype.emit = function(t) {
  for (var o = [], i = 1; i < arguments.length; i++) o.push(arguments[i]);
  var c = t === "error", n = this._events;
  if (n !== void 0)
    c = c && n.error === void 0;
  else if (!c)
    return !1;
  if (c) {
    var d;
    if (o.length > 0 && (d = o[0]), d instanceof Error)
      throw d;
    var f = new Error("Unhandled error." + (d ? " (" + d.message + ")" : ""));
    throw f.context = d, f;
  }
  var p = n[t];
  if (p === void 0)
    return !1;
  if (typeof p == "function")
    n4(p, this, o);
  else
    for (var l = p.length, h = xy(p, l), i = 0; i < l; ++i)
      n4(h[i], this, o);
  return !0;
};
function My(e, t, o, i) {
  var c, n, d;
  if (Yc(o), n = e._events, n === void 0 ? (n = e._events = /* @__PURE__ */ Object.create(null), e._eventsCount = 0) : (n.newListener !== void 0 && (e.emit(
    "newListener",
    t,
    o.listener ? o.listener : o
  ), n = e._events), d = n[t]), d === void 0)
    d = n[t] = o, ++e._eventsCount;
  else if (typeof d == "function" ? d = n[t] = i ? [o, d] : [d, o] : i ? d.unshift(o) : d.push(o), c = yy(e), c > 0 && d.length > c && !d.warned) {
    d.warned = !0;
    var f = new Error("Possible EventEmitter memory leak detected. " + d.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    f.name = "MaxListenersExceededWarning", f.emitter = e, f.type = t, f.count = d.length, yC(f);
  }
  return e;
}
mr.prototype.addListener = function(t, o) {
  return My(this, t, o, !1);
};
mr.prototype.on = mr.prototype.addListener;
mr.prototype.prependListener = function(t, o) {
  return My(this, t, o, !0);
};
function MC() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function my(e, t, o) {
  var i = { fired: !1, wrapFn: void 0, target: e, type: t, listener: o }, c = MC.bind(i);
  return c.listener = o, i.wrapFn = c, c;
}
mr.prototype.once = function(t, o) {
  return Yc(o), this.on(t, my(this, t, o)), this;
};
mr.prototype.prependOnceListener = function(t, o) {
  return Yc(o), this.prependListener(t, my(this, t, o)), this;
};
mr.prototype.removeListener = function(t, o) {
  var i, c, n, d, f;
  if (Yc(o), c = this._events, c === void 0)
    return this;
  if (i = c[t], i === void 0)
    return this;
  if (i === o || i.listener === o)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete c[t], c.removeListener && this.emit("removeListener", t, i.listener || o));
  else if (typeof i != "function") {
    for (n = -1, d = i.length - 1; d >= 0; d--)
      if (i[d] === o || i[d].listener === o) {
        f = i[d].listener, n = d;
        break;
      }
    if (n < 0)
      return this;
    n === 0 ? i.shift() : mC(i, n), i.length === 1 && (c[t] = i[0]), c.removeListener !== void 0 && this.emit("removeListener", t, f || o);
  }
  return this;
};
mr.prototype.off = mr.prototype.removeListener;
mr.prototype.removeAllListeners = function(t) {
  var o, i, c;
  if (i = this._events, i === void 0)
    return this;
  if (i.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : i[t] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete i[t]), this;
  if (arguments.length === 0) {
    var n = Object.keys(i), d;
    for (c = 0; c < n.length; ++c)
      d = n[c], d !== "removeListener" && this.removeAllListeners(d);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (o = i[t], typeof o == "function")
    this.removeListener(t, o);
  else if (o !== void 0)
    for (c = o.length - 1; c >= 0; c--)
      this.removeListener(t, o[c]);
  return this;
};
function vy(e, t, o) {
  var i = e._events;
  if (i === void 0)
    return [];
  var c = i[t];
  return c === void 0 ? [] : typeof c == "function" ? o ? [c.listener || c] : [c] : o ? vC(c) : xy(c, c.length);
}
mr.prototype.listeners = function(t) {
  return vy(this, t, !0);
};
mr.prototype.rawListeners = function(t) {
  return vy(this, t, !1);
};
mr.listenerCount = function(e, t) {
  return typeof e.listenerCount == "function" ? e.listenerCount(t) : by.call(e, t);
};
mr.prototype.listenerCount = by;
function by(e) {
  var t = this._events;
  if (t !== void 0) {
    var o = t[e];
    if (typeof o == "function")
      return 1;
    if (o !== void 0)
      return o.length;
  }
  return 0;
}
mr.prototype.eventNames = function() {
  return this._eventsCount > 0 ? _0(this._events) : [];
};
function xy(e, t) {
  for (var o = new Array(t), i = 0; i < t; ++i)
    o[i] = e[i];
  return o;
}
function mC(e, t) {
  for (; t + 1 < e.length; t++)
    e[t] = e[t + 1];
  e.pop();
}
function vC(e) {
  for (var t = new Array(e.length), o = 0; o < t.length; ++o)
    t[o] = e[o].listener || e[o];
  return t;
}
function bC(e, t) {
  return new Promise(function(o, i) {
    function c(d) {
      e.removeListener(t, n), i(d);
    }
    function n() {
      typeof e.removeListener == "function" && e.removeListener("error", c), o([].slice.call(arguments));
    }
    wy(e, t, n, { once: !0 }), t !== "error" && xC(e, c, { once: !0 });
  });
}
function xC(e, t, o) {
  typeof e.on == "function" && wy(e, "error", t, o);
}
function wy(e, t, o, i) {
  if (typeof e.on == "function")
    i.once ? e.once(t, o) : e.on(t, o);
  else if (typeof e.addEventListener == "function")
    e.addEventListener(t, function c(n) {
      i.once && e.removeEventListener(t, c), o(n);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
}
var Na = sh.exports;
const TR = /* @__PURE__ */ Yi(Na);
var Gl, o4;
function Cy() {
  return o4 || (o4 = 1, Gl = Na.EventEmitter), Gl;
}
const wC = {}, CC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wC
}, Symbol.toStringTag, { value: "Module" })), Ds = /* @__PURE__ */ u9(CC);
var $l, a4;
function IC() {
  if (a4) return $l;
  a4 = 1;
  function e(N, w) {
    var S = Object.keys(N);
    if (Object.getOwnPropertySymbols) {
      var T = Object.getOwnPropertySymbols(N);
      w && (T = T.filter(function(E) {
        return Object.getOwnPropertyDescriptor(N, E).enumerable;
      })), S.push.apply(S, T);
    }
    return S;
  }
  function t(N) {
    for (var w = 1; w < arguments.length; w++) {
      var S = arguments[w] != null ? arguments[w] : {};
      w % 2 ? e(Object(S), !0).forEach(function(T) {
        o(N, T, S[T]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(N, Object.getOwnPropertyDescriptors(S)) : e(Object(S)).forEach(function(T) {
        Object.defineProperty(N, T, Object.getOwnPropertyDescriptor(S, T));
      });
    }
    return N;
  }
  function o(N, w, S) {
    return w = d(w), w in N ? Object.defineProperty(N, w, { value: S, enumerable: !0, configurable: !0, writable: !0 }) : N[w] = S, N;
  }
  function i(N, w) {
    if (!(N instanceof w))
      throw new TypeError("Cannot call a class as a function");
  }
  function c(N, w) {
    for (var S = 0; S < w.length; S++) {
      var T = w[S];
      T.enumerable = T.enumerable || !1, T.configurable = !0, "value" in T && (T.writable = !0), Object.defineProperty(N, d(T.key), T);
    }
  }
  function n(N, w, S) {
    return w && c(N.prototype, w), Object.defineProperty(N, "prototype", { writable: !1 }), N;
  }
  function d(N) {
    var w = f(N, "string");
    return typeof w == "symbol" ? w : String(w);
  }
  function f(N, w) {
    if (typeof N != "object" || N === null) return N;
    var S = N[Symbol.toPrimitive];
    if (S !== void 0) {
      var T = S.call(N, w);
      if (typeof T != "object") return T;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(N);
  }
  var p = Wr, l = p.Buffer, h = Ds, y = h.inspect, M = y && y.custom || "inspect";
  function C(N, w, S) {
    l.prototype.copy.call(N, w, S);
  }
  return $l = /* @__PURE__ */ function() {
    function N() {
      i(this, N), this.head = null, this.tail = null, this.length = 0;
    }
    return n(N, [{
      key: "push",
      value: function(S) {
        var T = {
          data: S,
          next: null
        };
        this.length > 0 ? this.tail.next = T : this.head = T, this.tail = T, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(S) {
        var T = {
          data: S,
          next: this.head
        };
        this.length === 0 && (this.tail = T), this.head = T, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var S = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, S;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(S) {
        if (this.length === 0) return "";
        for (var T = this.head, E = "" + T.data; T = T.next; ) E += S + T.data;
        return E;
      }
    }, {
      key: "concat",
      value: function(S) {
        if (this.length === 0) return l.alloc(0);
        for (var T = l.allocUnsafe(S >>> 0), E = this.head, j = 0; E; )
          C(E.data, T, j), j += E.data.length, E = E.next;
        return T;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(S, T) {
        var E;
        return S < this.head.data.length ? (E = this.head.data.slice(0, S), this.head.data = this.head.data.slice(S)) : S === this.head.data.length ? E = this.shift() : E = T ? this._getString(S) : this._getBuffer(S), E;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(S) {
        var T = this.head, E = 1, j = T.data;
        for (S -= j.length; T = T.next; ) {
          var O = T.data, z = S > O.length ? O.length : S;
          if (z === O.length ? j += O : j += O.slice(0, S), S -= z, S === 0) {
            z === O.length ? (++E, T.next ? this.head = T.next : this.head = this.tail = null) : (this.head = T, T.data = O.slice(z));
            break;
          }
          ++E;
        }
        return this.length -= E, j;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(S) {
        var T = l.allocUnsafe(S), E = this.head, j = 1;
        for (E.data.copy(T), S -= E.data.length; E = E.next; ) {
          var O = E.data, z = S > O.length ? O.length : S;
          if (O.copy(T, T.length - S, 0, z), S -= z, S === 0) {
            z === O.length ? (++j, E.next ? this.head = E.next : this.head = this.tail = null) : (this.head = E, E.data = O.slice(z));
            break;
          }
          ++j;
        }
        return this.length -= j, T;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: M,
      value: function(S, T) {
        return y(this, t(t({}, T), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), N;
  }(), $l;
}
var ql, s4;
function Iy() {
  if (s4) return ql;
  s4 = 1;
  function e(d, f) {
    var p = this, l = this._readableState && this._readableState.destroyed, h = this._writableState && this._writableState.destroyed;
    return l || h ? (f ? f(d) : d && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, fe.process.nextTick(c, this, d)) : fe.process.nextTick(c, this, d)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(d || null, function(y) {
      !f && y ? p._writableState ? p._writableState.errorEmitted ? fe.process.nextTick(o, p) : (p._writableState.errorEmitted = !0, fe.process.nextTick(t, p, y)) : fe.process.nextTick(t, p, y) : f ? (fe.process.nextTick(o, p), f(y)) : fe.process.nextTick(o, p);
    }), this);
  }
  function t(d, f) {
    c(d, f), o(d);
  }
  function o(d) {
    d._writableState && !d._writableState.emitClose || d._readableState && !d._readableState.emitClose || d.emit("close");
  }
  function i() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function c(d, f) {
    d.emit("error", f);
  }
  function n(d, f) {
    var p = d._readableState, l = d._writableState;
    p && p.autoDestroy || l && l.autoDestroy ? d.destroy(f) : d.emit("error", f);
  }
  return ql = {
    destroy: e,
    undestroy: i,
    errorOrDestroy: n
  }, ql;
}
var Jl = {}, c4;
function Aa() {
  if (c4) return Jl;
  c4 = 1;
  function e(f, p) {
    f.prototype = Object.create(p.prototype), f.prototype.constructor = f, f.__proto__ = p;
  }
  var t = {};
  function o(f, p, l) {
    l || (l = Error);
    function h(M, C, N) {
      return typeof p == "string" ? p : p(M, C, N);
    }
    var y = /* @__PURE__ */ function(M) {
      e(C, M);
      function C(N, w, S) {
        return M.call(this, h(N, w, S)) || this;
      }
      return C;
    }(l);
    y.prototype.name = l.name, y.prototype.code = f, t[f] = y;
  }
  function i(f, p) {
    if (Array.isArray(f)) {
      var l = f.length;
      return f = f.map(function(h) {
        return String(h);
      }), l > 2 ? "one of ".concat(p, " ").concat(f.slice(0, l - 1).join(", "), ", or ") + f[l - 1] : l === 2 ? "one of ".concat(p, " ").concat(f[0], " or ").concat(f[1]) : "of ".concat(p, " ").concat(f[0]);
    } else
      return "of ".concat(p, " ").concat(String(f));
  }
  function c(f, p, l) {
    return f.substr(0, p.length) === p;
  }
  function n(f, p, l) {
    return (l === void 0 || l > f.length) && (l = f.length), f.substring(l - p.length, l) === p;
  }
  function d(f, p, l) {
    return typeof l != "number" && (l = 0), l + p.length > f.length ? !1 : f.indexOf(p, l) !== -1;
  }
  return o("ERR_INVALID_OPT_VALUE", function(f, p) {
    return 'The value "' + p + '" is invalid for option "' + f + '"';
  }, TypeError), o("ERR_INVALID_ARG_TYPE", function(f, p, l) {
    var h;
    typeof p == "string" && c(p, "not ") ? (h = "must not be", p = p.replace(/^not /, "")) : h = "must be";
    var y;
    if (n(f, " argument"))
      y = "The ".concat(f, " ").concat(h, " ").concat(i(p, "type"));
    else {
      var M = d(f, ".") ? "property" : "argument";
      y = 'The "'.concat(f, '" ').concat(M, " ").concat(h, " ").concat(i(p, "type"));
    }
    return y += ". Received type ".concat(typeof l), y;
  }, TypeError), o("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), o("ERR_METHOD_NOT_IMPLEMENTED", function(f) {
    return "The " + f + " method is not implemented";
  }), o("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), o("ERR_STREAM_DESTROYED", function(f) {
    return "Cannot call " + f + " after a stream was destroyed";
  }), o("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), o("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), o("ERR_STREAM_WRITE_AFTER_END", "write after end"), o("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), o("ERR_UNKNOWN_ENCODING", function(f) {
    return "Unknown encoding: " + f;
  }, TypeError), o("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), Jl.codes = t, Jl;
}
var Xl, l4;
function Ny() {
  if (l4) return Xl;
  l4 = 1;
  var e = Aa().codes.ERR_INVALID_OPT_VALUE;
  function t(i, c, n) {
    return i.highWaterMark != null ? i.highWaterMark : c ? i[n] : null;
  }
  function o(i, c, n, d) {
    var f = t(c, d, n);
    if (f != null) {
      if (!(isFinite(f) && Math.floor(f) === f) || f < 0) {
        var p = d ? n : "highWaterMark";
        throw new e(p, f);
      }
      return Math.floor(f);
    }
    return i.objectMode ? 16 : 16 * 1024;
  }
  return Xl = {
    getHighWaterMark: o
  }, Xl;
}
var Kl, f4;
function Ay() {
  if (f4) return Kl;
  f4 = 1, Kl = e;
  function e(o, i) {
    if (t("noDeprecation"))
      return o;
    var c = !1;
    function n() {
      if (!c) {
        if (t("throwDeprecation"))
          throw new Error(i);
        t("traceDeprecation") ? console.trace(i) : console.warn(i), c = !0;
      }
      return o.apply(this, arguments);
    }
    return n;
  }
  function t(o) {
    try {
      if (!Wt.localStorage) return !1;
    } catch {
      return !1;
    }
    var i = Wt.localStorage[o];
    return i == null ? !1 : String(i).toLowerCase() === "true";
  }
  return Kl;
}
var ef, u4;
function Ty() {
  if (u4) return ef;
  u4 = 1, ef = W;
  function e(q) {
    var R = this;
    this.next = null, this.entry = null, this.finish = function() {
      te(R, q);
    };
  }
  var t;
  W.WritableState = k;
  var o = {
    deprecate: Ay()
  }, i = Cy(), c = Wr.Buffer, n = (typeof Wt < "u" ? Wt : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function d(q) {
    return c.from(q);
  }
  function f(q) {
    return c.isBuffer(q) || q instanceof n;
  }
  var p = Iy(), l = Ny(), h = l.getHighWaterMark, y = Aa().codes, M = y.ERR_INVALID_ARG_TYPE, C = y.ERR_METHOD_NOT_IMPLEMENTED, N = y.ERR_MULTIPLE_CALLBACK, w = y.ERR_STREAM_CANNOT_PIPE, S = y.ERR_STREAM_DESTROYED, T = y.ERR_STREAM_NULL_VALUES, E = y.ERR_STREAM_WRITE_AFTER_END, j = y.ERR_UNKNOWN_ENCODING, O = p.errorOrDestroy;
  Yt(W, i);
  function z() {
  }
  function k(q, R, Q) {
    t = t || fa(), q = q || {}, typeof Q != "boolean" && (Q = R instanceof t), this.objectMode = !!q.objectMode, Q && (this.objectMode = this.objectMode || !!q.writableObjectMode), this.highWaterMark = h(this, q, "writableHighWaterMark", Q), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var $ = q.decodeStrings === !1;
    this.decodeStrings = !$, this.defaultEncoding = q.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(F) {
      v(R, F);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = q.emitClose !== !1, this.autoDestroy = !!q.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new e(this);
  }
  k.prototype.getBuffer = function() {
    for (var R = this.bufferedRequest, Q = []; R; )
      Q.push(R), R = R.next;
    return Q;
  }, function() {
    try {
      Object.defineProperty(k.prototype, "buffer", {
        get: o.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var H;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (H = Function.prototype[Symbol.hasInstance], Object.defineProperty(W, Symbol.hasInstance, {
    value: function(R) {
      return H.call(this, R) ? !0 : this !== W ? !1 : R && R._writableState instanceof k;
    }
  })) : H = function(R) {
    return R instanceof this;
  };
  function W(q) {
    t = t || fa();
    var R = this instanceof t;
    if (!R && !H.call(W, this)) return new W(q);
    this._writableState = new k(q, this, R), this.writable = !0, q && (typeof q.write == "function" && (this._write = q.write), typeof q.writev == "function" && (this._writev = q.writev), typeof q.destroy == "function" && (this._destroy = q.destroy), typeof q.final == "function" && (this._final = q.final)), i.call(this);
  }
  W.prototype.pipe = function() {
    O(this, new w());
  };
  function U(q, R) {
    var Q = new E();
    O(q, Q), fe.process.nextTick(R, Q);
  }
  function B(q, R, Q, $) {
    var F;
    return Q === null ? F = new T() : typeof Q != "string" && !R.objectMode && (F = new M("chunk", ["string", "Buffer"], Q)), F ? (O(q, F), fe.process.nextTick($, F), !1) : !0;
  }
  W.prototype.write = function(q, R, Q) {
    var $ = this._writableState, F = !1, P = !$.objectMode && f(q);
    return P && !c.isBuffer(q) && (q = d(q)), typeof R == "function" && (Q = R, R = null), P ? R = "buffer" : R || (R = $.defaultEncoding), typeof Q != "function" && (Q = z), $.ending ? U(this, Q) : (P || B(this, $, q, Q)) && ($.pendingcb++, F = r(this, $, P, q, R, Q)), F;
  }, W.prototype.cork = function() {
    this._writableState.corked++;
  }, W.prototype.uncork = function() {
    var q = this._writableState;
    q.corked && (q.corked--, !q.writing && !q.corked && !q.bufferProcessing && q.bufferedRequest && m(this, q));
  }, W.prototype.setDefaultEncoding = function(R) {
    if (typeof R == "string" && (R = R.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((R + "").toLowerCase()) > -1)) throw new j(R);
    return this._writableState.defaultEncoding = R, this;
  }, Object.defineProperty(W.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function I(q, R, Q) {
    return !q.objectMode && q.decodeStrings !== !1 && typeof R == "string" && (R = c.from(R, Q)), R;
  }
  Object.defineProperty(W.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function r(q, R, Q, $, F, P) {
    if (!Q) {
      var _ = I(R, $, F);
      $ !== _ && (Q = !0, F = "buffer", $ = _);
    }
    var X = R.objectMode ? 1 : $.length;
    R.length += X;
    var le = R.length < R.highWaterMark;
    if (le || (R.needDrain = !0), R.writing || R.corked) {
      var ie = R.lastBufferedRequest;
      R.lastBufferedRequest = {
        chunk: $,
        encoding: F,
        isBuf: Q,
        callback: P,
        next: null
      }, ie ? ie.next = R.lastBufferedRequest : R.bufferedRequest = R.lastBufferedRequest, R.bufferedRequestCount += 1;
    } else
      s(q, R, !1, X, $, F, P);
    return le;
  }
  function s(q, R, Q, $, F, P, _) {
    R.writelen = $, R.writecb = _, R.writing = !0, R.sync = !0, R.destroyed ? R.onwrite(new S("write")) : Q ? q._writev(F, R.onwrite) : q._write(F, P, R.onwrite), R.sync = !1;
  }
  function u(q, R, Q, $, F) {
    --R.pendingcb, Q ? (fe.process.nextTick(F, $), fe.process.nextTick(G, q, R), q._writableState.errorEmitted = !0, O(q, $)) : (F($), q._writableState.errorEmitted = !0, O(q, $), G(q, R));
  }
  function g(q) {
    q.writing = !1, q.writecb = null, q.length -= q.writelen, q.writelen = 0;
  }
  function v(q, R) {
    var Q = q._writableState, $ = Q.sync, F = Q.writecb;
    if (typeof F != "function") throw new N();
    if (g(Q), R) u(q, Q, $, R, F);
    else {
      var P = a(Q) || q.destroyed;
      !P && !Q.corked && !Q.bufferProcessing && Q.bufferedRequest && m(q, Q), $ ? fe.process.nextTick(A, q, Q, P, F) : A(q, Q, P, F);
    }
  }
  function A(q, R, Q, $) {
    Q || L(q, R), R.pendingcb--, $(), G(q, R);
  }
  function L(q, R) {
    R.length === 0 && R.needDrain && (R.needDrain = !1, q.emit("drain"));
  }
  function m(q, R) {
    R.bufferProcessing = !0;
    var Q = R.bufferedRequest;
    if (q._writev && Q && Q.next) {
      var $ = R.bufferedRequestCount, F = new Array($), P = R.corkedRequestsFree;
      P.entry = Q;
      for (var _ = 0, X = !0; Q; )
        F[_] = Q, Q.isBuf || (X = !1), Q = Q.next, _ += 1;
      F.allBuffers = X, s(q, R, !0, R.length, F, "", P.finish), R.pendingcb++, R.lastBufferedRequest = null, P.next ? (R.corkedRequestsFree = P.next, P.next = null) : R.corkedRequestsFree = new e(R), R.bufferedRequestCount = 0;
    } else {
      for (; Q; ) {
        var le = Q.chunk, ie = Q.encoding, oe = Q.callback, pe = R.objectMode ? 1 : le.length;
        if (s(q, R, !1, pe, le, ie, oe), Q = Q.next, R.bufferedRequestCount--, R.writing)
          break;
      }
      Q === null && (R.lastBufferedRequest = null);
    }
    R.bufferedRequest = Q, R.bufferProcessing = !1;
  }
  W.prototype._write = function(q, R, Q) {
    Q(new C("_write()"));
  }, W.prototype._writev = null, W.prototype.end = function(q, R, Q) {
    var $ = this._writableState;
    return typeof q == "function" ? (Q = q, q = null, R = null) : typeof R == "function" && (Q = R, R = null), q != null && this.write(q, R), $.corked && ($.corked = 1, this.uncork()), $.ending || Z(this, $, Q), this;
  }, Object.defineProperty(W.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function a(q) {
    return q.ending && q.length === 0 && q.bufferedRequest === null && !q.finished && !q.writing;
  }
  function x(q, R) {
    q._final(function(Q) {
      R.pendingcb--, Q && O(q, Q), R.prefinished = !0, q.emit("prefinish"), G(q, R);
    });
  }
  function V(q, R) {
    !R.prefinished && !R.finalCalled && (typeof q._final == "function" && !R.destroyed ? (R.pendingcb++, R.finalCalled = !0, fe.process.nextTick(x, q, R)) : (R.prefinished = !0, q.emit("prefinish")));
  }
  function G(q, R) {
    var Q = a(R);
    if (Q && (V(q, R), R.pendingcb === 0 && (R.finished = !0, q.emit("finish"), R.autoDestroy))) {
      var $ = q._readableState;
      (!$ || $.autoDestroy && $.endEmitted) && q.destroy();
    }
    return Q;
  }
  function Z(q, R, Q) {
    R.ending = !0, G(q, R), Q && (R.finished ? fe.process.nextTick(Q) : q.once("finish", Q)), R.ended = !0, q.writable = !1;
  }
  function te(q, R, Q) {
    var $ = q.entry;
    for (q.entry = null; $; ) {
      var F = $.callback;
      R.pendingcb--, F(Q), $ = $.next;
    }
    R.corkedRequestsFree.next = q;
  }
  return Object.defineProperty(W.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(R) {
      this._writableState && (this._writableState.destroyed = R);
    }
  }), W.prototype.destroy = p.destroy, W.prototype._undestroy = p.undestroy, W.prototype._destroy = function(q, R) {
    R(q);
  }, ef;
}
var tf, d4;
function fa() {
  if (d4) return tf;
  d4 = 1;
  var e = Object.keys || function(l) {
    var h = [];
    for (var y in l) h.push(y);
    return h;
  };
  tf = d;
  var t = Ly(), o = Ty();
  Yt(d, t);
  for (var i = e(o.prototype), c = 0; c < i.length; c++) {
    var n = i[c];
    d.prototype[n] || (d.prototype[n] = o.prototype[n]);
  }
  function d(l) {
    if (!(this instanceof d)) return new d(l);
    t.call(this, l), o.call(this, l), this.allowHalfOpen = !0, l && (l.readable === !1 && (this.readable = !1), l.writable === !1 && (this.writable = !1), l.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", f)));
  }
  Object.defineProperty(d.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(d.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(d.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function f() {
    this._writableState.ended || fe.process.nextTick(p, this);
  }
  function p(l) {
    l.end();
  }
  return Object.defineProperty(d.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(h) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = h, this._writableState.destroyed = h);
    }
  }), tf;
}
var rf = {}, h4;
function c1() {
  if (h4) return rf;
  h4 = 1;
  var e = Gt.Buffer, t = e.isEncoding || function(T) {
    switch (T = "" + T, T && T.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function o(T) {
    if (!T) return "utf8";
    for (var E; ; )
      switch (T) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return T;
        default:
          if (E) return;
          T = ("" + T).toLowerCase(), E = !0;
      }
  }
  function i(T) {
    var E = o(T);
    if (typeof E != "string" && (e.isEncoding === t || !t(T))) throw new Error("Unknown encoding: " + T);
    return E || T;
  }
  rf.StringDecoder = c;
  function c(T) {
    this.encoding = i(T);
    var E;
    switch (this.encoding) {
      case "utf16le":
        this.text = y, this.end = M, E = 4;
        break;
      case "utf8":
        this.fillLast = p, E = 4;
        break;
      case "base64":
        this.text = C, this.end = N, E = 3;
        break;
      default:
        this.write = w, this.end = S;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = e.allocUnsafe(E);
  }
  c.prototype.write = function(T) {
    if (T.length === 0) return "";
    var E, j;
    if (this.lastNeed) {
      if (E = this.fillLast(T), E === void 0) return "";
      j = this.lastNeed, this.lastNeed = 0;
    } else
      j = 0;
    return j < T.length ? E ? E + this.text(T, j) : this.text(T, j) : E || "";
  }, c.prototype.end = h, c.prototype.text = l, c.prototype.fillLast = function(T) {
    if (this.lastNeed <= T.length)
      return T.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    T.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, T.length), this.lastNeed -= T.length;
  };
  function n(T) {
    return T <= 127 ? 0 : T >> 5 === 6 ? 2 : T >> 4 === 14 ? 3 : T >> 3 === 30 ? 4 : T >> 6 === 2 ? -1 : -2;
  }
  function d(T, E, j) {
    var O = E.length - 1;
    if (O < j) return 0;
    var z = n(E[O]);
    return z >= 0 ? (z > 0 && (T.lastNeed = z - 1), z) : --O < j || z === -2 ? 0 : (z = n(E[O]), z >= 0 ? (z > 0 && (T.lastNeed = z - 2), z) : --O < j || z === -2 ? 0 : (z = n(E[O]), z >= 0 ? (z > 0 && (z === 2 ? z = 0 : T.lastNeed = z - 3), z) : 0));
  }
  function f(T, E, j) {
    if ((E[0] & 192) !== 128)
      return T.lastNeed = 0, "�";
    if (T.lastNeed > 1 && E.length > 1) {
      if ((E[1] & 192) !== 128)
        return T.lastNeed = 1, "�";
      if (T.lastNeed > 2 && E.length > 2 && (E[2] & 192) !== 128)
        return T.lastNeed = 2, "�";
    }
  }
  function p(T) {
    var E = this.lastTotal - this.lastNeed, j = f(this, T);
    if (j !== void 0) return j;
    if (this.lastNeed <= T.length)
      return T.copy(this.lastChar, E, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    T.copy(this.lastChar, E, 0, T.length), this.lastNeed -= T.length;
  }
  function l(T, E) {
    var j = d(this, T, E);
    if (!this.lastNeed) return T.toString("utf8", E);
    this.lastTotal = j;
    var O = T.length - (j - this.lastNeed);
    return T.copy(this.lastChar, 0, O), T.toString("utf8", E, O);
  }
  function h(T) {
    var E = T && T.length ? this.write(T) : "";
    return this.lastNeed ? E + "�" : E;
  }
  function y(T, E) {
    if ((T.length - E) % 2 === 0) {
      var j = T.toString("utf16le", E);
      if (j) {
        var O = j.charCodeAt(j.length - 1);
        if (O >= 55296 && O <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = T[T.length - 2], this.lastChar[1] = T[T.length - 1], j.slice(0, -1);
      }
      return j;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = T[T.length - 1], T.toString("utf16le", E, T.length - 1);
  }
  function M(T) {
    var E = T && T.length ? this.write(T) : "";
    if (this.lastNeed) {
      var j = this.lastTotal - this.lastNeed;
      return E + this.lastChar.toString("utf16le", 0, j);
    }
    return E;
  }
  function C(T, E) {
    var j = (T.length - E) % 3;
    return j === 0 ? T.toString("base64", E) : (this.lastNeed = 3 - j, this.lastTotal = 3, j === 1 ? this.lastChar[0] = T[T.length - 1] : (this.lastChar[0] = T[T.length - 2], this.lastChar[1] = T[T.length - 1]), T.toString("base64", E, T.length - j));
  }
  function N(T) {
    var E = T && T.length ? this.write(T) : "";
    return this.lastNeed ? E + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : E;
  }
  function w(T) {
    return T.toString(this.encoding);
  }
  function S(T) {
    return T && T.length ? this.write(T) : "";
  }
  return rf;
}
var nf, p4;
function ch() {
  if (p4) return nf;
  p4 = 1;
  var e = Aa().codes.ERR_STREAM_PREMATURE_CLOSE;
  function t(n) {
    var d = !1;
    return function() {
      if (!d) {
        d = !0;
        for (var f = arguments.length, p = new Array(f), l = 0; l < f; l++)
          p[l] = arguments[l];
        n.apply(this, p);
      }
    };
  }
  function o() {
  }
  function i(n) {
    return n.setHeader && typeof n.abort == "function";
  }
  function c(n, d, f) {
    if (typeof d == "function") return c(n, null, d);
    d || (d = {}), f = t(f || o);
    var p = d.readable || d.readable !== !1 && n.readable, l = d.writable || d.writable !== !1 && n.writable, h = function() {
      n.writable || M();
    }, y = n._writableState && n._writableState.finished, M = function() {
      l = !1, y = !0, p || f.call(n);
    }, C = n._readableState && n._readableState.endEmitted, N = function() {
      p = !1, C = !0, l || f.call(n);
    }, w = function(j) {
      f.call(n, j);
    }, S = function() {
      var j;
      if (p && !C)
        return (!n._readableState || !n._readableState.ended) && (j = new e()), f.call(n, j);
      if (l && !y)
        return (!n._writableState || !n._writableState.ended) && (j = new e()), f.call(n, j);
    }, T = function() {
      n.req.on("finish", M);
    };
    return i(n) ? (n.on("complete", M), n.on("abort", S), n.req ? T() : n.on("request", T)) : l && !n._writableState && (n.on("end", h), n.on("close", h)), n.on("end", N), n.on("finish", M), d.error !== !1 && n.on("error", w), n.on("close", S), function() {
      n.removeListener("complete", M), n.removeListener("abort", S), n.removeListener("request", T), n.req && n.req.removeListener("finish", M), n.removeListener("end", h), n.removeListener("close", h), n.removeListener("finish", M), n.removeListener("end", N), n.removeListener("error", w), n.removeListener("close", S);
    };
  }
  return nf = c, nf;
}
var of, g4;
function NC() {
  if (g4) return of;
  g4 = 1;
  var e;
  function t(j, O, z) {
    return O = o(O), O in j ? Object.defineProperty(j, O, { value: z, enumerable: !0, configurable: !0, writable: !0 }) : j[O] = z, j;
  }
  function o(j) {
    var O = i(j, "string");
    return typeof O == "symbol" ? O : String(O);
  }
  function i(j, O) {
    if (typeof j != "object" || j === null) return j;
    var z = j[Symbol.toPrimitive];
    if (z !== void 0) {
      var k = z.call(j, O);
      if (typeof k != "object") return k;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (O === "string" ? String : Number)(j);
  }
  var c = ch(), n = Symbol("lastResolve"), d = Symbol("lastReject"), f = Symbol("error"), p = Symbol("ended"), l = Symbol("lastPromise"), h = Symbol("handlePromise"), y = Symbol("stream");
  function M(j, O) {
    return {
      value: j,
      done: O
    };
  }
  function C(j) {
    var O = j[n];
    if (O !== null) {
      var z = j[y].read();
      z !== null && (j[l] = null, j[n] = null, j[d] = null, O(M(z, !1)));
    }
  }
  function N(j) {
    fe.process.nextTick(C, j);
  }
  function w(j, O) {
    return function(z, k) {
      j.then(function() {
        if (O[p]) {
          z(M(void 0, !0));
          return;
        }
        O[h](z, k);
      }, k);
    };
  }
  var S = Object.getPrototypeOf(function() {
  }), T = Object.setPrototypeOf((e = {
    get stream() {
      return this[y];
    },
    next: function() {
      var O = this, z = this[f];
      if (z !== null)
        return Promise.reject(z);
      if (this[p])
        return Promise.resolve(M(void 0, !0));
      if (this[y].destroyed)
        return new Promise(function(U, B) {
          fe.process.nextTick(function() {
            O[f] ? B(O[f]) : U(M(void 0, !0));
          });
        });
      var k = this[l], H;
      if (k)
        H = new Promise(w(k, this));
      else {
        var W = this[y].read();
        if (W !== null)
          return Promise.resolve(M(W, !1));
        H = new Promise(this[h]);
      }
      return this[l] = H, H;
    }
  }, t(e, Symbol.asyncIterator, function() {
    return this;
  }), t(e, "return", function() {
    var O = this;
    return new Promise(function(z, k) {
      O[y].destroy(null, function(H) {
        if (H) {
          k(H);
          return;
        }
        z(M(void 0, !0));
      });
    });
  }), e), S), E = function(O) {
    var z, k = Object.create(T, (z = {}, t(z, y, {
      value: O,
      writable: !0
    }), t(z, n, {
      value: null,
      writable: !0
    }), t(z, d, {
      value: null,
      writable: !0
    }), t(z, f, {
      value: null,
      writable: !0
    }), t(z, p, {
      value: O._readableState.endEmitted,
      writable: !0
    }), t(z, h, {
      value: function(W, U) {
        var B = k[y].read();
        B ? (k[l] = null, k[n] = null, k[d] = null, W(M(B, !1))) : (k[n] = W, k[d] = U);
      },
      writable: !0
    }), z));
    return k[l] = null, c(O, function(H) {
      if (H && H.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var W = k[d];
        W !== null && (k[l] = null, k[n] = null, k[d] = null, W(H)), k[f] = H;
        return;
      }
      var U = k[n];
      U !== null && (k[l] = null, k[n] = null, k[d] = null, U(M(void 0, !0))), k[p] = !0;
    }), O.on("readable", N.bind(null, k)), k;
  };
  return of = E, of;
}
var af, y4;
function AC() {
  return y4 || (y4 = 1, af = function() {
    throw new Error("Readable.from is not available in the browser");
  }), af;
}
var sf, M4;
function Ly() {
  if (M4) return sf;
  M4 = 1, sf = U;
  var e;
  U.ReadableState = W, Na.EventEmitter;
  var t = function(_, X) {
    return _.listeners(X).length;
  }, o = Cy(), i = Wr.Buffer, c = (typeof Wt < "u" ? Wt : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function n(P) {
    return i.from(P);
  }
  function d(P) {
    return i.isBuffer(P) || P instanceof c;
  }
  var f = Ds, p;
  f && f.debuglog ? p = f.debuglog("stream") : p = function() {
  };
  var l = IC(), h = Iy(), y = Ny(), M = y.getHighWaterMark, C = Aa().codes, N = C.ERR_INVALID_ARG_TYPE, w = C.ERR_STREAM_PUSH_AFTER_EOF, S = C.ERR_METHOD_NOT_IMPLEMENTED, T = C.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, E, j, O;
  Yt(U, o);
  var z = h.errorOrDestroy, k = ["error", "close", "destroy", "pause", "resume"];
  function H(P, _, X) {
    if (typeof P.prependListener == "function") return P.prependListener(_, X);
    !P._events || !P._events[_] ? P.on(_, X) : Array.isArray(P._events[_]) ? P._events[_].unshift(X) : P._events[_] = [X, P._events[_]];
  }
  function W(P, _, X) {
    e = e || fa(), P = P || {}, typeof X != "boolean" && (X = _ instanceof e), this.objectMode = !!P.objectMode, X && (this.objectMode = this.objectMode || !!P.readableObjectMode), this.highWaterMark = M(this, P, "readableHighWaterMark", X), this.buffer = new l(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = P.emitClose !== !1, this.autoDestroy = !!P.autoDestroy, this.destroyed = !1, this.defaultEncoding = P.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, P.encoding && (E || (E = c1().StringDecoder), this.decoder = new E(P.encoding), this.encoding = P.encoding);
  }
  function U(P) {
    if (e = e || fa(), !(this instanceof U)) return new U(P);
    var _ = this instanceof e;
    this._readableState = new W(P, this, _), this.readable = !0, P && (typeof P.read == "function" && (this._read = P.read), typeof P.destroy == "function" && (this._destroy = P.destroy)), o.call(this);
  }
  Object.defineProperty(U.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(_) {
      this._readableState && (this._readableState.destroyed = _);
    }
  }), U.prototype.destroy = h.destroy, U.prototype._undestroy = h.undestroy, U.prototype._destroy = function(P, _) {
    _(P);
  }, U.prototype.push = function(P, _) {
    var X = this._readableState, le;
    return X.objectMode ? le = !0 : typeof P == "string" && (_ = _ || X.defaultEncoding, _ !== X.encoding && (P = i.from(P, _), _ = ""), le = !0), B(this, P, _, !1, le);
  }, U.prototype.unshift = function(P) {
    return B(this, P, null, !0, !1);
  };
  function B(P, _, X, le, ie) {
    p("readableAddChunk", _);
    var oe = P._readableState;
    if (_ === null)
      oe.reading = !1, v(P, oe);
    else {
      var pe;
      if (ie || (pe = r(oe, _)), pe)
        z(P, pe);
      else if (oe.objectMode || _ && _.length > 0)
        if (typeof _ != "string" && !oe.objectMode && Object.getPrototypeOf(_) !== i.prototype && (_ = n(_)), le)
          oe.endEmitted ? z(P, new T()) : I(P, oe, _, !0);
        else if (oe.ended)
          z(P, new w());
        else {
          if (oe.destroyed)
            return !1;
          oe.reading = !1, oe.decoder && !X ? (_ = oe.decoder.write(_), oe.objectMode || _.length !== 0 ? I(P, oe, _, !1) : m(P, oe)) : I(P, oe, _, !1);
        }
      else le || (oe.reading = !1, m(P, oe));
    }
    return !oe.ended && (oe.length < oe.highWaterMark || oe.length === 0);
  }
  function I(P, _, X, le) {
    _.flowing && _.length === 0 && !_.sync ? (_.awaitDrain = 0, P.emit("data", X)) : (_.length += _.objectMode ? 1 : X.length, le ? _.buffer.unshift(X) : _.buffer.push(X), _.needReadable && A(P)), m(P, _);
  }
  function r(P, _) {
    var X;
    return !d(_) && typeof _ != "string" && _ !== void 0 && !P.objectMode && (X = new N("chunk", ["string", "Buffer", "Uint8Array"], _)), X;
  }
  U.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, U.prototype.setEncoding = function(P) {
    E || (E = c1().StringDecoder);
    var _ = new E(P);
    this._readableState.decoder = _, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var X = this._readableState.buffer.head, le = ""; X !== null; )
      le += _.write(X.data), X = X.next;
    return this._readableState.buffer.clear(), le !== "" && this._readableState.buffer.push(le), this._readableState.length = le.length, this;
  };
  var s = 1073741824;
  function u(P) {
    return P >= s ? P = s : (P--, P |= P >>> 1, P |= P >>> 2, P |= P >>> 4, P |= P >>> 8, P |= P >>> 16, P++), P;
  }
  function g(P, _) {
    return P <= 0 || _.length === 0 && _.ended ? 0 : _.objectMode ? 1 : P !== P ? _.flowing && _.length ? _.buffer.head.data.length : _.length : (P > _.highWaterMark && (_.highWaterMark = u(P)), P <= _.length ? P : _.ended ? _.length : (_.needReadable = !0, 0));
  }
  U.prototype.read = function(P) {
    p("read", P), P = parseInt(P, 10);
    var _ = this._readableState, X = P;
    if (P !== 0 && (_.emittedReadable = !1), P === 0 && _.needReadable && ((_.highWaterMark !== 0 ? _.length >= _.highWaterMark : _.length > 0) || _.ended))
      return p("read: emitReadable", _.length, _.ended), _.length === 0 && _.ended ? Q(this) : A(this), null;
    if (P = g(P, _), P === 0 && _.ended)
      return _.length === 0 && Q(this), null;
    var le = _.needReadable;
    p("need readable", le), (_.length === 0 || _.length - P < _.highWaterMark) && (le = !0, p("length less than watermark", le)), _.ended || _.reading ? (le = !1, p("reading or ended", le)) : le && (p("do read"), _.reading = !0, _.sync = !0, _.length === 0 && (_.needReadable = !0), this._read(_.highWaterMark), _.sync = !1, _.reading || (P = g(X, _)));
    var ie;
    return P > 0 ? ie = R(P, _) : ie = null, ie === null ? (_.needReadable = _.length <= _.highWaterMark, P = 0) : (_.length -= P, _.awaitDrain = 0), _.length === 0 && (_.ended || (_.needReadable = !0), X !== P && _.ended && Q(this)), ie !== null && this.emit("data", ie), ie;
  };
  function v(P, _) {
    if (p("onEofChunk"), !_.ended) {
      if (_.decoder) {
        var X = _.decoder.end();
        X && X.length && (_.buffer.push(X), _.length += _.objectMode ? 1 : X.length);
      }
      _.ended = !0, _.sync ? A(P) : (_.needReadable = !1, _.emittedReadable || (_.emittedReadable = !0, L(P)));
    }
  }
  function A(P) {
    var _ = P._readableState;
    p("emitReadable", _.needReadable, _.emittedReadable), _.needReadable = !1, _.emittedReadable || (p("emitReadable", _.flowing), _.emittedReadable = !0, fe.process.nextTick(L, P));
  }
  function L(P) {
    var _ = P._readableState;
    p("emitReadable_", _.destroyed, _.length, _.ended), !_.destroyed && (_.length || _.ended) && (P.emit("readable"), _.emittedReadable = !1), _.needReadable = !_.flowing && !_.ended && _.length <= _.highWaterMark, q(P);
  }
  function m(P, _) {
    _.readingMore || (_.readingMore = !0, fe.process.nextTick(a, P, _));
  }
  function a(P, _) {
    for (; !_.reading && !_.ended && (_.length < _.highWaterMark || _.flowing && _.length === 0); ) {
      var X = _.length;
      if (p("maybeReadMore read 0"), P.read(0), X === _.length)
        break;
    }
    _.readingMore = !1;
  }
  U.prototype._read = function(P) {
    z(this, new S("_read()"));
  }, U.prototype.pipe = function(P, _) {
    var X = this, le = this._readableState;
    switch (le.pipesCount) {
      case 0:
        le.pipes = P;
        break;
      case 1:
        le.pipes = [le.pipes, P];
        break;
      default:
        le.pipes.push(P);
        break;
    }
    le.pipesCount += 1, p("pipe count=%d opts=%j", le.pipesCount, _);
    var ie = (!_ || _.end !== !1) && P !== fe.process.stdout && P !== fe.process.stderr, oe = ie ? se : at;
    le.endEmitted ? fe.process.nextTick(oe) : X.once("end", oe), P.on("unpipe", pe);
    function pe(Ne, Ae) {
      p("onunpipe"), Ne === X && Ae && Ae.hasUnpiped === !1 && (Ae.hasUnpiped = !0, de());
    }
    function se() {
      p("onend"), P.end();
    }
    var ce = x(X);
    P.on("drain", ce);
    var me = !1;
    function de() {
      p("cleanup"), P.removeListener("close", ye), P.removeListener("finish", Me), P.removeListener("drain", ce), P.removeListener("error", Le), P.removeListener("unpipe", pe), X.removeListener("end", se), X.removeListener("end", at), X.removeListener("data", ae), me = !0, le.awaitDrain && (!P._writableState || P._writableState.needDrain) && ce();
    }
    X.on("data", ae);
    function ae(Ne) {
      p("ondata");
      var Ae = P.write(Ne);
      p("dest.write", Ae), Ae === !1 && ((le.pipesCount === 1 && le.pipes === P || le.pipesCount > 1 && F(le.pipes, P) !== -1) && !me && (p("false write response, pause", le.awaitDrain), le.awaitDrain++), X.pause());
    }
    function Le(Ne) {
      p("onerror", Ne), at(), P.removeListener("error", Le), t(P, "error") === 0 && z(P, Ne);
    }
    H(P, "error", Le);
    function ye() {
      P.removeListener("finish", Me), at();
    }
    P.once("close", ye);
    function Me() {
      p("onfinish"), P.removeListener("close", ye), at();
    }
    P.once("finish", Me);
    function at() {
      p("unpipe"), X.unpipe(P);
    }
    return P.emit("pipe", X), le.flowing || (p("pipe resume"), X.resume()), P;
  };
  function x(P) {
    return function() {
      var X = P._readableState;
      p("pipeOnDrain", X.awaitDrain), X.awaitDrain && X.awaitDrain--, X.awaitDrain === 0 && t(P, "data") && (X.flowing = !0, q(P));
    };
  }
  U.prototype.unpipe = function(P) {
    var _ = this._readableState, X = {
      hasUnpiped: !1
    };
    if (_.pipesCount === 0) return this;
    if (_.pipesCount === 1)
      return P && P !== _.pipes ? this : (P || (P = _.pipes), _.pipes = null, _.pipesCount = 0, _.flowing = !1, P && P.emit("unpipe", this, X), this);
    if (!P) {
      var le = _.pipes, ie = _.pipesCount;
      _.pipes = null, _.pipesCount = 0, _.flowing = !1;
      for (var oe = 0; oe < ie; oe++) le[oe].emit("unpipe", this, {
        hasUnpiped: !1
      });
      return this;
    }
    var pe = F(_.pipes, P);
    return pe === -1 ? this : (_.pipes.splice(pe, 1), _.pipesCount -= 1, _.pipesCount === 1 && (_.pipes = _.pipes[0]), P.emit("unpipe", this, X), this);
  }, U.prototype.on = function(P, _) {
    var X = o.prototype.on.call(this, P, _), le = this._readableState;
    return P === "data" ? (le.readableListening = this.listenerCount("readable") > 0, le.flowing !== !1 && this.resume()) : P === "readable" && !le.endEmitted && !le.readableListening && (le.readableListening = le.needReadable = !0, le.flowing = !1, le.emittedReadable = !1, p("on readable", le.length, le.reading), le.length ? A(this) : le.reading || fe.process.nextTick(G, this)), X;
  }, U.prototype.addListener = U.prototype.on, U.prototype.removeListener = function(P, _) {
    var X = o.prototype.removeListener.call(this, P, _);
    return P === "readable" && fe.process.nextTick(V, this), X;
  }, U.prototype.removeAllListeners = function(P) {
    var _ = o.prototype.removeAllListeners.apply(this, arguments);
    return (P === "readable" || P === void 0) && fe.process.nextTick(V, this), _;
  };
  function V(P) {
    var _ = P._readableState;
    _.readableListening = P.listenerCount("readable") > 0, _.resumeScheduled && !_.paused ? _.flowing = !0 : P.listenerCount("data") > 0 && P.resume();
  }
  function G(P) {
    p("readable nexttick read 0"), P.read(0);
  }
  U.prototype.resume = function() {
    var P = this._readableState;
    return P.flowing || (p("resume"), P.flowing = !P.readableListening, Z(this, P)), P.paused = !1, this;
  };
  function Z(P, _) {
    _.resumeScheduled || (_.resumeScheduled = !0, fe.process.nextTick(te, P, _));
  }
  function te(P, _) {
    p("resume", _.reading), _.reading || P.read(0), _.resumeScheduled = !1, P.emit("resume"), q(P), _.flowing && !_.reading && P.read(0);
  }
  U.prototype.pause = function() {
    return p("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (p("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function q(P) {
    var _ = P._readableState;
    for (p("flow", _.flowing); _.flowing && P.read() !== null; ) ;
  }
  U.prototype.wrap = function(P) {
    var _ = this, X = this._readableState, le = !1;
    P.on("end", function() {
      if (p("wrapped end"), X.decoder && !X.ended) {
        var pe = X.decoder.end();
        pe && pe.length && _.push(pe);
      }
      _.push(null);
    }), P.on("data", function(pe) {
      if (p("wrapped data"), X.decoder && (pe = X.decoder.write(pe)), !(X.objectMode && pe == null) && !(!X.objectMode && (!pe || !pe.length))) {
        var se = _.push(pe);
        se || (le = !0, P.pause());
      }
    });
    for (var ie in P)
      this[ie] === void 0 && typeof P[ie] == "function" && (this[ie] = /* @__PURE__ */ function(se) {
        return function() {
          return P[se].apply(P, arguments);
        };
      }(ie));
    for (var oe = 0; oe < k.length; oe++)
      P.on(k[oe], this.emit.bind(this, k[oe]));
    return this._read = function(pe) {
      p("wrapped _read", pe), le && (le = !1, P.resume());
    }, this;
  }, typeof Symbol == "function" && (U.prototype[Symbol.asyncIterator] = function() {
    return j === void 0 && (j = NC()), j(this);
  }), Object.defineProperty(U.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(U.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(U.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(_) {
      this._readableState && (this._readableState.flowing = _);
    }
  }), U._fromList = R, Object.defineProperty(U.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function R(P, _) {
    if (_.length === 0) return null;
    var X;
    return _.objectMode ? X = _.buffer.shift() : !P || P >= _.length ? (_.decoder ? X = _.buffer.join("") : _.buffer.length === 1 ? X = _.buffer.first() : X = _.buffer.concat(_.length), _.buffer.clear()) : X = _.buffer.consume(P, _.decoder), X;
  }
  function Q(P) {
    var _ = P._readableState;
    p("endReadable", _.endEmitted), _.endEmitted || (_.ended = !0, fe.process.nextTick($, _, P));
  }
  function $(P, _) {
    if (p("endReadableNT", P.endEmitted, P.length), !P.endEmitted && P.length === 0 && (P.endEmitted = !0, _.readable = !1, _.emit("end"), P.autoDestroy)) {
      var X = _._writableState;
      (!X || X.autoDestroy && X.finished) && _.destroy();
    }
  }
  typeof Symbol == "function" && (U.from = function(P, _) {
    return O === void 0 && (O = AC()), O(U, P, _);
  });
  function F(P, _) {
    for (var X = 0, le = P.length; X < le; X++)
      if (P[X] === _) return X;
    return -1;
  }
  return sf;
}
var cf, m4;
function Sy() {
  if (m4) return cf;
  m4 = 1, cf = f;
  var e = Aa().codes, t = e.ERR_METHOD_NOT_IMPLEMENTED, o = e.ERR_MULTIPLE_CALLBACK, i = e.ERR_TRANSFORM_ALREADY_TRANSFORMING, c = e.ERR_TRANSFORM_WITH_LENGTH_0, n = fa();
  Yt(f, n);
  function d(h, y) {
    var M = this._transformState;
    M.transforming = !1;
    var C = M.writecb;
    if (C === null)
      return this.emit("error", new o());
    M.writechunk = null, M.writecb = null, y != null && this.push(y), C(h);
    var N = this._readableState;
    N.reading = !1, (N.needReadable || N.length < N.highWaterMark) && this._read(N.highWaterMark);
  }
  function f(h) {
    if (!(this instanceof f)) return new f(h);
    n.call(this, h), this._transformState = {
      afterTransform: d.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, h && (typeof h.transform == "function" && (this._transform = h.transform), typeof h.flush == "function" && (this._flush = h.flush)), this.on("prefinish", p);
  }
  function p() {
    var h = this;
    typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(y, M) {
      l(h, y, M);
    }) : l(this, null, null);
  }
  f.prototype.push = function(h, y) {
    return this._transformState.needTransform = !1, n.prototype.push.call(this, h, y);
  }, f.prototype._transform = function(h, y, M) {
    M(new t("_transform()"));
  }, f.prototype._write = function(h, y, M) {
    var C = this._transformState;
    if (C.writecb = M, C.writechunk = h, C.writeencoding = y, !C.transforming) {
      var N = this._readableState;
      (C.needTransform || N.needReadable || N.length < N.highWaterMark) && this._read(N.highWaterMark);
    }
  }, f.prototype._read = function(h) {
    var y = this._transformState;
    y.writechunk !== null && !y.transforming ? (y.transforming = !0, this._transform(y.writechunk, y.writeencoding, y.afterTransform)) : y.needTransform = !0;
  }, f.prototype._destroy = function(h, y) {
    n.prototype._destroy.call(this, h, function(M) {
      y(M);
    });
  };
  function l(h, y, M) {
    if (y) return h.emit("error", y);
    if (M != null && h.push(M), h._writableState.length) throw new c();
    if (h._transformState.transforming) throw new i();
    return h.push(null);
  }
  return cf;
}
var lf, v4;
function TC() {
  if (v4) return lf;
  v4 = 1, lf = t;
  var e = Sy();
  Yt(t, e);
  function t(o) {
    if (!(this instanceof t)) return new t(o);
    e.call(this, o);
  }
  return t.prototype._transform = function(o, i, c) {
    c(null, o);
  }, lf;
}
var ff, b4;
function LC() {
  if (b4) return ff;
  b4 = 1;
  var e;
  function t(M) {
    var C = !1;
    return function() {
      C || (C = !0, M.apply(void 0, arguments));
    };
  }
  var o = Aa().codes, i = o.ERR_MISSING_ARGS, c = o.ERR_STREAM_DESTROYED;
  function n(M) {
    if (M) throw M;
  }
  function d(M) {
    return M.setHeader && typeof M.abort == "function";
  }
  function f(M, C, N, w) {
    w = t(w);
    var S = !1;
    M.on("close", function() {
      S = !0;
    }), e === void 0 && (e = ch()), e(M, {
      readable: C,
      writable: N
    }, function(E) {
      if (E) return w(E);
      S = !0, w();
    });
    var T = !1;
    return function(E) {
      if (!S && !T) {
        if (T = !0, d(M)) return M.abort();
        if (typeof M.destroy == "function") return M.destroy();
        w(E || new c("pipe"));
      }
    };
  }
  function p(M) {
    M();
  }
  function l(M, C) {
    return M.pipe(C);
  }
  function h(M) {
    return !M.length || typeof M[M.length - 1] != "function" ? n : M.pop();
  }
  function y() {
    for (var M = arguments.length, C = new Array(M), N = 0; N < M; N++)
      C[N] = arguments[N];
    var w = h(C);
    if (Array.isArray(C[0]) && (C = C[0]), C.length < 2)
      throw new i("streams");
    var S, T = C.map(function(E, j) {
      var O = j < C.length - 1, z = j > 0;
      return f(E, O, z, function(k) {
        S || (S = k), k && T.forEach(p), !O && (T.forEach(p), w(S));
      });
    });
    return C.reduce(l);
  }
  return ff = y, ff;
}
var Wc = Pn, lh = Na.EventEmitter, SC = Yt;
SC(Pn, lh);
Pn.Readable = Ly();
Pn.Writable = Ty();
Pn.Duplex = fa();
Pn.Transform = Sy();
Pn.PassThrough = TC();
Pn.finished = ch();
Pn.pipeline = LC();
Pn.Stream = Pn;
function Pn() {
  lh.call(this);
}
Pn.prototype.pipe = function(e, t) {
  var o = this;
  function i(h) {
    e.writable && e.write(h) === !1 && o.pause && o.pause();
  }
  o.on("data", i);
  function c() {
    o.readable && o.resume && o.resume();
  }
  e.on("drain", c), !e._isStdio && (!t || t.end !== !1) && (o.on("end", d), o.on("close", f));
  var n = !1;
  function d() {
    n || (n = !0, e.end());
  }
  function f() {
    n || (n = !0, typeof e.destroy == "function" && e.destroy());
  }
  function p(h) {
    if (l(), lh.listenerCount(this, "error") === 0)
      throw h;
  }
  o.on("error", p), e.on("error", p);
  function l() {
    o.removeListener("data", i), e.removeListener("drain", c), o.removeListener("end", d), o.removeListener("close", f), o.removeListener("error", p), e.removeListener("error", p), o.removeListener("end", l), o.removeListener("close", l), e.removeListener("close", l);
  }
  return o.on("end", l), o.on("close", l), e.on("close", l), e.emit("pipe", o), e;
};
const LR = /* @__PURE__ */ Yi(Wc);
var uf, x4;
function Ey() {
  if (x4) return uf;
  x4 = 1;
  var e = Gt.Buffer, t = Wc.Transform, o = Yt;
  function i(f) {
    t.call(this), this._block = e.allocUnsafe(f), this._blockSize = f, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  o(i, t), i.prototype._transform = function(f, p, l) {
    var h = null;
    try {
      this.update(f, p);
    } catch (y) {
      h = y;
    }
    l(h);
  }, i.prototype._flush = function(f) {
    var p = null;
    try {
      this.push(this.digest());
    } catch (l) {
      p = l;
    }
    f(p);
  };
  var c = typeof Uint8Array < "u", n = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && ArrayBuffer.isView && (e.prototype instanceof Uint8Array || e.TYPED_ARRAY_SUPPORT);
  function d(f, p) {
    if (f instanceof e) return f;
    if (typeof f == "string") return e.from(f, p);
    if (n && ArrayBuffer.isView(f)) {
      if (f.byteLength === 0) return e.alloc(0);
      var l = e.from(f.buffer, f.byteOffset, f.byteLength);
      if (l.byteLength === f.byteLength) return l;
    }
    if (c && f instanceof Uint8Array || e.isBuffer(f) && f.constructor && typeof f.constructor.isBuffer == "function" && f.constructor.isBuffer(f))
      return e.from(f);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
  }
  return i.prototype.update = function(f, p) {
    if (this._finalized) throw new Error("Digest already called");
    f = d(f, p);
    for (var l = this._block, h = 0; this._blockOffset + f.length - h >= this._blockSize; ) {
      for (var y = this._blockOffset; y < this._blockSize; ) l[y++] = f[h++];
      this._update(), this._blockOffset = 0;
    }
    for (; h < f.length; ) l[this._blockOffset++] = f[h++];
    for (var M = 0, C = f.length * 8; C > 0; ++M)
      this._length[M] += C, C = this._length[M] / 4294967296 | 0, C > 0 && (this._length[M] -= 4294967296 * C);
    return this;
  }, i.prototype._update = function() {
    throw new Error("_update is not implemented");
  }, i.prototype.digest = function(f) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = !0;
    var p = this._digest();
    f !== void 0 && (p = p.toString(f)), this._block.fill(0), this._blockOffset = 0;
    for (var l = 0; l < 4; ++l) this._length[l] = 0;
    return p;
  }, i.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, uf = i, uf;
}
var df, w4;
function fh() {
  if (w4) return df;
  w4 = 1;
  var e = Yt, t = Ey(), o = Gt.Buffer, i = new Array(16);
  function c() {
    t.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
  }
  e(c, t), c.prototype._update = function() {
    for (var h = i, y = 0; y < 16; ++y) h[y] = this._block.readInt32LE(y * 4);
    var M = this._a, C = this._b, N = this._c, w = this._d;
    M = d(M, C, N, w, h[0], 3614090360, 7), w = d(w, M, C, N, h[1], 3905402710, 12), N = d(N, w, M, C, h[2], 606105819, 17), C = d(C, N, w, M, h[3], 3250441966, 22), M = d(M, C, N, w, h[4], 4118548399, 7), w = d(w, M, C, N, h[5], 1200080426, 12), N = d(N, w, M, C, h[6], 2821735955, 17), C = d(C, N, w, M, h[7], 4249261313, 22), M = d(M, C, N, w, h[8], 1770035416, 7), w = d(w, M, C, N, h[9], 2336552879, 12), N = d(N, w, M, C, h[10], 4294925233, 17), C = d(C, N, w, M, h[11], 2304563134, 22), M = d(M, C, N, w, h[12], 1804603682, 7), w = d(w, M, C, N, h[13], 4254626195, 12), N = d(N, w, M, C, h[14], 2792965006, 17), C = d(C, N, w, M, h[15], 1236535329, 22), M = f(M, C, N, w, h[1], 4129170786, 5), w = f(w, M, C, N, h[6], 3225465664, 9), N = f(N, w, M, C, h[11], 643717713, 14), C = f(C, N, w, M, h[0], 3921069994, 20), M = f(M, C, N, w, h[5], 3593408605, 5), w = f(w, M, C, N, h[10], 38016083, 9), N = f(N, w, M, C, h[15], 3634488961, 14), C = f(C, N, w, M, h[4], 3889429448, 20), M = f(M, C, N, w, h[9], 568446438, 5), w = f(w, M, C, N, h[14], 3275163606, 9), N = f(N, w, M, C, h[3], 4107603335, 14), C = f(C, N, w, M, h[8], 1163531501, 20), M = f(M, C, N, w, h[13], 2850285829, 5), w = f(w, M, C, N, h[2], 4243563512, 9), N = f(N, w, M, C, h[7], 1735328473, 14), C = f(C, N, w, M, h[12], 2368359562, 20), M = p(M, C, N, w, h[5], 4294588738, 4), w = p(w, M, C, N, h[8], 2272392833, 11), N = p(N, w, M, C, h[11], 1839030562, 16), C = p(C, N, w, M, h[14], 4259657740, 23), M = p(M, C, N, w, h[1], 2763975236, 4), w = p(w, M, C, N, h[4], 1272893353, 11), N = p(N, w, M, C, h[7], 4139469664, 16), C = p(C, N, w, M, h[10], 3200236656, 23), M = p(M, C, N, w, h[13], 681279174, 4), w = p(w, M, C, N, h[0], 3936430074, 11), N = p(N, w, M, C, h[3], 3572445317, 16), C = p(C, N, w, M, h[6], 76029189, 23), M = p(M, C, N, w, h[9], 3654602809, 4), w = p(w, M, C, N, h[12], 3873151461, 11), N = p(N, w, M, C, h[15], 530742520, 16), C = p(C, N, w, M, h[2], 3299628645, 23), M = l(M, C, N, w, h[0], 4096336452, 6), w = l(w, M, C, N, h[7], 1126891415, 10), N = l(N, w, M, C, h[14], 2878612391, 15), C = l(C, N, w, M, h[5], 4237533241, 21), M = l(M, C, N, w, h[12], 1700485571, 6), w = l(w, M, C, N, h[3], 2399980690, 10), N = l(N, w, M, C, h[10], 4293915773, 15), C = l(C, N, w, M, h[1], 2240044497, 21), M = l(M, C, N, w, h[8], 1873313359, 6), w = l(w, M, C, N, h[15], 4264355552, 10), N = l(N, w, M, C, h[6], 2734768916, 15), C = l(C, N, w, M, h[13], 1309151649, 21), M = l(M, C, N, w, h[4], 4149444226, 6), w = l(w, M, C, N, h[11], 3174756917, 10), N = l(N, w, M, C, h[2], 718787259, 15), C = l(C, N, w, M, h[9], 3951481745, 21), this._a = this._a + M | 0, this._b = this._b + C | 0, this._c = this._c + N | 0, this._d = this._d + w | 0;
  }, c.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var h = o.allocUnsafe(16);
    return h.writeInt32LE(this._a, 0), h.writeInt32LE(this._b, 4), h.writeInt32LE(this._c, 8), h.writeInt32LE(this._d, 12), h;
  };
  function n(h, y) {
    return h << y | h >>> 32 - y;
  }
  function d(h, y, M, C, N, w, S) {
    return n(h + (y & M | ~y & C) + N + w | 0, S) + y | 0;
  }
  function f(h, y, M, C, N, w, S) {
    return n(h + (y & C | M & ~C) + N + w | 0, S) + y | 0;
  }
  function p(h, y, M, C, N, w, S) {
    return n(h + (y ^ M ^ C) + N + w | 0, S) + y | 0;
  }
  function l(h, y, M, C, N, w, S) {
    return n(h + (M ^ (y | ~C)) + N + w | 0, S) + y | 0;
  }
  return df = c, df;
}
var hf, C4;
function Dy() {
  if (C4) return hf;
  C4 = 1;
  var e = Wr.Buffer, t = Yt, o = Ey(), i = new Array(16), c = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], n = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], d = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], f = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ], p = [0, 1518500249, 1859775393, 2400959708, 2840853838], l = [1352829926, 1548603684, 1836072691, 2053994217, 0];
  function h() {
    o.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  t(h, o), h.prototype._update = function() {
    for (var T = i, E = 0; E < 16; ++E) T[E] = this._block.readInt32LE(E * 4);
    for (var j = this._a | 0, O = this._b | 0, z = this._c | 0, k = this._d | 0, H = this._e | 0, W = this._a | 0, U = this._b | 0, B = this._c | 0, I = this._d | 0, r = this._e | 0, s = 0; s < 80; s += 1) {
      var u, g;
      s < 16 ? (u = M(j, O, z, k, H, T[c[s]], p[0], d[s]), g = S(W, U, B, I, r, T[n[s]], l[0], f[s])) : s < 32 ? (u = C(j, O, z, k, H, T[c[s]], p[1], d[s]), g = w(W, U, B, I, r, T[n[s]], l[1], f[s])) : s < 48 ? (u = N(j, O, z, k, H, T[c[s]], p[2], d[s]), g = N(W, U, B, I, r, T[n[s]], l[2], f[s])) : s < 64 ? (u = w(j, O, z, k, H, T[c[s]], p[3], d[s]), g = C(W, U, B, I, r, T[n[s]], l[3], f[s])) : (u = S(j, O, z, k, H, T[c[s]], p[4], d[s]), g = M(W, U, B, I, r, T[n[s]], l[4], f[s])), j = H, H = k, k = y(z, 10), z = O, O = u, W = r, r = I, I = y(B, 10), B = U, U = g;
    }
    var v = this._b + z + I | 0;
    this._b = this._c + k + r | 0, this._c = this._d + H + W | 0, this._d = this._e + j + U | 0, this._e = this._a + O + B | 0, this._a = v;
  }, h.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var T = e.alloc ? e.alloc(20) : new e(20);
    return T.writeInt32LE(this._a, 0), T.writeInt32LE(this._b, 4), T.writeInt32LE(this._c, 8), T.writeInt32LE(this._d, 12), T.writeInt32LE(this._e, 16), T;
  };
  function y(T, E) {
    return T << E | T >>> 32 - E;
  }
  function M(T, E, j, O, z, k, H, W) {
    return y(T + (E ^ j ^ O) + k + H | 0, W) + z | 0;
  }
  function C(T, E, j, O, z, k, H, W) {
    return y(T + (E & j | ~E & O) + k + H | 0, W) + z | 0;
  }
  function N(T, E, j, O, z, k, H, W) {
    return y(T + ((E | ~j) ^ O) + k + H | 0, W) + z | 0;
  }
  function w(T, E, j, O, z, k, H, W) {
    return y(T + (E & O | j & ~O) + k + H | 0, W) + z | 0;
  }
  function S(T, E, j, O, z, k, H, W) {
    return y(T + (E ^ (j | ~O)) + k + H | 0, W) + z | 0;
  }
  return hf = h, hf;
}
var pf = { exports: {} }, gf, I4;
function EC() {
  if (I4) return gf;
  I4 = 1;
  var e = {}.toString;
  return gf = Array.isArray || function(t) {
    return e.call(t) == "[object Array]";
  }, gf;
}
var js = TypeError, jy = Object, DC = Error, jC = EvalError, OC = RangeError, zC = ReferenceError, Oy = SyntaxError, kC = URIError, _C = Math.abs, BC = Math.floor, FC = Math.max, RC = Math.min, PC = Math.pow, UC = Math.round, YC = Number.isNaN || function(t) {
  return t !== t;
}, WC = YC, HC = function(t) {
  return WC(t) || t === 0 ? t : t < 0 ? -1 : 1;
}, ZC = Object.getOwnPropertyDescriptor, B0 = ZC;
if (B0)
  try {
    B0([], "length");
  } catch {
    B0 = null;
  }
var Os = B0, F0 = Object.defineProperty || !1;
if (F0)
  try {
    F0({}, "a", { value: 1 });
  } catch {
    F0 = !1;
  }
var Hc = F0, zy = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var t = {}, o = Symbol("test"), i = Object(o);
  if (typeof o == "string" || Object.prototype.toString.call(o) !== "[object Symbol]" || Object.prototype.toString.call(i) !== "[object Symbol]")
    return !1;
  var c = 42;
  t[o] = c;
  for (var n in t)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
    return !1;
  var d = Object.getOwnPropertySymbols(t);
  if (d.length !== 1 || d[0] !== o || !Object.prototype.propertyIsEnumerable.call(t, o))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var f = (
      /** @type {PropertyDescriptor} */
      Object.getOwnPropertyDescriptor(t, o)
    );
    if (f.value !== c || f.enumerable !== !0)
      return !1;
  }
  return !0;
}, yf, N4;
function QC() {
  if (N4) return yf;
  N4 = 1;
  var e = typeof Symbol < "u" && Symbol, t = zy;
  return yf = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, yf;
}
var ky = typeof Reflect < "u" && Reflect.getPrototypeOf || null, VC = jy, _y = VC.getPrototypeOf || null, Mf, A4;
function GC() {
  if (A4) return Mf;
  A4 = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, o = Math.max, i = "[object Function]", c = function(p, l) {
    for (var h = [], y = 0; y < p.length; y += 1)
      h[y] = p[y];
    for (var M = 0; M < l.length; M += 1)
      h[M + p.length] = l[M];
    return h;
  }, n = function(p, l) {
    for (var h = [], y = l, M = 0; y < p.length; y += 1, M += 1)
      h[M] = p[y];
    return h;
  }, d = function(f, p) {
    for (var l = "", h = 0; h < f.length; h += 1)
      l += f[h], h + 1 < f.length && (l += p);
    return l;
  };
  return Mf = function(p) {
    var l = this;
    if (typeof l != "function" || t.apply(l) !== i)
      throw new TypeError(e + l);
    for (var h = n(arguments, 1), y, M = function() {
      if (this instanceof y) {
        var T = l.apply(
          this,
          c(h, arguments)
        );
        return Object(T) === T ? T : this;
      }
      return l.apply(
        p,
        c(h, arguments)
      );
    }, C = o(0, l.length - h.length), N = [], w = 0; w < C; w++)
      N[w] = "$" + w;
    if (y = Function("binder", "return function (" + d(N, ",") + "){ return binder.apply(this,arguments); }")(M), l.prototype) {
      var S = function() {
      };
      S.prototype = l.prototype, y.prototype = new S(), S.prototype = null;
    }
    return y;
  }, Mf;
}
var mf, T4;
function zs() {
  if (T4) return mf;
  T4 = 1;
  var e = GC();
  return mf = Function.prototype.bind || e, mf;
}
var vf, L4;
function uh() {
  return L4 || (L4 = 1, vf = Function.prototype.call), vf;
}
var bf, S4;
function dh() {
  return S4 || (S4 = 1, bf = Function.prototype.apply), bf;
}
var $C = typeof Reflect < "u" && Reflect && Reflect.apply, qC = zs(), JC = dh(), XC = uh(), KC = $C, By = KC || qC.call(XC, JC), eI = zs(), tI = js, rI = uh(), nI = By, hh = function(t) {
  if (t.length < 1 || typeof t[0] != "function")
    throw new tI("a function is required");
  return nI(eI, rI, t);
}, iI = hh, E4 = Os, Fy;
try {
  Fy = /** @type {{ __proto__?: typeof Array.prototype }} */
  [].__proto__ === Array.prototype;
} catch (e) {
  if (!e || typeof e != "object" || !("code" in e) || e.code !== "ERR_PROTO_ACCESS")
    throw e;
}
var xf = !!Fy && E4 && E4(
  Object.prototype,
  /** @type {keyof typeof Object.prototype} */
  "__proto__"
), Ry = Object, D4 = Ry.getPrototypeOf, oI = xf && typeof xf.get == "function" ? iI([xf.get]) : typeof D4 == "function" ? (
  /** @type {import('./get')} */
  function(t) {
    return D4(t == null ? t : Ry(t));
  }
) : !1, j4 = ky, O4 = _y, z4 = oI, Py = j4 ? function(t) {
  return j4(t);
} : O4 ? function(t) {
  if (!t || typeof t != "object" && typeof t != "function")
    throw new TypeError("getProto: not an object");
  return O4(t);
} : z4 ? function(t) {
  return z4(t);
} : null, wf, k4;
function aI() {
  if (k4) return wf;
  k4 = 1;
  var e = Function.prototype.call, t = Object.prototype.hasOwnProperty, o = zs();
  return wf = o.call(e, t), wf;
}
var Kt, sI = jy, cI = DC, lI = jC, fI = OC, uI = zC, ua = Oy, na = js, dI = kC, hI = _C, pI = BC, gI = FC, yI = RC, MI = PC, mI = UC, vI = HC, Uy = Function, Cf = function(e) {
  try {
    return Uy('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, us = Os, bI = Hc, If = function() {
  throw new na();
}, xI = us ? function() {
  try {
    return arguments.callee, If;
  } catch {
    try {
      return us(arguments, "callee").get;
    } catch {
      return If;
    }
  }
}() : If, Ho = QC()(), Zr = Py, wI = _y, CI = ky, Yy = dh(), ks = uh(), Go = {}, II = typeof Uint8Array > "u" || !Zr ? Kt : Zr(Uint8Array), vo = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? Kt : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? Kt : ArrayBuffer,
  "%ArrayIteratorPrototype%": Ho && Zr ? Zr([][Symbol.iterator]()) : Kt,
  "%AsyncFromSyncIteratorPrototype%": Kt,
  "%AsyncFunction%": Go,
  "%AsyncGenerator%": Go,
  "%AsyncGeneratorFunction%": Go,
  "%AsyncIteratorPrototype%": Go,
  "%Atomics%": typeof Atomics > "u" ? Kt : Atomics,
  "%BigInt%": typeof BigInt > "u" ? Kt : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? Kt : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? Kt : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? Kt : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": cI,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": lI,
  "%Float16Array%": typeof Float16Array > "u" ? Kt : Float16Array,
  "%Float32Array%": typeof Float32Array > "u" ? Kt : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? Kt : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? Kt : FinalizationRegistry,
  "%Function%": Uy,
  "%GeneratorFunction%": Go,
  "%Int8Array%": typeof Int8Array > "u" ? Kt : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? Kt : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? Kt : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": Ho && Zr ? Zr(Zr([][Symbol.iterator]())) : Kt,
  "%JSON%": typeof JSON == "object" ? JSON : Kt,
  "%Map%": typeof Map > "u" ? Kt : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !Ho || !Zr ? Kt : Zr((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": sI,
  "%Object.getOwnPropertyDescriptor%": us,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? Kt : Promise,
  "%Proxy%": typeof Proxy > "u" ? Kt : Proxy,
  "%RangeError%": fI,
  "%ReferenceError%": uI,
  "%Reflect%": typeof Reflect > "u" ? Kt : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? Kt : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !Ho || !Zr ? Kt : Zr((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? Kt : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": Ho && Zr ? Zr(""[Symbol.iterator]()) : Kt,
  "%Symbol%": Ho ? Symbol : Kt,
  "%SyntaxError%": ua,
  "%ThrowTypeError%": xI,
  "%TypedArray%": II,
  "%TypeError%": na,
  "%Uint8Array%": typeof Uint8Array > "u" ? Kt : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? Kt : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? Kt : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? Kt : Uint32Array,
  "%URIError%": dI,
  "%WeakMap%": typeof WeakMap > "u" ? Kt : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? Kt : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? Kt : WeakSet,
  "%Function.prototype.call%": ks,
  "%Function.prototype.apply%": Yy,
  "%Object.defineProperty%": bI,
  "%Object.getPrototypeOf%": wI,
  "%Math.abs%": hI,
  "%Math.floor%": pI,
  "%Math.max%": gI,
  "%Math.min%": yI,
  "%Math.pow%": MI,
  "%Math.round%": mI,
  "%Math.sign%": vI,
  "%Reflect.getPrototypeOf%": CI
};
if (Zr)
  try {
    null.error;
  } catch (e) {
    var NI = Zr(Zr(e));
    vo["%Error.prototype%"] = NI;
  }
var AI = function e(t) {
  var o;
  if (t === "%AsyncFunction%")
    o = Cf("async function () {}");
  else if (t === "%GeneratorFunction%")
    o = Cf("function* () {}");
  else if (t === "%AsyncGeneratorFunction%")
    o = Cf("async function* () {}");
  else if (t === "%AsyncGenerator%") {
    var i = e("%AsyncGeneratorFunction%");
    i && (o = i.prototype);
  } else if (t === "%AsyncIteratorPrototype%") {
    var c = e("%AsyncGenerator%");
    c && Zr && (o = Zr(c.prototype));
  }
  return vo[t] = o, o;
}, _4 = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, _s = zs(), nc = aI(), TI = _s.call(ks, Array.prototype.concat), LI = _s.call(Yy, Array.prototype.splice), B4 = _s.call(ks, String.prototype.replace), ic = _s.call(ks, String.prototype.slice), SI = _s.call(ks, RegExp.prototype.exec), EI = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, DI = /\\(\\)?/g, jI = function(t) {
  var o = ic(t, 0, 1), i = ic(t, -1);
  if (o === "%" && i !== "%")
    throw new ua("invalid intrinsic syntax, expected closing `%`");
  if (i === "%" && o !== "%")
    throw new ua("invalid intrinsic syntax, expected opening `%`");
  var c = [];
  return B4(t, EI, function(n, d, f, p) {
    c[c.length] = f ? B4(p, DI, "$1") : d || n;
  }), c;
}, OI = function(t, o) {
  var i = t, c;
  if (nc(_4, i) && (c = _4[i], i = "%" + c[0] + "%"), nc(vo, i)) {
    var n = vo[i];
    if (n === Go && (n = AI(i)), typeof n > "u" && !o)
      throw new na("intrinsic " + t + " exists, but is not available. Please file an issue!");
    return {
      alias: c,
      name: i,
      value: n
    };
  }
  throw new ua("intrinsic " + t + " does not exist!");
}, Wy = function(t, o) {
  if (typeof t != "string" || t.length === 0)
    throw new na("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof o != "boolean")
    throw new na('"allowMissing" argument must be a boolean');
  if (SI(/^%?[^%]*%?$/, t) === null)
    throw new ua("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var i = jI(t), c = i.length > 0 ? i[0] : "", n = OI("%" + c + "%", o), d = n.name, f = n.value, p = !1, l = n.alias;
  l && (c = l[0], LI(i, TI([0, 1], l)));
  for (var h = 1, y = !0; h < i.length; h += 1) {
    var M = i[h], C = ic(M, 0, 1), N = ic(M, -1);
    if ((C === '"' || C === "'" || C === "`" || N === '"' || N === "'" || N === "`") && C !== N)
      throw new ua("property names with quotes must have matching quotes");
    if ((M === "constructor" || !y) && (p = !0), c += "." + M, d = "%" + c + "%", nc(vo, d))
      f = vo[d];
    else if (f != null) {
      if (!(M in f)) {
        if (!o)
          throw new na("base intrinsic for " + t + " exists, but the property is not available.");
        return;
      }
      if (us && h + 1 >= i.length) {
        var w = us(f, M);
        y = !!w, y && "get" in w && !("originalValue" in w.get) ? f = w.get : f = f[M];
      } else
        y = nc(f, M), f = f[M];
      y && !p && (vo[d] = f);
    }
  }
  return f;
}, Hy = Wy, Zy = hh, zI = Zy([Hy("%String.prototype.indexOf%")]), Qy = function(t, o) {
  var i = (
    /** @type {(this: unknown, ...args: unknown[]) => unknown} */
    Hy(t, !!o)
  );
  return typeof i == "function" && zI(t, ".prototype.") > -1 ? Zy(
    /** @type {const} */
    [i]
  ) : i;
}, Vy = Function.prototype.toString, Jo = typeof Reflect == "object" && Reflect !== null && Reflect.apply, l1, R0;
if (typeof Jo == "function" && typeof Object.defineProperty == "function")
  try {
    l1 = Object.defineProperty({}, "length", {
      get: function() {
        throw R0;
      }
    }), R0 = {}, Jo(function() {
      throw 42;
    }, null, l1);
  } catch (e) {
    e !== R0 && (Jo = null);
  }
else
  Jo = null;
var kI = /^\s*class\b/, f1 = function(t) {
  try {
    var o = Vy.call(t);
    return kI.test(o);
  } catch {
    return !1;
  }
}, Nf = function(t) {
  try {
    return f1(t) ? !1 : (Vy.call(t), !0);
  } catch {
    return !1;
  }
}, P0 = Object.prototype.toString, _I = "[object Object]", BI = "[object Function]", FI = "[object GeneratorFunction]", RI = "[object HTMLAllCollection]", PI = "[object HTML document.all class]", UI = "[object HTMLCollection]", YI = typeof Symbol == "function" && !!Symbol.toStringTag, WI = !(0 in [,]), u1 = function() {
  return !1;
};
if (typeof document == "object") {
  var HI = document.all;
  P0.call(HI) === P0.call(document.all) && (u1 = function(t) {
    if ((WI || !t) && (typeof t > "u" || typeof t == "object"))
      try {
        var o = P0.call(t);
        return (o === RI || o === PI || o === UI || o === _I) && t("") == null;
      } catch {
      }
    return !1;
  });
}
var ZI = Jo ? function(t) {
  if (u1(t))
    return !0;
  if (!t || typeof t != "function" && typeof t != "object")
    return !1;
  try {
    Jo(t, null, l1);
  } catch (o) {
    if (o !== R0)
      return !1;
  }
  return !f1(t) && Nf(t);
} : function(t) {
  if (u1(t))
    return !0;
  if (!t || typeof t != "function" && typeof t != "object")
    return !1;
  if (YI)
    return Nf(t);
  if (f1(t))
    return !1;
  var o = P0.call(t);
  return o !== BI && o !== FI && !/^\[object HTML/.test(o) ? !1 : Nf(t);
}, QI = ZI, VI = Object.prototype.toString, Gy = Object.prototype.hasOwnProperty, GI = function(t, o, i) {
  for (var c = 0, n = t.length; c < n; c++)
    Gy.call(t, c) && (i == null ? o(t[c], c, t) : o.call(i, t[c], c, t));
}, $I = function(t, o, i) {
  for (var c = 0, n = t.length; c < n; c++)
    i == null ? o(t.charAt(c), c, t) : o.call(i, t.charAt(c), c, t);
}, qI = function(t, o, i) {
  for (var c in t)
    Gy.call(t, c) && (i == null ? o(t[c], c, t) : o.call(i, t[c], c, t));
};
function JI(e) {
  return VI.call(e) === "[object Array]";
}
var XI = function(t, o, i) {
  if (!QI(o))
    throw new TypeError("iterator must be a function");
  var c;
  arguments.length >= 3 && (c = i), JI(t) ? GI(t, o, c) : typeof t == "string" ? $I(t, o, c) : qI(t, o, c);
}, KI = [
  "Float16Array",
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Int16Array",
  "Int32Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array"
], Af = KI, eN = typeof globalThis > "u" ? Wt : globalThis, tN = function() {
  for (var t = [], o = 0; o < Af.length; o++)
    typeof eN[Af[o]] == "function" && (t[t.length] = Af[o]);
  return t;
}, $y = { exports: {} }, F4 = Hc, rN = Oy, Zo = js, R4 = Os, nN = function(t, o, i) {
  if (!t || typeof t != "object" && typeof t != "function")
    throw new Zo("`obj` must be an object or a function`");
  if (typeof o != "string" && typeof o != "symbol")
    throw new Zo("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new Zo("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new Zo("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new Zo("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new Zo("`loose`, if provided, must be a boolean");
  var c = arguments.length > 3 ? arguments[3] : null, n = arguments.length > 4 ? arguments[4] : null, d = arguments.length > 5 ? arguments[5] : null, f = arguments.length > 6 ? arguments[6] : !1, p = !!R4 && R4(t, o);
  if (F4)
    F4(t, o, {
      configurable: d === null && p ? p.configurable : !d,
      enumerable: c === null && p ? p.enumerable : !c,
      value: i,
      writable: n === null && p ? p.writable : !n
    });
  else if (f || !c && !n && !d)
    t[o] = i;
  else
    throw new rN("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, d1 = Hc, qy = function() {
  return !!d1;
};
qy.hasArrayLengthDefineBug = function() {
  if (!d1)
    return null;
  try {
    return d1([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var iN = qy, oN = Wy, P4 = nN, aN = iN(), U4 = Os, Y4 = js, sN = oN("%Math.floor%"), cN = function(t, o) {
  if (typeof t != "function")
    throw new Y4("`fn` is not a function");
  if (typeof o != "number" || o < 0 || o > 4294967295 || sN(o) !== o)
    throw new Y4("`length` must be a positive 32-bit integer");
  var i = arguments.length > 2 && !!arguments[2], c = !0, n = !0;
  if ("length" in t && U4) {
    var d = U4(t, "length");
    d && !d.configurable && (c = !1), d && !d.writable && (n = !1);
  }
  return (c || n || !i) && (aN ? P4(
    /** @type {Parameters<define>[0]} */
    t,
    "length",
    o,
    !0,
    !0
  ) : P4(
    /** @type {Parameters<define>[0]} */
    t,
    "length",
    o
  )), t;
}, lN = zs(), fN = dh(), uN = By, dN = function() {
  return uN(lN, fN, arguments);
};
(function(e) {
  var t = cN, o = Hc, i = hh, c = dN;
  e.exports = function(d) {
    var f = i(arguments), p = d.length - (arguments.length - 1);
    return t(
      f,
      1 + (p > 0 ? p : 0),
      !0
    );
  }, o ? o(e.exports, "apply", { value: c }) : e.exports.apply = c;
})($y);
var hN = $y.exports, pN = zy, gN = function() {
  return pN() && !!Symbol.toStringTag;
}, oc = XI, yN = tN, W4 = hN, ph = Qy, U0 = Os, s0 = Py, MN = ph("Object.prototype.toString"), Jy = gN(), H4 = typeof globalThis > "u" ? Wt : globalThis, h1 = yN(), gh = ph("String.prototype.slice"), mN = ph("Array.prototype.indexOf", !0) || function(t, o) {
  for (var i = 0; i < t.length; i += 1)
    if (t[i] === o)
      return i;
  return -1;
}, ac = { __proto__: null };
Jy && U0 && s0 ? oc(h1, function(e) {
  var t = new H4[e]();
  if (Symbol.toStringTag in t && s0) {
    var o = s0(t), i = U0(o, Symbol.toStringTag);
    if (!i && o) {
      var c = s0(o);
      i = U0(c, Symbol.toStringTag);
    }
    ac["$" + e] = W4(i.get);
  }
}) : oc(h1, function(e) {
  var t = new H4[e](), o = t.slice || t.set;
  o && (ac[
    /** @type {`$${import('.').TypedArrayName}`} */
    "$" + e
  ] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */
  // @ts-expect-error TODO FIXME
  W4(o));
});
var vN = function(t) {
  var o = !1;
  return oc(
    /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
    ac,
    /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
    function(i, c) {
      if (!o)
        try {
          "$" + i(t) === c && (o = /** @type {import('.').TypedArrayName} */
          gh(c, 1));
        } catch {
        }
    }
  ), o;
}, bN = function(t) {
  var o = !1;
  return oc(
    /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
    ac,
    /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
    function(i, c) {
      if (!o)
        try {
          i(t), o = /** @type {import('.').TypedArrayName} */
          gh(c, 1);
        } catch {
        }
    }
  ), o;
}, xN = function(t) {
  if (!t || typeof t != "object")
    return !1;
  if (!Jy) {
    var o = gh(MN(t), 8, -1);
    return mN(h1, o) > -1 ? o : o !== "Object" ? !1 : bN(t);
  }
  return U0 ? vN(t) : null;
}, wN = xN, CN = function(t) {
  return !!wN(t);
}, Tf, Z4;
function IN() {
  if (Z4) return Tf;
  Z4 = 1;
  var e = js, t = Qy, o = t("TypedArray.prototype.buffer", !0), i = CN;
  return Tf = o || function(n) {
    if (!i(n))
      throw new e("Not a Typed Array");
    return n.buffer;
  }, Tf;
}
var Lf, Q4;
function Xy() {
  if (Q4) return Lf;
  Q4 = 1;
  var e = Gt.Buffer, t = EC(), o = IN(), i = ArrayBuffer.isView || function(p) {
    try {
      return o(p), !0;
    } catch {
      return !1;
    }
  }, c = typeof Uint8Array < "u", n = typeof ArrayBuffer < "u" && typeof Uint8Array < "u", d = n && (e.prototype instanceof Uint8Array || e.TYPED_ARRAY_SUPPORT);
  return Lf = function(p, l) {
    if (p instanceof e)
      return p;
    if (typeof p == "string")
      return e.from(p, l);
    if (n && i(p)) {
      if (p.byteLength === 0)
        return e.alloc(0);
      if (d) {
        var h = e.from(p.buffer, p.byteOffset, p.byteLength);
        if (h.byteLength === p.byteLength)
          return h;
      }
      var y = p instanceof Uint8Array ? p : new Uint8Array(p.buffer, p.byteOffset, p.byteLength), M = e.from(y);
      if (M.length === p.byteLength)
        return M;
    }
    if (c && p instanceof Uint8Array)
      return e.from(p);
    var C = t(p);
    if (C)
      for (var N = 0; N < p.length; N += 1) {
        var w = p[N];
        if (typeof w != "number" || w < 0 || w > 255 || ~~w !== w)
          throw new RangeError("Array items must be numbers in the range 0-255.");
      }
    if (C || e.isBuffer(p) && p.constructor && typeof p.constructor.isBuffer == "function" && p.constructor.isBuffer(p))
      return e.from(p);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
  }, Lf;
}
var Sf, V4;
function Ta() {
  if (V4) return Sf;
  V4 = 1;
  var e = Gt.Buffer, t = Xy();
  function o(i, c) {
    this._block = e.alloc(i), this._finalSize = c, this._blockSize = i, this._len = 0;
  }
  return o.prototype.update = function(i, c) {
    i = t(i, c || "utf8");
    for (var n = this._block, d = this._blockSize, f = i.length, p = this._len, l = 0; l < f; ) {
      for (var h = p % d, y = Math.min(f - l, d - h), M = 0; M < y; M++)
        n[h + M] = i[l + M];
      p += y, l += y, p % d === 0 && this._update(n);
    }
    return this._len += f, this;
  }, o.prototype.digest = function(i) {
    var c = this._len % this._blockSize;
    this._block[c] = 128, this._block.fill(0, c + 1), c >= this._finalSize && (this._update(this._block), this._block.fill(0));
    var n = this._len * 8;
    if (n <= 4294967295)
      this._block.writeUInt32BE(n, this._blockSize - 4);
    else {
      var d = (n & 4294967295) >>> 0, f = (n - d) / 4294967296;
      this._block.writeUInt32BE(f, this._blockSize - 8), this._block.writeUInt32BE(d, this._blockSize - 4);
    }
    this._update(this._block);
    var p = this._hash();
    return i ? p.toString(i) : p;
  }, o.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
  }, Sf = o, Sf;
}
var Ef, G4;
function NN() {
  if (G4) return Ef;
  G4 = 1;
  var e = Yt, t = Ta(), o = Gt.Buffer, i = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], c = new Array(80);
  function n() {
    this.init(), this._w = c, t.call(this, 64, 56);
  }
  e(n, t), n.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function d(l) {
    return l << 5 | l >>> 27;
  }
  function f(l) {
    return l << 30 | l >>> 2;
  }
  function p(l, h, y, M) {
    return l === 0 ? h & y | ~h & M : l === 2 ? h & y | h & M | y & M : h ^ y ^ M;
  }
  return n.prototype._update = function(l) {
    for (var h = this._w, y = this._a | 0, M = this._b | 0, C = this._c | 0, N = this._d | 0, w = this._e | 0, S = 0; S < 16; ++S)
      h[S] = l.readInt32BE(S * 4);
    for (; S < 80; ++S)
      h[S] = h[S - 3] ^ h[S - 8] ^ h[S - 14] ^ h[S - 16];
    for (var T = 0; T < 80; ++T) {
      var E = ~~(T / 20), j = d(y) + p(E, M, C, N) + w + h[T] + i[E] | 0;
      w = N, N = C, C = f(M), M = y, y = j;
    }
    this._a = y + this._a | 0, this._b = M + this._b | 0, this._c = C + this._c | 0, this._d = N + this._d | 0, this._e = w + this._e | 0;
  }, n.prototype._hash = function() {
    var l = o.allocUnsafe(20);
    return l.writeInt32BE(this._a | 0, 0), l.writeInt32BE(this._b | 0, 4), l.writeInt32BE(this._c | 0, 8), l.writeInt32BE(this._d | 0, 12), l.writeInt32BE(this._e | 0, 16), l;
  }, Ef = n, Ef;
}
var Df, $4;
function AN() {
  if ($4) return Df;
  $4 = 1;
  var e = Yt, t = Ta(), o = Gt.Buffer, i = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], c = new Array(80);
  function n() {
    this.init(), this._w = c, t.call(this, 64, 56);
  }
  e(n, t), n.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function d(h) {
    return h << 1 | h >>> 31;
  }
  function f(h) {
    return h << 5 | h >>> 27;
  }
  function p(h) {
    return h << 30 | h >>> 2;
  }
  function l(h, y, M, C) {
    return h === 0 ? y & M | ~y & C : h === 2 ? y & M | y & C | M & C : y ^ M ^ C;
  }
  return n.prototype._update = function(h) {
    for (var y = this._w, M = this._a | 0, C = this._b | 0, N = this._c | 0, w = this._d | 0, S = this._e | 0, T = 0; T < 16; ++T)
      y[T] = h.readInt32BE(T * 4);
    for (; T < 80; ++T)
      y[T] = d(y[T - 3] ^ y[T - 8] ^ y[T - 14] ^ y[T - 16]);
    for (var E = 0; E < 80; ++E) {
      var j = ~~(E / 20), O = f(M) + l(j, C, N, w) + S + y[E] + i[j] | 0;
      S = w, w = N, N = p(C), C = M, M = O;
    }
    this._a = M + this._a | 0, this._b = C + this._b | 0, this._c = N + this._c | 0, this._d = w + this._d | 0, this._e = S + this._e | 0;
  }, n.prototype._hash = function() {
    var h = o.allocUnsafe(20);
    return h.writeInt32BE(this._a | 0, 0), h.writeInt32BE(this._b | 0, 4), h.writeInt32BE(this._c | 0, 8), h.writeInt32BE(this._d | 0, 12), h.writeInt32BE(this._e | 0, 16), h;
  }, Df = n, Df;
}
var jf, q4;
function Ky() {
  if (q4) return jf;
  q4 = 1;
  var e = Yt, t = Ta(), o = Gt.Buffer, i = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ], c = new Array(64);
  function n() {
    this.init(), this._w = c, t.call(this, 64, 56);
  }
  e(n, t), n.prototype.init = function() {
    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
  };
  function d(M, C, N) {
    return N ^ M & (C ^ N);
  }
  function f(M, C, N) {
    return M & C | N & (M | C);
  }
  function p(M) {
    return (M >>> 2 | M << 30) ^ (M >>> 13 | M << 19) ^ (M >>> 22 | M << 10);
  }
  function l(M) {
    return (M >>> 6 | M << 26) ^ (M >>> 11 | M << 21) ^ (M >>> 25 | M << 7);
  }
  function h(M) {
    return (M >>> 7 | M << 25) ^ (M >>> 18 | M << 14) ^ M >>> 3;
  }
  function y(M) {
    return (M >>> 17 | M << 15) ^ (M >>> 19 | M << 13) ^ M >>> 10;
  }
  return n.prototype._update = function(M) {
    for (var C = this._w, N = this._a | 0, w = this._b | 0, S = this._c | 0, T = this._d | 0, E = this._e | 0, j = this._f | 0, O = this._g | 0, z = this._h | 0, k = 0; k < 16; ++k)
      C[k] = M.readInt32BE(k * 4);
    for (; k < 64; ++k)
      C[k] = y(C[k - 2]) + C[k - 7] + h(C[k - 15]) + C[k - 16] | 0;
    for (var H = 0; H < 64; ++H) {
      var W = z + l(E) + d(E, j, O) + i[H] + C[H] | 0, U = p(N) + f(N, w, S) | 0;
      z = O, O = j, j = E, E = T + W | 0, T = S, S = w, w = N, N = W + U | 0;
    }
    this._a = N + this._a | 0, this._b = w + this._b | 0, this._c = S + this._c | 0, this._d = T + this._d | 0, this._e = E + this._e | 0, this._f = j + this._f | 0, this._g = O + this._g | 0, this._h = z + this._h | 0;
  }, n.prototype._hash = function() {
    var M = o.allocUnsafe(32);
    return M.writeInt32BE(this._a, 0), M.writeInt32BE(this._b, 4), M.writeInt32BE(this._c, 8), M.writeInt32BE(this._d, 12), M.writeInt32BE(this._e, 16), M.writeInt32BE(this._f, 20), M.writeInt32BE(this._g, 24), M.writeInt32BE(this._h, 28), M;
  }, jf = n, jf;
}
var Of, J4;
function TN() {
  if (J4) return Of;
  J4 = 1;
  var e = Yt, t = Ky(), o = Ta(), i = Gt.Buffer, c = new Array(64);
  function n() {
    this.init(), this._w = c, o.call(this, 64, 56);
  }
  return e(n, t), n.prototype.init = function() {
    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
  }, n.prototype._hash = function() {
    var d = i.allocUnsafe(28);
    return d.writeInt32BE(this._a, 0), d.writeInt32BE(this._b, 4), d.writeInt32BE(this._c, 8), d.writeInt32BE(this._d, 12), d.writeInt32BE(this._e, 16), d.writeInt32BE(this._f, 20), d.writeInt32BE(this._g, 24), d;
  }, Of = n, Of;
}
var zf, X4;
function eM() {
  if (X4) return zf;
  X4 = 1;
  var e = Yt, t = Ta(), o = Gt.Buffer, i = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ], c = new Array(160);
  function n() {
    this.init(), this._w = c, t.call(this, 128, 112);
  }
  e(n, t), n.prototype.init = function() {
    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
  };
  function d(w, S, T) {
    return T ^ w & (S ^ T);
  }
  function f(w, S, T) {
    return w & S | T & (w | S);
  }
  function p(w, S) {
    return (w >>> 28 | S << 4) ^ (S >>> 2 | w << 30) ^ (S >>> 7 | w << 25);
  }
  function l(w, S) {
    return (w >>> 14 | S << 18) ^ (w >>> 18 | S << 14) ^ (S >>> 9 | w << 23);
  }
  function h(w, S) {
    return (w >>> 1 | S << 31) ^ (w >>> 8 | S << 24) ^ w >>> 7;
  }
  function y(w, S) {
    return (w >>> 1 | S << 31) ^ (w >>> 8 | S << 24) ^ (w >>> 7 | S << 25);
  }
  function M(w, S) {
    return (w >>> 19 | S << 13) ^ (S >>> 29 | w << 3) ^ w >>> 6;
  }
  function C(w, S) {
    return (w >>> 19 | S << 13) ^ (S >>> 29 | w << 3) ^ (w >>> 6 | S << 26);
  }
  function N(w, S) {
    return w >>> 0 < S >>> 0 ? 1 : 0;
  }
  return n.prototype._update = function(w) {
    for (var S = this._w, T = this._ah | 0, E = this._bh | 0, j = this._ch | 0, O = this._dh | 0, z = this._eh | 0, k = this._fh | 0, H = this._gh | 0, W = this._hh | 0, U = this._al | 0, B = this._bl | 0, I = this._cl | 0, r = this._dl | 0, s = this._el | 0, u = this._fl | 0, g = this._gl | 0, v = this._hl | 0, A = 0; A < 32; A += 2)
      S[A] = w.readInt32BE(A * 4), S[A + 1] = w.readInt32BE(A * 4 + 4);
    for (; A < 160; A += 2) {
      var L = S[A - 30], m = S[A - 15 * 2 + 1], a = h(L, m), x = y(m, L);
      L = S[A - 2 * 2], m = S[A - 2 * 2 + 1];
      var V = M(L, m), G = C(m, L), Z = S[A - 7 * 2], te = S[A - 7 * 2 + 1], q = S[A - 16 * 2], R = S[A - 16 * 2 + 1], Q = x + te | 0, $ = a + Z + N(Q, x) | 0;
      Q = Q + G | 0, $ = $ + V + N(Q, G) | 0, Q = Q + R | 0, $ = $ + q + N(Q, R) | 0, S[A] = $, S[A + 1] = Q;
    }
    for (var F = 0; F < 160; F += 2) {
      $ = S[F], Q = S[F + 1];
      var P = f(T, E, j), _ = f(U, B, I), X = p(T, U), le = p(U, T), ie = l(z, s), oe = l(s, z), pe = i[F], se = i[F + 1], ce = d(z, k, H), me = d(s, u, g), de = v + oe | 0, ae = W + ie + N(de, v) | 0;
      de = de + me | 0, ae = ae + ce + N(de, me) | 0, de = de + se | 0, ae = ae + pe + N(de, se) | 0, de = de + Q | 0, ae = ae + $ + N(de, Q) | 0;
      var Le = le + _ | 0, ye = X + P + N(Le, le) | 0;
      W = H, v = g, H = k, g = u, k = z, u = s, s = r + de | 0, z = O + ae + N(s, r) | 0, O = j, r = I, j = E, I = B, E = T, B = U, U = de + Le | 0, T = ae + ye + N(U, de) | 0;
    }
    this._al = this._al + U | 0, this._bl = this._bl + B | 0, this._cl = this._cl + I | 0, this._dl = this._dl + r | 0, this._el = this._el + s | 0, this._fl = this._fl + u | 0, this._gl = this._gl + g | 0, this._hl = this._hl + v | 0, this._ah = this._ah + T + N(this._al, U) | 0, this._bh = this._bh + E + N(this._bl, B) | 0, this._ch = this._ch + j + N(this._cl, I) | 0, this._dh = this._dh + O + N(this._dl, r) | 0, this._eh = this._eh + z + N(this._el, s) | 0, this._fh = this._fh + k + N(this._fl, u) | 0, this._gh = this._gh + H + N(this._gl, g) | 0, this._hh = this._hh + W + N(this._hl, v) | 0;
  }, n.prototype._hash = function() {
    var w = o.allocUnsafe(64);
    function S(T, E, j) {
      w.writeInt32BE(T, j), w.writeInt32BE(E, j + 4);
    }
    return S(this._ah, this._al, 0), S(this._bh, this._bl, 8), S(this._ch, this._cl, 16), S(this._dh, this._dl, 24), S(this._eh, this._el, 32), S(this._fh, this._fl, 40), S(this._gh, this._gl, 48), S(this._hh, this._hl, 56), w;
  }, zf = n, zf;
}
var kf, K4;
function LN() {
  if (K4) return kf;
  K4 = 1;
  var e = Yt, t = eM(), o = Ta(), i = Gt.Buffer, c = new Array(160);
  function n() {
    this.init(), this._w = c, o.call(this, 128, 112);
  }
  return e(n, t), n.prototype.init = function() {
    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
  }, n.prototype._hash = function() {
    var d = i.allocUnsafe(48);
    function f(p, l, h) {
      d.writeInt32BE(p, h), d.writeInt32BE(l, h + 4);
    }
    return f(this._ah, this._al, 0), f(this._bh, this._bl, 8), f(this._ch, this._cl, 16), f(this._dh, this._dl, 24), f(this._eh, this._el, 32), f(this._fh, this._fl, 40), d;
  }, kf = n, kf;
}
var ep;
function yh() {
  return ep || (ep = 1, function(e) {
    e.exports = function(o) {
      var i = o.toLowerCase(), c = e.exports[i];
      if (!c)
        throw new Error(i + " is not supported (we accept pull requests)");
      return new c();
    }, e.exports.sha = NN(), e.exports.sha1 = AN(), e.exports.sha224 = TN(), e.exports.sha256 = Ky(), e.exports.sha384 = LN(), e.exports.sha512 = eM();
  }(pf)), pf.exports;
}
var _f, tp;
function Qi() {
  if (tp) return _f;
  tp = 1;
  var e = Gt.Buffer, t = Wc.Transform, o = c1().StringDecoder, i = Yt;
  function c(p) {
    t.call(this), this.hashMode = typeof p == "string", this.hashMode ? this[p] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
  }
  i(c, t);
  var n = typeof Uint8Array < "u", d = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && ArrayBuffer.isView && (e.prototype instanceof Uint8Array || e.TYPED_ARRAY_SUPPORT);
  function f(p, l) {
    if (p instanceof e)
      return p;
    if (typeof p == "string")
      return e.from(p, l);
    if (d && ArrayBuffer.isView(p)) {
      if (p.byteLength === 0)
        return e.alloc(0);
      var h = e.from(p.buffer, p.byteOffset, p.byteLength);
      if (h.byteLength === p.byteLength)
        return h;
    }
    if (n && p instanceof Uint8Array || e.isBuffer(p) && p.constructor && typeof p.constructor.isBuffer == "function" && p.constructor.isBuffer(p))
      return e.from(p);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
  }
  return c.prototype.update = function(p, l, h) {
    var y = f(p, l), M = this._update(y);
    return this.hashMode ? this : (h && (M = this._toString(M, h)), M);
  }, c.prototype.setAutoPadding = function() {
  }, c.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
  }, c.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
  }, c.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
  }, c.prototype._transform = function(p, l, h) {
    var y;
    try {
      this.hashMode ? this._update(p) : this.push(this._update(p));
    } catch (M) {
      y = M;
    } finally {
      h(y);
    }
  }, c.prototype._flush = function(p) {
    var l;
    try {
      this.push(this.__final());
    } catch (h) {
      l = h;
    }
    p(l);
  }, c.prototype._finalOrDigest = function(p) {
    var l = this.__final() || e.alloc(0);
    return p && (l = this._toString(l, p, !0)), l;
  }, c.prototype._toString = function(p, l, h) {
    if (this._decoder || (this._decoder = new o(l), this._encoding = l), this._encoding !== l)
      throw new Error("can’t switch encodings");
    var y = this._decoder.write(p);
    return h && (y += this._decoder.end()), y;
  }, _f = c, _f;
}
var Bf, rp;
function Bs() {
  if (rp) return Bf;
  rp = 1;
  var e = Yt, t = fh(), o = Dy(), i = yh(), c = Qi();
  function n(d) {
    c.call(this, "digest"), this._hash = d;
  }
  return e(n, c), n.prototype._update = function(d) {
    this._hash.update(d);
  }, n.prototype._final = function() {
    return this._hash.digest();
  }, Bf = function(f) {
    return f = f.toLowerCase(), f === "md5" ? new t() : f === "rmd160" || f === "ripemd160" ? new o() : new n(i(f));
  }, Bf;
}
var Ff, np;
function SN() {
  if (np) return Ff;
  np = 1;
  var e = Yt, t = Gt.Buffer, o = Qi(), i = t.alloc(128), c = 64;
  function n(d, f) {
    o.call(this, "digest"), typeof f == "string" && (f = t.from(f)), this._alg = d, this._key = f, f.length > c ? f = d(f) : f.length < c && (f = t.concat([f, i], c));
    for (var p = this._ipad = t.allocUnsafe(c), l = this._opad = t.allocUnsafe(c), h = 0; h < c; h++)
      p[h] = f[h] ^ 54, l[h] = f[h] ^ 92;
    this._hash = [p];
  }
  return e(n, o), n.prototype._update = function(d) {
    this._hash.push(d);
  }, n.prototype._final = function() {
    var d = this._alg(t.concat(this._hash));
    return this._alg(t.concat([this._opad, d]));
  }, Ff = n, Ff;
}
var Rf, ip;
function EN() {
  if (ip) return Rf;
  ip = 1;
  var e = fh();
  return Rf = function(t) {
    return new e().update(t).digest();
  }, Rf;
}
var Pf, op;
function tM() {
  if (op) return Pf;
  op = 1;
  var e = Yt, t = SN(), o = Qi(), i = Gt.Buffer, c = EN(), n = Dy(), d = yh(), f = i.alloc(128);
  function p(l, h) {
    o.call(this, "digest"), typeof h == "string" && (h = i.from(h));
    var y = l === "sha512" || l === "sha384" ? 128 : 64;
    if (this._alg = l, this._key = h, h.length > y) {
      var M = l === "rmd160" ? new n() : d(l);
      h = M.update(h).digest();
    } else h.length < y && (h = i.concat([h, f], y));
    for (var C = this._ipad = i.allocUnsafe(y), N = this._opad = i.allocUnsafe(y), w = 0; w < y; w++)
      C[w] = h[w] ^ 54, N[w] = h[w] ^ 92;
    this._hash = l === "rmd160" ? new n() : d(l), this._hash.update(C);
  }
  return e(p, o), p.prototype._update = function(l) {
    this._hash.update(l);
  }, p.prototype._final = function() {
    var l = this._hash.digest(), h = this._alg === "rmd160" ? new n() : d(this._alg);
    return h.update(this._opad).update(l).digest();
  }, Pf = function(h, y) {
    return h = h.toLowerCase(), h === "rmd160" || h === "ripemd160" ? new p("rmd160", y) : h === "md5" ? new t(c, y) : new p(h, y);
  }, Pf;
}
const DN = {
  sign: "rsa",
  hash: "sha224",
  id: "302d300d06096086480165030402040500041c"
}, jN = {
  sign: "rsa",
  hash: "sha256",
  id: "3031300d060960864801650304020105000420"
}, ON = {
  sign: "rsa",
  hash: "sha384",
  id: "3041300d060960864801650304020205000430"
}, zN = {
  sign: "rsa",
  hash: "sha512",
  id: "3051300d060960864801650304020305000440"
}, kN = {
  sign: "ecdsa",
  hash: "sha256",
  id: ""
}, _N = {
  sign: "ecdsa",
  hash: "sha224",
  id: ""
}, BN = {
  sign: "ecdsa",
  hash: "sha384",
  id: ""
}, FN = {
  sign: "ecdsa",
  hash: "sha512",
  id: ""
}, RN = {
  sign: "dsa",
  hash: "sha1",
  id: ""
}, PN = {
  sign: "rsa",
  hash: "rmd160",
  id: "3021300906052b2403020105000414"
}, UN = {
  sign: "rsa",
  hash: "md5",
  id: "3020300c06082a864886f70d020505000410"
}, rM = {
  sha224WithRSAEncryption: DN,
  "RSA-SHA224": {
    sign: "ecdsa/rsa",
    hash: "sha224",
    id: "302d300d06096086480165030402040500041c"
  },
  sha256WithRSAEncryption: jN,
  "RSA-SHA256": {
    sign: "ecdsa/rsa",
    hash: "sha256",
    id: "3031300d060960864801650304020105000420"
  },
  sha384WithRSAEncryption: ON,
  "RSA-SHA384": {
    sign: "ecdsa/rsa",
    hash: "sha384",
    id: "3041300d060960864801650304020205000430"
  },
  sha512WithRSAEncryption: zN,
  "RSA-SHA512": {
    sign: "ecdsa/rsa",
    hash: "sha512",
    id: "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    sign: "rsa",
    hash: "sha1",
    id: "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    sign: "ecdsa",
    hash: "sha1",
    id: ""
  },
  sha256: kN,
  sha224: _N,
  sha384: BN,
  sha512: FN,
  "DSA-SHA": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  "DSA-SHA1": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  DSA: RN,
  "DSA-WITH-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-WITH-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-WITH-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-WITH-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-RIPEMD160": {
    sign: "dsa",
    hash: "rmd160",
    id: ""
  },
  ripemd160WithRSA: PN,
  "RSA-RIPEMD160": {
    sign: "rsa",
    hash: "rmd160",
    id: "3021300906052b2403020105000414"
  },
  md5WithRSAEncryption: UN,
  "RSA-MD5": {
    sign: "rsa",
    hash: "md5",
    id: "3020300c06082a864886f70d020505000410"
  }
};
var Uf, ap;
function YN() {
  return ap || (ap = 1, Uf = rM), Uf;
}
var c0 = {}, Yf, sp;
function nM() {
  if (sp) return Yf;
  sp = 1;
  var e = Math.pow(2, 30) - 1;
  return Yf = function(t, o) {
    if (typeof t != "number")
      throw new TypeError("Iterations not a number");
    if (t < 0)
      throw new TypeError("Bad iterations");
    if (typeof o != "number")
      throw new TypeError("Key length not a number");
    if (o < 0 || o > e || o !== o)
      throw new TypeError("Bad key length");
  }, Yf;
}
var Wf, cp;
function iM() {
  if (cp) return Wf;
  cp = 1;
  var e;
  if (Wt.process && Wt.process.browser)
    e = "utf-8";
  else if (Wt.process && Wt.process.version) {
    var t = parseInt(fe.process.version.split(".")[0].slice(1), 10);
    e = t >= 6 ? "utf-8" : "binary";
  } else
    e = "utf-8";
  return Wf = e, Wf;
}
var Hf, lp;
function WN() {
  if (lp) return Hf;
  lp = 1;
  var e = 4, t = new fe.Buffer(e);
  t.fill(0);
  var o = 8, i = 16;
  function c(n) {
    if (n.length % e !== 0) {
      var d = n.length + (e - n.length % e);
      n = fe.Buffer.concat([n, t], d);
    }
    for (var f = new Array(n.length >>> 2), p = 0, l = 0; p < n.length; p += e, l++)
      f[l] = n.readInt32LE(p);
    return f;
  }
  return Hf = function(d, f) {
    var p = f(c(d), d.length * o);
    d = new fe.Buffer(i);
    for (var l = 0; l < p.length; l++)
      d.writeInt32LE(p[l], l << 2, !0);
    return d;
  }, Hf;
}
var Zf, fp;
function HN() {
  if (fp) return Zf;
  fp = 1;
  var e = WN();
  function t(l, h) {
    l[h >> 5] |= 128 << h % 32, l[(h + 64 >>> 9 << 4) + 14] = h;
    for (var y = 1732584193, M = -271733879, C = -1732584194, N = 271733878, w = 0; w < l.length; w += 16) {
      var S = y, T = M, E = C, j = N;
      y = i(y, M, C, N, l[w + 0], 7, -680876936), N = i(N, y, M, C, l[w + 1], 12, -389564586), C = i(C, N, y, M, l[w + 2], 17, 606105819), M = i(M, C, N, y, l[w + 3], 22, -1044525330), y = i(y, M, C, N, l[w + 4], 7, -176418897), N = i(N, y, M, C, l[w + 5], 12, 1200080426), C = i(C, N, y, M, l[w + 6], 17, -1473231341), M = i(M, C, N, y, l[w + 7], 22, -45705983), y = i(y, M, C, N, l[w + 8], 7, 1770035416), N = i(N, y, M, C, l[w + 9], 12, -1958414417), C = i(C, N, y, M, l[w + 10], 17, -42063), M = i(M, C, N, y, l[w + 11], 22, -1990404162), y = i(y, M, C, N, l[w + 12], 7, 1804603682), N = i(N, y, M, C, l[w + 13], 12, -40341101), C = i(C, N, y, M, l[w + 14], 17, -1502002290), M = i(M, C, N, y, l[w + 15], 22, 1236535329), y = c(y, M, C, N, l[w + 1], 5, -165796510), N = c(N, y, M, C, l[w + 6], 9, -1069501632), C = c(C, N, y, M, l[w + 11], 14, 643717713), M = c(M, C, N, y, l[w + 0], 20, -373897302), y = c(y, M, C, N, l[w + 5], 5, -701558691), N = c(N, y, M, C, l[w + 10], 9, 38016083), C = c(C, N, y, M, l[w + 15], 14, -660478335), M = c(M, C, N, y, l[w + 4], 20, -405537848), y = c(y, M, C, N, l[w + 9], 5, 568446438), N = c(N, y, M, C, l[w + 14], 9, -1019803690), C = c(C, N, y, M, l[w + 3], 14, -187363961), M = c(M, C, N, y, l[w + 8], 20, 1163531501), y = c(y, M, C, N, l[w + 13], 5, -1444681467), N = c(N, y, M, C, l[w + 2], 9, -51403784), C = c(C, N, y, M, l[w + 7], 14, 1735328473), M = c(M, C, N, y, l[w + 12], 20, -1926607734), y = n(y, M, C, N, l[w + 5], 4, -378558), N = n(N, y, M, C, l[w + 8], 11, -2022574463), C = n(C, N, y, M, l[w + 11], 16, 1839030562), M = n(M, C, N, y, l[w + 14], 23, -35309556), y = n(y, M, C, N, l[w + 1], 4, -1530992060), N = n(N, y, M, C, l[w + 4], 11, 1272893353), C = n(C, N, y, M, l[w + 7], 16, -155497632), M = n(M, C, N, y, l[w + 10], 23, -1094730640), y = n(y, M, C, N, l[w + 13], 4, 681279174), N = n(N, y, M, C, l[w + 0], 11, -358537222), C = n(C, N, y, M, l[w + 3], 16, -722521979), M = n(M, C, N, y, l[w + 6], 23, 76029189), y = n(y, M, C, N, l[w + 9], 4, -640364487), N = n(N, y, M, C, l[w + 12], 11, -421815835), C = n(C, N, y, M, l[w + 15], 16, 530742520), M = n(M, C, N, y, l[w + 2], 23, -995338651), y = d(y, M, C, N, l[w + 0], 6, -198630844), N = d(N, y, M, C, l[w + 7], 10, 1126891415), C = d(C, N, y, M, l[w + 14], 15, -1416354905), M = d(M, C, N, y, l[w + 5], 21, -57434055), y = d(y, M, C, N, l[w + 12], 6, 1700485571), N = d(N, y, M, C, l[w + 3], 10, -1894986606), C = d(C, N, y, M, l[w + 10], 15, -1051523), M = d(M, C, N, y, l[w + 1], 21, -2054922799), y = d(y, M, C, N, l[w + 8], 6, 1873313359), N = d(N, y, M, C, l[w + 15], 10, -30611744), C = d(C, N, y, M, l[w + 6], 15, -1560198380), M = d(M, C, N, y, l[w + 13], 21, 1309151649), y = d(y, M, C, N, l[w + 4], 6, -145523070), N = d(N, y, M, C, l[w + 11], 10, -1120210379), C = d(C, N, y, M, l[w + 2], 15, 718787259), M = d(M, C, N, y, l[w + 9], 21, -343485551), y = f(y, S), M = f(M, T), C = f(C, E), N = f(N, j);
    }
    return [y, M, C, N];
  }
  function o(l, h, y, M, C, N) {
    return f(p(f(f(h, l), f(M, N)), C), y);
  }
  function i(l, h, y, M, C, N, w) {
    return o(h & y | ~h & M, l, h, C, N, w);
  }
  function c(l, h, y, M, C, N, w) {
    return o(h & M | y & ~M, l, h, C, N, w);
  }
  function n(l, h, y, M, C, N, w) {
    return o(h ^ y ^ M, l, h, C, N, w);
  }
  function d(l, h, y, M, C, N, w) {
    return o(y ^ (h | ~M), l, h, C, N, w);
  }
  function f(l, h) {
    var y = (l & 65535) + (h & 65535), M = (l >> 16) + (h >> 16) + (y >> 16);
    return M << 16 | y & 65535;
  }
  function p(l, h) {
    return l << h | l >>> 32 - h;
  }
  return Zf = function(h) {
    return e(h, t);
  }, Zf;
}
var Qf, up;
function ZN() {
  if (up) return Qf;
  up = 1;
  var e = Wc.Transform, t = Yt;
  function o(i) {
    e.call(this), this._block = new fe.Buffer(i), this._blockSize = i, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  return t(o, e), o.prototype._transform = function(i, c, n) {
    var d = null;
    try {
      c !== "buffer" && (i = new fe.Buffer(i, c)), this.update(i);
    } catch (f) {
      d = f;
    }
    n(d);
  }, o.prototype._flush = function(i) {
    var c = null;
    try {
      this.push(this._digest());
    } catch (n) {
      c = n;
    }
    i(c);
  }, o.prototype.update = function(i, c) {
    if (!fe.Buffer.isBuffer(i) && typeof i != "string") throw new TypeError("Data must be a string or a buffer");
    if (this._finalized) throw new Error("Digest already called");
    fe.Buffer.isBuffer(i) || (i = new fe.Buffer(i, c || "binary"));
    for (var n = this._block, d = 0; this._blockOffset + i.length - d >= this._blockSize; ) {
      for (var f = this._blockOffset; f < this._blockSize; ) n[f++] = i[d++];
      this._update(), this._blockOffset = 0;
    }
    for (; d < i.length; ) n[this._blockOffset++] = i[d++];
    for (var p = 0, l = i.length * 8; l > 0; ++p)
      this._length[p] += l, l = this._length[p] / 4294967296 | 0, l > 0 && (this._length[p] -= 4294967296 * l);
    return this;
  }, o.prototype._update = function(i) {
    throw new Error("_update is not implemented");
  }, o.prototype.digest = function(i) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = !0;
    var c = this._digest();
    return i !== void 0 && (c = c.toString(i)), c;
  }, o.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, Qf = o, Qf;
}
var Vf, dp;
function QN() {
  if (dp) return Vf;
  dp = 1;
  var e = Yt, t = ZN();
  function o() {
    t.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  e(o, t), o.prototype._update = function() {
    for (var l = new Array(16), h = 0; h < 16; ++h) l[h] = this._block.readInt32LE(h * 4);
    var y = this._a, M = this._b, C = this._c, N = this._d, w = this._e;
    y = c(y, M, C, N, w, l[0], 0, 11), C = i(C, 10), w = c(w, y, M, C, N, l[1], 0, 14), M = i(M, 10), N = c(N, w, y, M, C, l[2], 0, 15), y = i(y, 10), C = c(C, N, w, y, M, l[3], 0, 12), w = i(w, 10), M = c(M, C, N, w, y, l[4], 0, 5), N = i(N, 10), y = c(y, M, C, N, w, l[5], 0, 8), C = i(C, 10), w = c(w, y, M, C, N, l[6], 0, 7), M = i(M, 10), N = c(N, w, y, M, C, l[7], 0, 9), y = i(y, 10), C = c(C, N, w, y, M, l[8], 0, 11), w = i(w, 10), M = c(M, C, N, w, y, l[9], 0, 13), N = i(N, 10), y = c(y, M, C, N, w, l[10], 0, 14), C = i(C, 10), w = c(w, y, M, C, N, l[11], 0, 15), M = i(M, 10), N = c(N, w, y, M, C, l[12], 0, 6), y = i(y, 10), C = c(C, N, w, y, M, l[13], 0, 7), w = i(w, 10), M = c(M, C, N, w, y, l[14], 0, 9), N = i(N, 10), y = c(y, M, C, N, w, l[15], 0, 8), C = i(C, 10), w = n(w, y, M, C, N, l[7], 1518500249, 7), M = i(M, 10), N = n(N, w, y, M, C, l[4], 1518500249, 6), y = i(y, 10), C = n(C, N, w, y, M, l[13], 1518500249, 8), w = i(w, 10), M = n(M, C, N, w, y, l[1], 1518500249, 13), N = i(N, 10), y = n(y, M, C, N, w, l[10], 1518500249, 11), C = i(C, 10), w = n(w, y, M, C, N, l[6], 1518500249, 9), M = i(M, 10), N = n(N, w, y, M, C, l[15], 1518500249, 7), y = i(y, 10), C = n(C, N, w, y, M, l[3], 1518500249, 15), w = i(w, 10), M = n(M, C, N, w, y, l[12], 1518500249, 7), N = i(N, 10), y = n(y, M, C, N, w, l[0], 1518500249, 12), C = i(C, 10), w = n(w, y, M, C, N, l[9], 1518500249, 15), M = i(M, 10), N = n(N, w, y, M, C, l[5], 1518500249, 9), y = i(y, 10), C = n(C, N, w, y, M, l[2], 1518500249, 11), w = i(w, 10), M = n(M, C, N, w, y, l[14], 1518500249, 7), N = i(N, 10), y = n(y, M, C, N, w, l[11], 1518500249, 13), C = i(C, 10), w = n(w, y, M, C, N, l[8], 1518500249, 12), M = i(M, 10), N = d(N, w, y, M, C, l[3], 1859775393, 11), y = i(y, 10), C = d(C, N, w, y, M, l[10], 1859775393, 13), w = i(w, 10), M = d(M, C, N, w, y, l[14], 1859775393, 6), N = i(N, 10), y = d(y, M, C, N, w, l[4], 1859775393, 7), C = i(C, 10), w = d(w, y, M, C, N, l[9], 1859775393, 14), M = i(M, 10), N = d(N, w, y, M, C, l[15], 1859775393, 9), y = i(y, 10), C = d(C, N, w, y, M, l[8], 1859775393, 13), w = i(w, 10), M = d(M, C, N, w, y, l[1], 1859775393, 15), N = i(N, 10), y = d(y, M, C, N, w, l[2], 1859775393, 14), C = i(C, 10), w = d(w, y, M, C, N, l[7], 1859775393, 8), M = i(M, 10), N = d(N, w, y, M, C, l[0], 1859775393, 13), y = i(y, 10), C = d(C, N, w, y, M, l[6], 1859775393, 6), w = i(w, 10), M = d(M, C, N, w, y, l[13], 1859775393, 5), N = i(N, 10), y = d(y, M, C, N, w, l[11], 1859775393, 12), C = i(C, 10), w = d(w, y, M, C, N, l[5], 1859775393, 7), M = i(M, 10), N = d(N, w, y, M, C, l[12], 1859775393, 5), y = i(y, 10), C = f(C, N, w, y, M, l[1], 2400959708, 11), w = i(w, 10), M = f(M, C, N, w, y, l[9], 2400959708, 12), N = i(N, 10), y = f(y, M, C, N, w, l[11], 2400959708, 14), C = i(C, 10), w = f(w, y, M, C, N, l[10], 2400959708, 15), M = i(M, 10), N = f(N, w, y, M, C, l[0], 2400959708, 14), y = i(y, 10), C = f(C, N, w, y, M, l[8], 2400959708, 15), w = i(w, 10), M = f(M, C, N, w, y, l[12], 2400959708, 9), N = i(N, 10), y = f(y, M, C, N, w, l[4], 2400959708, 8), C = i(C, 10), w = f(w, y, M, C, N, l[13], 2400959708, 9), M = i(M, 10), N = f(N, w, y, M, C, l[3], 2400959708, 14), y = i(y, 10), C = f(C, N, w, y, M, l[7], 2400959708, 5), w = i(w, 10), M = f(M, C, N, w, y, l[15], 2400959708, 6), N = i(N, 10), y = f(y, M, C, N, w, l[14], 2400959708, 8), C = i(C, 10), w = f(w, y, M, C, N, l[5], 2400959708, 6), M = i(M, 10), N = f(N, w, y, M, C, l[6], 2400959708, 5), y = i(y, 10), C = f(C, N, w, y, M, l[2], 2400959708, 12), w = i(w, 10), M = p(M, C, N, w, y, l[4], 2840853838, 9), N = i(N, 10), y = p(y, M, C, N, w, l[0], 2840853838, 15), C = i(C, 10), w = p(w, y, M, C, N, l[5], 2840853838, 5), M = i(M, 10), N = p(N, w, y, M, C, l[9], 2840853838, 11), y = i(y, 10), C = p(C, N, w, y, M, l[7], 2840853838, 6), w = i(w, 10), M = p(M, C, N, w, y, l[12], 2840853838, 8), N = i(N, 10), y = p(y, M, C, N, w, l[2], 2840853838, 13), C = i(C, 10), w = p(w, y, M, C, N, l[10], 2840853838, 12), M = i(M, 10), N = p(N, w, y, M, C, l[14], 2840853838, 5), y = i(y, 10), C = p(C, N, w, y, M, l[1], 2840853838, 12), w = i(w, 10), M = p(M, C, N, w, y, l[3], 2840853838, 13), N = i(N, 10), y = p(y, M, C, N, w, l[8], 2840853838, 14), C = i(C, 10), w = p(w, y, M, C, N, l[11], 2840853838, 11), M = i(M, 10), N = p(N, w, y, M, C, l[6], 2840853838, 8), y = i(y, 10), C = p(C, N, w, y, M, l[15], 2840853838, 5), w = i(w, 10), M = p(M, C, N, w, y, l[13], 2840853838, 6), N = i(N, 10);
    var S = this._a, T = this._b, E = this._c, j = this._d, O = this._e;
    S = p(S, T, E, j, O, l[5], 1352829926, 8), E = i(E, 10), O = p(O, S, T, E, j, l[14], 1352829926, 9), T = i(T, 10), j = p(j, O, S, T, E, l[7], 1352829926, 9), S = i(S, 10), E = p(E, j, O, S, T, l[0], 1352829926, 11), O = i(O, 10), T = p(T, E, j, O, S, l[9], 1352829926, 13), j = i(j, 10), S = p(S, T, E, j, O, l[2], 1352829926, 15), E = i(E, 10), O = p(O, S, T, E, j, l[11], 1352829926, 15), T = i(T, 10), j = p(j, O, S, T, E, l[4], 1352829926, 5), S = i(S, 10), E = p(E, j, O, S, T, l[13], 1352829926, 7), O = i(O, 10), T = p(T, E, j, O, S, l[6], 1352829926, 7), j = i(j, 10), S = p(S, T, E, j, O, l[15], 1352829926, 8), E = i(E, 10), O = p(O, S, T, E, j, l[8], 1352829926, 11), T = i(T, 10), j = p(j, O, S, T, E, l[1], 1352829926, 14), S = i(S, 10), E = p(E, j, O, S, T, l[10], 1352829926, 14), O = i(O, 10), T = p(T, E, j, O, S, l[3], 1352829926, 12), j = i(j, 10), S = p(S, T, E, j, O, l[12], 1352829926, 6), E = i(E, 10), O = f(O, S, T, E, j, l[6], 1548603684, 9), T = i(T, 10), j = f(j, O, S, T, E, l[11], 1548603684, 13), S = i(S, 10), E = f(E, j, O, S, T, l[3], 1548603684, 15), O = i(O, 10), T = f(T, E, j, O, S, l[7], 1548603684, 7), j = i(j, 10), S = f(S, T, E, j, O, l[0], 1548603684, 12), E = i(E, 10), O = f(O, S, T, E, j, l[13], 1548603684, 8), T = i(T, 10), j = f(j, O, S, T, E, l[5], 1548603684, 9), S = i(S, 10), E = f(E, j, O, S, T, l[10], 1548603684, 11), O = i(O, 10), T = f(T, E, j, O, S, l[14], 1548603684, 7), j = i(j, 10), S = f(S, T, E, j, O, l[15], 1548603684, 7), E = i(E, 10), O = f(O, S, T, E, j, l[8], 1548603684, 12), T = i(T, 10), j = f(j, O, S, T, E, l[12], 1548603684, 7), S = i(S, 10), E = f(E, j, O, S, T, l[4], 1548603684, 6), O = i(O, 10), T = f(T, E, j, O, S, l[9], 1548603684, 15), j = i(j, 10), S = f(S, T, E, j, O, l[1], 1548603684, 13), E = i(E, 10), O = f(O, S, T, E, j, l[2], 1548603684, 11), T = i(T, 10), j = d(j, O, S, T, E, l[15], 1836072691, 9), S = i(S, 10), E = d(E, j, O, S, T, l[5], 1836072691, 7), O = i(O, 10), T = d(T, E, j, O, S, l[1], 1836072691, 15), j = i(j, 10), S = d(S, T, E, j, O, l[3], 1836072691, 11), E = i(E, 10), O = d(O, S, T, E, j, l[7], 1836072691, 8), T = i(T, 10), j = d(j, O, S, T, E, l[14], 1836072691, 6), S = i(S, 10), E = d(E, j, O, S, T, l[6], 1836072691, 6), O = i(O, 10), T = d(T, E, j, O, S, l[9], 1836072691, 14), j = i(j, 10), S = d(S, T, E, j, O, l[11], 1836072691, 12), E = i(E, 10), O = d(O, S, T, E, j, l[8], 1836072691, 13), T = i(T, 10), j = d(j, O, S, T, E, l[12], 1836072691, 5), S = i(S, 10), E = d(E, j, O, S, T, l[2], 1836072691, 14), O = i(O, 10), T = d(T, E, j, O, S, l[10], 1836072691, 13), j = i(j, 10), S = d(S, T, E, j, O, l[0], 1836072691, 13), E = i(E, 10), O = d(O, S, T, E, j, l[4], 1836072691, 7), T = i(T, 10), j = d(j, O, S, T, E, l[13], 1836072691, 5), S = i(S, 10), E = n(E, j, O, S, T, l[8], 2053994217, 15), O = i(O, 10), T = n(T, E, j, O, S, l[6], 2053994217, 5), j = i(j, 10), S = n(S, T, E, j, O, l[4], 2053994217, 8), E = i(E, 10), O = n(O, S, T, E, j, l[1], 2053994217, 11), T = i(T, 10), j = n(j, O, S, T, E, l[3], 2053994217, 14), S = i(S, 10), E = n(E, j, O, S, T, l[11], 2053994217, 14), O = i(O, 10), T = n(T, E, j, O, S, l[15], 2053994217, 6), j = i(j, 10), S = n(S, T, E, j, O, l[0], 2053994217, 14), E = i(E, 10), O = n(O, S, T, E, j, l[5], 2053994217, 6), T = i(T, 10), j = n(j, O, S, T, E, l[12], 2053994217, 9), S = i(S, 10), E = n(E, j, O, S, T, l[2], 2053994217, 12), O = i(O, 10), T = n(T, E, j, O, S, l[13], 2053994217, 9), j = i(j, 10), S = n(S, T, E, j, O, l[9], 2053994217, 12), E = i(E, 10), O = n(O, S, T, E, j, l[7], 2053994217, 5), T = i(T, 10), j = n(j, O, S, T, E, l[10], 2053994217, 15), S = i(S, 10), E = n(E, j, O, S, T, l[14], 2053994217, 8), O = i(O, 10), T = c(T, E, j, O, S, l[12], 0, 8), j = i(j, 10), S = c(S, T, E, j, O, l[15], 0, 5), E = i(E, 10), O = c(O, S, T, E, j, l[10], 0, 12), T = i(T, 10), j = c(j, O, S, T, E, l[4], 0, 9), S = i(S, 10), E = c(E, j, O, S, T, l[1], 0, 12), O = i(O, 10), T = c(T, E, j, O, S, l[5], 0, 5), j = i(j, 10), S = c(S, T, E, j, O, l[8], 0, 14), E = i(E, 10), O = c(O, S, T, E, j, l[7], 0, 6), T = i(T, 10), j = c(j, O, S, T, E, l[6], 0, 8), S = i(S, 10), E = c(E, j, O, S, T, l[2], 0, 13), O = i(O, 10), T = c(T, E, j, O, S, l[13], 0, 6), j = i(j, 10), S = c(S, T, E, j, O, l[14], 0, 5), E = i(E, 10), O = c(O, S, T, E, j, l[0], 0, 15), T = i(T, 10), j = c(j, O, S, T, E, l[3], 0, 13), S = i(S, 10), E = c(E, j, O, S, T, l[9], 0, 11), O = i(O, 10), T = c(T, E, j, O, S, l[11], 0, 11), j = i(j, 10);
    var z = this._b + C + j | 0;
    this._b = this._c + N + O | 0, this._c = this._d + w + S | 0, this._d = this._e + y + T | 0, this._e = this._a + M + E | 0, this._a = z;
  }, o.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var l = new fe.Buffer(20);
    return l.writeInt32LE(this._a, 0), l.writeInt32LE(this._b, 4), l.writeInt32LE(this._c, 8), l.writeInt32LE(this._d, 12), l.writeInt32LE(this._e, 16), l;
  };
  function i(l, h) {
    return l << h | l >>> 32 - h;
  }
  function c(l, h, y, M, C, N, w, S) {
    return i(l + (h ^ y ^ M) + N + w | 0, S) + C | 0;
  }
  function n(l, h, y, M, C, N, w, S) {
    return i(l + (h & y | ~h & M) + N + w | 0, S) + C | 0;
  }
  function d(l, h, y, M, C, N, w, S) {
    return i(l + ((h | ~y) ^ M) + N + w | 0, S) + C | 0;
  }
  function f(l, h, y, M, C, N, w, S) {
    return i(l + (h & M | y & ~M) + N + w | 0, S) + C | 0;
  }
  function p(l, h, y, M, C, N, w, S) {
    return i(l + (h ^ (y | ~M)) + N + w | 0, S) + C | 0;
  }
  return Vf = o, Vf;
}
var Gf, hp;
function oM() {
  if (hp) return Gf;
  hp = 1;
  var e = Gt.Buffer, t = Xy(), o = typeof Uint8Array < "u", i = o && typeof ArrayBuffer < "u", c = i && ArrayBuffer.isView;
  return Gf = function(n, d, f) {
    if (typeof n == "string" || e.isBuffer(n) || o && n instanceof Uint8Array || c && c(n))
      return t(n, d);
    throw new TypeError(f + " must be a string, a Buffer, a Uint8Array, or a DataView");
  }, Gf;
}
var $f, pp;
function aM() {
  if (pp) return $f;
  pp = 1;
  var e = HN(), t = QN(), o = yh(), i = Gt.Buffer, c = nM(), n = iM(), d = oM(), f = i.alloc(128), p = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    "sha512-256": 32,
    ripemd160: 20,
    rmd160: 20
  }, l = {
    __proto__: null,
    "sha-1": "sha1",
    "sha-224": "sha224",
    "sha-256": "sha256",
    "sha-384": "sha384",
    "sha-512": "sha512",
    "ripemd-160": "ripemd160"
  };
  function h(N) {
    return new t().update(N).digest();
  }
  function y(N) {
    function w(S) {
      return o(N).update(S).digest();
    }
    return N === "rmd160" || N === "ripemd160" ? h : N === "md5" ? e : w;
  }
  function M(N, w, S) {
    var T = y(N), E = N === "sha512" || N === "sha384" ? 128 : 64;
    w.length > E ? w = T(w) : w.length < E && (w = i.concat([w, f], E));
    for (var j = i.allocUnsafe(E + p[N]), O = i.allocUnsafe(E + p[N]), z = 0; z < E; z++)
      j[z] = w[z] ^ 54, O[z] = w[z] ^ 92;
    var k = i.allocUnsafe(E + S + 4);
    j.copy(k, 0, 0, E), this.ipad1 = k, this.ipad2 = j, this.opad = O, this.alg = N, this.blocksize = E, this.hash = T, this.size = p[N];
  }
  M.prototype.run = function(N, w) {
    N.copy(w, this.blocksize);
    var S = this.hash(w);
    return S.copy(this.opad, this.blocksize), this.hash(this.opad);
  };
  function C(N, w, S, T, E) {
    c(S, T), N = d(N, n, "Password"), w = d(w, n, "Salt");
    var j = (E || "sha1").toLowerCase(), O = l[j] || j, z = p[O];
    if (typeof z != "number" || !z)
      throw new TypeError("Digest algorithm not supported: " + E);
    var k = new M(O, N, w.length), H = i.allocUnsafe(T), W = i.allocUnsafe(w.length + 4);
    w.copy(W, 0, 0, w.length);
    for (var U = 0, B = z, I = Math.ceil(T / B), r = 1; r <= I; r++) {
      W.writeUInt32BE(r, w.length);
      for (var s = k.run(W, k.ipad1), u = s, g = 1; g < S; g++) {
        u = k.run(u, k.ipad2);
        for (var v = 0; v < B; v++)
          s[v] ^= u[v];
      }
      s.copy(H, U), U += B;
    }
    return H;
  }
  return $f = C, $f;
}
var qf, gp;
function VN() {
  if (gp) return qf;
  gp = 1;
  var e = Gt.Buffer, t = nM(), o = iM(), i = aM(), c = oM(), n, d = Wt.crypto && Wt.crypto.subtle, f = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
  }, p = [], l;
  function h() {
    return l || (Wt.process && Wt.process.nextTick ? l = Wt.process.nextTick : Wt.queueMicrotask ? l = Wt.queueMicrotask : Wt.setImmediate ? l = Wt.setImmediate : l = Wt.setTimeout, l);
  }
  function y(N, w, S, T, E) {
    return d.importKey("raw", N, { name: "PBKDF2" }, !1, ["deriveBits"]).then(function(j) {
      return d.deriveBits({
        name: "PBKDF2",
        salt: w,
        iterations: S,
        hash: {
          name: E
        }
      }, j, T << 3);
    }).then(function(j) {
      return e.from(j);
    });
  }
  function M(N) {
    if (Wt.process && !Wt.process.browser || !d || !d.importKey || !d.deriveBits)
      return Promise.resolve(!1);
    if (p[N] !== void 0)
      return p[N];
    n = n || e.alloc(8);
    var w = y(n, n, 10, 128, N).then(
      function() {
        return !0;
      },
      function() {
        return !1;
      }
    );
    return p[N] = w, w;
  }
  function C(N, w) {
    N.then(function(S) {
      h()(function() {
        w(null, S);
      });
    }, function(S) {
      h()(function() {
        w(S);
      });
    });
  }
  return qf = function(N, w, S, T, E, j) {
    typeof E == "function" && (j = E, E = void 0), E = E || "sha1";
    var O = f[E.toLowerCase()];
    if (!O || typeof Wt.Promise != "function") {
      h()(function() {
        var z;
        try {
          z = i(N, w, S, T, E);
        } catch (k) {
          j(k);
          return;
        }
        j(null, z);
      });
      return;
    }
    if (t(S, T), N = c(N, o, "Password"), w = c(w, o, "Salt"), typeof j != "function")
      throw new Error("No callback provided to pbkdf2");
    C(M(O).then(function(z) {
      return z ? y(N, w, S, T, O) : i(N, w, S, T, E);
    }), j);
  }, qf;
}
var yp;
function sM() {
  return yp || (yp = 1, c0.pbkdf2 = VN(), c0.pbkdf2Sync = aM()), c0;
}
var Dn = {}, Xi = {}, wn = {}, Mp;
function cM() {
  if (Mp) return wn;
  Mp = 1, wn.readUInt32BE = function(c, n) {
    var d = c[0 + n] << 24 | c[1 + n] << 16 | c[2 + n] << 8 | c[3 + n];
    return d >>> 0;
  }, wn.writeUInt32BE = function(c, n, d) {
    c[0 + d] = n >>> 24, c[1 + d] = n >>> 16 & 255, c[2 + d] = n >>> 8 & 255, c[3 + d] = n & 255;
  }, wn.ip = function(c, n, d, f) {
    for (var p = 0, l = 0, h = 6; h >= 0; h -= 2) {
      for (var y = 0; y <= 24; y += 8)
        p <<= 1, p |= n >>> y + h & 1;
      for (var y = 0; y <= 24; y += 8)
        p <<= 1, p |= c >>> y + h & 1;
    }
    for (var h = 6; h >= 0; h -= 2) {
      for (var y = 1; y <= 25; y += 8)
        l <<= 1, l |= n >>> y + h & 1;
      for (var y = 1; y <= 25; y += 8)
        l <<= 1, l |= c >>> y + h & 1;
    }
    d[f + 0] = p >>> 0, d[f + 1] = l >>> 0;
  }, wn.rip = function(c, n, d, f) {
    for (var p = 0, l = 0, h = 0; h < 4; h++)
      for (var y = 24; y >= 0; y -= 8)
        p <<= 1, p |= n >>> y + h & 1, p <<= 1, p |= c >>> y + h & 1;
    for (var h = 4; h < 8; h++)
      for (var y = 24; y >= 0; y -= 8)
        l <<= 1, l |= n >>> y + h & 1, l <<= 1, l |= c >>> y + h & 1;
    d[f + 0] = p >>> 0, d[f + 1] = l >>> 0;
  }, wn.pc1 = function(c, n, d, f) {
    for (var p = 0, l = 0, h = 7; h >= 5; h--) {
      for (var y = 0; y <= 24; y += 8)
        p <<= 1, p |= n >> y + h & 1;
      for (var y = 0; y <= 24; y += 8)
        p <<= 1, p |= c >> y + h & 1;
    }
    for (var y = 0; y <= 24; y += 8)
      p <<= 1, p |= n >> y + h & 1;
    for (var h = 1; h <= 3; h++) {
      for (var y = 0; y <= 24; y += 8)
        l <<= 1, l |= n >> y + h & 1;
      for (var y = 0; y <= 24; y += 8)
        l <<= 1, l |= c >> y + h & 1;
    }
    for (var y = 0; y <= 24; y += 8)
      l <<= 1, l |= c >> y + h & 1;
    d[f + 0] = p >>> 0, d[f + 1] = l >>> 0;
  }, wn.r28shl = function(c, n) {
    return c << n & 268435455 | c >>> 28 - n;
  };
  var e = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
  ];
  wn.pc2 = function(c, n, d, f) {
    for (var p = 0, l = 0, h = e.length >>> 1, y = 0; y < h; y++)
      p <<= 1, p |= c >>> e[y] & 1;
    for (var y = h; y < e.length; y++)
      l <<= 1, l |= n >>> e[y] & 1;
    d[f + 0] = p >>> 0, d[f + 1] = l >>> 0;
  }, wn.expand = function(c, n, d) {
    var f = 0, p = 0;
    f = (c & 1) << 5 | c >>> 27;
    for (var l = 23; l >= 15; l -= 4)
      f <<= 6, f |= c >>> l & 63;
    for (var l = 11; l >= 3; l -= 4)
      p |= c >>> l & 63, p <<= 6;
    p |= (c & 31) << 1 | c >>> 31, n[d + 0] = f >>> 0, n[d + 1] = p >>> 0;
  };
  var t = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
  ];
  wn.substitute = function(c, n) {
    for (var d = 0, f = 0; f < 4; f++) {
      var p = c >>> 18 - f * 6 & 63, l = t[f * 64 + p];
      d <<= 4, d |= l;
    }
    for (var f = 0; f < 4; f++) {
      var p = n >>> 18 - f * 6 & 63, l = t[4 * 64 + f * 64 + p];
      d <<= 4, d |= l;
    }
    return d >>> 0;
  };
  var o = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
  ];
  return wn.permute = function(c) {
    for (var n = 0, d = 0; d < o.length; d++)
      n <<= 1, n |= c >>> o[d] & 1;
    return n >>> 0;
  }, wn.padSplit = function(c, n, d) {
    for (var f = c.toString(2); f.length < n; )
      f = "0" + f;
    for (var p = [], l = 0; l < n; l += d)
      p.push(f.slice(l, l + d));
    return p.join(" ");
  }, wn;
}
var Jf, mp;
function Zn() {
  if (mp) return Jf;
  mp = 1, Jf = e;
  function e(t, o) {
    if (!t)
      throw new Error(o || "Assertion failed");
  }
  return e.equal = function(o, i, c) {
    if (o != i)
      throw new Error(c || "Assertion failed: " + o + " != " + i);
  }, Jf;
}
var Xf, vp;
function Mh() {
  if (vp) return Xf;
  vp = 1;
  var e = Zn();
  function t(o) {
    this.options = o, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = o.padding !== !1;
  }
  return Xf = t, t.prototype._init = function() {
  }, t.prototype.update = function(i) {
    return i.length === 0 ? [] : this.type === "decrypt" ? this._updateDecrypt(i) : this._updateEncrypt(i);
  }, t.prototype._buffer = function(i, c) {
    for (var n = Math.min(this.buffer.length - this.bufferOff, i.length - c), d = 0; d < n; d++)
      this.buffer[this.bufferOff + d] = i[c + d];
    return this.bufferOff += n, n;
  }, t.prototype._flushBuffer = function(i, c) {
    return this._update(this.buffer, 0, i, c), this.bufferOff = 0, this.blockSize;
  }, t.prototype._updateEncrypt = function(i) {
    var c = 0, n = 0, d = (this.bufferOff + i.length) / this.blockSize | 0, f = new Array(d * this.blockSize);
    this.bufferOff !== 0 && (c += this._buffer(i, c), this.bufferOff === this.buffer.length && (n += this._flushBuffer(f, n)));
    for (var p = i.length - (i.length - c) % this.blockSize; c < p; c += this.blockSize)
      this._update(i, c, f, n), n += this.blockSize;
    for (; c < i.length; c++, this.bufferOff++)
      this.buffer[this.bufferOff] = i[c];
    return f;
  }, t.prototype._updateDecrypt = function(i) {
    for (var c = 0, n = 0, d = Math.ceil((this.bufferOff + i.length) / this.blockSize) - 1, f = new Array(d * this.blockSize); d > 0; d--)
      c += this._buffer(i, c), n += this._flushBuffer(f, n);
    return c += this._buffer(i, c), f;
  }, t.prototype.final = function(i) {
    var c;
    i && (c = this.update(i));
    var n;
    return this.type === "encrypt" ? n = this._finalEncrypt() : n = this._finalDecrypt(), c ? c.concat(n) : n;
  }, t.prototype._pad = function(i, c) {
    if (c === 0)
      return !1;
    for (; c < i.length; )
      i[c++] = 0;
    return !0;
  }, t.prototype._finalEncrypt = function() {
    if (!this._pad(this.buffer, this.bufferOff))
      return [];
    var i = new Array(this.blockSize);
    return this._update(this.buffer, 0, i, 0), i;
  }, t.prototype._unpad = function(i) {
    return i;
  }, t.prototype._finalDecrypt = function() {
    e.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var i = new Array(this.blockSize);
    return this._flushBuffer(i, 0), this._unpad(i);
  }, Xf;
}
var Kf, bp;
function lM() {
  if (bp) return Kf;
  bp = 1;
  var e = Zn(), t = Yt, o = cM(), i = Mh();
  function c() {
    this.tmp = new Array(2), this.keys = null;
  }
  function n(f) {
    i.call(this, f);
    var p = new c();
    this._desState = p, this.deriveKeys(p, f.key);
  }
  t(n, i), Kf = n, n.create = function(p) {
    return new n(p);
  };
  var d = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
  ];
  return n.prototype.deriveKeys = function(p, l) {
    p.keys = new Array(16 * 2), e.equal(l.length, this.blockSize, "Invalid key length");
    var h = o.readUInt32BE(l, 0), y = o.readUInt32BE(l, 4);
    o.pc1(h, y, p.tmp, 0), h = p.tmp[0], y = p.tmp[1];
    for (var M = 0; M < p.keys.length; M += 2) {
      var C = d[M >>> 1];
      h = o.r28shl(h, C), y = o.r28shl(y, C), o.pc2(h, y, p.keys, M);
    }
  }, n.prototype._update = function(p, l, h, y) {
    var M = this._desState, C = o.readUInt32BE(p, l), N = o.readUInt32BE(p, l + 4);
    o.ip(C, N, M.tmp, 0), C = M.tmp[0], N = M.tmp[1], this.type === "encrypt" ? this._encrypt(M, C, N, M.tmp, 0) : this._decrypt(M, C, N, M.tmp, 0), C = M.tmp[0], N = M.tmp[1], o.writeUInt32BE(h, C, y), o.writeUInt32BE(h, N, y + 4);
  }, n.prototype._pad = function(p, l) {
    if (this.padding === !1)
      return !1;
    for (var h = p.length - l, y = l; y < p.length; y++)
      p[y] = h;
    return !0;
  }, n.prototype._unpad = function(p) {
    if (this.padding === !1)
      return p;
    for (var l = p[p.length - 1], h = p.length - l; h < p.length; h++)
      e.equal(p[h], l);
    return p.slice(0, p.length - l);
  }, n.prototype._encrypt = function(p, l, h, y, M) {
    for (var C = l, N = h, w = 0; w < p.keys.length; w += 2) {
      var S = p.keys[w], T = p.keys[w + 1];
      o.expand(N, p.tmp, 0), S ^= p.tmp[0], T ^= p.tmp[1];
      var E = o.substitute(S, T), j = o.permute(E), O = N;
      N = (C ^ j) >>> 0, C = O;
    }
    o.rip(N, C, y, M);
  }, n.prototype._decrypt = function(p, l, h, y, M) {
    for (var C = h, N = l, w = p.keys.length - 2; w >= 0; w -= 2) {
      var S = p.keys[w], T = p.keys[w + 1];
      o.expand(C, p.tmp, 0), S ^= p.tmp[0], T ^= p.tmp[1];
      var E = o.substitute(S, T), j = o.permute(E), O = C;
      C = (N ^ j) >>> 0, N = O;
    }
    o.rip(C, N, y, M);
  }, Kf;
}
var eu = {}, xp;
function GN() {
  if (xp) return eu;
  xp = 1;
  var e = Zn(), t = Yt, o = {};
  function i(n) {
    e.equal(n.length, 8, "Invalid IV length"), this.iv = new Array(8);
    for (var d = 0; d < this.iv.length; d++)
      this.iv[d] = n[d];
  }
  function c(n) {
    function d(h) {
      n.call(this, h), this._cbcInit();
    }
    t(d, n);
    for (var f = Object.keys(o), p = 0; p < f.length; p++) {
      var l = f[p];
      d.prototype[l] = o[l];
    }
    return d.create = function(y) {
      return new d(y);
    }, d;
  }
  return eu.instantiate = c, o._cbcInit = function() {
    var d = new i(this.options.iv);
    this._cbcState = d;
  }, o._update = function(d, f, p, l) {
    var h = this._cbcState, y = this.constructor.super_.prototype, M = h.iv;
    if (this.type === "encrypt") {
      for (var C = 0; C < this.blockSize; C++)
        M[C] ^= d[f + C];
      y._update.call(this, M, 0, p, l);
      for (var C = 0; C < this.blockSize; C++)
        M[C] = p[l + C];
    } else {
      y._update.call(this, d, f, p, l);
      for (var C = 0; C < this.blockSize; C++)
        p[l + C] ^= M[C];
      for (var C = 0; C < this.blockSize; C++)
        M[C] = d[f + C];
    }
  }, eu;
}
var tu, wp;
function $N() {
  if (wp) return tu;
  wp = 1;
  var e = Zn(), t = Yt, o = Mh(), i = lM();
  function c(d, f) {
    e.equal(f.length, 24, "Invalid key length");
    var p = f.slice(0, 8), l = f.slice(8, 16), h = f.slice(16, 24);
    d === "encrypt" ? this.ciphers = [
      i.create({ type: "encrypt", key: p }),
      i.create({ type: "decrypt", key: l }),
      i.create({ type: "encrypt", key: h })
    ] : this.ciphers = [
      i.create({ type: "decrypt", key: h }),
      i.create({ type: "encrypt", key: l }),
      i.create({ type: "decrypt", key: p })
    ];
  }
  function n(d) {
    o.call(this, d);
    var f = new c(this.type, this.options.key);
    this._edeState = f;
  }
  return t(n, o), tu = n, n.create = function(f) {
    return new n(f);
  }, n.prototype._update = function(f, p, l, h) {
    var y = this._edeState;
    y.ciphers[0]._update(f, p, l, h), y.ciphers[1]._update(l, h, l, h), y.ciphers[2]._update(l, h, l, h);
  }, n.prototype._pad = i.prototype._pad, n.prototype._unpad = i.prototype._unpad, tu;
}
var Cp;
function qN() {
  return Cp || (Cp = 1, Xi.utils = cM(), Xi.Cipher = Mh(), Xi.DES = lM(), Xi.CBC = GN(), Xi.EDE = $N()), Xi;
}
var ru, Ip;
function JN() {
  if (Ip) return ru;
  Ip = 1;
  var e = Qi(), t = qN(), o = Yt, i = Gt.Buffer, c = {
    "des-ede3-cbc": t.CBC.instantiate(t.EDE),
    "des-ede3": t.EDE,
    "des-ede-cbc": t.CBC.instantiate(t.EDE),
    "des-ede": t.EDE,
    "des-cbc": t.CBC.instantiate(t.DES),
    "des-ecb": t.DES
  };
  c.des = c["des-cbc"], c.des3 = c["des-ede3-cbc"], ru = n, o(n, e);
  function n(d) {
    e.call(this);
    var f = d.mode.toLowerCase(), p = c[f], l;
    d.decrypt ? l = "decrypt" : l = "encrypt";
    var h = d.key;
    i.isBuffer(h) || (h = i.from(h)), (f === "des-ede" || f === "des-ede-cbc") && (h = i.concat([h, h.slice(0, 8)]));
    var y = d.iv;
    i.isBuffer(y) || (y = i.from(y)), this._des = p.create({
      key: h,
      iv: y,
      type: l
    });
  }
  return n.prototype._update = function(d) {
    return i.from(this._des.update(d));
  }, n.prototype._final = function() {
    return i.from(this._des.final());
  }, ru;
}
var jn = {}, l0 = {}, f0 = {}, Np;
function XN() {
  return Np || (Np = 1, f0.encrypt = function(e, t) {
    return e._cipher.encryptBlock(t);
  }, f0.decrypt = function(e, t) {
    return e._cipher.decryptBlock(t);
  }), f0;
}
var u0 = {}, nu, Ap;
function Fs() {
  return Ap || (Ap = 1, nu = function(t, o) {
    for (var i = Math.min(t.length, o.length), c = new fe.Buffer(i), n = 0; n < i; ++n)
      c[n] = t[n] ^ o[n];
    return c;
  }), nu;
}
var Tp;
function KN() {
  if (Tp) return u0;
  Tp = 1;
  var e = Fs();
  return u0.encrypt = function(t, o) {
    var i = e(o, t._prev);
    return t._prev = t._cipher.encryptBlock(i), t._prev;
  }, u0.decrypt = function(t, o) {
    var i = t._prev;
    t._prev = o;
    var c = t._cipher.decryptBlock(o);
    return e(c, i);
  }, u0;
}
var iu = {}, Lp;
function eA() {
  if (Lp) return iu;
  Lp = 1;
  var e = Gt.Buffer, t = Fs();
  function o(i, c, n) {
    var d = c.length, f = t(c, i._cache);
    return i._cache = i._cache.slice(d), i._prev = e.concat([i._prev, n ? c : f]), f;
  }
  return iu.encrypt = function(i, c, n) {
    for (var d = e.allocUnsafe(0), f; c.length; )
      if (i._cache.length === 0 && (i._cache = i._cipher.encryptBlock(i._prev), i._prev = e.allocUnsafe(0)), i._cache.length <= c.length)
        f = i._cache.length, d = e.concat([d, o(i, c.slice(0, f), n)]), c = c.slice(f);
      else {
        d = e.concat([d, o(i, c, n)]);
        break;
      }
    return d;
  }, iu;
}
var ou = {}, Sp;
function tA() {
  if (Sp) return ou;
  Sp = 1;
  var e = Gt.Buffer;
  function t(o, i, c) {
    var n = o._cipher.encryptBlock(o._prev), d = n[0] ^ i;
    return o._prev = e.concat([
      o._prev.slice(1),
      e.from([c ? i : d])
    ]), d;
  }
  return ou.encrypt = function(o, i, c) {
    for (var n = i.length, d = e.allocUnsafe(n), f = -1; ++f < n; )
      d[f] = t(o, i[f], c);
    return d;
  }, ou;
}
var au = {}, Ep;
function rA() {
  if (Ep) return au;
  Ep = 1;
  var e = Gt.Buffer;
  function t(i, c, n) {
    for (var d, f = -1, p = 8, l = 0, h, y; ++f < p; )
      d = i._cipher.encryptBlock(i._prev), h = c & 1 << 7 - f ? 128 : 0, y = d[0] ^ h, l += (y & 128) >> f % 8, i._prev = o(i._prev, n ? h : y);
    return l;
  }
  function o(i, c) {
    var n = i.length, d = -1, f = e.allocUnsafe(i.length);
    for (i = e.concat([i, e.from([c])]); ++d < n; )
      f[d] = i[d] << 1 | i[d + 1] >> 7;
    return f;
  }
  return au.encrypt = function(i, c, n) {
    for (var d = c.length, f = e.allocUnsafe(d), p = -1; ++p < d; )
      f[p] = t(i, c[p], n);
    return f;
  }, au;
}
var su = {}, Dp;
function nA() {
  if (Dp) return su;
  Dp = 1;
  var e = Fs();
  function t(o) {
    return o._prev = o._cipher.encryptBlock(o._prev), o._prev;
  }
  return su.encrypt = function(o, i) {
    for (; o._cache.length < i.length; )
      o._cache = fe.Buffer.concat([o._cache, t(o)]);
    var c = o._cache.slice(0, i.length);
    return o._cache = o._cache.slice(i.length), e(i, c);
  }, su;
}
var cu = {}, lu, jp;
function fM() {
  if (jp) return lu;
  jp = 1;
  function e(t) {
    for (var o = t.length, i; o--; )
      if (i = t.readUInt8(o), i === 255)
        t.writeUInt8(0, o);
      else {
        i++, t.writeUInt8(i, o);
        break;
      }
  }
  return lu = e, lu;
}
var Op;
function zp() {
  if (Op) return cu;
  Op = 1;
  var e = Fs(), t = Gt.Buffer, o = fM();
  function i(n) {
    var d = n._cipher.encryptBlockRaw(n._prev);
    return o(n._prev), d;
  }
  var c = 16;
  return cu.encrypt = function(n, d) {
    var f = Math.ceil(d.length / c), p = n._cache.length;
    n._cache = t.concat([
      n._cache,
      t.allocUnsafe(f * c)
    ]);
    for (var l = 0; l < f; l++) {
      var h = i(n), y = p + l * c;
      n._cache.writeUInt32BE(h[0], y + 0), n._cache.writeUInt32BE(h[1], y + 4), n._cache.writeUInt32BE(h[2], y + 8), n._cache.writeUInt32BE(h[3], y + 12);
    }
    var M = n._cache.slice(0, d.length);
    return n._cache = n._cache.slice(d.length), e(d, M);
  }, cu;
}
const iA = {
  cipher: "AES",
  key: 128,
  iv: 16,
  mode: "CBC",
  type: "block"
}, oA = {
  cipher: "AES",
  key: 192,
  iv: 16,
  mode: "CBC",
  type: "block"
}, aA = {
  cipher: "AES",
  key: 256,
  iv: 16,
  mode: "CBC",
  type: "block"
}, uM = {
  "aes-128-ecb": {
    cipher: "AES",
    key: 128,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-192-ecb": {
    cipher: "AES",
    key: 192,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-256-ecb": {
    cipher: "AES",
    key: 256,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-128-cbc": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-192-cbc": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-256-cbc": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  aes128: iA,
  aes192: oA,
  aes256: aA,
  "aes-128-cfb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-192-cfb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-256-cfb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-128-cfb8": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-192-cfb8": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-256-cfb8": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-128-cfb1": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-192-cfb1": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-256-cfb1": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-128-ofb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-192-ofb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-256-ofb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-128-ctr": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-192-ctr": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-256-ctr": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-128-gcm": {
    cipher: "AES",
    key: 128,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-192-gcm": {
    cipher: "AES",
    key: 192,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-256-gcm": {
    cipher: "AES",
    key: 256,
    iv: 12,
    mode: "GCM",
    type: "auth"
  }
};
var fu, kp;
function mh() {
  if (kp) return fu;
  kp = 1;
  var e = {
    ECB: XN(),
    CBC: KN(),
    CFB: eA(),
    CFB8: tA(),
    CFB1: rA(),
    OFB: nA(),
    CTR: zp(),
    GCM: zp()
  }, t = uM;
  for (var o in t)
    t[o].module = e[t[o].mode];
  return fu = t, fu;
}
var uu = {}, _p;
function Zc() {
  if (_p) return uu;
  _p = 1;
  var e = Gt.Buffer;
  function t(f) {
    e.isBuffer(f) || (f = e.from(f));
    for (var p = f.length / 4 | 0, l = new Array(p), h = 0; h < p; h++)
      l[h] = f.readUInt32BE(h * 4);
    return l;
  }
  function o(f) {
    for (var p = 0; p < f.length; f++)
      f[p] = 0;
  }
  function i(f, p, l, h, y) {
    for (var M = l[0], C = l[1], N = l[2], w = l[3], S = f[0] ^ p[0], T = f[1] ^ p[1], E = f[2] ^ p[2], j = f[3] ^ p[3], O, z, k, H, W = 4, U = 1; U < y; U++)
      O = M[S >>> 24] ^ C[T >>> 16 & 255] ^ N[E >>> 8 & 255] ^ w[j & 255] ^ p[W++], z = M[T >>> 24] ^ C[E >>> 16 & 255] ^ N[j >>> 8 & 255] ^ w[S & 255] ^ p[W++], k = M[E >>> 24] ^ C[j >>> 16 & 255] ^ N[S >>> 8 & 255] ^ w[T & 255] ^ p[W++], H = M[j >>> 24] ^ C[S >>> 16 & 255] ^ N[T >>> 8 & 255] ^ w[E & 255] ^ p[W++], S = O, T = z, E = k, j = H;
    return O = (h[S >>> 24] << 24 | h[T >>> 16 & 255] << 16 | h[E >>> 8 & 255] << 8 | h[j & 255]) ^ p[W++], z = (h[T >>> 24] << 24 | h[E >>> 16 & 255] << 16 | h[j >>> 8 & 255] << 8 | h[S & 255]) ^ p[W++], k = (h[E >>> 24] << 24 | h[j >>> 16 & 255] << 16 | h[S >>> 8 & 255] << 8 | h[T & 255]) ^ p[W++], H = (h[j >>> 24] << 24 | h[S >>> 16 & 255] << 16 | h[T >>> 8 & 255] << 8 | h[E & 255]) ^ p[W++], O = O >>> 0, z = z >>> 0, k = k >>> 0, H = H >>> 0, [O, z, k, H];
  }
  var c = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], n = function() {
    for (var f = new Array(256), p = 0; p < 256; p++)
      p < 128 ? f[p] = p << 1 : f[p] = p << 1 ^ 283;
    for (var l = [], h = [], y = [[], [], [], []], M = [[], [], [], []], C = 0, N = 0, w = 0; w < 256; ++w) {
      var S = N ^ N << 1 ^ N << 2 ^ N << 3 ^ N << 4;
      S = S >>> 8 ^ S & 255 ^ 99, l[C] = S, h[S] = C;
      var T = f[C], E = f[T], j = f[E], O = f[S] * 257 ^ S * 16843008;
      y[0][C] = O << 24 | O >>> 8, y[1][C] = O << 16 | O >>> 16, y[2][C] = O << 8 | O >>> 24, y[3][C] = O, O = j * 16843009 ^ E * 65537 ^ T * 257 ^ C * 16843008, M[0][S] = O << 24 | O >>> 8, M[1][S] = O << 16 | O >>> 16, M[2][S] = O << 8 | O >>> 24, M[3][S] = O, C === 0 ? C = N = 1 : (C = T ^ f[f[f[j ^ T]]], N ^= f[f[N]]);
    }
    return {
      SBOX: l,
      INV_SBOX: h,
      SUB_MIX: y,
      INV_SUB_MIX: M
    };
  }();
  function d(f) {
    this._key = t(f), this._reset();
  }
  return d.blockSize = 4 * 4, d.keySize = 256 / 8, d.prototype.blockSize = d.blockSize, d.prototype.keySize = d.keySize, d.prototype._reset = function() {
    for (var f = this._key, p = f.length, l = p + 6, h = (l + 1) * 4, y = [], M = 0; M < p; M++)
      y[M] = f[M];
    for (M = p; M < h; M++) {
      var C = y[M - 1];
      M % p === 0 ? (C = C << 8 | C >>> 24, C = n.SBOX[C >>> 24] << 24 | n.SBOX[C >>> 16 & 255] << 16 | n.SBOX[C >>> 8 & 255] << 8 | n.SBOX[C & 255], C ^= c[M / p | 0] << 24) : p > 6 && M % p === 4 && (C = n.SBOX[C >>> 24] << 24 | n.SBOX[C >>> 16 & 255] << 16 | n.SBOX[C >>> 8 & 255] << 8 | n.SBOX[C & 255]), y[M] = y[M - p] ^ C;
    }
    for (var N = [], w = 0; w < h; w++) {
      var S = h - w, T = y[S - (w % 4 ? 0 : 4)];
      w < 4 || S <= 4 ? N[w] = T : N[w] = n.INV_SUB_MIX[0][n.SBOX[T >>> 24]] ^ n.INV_SUB_MIX[1][n.SBOX[T >>> 16 & 255]] ^ n.INV_SUB_MIX[2][n.SBOX[T >>> 8 & 255]] ^ n.INV_SUB_MIX[3][n.SBOX[T & 255]];
    }
    this._nRounds = l, this._keySchedule = y, this._invKeySchedule = N;
  }, d.prototype.encryptBlockRaw = function(f) {
    return f = t(f), i(f, this._keySchedule, n.SUB_MIX, n.SBOX, this._nRounds);
  }, d.prototype.encryptBlock = function(f) {
    var p = this.encryptBlockRaw(f), l = e.allocUnsafe(16);
    return l.writeUInt32BE(p[0], 0), l.writeUInt32BE(p[1], 4), l.writeUInt32BE(p[2], 8), l.writeUInt32BE(p[3], 12), l;
  }, d.prototype.decryptBlock = function(f) {
    f = t(f);
    var p = f[1];
    f[1] = f[3], f[3] = p;
    var l = i(f, this._invKeySchedule, n.INV_SUB_MIX, n.INV_SBOX, this._nRounds), h = e.allocUnsafe(16);
    return h.writeUInt32BE(l[0], 0), h.writeUInt32BE(l[3], 4), h.writeUInt32BE(l[2], 8), h.writeUInt32BE(l[1], 12), h;
  }, d.prototype.scrub = function() {
    o(this._keySchedule), o(this._invKeySchedule), o(this._key);
  }, uu.AES = d, uu;
}
var du, Bp;
function sA() {
  if (Bp) return du;
  Bp = 1;
  var e = Gt.Buffer, t = e.alloc(16, 0);
  function o(n) {
    return [
      n.readUInt32BE(0),
      n.readUInt32BE(4),
      n.readUInt32BE(8),
      n.readUInt32BE(12)
    ];
  }
  function i(n) {
    var d = e.allocUnsafe(16);
    return d.writeUInt32BE(n[0] >>> 0, 0), d.writeUInt32BE(n[1] >>> 0, 4), d.writeUInt32BE(n[2] >>> 0, 8), d.writeUInt32BE(n[3] >>> 0, 12), d;
  }
  function c(n) {
    this.h = n, this.state = e.alloc(16, 0), this.cache = e.allocUnsafe(0);
  }
  return c.prototype.ghash = function(n) {
    for (var d = -1; ++d < n.length; )
      this.state[d] ^= n[d];
    this._multiply();
  }, c.prototype._multiply = function() {
    for (var n = o(this.h), d = [0, 0, 0, 0], f, p, l, h = -1; ++h < 128; ) {
      for (p = (this.state[~~(h / 8)] & 1 << 7 - h % 8) !== 0, p && (d[0] ^= n[0], d[1] ^= n[1], d[2] ^= n[2], d[3] ^= n[3]), l = (n[3] & 1) !== 0, f = 3; f > 0; f--)
        n[f] = n[f] >>> 1 | (n[f - 1] & 1) << 31;
      n[0] = n[0] >>> 1, l && (n[0] = n[0] ^ 225 << 24);
    }
    this.state = i(d);
  }, c.prototype.update = function(n) {
    this.cache = e.concat([this.cache, n]);
    for (var d; this.cache.length >= 16; )
      d = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(d);
  }, c.prototype.final = function(n, d) {
    return this.cache.length && this.ghash(e.concat([this.cache, t], 16)), this.ghash(i([0, n, 0, d])), this.state;
  }, du = c, du;
}
var hu, Fp;
function dM() {
  if (Fp) return hu;
  Fp = 1;
  var e = Zc(), t = Gt.Buffer, o = Qi(), i = Yt, c = sA(), n = Fs(), d = fM();
  function f(h, y) {
    var M = 0;
    h.length !== y.length && M++;
    for (var C = Math.min(h.length, y.length), N = 0; N < C; ++N)
      M += h[N] ^ y[N];
    return M;
  }
  function p(h, y, M) {
    if (y.length === 12)
      return h._finID = t.concat([y, t.from([0, 0, 0, 1])]), t.concat([y, t.from([0, 0, 0, 2])]);
    var C = new c(M), N = y.length, w = N % 16;
    C.update(y), w && (w = 16 - w, C.update(t.alloc(w, 0))), C.update(t.alloc(8, 0));
    var S = N * 8, T = t.alloc(8);
    T.writeUIntBE(S, 0, 8), C.update(T), h._finID = C.state;
    var E = t.from(h._finID);
    return d(E), E;
  }
  function l(h, y, M, C) {
    o.call(this);
    var N = t.alloc(4, 0);
    this._cipher = new e.AES(y);
    var w = this._cipher.encryptBlock(N);
    this._ghash = new c(w), M = p(this, M, w), this._prev = t.from(M), this._cache = t.allocUnsafe(0), this._secCache = t.allocUnsafe(0), this._decrypt = C, this._alen = 0, this._len = 0, this._mode = h, this._authTag = null, this._called = !1;
  }
  return i(l, o), l.prototype._update = function(h) {
    if (!this._called && this._alen) {
      var y = 16 - this._alen % 16;
      y < 16 && (y = t.alloc(y, 0), this._ghash.update(y));
    }
    this._called = !0;
    var M = this._mode.encrypt(this, h);
    return this._decrypt ? this._ghash.update(h) : this._ghash.update(M), this._len += h.length, M;
  }, l.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var h = n(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && f(h, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = h, this._cipher.scrub();
  }, l.prototype.getAuthTag = function() {
    if (this._decrypt || !t.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
  }, l.prototype.setAuthTag = function(y) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = y;
  }, l.prototype.setAAD = function(y) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(y), this._alen += y.length;
  }, hu = l, hu;
}
var pu, Rp;
function hM() {
  if (Rp) return pu;
  Rp = 1;
  var e = Zc(), t = Gt.Buffer, o = Qi(), i = Yt;
  function c(n, d, f, p) {
    o.call(this), this._cipher = new e.AES(d), this._prev = t.from(f), this._cache = t.allocUnsafe(0), this._secCache = t.allocUnsafe(0), this._decrypt = p, this._mode = n;
  }
  return i(c, o), c.prototype._update = function(n) {
    return this._mode.encrypt(this, n, this._decrypt);
  }, c.prototype._final = function() {
    this._cipher.scrub();
  }, pu = c, pu;
}
var gu, Pp;
function Qc() {
  if (Pp) return gu;
  Pp = 1;
  var e = Gt.Buffer, t = fh();
  function o(i, c, n, d) {
    if (e.isBuffer(i) || (i = e.from(i, "binary")), c && (e.isBuffer(c) || (c = e.from(c, "binary")), c.length !== 8))
      throw new RangeError("salt should be Buffer with 8 byte length");
    for (var f = n / 8, p = e.alloc(f), l = e.alloc(d || 0), h = e.alloc(0); f > 0 || d > 0; ) {
      var y = new t();
      y.update(h), y.update(i), c && y.update(c), h = y.digest();
      var M = 0;
      if (f > 0) {
        var C = p.length - f;
        M = Math.min(f, h.length), h.copy(p, C, 0, M), f -= M;
      }
      if (M < h.length && d > 0) {
        var N = l.length - d, w = Math.min(d, h.length - M);
        h.copy(l, N, M, M + w), d -= w;
      }
    }
    return h.fill(0), { key: p, iv: l };
  }
  return gu = o, gu;
}
var Up;
function cA() {
  if (Up) return l0;
  Up = 1;
  var e = mh(), t = dM(), o = Gt.Buffer, i = hM(), c = Qi(), n = Zc(), d = Qc(), f = Yt;
  function p(C, N, w) {
    c.call(this), this._cache = new h(), this._cipher = new n.AES(N), this._prev = o.from(w), this._mode = C, this._autopadding = !0;
  }
  f(p, c), p.prototype._update = function(C) {
    this._cache.add(C);
    for (var N, w, S = []; N = this._cache.get(); )
      w = this._mode.encrypt(this, N), S.push(w);
    return o.concat(S);
  };
  var l = o.alloc(16, 16);
  p.prototype._final = function() {
    var C = this._cache.flush();
    if (this._autopadding)
      return C = this._mode.encrypt(this, C), this._cipher.scrub(), C;
    if (!C.equals(l))
      throw this._cipher.scrub(), new Error("data not multiple of block length");
  }, p.prototype.setAutoPadding = function(C) {
    return this._autopadding = !!C, this;
  };
  function h() {
    this.cache = o.allocUnsafe(0);
  }
  h.prototype.add = function(C) {
    this.cache = o.concat([this.cache, C]);
  }, h.prototype.get = function() {
    if (this.cache.length > 15) {
      var C = this.cache.slice(0, 16);
      return this.cache = this.cache.slice(16), C;
    }
    return null;
  }, h.prototype.flush = function() {
    for (var C = 16 - this.cache.length, N = o.allocUnsafe(C), w = -1; ++w < C; )
      N.writeUInt8(C, w);
    return o.concat([this.cache, N]);
  };
  function y(C, N, w) {
    var S = e[C.toLowerCase()];
    if (!S) throw new TypeError("invalid suite type");
    if (typeof N == "string" && (N = o.from(N)), N.length !== S.key / 8) throw new TypeError("invalid key length " + N.length);
    if (typeof w == "string" && (w = o.from(w)), S.mode !== "GCM" && w.length !== S.iv) throw new TypeError("invalid iv length " + w.length);
    return S.type === "stream" ? new i(S.module, N, w) : S.type === "auth" ? new t(S.module, N, w) : new p(S.module, N, w);
  }
  function M(C, N) {
    var w = e[C.toLowerCase()];
    if (!w) throw new TypeError("invalid suite type");
    var S = d(N, !1, w.key, w.iv);
    return y(C, S.key, S.iv);
  }
  return l0.createCipheriv = y, l0.createCipher = M, l0;
}
var d0 = {}, Yp;
function lA() {
  if (Yp) return d0;
  Yp = 1;
  var e = dM(), t = Gt.Buffer, o = mh(), i = hM(), c = Qi(), n = Zc(), d = Qc(), f = Yt;
  function p(C, N, w) {
    c.call(this), this._cache = new l(), this._last = void 0, this._cipher = new n.AES(N), this._prev = t.from(w), this._mode = C, this._autopadding = !0;
  }
  f(p, c), p.prototype._update = function(C) {
    this._cache.add(C);
    for (var N, w, S = []; N = this._cache.get(this._autopadding); )
      w = this._mode.decrypt(this, N), S.push(w);
    return t.concat(S);
  }, p.prototype._final = function() {
    var C = this._cache.flush();
    if (this._autopadding)
      return h(this._mode.decrypt(this, C));
    if (C)
      throw new Error("data not multiple of block length");
  }, p.prototype.setAutoPadding = function(C) {
    return this._autopadding = !!C, this;
  };
  function l() {
    this.cache = t.allocUnsafe(0);
  }
  l.prototype.add = function(C) {
    this.cache = t.concat([this.cache, C]);
  }, l.prototype.get = function(C) {
    var N;
    if (C) {
      if (this.cache.length > 16)
        return N = this.cache.slice(0, 16), this.cache = this.cache.slice(16), N;
    } else if (this.cache.length >= 16)
      return N = this.cache.slice(0, 16), this.cache = this.cache.slice(16), N;
    return null;
  }, l.prototype.flush = function() {
    if (this.cache.length) return this.cache;
  };
  function h(C) {
    var N = C[15];
    if (N < 1 || N > 16)
      throw new Error("unable to decrypt data");
    for (var w = -1; ++w < N; )
      if (C[w + (16 - N)] !== N)
        throw new Error("unable to decrypt data");
    if (N !== 16)
      return C.slice(0, 16 - N);
  }
  function y(C, N, w) {
    var S = o[C.toLowerCase()];
    if (!S) throw new TypeError("invalid suite type");
    if (typeof w == "string" && (w = t.from(w)), S.mode !== "GCM" && w.length !== S.iv) throw new TypeError("invalid iv length " + w.length);
    if (typeof N == "string" && (N = t.from(N)), N.length !== S.key / 8) throw new TypeError("invalid key length " + N.length);
    return S.type === "stream" ? new i(S.module, N, w, !0) : S.type === "auth" ? new e(S.module, N, w, !0) : new p(S.module, N, w);
  }
  function M(C, N) {
    var w = o[C.toLowerCase()];
    if (!w) throw new TypeError("invalid suite type");
    var S = d(N, !1, w.key, w.iv);
    return y(C, S.key, S.iv);
  }
  return d0.createDecipher = M, d0.createDecipheriv = y, d0;
}
var Wp;
function vh() {
  if (Wp) return jn;
  Wp = 1;
  var e = cA(), t = lA(), o = uM;
  function i() {
    return Object.keys(o);
  }
  return jn.createCipher = jn.Cipher = e.createCipher, jn.createCipheriv = jn.Cipheriv = e.createCipheriv, jn.createDecipher = jn.Decipher = t.createDecipher, jn.createDecipheriv = jn.Decipheriv = t.createDecipheriv, jn.listCiphers = jn.getCiphers = i, jn;
}
var yu = {}, Hp;
function fA() {
  return Hp || (Hp = 1, function(e) {
    e["des-ecb"] = {
      key: 8,
      iv: 0
    }, e["des-cbc"] = e.des = {
      key: 8,
      iv: 8
    }, e["des-ede3-cbc"] = e.des3 = {
      key: 24,
      iv: 8
    }, e["des-ede3"] = {
      key: 24,
      iv: 0
    }, e["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, e["des-ede"] = {
      key: 16,
      iv: 0
    };
  }(yu)), yu;
}
var Zp;
function uA() {
  if (Zp) return Dn;
  Zp = 1;
  var e = JN(), t = vh(), o = mh(), i = fA(), c = Qc();
  function n(h, y) {
    h = h.toLowerCase();
    var M, C;
    if (o[h])
      M = o[h].key, C = o[h].iv;
    else if (i[h])
      M = i[h].key * 8, C = i[h].iv;
    else
      throw new TypeError("invalid suite type");
    var N = c(y, !1, M, C);
    return f(h, N.key, N.iv);
  }
  function d(h, y) {
    h = h.toLowerCase();
    var M, C;
    if (o[h])
      M = o[h].key, C = o[h].iv;
    else if (i[h])
      M = i[h].key * 8, C = i[h].iv;
    else
      throw new TypeError("invalid suite type");
    var N = c(y, !1, M, C);
    return p(h, N.key, N.iv);
  }
  function f(h, y, M) {
    if (h = h.toLowerCase(), o[h]) return t.createCipheriv(h, y, M);
    if (i[h]) return new e({ key: y, iv: M, mode: h });
    throw new TypeError("invalid suite type");
  }
  function p(h, y, M) {
    if (h = h.toLowerCase(), o[h]) return t.createDecipheriv(h, y, M);
    if (i[h]) return new e({ key: y, iv: M, mode: h, decrypt: !0 });
    throw new TypeError("invalid suite type");
  }
  function l() {
    return Object.keys(i).concat(t.getCiphers());
  }
  return Dn.createCipher = Dn.Cipher = n, Dn.createCipheriv = Dn.Cipheriv = f, Dn.createDecipher = Dn.Decipher = d, Dn.createDecipheriv = Dn.Decipheriv = p, Dn.listCiphers = Dn.getCiphers = l, Dn;
}
var Ki = {}, Y0 = { exports: {} };
Y0.exports;
var Qp;
function pM() {
  return Qp || (Qp = 1, function(e) {
    (function(t, o) {
      function i(I, r) {
        if (!I) throw new Error(r || "Assertion failed");
      }
      function c(I, r) {
        I.super_ = r;
        var s = function() {
        };
        s.prototype = r.prototype, I.prototype = new s(), I.prototype.constructor = I;
      }
      function n(I, r, s) {
        if (n.isBN(I))
          return I;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, I !== null && ((r === "le" || r === "be") && (s = r, r = 10), this._init(I || 0, r || 10, s || "be"));
      }
      typeof t == "object" ? t.exports = n : o.BN = n, n.BN = n, n.wordSize = 26;
      var d;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? d = window.Buffer : d = Wr.Buffer;
      } catch {
      }
      n.isBN = function(r) {
        return r instanceof n ? !0 : r !== null && typeof r == "object" && r.constructor.wordSize === n.wordSize && Array.isArray(r.words);
      }, n.max = function(r, s) {
        return r.cmp(s) > 0 ? r : s;
      }, n.min = function(r, s) {
        return r.cmp(s) < 0 ? r : s;
      }, n.prototype._init = function(r, s, u) {
        if (typeof r == "number")
          return this._initNumber(r, s, u);
        if (typeof r == "object")
          return this._initArray(r, s, u);
        s === "hex" && (s = 16), i(s === (s | 0) && s >= 2 && s <= 36), r = r.toString().replace(/\s+/g, "");
        var g = 0;
        r[0] === "-" && (g++, this.negative = 1), g < r.length && (s === 16 ? this._parseHex(r, g, u) : (this._parseBase(r, s, g), u === "le" && this._initArray(this.toArray(), s, u)));
      }, n.prototype._initNumber = function(r, s, u) {
        r < 0 && (this.negative = 1, r = -r), r < 67108864 ? (this.words = [r & 67108863], this.length = 1) : r < 4503599627370496 ? (this.words = [
          r & 67108863,
          r / 67108864 & 67108863
        ], this.length = 2) : (i(r < 9007199254740992), this.words = [
          r & 67108863,
          r / 67108864 & 67108863,
          1
        ], this.length = 3), u === "le" && this._initArray(this.toArray(), s, u);
      }, n.prototype._initArray = function(r, s, u) {
        if (i(typeof r.length == "number"), r.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(r.length / 3), this.words = new Array(this.length);
        for (var g = 0; g < this.length; g++)
          this.words[g] = 0;
        var v, A, L = 0;
        if (u === "be")
          for (g = r.length - 1, v = 0; g >= 0; g -= 3)
            A = r[g] | r[g - 1] << 8 | r[g - 2] << 16, this.words[v] |= A << L & 67108863, this.words[v + 1] = A >>> 26 - L & 67108863, L += 24, L >= 26 && (L -= 26, v++);
        else if (u === "le")
          for (g = 0, v = 0; g < r.length; g += 3)
            A = r[g] | r[g + 1] << 8 | r[g + 2] << 16, this.words[v] |= A << L & 67108863, this.words[v + 1] = A >>> 26 - L & 67108863, L += 24, L >= 26 && (L -= 26, v++);
        return this.strip();
      };
      function f(I, r) {
        var s = I.charCodeAt(r);
        return s >= 65 && s <= 70 ? s - 55 : s >= 97 && s <= 102 ? s - 87 : s - 48 & 15;
      }
      function p(I, r, s) {
        var u = f(I, s);
        return s - 1 >= r && (u |= f(I, s - 1) << 4), u;
      }
      n.prototype._parseHex = function(r, s, u) {
        this.length = Math.ceil((r.length - s) / 6), this.words = new Array(this.length);
        for (var g = 0; g < this.length; g++)
          this.words[g] = 0;
        var v = 0, A = 0, L;
        if (u === "be")
          for (g = r.length - 1; g >= s; g -= 2)
            L = p(r, s, g) << v, this.words[A] |= L & 67108863, v >= 18 ? (v -= 18, A += 1, this.words[A] |= L >>> 26) : v += 8;
        else {
          var m = r.length - s;
          for (g = m % 2 === 0 ? s + 1 : s; g < r.length; g += 2)
            L = p(r, s, g) << v, this.words[A] |= L & 67108863, v >= 18 ? (v -= 18, A += 1, this.words[A] |= L >>> 26) : v += 8;
        }
        this.strip();
      };
      function l(I, r, s, u) {
        for (var g = 0, v = Math.min(I.length, s), A = r; A < v; A++) {
          var L = I.charCodeAt(A) - 48;
          g *= u, L >= 49 ? g += L - 49 + 10 : L >= 17 ? g += L - 17 + 10 : g += L;
        }
        return g;
      }
      n.prototype._parseBase = function(r, s, u) {
        this.words = [0], this.length = 1;
        for (var g = 0, v = 1; v <= 67108863; v *= s)
          g++;
        g--, v = v / s | 0;
        for (var A = r.length - u, L = A % g, m = Math.min(A, A - L) + u, a = 0, x = u; x < m; x += g)
          a = l(r, x, x + g, s), this.imuln(v), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        if (L !== 0) {
          var V = 1;
          for (a = l(r, x, r.length, s), x = 0; x < L; x++)
            V *= s;
          this.imuln(V), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        }
        this.strip();
      }, n.prototype.copy = function(r) {
        r.words = new Array(this.length);
        for (var s = 0; s < this.length; s++)
          r.words[s] = this.words[s];
        r.length = this.length, r.negative = this.negative, r.red = this.red;
      }, n.prototype.clone = function() {
        var r = new n(null);
        return this.copy(r), r;
      }, n.prototype._expand = function(r) {
        for (; this.length < r; )
          this.words[this.length++] = 0;
        return this;
      }, n.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, n.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, n.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var h = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], y = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], M = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      n.prototype.toString = function(r, s) {
        r = r || 10, s = s | 0 || 1;
        var u;
        if (r === 16 || r === "hex") {
          u = "";
          for (var g = 0, v = 0, A = 0; A < this.length; A++) {
            var L = this.words[A], m = ((L << g | v) & 16777215).toString(16);
            v = L >>> 24 - g & 16777215, g += 2, g >= 26 && (g -= 26, A--), v !== 0 || A !== this.length - 1 ? u = h[6 - m.length] + m + u : u = m + u;
          }
          for (v !== 0 && (u = v.toString(16) + u); u.length % s !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        if (r === (r | 0) && r >= 2 && r <= 36) {
          var a = y[r], x = M[r];
          u = "";
          var V = this.clone();
          for (V.negative = 0; !V.isZero(); ) {
            var G = V.modn(x).toString(r);
            V = V.idivn(x), V.isZero() ? u = G + u : u = h[a - G.length] + G + u;
          }
          for (this.isZero() && (u = "0" + u); u.length % s !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        i(!1, "Base should be between 2 and 36");
      }, n.prototype.toNumber = function() {
        var r = this.words[0];
        return this.length === 2 ? r += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? r += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -r : r;
      }, n.prototype.toJSON = function() {
        return this.toString(16);
      }, n.prototype.toBuffer = function(r, s) {
        return i(typeof d < "u"), this.toArrayLike(d, r, s);
      }, n.prototype.toArray = function(r, s) {
        return this.toArrayLike(Array, r, s);
      }, n.prototype.toArrayLike = function(r, s, u) {
        var g = this.byteLength(), v = u || Math.max(1, g);
        i(g <= v, "byte array longer than desired length"), i(v > 0, "Requested array length <= 0"), this.strip();
        var A = s === "le", L = new r(v), m, a, x = this.clone();
        if (A) {
          for (a = 0; !x.isZero(); a++)
            m = x.andln(255), x.iushrn(8), L[a] = m;
          for (; a < v; a++)
            L[a] = 0;
        } else {
          for (a = 0; a < v - g; a++)
            L[a] = 0;
          for (a = 0; !x.isZero(); a++)
            m = x.andln(255), x.iushrn(8), L[v - a - 1] = m;
        }
        return L;
      }, Math.clz32 ? n.prototype._countBits = function(r) {
        return 32 - Math.clz32(r);
      } : n.prototype._countBits = function(r) {
        var s = r, u = 0;
        return s >= 4096 && (u += 13, s >>>= 13), s >= 64 && (u += 7, s >>>= 7), s >= 8 && (u += 4, s >>>= 4), s >= 2 && (u += 2, s >>>= 2), u + s;
      }, n.prototype._zeroBits = function(r) {
        if (r === 0) return 26;
        var s = r, u = 0;
        return s & 8191 || (u += 13, s >>>= 13), s & 127 || (u += 7, s >>>= 7), s & 15 || (u += 4, s >>>= 4), s & 3 || (u += 2, s >>>= 2), s & 1 || u++, u;
      }, n.prototype.bitLength = function() {
        var r = this.words[this.length - 1], s = this._countBits(r);
        return (this.length - 1) * 26 + s;
      };
      function C(I) {
        for (var r = new Array(I.bitLength()), s = 0; s < r.length; s++) {
          var u = s / 26 | 0, g = s % 26;
          r[s] = (I.words[u] & 1 << g) >>> g;
        }
        return r;
      }
      n.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var r = 0, s = 0; s < this.length; s++) {
          var u = this._zeroBits(this.words[s]);
          if (r += u, u !== 26) break;
        }
        return r;
      }, n.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, n.prototype.toTwos = function(r) {
        return this.negative !== 0 ? this.abs().inotn(r).iaddn(1) : this.clone();
      }, n.prototype.fromTwos = function(r) {
        return this.testn(r - 1) ? this.notn(r).iaddn(1).ineg() : this.clone();
      }, n.prototype.isNeg = function() {
        return this.negative !== 0;
      }, n.prototype.neg = function() {
        return this.clone().ineg();
      }, n.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, n.prototype.iuor = function(r) {
        for (; this.length < r.length; )
          this.words[this.length++] = 0;
        for (var s = 0; s < r.length; s++)
          this.words[s] = this.words[s] | r.words[s];
        return this.strip();
      }, n.prototype.ior = function(r) {
        return i((this.negative | r.negative) === 0), this.iuor(r);
      }, n.prototype.or = function(r) {
        return this.length > r.length ? this.clone().ior(r) : r.clone().ior(this);
      }, n.prototype.uor = function(r) {
        return this.length > r.length ? this.clone().iuor(r) : r.clone().iuor(this);
      }, n.prototype.iuand = function(r) {
        var s;
        this.length > r.length ? s = r : s = this;
        for (var u = 0; u < s.length; u++)
          this.words[u] = this.words[u] & r.words[u];
        return this.length = s.length, this.strip();
      }, n.prototype.iand = function(r) {
        return i((this.negative | r.negative) === 0), this.iuand(r);
      }, n.prototype.and = function(r) {
        return this.length > r.length ? this.clone().iand(r) : r.clone().iand(this);
      }, n.prototype.uand = function(r) {
        return this.length > r.length ? this.clone().iuand(r) : r.clone().iuand(this);
      }, n.prototype.iuxor = function(r) {
        var s, u;
        this.length > r.length ? (s = this, u = r) : (s = r, u = this);
        for (var g = 0; g < u.length; g++)
          this.words[g] = s.words[g] ^ u.words[g];
        if (this !== s)
          for (; g < s.length; g++)
            this.words[g] = s.words[g];
        return this.length = s.length, this.strip();
      }, n.prototype.ixor = function(r) {
        return i((this.negative | r.negative) === 0), this.iuxor(r);
      }, n.prototype.xor = function(r) {
        return this.length > r.length ? this.clone().ixor(r) : r.clone().ixor(this);
      }, n.prototype.uxor = function(r) {
        return this.length > r.length ? this.clone().iuxor(r) : r.clone().iuxor(this);
      }, n.prototype.inotn = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = Math.ceil(r / 26) | 0, u = r % 26;
        this._expand(s), u > 0 && s--;
        for (var g = 0; g < s; g++)
          this.words[g] = ~this.words[g] & 67108863;
        return u > 0 && (this.words[g] = ~this.words[g] & 67108863 >> 26 - u), this.strip();
      }, n.prototype.notn = function(r) {
        return this.clone().inotn(r);
      }, n.prototype.setn = function(r, s) {
        i(typeof r == "number" && r >= 0);
        var u = r / 26 | 0, g = r % 26;
        return this._expand(u + 1), s ? this.words[u] = this.words[u] | 1 << g : this.words[u] = this.words[u] & ~(1 << g), this.strip();
      }, n.prototype.iadd = function(r) {
        var s;
        if (this.negative !== 0 && r.negative === 0)
          return this.negative = 0, s = this.isub(r), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && r.negative !== 0)
          return r.negative = 0, s = this.isub(r), r.negative = 1, s._normSign();
        var u, g;
        this.length > r.length ? (u = this, g = r) : (u = r, g = this);
        for (var v = 0, A = 0; A < g.length; A++)
          s = (u.words[A] | 0) + (g.words[A] | 0) + v, this.words[A] = s & 67108863, v = s >>> 26;
        for (; v !== 0 && A < u.length; A++)
          s = (u.words[A] | 0) + v, this.words[A] = s & 67108863, v = s >>> 26;
        if (this.length = u.length, v !== 0)
          this.words[this.length] = v, this.length++;
        else if (u !== this)
          for (; A < u.length; A++)
            this.words[A] = u.words[A];
        return this;
      }, n.prototype.add = function(r) {
        var s;
        return r.negative !== 0 && this.negative === 0 ? (r.negative = 0, s = this.sub(r), r.negative ^= 1, s) : r.negative === 0 && this.negative !== 0 ? (this.negative = 0, s = r.sub(this), this.negative = 1, s) : this.length > r.length ? this.clone().iadd(r) : r.clone().iadd(this);
      }, n.prototype.isub = function(r) {
        if (r.negative !== 0) {
          r.negative = 0;
          var s = this.iadd(r);
          return r.negative = 1, s._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(r), this.negative = 1, this._normSign();
        var u = this.cmp(r);
        if (u === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var g, v;
        u > 0 ? (g = this, v = r) : (g = r, v = this);
        for (var A = 0, L = 0; L < v.length; L++)
          s = (g.words[L] | 0) - (v.words[L] | 0) + A, A = s >> 26, this.words[L] = s & 67108863;
        for (; A !== 0 && L < g.length; L++)
          s = (g.words[L] | 0) + A, A = s >> 26, this.words[L] = s & 67108863;
        if (A === 0 && L < g.length && g !== this)
          for (; L < g.length; L++)
            this.words[L] = g.words[L];
        return this.length = Math.max(this.length, L), g !== this && (this.negative = 1), this.strip();
      }, n.prototype.sub = function(r) {
        return this.clone().isub(r);
      };
      function N(I, r, s) {
        s.negative = r.negative ^ I.negative;
        var u = I.length + r.length | 0;
        s.length = u, u = u - 1 | 0;
        var g = I.words[0] | 0, v = r.words[0] | 0, A = g * v, L = A & 67108863, m = A / 67108864 | 0;
        s.words[0] = L;
        for (var a = 1; a < u; a++) {
          for (var x = m >>> 26, V = m & 67108863, G = Math.min(a, r.length - 1), Z = Math.max(0, a - I.length + 1); Z <= G; Z++) {
            var te = a - Z | 0;
            g = I.words[te] | 0, v = r.words[Z] | 0, A = g * v + V, x += A / 67108864 | 0, V = A & 67108863;
          }
          s.words[a] = V | 0, m = x | 0;
        }
        return m !== 0 ? s.words[a] = m | 0 : s.length--, s.strip();
      }
      var w = function(r, s, u) {
        var g = r.words, v = s.words, A = u.words, L = 0, m, a, x, V = g[0] | 0, G = V & 8191, Z = V >>> 13, te = g[1] | 0, q = te & 8191, R = te >>> 13, Q = g[2] | 0, $ = Q & 8191, F = Q >>> 13, P = g[3] | 0, _ = P & 8191, X = P >>> 13, le = g[4] | 0, ie = le & 8191, oe = le >>> 13, pe = g[5] | 0, se = pe & 8191, ce = pe >>> 13, me = g[6] | 0, de = me & 8191, ae = me >>> 13, Le = g[7] | 0, ye = Le & 8191, Me = Le >>> 13, at = g[8] | 0, Ne = at & 8191, Ae = at >>> 13, pt = g[9] | 0, ke = pt & 8191, Te = pt >>> 13, Dt = v[0] | 0, De = Dt & 8191, je = Dt >>> 13, At = v[1] | 0, xe = At & 8191, Ie = At >>> 13, Nt = v[2] | 0, _e = Nt & 8191, Be = Nt >>> 13, Xt = v[3] | 0, Re = Xt & 8191, Pe = Xt >>> 13, dr = v[4] | 0, We = dr & 8191, He = dr >>> 13, Ct = v[5] | 0, Ue = Ct & 8191, Ze = Ct >>> 13, Fr = v[6] | 0, Ye = Fr & 8191, Qe = Fr >>> 13, J = v[7] | 0, ee = J & 8191, K = J >>> 13, Y = v[8] | 0, re = Y & 8191, he = Y >>> 13, Se = v[9] | 0, ve = Se & 8191, we = Se >>> 13;
        u.negative = r.negative ^ s.negative, u.length = 19, m = Math.imul(G, De), a = Math.imul(G, je), a = a + Math.imul(Z, De) | 0, x = Math.imul(Z, je);
        var lt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (lt >>> 26) | 0, lt &= 67108863, m = Math.imul(q, De), a = Math.imul(q, je), a = a + Math.imul(R, De) | 0, x = Math.imul(R, je), m = m + Math.imul(G, xe) | 0, a = a + Math.imul(G, Ie) | 0, a = a + Math.imul(Z, xe) | 0, x = x + Math.imul(Z, Ie) | 0;
        var et = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (et >>> 26) | 0, et &= 67108863, m = Math.imul($, De), a = Math.imul($, je), a = a + Math.imul(F, De) | 0, x = Math.imul(F, je), m = m + Math.imul(q, xe) | 0, a = a + Math.imul(q, Ie) | 0, a = a + Math.imul(R, xe) | 0, x = x + Math.imul(R, Ie) | 0, m = m + Math.imul(G, _e) | 0, a = a + Math.imul(G, Be) | 0, a = a + Math.imul(Z, _e) | 0, x = x + Math.imul(Z, Be) | 0;
        var Lt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Lt >>> 26) | 0, Lt &= 67108863, m = Math.imul(_, De), a = Math.imul(_, je), a = a + Math.imul(X, De) | 0, x = Math.imul(X, je), m = m + Math.imul($, xe) | 0, a = a + Math.imul($, Ie) | 0, a = a + Math.imul(F, xe) | 0, x = x + Math.imul(F, Ie) | 0, m = m + Math.imul(q, _e) | 0, a = a + Math.imul(q, Be) | 0, a = a + Math.imul(R, _e) | 0, x = x + Math.imul(R, Be) | 0, m = m + Math.imul(G, Re) | 0, a = a + Math.imul(G, Pe) | 0, a = a + Math.imul(Z, Re) | 0, x = x + Math.imul(Z, Pe) | 0;
        var nt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (nt >>> 26) | 0, nt &= 67108863, m = Math.imul(ie, De), a = Math.imul(ie, je), a = a + Math.imul(oe, De) | 0, x = Math.imul(oe, je), m = m + Math.imul(_, xe) | 0, a = a + Math.imul(_, Ie) | 0, a = a + Math.imul(X, xe) | 0, x = x + Math.imul(X, Ie) | 0, m = m + Math.imul($, _e) | 0, a = a + Math.imul($, Be) | 0, a = a + Math.imul(F, _e) | 0, x = x + Math.imul(F, Be) | 0, m = m + Math.imul(q, Re) | 0, a = a + Math.imul(q, Pe) | 0, a = a + Math.imul(R, Re) | 0, x = x + Math.imul(R, Pe) | 0, m = m + Math.imul(G, We) | 0, a = a + Math.imul(G, He) | 0, a = a + Math.imul(Z, We) | 0, x = x + Math.imul(Z, He) | 0;
        var gt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, m = Math.imul(se, De), a = Math.imul(se, je), a = a + Math.imul(ce, De) | 0, x = Math.imul(ce, je), m = m + Math.imul(ie, xe) | 0, a = a + Math.imul(ie, Ie) | 0, a = a + Math.imul(oe, xe) | 0, x = x + Math.imul(oe, Ie) | 0, m = m + Math.imul(_, _e) | 0, a = a + Math.imul(_, Be) | 0, a = a + Math.imul(X, _e) | 0, x = x + Math.imul(X, Be) | 0, m = m + Math.imul($, Re) | 0, a = a + Math.imul($, Pe) | 0, a = a + Math.imul(F, Re) | 0, x = x + Math.imul(F, Pe) | 0, m = m + Math.imul(q, We) | 0, a = a + Math.imul(q, He) | 0, a = a + Math.imul(R, We) | 0, x = x + Math.imul(R, He) | 0, m = m + Math.imul(G, Ue) | 0, a = a + Math.imul(G, Ze) | 0, a = a + Math.imul(Z, Ue) | 0, x = x + Math.imul(Z, Ze) | 0;
        var yt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, m = Math.imul(de, De), a = Math.imul(de, je), a = a + Math.imul(ae, De) | 0, x = Math.imul(ae, je), m = m + Math.imul(se, xe) | 0, a = a + Math.imul(se, Ie) | 0, a = a + Math.imul(ce, xe) | 0, x = x + Math.imul(ce, Ie) | 0, m = m + Math.imul(ie, _e) | 0, a = a + Math.imul(ie, Be) | 0, a = a + Math.imul(oe, _e) | 0, x = x + Math.imul(oe, Be) | 0, m = m + Math.imul(_, Re) | 0, a = a + Math.imul(_, Pe) | 0, a = a + Math.imul(X, Re) | 0, x = x + Math.imul(X, Pe) | 0, m = m + Math.imul($, We) | 0, a = a + Math.imul($, He) | 0, a = a + Math.imul(F, We) | 0, x = x + Math.imul(F, He) | 0, m = m + Math.imul(q, Ue) | 0, a = a + Math.imul(q, Ze) | 0, a = a + Math.imul(R, Ue) | 0, x = x + Math.imul(R, Ze) | 0, m = m + Math.imul(G, Ye) | 0, a = a + Math.imul(G, Qe) | 0, a = a + Math.imul(Z, Ye) | 0, x = x + Math.imul(Z, Qe) | 0;
        var xt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (xt >>> 26) | 0, xt &= 67108863, m = Math.imul(ye, De), a = Math.imul(ye, je), a = a + Math.imul(Me, De) | 0, x = Math.imul(Me, je), m = m + Math.imul(de, xe) | 0, a = a + Math.imul(de, Ie) | 0, a = a + Math.imul(ae, xe) | 0, x = x + Math.imul(ae, Ie) | 0, m = m + Math.imul(se, _e) | 0, a = a + Math.imul(se, Be) | 0, a = a + Math.imul(ce, _e) | 0, x = x + Math.imul(ce, Be) | 0, m = m + Math.imul(ie, Re) | 0, a = a + Math.imul(ie, Pe) | 0, a = a + Math.imul(oe, Re) | 0, x = x + Math.imul(oe, Pe) | 0, m = m + Math.imul(_, We) | 0, a = a + Math.imul(_, He) | 0, a = a + Math.imul(X, We) | 0, x = x + Math.imul(X, He) | 0, m = m + Math.imul($, Ue) | 0, a = a + Math.imul($, Ze) | 0, a = a + Math.imul(F, Ue) | 0, x = x + Math.imul(F, Ze) | 0, m = m + Math.imul(q, Ye) | 0, a = a + Math.imul(q, Qe) | 0, a = a + Math.imul(R, Ye) | 0, x = x + Math.imul(R, Qe) | 0, m = m + Math.imul(G, ee) | 0, a = a + Math.imul(G, K) | 0, a = a + Math.imul(Z, ee) | 0, x = x + Math.imul(Z, K) | 0;
        var bt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, m = Math.imul(Ne, De), a = Math.imul(Ne, je), a = a + Math.imul(Ae, De) | 0, x = Math.imul(Ae, je), m = m + Math.imul(ye, xe) | 0, a = a + Math.imul(ye, Ie) | 0, a = a + Math.imul(Me, xe) | 0, x = x + Math.imul(Me, Ie) | 0, m = m + Math.imul(de, _e) | 0, a = a + Math.imul(de, Be) | 0, a = a + Math.imul(ae, _e) | 0, x = x + Math.imul(ae, Be) | 0, m = m + Math.imul(se, Re) | 0, a = a + Math.imul(se, Pe) | 0, a = a + Math.imul(ce, Re) | 0, x = x + Math.imul(ce, Pe) | 0, m = m + Math.imul(ie, We) | 0, a = a + Math.imul(ie, He) | 0, a = a + Math.imul(oe, We) | 0, x = x + Math.imul(oe, He) | 0, m = m + Math.imul(_, Ue) | 0, a = a + Math.imul(_, Ze) | 0, a = a + Math.imul(X, Ue) | 0, x = x + Math.imul(X, Ze) | 0, m = m + Math.imul($, Ye) | 0, a = a + Math.imul($, Qe) | 0, a = a + Math.imul(F, Ye) | 0, x = x + Math.imul(F, Qe) | 0, m = m + Math.imul(q, ee) | 0, a = a + Math.imul(q, K) | 0, a = a + Math.imul(R, ee) | 0, x = x + Math.imul(R, K) | 0, m = m + Math.imul(G, re) | 0, a = a + Math.imul(G, he) | 0, a = a + Math.imul(Z, re) | 0, x = x + Math.imul(Z, he) | 0;
        var Mt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Mt >>> 26) | 0, Mt &= 67108863, m = Math.imul(ke, De), a = Math.imul(ke, je), a = a + Math.imul(Te, De) | 0, x = Math.imul(Te, je), m = m + Math.imul(Ne, xe) | 0, a = a + Math.imul(Ne, Ie) | 0, a = a + Math.imul(Ae, xe) | 0, x = x + Math.imul(Ae, Ie) | 0, m = m + Math.imul(ye, _e) | 0, a = a + Math.imul(ye, Be) | 0, a = a + Math.imul(Me, _e) | 0, x = x + Math.imul(Me, Be) | 0, m = m + Math.imul(de, Re) | 0, a = a + Math.imul(de, Pe) | 0, a = a + Math.imul(ae, Re) | 0, x = x + Math.imul(ae, Pe) | 0, m = m + Math.imul(se, We) | 0, a = a + Math.imul(se, He) | 0, a = a + Math.imul(ce, We) | 0, x = x + Math.imul(ce, He) | 0, m = m + Math.imul(ie, Ue) | 0, a = a + Math.imul(ie, Ze) | 0, a = a + Math.imul(oe, Ue) | 0, x = x + Math.imul(oe, Ze) | 0, m = m + Math.imul(_, Ye) | 0, a = a + Math.imul(_, Qe) | 0, a = a + Math.imul(X, Ye) | 0, x = x + Math.imul(X, Qe) | 0, m = m + Math.imul($, ee) | 0, a = a + Math.imul($, K) | 0, a = a + Math.imul(F, ee) | 0, x = x + Math.imul(F, K) | 0, m = m + Math.imul(q, re) | 0, a = a + Math.imul(q, he) | 0, a = a + Math.imul(R, re) | 0, x = x + Math.imul(R, he) | 0, m = m + Math.imul(G, ve) | 0, a = a + Math.imul(G, we) | 0, a = a + Math.imul(Z, ve) | 0, x = x + Math.imul(Z, we) | 0;
        var vt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, m = Math.imul(ke, xe), a = Math.imul(ke, Ie), a = a + Math.imul(Te, xe) | 0, x = Math.imul(Te, Ie), m = m + Math.imul(Ne, _e) | 0, a = a + Math.imul(Ne, Be) | 0, a = a + Math.imul(Ae, _e) | 0, x = x + Math.imul(Ae, Be) | 0, m = m + Math.imul(ye, Re) | 0, a = a + Math.imul(ye, Pe) | 0, a = a + Math.imul(Me, Re) | 0, x = x + Math.imul(Me, Pe) | 0, m = m + Math.imul(de, We) | 0, a = a + Math.imul(de, He) | 0, a = a + Math.imul(ae, We) | 0, x = x + Math.imul(ae, He) | 0, m = m + Math.imul(se, Ue) | 0, a = a + Math.imul(se, Ze) | 0, a = a + Math.imul(ce, Ue) | 0, x = x + Math.imul(ce, Ze) | 0, m = m + Math.imul(ie, Ye) | 0, a = a + Math.imul(ie, Qe) | 0, a = a + Math.imul(oe, Ye) | 0, x = x + Math.imul(oe, Qe) | 0, m = m + Math.imul(_, ee) | 0, a = a + Math.imul(_, K) | 0, a = a + Math.imul(X, ee) | 0, x = x + Math.imul(X, K) | 0, m = m + Math.imul($, re) | 0, a = a + Math.imul($, he) | 0, a = a + Math.imul(F, re) | 0, x = x + Math.imul(F, he) | 0, m = m + Math.imul(q, ve) | 0, a = a + Math.imul(q, we) | 0, a = a + Math.imul(R, ve) | 0, x = x + Math.imul(R, we) | 0;
        var mt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, m = Math.imul(ke, _e), a = Math.imul(ke, Be), a = a + Math.imul(Te, _e) | 0, x = Math.imul(Te, Be), m = m + Math.imul(Ne, Re) | 0, a = a + Math.imul(Ne, Pe) | 0, a = a + Math.imul(Ae, Re) | 0, x = x + Math.imul(Ae, Pe) | 0, m = m + Math.imul(ye, We) | 0, a = a + Math.imul(ye, He) | 0, a = a + Math.imul(Me, We) | 0, x = x + Math.imul(Me, He) | 0, m = m + Math.imul(de, Ue) | 0, a = a + Math.imul(de, Ze) | 0, a = a + Math.imul(ae, Ue) | 0, x = x + Math.imul(ae, Ze) | 0, m = m + Math.imul(se, Ye) | 0, a = a + Math.imul(se, Qe) | 0, a = a + Math.imul(ce, Ye) | 0, x = x + Math.imul(ce, Qe) | 0, m = m + Math.imul(ie, ee) | 0, a = a + Math.imul(ie, K) | 0, a = a + Math.imul(oe, ee) | 0, x = x + Math.imul(oe, K) | 0, m = m + Math.imul(_, re) | 0, a = a + Math.imul(_, he) | 0, a = a + Math.imul(X, re) | 0, x = x + Math.imul(X, he) | 0, m = m + Math.imul($, ve) | 0, a = a + Math.imul($, we) | 0, a = a + Math.imul(F, ve) | 0, x = x + Math.imul(F, we) | 0;
        var ot = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (ot >>> 26) | 0, ot &= 67108863, m = Math.imul(ke, Re), a = Math.imul(ke, Pe), a = a + Math.imul(Te, Re) | 0, x = Math.imul(Te, Pe), m = m + Math.imul(Ne, We) | 0, a = a + Math.imul(Ne, He) | 0, a = a + Math.imul(Ae, We) | 0, x = x + Math.imul(Ae, He) | 0, m = m + Math.imul(ye, Ue) | 0, a = a + Math.imul(ye, Ze) | 0, a = a + Math.imul(Me, Ue) | 0, x = x + Math.imul(Me, Ze) | 0, m = m + Math.imul(de, Ye) | 0, a = a + Math.imul(de, Qe) | 0, a = a + Math.imul(ae, Ye) | 0, x = x + Math.imul(ae, Qe) | 0, m = m + Math.imul(se, ee) | 0, a = a + Math.imul(se, K) | 0, a = a + Math.imul(ce, ee) | 0, x = x + Math.imul(ce, K) | 0, m = m + Math.imul(ie, re) | 0, a = a + Math.imul(ie, he) | 0, a = a + Math.imul(oe, re) | 0, x = x + Math.imul(oe, he) | 0, m = m + Math.imul(_, ve) | 0, a = a + Math.imul(_, we) | 0, a = a + Math.imul(X, ve) | 0, x = x + Math.imul(X, we) | 0;
        var ft = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (ft >>> 26) | 0, ft &= 67108863, m = Math.imul(ke, We), a = Math.imul(ke, He), a = a + Math.imul(Te, We) | 0, x = Math.imul(Te, He), m = m + Math.imul(Ne, Ue) | 0, a = a + Math.imul(Ne, Ze) | 0, a = a + Math.imul(Ae, Ue) | 0, x = x + Math.imul(Ae, Ze) | 0, m = m + Math.imul(ye, Ye) | 0, a = a + Math.imul(ye, Qe) | 0, a = a + Math.imul(Me, Ye) | 0, x = x + Math.imul(Me, Qe) | 0, m = m + Math.imul(de, ee) | 0, a = a + Math.imul(de, K) | 0, a = a + Math.imul(ae, ee) | 0, x = x + Math.imul(ae, K) | 0, m = m + Math.imul(se, re) | 0, a = a + Math.imul(se, he) | 0, a = a + Math.imul(ce, re) | 0, x = x + Math.imul(ce, he) | 0, m = m + Math.imul(ie, ve) | 0, a = a + Math.imul(ie, we) | 0, a = a + Math.imul(oe, ve) | 0, x = x + Math.imul(oe, we) | 0;
        var rt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (rt >>> 26) | 0, rt &= 67108863, m = Math.imul(ke, Ue), a = Math.imul(ke, Ze), a = a + Math.imul(Te, Ue) | 0, x = Math.imul(Te, Ze), m = m + Math.imul(Ne, Ye) | 0, a = a + Math.imul(Ne, Qe) | 0, a = a + Math.imul(Ae, Ye) | 0, x = x + Math.imul(Ae, Qe) | 0, m = m + Math.imul(ye, ee) | 0, a = a + Math.imul(ye, K) | 0, a = a + Math.imul(Me, ee) | 0, x = x + Math.imul(Me, K) | 0, m = m + Math.imul(de, re) | 0, a = a + Math.imul(de, he) | 0, a = a + Math.imul(ae, re) | 0, x = x + Math.imul(ae, he) | 0, m = m + Math.imul(se, ve) | 0, a = a + Math.imul(se, we) | 0, a = a + Math.imul(ce, ve) | 0, x = x + Math.imul(ce, we) | 0;
        var st = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (st >>> 26) | 0, st &= 67108863, m = Math.imul(ke, Ye), a = Math.imul(ke, Qe), a = a + Math.imul(Te, Ye) | 0, x = Math.imul(Te, Qe), m = m + Math.imul(Ne, ee) | 0, a = a + Math.imul(Ne, K) | 0, a = a + Math.imul(Ae, ee) | 0, x = x + Math.imul(Ae, K) | 0, m = m + Math.imul(ye, re) | 0, a = a + Math.imul(ye, he) | 0, a = a + Math.imul(Me, re) | 0, x = x + Math.imul(Me, he) | 0, m = m + Math.imul(de, ve) | 0, a = a + Math.imul(de, we) | 0, a = a + Math.imul(ae, ve) | 0, x = x + Math.imul(ae, we) | 0;
        var ct = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (ct >>> 26) | 0, ct &= 67108863, m = Math.imul(ke, ee), a = Math.imul(ke, K), a = a + Math.imul(Te, ee) | 0, x = Math.imul(Te, K), m = m + Math.imul(Ne, re) | 0, a = a + Math.imul(Ne, he) | 0, a = a + Math.imul(Ae, re) | 0, x = x + Math.imul(Ae, he) | 0, m = m + Math.imul(ye, ve) | 0, a = a + Math.imul(ye, we) | 0, a = a + Math.imul(Me, ve) | 0, x = x + Math.imul(Me, we) | 0;
        var Je = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Je >>> 26) | 0, Je &= 67108863, m = Math.imul(ke, re), a = Math.imul(ke, he), a = a + Math.imul(Te, re) | 0, x = Math.imul(Te, he), m = m + Math.imul(Ne, ve) | 0, a = a + Math.imul(Ne, we) | 0, a = a + Math.imul(Ae, ve) | 0, x = x + Math.imul(Ae, we) | 0;
        var Oe = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, m = Math.imul(ke, ve), a = Math.imul(ke, we), a = a + Math.imul(Te, ve) | 0, x = Math.imul(Te, we);
        var ze = (L + m | 0) + ((a & 8191) << 13) | 0;
        return L = (x + (a >>> 13) | 0) + (ze >>> 26) | 0, ze &= 67108863, A[0] = lt, A[1] = et, A[2] = Lt, A[3] = nt, A[4] = gt, A[5] = yt, A[6] = xt, A[7] = bt, A[8] = Mt, A[9] = vt, A[10] = mt, A[11] = ot, A[12] = ft, A[13] = rt, A[14] = st, A[15] = ct, A[16] = Je, A[17] = Oe, A[18] = ze, L !== 0 && (A[19] = L, u.length++), u;
      };
      Math.imul || (w = N);
      function S(I, r, s) {
        s.negative = r.negative ^ I.negative, s.length = I.length + r.length;
        for (var u = 0, g = 0, v = 0; v < s.length - 1; v++) {
          var A = g;
          g = 0;
          for (var L = u & 67108863, m = Math.min(v, r.length - 1), a = Math.max(0, v - I.length + 1); a <= m; a++) {
            var x = v - a, V = I.words[x] | 0, G = r.words[a] | 0, Z = V * G, te = Z & 67108863;
            A = A + (Z / 67108864 | 0) | 0, te = te + L | 0, L = te & 67108863, A = A + (te >>> 26) | 0, g += A >>> 26, A &= 67108863;
          }
          s.words[v] = L, u = A, A = g;
        }
        return u !== 0 ? s.words[v] = u : s.length--, s.strip();
      }
      function T(I, r, s) {
        var u = new E();
        return u.mulp(I, r, s);
      }
      n.prototype.mulTo = function(r, s) {
        var u, g = this.length + r.length;
        return this.length === 10 && r.length === 10 ? u = w(this, r, s) : g < 63 ? u = N(this, r, s) : g < 1024 ? u = S(this, r, s) : u = T(this, r, s), u;
      };
      function E(I, r) {
        this.x = I, this.y = r;
      }
      E.prototype.makeRBT = function(r) {
        for (var s = new Array(r), u = n.prototype._countBits(r) - 1, g = 0; g < r; g++)
          s[g] = this.revBin(g, u, r);
        return s;
      }, E.prototype.revBin = function(r, s, u) {
        if (r === 0 || r === u - 1) return r;
        for (var g = 0, v = 0; v < s; v++)
          g |= (r & 1) << s - v - 1, r >>= 1;
        return g;
      }, E.prototype.permute = function(r, s, u, g, v, A) {
        for (var L = 0; L < A; L++)
          g[L] = s[r[L]], v[L] = u[r[L]];
      }, E.prototype.transform = function(r, s, u, g, v, A) {
        this.permute(A, r, s, u, g, v);
        for (var L = 1; L < v; L <<= 1)
          for (var m = L << 1, a = Math.cos(2 * Math.PI / m), x = Math.sin(2 * Math.PI / m), V = 0; V < v; V += m)
            for (var G = a, Z = x, te = 0; te < L; te++) {
              var q = u[V + te], R = g[V + te], Q = u[V + te + L], $ = g[V + te + L], F = G * Q - Z * $;
              $ = G * $ + Z * Q, Q = F, u[V + te] = q + Q, g[V + te] = R + $, u[V + te + L] = q - Q, g[V + te + L] = R - $, te !== m && (F = a * G - x * Z, Z = a * Z + x * G, G = F);
            }
      }, E.prototype.guessLen13b = function(r, s) {
        var u = Math.max(s, r) | 1, g = u & 1, v = 0;
        for (u = u / 2 | 0; u; u = u >>> 1)
          v++;
        return 1 << v + 1 + g;
      }, E.prototype.conjugate = function(r, s, u) {
        if (!(u <= 1))
          for (var g = 0; g < u / 2; g++) {
            var v = r[g];
            r[g] = r[u - g - 1], r[u - g - 1] = v, v = s[g], s[g] = -s[u - g - 1], s[u - g - 1] = -v;
          }
      }, E.prototype.normalize13b = function(r, s) {
        for (var u = 0, g = 0; g < s / 2; g++) {
          var v = Math.round(r[2 * g + 1] / s) * 8192 + Math.round(r[2 * g] / s) + u;
          r[g] = v & 67108863, v < 67108864 ? u = 0 : u = v / 67108864 | 0;
        }
        return r;
      }, E.prototype.convert13b = function(r, s, u, g) {
        for (var v = 0, A = 0; A < s; A++)
          v = v + (r[A] | 0), u[2 * A] = v & 8191, v = v >>> 13, u[2 * A + 1] = v & 8191, v = v >>> 13;
        for (A = 2 * s; A < g; ++A)
          u[A] = 0;
        i(v === 0), i((v & -8192) === 0);
      }, E.prototype.stub = function(r) {
        for (var s = new Array(r), u = 0; u < r; u++)
          s[u] = 0;
        return s;
      }, E.prototype.mulp = function(r, s, u) {
        var g = 2 * this.guessLen13b(r.length, s.length), v = this.makeRBT(g), A = this.stub(g), L = new Array(g), m = new Array(g), a = new Array(g), x = new Array(g), V = new Array(g), G = new Array(g), Z = u.words;
        Z.length = g, this.convert13b(r.words, r.length, L, g), this.convert13b(s.words, s.length, x, g), this.transform(L, A, m, a, g, v), this.transform(x, A, V, G, g, v);
        for (var te = 0; te < g; te++) {
          var q = m[te] * V[te] - a[te] * G[te];
          a[te] = m[te] * G[te] + a[te] * V[te], m[te] = q;
        }
        return this.conjugate(m, a, g), this.transform(m, a, Z, A, g, v), this.conjugate(Z, A, g), this.normalize13b(Z, g), u.negative = r.negative ^ s.negative, u.length = r.length + s.length, u.strip();
      }, n.prototype.mul = function(r) {
        var s = new n(null);
        return s.words = new Array(this.length + r.length), this.mulTo(r, s);
      }, n.prototype.mulf = function(r) {
        var s = new n(null);
        return s.words = new Array(this.length + r.length), T(this, r, s);
      }, n.prototype.imul = function(r) {
        return this.clone().mulTo(r, this);
      }, n.prototype.imuln = function(r) {
        i(typeof r == "number"), i(r < 67108864);
        for (var s = 0, u = 0; u < this.length; u++) {
          var g = (this.words[u] | 0) * r, v = (g & 67108863) + (s & 67108863);
          s >>= 26, s += g / 67108864 | 0, s += v >>> 26, this.words[u] = v & 67108863;
        }
        return s !== 0 && (this.words[u] = s, this.length++), this.length = r === 0 ? 1 : this.length, this;
      }, n.prototype.muln = function(r) {
        return this.clone().imuln(r);
      }, n.prototype.sqr = function() {
        return this.mul(this);
      }, n.prototype.isqr = function() {
        return this.imul(this.clone());
      }, n.prototype.pow = function(r) {
        var s = C(r);
        if (s.length === 0) return new n(1);
        for (var u = this, g = 0; g < s.length && s[g] === 0; g++, u = u.sqr())
          ;
        if (++g < s.length)
          for (var v = u.sqr(); g < s.length; g++, v = v.sqr())
            s[g] !== 0 && (u = u.mul(v));
        return u;
      }, n.prototype.iushln = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = r % 26, u = (r - s) / 26, g = 67108863 >>> 26 - s << 26 - s, v;
        if (s !== 0) {
          var A = 0;
          for (v = 0; v < this.length; v++) {
            var L = this.words[v] & g, m = (this.words[v] | 0) - L << s;
            this.words[v] = m | A, A = L >>> 26 - s;
          }
          A && (this.words[v] = A, this.length++);
        }
        if (u !== 0) {
          for (v = this.length - 1; v >= 0; v--)
            this.words[v + u] = this.words[v];
          for (v = 0; v < u; v++)
            this.words[v] = 0;
          this.length += u;
        }
        return this.strip();
      }, n.prototype.ishln = function(r) {
        return i(this.negative === 0), this.iushln(r);
      }, n.prototype.iushrn = function(r, s, u) {
        i(typeof r == "number" && r >= 0);
        var g;
        s ? g = (s - s % 26) / 26 : g = 0;
        var v = r % 26, A = Math.min((r - v) / 26, this.length), L = 67108863 ^ 67108863 >>> v << v, m = u;
        if (g -= A, g = Math.max(0, g), m) {
          for (var a = 0; a < A; a++)
            m.words[a] = this.words[a];
          m.length = A;
        }
        if (A !== 0) if (this.length > A)
          for (this.length -= A, a = 0; a < this.length; a++)
            this.words[a] = this.words[a + A];
        else
          this.words[0] = 0, this.length = 1;
        var x = 0;
        for (a = this.length - 1; a >= 0 && (x !== 0 || a >= g); a--) {
          var V = this.words[a] | 0;
          this.words[a] = x << 26 - v | V >>> v, x = V & L;
        }
        return m && x !== 0 && (m.words[m.length++] = x), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, n.prototype.ishrn = function(r, s, u) {
        return i(this.negative === 0), this.iushrn(r, s, u);
      }, n.prototype.shln = function(r) {
        return this.clone().ishln(r);
      }, n.prototype.ushln = function(r) {
        return this.clone().iushln(r);
      }, n.prototype.shrn = function(r) {
        return this.clone().ishrn(r);
      }, n.prototype.ushrn = function(r) {
        return this.clone().iushrn(r);
      }, n.prototype.testn = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = r % 26, u = (r - s) / 26, g = 1 << s;
        if (this.length <= u) return !1;
        var v = this.words[u];
        return !!(v & g);
      }, n.prototype.imaskn = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = r % 26, u = (r - s) / 26;
        if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= u)
          return this;
        if (s !== 0 && u++, this.length = Math.min(u, this.length), s !== 0) {
          var g = 67108863 ^ 67108863 >>> s << s;
          this.words[this.length - 1] &= g;
        }
        return this.strip();
      }, n.prototype.maskn = function(r) {
        return this.clone().imaskn(r);
      }, n.prototype.iaddn = function(r) {
        return i(typeof r == "number"), i(r < 67108864), r < 0 ? this.isubn(-r) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < r ? (this.words[0] = r - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(r), this.negative = 1, this) : this._iaddn(r);
      }, n.prototype._iaddn = function(r) {
        this.words[0] += r;
        for (var s = 0; s < this.length && this.words[s] >= 67108864; s++)
          this.words[s] -= 67108864, s === this.length - 1 ? this.words[s + 1] = 1 : this.words[s + 1]++;
        return this.length = Math.max(this.length, s + 1), this;
      }, n.prototype.isubn = function(r) {
        if (i(typeof r == "number"), i(r < 67108864), r < 0) return this.iaddn(-r);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(r), this.negative = 1, this;
        if (this.words[0] -= r, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var s = 0; s < this.length && this.words[s] < 0; s++)
            this.words[s] += 67108864, this.words[s + 1] -= 1;
        return this.strip();
      }, n.prototype.addn = function(r) {
        return this.clone().iaddn(r);
      }, n.prototype.subn = function(r) {
        return this.clone().isubn(r);
      }, n.prototype.iabs = function() {
        return this.negative = 0, this;
      }, n.prototype.abs = function() {
        return this.clone().iabs();
      }, n.prototype._ishlnsubmul = function(r, s, u) {
        var g = r.length + u, v;
        this._expand(g);
        var A, L = 0;
        for (v = 0; v < r.length; v++) {
          A = (this.words[v + u] | 0) + L;
          var m = (r.words[v] | 0) * s;
          A -= m & 67108863, L = (A >> 26) - (m / 67108864 | 0), this.words[v + u] = A & 67108863;
        }
        for (; v < this.length - u; v++)
          A = (this.words[v + u] | 0) + L, L = A >> 26, this.words[v + u] = A & 67108863;
        if (L === 0) return this.strip();
        for (i(L === -1), L = 0, v = 0; v < this.length; v++)
          A = -(this.words[v] | 0) + L, L = A >> 26, this.words[v] = A & 67108863;
        return this.negative = 1, this.strip();
      }, n.prototype._wordDiv = function(r, s) {
        var u = this.length - r.length, g = this.clone(), v = r, A = v.words[v.length - 1] | 0, L = this._countBits(A);
        u = 26 - L, u !== 0 && (v = v.ushln(u), g.iushln(u), A = v.words[v.length - 1] | 0);
        var m = g.length - v.length, a;
        if (s !== "mod") {
          a = new n(null), a.length = m + 1, a.words = new Array(a.length);
          for (var x = 0; x < a.length; x++)
            a.words[x] = 0;
        }
        var V = g.clone()._ishlnsubmul(v, 1, m);
        V.negative === 0 && (g = V, a && (a.words[m] = 1));
        for (var G = m - 1; G >= 0; G--) {
          var Z = (g.words[v.length + G] | 0) * 67108864 + (g.words[v.length + G - 1] | 0);
          for (Z = Math.min(Z / A | 0, 67108863), g._ishlnsubmul(v, Z, G); g.negative !== 0; )
            Z--, g.negative = 0, g._ishlnsubmul(v, 1, G), g.isZero() || (g.negative ^= 1);
          a && (a.words[G] = Z);
        }
        return a && a.strip(), g.strip(), s !== "div" && u !== 0 && g.iushrn(u), {
          div: a || null,
          mod: g
        };
      }, n.prototype.divmod = function(r, s, u) {
        if (i(!r.isZero()), this.isZero())
          return {
            div: new n(0),
            mod: new n(0)
          };
        var g, v, A;
        return this.negative !== 0 && r.negative === 0 ? (A = this.neg().divmod(r, s), s !== "mod" && (g = A.div.neg()), s !== "div" && (v = A.mod.neg(), u && v.negative !== 0 && v.iadd(r)), {
          div: g,
          mod: v
        }) : this.negative === 0 && r.negative !== 0 ? (A = this.divmod(r.neg(), s), s !== "mod" && (g = A.div.neg()), {
          div: g,
          mod: A.mod
        }) : this.negative & r.negative ? (A = this.neg().divmod(r.neg(), s), s !== "div" && (v = A.mod.neg(), u && v.negative !== 0 && v.isub(r)), {
          div: A.div,
          mod: v
        }) : r.length > this.length || this.cmp(r) < 0 ? {
          div: new n(0),
          mod: this
        } : r.length === 1 ? s === "div" ? {
          div: this.divn(r.words[0]),
          mod: null
        } : s === "mod" ? {
          div: null,
          mod: new n(this.modn(r.words[0]))
        } : {
          div: this.divn(r.words[0]),
          mod: new n(this.modn(r.words[0]))
        } : this._wordDiv(r, s);
      }, n.prototype.div = function(r) {
        return this.divmod(r, "div", !1).div;
      }, n.prototype.mod = function(r) {
        return this.divmod(r, "mod", !1).mod;
      }, n.prototype.umod = function(r) {
        return this.divmod(r, "mod", !0).mod;
      }, n.prototype.divRound = function(r) {
        var s = this.divmod(r);
        if (s.mod.isZero()) return s.div;
        var u = s.div.negative !== 0 ? s.mod.isub(r) : s.mod, g = r.ushrn(1), v = r.andln(1), A = u.cmp(g);
        return A < 0 || v === 1 && A === 0 ? s.div : s.div.negative !== 0 ? s.div.isubn(1) : s.div.iaddn(1);
      }, n.prototype.modn = function(r) {
        i(r <= 67108863);
        for (var s = (1 << 26) % r, u = 0, g = this.length - 1; g >= 0; g--)
          u = (s * u + (this.words[g] | 0)) % r;
        return u;
      }, n.prototype.idivn = function(r) {
        i(r <= 67108863);
        for (var s = 0, u = this.length - 1; u >= 0; u--) {
          var g = (this.words[u] | 0) + s * 67108864;
          this.words[u] = g / r | 0, s = g % r;
        }
        return this.strip();
      }, n.prototype.divn = function(r) {
        return this.clone().idivn(r);
      }, n.prototype.egcd = function(r) {
        i(r.negative === 0), i(!r.isZero());
        var s = this, u = r.clone();
        s.negative !== 0 ? s = s.umod(r) : s = s.clone();
        for (var g = new n(1), v = new n(0), A = new n(0), L = new n(1), m = 0; s.isEven() && u.isEven(); )
          s.iushrn(1), u.iushrn(1), ++m;
        for (var a = u.clone(), x = s.clone(); !s.isZero(); ) {
          for (var V = 0, G = 1; !(s.words[0] & G) && V < 26; ++V, G <<= 1) ;
          if (V > 0)
            for (s.iushrn(V); V-- > 0; )
              (g.isOdd() || v.isOdd()) && (g.iadd(a), v.isub(x)), g.iushrn(1), v.iushrn(1);
          for (var Z = 0, te = 1; !(u.words[0] & te) && Z < 26; ++Z, te <<= 1) ;
          if (Z > 0)
            for (u.iushrn(Z); Z-- > 0; )
              (A.isOdd() || L.isOdd()) && (A.iadd(a), L.isub(x)), A.iushrn(1), L.iushrn(1);
          s.cmp(u) >= 0 ? (s.isub(u), g.isub(A), v.isub(L)) : (u.isub(s), A.isub(g), L.isub(v));
        }
        return {
          a: A,
          b: L,
          gcd: u.iushln(m)
        };
      }, n.prototype._invmp = function(r) {
        i(r.negative === 0), i(!r.isZero());
        var s = this, u = r.clone();
        s.negative !== 0 ? s = s.umod(r) : s = s.clone();
        for (var g = new n(1), v = new n(0), A = u.clone(); s.cmpn(1) > 0 && u.cmpn(1) > 0; ) {
          for (var L = 0, m = 1; !(s.words[0] & m) && L < 26; ++L, m <<= 1) ;
          if (L > 0)
            for (s.iushrn(L); L-- > 0; )
              g.isOdd() && g.iadd(A), g.iushrn(1);
          for (var a = 0, x = 1; !(u.words[0] & x) && a < 26; ++a, x <<= 1) ;
          if (a > 0)
            for (u.iushrn(a); a-- > 0; )
              v.isOdd() && v.iadd(A), v.iushrn(1);
          s.cmp(u) >= 0 ? (s.isub(u), g.isub(v)) : (u.isub(s), v.isub(g));
        }
        var V;
        return s.cmpn(1) === 0 ? V = g : V = v, V.cmpn(0) < 0 && V.iadd(r), V;
      }, n.prototype.gcd = function(r) {
        if (this.isZero()) return r.abs();
        if (r.isZero()) return this.abs();
        var s = this.clone(), u = r.clone();
        s.negative = 0, u.negative = 0;
        for (var g = 0; s.isEven() && u.isEven(); g++)
          s.iushrn(1), u.iushrn(1);
        do {
          for (; s.isEven(); )
            s.iushrn(1);
          for (; u.isEven(); )
            u.iushrn(1);
          var v = s.cmp(u);
          if (v < 0) {
            var A = s;
            s = u, u = A;
          } else if (v === 0 || u.cmpn(1) === 0)
            break;
          s.isub(u);
        } while (!0);
        return u.iushln(g);
      }, n.prototype.invm = function(r) {
        return this.egcd(r).a.umod(r);
      }, n.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, n.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, n.prototype.andln = function(r) {
        return this.words[0] & r;
      }, n.prototype.bincn = function(r) {
        i(typeof r == "number");
        var s = r % 26, u = (r - s) / 26, g = 1 << s;
        if (this.length <= u)
          return this._expand(u + 1), this.words[u] |= g, this;
        for (var v = g, A = u; v !== 0 && A < this.length; A++) {
          var L = this.words[A] | 0;
          L += v, v = L >>> 26, L &= 67108863, this.words[A] = L;
        }
        return v !== 0 && (this.words[A] = v, this.length++), this;
      }, n.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, n.prototype.cmpn = function(r) {
        var s = r < 0;
        if (this.negative !== 0 && !s) return -1;
        if (this.negative === 0 && s) return 1;
        this.strip();
        var u;
        if (this.length > 1)
          u = 1;
        else {
          s && (r = -r), i(r <= 67108863, "Number is too big");
          var g = this.words[0] | 0;
          u = g === r ? 0 : g < r ? -1 : 1;
        }
        return this.negative !== 0 ? -u | 0 : u;
      }, n.prototype.cmp = function(r) {
        if (this.negative !== 0 && r.negative === 0) return -1;
        if (this.negative === 0 && r.negative !== 0) return 1;
        var s = this.ucmp(r);
        return this.negative !== 0 ? -s | 0 : s;
      }, n.prototype.ucmp = function(r) {
        if (this.length > r.length) return 1;
        if (this.length < r.length) return -1;
        for (var s = 0, u = this.length - 1; u >= 0; u--) {
          var g = this.words[u] | 0, v = r.words[u] | 0;
          if (g !== v) {
            g < v ? s = -1 : g > v && (s = 1);
            break;
          }
        }
        return s;
      }, n.prototype.gtn = function(r) {
        return this.cmpn(r) === 1;
      }, n.prototype.gt = function(r) {
        return this.cmp(r) === 1;
      }, n.prototype.gten = function(r) {
        return this.cmpn(r) >= 0;
      }, n.prototype.gte = function(r) {
        return this.cmp(r) >= 0;
      }, n.prototype.ltn = function(r) {
        return this.cmpn(r) === -1;
      }, n.prototype.lt = function(r) {
        return this.cmp(r) === -1;
      }, n.prototype.lten = function(r) {
        return this.cmpn(r) <= 0;
      }, n.prototype.lte = function(r) {
        return this.cmp(r) <= 0;
      }, n.prototype.eqn = function(r) {
        return this.cmpn(r) === 0;
      }, n.prototype.eq = function(r) {
        return this.cmp(r) === 0;
      }, n.red = function(r) {
        return new U(r);
      }, n.prototype.toRed = function(r) {
        return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), r.convertTo(this)._forceRed(r);
      }, n.prototype.fromRed = function() {
        return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, n.prototype._forceRed = function(r) {
        return this.red = r, this;
      }, n.prototype.forceRed = function(r) {
        return i(!this.red, "Already a number in reduction context"), this._forceRed(r);
      }, n.prototype.redAdd = function(r) {
        return i(this.red, "redAdd works only with red numbers"), this.red.add(this, r);
      }, n.prototype.redIAdd = function(r) {
        return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, r);
      }, n.prototype.redSub = function(r) {
        return i(this.red, "redSub works only with red numbers"), this.red.sub(this, r);
      }, n.prototype.redISub = function(r) {
        return i(this.red, "redISub works only with red numbers"), this.red.isub(this, r);
      }, n.prototype.redShl = function(r) {
        return i(this.red, "redShl works only with red numbers"), this.red.shl(this, r);
      }, n.prototype.redMul = function(r) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, r), this.red.mul(this, r);
      }, n.prototype.redIMul = function(r) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, r), this.red.imul(this, r);
      }, n.prototype.redSqr = function() {
        return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, n.prototype.redISqr = function() {
        return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, n.prototype.redSqrt = function() {
        return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, n.prototype.redInvm = function() {
        return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, n.prototype.redNeg = function() {
        return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, n.prototype.redPow = function(r) {
        return i(this.red && !r.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, r);
      };
      var j = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function O(I, r) {
        this.name = I, this.p = new n(r, 16), this.n = this.p.bitLength(), this.k = new n(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      O.prototype._tmp = function() {
        var r = new n(null);
        return r.words = new Array(Math.ceil(this.n / 13)), r;
      }, O.prototype.ireduce = function(r) {
        var s = r, u;
        do
          this.split(s, this.tmp), s = this.imulK(s), s = s.iadd(this.tmp), u = s.bitLength();
        while (u > this.n);
        var g = u < this.n ? -1 : s.ucmp(this.p);
        return g === 0 ? (s.words[0] = 0, s.length = 1) : g > 0 ? s.isub(this.p) : s.strip !== void 0 ? s.strip() : s._strip(), s;
      }, O.prototype.split = function(r, s) {
        r.iushrn(this.n, 0, s);
      }, O.prototype.imulK = function(r) {
        return r.imul(this.k);
      };
      function z() {
        O.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      c(z, O), z.prototype.split = function(r, s) {
        for (var u = 4194303, g = Math.min(r.length, 9), v = 0; v < g; v++)
          s.words[v] = r.words[v];
        if (s.length = g, r.length <= 9) {
          r.words[0] = 0, r.length = 1;
          return;
        }
        var A = r.words[9];
        for (s.words[s.length++] = A & u, v = 10; v < r.length; v++) {
          var L = r.words[v] | 0;
          r.words[v - 10] = (L & u) << 4 | A >>> 22, A = L;
        }
        A >>>= 22, r.words[v - 10] = A, A === 0 && r.length > 10 ? r.length -= 10 : r.length -= 9;
      }, z.prototype.imulK = function(r) {
        r.words[r.length] = 0, r.words[r.length + 1] = 0, r.length += 2;
        for (var s = 0, u = 0; u < r.length; u++) {
          var g = r.words[u] | 0;
          s += g * 977, r.words[u] = s & 67108863, s = g * 64 + (s / 67108864 | 0);
        }
        return r.words[r.length - 1] === 0 && (r.length--, r.words[r.length - 1] === 0 && r.length--), r;
      };
      function k() {
        O.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      c(k, O);
      function H() {
        O.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      c(H, O);
      function W() {
        O.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      c(W, O), W.prototype.imulK = function(r) {
        for (var s = 0, u = 0; u < r.length; u++) {
          var g = (r.words[u] | 0) * 19 + s, v = g & 67108863;
          g >>>= 26, r.words[u] = v, s = g;
        }
        return s !== 0 && (r.words[r.length++] = s), r;
      }, n._prime = function(r) {
        if (j[r]) return j[r];
        var s;
        if (r === "k256")
          s = new z();
        else if (r === "p224")
          s = new k();
        else if (r === "p192")
          s = new H();
        else if (r === "p25519")
          s = new W();
        else
          throw new Error("Unknown prime " + r);
        return j[r] = s, s;
      };
      function U(I) {
        if (typeof I == "string") {
          var r = n._prime(I);
          this.m = r.p, this.prime = r;
        } else
          i(I.gtn(1), "modulus must be greater than 1"), this.m = I, this.prime = null;
      }
      U.prototype._verify1 = function(r) {
        i(r.negative === 0, "red works only with positives"), i(r.red, "red works only with red numbers");
      }, U.prototype._verify2 = function(r, s) {
        i((r.negative | s.negative) === 0, "red works only with positives"), i(
          r.red && r.red === s.red,
          "red works only with red numbers"
        );
      }, U.prototype.imod = function(r) {
        return this.prime ? this.prime.ireduce(r)._forceRed(this) : r.umod(this.m)._forceRed(this);
      }, U.prototype.neg = function(r) {
        return r.isZero() ? r.clone() : this.m.sub(r)._forceRed(this);
      }, U.prototype.add = function(r, s) {
        this._verify2(r, s);
        var u = r.add(s);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u._forceRed(this);
      }, U.prototype.iadd = function(r, s) {
        this._verify2(r, s);
        var u = r.iadd(s);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u;
      }, U.prototype.sub = function(r, s) {
        this._verify2(r, s);
        var u = r.sub(s);
        return u.cmpn(0) < 0 && u.iadd(this.m), u._forceRed(this);
      }, U.prototype.isub = function(r, s) {
        this._verify2(r, s);
        var u = r.isub(s);
        return u.cmpn(0) < 0 && u.iadd(this.m), u;
      }, U.prototype.shl = function(r, s) {
        return this._verify1(r), this.imod(r.ushln(s));
      }, U.prototype.imul = function(r, s) {
        return this._verify2(r, s), this.imod(r.imul(s));
      }, U.prototype.mul = function(r, s) {
        return this._verify2(r, s), this.imod(r.mul(s));
      }, U.prototype.isqr = function(r) {
        return this.imul(r, r.clone());
      }, U.prototype.sqr = function(r) {
        return this.mul(r, r);
      }, U.prototype.sqrt = function(r) {
        if (r.isZero()) return r.clone();
        var s = this.m.andln(3);
        if (i(s % 2 === 1), s === 3) {
          var u = this.m.add(new n(1)).iushrn(2);
          return this.pow(r, u);
        }
        for (var g = this.m.subn(1), v = 0; !g.isZero() && g.andln(1) === 0; )
          v++, g.iushrn(1);
        i(!g.isZero());
        var A = new n(1).toRed(this), L = A.redNeg(), m = this.m.subn(1).iushrn(1), a = this.m.bitLength();
        for (a = new n(2 * a * a).toRed(this); this.pow(a, m).cmp(L) !== 0; )
          a.redIAdd(L);
        for (var x = this.pow(a, g), V = this.pow(r, g.addn(1).iushrn(1)), G = this.pow(r, g), Z = v; G.cmp(A) !== 0; ) {
          for (var te = G, q = 0; te.cmp(A) !== 0; q++)
            te = te.redSqr();
          i(q < Z);
          var R = this.pow(x, new n(1).iushln(Z - q - 1));
          V = V.redMul(R), x = R.redSqr(), G = G.redMul(x), Z = q;
        }
        return V;
      }, U.prototype.invm = function(r) {
        var s = r._invmp(this.m);
        return s.negative !== 0 ? (s.negative = 0, this.imod(s).redNeg()) : this.imod(s);
      }, U.prototype.pow = function(r, s) {
        if (s.isZero()) return new n(1).toRed(this);
        if (s.cmpn(1) === 0) return r.clone();
        var u = 4, g = new Array(1 << u);
        g[0] = new n(1).toRed(this), g[1] = r;
        for (var v = 2; v < g.length; v++)
          g[v] = this.mul(g[v - 1], r);
        var A = g[0], L = 0, m = 0, a = s.bitLength() % 26;
        for (a === 0 && (a = 26), v = s.length - 1; v >= 0; v--) {
          for (var x = s.words[v], V = a - 1; V >= 0; V--) {
            var G = x >> V & 1;
            if (A !== g[0] && (A = this.sqr(A)), G === 0 && L === 0) {
              m = 0;
              continue;
            }
            L <<= 1, L |= G, m++, !(m !== u && (v !== 0 || V !== 0)) && (A = this.mul(A, g[L]), m = 0, L = 0);
          }
          a = 26;
        }
        return A;
      }, U.prototype.convertTo = function(r) {
        var s = r.umod(this.m);
        return s === r ? s.clone() : s;
      }, U.prototype.convertFrom = function(r) {
        var s = r.clone();
        return s.red = null, s;
      }, n.mont = function(r) {
        return new B(r);
      };
      function B(I) {
        U.call(this, I), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new n(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      c(B, U), B.prototype.convertTo = function(r) {
        return this.imod(r.ushln(this.shift));
      }, B.prototype.convertFrom = function(r) {
        var s = this.imod(r.mul(this.rinv));
        return s.red = null, s;
      }, B.prototype.imul = function(r, s) {
        if (r.isZero() || s.isZero())
          return r.words[0] = 0, r.length = 1, r;
        var u = r.imul(s), g = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), v = u.isub(g).iushrn(this.shift), A = v;
        return v.cmp(this.m) >= 0 ? A = v.isub(this.m) : v.cmpn(0) < 0 && (A = v.iadd(this.m)), A._forceRed(this);
      }, B.prototype.mul = function(r, s) {
        if (r.isZero() || s.isZero()) return new n(0)._forceRed(this);
        var u = r.mul(s), g = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), v = u.isub(g).iushrn(this.shift), A = v;
        return v.cmp(this.m) >= 0 ? A = v.isub(this.m) : v.cmpn(0) < 0 && (A = v.iadd(this.m)), A._forceRed(this);
      }, B.prototype.invm = function(r) {
        var s = this.imod(r._invmp(this.m).mul(this.r2));
        return s._forceRed(this);
      };
    })(e, Wt);
  }(Y0)), Y0.exports;
}
var W0 = { exports: {} };
W0.exports;
var Vp;
function dA() {
  return Vp || (Vp = 1, function(e) {
    (function(t, o) {
      function i(I, r) {
        if (!I) throw new Error(r || "Assertion failed");
      }
      function c(I, r) {
        I.super_ = r;
        var s = function() {
        };
        s.prototype = r.prototype, I.prototype = new s(), I.prototype.constructor = I;
      }
      function n(I, r, s) {
        if (n.isBN(I))
          return I;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, I !== null && ((r === "le" || r === "be") && (s = r, r = 10), this._init(I || 0, r || 10, s || "be"));
      }
      typeof t == "object" ? t.exports = n : o.BN = n, n.BN = n, n.wordSize = 26;
      var d;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? d = window.Buffer : d = Wr.Buffer;
      } catch {
      }
      n.isBN = function(r) {
        return r instanceof n ? !0 : r !== null && typeof r == "object" && r.constructor.wordSize === n.wordSize && Array.isArray(r.words);
      }, n.max = function(r, s) {
        return r.cmp(s) > 0 ? r : s;
      }, n.min = function(r, s) {
        return r.cmp(s) < 0 ? r : s;
      }, n.prototype._init = function(r, s, u) {
        if (typeof r == "number")
          return this._initNumber(r, s, u);
        if (typeof r == "object")
          return this._initArray(r, s, u);
        s === "hex" && (s = 16), i(s === (s | 0) && s >= 2 && s <= 36), r = r.toString().replace(/\s+/g, "");
        var g = 0;
        r[0] === "-" && (g++, this.negative = 1), g < r.length && (s === 16 ? this._parseHex(r, g, u) : (this._parseBase(r, s, g), u === "le" && this._initArray(this.toArray(), s, u)));
      }, n.prototype._initNumber = function(r, s, u) {
        r < 0 && (this.negative = 1, r = -r), r < 67108864 ? (this.words = [r & 67108863], this.length = 1) : r < 4503599627370496 ? (this.words = [
          r & 67108863,
          r / 67108864 & 67108863
        ], this.length = 2) : (i(r < 9007199254740992), this.words = [
          r & 67108863,
          r / 67108864 & 67108863,
          1
        ], this.length = 3), u === "le" && this._initArray(this.toArray(), s, u);
      }, n.prototype._initArray = function(r, s, u) {
        if (i(typeof r.length == "number"), r.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(r.length / 3), this.words = new Array(this.length);
        for (var g = 0; g < this.length; g++)
          this.words[g] = 0;
        var v, A, L = 0;
        if (u === "be")
          for (g = r.length - 1, v = 0; g >= 0; g -= 3)
            A = r[g] | r[g - 1] << 8 | r[g - 2] << 16, this.words[v] |= A << L & 67108863, this.words[v + 1] = A >>> 26 - L & 67108863, L += 24, L >= 26 && (L -= 26, v++);
        else if (u === "le")
          for (g = 0, v = 0; g < r.length; g += 3)
            A = r[g] | r[g + 1] << 8 | r[g + 2] << 16, this.words[v] |= A << L & 67108863, this.words[v + 1] = A >>> 26 - L & 67108863, L += 24, L >= 26 && (L -= 26, v++);
        return this.strip();
      };
      function f(I, r) {
        var s = I.charCodeAt(r);
        return s >= 65 && s <= 70 ? s - 55 : s >= 97 && s <= 102 ? s - 87 : s - 48 & 15;
      }
      function p(I, r, s) {
        var u = f(I, s);
        return s - 1 >= r && (u |= f(I, s - 1) << 4), u;
      }
      n.prototype._parseHex = function(r, s, u) {
        this.length = Math.ceil((r.length - s) / 6), this.words = new Array(this.length);
        for (var g = 0; g < this.length; g++)
          this.words[g] = 0;
        var v = 0, A = 0, L;
        if (u === "be")
          for (g = r.length - 1; g >= s; g -= 2)
            L = p(r, s, g) << v, this.words[A] |= L & 67108863, v >= 18 ? (v -= 18, A += 1, this.words[A] |= L >>> 26) : v += 8;
        else {
          var m = r.length - s;
          for (g = m % 2 === 0 ? s + 1 : s; g < r.length; g += 2)
            L = p(r, s, g) << v, this.words[A] |= L & 67108863, v >= 18 ? (v -= 18, A += 1, this.words[A] |= L >>> 26) : v += 8;
        }
        this.strip();
      };
      function l(I, r, s, u) {
        for (var g = 0, v = Math.min(I.length, s), A = r; A < v; A++) {
          var L = I.charCodeAt(A) - 48;
          g *= u, L >= 49 ? g += L - 49 + 10 : L >= 17 ? g += L - 17 + 10 : g += L;
        }
        return g;
      }
      n.prototype._parseBase = function(r, s, u) {
        this.words = [0], this.length = 1;
        for (var g = 0, v = 1; v <= 67108863; v *= s)
          g++;
        g--, v = v / s | 0;
        for (var A = r.length - u, L = A % g, m = Math.min(A, A - L) + u, a = 0, x = u; x < m; x += g)
          a = l(r, x, x + g, s), this.imuln(v), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        if (L !== 0) {
          var V = 1;
          for (a = l(r, x, r.length, s), x = 0; x < L; x++)
            V *= s;
          this.imuln(V), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        }
        this.strip();
      }, n.prototype.copy = function(r) {
        r.words = new Array(this.length);
        for (var s = 0; s < this.length; s++)
          r.words[s] = this.words[s];
        r.length = this.length, r.negative = this.negative, r.red = this.red;
      }, n.prototype.clone = function() {
        var r = new n(null);
        return this.copy(r), r;
      }, n.prototype._expand = function(r) {
        for (; this.length < r; )
          this.words[this.length++] = 0;
        return this;
      }, n.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, n.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, n.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var h = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], y = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], M = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      n.prototype.toString = function(r, s) {
        r = r || 10, s = s | 0 || 1;
        var u;
        if (r === 16 || r === "hex") {
          u = "";
          for (var g = 0, v = 0, A = 0; A < this.length; A++) {
            var L = this.words[A], m = ((L << g | v) & 16777215).toString(16);
            v = L >>> 24 - g & 16777215, g += 2, g >= 26 && (g -= 26, A--), v !== 0 || A !== this.length - 1 ? u = h[6 - m.length] + m + u : u = m + u;
          }
          for (v !== 0 && (u = v.toString(16) + u); u.length % s !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        if (r === (r | 0) && r >= 2 && r <= 36) {
          var a = y[r], x = M[r];
          u = "";
          var V = this.clone();
          for (V.negative = 0; !V.isZero(); ) {
            var G = V.modn(x).toString(r);
            V = V.idivn(x), V.isZero() ? u = G + u : u = h[a - G.length] + G + u;
          }
          for (this.isZero() && (u = "0" + u); u.length % s !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        i(!1, "Base should be between 2 and 36");
      }, n.prototype.toNumber = function() {
        var r = this.words[0];
        return this.length === 2 ? r += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? r += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -r : r;
      }, n.prototype.toJSON = function() {
        return this.toString(16);
      }, n.prototype.toBuffer = function(r, s) {
        return i(typeof d < "u"), this.toArrayLike(d, r, s);
      }, n.prototype.toArray = function(r, s) {
        return this.toArrayLike(Array, r, s);
      }, n.prototype.toArrayLike = function(r, s, u) {
        var g = this.byteLength(), v = u || Math.max(1, g);
        i(g <= v, "byte array longer than desired length"), i(v > 0, "Requested array length <= 0"), this.strip();
        var A = s === "le", L = new r(v), m, a, x = this.clone();
        if (A) {
          for (a = 0; !x.isZero(); a++)
            m = x.andln(255), x.iushrn(8), L[a] = m;
          for (; a < v; a++)
            L[a] = 0;
        } else {
          for (a = 0; a < v - g; a++)
            L[a] = 0;
          for (a = 0; !x.isZero(); a++)
            m = x.andln(255), x.iushrn(8), L[v - a - 1] = m;
        }
        return L;
      }, Math.clz32 ? n.prototype._countBits = function(r) {
        return 32 - Math.clz32(r);
      } : n.prototype._countBits = function(r) {
        var s = r, u = 0;
        return s >= 4096 && (u += 13, s >>>= 13), s >= 64 && (u += 7, s >>>= 7), s >= 8 && (u += 4, s >>>= 4), s >= 2 && (u += 2, s >>>= 2), u + s;
      }, n.prototype._zeroBits = function(r) {
        if (r === 0) return 26;
        var s = r, u = 0;
        return s & 8191 || (u += 13, s >>>= 13), s & 127 || (u += 7, s >>>= 7), s & 15 || (u += 4, s >>>= 4), s & 3 || (u += 2, s >>>= 2), s & 1 || u++, u;
      }, n.prototype.bitLength = function() {
        var r = this.words[this.length - 1], s = this._countBits(r);
        return (this.length - 1) * 26 + s;
      };
      function C(I) {
        for (var r = new Array(I.bitLength()), s = 0; s < r.length; s++) {
          var u = s / 26 | 0, g = s % 26;
          r[s] = (I.words[u] & 1 << g) >>> g;
        }
        return r;
      }
      n.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var r = 0, s = 0; s < this.length; s++) {
          var u = this._zeroBits(this.words[s]);
          if (r += u, u !== 26) break;
        }
        return r;
      }, n.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, n.prototype.toTwos = function(r) {
        return this.negative !== 0 ? this.abs().inotn(r).iaddn(1) : this.clone();
      }, n.prototype.fromTwos = function(r) {
        return this.testn(r - 1) ? this.notn(r).iaddn(1).ineg() : this.clone();
      }, n.prototype.isNeg = function() {
        return this.negative !== 0;
      }, n.prototype.neg = function() {
        return this.clone().ineg();
      }, n.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, n.prototype.iuor = function(r) {
        for (; this.length < r.length; )
          this.words[this.length++] = 0;
        for (var s = 0; s < r.length; s++)
          this.words[s] = this.words[s] | r.words[s];
        return this.strip();
      }, n.prototype.ior = function(r) {
        return i((this.negative | r.negative) === 0), this.iuor(r);
      }, n.prototype.or = function(r) {
        return this.length > r.length ? this.clone().ior(r) : r.clone().ior(this);
      }, n.prototype.uor = function(r) {
        return this.length > r.length ? this.clone().iuor(r) : r.clone().iuor(this);
      }, n.prototype.iuand = function(r) {
        var s;
        this.length > r.length ? s = r : s = this;
        for (var u = 0; u < s.length; u++)
          this.words[u] = this.words[u] & r.words[u];
        return this.length = s.length, this.strip();
      }, n.prototype.iand = function(r) {
        return i((this.negative | r.negative) === 0), this.iuand(r);
      }, n.prototype.and = function(r) {
        return this.length > r.length ? this.clone().iand(r) : r.clone().iand(this);
      }, n.prototype.uand = function(r) {
        return this.length > r.length ? this.clone().iuand(r) : r.clone().iuand(this);
      }, n.prototype.iuxor = function(r) {
        var s, u;
        this.length > r.length ? (s = this, u = r) : (s = r, u = this);
        for (var g = 0; g < u.length; g++)
          this.words[g] = s.words[g] ^ u.words[g];
        if (this !== s)
          for (; g < s.length; g++)
            this.words[g] = s.words[g];
        return this.length = s.length, this.strip();
      }, n.prototype.ixor = function(r) {
        return i((this.negative | r.negative) === 0), this.iuxor(r);
      }, n.prototype.xor = function(r) {
        return this.length > r.length ? this.clone().ixor(r) : r.clone().ixor(this);
      }, n.prototype.uxor = function(r) {
        return this.length > r.length ? this.clone().iuxor(r) : r.clone().iuxor(this);
      }, n.prototype.inotn = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = Math.ceil(r / 26) | 0, u = r % 26;
        this._expand(s), u > 0 && s--;
        for (var g = 0; g < s; g++)
          this.words[g] = ~this.words[g] & 67108863;
        return u > 0 && (this.words[g] = ~this.words[g] & 67108863 >> 26 - u), this.strip();
      }, n.prototype.notn = function(r) {
        return this.clone().inotn(r);
      }, n.prototype.setn = function(r, s) {
        i(typeof r == "number" && r >= 0);
        var u = r / 26 | 0, g = r % 26;
        return this._expand(u + 1), s ? this.words[u] = this.words[u] | 1 << g : this.words[u] = this.words[u] & ~(1 << g), this.strip();
      }, n.prototype.iadd = function(r) {
        var s;
        if (this.negative !== 0 && r.negative === 0)
          return this.negative = 0, s = this.isub(r), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && r.negative !== 0)
          return r.negative = 0, s = this.isub(r), r.negative = 1, s._normSign();
        var u, g;
        this.length > r.length ? (u = this, g = r) : (u = r, g = this);
        for (var v = 0, A = 0; A < g.length; A++)
          s = (u.words[A] | 0) + (g.words[A] | 0) + v, this.words[A] = s & 67108863, v = s >>> 26;
        for (; v !== 0 && A < u.length; A++)
          s = (u.words[A] | 0) + v, this.words[A] = s & 67108863, v = s >>> 26;
        if (this.length = u.length, v !== 0)
          this.words[this.length] = v, this.length++;
        else if (u !== this)
          for (; A < u.length; A++)
            this.words[A] = u.words[A];
        return this;
      }, n.prototype.add = function(r) {
        var s;
        return r.negative !== 0 && this.negative === 0 ? (r.negative = 0, s = this.sub(r), r.negative ^= 1, s) : r.negative === 0 && this.negative !== 0 ? (this.negative = 0, s = r.sub(this), this.negative = 1, s) : this.length > r.length ? this.clone().iadd(r) : r.clone().iadd(this);
      }, n.prototype.isub = function(r) {
        if (r.negative !== 0) {
          r.negative = 0;
          var s = this.iadd(r);
          return r.negative = 1, s._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(r), this.negative = 1, this._normSign();
        var u = this.cmp(r);
        if (u === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var g, v;
        u > 0 ? (g = this, v = r) : (g = r, v = this);
        for (var A = 0, L = 0; L < v.length; L++)
          s = (g.words[L] | 0) - (v.words[L] | 0) + A, A = s >> 26, this.words[L] = s & 67108863;
        for (; A !== 0 && L < g.length; L++)
          s = (g.words[L] | 0) + A, A = s >> 26, this.words[L] = s & 67108863;
        if (A === 0 && L < g.length && g !== this)
          for (; L < g.length; L++)
            this.words[L] = g.words[L];
        return this.length = Math.max(this.length, L), g !== this && (this.negative = 1), this.strip();
      }, n.prototype.sub = function(r) {
        return this.clone().isub(r);
      };
      function N(I, r, s) {
        s.negative = r.negative ^ I.negative;
        var u = I.length + r.length | 0;
        s.length = u, u = u - 1 | 0;
        var g = I.words[0] | 0, v = r.words[0] | 0, A = g * v, L = A & 67108863, m = A / 67108864 | 0;
        s.words[0] = L;
        for (var a = 1; a < u; a++) {
          for (var x = m >>> 26, V = m & 67108863, G = Math.min(a, r.length - 1), Z = Math.max(0, a - I.length + 1); Z <= G; Z++) {
            var te = a - Z | 0;
            g = I.words[te] | 0, v = r.words[Z] | 0, A = g * v + V, x += A / 67108864 | 0, V = A & 67108863;
          }
          s.words[a] = V | 0, m = x | 0;
        }
        return m !== 0 ? s.words[a] = m | 0 : s.length--, s.strip();
      }
      var w = function(r, s, u) {
        var g = r.words, v = s.words, A = u.words, L = 0, m, a, x, V = g[0] | 0, G = V & 8191, Z = V >>> 13, te = g[1] | 0, q = te & 8191, R = te >>> 13, Q = g[2] | 0, $ = Q & 8191, F = Q >>> 13, P = g[3] | 0, _ = P & 8191, X = P >>> 13, le = g[4] | 0, ie = le & 8191, oe = le >>> 13, pe = g[5] | 0, se = pe & 8191, ce = pe >>> 13, me = g[6] | 0, de = me & 8191, ae = me >>> 13, Le = g[7] | 0, ye = Le & 8191, Me = Le >>> 13, at = g[8] | 0, Ne = at & 8191, Ae = at >>> 13, pt = g[9] | 0, ke = pt & 8191, Te = pt >>> 13, Dt = v[0] | 0, De = Dt & 8191, je = Dt >>> 13, At = v[1] | 0, xe = At & 8191, Ie = At >>> 13, Nt = v[2] | 0, _e = Nt & 8191, Be = Nt >>> 13, Xt = v[3] | 0, Re = Xt & 8191, Pe = Xt >>> 13, dr = v[4] | 0, We = dr & 8191, He = dr >>> 13, Ct = v[5] | 0, Ue = Ct & 8191, Ze = Ct >>> 13, Fr = v[6] | 0, Ye = Fr & 8191, Qe = Fr >>> 13, J = v[7] | 0, ee = J & 8191, K = J >>> 13, Y = v[8] | 0, re = Y & 8191, he = Y >>> 13, Se = v[9] | 0, ve = Se & 8191, we = Se >>> 13;
        u.negative = r.negative ^ s.negative, u.length = 19, m = Math.imul(G, De), a = Math.imul(G, je), a = a + Math.imul(Z, De) | 0, x = Math.imul(Z, je);
        var lt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (lt >>> 26) | 0, lt &= 67108863, m = Math.imul(q, De), a = Math.imul(q, je), a = a + Math.imul(R, De) | 0, x = Math.imul(R, je), m = m + Math.imul(G, xe) | 0, a = a + Math.imul(G, Ie) | 0, a = a + Math.imul(Z, xe) | 0, x = x + Math.imul(Z, Ie) | 0;
        var et = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (et >>> 26) | 0, et &= 67108863, m = Math.imul($, De), a = Math.imul($, je), a = a + Math.imul(F, De) | 0, x = Math.imul(F, je), m = m + Math.imul(q, xe) | 0, a = a + Math.imul(q, Ie) | 0, a = a + Math.imul(R, xe) | 0, x = x + Math.imul(R, Ie) | 0, m = m + Math.imul(G, _e) | 0, a = a + Math.imul(G, Be) | 0, a = a + Math.imul(Z, _e) | 0, x = x + Math.imul(Z, Be) | 0;
        var Lt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Lt >>> 26) | 0, Lt &= 67108863, m = Math.imul(_, De), a = Math.imul(_, je), a = a + Math.imul(X, De) | 0, x = Math.imul(X, je), m = m + Math.imul($, xe) | 0, a = a + Math.imul($, Ie) | 0, a = a + Math.imul(F, xe) | 0, x = x + Math.imul(F, Ie) | 0, m = m + Math.imul(q, _e) | 0, a = a + Math.imul(q, Be) | 0, a = a + Math.imul(R, _e) | 0, x = x + Math.imul(R, Be) | 0, m = m + Math.imul(G, Re) | 0, a = a + Math.imul(G, Pe) | 0, a = a + Math.imul(Z, Re) | 0, x = x + Math.imul(Z, Pe) | 0;
        var nt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (nt >>> 26) | 0, nt &= 67108863, m = Math.imul(ie, De), a = Math.imul(ie, je), a = a + Math.imul(oe, De) | 0, x = Math.imul(oe, je), m = m + Math.imul(_, xe) | 0, a = a + Math.imul(_, Ie) | 0, a = a + Math.imul(X, xe) | 0, x = x + Math.imul(X, Ie) | 0, m = m + Math.imul($, _e) | 0, a = a + Math.imul($, Be) | 0, a = a + Math.imul(F, _e) | 0, x = x + Math.imul(F, Be) | 0, m = m + Math.imul(q, Re) | 0, a = a + Math.imul(q, Pe) | 0, a = a + Math.imul(R, Re) | 0, x = x + Math.imul(R, Pe) | 0, m = m + Math.imul(G, We) | 0, a = a + Math.imul(G, He) | 0, a = a + Math.imul(Z, We) | 0, x = x + Math.imul(Z, He) | 0;
        var gt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, m = Math.imul(se, De), a = Math.imul(se, je), a = a + Math.imul(ce, De) | 0, x = Math.imul(ce, je), m = m + Math.imul(ie, xe) | 0, a = a + Math.imul(ie, Ie) | 0, a = a + Math.imul(oe, xe) | 0, x = x + Math.imul(oe, Ie) | 0, m = m + Math.imul(_, _e) | 0, a = a + Math.imul(_, Be) | 0, a = a + Math.imul(X, _e) | 0, x = x + Math.imul(X, Be) | 0, m = m + Math.imul($, Re) | 0, a = a + Math.imul($, Pe) | 0, a = a + Math.imul(F, Re) | 0, x = x + Math.imul(F, Pe) | 0, m = m + Math.imul(q, We) | 0, a = a + Math.imul(q, He) | 0, a = a + Math.imul(R, We) | 0, x = x + Math.imul(R, He) | 0, m = m + Math.imul(G, Ue) | 0, a = a + Math.imul(G, Ze) | 0, a = a + Math.imul(Z, Ue) | 0, x = x + Math.imul(Z, Ze) | 0;
        var yt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, m = Math.imul(de, De), a = Math.imul(de, je), a = a + Math.imul(ae, De) | 0, x = Math.imul(ae, je), m = m + Math.imul(se, xe) | 0, a = a + Math.imul(se, Ie) | 0, a = a + Math.imul(ce, xe) | 0, x = x + Math.imul(ce, Ie) | 0, m = m + Math.imul(ie, _e) | 0, a = a + Math.imul(ie, Be) | 0, a = a + Math.imul(oe, _e) | 0, x = x + Math.imul(oe, Be) | 0, m = m + Math.imul(_, Re) | 0, a = a + Math.imul(_, Pe) | 0, a = a + Math.imul(X, Re) | 0, x = x + Math.imul(X, Pe) | 0, m = m + Math.imul($, We) | 0, a = a + Math.imul($, He) | 0, a = a + Math.imul(F, We) | 0, x = x + Math.imul(F, He) | 0, m = m + Math.imul(q, Ue) | 0, a = a + Math.imul(q, Ze) | 0, a = a + Math.imul(R, Ue) | 0, x = x + Math.imul(R, Ze) | 0, m = m + Math.imul(G, Ye) | 0, a = a + Math.imul(G, Qe) | 0, a = a + Math.imul(Z, Ye) | 0, x = x + Math.imul(Z, Qe) | 0;
        var xt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (xt >>> 26) | 0, xt &= 67108863, m = Math.imul(ye, De), a = Math.imul(ye, je), a = a + Math.imul(Me, De) | 0, x = Math.imul(Me, je), m = m + Math.imul(de, xe) | 0, a = a + Math.imul(de, Ie) | 0, a = a + Math.imul(ae, xe) | 0, x = x + Math.imul(ae, Ie) | 0, m = m + Math.imul(se, _e) | 0, a = a + Math.imul(se, Be) | 0, a = a + Math.imul(ce, _e) | 0, x = x + Math.imul(ce, Be) | 0, m = m + Math.imul(ie, Re) | 0, a = a + Math.imul(ie, Pe) | 0, a = a + Math.imul(oe, Re) | 0, x = x + Math.imul(oe, Pe) | 0, m = m + Math.imul(_, We) | 0, a = a + Math.imul(_, He) | 0, a = a + Math.imul(X, We) | 0, x = x + Math.imul(X, He) | 0, m = m + Math.imul($, Ue) | 0, a = a + Math.imul($, Ze) | 0, a = a + Math.imul(F, Ue) | 0, x = x + Math.imul(F, Ze) | 0, m = m + Math.imul(q, Ye) | 0, a = a + Math.imul(q, Qe) | 0, a = a + Math.imul(R, Ye) | 0, x = x + Math.imul(R, Qe) | 0, m = m + Math.imul(G, ee) | 0, a = a + Math.imul(G, K) | 0, a = a + Math.imul(Z, ee) | 0, x = x + Math.imul(Z, K) | 0;
        var bt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, m = Math.imul(Ne, De), a = Math.imul(Ne, je), a = a + Math.imul(Ae, De) | 0, x = Math.imul(Ae, je), m = m + Math.imul(ye, xe) | 0, a = a + Math.imul(ye, Ie) | 0, a = a + Math.imul(Me, xe) | 0, x = x + Math.imul(Me, Ie) | 0, m = m + Math.imul(de, _e) | 0, a = a + Math.imul(de, Be) | 0, a = a + Math.imul(ae, _e) | 0, x = x + Math.imul(ae, Be) | 0, m = m + Math.imul(se, Re) | 0, a = a + Math.imul(se, Pe) | 0, a = a + Math.imul(ce, Re) | 0, x = x + Math.imul(ce, Pe) | 0, m = m + Math.imul(ie, We) | 0, a = a + Math.imul(ie, He) | 0, a = a + Math.imul(oe, We) | 0, x = x + Math.imul(oe, He) | 0, m = m + Math.imul(_, Ue) | 0, a = a + Math.imul(_, Ze) | 0, a = a + Math.imul(X, Ue) | 0, x = x + Math.imul(X, Ze) | 0, m = m + Math.imul($, Ye) | 0, a = a + Math.imul($, Qe) | 0, a = a + Math.imul(F, Ye) | 0, x = x + Math.imul(F, Qe) | 0, m = m + Math.imul(q, ee) | 0, a = a + Math.imul(q, K) | 0, a = a + Math.imul(R, ee) | 0, x = x + Math.imul(R, K) | 0, m = m + Math.imul(G, re) | 0, a = a + Math.imul(G, he) | 0, a = a + Math.imul(Z, re) | 0, x = x + Math.imul(Z, he) | 0;
        var Mt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Mt >>> 26) | 0, Mt &= 67108863, m = Math.imul(ke, De), a = Math.imul(ke, je), a = a + Math.imul(Te, De) | 0, x = Math.imul(Te, je), m = m + Math.imul(Ne, xe) | 0, a = a + Math.imul(Ne, Ie) | 0, a = a + Math.imul(Ae, xe) | 0, x = x + Math.imul(Ae, Ie) | 0, m = m + Math.imul(ye, _e) | 0, a = a + Math.imul(ye, Be) | 0, a = a + Math.imul(Me, _e) | 0, x = x + Math.imul(Me, Be) | 0, m = m + Math.imul(de, Re) | 0, a = a + Math.imul(de, Pe) | 0, a = a + Math.imul(ae, Re) | 0, x = x + Math.imul(ae, Pe) | 0, m = m + Math.imul(se, We) | 0, a = a + Math.imul(se, He) | 0, a = a + Math.imul(ce, We) | 0, x = x + Math.imul(ce, He) | 0, m = m + Math.imul(ie, Ue) | 0, a = a + Math.imul(ie, Ze) | 0, a = a + Math.imul(oe, Ue) | 0, x = x + Math.imul(oe, Ze) | 0, m = m + Math.imul(_, Ye) | 0, a = a + Math.imul(_, Qe) | 0, a = a + Math.imul(X, Ye) | 0, x = x + Math.imul(X, Qe) | 0, m = m + Math.imul($, ee) | 0, a = a + Math.imul($, K) | 0, a = a + Math.imul(F, ee) | 0, x = x + Math.imul(F, K) | 0, m = m + Math.imul(q, re) | 0, a = a + Math.imul(q, he) | 0, a = a + Math.imul(R, re) | 0, x = x + Math.imul(R, he) | 0, m = m + Math.imul(G, ve) | 0, a = a + Math.imul(G, we) | 0, a = a + Math.imul(Z, ve) | 0, x = x + Math.imul(Z, we) | 0;
        var vt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, m = Math.imul(ke, xe), a = Math.imul(ke, Ie), a = a + Math.imul(Te, xe) | 0, x = Math.imul(Te, Ie), m = m + Math.imul(Ne, _e) | 0, a = a + Math.imul(Ne, Be) | 0, a = a + Math.imul(Ae, _e) | 0, x = x + Math.imul(Ae, Be) | 0, m = m + Math.imul(ye, Re) | 0, a = a + Math.imul(ye, Pe) | 0, a = a + Math.imul(Me, Re) | 0, x = x + Math.imul(Me, Pe) | 0, m = m + Math.imul(de, We) | 0, a = a + Math.imul(de, He) | 0, a = a + Math.imul(ae, We) | 0, x = x + Math.imul(ae, He) | 0, m = m + Math.imul(se, Ue) | 0, a = a + Math.imul(se, Ze) | 0, a = a + Math.imul(ce, Ue) | 0, x = x + Math.imul(ce, Ze) | 0, m = m + Math.imul(ie, Ye) | 0, a = a + Math.imul(ie, Qe) | 0, a = a + Math.imul(oe, Ye) | 0, x = x + Math.imul(oe, Qe) | 0, m = m + Math.imul(_, ee) | 0, a = a + Math.imul(_, K) | 0, a = a + Math.imul(X, ee) | 0, x = x + Math.imul(X, K) | 0, m = m + Math.imul($, re) | 0, a = a + Math.imul($, he) | 0, a = a + Math.imul(F, re) | 0, x = x + Math.imul(F, he) | 0, m = m + Math.imul(q, ve) | 0, a = a + Math.imul(q, we) | 0, a = a + Math.imul(R, ve) | 0, x = x + Math.imul(R, we) | 0;
        var mt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, m = Math.imul(ke, _e), a = Math.imul(ke, Be), a = a + Math.imul(Te, _e) | 0, x = Math.imul(Te, Be), m = m + Math.imul(Ne, Re) | 0, a = a + Math.imul(Ne, Pe) | 0, a = a + Math.imul(Ae, Re) | 0, x = x + Math.imul(Ae, Pe) | 0, m = m + Math.imul(ye, We) | 0, a = a + Math.imul(ye, He) | 0, a = a + Math.imul(Me, We) | 0, x = x + Math.imul(Me, He) | 0, m = m + Math.imul(de, Ue) | 0, a = a + Math.imul(de, Ze) | 0, a = a + Math.imul(ae, Ue) | 0, x = x + Math.imul(ae, Ze) | 0, m = m + Math.imul(se, Ye) | 0, a = a + Math.imul(se, Qe) | 0, a = a + Math.imul(ce, Ye) | 0, x = x + Math.imul(ce, Qe) | 0, m = m + Math.imul(ie, ee) | 0, a = a + Math.imul(ie, K) | 0, a = a + Math.imul(oe, ee) | 0, x = x + Math.imul(oe, K) | 0, m = m + Math.imul(_, re) | 0, a = a + Math.imul(_, he) | 0, a = a + Math.imul(X, re) | 0, x = x + Math.imul(X, he) | 0, m = m + Math.imul($, ve) | 0, a = a + Math.imul($, we) | 0, a = a + Math.imul(F, ve) | 0, x = x + Math.imul(F, we) | 0;
        var ot = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (ot >>> 26) | 0, ot &= 67108863, m = Math.imul(ke, Re), a = Math.imul(ke, Pe), a = a + Math.imul(Te, Re) | 0, x = Math.imul(Te, Pe), m = m + Math.imul(Ne, We) | 0, a = a + Math.imul(Ne, He) | 0, a = a + Math.imul(Ae, We) | 0, x = x + Math.imul(Ae, He) | 0, m = m + Math.imul(ye, Ue) | 0, a = a + Math.imul(ye, Ze) | 0, a = a + Math.imul(Me, Ue) | 0, x = x + Math.imul(Me, Ze) | 0, m = m + Math.imul(de, Ye) | 0, a = a + Math.imul(de, Qe) | 0, a = a + Math.imul(ae, Ye) | 0, x = x + Math.imul(ae, Qe) | 0, m = m + Math.imul(se, ee) | 0, a = a + Math.imul(se, K) | 0, a = a + Math.imul(ce, ee) | 0, x = x + Math.imul(ce, K) | 0, m = m + Math.imul(ie, re) | 0, a = a + Math.imul(ie, he) | 0, a = a + Math.imul(oe, re) | 0, x = x + Math.imul(oe, he) | 0, m = m + Math.imul(_, ve) | 0, a = a + Math.imul(_, we) | 0, a = a + Math.imul(X, ve) | 0, x = x + Math.imul(X, we) | 0;
        var ft = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (ft >>> 26) | 0, ft &= 67108863, m = Math.imul(ke, We), a = Math.imul(ke, He), a = a + Math.imul(Te, We) | 0, x = Math.imul(Te, He), m = m + Math.imul(Ne, Ue) | 0, a = a + Math.imul(Ne, Ze) | 0, a = a + Math.imul(Ae, Ue) | 0, x = x + Math.imul(Ae, Ze) | 0, m = m + Math.imul(ye, Ye) | 0, a = a + Math.imul(ye, Qe) | 0, a = a + Math.imul(Me, Ye) | 0, x = x + Math.imul(Me, Qe) | 0, m = m + Math.imul(de, ee) | 0, a = a + Math.imul(de, K) | 0, a = a + Math.imul(ae, ee) | 0, x = x + Math.imul(ae, K) | 0, m = m + Math.imul(se, re) | 0, a = a + Math.imul(se, he) | 0, a = a + Math.imul(ce, re) | 0, x = x + Math.imul(ce, he) | 0, m = m + Math.imul(ie, ve) | 0, a = a + Math.imul(ie, we) | 0, a = a + Math.imul(oe, ve) | 0, x = x + Math.imul(oe, we) | 0;
        var rt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (rt >>> 26) | 0, rt &= 67108863, m = Math.imul(ke, Ue), a = Math.imul(ke, Ze), a = a + Math.imul(Te, Ue) | 0, x = Math.imul(Te, Ze), m = m + Math.imul(Ne, Ye) | 0, a = a + Math.imul(Ne, Qe) | 0, a = a + Math.imul(Ae, Ye) | 0, x = x + Math.imul(Ae, Qe) | 0, m = m + Math.imul(ye, ee) | 0, a = a + Math.imul(ye, K) | 0, a = a + Math.imul(Me, ee) | 0, x = x + Math.imul(Me, K) | 0, m = m + Math.imul(de, re) | 0, a = a + Math.imul(de, he) | 0, a = a + Math.imul(ae, re) | 0, x = x + Math.imul(ae, he) | 0, m = m + Math.imul(se, ve) | 0, a = a + Math.imul(se, we) | 0, a = a + Math.imul(ce, ve) | 0, x = x + Math.imul(ce, we) | 0;
        var st = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (st >>> 26) | 0, st &= 67108863, m = Math.imul(ke, Ye), a = Math.imul(ke, Qe), a = a + Math.imul(Te, Ye) | 0, x = Math.imul(Te, Qe), m = m + Math.imul(Ne, ee) | 0, a = a + Math.imul(Ne, K) | 0, a = a + Math.imul(Ae, ee) | 0, x = x + Math.imul(Ae, K) | 0, m = m + Math.imul(ye, re) | 0, a = a + Math.imul(ye, he) | 0, a = a + Math.imul(Me, re) | 0, x = x + Math.imul(Me, he) | 0, m = m + Math.imul(de, ve) | 0, a = a + Math.imul(de, we) | 0, a = a + Math.imul(ae, ve) | 0, x = x + Math.imul(ae, we) | 0;
        var ct = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (ct >>> 26) | 0, ct &= 67108863, m = Math.imul(ke, ee), a = Math.imul(ke, K), a = a + Math.imul(Te, ee) | 0, x = Math.imul(Te, K), m = m + Math.imul(Ne, re) | 0, a = a + Math.imul(Ne, he) | 0, a = a + Math.imul(Ae, re) | 0, x = x + Math.imul(Ae, he) | 0, m = m + Math.imul(ye, ve) | 0, a = a + Math.imul(ye, we) | 0, a = a + Math.imul(Me, ve) | 0, x = x + Math.imul(Me, we) | 0;
        var Je = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Je >>> 26) | 0, Je &= 67108863, m = Math.imul(ke, re), a = Math.imul(ke, he), a = a + Math.imul(Te, re) | 0, x = Math.imul(Te, he), m = m + Math.imul(Ne, ve) | 0, a = a + Math.imul(Ne, we) | 0, a = a + Math.imul(Ae, ve) | 0, x = x + Math.imul(Ae, we) | 0;
        var Oe = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, m = Math.imul(ke, ve), a = Math.imul(ke, we), a = a + Math.imul(Te, ve) | 0, x = Math.imul(Te, we);
        var ze = (L + m | 0) + ((a & 8191) << 13) | 0;
        return L = (x + (a >>> 13) | 0) + (ze >>> 26) | 0, ze &= 67108863, A[0] = lt, A[1] = et, A[2] = Lt, A[3] = nt, A[4] = gt, A[5] = yt, A[6] = xt, A[7] = bt, A[8] = Mt, A[9] = vt, A[10] = mt, A[11] = ot, A[12] = ft, A[13] = rt, A[14] = st, A[15] = ct, A[16] = Je, A[17] = Oe, A[18] = ze, L !== 0 && (A[19] = L, u.length++), u;
      };
      Math.imul || (w = N);
      function S(I, r, s) {
        s.negative = r.negative ^ I.negative, s.length = I.length + r.length;
        for (var u = 0, g = 0, v = 0; v < s.length - 1; v++) {
          var A = g;
          g = 0;
          for (var L = u & 67108863, m = Math.min(v, r.length - 1), a = Math.max(0, v - I.length + 1); a <= m; a++) {
            var x = v - a, V = I.words[x] | 0, G = r.words[a] | 0, Z = V * G, te = Z & 67108863;
            A = A + (Z / 67108864 | 0) | 0, te = te + L | 0, L = te & 67108863, A = A + (te >>> 26) | 0, g += A >>> 26, A &= 67108863;
          }
          s.words[v] = L, u = A, A = g;
        }
        return u !== 0 ? s.words[v] = u : s.length--, s.strip();
      }
      function T(I, r, s) {
        var u = new E();
        return u.mulp(I, r, s);
      }
      n.prototype.mulTo = function(r, s) {
        var u, g = this.length + r.length;
        return this.length === 10 && r.length === 10 ? u = w(this, r, s) : g < 63 ? u = N(this, r, s) : g < 1024 ? u = S(this, r, s) : u = T(this, r, s), u;
      };
      function E(I, r) {
        this.x = I, this.y = r;
      }
      E.prototype.makeRBT = function(r) {
        for (var s = new Array(r), u = n.prototype._countBits(r) - 1, g = 0; g < r; g++)
          s[g] = this.revBin(g, u, r);
        return s;
      }, E.prototype.revBin = function(r, s, u) {
        if (r === 0 || r === u - 1) return r;
        for (var g = 0, v = 0; v < s; v++)
          g |= (r & 1) << s - v - 1, r >>= 1;
        return g;
      }, E.prototype.permute = function(r, s, u, g, v, A) {
        for (var L = 0; L < A; L++)
          g[L] = s[r[L]], v[L] = u[r[L]];
      }, E.prototype.transform = function(r, s, u, g, v, A) {
        this.permute(A, r, s, u, g, v);
        for (var L = 1; L < v; L <<= 1)
          for (var m = L << 1, a = Math.cos(2 * Math.PI / m), x = Math.sin(2 * Math.PI / m), V = 0; V < v; V += m)
            for (var G = a, Z = x, te = 0; te < L; te++) {
              var q = u[V + te], R = g[V + te], Q = u[V + te + L], $ = g[V + te + L], F = G * Q - Z * $;
              $ = G * $ + Z * Q, Q = F, u[V + te] = q + Q, g[V + te] = R + $, u[V + te + L] = q - Q, g[V + te + L] = R - $, te !== m && (F = a * G - x * Z, Z = a * Z + x * G, G = F);
            }
      }, E.prototype.guessLen13b = function(r, s) {
        var u = Math.max(s, r) | 1, g = u & 1, v = 0;
        for (u = u / 2 | 0; u; u = u >>> 1)
          v++;
        return 1 << v + 1 + g;
      }, E.prototype.conjugate = function(r, s, u) {
        if (!(u <= 1))
          for (var g = 0; g < u / 2; g++) {
            var v = r[g];
            r[g] = r[u - g - 1], r[u - g - 1] = v, v = s[g], s[g] = -s[u - g - 1], s[u - g - 1] = -v;
          }
      }, E.prototype.normalize13b = function(r, s) {
        for (var u = 0, g = 0; g < s / 2; g++) {
          var v = Math.round(r[2 * g + 1] / s) * 8192 + Math.round(r[2 * g] / s) + u;
          r[g] = v & 67108863, v < 67108864 ? u = 0 : u = v / 67108864 | 0;
        }
        return r;
      }, E.prototype.convert13b = function(r, s, u, g) {
        for (var v = 0, A = 0; A < s; A++)
          v = v + (r[A] | 0), u[2 * A] = v & 8191, v = v >>> 13, u[2 * A + 1] = v & 8191, v = v >>> 13;
        for (A = 2 * s; A < g; ++A)
          u[A] = 0;
        i(v === 0), i((v & -8192) === 0);
      }, E.prototype.stub = function(r) {
        for (var s = new Array(r), u = 0; u < r; u++)
          s[u] = 0;
        return s;
      }, E.prototype.mulp = function(r, s, u) {
        var g = 2 * this.guessLen13b(r.length, s.length), v = this.makeRBT(g), A = this.stub(g), L = new Array(g), m = new Array(g), a = new Array(g), x = new Array(g), V = new Array(g), G = new Array(g), Z = u.words;
        Z.length = g, this.convert13b(r.words, r.length, L, g), this.convert13b(s.words, s.length, x, g), this.transform(L, A, m, a, g, v), this.transform(x, A, V, G, g, v);
        for (var te = 0; te < g; te++) {
          var q = m[te] * V[te] - a[te] * G[te];
          a[te] = m[te] * G[te] + a[te] * V[te], m[te] = q;
        }
        return this.conjugate(m, a, g), this.transform(m, a, Z, A, g, v), this.conjugate(Z, A, g), this.normalize13b(Z, g), u.negative = r.negative ^ s.negative, u.length = r.length + s.length, u.strip();
      }, n.prototype.mul = function(r) {
        var s = new n(null);
        return s.words = new Array(this.length + r.length), this.mulTo(r, s);
      }, n.prototype.mulf = function(r) {
        var s = new n(null);
        return s.words = new Array(this.length + r.length), T(this, r, s);
      }, n.prototype.imul = function(r) {
        return this.clone().mulTo(r, this);
      }, n.prototype.imuln = function(r) {
        i(typeof r == "number"), i(r < 67108864);
        for (var s = 0, u = 0; u < this.length; u++) {
          var g = (this.words[u] | 0) * r, v = (g & 67108863) + (s & 67108863);
          s >>= 26, s += g / 67108864 | 0, s += v >>> 26, this.words[u] = v & 67108863;
        }
        return s !== 0 && (this.words[u] = s, this.length++), this.length = r === 0 ? 1 : this.length, this;
      }, n.prototype.muln = function(r) {
        return this.clone().imuln(r);
      }, n.prototype.sqr = function() {
        return this.mul(this);
      }, n.prototype.isqr = function() {
        return this.imul(this.clone());
      }, n.prototype.pow = function(r) {
        var s = C(r);
        if (s.length === 0) return new n(1);
        for (var u = this, g = 0; g < s.length && s[g] === 0; g++, u = u.sqr())
          ;
        if (++g < s.length)
          for (var v = u.sqr(); g < s.length; g++, v = v.sqr())
            s[g] !== 0 && (u = u.mul(v));
        return u;
      }, n.prototype.iushln = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = r % 26, u = (r - s) / 26, g = 67108863 >>> 26 - s << 26 - s, v;
        if (s !== 0) {
          var A = 0;
          for (v = 0; v < this.length; v++) {
            var L = this.words[v] & g, m = (this.words[v] | 0) - L << s;
            this.words[v] = m | A, A = L >>> 26 - s;
          }
          A && (this.words[v] = A, this.length++);
        }
        if (u !== 0) {
          for (v = this.length - 1; v >= 0; v--)
            this.words[v + u] = this.words[v];
          for (v = 0; v < u; v++)
            this.words[v] = 0;
          this.length += u;
        }
        return this.strip();
      }, n.prototype.ishln = function(r) {
        return i(this.negative === 0), this.iushln(r);
      }, n.prototype.iushrn = function(r, s, u) {
        i(typeof r == "number" && r >= 0);
        var g;
        s ? g = (s - s % 26) / 26 : g = 0;
        var v = r % 26, A = Math.min((r - v) / 26, this.length), L = 67108863 ^ 67108863 >>> v << v, m = u;
        if (g -= A, g = Math.max(0, g), m) {
          for (var a = 0; a < A; a++)
            m.words[a] = this.words[a];
          m.length = A;
        }
        if (A !== 0) if (this.length > A)
          for (this.length -= A, a = 0; a < this.length; a++)
            this.words[a] = this.words[a + A];
        else
          this.words[0] = 0, this.length = 1;
        var x = 0;
        for (a = this.length - 1; a >= 0 && (x !== 0 || a >= g); a--) {
          var V = this.words[a] | 0;
          this.words[a] = x << 26 - v | V >>> v, x = V & L;
        }
        return m && x !== 0 && (m.words[m.length++] = x), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, n.prototype.ishrn = function(r, s, u) {
        return i(this.negative === 0), this.iushrn(r, s, u);
      }, n.prototype.shln = function(r) {
        return this.clone().ishln(r);
      }, n.prototype.ushln = function(r) {
        return this.clone().iushln(r);
      }, n.prototype.shrn = function(r) {
        return this.clone().ishrn(r);
      }, n.prototype.ushrn = function(r) {
        return this.clone().iushrn(r);
      }, n.prototype.testn = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = r % 26, u = (r - s) / 26, g = 1 << s;
        if (this.length <= u) return !1;
        var v = this.words[u];
        return !!(v & g);
      }, n.prototype.imaskn = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = r % 26, u = (r - s) / 26;
        if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= u)
          return this;
        if (s !== 0 && u++, this.length = Math.min(u, this.length), s !== 0) {
          var g = 67108863 ^ 67108863 >>> s << s;
          this.words[this.length - 1] &= g;
        }
        return this.strip();
      }, n.prototype.maskn = function(r) {
        return this.clone().imaskn(r);
      }, n.prototype.iaddn = function(r) {
        return i(typeof r == "number"), i(r < 67108864), r < 0 ? this.isubn(-r) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < r ? (this.words[0] = r - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(r), this.negative = 1, this) : this._iaddn(r);
      }, n.prototype._iaddn = function(r) {
        this.words[0] += r;
        for (var s = 0; s < this.length && this.words[s] >= 67108864; s++)
          this.words[s] -= 67108864, s === this.length - 1 ? this.words[s + 1] = 1 : this.words[s + 1]++;
        return this.length = Math.max(this.length, s + 1), this;
      }, n.prototype.isubn = function(r) {
        if (i(typeof r == "number"), i(r < 67108864), r < 0) return this.iaddn(-r);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(r), this.negative = 1, this;
        if (this.words[0] -= r, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var s = 0; s < this.length && this.words[s] < 0; s++)
            this.words[s] += 67108864, this.words[s + 1] -= 1;
        return this.strip();
      }, n.prototype.addn = function(r) {
        return this.clone().iaddn(r);
      }, n.prototype.subn = function(r) {
        return this.clone().isubn(r);
      }, n.prototype.iabs = function() {
        return this.negative = 0, this;
      }, n.prototype.abs = function() {
        return this.clone().iabs();
      }, n.prototype._ishlnsubmul = function(r, s, u) {
        var g = r.length + u, v;
        this._expand(g);
        var A, L = 0;
        for (v = 0; v < r.length; v++) {
          A = (this.words[v + u] | 0) + L;
          var m = (r.words[v] | 0) * s;
          A -= m & 67108863, L = (A >> 26) - (m / 67108864 | 0), this.words[v + u] = A & 67108863;
        }
        for (; v < this.length - u; v++)
          A = (this.words[v + u] | 0) + L, L = A >> 26, this.words[v + u] = A & 67108863;
        if (L === 0) return this.strip();
        for (i(L === -1), L = 0, v = 0; v < this.length; v++)
          A = -(this.words[v] | 0) + L, L = A >> 26, this.words[v] = A & 67108863;
        return this.negative = 1, this.strip();
      }, n.prototype._wordDiv = function(r, s) {
        var u = this.length - r.length, g = this.clone(), v = r, A = v.words[v.length - 1] | 0, L = this._countBits(A);
        u = 26 - L, u !== 0 && (v = v.ushln(u), g.iushln(u), A = v.words[v.length - 1] | 0);
        var m = g.length - v.length, a;
        if (s !== "mod") {
          a = new n(null), a.length = m + 1, a.words = new Array(a.length);
          for (var x = 0; x < a.length; x++)
            a.words[x] = 0;
        }
        var V = g.clone()._ishlnsubmul(v, 1, m);
        V.negative === 0 && (g = V, a && (a.words[m] = 1));
        for (var G = m - 1; G >= 0; G--) {
          var Z = (g.words[v.length + G] | 0) * 67108864 + (g.words[v.length + G - 1] | 0);
          for (Z = Math.min(Z / A | 0, 67108863), g._ishlnsubmul(v, Z, G); g.negative !== 0; )
            Z--, g.negative = 0, g._ishlnsubmul(v, 1, G), g.isZero() || (g.negative ^= 1);
          a && (a.words[G] = Z);
        }
        return a && a.strip(), g.strip(), s !== "div" && u !== 0 && g.iushrn(u), {
          div: a || null,
          mod: g
        };
      }, n.prototype.divmod = function(r, s, u) {
        if (i(!r.isZero()), this.isZero())
          return {
            div: new n(0),
            mod: new n(0)
          };
        var g, v, A;
        return this.negative !== 0 && r.negative === 0 ? (A = this.neg().divmod(r, s), s !== "mod" && (g = A.div.neg()), s !== "div" && (v = A.mod.neg(), u && v.negative !== 0 && v.iadd(r)), {
          div: g,
          mod: v
        }) : this.negative === 0 && r.negative !== 0 ? (A = this.divmod(r.neg(), s), s !== "mod" && (g = A.div.neg()), {
          div: g,
          mod: A.mod
        }) : this.negative & r.negative ? (A = this.neg().divmod(r.neg(), s), s !== "div" && (v = A.mod.neg(), u && v.negative !== 0 && v.isub(r)), {
          div: A.div,
          mod: v
        }) : r.length > this.length || this.cmp(r) < 0 ? {
          div: new n(0),
          mod: this
        } : r.length === 1 ? s === "div" ? {
          div: this.divn(r.words[0]),
          mod: null
        } : s === "mod" ? {
          div: null,
          mod: new n(this.modn(r.words[0]))
        } : {
          div: this.divn(r.words[0]),
          mod: new n(this.modn(r.words[0]))
        } : this._wordDiv(r, s);
      }, n.prototype.div = function(r) {
        return this.divmod(r, "div", !1).div;
      }, n.prototype.mod = function(r) {
        return this.divmod(r, "mod", !1).mod;
      }, n.prototype.umod = function(r) {
        return this.divmod(r, "mod", !0).mod;
      }, n.prototype.divRound = function(r) {
        var s = this.divmod(r);
        if (s.mod.isZero()) return s.div;
        var u = s.div.negative !== 0 ? s.mod.isub(r) : s.mod, g = r.ushrn(1), v = r.andln(1), A = u.cmp(g);
        return A < 0 || v === 1 && A === 0 ? s.div : s.div.negative !== 0 ? s.div.isubn(1) : s.div.iaddn(1);
      }, n.prototype.modn = function(r) {
        i(r <= 67108863);
        for (var s = (1 << 26) % r, u = 0, g = this.length - 1; g >= 0; g--)
          u = (s * u + (this.words[g] | 0)) % r;
        return u;
      }, n.prototype.idivn = function(r) {
        i(r <= 67108863);
        for (var s = 0, u = this.length - 1; u >= 0; u--) {
          var g = (this.words[u] | 0) + s * 67108864;
          this.words[u] = g / r | 0, s = g % r;
        }
        return this.strip();
      }, n.prototype.divn = function(r) {
        return this.clone().idivn(r);
      }, n.prototype.egcd = function(r) {
        i(r.negative === 0), i(!r.isZero());
        var s = this, u = r.clone();
        s.negative !== 0 ? s = s.umod(r) : s = s.clone();
        for (var g = new n(1), v = new n(0), A = new n(0), L = new n(1), m = 0; s.isEven() && u.isEven(); )
          s.iushrn(1), u.iushrn(1), ++m;
        for (var a = u.clone(), x = s.clone(); !s.isZero(); ) {
          for (var V = 0, G = 1; !(s.words[0] & G) && V < 26; ++V, G <<= 1) ;
          if (V > 0)
            for (s.iushrn(V); V-- > 0; )
              (g.isOdd() || v.isOdd()) && (g.iadd(a), v.isub(x)), g.iushrn(1), v.iushrn(1);
          for (var Z = 0, te = 1; !(u.words[0] & te) && Z < 26; ++Z, te <<= 1) ;
          if (Z > 0)
            for (u.iushrn(Z); Z-- > 0; )
              (A.isOdd() || L.isOdd()) && (A.iadd(a), L.isub(x)), A.iushrn(1), L.iushrn(1);
          s.cmp(u) >= 0 ? (s.isub(u), g.isub(A), v.isub(L)) : (u.isub(s), A.isub(g), L.isub(v));
        }
        return {
          a: A,
          b: L,
          gcd: u.iushln(m)
        };
      }, n.prototype._invmp = function(r) {
        i(r.negative === 0), i(!r.isZero());
        var s = this, u = r.clone();
        s.negative !== 0 ? s = s.umod(r) : s = s.clone();
        for (var g = new n(1), v = new n(0), A = u.clone(); s.cmpn(1) > 0 && u.cmpn(1) > 0; ) {
          for (var L = 0, m = 1; !(s.words[0] & m) && L < 26; ++L, m <<= 1) ;
          if (L > 0)
            for (s.iushrn(L); L-- > 0; )
              g.isOdd() && g.iadd(A), g.iushrn(1);
          for (var a = 0, x = 1; !(u.words[0] & x) && a < 26; ++a, x <<= 1) ;
          if (a > 0)
            for (u.iushrn(a); a-- > 0; )
              v.isOdd() && v.iadd(A), v.iushrn(1);
          s.cmp(u) >= 0 ? (s.isub(u), g.isub(v)) : (u.isub(s), v.isub(g));
        }
        var V;
        return s.cmpn(1) === 0 ? V = g : V = v, V.cmpn(0) < 0 && V.iadd(r), V;
      }, n.prototype.gcd = function(r) {
        if (this.isZero()) return r.abs();
        if (r.isZero()) return this.abs();
        var s = this.clone(), u = r.clone();
        s.negative = 0, u.negative = 0;
        for (var g = 0; s.isEven() && u.isEven(); g++)
          s.iushrn(1), u.iushrn(1);
        do {
          for (; s.isEven(); )
            s.iushrn(1);
          for (; u.isEven(); )
            u.iushrn(1);
          var v = s.cmp(u);
          if (v < 0) {
            var A = s;
            s = u, u = A;
          } else if (v === 0 || u.cmpn(1) === 0)
            break;
          s.isub(u);
        } while (!0);
        return u.iushln(g);
      }, n.prototype.invm = function(r) {
        return this.egcd(r).a.umod(r);
      }, n.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, n.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, n.prototype.andln = function(r) {
        return this.words[0] & r;
      }, n.prototype.bincn = function(r) {
        i(typeof r == "number");
        var s = r % 26, u = (r - s) / 26, g = 1 << s;
        if (this.length <= u)
          return this._expand(u + 1), this.words[u] |= g, this;
        for (var v = g, A = u; v !== 0 && A < this.length; A++) {
          var L = this.words[A] | 0;
          L += v, v = L >>> 26, L &= 67108863, this.words[A] = L;
        }
        return v !== 0 && (this.words[A] = v, this.length++), this;
      }, n.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, n.prototype.cmpn = function(r) {
        var s = r < 0;
        if (this.negative !== 0 && !s) return -1;
        if (this.negative === 0 && s) return 1;
        this.strip();
        var u;
        if (this.length > 1)
          u = 1;
        else {
          s && (r = -r), i(r <= 67108863, "Number is too big");
          var g = this.words[0] | 0;
          u = g === r ? 0 : g < r ? -1 : 1;
        }
        return this.negative !== 0 ? -u | 0 : u;
      }, n.prototype.cmp = function(r) {
        if (this.negative !== 0 && r.negative === 0) return -1;
        if (this.negative === 0 && r.negative !== 0) return 1;
        var s = this.ucmp(r);
        return this.negative !== 0 ? -s | 0 : s;
      }, n.prototype.ucmp = function(r) {
        if (this.length > r.length) return 1;
        if (this.length < r.length) return -1;
        for (var s = 0, u = this.length - 1; u >= 0; u--) {
          var g = this.words[u] | 0, v = r.words[u] | 0;
          if (g !== v) {
            g < v ? s = -1 : g > v && (s = 1);
            break;
          }
        }
        return s;
      }, n.prototype.gtn = function(r) {
        return this.cmpn(r) === 1;
      }, n.prototype.gt = function(r) {
        return this.cmp(r) === 1;
      }, n.prototype.gten = function(r) {
        return this.cmpn(r) >= 0;
      }, n.prototype.gte = function(r) {
        return this.cmp(r) >= 0;
      }, n.prototype.ltn = function(r) {
        return this.cmpn(r) === -1;
      }, n.prototype.lt = function(r) {
        return this.cmp(r) === -1;
      }, n.prototype.lten = function(r) {
        return this.cmpn(r) <= 0;
      }, n.prototype.lte = function(r) {
        return this.cmp(r) <= 0;
      }, n.prototype.eqn = function(r) {
        return this.cmpn(r) === 0;
      }, n.prototype.eq = function(r) {
        return this.cmp(r) === 0;
      }, n.red = function(r) {
        return new U(r);
      }, n.prototype.toRed = function(r) {
        return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), r.convertTo(this)._forceRed(r);
      }, n.prototype.fromRed = function() {
        return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, n.prototype._forceRed = function(r) {
        return this.red = r, this;
      }, n.prototype.forceRed = function(r) {
        return i(!this.red, "Already a number in reduction context"), this._forceRed(r);
      }, n.prototype.redAdd = function(r) {
        return i(this.red, "redAdd works only with red numbers"), this.red.add(this, r);
      }, n.prototype.redIAdd = function(r) {
        return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, r);
      }, n.prototype.redSub = function(r) {
        return i(this.red, "redSub works only with red numbers"), this.red.sub(this, r);
      }, n.prototype.redISub = function(r) {
        return i(this.red, "redISub works only with red numbers"), this.red.isub(this, r);
      }, n.prototype.redShl = function(r) {
        return i(this.red, "redShl works only with red numbers"), this.red.shl(this, r);
      }, n.prototype.redMul = function(r) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, r), this.red.mul(this, r);
      }, n.prototype.redIMul = function(r) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, r), this.red.imul(this, r);
      }, n.prototype.redSqr = function() {
        return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, n.prototype.redISqr = function() {
        return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, n.prototype.redSqrt = function() {
        return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, n.prototype.redInvm = function() {
        return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, n.prototype.redNeg = function() {
        return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, n.prototype.redPow = function(r) {
        return i(this.red && !r.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, r);
      };
      var j = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function O(I, r) {
        this.name = I, this.p = new n(r, 16), this.n = this.p.bitLength(), this.k = new n(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      O.prototype._tmp = function() {
        var r = new n(null);
        return r.words = new Array(Math.ceil(this.n / 13)), r;
      }, O.prototype.ireduce = function(r) {
        var s = r, u;
        do
          this.split(s, this.tmp), s = this.imulK(s), s = s.iadd(this.tmp), u = s.bitLength();
        while (u > this.n);
        var g = u < this.n ? -1 : s.ucmp(this.p);
        return g === 0 ? (s.words[0] = 0, s.length = 1) : g > 0 ? s.isub(this.p) : s.strip !== void 0 ? s.strip() : s._strip(), s;
      }, O.prototype.split = function(r, s) {
        r.iushrn(this.n, 0, s);
      }, O.prototype.imulK = function(r) {
        return r.imul(this.k);
      };
      function z() {
        O.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      c(z, O), z.prototype.split = function(r, s) {
        for (var u = 4194303, g = Math.min(r.length, 9), v = 0; v < g; v++)
          s.words[v] = r.words[v];
        if (s.length = g, r.length <= 9) {
          r.words[0] = 0, r.length = 1;
          return;
        }
        var A = r.words[9];
        for (s.words[s.length++] = A & u, v = 10; v < r.length; v++) {
          var L = r.words[v] | 0;
          r.words[v - 10] = (L & u) << 4 | A >>> 22, A = L;
        }
        A >>>= 22, r.words[v - 10] = A, A === 0 && r.length > 10 ? r.length -= 10 : r.length -= 9;
      }, z.prototype.imulK = function(r) {
        r.words[r.length] = 0, r.words[r.length + 1] = 0, r.length += 2;
        for (var s = 0, u = 0; u < r.length; u++) {
          var g = r.words[u] | 0;
          s += g * 977, r.words[u] = s & 67108863, s = g * 64 + (s / 67108864 | 0);
        }
        return r.words[r.length - 1] === 0 && (r.length--, r.words[r.length - 1] === 0 && r.length--), r;
      };
      function k() {
        O.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      c(k, O);
      function H() {
        O.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      c(H, O);
      function W() {
        O.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      c(W, O), W.prototype.imulK = function(r) {
        for (var s = 0, u = 0; u < r.length; u++) {
          var g = (r.words[u] | 0) * 19 + s, v = g & 67108863;
          g >>>= 26, r.words[u] = v, s = g;
        }
        return s !== 0 && (r.words[r.length++] = s), r;
      }, n._prime = function(r) {
        if (j[r]) return j[r];
        var s;
        if (r === "k256")
          s = new z();
        else if (r === "p224")
          s = new k();
        else if (r === "p192")
          s = new H();
        else if (r === "p25519")
          s = new W();
        else
          throw new Error("Unknown prime " + r);
        return j[r] = s, s;
      };
      function U(I) {
        if (typeof I == "string") {
          var r = n._prime(I);
          this.m = r.p, this.prime = r;
        } else
          i(I.gtn(1), "modulus must be greater than 1"), this.m = I, this.prime = null;
      }
      U.prototype._verify1 = function(r) {
        i(r.negative === 0, "red works only with positives"), i(r.red, "red works only with red numbers");
      }, U.prototype._verify2 = function(r, s) {
        i((r.negative | s.negative) === 0, "red works only with positives"), i(
          r.red && r.red === s.red,
          "red works only with red numbers"
        );
      }, U.prototype.imod = function(r) {
        return this.prime ? this.prime.ireduce(r)._forceRed(this) : r.umod(this.m)._forceRed(this);
      }, U.prototype.neg = function(r) {
        return r.isZero() ? r.clone() : this.m.sub(r)._forceRed(this);
      }, U.prototype.add = function(r, s) {
        this._verify2(r, s);
        var u = r.add(s);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u._forceRed(this);
      }, U.prototype.iadd = function(r, s) {
        this._verify2(r, s);
        var u = r.iadd(s);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u;
      }, U.prototype.sub = function(r, s) {
        this._verify2(r, s);
        var u = r.sub(s);
        return u.cmpn(0) < 0 && u.iadd(this.m), u._forceRed(this);
      }, U.prototype.isub = function(r, s) {
        this._verify2(r, s);
        var u = r.isub(s);
        return u.cmpn(0) < 0 && u.iadd(this.m), u;
      }, U.prototype.shl = function(r, s) {
        return this._verify1(r), this.imod(r.ushln(s));
      }, U.prototype.imul = function(r, s) {
        return this._verify2(r, s), this.imod(r.imul(s));
      }, U.prototype.mul = function(r, s) {
        return this._verify2(r, s), this.imod(r.mul(s));
      }, U.prototype.isqr = function(r) {
        return this.imul(r, r.clone());
      }, U.prototype.sqr = function(r) {
        return this.mul(r, r);
      }, U.prototype.sqrt = function(r) {
        if (r.isZero()) return r.clone();
        var s = this.m.andln(3);
        if (i(s % 2 === 1), s === 3) {
          var u = this.m.add(new n(1)).iushrn(2);
          return this.pow(r, u);
        }
        for (var g = this.m.subn(1), v = 0; !g.isZero() && g.andln(1) === 0; )
          v++, g.iushrn(1);
        i(!g.isZero());
        var A = new n(1).toRed(this), L = A.redNeg(), m = this.m.subn(1).iushrn(1), a = this.m.bitLength();
        for (a = new n(2 * a * a).toRed(this); this.pow(a, m).cmp(L) !== 0; )
          a.redIAdd(L);
        for (var x = this.pow(a, g), V = this.pow(r, g.addn(1).iushrn(1)), G = this.pow(r, g), Z = v; G.cmp(A) !== 0; ) {
          for (var te = G, q = 0; te.cmp(A) !== 0; q++)
            te = te.redSqr();
          i(q < Z);
          var R = this.pow(x, new n(1).iushln(Z - q - 1));
          V = V.redMul(R), x = R.redSqr(), G = G.redMul(x), Z = q;
        }
        return V;
      }, U.prototype.invm = function(r) {
        var s = r._invmp(this.m);
        return s.negative !== 0 ? (s.negative = 0, this.imod(s).redNeg()) : this.imod(s);
      }, U.prototype.pow = function(r, s) {
        if (s.isZero()) return new n(1).toRed(this);
        if (s.cmpn(1) === 0) return r.clone();
        var u = 4, g = new Array(1 << u);
        g[0] = new n(1).toRed(this), g[1] = r;
        for (var v = 2; v < g.length; v++)
          g[v] = this.mul(g[v - 1], r);
        var A = g[0], L = 0, m = 0, a = s.bitLength() % 26;
        for (a === 0 && (a = 26), v = s.length - 1; v >= 0; v--) {
          for (var x = s.words[v], V = a - 1; V >= 0; V--) {
            var G = x >> V & 1;
            if (A !== g[0] && (A = this.sqr(A)), G === 0 && L === 0) {
              m = 0;
              continue;
            }
            L <<= 1, L |= G, m++, !(m !== u && (v !== 0 || V !== 0)) && (A = this.mul(A, g[L]), m = 0, L = 0);
          }
          a = 26;
        }
        return A;
      }, U.prototype.convertTo = function(r) {
        var s = r.umod(this.m);
        return s === r ? s.clone() : s;
      }, U.prototype.convertFrom = function(r) {
        var s = r.clone();
        return s.red = null, s;
      }, n.mont = function(r) {
        return new B(r);
      };
      function B(I) {
        U.call(this, I), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new n(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      c(B, U), B.prototype.convertTo = function(r) {
        return this.imod(r.ushln(this.shift));
      }, B.prototype.convertFrom = function(r) {
        var s = this.imod(r.mul(this.rinv));
        return s.red = null, s;
      }, B.prototype.imul = function(r, s) {
        if (r.isZero() || s.isZero())
          return r.words[0] = 0, r.length = 1, r;
        var u = r.imul(s), g = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), v = u.isub(g).iushrn(this.shift), A = v;
        return v.cmp(this.m) >= 0 ? A = v.isub(this.m) : v.cmpn(0) < 0 && (A = v.iadd(this.m)), A._forceRed(this);
      }, B.prototype.mul = function(r, s) {
        if (r.isZero() || s.isZero()) return new n(0)._forceRed(this);
        var u = r.mul(s), g = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), v = u.isub(g).iushrn(this.shift), A = v;
        return v.cmp(this.m) >= 0 ? A = v.isub(this.m) : v.cmpn(0) < 0 && (A = v.iadd(this.m)), A._forceRed(this);
      }, B.prototype.invm = function(r) {
        var s = this.imod(r._invmp(this.m).mul(this.r2));
        return s._forceRed(this);
      };
    })(e, Wt);
  }(W0)), W0.exports;
}
var h0 = { exports: {} }, Gp;
function bh() {
  if (Gp) return h0.exports;
  Gp = 1;
  var e;
  h0.exports = function(c) {
    return e || (e = new t(null)), e.generate(c);
  };
  function t(i) {
    this.rand = i;
  }
  if (h0.exports.Rand = t, t.prototype.generate = function(c) {
    return this._rand(c);
  }, t.prototype._rand = function(c) {
    if (this.rand.getBytes)
      return this.rand.getBytes(c);
    for (var n = new Uint8Array(c), d = 0; d < n.length; d++)
      n[d] = this.rand.getByte();
    return n;
  }, typeof self == "object")
    self.crypto && self.crypto.getRandomValues ? t.prototype._rand = function(c) {
      var n = new Uint8Array(c);
      return self.crypto.getRandomValues(n), n;
    } : self.msCrypto && self.msCrypto.getRandomValues ? t.prototype._rand = function(c) {
      var n = new Uint8Array(c);
      return self.msCrypto.getRandomValues(n), n;
    } : typeof window == "object" && (t.prototype._rand = function() {
      throw new Error("Not implemented yet");
    });
  else
    try {
      var o = zM();
      if (typeof o.randomBytes != "function")
        throw new Error("Not supported");
      t.prototype._rand = function(c) {
        return o.randomBytes(c);
      };
    } catch {
    }
  return h0.exports;
}
var Mu, $p;
function gM() {
  if ($p) return Mu;
  $p = 1;
  var e = dA(), t = bh();
  function o(i) {
    this.rand = i || new t.Rand();
  }
  return Mu = o, o.create = function(c) {
    return new o(c);
  }, o.prototype._randbelow = function(c) {
    var n = c.bitLength(), d = Math.ceil(n / 8);
    do
      var f = new e(this.rand.generate(d));
    while (f.cmp(c) >= 0);
    return f;
  }, o.prototype._randrange = function(c, n) {
    var d = n.sub(c);
    return c.add(this._randbelow(d));
  }, o.prototype.test = function(c, n, d) {
    var f = c.bitLength(), p = e.mont(c), l = new e(1).toRed(p);
    n || (n = Math.max(1, f / 48 | 0));
    for (var h = c.subn(1), y = 0; !h.testn(y); y++)
      ;
    for (var M = c.shrn(y), C = h.toRed(p), N = !0; n > 0; n--) {
      var w = this._randrange(new e(2), h);
      d && d(w);
      var S = w.toRed(p).redPow(M);
      if (!(S.cmp(l) === 0 || S.cmp(C) === 0)) {
        for (var T = 1; T < y; T++) {
          if (S = S.redSqr(), S.cmp(l) === 0)
            return !1;
          if (S.cmp(C) === 0)
            break;
        }
        if (T === y)
          return !1;
      }
    }
    return N;
  }, o.prototype.getDivisor = function(c, n) {
    var d = c.bitLength(), f = e.mont(c), p = new e(1).toRed(f);
    n || (n = Math.max(1, d / 48 | 0));
    for (var l = c.subn(1), h = 0; !l.testn(h); h++)
      ;
    for (var y = c.shrn(h), M = l.toRed(f); n > 0; n--) {
      var C = this._randrange(new e(2), l), N = c.gcd(C);
      if (N.cmpn(1) !== 0)
        return N;
      var w = C.toRed(f).redPow(y);
      if (!(w.cmp(p) === 0 || w.cmp(M) === 0)) {
        for (var S = 1; S < h; S++) {
          if (w = w.redSqr(), w.cmp(p) === 0)
            return w.fromRed().subn(1).gcd(c);
          if (w.cmp(M) === 0)
            break;
        }
        if (S === h)
          return w = w.redSqr(), w.fromRed().subn(1).gcd(c);
      }
    }
    return !1;
  }, Mu;
}
var mu, qp;
function yM() {
  if (qp) return mu;
  qp = 1;
  var e = Ia();
  mu = S, S.simpleSieve = N, S.fermatTest = w;
  var t = pM(), o = new t(24), i = gM(), c = new i(), n = new t(1), d = new t(2), f = new t(5);
  new t(16), new t(8);
  var p = new t(10), l = new t(3);
  new t(7);
  var h = new t(11), y = new t(4);
  new t(12);
  var M = null;
  function C() {
    if (M !== null)
      return M;
    var T = 1048576, E = [];
    E[0] = 2;
    for (var j = 1, O = 3; O < T; O += 2) {
      for (var z = Math.ceil(Math.sqrt(O)), k = 0; k < j && E[k] <= z && O % E[k] !== 0; k++)
        ;
      j !== k && E[k] <= z || (E[j++] = O);
    }
    return M = E, E;
  }
  function N(T) {
    for (var E = C(), j = 0; j < E.length; j++)
      if (T.modn(E[j]) === 0)
        return T.cmpn(E[j]) === 0;
    return !0;
  }
  function w(T) {
    var E = t.mont(T);
    return d.toRed(E).redPow(T.subn(1)).fromRed().cmpn(1) === 0;
  }
  function S(T, E) {
    if (T < 16)
      return E === 2 || E === 5 ? new t([140, 123]) : new t([140, 39]);
    E = new t(E);
    for (var j, O; ; ) {
      for (j = new t(e(Math.ceil(T / 8))); j.bitLength() > T; )
        j.ishrn(1);
      if (j.isEven() && j.iadd(n), j.testn(1) || j.iadd(d), E.cmp(d)) {
        if (!E.cmp(f))
          for (; j.mod(p).cmp(l); )
            j.iadd(y);
      } else for (; j.mod(o).cmp(h); )
        j.iadd(y);
      if (O = j.shrn(1), N(O) && N(j) && w(O) && w(j) && c.test(O) && c.test(j))
        return j;
    }
  }
  return mu;
}
const hA = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
}, pA = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
}, gA = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
}, yA = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
}, MA = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
}, mA = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
}, vA = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
}, bA = {
  gen: "02",
  prime: "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"
}, xA = {
  modp1: hA,
  modp2: pA,
  modp5: gA,
  modp14: yA,
  modp15: MA,
  modp16: mA,
  modp17: vA,
  modp18: bA
};
var vu, Jp;
function wA() {
  if (Jp) return vu;
  Jp = 1;
  var e = pM(), t = gM(), o = new t(), i = new e(24), c = new e(11), n = new e(10), d = new e(3), f = new e(7), p = yM(), l = Ia();
  vu = N;
  function h(S, T) {
    return T = T || "utf8", fe.Buffer.isBuffer(S) || (S = new fe.Buffer(S, T)), this._pub = new e(S), this;
  }
  function y(S, T) {
    return T = T || "utf8", fe.Buffer.isBuffer(S) || (S = new fe.Buffer(S, T)), this._priv = new e(S), this;
  }
  var M = {};
  function C(S, T) {
    var E = T.toString("hex"), j = [E, S.toString(16)].join("_");
    if (j in M)
      return M[j];
    var O = 0;
    if (S.isEven() || !p.simpleSieve || !p.fermatTest(S) || !o.test(S))
      return O += 1, E === "02" || E === "05" ? O += 8 : O += 4, M[j] = O, O;
    o.test(S.shrn(1)) || (O += 2);
    var z;
    switch (E) {
      case "02":
        S.mod(i).cmp(c) && (O += 8);
        break;
      case "05":
        z = S.mod(n), z.cmp(d) && z.cmp(f) && (O += 8);
        break;
      default:
        O += 4;
    }
    return M[j] = O, O;
  }
  function N(S, T, E) {
    this.setGenerator(T), this.__prime = new e(S), this._prime = e.mont(this.__prime), this._primeLen = S.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, E ? (this.setPublicKey = h, this.setPrivateKey = y) : this._primeCode = 8;
  }
  Object.defineProperty(N.prototype, "verifyError", {
    enumerable: !0,
    get: function() {
      return typeof this._primeCode != "number" && (this._primeCode = C(this.__prime, this.__gen)), this._primeCode;
    }
  }), N.prototype.generateKeys = function() {
    return this._priv || (this._priv = new e(l(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
  }, N.prototype.computeSecret = function(S) {
    S = new e(S), S = S.toRed(this._prime);
    var T = S.redPow(this._priv).fromRed(), E = new fe.Buffer(T.toArray()), j = this.getPrime();
    if (E.length < j.length) {
      var O = new fe.Buffer(j.length - E.length);
      O.fill(0), E = fe.Buffer.concat([O, E]);
    }
    return E;
  }, N.prototype.getPublicKey = function(T) {
    return w(this._pub, T);
  }, N.prototype.getPrivateKey = function(T) {
    return w(this._priv, T);
  }, N.prototype.getPrime = function(S) {
    return w(this.__prime, S);
  }, N.prototype.getGenerator = function(S) {
    return w(this._gen, S);
  }, N.prototype.setGenerator = function(S, T) {
    return T = T || "utf8", fe.Buffer.isBuffer(S) || (S = new fe.Buffer(S, T)), this.__gen = S, this._gen = new e(S), this;
  };
  function w(S, T) {
    var E = new fe.Buffer(S.toArray());
    return T ? E.toString(T) : E;
  }
  return vu;
}
var Xp;
function CA() {
  if (Xp) return Ki;
  Xp = 1;
  var e = yM(), t = xA, o = wA();
  function i(d) {
    var f = new fe.Buffer(t[d].prime, "hex"), p = new fe.Buffer(t[d].gen, "hex");
    return new o(f, p);
  }
  var c = {
    binary: !0,
    hex: !0,
    base64: !0
  };
  function n(d, f, p, l) {
    return fe.Buffer.isBuffer(f) || c[f] === void 0 ? n(d, "binary", f, p) : (f = f || "binary", l = l || "binary", p = p || new fe.Buffer([2]), fe.Buffer.isBuffer(p) || (p = new fe.Buffer(p, l)), typeof d == "number" ? new o(e(d, p), p, !0) : (fe.Buffer.isBuffer(d) || (d = new fe.Buffer(d, f)), new o(d, p, !0)));
  }
  return Ki.DiffieHellmanGroup = Ki.createDiffieHellmanGroup = Ki.getDiffieHellman = i, Ki.createDiffieHellman = Ki.DiffieHellman = n, Ki;
}
var p0 = { exports: {} }, g0 = { exports: {} }, Kp;
function Vc() {
  if (Kp) return g0.exports;
  Kp = 1, typeof fe.process > "u" || !fe.process.version || fe.process.version.indexOf("v0.") === 0 || fe.process.version.indexOf("v1.") === 0 && fe.process.version.indexOf("v1.8.") !== 0 ? g0.exports = { nextTick: e } : g0.exports = fe.process;
  function e(t, o, i, c) {
    if (typeof t != "function")
      throw new TypeError('"callback" argument must be a function');
    var n = arguments.length, d, f;
    switch (n) {
      case 0:
      case 1:
        return fe.process.nextTick(t);
      case 2:
        return fe.process.nextTick(function() {
          t.call(null, o);
        });
      case 3:
        return fe.process.nextTick(function() {
          t.call(null, o, i);
        });
      case 4:
        return fe.process.nextTick(function() {
          t.call(null, o, i, c);
        });
      default:
        for (d = new Array(n - 1), f = 0; f < d.length; )
          d[f++] = arguments[f];
        return fe.process.nextTick(function() {
          t.apply(null, d);
        });
    }
  }
  return g0.exports;
}
var bu, e3;
function IA() {
  if (e3) return bu;
  e3 = 1;
  var e = {}.toString;
  return bu = Array.isArray || function(t) {
    return e.call(t) == "[object Array]";
  }, bu;
}
var xu, t3;
function MM() {
  return t3 || (t3 = 1, xu = Na.EventEmitter), xu;
}
var y0 = { exports: {} }, r3;
function Gc() {
  return r3 || (r3 = 1, function(e, t) {
    var o = Wr, i = o.Buffer;
    function c(d, f) {
      for (var p in d)
        f[p] = d[p];
    }
    i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? e.exports = o : (c(o, t), t.Buffer = n);
    function n(d, f, p) {
      return i(d, f, p);
    }
    c(i, n), n.from = function(d, f, p) {
      if (typeof d == "number")
        throw new TypeError("Argument must not be a number");
      return i(d, f, p);
    }, n.alloc = function(d, f, p) {
      if (typeof d != "number")
        throw new TypeError("Argument must be a number");
      var l = i(d);
      return f !== void 0 ? typeof p == "string" ? l.fill(f, p) : l.fill(f) : l.fill(0), l;
    }, n.allocUnsafe = function(d) {
      if (typeof d != "number")
        throw new TypeError("Argument must be a number");
      return i(d);
    }, n.allocUnsafeSlow = function(d) {
      if (typeof d != "number")
        throw new TypeError("Argument must be a number");
      return o.SlowBuffer(d);
    };
  }(y0, y0.exports)), y0.exports;
}
var $r = {}, n3;
function Rs() {
  if (n3) return $r;
  n3 = 1;
  function e(w) {
    return Array.isArray ? Array.isArray(w) : N(w) === "[object Array]";
  }
  $r.isArray = e;
  function t(w) {
    return typeof w == "boolean";
  }
  $r.isBoolean = t;
  function o(w) {
    return w === null;
  }
  $r.isNull = o;
  function i(w) {
    return w == null;
  }
  $r.isNullOrUndefined = i;
  function c(w) {
    return typeof w == "number";
  }
  $r.isNumber = c;
  function n(w) {
    return typeof w == "string";
  }
  $r.isString = n;
  function d(w) {
    return typeof w == "symbol";
  }
  $r.isSymbol = d;
  function f(w) {
    return w === void 0;
  }
  $r.isUndefined = f;
  function p(w) {
    return N(w) === "[object RegExp]";
  }
  $r.isRegExp = p;
  function l(w) {
    return typeof w == "object" && w !== null;
  }
  $r.isObject = l;
  function h(w) {
    return N(w) === "[object Date]";
  }
  $r.isDate = h;
  function y(w) {
    return N(w) === "[object Error]" || w instanceof Error;
  }
  $r.isError = y;
  function M(w) {
    return typeof w == "function";
  }
  $r.isFunction = M;
  function C(w) {
    return w === null || typeof w == "boolean" || typeof w == "number" || typeof w == "string" || typeof w == "symbol" || // ES6 symbol
    typeof w > "u";
  }
  $r.isPrimitive = C, $r.isBuffer = Wr.Buffer.isBuffer;
  function N(w) {
    return Object.prototype.toString.call(w);
  }
  return $r;
}
var wu = { exports: {} }, i3;
function NA() {
  return i3 || (i3 = 1, function(e) {
    function t(n, d) {
      if (!(n instanceof d))
        throw new TypeError("Cannot call a class as a function");
    }
    var o = Gc().Buffer, i = Ds;
    function c(n, d, f) {
      n.copy(d, f);
    }
    e.exports = function() {
      function n() {
        t(this, n), this.head = null, this.tail = null, this.length = 0;
      }
      return n.prototype.push = function(f) {
        var p = { data: f, next: null };
        this.length > 0 ? this.tail.next = p : this.head = p, this.tail = p, ++this.length;
      }, n.prototype.unshift = function(f) {
        var p = { data: f, next: this.head };
        this.length === 0 && (this.tail = p), this.head = p, ++this.length;
      }, n.prototype.shift = function() {
        if (this.length !== 0) {
          var f = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, f;
        }
      }, n.prototype.clear = function() {
        this.head = this.tail = null, this.length = 0;
      }, n.prototype.join = function(f) {
        if (this.length === 0) return "";
        for (var p = this.head, l = "" + p.data; p = p.next; )
          l += f + p.data;
        return l;
      }, n.prototype.concat = function(f) {
        if (this.length === 0) return o.alloc(0);
        for (var p = o.allocUnsafe(f >>> 0), l = this.head, h = 0; l; )
          c(l.data, p, h), h += l.data.length, l = l.next;
        return p;
      }, n;
    }(), i && i.inspect && i.inspect.custom && (e.exports.prototype[i.inspect.custom] = function() {
      var n = i.inspect({ length: this.length });
      return this.constructor.name + " " + n;
    });
  }(wu)), wu.exports;
}
var Cu, o3;
function mM() {
  if (o3) return Cu;
  o3 = 1;
  var e = Vc();
  function t(c, n) {
    var d = this, f = this._readableState && this._readableState.destroyed, p = this._writableState && this._writableState.destroyed;
    return f || p ? (n ? n(c) : c && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, e.nextTick(i, this, c)) : e.nextTick(i, this, c)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(c || null, function(l) {
      !n && l ? d._writableState ? d._writableState.errorEmitted || (d._writableState.errorEmitted = !0, e.nextTick(i, d, l)) : e.nextTick(i, d, l) : n && n(l);
    }), this);
  }
  function o() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function i(c, n) {
    c.emit("error", n);
  }
  return Cu = {
    destroy: t,
    undestroy: o
  }, Cu;
}
var Iu, a3;
function vM() {
  if (a3) return Iu;
  a3 = 1;
  var e = Vc();
  Iu = w;
  function t(A) {
    var L = this;
    this.next = null, this.entry = null, this.finish = function() {
      v(L, A);
    };
  }
  var o = !fe.process.browser && ["v0.10", "v0.9."].indexOf(fe.process.version.slice(0, 5)) > -1 ? setImmediate : e.nextTick, i;
  w.WritableState = C;
  var c = Object.create(Rs());
  c.inherits = Yt;
  var n = {
    deprecate: Ay()
  }, d = MM(), f = Gc().Buffer, p = (typeof Wt < "u" ? Wt : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function l(A) {
    return f.from(A);
  }
  function h(A) {
    return f.isBuffer(A) || A instanceof p;
  }
  var y = mM();
  c.inherits(w, d);
  function M() {
  }
  function C(A, L) {
    i = i || da(), A = A || {};
    var m = L instanceof i;
    this.objectMode = !!A.objectMode, m && (this.objectMode = this.objectMode || !!A.writableObjectMode);
    var a = A.highWaterMark, x = A.writableHighWaterMark, V = this.objectMode ? 16 : 16 * 1024;
    a || a === 0 ? this.highWaterMark = a : m && (x || x === 0) ? this.highWaterMark = x : this.highWaterMark = V, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var G = A.decodeStrings === !1;
    this.decodeStrings = !G, this.defaultEncoding = A.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Z) {
      H(L, Z);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new t(this);
  }
  C.prototype.getBuffer = function() {
    for (var L = this.bufferedRequest, m = []; L; )
      m.push(L), L = L.next;
    return m;
  }, function() {
    try {
      Object.defineProperty(C.prototype, "buffer", {
        get: n.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var N;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (N = Function.prototype[Symbol.hasInstance], Object.defineProperty(w, Symbol.hasInstance, {
    value: function(A) {
      return N.call(this, A) ? !0 : this !== w ? !1 : A && A._writableState instanceof C;
    }
  })) : N = function(A) {
    return A instanceof this;
  };
  function w(A) {
    if (i = i || da(), !N.call(w, this) && !(this instanceof i))
      return new w(A);
    this._writableState = new C(A, this), this.writable = !0, A && (typeof A.write == "function" && (this._write = A.write), typeof A.writev == "function" && (this._writev = A.writev), typeof A.destroy == "function" && (this._destroy = A.destroy), typeof A.final == "function" && (this._final = A.final)), d.call(this);
  }
  w.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
  };
  function S(A, L) {
    var m = new Error("write after end");
    A.emit("error", m), e.nextTick(L, m);
  }
  function T(A, L, m, a) {
    var x = !0, V = !1;
    return m === null ? V = new TypeError("May not write null values to stream") : typeof m != "string" && m !== void 0 && !L.objectMode && (V = new TypeError("Invalid non-string/buffer chunk")), V && (A.emit("error", V), e.nextTick(a, V), x = !1), x;
  }
  w.prototype.write = function(A, L, m) {
    var a = this._writableState, x = !1, V = !a.objectMode && h(A);
    return V && !f.isBuffer(A) && (A = l(A)), typeof L == "function" && (m = L, L = null), V ? L = "buffer" : L || (L = a.defaultEncoding), typeof m != "function" && (m = M), a.ended ? S(this, m) : (V || T(this, a, A, m)) && (a.pendingcb++, x = j(this, a, V, A, L, m)), x;
  }, w.prototype.cork = function() {
    var A = this._writableState;
    A.corked++;
  }, w.prototype.uncork = function() {
    var A = this._writableState;
    A.corked && (A.corked--, !A.writing && !A.corked && !A.bufferProcessing && A.bufferedRequest && B(this, A));
  }, w.prototype.setDefaultEncoding = function(L) {
    if (typeof L == "string" && (L = L.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((L + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + L);
    return this._writableState.defaultEncoding = L, this;
  };
  function E(A, L, m) {
    return !A.objectMode && A.decodeStrings !== !1 && typeof L == "string" && (L = f.from(L, m)), L;
  }
  Object.defineProperty(w.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function j(A, L, m, a, x, V) {
    if (!m) {
      var G = E(L, a, x);
      a !== G && (m = !0, x = "buffer", a = G);
    }
    var Z = L.objectMode ? 1 : a.length;
    L.length += Z;
    var te = L.length < L.highWaterMark;
    if (te || (L.needDrain = !0), L.writing || L.corked) {
      var q = L.lastBufferedRequest;
      L.lastBufferedRequest = {
        chunk: a,
        encoding: x,
        isBuf: m,
        callback: V,
        next: null
      }, q ? q.next = L.lastBufferedRequest : L.bufferedRequest = L.lastBufferedRequest, L.bufferedRequestCount += 1;
    } else
      O(A, L, !1, Z, a, x, V);
    return te;
  }
  function O(A, L, m, a, x, V, G) {
    L.writelen = a, L.writecb = G, L.writing = !0, L.sync = !0, m ? A._writev(x, L.onwrite) : A._write(x, V, L.onwrite), L.sync = !1;
  }
  function z(A, L, m, a, x) {
    --L.pendingcb, m ? (e.nextTick(x, a), e.nextTick(u, A, L), A._writableState.errorEmitted = !0, A.emit("error", a)) : (x(a), A._writableState.errorEmitted = !0, A.emit("error", a), u(A, L));
  }
  function k(A) {
    A.writing = !1, A.writecb = null, A.length -= A.writelen, A.writelen = 0;
  }
  function H(A, L) {
    var m = A._writableState, a = m.sync, x = m.writecb;
    if (k(m), L) z(A, m, a, L, x);
    else {
      var V = I(m);
      !V && !m.corked && !m.bufferProcessing && m.bufferedRequest && B(A, m), a ? o(W, A, m, V, x) : W(A, m, V, x);
    }
  }
  function W(A, L, m, a) {
    m || U(A, L), L.pendingcb--, a(), u(A, L);
  }
  function U(A, L) {
    L.length === 0 && L.needDrain && (L.needDrain = !1, A.emit("drain"));
  }
  function B(A, L) {
    L.bufferProcessing = !0;
    var m = L.bufferedRequest;
    if (A._writev && m && m.next) {
      var a = L.bufferedRequestCount, x = new Array(a), V = L.corkedRequestsFree;
      V.entry = m;
      for (var G = 0, Z = !0; m; )
        x[G] = m, m.isBuf || (Z = !1), m = m.next, G += 1;
      x.allBuffers = Z, O(A, L, !0, L.length, x, "", V.finish), L.pendingcb++, L.lastBufferedRequest = null, V.next ? (L.corkedRequestsFree = V.next, V.next = null) : L.corkedRequestsFree = new t(L), L.bufferedRequestCount = 0;
    } else {
      for (; m; ) {
        var te = m.chunk, q = m.encoding, R = m.callback, Q = L.objectMode ? 1 : te.length;
        if (O(A, L, !1, Q, te, q, R), m = m.next, L.bufferedRequestCount--, L.writing)
          break;
      }
      m === null && (L.lastBufferedRequest = null);
    }
    L.bufferedRequest = m, L.bufferProcessing = !1;
  }
  w.prototype._write = function(A, L, m) {
    m(new Error("_write() is not implemented"));
  }, w.prototype._writev = null, w.prototype.end = function(A, L, m) {
    var a = this._writableState;
    typeof A == "function" ? (m = A, A = null, L = null) : typeof L == "function" && (m = L, L = null), A != null && this.write(A, L), a.corked && (a.corked = 1, this.uncork()), a.ending || g(this, a, m);
  };
  function I(A) {
    return A.ending && A.length === 0 && A.bufferedRequest === null && !A.finished && !A.writing;
  }
  function r(A, L) {
    A._final(function(m) {
      L.pendingcb--, m && A.emit("error", m), L.prefinished = !0, A.emit("prefinish"), u(A, L);
    });
  }
  function s(A, L) {
    !L.prefinished && !L.finalCalled && (typeof A._final == "function" ? (L.pendingcb++, L.finalCalled = !0, e.nextTick(r, A, L)) : (L.prefinished = !0, A.emit("prefinish")));
  }
  function u(A, L) {
    var m = I(L);
    return m && (s(A, L), L.pendingcb === 0 && (L.finished = !0, A.emit("finish"))), m;
  }
  function g(A, L, m) {
    L.ending = !0, u(A, L), m && (L.finished ? e.nextTick(m) : A.once("finish", m)), L.ended = !0, A.writable = !1;
  }
  function v(A, L, m) {
    var a = A.entry;
    for (A.entry = null; a; ) {
      var x = a.callback;
      L.pendingcb--, x(m), a = a.next;
    }
    L.corkedRequestsFree.next = A;
  }
  return Object.defineProperty(w.prototype, "destroyed", {
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(A) {
      this._writableState && (this._writableState.destroyed = A);
    }
  }), w.prototype.destroy = y.destroy, w.prototype._undestroy = y.undestroy, w.prototype._destroy = function(A, L) {
    this.end(), L(A);
  }, Iu;
}
var Nu, s3;
function da() {
  if (s3) return Nu;
  s3 = 1;
  var e = Vc(), t = Object.keys || function(y) {
    var M = [];
    for (var C in y)
      M.push(C);
    return M;
  };
  Nu = p;
  var o = Object.create(Rs());
  o.inherits = Yt;
  var i = bM(), c = vM();
  o.inherits(p, i);
  for (var n = t(c.prototype), d = 0; d < n.length; d++) {
    var f = n[d];
    p.prototype[f] || (p.prototype[f] = c.prototype[f]);
  }
  function p(y) {
    if (!(this instanceof p)) return new p(y);
    i.call(this, y), c.call(this, y), y && y.readable === !1 && (this.readable = !1), y && y.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, y && y.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", l);
  }
  Object.defineProperty(p.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function l() {
    this.allowHalfOpen || this._writableState.ended || e.nextTick(h, this);
  }
  function h(y) {
    y.end();
  }
  return Object.defineProperty(p.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(y) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = y, this._writableState.destroyed = y);
    }
  }), p.prototype._destroy = function(y, M) {
    this.push(null), this.end(), e.nextTick(M, y);
  }, Nu;
}
var Au = {}, c3;
function l3() {
  if (c3) return Au;
  c3 = 1;
  var e = Gc().Buffer, t = e.isEncoding || function(T) {
    switch (T = "" + T, T && T.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function o(T) {
    if (!T) return "utf8";
    for (var E; ; )
      switch (T) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return T;
        default:
          if (E) return;
          T = ("" + T).toLowerCase(), E = !0;
      }
  }
  function i(T) {
    var E = o(T);
    if (typeof E != "string" && (e.isEncoding === t || !t(T))) throw new Error("Unknown encoding: " + T);
    return E || T;
  }
  Au.StringDecoder = c;
  function c(T) {
    this.encoding = i(T);
    var E;
    switch (this.encoding) {
      case "utf16le":
        this.text = y, this.end = M, E = 4;
        break;
      case "utf8":
        this.fillLast = p, E = 4;
        break;
      case "base64":
        this.text = C, this.end = N, E = 3;
        break;
      default:
        this.write = w, this.end = S;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = e.allocUnsafe(E);
  }
  c.prototype.write = function(T) {
    if (T.length === 0) return "";
    var E, j;
    if (this.lastNeed) {
      if (E = this.fillLast(T), E === void 0) return "";
      j = this.lastNeed, this.lastNeed = 0;
    } else
      j = 0;
    return j < T.length ? E ? E + this.text(T, j) : this.text(T, j) : E || "";
  }, c.prototype.end = h, c.prototype.text = l, c.prototype.fillLast = function(T) {
    if (this.lastNeed <= T.length)
      return T.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    T.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, T.length), this.lastNeed -= T.length;
  };
  function n(T) {
    return T <= 127 ? 0 : T >> 5 === 6 ? 2 : T >> 4 === 14 ? 3 : T >> 3 === 30 ? 4 : T >> 6 === 2 ? -1 : -2;
  }
  function d(T, E, j) {
    var O = E.length - 1;
    if (O < j) return 0;
    var z = n(E[O]);
    return z >= 0 ? (z > 0 && (T.lastNeed = z - 1), z) : --O < j || z === -2 ? 0 : (z = n(E[O]), z >= 0 ? (z > 0 && (T.lastNeed = z - 2), z) : --O < j || z === -2 ? 0 : (z = n(E[O]), z >= 0 ? (z > 0 && (z === 2 ? z = 0 : T.lastNeed = z - 3), z) : 0));
  }
  function f(T, E, j) {
    if ((E[0] & 192) !== 128)
      return T.lastNeed = 0, "�";
    if (T.lastNeed > 1 && E.length > 1) {
      if ((E[1] & 192) !== 128)
        return T.lastNeed = 1, "�";
      if (T.lastNeed > 2 && E.length > 2 && (E[2] & 192) !== 128)
        return T.lastNeed = 2, "�";
    }
  }
  function p(T) {
    var E = this.lastTotal - this.lastNeed, j = f(this, T);
    if (j !== void 0) return j;
    if (this.lastNeed <= T.length)
      return T.copy(this.lastChar, E, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    T.copy(this.lastChar, E, 0, T.length), this.lastNeed -= T.length;
  }
  function l(T, E) {
    var j = d(this, T, E);
    if (!this.lastNeed) return T.toString("utf8", E);
    this.lastTotal = j;
    var O = T.length - (j - this.lastNeed);
    return T.copy(this.lastChar, 0, O), T.toString("utf8", E, O);
  }
  function h(T) {
    var E = T && T.length ? this.write(T) : "";
    return this.lastNeed ? E + "�" : E;
  }
  function y(T, E) {
    if ((T.length - E) % 2 === 0) {
      var j = T.toString("utf16le", E);
      if (j) {
        var O = j.charCodeAt(j.length - 1);
        if (O >= 55296 && O <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = T[T.length - 2], this.lastChar[1] = T[T.length - 1], j.slice(0, -1);
      }
      return j;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = T[T.length - 1], T.toString("utf16le", E, T.length - 1);
  }
  function M(T) {
    var E = T && T.length ? this.write(T) : "";
    if (this.lastNeed) {
      var j = this.lastTotal - this.lastNeed;
      return E + this.lastChar.toString("utf16le", 0, j);
    }
    return E;
  }
  function C(T, E) {
    var j = (T.length - E) % 3;
    return j === 0 ? T.toString("base64", E) : (this.lastNeed = 3 - j, this.lastTotal = 3, j === 1 ? this.lastChar[0] = T[T.length - 1] : (this.lastChar[0] = T[T.length - 2], this.lastChar[1] = T[T.length - 1]), T.toString("base64", E, T.length - j));
  }
  function N(T) {
    var E = T && T.length ? this.write(T) : "";
    return this.lastNeed ? E + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : E;
  }
  function w(T) {
    return T.toString(this.encoding);
  }
  function S(T) {
    return T && T.length ? this.write(T) : "";
  }
  return Au;
}
var Tu, f3;
function bM() {
  if (f3) return Tu;
  f3 = 1;
  var e = Vc();
  Tu = E;
  var t = IA(), o;
  E.ReadableState = T, Na.EventEmitter;
  var i = function(R, Q) {
    return R.listeners(Q).length;
  }, c = MM(), n = Gc().Buffer, d = (typeof Wt < "u" ? Wt : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function f(R) {
    return n.from(R);
  }
  function p(R) {
    return n.isBuffer(R) || R instanceof d;
  }
  var l = Object.create(Rs());
  l.inherits = Yt;
  var h = Ds, y = void 0;
  h && h.debuglog ? y = h.debuglog("stream") : y = function() {
  };
  var M = NA(), C = mM(), N;
  l.inherits(E, c);
  var w = ["error", "close", "destroy", "pause", "resume"];
  function S(R, Q, $) {
    if (typeof R.prependListener == "function") return R.prependListener(Q, $);
    !R._events || !R._events[Q] ? R.on(Q, $) : t(R._events[Q]) ? R._events[Q].unshift($) : R._events[Q] = [$, R._events[Q]];
  }
  function T(R, Q) {
    o = o || da(), R = R || {};
    var $ = Q instanceof o;
    this.objectMode = !!R.objectMode, $ && (this.objectMode = this.objectMode || !!R.readableObjectMode);
    var F = R.highWaterMark, P = R.readableHighWaterMark, _ = this.objectMode ? 16 : 16 * 1024;
    F || F === 0 ? this.highWaterMark = F : $ && (P || P === 0) ? this.highWaterMark = P : this.highWaterMark = _, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new M(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = R.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, R.encoding && (N || (N = l3().StringDecoder), this.decoder = new N(R.encoding), this.encoding = R.encoding);
  }
  function E(R) {
    if (o = o || da(), !(this instanceof E)) return new E(R);
    this._readableState = new T(R, this), this.readable = !0, R && (typeof R.read == "function" && (this._read = R.read), typeof R.destroy == "function" && (this._destroy = R.destroy)), c.call(this);
  }
  Object.defineProperty(E.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(R) {
      this._readableState && (this._readableState.destroyed = R);
    }
  }), E.prototype.destroy = C.destroy, E.prototype._undestroy = C.undestroy, E.prototype._destroy = function(R, Q) {
    this.push(null), Q(R);
  }, E.prototype.push = function(R, Q) {
    var $ = this._readableState, F;
    return $.objectMode ? F = !0 : typeof R == "string" && (Q = Q || $.defaultEncoding, Q !== $.encoding && (R = n.from(R, Q), Q = ""), F = !0), j(this, R, Q, !1, F);
  }, E.prototype.unshift = function(R) {
    return j(this, R, null, !0, !1);
  };
  function j(R, Q, $, F, P) {
    var _ = R._readableState;
    if (Q === null)
      _.reading = !1, B(R, _);
    else {
      var X;
      P || (X = z(_, Q)), X ? R.emit("error", X) : _.objectMode || Q && Q.length > 0 ? (typeof Q != "string" && !_.objectMode && Object.getPrototypeOf(Q) !== n.prototype && (Q = f(Q)), F ? _.endEmitted ? R.emit("error", new Error("stream.unshift() after end event")) : O(R, _, Q, !0) : _.ended ? R.emit("error", new Error("stream.push() after EOF")) : (_.reading = !1, _.decoder && !$ ? (Q = _.decoder.write(Q), _.objectMode || Q.length !== 0 ? O(R, _, Q, !1) : s(R, _)) : O(R, _, Q, !1))) : F || (_.reading = !1);
    }
    return k(_);
  }
  function O(R, Q, $, F) {
    Q.flowing && Q.length === 0 && !Q.sync ? (R.emit("data", $), R.read(0)) : (Q.length += Q.objectMode ? 1 : $.length, F ? Q.buffer.unshift($) : Q.buffer.push($), Q.needReadable && I(R)), s(R, Q);
  }
  function z(R, Q) {
    var $;
    return !p(Q) && typeof Q != "string" && Q !== void 0 && !R.objectMode && ($ = new TypeError("Invalid non-string/buffer chunk")), $;
  }
  function k(R) {
    return !R.ended && (R.needReadable || R.length < R.highWaterMark || R.length === 0);
  }
  E.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, E.prototype.setEncoding = function(R) {
    return N || (N = l3().StringDecoder), this._readableState.decoder = new N(R), this._readableState.encoding = R, this;
  };
  var H = 8388608;
  function W(R) {
    return R >= H ? R = H : (R--, R |= R >>> 1, R |= R >>> 2, R |= R >>> 4, R |= R >>> 8, R |= R >>> 16, R++), R;
  }
  function U(R, Q) {
    return R <= 0 || Q.length === 0 && Q.ended ? 0 : Q.objectMode ? 1 : R !== R ? Q.flowing && Q.length ? Q.buffer.head.data.length : Q.length : (R > Q.highWaterMark && (Q.highWaterMark = W(R)), R <= Q.length ? R : Q.ended ? Q.length : (Q.needReadable = !0, 0));
  }
  E.prototype.read = function(R) {
    y("read", R), R = parseInt(R, 10);
    var Q = this._readableState, $ = R;
    if (R !== 0 && (Q.emittedReadable = !1), R === 0 && Q.needReadable && (Q.length >= Q.highWaterMark || Q.ended))
      return y("read: emitReadable", Q.length, Q.ended), Q.length === 0 && Q.ended ? Z(this) : I(this), null;
    if (R = U(R, Q), R === 0 && Q.ended)
      return Q.length === 0 && Z(this), null;
    var F = Q.needReadable;
    y("need readable", F), (Q.length === 0 || Q.length - R < Q.highWaterMark) && (F = !0, y("length less than watermark", F)), Q.ended || Q.reading ? (F = !1, y("reading or ended", F)) : F && (y("do read"), Q.reading = !0, Q.sync = !0, Q.length === 0 && (Q.needReadable = !0), this._read(Q.highWaterMark), Q.sync = !1, Q.reading || (R = U($, Q)));
    var P;
    return R > 0 ? P = a(R, Q) : P = null, P === null ? (Q.needReadable = !0, R = 0) : Q.length -= R, Q.length === 0 && (Q.ended || (Q.needReadable = !0), $ !== R && Q.ended && Z(this)), P !== null && this.emit("data", P), P;
  };
  function B(R, Q) {
    if (!Q.ended) {
      if (Q.decoder) {
        var $ = Q.decoder.end();
        $ && $.length && (Q.buffer.push($), Q.length += Q.objectMode ? 1 : $.length);
      }
      Q.ended = !0, I(R);
    }
  }
  function I(R) {
    var Q = R._readableState;
    Q.needReadable = !1, Q.emittedReadable || (y("emitReadable", Q.flowing), Q.emittedReadable = !0, Q.sync ? e.nextTick(r, R) : r(R));
  }
  function r(R) {
    y("emit readable"), R.emit("readable"), m(R);
  }
  function s(R, Q) {
    Q.readingMore || (Q.readingMore = !0, e.nextTick(u, R, Q));
  }
  function u(R, Q) {
    for (var $ = Q.length; !Q.reading && !Q.flowing && !Q.ended && Q.length < Q.highWaterMark && (y("maybeReadMore read 0"), R.read(0), $ !== Q.length); )
      $ = Q.length;
    Q.readingMore = !1;
  }
  E.prototype._read = function(R) {
    this.emit("error", new Error("_read() is not implemented"));
  }, E.prototype.pipe = function(R, Q) {
    var $ = this, F = this._readableState;
    switch (F.pipesCount) {
      case 0:
        F.pipes = R;
        break;
      case 1:
        F.pipes = [F.pipes, R];
        break;
      default:
        F.pipes.push(R);
        break;
    }
    F.pipesCount += 1, y("pipe count=%d opts=%j", F.pipesCount, Q);
    var P = (!Q || Q.end !== !1) && R !== fe.process.stdout && R !== fe.process.stderr, _ = P ? le : Le;
    F.endEmitted ? e.nextTick(_) : $.once("end", _), R.on("unpipe", X);
    function X(ye, Me) {
      y("onunpipe"), ye === $ && Me && Me.hasUnpiped === !1 && (Me.hasUnpiped = !0, pe());
    }
    function le() {
      y("onend"), R.end();
    }
    var ie = g($);
    R.on("drain", ie);
    var oe = !1;
    function pe() {
      y("cleanup"), R.removeListener("close", de), R.removeListener("finish", ae), R.removeListener("drain", ie), R.removeListener("error", me), R.removeListener("unpipe", X), $.removeListener("end", le), $.removeListener("end", Le), $.removeListener("data", ce), oe = !0, F.awaitDrain && (!R._writableState || R._writableState.needDrain) && ie();
    }
    var se = !1;
    $.on("data", ce);
    function ce(ye) {
      y("ondata"), se = !1;
      var Me = R.write(ye);
      Me === !1 && !se && ((F.pipesCount === 1 && F.pipes === R || F.pipesCount > 1 && q(F.pipes, R) !== -1) && !oe && (y("false write response, pause", F.awaitDrain), F.awaitDrain++, se = !0), $.pause());
    }
    function me(ye) {
      y("onerror", ye), Le(), R.removeListener("error", me), i(R, "error") === 0 && R.emit("error", ye);
    }
    S(R, "error", me);
    function de() {
      R.removeListener("finish", ae), Le();
    }
    R.once("close", de);
    function ae() {
      y("onfinish"), R.removeListener("close", de), Le();
    }
    R.once("finish", ae);
    function Le() {
      y("unpipe"), $.unpipe(R);
    }
    return R.emit("pipe", $), F.flowing || (y("pipe resume"), $.resume()), R;
  };
  function g(R) {
    return function() {
      var Q = R._readableState;
      y("pipeOnDrain", Q.awaitDrain), Q.awaitDrain && Q.awaitDrain--, Q.awaitDrain === 0 && i(R, "data") && (Q.flowing = !0, m(R));
    };
  }
  E.prototype.unpipe = function(R) {
    var Q = this._readableState, $ = { hasUnpiped: !1 };
    if (Q.pipesCount === 0) return this;
    if (Q.pipesCount === 1)
      return R && R !== Q.pipes ? this : (R || (R = Q.pipes), Q.pipes = null, Q.pipesCount = 0, Q.flowing = !1, R && R.emit("unpipe", this, $), this);
    if (!R) {
      var F = Q.pipes, P = Q.pipesCount;
      Q.pipes = null, Q.pipesCount = 0, Q.flowing = !1;
      for (var _ = 0; _ < P; _++)
        F[_].emit("unpipe", this, { hasUnpiped: !1 });
      return this;
    }
    var X = q(Q.pipes, R);
    return X === -1 ? this : (Q.pipes.splice(X, 1), Q.pipesCount -= 1, Q.pipesCount === 1 && (Q.pipes = Q.pipes[0]), R.emit("unpipe", this, $), this);
  }, E.prototype.on = function(R, Q) {
    var $ = c.prototype.on.call(this, R, Q);
    if (R === "data")
      this._readableState.flowing !== !1 && this.resume();
    else if (R === "readable") {
      var F = this._readableState;
      !F.endEmitted && !F.readableListening && (F.readableListening = F.needReadable = !0, F.emittedReadable = !1, F.reading ? F.length && I(this) : e.nextTick(v, this));
    }
    return $;
  }, E.prototype.addListener = E.prototype.on;
  function v(R) {
    y("readable nexttick read 0"), R.read(0);
  }
  E.prototype.resume = function() {
    var R = this._readableState;
    return R.flowing || (y("resume"), R.flowing = !0, A(this, R)), this;
  };
  function A(R, Q) {
    Q.resumeScheduled || (Q.resumeScheduled = !0, e.nextTick(L, R, Q));
  }
  function L(R, Q) {
    Q.reading || (y("resume read 0"), R.read(0)), Q.resumeScheduled = !1, Q.awaitDrain = 0, R.emit("resume"), m(R), Q.flowing && !Q.reading && R.read(0);
  }
  E.prototype.pause = function() {
    return y("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (y("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
  };
  function m(R) {
    var Q = R._readableState;
    for (y("flow", Q.flowing); Q.flowing && R.read() !== null; )
      ;
  }
  E.prototype.wrap = function(R) {
    var Q = this, $ = this._readableState, F = !1;
    R.on("end", function() {
      if (y("wrapped end"), $.decoder && !$.ended) {
        var X = $.decoder.end();
        X && X.length && Q.push(X);
      }
      Q.push(null);
    }), R.on("data", function(X) {
      if (y("wrapped data"), $.decoder && (X = $.decoder.write(X)), !($.objectMode && X == null) && !(!$.objectMode && (!X || !X.length))) {
        var le = Q.push(X);
        le || (F = !0, R.pause());
      }
    });
    for (var P in R)
      this[P] === void 0 && typeof R[P] == "function" && (this[P] = /* @__PURE__ */ function(X) {
        return function() {
          return R[X].apply(R, arguments);
        };
      }(P));
    for (var _ = 0; _ < w.length; _++)
      R.on(w[_], this.emit.bind(this, w[_]));
    return this._read = function(X) {
      y("wrapped _read", X), F && (F = !1, R.resume());
    }, this;
  }, Object.defineProperty(E.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), E._fromList = a;
  function a(R, Q) {
    if (Q.length === 0) return null;
    var $;
    return Q.objectMode ? $ = Q.buffer.shift() : !R || R >= Q.length ? (Q.decoder ? $ = Q.buffer.join("") : Q.buffer.length === 1 ? $ = Q.buffer.head.data : $ = Q.buffer.concat(Q.length), Q.buffer.clear()) : $ = x(R, Q.buffer, Q.decoder), $;
  }
  function x(R, Q, $) {
    var F;
    return R < Q.head.data.length ? (F = Q.head.data.slice(0, R), Q.head.data = Q.head.data.slice(R)) : R === Q.head.data.length ? F = Q.shift() : F = $ ? V(R, Q) : G(R, Q), F;
  }
  function V(R, Q) {
    var $ = Q.head, F = 1, P = $.data;
    for (R -= P.length; $ = $.next; ) {
      var _ = $.data, X = R > _.length ? _.length : R;
      if (X === _.length ? P += _ : P += _.slice(0, R), R -= X, R === 0) {
        X === _.length ? (++F, $.next ? Q.head = $.next : Q.head = Q.tail = null) : (Q.head = $, $.data = _.slice(X));
        break;
      }
      ++F;
    }
    return Q.length -= F, P;
  }
  function G(R, Q) {
    var $ = n.allocUnsafe(R), F = Q.head, P = 1;
    for (F.data.copy($), R -= F.data.length; F = F.next; ) {
      var _ = F.data, X = R > _.length ? _.length : R;
      if (_.copy($, $.length - R, 0, X), R -= X, R === 0) {
        X === _.length ? (++P, F.next ? Q.head = F.next : Q.head = Q.tail = null) : (Q.head = F, F.data = _.slice(X));
        break;
      }
      ++P;
    }
    return Q.length -= P, $;
  }
  function Z(R) {
    var Q = R._readableState;
    if (Q.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    Q.endEmitted || (Q.ended = !0, e.nextTick(te, Q, R));
  }
  function te(R, Q) {
    !R.endEmitted && R.length === 0 && (R.endEmitted = !0, Q.readable = !1, Q.emit("end"));
  }
  function q(R, Q) {
    for (var $ = 0, F = R.length; $ < F; $++)
      if (R[$] === Q) return $;
    return -1;
  }
  return Tu;
}
var Lu, u3;
function xM() {
  if (u3) return Lu;
  u3 = 1, Lu = i;
  var e = da(), t = Object.create(Rs());
  t.inherits = Yt, t.inherits(i, e);
  function o(d, f) {
    var p = this._transformState;
    p.transforming = !1;
    var l = p.writecb;
    if (!l)
      return this.emit("error", new Error("write callback called multiple times"));
    p.writechunk = null, p.writecb = null, f != null && this.push(f), l(d);
    var h = this._readableState;
    h.reading = !1, (h.needReadable || h.length < h.highWaterMark) && this._read(h.highWaterMark);
  }
  function i(d) {
    if (!(this instanceof i)) return new i(d);
    e.call(this, d), this._transformState = {
      afterTransform: o.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, d && (typeof d.transform == "function" && (this._transform = d.transform), typeof d.flush == "function" && (this._flush = d.flush)), this.on("prefinish", c);
  }
  function c() {
    var d = this;
    typeof this._flush == "function" ? this._flush(function(f, p) {
      n(d, f, p);
    }) : n(this, null, null);
  }
  i.prototype.push = function(d, f) {
    return this._transformState.needTransform = !1, e.prototype.push.call(this, d, f);
  }, i.prototype._transform = function(d, f, p) {
    throw new Error("_transform() is not implemented");
  }, i.prototype._write = function(d, f, p) {
    var l = this._transformState;
    if (l.writecb = p, l.writechunk = d, l.writeencoding = f, !l.transforming) {
      var h = this._readableState;
      (l.needTransform || h.needReadable || h.length < h.highWaterMark) && this._read(h.highWaterMark);
    }
  }, i.prototype._read = function(d) {
    var f = this._transformState;
    f.writechunk !== null && f.writecb && !f.transforming ? (f.transforming = !0, this._transform(f.writechunk, f.writeencoding, f.afterTransform)) : f.needTransform = !0;
  }, i.prototype._destroy = function(d, f) {
    var p = this;
    e.prototype._destroy.call(this, d, function(l) {
      f(l), p.emit("close");
    });
  };
  function n(d, f, p) {
    if (f) return d.emit("error", f);
    if (p != null && d.push(p), d._writableState.length) throw new Error("Calling transform done when ws.length != 0");
    if (d._transformState.transforming) throw new Error("Calling transform done when still transforming");
    return d.push(null);
  }
  return Lu;
}
var Su, d3;
function AA() {
  if (d3) return Su;
  d3 = 1, Su = o;
  var e = xM(), t = Object.create(Rs());
  t.inherits = Yt, t.inherits(o, e);
  function o(i) {
    if (!(this instanceof o)) return new o(i);
    e.call(this, i);
  }
  return o.prototype._transform = function(i, c, n) {
    n(null, i);
  }, Su;
}
var h3;
function TA() {
  return h3 || (h3 = 1, function(e, t) {
    t = e.exports = bM(), t.Stream = t, t.Readable = t, t.Writable = vM(), t.Duplex = da(), t.Transform = xM(), t.PassThrough = AA();
  }(p0, p0.exports)), p0.exports;
}
var ja = { exports: {} }, Eu, p3;
function xh() {
  if (p3) return Eu;
  p3 = 1;
  var e = Y1, t = Ia(), o = Gt.Buffer;
  function i(d) {
    var f = d.modulus.byteLength(), p;
    do
      p = new e(t(f));
    while (p.cmp(d.modulus) >= 0 || !p.umod(d.prime1) || !p.umod(d.prime2));
    return p;
  }
  function c(d) {
    var f = i(d), p = f.toRed(e.mont(d.modulus)).redPow(new e(d.publicExponent)).fromRed();
    return { blinder: p, unblinder: f.invm(d.modulus) };
  }
  function n(d, f) {
    var p = c(f), l = f.modulus.byteLength(), h = new e(d).mul(p.blinder).umod(f.modulus), y = h.toRed(e.mont(f.prime1)), M = h.toRed(e.mont(f.prime2)), C = f.coefficient, N = f.prime1, w = f.prime2, S = y.redPow(f.exponent1).fromRed(), T = M.redPow(f.exponent2).fromRed(), E = S.isub(T).imul(C).umod(N).imul(w);
    return T.iadd(E).imul(p.unblinder).umod(f.modulus).toArrayLike(o, "be", l);
  }
  return n.getr = i, Eu = n, Eu;
}
var Du = {};
const LA = "6.6.1", SA = {
  version: LA
};
var ju = {}, H0 = { exports: {} };
H0.exports;
var g3;
function Ni() {
  return g3 || (g3 = 1, function(e) {
    (function(t, o) {
      function i(I, r) {
        if (!I) throw new Error(r || "Assertion failed");
      }
      function c(I, r) {
        I.super_ = r;
        var s = function() {
        };
        s.prototype = r.prototype, I.prototype = new s(), I.prototype.constructor = I;
      }
      function n(I, r, s) {
        if (n.isBN(I))
          return I;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, I !== null && ((r === "le" || r === "be") && (s = r, r = 10), this._init(I || 0, r || 10, s || "be"));
      }
      typeof t == "object" ? t.exports = n : o.BN = n, n.BN = n, n.wordSize = 26;
      var d;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? d = window.Buffer : d = Wr.Buffer;
      } catch {
      }
      n.isBN = function(r) {
        return r instanceof n ? !0 : r !== null && typeof r == "object" && r.constructor.wordSize === n.wordSize && Array.isArray(r.words);
      }, n.max = function(r, s) {
        return r.cmp(s) > 0 ? r : s;
      }, n.min = function(r, s) {
        return r.cmp(s) < 0 ? r : s;
      }, n.prototype._init = function(r, s, u) {
        if (typeof r == "number")
          return this._initNumber(r, s, u);
        if (typeof r == "object")
          return this._initArray(r, s, u);
        s === "hex" && (s = 16), i(s === (s | 0) && s >= 2 && s <= 36), r = r.toString().replace(/\s+/g, "");
        var g = 0;
        r[0] === "-" && (g++, this.negative = 1), g < r.length && (s === 16 ? this._parseHex(r, g, u) : (this._parseBase(r, s, g), u === "le" && this._initArray(this.toArray(), s, u)));
      }, n.prototype._initNumber = function(r, s, u) {
        r < 0 && (this.negative = 1, r = -r), r < 67108864 ? (this.words = [r & 67108863], this.length = 1) : r < 4503599627370496 ? (this.words = [
          r & 67108863,
          r / 67108864 & 67108863
        ], this.length = 2) : (i(r < 9007199254740992), this.words = [
          r & 67108863,
          r / 67108864 & 67108863,
          1
        ], this.length = 3), u === "le" && this._initArray(this.toArray(), s, u);
      }, n.prototype._initArray = function(r, s, u) {
        if (i(typeof r.length == "number"), r.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(r.length / 3), this.words = new Array(this.length);
        for (var g = 0; g < this.length; g++)
          this.words[g] = 0;
        var v, A, L = 0;
        if (u === "be")
          for (g = r.length - 1, v = 0; g >= 0; g -= 3)
            A = r[g] | r[g - 1] << 8 | r[g - 2] << 16, this.words[v] |= A << L & 67108863, this.words[v + 1] = A >>> 26 - L & 67108863, L += 24, L >= 26 && (L -= 26, v++);
        else if (u === "le")
          for (g = 0, v = 0; g < r.length; g += 3)
            A = r[g] | r[g + 1] << 8 | r[g + 2] << 16, this.words[v] |= A << L & 67108863, this.words[v + 1] = A >>> 26 - L & 67108863, L += 24, L >= 26 && (L -= 26, v++);
        return this.strip();
      };
      function f(I, r) {
        var s = I.charCodeAt(r);
        return s >= 65 && s <= 70 ? s - 55 : s >= 97 && s <= 102 ? s - 87 : s - 48 & 15;
      }
      function p(I, r, s) {
        var u = f(I, s);
        return s - 1 >= r && (u |= f(I, s - 1) << 4), u;
      }
      n.prototype._parseHex = function(r, s, u) {
        this.length = Math.ceil((r.length - s) / 6), this.words = new Array(this.length);
        for (var g = 0; g < this.length; g++)
          this.words[g] = 0;
        var v = 0, A = 0, L;
        if (u === "be")
          for (g = r.length - 1; g >= s; g -= 2)
            L = p(r, s, g) << v, this.words[A] |= L & 67108863, v >= 18 ? (v -= 18, A += 1, this.words[A] |= L >>> 26) : v += 8;
        else {
          var m = r.length - s;
          for (g = m % 2 === 0 ? s + 1 : s; g < r.length; g += 2)
            L = p(r, s, g) << v, this.words[A] |= L & 67108863, v >= 18 ? (v -= 18, A += 1, this.words[A] |= L >>> 26) : v += 8;
        }
        this.strip();
      };
      function l(I, r, s, u) {
        for (var g = 0, v = Math.min(I.length, s), A = r; A < v; A++) {
          var L = I.charCodeAt(A) - 48;
          g *= u, L >= 49 ? g += L - 49 + 10 : L >= 17 ? g += L - 17 + 10 : g += L;
        }
        return g;
      }
      n.prototype._parseBase = function(r, s, u) {
        this.words = [0], this.length = 1;
        for (var g = 0, v = 1; v <= 67108863; v *= s)
          g++;
        g--, v = v / s | 0;
        for (var A = r.length - u, L = A % g, m = Math.min(A, A - L) + u, a = 0, x = u; x < m; x += g)
          a = l(r, x, x + g, s), this.imuln(v), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        if (L !== 0) {
          var V = 1;
          for (a = l(r, x, r.length, s), x = 0; x < L; x++)
            V *= s;
          this.imuln(V), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        }
        this.strip();
      }, n.prototype.copy = function(r) {
        r.words = new Array(this.length);
        for (var s = 0; s < this.length; s++)
          r.words[s] = this.words[s];
        r.length = this.length, r.negative = this.negative, r.red = this.red;
      }, n.prototype.clone = function() {
        var r = new n(null);
        return this.copy(r), r;
      }, n.prototype._expand = function(r) {
        for (; this.length < r; )
          this.words[this.length++] = 0;
        return this;
      }, n.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, n.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, n.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var h = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], y = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], M = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      n.prototype.toString = function(r, s) {
        r = r || 10, s = s | 0 || 1;
        var u;
        if (r === 16 || r === "hex") {
          u = "";
          for (var g = 0, v = 0, A = 0; A < this.length; A++) {
            var L = this.words[A], m = ((L << g | v) & 16777215).toString(16);
            v = L >>> 24 - g & 16777215, g += 2, g >= 26 && (g -= 26, A--), v !== 0 || A !== this.length - 1 ? u = h[6 - m.length] + m + u : u = m + u;
          }
          for (v !== 0 && (u = v.toString(16) + u); u.length % s !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        if (r === (r | 0) && r >= 2 && r <= 36) {
          var a = y[r], x = M[r];
          u = "";
          var V = this.clone();
          for (V.negative = 0; !V.isZero(); ) {
            var G = V.modn(x).toString(r);
            V = V.idivn(x), V.isZero() ? u = G + u : u = h[a - G.length] + G + u;
          }
          for (this.isZero() && (u = "0" + u); u.length % s !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        i(!1, "Base should be between 2 and 36");
      }, n.prototype.toNumber = function() {
        var r = this.words[0];
        return this.length === 2 ? r += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? r += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -r : r;
      }, n.prototype.toJSON = function() {
        return this.toString(16);
      }, n.prototype.toBuffer = function(r, s) {
        return i(typeof d < "u"), this.toArrayLike(d, r, s);
      }, n.prototype.toArray = function(r, s) {
        return this.toArrayLike(Array, r, s);
      }, n.prototype.toArrayLike = function(r, s, u) {
        var g = this.byteLength(), v = u || Math.max(1, g);
        i(g <= v, "byte array longer than desired length"), i(v > 0, "Requested array length <= 0"), this.strip();
        var A = s === "le", L = new r(v), m, a, x = this.clone();
        if (A) {
          for (a = 0; !x.isZero(); a++)
            m = x.andln(255), x.iushrn(8), L[a] = m;
          for (; a < v; a++)
            L[a] = 0;
        } else {
          for (a = 0; a < v - g; a++)
            L[a] = 0;
          for (a = 0; !x.isZero(); a++)
            m = x.andln(255), x.iushrn(8), L[v - a - 1] = m;
        }
        return L;
      }, Math.clz32 ? n.prototype._countBits = function(r) {
        return 32 - Math.clz32(r);
      } : n.prototype._countBits = function(r) {
        var s = r, u = 0;
        return s >= 4096 && (u += 13, s >>>= 13), s >= 64 && (u += 7, s >>>= 7), s >= 8 && (u += 4, s >>>= 4), s >= 2 && (u += 2, s >>>= 2), u + s;
      }, n.prototype._zeroBits = function(r) {
        if (r === 0) return 26;
        var s = r, u = 0;
        return s & 8191 || (u += 13, s >>>= 13), s & 127 || (u += 7, s >>>= 7), s & 15 || (u += 4, s >>>= 4), s & 3 || (u += 2, s >>>= 2), s & 1 || u++, u;
      }, n.prototype.bitLength = function() {
        var r = this.words[this.length - 1], s = this._countBits(r);
        return (this.length - 1) * 26 + s;
      };
      function C(I) {
        for (var r = new Array(I.bitLength()), s = 0; s < r.length; s++) {
          var u = s / 26 | 0, g = s % 26;
          r[s] = (I.words[u] & 1 << g) >>> g;
        }
        return r;
      }
      n.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var r = 0, s = 0; s < this.length; s++) {
          var u = this._zeroBits(this.words[s]);
          if (r += u, u !== 26) break;
        }
        return r;
      }, n.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, n.prototype.toTwos = function(r) {
        return this.negative !== 0 ? this.abs().inotn(r).iaddn(1) : this.clone();
      }, n.prototype.fromTwos = function(r) {
        return this.testn(r - 1) ? this.notn(r).iaddn(1).ineg() : this.clone();
      }, n.prototype.isNeg = function() {
        return this.negative !== 0;
      }, n.prototype.neg = function() {
        return this.clone().ineg();
      }, n.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, n.prototype.iuor = function(r) {
        for (; this.length < r.length; )
          this.words[this.length++] = 0;
        for (var s = 0; s < r.length; s++)
          this.words[s] = this.words[s] | r.words[s];
        return this.strip();
      }, n.prototype.ior = function(r) {
        return i((this.negative | r.negative) === 0), this.iuor(r);
      }, n.prototype.or = function(r) {
        return this.length > r.length ? this.clone().ior(r) : r.clone().ior(this);
      }, n.prototype.uor = function(r) {
        return this.length > r.length ? this.clone().iuor(r) : r.clone().iuor(this);
      }, n.prototype.iuand = function(r) {
        var s;
        this.length > r.length ? s = r : s = this;
        for (var u = 0; u < s.length; u++)
          this.words[u] = this.words[u] & r.words[u];
        return this.length = s.length, this.strip();
      }, n.prototype.iand = function(r) {
        return i((this.negative | r.negative) === 0), this.iuand(r);
      }, n.prototype.and = function(r) {
        return this.length > r.length ? this.clone().iand(r) : r.clone().iand(this);
      }, n.prototype.uand = function(r) {
        return this.length > r.length ? this.clone().iuand(r) : r.clone().iuand(this);
      }, n.prototype.iuxor = function(r) {
        var s, u;
        this.length > r.length ? (s = this, u = r) : (s = r, u = this);
        for (var g = 0; g < u.length; g++)
          this.words[g] = s.words[g] ^ u.words[g];
        if (this !== s)
          for (; g < s.length; g++)
            this.words[g] = s.words[g];
        return this.length = s.length, this.strip();
      }, n.prototype.ixor = function(r) {
        return i((this.negative | r.negative) === 0), this.iuxor(r);
      }, n.prototype.xor = function(r) {
        return this.length > r.length ? this.clone().ixor(r) : r.clone().ixor(this);
      }, n.prototype.uxor = function(r) {
        return this.length > r.length ? this.clone().iuxor(r) : r.clone().iuxor(this);
      }, n.prototype.inotn = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = Math.ceil(r / 26) | 0, u = r % 26;
        this._expand(s), u > 0 && s--;
        for (var g = 0; g < s; g++)
          this.words[g] = ~this.words[g] & 67108863;
        return u > 0 && (this.words[g] = ~this.words[g] & 67108863 >> 26 - u), this.strip();
      }, n.prototype.notn = function(r) {
        return this.clone().inotn(r);
      }, n.prototype.setn = function(r, s) {
        i(typeof r == "number" && r >= 0);
        var u = r / 26 | 0, g = r % 26;
        return this._expand(u + 1), s ? this.words[u] = this.words[u] | 1 << g : this.words[u] = this.words[u] & ~(1 << g), this.strip();
      }, n.prototype.iadd = function(r) {
        var s;
        if (this.negative !== 0 && r.negative === 0)
          return this.negative = 0, s = this.isub(r), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && r.negative !== 0)
          return r.negative = 0, s = this.isub(r), r.negative = 1, s._normSign();
        var u, g;
        this.length > r.length ? (u = this, g = r) : (u = r, g = this);
        for (var v = 0, A = 0; A < g.length; A++)
          s = (u.words[A] | 0) + (g.words[A] | 0) + v, this.words[A] = s & 67108863, v = s >>> 26;
        for (; v !== 0 && A < u.length; A++)
          s = (u.words[A] | 0) + v, this.words[A] = s & 67108863, v = s >>> 26;
        if (this.length = u.length, v !== 0)
          this.words[this.length] = v, this.length++;
        else if (u !== this)
          for (; A < u.length; A++)
            this.words[A] = u.words[A];
        return this;
      }, n.prototype.add = function(r) {
        var s;
        return r.negative !== 0 && this.negative === 0 ? (r.negative = 0, s = this.sub(r), r.negative ^= 1, s) : r.negative === 0 && this.negative !== 0 ? (this.negative = 0, s = r.sub(this), this.negative = 1, s) : this.length > r.length ? this.clone().iadd(r) : r.clone().iadd(this);
      }, n.prototype.isub = function(r) {
        if (r.negative !== 0) {
          r.negative = 0;
          var s = this.iadd(r);
          return r.negative = 1, s._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(r), this.negative = 1, this._normSign();
        var u = this.cmp(r);
        if (u === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var g, v;
        u > 0 ? (g = this, v = r) : (g = r, v = this);
        for (var A = 0, L = 0; L < v.length; L++)
          s = (g.words[L] | 0) - (v.words[L] | 0) + A, A = s >> 26, this.words[L] = s & 67108863;
        for (; A !== 0 && L < g.length; L++)
          s = (g.words[L] | 0) + A, A = s >> 26, this.words[L] = s & 67108863;
        if (A === 0 && L < g.length && g !== this)
          for (; L < g.length; L++)
            this.words[L] = g.words[L];
        return this.length = Math.max(this.length, L), g !== this && (this.negative = 1), this.strip();
      }, n.prototype.sub = function(r) {
        return this.clone().isub(r);
      };
      function N(I, r, s) {
        s.negative = r.negative ^ I.negative;
        var u = I.length + r.length | 0;
        s.length = u, u = u - 1 | 0;
        var g = I.words[0] | 0, v = r.words[0] | 0, A = g * v, L = A & 67108863, m = A / 67108864 | 0;
        s.words[0] = L;
        for (var a = 1; a < u; a++) {
          for (var x = m >>> 26, V = m & 67108863, G = Math.min(a, r.length - 1), Z = Math.max(0, a - I.length + 1); Z <= G; Z++) {
            var te = a - Z | 0;
            g = I.words[te] | 0, v = r.words[Z] | 0, A = g * v + V, x += A / 67108864 | 0, V = A & 67108863;
          }
          s.words[a] = V | 0, m = x | 0;
        }
        return m !== 0 ? s.words[a] = m | 0 : s.length--, s.strip();
      }
      var w = function(r, s, u) {
        var g = r.words, v = s.words, A = u.words, L = 0, m, a, x, V = g[0] | 0, G = V & 8191, Z = V >>> 13, te = g[1] | 0, q = te & 8191, R = te >>> 13, Q = g[2] | 0, $ = Q & 8191, F = Q >>> 13, P = g[3] | 0, _ = P & 8191, X = P >>> 13, le = g[4] | 0, ie = le & 8191, oe = le >>> 13, pe = g[5] | 0, se = pe & 8191, ce = pe >>> 13, me = g[6] | 0, de = me & 8191, ae = me >>> 13, Le = g[7] | 0, ye = Le & 8191, Me = Le >>> 13, at = g[8] | 0, Ne = at & 8191, Ae = at >>> 13, pt = g[9] | 0, ke = pt & 8191, Te = pt >>> 13, Dt = v[0] | 0, De = Dt & 8191, je = Dt >>> 13, At = v[1] | 0, xe = At & 8191, Ie = At >>> 13, Nt = v[2] | 0, _e = Nt & 8191, Be = Nt >>> 13, Xt = v[3] | 0, Re = Xt & 8191, Pe = Xt >>> 13, dr = v[4] | 0, We = dr & 8191, He = dr >>> 13, Ct = v[5] | 0, Ue = Ct & 8191, Ze = Ct >>> 13, Fr = v[6] | 0, Ye = Fr & 8191, Qe = Fr >>> 13, J = v[7] | 0, ee = J & 8191, K = J >>> 13, Y = v[8] | 0, re = Y & 8191, he = Y >>> 13, Se = v[9] | 0, ve = Se & 8191, we = Se >>> 13;
        u.negative = r.negative ^ s.negative, u.length = 19, m = Math.imul(G, De), a = Math.imul(G, je), a = a + Math.imul(Z, De) | 0, x = Math.imul(Z, je);
        var lt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (lt >>> 26) | 0, lt &= 67108863, m = Math.imul(q, De), a = Math.imul(q, je), a = a + Math.imul(R, De) | 0, x = Math.imul(R, je), m = m + Math.imul(G, xe) | 0, a = a + Math.imul(G, Ie) | 0, a = a + Math.imul(Z, xe) | 0, x = x + Math.imul(Z, Ie) | 0;
        var et = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (et >>> 26) | 0, et &= 67108863, m = Math.imul($, De), a = Math.imul($, je), a = a + Math.imul(F, De) | 0, x = Math.imul(F, je), m = m + Math.imul(q, xe) | 0, a = a + Math.imul(q, Ie) | 0, a = a + Math.imul(R, xe) | 0, x = x + Math.imul(R, Ie) | 0, m = m + Math.imul(G, _e) | 0, a = a + Math.imul(G, Be) | 0, a = a + Math.imul(Z, _e) | 0, x = x + Math.imul(Z, Be) | 0;
        var Lt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Lt >>> 26) | 0, Lt &= 67108863, m = Math.imul(_, De), a = Math.imul(_, je), a = a + Math.imul(X, De) | 0, x = Math.imul(X, je), m = m + Math.imul($, xe) | 0, a = a + Math.imul($, Ie) | 0, a = a + Math.imul(F, xe) | 0, x = x + Math.imul(F, Ie) | 0, m = m + Math.imul(q, _e) | 0, a = a + Math.imul(q, Be) | 0, a = a + Math.imul(R, _e) | 0, x = x + Math.imul(R, Be) | 0, m = m + Math.imul(G, Re) | 0, a = a + Math.imul(G, Pe) | 0, a = a + Math.imul(Z, Re) | 0, x = x + Math.imul(Z, Pe) | 0;
        var nt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (nt >>> 26) | 0, nt &= 67108863, m = Math.imul(ie, De), a = Math.imul(ie, je), a = a + Math.imul(oe, De) | 0, x = Math.imul(oe, je), m = m + Math.imul(_, xe) | 0, a = a + Math.imul(_, Ie) | 0, a = a + Math.imul(X, xe) | 0, x = x + Math.imul(X, Ie) | 0, m = m + Math.imul($, _e) | 0, a = a + Math.imul($, Be) | 0, a = a + Math.imul(F, _e) | 0, x = x + Math.imul(F, Be) | 0, m = m + Math.imul(q, Re) | 0, a = a + Math.imul(q, Pe) | 0, a = a + Math.imul(R, Re) | 0, x = x + Math.imul(R, Pe) | 0, m = m + Math.imul(G, We) | 0, a = a + Math.imul(G, He) | 0, a = a + Math.imul(Z, We) | 0, x = x + Math.imul(Z, He) | 0;
        var gt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, m = Math.imul(se, De), a = Math.imul(se, je), a = a + Math.imul(ce, De) | 0, x = Math.imul(ce, je), m = m + Math.imul(ie, xe) | 0, a = a + Math.imul(ie, Ie) | 0, a = a + Math.imul(oe, xe) | 0, x = x + Math.imul(oe, Ie) | 0, m = m + Math.imul(_, _e) | 0, a = a + Math.imul(_, Be) | 0, a = a + Math.imul(X, _e) | 0, x = x + Math.imul(X, Be) | 0, m = m + Math.imul($, Re) | 0, a = a + Math.imul($, Pe) | 0, a = a + Math.imul(F, Re) | 0, x = x + Math.imul(F, Pe) | 0, m = m + Math.imul(q, We) | 0, a = a + Math.imul(q, He) | 0, a = a + Math.imul(R, We) | 0, x = x + Math.imul(R, He) | 0, m = m + Math.imul(G, Ue) | 0, a = a + Math.imul(G, Ze) | 0, a = a + Math.imul(Z, Ue) | 0, x = x + Math.imul(Z, Ze) | 0;
        var yt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, m = Math.imul(de, De), a = Math.imul(de, je), a = a + Math.imul(ae, De) | 0, x = Math.imul(ae, je), m = m + Math.imul(se, xe) | 0, a = a + Math.imul(se, Ie) | 0, a = a + Math.imul(ce, xe) | 0, x = x + Math.imul(ce, Ie) | 0, m = m + Math.imul(ie, _e) | 0, a = a + Math.imul(ie, Be) | 0, a = a + Math.imul(oe, _e) | 0, x = x + Math.imul(oe, Be) | 0, m = m + Math.imul(_, Re) | 0, a = a + Math.imul(_, Pe) | 0, a = a + Math.imul(X, Re) | 0, x = x + Math.imul(X, Pe) | 0, m = m + Math.imul($, We) | 0, a = a + Math.imul($, He) | 0, a = a + Math.imul(F, We) | 0, x = x + Math.imul(F, He) | 0, m = m + Math.imul(q, Ue) | 0, a = a + Math.imul(q, Ze) | 0, a = a + Math.imul(R, Ue) | 0, x = x + Math.imul(R, Ze) | 0, m = m + Math.imul(G, Ye) | 0, a = a + Math.imul(G, Qe) | 0, a = a + Math.imul(Z, Ye) | 0, x = x + Math.imul(Z, Qe) | 0;
        var xt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (xt >>> 26) | 0, xt &= 67108863, m = Math.imul(ye, De), a = Math.imul(ye, je), a = a + Math.imul(Me, De) | 0, x = Math.imul(Me, je), m = m + Math.imul(de, xe) | 0, a = a + Math.imul(de, Ie) | 0, a = a + Math.imul(ae, xe) | 0, x = x + Math.imul(ae, Ie) | 0, m = m + Math.imul(se, _e) | 0, a = a + Math.imul(se, Be) | 0, a = a + Math.imul(ce, _e) | 0, x = x + Math.imul(ce, Be) | 0, m = m + Math.imul(ie, Re) | 0, a = a + Math.imul(ie, Pe) | 0, a = a + Math.imul(oe, Re) | 0, x = x + Math.imul(oe, Pe) | 0, m = m + Math.imul(_, We) | 0, a = a + Math.imul(_, He) | 0, a = a + Math.imul(X, We) | 0, x = x + Math.imul(X, He) | 0, m = m + Math.imul($, Ue) | 0, a = a + Math.imul($, Ze) | 0, a = a + Math.imul(F, Ue) | 0, x = x + Math.imul(F, Ze) | 0, m = m + Math.imul(q, Ye) | 0, a = a + Math.imul(q, Qe) | 0, a = a + Math.imul(R, Ye) | 0, x = x + Math.imul(R, Qe) | 0, m = m + Math.imul(G, ee) | 0, a = a + Math.imul(G, K) | 0, a = a + Math.imul(Z, ee) | 0, x = x + Math.imul(Z, K) | 0;
        var bt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, m = Math.imul(Ne, De), a = Math.imul(Ne, je), a = a + Math.imul(Ae, De) | 0, x = Math.imul(Ae, je), m = m + Math.imul(ye, xe) | 0, a = a + Math.imul(ye, Ie) | 0, a = a + Math.imul(Me, xe) | 0, x = x + Math.imul(Me, Ie) | 0, m = m + Math.imul(de, _e) | 0, a = a + Math.imul(de, Be) | 0, a = a + Math.imul(ae, _e) | 0, x = x + Math.imul(ae, Be) | 0, m = m + Math.imul(se, Re) | 0, a = a + Math.imul(se, Pe) | 0, a = a + Math.imul(ce, Re) | 0, x = x + Math.imul(ce, Pe) | 0, m = m + Math.imul(ie, We) | 0, a = a + Math.imul(ie, He) | 0, a = a + Math.imul(oe, We) | 0, x = x + Math.imul(oe, He) | 0, m = m + Math.imul(_, Ue) | 0, a = a + Math.imul(_, Ze) | 0, a = a + Math.imul(X, Ue) | 0, x = x + Math.imul(X, Ze) | 0, m = m + Math.imul($, Ye) | 0, a = a + Math.imul($, Qe) | 0, a = a + Math.imul(F, Ye) | 0, x = x + Math.imul(F, Qe) | 0, m = m + Math.imul(q, ee) | 0, a = a + Math.imul(q, K) | 0, a = a + Math.imul(R, ee) | 0, x = x + Math.imul(R, K) | 0, m = m + Math.imul(G, re) | 0, a = a + Math.imul(G, he) | 0, a = a + Math.imul(Z, re) | 0, x = x + Math.imul(Z, he) | 0;
        var Mt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Mt >>> 26) | 0, Mt &= 67108863, m = Math.imul(ke, De), a = Math.imul(ke, je), a = a + Math.imul(Te, De) | 0, x = Math.imul(Te, je), m = m + Math.imul(Ne, xe) | 0, a = a + Math.imul(Ne, Ie) | 0, a = a + Math.imul(Ae, xe) | 0, x = x + Math.imul(Ae, Ie) | 0, m = m + Math.imul(ye, _e) | 0, a = a + Math.imul(ye, Be) | 0, a = a + Math.imul(Me, _e) | 0, x = x + Math.imul(Me, Be) | 0, m = m + Math.imul(de, Re) | 0, a = a + Math.imul(de, Pe) | 0, a = a + Math.imul(ae, Re) | 0, x = x + Math.imul(ae, Pe) | 0, m = m + Math.imul(se, We) | 0, a = a + Math.imul(se, He) | 0, a = a + Math.imul(ce, We) | 0, x = x + Math.imul(ce, He) | 0, m = m + Math.imul(ie, Ue) | 0, a = a + Math.imul(ie, Ze) | 0, a = a + Math.imul(oe, Ue) | 0, x = x + Math.imul(oe, Ze) | 0, m = m + Math.imul(_, Ye) | 0, a = a + Math.imul(_, Qe) | 0, a = a + Math.imul(X, Ye) | 0, x = x + Math.imul(X, Qe) | 0, m = m + Math.imul($, ee) | 0, a = a + Math.imul($, K) | 0, a = a + Math.imul(F, ee) | 0, x = x + Math.imul(F, K) | 0, m = m + Math.imul(q, re) | 0, a = a + Math.imul(q, he) | 0, a = a + Math.imul(R, re) | 0, x = x + Math.imul(R, he) | 0, m = m + Math.imul(G, ve) | 0, a = a + Math.imul(G, we) | 0, a = a + Math.imul(Z, ve) | 0, x = x + Math.imul(Z, we) | 0;
        var vt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, m = Math.imul(ke, xe), a = Math.imul(ke, Ie), a = a + Math.imul(Te, xe) | 0, x = Math.imul(Te, Ie), m = m + Math.imul(Ne, _e) | 0, a = a + Math.imul(Ne, Be) | 0, a = a + Math.imul(Ae, _e) | 0, x = x + Math.imul(Ae, Be) | 0, m = m + Math.imul(ye, Re) | 0, a = a + Math.imul(ye, Pe) | 0, a = a + Math.imul(Me, Re) | 0, x = x + Math.imul(Me, Pe) | 0, m = m + Math.imul(de, We) | 0, a = a + Math.imul(de, He) | 0, a = a + Math.imul(ae, We) | 0, x = x + Math.imul(ae, He) | 0, m = m + Math.imul(se, Ue) | 0, a = a + Math.imul(se, Ze) | 0, a = a + Math.imul(ce, Ue) | 0, x = x + Math.imul(ce, Ze) | 0, m = m + Math.imul(ie, Ye) | 0, a = a + Math.imul(ie, Qe) | 0, a = a + Math.imul(oe, Ye) | 0, x = x + Math.imul(oe, Qe) | 0, m = m + Math.imul(_, ee) | 0, a = a + Math.imul(_, K) | 0, a = a + Math.imul(X, ee) | 0, x = x + Math.imul(X, K) | 0, m = m + Math.imul($, re) | 0, a = a + Math.imul($, he) | 0, a = a + Math.imul(F, re) | 0, x = x + Math.imul(F, he) | 0, m = m + Math.imul(q, ve) | 0, a = a + Math.imul(q, we) | 0, a = a + Math.imul(R, ve) | 0, x = x + Math.imul(R, we) | 0;
        var mt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, m = Math.imul(ke, _e), a = Math.imul(ke, Be), a = a + Math.imul(Te, _e) | 0, x = Math.imul(Te, Be), m = m + Math.imul(Ne, Re) | 0, a = a + Math.imul(Ne, Pe) | 0, a = a + Math.imul(Ae, Re) | 0, x = x + Math.imul(Ae, Pe) | 0, m = m + Math.imul(ye, We) | 0, a = a + Math.imul(ye, He) | 0, a = a + Math.imul(Me, We) | 0, x = x + Math.imul(Me, He) | 0, m = m + Math.imul(de, Ue) | 0, a = a + Math.imul(de, Ze) | 0, a = a + Math.imul(ae, Ue) | 0, x = x + Math.imul(ae, Ze) | 0, m = m + Math.imul(se, Ye) | 0, a = a + Math.imul(se, Qe) | 0, a = a + Math.imul(ce, Ye) | 0, x = x + Math.imul(ce, Qe) | 0, m = m + Math.imul(ie, ee) | 0, a = a + Math.imul(ie, K) | 0, a = a + Math.imul(oe, ee) | 0, x = x + Math.imul(oe, K) | 0, m = m + Math.imul(_, re) | 0, a = a + Math.imul(_, he) | 0, a = a + Math.imul(X, re) | 0, x = x + Math.imul(X, he) | 0, m = m + Math.imul($, ve) | 0, a = a + Math.imul($, we) | 0, a = a + Math.imul(F, ve) | 0, x = x + Math.imul(F, we) | 0;
        var ot = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (ot >>> 26) | 0, ot &= 67108863, m = Math.imul(ke, Re), a = Math.imul(ke, Pe), a = a + Math.imul(Te, Re) | 0, x = Math.imul(Te, Pe), m = m + Math.imul(Ne, We) | 0, a = a + Math.imul(Ne, He) | 0, a = a + Math.imul(Ae, We) | 0, x = x + Math.imul(Ae, He) | 0, m = m + Math.imul(ye, Ue) | 0, a = a + Math.imul(ye, Ze) | 0, a = a + Math.imul(Me, Ue) | 0, x = x + Math.imul(Me, Ze) | 0, m = m + Math.imul(de, Ye) | 0, a = a + Math.imul(de, Qe) | 0, a = a + Math.imul(ae, Ye) | 0, x = x + Math.imul(ae, Qe) | 0, m = m + Math.imul(se, ee) | 0, a = a + Math.imul(se, K) | 0, a = a + Math.imul(ce, ee) | 0, x = x + Math.imul(ce, K) | 0, m = m + Math.imul(ie, re) | 0, a = a + Math.imul(ie, he) | 0, a = a + Math.imul(oe, re) | 0, x = x + Math.imul(oe, he) | 0, m = m + Math.imul(_, ve) | 0, a = a + Math.imul(_, we) | 0, a = a + Math.imul(X, ve) | 0, x = x + Math.imul(X, we) | 0;
        var ft = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (ft >>> 26) | 0, ft &= 67108863, m = Math.imul(ke, We), a = Math.imul(ke, He), a = a + Math.imul(Te, We) | 0, x = Math.imul(Te, He), m = m + Math.imul(Ne, Ue) | 0, a = a + Math.imul(Ne, Ze) | 0, a = a + Math.imul(Ae, Ue) | 0, x = x + Math.imul(Ae, Ze) | 0, m = m + Math.imul(ye, Ye) | 0, a = a + Math.imul(ye, Qe) | 0, a = a + Math.imul(Me, Ye) | 0, x = x + Math.imul(Me, Qe) | 0, m = m + Math.imul(de, ee) | 0, a = a + Math.imul(de, K) | 0, a = a + Math.imul(ae, ee) | 0, x = x + Math.imul(ae, K) | 0, m = m + Math.imul(se, re) | 0, a = a + Math.imul(se, he) | 0, a = a + Math.imul(ce, re) | 0, x = x + Math.imul(ce, he) | 0, m = m + Math.imul(ie, ve) | 0, a = a + Math.imul(ie, we) | 0, a = a + Math.imul(oe, ve) | 0, x = x + Math.imul(oe, we) | 0;
        var rt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (rt >>> 26) | 0, rt &= 67108863, m = Math.imul(ke, Ue), a = Math.imul(ke, Ze), a = a + Math.imul(Te, Ue) | 0, x = Math.imul(Te, Ze), m = m + Math.imul(Ne, Ye) | 0, a = a + Math.imul(Ne, Qe) | 0, a = a + Math.imul(Ae, Ye) | 0, x = x + Math.imul(Ae, Qe) | 0, m = m + Math.imul(ye, ee) | 0, a = a + Math.imul(ye, K) | 0, a = a + Math.imul(Me, ee) | 0, x = x + Math.imul(Me, K) | 0, m = m + Math.imul(de, re) | 0, a = a + Math.imul(de, he) | 0, a = a + Math.imul(ae, re) | 0, x = x + Math.imul(ae, he) | 0, m = m + Math.imul(se, ve) | 0, a = a + Math.imul(se, we) | 0, a = a + Math.imul(ce, ve) | 0, x = x + Math.imul(ce, we) | 0;
        var st = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (st >>> 26) | 0, st &= 67108863, m = Math.imul(ke, Ye), a = Math.imul(ke, Qe), a = a + Math.imul(Te, Ye) | 0, x = Math.imul(Te, Qe), m = m + Math.imul(Ne, ee) | 0, a = a + Math.imul(Ne, K) | 0, a = a + Math.imul(Ae, ee) | 0, x = x + Math.imul(Ae, K) | 0, m = m + Math.imul(ye, re) | 0, a = a + Math.imul(ye, he) | 0, a = a + Math.imul(Me, re) | 0, x = x + Math.imul(Me, he) | 0, m = m + Math.imul(de, ve) | 0, a = a + Math.imul(de, we) | 0, a = a + Math.imul(ae, ve) | 0, x = x + Math.imul(ae, we) | 0;
        var ct = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (ct >>> 26) | 0, ct &= 67108863, m = Math.imul(ke, ee), a = Math.imul(ke, K), a = a + Math.imul(Te, ee) | 0, x = Math.imul(Te, K), m = m + Math.imul(Ne, re) | 0, a = a + Math.imul(Ne, he) | 0, a = a + Math.imul(Ae, re) | 0, x = x + Math.imul(Ae, he) | 0, m = m + Math.imul(ye, ve) | 0, a = a + Math.imul(ye, we) | 0, a = a + Math.imul(Me, ve) | 0, x = x + Math.imul(Me, we) | 0;
        var Je = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Je >>> 26) | 0, Je &= 67108863, m = Math.imul(ke, re), a = Math.imul(ke, he), a = a + Math.imul(Te, re) | 0, x = Math.imul(Te, he), m = m + Math.imul(Ne, ve) | 0, a = a + Math.imul(Ne, we) | 0, a = a + Math.imul(Ae, ve) | 0, x = x + Math.imul(Ae, we) | 0;
        var Oe = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, m = Math.imul(ke, ve), a = Math.imul(ke, we), a = a + Math.imul(Te, ve) | 0, x = Math.imul(Te, we);
        var ze = (L + m | 0) + ((a & 8191) << 13) | 0;
        return L = (x + (a >>> 13) | 0) + (ze >>> 26) | 0, ze &= 67108863, A[0] = lt, A[1] = et, A[2] = Lt, A[3] = nt, A[4] = gt, A[5] = yt, A[6] = xt, A[7] = bt, A[8] = Mt, A[9] = vt, A[10] = mt, A[11] = ot, A[12] = ft, A[13] = rt, A[14] = st, A[15] = ct, A[16] = Je, A[17] = Oe, A[18] = ze, L !== 0 && (A[19] = L, u.length++), u;
      };
      Math.imul || (w = N);
      function S(I, r, s) {
        s.negative = r.negative ^ I.negative, s.length = I.length + r.length;
        for (var u = 0, g = 0, v = 0; v < s.length - 1; v++) {
          var A = g;
          g = 0;
          for (var L = u & 67108863, m = Math.min(v, r.length - 1), a = Math.max(0, v - I.length + 1); a <= m; a++) {
            var x = v - a, V = I.words[x] | 0, G = r.words[a] | 0, Z = V * G, te = Z & 67108863;
            A = A + (Z / 67108864 | 0) | 0, te = te + L | 0, L = te & 67108863, A = A + (te >>> 26) | 0, g += A >>> 26, A &= 67108863;
          }
          s.words[v] = L, u = A, A = g;
        }
        return u !== 0 ? s.words[v] = u : s.length--, s.strip();
      }
      function T(I, r, s) {
        var u = new E();
        return u.mulp(I, r, s);
      }
      n.prototype.mulTo = function(r, s) {
        var u, g = this.length + r.length;
        return this.length === 10 && r.length === 10 ? u = w(this, r, s) : g < 63 ? u = N(this, r, s) : g < 1024 ? u = S(this, r, s) : u = T(this, r, s), u;
      };
      function E(I, r) {
        this.x = I, this.y = r;
      }
      E.prototype.makeRBT = function(r) {
        for (var s = new Array(r), u = n.prototype._countBits(r) - 1, g = 0; g < r; g++)
          s[g] = this.revBin(g, u, r);
        return s;
      }, E.prototype.revBin = function(r, s, u) {
        if (r === 0 || r === u - 1) return r;
        for (var g = 0, v = 0; v < s; v++)
          g |= (r & 1) << s - v - 1, r >>= 1;
        return g;
      }, E.prototype.permute = function(r, s, u, g, v, A) {
        for (var L = 0; L < A; L++)
          g[L] = s[r[L]], v[L] = u[r[L]];
      }, E.prototype.transform = function(r, s, u, g, v, A) {
        this.permute(A, r, s, u, g, v);
        for (var L = 1; L < v; L <<= 1)
          for (var m = L << 1, a = Math.cos(2 * Math.PI / m), x = Math.sin(2 * Math.PI / m), V = 0; V < v; V += m)
            for (var G = a, Z = x, te = 0; te < L; te++) {
              var q = u[V + te], R = g[V + te], Q = u[V + te + L], $ = g[V + te + L], F = G * Q - Z * $;
              $ = G * $ + Z * Q, Q = F, u[V + te] = q + Q, g[V + te] = R + $, u[V + te + L] = q - Q, g[V + te + L] = R - $, te !== m && (F = a * G - x * Z, Z = a * Z + x * G, G = F);
            }
      }, E.prototype.guessLen13b = function(r, s) {
        var u = Math.max(s, r) | 1, g = u & 1, v = 0;
        for (u = u / 2 | 0; u; u = u >>> 1)
          v++;
        return 1 << v + 1 + g;
      }, E.prototype.conjugate = function(r, s, u) {
        if (!(u <= 1))
          for (var g = 0; g < u / 2; g++) {
            var v = r[g];
            r[g] = r[u - g - 1], r[u - g - 1] = v, v = s[g], s[g] = -s[u - g - 1], s[u - g - 1] = -v;
          }
      }, E.prototype.normalize13b = function(r, s) {
        for (var u = 0, g = 0; g < s / 2; g++) {
          var v = Math.round(r[2 * g + 1] / s) * 8192 + Math.round(r[2 * g] / s) + u;
          r[g] = v & 67108863, v < 67108864 ? u = 0 : u = v / 67108864 | 0;
        }
        return r;
      }, E.prototype.convert13b = function(r, s, u, g) {
        for (var v = 0, A = 0; A < s; A++)
          v = v + (r[A] | 0), u[2 * A] = v & 8191, v = v >>> 13, u[2 * A + 1] = v & 8191, v = v >>> 13;
        for (A = 2 * s; A < g; ++A)
          u[A] = 0;
        i(v === 0), i((v & -8192) === 0);
      }, E.prototype.stub = function(r) {
        for (var s = new Array(r), u = 0; u < r; u++)
          s[u] = 0;
        return s;
      }, E.prototype.mulp = function(r, s, u) {
        var g = 2 * this.guessLen13b(r.length, s.length), v = this.makeRBT(g), A = this.stub(g), L = new Array(g), m = new Array(g), a = new Array(g), x = new Array(g), V = new Array(g), G = new Array(g), Z = u.words;
        Z.length = g, this.convert13b(r.words, r.length, L, g), this.convert13b(s.words, s.length, x, g), this.transform(L, A, m, a, g, v), this.transform(x, A, V, G, g, v);
        for (var te = 0; te < g; te++) {
          var q = m[te] * V[te] - a[te] * G[te];
          a[te] = m[te] * G[te] + a[te] * V[te], m[te] = q;
        }
        return this.conjugate(m, a, g), this.transform(m, a, Z, A, g, v), this.conjugate(Z, A, g), this.normalize13b(Z, g), u.negative = r.negative ^ s.negative, u.length = r.length + s.length, u.strip();
      }, n.prototype.mul = function(r) {
        var s = new n(null);
        return s.words = new Array(this.length + r.length), this.mulTo(r, s);
      }, n.prototype.mulf = function(r) {
        var s = new n(null);
        return s.words = new Array(this.length + r.length), T(this, r, s);
      }, n.prototype.imul = function(r) {
        return this.clone().mulTo(r, this);
      }, n.prototype.imuln = function(r) {
        i(typeof r == "number"), i(r < 67108864);
        for (var s = 0, u = 0; u < this.length; u++) {
          var g = (this.words[u] | 0) * r, v = (g & 67108863) + (s & 67108863);
          s >>= 26, s += g / 67108864 | 0, s += v >>> 26, this.words[u] = v & 67108863;
        }
        return s !== 0 && (this.words[u] = s, this.length++), this.length = r === 0 ? 1 : this.length, this;
      }, n.prototype.muln = function(r) {
        return this.clone().imuln(r);
      }, n.prototype.sqr = function() {
        return this.mul(this);
      }, n.prototype.isqr = function() {
        return this.imul(this.clone());
      }, n.prototype.pow = function(r) {
        var s = C(r);
        if (s.length === 0) return new n(1);
        for (var u = this, g = 0; g < s.length && s[g] === 0; g++, u = u.sqr())
          ;
        if (++g < s.length)
          for (var v = u.sqr(); g < s.length; g++, v = v.sqr())
            s[g] !== 0 && (u = u.mul(v));
        return u;
      }, n.prototype.iushln = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = r % 26, u = (r - s) / 26, g = 67108863 >>> 26 - s << 26 - s, v;
        if (s !== 0) {
          var A = 0;
          for (v = 0; v < this.length; v++) {
            var L = this.words[v] & g, m = (this.words[v] | 0) - L << s;
            this.words[v] = m | A, A = L >>> 26 - s;
          }
          A && (this.words[v] = A, this.length++);
        }
        if (u !== 0) {
          for (v = this.length - 1; v >= 0; v--)
            this.words[v + u] = this.words[v];
          for (v = 0; v < u; v++)
            this.words[v] = 0;
          this.length += u;
        }
        return this.strip();
      }, n.prototype.ishln = function(r) {
        return i(this.negative === 0), this.iushln(r);
      }, n.prototype.iushrn = function(r, s, u) {
        i(typeof r == "number" && r >= 0);
        var g;
        s ? g = (s - s % 26) / 26 : g = 0;
        var v = r % 26, A = Math.min((r - v) / 26, this.length), L = 67108863 ^ 67108863 >>> v << v, m = u;
        if (g -= A, g = Math.max(0, g), m) {
          for (var a = 0; a < A; a++)
            m.words[a] = this.words[a];
          m.length = A;
        }
        if (A !== 0) if (this.length > A)
          for (this.length -= A, a = 0; a < this.length; a++)
            this.words[a] = this.words[a + A];
        else
          this.words[0] = 0, this.length = 1;
        var x = 0;
        for (a = this.length - 1; a >= 0 && (x !== 0 || a >= g); a--) {
          var V = this.words[a] | 0;
          this.words[a] = x << 26 - v | V >>> v, x = V & L;
        }
        return m && x !== 0 && (m.words[m.length++] = x), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, n.prototype.ishrn = function(r, s, u) {
        return i(this.negative === 0), this.iushrn(r, s, u);
      }, n.prototype.shln = function(r) {
        return this.clone().ishln(r);
      }, n.prototype.ushln = function(r) {
        return this.clone().iushln(r);
      }, n.prototype.shrn = function(r) {
        return this.clone().ishrn(r);
      }, n.prototype.ushrn = function(r) {
        return this.clone().iushrn(r);
      }, n.prototype.testn = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = r % 26, u = (r - s) / 26, g = 1 << s;
        if (this.length <= u) return !1;
        var v = this.words[u];
        return !!(v & g);
      }, n.prototype.imaskn = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = r % 26, u = (r - s) / 26;
        if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= u)
          return this;
        if (s !== 0 && u++, this.length = Math.min(u, this.length), s !== 0) {
          var g = 67108863 ^ 67108863 >>> s << s;
          this.words[this.length - 1] &= g;
        }
        return this.strip();
      }, n.prototype.maskn = function(r) {
        return this.clone().imaskn(r);
      }, n.prototype.iaddn = function(r) {
        return i(typeof r == "number"), i(r < 67108864), r < 0 ? this.isubn(-r) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < r ? (this.words[0] = r - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(r), this.negative = 1, this) : this._iaddn(r);
      }, n.prototype._iaddn = function(r) {
        this.words[0] += r;
        for (var s = 0; s < this.length && this.words[s] >= 67108864; s++)
          this.words[s] -= 67108864, s === this.length - 1 ? this.words[s + 1] = 1 : this.words[s + 1]++;
        return this.length = Math.max(this.length, s + 1), this;
      }, n.prototype.isubn = function(r) {
        if (i(typeof r == "number"), i(r < 67108864), r < 0) return this.iaddn(-r);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(r), this.negative = 1, this;
        if (this.words[0] -= r, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var s = 0; s < this.length && this.words[s] < 0; s++)
            this.words[s] += 67108864, this.words[s + 1] -= 1;
        return this.strip();
      }, n.prototype.addn = function(r) {
        return this.clone().iaddn(r);
      }, n.prototype.subn = function(r) {
        return this.clone().isubn(r);
      }, n.prototype.iabs = function() {
        return this.negative = 0, this;
      }, n.prototype.abs = function() {
        return this.clone().iabs();
      }, n.prototype._ishlnsubmul = function(r, s, u) {
        var g = r.length + u, v;
        this._expand(g);
        var A, L = 0;
        for (v = 0; v < r.length; v++) {
          A = (this.words[v + u] | 0) + L;
          var m = (r.words[v] | 0) * s;
          A -= m & 67108863, L = (A >> 26) - (m / 67108864 | 0), this.words[v + u] = A & 67108863;
        }
        for (; v < this.length - u; v++)
          A = (this.words[v + u] | 0) + L, L = A >> 26, this.words[v + u] = A & 67108863;
        if (L === 0) return this.strip();
        for (i(L === -1), L = 0, v = 0; v < this.length; v++)
          A = -(this.words[v] | 0) + L, L = A >> 26, this.words[v] = A & 67108863;
        return this.negative = 1, this.strip();
      }, n.prototype._wordDiv = function(r, s) {
        var u = this.length - r.length, g = this.clone(), v = r, A = v.words[v.length - 1] | 0, L = this._countBits(A);
        u = 26 - L, u !== 0 && (v = v.ushln(u), g.iushln(u), A = v.words[v.length - 1] | 0);
        var m = g.length - v.length, a;
        if (s !== "mod") {
          a = new n(null), a.length = m + 1, a.words = new Array(a.length);
          for (var x = 0; x < a.length; x++)
            a.words[x] = 0;
        }
        var V = g.clone()._ishlnsubmul(v, 1, m);
        V.negative === 0 && (g = V, a && (a.words[m] = 1));
        for (var G = m - 1; G >= 0; G--) {
          var Z = (g.words[v.length + G] | 0) * 67108864 + (g.words[v.length + G - 1] | 0);
          for (Z = Math.min(Z / A | 0, 67108863), g._ishlnsubmul(v, Z, G); g.negative !== 0; )
            Z--, g.negative = 0, g._ishlnsubmul(v, 1, G), g.isZero() || (g.negative ^= 1);
          a && (a.words[G] = Z);
        }
        return a && a.strip(), g.strip(), s !== "div" && u !== 0 && g.iushrn(u), {
          div: a || null,
          mod: g
        };
      }, n.prototype.divmod = function(r, s, u) {
        if (i(!r.isZero()), this.isZero())
          return {
            div: new n(0),
            mod: new n(0)
          };
        var g, v, A;
        return this.negative !== 0 && r.negative === 0 ? (A = this.neg().divmod(r, s), s !== "mod" && (g = A.div.neg()), s !== "div" && (v = A.mod.neg(), u && v.negative !== 0 && v.iadd(r)), {
          div: g,
          mod: v
        }) : this.negative === 0 && r.negative !== 0 ? (A = this.divmod(r.neg(), s), s !== "mod" && (g = A.div.neg()), {
          div: g,
          mod: A.mod
        }) : this.negative & r.negative ? (A = this.neg().divmod(r.neg(), s), s !== "div" && (v = A.mod.neg(), u && v.negative !== 0 && v.isub(r)), {
          div: A.div,
          mod: v
        }) : r.length > this.length || this.cmp(r) < 0 ? {
          div: new n(0),
          mod: this
        } : r.length === 1 ? s === "div" ? {
          div: this.divn(r.words[0]),
          mod: null
        } : s === "mod" ? {
          div: null,
          mod: new n(this.modn(r.words[0]))
        } : {
          div: this.divn(r.words[0]),
          mod: new n(this.modn(r.words[0]))
        } : this._wordDiv(r, s);
      }, n.prototype.div = function(r) {
        return this.divmod(r, "div", !1).div;
      }, n.prototype.mod = function(r) {
        return this.divmod(r, "mod", !1).mod;
      }, n.prototype.umod = function(r) {
        return this.divmod(r, "mod", !0).mod;
      }, n.prototype.divRound = function(r) {
        var s = this.divmod(r);
        if (s.mod.isZero()) return s.div;
        var u = s.div.negative !== 0 ? s.mod.isub(r) : s.mod, g = r.ushrn(1), v = r.andln(1), A = u.cmp(g);
        return A < 0 || v === 1 && A === 0 ? s.div : s.div.negative !== 0 ? s.div.isubn(1) : s.div.iaddn(1);
      }, n.prototype.modn = function(r) {
        i(r <= 67108863);
        for (var s = (1 << 26) % r, u = 0, g = this.length - 1; g >= 0; g--)
          u = (s * u + (this.words[g] | 0)) % r;
        return u;
      }, n.prototype.idivn = function(r) {
        i(r <= 67108863);
        for (var s = 0, u = this.length - 1; u >= 0; u--) {
          var g = (this.words[u] | 0) + s * 67108864;
          this.words[u] = g / r | 0, s = g % r;
        }
        return this.strip();
      }, n.prototype.divn = function(r) {
        return this.clone().idivn(r);
      }, n.prototype.egcd = function(r) {
        i(r.negative === 0), i(!r.isZero());
        var s = this, u = r.clone();
        s.negative !== 0 ? s = s.umod(r) : s = s.clone();
        for (var g = new n(1), v = new n(0), A = new n(0), L = new n(1), m = 0; s.isEven() && u.isEven(); )
          s.iushrn(1), u.iushrn(1), ++m;
        for (var a = u.clone(), x = s.clone(); !s.isZero(); ) {
          for (var V = 0, G = 1; !(s.words[0] & G) && V < 26; ++V, G <<= 1) ;
          if (V > 0)
            for (s.iushrn(V); V-- > 0; )
              (g.isOdd() || v.isOdd()) && (g.iadd(a), v.isub(x)), g.iushrn(1), v.iushrn(1);
          for (var Z = 0, te = 1; !(u.words[0] & te) && Z < 26; ++Z, te <<= 1) ;
          if (Z > 0)
            for (u.iushrn(Z); Z-- > 0; )
              (A.isOdd() || L.isOdd()) && (A.iadd(a), L.isub(x)), A.iushrn(1), L.iushrn(1);
          s.cmp(u) >= 0 ? (s.isub(u), g.isub(A), v.isub(L)) : (u.isub(s), A.isub(g), L.isub(v));
        }
        return {
          a: A,
          b: L,
          gcd: u.iushln(m)
        };
      }, n.prototype._invmp = function(r) {
        i(r.negative === 0), i(!r.isZero());
        var s = this, u = r.clone();
        s.negative !== 0 ? s = s.umod(r) : s = s.clone();
        for (var g = new n(1), v = new n(0), A = u.clone(); s.cmpn(1) > 0 && u.cmpn(1) > 0; ) {
          for (var L = 0, m = 1; !(s.words[0] & m) && L < 26; ++L, m <<= 1) ;
          if (L > 0)
            for (s.iushrn(L); L-- > 0; )
              g.isOdd() && g.iadd(A), g.iushrn(1);
          for (var a = 0, x = 1; !(u.words[0] & x) && a < 26; ++a, x <<= 1) ;
          if (a > 0)
            for (u.iushrn(a); a-- > 0; )
              v.isOdd() && v.iadd(A), v.iushrn(1);
          s.cmp(u) >= 0 ? (s.isub(u), g.isub(v)) : (u.isub(s), v.isub(g));
        }
        var V;
        return s.cmpn(1) === 0 ? V = g : V = v, V.cmpn(0) < 0 && V.iadd(r), V;
      }, n.prototype.gcd = function(r) {
        if (this.isZero()) return r.abs();
        if (r.isZero()) return this.abs();
        var s = this.clone(), u = r.clone();
        s.negative = 0, u.negative = 0;
        for (var g = 0; s.isEven() && u.isEven(); g++)
          s.iushrn(1), u.iushrn(1);
        do {
          for (; s.isEven(); )
            s.iushrn(1);
          for (; u.isEven(); )
            u.iushrn(1);
          var v = s.cmp(u);
          if (v < 0) {
            var A = s;
            s = u, u = A;
          } else if (v === 0 || u.cmpn(1) === 0)
            break;
          s.isub(u);
        } while (!0);
        return u.iushln(g);
      }, n.prototype.invm = function(r) {
        return this.egcd(r).a.umod(r);
      }, n.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, n.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, n.prototype.andln = function(r) {
        return this.words[0] & r;
      }, n.prototype.bincn = function(r) {
        i(typeof r == "number");
        var s = r % 26, u = (r - s) / 26, g = 1 << s;
        if (this.length <= u)
          return this._expand(u + 1), this.words[u] |= g, this;
        for (var v = g, A = u; v !== 0 && A < this.length; A++) {
          var L = this.words[A] | 0;
          L += v, v = L >>> 26, L &= 67108863, this.words[A] = L;
        }
        return v !== 0 && (this.words[A] = v, this.length++), this;
      }, n.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, n.prototype.cmpn = function(r) {
        var s = r < 0;
        if (this.negative !== 0 && !s) return -1;
        if (this.negative === 0 && s) return 1;
        this.strip();
        var u;
        if (this.length > 1)
          u = 1;
        else {
          s && (r = -r), i(r <= 67108863, "Number is too big");
          var g = this.words[0] | 0;
          u = g === r ? 0 : g < r ? -1 : 1;
        }
        return this.negative !== 0 ? -u | 0 : u;
      }, n.prototype.cmp = function(r) {
        if (this.negative !== 0 && r.negative === 0) return -1;
        if (this.negative === 0 && r.negative !== 0) return 1;
        var s = this.ucmp(r);
        return this.negative !== 0 ? -s | 0 : s;
      }, n.prototype.ucmp = function(r) {
        if (this.length > r.length) return 1;
        if (this.length < r.length) return -1;
        for (var s = 0, u = this.length - 1; u >= 0; u--) {
          var g = this.words[u] | 0, v = r.words[u] | 0;
          if (g !== v) {
            g < v ? s = -1 : g > v && (s = 1);
            break;
          }
        }
        return s;
      }, n.prototype.gtn = function(r) {
        return this.cmpn(r) === 1;
      }, n.prototype.gt = function(r) {
        return this.cmp(r) === 1;
      }, n.prototype.gten = function(r) {
        return this.cmpn(r) >= 0;
      }, n.prototype.gte = function(r) {
        return this.cmp(r) >= 0;
      }, n.prototype.ltn = function(r) {
        return this.cmpn(r) === -1;
      }, n.prototype.lt = function(r) {
        return this.cmp(r) === -1;
      }, n.prototype.lten = function(r) {
        return this.cmpn(r) <= 0;
      }, n.prototype.lte = function(r) {
        return this.cmp(r) <= 0;
      }, n.prototype.eqn = function(r) {
        return this.cmpn(r) === 0;
      }, n.prototype.eq = function(r) {
        return this.cmp(r) === 0;
      }, n.red = function(r) {
        return new U(r);
      }, n.prototype.toRed = function(r) {
        return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), r.convertTo(this)._forceRed(r);
      }, n.prototype.fromRed = function() {
        return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, n.prototype._forceRed = function(r) {
        return this.red = r, this;
      }, n.prototype.forceRed = function(r) {
        return i(!this.red, "Already a number in reduction context"), this._forceRed(r);
      }, n.prototype.redAdd = function(r) {
        return i(this.red, "redAdd works only with red numbers"), this.red.add(this, r);
      }, n.prototype.redIAdd = function(r) {
        return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, r);
      }, n.prototype.redSub = function(r) {
        return i(this.red, "redSub works only with red numbers"), this.red.sub(this, r);
      }, n.prototype.redISub = function(r) {
        return i(this.red, "redISub works only with red numbers"), this.red.isub(this, r);
      }, n.prototype.redShl = function(r) {
        return i(this.red, "redShl works only with red numbers"), this.red.shl(this, r);
      }, n.prototype.redMul = function(r) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, r), this.red.mul(this, r);
      }, n.prototype.redIMul = function(r) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, r), this.red.imul(this, r);
      }, n.prototype.redSqr = function() {
        return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, n.prototype.redISqr = function() {
        return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, n.prototype.redSqrt = function() {
        return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, n.prototype.redInvm = function() {
        return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, n.prototype.redNeg = function() {
        return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, n.prototype.redPow = function(r) {
        return i(this.red && !r.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, r);
      };
      var j = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function O(I, r) {
        this.name = I, this.p = new n(r, 16), this.n = this.p.bitLength(), this.k = new n(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      O.prototype._tmp = function() {
        var r = new n(null);
        return r.words = new Array(Math.ceil(this.n / 13)), r;
      }, O.prototype.ireduce = function(r) {
        var s = r, u;
        do
          this.split(s, this.tmp), s = this.imulK(s), s = s.iadd(this.tmp), u = s.bitLength();
        while (u > this.n);
        var g = u < this.n ? -1 : s.ucmp(this.p);
        return g === 0 ? (s.words[0] = 0, s.length = 1) : g > 0 ? s.isub(this.p) : s.strip !== void 0 ? s.strip() : s._strip(), s;
      }, O.prototype.split = function(r, s) {
        r.iushrn(this.n, 0, s);
      }, O.prototype.imulK = function(r) {
        return r.imul(this.k);
      };
      function z() {
        O.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      c(z, O), z.prototype.split = function(r, s) {
        for (var u = 4194303, g = Math.min(r.length, 9), v = 0; v < g; v++)
          s.words[v] = r.words[v];
        if (s.length = g, r.length <= 9) {
          r.words[0] = 0, r.length = 1;
          return;
        }
        var A = r.words[9];
        for (s.words[s.length++] = A & u, v = 10; v < r.length; v++) {
          var L = r.words[v] | 0;
          r.words[v - 10] = (L & u) << 4 | A >>> 22, A = L;
        }
        A >>>= 22, r.words[v - 10] = A, A === 0 && r.length > 10 ? r.length -= 10 : r.length -= 9;
      }, z.prototype.imulK = function(r) {
        r.words[r.length] = 0, r.words[r.length + 1] = 0, r.length += 2;
        for (var s = 0, u = 0; u < r.length; u++) {
          var g = r.words[u] | 0;
          s += g * 977, r.words[u] = s & 67108863, s = g * 64 + (s / 67108864 | 0);
        }
        return r.words[r.length - 1] === 0 && (r.length--, r.words[r.length - 1] === 0 && r.length--), r;
      };
      function k() {
        O.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      c(k, O);
      function H() {
        O.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      c(H, O);
      function W() {
        O.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      c(W, O), W.prototype.imulK = function(r) {
        for (var s = 0, u = 0; u < r.length; u++) {
          var g = (r.words[u] | 0) * 19 + s, v = g & 67108863;
          g >>>= 26, r.words[u] = v, s = g;
        }
        return s !== 0 && (r.words[r.length++] = s), r;
      }, n._prime = function(r) {
        if (j[r]) return j[r];
        var s;
        if (r === "k256")
          s = new z();
        else if (r === "p224")
          s = new k();
        else if (r === "p192")
          s = new H();
        else if (r === "p25519")
          s = new W();
        else
          throw new Error("Unknown prime " + r);
        return j[r] = s, s;
      };
      function U(I) {
        if (typeof I == "string") {
          var r = n._prime(I);
          this.m = r.p, this.prime = r;
        } else
          i(I.gtn(1), "modulus must be greater than 1"), this.m = I, this.prime = null;
      }
      U.prototype._verify1 = function(r) {
        i(r.negative === 0, "red works only with positives"), i(r.red, "red works only with red numbers");
      }, U.prototype._verify2 = function(r, s) {
        i((r.negative | s.negative) === 0, "red works only with positives"), i(
          r.red && r.red === s.red,
          "red works only with red numbers"
        );
      }, U.prototype.imod = function(r) {
        return this.prime ? this.prime.ireduce(r)._forceRed(this) : r.umod(this.m)._forceRed(this);
      }, U.prototype.neg = function(r) {
        return r.isZero() ? r.clone() : this.m.sub(r)._forceRed(this);
      }, U.prototype.add = function(r, s) {
        this._verify2(r, s);
        var u = r.add(s);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u._forceRed(this);
      }, U.prototype.iadd = function(r, s) {
        this._verify2(r, s);
        var u = r.iadd(s);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u;
      }, U.prototype.sub = function(r, s) {
        this._verify2(r, s);
        var u = r.sub(s);
        return u.cmpn(0) < 0 && u.iadd(this.m), u._forceRed(this);
      }, U.prototype.isub = function(r, s) {
        this._verify2(r, s);
        var u = r.isub(s);
        return u.cmpn(0) < 0 && u.iadd(this.m), u;
      }, U.prototype.shl = function(r, s) {
        return this._verify1(r), this.imod(r.ushln(s));
      }, U.prototype.imul = function(r, s) {
        return this._verify2(r, s), this.imod(r.imul(s));
      }, U.prototype.mul = function(r, s) {
        return this._verify2(r, s), this.imod(r.mul(s));
      }, U.prototype.isqr = function(r) {
        return this.imul(r, r.clone());
      }, U.prototype.sqr = function(r) {
        return this.mul(r, r);
      }, U.prototype.sqrt = function(r) {
        if (r.isZero()) return r.clone();
        var s = this.m.andln(3);
        if (i(s % 2 === 1), s === 3) {
          var u = this.m.add(new n(1)).iushrn(2);
          return this.pow(r, u);
        }
        for (var g = this.m.subn(1), v = 0; !g.isZero() && g.andln(1) === 0; )
          v++, g.iushrn(1);
        i(!g.isZero());
        var A = new n(1).toRed(this), L = A.redNeg(), m = this.m.subn(1).iushrn(1), a = this.m.bitLength();
        for (a = new n(2 * a * a).toRed(this); this.pow(a, m).cmp(L) !== 0; )
          a.redIAdd(L);
        for (var x = this.pow(a, g), V = this.pow(r, g.addn(1).iushrn(1)), G = this.pow(r, g), Z = v; G.cmp(A) !== 0; ) {
          for (var te = G, q = 0; te.cmp(A) !== 0; q++)
            te = te.redSqr();
          i(q < Z);
          var R = this.pow(x, new n(1).iushln(Z - q - 1));
          V = V.redMul(R), x = R.redSqr(), G = G.redMul(x), Z = q;
        }
        return V;
      }, U.prototype.invm = function(r) {
        var s = r._invmp(this.m);
        return s.negative !== 0 ? (s.negative = 0, this.imod(s).redNeg()) : this.imod(s);
      }, U.prototype.pow = function(r, s) {
        if (s.isZero()) return new n(1).toRed(this);
        if (s.cmpn(1) === 0) return r.clone();
        var u = 4, g = new Array(1 << u);
        g[0] = new n(1).toRed(this), g[1] = r;
        for (var v = 2; v < g.length; v++)
          g[v] = this.mul(g[v - 1], r);
        var A = g[0], L = 0, m = 0, a = s.bitLength() % 26;
        for (a === 0 && (a = 26), v = s.length - 1; v >= 0; v--) {
          for (var x = s.words[v], V = a - 1; V >= 0; V--) {
            var G = x >> V & 1;
            if (A !== g[0] && (A = this.sqr(A)), G === 0 && L === 0) {
              m = 0;
              continue;
            }
            L <<= 1, L |= G, m++, !(m !== u && (v !== 0 || V !== 0)) && (A = this.mul(A, g[L]), m = 0, L = 0);
          }
          a = 26;
        }
        return A;
      }, U.prototype.convertTo = function(r) {
        var s = r.umod(this.m);
        return s === r ? s.clone() : s;
      }, U.prototype.convertFrom = function(r) {
        var s = r.clone();
        return s.red = null, s;
      }, n.mont = function(r) {
        return new B(r);
      };
      function B(I) {
        U.call(this, I), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new n(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      c(B, U), B.prototype.convertTo = function(r) {
        return this.imod(r.ushln(this.shift));
      }, B.prototype.convertFrom = function(r) {
        var s = this.imod(r.mul(this.rinv));
        return s.red = null, s;
      }, B.prototype.imul = function(r, s) {
        if (r.isZero() || s.isZero())
          return r.words[0] = 0, r.length = 1, r;
        var u = r.imul(s), g = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), v = u.isub(g).iushrn(this.shift), A = v;
        return v.cmp(this.m) >= 0 ? A = v.isub(this.m) : v.cmpn(0) < 0 && (A = v.iadd(this.m)), A._forceRed(this);
      }, B.prototype.mul = function(r, s) {
        if (r.isZero() || s.isZero()) return new n(0)._forceRed(this);
        var u = r.mul(s), g = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), v = u.isub(g).iushrn(this.shift), A = v;
        return v.cmp(this.m) >= 0 ? A = v.isub(this.m) : v.cmpn(0) < 0 && (A = v.iadd(this.m)), A._forceRed(this);
      }, B.prototype.invm = function(r) {
        var s = this.imod(r._invmp(this.m).mul(this.r2));
        return s._forceRed(this);
      };
    })(e, Wt);
  }(H0)), H0.exports;
}
var Ou = {}, y3;
function wM() {
  return y3 || (y3 = 1, function(e) {
    var t = e;
    function o(n, d) {
      if (Array.isArray(n))
        return n.slice();
      if (!n)
        return [];
      var f = [];
      if (typeof n != "string") {
        for (var p = 0; p < n.length; p++)
          f[p] = n[p] | 0;
        return f;
      }
      if (d === "hex") {
        n = n.replace(/[^a-z0-9]+/ig, ""), n.length % 2 !== 0 && (n = "0" + n);
        for (var p = 0; p < n.length; p += 2)
          f.push(parseInt(n[p] + n[p + 1], 16));
      } else
        for (var p = 0; p < n.length; p++) {
          var l = n.charCodeAt(p), h = l >> 8, y = l & 255;
          h ? f.push(h, y) : f.push(y);
        }
      return f;
    }
    t.toArray = o;
    function i(n) {
      return n.length === 1 ? "0" + n : n;
    }
    t.zero2 = i;
    function c(n) {
      for (var d = "", f = 0; f < n.length; f++)
        d += i(n[f].toString(16));
      return d;
    }
    t.toHex = c, t.encode = function(d, f) {
      return f === "hex" ? c(d) : d;
    };
  }(Ou)), Ou;
}
var M3;
function Qn() {
  return M3 || (M3 = 1, function(e) {
    var t = e, o = Ni(), i = Zn(), c = wM();
    t.assert = i, t.toArray = c.toArray, t.zero2 = c.zero2, t.toHex = c.toHex, t.encode = c.encode;
    function n(h, y, M) {
      var C = new Array(Math.max(h.bitLength(), M) + 1), N;
      for (N = 0; N < C.length; N += 1)
        C[N] = 0;
      var w = 1 << y + 1, S = h.clone();
      for (N = 0; N < C.length; N++) {
        var T, E = S.andln(w - 1);
        S.isOdd() ? (E > (w >> 1) - 1 ? T = (w >> 1) - E : T = E, S.isubn(T)) : T = 0, C[N] = T, S.iushrn(1);
      }
      return C;
    }
    t.getNAF = n;
    function d(h, y) {
      var M = [
        [],
        []
      ];
      h = h.clone(), y = y.clone();
      for (var C = 0, N = 0, w; h.cmpn(-C) > 0 || y.cmpn(-N) > 0; ) {
        var S = h.andln(3) + C & 3, T = y.andln(3) + N & 3;
        S === 3 && (S = -1), T === 3 && (T = -1);
        var E;
        S & 1 ? (w = h.andln(7) + C & 7, (w === 3 || w === 5) && T === 2 ? E = -S : E = S) : E = 0, M[0].push(E);
        var j;
        T & 1 ? (w = y.andln(7) + N & 7, (w === 3 || w === 5) && S === 2 ? j = -T : j = T) : j = 0, M[1].push(j), 2 * C === E + 1 && (C = 1 - C), 2 * N === j + 1 && (N = 1 - N), h.iushrn(1), y.iushrn(1);
      }
      return M;
    }
    t.getJSF = d;
    function f(h, y, M) {
      var C = "_" + y;
      h.prototype[y] = function() {
        return this[C] !== void 0 ? this[C] : this[C] = M.call(this);
      };
    }
    t.cachedProperty = f;
    function p(h) {
      return typeof h == "string" ? t.toArray(h, "hex") : h;
    }
    t.parseBytes = p;
    function l(h) {
      return new o(h, "hex", "le");
    }
    t.intFromLE = l;
  }(ju)), ju;
}
var zu = {}, ku, m3;
function $c() {
  if (m3) return ku;
  m3 = 1;
  var e = Ni(), t = Qn(), o = t.getNAF, i = t.getJSF, c = t.assert;
  function n(f, p) {
    this.type = f, this.p = new e(p.p, 16), this.red = p.prime ? e.red(p.prime) : e.mont(this.p), this.zero = new e(0).toRed(this.red), this.one = new e(1).toRed(this.red), this.two = new e(2).toRed(this.red), this.n = p.n && new e(p.n, 16), this.g = p.g && this.pointFromJSON(p.g, p.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var l = this.n && this.p.div(this.n);
    !l || l.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
  }
  ku = n, n.prototype.point = function() {
    throw new Error("Not implemented");
  }, n.prototype.validate = function() {
    throw new Error("Not implemented");
  }, n.prototype._fixedNafMul = function(p, l) {
    c(p.precomputed);
    var h = p._getDoubles(), y = o(l, 1, this._bitLength), M = (1 << h.step + 1) - (h.step % 2 === 0 ? 2 : 1);
    M /= 3;
    var C = [], N, w;
    for (N = 0; N < y.length; N += h.step) {
      w = 0;
      for (var S = N + h.step - 1; S >= N; S--)
        w = (w << 1) + y[S];
      C.push(w);
    }
    for (var T = this.jpoint(null, null, null), E = this.jpoint(null, null, null), j = M; j > 0; j--) {
      for (N = 0; N < C.length; N++)
        w = C[N], w === j ? E = E.mixedAdd(h.points[N]) : w === -j && (E = E.mixedAdd(h.points[N].neg()));
      T = T.add(E);
    }
    return T.toP();
  }, n.prototype._wnafMul = function(p, l) {
    var h = 4, y = p._getNAFPoints(h);
    h = y.wnd;
    for (var M = y.points, C = o(l, h, this._bitLength), N = this.jpoint(null, null, null), w = C.length - 1; w >= 0; w--) {
      for (var S = 0; w >= 0 && C[w] === 0; w--)
        S++;
      if (w >= 0 && S++, N = N.dblp(S), w < 0)
        break;
      var T = C[w];
      c(T !== 0), p.type === "affine" ? T > 0 ? N = N.mixedAdd(M[T - 1 >> 1]) : N = N.mixedAdd(M[-T - 1 >> 1].neg()) : T > 0 ? N = N.add(M[T - 1 >> 1]) : N = N.add(M[-T - 1 >> 1].neg());
    }
    return p.type === "affine" ? N.toP() : N;
  }, n.prototype._wnafMulAdd = function(p, l, h, y, M) {
    var C = this._wnafT1, N = this._wnafT2, w = this._wnafT3, S = 0, T, E, j;
    for (T = 0; T < y; T++) {
      j = l[T];
      var O = j._getNAFPoints(p);
      C[T] = O.wnd, N[T] = O.points;
    }
    for (T = y - 1; T >= 1; T -= 2) {
      var z = T - 1, k = T;
      if (C[z] !== 1 || C[k] !== 1) {
        w[z] = o(h[z], C[z], this._bitLength), w[k] = o(h[k], C[k], this._bitLength), S = Math.max(w[z].length, S), S = Math.max(w[k].length, S);
        continue;
      }
      var H = [
        l[z],
        /* 1 */
        null,
        /* 3 */
        null,
        /* 5 */
        l[k]
        /* 7 */
      ];
      l[z].y.cmp(l[k].y) === 0 ? (H[1] = l[z].add(l[k]), H[2] = l[z].toJ().mixedAdd(l[k].neg())) : l[z].y.cmp(l[k].y.redNeg()) === 0 ? (H[1] = l[z].toJ().mixedAdd(l[k]), H[2] = l[z].add(l[k].neg())) : (H[1] = l[z].toJ().mixedAdd(l[k]), H[2] = l[z].toJ().mixedAdd(l[k].neg()));
      var W = [
        -3,
        /* -1 -1 */
        -1,
        /* -1 0 */
        -5,
        /* -1 1 */
        -7,
        /* 0 -1 */
        0,
        /* 0 0 */
        7,
        /* 0 1 */
        5,
        /* 1 -1 */
        1,
        /* 1 0 */
        3
        /* 1 1 */
      ], U = i(h[z], h[k]);
      for (S = Math.max(U[0].length, S), w[z] = new Array(S), w[k] = new Array(S), E = 0; E < S; E++) {
        var B = U[0][E] | 0, I = U[1][E] | 0;
        w[z][E] = W[(B + 1) * 3 + (I + 1)], w[k][E] = 0, N[z] = H;
      }
    }
    var r = this.jpoint(null, null, null), s = this._wnafT4;
    for (T = S; T >= 0; T--) {
      for (var u = 0; T >= 0; ) {
        var g = !0;
        for (E = 0; E < y; E++)
          s[E] = w[E][T] | 0, s[E] !== 0 && (g = !1);
        if (!g)
          break;
        u++, T--;
      }
      if (T >= 0 && u++, r = r.dblp(u), T < 0)
        break;
      for (E = 0; E < y; E++) {
        var v = s[E];
        v !== 0 && (v > 0 ? j = N[E][v - 1 >> 1] : v < 0 && (j = N[E][-v - 1 >> 1].neg()), j.type === "affine" ? r = r.mixedAdd(j) : r = r.add(j));
      }
    }
    for (T = 0; T < y; T++)
      N[T] = null;
    return M ? r : r.toP();
  };
  function d(f, p) {
    this.curve = f, this.type = p, this.precomputed = null;
  }
  return n.BasePoint = d, d.prototype.eq = function() {
    throw new Error("Not implemented");
  }, d.prototype.validate = function() {
    return this.curve.validate(this);
  }, n.prototype.decodePoint = function(p, l) {
    p = t.toArray(p, l);
    var h = this.p.byteLength();
    if ((p[0] === 4 || p[0] === 6 || p[0] === 7) && p.length - 1 === 2 * h) {
      p[0] === 6 ? c(p[p.length - 1] % 2 === 0) : p[0] === 7 && c(p[p.length - 1] % 2 === 1);
      var y = this.point(
        p.slice(1, 1 + h),
        p.slice(1 + h, 1 + 2 * h)
      );
      return y;
    } else if ((p[0] === 2 || p[0] === 3) && p.length - 1 === h)
      return this.pointFromX(p.slice(1, 1 + h), p[0] === 3);
    throw new Error("Unknown point format");
  }, d.prototype.encodeCompressed = function(p) {
    return this.encode(p, !0);
  }, d.prototype._encode = function(p) {
    var l = this.curve.p.byteLength(), h = this.getX().toArray("be", l);
    return p ? [this.getY().isEven() ? 2 : 3].concat(h) : [4].concat(h, this.getY().toArray("be", l));
  }, d.prototype.encode = function(p, l) {
    return t.encode(this._encode(l), p);
  }, d.prototype.precompute = function(p) {
    if (this.precomputed)
      return this;
    var l = {
      doubles: null,
      naf: null,
      beta: null
    };
    return l.naf = this._getNAFPoints(8), l.doubles = this._getDoubles(4, p), l.beta = this._getBeta(), this.precomputed = l, this;
  }, d.prototype._hasDoubles = function(p) {
    if (!this.precomputed)
      return !1;
    var l = this.precomputed.doubles;
    return l ? l.points.length >= Math.ceil((p.bitLength() + 1) / l.step) : !1;
  }, d.prototype._getDoubles = function(p, l) {
    if (this.precomputed && this.precomputed.doubles)
      return this.precomputed.doubles;
    for (var h = [this], y = this, M = 0; M < l; M += p) {
      for (var C = 0; C < p; C++)
        y = y.dbl();
      h.push(y);
    }
    return {
      step: p,
      points: h
    };
  }, d.prototype._getNAFPoints = function(p) {
    if (this.precomputed && this.precomputed.naf)
      return this.precomputed.naf;
    for (var l = [this], h = (1 << p) - 1, y = h === 1 ? null : this.dbl(), M = 1; M < h; M++)
      l[M] = l[M - 1].add(y);
    return {
      wnd: p,
      points: l
    };
  }, d.prototype._getBeta = function() {
    return null;
  }, d.prototype.dblp = function(p) {
    for (var l = this, h = 0; h < p; h++)
      l = l.dbl();
    return l;
  }, ku;
}
var _u, v3;
function EA() {
  if (v3) return _u;
  v3 = 1;
  var e = Qn(), t = Ni(), o = Yt, i = $c(), c = e.assert;
  function n(p) {
    i.call(this, "short", p), this.a = new t(p.a, 16).toRed(this.red), this.b = new t(p.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(p), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
  }
  o(n, i), _u = n, n.prototype._getEndomorphism = function(l) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
      var h, y;
      if (l.beta)
        h = new t(l.beta, 16).toRed(this.red);
      else {
        var M = this._getEndoRoots(this.p);
        h = M[0].cmp(M[1]) < 0 ? M[0] : M[1], h = h.toRed(this.red);
      }
      if (l.lambda)
        y = new t(l.lambda, 16);
      else {
        var C = this._getEndoRoots(this.n);
        this.g.mul(C[0]).x.cmp(this.g.x.redMul(h)) === 0 ? y = C[0] : (y = C[1], c(this.g.mul(y).x.cmp(this.g.x.redMul(h)) === 0));
      }
      var N;
      return l.basis ? N = l.basis.map(function(w) {
        return {
          a: new t(w.a, 16),
          b: new t(w.b, 16)
        };
      }) : N = this._getEndoBasis(y), {
        beta: h,
        lambda: y,
        basis: N
      };
    }
  }, n.prototype._getEndoRoots = function(l) {
    var h = l === this.p ? this.red : t.mont(l), y = new t(2).toRed(h).redInvm(), M = y.redNeg(), C = new t(3).toRed(h).redNeg().redSqrt().redMul(y), N = M.redAdd(C).fromRed(), w = M.redSub(C).fromRed();
    return [N, w];
  }, n.prototype._getEndoBasis = function(l) {
    for (var h = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), y = l, M = this.n.clone(), C = new t(1), N = new t(0), w = new t(0), S = new t(1), T, E, j, O, z, k, H, W = 0, U, B; y.cmpn(0) !== 0; ) {
      var I = M.div(y);
      U = M.sub(I.mul(y)), B = w.sub(I.mul(C));
      var r = S.sub(I.mul(N));
      if (!j && U.cmp(h) < 0)
        T = H.neg(), E = C, j = U.neg(), O = B;
      else if (j && ++W === 2)
        break;
      H = U, M = y, y = U, w = C, C = B, S = N, N = r;
    }
    z = U.neg(), k = B;
    var s = j.sqr().add(O.sqr()), u = z.sqr().add(k.sqr());
    return u.cmp(s) >= 0 && (z = T, k = E), j.negative && (j = j.neg(), O = O.neg()), z.negative && (z = z.neg(), k = k.neg()), [
      { a: j, b: O },
      { a: z, b: k }
    ];
  }, n.prototype._endoSplit = function(l) {
    var h = this.endo.basis, y = h[0], M = h[1], C = M.b.mul(l).divRound(this.n), N = y.b.neg().mul(l).divRound(this.n), w = C.mul(y.a), S = N.mul(M.a), T = C.mul(y.b), E = N.mul(M.b), j = l.sub(w).sub(S), O = T.add(E).neg();
    return { k1: j, k2: O };
  }, n.prototype.pointFromX = function(l, h) {
    l = new t(l, 16), l.red || (l = l.toRed(this.red));
    var y = l.redSqr().redMul(l).redIAdd(l.redMul(this.a)).redIAdd(this.b), M = y.redSqrt();
    if (M.redSqr().redSub(y).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var C = M.fromRed().isOdd();
    return (h && !C || !h && C) && (M = M.redNeg()), this.point(l, M);
  }, n.prototype.validate = function(l) {
    if (l.inf)
      return !0;
    var h = l.x, y = l.y, M = this.a.redMul(h), C = h.redSqr().redMul(h).redIAdd(M).redIAdd(this.b);
    return y.redSqr().redISub(C).cmpn(0) === 0;
  }, n.prototype._endoWnafMulAdd = function(l, h, y) {
    for (var M = this._endoWnafT1, C = this._endoWnafT2, N = 0; N < l.length; N++) {
      var w = this._endoSplit(h[N]), S = l[N], T = S._getBeta();
      w.k1.negative && (w.k1.ineg(), S = S.neg(!0)), w.k2.negative && (w.k2.ineg(), T = T.neg(!0)), M[N * 2] = S, M[N * 2 + 1] = T, C[N * 2] = w.k1, C[N * 2 + 1] = w.k2;
    }
    for (var E = this._wnafMulAdd(1, M, C, N * 2, y), j = 0; j < N * 2; j++)
      M[j] = null, C[j] = null;
    return E;
  };
  function d(p, l, h, y) {
    i.BasePoint.call(this, p, "affine"), l === null && h === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new t(l, 16), this.y = new t(h, 16), y && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
  }
  o(d, i.BasePoint), n.prototype.point = function(l, h, y) {
    return new d(this, l, h, y);
  }, n.prototype.pointFromJSON = function(l, h) {
    return d.fromJSON(this, l, h);
  }, d.prototype._getBeta = function() {
    if (this.curve.endo) {
      var l = this.precomputed;
      if (l && l.beta)
        return l.beta;
      var h = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
      if (l) {
        var y = this.curve, M = function(C) {
          return y.point(C.x.redMul(y.endo.beta), C.y);
        };
        l.beta = h, h.precomputed = {
          beta: null,
          naf: l.naf && {
            wnd: l.naf.wnd,
            points: l.naf.points.map(M)
          },
          doubles: l.doubles && {
            step: l.doubles.step,
            points: l.doubles.points.map(M)
          }
        };
      }
      return h;
    }
  }, d.prototype.toJSON = function() {
    return this.precomputed ? [this.x, this.y, this.precomputed && {
      doubles: this.precomputed.doubles && {
        step: this.precomputed.doubles.step,
        points: this.precomputed.doubles.points.slice(1)
      },
      naf: this.precomputed.naf && {
        wnd: this.precomputed.naf.wnd,
        points: this.precomputed.naf.points.slice(1)
      }
    }] : [this.x, this.y];
  }, d.fromJSON = function(l, h, y) {
    typeof h == "string" && (h = JSON.parse(h));
    var M = l.point(h[0], h[1], y);
    if (!h[2])
      return M;
    function C(w) {
      return l.point(w[0], w[1], y);
    }
    var N = h[2];
    return M.precomputed = {
      beta: null,
      doubles: N.doubles && {
        step: N.doubles.step,
        points: [M].concat(N.doubles.points.map(C))
      },
      naf: N.naf && {
        wnd: N.naf.wnd,
        points: [M].concat(N.naf.points.map(C))
      }
    }, M;
  }, d.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
  }, d.prototype.isInfinity = function() {
    return this.inf;
  }, d.prototype.add = function(l) {
    if (this.inf)
      return l;
    if (l.inf)
      return this;
    if (this.eq(l))
      return this.dbl();
    if (this.neg().eq(l))
      return this.curve.point(null, null);
    if (this.x.cmp(l.x) === 0)
      return this.curve.point(null, null);
    var h = this.y.redSub(l.y);
    h.cmpn(0) !== 0 && (h = h.redMul(this.x.redSub(l.x).redInvm()));
    var y = h.redSqr().redISub(this.x).redISub(l.x), M = h.redMul(this.x.redSub(y)).redISub(this.y);
    return this.curve.point(y, M);
  }, d.prototype.dbl = function() {
    if (this.inf)
      return this;
    var l = this.y.redAdd(this.y);
    if (l.cmpn(0) === 0)
      return this.curve.point(null, null);
    var h = this.curve.a, y = this.x.redSqr(), M = l.redInvm(), C = y.redAdd(y).redIAdd(y).redIAdd(h).redMul(M), N = C.redSqr().redISub(this.x.redAdd(this.x)), w = C.redMul(this.x.redSub(N)).redISub(this.y);
    return this.curve.point(N, w);
  }, d.prototype.getX = function() {
    return this.x.fromRed();
  }, d.prototype.getY = function() {
    return this.y.fromRed();
  }, d.prototype.mul = function(l) {
    return l = new t(l, 16), this.isInfinity() ? this : this._hasDoubles(l) ? this.curve._fixedNafMul(this, l) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [l]) : this.curve._wnafMul(this, l);
  }, d.prototype.mulAdd = function(l, h, y) {
    var M = [this, h], C = [l, y];
    return this.curve.endo ? this.curve._endoWnafMulAdd(M, C) : this.curve._wnafMulAdd(1, M, C, 2);
  }, d.prototype.jmulAdd = function(l, h, y) {
    var M = [this, h], C = [l, y];
    return this.curve.endo ? this.curve._endoWnafMulAdd(M, C, !0) : this.curve._wnafMulAdd(1, M, C, 2, !0);
  }, d.prototype.eq = function(l) {
    return this === l || this.inf === l.inf && (this.inf || this.x.cmp(l.x) === 0 && this.y.cmp(l.y) === 0);
  }, d.prototype.neg = function(l) {
    if (this.inf)
      return this;
    var h = this.curve.point(this.x, this.y.redNeg());
    if (l && this.precomputed) {
      var y = this.precomputed, M = function(C) {
        return C.neg();
      };
      h.precomputed = {
        naf: y.naf && {
          wnd: y.naf.wnd,
          points: y.naf.points.map(M)
        },
        doubles: y.doubles && {
          step: y.doubles.step,
          points: y.doubles.points.map(M)
        }
      };
    }
    return h;
  }, d.prototype.toJ = function() {
    if (this.inf)
      return this.curve.jpoint(null, null, null);
    var l = this.curve.jpoint(this.x, this.y, this.curve.one);
    return l;
  };
  function f(p, l, h, y) {
    i.BasePoint.call(this, p, "jacobian"), l === null && h === null && y === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new t(0)) : (this.x = new t(l, 16), this.y = new t(h, 16), this.z = new t(y, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }
  return o(f, i.BasePoint), n.prototype.jpoint = function(l, h, y) {
    return new f(this, l, h, y);
  }, f.prototype.toP = function() {
    if (this.isInfinity())
      return this.curve.point(null, null);
    var l = this.z.redInvm(), h = l.redSqr(), y = this.x.redMul(h), M = this.y.redMul(h).redMul(l);
    return this.curve.point(y, M);
  }, f.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }, f.prototype.add = function(l) {
    if (this.isInfinity())
      return l;
    if (l.isInfinity())
      return this;
    var h = l.z.redSqr(), y = this.z.redSqr(), M = this.x.redMul(h), C = l.x.redMul(y), N = this.y.redMul(h.redMul(l.z)), w = l.y.redMul(y.redMul(this.z)), S = M.redSub(C), T = N.redSub(w);
    if (S.cmpn(0) === 0)
      return T.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var E = S.redSqr(), j = E.redMul(S), O = M.redMul(E), z = T.redSqr().redIAdd(j).redISub(O).redISub(O), k = T.redMul(O.redISub(z)).redISub(N.redMul(j)), H = this.z.redMul(l.z).redMul(S);
    return this.curve.jpoint(z, k, H);
  }, f.prototype.mixedAdd = function(l) {
    if (this.isInfinity())
      return l.toJ();
    if (l.isInfinity())
      return this;
    var h = this.z.redSqr(), y = this.x, M = l.x.redMul(h), C = this.y, N = l.y.redMul(h).redMul(this.z), w = y.redSub(M), S = C.redSub(N);
    if (w.cmpn(0) === 0)
      return S.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var T = w.redSqr(), E = T.redMul(w), j = y.redMul(T), O = S.redSqr().redIAdd(E).redISub(j).redISub(j), z = S.redMul(j.redISub(O)).redISub(C.redMul(E)), k = this.z.redMul(w);
    return this.curve.jpoint(O, z, k);
  }, f.prototype.dblp = function(l) {
    if (l === 0)
      return this;
    if (this.isInfinity())
      return this;
    if (!l)
      return this.dbl();
    var h;
    if (this.curve.zeroA || this.curve.threeA) {
      var y = this;
      for (h = 0; h < l; h++)
        y = y.dbl();
      return y;
    }
    var M = this.curve.a, C = this.curve.tinv, N = this.x, w = this.y, S = this.z, T = S.redSqr().redSqr(), E = w.redAdd(w);
    for (h = 0; h < l; h++) {
      var j = N.redSqr(), O = E.redSqr(), z = O.redSqr(), k = j.redAdd(j).redIAdd(j).redIAdd(M.redMul(T)), H = N.redMul(O), W = k.redSqr().redISub(H.redAdd(H)), U = H.redISub(W), B = k.redMul(U);
      B = B.redIAdd(B).redISub(z);
      var I = E.redMul(S);
      h + 1 < l && (T = T.redMul(z)), N = W, S = I, E = B;
    }
    return this.curve.jpoint(N, E.redMul(C), S);
  }, f.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
  }, f.prototype._zeroDbl = function() {
    var l, h, y;
    if (this.zOne) {
      var M = this.x.redSqr(), C = this.y.redSqr(), N = C.redSqr(), w = this.x.redAdd(C).redSqr().redISub(M).redISub(N);
      w = w.redIAdd(w);
      var S = M.redAdd(M).redIAdd(M), T = S.redSqr().redISub(w).redISub(w), E = N.redIAdd(N);
      E = E.redIAdd(E), E = E.redIAdd(E), l = T, h = S.redMul(w.redISub(T)).redISub(E), y = this.y.redAdd(this.y);
    } else {
      var j = this.x.redSqr(), O = this.y.redSqr(), z = O.redSqr(), k = this.x.redAdd(O).redSqr().redISub(j).redISub(z);
      k = k.redIAdd(k);
      var H = j.redAdd(j).redIAdd(j), W = H.redSqr(), U = z.redIAdd(z);
      U = U.redIAdd(U), U = U.redIAdd(U), l = W.redISub(k).redISub(k), h = H.redMul(k.redISub(l)).redISub(U), y = this.y.redMul(this.z), y = y.redIAdd(y);
    }
    return this.curve.jpoint(l, h, y);
  }, f.prototype._threeDbl = function() {
    var l, h, y;
    if (this.zOne) {
      var M = this.x.redSqr(), C = this.y.redSqr(), N = C.redSqr(), w = this.x.redAdd(C).redSqr().redISub(M).redISub(N);
      w = w.redIAdd(w);
      var S = M.redAdd(M).redIAdd(M).redIAdd(this.curve.a), T = S.redSqr().redISub(w).redISub(w);
      l = T;
      var E = N.redIAdd(N);
      E = E.redIAdd(E), E = E.redIAdd(E), h = S.redMul(w.redISub(T)).redISub(E), y = this.y.redAdd(this.y);
    } else {
      var j = this.z.redSqr(), O = this.y.redSqr(), z = this.x.redMul(O), k = this.x.redSub(j).redMul(this.x.redAdd(j));
      k = k.redAdd(k).redIAdd(k);
      var H = z.redIAdd(z);
      H = H.redIAdd(H);
      var W = H.redAdd(H);
      l = k.redSqr().redISub(W), y = this.y.redAdd(this.z).redSqr().redISub(O).redISub(j);
      var U = O.redSqr();
      U = U.redIAdd(U), U = U.redIAdd(U), U = U.redIAdd(U), h = k.redMul(H.redISub(l)).redISub(U);
    }
    return this.curve.jpoint(l, h, y);
  }, f.prototype._dbl = function() {
    var l = this.curve.a, h = this.x, y = this.y, M = this.z, C = M.redSqr().redSqr(), N = h.redSqr(), w = y.redSqr(), S = N.redAdd(N).redIAdd(N).redIAdd(l.redMul(C)), T = h.redAdd(h);
    T = T.redIAdd(T);
    var E = T.redMul(w), j = S.redSqr().redISub(E.redAdd(E)), O = E.redISub(j), z = w.redSqr();
    z = z.redIAdd(z), z = z.redIAdd(z), z = z.redIAdd(z);
    var k = S.redMul(O).redISub(z), H = y.redAdd(y).redMul(M);
    return this.curve.jpoint(j, k, H);
  }, f.prototype.trpl = function() {
    if (!this.curve.zeroA)
      return this.dbl().add(this);
    var l = this.x.redSqr(), h = this.y.redSqr(), y = this.z.redSqr(), M = h.redSqr(), C = l.redAdd(l).redIAdd(l), N = C.redSqr(), w = this.x.redAdd(h).redSqr().redISub(l).redISub(M);
    w = w.redIAdd(w), w = w.redAdd(w).redIAdd(w), w = w.redISub(N);
    var S = w.redSqr(), T = M.redIAdd(M);
    T = T.redIAdd(T), T = T.redIAdd(T), T = T.redIAdd(T);
    var E = C.redIAdd(w).redSqr().redISub(N).redISub(S).redISub(T), j = h.redMul(E);
    j = j.redIAdd(j), j = j.redIAdd(j);
    var O = this.x.redMul(S).redISub(j);
    O = O.redIAdd(O), O = O.redIAdd(O);
    var z = this.y.redMul(E.redMul(T.redISub(E)).redISub(w.redMul(S)));
    z = z.redIAdd(z), z = z.redIAdd(z), z = z.redIAdd(z);
    var k = this.z.redAdd(w).redSqr().redISub(y).redISub(S);
    return this.curve.jpoint(O, z, k);
  }, f.prototype.mul = function(l, h) {
    return l = new t(l, h), this.curve._wnafMul(this, l);
  }, f.prototype.eq = function(l) {
    if (l.type === "affine")
      return this.eq(l.toJ());
    if (this === l)
      return !0;
    var h = this.z.redSqr(), y = l.z.redSqr();
    if (this.x.redMul(y).redISub(l.x.redMul(h)).cmpn(0) !== 0)
      return !1;
    var M = h.redMul(this.z), C = y.redMul(l.z);
    return this.y.redMul(C).redISub(l.y.redMul(M)).cmpn(0) === 0;
  }, f.prototype.eqXToP = function(l) {
    var h = this.z.redSqr(), y = l.toRed(this.curve.red).redMul(h);
    if (this.x.cmp(y) === 0)
      return !0;
    for (var M = l.clone(), C = this.curve.redN.redMul(h); ; ) {
      if (M.iadd(this.curve.n), M.cmp(this.curve.p) >= 0)
        return !1;
      if (y.redIAdd(C), this.x.cmp(y) === 0)
        return !0;
    }
  }, f.prototype.inspect = function() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
  }, f.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, _u;
}
var Bu, b3;
function DA() {
  if (b3) return Bu;
  b3 = 1;
  var e = Ni(), t = Yt, o = $c(), i = Qn();
  function c(d) {
    o.call(this, "mont", d), this.a = new e(d.a, 16).toRed(this.red), this.b = new e(d.b, 16).toRed(this.red), this.i4 = new e(4).toRed(this.red).redInvm(), this.two = new e(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }
  t(c, o), Bu = c, c.prototype.validate = function(f) {
    var p = f.normalize().x, l = p.redSqr(), h = l.redMul(p).redAdd(l.redMul(this.a)).redAdd(p), y = h.redSqrt();
    return y.redSqr().cmp(h) === 0;
  };
  function n(d, f, p) {
    o.BasePoint.call(this, d, "projective"), f === null && p === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new e(f, 16), this.z = new e(p, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }
  return t(n, o.BasePoint), c.prototype.decodePoint = function(f, p) {
    return this.point(i.toArray(f, p), 1);
  }, c.prototype.point = function(f, p) {
    return new n(this, f, p);
  }, c.prototype.pointFromJSON = function(f) {
    return n.fromJSON(this, f);
  }, n.prototype.precompute = function() {
  }, n.prototype._encode = function() {
    return this.getX().toArray("be", this.curve.p.byteLength());
  }, n.fromJSON = function(f, p) {
    return new n(f, p[0], p[1] || f.one);
  }, n.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, n.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, n.prototype.dbl = function() {
    var f = this.x.redAdd(this.z), p = f.redSqr(), l = this.x.redSub(this.z), h = l.redSqr(), y = p.redSub(h), M = p.redMul(h), C = y.redMul(h.redAdd(this.curve.a24.redMul(y)));
    return this.curve.point(M, C);
  }, n.prototype.add = function() {
    throw new Error("Not supported on Montgomery curve");
  }, n.prototype.diffAdd = function(f, p) {
    var l = this.x.redAdd(this.z), h = this.x.redSub(this.z), y = f.x.redAdd(f.z), M = f.x.redSub(f.z), C = M.redMul(l), N = y.redMul(h), w = p.z.redMul(C.redAdd(N).redSqr()), S = p.x.redMul(C.redISub(N).redSqr());
    return this.curve.point(w, S);
  }, n.prototype.mul = function(f) {
    for (var p = f.clone(), l = this, h = this.curve.point(null, null), y = this, M = []; p.cmpn(0) !== 0; p.iushrn(1))
      M.push(p.andln(1));
    for (var C = M.length - 1; C >= 0; C--)
      M[C] === 0 ? (l = l.diffAdd(h, y), h = h.dbl()) : (h = l.diffAdd(h, y), l = l.dbl());
    return h;
  }, n.prototype.mulAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, n.prototype.jumlAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, n.prototype.eq = function(f) {
    return this.getX().cmp(f.getX()) === 0;
  }, n.prototype.normalize = function() {
    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
  }, n.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, Bu;
}
var Fu, x3;
function jA() {
  if (x3) return Fu;
  x3 = 1;
  var e = Qn(), t = Ni(), o = Yt, i = $c(), c = e.assert;
  function n(f) {
    this.twisted = (f.a | 0) !== 1, this.mOneA = this.twisted && (f.a | 0) === -1, this.extended = this.mOneA, i.call(this, "edwards", f), this.a = new t(f.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new t(f.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new t(f.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), c(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (f.c | 0) === 1;
  }
  o(n, i), Fu = n, n.prototype._mulA = function(p) {
    return this.mOneA ? p.redNeg() : this.a.redMul(p);
  }, n.prototype._mulC = function(p) {
    return this.oneC ? p : this.c.redMul(p);
  }, n.prototype.jpoint = function(p, l, h, y) {
    return this.point(p, l, h, y);
  }, n.prototype.pointFromX = function(p, l) {
    p = new t(p, 16), p.red || (p = p.toRed(this.red));
    var h = p.redSqr(), y = this.c2.redSub(this.a.redMul(h)), M = this.one.redSub(this.c2.redMul(this.d).redMul(h)), C = y.redMul(M.redInvm()), N = C.redSqrt();
    if (N.redSqr().redSub(C).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var w = N.fromRed().isOdd();
    return (l && !w || !l && w) && (N = N.redNeg()), this.point(p, N);
  }, n.prototype.pointFromY = function(p, l) {
    p = new t(p, 16), p.red || (p = p.toRed(this.red));
    var h = p.redSqr(), y = h.redSub(this.c2), M = h.redMul(this.d).redMul(this.c2).redSub(this.a), C = y.redMul(M.redInvm());
    if (C.cmp(this.zero) === 0) {
      if (l)
        throw new Error("invalid point");
      return this.point(this.zero, p);
    }
    var N = C.redSqrt();
    if (N.redSqr().redSub(C).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    return N.fromRed().isOdd() !== l && (N = N.redNeg()), this.point(N, p);
  }, n.prototype.validate = function(p) {
    if (p.isInfinity())
      return !0;
    p.normalize();
    var l = p.x.redSqr(), h = p.y.redSqr(), y = l.redMul(this.a).redAdd(h), M = this.c2.redMul(this.one.redAdd(this.d.redMul(l).redMul(h)));
    return y.cmp(M) === 0;
  };
  function d(f, p, l, h, y) {
    i.BasePoint.call(this, f, "projective"), p === null && l === null && h === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new t(p, 16), this.y = new t(l, 16), this.z = h ? new t(h, 16) : this.curve.one, this.t = y && new t(y, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }
  return o(d, i.BasePoint), n.prototype.pointFromJSON = function(p) {
    return d.fromJSON(this, p);
  }, n.prototype.point = function(p, l, h, y) {
    return new d(this, p, l, h, y);
  }, d.fromJSON = function(p, l) {
    return new d(p, l[0], l[1], l[2]);
  }, d.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, d.prototype.isInfinity = function() {
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
  }, d.prototype._extDbl = function() {
    var p = this.x.redSqr(), l = this.y.redSqr(), h = this.z.redSqr();
    h = h.redIAdd(h);
    var y = this.curve._mulA(p), M = this.x.redAdd(this.y).redSqr().redISub(p).redISub(l), C = y.redAdd(l), N = C.redSub(h), w = y.redSub(l), S = M.redMul(N), T = C.redMul(w), E = M.redMul(w), j = N.redMul(C);
    return this.curve.point(S, T, j, E);
  }, d.prototype._projDbl = function() {
    var p = this.x.redAdd(this.y).redSqr(), l = this.x.redSqr(), h = this.y.redSqr(), y, M, C, N, w, S;
    if (this.curve.twisted) {
      N = this.curve._mulA(l);
      var T = N.redAdd(h);
      this.zOne ? (y = p.redSub(l).redSub(h).redMul(T.redSub(this.curve.two)), M = T.redMul(N.redSub(h)), C = T.redSqr().redSub(T).redSub(T)) : (w = this.z.redSqr(), S = T.redSub(w).redISub(w), y = p.redSub(l).redISub(h).redMul(S), M = T.redMul(N.redSub(h)), C = T.redMul(S));
    } else
      N = l.redAdd(h), w = this.curve._mulC(this.z).redSqr(), S = N.redSub(w).redSub(w), y = this.curve._mulC(p.redISub(N)).redMul(S), M = this.curve._mulC(N).redMul(l.redISub(h)), C = N.redMul(S);
    return this.curve.point(y, M, C);
  }, d.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
  }, d.prototype._extAdd = function(p) {
    var l = this.y.redSub(this.x).redMul(p.y.redSub(p.x)), h = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x)), y = this.t.redMul(this.curve.dd).redMul(p.t), M = this.z.redMul(p.z.redAdd(p.z)), C = h.redSub(l), N = M.redSub(y), w = M.redAdd(y), S = h.redAdd(l), T = C.redMul(N), E = w.redMul(S), j = C.redMul(S), O = N.redMul(w);
    return this.curve.point(T, E, O, j);
  }, d.prototype._projAdd = function(p) {
    var l = this.z.redMul(p.z), h = l.redSqr(), y = this.x.redMul(p.x), M = this.y.redMul(p.y), C = this.curve.d.redMul(y).redMul(M), N = h.redSub(C), w = h.redAdd(C), S = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(y).redISub(M), T = l.redMul(N).redMul(S), E, j;
    return this.curve.twisted ? (E = l.redMul(w).redMul(M.redSub(this.curve._mulA(y))), j = N.redMul(w)) : (E = l.redMul(w).redMul(M.redSub(y)), j = this.curve._mulC(N).redMul(w)), this.curve.point(T, E, j);
  }, d.prototype.add = function(p) {
    return this.isInfinity() ? p : p.isInfinity() ? this : this.curve.extended ? this._extAdd(p) : this._projAdd(p);
  }, d.prototype.mul = function(p) {
    return this._hasDoubles(p) ? this.curve._fixedNafMul(this, p) : this.curve._wnafMul(this, p);
  }, d.prototype.mulAdd = function(p, l, h) {
    return this.curve._wnafMulAdd(1, [this, l], [p, h], 2, !1);
  }, d.prototype.jmulAdd = function(p, l, h) {
    return this.curve._wnafMulAdd(1, [this, l], [p, h], 2, !0);
  }, d.prototype.normalize = function() {
    if (this.zOne)
      return this;
    var p = this.z.redInvm();
    return this.x = this.x.redMul(p), this.y = this.y.redMul(p), this.t && (this.t = this.t.redMul(p)), this.z = this.curve.one, this.zOne = !0, this;
  }, d.prototype.neg = function() {
    return this.curve.point(
      this.x.redNeg(),
      this.y,
      this.z,
      this.t && this.t.redNeg()
    );
  }, d.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, d.prototype.getY = function() {
    return this.normalize(), this.y.fromRed();
  }, d.prototype.eq = function(p) {
    return this === p || this.getX().cmp(p.getX()) === 0 && this.getY().cmp(p.getY()) === 0;
  }, d.prototype.eqXToP = function(p) {
    var l = p.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(l) === 0)
      return !0;
    for (var h = p.clone(), y = this.curve.redN.redMul(this.z); ; ) {
      if (h.iadd(this.curve.n), h.cmp(this.curve.p) >= 0)
        return !1;
      if (l.redIAdd(y), this.x.cmp(l) === 0)
        return !0;
    }
  }, d.prototype.toP = d.prototype.normalize, d.prototype.mixedAdd = d.prototype.add, Fu;
}
var w3;
function CM() {
  return w3 || (w3 = 1, function(e) {
    var t = e;
    t.base = $c(), t.short = EA(), t.mont = DA(), t.edwards = jA();
  }(zu)), zu;
}
var Ru = {}, Pu = {}, yr = {}, C3;
function ui() {
  if (C3) return yr;
  C3 = 1;
  var e = Zn(), t = Yt;
  yr.inherits = t;
  function o(r, s) {
    return (r.charCodeAt(s) & 64512) !== 55296 || s < 0 || s + 1 >= r.length ? !1 : (r.charCodeAt(s + 1) & 64512) === 56320;
  }
  function i(r, s) {
    if (Array.isArray(r))
      return r.slice();
    if (!r)
      return [];
    var u = [];
    if (typeof r == "string")
      if (s) {
        if (s === "hex")
          for (r = r.replace(/[^a-z0-9]+/ig, ""), r.length % 2 !== 0 && (r = "0" + r), v = 0; v < r.length; v += 2)
            u.push(parseInt(r[v] + r[v + 1], 16));
      } else for (var g = 0, v = 0; v < r.length; v++) {
        var A = r.charCodeAt(v);
        A < 128 ? u[g++] = A : A < 2048 ? (u[g++] = A >> 6 | 192, u[g++] = A & 63 | 128) : o(r, v) ? (A = 65536 + ((A & 1023) << 10) + (r.charCodeAt(++v) & 1023), u[g++] = A >> 18 | 240, u[g++] = A >> 12 & 63 | 128, u[g++] = A >> 6 & 63 | 128, u[g++] = A & 63 | 128) : (u[g++] = A >> 12 | 224, u[g++] = A >> 6 & 63 | 128, u[g++] = A & 63 | 128);
      }
    else
      for (v = 0; v < r.length; v++)
        u[v] = r[v] | 0;
    return u;
  }
  yr.toArray = i;
  function c(r) {
    for (var s = "", u = 0; u < r.length; u++)
      s += f(r[u].toString(16));
    return s;
  }
  yr.toHex = c;
  function n(r) {
    var s = r >>> 24 | r >>> 8 & 65280 | r << 8 & 16711680 | (r & 255) << 24;
    return s >>> 0;
  }
  yr.htonl = n;
  function d(r, s) {
    for (var u = "", g = 0; g < r.length; g++) {
      var v = r[g];
      s === "little" && (v = n(v)), u += p(v.toString(16));
    }
    return u;
  }
  yr.toHex32 = d;
  function f(r) {
    return r.length === 1 ? "0" + r : r;
  }
  yr.zero2 = f;
  function p(r) {
    return r.length === 7 ? "0" + r : r.length === 6 ? "00" + r : r.length === 5 ? "000" + r : r.length === 4 ? "0000" + r : r.length === 3 ? "00000" + r : r.length === 2 ? "000000" + r : r.length === 1 ? "0000000" + r : r;
  }
  yr.zero8 = p;
  function l(r, s, u, g) {
    var v = u - s;
    e(v % 4 === 0);
    for (var A = new Array(v / 4), L = 0, m = s; L < A.length; L++, m += 4) {
      var a;
      g === "big" ? a = r[m] << 24 | r[m + 1] << 16 | r[m + 2] << 8 | r[m + 3] : a = r[m + 3] << 24 | r[m + 2] << 16 | r[m + 1] << 8 | r[m], A[L] = a >>> 0;
    }
    return A;
  }
  yr.join32 = l;
  function h(r, s) {
    for (var u = new Array(r.length * 4), g = 0, v = 0; g < r.length; g++, v += 4) {
      var A = r[g];
      s === "big" ? (u[v] = A >>> 24, u[v + 1] = A >>> 16 & 255, u[v + 2] = A >>> 8 & 255, u[v + 3] = A & 255) : (u[v + 3] = A >>> 24, u[v + 2] = A >>> 16 & 255, u[v + 1] = A >>> 8 & 255, u[v] = A & 255);
    }
    return u;
  }
  yr.split32 = h;
  function y(r, s) {
    return r >>> s | r << 32 - s;
  }
  yr.rotr32 = y;
  function M(r, s) {
    return r << s | r >>> 32 - s;
  }
  yr.rotl32 = M;
  function C(r, s) {
    return r + s >>> 0;
  }
  yr.sum32 = C;
  function N(r, s, u) {
    return r + s + u >>> 0;
  }
  yr.sum32_3 = N;
  function w(r, s, u, g) {
    return r + s + u + g >>> 0;
  }
  yr.sum32_4 = w;
  function S(r, s, u, g, v) {
    return r + s + u + g + v >>> 0;
  }
  yr.sum32_5 = S;
  function T(r, s, u, g) {
    var v = r[s], A = r[s + 1], L = g + A >>> 0, m = (L < g ? 1 : 0) + u + v;
    r[s] = m >>> 0, r[s + 1] = L;
  }
  yr.sum64 = T;
  function E(r, s, u, g) {
    var v = s + g >>> 0, A = (v < s ? 1 : 0) + r + u;
    return A >>> 0;
  }
  yr.sum64_hi = E;
  function j(r, s, u, g) {
    var v = s + g;
    return v >>> 0;
  }
  yr.sum64_lo = j;
  function O(r, s, u, g, v, A, L, m) {
    var a = 0, x = s;
    x = x + g >>> 0, a += x < s ? 1 : 0, x = x + A >>> 0, a += x < A ? 1 : 0, x = x + m >>> 0, a += x < m ? 1 : 0;
    var V = r + u + v + L + a;
    return V >>> 0;
  }
  yr.sum64_4_hi = O;
  function z(r, s, u, g, v, A, L, m) {
    var a = s + g + A + m;
    return a >>> 0;
  }
  yr.sum64_4_lo = z;
  function k(r, s, u, g, v, A, L, m, a, x) {
    var V = 0, G = s;
    G = G + g >>> 0, V += G < s ? 1 : 0, G = G + A >>> 0, V += G < A ? 1 : 0, G = G + m >>> 0, V += G < m ? 1 : 0, G = G + x >>> 0, V += G < x ? 1 : 0;
    var Z = r + u + v + L + a + V;
    return Z >>> 0;
  }
  yr.sum64_5_hi = k;
  function H(r, s, u, g, v, A, L, m, a, x) {
    var V = s + g + A + m + x;
    return V >>> 0;
  }
  yr.sum64_5_lo = H;
  function W(r, s, u) {
    var g = s << 32 - u | r >>> u;
    return g >>> 0;
  }
  yr.rotr64_hi = W;
  function U(r, s, u) {
    var g = r << 32 - u | s >>> u;
    return g >>> 0;
  }
  yr.rotr64_lo = U;
  function B(r, s, u) {
    return r >>> u;
  }
  yr.shr64_hi = B;
  function I(r, s, u) {
    var g = r << 32 - u | s >>> u;
    return g >>> 0;
  }
  return yr.shr64_lo = I, yr;
}
var Uu = {}, I3;
function Ps() {
  if (I3) return Uu;
  I3 = 1;
  var e = ui(), t = Zn();
  function o() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
  }
  return Uu.BlockHash = o, o.prototype.update = function(c, n) {
    if (c = e.toArray(c, n), this.pending ? this.pending = this.pending.concat(c) : this.pending = c, this.pendingTotal += c.length, this.pending.length >= this._delta8) {
      c = this.pending;
      var d = c.length % this._delta8;
      this.pending = c.slice(c.length - d, c.length), this.pending.length === 0 && (this.pending = null), c = e.join32(c, 0, c.length - d, this.endian);
      for (var f = 0; f < c.length; f += this._delta32)
        this._update(c, f, f + this._delta32);
    }
    return this;
  }, o.prototype.digest = function(c) {
    return this.update(this._pad()), t(this.pending === null), this._digest(c);
  }, o.prototype._pad = function() {
    var c = this.pendingTotal, n = this._delta8, d = n - (c + this.padLength) % n, f = new Array(d + this.padLength);
    f[0] = 128;
    for (var p = 1; p < d; p++)
      f[p] = 0;
    if (c <<= 3, this.endian === "big") {
      for (var l = 8; l < this.padLength; l++)
        f[p++] = 0;
      f[p++] = 0, f[p++] = 0, f[p++] = 0, f[p++] = 0, f[p++] = c >>> 24 & 255, f[p++] = c >>> 16 & 255, f[p++] = c >>> 8 & 255, f[p++] = c & 255;
    } else
      for (f[p++] = c & 255, f[p++] = c >>> 8 & 255, f[p++] = c >>> 16 & 255, f[p++] = c >>> 24 & 255, f[p++] = 0, f[p++] = 0, f[p++] = 0, f[p++] = 0, l = 8; l < this.padLength; l++)
        f[p++] = 0;
    return f;
  }, Uu;
}
var eo = {}, Xn = {}, N3;
function IM() {
  if (N3) return Xn;
  N3 = 1;
  var e = ui(), t = e.rotr32;
  function o(h, y, M, C) {
    if (h === 0)
      return i(y, M, C);
    if (h === 1 || h === 3)
      return n(y, M, C);
    if (h === 2)
      return c(y, M, C);
  }
  Xn.ft_1 = o;
  function i(h, y, M) {
    return h & y ^ ~h & M;
  }
  Xn.ch32 = i;
  function c(h, y, M) {
    return h & y ^ h & M ^ y & M;
  }
  Xn.maj32 = c;
  function n(h, y, M) {
    return h ^ y ^ M;
  }
  Xn.p32 = n;
  function d(h) {
    return t(h, 2) ^ t(h, 13) ^ t(h, 22);
  }
  Xn.s0_256 = d;
  function f(h) {
    return t(h, 6) ^ t(h, 11) ^ t(h, 25);
  }
  Xn.s1_256 = f;
  function p(h) {
    return t(h, 7) ^ t(h, 18) ^ h >>> 3;
  }
  Xn.g0_256 = p;
  function l(h) {
    return t(h, 17) ^ t(h, 19) ^ h >>> 10;
  }
  return Xn.g1_256 = l, Xn;
}
var Yu, A3;
function OA() {
  if (A3) return Yu;
  A3 = 1;
  var e = ui(), t = Ps(), o = IM(), i = e.rotl32, c = e.sum32, n = e.sum32_5, d = o.ft_1, f = t.BlockHash, p = [
    1518500249,
    1859775393,
    2400959708,
    3395469782
  ];
  function l() {
    if (!(this instanceof l))
      return new l();
    f.call(this), this.h = [
      1732584193,
      4023233417,
      2562383102,
      271733878,
      3285377520
    ], this.W = new Array(80);
  }
  return e.inherits(l, f), Yu = l, l.blockSize = 512, l.outSize = 160, l.hmacStrength = 80, l.padLength = 64, l.prototype._update = function(y, M) {
    for (var C = this.W, N = 0; N < 16; N++)
      C[N] = y[M + N];
    for (; N < C.length; N++)
      C[N] = i(C[N - 3] ^ C[N - 8] ^ C[N - 14] ^ C[N - 16], 1);
    var w = this.h[0], S = this.h[1], T = this.h[2], E = this.h[3], j = this.h[4];
    for (N = 0; N < C.length; N++) {
      var O = ~~(N / 20), z = n(i(w, 5), d(O, S, T, E), j, C[N], p[O]);
      j = E, E = T, T = i(S, 30), S = w, w = z;
    }
    this.h[0] = c(this.h[0], w), this.h[1] = c(this.h[1], S), this.h[2] = c(this.h[2], T), this.h[3] = c(this.h[3], E), this.h[4] = c(this.h[4], j);
  }, l.prototype._digest = function(y) {
    return y === "hex" ? e.toHex32(this.h, "big") : e.split32(this.h, "big");
  }, Yu;
}
var Wu, T3;
function NM() {
  if (T3) return Wu;
  T3 = 1;
  var e = ui(), t = Ps(), o = IM(), i = Zn(), c = e.sum32, n = e.sum32_4, d = e.sum32_5, f = o.ch32, p = o.maj32, l = o.s0_256, h = o.s1_256, y = o.g0_256, M = o.g1_256, C = t.BlockHash, N = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ];
  function w() {
    if (!(this instanceof w))
      return new w();
    C.call(this), this.h = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ], this.k = N, this.W = new Array(64);
  }
  return e.inherits(w, C), Wu = w, w.blockSize = 512, w.outSize = 256, w.hmacStrength = 192, w.padLength = 64, w.prototype._update = function(T, E) {
    for (var j = this.W, O = 0; O < 16; O++)
      j[O] = T[E + O];
    for (; O < j.length; O++)
      j[O] = n(M(j[O - 2]), j[O - 7], y(j[O - 15]), j[O - 16]);
    var z = this.h[0], k = this.h[1], H = this.h[2], W = this.h[3], U = this.h[4], B = this.h[5], I = this.h[6], r = this.h[7];
    for (i(this.k.length === j.length), O = 0; O < j.length; O++) {
      var s = d(r, h(U), f(U, B, I), this.k[O], j[O]), u = c(l(z), p(z, k, H));
      r = I, I = B, B = U, U = c(W, s), W = H, H = k, k = z, z = c(s, u);
    }
    this.h[0] = c(this.h[0], z), this.h[1] = c(this.h[1], k), this.h[2] = c(this.h[2], H), this.h[3] = c(this.h[3], W), this.h[4] = c(this.h[4], U), this.h[5] = c(this.h[5], B), this.h[6] = c(this.h[6], I), this.h[7] = c(this.h[7], r);
  }, w.prototype._digest = function(T) {
    return T === "hex" ? e.toHex32(this.h, "big") : e.split32(this.h, "big");
  }, Wu;
}
var Hu, L3;
function zA() {
  if (L3) return Hu;
  L3 = 1;
  var e = ui(), t = NM();
  function o() {
    if (!(this instanceof o))
      return new o();
    t.call(this), this.h = [
      3238371032,
      914150663,
      812702999,
      4144912697,
      4290775857,
      1750603025,
      1694076839,
      3204075428
    ];
  }
  return e.inherits(o, t), Hu = o, o.blockSize = 512, o.outSize = 224, o.hmacStrength = 192, o.padLength = 64, o.prototype._digest = function(c) {
    return c === "hex" ? e.toHex32(this.h.slice(0, 7), "big") : e.split32(this.h.slice(0, 7), "big");
  }, Hu;
}
var Zu, S3;
function AM() {
  if (S3) return Zu;
  S3 = 1;
  var e = ui(), t = Ps(), o = Zn(), i = e.rotr64_hi, c = e.rotr64_lo, n = e.shr64_hi, d = e.shr64_lo, f = e.sum64, p = e.sum64_hi, l = e.sum64_lo, h = e.sum64_4_hi, y = e.sum64_4_lo, M = e.sum64_5_hi, C = e.sum64_5_lo, N = t.BlockHash, w = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ];
  function S() {
    if (!(this instanceof S))
      return new S();
    N.call(this), this.h = [
      1779033703,
      4089235720,
      3144134277,
      2227873595,
      1013904242,
      4271175723,
      2773480762,
      1595750129,
      1359893119,
      2917565137,
      2600822924,
      725511199,
      528734635,
      4215389547,
      1541459225,
      327033209
    ], this.k = w, this.W = new Array(160);
  }
  e.inherits(S, N), Zu = S, S.blockSize = 1024, S.outSize = 512, S.hmacStrength = 192, S.padLength = 128, S.prototype._prepareBlock = function(u, g) {
    for (var v = this.W, A = 0; A < 32; A++)
      v[A] = u[g + A];
    for (; A < v.length; A += 2) {
      var L = I(v[A - 4], v[A - 3]), m = r(v[A - 4], v[A - 3]), a = v[A - 14], x = v[A - 13], V = U(v[A - 30], v[A - 29]), G = B(v[A - 30], v[A - 29]), Z = v[A - 32], te = v[A - 31];
      v[A] = h(
        L,
        m,
        a,
        x,
        V,
        G,
        Z,
        te
      ), v[A + 1] = y(
        L,
        m,
        a,
        x,
        V,
        G,
        Z,
        te
      );
    }
  }, S.prototype._update = function(u, g) {
    this._prepareBlock(u, g);
    var v = this.W, A = this.h[0], L = this.h[1], m = this.h[2], a = this.h[3], x = this.h[4], V = this.h[5], G = this.h[6], Z = this.h[7], te = this.h[8], q = this.h[9], R = this.h[10], Q = this.h[11], $ = this.h[12], F = this.h[13], P = this.h[14], _ = this.h[15];
    o(this.k.length === v.length);
    for (var X = 0; X < v.length; X += 2) {
      var le = P, ie = _, oe = H(te, q), pe = W(te, q), se = T(te, q, R, Q, $), ce = E(te, q, R, Q, $, F), me = this.k[X], de = this.k[X + 1], ae = v[X], Le = v[X + 1], ye = M(
        le,
        ie,
        oe,
        pe,
        se,
        ce,
        me,
        de,
        ae,
        Le
      ), Me = C(
        le,
        ie,
        oe,
        pe,
        se,
        ce,
        me,
        de,
        ae,
        Le
      );
      le = z(A, L), ie = k(A, L), oe = j(A, L, m, a, x), pe = O(A, L, m, a, x, V);
      var at = p(le, ie, oe, pe), Ne = l(le, ie, oe, pe);
      P = $, _ = F, $ = R, F = Q, R = te, Q = q, te = p(G, Z, ye, Me), q = l(Z, Z, ye, Me), G = x, Z = V, x = m, V = a, m = A, a = L, A = p(ye, Me, at, Ne), L = l(ye, Me, at, Ne);
    }
    f(this.h, 0, A, L), f(this.h, 2, m, a), f(this.h, 4, x, V), f(this.h, 6, G, Z), f(this.h, 8, te, q), f(this.h, 10, R, Q), f(this.h, 12, $, F), f(this.h, 14, P, _);
  }, S.prototype._digest = function(u) {
    return u === "hex" ? e.toHex32(this.h, "big") : e.split32(this.h, "big");
  };
  function T(s, u, g, v, A) {
    var L = s & g ^ ~s & A;
    return L < 0 && (L += 4294967296), L;
  }
  function E(s, u, g, v, A, L) {
    var m = u & v ^ ~u & L;
    return m < 0 && (m += 4294967296), m;
  }
  function j(s, u, g, v, A) {
    var L = s & g ^ s & A ^ g & A;
    return L < 0 && (L += 4294967296), L;
  }
  function O(s, u, g, v, A, L) {
    var m = u & v ^ u & L ^ v & L;
    return m < 0 && (m += 4294967296), m;
  }
  function z(s, u) {
    var g = i(s, u, 28), v = i(u, s, 2), A = i(u, s, 7), L = g ^ v ^ A;
    return L < 0 && (L += 4294967296), L;
  }
  function k(s, u) {
    var g = c(s, u, 28), v = c(u, s, 2), A = c(u, s, 7), L = g ^ v ^ A;
    return L < 0 && (L += 4294967296), L;
  }
  function H(s, u) {
    var g = i(s, u, 14), v = i(s, u, 18), A = i(u, s, 9), L = g ^ v ^ A;
    return L < 0 && (L += 4294967296), L;
  }
  function W(s, u) {
    var g = c(s, u, 14), v = c(s, u, 18), A = c(u, s, 9), L = g ^ v ^ A;
    return L < 0 && (L += 4294967296), L;
  }
  function U(s, u) {
    var g = i(s, u, 1), v = i(s, u, 8), A = n(s, u, 7), L = g ^ v ^ A;
    return L < 0 && (L += 4294967296), L;
  }
  function B(s, u) {
    var g = c(s, u, 1), v = c(s, u, 8), A = d(s, u, 7), L = g ^ v ^ A;
    return L < 0 && (L += 4294967296), L;
  }
  function I(s, u) {
    var g = i(s, u, 19), v = i(u, s, 29), A = n(s, u, 6), L = g ^ v ^ A;
    return L < 0 && (L += 4294967296), L;
  }
  function r(s, u) {
    var g = c(s, u, 19), v = c(u, s, 29), A = d(s, u, 6), L = g ^ v ^ A;
    return L < 0 && (L += 4294967296), L;
  }
  return Zu;
}
var Qu, E3;
function kA() {
  if (E3) return Qu;
  E3 = 1;
  var e = ui(), t = AM();
  function o() {
    if (!(this instanceof o))
      return new o();
    t.call(this), this.h = [
      3418070365,
      3238371032,
      1654270250,
      914150663,
      2438529370,
      812702999,
      355462360,
      4144912697,
      1731405415,
      4290775857,
      2394180231,
      1750603025,
      3675008525,
      1694076839,
      1203062813,
      3204075428
    ];
  }
  return e.inherits(o, t), Qu = o, o.blockSize = 1024, o.outSize = 384, o.hmacStrength = 192, o.padLength = 128, o.prototype._digest = function(c) {
    return c === "hex" ? e.toHex32(this.h.slice(0, 12), "big") : e.split32(this.h.slice(0, 12), "big");
  }, Qu;
}
var D3;
function _A() {
  return D3 || (D3 = 1, eo.sha1 = OA(), eo.sha224 = zA(), eo.sha256 = NM(), eo.sha384 = kA(), eo.sha512 = AM()), eo;
}
var Vu = {}, j3;
function BA() {
  if (j3) return Vu;
  j3 = 1;
  var e = ui(), t = Ps(), o = e.rotl32, i = e.sum32, c = e.sum32_3, n = e.sum32_4, d = t.BlockHash;
  function f() {
    if (!(this instanceof f))
      return new f();
    d.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
  }
  e.inherits(f, d), Vu.ripemd160 = f, f.blockSize = 512, f.outSize = 160, f.hmacStrength = 192, f.padLength = 64, f.prototype._update = function(S, T) {
    for (var E = this.h[0], j = this.h[1], O = this.h[2], z = this.h[3], k = this.h[4], H = E, W = j, U = O, B = z, I = k, r = 0; r < 80; r++) {
      var s = i(
        o(
          n(E, p(r, j, O, z), S[y[r] + T], l(r)),
          C[r]
        ),
        k
      );
      E = k, k = z, z = o(O, 10), O = j, j = s, s = i(
        o(
          n(H, p(79 - r, W, U, B), S[M[r] + T], h(r)),
          N[r]
        ),
        I
      ), H = I, I = B, B = o(U, 10), U = W, W = s;
    }
    s = c(this.h[1], O, B), this.h[1] = c(this.h[2], z, I), this.h[2] = c(this.h[3], k, H), this.h[3] = c(this.h[4], E, W), this.h[4] = c(this.h[0], j, U), this.h[0] = s;
  }, f.prototype._digest = function(S) {
    return S === "hex" ? e.toHex32(this.h, "little") : e.split32(this.h, "little");
  };
  function p(w, S, T, E) {
    return w <= 15 ? S ^ T ^ E : w <= 31 ? S & T | ~S & E : w <= 47 ? (S | ~T) ^ E : w <= 63 ? S & E | T & ~E : S ^ (T | ~E);
  }
  function l(w) {
    return w <= 15 ? 0 : w <= 31 ? 1518500249 : w <= 47 ? 1859775393 : w <= 63 ? 2400959708 : 2840853838;
  }
  function h(w) {
    return w <= 15 ? 1352829926 : w <= 31 ? 1548603684 : w <= 47 ? 1836072691 : w <= 63 ? 2053994217 : 0;
  }
  var y = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], M = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], C = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], N = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ];
  return Vu;
}
var Gu, O3;
function FA() {
  if (O3) return Gu;
  O3 = 1;
  var e = ui(), t = Zn();
  function o(i, c, n) {
    if (!(this instanceof o))
      return new o(i, c, n);
    this.Hash = i, this.blockSize = i.blockSize / 8, this.outSize = i.outSize / 8, this.inner = null, this.outer = null, this._init(e.toArray(c, n));
  }
  return Gu = o, o.prototype._init = function(c) {
    c.length > this.blockSize && (c = new this.Hash().update(c).digest()), t(c.length <= this.blockSize);
    for (var n = c.length; n < this.blockSize; n++)
      c.push(0);
    for (n = 0; n < c.length; n++)
      c[n] ^= 54;
    for (this.inner = new this.Hash().update(c), n = 0; n < c.length; n++)
      c[n] ^= 106;
    this.outer = new this.Hash().update(c);
  }, o.prototype.update = function(c, n) {
    return this.inner.update(c, n), this;
  }, o.prototype.digest = function(c) {
    return this.outer.update(this.inner.digest()), this.outer.digest(c);
  }, Gu;
}
var z3;
function wh() {
  return z3 || (z3 = 1, function(e) {
    var t = e;
    t.utils = ui(), t.common = Ps(), t.sha = _A(), t.ripemd = BA(), t.hmac = FA(), t.sha1 = t.sha.sha1, t.sha256 = t.sha.sha256, t.sha224 = t.sha.sha224, t.sha384 = t.sha.sha384, t.sha512 = t.sha.sha512, t.ripemd160 = t.ripemd.ripemd160;
  }(Pu)), Pu;
}
var $u, k3;
function RA() {
  return k3 || (k3 = 1, $u = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), $u;
}
var _3;
function Ch() {
  return _3 || (_3 = 1, function(e) {
    var t = e, o = wh(), i = CM(), c = Qn(), n = c.assert;
    function d(l) {
      l.type === "short" ? this.curve = new i.short(l) : l.type === "edwards" ? this.curve = new i.edwards(l) : this.curve = new i.mont(l), this.g = this.curve.g, this.n = this.curve.n, this.hash = l.hash, n(this.g.validate(), "Invalid curve"), n(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    t.PresetCurve = d;
    function f(l, h) {
      Object.defineProperty(t, l, {
        configurable: !0,
        enumerable: !0,
        get: function() {
          var y = new d(h);
          return Object.defineProperty(t, l, {
            configurable: !0,
            enumerable: !0,
            value: y
          }), y;
        }
      });
    }
    f("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: o.sha256,
      gRed: !1,
      g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
      ]
    }), f("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: o.sha256,
      gRed: !1,
      g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
      ]
    }), f("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: o.sha256,
      gRed: !1,
      g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
      ]
    }), f("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: o.sha384,
      gRed: !1,
      g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
      ]
    }), f("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: o.sha512,
      gRed: !1,
      g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
      ]
    }), f("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: o.sha256,
      gRed: !1,
      g: [
        "9"
      ]
    }), f("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      // -121665 * (121666^(-1)) (mod P)
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: o.sha256,
      gRed: !1,
      g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
      ]
    });
    var p;
    try {
      p = RA();
    } catch {
      p = void 0;
    }
    f("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: o.sha256,
      // Precomputed endomorphism
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [
        {
          a: "3086d221a7d46bcde86c90e49284eb15",
          b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
          a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
          b: "3086d221a7d46bcde86c90e49284eb15"
        }
      ],
      gRed: !1,
      g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        p
      ]
    });
  }(Ru)), Ru;
}
var qu, B3;
function PA() {
  if (B3) return qu;
  B3 = 1;
  var e = wh(), t = wM(), o = Zn();
  function i(c) {
    if (!(this instanceof i))
      return new i(c);
    this.hash = c.hash, this.predResist = !!c.predResist, this.outLen = this.hash.outSize, this.minEntropy = c.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var n = t.toArray(c.entropy, c.entropyEnc || "hex"), d = t.toArray(c.nonce, c.nonceEnc || "hex"), f = t.toArray(c.pers, c.persEnc || "hex");
    o(
      n.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._init(n, d, f);
  }
  return qu = i, i.prototype._init = function(n, d, f) {
    var p = n.concat(d).concat(f);
    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
    for (var l = 0; l < this.V.length; l++)
      this.K[l] = 0, this.V[l] = 1;
    this._update(p), this._reseed = 1, this.reseedInterval = 281474976710656;
  }, i.prototype._hmac = function() {
    return new e.hmac(this.hash, this.K);
  }, i.prototype._update = function(n) {
    var d = this._hmac().update(this.V).update([0]);
    n && (d = d.update(n)), this.K = d.digest(), this.V = this._hmac().update(this.V).digest(), n && (this.K = this._hmac().update(this.V).update([1]).update(n).digest(), this.V = this._hmac().update(this.V).digest());
  }, i.prototype.reseed = function(n, d, f, p) {
    typeof d != "string" && (p = f, f = d, d = null), n = t.toArray(n, d), f = t.toArray(f, p), o(
      n.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._update(n.concat(f || [])), this._reseed = 1;
  }, i.prototype.generate = function(n, d, f, p) {
    if (this._reseed > this.reseedInterval)
      throw new Error("Reseed is required");
    typeof d != "string" && (p = f, f = d, d = null), f && (f = t.toArray(f, p || "hex"), this._update(f));
    for (var l = []; l.length < n; )
      this.V = this._hmac().update(this.V).digest(), l = l.concat(this.V);
    var h = l.slice(0, n);
    return this._update(f), this._reseed++, t.encode(h, d);
  }, qu;
}
var Ju, F3;
function UA() {
  if (F3) return Ju;
  F3 = 1;
  var e = Ni(), t = Qn(), o = t.assert;
  function i(c, n) {
    this.ec = c, this.priv = null, this.pub = null, n.priv && this._importPrivate(n.priv, n.privEnc), n.pub && this._importPublic(n.pub, n.pubEnc);
  }
  return Ju = i, i.fromPublic = function(n, d, f) {
    return d instanceof i ? d : new i(n, {
      pub: d,
      pubEnc: f
    });
  }, i.fromPrivate = function(n, d, f) {
    return d instanceof i ? d : new i(n, {
      priv: d,
      privEnc: f
    });
  }, i.prototype.validate = function() {
    var n = this.getPublic();
    return n.isInfinity() ? { result: !1, reason: "Invalid public key" } : n.validate() ? n.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
  }, i.prototype.getPublic = function(n, d) {
    return typeof n == "string" && (d = n, n = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), d ? this.pub.encode(d, n) : this.pub;
  }, i.prototype.getPrivate = function(n) {
    return n === "hex" ? this.priv.toString(16, 2) : this.priv;
  }, i.prototype._importPrivate = function(n, d) {
    this.priv = new e(n, d || 16), this.priv = this.priv.umod(this.ec.curve.n);
  }, i.prototype._importPublic = function(n, d) {
    if (n.x || n.y) {
      this.ec.curve.type === "mont" ? o(n.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && o(n.x && n.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(n.x, n.y);
      return;
    }
    this.pub = this.ec.curve.decodePoint(n, d);
  }, i.prototype.derive = function(n) {
    return n.validate() || o(n.validate(), "public point not validated"), n.mul(this.priv).getX();
  }, i.prototype.sign = function(n, d, f) {
    return this.ec.sign(n, this, d, f);
  }, i.prototype.verify = function(n, d, f) {
    return this.ec.verify(n, d, this, void 0, f);
  }, i.prototype.inspect = function() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
  }, Ju;
}
var Xu, R3;
function YA() {
  if (R3) return Xu;
  R3 = 1;
  var e = Ni(), t = Qn(), o = t.assert;
  function i(p, l) {
    if (p instanceof i)
      return p;
    this._importDER(p, l) || (o(p.r && p.s, "Signature without r or s"), this.r = new e(p.r, 16), this.s = new e(p.s, 16), p.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = p.recoveryParam);
  }
  Xu = i;
  function c() {
    this.place = 0;
  }
  function n(p, l) {
    var h = p[l.place++];
    if (!(h & 128))
      return h;
    var y = h & 15;
    if (y === 0 || y > 4 || p[l.place] === 0)
      return !1;
    for (var M = 0, C = 0, N = l.place; C < y; C++, N++)
      M <<= 8, M |= p[N], M >>>= 0;
    return M <= 127 ? !1 : (l.place = N, M);
  }
  function d(p) {
    for (var l = 0, h = p.length - 1; !p[l] && !(p[l + 1] & 128) && l < h; )
      l++;
    return l === 0 ? p : p.slice(l);
  }
  i.prototype._importDER = function(l, h) {
    l = t.toArray(l, h);
    var y = new c();
    if (l[y.place++] !== 48)
      return !1;
    var M = n(l, y);
    if (M === !1 || M + y.place !== l.length || l[y.place++] !== 2)
      return !1;
    var C = n(l, y);
    if (C === !1 || l[y.place] & 128)
      return !1;
    var N = l.slice(y.place, C + y.place);
    if (y.place += C, l[y.place++] !== 2)
      return !1;
    var w = n(l, y);
    if (w === !1 || l.length !== w + y.place || l[y.place] & 128)
      return !1;
    var S = l.slice(y.place, w + y.place);
    if (N[0] === 0)
      if (N[1] & 128)
        N = N.slice(1);
      else
        return !1;
    if (S[0] === 0)
      if (S[1] & 128)
        S = S.slice(1);
      else
        return !1;
    return this.r = new e(N), this.s = new e(S), this.recoveryParam = null, !0;
  };
  function f(p, l) {
    if (l < 128) {
      p.push(l);
      return;
    }
    var h = 1 + (Math.log(l) / Math.LN2 >>> 3);
    for (p.push(h | 128); --h; )
      p.push(l >>> (h << 3) & 255);
    p.push(l);
  }
  return i.prototype.toDER = function(l) {
    var h = this.r.toArray(), y = this.s.toArray();
    for (h[0] & 128 && (h = [0].concat(h)), y[0] & 128 && (y = [0].concat(y)), h = d(h), y = d(y); !y[0] && !(y[1] & 128); )
      y = y.slice(1);
    var M = [2];
    f(M, h.length), M = M.concat(h), M.push(2), f(M, y.length);
    var C = M.concat(y), N = [48];
    return f(N, C.length), N = N.concat(C), t.encode(N, l);
  }, Xu;
}
var Ku, P3;
function WA() {
  if (P3) return Ku;
  P3 = 1;
  var e = Ni(), t = PA(), o = Qn(), i = Ch(), c = bh(), n = o.assert, d = UA(), f = YA();
  function p(l) {
    if (!(this instanceof p))
      return new p(l);
    typeof l == "string" && (n(
      Object.prototype.hasOwnProperty.call(i, l),
      "Unknown curve " + l
    ), l = i[l]), l instanceof i.PresetCurve && (l = { curve: l }), this.curve = l.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = l.curve.g, this.g.precompute(l.curve.n.bitLength() + 1), this.hash = l.hash || l.curve.hash;
  }
  return Ku = p, p.prototype.keyPair = function(h) {
    return new d(this, h);
  }, p.prototype.keyFromPrivate = function(h, y) {
    return d.fromPrivate(this, h, y);
  }, p.prototype.keyFromPublic = function(h, y) {
    return d.fromPublic(this, h, y);
  }, p.prototype.genKeyPair = function(h) {
    h || (h = {});
    for (var y = new t({
      hash: this.hash,
      pers: h.pers,
      persEnc: h.persEnc || "utf8",
      entropy: h.entropy || c(this.hash.hmacStrength),
      entropyEnc: h.entropy && h.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), M = this.n.byteLength(), C = this.n.sub(new e(2)); ; ) {
      var N = new e(y.generate(M));
      if (!(N.cmp(C) > 0))
        return N.iaddn(1), this.keyFromPrivate(N);
    }
  }, p.prototype._truncateToN = function(h, y, M) {
    var C;
    if (e.isBN(h) || typeof h == "number")
      h = new e(h, 16), C = h.byteLength();
    else if (typeof h == "object")
      C = h.length, h = new e(h, 16);
    else {
      var N = h.toString();
      C = N.length + 1 >>> 1, h = new e(N, 16);
    }
    typeof M != "number" && (M = C * 8);
    var w = M - this.n.bitLength();
    return w > 0 && (h = h.ushrn(w)), !y && h.cmp(this.n) >= 0 ? h.sub(this.n) : h;
  }, p.prototype.sign = function(h, y, M, C) {
    if (typeof M == "object" && (C = M, M = null), C || (C = {}), typeof h != "string" && typeof h != "number" && !e.isBN(h)) {
      n(
        typeof h == "object" && h && typeof h.length == "number",
        "Expected message to be an array-like, a hex string, or a BN instance"
      ), n(h.length >>> 0 === h.length);
      for (var N = 0; N < h.length; N++) n((h[N] & 255) === h[N]);
    }
    y = this.keyFromPrivate(y, M), h = this._truncateToN(h, !1, C.msgBitLength), n(!h.isNeg(), "Can not sign a negative message");
    var w = this.n.byteLength(), S = y.getPrivate().toArray("be", w), T = h.toArray("be", w);
    n(new e(T).eq(h), "Can not sign message");
    for (var E = new t({
      hash: this.hash,
      entropy: S,
      nonce: T,
      pers: C.pers,
      persEnc: C.persEnc || "utf8"
    }), j = this.n.sub(new e(1)), O = 0; ; O++) {
      var z = C.k ? C.k(O) : new e(E.generate(this.n.byteLength()));
      if (z = this._truncateToN(z, !0), !(z.cmpn(1) <= 0 || z.cmp(j) >= 0)) {
        var k = this.g.mul(z);
        if (!k.isInfinity()) {
          var H = k.getX(), W = H.umod(this.n);
          if (W.cmpn(0) !== 0) {
            var U = z.invm(this.n).mul(W.mul(y.getPrivate()).iadd(h));
            if (U = U.umod(this.n), U.cmpn(0) !== 0) {
              var B = (k.getY().isOdd() ? 1 : 0) | (H.cmp(W) !== 0 ? 2 : 0);
              return C.canonical && U.cmp(this.nh) > 0 && (U = this.n.sub(U), B ^= 1), new f({ r: W, s: U, recoveryParam: B });
            }
          }
        }
      }
    }
  }, p.prototype.verify = function(h, y, M, C, N) {
    N || (N = {}), h = this._truncateToN(h, !1, N.msgBitLength), M = this.keyFromPublic(M, C), y = new f(y, "hex");
    var w = y.r, S = y.s;
    if (w.cmpn(1) < 0 || w.cmp(this.n) >= 0 || S.cmpn(1) < 0 || S.cmp(this.n) >= 0)
      return !1;
    var T = S.invm(this.n), E = T.mul(h).umod(this.n), j = T.mul(w).umod(this.n), O;
    return this.curve._maxwellTrick ? (O = this.g.jmulAdd(E, M.getPublic(), j), O.isInfinity() ? !1 : O.eqXToP(w)) : (O = this.g.mulAdd(E, M.getPublic(), j), O.isInfinity() ? !1 : O.getX().umod(this.n).cmp(w) === 0);
  }, p.prototype.recoverPubKey = function(l, h, y, M) {
    n((3 & y) === y, "The recovery param is more than two bits"), h = new f(h, M);
    var C = this.n, N = new e(l), w = h.r, S = h.s, T = y & 1, E = y >> 1;
    if (w.cmp(this.curve.p.umod(this.curve.n)) >= 0 && E)
      throw new Error("Unable to find sencond key candinate");
    E ? w = this.curve.pointFromX(w.add(this.curve.n), T) : w = this.curve.pointFromX(w, T);
    var j = h.r.invm(C), O = C.sub(N).mul(j).umod(C), z = S.mul(j).umod(C);
    return this.g.mulAdd(O, w, z);
  }, p.prototype.getKeyRecoveryParam = function(l, h, y, M) {
    if (h = new f(h, M), h.recoveryParam !== null)
      return h.recoveryParam;
    for (var C = 0; C < 4; C++) {
      var N;
      try {
        N = this.recoverPubKey(l, h, C);
      } catch {
        continue;
      }
      if (N.eq(y))
        return C;
    }
    throw new Error("Unable to find valid recovery factor");
  }, Ku;
}
var ed, U3;
function HA() {
  if (U3) return ed;
  U3 = 1;
  var e = Qn(), t = e.assert, o = e.parseBytes, i = e.cachedProperty;
  function c(n, d) {
    this.eddsa = n, this._secret = o(d.secret), n.isPoint(d.pub) ? this._pub = d.pub : this._pubBytes = o(d.pub);
  }
  return c.fromPublic = function(d, f) {
    return f instanceof c ? f : new c(d, { pub: f });
  }, c.fromSecret = function(d, f) {
    return f instanceof c ? f : new c(d, { secret: f });
  }, c.prototype.secret = function() {
    return this._secret;
  }, i(c, "pubBytes", function() {
    return this.eddsa.encodePoint(this.pub());
  }), i(c, "pub", function() {
    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
  }), i(c, "privBytes", function() {
    var d = this.eddsa, f = this.hash(), p = d.encodingLength - 1, l = f.slice(0, d.encodingLength);
    return l[0] &= 248, l[p] &= 127, l[p] |= 64, l;
  }), i(c, "priv", function() {
    return this.eddsa.decodeInt(this.privBytes());
  }), i(c, "hash", function() {
    return this.eddsa.hash().update(this.secret()).digest();
  }), i(c, "messagePrefix", function() {
    return this.hash().slice(this.eddsa.encodingLength);
  }), c.prototype.sign = function(d) {
    return t(this._secret, "KeyPair can only verify"), this.eddsa.sign(d, this);
  }, c.prototype.verify = function(d, f) {
    return this.eddsa.verify(d, f, this);
  }, c.prototype.getSecret = function(d) {
    return t(this._secret, "KeyPair is public only"), e.encode(this.secret(), d);
  }, c.prototype.getPublic = function(d) {
    return e.encode(this.pubBytes(), d);
  }, ed = c, ed;
}
var td, Y3;
function ZA() {
  if (Y3) return td;
  Y3 = 1;
  var e = Ni(), t = Qn(), o = t.assert, i = t.cachedProperty, c = t.parseBytes;
  function n(d, f) {
    this.eddsa = d, typeof f != "object" && (f = c(f)), Array.isArray(f) && (o(f.length === d.encodingLength * 2, "Signature has invalid size"), f = {
      R: f.slice(0, d.encodingLength),
      S: f.slice(d.encodingLength)
    }), o(f.R && f.S, "Signature without R or S"), d.isPoint(f.R) && (this._R = f.R), f.S instanceof e && (this._S = f.S), this._Rencoded = Array.isArray(f.R) ? f.R : f.Rencoded, this._Sencoded = Array.isArray(f.S) ? f.S : f.Sencoded;
  }
  return i(n, "S", function() {
    return this.eddsa.decodeInt(this.Sencoded());
  }), i(n, "R", function() {
    return this.eddsa.decodePoint(this.Rencoded());
  }), i(n, "Rencoded", function() {
    return this.eddsa.encodePoint(this.R());
  }), i(n, "Sencoded", function() {
    return this.eddsa.encodeInt(this.S());
  }), n.prototype.toBytes = function() {
    return this.Rencoded().concat(this.Sencoded());
  }, n.prototype.toHex = function() {
    return t.encode(this.toBytes(), "hex").toUpperCase();
  }, td = n, td;
}
var rd, W3;
function QA() {
  if (W3) return rd;
  W3 = 1;
  var e = wh(), t = Ch(), o = Qn(), i = o.assert, c = o.parseBytes, n = HA(), d = ZA();
  function f(p) {
    if (i(p === "ed25519", "only tested with ed25519 so far"), !(this instanceof f))
      return new f(p);
    p = t[p].curve, this.curve = p, this.g = p.g, this.g.precompute(p.n.bitLength() + 1), this.pointClass = p.point().constructor, this.encodingLength = Math.ceil(p.n.bitLength() / 8), this.hash = e.sha512;
  }
  return rd = f, f.prototype.sign = function(l, h) {
    l = c(l);
    var y = this.keyFromSecret(h), M = this.hashInt(y.messagePrefix(), l), C = this.g.mul(M), N = this.encodePoint(C), w = this.hashInt(N, y.pubBytes(), l).mul(y.priv()), S = M.add(w).umod(this.curve.n);
    return this.makeSignature({ R: C, S, Rencoded: N });
  }, f.prototype.verify = function(l, h, y) {
    if (l = c(l), h = this.makeSignature(h), h.S().gte(h.eddsa.curve.n) || h.S().isNeg())
      return !1;
    var M = this.keyFromPublic(y), C = this.hashInt(h.Rencoded(), M.pubBytes(), l), N = this.g.mul(h.S()), w = h.R().add(M.pub().mul(C));
    return w.eq(N);
  }, f.prototype.hashInt = function() {
    for (var l = this.hash(), h = 0; h < arguments.length; h++)
      l.update(arguments[h]);
    return o.intFromLE(l.digest()).umod(this.curve.n);
  }, f.prototype.keyFromPublic = function(l) {
    return n.fromPublic(this, l);
  }, f.prototype.keyFromSecret = function(l) {
    return n.fromSecret(this, l);
  }, f.prototype.makeSignature = function(l) {
    return l instanceof d ? l : new d(this, l);
  }, f.prototype.encodePoint = function(l) {
    var h = l.getY().toArray("le", this.encodingLength);
    return h[this.encodingLength - 1] |= l.getX().isOdd() ? 128 : 0, h;
  }, f.prototype.decodePoint = function(l) {
    l = o.parseBytes(l);
    var h = l.length - 1, y = l.slice(0, h).concat(l[h] & -129), M = (l[h] & 128) !== 0, C = o.intFromLE(y);
    return this.curve.pointFromY(C, M);
  }, f.prototype.encodeInt = function(l) {
    return l.toArray("le", this.encodingLength);
  }, f.prototype.decodeInt = function(l) {
    return o.intFromLE(l);
  }, f.prototype.isPoint = function(l) {
    return l instanceof this.pointClass;
  }, rd;
}
var H3;
function Ih() {
  return H3 || (H3 = 1, function(e) {
    var t = e;
    t.version = SA.version, t.utils = Qn(), t.rand = bh(), t.curve = CM(), t.curves = Ch(), t.ec = WA(), t.eddsa = QA();
  }(Du)), Du;
}
var On = {}, nd = {}, Z0 = { exports: {} };
Z0.exports;
var Z3;
function VA() {
  return Z3 || (Z3 = 1, function(e) {
    (function(t, o) {
      function i(I, r) {
        if (!I) throw new Error(r || "Assertion failed");
      }
      function c(I, r) {
        I.super_ = r;
        var s = function() {
        };
        s.prototype = r.prototype, I.prototype = new s(), I.prototype.constructor = I;
      }
      function n(I, r, s) {
        if (n.isBN(I))
          return I;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, I !== null && ((r === "le" || r === "be") && (s = r, r = 10), this._init(I || 0, r || 10, s || "be"));
      }
      typeof t == "object" ? t.exports = n : o.BN = n, n.BN = n, n.wordSize = 26;
      var d;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? d = window.Buffer : d = Wr.Buffer;
      } catch {
      }
      n.isBN = function(r) {
        return r instanceof n ? !0 : r !== null && typeof r == "object" && r.constructor.wordSize === n.wordSize && Array.isArray(r.words);
      }, n.max = function(r, s) {
        return r.cmp(s) > 0 ? r : s;
      }, n.min = function(r, s) {
        return r.cmp(s) < 0 ? r : s;
      }, n.prototype._init = function(r, s, u) {
        if (typeof r == "number")
          return this._initNumber(r, s, u);
        if (typeof r == "object")
          return this._initArray(r, s, u);
        s === "hex" && (s = 16), i(s === (s | 0) && s >= 2 && s <= 36), r = r.toString().replace(/\s+/g, "");
        var g = 0;
        r[0] === "-" && (g++, this.negative = 1), g < r.length && (s === 16 ? this._parseHex(r, g, u) : (this._parseBase(r, s, g), u === "le" && this._initArray(this.toArray(), s, u)));
      }, n.prototype._initNumber = function(r, s, u) {
        r < 0 && (this.negative = 1, r = -r), r < 67108864 ? (this.words = [r & 67108863], this.length = 1) : r < 4503599627370496 ? (this.words = [
          r & 67108863,
          r / 67108864 & 67108863
        ], this.length = 2) : (i(r < 9007199254740992), this.words = [
          r & 67108863,
          r / 67108864 & 67108863,
          1
        ], this.length = 3), u === "le" && this._initArray(this.toArray(), s, u);
      }, n.prototype._initArray = function(r, s, u) {
        if (i(typeof r.length == "number"), r.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(r.length / 3), this.words = new Array(this.length);
        for (var g = 0; g < this.length; g++)
          this.words[g] = 0;
        var v, A, L = 0;
        if (u === "be")
          for (g = r.length - 1, v = 0; g >= 0; g -= 3)
            A = r[g] | r[g - 1] << 8 | r[g - 2] << 16, this.words[v] |= A << L & 67108863, this.words[v + 1] = A >>> 26 - L & 67108863, L += 24, L >= 26 && (L -= 26, v++);
        else if (u === "le")
          for (g = 0, v = 0; g < r.length; g += 3)
            A = r[g] | r[g + 1] << 8 | r[g + 2] << 16, this.words[v] |= A << L & 67108863, this.words[v + 1] = A >>> 26 - L & 67108863, L += 24, L >= 26 && (L -= 26, v++);
        return this.strip();
      };
      function f(I, r) {
        var s = I.charCodeAt(r);
        return s >= 65 && s <= 70 ? s - 55 : s >= 97 && s <= 102 ? s - 87 : s - 48 & 15;
      }
      function p(I, r, s) {
        var u = f(I, s);
        return s - 1 >= r && (u |= f(I, s - 1) << 4), u;
      }
      n.prototype._parseHex = function(r, s, u) {
        this.length = Math.ceil((r.length - s) / 6), this.words = new Array(this.length);
        for (var g = 0; g < this.length; g++)
          this.words[g] = 0;
        var v = 0, A = 0, L;
        if (u === "be")
          for (g = r.length - 1; g >= s; g -= 2)
            L = p(r, s, g) << v, this.words[A] |= L & 67108863, v >= 18 ? (v -= 18, A += 1, this.words[A] |= L >>> 26) : v += 8;
        else {
          var m = r.length - s;
          for (g = m % 2 === 0 ? s + 1 : s; g < r.length; g += 2)
            L = p(r, s, g) << v, this.words[A] |= L & 67108863, v >= 18 ? (v -= 18, A += 1, this.words[A] |= L >>> 26) : v += 8;
        }
        this.strip();
      };
      function l(I, r, s, u) {
        for (var g = 0, v = Math.min(I.length, s), A = r; A < v; A++) {
          var L = I.charCodeAt(A) - 48;
          g *= u, L >= 49 ? g += L - 49 + 10 : L >= 17 ? g += L - 17 + 10 : g += L;
        }
        return g;
      }
      n.prototype._parseBase = function(r, s, u) {
        this.words = [0], this.length = 1;
        for (var g = 0, v = 1; v <= 67108863; v *= s)
          g++;
        g--, v = v / s | 0;
        for (var A = r.length - u, L = A % g, m = Math.min(A, A - L) + u, a = 0, x = u; x < m; x += g)
          a = l(r, x, x + g, s), this.imuln(v), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        if (L !== 0) {
          var V = 1;
          for (a = l(r, x, r.length, s), x = 0; x < L; x++)
            V *= s;
          this.imuln(V), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        }
        this.strip();
      }, n.prototype.copy = function(r) {
        r.words = new Array(this.length);
        for (var s = 0; s < this.length; s++)
          r.words[s] = this.words[s];
        r.length = this.length, r.negative = this.negative, r.red = this.red;
      }, n.prototype.clone = function() {
        var r = new n(null);
        return this.copy(r), r;
      }, n.prototype._expand = function(r) {
        for (; this.length < r; )
          this.words[this.length++] = 0;
        return this;
      }, n.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, n.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, n.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var h = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], y = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], M = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      n.prototype.toString = function(r, s) {
        r = r || 10, s = s | 0 || 1;
        var u;
        if (r === 16 || r === "hex") {
          u = "";
          for (var g = 0, v = 0, A = 0; A < this.length; A++) {
            var L = this.words[A], m = ((L << g | v) & 16777215).toString(16);
            v = L >>> 24 - g & 16777215, g += 2, g >= 26 && (g -= 26, A--), v !== 0 || A !== this.length - 1 ? u = h[6 - m.length] + m + u : u = m + u;
          }
          for (v !== 0 && (u = v.toString(16) + u); u.length % s !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        if (r === (r | 0) && r >= 2 && r <= 36) {
          var a = y[r], x = M[r];
          u = "";
          var V = this.clone();
          for (V.negative = 0; !V.isZero(); ) {
            var G = V.modn(x).toString(r);
            V = V.idivn(x), V.isZero() ? u = G + u : u = h[a - G.length] + G + u;
          }
          for (this.isZero() && (u = "0" + u); u.length % s !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        i(!1, "Base should be between 2 and 36");
      }, n.prototype.toNumber = function() {
        var r = this.words[0];
        return this.length === 2 ? r += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? r += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -r : r;
      }, n.prototype.toJSON = function() {
        return this.toString(16);
      }, n.prototype.toBuffer = function(r, s) {
        return i(typeof d < "u"), this.toArrayLike(d, r, s);
      }, n.prototype.toArray = function(r, s) {
        return this.toArrayLike(Array, r, s);
      }, n.prototype.toArrayLike = function(r, s, u) {
        var g = this.byteLength(), v = u || Math.max(1, g);
        i(g <= v, "byte array longer than desired length"), i(v > 0, "Requested array length <= 0"), this.strip();
        var A = s === "le", L = new r(v), m, a, x = this.clone();
        if (A) {
          for (a = 0; !x.isZero(); a++)
            m = x.andln(255), x.iushrn(8), L[a] = m;
          for (; a < v; a++)
            L[a] = 0;
        } else {
          for (a = 0; a < v - g; a++)
            L[a] = 0;
          for (a = 0; !x.isZero(); a++)
            m = x.andln(255), x.iushrn(8), L[v - a - 1] = m;
        }
        return L;
      }, Math.clz32 ? n.prototype._countBits = function(r) {
        return 32 - Math.clz32(r);
      } : n.prototype._countBits = function(r) {
        var s = r, u = 0;
        return s >= 4096 && (u += 13, s >>>= 13), s >= 64 && (u += 7, s >>>= 7), s >= 8 && (u += 4, s >>>= 4), s >= 2 && (u += 2, s >>>= 2), u + s;
      }, n.prototype._zeroBits = function(r) {
        if (r === 0) return 26;
        var s = r, u = 0;
        return s & 8191 || (u += 13, s >>>= 13), s & 127 || (u += 7, s >>>= 7), s & 15 || (u += 4, s >>>= 4), s & 3 || (u += 2, s >>>= 2), s & 1 || u++, u;
      }, n.prototype.bitLength = function() {
        var r = this.words[this.length - 1], s = this._countBits(r);
        return (this.length - 1) * 26 + s;
      };
      function C(I) {
        for (var r = new Array(I.bitLength()), s = 0; s < r.length; s++) {
          var u = s / 26 | 0, g = s % 26;
          r[s] = (I.words[u] & 1 << g) >>> g;
        }
        return r;
      }
      n.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var r = 0, s = 0; s < this.length; s++) {
          var u = this._zeroBits(this.words[s]);
          if (r += u, u !== 26) break;
        }
        return r;
      }, n.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, n.prototype.toTwos = function(r) {
        return this.negative !== 0 ? this.abs().inotn(r).iaddn(1) : this.clone();
      }, n.prototype.fromTwos = function(r) {
        return this.testn(r - 1) ? this.notn(r).iaddn(1).ineg() : this.clone();
      }, n.prototype.isNeg = function() {
        return this.negative !== 0;
      }, n.prototype.neg = function() {
        return this.clone().ineg();
      }, n.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, n.prototype.iuor = function(r) {
        for (; this.length < r.length; )
          this.words[this.length++] = 0;
        for (var s = 0; s < r.length; s++)
          this.words[s] = this.words[s] | r.words[s];
        return this.strip();
      }, n.prototype.ior = function(r) {
        return i((this.negative | r.negative) === 0), this.iuor(r);
      }, n.prototype.or = function(r) {
        return this.length > r.length ? this.clone().ior(r) : r.clone().ior(this);
      }, n.prototype.uor = function(r) {
        return this.length > r.length ? this.clone().iuor(r) : r.clone().iuor(this);
      }, n.prototype.iuand = function(r) {
        var s;
        this.length > r.length ? s = r : s = this;
        for (var u = 0; u < s.length; u++)
          this.words[u] = this.words[u] & r.words[u];
        return this.length = s.length, this.strip();
      }, n.prototype.iand = function(r) {
        return i((this.negative | r.negative) === 0), this.iuand(r);
      }, n.prototype.and = function(r) {
        return this.length > r.length ? this.clone().iand(r) : r.clone().iand(this);
      }, n.prototype.uand = function(r) {
        return this.length > r.length ? this.clone().iuand(r) : r.clone().iuand(this);
      }, n.prototype.iuxor = function(r) {
        var s, u;
        this.length > r.length ? (s = this, u = r) : (s = r, u = this);
        for (var g = 0; g < u.length; g++)
          this.words[g] = s.words[g] ^ u.words[g];
        if (this !== s)
          for (; g < s.length; g++)
            this.words[g] = s.words[g];
        return this.length = s.length, this.strip();
      }, n.prototype.ixor = function(r) {
        return i((this.negative | r.negative) === 0), this.iuxor(r);
      }, n.prototype.xor = function(r) {
        return this.length > r.length ? this.clone().ixor(r) : r.clone().ixor(this);
      }, n.prototype.uxor = function(r) {
        return this.length > r.length ? this.clone().iuxor(r) : r.clone().iuxor(this);
      }, n.prototype.inotn = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = Math.ceil(r / 26) | 0, u = r % 26;
        this._expand(s), u > 0 && s--;
        for (var g = 0; g < s; g++)
          this.words[g] = ~this.words[g] & 67108863;
        return u > 0 && (this.words[g] = ~this.words[g] & 67108863 >> 26 - u), this.strip();
      }, n.prototype.notn = function(r) {
        return this.clone().inotn(r);
      }, n.prototype.setn = function(r, s) {
        i(typeof r == "number" && r >= 0);
        var u = r / 26 | 0, g = r % 26;
        return this._expand(u + 1), s ? this.words[u] = this.words[u] | 1 << g : this.words[u] = this.words[u] & ~(1 << g), this.strip();
      }, n.prototype.iadd = function(r) {
        var s;
        if (this.negative !== 0 && r.negative === 0)
          return this.negative = 0, s = this.isub(r), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && r.negative !== 0)
          return r.negative = 0, s = this.isub(r), r.negative = 1, s._normSign();
        var u, g;
        this.length > r.length ? (u = this, g = r) : (u = r, g = this);
        for (var v = 0, A = 0; A < g.length; A++)
          s = (u.words[A] | 0) + (g.words[A] | 0) + v, this.words[A] = s & 67108863, v = s >>> 26;
        for (; v !== 0 && A < u.length; A++)
          s = (u.words[A] | 0) + v, this.words[A] = s & 67108863, v = s >>> 26;
        if (this.length = u.length, v !== 0)
          this.words[this.length] = v, this.length++;
        else if (u !== this)
          for (; A < u.length; A++)
            this.words[A] = u.words[A];
        return this;
      }, n.prototype.add = function(r) {
        var s;
        return r.negative !== 0 && this.negative === 0 ? (r.negative = 0, s = this.sub(r), r.negative ^= 1, s) : r.negative === 0 && this.negative !== 0 ? (this.negative = 0, s = r.sub(this), this.negative = 1, s) : this.length > r.length ? this.clone().iadd(r) : r.clone().iadd(this);
      }, n.prototype.isub = function(r) {
        if (r.negative !== 0) {
          r.negative = 0;
          var s = this.iadd(r);
          return r.negative = 1, s._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(r), this.negative = 1, this._normSign();
        var u = this.cmp(r);
        if (u === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var g, v;
        u > 0 ? (g = this, v = r) : (g = r, v = this);
        for (var A = 0, L = 0; L < v.length; L++)
          s = (g.words[L] | 0) - (v.words[L] | 0) + A, A = s >> 26, this.words[L] = s & 67108863;
        for (; A !== 0 && L < g.length; L++)
          s = (g.words[L] | 0) + A, A = s >> 26, this.words[L] = s & 67108863;
        if (A === 0 && L < g.length && g !== this)
          for (; L < g.length; L++)
            this.words[L] = g.words[L];
        return this.length = Math.max(this.length, L), g !== this && (this.negative = 1), this.strip();
      }, n.prototype.sub = function(r) {
        return this.clone().isub(r);
      };
      function N(I, r, s) {
        s.negative = r.negative ^ I.negative;
        var u = I.length + r.length | 0;
        s.length = u, u = u - 1 | 0;
        var g = I.words[0] | 0, v = r.words[0] | 0, A = g * v, L = A & 67108863, m = A / 67108864 | 0;
        s.words[0] = L;
        for (var a = 1; a < u; a++) {
          for (var x = m >>> 26, V = m & 67108863, G = Math.min(a, r.length - 1), Z = Math.max(0, a - I.length + 1); Z <= G; Z++) {
            var te = a - Z | 0;
            g = I.words[te] | 0, v = r.words[Z] | 0, A = g * v + V, x += A / 67108864 | 0, V = A & 67108863;
          }
          s.words[a] = V | 0, m = x | 0;
        }
        return m !== 0 ? s.words[a] = m | 0 : s.length--, s.strip();
      }
      var w = function(r, s, u) {
        var g = r.words, v = s.words, A = u.words, L = 0, m, a, x, V = g[0] | 0, G = V & 8191, Z = V >>> 13, te = g[1] | 0, q = te & 8191, R = te >>> 13, Q = g[2] | 0, $ = Q & 8191, F = Q >>> 13, P = g[3] | 0, _ = P & 8191, X = P >>> 13, le = g[4] | 0, ie = le & 8191, oe = le >>> 13, pe = g[5] | 0, se = pe & 8191, ce = pe >>> 13, me = g[6] | 0, de = me & 8191, ae = me >>> 13, Le = g[7] | 0, ye = Le & 8191, Me = Le >>> 13, at = g[8] | 0, Ne = at & 8191, Ae = at >>> 13, pt = g[9] | 0, ke = pt & 8191, Te = pt >>> 13, Dt = v[0] | 0, De = Dt & 8191, je = Dt >>> 13, At = v[1] | 0, xe = At & 8191, Ie = At >>> 13, Nt = v[2] | 0, _e = Nt & 8191, Be = Nt >>> 13, Xt = v[3] | 0, Re = Xt & 8191, Pe = Xt >>> 13, dr = v[4] | 0, We = dr & 8191, He = dr >>> 13, Ct = v[5] | 0, Ue = Ct & 8191, Ze = Ct >>> 13, Fr = v[6] | 0, Ye = Fr & 8191, Qe = Fr >>> 13, J = v[7] | 0, ee = J & 8191, K = J >>> 13, Y = v[8] | 0, re = Y & 8191, he = Y >>> 13, Se = v[9] | 0, ve = Se & 8191, we = Se >>> 13;
        u.negative = r.negative ^ s.negative, u.length = 19, m = Math.imul(G, De), a = Math.imul(G, je), a = a + Math.imul(Z, De) | 0, x = Math.imul(Z, je);
        var lt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (lt >>> 26) | 0, lt &= 67108863, m = Math.imul(q, De), a = Math.imul(q, je), a = a + Math.imul(R, De) | 0, x = Math.imul(R, je), m = m + Math.imul(G, xe) | 0, a = a + Math.imul(G, Ie) | 0, a = a + Math.imul(Z, xe) | 0, x = x + Math.imul(Z, Ie) | 0;
        var et = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (et >>> 26) | 0, et &= 67108863, m = Math.imul($, De), a = Math.imul($, je), a = a + Math.imul(F, De) | 0, x = Math.imul(F, je), m = m + Math.imul(q, xe) | 0, a = a + Math.imul(q, Ie) | 0, a = a + Math.imul(R, xe) | 0, x = x + Math.imul(R, Ie) | 0, m = m + Math.imul(G, _e) | 0, a = a + Math.imul(G, Be) | 0, a = a + Math.imul(Z, _e) | 0, x = x + Math.imul(Z, Be) | 0;
        var Lt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Lt >>> 26) | 0, Lt &= 67108863, m = Math.imul(_, De), a = Math.imul(_, je), a = a + Math.imul(X, De) | 0, x = Math.imul(X, je), m = m + Math.imul($, xe) | 0, a = a + Math.imul($, Ie) | 0, a = a + Math.imul(F, xe) | 0, x = x + Math.imul(F, Ie) | 0, m = m + Math.imul(q, _e) | 0, a = a + Math.imul(q, Be) | 0, a = a + Math.imul(R, _e) | 0, x = x + Math.imul(R, Be) | 0, m = m + Math.imul(G, Re) | 0, a = a + Math.imul(G, Pe) | 0, a = a + Math.imul(Z, Re) | 0, x = x + Math.imul(Z, Pe) | 0;
        var nt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (nt >>> 26) | 0, nt &= 67108863, m = Math.imul(ie, De), a = Math.imul(ie, je), a = a + Math.imul(oe, De) | 0, x = Math.imul(oe, je), m = m + Math.imul(_, xe) | 0, a = a + Math.imul(_, Ie) | 0, a = a + Math.imul(X, xe) | 0, x = x + Math.imul(X, Ie) | 0, m = m + Math.imul($, _e) | 0, a = a + Math.imul($, Be) | 0, a = a + Math.imul(F, _e) | 0, x = x + Math.imul(F, Be) | 0, m = m + Math.imul(q, Re) | 0, a = a + Math.imul(q, Pe) | 0, a = a + Math.imul(R, Re) | 0, x = x + Math.imul(R, Pe) | 0, m = m + Math.imul(G, We) | 0, a = a + Math.imul(G, He) | 0, a = a + Math.imul(Z, We) | 0, x = x + Math.imul(Z, He) | 0;
        var gt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, m = Math.imul(se, De), a = Math.imul(se, je), a = a + Math.imul(ce, De) | 0, x = Math.imul(ce, je), m = m + Math.imul(ie, xe) | 0, a = a + Math.imul(ie, Ie) | 0, a = a + Math.imul(oe, xe) | 0, x = x + Math.imul(oe, Ie) | 0, m = m + Math.imul(_, _e) | 0, a = a + Math.imul(_, Be) | 0, a = a + Math.imul(X, _e) | 0, x = x + Math.imul(X, Be) | 0, m = m + Math.imul($, Re) | 0, a = a + Math.imul($, Pe) | 0, a = a + Math.imul(F, Re) | 0, x = x + Math.imul(F, Pe) | 0, m = m + Math.imul(q, We) | 0, a = a + Math.imul(q, He) | 0, a = a + Math.imul(R, We) | 0, x = x + Math.imul(R, He) | 0, m = m + Math.imul(G, Ue) | 0, a = a + Math.imul(G, Ze) | 0, a = a + Math.imul(Z, Ue) | 0, x = x + Math.imul(Z, Ze) | 0;
        var yt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, m = Math.imul(de, De), a = Math.imul(de, je), a = a + Math.imul(ae, De) | 0, x = Math.imul(ae, je), m = m + Math.imul(se, xe) | 0, a = a + Math.imul(se, Ie) | 0, a = a + Math.imul(ce, xe) | 0, x = x + Math.imul(ce, Ie) | 0, m = m + Math.imul(ie, _e) | 0, a = a + Math.imul(ie, Be) | 0, a = a + Math.imul(oe, _e) | 0, x = x + Math.imul(oe, Be) | 0, m = m + Math.imul(_, Re) | 0, a = a + Math.imul(_, Pe) | 0, a = a + Math.imul(X, Re) | 0, x = x + Math.imul(X, Pe) | 0, m = m + Math.imul($, We) | 0, a = a + Math.imul($, He) | 0, a = a + Math.imul(F, We) | 0, x = x + Math.imul(F, He) | 0, m = m + Math.imul(q, Ue) | 0, a = a + Math.imul(q, Ze) | 0, a = a + Math.imul(R, Ue) | 0, x = x + Math.imul(R, Ze) | 0, m = m + Math.imul(G, Ye) | 0, a = a + Math.imul(G, Qe) | 0, a = a + Math.imul(Z, Ye) | 0, x = x + Math.imul(Z, Qe) | 0;
        var xt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (xt >>> 26) | 0, xt &= 67108863, m = Math.imul(ye, De), a = Math.imul(ye, je), a = a + Math.imul(Me, De) | 0, x = Math.imul(Me, je), m = m + Math.imul(de, xe) | 0, a = a + Math.imul(de, Ie) | 0, a = a + Math.imul(ae, xe) | 0, x = x + Math.imul(ae, Ie) | 0, m = m + Math.imul(se, _e) | 0, a = a + Math.imul(se, Be) | 0, a = a + Math.imul(ce, _e) | 0, x = x + Math.imul(ce, Be) | 0, m = m + Math.imul(ie, Re) | 0, a = a + Math.imul(ie, Pe) | 0, a = a + Math.imul(oe, Re) | 0, x = x + Math.imul(oe, Pe) | 0, m = m + Math.imul(_, We) | 0, a = a + Math.imul(_, He) | 0, a = a + Math.imul(X, We) | 0, x = x + Math.imul(X, He) | 0, m = m + Math.imul($, Ue) | 0, a = a + Math.imul($, Ze) | 0, a = a + Math.imul(F, Ue) | 0, x = x + Math.imul(F, Ze) | 0, m = m + Math.imul(q, Ye) | 0, a = a + Math.imul(q, Qe) | 0, a = a + Math.imul(R, Ye) | 0, x = x + Math.imul(R, Qe) | 0, m = m + Math.imul(G, ee) | 0, a = a + Math.imul(G, K) | 0, a = a + Math.imul(Z, ee) | 0, x = x + Math.imul(Z, K) | 0;
        var bt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, m = Math.imul(Ne, De), a = Math.imul(Ne, je), a = a + Math.imul(Ae, De) | 0, x = Math.imul(Ae, je), m = m + Math.imul(ye, xe) | 0, a = a + Math.imul(ye, Ie) | 0, a = a + Math.imul(Me, xe) | 0, x = x + Math.imul(Me, Ie) | 0, m = m + Math.imul(de, _e) | 0, a = a + Math.imul(de, Be) | 0, a = a + Math.imul(ae, _e) | 0, x = x + Math.imul(ae, Be) | 0, m = m + Math.imul(se, Re) | 0, a = a + Math.imul(se, Pe) | 0, a = a + Math.imul(ce, Re) | 0, x = x + Math.imul(ce, Pe) | 0, m = m + Math.imul(ie, We) | 0, a = a + Math.imul(ie, He) | 0, a = a + Math.imul(oe, We) | 0, x = x + Math.imul(oe, He) | 0, m = m + Math.imul(_, Ue) | 0, a = a + Math.imul(_, Ze) | 0, a = a + Math.imul(X, Ue) | 0, x = x + Math.imul(X, Ze) | 0, m = m + Math.imul($, Ye) | 0, a = a + Math.imul($, Qe) | 0, a = a + Math.imul(F, Ye) | 0, x = x + Math.imul(F, Qe) | 0, m = m + Math.imul(q, ee) | 0, a = a + Math.imul(q, K) | 0, a = a + Math.imul(R, ee) | 0, x = x + Math.imul(R, K) | 0, m = m + Math.imul(G, re) | 0, a = a + Math.imul(G, he) | 0, a = a + Math.imul(Z, re) | 0, x = x + Math.imul(Z, he) | 0;
        var Mt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Mt >>> 26) | 0, Mt &= 67108863, m = Math.imul(ke, De), a = Math.imul(ke, je), a = a + Math.imul(Te, De) | 0, x = Math.imul(Te, je), m = m + Math.imul(Ne, xe) | 0, a = a + Math.imul(Ne, Ie) | 0, a = a + Math.imul(Ae, xe) | 0, x = x + Math.imul(Ae, Ie) | 0, m = m + Math.imul(ye, _e) | 0, a = a + Math.imul(ye, Be) | 0, a = a + Math.imul(Me, _e) | 0, x = x + Math.imul(Me, Be) | 0, m = m + Math.imul(de, Re) | 0, a = a + Math.imul(de, Pe) | 0, a = a + Math.imul(ae, Re) | 0, x = x + Math.imul(ae, Pe) | 0, m = m + Math.imul(se, We) | 0, a = a + Math.imul(se, He) | 0, a = a + Math.imul(ce, We) | 0, x = x + Math.imul(ce, He) | 0, m = m + Math.imul(ie, Ue) | 0, a = a + Math.imul(ie, Ze) | 0, a = a + Math.imul(oe, Ue) | 0, x = x + Math.imul(oe, Ze) | 0, m = m + Math.imul(_, Ye) | 0, a = a + Math.imul(_, Qe) | 0, a = a + Math.imul(X, Ye) | 0, x = x + Math.imul(X, Qe) | 0, m = m + Math.imul($, ee) | 0, a = a + Math.imul($, K) | 0, a = a + Math.imul(F, ee) | 0, x = x + Math.imul(F, K) | 0, m = m + Math.imul(q, re) | 0, a = a + Math.imul(q, he) | 0, a = a + Math.imul(R, re) | 0, x = x + Math.imul(R, he) | 0, m = m + Math.imul(G, ve) | 0, a = a + Math.imul(G, we) | 0, a = a + Math.imul(Z, ve) | 0, x = x + Math.imul(Z, we) | 0;
        var vt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, m = Math.imul(ke, xe), a = Math.imul(ke, Ie), a = a + Math.imul(Te, xe) | 0, x = Math.imul(Te, Ie), m = m + Math.imul(Ne, _e) | 0, a = a + Math.imul(Ne, Be) | 0, a = a + Math.imul(Ae, _e) | 0, x = x + Math.imul(Ae, Be) | 0, m = m + Math.imul(ye, Re) | 0, a = a + Math.imul(ye, Pe) | 0, a = a + Math.imul(Me, Re) | 0, x = x + Math.imul(Me, Pe) | 0, m = m + Math.imul(de, We) | 0, a = a + Math.imul(de, He) | 0, a = a + Math.imul(ae, We) | 0, x = x + Math.imul(ae, He) | 0, m = m + Math.imul(se, Ue) | 0, a = a + Math.imul(se, Ze) | 0, a = a + Math.imul(ce, Ue) | 0, x = x + Math.imul(ce, Ze) | 0, m = m + Math.imul(ie, Ye) | 0, a = a + Math.imul(ie, Qe) | 0, a = a + Math.imul(oe, Ye) | 0, x = x + Math.imul(oe, Qe) | 0, m = m + Math.imul(_, ee) | 0, a = a + Math.imul(_, K) | 0, a = a + Math.imul(X, ee) | 0, x = x + Math.imul(X, K) | 0, m = m + Math.imul($, re) | 0, a = a + Math.imul($, he) | 0, a = a + Math.imul(F, re) | 0, x = x + Math.imul(F, he) | 0, m = m + Math.imul(q, ve) | 0, a = a + Math.imul(q, we) | 0, a = a + Math.imul(R, ve) | 0, x = x + Math.imul(R, we) | 0;
        var mt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, m = Math.imul(ke, _e), a = Math.imul(ke, Be), a = a + Math.imul(Te, _e) | 0, x = Math.imul(Te, Be), m = m + Math.imul(Ne, Re) | 0, a = a + Math.imul(Ne, Pe) | 0, a = a + Math.imul(Ae, Re) | 0, x = x + Math.imul(Ae, Pe) | 0, m = m + Math.imul(ye, We) | 0, a = a + Math.imul(ye, He) | 0, a = a + Math.imul(Me, We) | 0, x = x + Math.imul(Me, He) | 0, m = m + Math.imul(de, Ue) | 0, a = a + Math.imul(de, Ze) | 0, a = a + Math.imul(ae, Ue) | 0, x = x + Math.imul(ae, Ze) | 0, m = m + Math.imul(se, Ye) | 0, a = a + Math.imul(se, Qe) | 0, a = a + Math.imul(ce, Ye) | 0, x = x + Math.imul(ce, Qe) | 0, m = m + Math.imul(ie, ee) | 0, a = a + Math.imul(ie, K) | 0, a = a + Math.imul(oe, ee) | 0, x = x + Math.imul(oe, K) | 0, m = m + Math.imul(_, re) | 0, a = a + Math.imul(_, he) | 0, a = a + Math.imul(X, re) | 0, x = x + Math.imul(X, he) | 0, m = m + Math.imul($, ve) | 0, a = a + Math.imul($, we) | 0, a = a + Math.imul(F, ve) | 0, x = x + Math.imul(F, we) | 0;
        var ot = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (ot >>> 26) | 0, ot &= 67108863, m = Math.imul(ke, Re), a = Math.imul(ke, Pe), a = a + Math.imul(Te, Re) | 0, x = Math.imul(Te, Pe), m = m + Math.imul(Ne, We) | 0, a = a + Math.imul(Ne, He) | 0, a = a + Math.imul(Ae, We) | 0, x = x + Math.imul(Ae, He) | 0, m = m + Math.imul(ye, Ue) | 0, a = a + Math.imul(ye, Ze) | 0, a = a + Math.imul(Me, Ue) | 0, x = x + Math.imul(Me, Ze) | 0, m = m + Math.imul(de, Ye) | 0, a = a + Math.imul(de, Qe) | 0, a = a + Math.imul(ae, Ye) | 0, x = x + Math.imul(ae, Qe) | 0, m = m + Math.imul(se, ee) | 0, a = a + Math.imul(se, K) | 0, a = a + Math.imul(ce, ee) | 0, x = x + Math.imul(ce, K) | 0, m = m + Math.imul(ie, re) | 0, a = a + Math.imul(ie, he) | 0, a = a + Math.imul(oe, re) | 0, x = x + Math.imul(oe, he) | 0, m = m + Math.imul(_, ve) | 0, a = a + Math.imul(_, we) | 0, a = a + Math.imul(X, ve) | 0, x = x + Math.imul(X, we) | 0;
        var ft = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (ft >>> 26) | 0, ft &= 67108863, m = Math.imul(ke, We), a = Math.imul(ke, He), a = a + Math.imul(Te, We) | 0, x = Math.imul(Te, He), m = m + Math.imul(Ne, Ue) | 0, a = a + Math.imul(Ne, Ze) | 0, a = a + Math.imul(Ae, Ue) | 0, x = x + Math.imul(Ae, Ze) | 0, m = m + Math.imul(ye, Ye) | 0, a = a + Math.imul(ye, Qe) | 0, a = a + Math.imul(Me, Ye) | 0, x = x + Math.imul(Me, Qe) | 0, m = m + Math.imul(de, ee) | 0, a = a + Math.imul(de, K) | 0, a = a + Math.imul(ae, ee) | 0, x = x + Math.imul(ae, K) | 0, m = m + Math.imul(se, re) | 0, a = a + Math.imul(se, he) | 0, a = a + Math.imul(ce, re) | 0, x = x + Math.imul(ce, he) | 0, m = m + Math.imul(ie, ve) | 0, a = a + Math.imul(ie, we) | 0, a = a + Math.imul(oe, ve) | 0, x = x + Math.imul(oe, we) | 0;
        var rt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (rt >>> 26) | 0, rt &= 67108863, m = Math.imul(ke, Ue), a = Math.imul(ke, Ze), a = a + Math.imul(Te, Ue) | 0, x = Math.imul(Te, Ze), m = m + Math.imul(Ne, Ye) | 0, a = a + Math.imul(Ne, Qe) | 0, a = a + Math.imul(Ae, Ye) | 0, x = x + Math.imul(Ae, Qe) | 0, m = m + Math.imul(ye, ee) | 0, a = a + Math.imul(ye, K) | 0, a = a + Math.imul(Me, ee) | 0, x = x + Math.imul(Me, K) | 0, m = m + Math.imul(de, re) | 0, a = a + Math.imul(de, he) | 0, a = a + Math.imul(ae, re) | 0, x = x + Math.imul(ae, he) | 0, m = m + Math.imul(se, ve) | 0, a = a + Math.imul(se, we) | 0, a = a + Math.imul(ce, ve) | 0, x = x + Math.imul(ce, we) | 0;
        var st = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (st >>> 26) | 0, st &= 67108863, m = Math.imul(ke, Ye), a = Math.imul(ke, Qe), a = a + Math.imul(Te, Ye) | 0, x = Math.imul(Te, Qe), m = m + Math.imul(Ne, ee) | 0, a = a + Math.imul(Ne, K) | 0, a = a + Math.imul(Ae, ee) | 0, x = x + Math.imul(Ae, K) | 0, m = m + Math.imul(ye, re) | 0, a = a + Math.imul(ye, he) | 0, a = a + Math.imul(Me, re) | 0, x = x + Math.imul(Me, he) | 0, m = m + Math.imul(de, ve) | 0, a = a + Math.imul(de, we) | 0, a = a + Math.imul(ae, ve) | 0, x = x + Math.imul(ae, we) | 0;
        var ct = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (ct >>> 26) | 0, ct &= 67108863, m = Math.imul(ke, ee), a = Math.imul(ke, K), a = a + Math.imul(Te, ee) | 0, x = Math.imul(Te, K), m = m + Math.imul(Ne, re) | 0, a = a + Math.imul(Ne, he) | 0, a = a + Math.imul(Ae, re) | 0, x = x + Math.imul(Ae, he) | 0, m = m + Math.imul(ye, ve) | 0, a = a + Math.imul(ye, we) | 0, a = a + Math.imul(Me, ve) | 0, x = x + Math.imul(Me, we) | 0;
        var Je = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Je >>> 26) | 0, Je &= 67108863, m = Math.imul(ke, re), a = Math.imul(ke, he), a = a + Math.imul(Te, re) | 0, x = Math.imul(Te, he), m = m + Math.imul(Ne, ve) | 0, a = a + Math.imul(Ne, we) | 0, a = a + Math.imul(Ae, ve) | 0, x = x + Math.imul(Ae, we) | 0;
        var Oe = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, m = Math.imul(ke, ve), a = Math.imul(ke, we), a = a + Math.imul(Te, ve) | 0, x = Math.imul(Te, we);
        var ze = (L + m | 0) + ((a & 8191) << 13) | 0;
        return L = (x + (a >>> 13) | 0) + (ze >>> 26) | 0, ze &= 67108863, A[0] = lt, A[1] = et, A[2] = Lt, A[3] = nt, A[4] = gt, A[5] = yt, A[6] = xt, A[7] = bt, A[8] = Mt, A[9] = vt, A[10] = mt, A[11] = ot, A[12] = ft, A[13] = rt, A[14] = st, A[15] = ct, A[16] = Je, A[17] = Oe, A[18] = ze, L !== 0 && (A[19] = L, u.length++), u;
      };
      Math.imul || (w = N);
      function S(I, r, s) {
        s.negative = r.negative ^ I.negative, s.length = I.length + r.length;
        for (var u = 0, g = 0, v = 0; v < s.length - 1; v++) {
          var A = g;
          g = 0;
          for (var L = u & 67108863, m = Math.min(v, r.length - 1), a = Math.max(0, v - I.length + 1); a <= m; a++) {
            var x = v - a, V = I.words[x] | 0, G = r.words[a] | 0, Z = V * G, te = Z & 67108863;
            A = A + (Z / 67108864 | 0) | 0, te = te + L | 0, L = te & 67108863, A = A + (te >>> 26) | 0, g += A >>> 26, A &= 67108863;
          }
          s.words[v] = L, u = A, A = g;
        }
        return u !== 0 ? s.words[v] = u : s.length--, s.strip();
      }
      function T(I, r, s) {
        var u = new E();
        return u.mulp(I, r, s);
      }
      n.prototype.mulTo = function(r, s) {
        var u, g = this.length + r.length;
        return this.length === 10 && r.length === 10 ? u = w(this, r, s) : g < 63 ? u = N(this, r, s) : g < 1024 ? u = S(this, r, s) : u = T(this, r, s), u;
      };
      function E(I, r) {
        this.x = I, this.y = r;
      }
      E.prototype.makeRBT = function(r) {
        for (var s = new Array(r), u = n.prototype._countBits(r) - 1, g = 0; g < r; g++)
          s[g] = this.revBin(g, u, r);
        return s;
      }, E.prototype.revBin = function(r, s, u) {
        if (r === 0 || r === u - 1) return r;
        for (var g = 0, v = 0; v < s; v++)
          g |= (r & 1) << s - v - 1, r >>= 1;
        return g;
      }, E.prototype.permute = function(r, s, u, g, v, A) {
        for (var L = 0; L < A; L++)
          g[L] = s[r[L]], v[L] = u[r[L]];
      }, E.prototype.transform = function(r, s, u, g, v, A) {
        this.permute(A, r, s, u, g, v);
        for (var L = 1; L < v; L <<= 1)
          for (var m = L << 1, a = Math.cos(2 * Math.PI / m), x = Math.sin(2 * Math.PI / m), V = 0; V < v; V += m)
            for (var G = a, Z = x, te = 0; te < L; te++) {
              var q = u[V + te], R = g[V + te], Q = u[V + te + L], $ = g[V + te + L], F = G * Q - Z * $;
              $ = G * $ + Z * Q, Q = F, u[V + te] = q + Q, g[V + te] = R + $, u[V + te + L] = q - Q, g[V + te + L] = R - $, te !== m && (F = a * G - x * Z, Z = a * Z + x * G, G = F);
            }
      }, E.prototype.guessLen13b = function(r, s) {
        var u = Math.max(s, r) | 1, g = u & 1, v = 0;
        for (u = u / 2 | 0; u; u = u >>> 1)
          v++;
        return 1 << v + 1 + g;
      }, E.prototype.conjugate = function(r, s, u) {
        if (!(u <= 1))
          for (var g = 0; g < u / 2; g++) {
            var v = r[g];
            r[g] = r[u - g - 1], r[u - g - 1] = v, v = s[g], s[g] = -s[u - g - 1], s[u - g - 1] = -v;
          }
      }, E.prototype.normalize13b = function(r, s) {
        for (var u = 0, g = 0; g < s / 2; g++) {
          var v = Math.round(r[2 * g + 1] / s) * 8192 + Math.round(r[2 * g] / s) + u;
          r[g] = v & 67108863, v < 67108864 ? u = 0 : u = v / 67108864 | 0;
        }
        return r;
      }, E.prototype.convert13b = function(r, s, u, g) {
        for (var v = 0, A = 0; A < s; A++)
          v = v + (r[A] | 0), u[2 * A] = v & 8191, v = v >>> 13, u[2 * A + 1] = v & 8191, v = v >>> 13;
        for (A = 2 * s; A < g; ++A)
          u[A] = 0;
        i(v === 0), i((v & -8192) === 0);
      }, E.prototype.stub = function(r) {
        for (var s = new Array(r), u = 0; u < r; u++)
          s[u] = 0;
        return s;
      }, E.prototype.mulp = function(r, s, u) {
        var g = 2 * this.guessLen13b(r.length, s.length), v = this.makeRBT(g), A = this.stub(g), L = new Array(g), m = new Array(g), a = new Array(g), x = new Array(g), V = new Array(g), G = new Array(g), Z = u.words;
        Z.length = g, this.convert13b(r.words, r.length, L, g), this.convert13b(s.words, s.length, x, g), this.transform(L, A, m, a, g, v), this.transform(x, A, V, G, g, v);
        for (var te = 0; te < g; te++) {
          var q = m[te] * V[te] - a[te] * G[te];
          a[te] = m[te] * G[te] + a[te] * V[te], m[te] = q;
        }
        return this.conjugate(m, a, g), this.transform(m, a, Z, A, g, v), this.conjugate(Z, A, g), this.normalize13b(Z, g), u.negative = r.negative ^ s.negative, u.length = r.length + s.length, u.strip();
      }, n.prototype.mul = function(r) {
        var s = new n(null);
        return s.words = new Array(this.length + r.length), this.mulTo(r, s);
      }, n.prototype.mulf = function(r) {
        var s = new n(null);
        return s.words = new Array(this.length + r.length), T(this, r, s);
      }, n.prototype.imul = function(r) {
        return this.clone().mulTo(r, this);
      }, n.prototype.imuln = function(r) {
        i(typeof r == "number"), i(r < 67108864);
        for (var s = 0, u = 0; u < this.length; u++) {
          var g = (this.words[u] | 0) * r, v = (g & 67108863) + (s & 67108863);
          s >>= 26, s += g / 67108864 | 0, s += v >>> 26, this.words[u] = v & 67108863;
        }
        return s !== 0 && (this.words[u] = s, this.length++), this.length = r === 0 ? 1 : this.length, this;
      }, n.prototype.muln = function(r) {
        return this.clone().imuln(r);
      }, n.prototype.sqr = function() {
        return this.mul(this);
      }, n.prototype.isqr = function() {
        return this.imul(this.clone());
      }, n.prototype.pow = function(r) {
        var s = C(r);
        if (s.length === 0) return new n(1);
        for (var u = this, g = 0; g < s.length && s[g] === 0; g++, u = u.sqr())
          ;
        if (++g < s.length)
          for (var v = u.sqr(); g < s.length; g++, v = v.sqr())
            s[g] !== 0 && (u = u.mul(v));
        return u;
      }, n.prototype.iushln = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = r % 26, u = (r - s) / 26, g = 67108863 >>> 26 - s << 26 - s, v;
        if (s !== 0) {
          var A = 0;
          for (v = 0; v < this.length; v++) {
            var L = this.words[v] & g, m = (this.words[v] | 0) - L << s;
            this.words[v] = m | A, A = L >>> 26 - s;
          }
          A && (this.words[v] = A, this.length++);
        }
        if (u !== 0) {
          for (v = this.length - 1; v >= 0; v--)
            this.words[v + u] = this.words[v];
          for (v = 0; v < u; v++)
            this.words[v] = 0;
          this.length += u;
        }
        return this.strip();
      }, n.prototype.ishln = function(r) {
        return i(this.negative === 0), this.iushln(r);
      }, n.prototype.iushrn = function(r, s, u) {
        i(typeof r == "number" && r >= 0);
        var g;
        s ? g = (s - s % 26) / 26 : g = 0;
        var v = r % 26, A = Math.min((r - v) / 26, this.length), L = 67108863 ^ 67108863 >>> v << v, m = u;
        if (g -= A, g = Math.max(0, g), m) {
          for (var a = 0; a < A; a++)
            m.words[a] = this.words[a];
          m.length = A;
        }
        if (A !== 0) if (this.length > A)
          for (this.length -= A, a = 0; a < this.length; a++)
            this.words[a] = this.words[a + A];
        else
          this.words[0] = 0, this.length = 1;
        var x = 0;
        for (a = this.length - 1; a >= 0 && (x !== 0 || a >= g); a--) {
          var V = this.words[a] | 0;
          this.words[a] = x << 26 - v | V >>> v, x = V & L;
        }
        return m && x !== 0 && (m.words[m.length++] = x), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, n.prototype.ishrn = function(r, s, u) {
        return i(this.negative === 0), this.iushrn(r, s, u);
      }, n.prototype.shln = function(r) {
        return this.clone().ishln(r);
      }, n.prototype.ushln = function(r) {
        return this.clone().iushln(r);
      }, n.prototype.shrn = function(r) {
        return this.clone().ishrn(r);
      }, n.prototype.ushrn = function(r) {
        return this.clone().iushrn(r);
      }, n.prototype.testn = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = r % 26, u = (r - s) / 26, g = 1 << s;
        if (this.length <= u) return !1;
        var v = this.words[u];
        return !!(v & g);
      }, n.prototype.imaskn = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = r % 26, u = (r - s) / 26;
        if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= u)
          return this;
        if (s !== 0 && u++, this.length = Math.min(u, this.length), s !== 0) {
          var g = 67108863 ^ 67108863 >>> s << s;
          this.words[this.length - 1] &= g;
        }
        return this.strip();
      }, n.prototype.maskn = function(r) {
        return this.clone().imaskn(r);
      }, n.prototype.iaddn = function(r) {
        return i(typeof r == "number"), i(r < 67108864), r < 0 ? this.isubn(-r) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < r ? (this.words[0] = r - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(r), this.negative = 1, this) : this._iaddn(r);
      }, n.prototype._iaddn = function(r) {
        this.words[0] += r;
        for (var s = 0; s < this.length && this.words[s] >= 67108864; s++)
          this.words[s] -= 67108864, s === this.length - 1 ? this.words[s + 1] = 1 : this.words[s + 1]++;
        return this.length = Math.max(this.length, s + 1), this;
      }, n.prototype.isubn = function(r) {
        if (i(typeof r == "number"), i(r < 67108864), r < 0) return this.iaddn(-r);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(r), this.negative = 1, this;
        if (this.words[0] -= r, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var s = 0; s < this.length && this.words[s] < 0; s++)
            this.words[s] += 67108864, this.words[s + 1] -= 1;
        return this.strip();
      }, n.prototype.addn = function(r) {
        return this.clone().iaddn(r);
      }, n.prototype.subn = function(r) {
        return this.clone().isubn(r);
      }, n.prototype.iabs = function() {
        return this.negative = 0, this;
      }, n.prototype.abs = function() {
        return this.clone().iabs();
      }, n.prototype._ishlnsubmul = function(r, s, u) {
        var g = r.length + u, v;
        this._expand(g);
        var A, L = 0;
        for (v = 0; v < r.length; v++) {
          A = (this.words[v + u] | 0) + L;
          var m = (r.words[v] | 0) * s;
          A -= m & 67108863, L = (A >> 26) - (m / 67108864 | 0), this.words[v + u] = A & 67108863;
        }
        for (; v < this.length - u; v++)
          A = (this.words[v + u] | 0) + L, L = A >> 26, this.words[v + u] = A & 67108863;
        if (L === 0) return this.strip();
        for (i(L === -1), L = 0, v = 0; v < this.length; v++)
          A = -(this.words[v] | 0) + L, L = A >> 26, this.words[v] = A & 67108863;
        return this.negative = 1, this.strip();
      }, n.prototype._wordDiv = function(r, s) {
        var u = this.length - r.length, g = this.clone(), v = r, A = v.words[v.length - 1] | 0, L = this._countBits(A);
        u = 26 - L, u !== 0 && (v = v.ushln(u), g.iushln(u), A = v.words[v.length - 1] | 0);
        var m = g.length - v.length, a;
        if (s !== "mod") {
          a = new n(null), a.length = m + 1, a.words = new Array(a.length);
          for (var x = 0; x < a.length; x++)
            a.words[x] = 0;
        }
        var V = g.clone()._ishlnsubmul(v, 1, m);
        V.negative === 0 && (g = V, a && (a.words[m] = 1));
        for (var G = m - 1; G >= 0; G--) {
          var Z = (g.words[v.length + G] | 0) * 67108864 + (g.words[v.length + G - 1] | 0);
          for (Z = Math.min(Z / A | 0, 67108863), g._ishlnsubmul(v, Z, G); g.negative !== 0; )
            Z--, g.negative = 0, g._ishlnsubmul(v, 1, G), g.isZero() || (g.negative ^= 1);
          a && (a.words[G] = Z);
        }
        return a && a.strip(), g.strip(), s !== "div" && u !== 0 && g.iushrn(u), {
          div: a || null,
          mod: g
        };
      }, n.prototype.divmod = function(r, s, u) {
        if (i(!r.isZero()), this.isZero())
          return {
            div: new n(0),
            mod: new n(0)
          };
        var g, v, A;
        return this.negative !== 0 && r.negative === 0 ? (A = this.neg().divmod(r, s), s !== "mod" && (g = A.div.neg()), s !== "div" && (v = A.mod.neg(), u && v.negative !== 0 && v.iadd(r)), {
          div: g,
          mod: v
        }) : this.negative === 0 && r.negative !== 0 ? (A = this.divmod(r.neg(), s), s !== "mod" && (g = A.div.neg()), {
          div: g,
          mod: A.mod
        }) : this.negative & r.negative ? (A = this.neg().divmod(r.neg(), s), s !== "div" && (v = A.mod.neg(), u && v.negative !== 0 && v.isub(r)), {
          div: A.div,
          mod: v
        }) : r.length > this.length || this.cmp(r) < 0 ? {
          div: new n(0),
          mod: this
        } : r.length === 1 ? s === "div" ? {
          div: this.divn(r.words[0]),
          mod: null
        } : s === "mod" ? {
          div: null,
          mod: new n(this.modn(r.words[0]))
        } : {
          div: this.divn(r.words[0]),
          mod: new n(this.modn(r.words[0]))
        } : this._wordDiv(r, s);
      }, n.prototype.div = function(r) {
        return this.divmod(r, "div", !1).div;
      }, n.prototype.mod = function(r) {
        return this.divmod(r, "mod", !1).mod;
      }, n.prototype.umod = function(r) {
        return this.divmod(r, "mod", !0).mod;
      }, n.prototype.divRound = function(r) {
        var s = this.divmod(r);
        if (s.mod.isZero()) return s.div;
        var u = s.div.negative !== 0 ? s.mod.isub(r) : s.mod, g = r.ushrn(1), v = r.andln(1), A = u.cmp(g);
        return A < 0 || v === 1 && A === 0 ? s.div : s.div.negative !== 0 ? s.div.isubn(1) : s.div.iaddn(1);
      }, n.prototype.modn = function(r) {
        i(r <= 67108863);
        for (var s = (1 << 26) % r, u = 0, g = this.length - 1; g >= 0; g--)
          u = (s * u + (this.words[g] | 0)) % r;
        return u;
      }, n.prototype.idivn = function(r) {
        i(r <= 67108863);
        for (var s = 0, u = this.length - 1; u >= 0; u--) {
          var g = (this.words[u] | 0) + s * 67108864;
          this.words[u] = g / r | 0, s = g % r;
        }
        return this.strip();
      }, n.prototype.divn = function(r) {
        return this.clone().idivn(r);
      }, n.prototype.egcd = function(r) {
        i(r.negative === 0), i(!r.isZero());
        var s = this, u = r.clone();
        s.negative !== 0 ? s = s.umod(r) : s = s.clone();
        for (var g = new n(1), v = new n(0), A = new n(0), L = new n(1), m = 0; s.isEven() && u.isEven(); )
          s.iushrn(1), u.iushrn(1), ++m;
        for (var a = u.clone(), x = s.clone(); !s.isZero(); ) {
          for (var V = 0, G = 1; !(s.words[0] & G) && V < 26; ++V, G <<= 1) ;
          if (V > 0)
            for (s.iushrn(V); V-- > 0; )
              (g.isOdd() || v.isOdd()) && (g.iadd(a), v.isub(x)), g.iushrn(1), v.iushrn(1);
          for (var Z = 0, te = 1; !(u.words[0] & te) && Z < 26; ++Z, te <<= 1) ;
          if (Z > 0)
            for (u.iushrn(Z); Z-- > 0; )
              (A.isOdd() || L.isOdd()) && (A.iadd(a), L.isub(x)), A.iushrn(1), L.iushrn(1);
          s.cmp(u) >= 0 ? (s.isub(u), g.isub(A), v.isub(L)) : (u.isub(s), A.isub(g), L.isub(v));
        }
        return {
          a: A,
          b: L,
          gcd: u.iushln(m)
        };
      }, n.prototype._invmp = function(r) {
        i(r.negative === 0), i(!r.isZero());
        var s = this, u = r.clone();
        s.negative !== 0 ? s = s.umod(r) : s = s.clone();
        for (var g = new n(1), v = new n(0), A = u.clone(); s.cmpn(1) > 0 && u.cmpn(1) > 0; ) {
          for (var L = 0, m = 1; !(s.words[0] & m) && L < 26; ++L, m <<= 1) ;
          if (L > 0)
            for (s.iushrn(L); L-- > 0; )
              g.isOdd() && g.iadd(A), g.iushrn(1);
          for (var a = 0, x = 1; !(u.words[0] & x) && a < 26; ++a, x <<= 1) ;
          if (a > 0)
            for (u.iushrn(a); a-- > 0; )
              v.isOdd() && v.iadd(A), v.iushrn(1);
          s.cmp(u) >= 0 ? (s.isub(u), g.isub(v)) : (u.isub(s), v.isub(g));
        }
        var V;
        return s.cmpn(1) === 0 ? V = g : V = v, V.cmpn(0) < 0 && V.iadd(r), V;
      }, n.prototype.gcd = function(r) {
        if (this.isZero()) return r.abs();
        if (r.isZero()) return this.abs();
        var s = this.clone(), u = r.clone();
        s.negative = 0, u.negative = 0;
        for (var g = 0; s.isEven() && u.isEven(); g++)
          s.iushrn(1), u.iushrn(1);
        do {
          for (; s.isEven(); )
            s.iushrn(1);
          for (; u.isEven(); )
            u.iushrn(1);
          var v = s.cmp(u);
          if (v < 0) {
            var A = s;
            s = u, u = A;
          } else if (v === 0 || u.cmpn(1) === 0)
            break;
          s.isub(u);
        } while (!0);
        return u.iushln(g);
      }, n.prototype.invm = function(r) {
        return this.egcd(r).a.umod(r);
      }, n.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, n.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, n.prototype.andln = function(r) {
        return this.words[0] & r;
      }, n.prototype.bincn = function(r) {
        i(typeof r == "number");
        var s = r % 26, u = (r - s) / 26, g = 1 << s;
        if (this.length <= u)
          return this._expand(u + 1), this.words[u] |= g, this;
        for (var v = g, A = u; v !== 0 && A < this.length; A++) {
          var L = this.words[A] | 0;
          L += v, v = L >>> 26, L &= 67108863, this.words[A] = L;
        }
        return v !== 0 && (this.words[A] = v, this.length++), this;
      }, n.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, n.prototype.cmpn = function(r) {
        var s = r < 0;
        if (this.negative !== 0 && !s) return -1;
        if (this.negative === 0 && s) return 1;
        this.strip();
        var u;
        if (this.length > 1)
          u = 1;
        else {
          s && (r = -r), i(r <= 67108863, "Number is too big");
          var g = this.words[0] | 0;
          u = g === r ? 0 : g < r ? -1 : 1;
        }
        return this.negative !== 0 ? -u | 0 : u;
      }, n.prototype.cmp = function(r) {
        if (this.negative !== 0 && r.negative === 0) return -1;
        if (this.negative === 0 && r.negative !== 0) return 1;
        var s = this.ucmp(r);
        return this.negative !== 0 ? -s | 0 : s;
      }, n.prototype.ucmp = function(r) {
        if (this.length > r.length) return 1;
        if (this.length < r.length) return -1;
        for (var s = 0, u = this.length - 1; u >= 0; u--) {
          var g = this.words[u] | 0, v = r.words[u] | 0;
          if (g !== v) {
            g < v ? s = -1 : g > v && (s = 1);
            break;
          }
        }
        return s;
      }, n.prototype.gtn = function(r) {
        return this.cmpn(r) === 1;
      }, n.prototype.gt = function(r) {
        return this.cmp(r) === 1;
      }, n.prototype.gten = function(r) {
        return this.cmpn(r) >= 0;
      }, n.prototype.gte = function(r) {
        return this.cmp(r) >= 0;
      }, n.prototype.ltn = function(r) {
        return this.cmpn(r) === -1;
      }, n.prototype.lt = function(r) {
        return this.cmp(r) === -1;
      }, n.prototype.lten = function(r) {
        return this.cmpn(r) <= 0;
      }, n.prototype.lte = function(r) {
        return this.cmp(r) <= 0;
      }, n.prototype.eqn = function(r) {
        return this.cmpn(r) === 0;
      }, n.prototype.eq = function(r) {
        return this.cmp(r) === 0;
      }, n.red = function(r) {
        return new U(r);
      }, n.prototype.toRed = function(r) {
        return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), r.convertTo(this)._forceRed(r);
      }, n.prototype.fromRed = function() {
        return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, n.prototype._forceRed = function(r) {
        return this.red = r, this;
      }, n.prototype.forceRed = function(r) {
        return i(!this.red, "Already a number in reduction context"), this._forceRed(r);
      }, n.prototype.redAdd = function(r) {
        return i(this.red, "redAdd works only with red numbers"), this.red.add(this, r);
      }, n.prototype.redIAdd = function(r) {
        return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, r);
      }, n.prototype.redSub = function(r) {
        return i(this.red, "redSub works only with red numbers"), this.red.sub(this, r);
      }, n.prototype.redISub = function(r) {
        return i(this.red, "redISub works only with red numbers"), this.red.isub(this, r);
      }, n.prototype.redShl = function(r) {
        return i(this.red, "redShl works only with red numbers"), this.red.shl(this, r);
      }, n.prototype.redMul = function(r) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, r), this.red.mul(this, r);
      }, n.prototype.redIMul = function(r) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, r), this.red.imul(this, r);
      }, n.prototype.redSqr = function() {
        return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, n.prototype.redISqr = function() {
        return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, n.prototype.redSqrt = function() {
        return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, n.prototype.redInvm = function() {
        return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, n.prototype.redNeg = function() {
        return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, n.prototype.redPow = function(r) {
        return i(this.red && !r.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, r);
      };
      var j = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function O(I, r) {
        this.name = I, this.p = new n(r, 16), this.n = this.p.bitLength(), this.k = new n(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      O.prototype._tmp = function() {
        var r = new n(null);
        return r.words = new Array(Math.ceil(this.n / 13)), r;
      }, O.prototype.ireduce = function(r) {
        var s = r, u;
        do
          this.split(s, this.tmp), s = this.imulK(s), s = s.iadd(this.tmp), u = s.bitLength();
        while (u > this.n);
        var g = u < this.n ? -1 : s.ucmp(this.p);
        return g === 0 ? (s.words[0] = 0, s.length = 1) : g > 0 ? s.isub(this.p) : s.strip !== void 0 ? s.strip() : s._strip(), s;
      }, O.prototype.split = function(r, s) {
        r.iushrn(this.n, 0, s);
      }, O.prototype.imulK = function(r) {
        return r.imul(this.k);
      };
      function z() {
        O.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      c(z, O), z.prototype.split = function(r, s) {
        for (var u = 4194303, g = Math.min(r.length, 9), v = 0; v < g; v++)
          s.words[v] = r.words[v];
        if (s.length = g, r.length <= 9) {
          r.words[0] = 0, r.length = 1;
          return;
        }
        var A = r.words[9];
        for (s.words[s.length++] = A & u, v = 10; v < r.length; v++) {
          var L = r.words[v] | 0;
          r.words[v - 10] = (L & u) << 4 | A >>> 22, A = L;
        }
        A >>>= 22, r.words[v - 10] = A, A === 0 && r.length > 10 ? r.length -= 10 : r.length -= 9;
      }, z.prototype.imulK = function(r) {
        r.words[r.length] = 0, r.words[r.length + 1] = 0, r.length += 2;
        for (var s = 0, u = 0; u < r.length; u++) {
          var g = r.words[u] | 0;
          s += g * 977, r.words[u] = s & 67108863, s = g * 64 + (s / 67108864 | 0);
        }
        return r.words[r.length - 1] === 0 && (r.length--, r.words[r.length - 1] === 0 && r.length--), r;
      };
      function k() {
        O.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      c(k, O);
      function H() {
        O.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      c(H, O);
      function W() {
        O.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      c(W, O), W.prototype.imulK = function(r) {
        for (var s = 0, u = 0; u < r.length; u++) {
          var g = (r.words[u] | 0) * 19 + s, v = g & 67108863;
          g >>>= 26, r.words[u] = v, s = g;
        }
        return s !== 0 && (r.words[r.length++] = s), r;
      }, n._prime = function(r) {
        if (j[r]) return j[r];
        var s;
        if (r === "k256")
          s = new z();
        else if (r === "p224")
          s = new k();
        else if (r === "p192")
          s = new H();
        else if (r === "p25519")
          s = new W();
        else
          throw new Error("Unknown prime " + r);
        return j[r] = s, s;
      };
      function U(I) {
        if (typeof I == "string") {
          var r = n._prime(I);
          this.m = r.p, this.prime = r;
        } else
          i(I.gtn(1), "modulus must be greater than 1"), this.m = I, this.prime = null;
      }
      U.prototype._verify1 = function(r) {
        i(r.negative === 0, "red works only with positives"), i(r.red, "red works only with red numbers");
      }, U.prototype._verify2 = function(r, s) {
        i((r.negative | s.negative) === 0, "red works only with positives"), i(
          r.red && r.red === s.red,
          "red works only with red numbers"
        );
      }, U.prototype.imod = function(r) {
        return this.prime ? this.prime.ireduce(r)._forceRed(this) : r.umod(this.m)._forceRed(this);
      }, U.prototype.neg = function(r) {
        return r.isZero() ? r.clone() : this.m.sub(r)._forceRed(this);
      }, U.prototype.add = function(r, s) {
        this._verify2(r, s);
        var u = r.add(s);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u._forceRed(this);
      }, U.prototype.iadd = function(r, s) {
        this._verify2(r, s);
        var u = r.iadd(s);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u;
      }, U.prototype.sub = function(r, s) {
        this._verify2(r, s);
        var u = r.sub(s);
        return u.cmpn(0) < 0 && u.iadd(this.m), u._forceRed(this);
      }, U.prototype.isub = function(r, s) {
        this._verify2(r, s);
        var u = r.isub(s);
        return u.cmpn(0) < 0 && u.iadd(this.m), u;
      }, U.prototype.shl = function(r, s) {
        return this._verify1(r), this.imod(r.ushln(s));
      }, U.prototype.imul = function(r, s) {
        return this._verify2(r, s), this.imod(r.imul(s));
      }, U.prototype.mul = function(r, s) {
        return this._verify2(r, s), this.imod(r.mul(s));
      }, U.prototype.isqr = function(r) {
        return this.imul(r, r.clone());
      }, U.prototype.sqr = function(r) {
        return this.mul(r, r);
      }, U.prototype.sqrt = function(r) {
        if (r.isZero()) return r.clone();
        var s = this.m.andln(3);
        if (i(s % 2 === 1), s === 3) {
          var u = this.m.add(new n(1)).iushrn(2);
          return this.pow(r, u);
        }
        for (var g = this.m.subn(1), v = 0; !g.isZero() && g.andln(1) === 0; )
          v++, g.iushrn(1);
        i(!g.isZero());
        var A = new n(1).toRed(this), L = A.redNeg(), m = this.m.subn(1).iushrn(1), a = this.m.bitLength();
        for (a = new n(2 * a * a).toRed(this); this.pow(a, m).cmp(L) !== 0; )
          a.redIAdd(L);
        for (var x = this.pow(a, g), V = this.pow(r, g.addn(1).iushrn(1)), G = this.pow(r, g), Z = v; G.cmp(A) !== 0; ) {
          for (var te = G, q = 0; te.cmp(A) !== 0; q++)
            te = te.redSqr();
          i(q < Z);
          var R = this.pow(x, new n(1).iushln(Z - q - 1));
          V = V.redMul(R), x = R.redSqr(), G = G.redMul(x), Z = q;
        }
        return V;
      }, U.prototype.invm = function(r) {
        var s = r._invmp(this.m);
        return s.negative !== 0 ? (s.negative = 0, this.imod(s).redNeg()) : this.imod(s);
      }, U.prototype.pow = function(r, s) {
        if (s.isZero()) return new n(1).toRed(this);
        if (s.cmpn(1) === 0) return r.clone();
        var u = 4, g = new Array(1 << u);
        g[0] = new n(1).toRed(this), g[1] = r;
        for (var v = 2; v < g.length; v++)
          g[v] = this.mul(g[v - 1], r);
        var A = g[0], L = 0, m = 0, a = s.bitLength() % 26;
        for (a === 0 && (a = 26), v = s.length - 1; v >= 0; v--) {
          for (var x = s.words[v], V = a - 1; V >= 0; V--) {
            var G = x >> V & 1;
            if (A !== g[0] && (A = this.sqr(A)), G === 0 && L === 0) {
              m = 0;
              continue;
            }
            L <<= 1, L |= G, m++, !(m !== u && (v !== 0 || V !== 0)) && (A = this.mul(A, g[L]), m = 0, L = 0);
          }
          a = 26;
        }
        return A;
      }, U.prototype.convertTo = function(r) {
        var s = r.umod(this.m);
        return s === r ? s.clone() : s;
      }, U.prototype.convertFrom = function(r) {
        var s = r.clone();
        return s.red = null, s;
      }, n.mont = function(r) {
        return new B(r);
      };
      function B(I) {
        U.call(this, I), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new n(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      c(B, U), B.prototype.convertTo = function(r) {
        return this.imod(r.ushln(this.shift));
      }, B.prototype.convertFrom = function(r) {
        var s = this.imod(r.mul(this.rinv));
        return s.red = null, s;
      }, B.prototype.imul = function(r, s) {
        if (r.isZero() || s.isZero())
          return r.words[0] = 0, r.length = 1, r;
        var u = r.imul(s), g = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), v = u.isub(g).iushrn(this.shift), A = v;
        return v.cmp(this.m) >= 0 ? A = v.isub(this.m) : v.cmpn(0) < 0 && (A = v.iadd(this.m)), A._forceRed(this);
      }, B.prototype.mul = function(r, s) {
        if (r.isZero() || s.isZero()) return new n(0)._forceRed(this);
        var u = r.mul(s), g = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), v = u.isub(g).iushrn(this.shift), A = v;
        return v.cmp(this.m) >= 0 ? A = v.isub(this.m) : v.cmpn(0) < 0 && (A = v.iadd(this.m)), A._forceRed(this);
      }, B.prototype.invm = function(r) {
        var s = this.imod(r._invmp(this.m).mul(this.r2));
        return s._forceRed(this);
      };
    })(e, Wt);
  }(Z0)), Z0.exports;
}
var id = {}, Q3;
function GA() {
  return Q3 || (Q3 = 1, function(e) {
    var t = Us(), o = Yt, i = e;
    i.define = function(d, f) {
      return new c(d, f);
    };
    function c(n, d) {
      this.name = n, this.body = d, this.decoders = {}, this.encoders = {};
    }
    c.prototype._createNamed = function(d) {
      var f;
      try {
        f = Ds.runInThisContext(
          "(function " + this.name + `(entity) {
  this._initNamed(entity);
})`
        );
      } catch {
        f = function(l) {
          this._initNamed(l);
        };
      }
      return o(f, d), f.prototype._initNamed = function(l) {
        d.call(this, l);
      }, new f(this);
    }, c.prototype._getDecoder = function(d) {
      return d = d || "der", this.decoders.hasOwnProperty(d) || (this.decoders[d] = this._createNamed(t.decoders[d])), this.decoders[d];
    }, c.prototype.decode = function(d, f, p) {
      return this._getDecoder(f).decode(d, p);
    }, c.prototype._getEncoder = function(d) {
      return d = d || "der", this.encoders.hasOwnProperty(d) || (this.encoders[d] = this._createNamed(t.encoders[d])), this.encoders[d];
    }, c.prototype.encode = function(d, f, p) {
      return this._getEncoder(f).encode(d, p);
    };
  }(id)), id;
}
var od = {}, ad = {}, V3;
function $A() {
  if (V3) return ad;
  V3 = 1;
  var e = Yt;
  function t(i) {
    this._reporterState = {
      obj: null,
      path: [],
      options: i || {},
      errors: []
    };
  }
  ad.Reporter = t, t.prototype.isError = function(c) {
    return c instanceof o;
  }, t.prototype.save = function() {
    var c = this._reporterState;
    return { obj: c.obj, pathLen: c.path.length };
  }, t.prototype.restore = function(c) {
    var n = this._reporterState;
    n.obj = c.obj, n.path = n.path.slice(0, c.pathLen);
  }, t.prototype.enterKey = function(c) {
    return this._reporterState.path.push(c);
  }, t.prototype.exitKey = function(c) {
    var n = this._reporterState;
    n.path = n.path.slice(0, c - 1);
  }, t.prototype.leaveKey = function(c, n, d) {
    var f = this._reporterState;
    this.exitKey(c), f.obj !== null && (f.obj[n] = d);
  }, t.prototype.path = function() {
    return this._reporterState.path.join("/");
  }, t.prototype.enterObject = function() {
    var c = this._reporterState, n = c.obj;
    return c.obj = {}, n;
  }, t.prototype.leaveObject = function(c) {
    var n = this._reporterState, d = n.obj;
    return n.obj = c, d;
  }, t.prototype.error = function(c) {
    var n, d = this._reporterState, f = c instanceof o;
    if (f ? n = c : n = new o(d.path.map(function(p) {
      return "[" + JSON.stringify(p) + "]";
    }).join(""), c.message || c, c.stack), !d.options.partial)
      throw n;
    return f || d.errors.push(n), n;
  }, t.prototype.wrapResult = function(c) {
    var n = this._reporterState;
    return n.options.partial ? {
      result: this.isError(c) ? null : c,
      errors: n.errors
    } : c;
  };
  function o(i, c) {
    this.path = i, this.rethrow(c);
  }
  return e(o, Error), o.prototype.rethrow = function(c) {
    if (this.message = c + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, o), !this.stack)
      try {
        throw new Error(this.message);
      } catch (n) {
        this.stack = n.stack;
      }
    return this;
  }, ad;
}
var M0 = {}, G3;
function $3() {
  if (G3) return M0;
  G3 = 1;
  var e = Yt, t = Ja().Reporter, o = Wr.Buffer;
  function i(n, d) {
    if (t.call(this, d), !o.isBuffer(n)) {
      this.error("Input not Buffer");
      return;
    }
    this.base = n, this.offset = 0, this.length = n.length;
  }
  e(i, t), M0.DecoderBuffer = i, i.prototype.save = function() {
    return { offset: this.offset, reporter: t.prototype.save.call(this) };
  }, i.prototype.restore = function(d) {
    var f = new i(this.base);
    return f.offset = d.offset, f.length = this.offset, this.offset = d.offset, t.prototype.restore.call(this, d.reporter), f;
  }, i.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, i.prototype.readUInt8 = function(d) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(d || "DecoderBuffer overrun");
  }, i.prototype.skip = function(d, f) {
    if (!(this.offset + d <= this.length))
      return this.error(f || "DecoderBuffer overrun");
    var p = new i(this.base);
    return p._reporterState = this._reporterState, p.offset = this.offset, p.length = this.offset + d, this.offset += d, p;
  }, i.prototype.raw = function(d) {
    return this.base.slice(d ? d.offset : this.offset, this.length);
  };
  function c(n, d) {
    if (Array.isArray(n))
      this.length = 0, this.value = n.map(function(f) {
        return f instanceof c || (f = new c(f, d)), this.length += f.length, f;
      }, this);
    else if (typeof n == "number") {
      if (!(0 <= n && n <= 255))
        return d.error("non-byte EncoderBuffer value");
      this.value = n, this.length = 1;
    } else if (typeof n == "string")
      this.value = n, this.length = o.byteLength(n);
    else if (o.isBuffer(n))
      this.value = n, this.length = n.length;
    else
      return d.error("Unsupported type: " + typeof n);
  }
  return M0.EncoderBuffer = c, c.prototype.join = function(d, f) {
    return d || (d = new o(this.length)), f || (f = 0), this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(p) {
      p.join(d, f), f += p.length;
    }) : (typeof this.value == "number" ? d[f] = this.value : typeof this.value == "string" ? d.write(this.value, f) : o.isBuffer(this.value) && this.value.copy(d, f), f += this.length)), d;
  }, M0;
}
var sd, q3;
function qA() {
  if (q3) return sd;
  q3 = 1;
  var e = Ja().Reporter, t = Ja().EncoderBuffer, o = Ja().DecoderBuffer, i = Zn(), c = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
  ], n = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
  ].concat(c), d = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
  ];
  function f(l, h) {
    var y = {};
    this._baseState = y, y.enc = l, y.parent = h || null, y.children = null, y.tag = null, y.args = null, y.reverseArgs = null, y.choice = null, y.optional = !1, y.any = !1, y.obj = !1, y.use = null, y.useDecoder = null, y.key = null, y.default = null, y.explicit = null, y.implicit = null, y.contains = null, y.parent || (y.children = [], this._wrap());
  }
  sd = f;
  var p = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
  ];
  return f.prototype.clone = function() {
    var h = this._baseState, y = {};
    p.forEach(function(C) {
      y[C] = h[C];
    });
    var M = new this.constructor(y.parent);
    return M._baseState = y, M;
  }, f.prototype._wrap = function() {
    var h = this._baseState;
    n.forEach(function(y) {
      this[y] = function() {
        var C = new this.constructor(this);
        return h.children.push(C), C[y].apply(C, arguments);
      };
    }, this);
  }, f.prototype._init = function(h) {
    var y = this._baseState;
    i(y.parent === null), h.call(this), y.children = y.children.filter(function(M) {
      return M._baseState.parent === this;
    }, this), i.equal(y.children.length, 1, "Root node can have only one child");
  }, f.prototype._useArgs = function(h) {
    var y = this._baseState, M = h.filter(function(C) {
      return C instanceof this.constructor;
    }, this);
    h = h.filter(function(C) {
      return !(C instanceof this.constructor);
    }, this), M.length !== 0 && (i(y.children === null), y.children = M, M.forEach(function(C) {
      C._baseState.parent = this;
    }, this)), h.length !== 0 && (i(y.args === null), y.args = h, y.reverseArgs = h.map(function(C) {
      if (typeof C != "object" || C.constructor !== Object)
        return C;
      var N = {};
      return Object.keys(C).forEach(function(w) {
        w == (w | 0) && (w |= 0);
        var S = C[w];
        N[S] = w;
      }), N;
    }));
  }, d.forEach(function(l) {
    f.prototype[l] = function() {
      var y = this._baseState;
      throw new Error(l + " not implemented for encoding: " + y.enc);
    };
  }), c.forEach(function(l) {
    f.prototype[l] = function() {
      var y = this._baseState, M = Array.prototype.slice.call(arguments);
      return i(y.tag === null), y.tag = l, this._useArgs(M), this;
    };
  }), f.prototype.use = function(h) {
    i(h);
    var y = this._baseState;
    return i(y.use === null), y.use = h, this;
  }, f.prototype.optional = function() {
    var h = this._baseState;
    return h.optional = !0, this;
  }, f.prototype.def = function(h) {
    var y = this._baseState;
    return i(y.default === null), y.default = h, y.optional = !0, this;
  }, f.prototype.explicit = function(h) {
    var y = this._baseState;
    return i(y.explicit === null && y.implicit === null), y.explicit = h, this;
  }, f.prototype.implicit = function(h) {
    var y = this._baseState;
    return i(y.explicit === null && y.implicit === null), y.implicit = h, this;
  }, f.prototype.obj = function() {
    var h = this._baseState, y = Array.prototype.slice.call(arguments);
    return h.obj = !0, y.length !== 0 && this._useArgs(y), this;
  }, f.prototype.key = function(h) {
    var y = this._baseState;
    return i(y.key === null), y.key = h, this;
  }, f.prototype.any = function() {
    var h = this._baseState;
    return h.any = !0, this;
  }, f.prototype.choice = function(h) {
    var y = this._baseState;
    return i(y.choice === null), y.choice = h, this._useArgs(Object.keys(h).map(function(M) {
      return h[M];
    })), this;
  }, f.prototype.contains = function(h) {
    var y = this._baseState;
    return i(y.use === null), y.contains = h, this;
  }, f.prototype._decode = function(h, y) {
    var M = this._baseState;
    if (M.parent === null)
      return h.wrapResult(M.children[0]._decode(h, y));
    var C = M.default, N = !0, w = null;
    if (M.key !== null && (w = h.enterKey(M.key)), M.optional) {
      var S = null;
      if (M.explicit !== null ? S = M.explicit : M.implicit !== null ? S = M.implicit : M.tag !== null && (S = M.tag), S === null && !M.any) {
        var T = h.save();
        try {
          M.choice === null ? this._decodeGeneric(M.tag, h, y) : this._decodeChoice(h, y), N = !0;
        } catch {
          N = !1;
        }
        h.restore(T);
      } else if (N = this._peekTag(h, S, M.any), h.isError(N))
        return N;
    }
    var E;
    if (M.obj && N && (E = h.enterObject()), N) {
      if (M.explicit !== null) {
        var j = this._decodeTag(h, M.explicit);
        if (h.isError(j))
          return j;
        h = j;
      }
      var O = h.offset;
      if (M.use === null && M.choice === null) {
        if (M.any)
          var T = h.save();
        var z = this._decodeTag(
          h,
          M.implicit !== null ? M.implicit : M.tag,
          M.any
        );
        if (h.isError(z))
          return z;
        M.any ? C = h.raw(T) : h = z;
      }
      if (y && y.track && M.tag !== null && y.track(h.path(), O, h.length, "tagged"), y && y.track && M.tag !== null && y.track(h.path(), h.offset, h.length, "content"), M.any ? C = C : M.choice === null ? C = this._decodeGeneric(M.tag, h, y) : C = this._decodeChoice(h, y), h.isError(C))
        return C;
      if (!M.any && M.choice === null && M.children !== null && M.children.forEach(function(W) {
        W._decode(h, y);
      }), M.contains && (M.tag === "octstr" || M.tag === "bitstr")) {
        var k = new o(C);
        C = this._getUse(M.contains, h._reporterState.obj)._decode(k, y);
      }
    }
    return M.obj && N && (C = h.leaveObject(E)), M.key !== null && (C !== null || N === !0) ? h.leaveKey(w, M.key, C) : w !== null && h.exitKey(w), C;
  }, f.prototype._decodeGeneric = function(h, y, M) {
    var C = this._baseState;
    return h === "seq" || h === "set" ? null : h === "seqof" || h === "setof" ? this._decodeList(y, h, C.args[0], M) : /str$/.test(h) ? this._decodeStr(y, h, M) : h === "objid" && C.args ? this._decodeObjid(y, C.args[0], C.args[1], M) : h === "objid" ? this._decodeObjid(y, null, null, M) : h === "gentime" || h === "utctime" ? this._decodeTime(y, h, M) : h === "null_" ? this._decodeNull(y, M) : h === "bool" ? this._decodeBool(y, M) : h === "objDesc" ? this._decodeStr(y, h, M) : h === "int" || h === "enum" ? this._decodeInt(y, C.args && C.args[0], M) : C.use !== null ? this._getUse(C.use, y._reporterState.obj)._decode(y, M) : y.error("unknown tag: " + h);
  }, f.prototype._getUse = function(h, y) {
    var M = this._baseState;
    return M.useDecoder = this._use(h, y), i(M.useDecoder._baseState.parent === null), M.useDecoder = M.useDecoder._baseState.children[0], M.implicit !== M.useDecoder._baseState.implicit && (M.useDecoder = M.useDecoder.clone(), M.useDecoder._baseState.implicit = M.implicit), M.useDecoder;
  }, f.prototype._decodeChoice = function(h, y) {
    var M = this._baseState, C = null, N = !1;
    return Object.keys(M.choice).some(function(w) {
      var S = h.save(), T = M.choice[w];
      try {
        var E = T._decode(h, y);
        if (h.isError(E))
          return !1;
        C = { type: w, value: E }, N = !0;
      } catch {
        return h.restore(S), !1;
      }
      return !0;
    }, this), N ? C : h.error("Choice not matched");
  }, f.prototype._createEncoderBuffer = function(h) {
    return new t(h, this.reporter);
  }, f.prototype._encode = function(h, y, M) {
    var C = this._baseState;
    if (!(C.default !== null && C.default === h)) {
      var N = this._encodeValue(h, y, M);
      if (N !== void 0 && !this._skipDefault(N, y, M))
        return N;
    }
  }, f.prototype._encodeValue = function(h, y, M) {
    var C = this._baseState;
    if (C.parent === null)
      return C.children[0]._encode(h, y || new e());
    var T = null;
    if (this.reporter = y, C.optional && h === void 0)
      if (C.default !== null)
        h = C.default;
      else
        return;
    var N = null, w = !1;
    if (C.any)
      T = this._createEncoderBuffer(h);
    else if (C.choice)
      T = this._encodeChoice(h, y);
    else if (C.contains)
      N = this._getUse(C.contains, M)._encode(h, y), w = !0;
    else if (C.children)
      N = C.children.map(function(O) {
        if (O._baseState.tag === "null_")
          return O._encode(null, y, h);
        if (O._baseState.key === null)
          return y.error("Child should have a key");
        var z = y.enterKey(O._baseState.key);
        if (typeof h != "object")
          return y.error("Child expected, but input is not object");
        var k = O._encode(h[O._baseState.key], y, h);
        return y.leaveKey(z), k;
      }, this).filter(function(O) {
        return O;
      }), N = this._createEncoderBuffer(N);
    else if (C.tag === "seqof" || C.tag === "setof") {
      if (!(C.args && C.args.length === 1))
        return y.error("Too many args for : " + C.tag);
      if (!Array.isArray(h))
        return y.error("seqof/setof, but data is not Array");
      var S = this.clone();
      S._baseState.implicit = null, N = this._createEncoderBuffer(h.map(function(O) {
        var z = this._baseState;
        return this._getUse(z.args[0], h)._encode(O, y);
      }, S));
    } else C.use !== null ? T = this._getUse(C.use, M)._encode(h, y) : (N = this._encodePrimitive(C.tag, h), w = !0);
    var T;
    if (!C.any && C.choice === null) {
      var E = C.implicit !== null ? C.implicit : C.tag, j = C.implicit === null ? "universal" : "context";
      E === null ? C.use === null && y.error("Tag could be omitted only for .use()") : C.use === null && (T = this._encodeComposite(E, w, j, N));
    }
    return C.explicit !== null && (T = this._encodeComposite(C.explicit, !1, "context", T)), T;
  }, f.prototype._encodeChoice = function(h, y) {
    var M = this._baseState, C = M.choice[h.type];
    return C || i(
      !1,
      h.type + " not found in " + JSON.stringify(Object.keys(M.choice))
    ), C._encode(h.value, y);
  }, f.prototype._encodePrimitive = function(h, y) {
    var M = this._baseState;
    if (/str$/.test(h))
      return this._encodeStr(y, h);
    if (h === "objid" && M.args)
      return this._encodeObjid(y, M.reverseArgs[0], M.args[1]);
    if (h === "objid")
      return this._encodeObjid(y, null, null);
    if (h === "gentime" || h === "utctime")
      return this._encodeTime(y, h);
    if (h === "null_")
      return this._encodeNull();
    if (h === "int" || h === "enum")
      return this._encodeInt(y, M.args && M.reverseArgs[0]);
    if (h === "bool")
      return this._encodeBool(y);
    if (h === "objDesc")
      return this._encodeStr(y, h);
    throw new Error("Unsupported tag: " + h);
  }, f.prototype._isNumstr = function(h) {
    return /^[0-9 ]*$/.test(h);
  }, f.prototype._isPrintstr = function(h) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(h);
  }, sd;
}
var J3;
function Ja() {
  return J3 || (J3 = 1, function(e) {
    var t = e;
    t.Reporter = $A().Reporter, t.DecoderBuffer = $3().DecoderBuffer, t.EncoderBuffer = $3().EncoderBuffer, t.Node = qA();
  }(od)), od;
}
var cd = {}, ld = {}, X3;
function JA() {
  return X3 || (X3 = 1, function(e) {
    var t = TM();
    e.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, e.tagClassByName = t._reverse(e.tagClass), e.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, e.tagByName = t._reverse(e.tag);
  }(ld)), ld;
}
var K3;
function TM() {
  return K3 || (K3 = 1, function(e) {
    var t = e;
    t._reverse = function(i) {
      var c = {};
      return Object.keys(i).forEach(function(n) {
        (n | 0) == n && (n = n | 0);
        var d = i[n];
        c[d] = n;
      }), c;
    }, t.der = JA();
  }(cd)), cd;
}
var fd = {}, ud, e5;
function LM() {
  if (e5) return ud;
  e5 = 1;
  var e = Yt, t = Us(), o = t.base, i = t.bignum, c = t.constants.der;
  function n(l) {
    this.enc = "der", this.name = l.name, this.entity = l, this.tree = new d(), this.tree._init(l.body);
  }
  ud = n, n.prototype.decode = function(h, y) {
    return h instanceof o.DecoderBuffer || (h = new o.DecoderBuffer(h, y)), this.tree._decode(h, y);
  };
  function d(l) {
    o.Node.call(this, "der", l);
  }
  e(d, o.Node), d.prototype._peekTag = function(h, y, M) {
    if (h.isEmpty())
      return !1;
    var C = h.save(), N = f(h, 'Failed to peek tag: "' + y + '"');
    return h.isError(N) ? N : (h.restore(C), N.tag === y || N.tagStr === y || N.tagStr + "of" === y || M);
  }, d.prototype._decodeTag = function(h, y, M) {
    var C = f(
      h,
      'Failed to decode tag of "' + y + '"'
    );
    if (h.isError(C))
      return C;
    var N = p(
      h,
      C.primitive,
      'Failed to get length of "' + y + '"'
    );
    if (h.isError(N))
      return N;
    if (!M && C.tag !== y && C.tagStr !== y && C.tagStr + "of" !== y)
      return h.error('Failed to match tag: "' + y + '"');
    if (C.primitive || N !== null)
      return h.skip(N, 'Failed to match body of: "' + y + '"');
    var w = h.save(), S = this._skipUntilEnd(
      h,
      'Failed to skip indefinite length body: "' + this.tag + '"'
    );
    return h.isError(S) ? S : (N = h.offset - w.offset, h.restore(w), h.skip(N, 'Failed to match body of: "' + y + '"'));
  }, d.prototype._skipUntilEnd = function(h, y) {
    for (; ; ) {
      var M = f(h, y);
      if (h.isError(M))
        return M;
      var C = p(h, M.primitive, y);
      if (h.isError(C))
        return C;
      var N;
      if (M.primitive || C !== null ? N = h.skip(C) : N = this._skipUntilEnd(h, y), h.isError(N))
        return N;
      if (M.tagStr === "end")
        break;
    }
  }, d.prototype._decodeList = function(h, y, M, C) {
    for (var N = []; !h.isEmpty(); ) {
      var w = this._peekTag(h, "end");
      if (h.isError(w))
        return w;
      var S = M.decode(h, "der", C);
      if (h.isError(S) && w)
        break;
      N.push(S);
    }
    return N;
  }, d.prototype._decodeStr = function(h, y) {
    if (y === "bitstr") {
      var M = h.readUInt8();
      return h.isError(M) ? M : { unused: M, data: h.raw() };
    } else if (y === "bmpstr") {
      var C = h.raw();
      if (C.length % 2 === 1)
        return h.error("Decoding of string type: bmpstr length mismatch");
      for (var N = "", w = 0; w < C.length / 2; w++)
        N += String.fromCharCode(C.readUInt16BE(w * 2));
      return N;
    } else if (y === "numstr") {
      var S = h.raw().toString("ascii");
      return this._isNumstr(S) ? S : h.error("Decoding of string type: numstr unsupported characters");
    } else {
      if (y === "octstr")
        return h.raw();
      if (y === "objDesc")
        return h.raw();
      if (y === "printstr") {
        var T = h.raw().toString("ascii");
        return this._isPrintstr(T) ? T : h.error("Decoding of string type: printstr unsupported characters");
      } else return /str$/.test(y) ? h.raw().toString() : h.error("Decoding of string type: " + y + " unsupported");
    }
  }, d.prototype._decodeObjid = function(h, y, M) {
    for (var C, N = [], w = 0; !h.isEmpty(); ) {
      var S = h.readUInt8();
      w <<= 7, w |= S & 127, S & 128 || (N.push(w), w = 0);
    }
    S & 128 && N.push(w);
    var T = N[0] / 40 | 0, E = N[0] % 40;
    if (M ? C = N : C = [T, E].concat(N.slice(1)), y) {
      var j = y[C.join(" ")];
      j === void 0 && (j = y[C.join(".")]), j !== void 0 && (C = j);
    }
    return C;
  }, d.prototype._decodeTime = function(h, y) {
    var M = h.raw().toString();
    if (y === "gentime")
      var C = M.slice(0, 4) | 0, N = M.slice(4, 6) | 0, w = M.slice(6, 8) | 0, S = M.slice(8, 10) | 0, T = M.slice(10, 12) | 0, E = M.slice(12, 14) | 0;
    else if (y === "utctime") {
      var C = M.slice(0, 2) | 0, N = M.slice(2, 4) | 0, w = M.slice(4, 6) | 0, S = M.slice(6, 8) | 0, T = M.slice(8, 10) | 0, E = M.slice(10, 12) | 0;
      C < 70 ? C = 2e3 + C : C = 1900 + C;
    } else
      return h.error("Decoding " + y + " time is not supported yet");
    return Date.UTC(C, N - 1, w, S, T, E, 0);
  }, d.prototype._decodeNull = function(h) {
    return null;
  }, d.prototype._decodeBool = function(h) {
    var y = h.readUInt8();
    return h.isError(y) ? y : y !== 0;
  }, d.prototype._decodeInt = function(h, y) {
    var M = h.raw(), C = new i(M);
    return y && (C = y[C.toString(10)] || C), C;
  }, d.prototype._use = function(h, y) {
    return typeof h == "function" && (h = h(y)), h._getDecoder("der").tree;
  };
  function f(l, h) {
    var y = l.readUInt8(h);
    if (l.isError(y))
      return y;
    var M = c.tagClass[y >> 6], C = (y & 32) === 0;
    if ((y & 31) === 31) {
      var N = y;
      for (y = 0; (N & 128) === 128; ) {
        if (N = l.readUInt8(h), l.isError(N))
          return N;
        y <<= 7, y |= N & 127;
      }
    } else
      y &= 31;
    var w = c.tag[y];
    return {
      cls: M,
      primitive: C,
      tag: y,
      tagStr: w
    };
  }
  function p(l, h, y) {
    var M = l.readUInt8(y);
    if (l.isError(M))
      return M;
    if (!h && M === 128)
      return null;
    if (!(M & 128))
      return M;
    var C = M & 127;
    if (C > 4)
      return l.error("length octect is too long");
    M = 0;
    for (var N = 0; N < C; N++) {
      M <<= 8;
      var w = l.readUInt8(y);
      if (l.isError(w))
        return w;
      M |= w;
    }
    return M;
  }
  return ud;
}
var dd, t5;
function XA() {
  if (t5) return dd;
  t5 = 1;
  var e = Yt, t = Wr.Buffer, o = LM();
  function i(c) {
    o.call(this, c), this.enc = "pem";
  }
  return e(i, o), dd = i, i.prototype.decode = function(n, d) {
    for (var f = n.toString().split(/[\r\n]+/g), p = d.label.toUpperCase(), l = /^-----(BEGIN|END) ([^-]+)-----$/, h = -1, y = -1, M = 0; M < f.length; M++) {
      var C = f[M].match(l);
      if (C !== null && C[2] === p)
        if (h === -1) {
          if (C[1] !== "BEGIN")
            break;
          h = M;
        } else {
          if (C[1] !== "END")
            break;
          y = M;
          break;
        }
    }
    if (h === -1 || y === -1)
      throw new Error("PEM section not found for: " + p);
    var N = f.slice(h + 1, y).join("");
    N.replace(/[^a-z0-9\+\/=]+/gi, "");
    var w = new t(N, "base64");
    return o.prototype.decode.call(this, w, d);
  }, dd;
}
var r5;
function KA() {
  return r5 || (r5 = 1, function(e) {
    var t = e;
    t.der = LM(), t.pem = XA();
  }(fd)), fd;
}
var hd = {}, pd, n5;
function SM() {
  if (n5) return pd;
  n5 = 1;
  var e = Yt, t = Wr.Buffer, o = Us(), i = o.base, c = o.constants.der;
  function n(l) {
    this.enc = "der", this.name = l.name, this.entity = l, this.tree = new d(), this.tree._init(l.body);
  }
  pd = n, n.prototype.encode = function(h, y) {
    return this.tree._encode(h, y).join();
  };
  function d(l) {
    i.Node.call(this, "der", l);
  }
  e(d, i.Node), d.prototype._encodeComposite = function(h, y, M, C) {
    var N = p(h, y, M, this.reporter);
    if (C.length < 128) {
      var T = new t(2);
      return T[0] = N, T[1] = C.length, this._createEncoderBuffer([T, C]);
    }
    for (var w = 1, S = C.length; S >= 256; S >>= 8)
      w++;
    var T = new t(2 + w);
    T[0] = N, T[1] = 128 | w;
    for (var S = 1 + w, E = C.length; E > 0; S--, E >>= 8)
      T[S] = E & 255;
    return this._createEncoderBuffer([T, C]);
  }, d.prototype._encodeStr = function(h, y) {
    if (y === "bitstr")
      return this._createEncoderBuffer([h.unused | 0, h.data]);
    if (y === "bmpstr") {
      for (var M = new t(h.length * 2), C = 0; C < h.length; C++)
        M.writeUInt16BE(h.charCodeAt(C), C * 2);
      return this._createEncoderBuffer(M);
    } else return y === "numstr" ? this._isNumstr(h) ? this._createEncoderBuffer(h) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : y === "printstr" ? this._isPrintstr(h) ? this._createEncoderBuffer(h) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(y) ? this._createEncoderBuffer(h) : y === "objDesc" ? this._createEncoderBuffer(h) : this.reporter.error("Encoding of string type: " + y + " unsupported");
  }, d.prototype._encodeObjid = function(h, y, M) {
    if (typeof h == "string") {
      if (!y)
        return this.reporter.error("string objid given, but no values map found");
      if (!y.hasOwnProperty(h))
        return this.reporter.error("objid not found in values map");
      h = y[h].split(/[\s\.]+/g);
      for (var C = 0; C < h.length; C++)
        h[C] |= 0;
    } else if (Array.isArray(h)) {
      h = h.slice();
      for (var C = 0; C < h.length; C++)
        h[C] |= 0;
    }
    if (!Array.isArray(h))
      return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(h));
    if (!M) {
      if (h[1] >= 40)
        return this.reporter.error("Second objid identifier OOB");
      h.splice(0, 2, h[0] * 40 + h[1]);
    }
    for (var N = 0, C = 0; C < h.length; C++) {
      var w = h[C];
      for (N++; w >= 128; w >>= 7)
        N++;
    }
    for (var S = new t(N), T = S.length - 1, C = h.length - 1; C >= 0; C--) {
      var w = h[C];
      for (S[T--] = w & 127; (w >>= 7) > 0; )
        S[T--] = 128 | w & 127;
    }
    return this._createEncoderBuffer(S);
  };
  function f(l) {
    return l < 10 ? "0" + l : l;
  }
  d.prototype._encodeTime = function(h, y) {
    var M, C = new Date(h);
    return y === "gentime" ? M = [
      f(C.getFullYear()),
      f(C.getUTCMonth() + 1),
      f(C.getUTCDate()),
      f(C.getUTCHours()),
      f(C.getUTCMinutes()),
      f(C.getUTCSeconds()),
      "Z"
    ].join("") : y === "utctime" ? M = [
      f(C.getFullYear() % 100),
      f(C.getUTCMonth() + 1),
      f(C.getUTCDate()),
      f(C.getUTCHours()),
      f(C.getUTCMinutes()),
      f(C.getUTCSeconds()),
      "Z"
    ].join("") : this.reporter.error("Encoding " + y + " time is not supported yet"), this._encodeStr(M, "octstr");
  }, d.prototype._encodeNull = function() {
    return this._createEncoderBuffer("");
  }, d.prototype._encodeInt = function(h, y) {
    if (typeof h == "string") {
      if (!y)
        return this.reporter.error("String int or enum given, but no values map");
      if (!y.hasOwnProperty(h))
        return this.reporter.error("Values map doesn't contain: " + JSON.stringify(h));
      h = y[h];
    }
    if (typeof h != "number" && !t.isBuffer(h)) {
      var M = h.toArray();
      !h.sign && M[0] & 128 && M.unshift(0), h = new t(M);
    }
    if (t.isBuffer(h)) {
      var C = h.length;
      h.length === 0 && C++;
      var w = new t(C);
      return h.copy(w), h.length === 0 && (w[0] = 0), this._createEncoderBuffer(w);
    }
    if (h < 128)
      return this._createEncoderBuffer(h);
    if (h < 256)
      return this._createEncoderBuffer([0, h]);
    for (var C = 1, N = h; N >= 256; N >>= 8)
      C++;
    for (var w = new Array(C), N = w.length - 1; N >= 0; N--)
      w[N] = h & 255, h >>= 8;
    return w[0] & 128 && w.unshift(0), this._createEncoderBuffer(new t(w));
  }, d.prototype._encodeBool = function(h) {
    return this._createEncoderBuffer(h ? 255 : 0);
  }, d.prototype._use = function(h, y) {
    return typeof h == "function" && (h = h(y)), h._getEncoder("der").tree;
  }, d.prototype._skipDefault = function(h, y, M) {
    var C = this._baseState, N;
    if (C.default === null)
      return !1;
    var w = h.join();
    if (C.defaultBuffer === void 0 && (C.defaultBuffer = this._encodeValue(C.default, y, M).join()), w.length !== C.defaultBuffer.length)
      return !1;
    for (N = 0; N < w.length; N++)
      if (w[N] !== C.defaultBuffer[N])
        return !1;
    return !0;
  };
  function p(l, h, y, M) {
    var C;
    if (l === "seqof" ? l = "seq" : l === "setof" && (l = "set"), c.tagByName.hasOwnProperty(l))
      C = c.tagByName[l];
    else if (typeof l == "number" && (l | 0) === l)
      C = l;
    else
      return M.error("Unknown tag: " + l);
    return C >= 31 ? M.error("Multi-octet tag encoding unsupported") : (h || (C |= 32), C |= c.tagClassByName[y || "universal"] << 6, C);
  }
  return pd;
}
var gd, i5;
function eT() {
  if (i5) return gd;
  i5 = 1;
  var e = Yt, t = SM();
  function o(i) {
    t.call(this, i), this.enc = "pem";
  }
  return e(o, t), gd = o, o.prototype.encode = function(c, n) {
    for (var d = t.prototype.encode.call(this, c), f = d.toString("base64"), p = ["-----BEGIN " + n.label + "-----"], l = 0; l < f.length; l += 64)
      p.push(f.slice(l, l + 64));
    return p.push("-----END " + n.label + "-----"), p.join(`
`);
  }, gd;
}
var o5;
function tT() {
  return o5 || (o5 = 1, function(e) {
    var t = e;
    t.der = SM(), t.pem = eT();
  }(hd)), hd;
}
var a5;
function Us() {
  return a5 || (a5 = 1, function(e) {
    var t = e;
    t.bignum = VA(), t.define = GA().define, t.base = Ja(), t.constants = TM(), t.decoders = KA(), t.encoders = tT();
  }(nd)), nd;
}
var yd, s5;
function rT() {
  if (s5) return yd;
  s5 = 1;
  var e = Us(), t = e.define("Time", function() {
    this.choice({
      utcTime: this.utctime(),
      generalTime: this.gentime()
    });
  }), o = e.define("AttributeTypeValue", function() {
    this.seq().obj(
      this.key("type").objid(),
      this.key("value").any()
    );
  }), i = e.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("parameters").optional(),
      this.key("curve").objid().optional()
    );
  }), c = e.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(i),
      this.key("subjectPublicKey").bitstr()
    );
  }), n = e.define("RelativeDistinguishedName", function() {
    this.setof(o);
  }), d = e.define("RDNSequence", function() {
    this.seqof(n);
  }), f = e.define("Name", function() {
    this.choice({
      rdnSequence: this.use(d)
    });
  }), p = e.define("Validity", function() {
    this.seq().obj(
      this.key("notBefore").use(t),
      this.key("notAfter").use(t)
    );
  }), l = e.define("Extension", function() {
    this.seq().obj(
      this.key("extnID").objid(),
      this.key("critical").bool().def(!1),
      this.key("extnValue").octstr()
    );
  }), h = e.define("TBSCertificate", function() {
    this.seq().obj(
      this.key("version").explicit(0).int().optional(),
      this.key("serialNumber").int(),
      this.key("signature").use(i),
      this.key("issuer").use(f),
      this.key("validity").use(p),
      this.key("subject").use(f),
      this.key("subjectPublicKeyInfo").use(c),
      this.key("issuerUniqueID").implicit(1).bitstr().optional(),
      this.key("subjectUniqueID").implicit(2).bitstr().optional(),
      this.key("extensions").explicit(3).seqof(l).optional()
    );
  }), y = e.define("X509Certificate", function() {
    this.seq().obj(
      this.key("tbsCertificate").use(h),
      this.key("signatureAlgorithm").use(i),
      this.key("signatureValue").bitstr()
    );
  });
  return yd = y, yd;
}
var c5;
function nT() {
  if (c5) return On;
  c5 = 1;
  var e = Us();
  On.certificate = rT();
  var t = e.define("RSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("modulus").int(),
      this.key("publicExponent").int(),
      this.key("privateExponent").int(),
      this.key("prime1").int(),
      this.key("prime2").int(),
      this.key("exponent1").int(),
      this.key("exponent2").int(),
      this.key("coefficient").int()
    );
  });
  On.RSAPrivateKey = t;
  var o = e.define("RSAPublicKey", function() {
    this.seq().obj(
      this.key("modulus").int(),
      this.key("publicExponent").int()
    );
  });
  On.RSAPublicKey = o;
  var i = e.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("none").null_().optional(),
      this.key("curve").objid().optional(),
      this.key("params").seq().obj(
        this.key("p").int(),
        this.key("q").int(),
        this.key("g").int()
      ).optional()
    );
  }), c = e.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(i),
      this.key("subjectPublicKey").bitstr()
    );
  });
  On.PublicKey = c;
  var n = e.define("PrivateKeyInfo", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("algorithm").use(i),
      this.key("subjectPrivateKey").octstr()
    );
  });
  On.PrivateKey = n;
  var d = e.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").seq().obj(
        this.key("id").objid(),
        this.key("decrypt").seq().obj(
          this.key("kde").seq().obj(
            this.key("id").objid(),
            this.key("kdeparams").seq().obj(
              this.key("salt").octstr(),
              this.key("iters").int()
            )
          ),
          this.key("cipher").seq().obj(
            this.key("algo").objid(),
            this.key("iv").octstr()
          )
        )
      ),
      this.key("subjectPrivateKey").octstr()
    );
  });
  On.EncryptedPrivateKey = d;
  var f = e.define("DSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int(),
      this.key("pub_key").int(),
      this.key("priv_key").int()
    );
  });
  On.DSAPrivateKey = f, On.DSAparam = e.define("DSAparam", function() {
    this.int();
  });
  var p = e.define("ECParameters", function() {
    this.choice({
      namedCurve: this.objid()
    });
  }), l = e.define("ECPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("privateKey").octstr(),
      this.key("parameters").optional().explicit(0).use(p),
      this.key("publicKey").optional().explicit(1).bitstr()
    );
  });
  return On.ECPrivateKey = l, On.signature = e.define("signature", function() {
    this.seq().obj(
      this.key("r").int(),
      this.key("s").int()
    );
  }), On;
}
const iT = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};
var Md, l5;
function oT() {
  if (l5) return Md;
  l5 = 1;
  var e = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, t = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, o = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, i = Qc(), c = vh(), n = Gt.Buffer;
  return Md = function(d, f) {
    var p = d.toString(), l = p.match(e), h;
    if (l) {
      var M = "aes" + l[1], C = n.from(l[2], "hex"), N = n.from(l[3].replace(/[\r\n]/g, ""), "base64"), w = i(f, C.slice(0, 8), parseInt(l[1], 10)).key, S = [], T = c.createDecipheriv(M, w, C);
      S.push(T.update(N)), S.push(T.final()), h = n.concat(S);
    } else {
      var y = p.match(o);
      h = n.from(y[2].replace(/[\r\n]/g, ""), "base64");
    }
    var E = p.match(t)[1];
    return {
      tag: E,
      data: h
    };
  }, Md;
}
var md, f5;
function qc() {
  if (f5) return md;
  f5 = 1;
  var e = nT(), t = iT, o = oT(), i = vh(), c = sM(), n = Gt.Buffer;
  function d(p, l) {
    var h = p.algorithm.decrypt.kde.kdeparams.salt, y = parseInt(p.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), M = t[p.algorithm.decrypt.cipher.algo.join(".")], C = p.algorithm.decrypt.cipher.iv, N = p.subjectPrivateKey, w = parseInt(M.split("-")[1], 10) / 8, S = c.pbkdf2Sync(l, h, y, w, "sha1"), T = i.createDecipheriv(M, S, C), E = [];
    return E.push(T.update(N)), E.push(T.final()), n.concat(E);
  }
  function f(p) {
    var l;
    typeof p == "object" && !n.isBuffer(p) && (l = p.passphrase, p = p.key), typeof p == "string" && (p = n.from(p));
    var h = o(p, l), y = h.tag, M = h.data, C, N;
    switch (y) {
      case "CERTIFICATE":
        N = e.certificate.decode(M, "der").tbsCertificate.subjectPublicKeyInfo;
      case "PUBLIC KEY":
        switch (N || (N = e.PublicKey.decode(M, "der")), C = N.algorithm.algorithm.join("."), C) {
          case "1.2.840.113549.1.1.1":
            return e.RSAPublicKey.decode(N.subjectPublicKey.data, "der");
          case "1.2.840.10045.2.1":
            return N.subjectPrivateKey = N.subjectPublicKey, {
              type: "ec",
              data: N
            };
          case "1.2.840.10040.4.1":
            return N.algorithm.params.pub_key = e.DSAparam.decode(N.subjectPublicKey.data, "der"), {
              type: "dsa",
              data: N.algorithm.params
            };
          default:
            throw new Error("unknown key id " + C);
        }
      case "ENCRYPTED PRIVATE KEY":
        M = e.EncryptedPrivateKey.decode(M, "der"), M = d(M, l);
      case "PRIVATE KEY":
        switch (N = e.PrivateKey.decode(M, "der"), C = N.algorithm.algorithm.join("."), C) {
          case "1.2.840.113549.1.1.1":
            return e.RSAPrivateKey.decode(N.subjectPrivateKey, "der");
          case "1.2.840.10045.2.1":
            return {
              curve: N.algorithm.curve,
              privateKey: e.ECPrivateKey.decode(N.subjectPrivateKey, "der").privateKey
            };
          case "1.2.840.10040.4.1":
            return N.algorithm.params.priv_key = e.DSAparam.decode(N.subjectPrivateKey, "der"), {
              type: "dsa",
              params: N.algorithm.params
            };
          default:
            throw new Error("unknown key id " + C);
        }
      case "RSA PUBLIC KEY":
        return e.RSAPublicKey.decode(M, "der");
      case "RSA PRIVATE KEY":
        return e.RSAPrivateKey.decode(M, "der");
      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: e.DSAPrivateKey.decode(M, "der")
        };
      case "EC PRIVATE KEY":
        return M = e.ECPrivateKey.decode(M, "der"), {
          curve: M.parameters.value,
          privateKey: M.privateKey
        };
      default:
        throw new Error("unknown key type " + y);
    }
  }
  return f.signature = e.signature, md = f, md;
}
const EM = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
};
var u5;
function aT() {
  if (u5) return ja.exports;
  u5 = 1;
  var e = Gt.Buffer, t = tM(), o = xh(), i = Ih().ec, c = Y1, n = qc(), d = EM, f = 1;
  function p(T, E, j, O, z) {
    var k = n(E);
    if (k.curve) {
      if (O !== "ecdsa" && O !== "ecdsa/rsa")
        throw new Error("wrong private key type");
      return l(T, k);
    } else if (k.type === "dsa") {
      if (O !== "dsa")
        throw new Error("wrong private key type");
      return h(T, k, j);
    }
    if (O !== "rsa" && O !== "ecdsa/rsa")
      throw new Error("wrong private key type");
    if (E.padding !== void 0 && E.padding !== f)
      throw new Error("illegal or unsupported padding mode");
    T = e.concat([z, T]);
    for (var H = k.modulus.byteLength(), W = [0, 1]; T.length + W.length + 1 < H; )
      W.push(255);
    W.push(0);
    for (var U = -1; ++U < T.length; )
      W.push(T[U]);
    var B = o(W, k);
    return B;
  }
  function l(T, E) {
    var j = d[E.curve.join(".")];
    if (!j)
      throw new Error("unknown curve " + E.curve.join("."));
    var O = new i(j), z = O.keyFromPrivate(E.privateKey), k = z.sign(T);
    return e.from(k.toDER());
  }
  function h(T, E, j) {
    for (var O = E.params.priv_key, z = E.params.p, k = E.params.q, H = E.params.g, W = new c(0), U, B = C(T, k).mod(k), I = !1, r = M(O, k, T, j); I === !1; )
      U = w(k, r, j), W = S(H, U, z, k), I = U.invm(k).imul(B.add(O.mul(W))).mod(k), I.cmpn(0) === 0 && (I = !1, W = new c(0));
    return y(W, I);
  }
  function y(T, E) {
    T = T.toArray(), E = E.toArray(), T[0] & 128 && (T = [0].concat(T)), E[0] & 128 && (E = [0].concat(E));
    var j = T.length + E.length + 4, O = [
      48,
      j,
      2,
      T.length
    ];
    return O = O.concat(T, [2, E.length], E), e.from(O);
  }
  function M(T, E, j, O) {
    if (T = e.from(T.toArray()), T.length < E.byteLength()) {
      var z = e.alloc(E.byteLength() - T.length);
      T = e.concat([z, T]);
    }
    var k = j.length, H = N(j, E), W = e.alloc(k);
    W.fill(1);
    var U = e.alloc(k);
    return U = t(O, U).update(W).update(e.from([0])).update(T).update(H).digest(), W = t(O, U).update(W).digest(), U = t(O, U).update(W).update(e.from([1])).update(T).update(H).digest(), W = t(O, U).update(W).digest(), { k: U, v: W };
  }
  function C(T, E) {
    var j = new c(T), O = (T.length << 3) - E.bitLength();
    return O > 0 && j.ishrn(O), j;
  }
  function N(T, E) {
    T = C(T, E), T = T.mod(E);
    var j = e.from(T.toArray());
    if (j.length < E.byteLength()) {
      var O = e.alloc(E.byteLength() - j.length);
      j = e.concat([O, j]);
    }
    return j;
  }
  function w(T, E, j) {
    var O, z;
    do {
      for (O = e.alloc(0); O.length * 8 < T.bitLength(); )
        E.v = t(j, E.k).update(E.v).digest(), O = e.concat([O, E.v]);
      z = C(O, T), E.k = t(j, E.k).update(E.v).update(e.from([0])).digest(), E.v = t(j, E.k).update(E.v).digest();
    } while (z.cmp(T) !== -1);
    return z;
  }
  function S(T, E, j, O) {
    return T.toRed(c.mont(j)).redPow(E).fromRed().mod(O);
  }
  return ja.exports = p, ja.exports.getKey = M, ja.exports.makeKey = w, ja.exports;
}
var vd, d5;
function sT() {
  if (d5) return vd;
  d5 = 1;
  var e = Gt.Buffer, t = Y1, o = Ih().ec, i = qc(), c = EM;
  function n(l, h, y, M, C) {
    var N = i(y);
    if (N.type === "ec") {
      if (M !== "ecdsa" && M !== "ecdsa/rsa")
        throw new Error("wrong public key type");
      return d(l, h, N);
    } else if (N.type === "dsa") {
      if (M !== "dsa")
        throw new Error("wrong public key type");
      return f(l, h, N);
    }
    if (M !== "rsa" && M !== "ecdsa/rsa")
      throw new Error("wrong public key type");
    h = e.concat([C, h]);
    for (var w = N.modulus.byteLength(), S = [1], T = 0; h.length + S.length + 2 < w; )
      S.push(255), T += 1;
    S.push(0);
    for (var E = -1; ++E < h.length; )
      S.push(h[E]);
    S = e.from(S);
    var j = t.mont(N.modulus);
    l = new t(l).toRed(j), l = l.redPow(new t(N.publicExponent)), l = e.from(l.fromRed().toArray());
    var O = T < 8 ? 1 : 0;
    for (w = Math.min(l.length, S.length), l.length !== S.length && (O = 1), E = -1; ++E < w; )
      O |= l[E] ^ S[E];
    return O === 0;
  }
  function d(l, h, y) {
    var M = c[y.data.algorithm.curve.join(".")];
    if (!M)
      throw new Error("unknown curve " + y.data.algorithm.curve.join("."));
    var C = new o(M), N = y.data.subjectPrivateKey.data;
    return C.verify(h, l, N);
  }
  function f(l, h, y) {
    var M = y.data.p, C = y.data.q, N = y.data.g, w = y.data.pub_key, S = i.signature.decode(l, "der"), T = S.s, E = S.r;
    p(T, C), p(E, C);
    var j = t.mont(M), O = T.invm(C), z = N.toRed(j).redPow(new t(h).mul(O).mod(C)).fromRed().mul(w.toRed(j).redPow(E.mul(O).mod(C)).fromRed()).mod(M).mod(C);
    return z.cmp(E) === 0;
  }
  function p(l, h) {
    if (l.cmpn(0) <= 0)
      throw new Error("invalid sig");
    if (l.cmp(h) >= 0)
      throw new Error("invalid sig");
  }
  return vd = n, vd;
}
var bd, h5;
function cT() {
  if (h5) return bd;
  h5 = 1;
  var e = Gt.Buffer, t = Bs(), o = TA(), i = Yt, c = aT(), n = sT(), d = rM;
  Object.keys(d).forEach(function(y) {
    d[y].id = e.from(d[y].id, "hex"), d[y.toLowerCase()] = d[y];
  });
  function f(y) {
    o.Writable.call(this);
    var M = d[y];
    if (!M)
      throw new Error("Unknown message digest");
    this._hashType = M.hash, this._hash = t(M.hash), this._tag = M.id, this._signType = M.sign;
  }
  i(f, o.Writable), f.prototype._write = function(M, C, N) {
    this._hash.update(M), N();
  }, f.prototype.update = function(M, C) {
    return this._hash.update(typeof M == "string" ? e.from(M, C) : M), this;
  }, f.prototype.sign = function(M, C) {
    this.end();
    var N = this._hash.digest(), w = c(N, M, this._hashType, this._signType, this._tag);
    return C ? w.toString(C) : w;
  };
  function p(y) {
    o.Writable.call(this);
    var M = d[y];
    if (!M)
      throw new Error("Unknown message digest");
    this._hash = t(M.hash), this._tag = M.id, this._signType = M.sign;
  }
  i(p, o.Writable), p.prototype._write = function(M, C, N) {
    this._hash.update(M), N();
  }, p.prototype.update = function(M, C) {
    return this._hash.update(typeof M == "string" ? e.from(M, C) : M), this;
  }, p.prototype.verify = function(M, C, N) {
    var w = typeof C == "string" ? e.from(C, N) : C;
    this.end();
    var S = this._hash.digest();
    return n(w, S, M, this._signType, this._tag);
  };
  function l(y) {
    return new f(y);
  }
  function h(y) {
    return new p(y);
  }
  return bd = {
    Sign: l,
    Verify: h,
    createSign: l,
    createVerify: h
  }, bd;
}
var Q0 = { exports: {} };
Q0.exports;
var p5;
function lT() {
  return p5 || (p5 = 1, function(e) {
    (function(t, o) {
      function i(I, r) {
        if (!I) throw new Error(r || "Assertion failed");
      }
      function c(I, r) {
        I.super_ = r;
        var s = function() {
        };
        s.prototype = r.prototype, I.prototype = new s(), I.prototype.constructor = I;
      }
      function n(I, r, s) {
        if (n.isBN(I))
          return I;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, I !== null && ((r === "le" || r === "be") && (s = r, r = 10), this._init(I || 0, r || 10, s || "be"));
      }
      typeof t == "object" ? t.exports = n : o.BN = n, n.BN = n, n.wordSize = 26;
      var d;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? d = window.Buffer : d = Wr.Buffer;
      } catch {
      }
      n.isBN = function(r) {
        return r instanceof n ? !0 : r !== null && typeof r == "object" && r.constructor.wordSize === n.wordSize && Array.isArray(r.words);
      }, n.max = function(r, s) {
        return r.cmp(s) > 0 ? r : s;
      }, n.min = function(r, s) {
        return r.cmp(s) < 0 ? r : s;
      }, n.prototype._init = function(r, s, u) {
        if (typeof r == "number")
          return this._initNumber(r, s, u);
        if (typeof r == "object")
          return this._initArray(r, s, u);
        s === "hex" && (s = 16), i(s === (s | 0) && s >= 2 && s <= 36), r = r.toString().replace(/\s+/g, "");
        var g = 0;
        r[0] === "-" && (g++, this.negative = 1), g < r.length && (s === 16 ? this._parseHex(r, g, u) : (this._parseBase(r, s, g), u === "le" && this._initArray(this.toArray(), s, u)));
      }, n.prototype._initNumber = function(r, s, u) {
        r < 0 && (this.negative = 1, r = -r), r < 67108864 ? (this.words = [r & 67108863], this.length = 1) : r < 4503599627370496 ? (this.words = [
          r & 67108863,
          r / 67108864 & 67108863
        ], this.length = 2) : (i(r < 9007199254740992), this.words = [
          r & 67108863,
          r / 67108864 & 67108863,
          1
        ], this.length = 3), u === "le" && this._initArray(this.toArray(), s, u);
      }, n.prototype._initArray = function(r, s, u) {
        if (i(typeof r.length == "number"), r.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(r.length / 3), this.words = new Array(this.length);
        for (var g = 0; g < this.length; g++)
          this.words[g] = 0;
        var v, A, L = 0;
        if (u === "be")
          for (g = r.length - 1, v = 0; g >= 0; g -= 3)
            A = r[g] | r[g - 1] << 8 | r[g - 2] << 16, this.words[v] |= A << L & 67108863, this.words[v + 1] = A >>> 26 - L & 67108863, L += 24, L >= 26 && (L -= 26, v++);
        else if (u === "le")
          for (g = 0, v = 0; g < r.length; g += 3)
            A = r[g] | r[g + 1] << 8 | r[g + 2] << 16, this.words[v] |= A << L & 67108863, this.words[v + 1] = A >>> 26 - L & 67108863, L += 24, L >= 26 && (L -= 26, v++);
        return this.strip();
      };
      function f(I, r) {
        var s = I.charCodeAt(r);
        return s >= 65 && s <= 70 ? s - 55 : s >= 97 && s <= 102 ? s - 87 : s - 48 & 15;
      }
      function p(I, r, s) {
        var u = f(I, s);
        return s - 1 >= r && (u |= f(I, s - 1) << 4), u;
      }
      n.prototype._parseHex = function(r, s, u) {
        this.length = Math.ceil((r.length - s) / 6), this.words = new Array(this.length);
        for (var g = 0; g < this.length; g++)
          this.words[g] = 0;
        var v = 0, A = 0, L;
        if (u === "be")
          for (g = r.length - 1; g >= s; g -= 2)
            L = p(r, s, g) << v, this.words[A] |= L & 67108863, v >= 18 ? (v -= 18, A += 1, this.words[A] |= L >>> 26) : v += 8;
        else {
          var m = r.length - s;
          for (g = m % 2 === 0 ? s + 1 : s; g < r.length; g += 2)
            L = p(r, s, g) << v, this.words[A] |= L & 67108863, v >= 18 ? (v -= 18, A += 1, this.words[A] |= L >>> 26) : v += 8;
        }
        this.strip();
      };
      function l(I, r, s, u) {
        for (var g = 0, v = Math.min(I.length, s), A = r; A < v; A++) {
          var L = I.charCodeAt(A) - 48;
          g *= u, L >= 49 ? g += L - 49 + 10 : L >= 17 ? g += L - 17 + 10 : g += L;
        }
        return g;
      }
      n.prototype._parseBase = function(r, s, u) {
        this.words = [0], this.length = 1;
        for (var g = 0, v = 1; v <= 67108863; v *= s)
          g++;
        g--, v = v / s | 0;
        for (var A = r.length - u, L = A % g, m = Math.min(A, A - L) + u, a = 0, x = u; x < m; x += g)
          a = l(r, x, x + g, s), this.imuln(v), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        if (L !== 0) {
          var V = 1;
          for (a = l(r, x, r.length, s), x = 0; x < L; x++)
            V *= s;
          this.imuln(V), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        }
        this.strip();
      }, n.prototype.copy = function(r) {
        r.words = new Array(this.length);
        for (var s = 0; s < this.length; s++)
          r.words[s] = this.words[s];
        r.length = this.length, r.negative = this.negative, r.red = this.red;
      }, n.prototype.clone = function() {
        var r = new n(null);
        return this.copy(r), r;
      }, n.prototype._expand = function(r) {
        for (; this.length < r; )
          this.words[this.length++] = 0;
        return this;
      }, n.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, n.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, n.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var h = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], y = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], M = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      n.prototype.toString = function(r, s) {
        r = r || 10, s = s | 0 || 1;
        var u;
        if (r === 16 || r === "hex") {
          u = "";
          for (var g = 0, v = 0, A = 0; A < this.length; A++) {
            var L = this.words[A], m = ((L << g | v) & 16777215).toString(16);
            v = L >>> 24 - g & 16777215, g += 2, g >= 26 && (g -= 26, A--), v !== 0 || A !== this.length - 1 ? u = h[6 - m.length] + m + u : u = m + u;
          }
          for (v !== 0 && (u = v.toString(16) + u); u.length % s !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        if (r === (r | 0) && r >= 2 && r <= 36) {
          var a = y[r], x = M[r];
          u = "";
          var V = this.clone();
          for (V.negative = 0; !V.isZero(); ) {
            var G = V.modn(x).toString(r);
            V = V.idivn(x), V.isZero() ? u = G + u : u = h[a - G.length] + G + u;
          }
          for (this.isZero() && (u = "0" + u); u.length % s !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        i(!1, "Base should be between 2 and 36");
      }, n.prototype.toNumber = function() {
        var r = this.words[0];
        return this.length === 2 ? r += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? r += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -r : r;
      }, n.prototype.toJSON = function() {
        return this.toString(16);
      }, n.prototype.toBuffer = function(r, s) {
        return i(typeof d < "u"), this.toArrayLike(d, r, s);
      }, n.prototype.toArray = function(r, s) {
        return this.toArrayLike(Array, r, s);
      }, n.prototype.toArrayLike = function(r, s, u) {
        var g = this.byteLength(), v = u || Math.max(1, g);
        i(g <= v, "byte array longer than desired length"), i(v > 0, "Requested array length <= 0"), this.strip();
        var A = s === "le", L = new r(v), m, a, x = this.clone();
        if (A) {
          for (a = 0; !x.isZero(); a++)
            m = x.andln(255), x.iushrn(8), L[a] = m;
          for (; a < v; a++)
            L[a] = 0;
        } else {
          for (a = 0; a < v - g; a++)
            L[a] = 0;
          for (a = 0; !x.isZero(); a++)
            m = x.andln(255), x.iushrn(8), L[v - a - 1] = m;
        }
        return L;
      }, Math.clz32 ? n.prototype._countBits = function(r) {
        return 32 - Math.clz32(r);
      } : n.prototype._countBits = function(r) {
        var s = r, u = 0;
        return s >= 4096 && (u += 13, s >>>= 13), s >= 64 && (u += 7, s >>>= 7), s >= 8 && (u += 4, s >>>= 4), s >= 2 && (u += 2, s >>>= 2), u + s;
      }, n.prototype._zeroBits = function(r) {
        if (r === 0) return 26;
        var s = r, u = 0;
        return s & 8191 || (u += 13, s >>>= 13), s & 127 || (u += 7, s >>>= 7), s & 15 || (u += 4, s >>>= 4), s & 3 || (u += 2, s >>>= 2), s & 1 || u++, u;
      }, n.prototype.bitLength = function() {
        var r = this.words[this.length - 1], s = this._countBits(r);
        return (this.length - 1) * 26 + s;
      };
      function C(I) {
        for (var r = new Array(I.bitLength()), s = 0; s < r.length; s++) {
          var u = s / 26 | 0, g = s % 26;
          r[s] = (I.words[u] & 1 << g) >>> g;
        }
        return r;
      }
      n.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var r = 0, s = 0; s < this.length; s++) {
          var u = this._zeroBits(this.words[s]);
          if (r += u, u !== 26) break;
        }
        return r;
      }, n.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, n.prototype.toTwos = function(r) {
        return this.negative !== 0 ? this.abs().inotn(r).iaddn(1) : this.clone();
      }, n.prototype.fromTwos = function(r) {
        return this.testn(r - 1) ? this.notn(r).iaddn(1).ineg() : this.clone();
      }, n.prototype.isNeg = function() {
        return this.negative !== 0;
      }, n.prototype.neg = function() {
        return this.clone().ineg();
      }, n.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, n.prototype.iuor = function(r) {
        for (; this.length < r.length; )
          this.words[this.length++] = 0;
        for (var s = 0; s < r.length; s++)
          this.words[s] = this.words[s] | r.words[s];
        return this.strip();
      }, n.prototype.ior = function(r) {
        return i((this.negative | r.negative) === 0), this.iuor(r);
      }, n.prototype.or = function(r) {
        return this.length > r.length ? this.clone().ior(r) : r.clone().ior(this);
      }, n.prototype.uor = function(r) {
        return this.length > r.length ? this.clone().iuor(r) : r.clone().iuor(this);
      }, n.prototype.iuand = function(r) {
        var s;
        this.length > r.length ? s = r : s = this;
        for (var u = 0; u < s.length; u++)
          this.words[u] = this.words[u] & r.words[u];
        return this.length = s.length, this.strip();
      }, n.prototype.iand = function(r) {
        return i((this.negative | r.negative) === 0), this.iuand(r);
      }, n.prototype.and = function(r) {
        return this.length > r.length ? this.clone().iand(r) : r.clone().iand(this);
      }, n.prototype.uand = function(r) {
        return this.length > r.length ? this.clone().iuand(r) : r.clone().iuand(this);
      }, n.prototype.iuxor = function(r) {
        var s, u;
        this.length > r.length ? (s = this, u = r) : (s = r, u = this);
        for (var g = 0; g < u.length; g++)
          this.words[g] = s.words[g] ^ u.words[g];
        if (this !== s)
          for (; g < s.length; g++)
            this.words[g] = s.words[g];
        return this.length = s.length, this.strip();
      }, n.prototype.ixor = function(r) {
        return i((this.negative | r.negative) === 0), this.iuxor(r);
      }, n.prototype.xor = function(r) {
        return this.length > r.length ? this.clone().ixor(r) : r.clone().ixor(this);
      }, n.prototype.uxor = function(r) {
        return this.length > r.length ? this.clone().iuxor(r) : r.clone().iuxor(this);
      }, n.prototype.inotn = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = Math.ceil(r / 26) | 0, u = r % 26;
        this._expand(s), u > 0 && s--;
        for (var g = 0; g < s; g++)
          this.words[g] = ~this.words[g] & 67108863;
        return u > 0 && (this.words[g] = ~this.words[g] & 67108863 >> 26 - u), this.strip();
      }, n.prototype.notn = function(r) {
        return this.clone().inotn(r);
      }, n.prototype.setn = function(r, s) {
        i(typeof r == "number" && r >= 0);
        var u = r / 26 | 0, g = r % 26;
        return this._expand(u + 1), s ? this.words[u] = this.words[u] | 1 << g : this.words[u] = this.words[u] & ~(1 << g), this.strip();
      }, n.prototype.iadd = function(r) {
        var s;
        if (this.negative !== 0 && r.negative === 0)
          return this.negative = 0, s = this.isub(r), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && r.negative !== 0)
          return r.negative = 0, s = this.isub(r), r.negative = 1, s._normSign();
        var u, g;
        this.length > r.length ? (u = this, g = r) : (u = r, g = this);
        for (var v = 0, A = 0; A < g.length; A++)
          s = (u.words[A] | 0) + (g.words[A] | 0) + v, this.words[A] = s & 67108863, v = s >>> 26;
        for (; v !== 0 && A < u.length; A++)
          s = (u.words[A] | 0) + v, this.words[A] = s & 67108863, v = s >>> 26;
        if (this.length = u.length, v !== 0)
          this.words[this.length] = v, this.length++;
        else if (u !== this)
          for (; A < u.length; A++)
            this.words[A] = u.words[A];
        return this;
      }, n.prototype.add = function(r) {
        var s;
        return r.negative !== 0 && this.negative === 0 ? (r.negative = 0, s = this.sub(r), r.negative ^= 1, s) : r.negative === 0 && this.negative !== 0 ? (this.negative = 0, s = r.sub(this), this.negative = 1, s) : this.length > r.length ? this.clone().iadd(r) : r.clone().iadd(this);
      }, n.prototype.isub = function(r) {
        if (r.negative !== 0) {
          r.negative = 0;
          var s = this.iadd(r);
          return r.negative = 1, s._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(r), this.negative = 1, this._normSign();
        var u = this.cmp(r);
        if (u === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var g, v;
        u > 0 ? (g = this, v = r) : (g = r, v = this);
        for (var A = 0, L = 0; L < v.length; L++)
          s = (g.words[L] | 0) - (v.words[L] | 0) + A, A = s >> 26, this.words[L] = s & 67108863;
        for (; A !== 0 && L < g.length; L++)
          s = (g.words[L] | 0) + A, A = s >> 26, this.words[L] = s & 67108863;
        if (A === 0 && L < g.length && g !== this)
          for (; L < g.length; L++)
            this.words[L] = g.words[L];
        return this.length = Math.max(this.length, L), g !== this && (this.negative = 1), this.strip();
      }, n.prototype.sub = function(r) {
        return this.clone().isub(r);
      };
      function N(I, r, s) {
        s.negative = r.negative ^ I.negative;
        var u = I.length + r.length | 0;
        s.length = u, u = u - 1 | 0;
        var g = I.words[0] | 0, v = r.words[0] | 0, A = g * v, L = A & 67108863, m = A / 67108864 | 0;
        s.words[0] = L;
        for (var a = 1; a < u; a++) {
          for (var x = m >>> 26, V = m & 67108863, G = Math.min(a, r.length - 1), Z = Math.max(0, a - I.length + 1); Z <= G; Z++) {
            var te = a - Z | 0;
            g = I.words[te] | 0, v = r.words[Z] | 0, A = g * v + V, x += A / 67108864 | 0, V = A & 67108863;
          }
          s.words[a] = V | 0, m = x | 0;
        }
        return m !== 0 ? s.words[a] = m | 0 : s.length--, s.strip();
      }
      var w = function(r, s, u) {
        var g = r.words, v = s.words, A = u.words, L = 0, m, a, x, V = g[0] | 0, G = V & 8191, Z = V >>> 13, te = g[1] | 0, q = te & 8191, R = te >>> 13, Q = g[2] | 0, $ = Q & 8191, F = Q >>> 13, P = g[3] | 0, _ = P & 8191, X = P >>> 13, le = g[4] | 0, ie = le & 8191, oe = le >>> 13, pe = g[5] | 0, se = pe & 8191, ce = pe >>> 13, me = g[6] | 0, de = me & 8191, ae = me >>> 13, Le = g[7] | 0, ye = Le & 8191, Me = Le >>> 13, at = g[8] | 0, Ne = at & 8191, Ae = at >>> 13, pt = g[9] | 0, ke = pt & 8191, Te = pt >>> 13, Dt = v[0] | 0, De = Dt & 8191, je = Dt >>> 13, At = v[1] | 0, xe = At & 8191, Ie = At >>> 13, Nt = v[2] | 0, _e = Nt & 8191, Be = Nt >>> 13, Xt = v[3] | 0, Re = Xt & 8191, Pe = Xt >>> 13, dr = v[4] | 0, We = dr & 8191, He = dr >>> 13, Ct = v[5] | 0, Ue = Ct & 8191, Ze = Ct >>> 13, Fr = v[6] | 0, Ye = Fr & 8191, Qe = Fr >>> 13, J = v[7] | 0, ee = J & 8191, K = J >>> 13, Y = v[8] | 0, re = Y & 8191, he = Y >>> 13, Se = v[9] | 0, ve = Se & 8191, we = Se >>> 13;
        u.negative = r.negative ^ s.negative, u.length = 19, m = Math.imul(G, De), a = Math.imul(G, je), a = a + Math.imul(Z, De) | 0, x = Math.imul(Z, je);
        var lt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (lt >>> 26) | 0, lt &= 67108863, m = Math.imul(q, De), a = Math.imul(q, je), a = a + Math.imul(R, De) | 0, x = Math.imul(R, je), m = m + Math.imul(G, xe) | 0, a = a + Math.imul(G, Ie) | 0, a = a + Math.imul(Z, xe) | 0, x = x + Math.imul(Z, Ie) | 0;
        var et = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (et >>> 26) | 0, et &= 67108863, m = Math.imul($, De), a = Math.imul($, je), a = a + Math.imul(F, De) | 0, x = Math.imul(F, je), m = m + Math.imul(q, xe) | 0, a = a + Math.imul(q, Ie) | 0, a = a + Math.imul(R, xe) | 0, x = x + Math.imul(R, Ie) | 0, m = m + Math.imul(G, _e) | 0, a = a + Math.imul(G, Be) | 0, a = a + Math.imul(Z, _e) | 0, x = x + Math.imul(Z, Be) | 0;
        var Lt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Lt >>> 26) | 0, Lt &= 67108863, m = Math.imul(_, De), a = Math.imul(_, je), a = a + Math.imul(X, De) | 0, x = Math.imul(X, je), m = m + Math.imul($, xe) | 0, a = a + Math.imul($, Ie) | 0, a = a + Math.imul(F, xe) | 0, x = x + Math.imul(F, Ie) | 0, m = m + Math.imul(q, _e) | 0, a = a + Math.imul(q, Be) | 0, a = a + Math.imul(R, _e) | 0, x = x + Math.imul(R, Be) | 0, m = m + Math.imul(G, Re) | 0, a = a + Math.imul(G, Pe) | 0, a = a + Math.imul(Z, Re) | 0, x = x + Math.imul(Z, Pe) | 0;
        var nt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (nt >>> 26) | 0, nt &= 67108863, m = Math.imul(ie, De), a = Math.imul(ie, je), a = a + Math.imul(oe, De) | 0, x = Math.imul(oe, je), m = m + Math.imul(_, xe) | 0, a = a + Math.imul(_, Ie) | 0, a = a + Math.imul(X, xe) | 0, x = x + Math.imul(X, Ie) | 0, m = m + Math.imul($, _e) | 0, a = a + Math.imul($, Be) | 0, a = a + Math.imul(F, _e) | 0, x = x + Math.imul(F, Be) | 0, m = m + Math.imul(q, Re) | 0, a = a + Math.imul(q, Pe) | 0, a = a + Math.imul(R, Re) | 0, x = x + Math.imul(R, Pe) | 0, m = m + Math.imul(G, We) | 0, a = a + Math.imul(G, He) | 0, a = a + Math.imul(Z, We) | 0, x = x + Math.imul(Z, He) | 0;
        var gt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, m = Math.imul(se, De), a = Math.imul(se, je), a = a + Math.imul(ce, De) | 0, x = Math.imul(ce, je), m = m + Math.imul(ie, xe) | 0, a = a + Math.imul(ie, Ie) | 0, a = a + Math.imul(oe, xe) | 0, x = x + Math.imul(oe, Ie) | 0, m = m + Math.imul(_, _e) | 0, a = a + Math.imul(_, Be) | 0, a = a + Math.imul(X, _e) | 0, x = x + Math.imul(X, Be) | 0, m = m + Math.imul($, Re) | 0, a = a + Math.imul($, Pe) | 0, a = a + Math.imul(F, Re) | 0, x = x + Math.imul(F, Pe) | 0, m = m + Math.imul(q, We) | 0, a = a + Math.imul(q, He) | 0, a = a + Math.imul(R, We) | 0, x = x + Math.imul(R, He) | 0, m = m + Math.imul(G, Ue) | 0, a = a + Math.imul(G, Ze) | 0, a = a + Math.imul(Z, Ue) | 0, x = x + Math.imul(Z, Ze) | 0;
        var yt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, m = Math.imul(de, De), a = Math.imul(de, je), a = a + Math.imul(ae, De) | 0, x = Math.imul(ae, je), m = m + Math.imul(se, xe) | 0, a = a + Math.imul(se, Ie) | 0, a = a + Math.imul(ce, xe) | 0, x = x + Math.imul(ce, Ie) | 0, m = m + Math.imul(ie, _e) | 0, a = a + Math.imul(ie, Be) | 0, a = a + Math.imul(oe, _e) | 0, x = x + Math.imul(oe, Be) | 0, m = m + Math.imul(_, Re) | 0, a = a + Math.imul(_, Pe) | 0, a = a + Math.imul(X, Re) | 0, x = x + Math.imul(X, Pe) | 0, m = m + Math.imul($, We) | 0, a = a + Math.imul($, He) | 0, a = a + Math.imul(F, We) | 0, x = x + Math.imul(F, He) | 0, m = m + Math.imul(q, Ue) | 0, a = a + Math.imul(q, Ze) | 0, a = a + Math.imul(R, Ue) | 0, x = x + Math.imul(R, Ze) | 0, m = m + Math.imul(G, Ye) | 0, a = a + Math.imul(G, Qe) | 0, a = a + Math.imul(Z, Ye) | 0, x = x + Math.imul(Z, Qe) | 0;
        var xt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (xt >>> 26) | 0, xt &= 67108863, m = Math.imul(ye, De), a = Math.imul(ye, je), a = a + Math.imul(Me, De) | 0, x = Math.imul(Me, je), m = m + Math.imul(de, xe) | 0, a = a + Math.imul(de, Ie) | 0, a = a + Math.imul(ae, xe) | 0, x = x + Math.imul(ae, Ie) | 0, m = m + Math.imul(se, _e) | 0, a = a + Math.imul(se, Be) | 0, a = a + Math.imul(ce, _e) | 0, x = x + Math.imul(ce, Be) | 0, m = m + Math.imul(ie, Re) | 0, a = a + Math.imul(ie, Pe) | 0, a = a + Math.imul(oe, Re) | 0, x = x + Math.imul(oe, Pe) | 0, m = m + Math.imul(_, We) | 0, a = a + Math.imul(_, He) | 0, a = a + Math.imul(X, We) | 0, x = x + Math.imul(X, He) | 0, m = m + Math.imul($, Ue) | 0, a = a + Math.imul($, Ze) | 0, a = a + Math.imul(F, Ue) | 0, x = x + Math.imul(F, Ze) | 0, m = m + Math.imul(q, Ye) | 0, a = a + Math.imul(q, Qe) | 0, a = a + Math.imul(R, Ye) | 0, x = x + Math.imul(R, Qe) | 0, m = m + Math.imul(G, ee) | 0, a = a + Math.imul(G, K) | 0, a = a + Math.imul(Z, ee) | 0, x = x + Math.imul(Z, K) | 0;
        var bt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, m = Math.imul(Ne, De), a = Math.imul(Ne, je), a = a + Math.imul(Ae, De) | 0, x = Math.imul(Ae, je), m = m + Math.imul(ye, xe) | 0, a = a + Math.imul(ye, Ie) | 0, a = a + Math.imul(Me, xe) | 0, x = x + Math.imul(Me, Ie) | 0, m = m + Math.imul(de, _e) | 0, a = a + Math.imul(de, Be) | 0, a = a + Math.imul(ae, _e) | 0, x = x + Math.imul(ae, Be) | 0, m = m + Math.imul(se, Re) | 0, a = a + Math.imul(se, Pe) | 0, a = a + Math.imul(ce, Re) | 0, x = x + Math.imul(ce, Pe) | 0, m = m + Math.imul(ie, We) | 0, a = a + Math.imul(ie, He) | 0, a = a + Math.imul(oe, We) | 0, x = x + Math.imul(oe, He) | 0, m = m + Math.imul(_, Ue) | 0, a = a + Math.imul(_, Ze) | 0, a = a + Math.imul(X, Ue) | 0, x = x + Math.imul(X, Ze) | 0, m = m + Math.imul($, Ye) | 0, a = a + Math.imul($, Qe) | 0, a = a + Math.imul(F, Ye) | 0, x = x + Math.imul(F, Qe) | 0, m = m + Math.imul(q, ee) | 0, a = a + Math.imul(q, K) | 0, a = a + Math.imul(R, ee) | 0, x = x + Math.imul(R, K) | 0, m = m + Math.imul(G, re) | 0, a = a + Math.imul(G, he) | 0, a = a + Math.imul(Z, re) | 0, x = x + Math.imul(Z, he) | 0;
        var Mt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Mt >>> 26) | 0, Mt &= 67108863, m = Math.imul(ke, De), a = Math.imul(ke, je), a = a + Math.imul(Te, De) | 0, x = Math.imul(Te, je), m = m + Math.imul(Ne, xe) | 0, a = a + Math.imul(Ne, Ie) | 0, a = a + Math.imul(Ae, xe) | 0, x = x + Math.imul(Ae, Ie) | 0, m = m + Math.imul(ye, _e) | 0, a = a + Math.imul(ye, Be) | 0, a = a + Math.imul(Me, _e) | 0, x = x + Math.imul(Me, Be) | 0, m = m + Math.imul(de, Re) | 0, a = a + Math.imul(de, Pe) | 0, a = a + Math.imul(ae, Re) | 0, x = x + Math.imul(ae, Pe) | 0, m = m + Math.imul(se, We) | 0, a = a + Math.imul(se, He) | 0, a = a + Math.imul(ce, We) | 0, x = x + Math.imul(ce, He) | 0, m = m + Math.imul(ie, Ue) | 0, a = a + Math.imul(ie, Ze) | 0, a = a + Math.imul(oe, Ue) | 0, x = x + Math.imul(oe, Ze) | 0, m = m + Math.imul(_, Ye) | 0, a = a + Math.imul(_, Qe) | 0, a = a + Math.imul(X, Ye) | 0, x = x + Math.imul(X, Qe) | 0, m = m + Math.imul($, ee) | 0, a = a + Math.imul($, K) | 0, a = a + Math.imul(F, ee) | 0, x = x + Math.imul(F, K) | 0, m = m + Math.imul(q, re) | 0, a = a + Math.imul(q, he) | 0, a = a + Math.imul(R, re) | 0, x = x + Math.imul(R, he) | 0, m = m + Math.imul(G, ve) | 0, a = a + Math.imul(G, we) | 0, a = a + Math.imul(Z, ve) | 0, x = x + Math.imul(Z, we) | 0;
        var vt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, m = Math.imul(ke, xe), a = Math.imul(ke, Ie), a = a + Math.imul(Te, xe) | 0, x = Math.imul(Te, Ie), m = m + Math.imul(Ne, _e) | 0, a = a + Math.imul(Ne, Be) | 0, a = a + Math.imul(Ae, _e) | 0, x = x + Math.imul(Ae, Be) | 0, m = m + Math.imul(ye, Re) | 0, a = a + Math.imul(ye, Pe) | 0, a = a + Math.imul(Me, Re) | 0, x = x + Math.imul(Me, Pe) | 0, m = m + Math.imul(de, We) | 0, a = a + Math.imul(de, He) | 0, a = a + Math.imul(ae, We) | 0, x = x + Math.imul(ae, He) | 0, m = m + Math.imul(se, Ue) | 0, a = a + Math.imul(se, Ze) | 0, a = a + Math.imul(ce, Ue) | 0, x = x + Math.imul(ce, Ze) | 0, m = m + Math.imul(ie, Ye) | 0, a = a + Math.imul(ie, Qe) | 0, a = a + Math.imul(oe, Ye) | 0, x = x + Math.imul(oe, Qe) | 0, m = m + Math.imul(_, ee) | 0, a = a + Math.imul(_, K) | 0, a = a + Math.imul(X, ee) | 0, x = x + Math.imul(X, K) | 0, m = m + Math.imul($, re) | 0, a = a + Math.imul($, he) | 0, a = a + Math.imul(F, re) | 0, x = x + Math.imul(F, he) | 0, m = m + Math.imul(q, ve) | 0, a = a + Math.imul(q, we) | 0, a = a + Math.imul(R, ve) | 0, x = x + Math.imul(R, we) | 0;
        var mt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, m = Math.imul(ke, _e), a = Math.imul(ke, Be), a = a + Math.imul(Te, _e) | 0, x = Math.imul(Te, Be), m = m + Math.imul(Ne, Re) | 0, a = a + Math.imul(Ne, Pe) | 0, a = a + Math.imul(Ae, Re) | 0, x = x + Math.imul(Ae, Pe) | 0, m = m + Math.imul(ye, We) | 0, a = a + Math.imul(ye, He) | 0, a = a + Math.imul(Me, We) | 0, x = x + Math.imul(Me, He) | 0, m = m + Math.imul(de, Ue) | 0, a = a + Math.imul(de, Ze) | 0, a = a + Math.imul(ae, Ue) | 0, x = x + Math.imul(ae, Ze) | 0, m = m + Math.imul(se, Ye) | 0, a = a + Math.imul(se, Qe) | 0, a = a + Math.imul(ce, Ye) | 0, x = x + Math.imul(ce, Qe) | 0, m = m + Math.imul(ie, ee) | 0, a = a + Math.imul(ie, K) | 0, a = a + Math.imul(oe, ee) | 0, x = x + Math.imul(oe, K) | 0, m = m + Math.imul(_, re) | 0, a = a + Math.imul(_, he) | 0, a = a + Math.imul(X, re) | 0, x = x + Math.imul(X, he) | 0, m = m + Math.imul($, ve) | 0, a = a + Math.imul($, we) | 0, a = a + Math.imul(F, ve) | 0, x = x + Math.imul(F, we) | 0;
        var ot = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (ot >>> 26) | 0, ot &= 67108863, m = Math.imul(ke, Re), a = Math.imul(ke, Pe), a = a + Math.imul(Te, Re) | 0, x = Math.imul(Te, Pe), m = m + Math.imul(Ne, We) | 0, a = a + Math.imul(Ne, He) | 0, a = a + Math.imul(Ae, We) | 0, x = x + Math.imul(Ae, He) | 0, m = m + Math.imul(ye, Ue) | 0, a = a + Math.imul(ye, Ze) | 0, a = a + Math.imul(Me, Ue) | 0, x = x + Math.imul(Me, Ze) | 0, m = m + Math.imul(de, Ye) | 0, a = a + Math.imul(de, Qe) | 0, a = a + Math.imul(ae, Ye) | 0, x = x + Math.imul(ae, Qe) | 0, m = m + Math.imul(se, ee) | 0, a = a + Math.imul(se, K) | 0, a = a + Math.imul(ce, ee) | 0, x = x + Math.imul(ce, K) | 0, m = m + Math.imul(ie, re) | 0, a = a + Math.imul(ie, he) | 0, a = a + Math.imul(oe, re) | 0, x = x + Math.imul(oe, he) | 0, m = m + Math.imul(_, ve) | 0, a = a + Math.imul(_, we) | 0, a = a + Math.imul(X, ve) | 0, x = x + Math.imul(X, we) | 0;
        var ft = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (ft >>> 26) | 0, ft &= 67108863, m = Math.imul(ke, We), a = Math.imul(ke, He), a = a + Math.imul(Te, We) | 0, x = Math.imul(Te, He), m = m + Math.imul(Ne, Ue) | 0, a = a + Math.imul(Ne, Ze) | 0, a = a + Math.imul(Ae, Ue) | 0, x = x + Math.imul(Ae, Ze) | 0, m = m + Math.imul(ye, Ye) | 0, a = a + Math.imul(ye, Qe) | 0, a = a + Math.imul(Me, Ye) | 0, x = x + Math.imul(Me, Qe) | 0, m = m + Math.imul(de, ee) | 0, a = a + Math.imul(de, K) | 0, a = a + Math.imul(ae, ee) | 0, x = x + Math.imul(ae, K) | 0, m = m + Math.imul(se, re) | 0, a = a + Math.imul(se, he) | 0, a = a + Math.imul(ce, re) | 0, x = x + Math.imul(ce, he) | 0, m = m + Math.imul(ie, ve) | 0, a = a + Math.imul(ie, we) | 0, a = a + Math.imul(oe, ve) | 0, x = x + Math.imul(oe, we) | 0;
        var rt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (rt >>> 26) | 0, rt &= 67108863, m = Math.imul(ke, Ue), a = Math.imul(ke, Ze), a = a + Math.imul(Te, Ue) | 0, x = Math.imul(Te, Ze), m = m + Math.imul(Ne, Ye) | 0, a = a + Math.imul(Ne, Qe) | 0, a = a + Math.imul(Ae, Ye) | 0, x = x + Math.imul(Ae, Qe) | 0, m = m + Math.imul(ye, ee) | 0, a = a + Math.imul(ye, K) | 0, a = a + Math.imul(Me, ee) | 0, x = x + Math.imul(Me, K) | 0, m = m + Math.imul(de, re) | 0, a = a + Math.imul(de, he) | 0, a = a + Math.imul(ae, re) | 0, x = x + Math.imul(ae, he) | 0, m = m + Math.imul(se, ve) | 0, a = a + Math.imul(se, we) | 0, a = a + Math.imul(ce, ve) | 0, x = x + Math.imul(ce, we) | 0;
        var st = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (st >>> 26) | 0, st &= 67108863, m = Math.imul(ke, Ye), a = Math.imul(ke, Qe), a = a + Math.imul(Te, Ye) | 0, x = Math.imul(Te, Qe), m = m + Math.imul(Ne, ee) | 0, a = a + Math.imul(Ne, K) | 0, a = a + Math.imul(Ae, ee) | 0, x = x + Math.imul(Ae, K) | 0, m = m + Math.imul(ye, re) | 0, a = a + Math.imul(ye, he) | 0, a = a + Math.imul(Me, re) | 0, x = x + Math.imul(Me, he) | 0, m = m + Math.imul(de, ve) | 0, a = a + Math.imul(de, we) | 0, a = a + Math.imul(ae, ve) | 0, x = x + Math.imul(ae, we) | 0;
        var ct = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (ct >>> 26) | 0, ct &= 67108863, m = Math.imul(ke, ee), a = Math.imul(ke, K), a = a + Math.imul(Te, ee) | 0, x = Math.imul(Te, K), m = m + Math.imul(Ne, re) | 0, a = a + Math.imul(Ne, he) | 0, a = a + Math.imul(Ae, re) | 0, x = x + Math.imul(Ae, he) | 0, m = m + Math.imul(ye, ve) | 0, a = a + Math.imul(ye, we) | 0, a = a + Math.imul(Me, ve) | 0, x = x + Math.imul(Me, we) | 0;
        var Je = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Je >>> 26) | 0, Je &= 67108863, m = Math.imul(ke, re), a = Math.imul(ke, he), a = a + Math.imul(Te, re) | 0, x = Math.imul(Te, he), m = m + Math.imul(Ne, ve) | 0, a = a + Math.imul(Ne, we) | 0, a = a + Math.imul(Ae, ve) | 0, x = x + Math.imul(Ae, we) | 0;
        var Oe = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, m = Math.imul(ke, ve), a = Math.imul(ke, we), a = a + Math.imul(Te, ve) | 0, x = Math.imul(Te, we);
        var ze = (L + m | 0) + ((a & 8191) << 13) | 0;
        return L = (x + (a >>> 13) | 0) + (ze >>> 26) | 0, ze &= 67108863, A[0] = lt, A[1] = et, A[2] = Lt, A[3] = nt, A[4] = gt, A[5] = yt, A[6] = xt, A[7] = bt, A[8] = Mt, A[9] = vt, A[10] = mt, A[11] = ot, A[12] = ft, A[13] = rt, A[14] = st, A[15] = ct, A[16] = Je, A[17] = Oe, A[18] = ze, L !== 0 && (A[19] = L, u.length++), u;
      };
      Math.imul || (w = N);
      function S(I, r, s) {
        s.negative = r.negative ^ I.negative, s.length = I.length + r.length;
        for (var u = 0, g = 0, v = 0; v < s.length - 1; v++) {
          var A = g;
          g = 0;
          for (var L = u & 67108863, m = Math.min(v, r.length - 1), a = Math.max(0, v - I.length + 1); a <= m; a++) {
            var x = v - a, V = I.words[x] | 0, G = r.words[a] | 0, Z = V * G, te = Z & 67108863;
            A = A + (Z / 67108864 | 0) | 0, te = te + L | 0, L = te & 67108863, A = A + (te >>> 26) | 0, g += A >>> 26, A &= 67108863;
          }
          s.words[v] = L, u = A, A = g;
        }
        return u !== 0 ? s.words[v] = u : s.length--, s.strip();
      }
      function T(I, r, s) {
        var u = new E();
        return u.mulp(I, r, s);
      }
      n.prototype.mulTo = function(r, s) {
        var u, g = this.length + r.length;
        return this.length === 10 && r.length === 10 ? u = w(this, r, s) : g < 63 ? u = N(this, r, s) : g < 1024 ? u = S(this, r, s) : u = T(this, r, s), u;
      };
      function E(I, r) {
        this.x = I, this.y = r;
      }
      E.prototype.makeRBT = function(r) {
        for (var s = new Array(r), u = n.prototype._countBits(r) - 1, g = 0; g < r; g++)
          s[g] = this.revBin(g, u, r);
        return s;
      }, E.prototype.revBin = function(r, s, u) {
        if (r === 0 || r === u - 1) return r;
        for (var g = 0, v = 0; v < s; v++)
          g |= (r & 1) << s - v - 1, r >>= 1;
        return g;
      }, E.prototype.permute = function(r, s, u, g, v, A) {
        for (var L = 0; L < A; L++)
          g[L] = s[r[L]], v[L] = u[r[L]];
      }, E.prototype.transform = function(r, s, u, g, v, A) {
        this.permute(A, r, s, u, g, v);
        for (var L = 1; L < v; L <<= 1)
          for (var m = L << 1, a = Math.cos(2 * Math.PI / m), x = Math.sin(2 * Math.PI / m), V = 0; V < v; V += m)
            for (var G = a, Z = x, te = 0; te < L; te++) {
              var q = u[V + te], R = g[V + te], Q = u[V + te + L], $ = g[V + te + L], F = G * Q - Z * $;
              $ = G * $ + Z * Q, Q = F, u[V + te] = q + Q, g[V + te] = R + $, u[V + te + L] = q - Q, g[V + te + L] = R - $, te !== m && (F = a * G - x * Z, Z = a * Z + x * G, G = F);
            }
      }, E.prototype.guessLen13b = function(r, s) {
        var u = Math.max(s, r) | 1, g = u & 1, v = 0;
        for (u = u / 2 | 0; u; u = u >>> 1)
          v++;
        return 1 << v + 1 + g;
      }, E.prototype.conjugate = function(r, s, u) {
        if (!(u <= 1))
          for (var g = 0; g < u / 2; g++) {
            var v = r[g];
            r[g] = r[u - g - 1], r[u - g - 1] = v, v = s[g], s[g] = -s[u - g - 1], s[u - g - 1] = -v;
          }
      }, E.prototype.normalize13b = function(r, s) {
        for (var u = 0, g = 0; g < s / 2; g++) {
          var v = Math.round(r[2 * g + 1] / s) * 8192 + Math.round(r[2 * g] / s) + u;
          r[g] = v & 67108863, v < 67108864 ? u = 0 : u = v / 67108864 | 0;
        }
        return r;
      }, E.prototype.convert13b = function(r, s, u, g) {
        for (var v = 0, A = 0; A < s; A++)
          v = v + (r[A] | 0), u[2 * A] = v & 8191, v = v >>> 13, u[2 * A + 1] = v & 8191, v = v >>> 13;
        for (A = 2 * s; A < g; ++A)
          u[A] = 0;
        i(v === 0), i((v & -8192) === 0);
      }, E.prototype.stub = function(r) {
        for (var s = new Array(r), u = 0; u < r; u++)
          s[u] = 0;
        return s;
      }, E.prototype.mulp = function(r, s, u) {
        var g = 2 * this.guessLen13b(r.length, s.length), v = this.makeRBT(g), A = this.stub(g), L = new Array(g), m = new Array(g), a = new Array(g), x = new Array(g), V = new Array(g), G = new Array(g), Z = u.words;
        Z.length = g, this.convert13b(r.words, r.length, L, g), this.convert13b(s.words, s.length, x, g), this.transform(L, A, m, a, g, v), this.transform(x, A, V, G, g, v);
        for (var te = 0; te < g; te++) {
          var q = m[te] * V[te] - a[te] * G[te];
          a[te] = m[te] * G[te] + a[te] * V[te], m[te] = q;
        }
        return this.conjugate(m, a, g), this.transform(m, a, Z, A, g, v), this.conjugate(Z, A, g), this.normalize13b(Z, g), u.negative = r.negative ^ s.negative, u.length = r.length + s.length, u.strip();
      }, n.prototype.mul = function(r) {
        var s = new n(null);
        return s.words = new Array(this.length + r.length), this.mulTo(r, s);
      }, n.prototype.mulf = function(r) {
        var s = new n(null);
        return s.words = new Array(this.length + r.length), T(this, r, s);
      }, n.prototype.imul = function(r) {
        return this.clone().mulTo(r, this);
      }, n.prototype.imuln = function(r) {
        i(typeof r == "number"), i(r < 67108864);
        for (var s = 0, u = 0; u < this.length; u++) {
          var g = (this.words[u] | 0) * r, v = (g & 67108863) + (s & 67108863);
          s >>= 26, s += g / 67108864 | 0, s += v >>> 26, this.words[u] = v & 67108863;
        }
        return s !== 0 && (this.words[u] = s, this.length++), this.length = r === 0 ? 1 : this.length, this;
      }, n.prototype.muln = function(r) {
        return this.clone().imuln(r);
      }, n.prototype.sqr = function() {
        return this.mul(this);
      }, n.prototype.isqr = function() {
        return this.imul(this.clone());
      }, n.prototype.pow = function(r) {
        var s = C(r);
        if (s.length === 0) return new n(1);
        for (var u = this, g = 0; g < s.length && s[g] === 0; g++, u = u.sqr())
          ;
        if (++g < s.length)
          for (var v = u.sqr(); g < s.length; g++, v = v.sqr())
            s[g] !== 0 && (u = u.mul(v));
        return u;
      }, n.prototype.iushln = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = r % 26, u = (r - s) / 26, g = 67108863 >>> 26 - s << 26 - s, v;
        if (s !== 0) {
          var A = 0;
          for (v = 0; v < this.length; v++) {
            var L = this.words[v] & g, m = (this.words[v] | 0) - L << s;
            this.words[v] = m | A, A = L >>> 26 - s;
          }
          A && (this.words[v] = A, this.length++);
        }
        if (u !== 0) {
          for (v = this.length - 1; v >= 0; v--)
            this.words[v + u] = this.words[v];
          for (v = 0; v < u; v++)
            this.words[v] = 0;
          this.length += u;
        }
        return this.strip();
      }, n.prototype.ishln = function(r) {
        return i(this.negative === 0), this.iushln(r);
      }, n.prototype.iushrn = function(r, s, u) {
        i(typeof r == "number" && r >= 0);
        var g;
        s ? g = (s - s % 26) / 26 : g = 0;
        var v = r % 26, A = Math.min((r - v) / 26, this.length), L = 67108863 ^ 67108863 >>> v << v, m = u;
        if (g -= A, g = Math.max(0, g), m) {
          for (var a = 0; a < A; a++)
            m.words[a] = this.words[a];
          m.length = A;
        }
        if (A !== 0) if (this.length > A)
          for (this.length -= A, a = 0; a < this.length; a++)
            this.words[a] = this.words[a + A];
        else
          this.words[0] = 0, this.length = 1;
        var x = 0;
        for (a = this.length - 1; a >= 0 && (x !== 0 || a >= g); a--) {
          var V = this.words[a] | 0;
          this.words[a] = x << 26 - v | V >>> v, x = V & L;
        }
        return m && x !== 0 && (m.words[m.length++] = x), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, n.prototype.ishrn = function(r, s, u) {
        return i(this.negative === 0), this.iushrn(r, s, u);
      }, n.prototype.shln = function(r) {
        return this.clone().ishln(r);
      }, n.prototype.ushln = function(r) {
        return this.clone().iushln(r);
      }, n.prototype.shrn = function(r) {
        return this.clone().ishrn(r);
      }, n.prototype.ushrn = function(r) {
        return this.clone().iushrn(r);
      }, n.prototype.testn = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = r % 26, u = (r - s) / 26, g = 1 << s;
        if (this.length <= u) return !1;
        var v = this.words[u];
        return !!(v & g);
      }, n.prototype.imaskn = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = r % 26, u = (r - s) / 26;
        if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= u)
          return this;
        if (s !== 0 && u++, this.length = Math.min(u, this.length), s !== 0) {
          var g = 67108863 ^ 67108863 >>> s << s;
          this.words[this.length - 1] &= g;
        }
        return this.strip();
      }, n.prototype.maskn = function(r) {
        return this.clone().imaskn(r);
      }, n.prototype.iaddn = function(r) {
        return i(typeof r == "number"), i(r < 67108864), r < 0 ? this.isubn(-r) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < r ? (this.words[0] = r - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(r), this.negative = 1, this) : this._iaddn(r);
      }, n.prototype._iaddn = function(r) {
        this.words[0] += r;
        for (var s = 0; s < this.length && this.words[s] >= 67108864; s++)
          this.words[s] -= 67108864, s === this.length - 1 ? this.words[s + 1] = 1 : this.words[s + 1]++;
        return this.length = Math.max(this.length, s + 1), this;
      }, n.prototype.isubn = function(r) {
        if (i(typeof r == "number"), i(r < 67108864), r < 0) return this.iaddn(-r);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(r), this.negative = 1, this;
        if (this.words[0] -= r, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var s = 0; s < this.length && this.words[s] < 0; s++)
            this.words[s] += 67108864, this.words[s + 1] -= 1;
        return this.strip();
      }, n.prototype.addn = function(r) {
        return this.clone().iaddn(r);
      }, n.prototype.subn = function(r) {
        return this.clone().isubn(r);
      }, n.prototype.iabs = function() {
        return this.negative = 0, this;
      }, n.prototype.abs = function() {
        return this.clone().iabs();
      }, n.prototype._ishlnsubmul = function(r, s, u) {
        var g = r.length + u, v;
        this._expand(g);
        var A, L = 0;
        for (v = 0; v < r.length; v++) {
          A = (this.words[v + u] | 0) + L;
          var m = (r.words[v] | 0) * s;
          A -= m & 67108863, L = (A >> 26) - (m / 67108864 | 0), this.words[v + u] = A & 67108863;
        }
        for (; v < this.length - u; v++)
          A = (this.words[v + u] | 0) + L, L = A >> 26, this.words[v + u] = A & 67108863;
        if (L === 0) return this.strip();
        for (i(L === -1), L = 0, v = 0; v < this.length; v++)
          A = -(this.words[v] | 0) + L, L = A >> 26, this.words[v] = A & 67108863;
        return this.negative = 1, this.strip();
      }, n.prototype._wordDiv = function(r, s) {
        var u = this.length - r.length, g = this.clone(), v = r, A = v.words[v.length - 1] | 0, L = this._countBits(A);
        u = 26 - L, u !== 0 && (v = v.ushln(u), g.iushln(u), A = v.words[v.length - 1] | 0);
        var m = g.length - v.length, a;
        if (s !== "mod") {
          a = new n(null), a.length = m + 1, a.words = new Array(a.length);
          for (var x = 0; x < a.length; x++)
            a.words[x] = 0;
        }
        var V = g.clone()._ishlnsubmul(v, 1, m);
        V.negative === 0 && (g = V, a && (a.words[m] = 1));
        for (var G = m - 1; G >= 0; G--) {
          var Z = (g.words[v.length + G] | 0) * 67108864 + (g.words[v.length + G - 1] | 0);
          for (Z = Math.min(Z / A | 0, 67108863), g._ishlnsubmul(v, Z, G); g.negative !== 0; )
            Z--, g.negative = 0, g._ishlnsubmul(v, 1, G), g.isZero() || (g.negative ^= 1);
          a && (a.words[G] = Z);
        }
        return a && a.strip(), g.strip(), s !== "div" && u !== 0 && g.iushrn(u), {
          div: a || null,
          mod: g
        };
      }, n.prototype.divmod = function(r, s, u) {
        if (i(!r.isZero()), this.isZero())
          return {
            div: new n(0),
            mod: new n(0)
          };
        var g, v, A;
        return this.negative !== 0 && r.negative === 0 ? (A = this.neg().divmod(r, s), s !== "mod" && (g = A.div.neg()), s !== "div" && (v = A.mod.neg(), u && v.negative !== 0 && v.iadd(r)), {
          div: g,
          mod: v
        }) : this.negative === 0 && r.negative !== 0 ? (A = this.divmod(r.neg(), s), s !== "mod" && (g = A.div.neg()), {
          div: g,
          mod: A.mod
        }) : this.negative & r.negative ? (A = this.neg().divmod(r.neg(), s), s !== "div" && (v = A.mod.neg(), u && v.negative !== 0 && v.isub(r)), {
          div: A.div,
          mod: v
        }) : r.length > this.length || this.cmp(r) < 0 ? {
          div: new n(0),
          mod: this
        } : r.length === 1 ? s === "div" ? {
          div: this.divn(r.words[0]),
          mod: null
        } : s === "mod" ? {
          div: null,
          mod: new n(this.modn(r.words[0]))
        } : {
          div: this.divn(r.words[0]),
          mod: new n(this.modn(r.words[0]))
        } : this._wordDiv(r, s);
      }, n.prototype.div = function(r) {
        return this.divmod(r, "div", !1).div;
      }, n.prototype.mod = function(r) {
        return this.divmod(r, "mod", !1).mod;
      }, n.prototype.umod = function(r) {
        return this.divmod(r, "mod", !0).mod;
      }, n.prototype.divRound = function(r) {
        var s = this.divmod(r);
        if (s.mod.isZero()) return s.div;
        var u = s.div.negative !== 0 ? s.mod.isub(r) : s.mod, g = r.ushrn(1), v = r.andln(1), A = u.cmp(g);
        return A < 0 || v === 1 && A === 0 ? s.div : s.div.negative !== 0 ? s.div.isubn(1) : s.div.iaddn(1);
      }, n.prototype.modn = function(r) {
        i(r <= 67108863);
        for (var s = (1 << 26) % r, u = 0, g = this.length - 1; g >= 0; g--)
          u = (s * u + (this.words[g] | 0)) % r;
        return u;
      }, n.prototype.idivn = function(r) {
        i(r <= 67108863);
        for (var s = 0, u = this.length - 1; u >= 0; u--) {
          var g = (this.words[u] | 0) + s * 67108864;
          this.words[u] = g / r | 0, s = g % r;
        }
        return this.strip();
      }, n.prototype.divn = function(r) {
        return this.clone().idivn(r);
      }, n.prototype.egcd = function(r) {
        i(r.negative === 0), i(!r.isZero());
        var s = this, u = r.clone();
        s.negative !== 0 ? s = s.umod(r) : s = s.clone();
        for (var g = new n(1), v = new n(0), A = new n(0), L = new n(1), m = 0; s.isEven() && u.isEven(); )
          s.iushrn(1), u.iushrn(1), ++m;
        for (var a = u.clone(), x = s.clone(); !s.isZero(); ) {
          for (var V = 0, G = 1; !(s.words[0] & G) && V < 26; ++V, G <<= 1) ;
          if (V > 0)
            for (s.iushrn(V); V-- > 0; )
              (g.isOdd() || v.isOdd()) && (g.iadd(a), v.isub(x)), g.iushrn(1), v.iushrn(1);
          for (var Z = 0, te = 1; !(u.words[0] & te) && Z < 26; ++Z, te <<= 1) ;
          if (Z > 0)
            for (u.iushrn(Z); Z-- > 0; )
              (A.isOdd() || L.isOdd()) && (A.iadd(a), L.isub(x)), A.iushrn(1), L.iushrn(1);
          s.cmp(u) >= 0 ? (s.isub(u), g.isub(A), v.isub(L)) : (u.isub(s), A.isub(g), L.isub(v));
        }
        return {
          a: A,
          b: L,
          gcd: u.iushln(m)
        };
      }, n.prototype._invmp = function(r) {
        i(r.negative === 0), i(!r.isZero());
        var s = this, u = r.clone();
        s.negative !== 0 ? s = s.umod(r) : s = s.clone();
        for (var g = new n(1), v = new n(0), A = u.clone(); s.cmpn(1) > 0 && u.cmpn(1) > 0; ) {
          for (var L = 0, m = 1; !(s.words[0] & m) && L < 26; ++L, m <<= 1) ;
          if (L > 0)
            for (s.iushrn(L); L-- > 0; )
              g.isOdd() && g.iadd(A), g.iushrn(1);
          for (var a = 0, x = 1; !(u.words[0] & x) && a < 26; ++a, x <<= 1) ;
          if (a > 0)
            for (u.iushrn(a); a-- > 0; )
              v.isOdd() && v.iadd(A), v.iushrn(1);
          s.cmp(u) >= 0 ? (s.isub(u), g.isub(v)) : (u.isub(s), v.isub(g));
        }
        var V;
        return s.cmpn(1) === 0 ? V = g : V = v, V.cmpn(0) < 0 && V.iadd(r), V;
      }, n.prototype.gcd = function(r) {
        if (this.isZero()) return r.abs();
        if (r.isZero()) return this.abs();
        var s = this.clone(), u = r.clone();
        s.negative = 0, u.negative = 0;
        for (var g = 0; s.isEven() && u.isEven(); g++)
          s.iushrn(1), u.iushrn(1);
        do {
          for (; s.isEven(); )
            s.iushrn(1);
          for (; u.isEven(); )
            u.iushrn(1);
          var v = s.cmp(u);
          if (v < 0) {
            var A = s;
            s = u, u = A;
          } else if (v === 0 || u.cmpn(1) === 0)
            break;
          s.isub(u);
        } while (!0);
        return u.iushln(g);
      }, n.prototype.invm = function(r) {
        return this.egcd(r).a.umod(r);
      }, n.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, n.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, n.prototype.andln = function(r) {
        return this.words[0] & r;
      }, n.prototype.bincn = function(r) {
        i(typeof r == "number");
        var s = r % 26, u = (r - s) / 26, g = 1 << s;
        if (this.length <= u)
          return this._expand(u + 1), this.words[u] |= g, this;
        for (var v = g, A = u; v !== 0 && A < this.length; A++) {
          var L = this.words[A] | 0;
          L += v, v = L >>> 26, L &= 67108863, this.words[A] = L;
        }
        return v !== 0 && (this.words[A] = v, this.length++), this;
      }, n.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, n.prototype.cmpn = function(r) {
        var s = r < 0;
        if (this.negative !== 0 && !s) return -1;
        if (this.negative === 0 && s) return 1;
        this.strip();
        var u;
        if (this.length > 1)
          u = 1;
        else {
          s && (r = -r), i(r <= 67108863, "Number is too big");
          var g = this.words[0] | 0;
          u = g === r ? 0 : g < r ? -1 : 1;
        }
        return this.negative !== 0 ? -u | 0 : u;
      }, n.prototype.cmp = function(r) {
        if (this.negative !== 0 && r.negative === 0) return -1;
        if (this.negative === 0 && r.negative !== 0) return 1;
        var s = this.ucmp(r);
        return this.negative !== 0 ? -s | 0 : s;
      }, n.prototype.ucmp = function(r) {
        if (this.length > r.length) return 1;
        if (this.length < r.length) return -1;
        for (var s = 0, u = this.length - 1; u >= 0; u--) {
          var g = this.words[u] | 0, v = r.words[u] | 0;
          if (g !== v) {
            g < v ? s = -1 : g > v && (s = 1);
            break;
          }
        }
        return s;
      }, n.prototype.gtn = function(r) {
        return this.cmpn(r) === 1;
      }, n.prototype.gt = function(r) {
        return this.cmp(r) === 1;
      }, n.prototype.gten = function(r) {
        return this.cmpn(r) >= 0;
      }, n.prototype.gte = function(r) {
        return this.cmp(r) >= 0;
      }, n.prototype.ltn = function(r) {
        return this.cmpn(r) === -1;
      }, n.prototype.lt = function(r) {
        return this.cmp(r) === -1;
      }, n.prototype.lten = function(r) {
        return this.cmpn(r) <= 0;
      }, n.prototype.lte = function(r) {
        return this.cmp(r) <= 0;
      }, n.prototype.eqn = function(r) {
        return this.cmpn(r) === 0;
      }, n.prototype.eq = function(r) {
        return this.cmp(r) === 0;
      }, n.red = function(r) {
        return new U(r);
      }, n.prototype.toRed = function(r) {
        return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), r.convertTo(this)._forceRed(r);
      }, n.prototype.fromRed = function() {
        return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, n.prototype._forceRed = function(r) {
        return this.red = r, this;
      }, n.prototype.forceRed = function(r) {
        return i(!this.red, "Already a number in reduction context"), this._forceRed(r);
      }, n.prototype.redAdd = function(r) {
        return i(this.red, "redAdd works only with red numbers"), this.red.add(this, r);
      }, n.prototype.redIAdd = function(r) {
        return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, r);
      }, n.prototype.redSub = function(r) {
        return i(this.red, "redSub works only with red numbers"), this.red.sub(this, r);
      }, n.prototype.redISub = function(r) {
        return i(this.red, "redISub works only with red numbers"), this.red.isub(this, r);
      }, n.prototype.redShl = function(r) {
        return i(this.red, "redShl works only with red numbers"), this.red.shl(this, r);
      }, n.prototype.redMul = function(r) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, r), this.red.mul(this, r);
      }, n.prototype.redIMul = function(r) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, r), this.red.imul(this, r);
      }, n.prototype.redSqr = function() {
        return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, n.prototype.redISqr = function() {
        return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, n.prototype.redSqrt = function() {
        return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, n.prototype.redInvm = function() {
        return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, n.prototype.redNeg = function() {
        return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, n.prototype.redPow = function(r) {
        return i(this.red && !r.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, r);
      };
      var j = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function O(I, r) {
        this.name = I, this.p = new n(r, 16), this.n = this.p.bitLength(), this.k = new n(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      O.prototype._tmp = function() {
        var r = new n(null);
        return r.words = new Array(Math.ceil(this.n / 13)), r;
      }, O.prototype.ireduce = function(r) {
        var s = r, u;
        do
          this.split(s, this.tmp), s = this.imulK(s), s = s.iadd(this.tmp), u = s.bitLength();
        while (u > this.n);
        var g = u < this.n ? -1 : s.ucmp(this.p);
        return g === 0 ? (s.words[0] = 0, s.length = 1) : g > 0 ? s.isub(this.p) : s.strip !== void 0 ? s.strip() : s._strip(), s;
      }, O.prototype.split = function(r, s) {
        r.iushrn(this.n, 0, s);
      }, O.prototype.imulK = function(r) {
        return r.imul(this.k);
      };
      function z() {
        O.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      c(z, O), z.prototype.split = function(r, s) {
        for (var u = 4194303, g = Math.min(r.length, 9), v = 0; v < g; v++)
          s.words[v] = r.words[v];
        if (s.length = g, r.length <= 9) {
          r.words[0] = 0, r.length = 1;
          return;
        }
        var A = r.words[9];
        for (s.words[s.length++] = A & u, v = 10; v < r.length; v++) {
          var L = r.words[v] | 0;
          r.words[v - 10] = (L & u) << 4 | A >>> 22, A = L;
        }
        A >>>= 22, r.words[v - 10] = A, A === 0 && r.length > 10 ? r.length -= 10 : r.length -= 9;
      }, z.prototype.imulK = function(r) {
        r.words[r.length] = 0, r.words[r.length + 1] = 0, r.length += 2;
        for (var s = 0, u = 0; u < r.length; u++) {
          var g = r.words[u] | 0;
          s += g * 977, r.words[u] = s & 67108863, s = g * 64 + (s / 67108864 | 0);
        }
        return r.words[r.length - 1] === 0 && (r.length--, r.words[r.length - 1] === 0 && r.length--), r;
      };
      function k() {
        O.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      c(k, O);
      function H() {
        O.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      c(H, O);
      function W() {
        O.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      c(W, O), W.prototype.imulK = function(r) {
        for (var s = 0, u = 0; u < r.length; u++) {
          var g = (r.words[u] | 0) * 19 + s, v = g & 67108863;
          g >>>= 26, r.words[u] = v, s = g;
        }
        return s !== 0 && (r.words[r.length++] = s), r;
      }, n._prime = function(r) {
        if (j[r]) return j[r];
        var s;
        if (r === "k256")
          s = new z();
        else if (r === "p224")
          s = new k();
        else if (r === "p192")
          s = new H();
        else if (r === "p25519")
          s = new W();
        else
          throw new Error("Unknown prime " + r);
        return j[r] = s, s;
      };
      function U(I) {
        if (typeof I == "string") {
          var r = n._prime(I);
          this.m = r.p, this.prime = r;
        } else
          i(I.gtn(1), "modulus must be greater than 1"), this.m = I, this.prime = null;
      }
      U.prototype._verify1 = function(r) {
        i(r.negative === 0, "red works only with positives"), i(r.red, "red works only with red numbers");
      }, U.prototype._verify2 = function(r, s) {
        i((r.negative | s.negative) === 0, "red works only with positives"), i(
          r.red && r.red === s.red,
          "red works only with red numbers"
        );
      }, U.prototype.imod = function(r) {
        return this.prime ? this.prime.ireduce(r)._forceRed(this) : r.umod(this.m)._forceRed(this);
      }, U.prototype.neg = function(r) {
        return r.isZero() ? r.clone() : this.m.sub(r)._forceRed(this);
      }, U.prototype.add = function(r, s) {
        this._verify2(r, s);
        var u = r.add(s);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u._forceRed(this);
      }, U.prototype.iadd = function(r, s) {
        this._verify2(r, s);
        var u = r.iadd(s);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u;
      }, U.prototype.sub = function(r, s) {
        this._verify2(r, s);
        var u = r.sub(s);
        return u.cmpn(0) < 0 && u.iadd(this.m), u._forceRed(this);
      }, U.prototype.isub = function(r, s) {
        this._verify2(r, s);
        var u = r.isub(s);
        return u.cmpn(0) < 0 && u.iadd(this.m), u;
      }, U.prototype.shl = function(r, s) {
        return this._verify1(r), this.imod(r.ushln(s));
      }, U.prototype.imul = function(r, s) {
        return this._verify2(r, s), this.imod(r.imul(s));
      }, U.prototype.mul = function(r, s) {
        return this._verify2(r, s), this.imod(r.mul(s));
      }, U.prototype.isqr = function(r) {
        return this.imul(r, r.clone());
      }, U.prototype.sqr = function(r) {
        return this.mul(r, r);
      }, U.prototype.sqrt = function(r) {
        if (r.isZero()) return r.clone();
        var s = this.m.andln(3);
        if (i(s % 2 === 1), s === 3) {
          var u = this.m.add(new n(1)).iushrn(2);
          return this.pow(r, u);
        }
        for (var g = this.m.subn(1), v = 0; !g.isZero() && g.andln(1) === 0; )
          v++, g.iushrn(1);
        i(!g.isZero());
        var A = new n(1).toRed(this), L = A.redNeg(), m = this.m.subn(1).iushrn(1), a = this.m.bitLength();
        for (a = new n(2 * a * a).toRed(this); this.pow(a, m).cmp(L) !== 0; )
          a.redIAdd(L);
        for (var x = this.pow(a, g), V = this.pow(r, g.addn(1).iushrn(1)), G = this.pow(r, g), Z = v; G.cmp(A) !== 0; ) {
          for (var te = G, q = 0; te.cmp(A) !== 0; q++)
            te = te.redSqr();
          i(q < Z);
          var R = this.pow(x, new n(1).iushln(Z - q - 1));
          V = V.redMul(R), x = R.redSqr(), G = G.redMul(x), Z = q;
        }
        return V;
      }, U.prototype.invm = function(r) {
        var s = r._invmp(this.m);
        return s.negative !== 0 ? (s.negative = 0, this.imod(s).redNeg()) : this.imod(s);
      }, U.prototype.pow = function(r, s) {
        if (s.isZero()) return new n(1).toRed(this);
        if (s.cmpn(1) === 0) return r.clone();
        var u = 4, g = new Array(1 << u);
        g[0] = new n(1).toRed(this), g[1] = r;
        for (var v = 2; v < g.length; v++)
          g[v] = this.mul(g[v - 1], r);
        var A = g[0], L = 0, m = 0, a = s.bitLength() % 26;
        for (a === 0 && (a = 26), v = s.length - 1; v >= 0; v--) {
          for (var x = s.words[v], V = a - 1; V >= 0; V--) {
            var G = x >> V & 1;
            if (A !== g[0] && (A = this.sqr(A)), G === 0 && L === 0) {
              m = 0;
              continue;
            }
            L <<= 1, L |= G, m++, !(m !== u && (v !== 0 || V !== 0)) && (A = this.mul(A, g[L]), m = 0, L = 0);
          }
          a = 26;
        }
        return A;
      }, U.prototype.convertTo = function(r) {
        var s = r.umod(this.m);
        return s === r ? s.clone() : s;
      }, U.prototype.convertFrom = function(r) {
        var s = r.clone();
        return s.red = null, s;
      }, n.mont = function(r) {
        return new B(r);
      };
      function B(I) {
        U.call(this, I), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new n(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      c(B, U), B.prototype.convertTo = function(r) {
        return this.imod(r.ushln(this.shift));
      }, B.prototype.convertFrom = function(r) {
        var s = this.imod(r.mul(this.rinv));
        return s.red = null, s;
      }, B.prototype.imul = function(r, s) {
        if (r.isZero() || s.isZero())
          return r.words[0] = 0, r.length = 1, r;
        var u = r.imul(s), g = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), v = u.isub(g).iushrn(this.shift), A = v;
        return v.cmp(this.m) >= 0 ? A = v.isub(this.m) : v.cmpn(0) < 0 && (A = v.iadd(this.m)), A._forceRed(this);
      }, B.prototype.mul = function(r, s) {
        if (r.isZero() || s.isZero()) return new n(0)._forceRed(this);
        var u = r.mul(s), g = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), v = u.isub(g).iushrn(this.shift), A = v;
        return v.cmp(this.m) >= 0 ? A = v.isub(this.m) : v.cmpn(0) < 0 && (A = v.iadd(this.m)), A._forceRed(this);
      }, B.prototype.invm = function(r) {
        var s = this.imod(r._invmp(this.m).mul(this.r2));
        return s._forceRed(this);
      };
    })(e, Wt);
  }(Q0)), Q0.exports;
}
var xd, g5;
function fT() {
  if (g5) return xd;
  g5 = 1;
  var e = Ih(), t = lT();
  xd = function(d) {
    return new i(d);
  };
  var o = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32
    },
    secp224r1: {
      name: "p224",
      byteLength: 28
    },
    prime256v1: {
      name: "p256",
      byteLength: 32
    },
    prime192v1: {
      name: "p192",
      byteLength: 24
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32
    },
    secp384r1: {
      name: "p384",
      byteLength: 48
    },
    secp521r1: {
      name: "p521",
      byteLength: 66
    }
  };
  o.p224 = o.secp224r1, o.p256 = o.secp256r1 = o.prime256v1, o.p192 = o.secp192r1 = o.prime192v1, o.p384 = o.secp384r1, o.p521 = o.secp521r1;
  function i(n) {
    this.curveType = o[n], this.curveType || (this.curveType = {
      name: n
    }), this.curve = new e.ec(this.curveType.name), this.keys = void 0;
  }
  i.prototype.generateKeys = function(n, d) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(n, d);
  }, i.prototype.computeSecret = function(n, d, f) {
    d = d || "utf8", fe.Buffer.isBuffer(n) || (n = new fe.Buffer(n, d));
    var p = this.curve.keyFromPublic(n).getPublic(), l = p.mul(this.keys.getPrivate()).getX();
    return c(l, f, this.curveType.byteLength);
  }, i.prototype.getPublicKey = function(n, d) {
    var f = this.keys.getPublic(d === "compressed", !0);
    return d === "hybrid" && (f[f.length - 1] % 2 ? f[0] = 7 : f[0] = 6), c(f, n);
  }, i.prototype.getPrivateKey = function(n) {
    return c(this.keys.getPrivate(), n);
  }, i.prototype.setPublicKey = function(n, d) {
    return d = d || "utf8", fe.Buffer.isBuffer(n) || (n = new fe.Buffer(n, d)), this.keys._importPublic(n), this;
  }, i.prototype.setPrivateKey = function(n, d) {
    d = d || "utf8", fe.Buffer.isBuffer(n) || (n = new fe.Buffer(n, d));
    var f = new t(n);
    return f = f.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(f), this;
  };
  function c(n, d, f) {
    Array.isArray(n) || (n = n.toArray());
    var p = new fe.Buffer(n);
    if (f && p.length < f) {
      var l = new fe.Buffer(f - p.length);
      l.fill(0), p = fe.Buffer.concat([l, p]);
    }
    return d ? p.toString(d) : p;
  }
  return xd;
}
var wd = {}, Cd, y5;
function DM() {
  if (y5) return Cd;
  y5 = 1;
  var e = Bs(), t = Gt.Buffer;
  Cd = function(i, c) {
    for (var n = t.alloc(0), d = 0, f; n.length < c; )
      f = o(d++), n = t.concat([n, e("sha1").update(i).update(f).digest()]);
    return n.slice(0, c);
  };
  function o(i) {
    var c = t.allocUnsafe(4);
    return c.writeUInt32BE(i, 0), c;
  }
  return Cd;
}
var Id, M5;
function jM() {
  return M5 || (M5 = 1, Id = function(t, o) {
    for (var i = t.length, c = -1; ++c < i; )
      t[c] ^= o[c];
    return t;
  }), Id;
}
var V0 = { exports: {} };
V0.exports;
var m5;
function Nh() {
  return m5 || (m5 = 1, function(e) {
    (function(t, o) {
      function i(I, r) {
        if (!I) throw new Error(r || "Assertion failed");
      }
      function c(I, r) {
        I.super_ = r;
        var s = function() {
        };
        s.prototype = r.prototype, I.prototype = new s(), I.prototype.constructor = I;
      }
      function n(I, r, s) {
        if (n.isBN(I))
          return I;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, I !== null && ((r === "le" || r === "be") && (s = r, r = 10), this._init(I || 0, r || 10, s || "be"));
      }
      typeof t == "object" ? t.exports = n : o.BN = n, n.BN = n, n.wordSize = 26;
      var d;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? d = window.Buffer : d = Wr.Buffer;
      } catch {
      }
      n.isBN = function(r) {
        return r instanceof n ? !0 : r !== null && typeof r == "object" && r.constructor.wordSize === n.wordSize && Array.isArray(r.words);
      }, n.max = function(r, s) {
        return r.cmp(s) > 0 ? r : s;
      }, n.min = function(r, s) {
        return r.cmp(s) < 0 ? r : s;
      }, n.prototype._init = function(r, s, u) {
        if (typeof r == "number")
          return this._initNumber(r, s, u);
        if (typeof r == "object")
          return this._initArray(r, s, u);
        s === "hex" && (s = 16), i(s === (s | 0) && s >= 2 && s <= 36), r = r.toString().replace(/\s+/g, "");
        var g = 0;
        r[0] === "-" && (g++, this.negative = 1), g < r.length && (s === 16 ? this._parseHex(r, g, u) : (this._parseBase(r, s, g), u === "le" && this._initArray(this.toArray(), s, u)));
      }, n.prototype._initNumber = function(r, s, u) {
        r < 0 && (this.negative = 1, r = -r), r < 67108864 ? (this.words = [r & 67108863], this.length = 1) : r < 4503599627370496 ? (this.words = [
          r & 67108863,
          r / 67108864 & 67108863
        ], this.length = 2) : (i(r < 9007199254740992), this.words = [
          r & 67108863,
          r / 67108864 & 67108863,
          1
        ], this.length = 3), u === "le" && this._initArray(this.toArray(), s, u);
      }, n.prototype._initArray = function(r, s, u) {
        if (i(typeof r.length == "number"), r.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(r.length / 3), this.words = new Array(this.length);
        for (var g = 0; g < this.length; g++)
          this.words[g] = 0;
        var v, A, L = 0;
        if (u === "be")
          for (g = r.length - 1, v = 0; g >= 0; g -= 3)
            A = r[g] | r[g - 1] << 8 | r[g - 2] << 16, this.words[v] |= A << L & 67108863, this.words[v + 1] = A >>> 26 - L & 67108863, L += 24, L >= 26 && (L -= 26, v++);
        else if (u === "le")
          for (g = 0, v = 0; g < r.length; g += 3)
            A = r[g] | r[g + 1] << 8 | r[g + 2] << 16, this.words[v] |= A << L & 67108863, this.words[v + 1] = A >>> 26 - L & 67108863, L += 24, L >= 26 && (L -= 26, v++);
        return this.strip();
      };
      function f(I, r) {
        var s = I.charCodeAt(r);
        return s >= 65 && s <= 70 ? s - 55 : s >= 97 && s <= 102 ? s - 87 : s - 48 & 15;
      }
      function p(I, r, s) {
        var u = f(I, s);
        return s - 1 >= r && (u |= f(I, s - 1) << 4), u;
      }
      n.prototype._parseHex = function(r, s, u) {
        this.length = Math.ceil((r.length - s) / 6), this.words = new Array(this.length);
        for (var g = 0; g < this.length; g++)
          this.words[g] = 0;
        var v = 0, A = 0, L;
        if (u === "be")
          for (g = r.length - 1; g >= s; g -= 2)
            L = p(r, s, g) << v, this.words[A] |= L & 67108863, v >= 18 ? (v -= 18, A += 1, this.words[A] |= L >>> 26) : v += 8;
        else {
          var m = r.length - s;
          for (g = m % 2 === 0 ? s + 1 : s; g < r.length; g += 2)
            L = p(r, s, g) << v, this.words[A] |= L & 67108863, v >= 18 ? (v -= 18, A += 1, this.words[A] |= L >>> 26) : v += 8;
        }
        this.strip();
      };
      function l(I, r, s, u) {
        for (var g = 0, v = Math.min(I.length, s), A = r; A < v; A++) {
          var L = I.charCodeAt(A) - 48;
          g *= u, L >= 49 ? g += L - 49 + 10 : L >= 17 ? g += L - 17 + 10 : g += L;
        }
        return g;
      }
      n.prototype._parseBase = function(r, s, u) {
        this.words = [0], this.length = 1;
        for (var g = 0, v = 1; v <= 67108863; v *= s)
          g++;
        g--, v = v / s | 0;
        for (var A = r.length - u, L = A % g, m = Math.min(A, A - L) + u, a = 0, x = u; x < m; x += g)
          a = l(r, x, x + g, s), this.imuln(v), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        if (L !== 0) {
          var V = 1;
          for (a = l(r, x, r.length, s), x = 0; x < L; x++)
            V *= s;
          this.imuln(V), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        }
        this.strip();
      }, n.prototype.copy = function(r) {
        r.words = new Array(this.length);
        for (var s = 0; s < this.length; s++)
          r.words[s] = this.words[s];
        r.length = this.length, r.negative = this.negative, r.red = this.red;
      }, n.prototype.clone = function() {
        var r = new n(null);
        return this.copy(r), r;
      }, n.prototype._expand = function(r) {
        for (; this.length < r; )
          this.words[this.length++] = 0;
        return this;
      }, n.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, n.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, n.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var h = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], y = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], M = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      n.prototype.toString = function(r, s) {
        r = r || 10, s = s | 0 || 1;
        var u;
        if (r === 16 || r === "hex") {
          u = "";
          for (var g = 0, v = 0, A = 0; A < this.length; A++) {
            var L = this.words[A], m = ((L << g | v) & 16777215).toString(16);
            v = L >>> 24 - g & 16777215, g += 2, g >= 26 && (g -= 26, A--), v !== 0 || A !== this.length - 1 ? u = h[6 - m.length] + m + u : u = m + u;
          }
          for (v !== 0 && (u = v.toString(16) + u); u.length % s !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        if (r === (r | 0) && r >= 2 && r <= 36) {
          var a = y[r], x = M[r];
          u = "";
          var V = this.clone();
          for (V.negative = 0; !V.isZero(); ) {
            var G = V.modn(x).toString(r);
            V = V.idivn(x), V.isZero() ? u = G + u : u = h[a - G.length] + G + u;
          }
          for (this.isZero() && (u = "0" + u); u.length % s !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        i(!1, "Base should be between 2 and 36");
      }, n.prototype.toNumber = function() {
        var r = this.words[0];
        return this.length === 2 ? r += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? r += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -r : r;
      }, n.prototype.toJSON = function() {
        return this.toString(16);
      }, n.prototype.toBuffer = function(r, s) {
        return i(typeof d < "u"), this.toArrayLike(d, r, s);
      }, n.prototype.toArray = function(r, s) {
        return this.toArrayLike(Array, r, s);
      }, n.prototype.toArrayLike = function(r, s, u) {
        var g = this.byteLength(), v = u || Math.max(1, g);
        i(g <= v, "byte array longer than desired length"), i(v > 0, "Requested array length <= 0"), this.strip();
        var A = s === "le", L = new r(v), m, a, x = this.clone();
        if (A) {
          for (a = 0; !x.isZero(); a++)
            m = x.andln(255), x.iushrn(8), L[a] = m;
          for (; a < v; a++)
            L[a] = 0;
        } else {
          for (a = 0; a < v - g; a++)
            L[a] = 0;
          for (a = 0; !x.isZero(); a++)
            m = x.andln(255), x.iushrn(8), L[v - a - 1] = m;
        }
        return L;
      }, Math.clz32 ? n.prototype._countBits = function(r) {
        return 32 - Math.clz32(r);
      } : n.prototype._countBits = function(r) {
        var s = r, u = 0;
        return s >= 4096 && (u += 13, s >>>= 13), s >= 64 && (u += 7, s >>>= 7), s >= 8 && (u += 4, s >>>= 4), s >= 2 && (u += 2, s >>>= 2), u + s;
      }, n.prototype._zeroBits = function(r) {
        if (r === 0) return 26;
        var s = r, u = 0;
        return s & 8191 || (u += 13, s >>>= 13), s & 127 || (u += 7, s >>>= 7), s & 15 || (u += 4, s >>>= 4), s & 3 || (u += 2, s >>>= 2), s & 1 || u++, u;
      }, n.prototype.bitLength = function() {
        var r = this.words[this.length - 1], s = this._countBits(r);
        return (this.length - 1) * 26 + s;
      };
      function C(I) {
        for (var r = new Array(I.bitLength()), s = 0; s < r.length; s++) {
          var u = s / 26 | 0, g = s % 26;
          r[s] = (I.words[u] & 1 << g) >>> g;
        }
        return r;
      }
      n.prototype.zeroBits = function() {
        if (this.isZero()) return 0;
        for (var r = 0, s = 0; s < this.length; s++) {
          var u = this._zeroBits(this.words[s]);
          if (r += u, u !== 26) break;
        }
        return r;
      }, n.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, n.prototype.toTwos = function(r) {
        return this.negative !== 0 ? this.abs().inotn(r).iaddn(1) : this.clone();
      }, n.prototype.fromTwos = function(r) {
        return this.testn(r - 1) ? this.notn(r).iaddn(1).ineg() : this.clone();
      }, n.prototype.isNeg = function() {
        return this.negative !== 0;
      }, n.prototype.neg = function() {
        return this.clone().ineg();
      }, n.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, n.prototype.iuor = function(r) {
        for (; this.length < r.length; )
          this.words[this.length++] = 0;
        for (var s = 0; s < r.length; s++)
          this.words[s] = this.words[s] | r.words[s];
        return this.strip();
      }, n.prototype.ior = function(r) {
        return i((this.negative | r.negative) === 0), this.iuor(r);
      }, n.prototype.or = function(r) {
        return this.length > r.length ? this.clone().ior(r) : r.clone().ior(this);
      }, n.prototype.uor = function(r) {
        return this.length > r.length ? this.clone().iuor(r) : r.clone().iuor(this);
      }, n.prototype.iuand = function(r) {
        var s;
        this.length > r.length ? s = r : s = this;
        for (var u = 0; u < s.length; u++)
          this.words[u] = this.words[u] & r.words[u];
        return this.length = s.length, this.strip();
      }, n.prototype.iand = function(r) {
        return i((this.negative | r.negative) === 0), this.iuand(r);
      }, n.prototype.and = function(r) {
        return this.length > r.length ? this.clone().iand(r) : r.clone().iand(this);
      }, n.prototype.uand = function(r) {
        return this.length > r.length ? this.clone().iuand(r) : r.clone().iuand(this);
      }, n.prototype.iuxor = function(r) {
        var s, u;
        this.length > r.length ? (s = this, u = r) : (s = r, u = this);
        for (var g = 0; g < u.length; g++)
          this.words[g] = s.words[g] ^ u.words[g];
        if (this !== s)
          for (; g < s.length; g++)
            this.words[g] = s.words[g];
        return this.length = s.length, this.strip();
      }, n.prototype.ixor = function(r) {
        return i((this.negative | r.negative) === 0), this.iuxor(r);
      }, n.prototype.xor = function(r) {
        return this.length > r.length ? this.clone().ixor(r) : r.clone().ixor(this);
      }, n.prototype.uxor = function(r) {
        return this.length > r.length ? this.clone().iuxor(r) : r.clone().iuxor(this);
      }, n.prototype.inotn = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = Math.ceil(r / 26) | 0, u = r % 26;
        this._expand(s), u > 0 && s--;
        for (var g = 0; g < s; g++)
          this.words[g] = ~this.words[g] & 67108863;
        return u > 0 && (this.words[g] = ~this.words[g] & 67108863 >> 26 - u), this.strip();
      }, n.prototype.notn = function(r) {
        return this.clone().inotn(r);
      }, n.prototype.setn = function(r, s) {
        i(typeof r == "number" && r >= 0);
        var u = r / 26 | 0, g = r % 26;
        return this._expand(u + 1), s ? this.words[u] = this.words[u] | 1 << g : this.words[u] = this.words[u] & ~(1 << g), this.strip();
      }, n.prototype.iadd = function(r) {
        var s;
        if (this.negative !== 0 && r.negative === 0)
          return this.negative = 0, s = this.isub(r), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && r.negative !== 0)
          return r.negative = 0, s = this.isub(r), r.negative = 1, s._normSign();
        var u, g;
        this.length > r.length ? (u = this, g = r) : (u = r, g = this);
        for (var v = 0, A = 0; A < g.length; A++)
          s = (u.words[A] | 0) + (g.words[A] | 0) + v, this.words[A] = s & 67108863, v = s >>> 26;
        for (; v !== 0 && A < u.length; A++)
          s = (u.words[A] | 0) + v, this.words[A] = s & 67108863, v = s >>> 26;
        if (this.length = u.length, v !== 0)
          this.words[this.length] = v, this.length++;
        else if (u !== this)
          for (; A < u.length; A++)
            this.words[A] = u.words[A];
        return this;
      }, n.prototype.add = function(r) {
        var s;
        return r.negative !== 0 && this.negative === 0 ? (r.negative = 0, s = this.sub(r), r.negative ^= 1, s) : r.negative === 0 && this.negative !== 0 ? (this.negative = 0, s = r.sub(this), this.negative = 1, s) : this.length > r.length ? this.clone().iadd(r) : r.clone().iadd(this);
      }, n.prototype.isub = function(r) {
        if (r.negative !== 0) {
          r.negative = 0;
          var s = this.iadd(r);
          return r.negative = 1, s._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(r), this.negative = 1, this._normSign();
        var u = this.cmp(r);
        if (u === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var g, v;
        u > 0 ? (g = this, v = r) : (g = r, v = this);
        for (var A = 0, L = 0; L < v.length; L++)
          s = (g.words[L] | 0) - (v.words[L] | 0) + A, A = s >> 26, this.words[L] = s & 67108863;
        for (; A !== 0 && L < g.length; L++)
          s = (g.words[L] | 0) + A, A = s >> 26, this.words[L] = s & 67108863;
        if (A === 0 && L < g.length && g !== this)
          for (; L < g.length; L++)
            this.words[L] = g.words[L];
        return this.length = Math.max(this.length, L), g !== this && (this.negative = 1), this.strip();
      }, n.prototype.sub = function(r) {
        return this.clone().isub(r);
      };
      function N(I, r, s) {
        s.negative = r.negative ^ I.negative;
        var u = I.length + r.length | 0;
        s.length = u, u = u - 1 | 0;
        var g = I.words[0] | 0, v = r.words[0] | 0, A = g * v, L = A & 67108863, m = A / 67108864 | 0;
        s.words[0] = L;
        for (var a = 1; a < u; a++) {
          for (var x = m >>> 26, V = m & 67108863, G = Math.min(a, r.length - 1), Z = Math.max(0, a - I.length + 1); Z <= G; Z++) {
            var te = a - Z | 0;
            g = I.words[te] | 0, v = r.words[Z] | 0, A = g * v + V, x += A / 67108864 | 0, V = A & 67108863;
          }
          s.words[a] = V | 0, m = x | 0;
        }
        return m !== 0 ? s.words[a] = m | 0 : s.length--, s.strip();
      }
      var w = function(r, s, u) {
        var g = r.words, v = s.words, A = u.words, L = 0, m, a, x, V = g[0] | 0, G = V & 8191, Z = V >>> 13, te = g[1] | 0, q = te & 8191, R = te >>> 13, Q = g[2] | 0, $ = Q & 8191, F = Q >>> 13, P = g[3] | 0, _ = P & 8191, X = P >>> 13, le = g[4] | 0, ie = le & 8191, oe = le >>> 13, pe = g[5] | 0, se = pe & 8191, ce = pe >>> 13, me = g[6] | 0, de = me & 8191, ae = me >>> 13, Le = g[7] | 0, ye = Le & 8191, Me = Le >>> 13, at = g[8] | 0, Ne = at & 8191, Ae = at >>> 13, pt = g[9] | 0, ke = pt & 8191, Te = pt >>> 13, Dt = v[0] | 0, De = Dt & 8191, je = Dt >>> 13, At = v[1] | 0, xe = At & 8191, Ie = At >>> 13, Nt = v[2] | 0, _e = Nt & 8191, Be = Nt >>> 13, Xt = v[3] | 0, Re = Xt & 8191, Pe = Xt >>> 13, dr = v[4] | 0, We = dr & 8191, He = dr >>> 13, Ct = v[5] | 0, Ue = Ct & 8191, Ze = Ct >>> 13, Fr = v[6] | 0, Ye = Fr & 8191, Qe = Fr >>> 13, J = v[7] | 0, ee = J & 8191, K = J >>> 13, Y = v[8] | 0, re = Y & 8191, he = Y >>> 13, Se = v[9] | 0, ve = Se & 8191, we = Se >>> 13;
        u.negative = r.negative ^ s.negative, u.length = 19, m = Math.imul(G, De), a = Math.imul(G, je), a = a + Math.imul(Z, De) | 0, x = Math.imul(Z, je);
        var lt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (lt >>> 26) | 0, lt &= 67108863, m = Math.imul(q, De), a = Math.imul(q, je), a = a + Math.imul(R, De) | 0, x = Math.imul(R, je), m = m + Math.imul(G, xe) | 0, a = a + Math.imul(G, Ie) | 0, a = a + Math.imul(Z, xe) | 0, x = x + Math.imul(Z, Ie) | 0;
        var et = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (et >>> 26) | 0, et &= 67108863, m = Math.imul($, De), a = Math.imul($, je), a = a + Math.imul(F, De) | 0, x = Math.imul(F, je), m = m + Math.imul(q, xe) | 0, a = a + Math.imul(q, Ie) | 0, a = a + Math.imul(R, xe) | 0, x = x + Math.imul(R, Ie) | 0, m = m + Math.imul(G, _e) | 0, a = a + Math.imul(G, Be) | 0, a = a + Math.imul(Z, _e) | 0, x = x + Math.imul(Z, Be) | 0;
        var Lt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Lt >>> 26) | 0, Lt &= 67108863, m = Math.imul(_, De), a = Math.imul(_, je), a = a + Math.imul(X, De) | 0, x = Math.imul(X, je), m = m + Math.imul($, xe) | 0, a = a + Math.imul($, Ie) | 0, a = a + Math.imul(F, xe) | 0, x = x + Math.imul(F, Ie) | 0, m = m + Math.imul(q, _e) | 0, a = a + Math.imul(q, Be) | 0, a = a + Math.imul(R, _e) | 0, x = x + Math.imul(R, Be) | 0, m = m + Math.imul(G, Re) | 0, a = a + Math.imul(G, Pe) | 0, a = a + Math.imul(Z, Re) | 0, x = x + Math.imul(Z, Pe) | 0;
        var nt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (nt >>> 26) | 0, nt &= 67108863, m = Math.imul(ie, De), a = Math.imul(ie, je), a = a + Math.imul(oe, De) | 0, x = Math.imul(oe, je), m = m + Math.imul(_, xe) | 0, a = a + Math.imul(_, Ie) | 0, a = a + Math.imul(X, xe) | 0, x = x + Math.imul(X, Ie) | 0, m = m + Math.imul($, _e) | 0, a = a + Math.imul($, Be) | 0, a = a + Math.imul(F, _e) | 0, x = x + Math.imul(F, Be) | 0, m = m + Math.imul(q, Re) | 0, a = a + Math.imul(q, Pe) | 0, a = a + Math.imul(R, Re) | 0, x = x + Math.imul(R, Pe) | 0, m = m + Math.imul(G, We) | 0, a = a + Math.imul(G, He) | 0, a = a + Math.imul(Z, We) | 0, x = x + Math.imul(Z, He) | 0;
        var gt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, m = Math.imul(se, De), a = Math.imul(se, je), a = a + Math.imul(ce, De) | 0, x = Math.imul(ce, je), m = m + Math.imul(ie, xe) | 0, a = a + Math.imul(ie, Ie) | 0, a = a + Math.imul(oe, xe) | 0, x = x + Math.imul(oe, Ie) | 0, m = m + Math.imul(_, _e) | 0, a = a + Math.imul(_, Be) | 0, a = a + Math.imul(X, _e) | 0, x = x + Math.imul(X, Be) | 0, m = m + Math.imul($, Re) | 0, a = a + Math.imul($, Pe) | 0, a = a + Math.imul(F, Re) | 0, x = x + Math.imul(F, Pe) | 0, m = m + Math.imul(q, We) | 0, a = a + Math.imul(q, He) | 0, a = a + Math.imul(R, We) | 0, x = x + Math.imul(R, He) | 0, m = m + Math.imul(G, Ue) | 0, a = a + Math.imul(G, Ze) | 0, a = a + Math.imul(Z, Ue) | 0, x = x + Math.imul(Z, Ze) | 0;
        var yt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, m = Math.imul(de, De), a = Math.imul(de, je), a = a + Math.imul(ae, De) | 0, x = Math.imul(ae, je), m = m + Math.imul(se, xe) | 0, a = a + Math.imul(se, Ie) | 0, a = a + Math.imul(ce, xe) | 0, x = x + Math.imul(ce, Ie) | 0, m = m + Math.imul(ie, _e) | 0, a = a + Math.imul(ie, Be) | 0, a = a + Math.imul(oe, _e) | 0, x = x + Math.imul(oe, Be) | 0, m = m + Math.imul(_, Re) | 0, a = a + Math.imul(_, Pe) | 0, a = a + Math.imul(X, Re) | 0, x = x + Math.imul(X, Pe) | 0, m = m + Math.imul($, We) | 0, a = a + Math.imul($, He) | 0, a = a + Math.imul(F, We) | 0, x = x + Math.imul(F, He) | 0, m = m + Math.imul(q, Ue) | 0, a = a + Math.imul(q, Ze) | 0, a = a + Math.imul(R, Ue) | 0, x = x + Math.imul(R, Ze) | 0, m = m + Math.imul(G, Ye) | 0, a = a + Math.imul(G, Qe) | 0, a = a + Math.imul(Z, Ye) | 0, x = x + Math.imul(Z, Qe) | 0;
        var xt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (xt >>> 26) | 0, xt &= 67108863, m = Math.imul(ye, De), a = Math.imul(ye, je), a = a + Math.imul(Me, De) | 0, x = Math.imul(Me, je), m = m + Math.imul(de, xe) | 0, a = a + Math.imul(de, Ie) | 0, a = a + Math.imul(ae, xe) | 0, x = x + Math.imul(ae, Ie) | 0, m = m + Math.imul(se, _e) | 0, a = a + Math.imul(se, Be) | 0, a = a + Math.imul(ce, _e) | 0, x = x + Math.imul(ce, Be) | 0, m = m + Math.imul(ie, Re) | 0, a = a + Math.imul(ie, Pe) | 0, a = a + Math.imul(oe, Re) | 0, x = x + Math.imul(oe, Pe) | 0, m = m + Math.imul(_, We) | 0, a = a + Math.imul(_, He) | 0, a = a + Math.imul(X, We) | 0, x = x + Math.imul(X, He) | 0, m = m + Math.imul($, Ue) | 0, a = a + Math.imul($, Ze) | 0, a = a + Math.imul(F, Ue) | 0, x = x + Math.imul(F, Ze) | 0, m = m + Math.imul(q, Ye) | 0, a = a + Math.imul(q, Qe) | 0, a = a + Math.imul(R, Ye) | 0, x = x + Math.imul(R, Qe) | 0, m = m + Math.imul(G, ee) | 0, a = a + Math.imul(G, K) | 0, a = a + Math.imul(Z, ee) | 0, x = x + Math.imul(Z, K) | 0;
        var bt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, m = Math.imul(Ne, De), a = Math.imul(Ne, je), a = a + Math.imul(Ae, De) | 0, x = Math.imul(Ae, je), m = m + Math.imul(ye, xe) | 0, a = a + Math.imul(ye, Ie) | 0, a = a + Math.imul(Me, xe) | 0, x = x + Math.imul(Me, Ie) | 0, m = m + Math.imul(de, _e) | 0, a = a + Math.imul(de, Be) | 0, a = a + Math.imul(ae, _e) | 0, x = x + Math.imul(ae, Be) | 0, m = m + Math.imul(se, Re) | 0, a = a + Math.imul(se, Pe) | 0, a = a + Math.imul(ce, Re) | 0, x = x + Math.imul(ce, Pe) | 0, m = m + Math.imul(ie, We) | 0, a = a + Math.imul(ie, He) | 0, a = a + Math.imul(oe, We) | 0, x = x + Math.imul(oe, He) | 0, m = m + Math.imul(_, Ue) | 0, a = a + Math.imul(_, Ze) | 0, a = a + Math.imul(X, Ue) | 0, x = x + Math.imul(X, Ze) | 0, m = m + Math.imul($, Ye) | 0, a = a + Math.imul($, Qe) | 0, a = a + Math.imul(F, Ye) | 0, x = x + Math.imul(F, Qe) | 0, m = m + Math.imul(q, ee) | 0, a = a + Math.imul(q, K) | 0, a = a + Math.imul(R, ee) | 0, x = x + Math.imul(R, K) | 0, m = m + Math.imul(G, re) | 0, a = a + Math.imul(G, he) | 0, a = a + Math.imul(Z, re) | 0, x = x + Math.imul(Z, he) | 0;
        var Mt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Mt >>> 26) | 0, Mt &= 67108863, m = Math.imul(ke, De), a = Math.imul(ke, je), a = a + Math.imul(Te, De) | 0, x = Math.imul(Te, je), m = m + Math.imul(Ne, xe) | 0, a = a + Math.imul(Ne, Ie) | 0, a = a + Math.imul(Ae, xe) | 0, x = x + Math.imul(Ae, Ie) | 0, m = m + Math.imul(ye, _e) | 0, a = a + Math.imul(ye, Be) | 0, a = a + Math.imul(Me, _e) | 0, x = x + Math.imul(Me, Be) | 0, m = m + Math.imul(de, Re) | 0, a = a + Math.imul(de, Pe) | 0, a = a + Math.imul(ae, Re) | 0, x = x + Math.imul(ae, Pe) | 0, m = m + Math.imul(se, We) | 0, a = a + Math.imul(se, He) | 0, a = a + Math.imul(ce, We) | 0, x = x + Math.imul(ce, He) | 0, m = m + Math.imul(ie, Ue) | 0, a = a + Math.imul(ie, Ze) | 0, a = a + Math.imul(oe, Ue) | 0, x = x + Math.imul(oe, Ze) | 0, m = m + Math.imul(_, Ye) | 0, a = a + Math.imul(_, Qe) | 0, a = a + Math.imul(X, Ye) | 0, x = x + Math.imul(X, Qe) | 0, m = m + Math.imul($, ee) | 0, a = a + Math.imul($, K) | 0, a = a + Math.imul(F, ee) | 0, x = x + Math.imul(F, K) | 0, m = m + Math.imul(q, re) | 0, a = a + Math.imul(q, he) | 0, a = a + Math.imul(R, re) | 0, x = x + Math.imul(R, he) | 0, m = m + Math.imul(G, ve) | 0, a = a + Math.imul(G, we) | 0, a = a + Math.imul(Z, ve) | 0, x = x + Math.imul(Z, we) | 0;
        var vt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, m = Math.imul(ke, xe), a = Math.imul(ke, Ie), a = a + Math.imul(Te, xe) | 0, x = Math.imul(Te, Ie), m = m + Math.imul(Ne, _e) | 0, a = a + Math.imul(Ne, Be) | 0, a = a + Math.imul(Ae, _e) | 0, x = x + Math.imul(Ae, Be) | 0, m = m + Math.imul(ye, Re) | 0, a = a + Math.imul(ye, Pe) | 0, a = a + Math.imul(Me, Re) | 0, x = x + Math.imul(Me, Pe) | 0, m = m + Math.imul(de, We) | 0, a = a + Math.imul(de, He) | 0, a = a + Math.imul(ae, We) | 0, x = x + Math.imul(ae, He) | 0, m = m + Math.imul(se, Ue) | 0, a = a + Math.imul(se, Ze) | 0, a = a + Math.imul(ce, Ue) | 0, x = x + Math.imul(ce, Ze) | 0, m = m + Math.imul(ie, Ye) | 0, a = a + Math.imul(ie, Qe) | 0, a = a + Math.imul(oe, Ye) | 0, x = x + Math.imul(oe, Qe) | 0, m = m + Math.imul(_, ee) | 0, a = a + Math.imul(_, K) | 0, a = a + Math.imul(X, ee) | 0, x = x + Math.imul(X, K) | 0, m = m + Math.imul($, re) | 0, a = a + Math.imul($, he) | 0, a = a + Math.imul(F, re) | 0, x = x + Math.imul(F, he) | 0, m = m + Math.imul(q, ve) | 0, a = a + Math.imul(q, we) | 0, a = a + Math.imul(R, ve) | 0, x = x + Math.imul(R, we) | 0;
        var mt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, m = Math.imul(ke, _e), a = Math.imul(ke, Be), a = a + Math.imul(Te, _e) | 0, x = Math.imul(Te, Be), m = m + Math.imul(Ne, Re) | 0, a = a + Math.imul(Ne, Pe) | 0, a = a + Math.imul(Ae, Re) | 0, x = x + Math.imul(Ae, Pe) | 0, m = m + Math.imul(ye, We) | 0, a = a + Math.imul(ye, He) | 0, a = a + Math.imul(Me, We) | 0, x = x + Math.imul(Me, He) | 0, m = m + Math.imul(de, Ue) | 0, a = a + Math.imul(de, Ze) | 0, a = a + Math.imul(ae, Ue) | 0, x = x + Math.imul(ae, Ze) | 0, m = m + Math.imul(se, Ye) | 0, a = a + Math.imul(se, Qe) | 0, a = a + Math.imul(ce, Ye) | 0, x = x + Math.imul(ce, Qe) | 0, m = m + Math.imul(ie, ee) | 0, a = a + Math.imul(ie, K) | 0, a = a + Math.imul(oe, ee) | 0, x = x + Math.imul(oe, K) | 0, m = m + Math.imul(_, re) | 0, a = a + Math.imul(_, he) | 0, a = a + Math.imul(X, re) | 0, x = x + Math.imul(X, he) | 0, m = m + Math.imul($, ve) | 0, a = a + Math.imul($, we) | 0, a = a + Math.imul(F, ve) | 0, x = x + Math.imul(F, we) | 0;
        var ot = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (ot >>> 26) | 0, ot &= 67108863, m = Math.imul(ke, Re), a = Math.imul(ke, Pe), a = a + Math.imul(Te, Re) | 0, x = Math.imul(Te, Pe), m = m + Math.imul(Ne, We) | 0, a = a + Math.imul(Ne, He) | 0, a = a + Math.imul(Ae, We) | 0, x = x + Math.imul(Ae, He) | 0, m = m + Math.imul(ye, Ue) | 0, a = a + Math.imul(ye, Ze) | 0, a = a + Math.imul(Me, Ue) | 0, x = x + Math.imul(Me, Ze) | 0, m = m + Math.imul(de, Ye) | 0, a = a + Math.imul(de, Qe) | 0, a = a + Math.imul(ae, Ye) | 0, x = x + Math.imul(ae, Qe) | 0, m = m + Math.imul(se, ee) | 0, a = a + Math.imul(se, K) | 0, a = a + Math.imul(ce, ee) | 0, x = x + Math.imul(ce, K) | 0, m = m + Math.imul(ie, re) | 0, a = a + Math.imul(ie, he) | 0, a = a + Math.imul(oe, re) | 0, x = x + Math.imul(oe, he) | 0, m = m + Math.imul(_, ve) | 0, a = a + Math.imul(_, we) | 0, a = a + Math.imul(X, ve) | 0, x = x + Math.imul(X, we) | 0;
        var ft = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (ft >>> 26) | 0, ft &= 67108863, m = Math.imul(ke, We), a = Math.imul(ke, He), a = a + Math.imul(Te, We) | 0, x = Math.imul(Te, He), m = m + Math.imul(Ne, Ue) | 0, a = a + Math.imul(Ne, Ze) | 0, a = a + Math.imul(Ae, Ue) | 0, x = x + Math.imul(Ae, Ze) | 0, m = m + Math.imul(ye, Ye) | 0, a = a + Math.imul(ye, Qe) | 0, a = a + Math.imul(Me, Ye) | 0, x = x + Math.imul(Me, Qe) | 0, m = m + Math.imul(de, ee) | 0, a = a + Math.imul(de, K) | 0, a = a + Math.imul(ae, ee) | 0, x = x + Math.imul(ae, K) | 0, m = m + Math.imul(se, re) | 0, a = a + Math.imul(se, he) | 0, a = a + Math.imul(ce, re) | 0, x = x + Math.imul(ce, he) | 0, m = m + Math.imul(ie, ve) | 0, a = a + Math.imul(ie, we) | 0, a = a + Math.imul(oe, ve) | 0, x = x + Math.imul(oe, we) | 0;
        var rt = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (rt >>> 26) | 0, rt &= 67108863, m = Math.imul(ke, Ue), a = Math.imul(ke, Ze), a = a + Math.imul(Te, Ue) | 0, x = Math.imul(Te, Ze), m = m + Math.imul(Ne, Ye) | 0, a = a + Math.imul(Ne, Qe) | 0, a = a + Math.imul(Ae, Ye) | 0, x = x + Math.imul(Ae, Qe) | 0, m = m + Math.imul(ye, ee) | 0, a = a + Math.imul(ye, K) | 0, a = a + Math.imul(Me, ee) | 0, x = x + Math.imul(Me, K) | 0, m = m + Math.imul(de, re) | 0, a = a + Math.imul(de, he) | 0, a = a + Math.imul(ae, re) | 0, x = x + Math.imul(ae, he) | 0, m = m + Math.imul(se, ve) | 0, a = a + Math.imul(se, we) | 0, a = a + Math.imul(ce, ve) | 0, x = x + Math.imul(ce, we) | 0;
        var st = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (st >>> 26) | 0, st &= 67108863, m = Math.imul(ke, Ye), a = Math.imul(ke, Qe), a = a + Math.imul(Te, Ye) | 0, x = Math.imul(Te, Qe), m = m + Math.imul(Ne, ee) | 0, a = a + Math.imul(Ne, K) | 0, a = a + Math.imul(Ae, ee) | 0, x = x + Math.imul(Ae, K) | 0, m = m + Math.imul(ye, re) | 0, a = a + Math.imul(ye, he) | 0, a = a + Math.imul(Me, re) | 0, x = x + Math.imul(Me, he) | 0, m = m + Math.imul(de, ve) | 0, a = a + Math.imul(de, we) | 0, a = a + Math.imul(ae, ve) | 0, x = x + Math.imul(ae, we) | 0;
        var ct = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (ct >>> 26) | 0, ct &= 67108863, m = Math.imul(ke, ee), a = Math.imul(ke, K), a = a + Math.imul(Te, ee) | 0, x = Math.imul(Te, K), m = m + Math.imul(Ne, re) | 0, a = a + Math.imul(Ne, he) | 0, a = a + Math.imul(Ae, re) | 0, x = x + Math.imul(Ae, he) | 0, m = m + Math.imul(ye, ve) | 0, a = a + Math.imul(ye, we) | 0, a = a + Math.imul(Me, ve) | 0, x = x + Math.imul(Me, we) | 0;
        var Je = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Je >>> 26) | 0, Je &= 67108863, m = Math.imul(ke, re), a = Math.imul(ke, he), a = a + Math.imul(Te, re) | 0, x = Math.imul(Te, he), m = m + Math.imul(Ne, ve) | 0, a = a + Math.imul(Ne, we) | 0, a = a + Math.imul(Ae, ve) | 0, x = x + Math.imul(Ae, we) | 0;
        var Oe = (L + m | 0) + ((a & 8191) << 13) | 0;
        L = (x + (a >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, m = Math.imul(ke, ve), a = Math.imul(ke, we), a = a + Math.imul(Te, ve) | 0, x = Math.imul(Te, we);
        var ze = (L + m | 0) + ((a & 8191) << 13) | 0;
        return L = (x + (a >>> 13) | 0) + (ze >>> 26) | 0, ze &= 67108863, A[0] = lt, A[1] = et, A[2] = Lt, A[3] = nt, A[4] = gt, A[5] = yt, A[6] = xt, A[7] = bt, A[8] = Mt, A[9] = vt, A[10] = mt, A[11] = ot, A[12] = ft, A[13] = rt, A[14] = st, A[15] = ct, A[16] = Je, A[17] = Oe, A[18] = ze, L !== 0 && (A[19] = L, u.length++), u;
      };
      Math.imul || (w = N);
      function S(I, r, s) {
        s.negative = r.negative ^ I.negative, s.length = I.length + r.length;
        for (var u = 0, g = 0, v = 0; v < s.length - 1; v++) {
          var A = g;
          g = 0;
          for (var L = u & 67108863, m = Math.min(v, r.length - 1), a = Math.max(0, v - I.length + 1); a <= m; a++) {
            var x = v - a, V = I.words[x] | 0, G = r.words[a] | 0, Z = V * G, te = Z & 67108863;
            A = A + (Z / 67108864 | 0) | 0, te = te + L | 0, L = te & 67108863, A = A + (te >>> 26) | 0, g += A >>> 26, A &= 67108863;
          }
          s.words[v] = L, u = A, A = g;
        }
        return u !== 0 ? s.words[v] = u : s.length--, s.strip();
      }
      function T(I, r, s) {
        var u = new E();
        return u.mulp(I, r, s);
      }
      n.prototype.mulTo = function(r, s) {
        var u, g = this.length + r.length;
        return this.length === 10 && r.length === 10 ? u = w(this, r, s) : g < 63 ? u = N(this, r, s) : g < 1024 ? u = S(this, r, s) : u = T(this, r, s), u;
      };
      function E(I, r) {
        this.x = I, this.y = r;
      }
      E.prototype.makeRBT = function(r) {
        for (var s = new Array(r), u = n.prototype._countBits(r) - 1, g = 0; g < r; g++)
          s[g] = this.revBin(g, u, r);
        return s;
      }, E.prototype.revBin = function(r, s, u) {
        if (r === 0 || r === u - 1) return r;
        for (var g = 0, v = 0; v < s; v++)
          g |= (r & 1) << s - v - 1, r >>= 1;
        return g;
      }, E.prototype.permute = function(r, s, u, g, v, A) {
        for (var L = 0; L < A; L++)
          g[L] = s[r[L]], v[L] = u[r[L]];
      }, E.prototype.transform = function(r, s, u, g, v, A) {
        this.permute(A, r, s, u, g, v);
        for (var L = 1; L < v; L <<= 1)
          for (var m = L << 1, a = Math.cos(2 * Math.PI / m), x = Math.sin(2 * Math.PI / m), V = 0; V < v; V += m)
            for (var G = a, Z = x, te = 0; te < L; te++) {
              var q = u[V + te], R = g[V + te], Q = u[V + te + L], $ = g[V + te + L], F = G * Q - Z * $;
              $ = G * $ + Z * Q, Q = F, u[V + te] = q + Q, g[V + te] = R + $, u[V + te + L] = q - Q, g[V + te + L] = R - $, te !== m && (F = a * G - x * Z, Z = a * Z + x * G, G = F);
            }
      }, E.prototype.guessLen13b = function(r, s) {
        var u = Math.max(s, r) | 1, g = u & 1, v = 0;
        for (u = u / 2 | 0; u; u = u >>> 1)
          v++;
        return 1 << v + 1 + g;
      }, E.prototype.conjugate = function(r, s, u) {
        if (!(u <= 1))
          for (var g = 0; g < u / 2; g++) {
            var v = r[g];
            r[g] = r[u - g - 1], r[u - g - 1] = v, v = s[g], s[g] = -s[u - g - 1], s[u - g - 1] = -v;
          }
      }, E.prototype.normalize13b = function(r, s) {
        for (var u = 0, g = 0; g < s / 2; g++) {
          var v = Math.round(r[2 * g + 1] / s) * 8192 + Math.round(r[2 * g] / s) + u;
          r[g] = v & 67108863, v < 67108864 ? u = 0 : u = v / 67108864 | 0;
        }
        return r;
      }, E.prototype.convert13b = function(r, s, u, g) {
        for (var v = 0, A = 0; A < s; A++)
          v = v + (r[A] | 0), u[2 * A] = v & 8191, v = v >>> 13, u[2 * A + 1] = v & 8191, v = v >>> 13;
        for (A = 2 * s; A < g; ++A)
          u[A] = 0;
        i(v === 0), i((v & -8192) === 0);
      }, E.prototype.stub = function(r) {
        for (var s = new Array(r), u = 0; u < r; u++)
          s[u] = 0;
        return s;
      }, E.prototype.mulp = function(r, s, u) {
        var g = 2 * this.guessLen13b(r.length, s.length), v = this.makeRBT(g), A = this.stub(g), L = new Array(g), m = new Array(g), a = new Array(g), x = new Array(g), V = new Array(g), G = new Array(g), Z = u.words;
        Z.length = g, this.convert13b(r.words, r.length, L, g), this.convert13b(s.words, s.length, x, g), this.transform(L, A, m, a, g, v), this.transform(x, A, V, G, g, v);
        for (var te = 0; te < g; te++) {
          var q = m[te] * V[te] - a[te] * G[te];
          a[te] = m[te] * G[te] + a[te] * V[te], m[te] = q;
        }
        return this.conjugate(m, a, g), this.transform(m, a, Z, A, g, v), this.conjugate(Z, A, g), this.normalize13b(Z, g), u.negative = r.negative ^ s.negative, u.length = r.length + s.length, u.strip();
      }, n.prototype.mul = function(r) {
        var s = new n(null);
        return s.words = new Array(this.length + r.length), this.mulTo(r, s);
      }, n.prototype.mulf = function(r) {
        var s = new n(null);
        return s.words = new Array(this.length + r.length), T(this, r, s);
      }, n.prototype.imul = function(r) {
        return this.clone().mulTo(r, this);
      }, n.prototype.imuln = function(r) {
        i(typeof r == "number"), i(r < 67108864);
        for (var s = 0, u = 0; u < this.length; u++) {
          var g = (this.words[u] | 0) * r, v = (g & 67108863) + (s & 67108863);
          s >>= 26, s += g / 67108864 | 0, s += v >>> 26, this.words[u] = v & 67108863;
        }
        return s !== 0 && (this.words[u] = s, this.length++), this.length = r === 0 ? 1 : this.length, this;
      }, n.prototype.muln = function(r) {
        return this.clone().imuln(r);
      }, n.prototype.sqr = function() {
        return this.mul(this);
      }, n.prototype.isqr = function() {
        return this.imul(this.clone());
      }, n.prototype.pow = function(r) {
        var s = C(r);
        if (s.length === 0) return new n(1);
        for (var u = this, g = 0; g < s.length && s[g] === 0; g++, u = u.sqr())
          ;
        if (++g < s.length)
          for (var v = u.sqr(); g < s.length; g++, v = v.sqr())
            s[g] !== 0 && (u = u.mul(v));
        return u;
      }, n.prototype.iushln = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = r % 26, u = (r - s) / 26, g = 67108863 >>> 26 - s << 26 - s, v;
        if (s !== 0) {
          var A = 0;
          for (v = 0; v < this.length; v++) {
            var L = this.words[v] & g, m = (this.words[v] | 0) - L << s;
            this.words[v] = m | A, A = L >>> 26 - s;
          }
          A && (this.words[v] = A, this.length++);
        }
        if (u !== 0) {
          for (v = this.length - 1; v >= 0; v--)
            this.words[v + u] = this.words[v];
          for (v = 0; v < u; v++)
            this.words[v] = 0;
          this.length += u;
        }
        return this.strip();
      }, n.prototype.ishln = function(r) {
        return i(this.negative === 0), this.iushln(r);
      }, n.prototype.iushrn = function(r, s, u) {
        i(typeof r == "number" && r >= 0);
        var g;
        s ? g = (s - s % 26) / 26 : g = 0;
        var v = r % 26, A = Math.min((r - v) / 26, this.length), L = 67108863 ^ 67108863 >>> v << v, m = u;
        if (g -= A, g = Math.max(0, g), m) {
          for (var a = 0; a < A; a++)
            m.words[a] = this.words[a];
          m.length = A;
        }
        if (A !== 0) if (this.length > A)
          for (this.length -= A, a = 0; a < this.length; a++)
            this.words[a] = this.words[a + A];
        else
          this.words[0] = 0, this.length = 1;
        var x = 0;
        for (a = this.length - 1; a >= 0 && (x !== 0 || a >= g); a--) {
          var V = this.words[a] | 0;
          this.words[a] = x << 26 - v | V >>> v, x = V & L;
        }
        return m && x !== 0 && (m.words[m.length++] = x), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, n.prototype.ishrn = function(r, s, u) {
        return i(this.negative === 0), this.iushrn(r, s, u);
      }, n.prototype.shln = function(r) {
        return this.clone().ishln(r);
      }, n.prototype.ushln = function(r) {
        return this.clone().iushln(r);
      }, n.prototype.shrn = function(r) {
        return this.clone().ishrn(r);
      }, n.prototype.ushrn = function(r) {
        return this.clone().iushrn(r);
      }, n.prototype.testn = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = r % 26, u = (r - s) / 26, g = 1 << s;
        if (this.length <= u) return !1;
        var v = this.words[u];
        return !!(v & g);
      }, n.prototype.imaskn = function(r) {
        i(typeof r == "number" && r >= 0);
        var s = r % 26, u = (r - s) / 26;
        if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= u)
          return this;
        if (s !== 0 && u++, this.length = Math.min(u, this.length), s !== 0) {
          var g = 67108863 ^ 67108863 >>> s << s;
          this.words[this.length - 1] &= g;
        }
        return this.strip();
      }, n.prototype.maskn = function(r) {
        return this.clone().imaskn(r);
      }, n.prototype.iaddn = function(r) {
        return i(typeof r == "number"), i(r < 67108864), r < 0 ? this.isubn(-r) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < r ? (this.words[0] = r - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(r), this.negative = 1, this) : this._iaddn(r);
      }, n.prototype._iaddn = function(r) {
        this.words[0] += r;
        for (var s = 0; s < this.length && this.words[s] >= 67108864; s++)
          this.words[s] -= 67108864, s === this.length - 1 ? this.words[s + 1] = 1 : this.words[s + 1]++;
        return this.length = Math.max(this.length, s + 1), this;
      }, n.prototype.isubn = function(r) {
        if (i(typeof r == "number"), i(r < 67108864), r < 0) return this.iaddn(-r);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(r), this.negative = 1, this;
        if (this.words[0] -= r, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var s = 0; s < this.length && this.words[s] < 0; s++)
            this.words[s] += 67108864, this.words[s + 1] -= 1;
        return this.strip();
      }, n.prototype.addn = function(r) {
        return this.clone().iaddn(r);
      }, n.prototype.subn = function(r) {
        return this.clone().isubn(r);
      }, n.prototype.iabs = function() {
        return this.negative = 0, this;
      }, n.prototype.abs = function() {
        return this.clone().iabs();
      }, n.prototype._ishlnsubmul = function(r, s, u) {
        var g = r.length + u, v;
        this._expand(g);
        var A, L = 0;
        for (v = 0; v < r.length; v++) {
          A = (this.words[v + u] | 0) + L;
          var m = (r.words[v] | 0) * s;
          A -= m & 67108863, L = (A >> 26) - (m / 67108864 | 0), this.words[v + u] = A & 67108863;
        }
        for (; v < this.length - u; v++)
          A = (this.words[v + u] | 0) + L, L = A >> 26, this.words[v + u] = A & 67108863;
        if (L === 0) return this.strip();
        for (i(L === -1), L = 0, v = 0; v < this.length; v++)
          A = -(this.words[v] | 0) + L, L = A >> 26, this.words[v] = A & 67108863;
        return this.negative = 1, this.strip();
      }, n.prototype._wordDiv = function(r, s) {
        var u = this.length - r.length, g = this.clone(), v = r, A = v.words[v.length - 1] | 0, L = this._countBits(A);
        u = 26 - L, u !== 0 && (v = v.ushln(u), g.iushln(u), A = v.words[v.length - 1] | 0);
        var m = g.length - v.length, a;
        if (s !== "mod") {
          a = new n(null), a.length = m + 1, a.words = new Array(a.length);
          for (var x = 0; x < a.length; x++)
            a.words[x] = 0;
        }
        var V = g.clone()._ishlnsubmul(v, 1, m);
        V.negative === 0 && (g = V, a && (a.words[m] = 1));
        for (var G = m - 1; G >= 0; G--) {
          var Z = (g.words[v.length + G] | 0) * 67108864 + (g.words[v.length + G - 1] | 0);
          for (Z = Math.min(Z / A | 0, 67108863), g._ishlnsubmul(v, Z, G); g.negative !== 0; )
            Z--, g.negative = 0, g._ishlnsubmul(v, 1, G), g.isZero() || (g.negative ^= 1);
          a && (a.words[G] = Z);
        }
        return a && a.strip(), g.strip(), s !== "div" && u !== 0 && g.iushrn(u), {
          div: a || null,
          mod: g
        };
      }, n.prototype.divmod = function(r, s, u) {
        if (i(!r.isZero()), this.isZero())
          return {
            div: new n(0),
            mod: new n(0)
          };
        var g, v, A;
        return this.negative !== 0 && r.negative === 0 ? (A = this.neg().divmod(r, s), s !== "mod" && (g = A.div.neg()), s !== "div" && (v = A.mod.neg(), u && v.negative !== 0 && v.iadd(r)), {
          div: g,
          mod: v
        }) : this.negative === 0 && r.negative !== 0 ? (A = this.divmod(r.neg(), s), s !== "mod" && (g = A.div.neg()), {
          div: g,
          mod: A.mod
        }) : this.negative & r.negative ? (A = this.neg().divmod(r.neg(), s), s !== "div" && (v = A.mod.neg(), u && v.negative !== 0 && v.isub(r)), {
          div: A.div,
          mod: v
        }) : r.length > this.length || this.cmp(r) < 0 ? {
          div: new n(0),
          mod: this
        } : r.length === 1 ? s === "div" ? {
          div: this.divn(r.words[0]),
          mod: null
        } : s === "mod" ? {
          div: null,
          mod: new n(this.modn(r.words[0]))
        } : {
          div: this.divn(r.words[0]),
          mod: new n(this.modn(r.words[0]))
        } : this._wordDiv(r, s);
      }, n.prototype.div = function(r) {
        return this.divmod(r, "div", !1).div;
      }, n.prototype.mod = function(r) {
        return this.divmod(r, "mod", !1).mod;
      }, n.prototype.umod = function(r) {
        return this.divmod(r, "mod", !0).mod;
      }, n.prototype.divRound = function(r) {
        var s = this.divmod(r);
        if (s.mod.isZero()) return s.div;
        var u = s.div.negative !== 0 ? s.mod.isub(r) : s.mod, g = r.ushrn(1), v = r.andln(1), A = u.cmp(g);
        return A < 0 || v === 1 && A === 0 ? s.div : s.div.negative !== 0 ? s.div.isubn(1) : s.div.iaddn(1);
      }, n.prototype.modn = function(r) {
        i(r <= 67108863);
        for (var s = (1 << 26) % r, u = 0, g = this.length - 1; g >= 0; g--)
          u = (s * u + (this.words[g] | 0)) % r;
        return u;
      }, n.prototype.idivn = function(r) {
        i(r <= 67108863);
        for (var s = 0, u = this.length - 1; u >= 0; u--) {
          var g = (this.words[u] | 0) + s * 67108864;
          this.words[u] = g / r | 0, s = g % r;
        }
        return this.strip();
      }, n.prototype.divn = function(r) {
        return this.clone().idivn(r);
      }, n.prototype.egcd = function(r) {
        i(r.negative === 0), i(!r.isZero());
        var s = this, u = r.clone();
        s.negative !== 0 ? s = s.umod(r) : s = s.clone();
        for (var g = new n(1), v = new n(0), A = new n(0), L = new n(1), m = 0; s.isEven() && u.isEven(); )
          s.iushrn(1), u.iushrn(1), ++m;
        for (var a = u.clone(), x = s.clone(); !s.isZero(); ) {
          for (var V = 0, G = 1; !(s.words[0] & G) && V < 26; ++V, G <<= 1) ;
          if (V > 0)
            for (s.iushrn(V); V-- > 0; )
              (g.isOdd() || v.isOdd()) && (g.iadd(a), v.isub(x)), g.iushrn(1), v.iushrn(1);
          for (var Z = 0, te = 1; !(u.words[0] & te) && Z < 26; ++Z, te <<= 1) ;
          if (Z > 0)
            for (u.iushrn(Z); Z-- > 0; )
              (A.isOdd() || L.isOdd()) && (A.iadd(a), L.isub(x)), A.iushrn(1), L.iushrn(1);
          s.cmp(u) >= 0 ? (s.isub(u), g.isub(A), v.isub(L)) : (u.isub(s), A.isub(g), L.isub(v));
        }
        return {
          a: A,
          b: L,
          gcd: u.iushln(m)
        };
      }, n.prototype._invmp = function(r) {
        i(r.negative === 0), i(!r.isZero());
        var s = this, u = r.clone();
        s.negative !== 0 ? s = s.umod(r) : s = s.clone();
        for (var g = new n(1), v = new n(0), A = u.clone(); s.cmpn(1) > 0 && u.cmpn(1) > 0; ) {
          for (var L = 0, m = 1; !(s.words[0] & m) && L < 26; ++L, m <<= 1) ;
          if (L > 0)
            for (s.iushrn(L); L-- > 0; )
              g.isOdd() && g.iadd(A), g.iushrn(1);
          for (var a = 0, x = 1; !(u.words[0] & x) && a < 26; ++a, x <<= 1) ;
          if (a > 0)
            for (u.iushrn(a); a-- > 0; )
              v.isOdd() && v.iadd(A), v.iushrn(1);
          s.cmp(u) >= 0 ? (s.isub(u), g.isub(v)) : (u.isub(s), v.isub(g));
        }
        var V;
        return s.cmpn(1) === 0 ? V = g : V = v, V.cmpn(0) < 0 && V.iadd(r), V;
      }, n.prototype.gcd = function(r) {
        if (this.isZero()) return r.abs();
        if (r.isZero()) return this.abs();
        var s = this.clone(), u = r.clone();
        s.negative = 0, u.negative = 0;
        for (var g = 0; s.isEven() && u.isEven(); g++)
          s.iushrn(1), u.iushrn(1);
        do {
          for (; s.isEven(); )
            s.iushrn(1);
          for (; u.isEven(); )
            u.iushrn(1);
          var v = s.cmp(u);
          if (v < 0) {
            var A = s;
            s = u, u = A;
          } else if (v === 0 || u.cmpn(1) === 0)
            break;
          s.isub(u);
        } while (!0);
        return u.iushln(g);
      }, n.prototype.invm = function(r) {
        return this.egcd(r).a.umod(r);
      }, n.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, n.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, n.prototype.andln = function(r) {
        return this.words[0] & r;
      }, n.prototype.bincn = function(r) {
        i(typeof r == "number");
        var s = r % 26, u = (r - s) / 26, g = 1 << s;
        if (this.length <= u)
          return this._expand(u + 1), this.words[u] |= g, this;
        for (var v = g, A = u; v !== 0 && A < this.length; A++) {
          var L = this.words[A] | 0;
          L += v, v = L >>> 26, L &= 67108863, this.words[A] = L;
        }
        return v !== 0 && (this.words[A] = v, this.length++), this;
      }, n.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, n.prototype.cmpn = function(r) {
        var s = r < 0;
        if (this.negative !== 0 && !s) return -1;
        if (this.negative === 0 && s) return 1;
        this.strip();
        var u;
        if (this.length > 1)
          u = 1;
        else {
          s && (r = -r), i(r <= 67108863, "Number is too big");
          var g = this.words[0] | 0;
          u = g === r ? 0 : g < r ? -1 : 1;
        }
        return this.negative !== 0 ? -u | 0 : u;
      }, n.prototype.cmp = function(r) {
        if (this.negative !== 0 && r.negative === 0) return -1;
        if (this.negative === 0 && r.negative !== 0) return 1;
        var s = this.ucmp(r);
        return this.negative !== 0 ? -s | 0 : s;
      }, n.prototype.ucmp = function(r) {
        if (this.length > r.length) return 1;
        if (this.length < r.length) return -1;
        for (var s = 0, u = this.length - 1; u >= 0; u--) {
          var g = this.words[u] | 0, v = r.words[u] | 0;
          if (g !== v) {
            g < v ? s = -1 : g > v && (s = 1);
            break;
          }
        }
        return s;
      }, n.prototype.gtn = function(r) {
        return this.cmpn(r) === 1;
      }, n.prototype.gt = function(r) {
        return this.cmp(r) === 1;
      }, n.prototype.gten = function(r) {
        return this.cmpn(r) >= 0;
      }, n.prototype.gte = function(r) {
        return this.cmp(r) >= 0;
      }, n.prototype.ltn = function(r) {
        return this.cmpn(r) === -1;
      }, n.prototype.lt = function(r) {
        return this.cmp(r) === -1;
      }, n.prototype.lten = function(r) {
        return this.cmpn(r) <= 0;
      }, n.prototype.lte = function(r) {
        return this.cmp(r) <= 0;
      }, n.prototype.eqn = function(r) {
        return this.cmpn(r) === 0;
      }, n.prototype.eq = function(r) {
        return this.cmp(r) === 0;
      }, n.red = function(r) {
        return new U(r);
      }, n.prototype.toRed = function(r) {
        return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), r.convertTo(this)._forceRed(r);
      }, n.prototype.fromRed = function() {
        return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, n.prototype._forceRed = function(r) {
        return this.red = r, this;
      }, n.prototype.forceRed = function(r) {
        return i(!this.red, "Already a number in reduction context"), this._forceRed(r);
      }, n.prototype.redAdd = function(r) {
        return i(this.red, "redAdd works only with red numbers"), this.red.add(this, r);
      }, n.prototype.redIAdd = function(r) {
        return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, r);
      }, n.prototype.redSub = function(r) {
        return i(this.red, "redSub works only with red numbers"), this.red.sub(this, r);
      }, n.prototype.redISub = function(r) {
        return i(this.red, "redISub works only with red numbers"), this.red.isub(this, r);
      }, n.prototype.redShl = function(r) {
        return i(this.red, "redShl works only with red numbers"), this.red.shl(this, r);
      }, n.prototype.redMul = function(r) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, r), this.red.mul(this, r);
      }, n.prototype.redIMul = function(r) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, r), this.red.imul(this, r);
      }, n.prototype.redSqr = function() {
        return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, n.prototype.redISqr = function() {
        return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, n.prototype.redSqrt = function() {
        return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, n.prototype.redInvm = function() {
        return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, n.prototype.redNeg = function() {
        return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, n.prototype.redPow = function(r) {
        return i(this.red && !r.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, r);
      };
      var j = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function O(I, r) {
        this.name = I, this.p = new n(r, 16), this.n = this.p.bitLength(), this.k = new n(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      O.prototype._tmp = function() {
        var r = new n(null);
        return r.words = new Array(Math.ceil(this.n / 13)), r;
      }, O.prototype.ireduce = function(r) {
        var s = r, u;
        do
          this.split(s, this.tmp), s = this.imulK(s), s = s.iadd(this.tmp), u = s.bitLength();
        while (u > this.n);
        var g = u < this.n ? -1 : s.ucmp(this.p);
        return g === 0 ? (s.words[0] = 0, s.length = 1) : g > 0 ? s.isub(this.p) : s.strip !== void 0 ? s.strip() : s._strip(), s;
      }, O.prototype.split = function(r, s) {
        r.iushrn(this.n, 0, s);
      }, O.prototype.imulK = function(r) {
        return r.imul(this.k);
      };
      function z() {
        O.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      c(z, O), z.prototype.split = function(r, s) {
        for (var u = 4194303, g = Math.min(r.length, 9), v = 0; v < g; v++)
          s.words[v] = r.words[v];
        if (s.length = g, r.length <= 9) {
          r.words[0] = 0, r.length = 1;
          return;
        }
        var A = r.words[9];
        for (s.words[s.length++] = A & u, v = 10; v < r.length; v++) {
          var L = r.words[v] | 0;
          r.words[v - 10] = (L & u) << 4 | A >>> 22, A = L;
        }
        A >>>= 22, r.words[v - 10] = A, A === 0 && r.length > 10 ? r.length -= 10 : r.length -= 9;
      }, z.prototype.imulK = function(r) {
        r.words[r.length] = 0, r.words[r.length + 1] = 0, r.length += 2;
        for (var s = 0, u = 0; u < r.length; u++) {
          var g = r.words[u] | 0;
          s += g * 977, r.words[u] = s & 67108863, s = g * 64 + (s / 67108864 | 0);
        }
        return r.words[r.length - 1] === 0 && (r.length--, r.words[r.length - 1] === 0 && r.length--), r;
      };
      function k() {
        O.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      c(k, O);
      function H() {
        O.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      c(H, O);
      function W() {
        O.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      c(W, O), W.prototype.imulK = function(r) {
        for (var s = 0, u = 0; u < r.length; u++) {
          var g = (r.words[u] | 0) * 19 + s, v = g & 67108863;
          g >>>= 26, r.words[u] = v, s = g;
        }
        return s !== 0 && (r.words[r.length++] = s), r;
      }, n._prime = function(r) {
        if (j[r]) return j[r];
        var s;
        if (r === "k256")
          s = new z();
        else if (r === "p224")
          s = new k();
        else if (r === "p192")
          s = new H();
        else if (r === "p25519")
          s = new W();
        else
          throw new Error("Unknown prime " + r);
        return j[r] = s, s;
      };
      function U(I) {
        if (typeof I == "string") {
          var r = n._prime(I);
          this.m = r.p, this.prime = r;
        } else
          i(I.gtn(1), "modulus must be greater than 1"), this.m = I, this.prime = null;
      }
      U.prototype._verify1 = function(r) {
        i(r.negative === 0, "red works only with positives"), i(r.red, "red works only with red numbers");
      }, U.prototype._verify2 = function(r, s) {
        i((r.negative | s.negative) === 0, "red works only with positives"), i(
          r.red && r.red === s.red,
          "red works only with red numbers"
        );
      }, U.prototype.imod = function(r) {
        return this.prime ? this.prime.ireduce(r)._forceRed(this) : r.umod(this.m)._forceRed(this);
      }, U.prototype.neg = function(r) {
        return r.isZero() ? r.clone() : this.m.sub(r)._forceRed(this);
      }, U.prototype.add = function(r, s) {
        this._verify2(r, s);
        var u = r.add(s);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u._forceRed(this);
      }, U.prototype.iadd = function(r, s) {
        this._verify2(r, s);
        var u = r.iadd(s);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u;
      }, U.prototype.sub = function(r, s) {
        this._verify2(r, s);
        var u = r.sub(s);
        return u.cmpn(0) < 0 && u.iadd(this.m), u._forceRed(this);
      }, U.prototype.isub = function(r, s) {
        this._verify2(r, s);
        var u = r.isub(s);
        return u.cmpn(0) < 0 && u.iadd(this.m), u;
      }, U.prototype.shl = function(r, s) {
        return this._verify1(r), this.imod(r.ushln(s));
      }, U.prototype.imul = function(r, s) {
        return this._verify2(r, s), this.imod(r.imul(s));
      }, U.prototype.mul = function(r, s) {
        return this._verify2(r, s), this.imod(r.mul(s));
      }, U.prototype.isqr = function(r) {
        return this.imul(r, r.clone());
      }, U.prototype.sqr = function(r) {
        return this.mul(r, r);
      }, U.prototype.sqrt = function(r) {
        if (r.isZero()) return r.clone();
        var s = this.m.andln(3);
        if (i(s % 2 === 1), s === 3) {
          var u = this.m.add(new n(1)).iushrn(2);
          return this.pow(r, u);
        }
        for (var g = this.m.subn(1), v = 0; !g.isZero() && g.andln(1) === 0; )
          v++, g.iushrn(1);
        i(!g.isZero());
        var A = new n(1).toRed(this), L = A.redNeg(), m = this.m.subn(1).iushrn(1), a = this.m.bitLength();
        for (a = new n(2 * a * a).toRed(this); this.pow(a, m).cmp(L) !== 0; )
          a.redIAdd(L);
        for (var x = this.pow(a, g), V = this.pow(r, g.addn(1).iushrn(1)), G = this.pow(r, g), Z = v; G.cmp(A) !== 0; ) {
          for (var te = G, q = 0; te.cmp(A) !== 0; q++)
            te = te.redSqr();
          i(q < Z);
          var R = this.pow(x, new n(1).iushln(Z - q - 1));
          V = V.redMul(R), x = R.redSqr(), G = G.redMul(x), Z = q;
        }
        return V;
      }, U.prototype.invm = function(r) {
        var s = r._invmp(this.m);
        return s.negative !== 0 ? (s.negative = 0, this.imod(s).redNeg()) : this.imod(s);
      }, U.prototype.pow = function(r, s) {
        if (s.isZero()) return new n(1).toRed(this);
        if (s.cmpn(1) === 0) return r.clone();
        var u = 4, g = new Array(1 << u);
        g[0] = new n(1).toRed(this), g[1] = r;
        for (var v = 2; v < g.length; v++)
          g[v] = this.mul(g[v - 1], r);
        var A = g[0], L = 0, m = 0, a = s.bitLength() % 26;
        for (a === 0 && (a = 26), v = s.length - 1; v >= 0; v--) {
          for (var x = s.words[v], V = a - 1; V >= 0; V--) {
            var G = x >> V & 1;
            if (A !== g[0] && (A = this.sqr(A)), G === 0 && L === 0) {
              m = 0;
              continue;
            }
            L <<= 1, L |= G, m++, !(m !== u && (v !== 0 || V !== 0)) && (A = this.mul(A, g[L]), m = 0, L = 0);
          }
          a = 26;
        }
        return A;
      }, U.prototype.convertTo = function(r) {
        var s = r.umod(this.m);
        return s === r ? s.clone() : s;
      }, U.prototype.convertFrom = function(r) {
        var s = r.clone();
        return s.red = null, s;
      }, n.mont = function(r) {
        return new B(r);
      };
      function B(I) {
        U.call(this, I), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new n(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      c(B, U), B.prototype.convertTo = function(r) {
        return this.imod(r.ushln(this.shift));
      }, B.prototype.convertFrom = function(r) {
        var s = this.imod(r.mul(this.rinv));
        return s.red = null, s;
      }, B.prototype.imul = function(r, s) {
        if (r.isZero() || s.isZero())
          return r.words[0] = 0, r.length = 1, r;
        var u = r.imul(s), g = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), v = u.isub(g).iushrn(this.shift), A = v;
        return v.cmp(this.m) >= 0 ? A = v.isub(this.m) : v.cmpn(0) < 0 && (A = v.iadd(this.m)), A._forceRed(this);
      }, B.prototype.mul = function(r, s) {
        if (r.isZero() || s.isZero()) return new n(0)._forceRed(this);
        var u = r.mul(s), g = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), v = u.isub(g).iushrn(this.shift), A = v;
        return v.cmp(this.m) >= 0 ? A = v.isub(this.m) : v.cmpn(0) < 0 && (A = v.iadd(this.m)), A._forceRed(this);
      }, B.prototype.invm = function(r) {
        var s = this.imod(r._invmp(this.m).mul(this.r2));
        return s._forceRed(this);
      };
    })(e, Wt);
  }(V0)), V0.exports;
}
var Nd, v5;
function OM() {
  if (v5) return Nd;
  v5 = 1;
  var e = Nh(), t = Gt.Buffer;
  function o(i, c) {
    return t.from(i.toRed(e.mont(c.modulus)).redPow(new e(c.publicExponent)).fromRed().toArray());
  }
  return Nd = o, Nd;
}
var Ad, b5;
function uT() {
  if (b5) return Ad;
  b5 = 1;
  var e = qc(), t = Ia(), o = Bs(), i = DM(), c = jM(), n = Nh(), d = OM(), f = xh(), p = Gt.Buffer;
  Ad = function(C, N, w) {
    var S;
    C.padding ? S = C.padding : w ? S = 1 : S = 4;
    var T = e(C), E;
    if (S === 4)
      E = l(T, N);
    else if (S === 1)
      E = h(T, N, w);
    else if (S === 3) {
      if (E = new n(N), E.cmp(T.modulus) >= 0)
        throw new Error("data too long for modulus");
    } else
      throw new Error("unknown padding");
    return w ? f(E, T) : d(E, T);
  };
  function l(M, C) {
    var N = M.modulus.byteLength(), w = C.length, S = o("sha1").update(p.alloc(0)).digest(), T = S.length, E = 2 * T;
    if (w > N - E - 2)
      throw new Error("message too long");
    var j = p.alloc(N - w - E - 2), O = N - T - 1, z = t(T), k = c(p.concat([S, j, p.alloc(1, 1), C], O), i(z, O)), H = c(z, i(k, T));
    return new n(p.concat([p.alloc(1), H, k], N));
  }
  function h(M, C, N) {
    var w = C.length, S = M.modulus.byteLength();
    if (w > S - 11)
      throw new Error("message too long");
    var T;
    return N ? T = p.alloc(S - w - 3, 255) : T = y(S - w - 3), new n(p.concat([p.from([0, N ? 1 : 2]), T, p.alloc(1), C], S));
  }
  function y(M) {
    for (var C = p.allocUnsafe(M), N = 0, w = t(M * 2), S = 0, T; N < M; )
      S === w.length && (w = t(M * 2), S = 0), T = w[S++], T && (C[N++] = T);
    return C;
  }
  return Ad;
}
var Td, x5;
function dT() {
  if (x5) return Td;
  x5 = 1;
  var e = qc(), t = DM(), o = jM(), i = Nh(), c = xh(), n = Bs(), d = OM(), f = Gt.Buffer;
  Td = function(M, C, N) {
    var w;
    M.padding ? w = M.padding : N ? w = 1 : w = 4;
    var S = e(M), T = S.modulus.byteLength();
    if (C.length > T || new i(C).cmp(S.modulus) >= 0)
      throw new Error("decryption error");
    var E;
    N ? E = d(new i(C), S) : E = c(C, S);
    var j = f.alloc(T - E.length);
    if (E = f.concat([j, E], T), w === 4)
      return p(S, E);
    if (w === 1)
      return l(S, E, N);
    if (w === 3)
      return E;
    throw new Error("unknown padding");
  };
  function p(y, M) {
    var C = y.modulus.byteLength(), N = n("sha1").update(f.alloc(0)).digest(), w = N.length;
    if (M[0] !== 0)
      throw new Error("decryption error");
    var S = M.slice(1, w + 1), T = M.slice(w + 1), E = o(S, t(T, w)), j = o(T, t(E, C - w - 1));
    if (h(N, j.slice(0, w)))
      throw new Error("decryption error");
    for (var O = w; j[O] === 0; )
      O++;
    if (j[O++] !== 1)
      throw new Error("decryption error");
    return j.slice(O);
  }
  function l(y, M, C) {
    for (var N = M.slice(0, 2), w = 2, S = 0; M[w++] !== 0; )
      if (w >= M.length) {
        S++;
        break;
      }
    var T = M.slice(2, w - 1);
    if ((N.toString("hex") !== "0002" && !C || N.toString("hex") !== "0001" && C) && S++, T.length < 8 && S++, S)
      throw new Error("decryption error");
    return M.slice(w);
  }
  function h(y, M) {
    y = f.from(y), M = f.from(M);
    var C = 0, N = y.length;
    y.length !== M.length && (C++, N = Math.min(y.length, M.length));
    for (var w = -1; ++w < N; )
      C += y[w] ^ M[w];
    return C;
  }
  return Td;
}
var w5;
function hT() {
  return w5 || (w5 = 1, function(e) {
    e.publicEncrypt = uT(), e.privateDecrypt = dT(), e.privateEncrypt = function(o, i) {
      return e.publicEncrypt(o, i, !0);
    }, e.publicDecrypt = function(o, i) {
      return e.privateDecrypt(o, i, !0);
    };
  }(wd)), wd;
}
var Qo = {}, C5;
function pT() {
  if (C5) return Qo;
  C5 = 1;
  function e() {
    throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
  }
  var t = Gt, o = Ia(), i = t.Buffer, c = t.kMaxLength, n = Wt.crypto || Wt.msCrypto, d = Math.pow(2, 32) - 1;
  function f(M, C) {
    if (typeof M != "number" || M !== M)
      throw new TypeError("offset must be a number");
    if (M > d || M < 0)
      throw new TypeError("offset must be a uint32");
    if (M > c || M > C)
      throw new RangeError("offset out of range");
  }
  function p(M, C, N) {
    if (typeof M != "number" || M !== M)
      throw new TypeError("size must be a number");
    if (M > d || M < 0)
      throw new TypeError("size must be a uint32");
    if (M + C > N || M > c)
      throw new RangeError("buffer too small");
  }
  n && n.getRandomValues || !fe.process.browser ? (Qo.randomFill = l, Qo.randomFillSync = y) : (Qo.randomFill = e, Qo.randomFillSync = e);
  function l(M, C, N, w) {
    if (!i.isBuffer(M) && !(M instanceof Wt.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof C == "function")
      w = C, C = 0, N = M.length;
    else if (typeof N == "function")
      w = N, N = M.length - C;
    else if (typeof w != "function")
      throw new TypeError('"cb" argument must be a function');
    return f(C, M.length), p(N, C, M.length), h(M, C, N, w);
  }
  function h(M, C, N, w) {
    if (fe.process.browser) {
      var S = M.buffer, T = new Uint8Array(S, C, N);
      if (n.getRandomValues(T), w) {
        fe.process.nextTick(function() {
          w(null, M);
        });
        return;
      }
      return M;
    }
    if (w) {
      o(N, function(j, O) {
        if (j)
          return w(j);
        O.copy(M, C), w(null, M);
      });
      return;
    }
    var E = o(N);
    return E.copy(M, C), M;
  }
  function y(M, C, N) {
    if (typeof C > "u" && (C = 0), !i.isBuffer(M) && !(M instanceof Wt.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    return f(C, M.length), N === void 0 && (N = M.length - C), p(N, C, M.length), h(M, C, N);
  }
  return Qo;
}
var I5;
function zM() {
  if (I5) return Vt;
  I5 = 1, Vt.randomBytes = Vt.rng = Vt.pseudoRandomBytes = Vt.prng = Ia(), Vt.createHash = Vt.Hash = Bs(), Vt.createHmac = Vt.Hmac = tM();
  var e = YN(), t = Object.keys(e), o = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
  ].concat(t);
  Vt.getHashes = function() {
    return o;
  };
  var i = sM();
  Vt.pbkdf2 = i.pbkdf2, Vt.pbkdf2Sync = i.pbkdf2Sync;
  var c = uA();
  Vt.Cipher = c.Cipher, Vt.createCipher = c.createCipher, Vt.Cipheriv = c.Cipheriv, Vt.createCipheriv = c.createCipheriv, Vt.Decipher = c.Decipher, Vt.createDecipher = c.createDecipher, Vt.Decipheriv = c.Decipheriv, Vt.createDecipheriv = c.createDecipheriv, Vt.getCiphers = c.getCiphers, Vt.listCiphers = c.listCiphers;
  var n = CA();
  Vt.DiffieHellmanGroup = n.DiffieHellmanGroup, Vt.createDiffieHellmanGroup = n.createDiffieHellmanGroup, Vt.getDiffieHellman = n.getDiffieHellman, Vt.createDiffieHellman = n.createDiffieHellman, Vt.DiffieHellman = n.DiffieHellman;
  var d = cT();
  Vt.createSign = d.createSign, Vt.Sign = d.Sign, Vt.createVerify = d.createVerify, Vt.Verify = d.Verify, Vt.createECDH = fT();
  var f = hT();
  Vt.publicEncrypt = f.publicEncrypt, Vt.privateEncrypt = f.privateEncrypt, Vt.publicDecrypt = f.publicDecrypt, Vt.privateDecrypt = f.privateDecrypt;
  var p = pT();
  return Vt.randomFill = p.randomFill, Vt.randomFillSync = p.randomFillSync, Vt.createCredentials = function() {
    throw new Error(`sorry, createCredentials is not implemented yet
we accept pull requests
https://github.com/browserify/crypto-browserify`);
  }, Vt.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  }, Vt;
}
(function(e) {
  (function(t) {
    var o = function(J) {
      var ee, K = new Float64Array(16);
      if (J) for (ee = 0; ee < J.length; ee++) K[ee] = J[ee];
      return K;
    }, i = function() {
      throw new Error("no PRNG");
    }, c = new Uint8Array(16), n = new Uint8Array(32);
    n[0] = 9;
    var d = o(), f = o([1]), p = o([56129, 1]), l = o([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]), h = o([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]), y = o([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]), M = o([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]), C = o([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
    function N(J, ee, K, Y) {
      J[ee] = K >> 24 & 255, J[ee + 1] = K >> 16 & 255, J[ee + 2] = K >> 8 & 255, J[ee + 3] = K & 255, J[ee + 4] = Y >> 24 & 255, J[ee + 5] = Y >> 16 & 255, J[ee + 6] = Y >> 8 & 255, J[ee + 7] = Y & 255;
    }
    function w(J, ee, K, Y, re) {
      var he, Se = 0;
      for (he = 0; he < re; he++) Se |= J[ee + he] ^ K[Y + he];
      return (1 & Se - 1 >>> 8) - 1;
    }
    function S(J, ee, K, Y) {
      return w(J, ee, K, Y, 16);
    }
    function T(J, ee, K, Y) {
      return w(J, ee, K, Y, 32);
    }
    function E(J, ee, K, Y) {
      for (var re = Y[0] & 255 | (Y[1] & 255) << 8 | (Y[2] & 255) << 16 | (Y[3] & 255) << 24, he = K[0] & 255 | (K[1] & 255) << 8 | (K[2] & 255) << 16 | (K[3] & 255) << 24, Se = K[4] & 255 | (K[5] & 255) << 8 | (K[6] & 255) << 16 | (K[7] & 255) << 24, ve = K[8] & 255 | (K[9] & 255) << 8 | (K[10] & 255) << 16 | (K[11] & 255) << 24, we = K[12] & 255 | (K[13] & 255) << 8 | (K[14] & 255) << 16 | (K[15] & 255) << 24, lt = Y[4] & 255 | (Y[5] & 255) << 8 | (Y[6] & 255) << 16 | (Y[7] & 255) << 24, et = ee[0] & 255 | (ee[1] & 255) << 8 | (ee[2] & 255) << 16 | (ee[3] & 255) << 24, Lt = ee[4] & 255 | (ee[5] & 255) << 8 | (ee[6] & 255) << 16 | (ee[7] & 255) << 24, nt = ee[8] & 255 | (ee[9] & 255) << 8 | (ee[10] & 255) << 16 | (ee[11] & 255) << 24, gt = ee[12] & 255 | (ee[13] & 255) << 8 | (ee[14] & 255) << 16 | (ee[15] & 255) << 24, yt = Y[8] & 255 | (Y[9] & 255) << 8 | (Y[10] & 255) << 16 | (Y[11] & 255) << 24, xt = K[16] & 255 | (K[17] & 255) << 8 | (K[18] & 255) << 16 | (K[19] & 255) << 24, bt = K[20] & 255 | (K[21] & 255) << 8 | (K[22] & 255) << 16 | (K[23] & 255) << 24, Mt = K[24] & 255 | (K[25] & 255) << 8 | (K[26] & 255) << 16 | (K[27] & 255) << 24, vt = K[28] & 255 | (K[29] & 255) << 8 | (K[30] & 255) << 16 | (K[31] & 255) << 24, mt = Y[12] & 255 | (Y[13] & 255) << 8 | (Y[14] & 255) << 16 | (Y[15] & 255) << 24, ot = re, ft = he, rt = Se, st = ve, ct = we, Je = lt, Oe = et, ze = Lt, qe = nt, Ge = gt, $e = yt, tt = xt, Ot = bt, Ht = Mt, Qt = vt, Zt = mt, be, Jt = 0; Jt < 20; Jt += 2)
        be = ot + Ot | 0, ct ^= be << 7 | be >>> 25, be = ct + ot | 0, qe ^= be << 9 | be >>> 23, be = qe + ct | 0, Ot ^= be << 13 | be >>> 19, be = Ot + qe | 0, ot ^= be << 18 | be >>> 14, be = Je + ft | 0, Ge ^= be << 7 | be >>> 25, be = Ge + Je | 0, Ht ^= be << 9 | be >>> 23, be = Ht + Ge | 0, ft ^= be << 13 | be >>> 19, be = ft + Ht | 0, Je ^= be << 18 | be >>> 14, be = $e + Oe | 0, Qt ^= be << 7 | be >>> 25, be = Qt + $e | 0, rt ^= be << 9 | be >>> 23, be = rt + Qt | 0, Oe ^= be << 13 | be >>> 19, be = Oe + rt | 0, $e ^= be << 18 | be >>> 14, be = Zt + tt | 0, st ^= be << 7 | be >>> 25, be = st + Zt | 0, ze ^= be << 9 | be >>> 23, be = ze + st | 0, tt ^= be << 13 | be >>> 19, be = tt + ze | 0, Zt ^= be << 18 | be >>> 14, be = ot + st | 0, ft ^= be << 7 | be >>> 25, be = ft + ot | 0, rt ^= be << 9 | be >>> 23, be = rt + ft | 0, st ^= be << 13 | be >>> 19, be = st + rt | 0, ot ^= be << 18 | be >>> 14, be = Je + ct | 0, Oe ^= be << 7 | be >>> 25, be = Oe + Je | 0, ze ^= be << 9 | be >>> 23, be = ze + Oe | 0, ct ^= be << 13 | be >>> 19, be = ct + ze | 0, Je ^= be << 18 | be >>> 14, be = $e + Ge | 0, tt ^= be << 7 | be >>> 25, be = tt + $e | 0, qe ^= be << 9 | be >>> 23, be = qe + tt | 0, Ge ^= be << 13 | be >>> 19, be = Ge + qe | 0, $e ^= be << 18 | be >>> 14, be = Zt + Qt | 0, Ot ^= be << 7 | be >>> 25, be = Ot + Zt | 0, Ht ^= be << 9 | be >>> 23, be = Ht + Ot | 0, Qt ^= be << 13 | be >>> 19, be = Qt + Ht | 0, Zt ^= be << 18 | be >>> 14;
      ot = ot + re | 0, ft = ft + he | 0, rt = rt + Se | 0, st = st + ve | 0, ct = ct + we | 0, Je = Je + lt | 0, Oe = Oe + et | 0, ze = ze + Lt | 0, qe = qe + nt | 0, Ge = Ge + gt | 0, $e = $e + yt | 0, tt = tt + xt | 0, Ot = Ot + bt | 0, Ht = Ht + Mt | 0, Qt = Qt + vt | 0, Zt = Zt + mt | 0, J[0] = ot >>> 0 & 255, J[1] = ot >>> 8 & 255, J[2] = ot >>> 16 & 255, J[3] = ot >>> 24 & 255, J[4] = ft >>> 0 & 255, J[5] = ft >>> 8 & 255, J[6] = ft >>> 16 & 255, J[7] = ft >>> 24 & 255, J[8] = rt >>> 0 & 255, J[9] = rt >>> 8 & 255, J[10] = rt >>> 16 & 255, J[11] = rt >>> 24 & 255, J[12] = st >>> 0 & 255, J[13] = st >>> 8 & 255, J[14] = st >>> 16 & 255, J[15] = st >>> 24 & 255, J[16] = ct >>> 0 & 255, J[17] = ct >>> 8 & 255, J[18] = ct >>> 16 & 255, J[19] = ct >>> 24 & 255, J[20] = Je >>> 0 & 255, J[21] = Je >>> 8 & 255, J[22] = Je >>> 16 & 255, J[23] = Je >>> 24 & 255, J[24] = Oe >>> 0 & 255, J[25] = Oe >>> 8 & 255, J[26] = Oe >>> 16 & 255, J[27] = Oe >>> 24 & 255, J[28] = ze >>> 0 & 255, J[29] = ze >>> 8 & 255, J[30] = ze >>> 16 & 255, J[31] = ze >>> 24 & 255, J[32] = qe >>> 0 & 255, J[33] = qe >>> 8 & 255, J[34] = qe >>> 16 & 255, J[35] = qe >>> 24 & 255, J[36] = Ge >>> 0 & 255, J[37] = Ge >>> 8 & 255, J[38] = Ge >>> 16 & 255, J[39] = Ge >>> 24 & 255, J[40] = $e >>> 0 & 255, J[41] = $e >>> 8 & 255, J[42] = $e >>> 16 & 255, J[43] = $e >>> 24 & 255, J[44] = tt >>> 0 & 255, J[45] = tt >>> 8 & 255, J[46] = tt >>> 16 & 255, J[47] = tt >>> 24 & 255, J[48] = Ot >>> 0 & 255, J[49] = Ot >>> 8 & 255, J[50] = Ot >>> 16 & 255, J[51] = Ot >>> 24 & 255, J[52] = Ht >>> 0 & 255, J[53] = Ht >>> 8 & 255, J[54] = Ht >>> 16 & 255, J[55] = Ht >>> 24 & 255, J[56] = Qt >>> 0 & 255, J[57] = Qt >>> 8 & 255, J[58] = Qt >>> 16 & 255, J[59] = Qt >>> 24 & 255, J[60] = Zt >>> 0 & 255, J[61] = Zt >>> 8 & 255, J[62] = Zt >>> 16 & 255, J[63] = Zt >>> 24 & 255;
    }
    function j(J, ee, K, Y) {
      for (var re = Y[0] & 255 | (Y[1] & 255) << 8 | (Y[2] & 255) << 16 | (Y[3] & 255) << 24, he = K[0] & 255 | (K[1] & 255) << 8 | (K[2] & 255) << 16 | (K[3] & 255) << 24, Se = K[4] & 255 | (K[5] & 255) << 8 | (K[6] & 255) << 16 | (K[7] & 255) << 24, ve = K[8] & 255 | (K[9] & 255) << 8 | (K[10] & 255) << 16 | (K[11] & 255) << 24, we = K[12] & 255 | (K[13] & 255) << 8 | (K[14] & 255) << 16 | (K[15] & 255) << 24, lt = Y[4] & 255 | (Y[5] & 255) << 8 | (Y[6] & 255) << 16 | (Y[7] & 255) << 24, et = ee[0] & 255 | (ee[1] & 255) << 8 | (ee[2] & 255) << 16 | (ee[3] & 255) << 24, Lt = ee[4] & 255 | (ee[5] & 255) << 8 | (ee[6] & 255) << 16 | (ee[7] & 255) << 24, nt = ee[8] & 255 | (ee[9] & 255) << 8 | (ee[10] & 255) << 16 | (ee[11] & 255) << 24, gt = ee[12] & 255 | (ee[13] & 255) << 8 | (ee[14] & 255) << 16 | (ee[15] & 255) << 24, yt = Y[8] & 255 | (Y[9] & 255) << 8 | (Y[10] & 255) << 16 | (Y[11] & 255) << 24, xt = K[16] & 255 | (K[17] & 255) << 8 | (K[18] & 255) << 16 | (K[19] & 255) << 24, bt = K[20] & 255 | (K[21] & 255) << 8 | (K[22] & 255) << 16 | (K[23] & 255) << 24, Mt = K[24] & 255 | (K[25] & 255) << 8 | (K[26] & 255) << 16 | (K[27] & 255) << 24, vt = K[28] & 255 | (K[29] & 255) << 8 | (K[30] & 255) << 16 | (K[31] & 255) << 24, mt = Y[12] & 255 | (Y[13] & 255) << 8 | (Y[14] & 255) << 16 | (Y[15] & 255) << 24, ot = re, ft = he, rt = Se, st = ve, ct = we, Je = lt, Oe = et, ze = Lt, qe = nt, Ge = gt, $e = yt, tt = xt, Ot = bt, Ht = Mt, Qt = vt, Zt = mt, be, Jt = 0; Jt < 20; Jt += 2)
        be = ot + Ot | 0, ct ^= be << 7 | be >>> 25, be = ct + ot | 0, qe ^= be << 9 | be >>> 23, be = qe + ct | 0, Ot ^= be << 13 | be >>> 19, be = Ot + qe | 0, ot ^= be << 18 | be >>> 14, be = Je + ft | 0, Ge ^= be << 7 | be >>> 25, be = Ge + Je | 0, Ht ^= be << 9 | be >>> 23, be = Ht + Ge | 0, ft ^= be << 13 | be >>> 19, be = ft + Ht | 0, Je ^= be << 18 | be >>> 14, be = $e + Oe | 0, Qt ^= be << 7 | be >>> 25, be = Qt + $e | 0, rt ^= be << 9 | be >>> 23, be = rt + Qt | 0, Oe ^= be << 13 | be >>> 19, be = Oe + rt | 0, $e ^= be << 18 | be >>> 14, be = Zt + tt | 0, st ^= be << 7 | be >>> 25, be = st + Zt | 0, ze ^= be << 9 | be >>> 23, be = ze + st | 0, tt ^= be << 13 | be >>> 19, be = tt + ze | 0, Zt ^= be << 18 | be >>> 14, be = ot + st | 0, ft ^= be << 7 | be >>> 25, be = ft + ot | 0, rt ^= be << 9 | be >>> 23, be = rt + ft | 0, st ^= be << 13 | be >>> 19, be = st + rt | 0, ot ^= be << 18 | be >>> 14, be = Je + ct | 0, Oe ^= be << 7 | be >>> 25, be = Oe + Je | 0, ze ^= be << 9 | be >>> 23, be = ze + Oe | 0, ct ^= be << 13 | be >>> 19, be = ct + ze | 0, Je ^= be << 18 | be >>> 14, be = $e + Ge | 0, tt ^= be << 7 | be >>> 25, be = tt + $e | 0, qe ^= be << 9 | be >>> 23, be = qe + tt | 0, Ge ^= be << 13 | be >>> 19, be = Ge + qe | 0, $e ^= be << 18 | be >>> 14, be = Zt + Qt | 0, Ot ^= be << 7 | be >>> 25, be = Ot + Zt | 0, Ht ^= be << 9 | be >>> 23, be = Ht + Ot | 0, Qt ^= be << 13 | be >>> 19, be = Qt + Ht | 0, Zt ^= be << 18 | be >>> 14;
      J[0] = ot >>> 0 & 255, J[1] = ot >>> 8 & 255, J[2] = ot >>> 16 & 255, J[3] = ot >>> 24 & 255, J[4] = Je >>> 0 & 255, J[5] = Je >>> 8 & 255, J[6] = Je >>> 16 & 255, J[7] = Je >>> 24 & 255, J[8] = $e >>> 0 & 255, J[9] = $e >>> 8 & 255, J[10] = $e >>> 16 & 255, J[11] = $e >>> 24 & 255, J[12] = Zt >>> 0 & 255, J[13] = Zt >>> 8 & 255, J[14] = Zt >>> 16 & 255, J[15] = Zt >>> 24 & 255, J[16] = Oe >>> 0 & 255, J[17] = Oe >>> 8 & 255, J[18] = Oe >>> 16 & 255, J[19] = Oe >>> 24 & 255, J[20] = ze >>> 0 & 255, J[21] = ze >>> 8 & 255, J[22] = ze >>> 16 & 255, J[23] = ze >>> 24 & 255, J[24] = qe >>> 0 & 255, J[25] = qe >>> 8 & 255, J[26] = qe >>> 16 & 255, J[27] = qe >>> 24 & 255, J[28] = Ge >>> 0 & 255, J[29] = Ge >>> 8 & 255, J[30] = Ge >>> 16 & 255, J[31] = Ge >>> 24 & 255;
    }
    function O(J, ee, K, Y) {
      E(J, ee, K, Y);
    }
    function z(J, ee, K, Y) {
      j(J, ee, K, Y);
    }
    var k = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
    function H(J, ee, K, Y, re, he, Se) {
      var ve = new Uint8Array(16), we = new Uint8Array(64), lt, et;
      for (et = 0; et < 16; et++) ve[et] = 0;
      for (et = 0; et < 8; et++) ve[et] = he[et];
      for (; re >= 64; ) {
        for (O(we, ve, Se, k), et = 0; et < 64; et++) J[ee + et] = K[Y + et] ^ we[et];
        for (lt = 1, et = 8; et < 16; et++)
          lt = lt + (ve[et] & 255) | 0, ve[et] = lt & 255, lt >>>= 8;
        re -= 64, ee += 64, Y += 64;
      }
      if (re > 0)
        for (O(we, ve, Se, k), et = 0; et < re; et++) J[ee + et] = K[Y + et] ^ we[et];
      return 0;
    }
    function W(J, ee, K, Y, re) {
      var he = new Uint8Array(16), Se = new Uint8Array(64), ve, we;
      for (we = 0; we < 16; we++) he[we] = 0;
      for (we = 0; we < 8; we++) he[we] = Y[we];
      for (; K >= 64; ) {
        for (O(Se, he, re, k), we = 0; we < 64; we++) J[ee + we] = Se[we];
        for (ve = 1, we = 8; we < 16; we++)
          ve = ve + (he[we] & 255) | 0, he[we] = ve & 255, ve >>>= 8;
        K -= 64, ee += 64;
      }
      if (K > 0)
        for (O(Se, he, re, k), we = 0; we < K; we++) J[ee + we] = Se[we];
      return 0;
    }
    function U(J, ee, K, Y, re) {
      var he = new Uint8Array(32);
      z(he, Y, re, k);
      for (var Se = new Uint8Array(8), ve = 0; ve < 8; ve++) Se[ve] = Y[ve + 16];
      return W(J, ee, K, Se, he);
    }
    function B(J, ee, K, Y, re, he, Se) {
      var ve = new Uint8Array(32);
      z(ve, he, Se, k);
      for (var we = new Uint8Array(8), lt = 0; lt < 8; lt++) we[lt] = he[lt + 16];
      return H(J, ee, K, Y, re, we, ve);
    }
    var I = function(J) {
      this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.leftover = 0, this.fin = 0;
      var ee, K, Y, re, he, Se, ve, we;
      ee = J[0] & 255 | (J[1] & 255) << 8, this.r[0] = ee & 8191, K = J[2] & 255 | (J[3] & 255) << 8, this.r[1] = (ee >>> 13 | K << 3) & 8191, Y = J[4] & 255 | (J[5] & 255) << 8, this.r[2] = (K >>> 10 | Y << 6) & 7939, re = J[6] & 255 | (J[7] & 255) << 8, this.r[3] = (Y >>> 7 | re << 9) & 8191, he = J[8] & 255 | (J[9] & 255) << 8, this.r[4] = (re >>> 4 | he << 12) & 255, this.r[5] = he >>> 1 & 8190, Se = J[10] & 255 | (J[11] & 255) << 8, this.r[6] = (he >>> 14 | Se << 2) & 8191, ve = J[12] & 255 | (J[13] & 255) << 8, this.r[7] = (Se >>> 11 | ve << 5) & 8065, we = J[14] & 255 | (J[15] & 255) << 8, this.r[8] = (ve >>> 8 | we << 8) & 8191, this.r[9] = we >>> 5 & 127, this.pad[0] = J[16] & 255 | (J[17] & 255) << 8, this.pad[1] = J[18] & 255 | (J[19] & 255) << 8, this.pad[2] = J[20] & 255 | (J[21] & 255) << 8, this.pad[3] = J[22] & 255 | (J[23] & 255) << 8, this.pad[4] = J[24] & 255 | (J[25] & 255) << 8, this.pad[5] = J[26] & 255 | (J[27] & 255) << 8, this.pad[6] = J[28] & 255 | (J[29] & 255) << 8, this.pad[7] = J[30] & 255 | (J[31] & 255) << 8;
    };
    I.prototype.blocks = function(J, ee, K) {
      for (var Y = this.fin ? 0 : 2048, re, he, Se, ve, we, lt, et, Lt, nt, gt, yt, xt, bt, Mt, vt, mt, ot, ft, rt, st = this.h[0], ct = this.h[1], Je = this.h[2], Oe = this.h[3], ze = this.h[4], qe = this.h[5], Ge = this.h[6], $e = this.h[7], tt = this.h[8], Ot = this.h[9], Ht = this.r[0], Qt = this.r[1], Zt = this.r[2], be = this.r[3], Jt = this.r[4], nr = this.r[5], ir = this.r[6], $t = this.r[7], tr = this.r[8], rr = this.r[9]; K >= 16; )
        re = J[ee + 0] & 255 | (J[ee + 1] & 255) << 8, st += re & 8191, he = J[ee + 2] & 255 | (J[ee + 3] & 255) << 8, ct += (re >>> 13 | he << 3) & 8191, Se = J[ee + 4] & 255 | (J[ee + 5] & 255) << 8, Je += (he >>> 10 | Se << 6) & 8191, ve = J[ee + 6] & 255 | (J[ee + 7] & 255) << 8, Oe += (Se >>> 7 | ve << 9) & 8191, we = J[ee + 8] & 255 | (J[ee + 9] & 255) << 8, ze += (ve >>> 4 | we << 12) & 8191, qe += we >>> 1 & 8191, lt = J[ee + 10] & 255 | (J[ee + 11] & 255) << 8, Ge += (we >>> 14 | lt << 2) & 8191, et = J[ee + 12] & 255 | (J[ee + 13] & 255) << 8, $e += (lt >>> 11 | et << 5) & 8191, Lt = J[ee + 14] & 255 | (J[ee + 15] & 255) << 8, tt += (et >>> 8 | Lt << 8) & 8191, Ot += Lt >>> 5 | Y, nt = 0, gt = nt, gt += st * Ht, gt += ct * (5 * rr), gt += Je * (5 * tr), gt += Oe * (5 * $t), gt += ze * (5 * ir), nt = gt >>> 13, gt &= 8191, gt += qe * (5 * nr), gt += Ge * (5 * Jt), gt += $e * (5 * be), gt += tt * (5 * Zt), gt += Ot * (5 * Qt), nt += gt >>> 13, gt &= 8191, yt = nt, yt += st * Qt, yt += ct * Ht, yt += Je * (5 * rr), yt += Oe * (5 * tr), yt += ze * (5 * $t), nt = yt >>> 13, yt &= 8191, yt += qe * (5 * ir), yt += Ge * (5 * nr), yt += $e * (5 * Jt), yt += tt * (5 * be), yt += Ot * (5 * Zt), nt += yt >>> 13, yt &= 8191, xt = nt, xt += st * Zt, xt += ct * Qt, xt += Je * Ht, xt += Oe * (5 * rr), xt += ze * (5 * tr), nt = xt >>> 13, xt &= 8191, xt += qe * (5 * $t), xt += Ge * (5 * ir), xt += $e * (5 * nr), xt += tt * (5 * Jt), xt += Ot * (5 * be), nt += xt >>> 13, xt &= 8191, bt = nt, bt += st * be, bt += ct * Zt, bt += Je * Qt, bt += Oe * Ht, bt += ze * (5 * rr), nt = bt >>> 13, bt &= 8191, bt += qe * (5 * tr), bt += Ge * (5 * $t), bt += $e * (5 * ir), bt += tt * (5 * nr), bt += Ot * (5 * Jt), nt += bt >>> 13, bt &= 8191, Mt = nt, Mt += st * Jt, Mt += ct * be, Mt += Je * Zt, Mt += Oe * Qt, Mt += ze * Ht, nt = Mt >>> 13, Mt &= 8191, Mt += qe * (5 * rr), Mt += Ge * (5 * tr), Mt += $e * (5 * $t), Mt += tt * (5 * ir), Mt += Ot * (5 * nr), nt += Mt >>> 13, Mt &= 8191, vt = nt, vt += st * nr, vt += ct * Jt, vt += Je * be, vt += Oe * Zt, vt += ze * Qt, nt = vt >>> 13, vt &= 8191, vt += qe * Ht, vt += Ge * (5 * rr), vt += $e * (5 * tr), vt += tt * (5 * $t), vt += Ot * (5 * ir), nt += vt >>> 13, vt &= 8191, mt = nt, mt += st * ir, mt += ct * nr, mt += Je * Jt, mt += Oe * be, mt += ze * Zt, nt = mt >>> 13, mt &= 8191, mt += qe * Qt, mt += Ge * Ht, mt += $e * (5 * rr), mt += tt * (5 * tr), mt += Ot * (5 * $t), nt += mt >>> 13, mt &= 8191, ot = nt, ot += st * $t, ot += ct * ir, ot += Je * nr, ot += Oe * Jt, ot += ze * be, nt = ot >>> 13, ot &= 8191, ot += qe * Zt, ot += Ge * Qt, ot += $e * Ht, ot += tt * (5 * rr), ot += Ot * (5 * tr), nt += ot >>> 13, ot &= 8191, ft = nt, ft += st * tr, ft += ct * $t, ft += Je * ir, ft += Oe * nr, ft += ze * Jt, nt = ft >>> 13, ft &= 8191, ft += qe * be, ft += Ge * Zt, ft += $e * Qt, ft += tt * Ht, ft += Ot * (5 * rr), nt += ft >>> 13, ft &= 8191, rt = nt, rt += st * rr, rt += ct * tr, rt += Je * $t, rt += Oe * ir, rt += ze * nr, nt = rt >>> 13, rt &= 8191, rt += qe * Jt, rt += Ge * be, rt += $e * Zt, rt += tt * Qt, rt += Ot * Ht, nt += rt >>> 13, rt &= 8191, nt = (nt << 2) + nt | 0, nt = nt + gt | 0, gt = nt & 8191, nt = nt >>> 13, yt += nt, st = gt, ct = yt, Je = xt, Oe = bt, ze = Mt, qe = vt, Ge = mt, $e = ot, tt = ft, Ot = rt, ee += 16, K -= 16;
      this.h[0] = st, this.h[1] = ct, this.h[2] = Je, this.h[3] = Oe, this.h[4] = ze, this.h[5] = qe, this.h[6] = Ge, this.h[7] = $e, this.h[8] = tt, this.h[9] = Ot;
    }, I.prototype.finish = function(J, ee) {
      var K = new Uint16Array(10), Y, re, he, Se;
      if (this.leftover) {
        for (Se = this.leftover, this.buffer[Se++] = 1; Se < 16; Se++) this.buffer[Se] = 0;
        this.fin = 1, this.blocks(this.buffer, 0, 16);
      }
      for (Y = this.h[1] >>> 13, this.h[1] &= 8191, Se = 2; Se < 10; Se++)
        this.h[Se] += Y, Y = this.h[Se] >>> 13, this.h[Se] &= 8191;
      for (this.h[0] += Y * 5, Y = this.h[0] >>> 13, this.h[0] &= 8191, this.h[1] += Y, Y = this.h[1] >>> 13, this.h[1] &= 8191, this.h[2] += Y, K[0] = this.h[0] + 5, Y = K[0] >>> 13, K[0] &= 8191, Se = 1; Se < 10; Se++)
        K[Se] = this.h[Se] + Y, Y = K[Se] >>> 13, K[Se] &= 8191;
      for (K[9] -= 8192, re = (Y ^ 1) - 1, Se = 0; Se < 10; Se++) K[Se] &= re;
      for (re = ~re, Se = 0; Se < 10; Se++) this.h[Se] = this.h[Se] & re | K[Se];
      for (this.h[0] = (this.h[0] | this.h[1] << 13) & 65535, this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 65535, this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 65535, this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 65535, this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 65535, this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 65535, this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 65535, this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 65535, he = this.h[0] + this.pad[0], this.h[0] = he & 65535, Se = 1; Se < 8; Se++)
        he = (this.h[Se] + this.pad[Se] | 0) + (he >>> 16) | 0, this.h[Se] = he & 65535;
      J[ee + 0] = this.h[0] >>> 0 & 255, J[ee + 1] = this.h[0] >>> 8 & 255, J[ee + 2] = this.h[1] >>> 0 & 255, J[ee + 3] = this.h[1] >>> 8 & 255, J[ee + 4] = this.h[2] >>> 0 & 255, J[ee + 5] = this.h[2] >>> 8 & 255, J[ee + 6] = this.h[3] >>> 0 & 255, J[ee + 7] = this.h[3] >>> 8 & 255, J[ee + 8] = this.h[4] >>> 0 & 255, J[ee + 9] = this.h[4] >>> 8 & 255, J[ee + 10] = this.h[5] >>> 0 & 255, J[ee + 11] = this.h[5] >>> 8 & 255, J[ee + 12] = this.h[6] >>> 0 & 255, J[ee + 13] = this.h[6] >>> 8 & 255, J[ee + 14] = this.h[7] >>> 0 & 255, J[ee + 15] = this.h[7] >>> 8 & 255;
    }, I.prototype.update = function(J, ee, K) {
      var Y, re;
      if (this.leftover) {
        for (re = 16 - this.leftover, re > K && (re = K), Y = 0; Y < re; Y++)
          this.buffer[this.leftover + Y] = J[ee + Y];
        if (K -= re, ee += re, this.leftover += re, this.leftover < 16)
          return;
        this.blocks(this.buffer, 0, 16), this.leftover = 0;
      }
      if (K >= 16 && (re = K - K % 16, this.blocks(J, ee, re), ee += re, K -= re), K) {
        for (Y = 0; Y < K; Y++)
          this.buffer[this.leftover + Y] = J[ee + Y];
        this.leftover += K;
      }
    };
    function r(J, ee, K, Y, re, he) {
      var Se = new I(he);
      return Se.update(K, Y, re), Se.finish(J, ee), 0;
    }
    function s(J, ee, K, Y, re, he) {
      var Se = new Uint8Array(16);
      return r(Se, 0, K, Y, re, he), S(J, ee, Se, 0);
    }
    function u(J, ee, K, Y, re) {
      var he;
      if (K < 32) return -1;
      for (B(J, 0, ee, 0, K, Y, re), r(J, 16, J, 32, K - 32, J), he = 0; he < 16; he++) J[he] = 0;
      return 0;
    }
    function g(J, ee, K, Y, re) {
      var he, Se = new Uint8Array(32);
      if (K < 32 || (U(Se, 0, 32, Y, re), s(ee, 16, ee, 32, K - 32, Se) !== 0)) return -1;
      for (B(J, 0, ee, 0, K, Y, re), he = 0; he < 32; he++) J[he] = 0;
      return 0;
    }
    function v(J, ee) {
      var K;
      for (K = 0; K < 16; K++) J[K] = ee[K] | 0;
    }
    function A(J) {
      var ee, K, Y = 1;
      for (ee = 0; ee < 16; ee++)
        K = J[ee] + Y + 65535, Y = Math.floor(K / 65536), J[ee] = K - Y * 65536;
      J[0] += Y - 1 + 37 * (Y - 1);
    }
    function L(J, ee, K) {
      for (var Y, re = ~(K - 1), he = 0; he < 16; he++)
        Y = re & (J[he] ^ ee[he]), J[he] ^= Y, ee[he] ^= Y;
    }
    function m(J, ee) {
      var K, Y, re, he = o(), Se = o();
      for (K = 0; K < 16; K++) Se[K] = ee[K];
      for (A(Se), A(Se), A(Se), Y = 0; Y < 2; Y++) {
        for (he[0] = Se[0] - 65517, K = 1; K < 15; K++)
          he[K] = Se[K] - 65535 - (he[K - 1] >> 16 & 1), he[K - 1] &= 65535;
        he[15] = Se[15] - 32767 - (he[14] >> 16 & 1), re = he[15] >> 16 & 1, he[14] &= 65535, L(Se, he, 1 - re);
      }
      for (K = 0; K < 16; K++)
        J[2 * K] = Se[K] & 255, J[2 * K + 1] = Se[K] >> 8;
    }
    function a(J, ee) {
      var K = new Uint8Array(32), Y = new Uint8Array(32);
      return m(K, J), m(Y, ee), T(K, 0, Y, 0);
    }
    function x(J) {
      var ee = new Uint8Array(32);
      return m(ee, J), ee[0] & 1;
    }
    function V(J, ee) {
      var K;
      for (K = 0; K < 16; K++) J[K] = ee[2 * K] + (ee[2 * K + 1] << 8);
      J[15] &= 32767;
    }
    function G(J, ee, K) {
      for (var Y = 0; Y < 16; Y++) J[Y] = ee[Y] + K[Y];
    }
    function Z(J, ee, K) {
      for (var Y = 0; Y < 16; Y++) J[Y] = ee[Y] - K[Y];
    }
    function te(J, ee, K) {
      var Y, re, he = 0, Se = 0, ve = 0, we = 0, lt = 0, et = 0, Lt = 0, nt = 0, gt = 0, yt = 0, xt = 0, bt = 0, Mt = 0, vt = 0, mt = 0, ot = 0, ft = 0, rt = 0, st = 0, ct = 0, Je = 0, Oe = 0, ze = 0, qe = 0, Ge = 0, $e = 0, tt = 0, Ot = 0, Ht = 0, Qt = 0, Zt = 0, be = K[0], Jt = K[1], nr = K[2], ir = K[3], $t = K[4], tr = K[5], rr = K[6], kr = K[7], hr = K[8], Ar = K[9], Tr = K[10], Lr = K[11], Rr = K[12], Kr = K[13], en = K[14], tn = K[15];
      Y = ee[0], he += Y * be, Se += Y * Jt, ve += Y * nr, we += Y * ir, lt += Y * $t, et += Y * tr, Lt += Y * rr, nt += Y * kr, gt += Y * hr, yt += Y * Ar, xt += Y * Tr, bt += Y * Lr, Mt += Y * Rr, vt += Y * Kr, mt += Y * en, ot += Y * tn, Y = ee[1], Se += Y * be, ve += Y * Jt, we += Y * nr, lt += Y * ir, et += Y * $t, Lt += Y * tr, nt += Y * rr, gt += Y * kr, yt += Y * hr, xt += Y * Ar, bt += Y * Tr, Mt += Y * Lr, vt += Y * Rr, mt += Y * Kr, ot += Y * en, ft += Y * tn, Y = ee[2], ve += Y * be, we += Y * Jt, lt += Y * nr, et += Y * ir, Lt += Y * $t, nt += Y * tr, gt += Y * rr, yt += Y * kr, xt += Y * hr, bt += Y * Ar, Mt += Y * Tr, vt += Y * Lr, mt += Y * Rr, ot += Y * Kr, ft += Y * en, rt += Y * tn, Y = ee[3], we += Y * be, lt += Y * Jt, et += Y * nr, Lt += Y * ir, nt += Y * $t, gt += Y * tr, yt += Y * rr, xt += Y * kr, bt += Y * hr, Mt += Y * Ar, vt += Y * Tr, mt += Y * Lr, ot += Y * Rr, ft += Y * Kr, rt += Y * en, st += Y * tn, Y = ee[4], lt += Y * be, et += Y * Jt, Lt += Y * nr, nt += Y * ir, gt += Y * $t, yt += Y * tr, xt += Y * rr, bt += Y * kr, Mt += Y * hr, vt += Y * Ar, mt += Y * Tr, ot += Y * Lr, ft += Y * Rr, rt += Y * Kr, st += Y * en, ct += Y * tn, Y = ee[5], et += Y * be, Lt += Y * Jt, nt += Y * nr, gt += Y * ir, yt += Y * $t, xt += Y * tr, bt += Y * rr, Mt += Y * kr, vt += Y * hr, mt += Y * Ar, ot += Y * Tr, ft += Y * Lr, rt += Y * Rr, st += Y * Kr, ct += Y * en, Je += Y * tn, Y = ee[6], Lt += Y * be, nt += Y * Jt, gt += Y * nr, yt += Y * ir, xt += Y * $t, bt += Y * tr, Mt += Y * rr, vt += Y * kr, mt += Y * hr, ot += Y * Ar, ft += Y * Tr, rt += Y * Lr, st += Y * Rr, ct += Y * Kr, Je += Y * en, Oe += Y * tn, Y = ee[7], nt += Y * be, gt += Y * Jt, yt += Y * nr, xt += Y * ir, bt += Y * $t, Mt += Y * tr, vt += Y * rr, mt += Y * kr, ot += Y * hr, ft += Y * Ar, rt += Y * Tr, st += Y * Lr, ct += Y * Rr, Je += Y * Kr, Oe += Y * en, ze += Y * tn, Y = ee[8], gt += Y * be, yt += Y * Jt, xt += Y * nr, bt += Y * ir, Mt += Y * $t, vt += Y * tr, mt += Y * rr, ot += Y * kr, ft += Y * hr, rt += Y * Ar, st += Y * Tr, ct += Y * Lr, Je += Y * Rr, Oe += Y * Kr, ze += Y * en, qe += Y * tn, Y = ee[9], yt += Y * be, xt += Y * Jt, bt += Y * nr, Mt += Y * ir, vt += Y * $t, mt += Y * tr, ot += Y * rr, ft += Y * kr, rt += Y * hr, st += Y * Ar, ct += Y * Tr, Je += Y * Lr, Oe += Y * Rr, ze += Y * Kr, qe += Y * en, Ge += Y * tn, Y = ee[10], xt += Y * be, bt += Y * Jt, Mt += Y * nr, vt += Y * ir, mt += Y * $t, ot += Y * tr, ft += Y * rr, rt += Y * kr, st += Y * hr, ct += Y * Ar, Je += Y * Tr, Oe += Y * Lr, ze += Y * Rr, qe += Y * Kr, Ge += Y * en, $e += Y * tn, Y = ee[11], bt += Y * be, Mt += Y * Jt, vt += Y * nr, mt += Y * ir, ot += Y * $t, ft += Y * tr, rt += Y * rr, st += Y * kr, ct += Y * hr, Je += Y * Ar, Oe += Y * Tr, ze += Y * Lr, qe += Y * Rr, Ge += Y * Kr, $e += Y * en, tt += Y * tn, Y = ee[12], Mt += Y * be, vt += Y * Jt, mt += Y * nr, ot += Y * ir, ft += Y * $t, rt += Y * tr, st += Y * rr, ct += Y * kr, Je += Y * hr, Oe += Y * Ar, ze += Y * Tr, qe += Y * Lr, Ge += Y * Rr, $e += Y * Kr, tt += Y * en, Ot += Y * tn, Y = ee[13], vt += Y * be, mt += Y * Jt, ot += Y * nr, ft += Y * ir, rt += Y * $t, st += Y * tr, ct += Y * rr, Je += Y * kr, Oe += Y * hr, ze += Y * Ar, qe += Y * Tr, Ge += Y * Lr, $e += Y * Rr, tt += Y * Kr, Ot += Y * en, Ht += Y * tn, Y = ee[14], mt += Y * be, ot += Y * Jt, ft += Y * nr, rt += Y * ir, st += Y * $t, ct += Y * tr, Je += Y * rr, Oe += Y * kr, ze += Y * hr, qe += Y * Ar, Ge += Y * Tr, $e += Y * Lr, tt += Y * Rr, Ot += Y * Kr, Ht += Y * en, Qt += Y * tn, Y = ee[15], ot += Y * be, ft += Y * Jt, rt += Y * nr, st += Y * ir, ct += Y * $t, Je += Y * tr, Oe += Y * rr, ze += Y * kr, qe += Y * hr, Ge += Y * Ar, $e += Y * Tr, tt += Y * Lr, Ot += Y * Rr, Ht += Y * Kr, Qt += Y * en, Zt += Y * tn, he += 38 * ft, Se += 38 * rt, ve += 38 * st, we += 38 * ct, lt += 38 * Je, et += 38 * Oe, Lt += 38 * ze, nt += 38 * qe, gt += 38 * Ge, yt += 38 * $e, xt += 38 * tt, bt += 38 * Ot, Mt += 38 * Ht, vt += 38 * Qt, mt += 38 * Zt, re = 1, Y = he + re + 65535, re = Math.floor(Y / 65536), he = Y - re * 65536, Y = Se + re + 65535, re = Math.floor(Y / 65536), Se = Y - re * 65536, Y = ve + re + 65535, re = Math.floor(Y / 65536), ve = Y - re * 65536, Y = we + re + 65535, re = Math.floor(Y / 65536), we = Y - re * 65536, Y = lt + re + 65535, re = Math.floor(Y / 65536), lt = Y - re * 65536, Y = et + re + 65535, re = Math.floor(Y / 65536), et = Y - re * 65536, Y = Lt + re + 65535, re = Math.floor(Y / 65536), Lt = Y - re * 65536, Y = nt + re + 65535, re = Math.floor(Y / 65536), nt = Y - re * 65536, Y = gt + re + 65535, re = Math.floor(Y / 65536), gt = Y - re * 65536, Y = yt + re + 65535, re = Math.floor(Y / 65536), yt = Y - re * 65536, Y = xt + re + 65535, re = Math.floor(Y / 65536), xt = Y - re * 65536, Y = bt + re + 65535, re = Math.floor(Y / 65536), bt = Y - re * 65536, Y = Mt + re + 65535, re = Math.floor(Y / 65536), Mt = Y - re * 65536, Y = vt + re + 65535, re = Math.floor(Y / 65536), vt = Y - re * 65536, Y = mt + re + 65535, re = Math.floor(Y / 65536), mt = Y - re * 65536, Y = ot + re + 65535, re = Math.floor(Y / 65536), ot = Y - re * 65536, he += re - 1 + 37 * (re - 1), re = 1, Y = he + re + 65535, re = Math.floor(Y / 65536), he = Y - re * 65536, Y = Se + re + 65535, re = Math.floor(Y / 65536), Se = Y - re * 65536, Y = ve + re + 65535, re = Math.floor(Y / 65536), ve = Y - re * 65536, Y = we + re + 65535, re = Math.floor(Y / 65536), we = Y - re * 65536, Y = lt + re + 65535, re = Math.floor(Y / 65536), lt = Y - re * 65536, Y = et + re + 65535, re = Math.floor(Y / 65536), et = Y - re * 65536, Y = Lt + re + 65535, re = Math.floor(Y / 65536), Lt = Y - re * 65536, Y = nt + re + 65535, re = Math.floor(Y / 65536), nt = Y - re * 65536, Y = gt + re + 65535, re = Math.floor(Y / 65536), gt = Y - re * 65536, Y = yt + re + 65535, re = Math.floor(Y / 65536), yt = Y - re * 65536, Y = xt + re + 65535, re = Math.floor(Y / 65536), xt = Y - re * 65536, Y = bt + re + 65535, re = Math.floor(Y / 65536), bt = Y - re * 65536, Y = Mt + re + 65535, re = Math.floor(Y / 65536), Mt = Y - re * 65536, Y = vt + re + 65535, re = Math.floor(Y / 65536), vt = Y - re * 65536, Y = mt + re + 65535, re = Math.floor(Y / 65536), mt = Y - re * 65536, Y = ot + re + 65535, re = Math.floor(Y / 65536), ot = Y - re * 65536, he += re - 1 + 37 * (re - 1), J[0] = he, J[1] = Se, J[2] = ve, J[3] = we, J[4] = lt, J[5] = et, J[6] = Lt, J[7] = nt, J[8] = gt, J[9] = yt, J[10] = xt, J[11] = bt, J[12] = Mt, J[13] = vt, J[14] = mt, J[15] = ot;
    }
    function q(J, ee) {
      te(J, ee, ee);
    }
    function R(J, ee) {
      var K = o(), Y;
      for (Y = 0; Y < 16; Y++) K[Y] = ee[Y];
      for (Y = 253; Y >= 0; Y--)
        q(K, K), Y !== 2 && Y !== 4 && te(K, K, ee);
      for (Y = 0; Y < 16; Y++) J[Y] = K[Y];
    }
    function Q(J, ee) {
      var K = o(), Y;
      for (Y = 0; Y < 16; Y++) K[Y] = ee[Y];
      for (Y = 250; Y >= 0; Y--)
        q(K, K), Y !== 1 && te(K, K, ee);
      for (Y = 0; Y < 16; Y++) J[Y] = K[Y];
    }
    function $(J, ee, K) {
      var Y = new Uint8Array(32), re = new Float64Array(80), he, Se, ve = o(), we = o(), lt = o(), et = o(), Lt = o(), nt = o();
      for (Se = 0; Se < 31; Se++) Y[Se] = ee[Se];
      for (Y[31] = ee[31] & 127 | 64, Y[0] &= 248, V(re, K), Se = 0; Se < 16; Se++)
        we[Se] = re[Se], et[Se] = ve[Se] = lt[Se] = 0;
      for (ve[0] = et[0] = 1, Se = 254; Se >= 0; --Se)
        he = Y[Se >>> 3] >>> (Se & 7) & 1, L(ve, we, he), L(lt, et, he), G(Lt, ve, lt), Z(ve, ve, lt), G(lt, we, et), Z(we, we, et), q(et, Lt), q(nt, ve), te(ve, lt, ve), te(lt, we, Lt), G(Lt, ve, lt), Z(ve, ve, lt), q(we, ve), Z(lt, et, nt), te(ve, lt, p), G(ve, ve, et), te(lt, lt, ve), te(ve, et, nt), te(et, we, re), q(we, Lt), L(ve, we, he), L(lt, et, he);
      for (Se = 0; Se < 16; Se++)
        re[Se + 16] = ve[Se], re[Se + 32] = lt[Se], re[Se + 48] = we[Se], re[Se + 64] = et[Se];
      var gt = re.subarray(32), yt = re.subarray(16);
      return R(gt, gt), te(yt, yt, gt), m(J, yt), 0;
    }
    function F(J, ee) {
      return $(J, ee, n);
    }
    function P(J, ee) {
      return i(ee, 32), F(J, ee);
    }
    function _(J, ee, K) {
      var Y = new Uint8Array(32);
      return $(Y, K, ee), z(J, c, Y, k);
    }
    var X = u, le = g;
    function ie(J, ee, K, Y, re, he) {
      var Se = new Uint8Array(32);
      return _(Se, re, he), X(J, ee, K, Y, Se);
    }
    function oe(J, ee, K, Y, re, he) {
      var Se = new Uint8Array(32);
      return _(Se, re, he), le(J, ee, K, Y, Se);
    }
    var pe = [
      1116352408,
      3609767458,
      1899447441,
      602891725,
      3049323471,
      3964484399,
      3921009573,
      2173295548,
      961987163,
      4081628472,
      1508970993,
      3053834265,
      2453635748,
      2937671579,
      2870763221,
      3664609560,
      3624381080,
      2734883394,
      310598401,
      1164996542,
      607225278,
      1323610764,
      1426881987,
      3590304994,
      1925078388,
      4068182383,
      2162078206,
      991336113,
      2614888103,
      633803317,
      3248222580,
      3479774868,
      3835390401,
      2666613458,
      4022224774,
      944711139,
      264347078,
      2341262773,
      604807628,
      2007800933,
      770255983,
      1495990901,
      1249150122,
      1856431235,
      1555081692,
      3175218132,
      1996064986,
      2198950837,
      2554220882,
      3999719339,
      2821834349,
      766784016,
      2952996808,
      2566594879,
      3210313671,
      3203337956,
      3336571891,
      1034457026,
      3584528711,
      2466948901,
      113926993,
      3758326383,
      338241895,
      168717936,
      666307205,
      1188179964,
      773529912,
      1546045734,
      1294757372,
      1522805485,
      1396182291,
      2643833823,
      1695183700,
      2343527390,
      1986661051,
      1014477480,
      2177026350,
      1206759142,
      2456956037,
      344077627,
      2730485921,
      1290863460,
      2820302411,
      3158454273,
      3259730800,
      3505952657,
      3345764771,
      106217008,
      3516065817,
      3606008344,
      3600352804,
      1432725776,
      4094571909,
      1467031594,
      275423344,
      851169720,
      430227734,
      3100823752,
      506948616,
      1363258195,
      659060556,
      3750685593,
      883997877,
      3785050280,
      958139571,
      3318307427,
      1322822218,
      3812723403,
      1537002063,
      2003034995,
      1747873779,
      3602036899,
      1955562222,
      1575990012,
      2024104815,
      1125592928,
      2227730452,
      2716904306,
      2361852424,
      442776044,
      2428436474,
      593698344,
      2756734187,
      3733110249,
      3204031479,
      2999351573,
      3329325298,
      3815920427,
      3391569614,
      3928383900,
      3515267271,
      566280711,
      3940187606,
      3454069534,
      4118630271,
      4000239992,
      116418474,
      1914138554,
      174292421,
      2731055270,
      289380356,
      3203993006,
      460393269,
      320620315,
      685471733,
      587496836,
      852142971,
      1086792851,
      1017036298,
      365543100,
      1126000580,
      2618297676,
      1288033470,
      3409855158,
      1501505948,
      4234509866,
      1607167915,
      987167468,
      1816402316,
      1246189591
    ];
    function se(J, ee, K, Y) {
      for (var re = new Int32Array(16), he = new Int32Array(16), Se, ve, we, lt, et, Lt, nt, gt, yt, xt, bt, Mt, vt, mt, ot, ft, rt, st, ct, Je, Oe, ze, qe, Ge, $e, tt, Ot = J[0], Ht = J[1], Qt = J[2], Zt = J[3], be = J[4], Jt = J[5], nr = J[6], ir = J[7], $t = ee[0], tr = ee[1], rr = ee[2], kr = ee[3], hr = ee[4], Ar = ee[5], Tr = ee[6], Lr = ee[7], Rr = 0; Y >= 128; ) {
        for (ct = 0; ct < 16; ct++)
          Je = 8 * ct + Rr, re[ct] = K[Je + 0] << 24 | K[Je + 1] << 16 | K[Je + 2] << 8 | K[Je + 3], he[ct] = K[Je + 4] << 24 | K[Je + 5] << 16 | K[Je + 6] << 8 | K[Je + 7];
        for (ct = 0; ct < 80; ct++)
          if (Se = Ot, ve = Ht, we = Qt, lt = Zt, et = be, Lt = Jt, nt = nr, gt = ir, yt = $t, xt = tr, bt = rr, Mt = kr, vt = hr, mt = Ar, ot = Tr, ft = Lr, Oe = ir, ze = Lr, qe = ze & 65535, Ge = ze >>> 16, $e = Oe & 65535, tt = Oe >>> 16, Oe = (be >>> 14 | hr << 18) ^ (be >>> 18 | hr << 14) ^ (hr >>> 9 | be << 23), ze = (hr >>> 14 | be << 18) ^ (hr >>> 18 | be << 14) ^ (be >>> 9 | hr << 23), qe += ze & 65535, Ge += ze >>> 16, $e += Oe & 65535, tt += Oe >>> 16, Oe = be & Jt ^ ~be & nr, ze = hr & Ar ^ ~hr & Tr, qe += ze & 65535, Ge += ze >>> 16, $e += Oe & 65535, tt += Oe >>> 16, Oe = pe[ct * 2], ze = pe[ct * 2 + 1], qe += ze & 65535, Ge += ze >>> 16, $e += Oe & 65535, tt += Oe >>> 16, Oe = re[ct % 16], ze = he[ct % 16], qe += ze & 65535, Ge += ze >>> 16, $e += Oe & 65535, tt += Oe >>> 16, Ge += qe >>> 16, $e += Ge >>> 16, tt += $e >>> 16, rt = $e & 65535 | tt << 16, st = qe & 65535 | Ge << 16, Oe = rt, ze = st, qe = ze & 65535, Ge = ze >>> 16, $e = Oe & 65535, tt = Oe >>> 16, Oe = (Ot >>> 28 | $t << 4) ^ ($t >>> 2 | Ot << 30) ^ ($t >>> 7 | Ot << 25), ze = ($t >>> 28 | Ot << 4) ^ (Ot >>> 2 | $t << 30) ^ (Ot >>> 7 | $t << 25), qe += ze & 65535, Ge += ze >>> 16, $e += Oe & 65535, tt += Oe >>> 16, Oe = Ot & Ht ^ Ot & Qt ^ Ht & Qt, ze = $t & tr ^ $t & rr ^ tr & rr, qe += ze & 65535, Ge += ze >>> 16, $e += Oe & 65535, tt += Oe >>> 16, Ge += qe >>> 16, $e += Ge >>> 16, tt += $e >>> 16, gt = $e & 65535 | tt << 16, ft = qe & 65535 | Ge << 16, Oe = lt, ze = Mt, qe = ze & 65535, Ge = ze >>> 16, $e = Oe & 65535, tt = Oe >>> 16, Oe = rt, ze = st, qe += ze & 65535, Ge += ze >>> 16, $e += Oe & 65535, tt += Oe >>> 16, Ge += qe >>> 16, $e += Ge >>> 16, tt += $e >>> 16, lt = $e & 65535 | tt << 16, Mt = qe & 65535 | Ge << 16, Ht = Se, Qt = ve, Zt = we, be = lt, Jt = et, nr = Lt, ir = nt, Ot = gt, tr = yt, rr = xt, kr = bt, hr = Mt, Ar = vt, Tr = mt, Lr = ot, $t = ft, ct % 16 === 15)
            for (Je = 0; Je < 16; Je++)
              Oe = re[Je], ze = he[Je], qe = ze & 65535, Ge = ze >>> 16, $e = Oe & 65535, tt = Oe >>> 16, Oe = re[(Je + 9) % 16], ze = he[(Je + 9) % 16], qe += ze & 65535, Ge += ze >>> 16, $e += Oe & 65535, tt += Oe >>> 16, rt = re[(Je + 1) % 16], st = he[(Je + 1) % 16], Oe = (rt >>> 1 | st << 31) ^ (rt >>> 8 | st << 24) ^ rt >>> 7, ze = (st >>> 1 | rt << 31) ^ (st >>> 8 | rt << 24) ^ (st >>> 7 | rt << 25), qe += ze & 65535, Ge += ze >>> 16, $e += Oe & 65535, tt += Oe >>> 16, rt = re[(Je + 14) % 16], st = he[(Je + 14) % 16], Oe = (rt >>> 19 | st << 13) ^ (st >>> 29 | rt << 3) ^ rt >>> 6, ze = (st >>> 19 | rt << 13) ^ (rt >>> 29 | st << 3) ^ (st >>> 6 | rt << 26), qe += ze & 65535, Ge += ze >>> 16, $e += Oe & 65535, tt += Oe >>> 16, Ge += qe >>> 16, $e += Ge >>> 16, tt += $e >>> 16, re[Je] = $e & 65535 | tt << 16, he[Je] = qe & 65535 | Ge << 16;
        Oe = Ot, ze = $t, qe = ze & 65535, Ge = ze >>> 16, $e = Oe & 65535, tt = Oe >>> 16, Oe = J[0], ze = ee[0], qe += ze & 65535, Ge += ze >>> 16, $e += Oe & 65535, tt += Oe >>> 16, Ge += qe >>> 16, $e += Ge >>> 16, tt += $e >>> 16, J[0] = Ot = $e & 65535 | tt << 16, ee[0] = $t = qe & 65535 | Ge << 16, Oe = Ht, ze = tr, qe = ze & 65535, Ge = ze >>> 16, $e = Oe & 65535, tt = Oe >>> 16, Oe = J[1], ze = ee[1], qe += ze & 65535, Ge += ze >>> 16, $e += Oe & 65535, tt += Oe >>> 16, Ge += qe >>> 16, $e += Ge >>> 16, tt += $e >>> 16, J[1] = Ht = $e & 65535 | tt << 16, ee[1] = tr = qe & 65535 | Ge << 16, Oe = Qt, ze = rr, qe = ze & 65535, Ge = ze >>> 16, $e = Oe & 65535, tt = Oe >>> 16, Oe = J[2], ze = ee[2], qe += ze & 65535, Ge += ze >>> 16, $e += Oe & 65535, tt += Oe >>> 16, Ge += qe >>> 16, $e += Ge >>> 16, tt += $e >>> 16, J[2] = Qt = $e & 65535 | tt << 16, ee[2] = rr = qe & 65535 | Ge << 16, Oe = Zt, ze = kr, qe = ze & 65535, Ge = ze >>> 16, $e = Oe & 65535, tt = Oe >>> 16, Oe = J[3], ze = ee[3], qe += ze & 65535, Ge += ze >>> 16, $e += Oe & 65535, tt += Oe >>> 16, Ge += qe >>> 16, $e += Ge >>> 16, tt += $e >>> 16, J[3] = Zt = $e & 65535 | tt << 16, ee[3] = kr = qe & 65535 | Ge << 16, Oe = be, ze = hr, qe = ze & 65535, Ge = ze >>> 16, $e = Oe & 65535, tt = Oe >>> 16, Oe = J[4], ze = ee[4], qe += ze & 65535, Ge += ze >>> 16, $e += Oe & 65535, tt += Oe >>> 16, Ge += qe >>> 16, $e += Ge >>> 16, tt += $e >>> 16, J[4] = be = $e & 65535 | tt << 16, ee[4] = hr = qe & 65535 | Ge << 16, Oe = Jt, ze = Ar, qe = ze & 65535, Ge = ze >>> 16, $e = Oe & 65535, tt = Oe >>> 16, Oe = J[5], ze = ee[5], qe += ze & 65535, Ge += ze >>> 16, $e += Oe & 65535, tt += Oe >>> 16, Ge += qe >>> 16, $e += Ge >>> 16, tt += $e >>> 16, J[5] = Jt = $e & 65535 | tt << 16, ee[5] = Ar = qe & 65535 | Ge << 16, Oe = nr, ze = Tr, qe = ze & 65535, Ge = ze >>> 16, $e = Oe & 65535, tt = Oe >>> 16, Oe = J[6], ze = ee[6], qe += ze & 65535, Ge += ze >>> 16, $e += Oe & 65535, tt += Oe >>> 16, Ge += qe >>> 16, $e += Ge >>> 16, tt += $e >>> 16, J[6] = nr = $e & 65535 | tt << 16, ee[6] = Tr = qe & 65535 | Ge << 16, Oe = ir, ze = Lr, qe = ze & 65535, Ge = ze >>> 16, $e = Oe & 65535, tt = Oe >>> 16, Oe = J[7], ze = ee[7], qe += ze & 65535, Ge += ze >>> 16, $e += Oe & 65535, tt += Oe >>> 16, Ge += qe >>> 16, $e += Ge >>> 16, tt += $e >>> 16, J[7] = ir = $e & 65535 | tt << 16, ee[7] = Lr = qe & 65535 | Ge << 16, Rr += 128, Y -= 128;
      }
      return Y;
    }
    function ce(J, ee, K) {
      var Y = new Int32Array(8), re = new Int32Array(8), he = new Uint8Array(256), Se, ve = K;
      for (Y[0] = 1779033703, Y[1] = 3144134277, Y[2] = 1013904242, Y[3] = 2773480762, Y[4] = 1359893119, Y[5] = 2600822924, Y[6] = 528734635, Y[7] = 1541459225, re[0] = 4089235720, re[1] = 2227873595, re[2] = 4271175723, re[3] = 1595750129, re[4] = 2917565137, re[5] = 725511199, re[6] = 4215389547, re[7] = 327033209, se(Y, re, ee, K), K %= 128, Se = 0; Se < K; Se++) he[Se] = ee[ve - K + Se];
      for (he[K] = 128, K = 256 - 128 * (K < 112 ? 1 : 0), he[K - 9] = 0, N(he, K - 8, ve / 536870912 | 0, ve << 3), se(Y, re, he, K), Se = 0; Se < 8; Se++) N(J, 8 * Se, Y[Se], re[Se]);
      return 0;
    }
    function me(J, ee) {
      var K = o(), Y = o(), re = o(), he = o(), Se = o(), ve = o(), we = o(), lt = o(), et = o();
      Z(K, J[1], J[0]), Z(et, ee[1], ee[0]), te(K, K, et), G(Y, J[0], J[1]), G(et, ee[0], ee[1]), te(Y, Y, et), te(re, J[3], ee[3]), te(re, re, h), te(he, J[2], ee[2]), G(he, he, he), Z(Se, Y, K), Z(ve, he, re), G(we, he, re), G(lt, Y, K), te(J[0], Se, ve), te(J[1], lt, we), te(J[2], we, ve), te(J[3], Se, lt);
    }
    function de(J, ee, K) {
      var Y;
      for (Y = 0; Y < 4; Y++)
        L(J[Y], ee[Y], K);
    }
    function ae(J, ee) {
      var K = o(), Y = o(), re = o();
      R(re, ee[2]), te(K, ee[0], re), te(Y, ee[1], re), m(J, Y), J[31] ^= x(K) << 7;
    }
    function Le(J, ee, K) {
      var Y, re;
      for (v(J[0], d), v(J[1], f), v(J[2], f), v(J[3], d), re = 255; re >= 0; --re)
        Y = K[re / 8 | 0] >> (re & 7) & 1, de(J, ee, Y), me(ee, J), me(J, J), de(J, ee, Y);
    }
    function ye(J, ee) {
      var K = [o(), o(), o(), o()];
      v(K[0], y), v(K[1], M), v(K[2], f), te(K[3], y, M), Le(J, K, ee);
    }
    function Me(J, ee, K) {
      var Y = new Uint8Array(64), re = [o(), o(), o(), o()], he;
      for (K || i(ee, 32), ce(Y, ee, 32), Y[0] &= 248, Y[31] &= 127, Y[31] |= 64, ye(re, Y), ae(J, re), he = 0; he < 32; he++) ee[he + 32] = J[he];
      return 0;
    }
    var at = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);
    function Ne(J, ee) {
      var K, Y, re, he;
      for (Y = 63; Y >= 32; --Y) {
        for (K = 0, re = Y - 32, he = Y - 12; re < he; ++re)
          ee[re] += K - 16 * ee[Y] * at[re - (Y - 32)], K = Math.floor((ee[re] + 128) / 256), ee[re] -= K * 256;
        ee[re] += K, ee[Y] = 0;
      }
      for (K = 0, re = 0; re < 32; re++)
        ee[re] += K - (ee[31] >> 4) * at[re], K = ee[re] >> 8, ee[re] &= 255;
      for (re = 0; re < 32; re++) ee[re] -= K * at[re];
      for (Y = 0; Y < 32; Y++)
        ee[Y + 1] += ee[Y] >> 8, J[Y] = ee[Y] & 255;
    }
    function Ae(J) {
      var ee = new Float64Array(64), K;
      for (K = 0; K < 64; K++) ee[K] = J[K];
      for (K = 0; K < 64; K++) J[K] = 0;
      Ne(J, ee);
    }
    function pt(J, ee, K, Y) {
      var re = new Uint8Array(64), he = new Uint8Array(64), Se = new Uint8Array(64), ve, we, lt = new Float64Array(64), et = [o(), o(), o(), o()];
      ce(re, Y, 32), re[0] &= 248, re[31] &= 127, re[31] |= 64;
      var Lt = K + 64;
      for (ve = 0; ve < K; ve++) J[64 + ve] = ee[ve];
      for (ve = 0; ve < 32; ve++) J[32 + ve] = re[32 + ve];
      for (ce(Se, J.subarray(32), K + 32), Ae(Se), ye(et, Se), ae(J, et), ve = 32; ve < 64; ve++) J[ve] = Y[ve];
      for (ce(he, J, K + 64), Ae(he), ve = 0; ve < 64; ve++) lt[ve] = 0;
      for (ve = 0; ve < 32; ve++) lt[ve] = Se[ve];
      for (ve = 0; ve < 32; ve++)
        for (we = 0; we < 32; we++)
          lt[ve + we] += he[ve] * re[we];
      return Ne(J.subarray(32), lt), Lt;
    }
    function ke(J, ee) {
      var K = o(), Y = o(), re = o(), he = o(), Se = o(), ve = o(), we = o();
      return v(J[2], f), V(J[1], ee), q(re, J[1]), te(he, re, l), Z(re, re, J[2]), G(he, J[2], he), q(Se, he), q(ve, Se), te(we, ve, Se), te(K, we, re), te(K, K, he), Q(K, K), te(K, K, re), te(K, K, he), te(K, K, he), te(J[0], K, he), q(Y, J[0]), te(Y, Y, he), a(Y, re) && te(J[0], J[0], C), q(Y, J[0]), te(Y, Y, he), a(Y, re) ? -1 : (x(J[0]) === ee[31] >> 7 && Z(J[0], d, J[0]), te(J[3], J[0], J[1]), 0);
    }
    function Te(J, ee, K, Y) {
      var re, he = new Uint8Array(32), Se = new Uint8Array(64), ve = [o(), o(), o(), o()], we = [o(), o(), o(), o()];
      if (K < 64 || ke(we, Y)) return -1;
      for (re = 0; re < K; re++) J[re] = ee[re];
      for (re = 0; re < 32; re++) J[re + 32] = Y[re];
      if (ce(Se, J, K), Ae(Se), Le(ve, we, Se), ye(we, ee.subarray(32)), me(ve, we), ae(he, ve), K -= 64, T(ee, 0, he, 0)) {
        for (re = 0; re < K; re++) J[re] = 0;
        return -1;
      }
      for (re = 0; re < K; re++) J[re] = ee[re + 64];
      return K;
    }
    var Dt = 32, De = 24, je = 32, At = 16, xe = 32, Ie = 32, Nt = 32, _e = 32, Be = 32, Xt = De, Re = je, Pe = At, dr = 64, We = 32, He = 64, Ct = 32, Ue = 64;
    t.lowlevel = {
      crypto_core_hsalsa20: z,
      crypto_stream_xor: B,
      crypto_stream: U,
      crypto_stream_salsa20_xor: H,
      crypto_stream_salsa20: W,
      crypto_onetimeauth: r,
      crypto_onetimeauth_verify: s,
      crypto_verify_16: S,
      crypto_verify_32: T,
      crypto_secretbox: u,
      crypto_secretbox_open: g,
      crypto_scalarmult: $,
      crypto_scalarmult_base: F,
      crypto_box_beforenm: _,
      crypto_box_afternm: X,
      crypto_box: ie,
      crypto_box_open: oe,
      crypto_box_keypair: P,
      crypto_hash: ce,
      crypto_sign: pt,
      crypto_sign_keypair: Me,
      crypto_sign_open: Te,
      crypto_secretbox_KEYBYTES: Dt,
      crypto_secretbox_NONCEBYTES: De,
      crypto_secretbox_ZEROBYTES: je,
      crypto_secretbox_BOXZEROBYTES: At,
      crypto_scalarmult_BYTES: xe,
      crypto_scalarmult_SCALARBYTES: Ie,
      crypto_box_PUBLICKEYBYTES: Nt,
      crypto_box_SECRETKEYBYTES: _e,
      crypto_box_BEFORENMBYTES: Be,
      crypto_box_NONCEBYTES: Xt,
      crypto_box_ZEROBYTES: Re,
      crypto_box_BOXZEROBYTES: Pe,
      crypto_sign_BYTES: dr,
      crypto_sign_PUBLICKEYBYTES: We,
      crypto_sign_SECRETKEYBYTES: He,
      crypto_sign_SEEDBYTES: Ct,
      crypto_hash_BYTES: Ue,
      gf: o,
      D: l,
      L: at,
      pack25519: m,
      unpack25519: V,
      M: te,
      A: G,
      S: q,
      Z,
      pow2523: Q,
      add: me,
      set25519: v,
      modL: Ne,
      scalarmult: Le,
      scalarbase: ye
    };
    function Ze(J, ee) {
      if (J.length !== Dt) throw new Error("bad key size");
      if (ee.length !== De) throw new Error("bad nonce size");
    }
    function Fr(J, ee) {
      if (J.length !== Nt) throw new Error("bad public key size");
      if (ee.length !== _e) throw new Error("bad secret key size");
    }
    function Ye() {
      for (var J = 0; J < arguments.length; J++)
        if (!(arguments[J] instanceof Uint8Array))
          throw new TypeError("unexpected type, use Uint8Array");
    }
    function Qe(J) {
      for (var ee = 0; ee < J.length; ee++) J[ee] = 0;
    }
    t.randomBytes = function(J) {
      var ee = new Uint8Array(J);
      return i(ee, J), ee;
    }, t.secretbox = function(J, ee, K) {
      Ye(J, ee, K), Ze(K, ee);
      for (var Y = new Uint8Array(je + J.length), re = new Uint8Array(Y.length), he = 0; he < J.length; he++) Y[he + je] = J[he];
      return u(re, Y, Y.length, ee, K), re.subarray(At);
    }, t.secretbox.open = function(J, ee, K) {
      Ye(J, ee, K), Ze(K, ee);
      for (var Y = new Uint8Array(At + J.length), re = new Uint8Array(Y.length), he = 0; he < J.length; he++) Y[he + At] = J[he];
      return Y.length < 32 || g(re, Y, Y.length, ee, K) !== 0 ? null : re.subarray(je);
    }, t.secretbox.keyLength = Dt, t.secretbox.nonceLength = De, t.secretbox.overheadLength = At, t.scalarMult = function(J, ee) {
      if (Ye(J, ee), J.length !== Ie) throw new Error("bad n size");
      if (ee.length !== xe) throw new Error("bad p size");
      var K = new Uint8Array(xe);
      return $(K, J, ee), K;
    }, t.scalarMult.base = function(J) {
      if (Ye(J), J.length !== Ie) throw new Error("bad n size");
      var ee = new Uint8Array(xe);
      return F(ee, J), ee;
    }, t.scalarMult.scalarLength = Ie, t.scalarMult.groupElementLength = xe, t.box = function(J, ee, K, Y) {
      var re = t.box.before(K, Y);
      return t.secretbox(J, ee, re);
    }, t.box.before = function(J, ee) {
      Ye(J, ee), Fr(J, ee);
      var K = new Uint8Array(Be);
      return _(K, J, ee), K;
    }, t.box.after = t.secretbox, t.box.open = function(J, ee, K, Y) {
      var re = t.box.before(K, Y);
      return t.secretbox.open(J, ee, re);
    }, t.box.open.after = t.secretbox.open, t.box.keyPair = function() {
      var J = new Uint8Array(Nt), ee = new Uint8Array(_e);
      return P(J, ee), { publicKey: J, secretKey: ee };
    }, t.box.keyPair.fromSecretKey = function(J) {
      if (Ye(J), J.length !== _e)
        throw new Error("bad secret key size");
      var ee = new Uint8Array(Nt);
      return F(ee, J), { publicKey: ee, secretKey: new Uint8Array(J) };
    }, t.box.publicKeyLength = Nt, t.box.secretKeyLength = _e, t.box.sharedKeyLength = Be, t.box.nonceLength = Xt, t.box.overheadLength = t.secretbox.overheadLength, t.sign = function(J, ee) {
      if (Ye(J, ee), ee.length !== He)
        throw new Error("bad secret key size");
      var K = new Uint8Array(dr + J.length);
      return pt(K, J, J.length, ee), K;
    }, t.sign.open = function(J, ee) {
      if (Ye(J, ee), ee.length !== We)
        throw new Error("bad public key size");
      var K = new Uint8Array(J.length), Y = Te(K, J, J.length, ee);
      if (Y < 0) return null;
      for (var re = new Uint8Array(Y), he = 0; he < re.length; he++) re[he] = K[he];
      return re;
    }, t.sign.detached = function(J, ee) {
      for (var K = t.sign(J, ee), Y = new Uint8Array(dr), re = 0; re < Y.length; re++) Y[re] = K[re];
      return Y;
    }, t.sign.detached.verify = function(J, ee, K) {
      if (Ye(J, ee, K), ee.length !== dr)
        throw new Error("bad signature size");
      if (K.length !== We)
        throw new Error("bad public key size");
      var Y = new Uint8Array(dr + J.length), re = new Uint8Array(dr + J.length), he;
      for (he = 0; he < dr; he++) Y[he] = ee[he];
      for (he = 0; he < J.length; he++) Y[he + dr] = J[he];
      return Te(re, Y, Y.length, K) >= 0;
    }, t.sign.keyPair = function() {
      var J = new Uint8Array(We), ee = new Uint8Array(He);
      return Me(J, ee), { publicKey: J, secretKey: ee };
    }, t.sign.keyPair.fromSecretKey = function(J) {
      if (Ye(J), J.length !== He)
        throw new Error("bad secret key size");
      for (var ee = new Uint8Array(We), K = 0; K < ee.length; K++) ee[K] = J[32 + K];
      return { publicKey: ee, secretKey: new Uint8Array(J) };
    }, t.sign.keyPair.fromSeed = function(J) {
      if (Ye(J), J.length !== Ct)
        throw new Error("bad seed size");
      for (var ee = new Uint8Array(We), K = new Uint8Array(He), Y = 0; Y < 32; Y++) K[Y] = J[Y];
      return Me(ee, K, !0), { publicKey: ee, secretKey: K };
    }, t.sign.publicKeyLength = We, t.sign.secretKeyLength = He, t.sign.seedLength = Ct, t.sign.signatureLength = dr, t.hash = function(J) {
      Ye(J);
      var ee = new Uint8Array(Ue);
      return ce(ee, J, J.length), ee;
    }, t.hash.hashLength = Ue, t.verify = function(J, ee) {
      return Ye(J, ee), J.length === 0 || ee.length === 0 || J.length !== ee.length ? !1 : w(J, 0, ee, 0, J.length) === 0;
    }, t.setPRNG = function(J) {
      i = J;
    }, function() {
      var J = typeof self < "u" ? self.crypto || self.msCrypto : null;
      if (J && J.getRandomValues) {
        var ee = 65536;
        t.setPRNG(function(K, Y) {
          var re, he = new Uint8Array(Y);
          for (re = 0; re < Y; re += ee)
            J.getRandomValues(he.subarray(re, re + Math.min(Y - re, ee)));
          for (re = 0; re < Y; re++) K[re] = he[re];
          Qe(he);
        });
      } else typeof gC < "u" && (J = zM(), J && J.randomBytes && t.setPRNG(function(K, Y) {
        var re, he = J.randomBytes(Y);
        for (re = 0; re < Y; re++) K[re] = he[re];
        Qe(he);
      }));
    }();
  })(e.exports ? e.exports : self.nacl = self.nacl || {});
})(py);
var gT = py.exports;
const kM = /* @__PURE__ */ Yi(gT);
var _M = { exports: {} };
(function(e) {
  (function() {
    var t = "input is invalid type", o = "finalize already called", i = typeof window == "object", c = i ? window : {};
    c.JS_SHA512_NO_WINDOW && (i = !1);
    var n = !i && typeof self == "object", d = !c.JS_SHA512_NO_NODE_JS && typeof fe.process == "object" && fe.process.versions && fe.process.versions.node;
    d ? c = Wt : n && (c = self);
    var f = !c.JS_SHA512_NO_COMMON_JS && !0 && e.exports, p = !c.JS_SHA512_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", l = "0123456789abcdef".split(""), h = [-2147483648, 8388608, 32768, 128], y = [24, 16, 8, 0], M = [
      1116352408,
      3609767458,
      1899447441,
      602891725,
      3049323471,
      3964484399,
      3921009573,
      2173295548,
      961987163,
      4081628472,
      1508970993,
      3053834265,
      2453635748,
      2937671579,
      2870763221,
      3664609560,
      3624381080,
      2734883394,
      310598401,
      1164996542,
      607225278,
      1323610764,
      1426881987,
      3590304994,
      1925078388,
      4068182383,
      2162078206,
      991336113,
      2614888103,
      633803317,
      3248222580,
      3479774868,
      3835390401,
      2666613458,
      4022224774,
      944711139,
      264347078,
      2341262773,
      604807628,
      2007800933,
      770255983,
      1495990901,
      1249150122,
      1856431235,
      1555081692,
      3175218132,
      1996064986,
      2198950837,
      2554220882,
      3999719339,
      2821834349,
      766784016,
      2952996808,
      2566594879,
      3210313671,
      3203337956,
      3336571891,
      1034457026,
      3584528711,
      2466948901,
      113926993,
      3758326383,
      338241895,
      168717936,
      666307205,
      1188179964,
      773529912,
      1546045734,
      1294757372,
      1522805485,
      1396182291,
      2643833823,
      1695183700,
      2343527390,
      1986661051,
      1014477480,
      2177026350,
      1206759142,
      2456956037,
      344077627,
      2730485921,
      1290863460,
      2820302411,
      3158454273,
      3259730800,
      3505952657,
      3345764771,
      106217008,
      3516065817,
      3606008344,
      3600352804,
      1432725776,
      4094571909,
      1467031594,
      275423344,
      851169720,
      430227734,
      3100823752,
      506948616,
      1363258195,
      659060556,
      3750685593,
      883997877,
      3785050280,
      958139571,
      3318307427,
      1322822218,
      3812723403,
      1537002063,
      2003034995,
      1747873779,
      3602036899,
      1955562222,
      1575990012,
      2024104815,
      1125592928,
      2227730452,
      2716904306,
      2361852424,
      442776044,
      2428436474,
      593698344,
      2756734187,
      3733110249,
      3204031479,
      2999351573,
      3329325298,
      3815920427,
      3391569614,
      3928383900,
      3515267271,
      566280711,
      3940187606,
      3454069534,
      4118630271,
      4000239992,
      116418474,
      1914138554,
      174292421,
      2731055270,
      289380356,
      3203993006,
      460393269,
      320620315,
      685471733,
      587496836,
      852142971,
      1086792851,
      1017036298,
      365543100,
      1126000580,
      2618297676,
      1288033470,
      3409855158,
      1501505948,
      4234509866,
      1607167915,
      987167468,
      1816402316,
      1246189591
    ], C = ["hex", "array", "digest", "arrayBuffer"], N = [];
    (c.JS_SHA512_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(k) {
      return Object.prototype.toString.call(k) === "[object Array]";
    }), p && (c.JS_SHA512_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(k) {
      return typeof k == "object" && k.buffer && k.buffer.constructor === ArrayBuffer;
    });
    var w = function(k, H) {
      return function(W) {
        return new j(H, !0).update(W)[k]();
      };
    }, S = function(k) {
      var H = w("hex", k);
      H.create = function() {
        return new j(k);
      }, H.update = function(B) {
        return H.create().update(B);
      };
      for (var W = 0; W < C.length; ++W) {
        var U = C[W];
        H[U] = w(U, k);
      }
      return H;
    }, T = function(k, H) {
      return function(W, U) {
        return new O(W, H, !0).update(U)[k]();
      };
    }, E = function(k) {
      var H = T("hex", k);
      H.create = function(B) {
        return new O(B, k);
      }, H.update = function(B, I) {
        return H.create(B).update(I);
      };
      for (var W = 0; W < C.length; ++W) {
        var U = C[W];
        H[U] = T(U, k);
      }
      return H;
    };
    function j(k, H) {
      H ? (N[0] = N[1] = N[2] = N[3] = N[4] = N[5] = N[6] = N[7] = N[8] = N[9] = N[10] = N[11] = N[12] = N[13] = N[14] = N[15] = N[16] = N[17] = N[18] = N[19] = N[20] = N[21] = N[22] = N[23] = N[24] = N[25] = N[26] = N[27] = N[28] = N[29] = N[30] = N[31] = N[32] = 0, this.blocks = N) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], k == 384 ? (this.h0h = 3418070365, this.h0l = 3238371032, this.h1h = 1654270250, this.h1l = 914150663, this.h2h = 2438529370, this.h2l = 812702999, this.h3h = 355462360, this.h3l = 4144912697, this.h4h = 1731405415, this.h4l = 4290775857, this.h5h = 2394180231, this.h5l = 1750603025, this.h6h = 3675008525, this.h6l = 1694076839, this.h7h = 1203062813, this.h7l = 3204075428) : k == 256 ? (this.h0h = 573645204, this.h0l = 4230739756, this.h1h = 2673172387, this.h1l = 3360449730, this.h2h = 596883563, this.h2l = 1867755857, this.h3h = 2520282905, this.h3l = 1497426621, this.h4h = 2519219938, this.h4l = 2827943907, this.h5h = 3193839141, this.h5l = 1401305490, this.h6h = 721525244, this.h6l = 746961066, this.h7h = 246885852, this.h7l = 2177182882) : k == 224 ? (this.h0h = 2352822216, this.h0l = 424955298, this.h1h = 1944164710, this.h1l = 2312950998, this.h2h = 502970286, this.h2l = 855612546, this.h3h = 1738396948, this.h3l = 1479516111, this.h4h = 258812777, this.h4l = 2077511080, this.h5h = 2011393907, this.h5l = 79989058, this.h6h = 1067287976, this.h6l = 1780299464, this.h7h = 286451373, this.h7l = 2446758561) : (this.h0h = 1779033703, this.h0l = 4089235720, this.h1h = 3144134277, this.h1l = 2227873595, this.h2h = 1013904242, this.h2l = 4271175723, this.h3h = 2773480762, this.h3l = 1595750129, this.h4h = 1359893119, this.h4l = 2917565137, this.h5h = 2600822924, this.h5l = 725511199, this.h6h = 528734635, this.h6l = 4215389547, this.h7h = 1541459225, this.h7l = 327033209), this.bits = k, this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1;
    }
    j.prototype.update = function(k) {
      if (this.finalized)
        throw new Error(o);
      var H, W = typeof k;
      if (W !== "string") {
        if (W === "object") {
          if (k === null)
            throw new Error(t);
          if (p && k.constructor === ArrayBuffer)
            k = new Uint8Array(k);
          else if (!Array.isArray(k) && (!p || !ArrayBuffer.isView(k)))
            throw new Error(t);
        } else
          throw new Error(t);
        H = !0;
      }
      for (var U, B = 0, I, r = k.length, s = this.blocks; B < r; ) {
        if (this.hashed && (this.hashed = !1, s[0] = this.block, s[1] = s[2] = s[3] = s[4] = s[5] = s[6] = s[7] = s[8] = s[9] = s[10] = s[11] = s[12] = s[13] = s[14] = s[15] = s[16] = s[17] = s[18] = s[19] = s[20] = s[21] = s[22] = s[23] = s[24] = s[25] = s[26] = s[27] = s[28] = s[29] = s[30] = s[31] = s[32] = 0), H)
          for (I = this.start; B < r && I < 128; ++B)
            s[I >> 2] |= k[B] << y[I++ & 3];
        else
          for (I = this.start; B < r && I < 128; ++B)
            U = k.charCodeAt(B), U < 128 ? s[I >> 2] |= U << y[I++ & 3] : U < 2048 ? (s[I >> 2] |= (192 | U >> 6) << y[I++ & 3], s[I >> 2] |= (128 | U & 63) << y[I++ & 3]) : U < 55296 || U >= 57344 ? (s[I >> 2] |= (224 | U >> 12) << y[I++ & 3], s[I >> 2] |= (128 | U >> 6 & 63) << y[I++ & 3], s[I >> 2] |= (128 | U & 63) << y[I++ & 3]) : (U = 65536 + ((U & 1023) << 10 | k.charCodeAt(++B) & 1023), s[I >> 2] |= (240 | U >> 18) << y[I++ & 3], s[I >> 2] |= (128 | U >> 12 & 63) << y[I++ & 3], s[I >> 2] |= (128 | U >> 6 & 63) << y[I++ & 3], s[I >> 2] |= (128 | U & 63) << y[I++ & 3]);
        this.lastByteIndex = I, this.bytes += I - this.start, I >= 128 ? (this.block = s[32], this.start = I - 128, this.hash(), this.hashed = !0) : this.start = I;
      }
      return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
    }, j.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var k = this.blocks, H = this.lastByteIndex;
        k[32] = this.block, k[H >> 2] |= h[H & 3], this.block = k[32], H >= 112 && (this.hashed || this.hash(), k[0] = this.block, k[1] = k[2] = k[3] = k[4] = k[5] = k[6] = k[7] = k[8] = k[9] = k[10] = k[11] = k[12] = k[13] = k[14] = k[15] = k[16] = k[17] = k[18] = k[19] = k[20] = k[21] = k[22] = k[23] = k[24] = k[25] = k[26] = k[27] = k[28] = k[29] = k[30] = k[31] = k[32] = 0), k[30] = this.hBytes << 3 | this.bytes >>> 29, k[31] = this.bytes << 3, this.hash();
      }
    }, j.prototype.hash = function() {
      var k = this.h0h, H = this.h0l, W = this.h1h, U = this.h1l, B = this.h2h, I = this.h2l, r = this.h3h, s = this.h3l, u = this.h4h, g = this.h4l, v = this.h5h, A = this.h5l, L = this.h6h, m = this.h6l, a = this.h7h, x = this.h7l, V = this.blocks, G, Z, te, q, R, Q, $, F, P, _, X, le, ie, oe, pe, se, ce, me, de, ae, Le, ye, Me, at, Ne;
      for (G = 32; G < 160; G += 2)
        ae = V[G - 30], Le = V[G - 29], Z = (ae >>> 1 | Le << 31) ^ (ae >>> 8 | Le << 24) ^ ae >>> 7, te = (Le >>> 1 | ae << 31) ^ (Le >>> 8 | ae << 24) ^ (Le >>> 7 | ae << 25), ae = V[G - 4], Le = V[G - 3], q = (ae >>> 19 | Le << 13) ^ (Le >>> 29 | ae << 3) ^ ae >>> 6, R = (Le >>> 19 | ae << 13) ^ (ae >>> 29 | Le << 3) ^ (Le >>> 6 | ae << 26), ae = V[G - 32], Le = V[G - 31], ye = V[G - 14], Me = V[G - 13], Q = (Me & 65535) + (Le & 65535) + (te & 65535) + (R & 65535), $ = (Me >>> 16) + (Le >>> 16) + (te >>> 16) + (R >>> 16) + (Q >>> 16), F = (ye & 65535) + (ae & 65535) + (Z & 65535) + (q & 65535) + ($ >>> 16), P = (ye >>> 16) + (ae >>> 16) + (Z >>> 16) + (q >>> 16) + (F >>> 16), V[G] = P << 16 | F & 65535, V[G + 1] = $ << 16 | Q & 65535;
      var Ae = k, pt = H, ke = W, Te = U, Dt = B, De = I, je = r, At = s, xe = u, Ie = g, Nt = v, _e = A, Be = L, Xt = m, Re = a, Pe = x;
      for (se = ke & Dt, ce = Te & De, G = 0; G < 160; G += 8)
        Z = (Ae >>> 28 | pt << 4) ^ (pt >>> 2 | Ae << 30) ^ (pt >>> 7 | Ae << 25), te = (pt >>> 28 | Ae << 4) ^ (Ae >>> 2 | pt << 30) ^ (Ae >>> 7 | pt << 25), q = (xe >>> 14 | Ie << 18) ^ (xe >>> 18 | Ie << 14) ^ (Ie >>> 9 | xe << 23), R = (Ie >>> 14 | xe << 18) ^ (Ie >>> 18 | xe << 14) ^ (xe >>> 9 | Ie << 23), _ = Ae & ke, X = pt & Te, me = _ ^ Ae & Dt ^ se, de = X ^ pt & De ^ ce, at = xe & Nt ^ ~xe & Be, Ne = Ie & _e ^ ~Ie & Xt, ae = V[G], Le = V[G + 1], ye = M[G], Me = M[G + 1], Q = (Me & 65535) + (Le & 65535) + (Ne & 65535) + (R & 65535) + (Pe & 65535), $ = (Me >>> 16) + (Le >>> 16) + (Ne >>> 16) + (R >>> 16) + (Pe >>> 16) + (Q >>> 16), F = (ye & 65535) + (ae & 65535) + (at & 65535) + (q & 65535) + (Re & 65535) + ($ >>> 16), P = (ye >>> 16) + (ae >>> 16) + (at >>> 16) + (q >>> 16) + (Re >>> 16) + (F >>> 16), ae = P << 16 | F & 65535, Le = $ << 16 | Q & 65535, Q = (de & 65535) + (te & 65535), $ = (de >>> 16) + (te >>> 16) + (Q >>> 16), F = (me & 65535) + (Z & 65535) + ($ >>> 16), P = (me >>> 16) + (Z >>> 16) + (F >>> 16), ye = P << 16 | F & 65535, Me = $ << 16 | Q & 65535, Q = (At & 65535) + (Le & 65535), $ = (At >>> 16) + (Le >>> 16) + (Q >>> 16), F = (je & 65535) + (ae & 65535) + ($ >>> 16), P = (je >>> 16) + (ae >>> 16) + (F >>> 16), Re = P << 16 | F & 65535, Pe = $ << 16 | Q & 65535, Q = (Me & 65535) + (Le & 65535), $ = (Me >>> 16) + (Le >>> 16) + (Q >>> 16), F = (ye & 65535) + (ae & 65535) + ($ >>> 16), P = (ye >>> 16) + (ae >>> 16) + (F >>> 16), je = P << 16 | F & 65535, At = $ << 16 | Q & 65535, Z = (je >>> 28 | At << 4) ^ (At >>> 2 | je << 30) ^ (At >>> 7 | je << 25), te = (At >>> 28 | je << 4) ^ (je >>> 2 | At << 30) ^ (je >>> 7 | At << 25), q = (Re >>> 14 | Pe << 18) ^ (Re >>> 18 | Pe << 14) ^ (Pe >>> 9 | Re << 23), R = (Pe >>> 14 | Re << 18) ^ (Pe >>> 18 | Re << 14) ^ (Re >>> 9 | Pe << 23), le = je & Ae, ie = At & pt, me = le ^ je & ke ^ _, de = ie ^ At & Te ^ X, at = Re & xe ^ ~Re & Nt, Ne = Pe & Ie ^ ~Pe & _e, ae = V[G + 2], Le = V[G + 3], ye = M[G + 2], Me = M[G + 3], Q = (Me & 65535) + (Le & 65535) + (Ne & 65535) + (R & 65535) + (Xt & 65535), $ = (Me >>> 16) + (Le >>> 16) + (Ne >>> 16) + (R >>> 16) + (Xt >>> 16) + (Q >>> 16), F = (ye & 65535) + (ae & 65535) + (at & 65535) + (q & 65535) + (Be & 65535) + ($ >>> 16), P = (ye >>> 16) + (ae >>> 16) + (at >>> 16) + (q >>> 16) + (Be >>> 16) + (F >>> 16), ae = P << 16 | F & 65535, Le = $ << 16 | Q & 65535, Q = (de & 65535) + (te & 65535), $ = (de >>> 16) + (te >>> 16) + (Q >>> 16), F = (me & 65535) + (Z & 65535) + ($ >>> 16), P = (me >>> 16) + (Z >>> 16) + (F >>> 16), ye = P << 16 | F & 65535, Me = $ << 16 | Q & 65535, Q = (De & 65535) + (Le & 65535), $ = (De >>> 16) + (Le >>> 16) + (Q >>> 16), F = (Dt & 65535) + (ae & 65535) + ($ >>> 16), P = (Dt >>> 16) + (ae >>> 16) + (F >>> 16), Be = P << 16 | F & 65535, Xt = $ << 16 | Q & 65535, Q = (Me & 65535) + (Le & 65535), $ = (Me >>> 16) + (Le >>> 16) + (Q >>> 16), F = (ye & 65535) + (ae & 65535) + ($ >>> 16), P = (ye >>> 16) + (ae >>> 16) + (F >>> 16), Dt = P << 16 | F & 65535, De = $ << 16 | Q & 65535, Z = (Dt >>> 28 | De << 4) ^ (De >>> 2 | Dt << 30) ^ (De >>> 7 | Dt << 25), te = (De >>> 28 | Dt << 4) ^ (Dt >>> 2 | De << 30) ^ (Dt >>> 7 | De << 25), q = (Be >>> 14 | Xt << 18) ^ (Be >>> 18 | Xt << 14) ^ (Xt >>> 9 | Be << 23), R = (Xt >>> 14 | Be << 18) ^ (Xt >>> 18 | Be << 14) ^ (Be >>> 9 | Xt << 23), oe = Dt & je, pe = De & At, me = oe ^ Dt & Ae ^ le, de = pe ^ De & pt ^ ie, at = Be & Re ^ ~Be & xe, Ne = Xt & Pe ^ ~Xt & Ie, ae = V[G + 4], Le = V[G + 5], ye = M[G + 4], Me = M[G + 5], Q = (Me & 65535) + (Le & 65535) + (Ne & 65535) + (R & 65535) + (_e & 65535), $ = (Me >>> 16) + (Le >>> 16) + (Ne >>> 16) + (R >>> 16) + (_e >>> 16) + (Q >>> 16), F = (ye & 65535) + (ae & 65535) + (at & 65535) + (q & 65535) + (Nt & 65535) + ($ >>> 16), P = (ye >>> 16) + (ae >>> 16) + (at >>> 16) + (q >>> 16) + (Nt >>> 16) + (F >>> 16), ae = P << 16 | F & 65535, Le = $ << 16 | Q & 65535, Q = (de & 65535) + (te & 65535), $ = (de >>> 16) + (te >>> 16) + (Q >>> 16), F = (me & 65535) + (Z & 65535) + ($ >>> 16), P = (me >>> 16) + (Z >>> 16) + (F >>> 16), ye = P << 16 | F & 65535, Me = $ << 16 | Q & 65535, Q = (Te & 65535) + (Le & 65535), $ = (Te >>> 16) + (Le >>> 16) + (Q >>> 16), F = (ke & 65535) + (ae & 65535) + ($ >>> 16), P = (ke >>> 16) + (ae >>> 16) + (F >>> 16), Nt = P << 16 | F & 65535, _e = $ << 16 | Q & 65535, Q = (Me & 65535) + (Le & 65535), $ = (Me >>> 16) + (Le >>> 16) + (Q >>> 16), F = (ye & 65535) + (ae & 65535) + ($ >>> 16), P = (ye >>> 16) + (ae >>> 16) + (F >>> 16), ke = P << 16 | F & 65535, Te = $ << 16 | Q & 65535, Z = (ke >>> 28 | Te << 4) ^ (Te >>> 2 | ke << 30) ^ (Te >>> 7 | ke << 25), te = (Te >>> 28 | ke << 4) ^ (ke >>> 2 | Te << 30) ^ (ke >>> 7 | Te << 25), q = (Nt >>> 14 | _e << 18) ^ (Nt >>> 18 | _e << 14) ^ (_e >>> 9 | Nt << 23), R = (_e >>> 14 | Nt << 18) ^ (_e >>> 18 | Nt << 14) ^ (Nt >>> 9 | _e << 23), se = ke & Dt, ce = Te & De, me = se ^ ke & je ^ oe, de = ce ^ Te & At ^ pe, at = Nt & Be ^ ~Nt & Re, Ne = _e & Xt ^ ~_e & Pe, ae = V[G + 6], Le = V[G + 7], ye = M[G + 6], Me = M[G + 7], Q = (Me & 65535) + (Le & 65535) + (Ne & 65535) + (R & 65535) + (Ie & 65535), $ = (Me >>> 16) + (Le >>> 16) + (Ne >>> 16) + (R >>> 16) + (Ie >>> 16) + (Q >>> 16), F = (ye & 65535) + (ae & 65535) + (at & 65535) + (q & 65535) + (xe & 65535) + ($ >>> 16), P = (ye >>> 16) + (ae >>> 16) + (at >>> 16) + (q >>> 16) + (xe >>> 16) + (F >>> 16), ae = P << 16 | F & 65535, Le = $ << 16 | Q & 65535, Q = (de & 65535) + (te & 65535), $ = (de >>> 16) + (te >>> 16) + (Q >>> 16), F = (me & 65535) + (Z & 65535) + ($ >>> 16), P = (me >>> 16) + (Z >>> 16) + (F >>> 16), ye = P << 16 | F & 65535, Me = $ << 16 | Q & 65535, Q = (pt & 65535) + (Le & 65535), $ = (pt >>> 16) + (Le >>> 16) + (Q >>> 16), F = (Ae & 65535) + (ae & 65535) + ($ >>> 16), P = (Ae >>> 16) + (ae >>> 16) + (F >>> 16), xe = P << 16 | F & 65535, Ie = $ << 16 | Q & 65535, Q = (Me & 65535) + (Le & 65535), $ = (Me >>> 16) + (Le >>> 16) + (Q >>> 16), F = (ye & 65535) + (ae & 65535) + ($ >>> 16), P = (ye >>> 16) + (ae >>> 16) + (F >>> 16), Ae = P << 16 | F & 65535, pt = $ << 16 | Q & 65535;
      Q = (H & 65535) + (pt & 65535), $ = (H >>> 16) + (pt >>> 16) + (Q >>> 16), F = (k & 65535) + (Ae & 65535) + ($ >>> 16), P = (k >>> 16) + (Ae >>> 16) + (F >>> 16), this.h0h = P << 16 | F & 65535, this.h0l = $ << 16 | Q & 65535, Q = (U & 65535) + (Te & 65535), $ = (U >>> 16) + (Te >>> 16) + (Q >>> 16), F = (W & 65535) + (ke & 65535) + ($ >>> 16), P = (W >>> 16) + (ke >>> 16) + (F >>> 16), this.h1h = P << 16 | F & 65535, this.h1l = $ << 16 | Q & 65535, Q = (I & 65535) + (De & 65535), $ = (I >>> 16) + (De >>> 16) + (Q >>> 16), F = (B & 65535) + (Dt & 65535) + ($ >>> 16), P = (B >>> 16) + (Dt >>> 16) + (F >>> 16), this.h2h = P << 16 | F & 65535, this.h2l = $ << 16 | Q & 65535, Q = (s & 65535) + (At & 65535), $ = (s >>> 16) + (At >>> 16) + (Q >>> 16), F = (r & 65535) + (je & 65535) + ($ >>> 16), P = (r >>> 16) + (je >>> 16) + (F >>> 16), this.h3h = P << 16 | F & 65535, this.h3l = $ << 16 | Q & 65535, Q = (g & 65535) + (Ie & 65535), $ = (g >>> 16) + (Ie >>> 16) + (Q >>> 16), F = (u & 65535) + (xe & 65535) + ($ >>> 16), P = (u >>> 16) + (xe >>> 16) + (F >>> 16), this.h4h = P << 16 | F & 65535, this.h4l = $ << 16 | Q & 65535, Q = (A & 65535) + (_e & 65535), $ = (A >>> 16) + (_e >>> 16) + (Q >>> 16), F = (v & 65535) + (Nt & 65535) + ($ >>> 16), P = (v >>> 16) + (Nt >>> 16) + (F >>> 16), this.h5h = P << 16 | F & 65535, this.h5l = $ << 16 | Q & 65535, Q = (m & 65535) + (Xt & 65535), $ = (m >>> 16) + (Xt >>> 16) + (Q >>> 16), F = (L & 65535) + (Be & 65535) + ($ >>> 16), P = (L >>> 16) + (Be >>> 16) + (F >>> 16), this.h6h = P << 16 | F & 65535, this.h6l = $ << 16 | Q & 65535, Q = (x & 65535) + (Pe & 65535), $ = (x >>> 16) + (Pe >>> 16) + (Q >>> 16), F = (a & 65535) + (Re & 65535) + ($ >>> 16), P = (a >>> 16) + (Re >>> 16) + (F >>> 16), this.h7h = P << 16 | F & 65535, this.h7l = $ << 16 | Q & 65535;
    }, j.prototype.hex = function() {
      this.finalize();
      var k = this.h0h, H = this.h0l, W = this.h1h, U = this.h1l, B = this.h2h, I = this.h2l, r = this.h3h, s = this.h3l, u = this.h4h, g = this.h4l, v = this.h5h, A = this.h5l, L = this.h6h, m = this.h6l, a = this.h7h, x = this.h7l, V = this.bits, G = l[k >> 28 & 15] + l[k >> 24 & 15] + l[k >> 20 & 15] + l[k >> 16 & 15] + l[k >> 12 & 15] + l[k >> 8 & 15] + l[k >> 4 & 15] + l[k & 15] + l[H >> 28 & 15] + l[H >> 24 & 15] + l[H >> 20 & 15] + l[H >> 16 & 15] + l[H >> 12 & 15] + l[H >> 8 & 15] + l[H >> 4 & 15] + l[H & 15] + l[W >> 28 & 15] + l[W >> 24 & 15] + l[W >> 20 & 15] + l[W >> 16 & 15] + l[W >> 12 & 15] + l[W >> 8 & 15] + l[W >> 4 & 15] + l[W & 15] + l[U >> 28 & 15] + l[U >> 24 & 15] + l[U >> 20 & 15] + l[U >> 16 & 15] + l[U >> 12 & 15] + l[U >> 8 & 15] + l[U >> 4 & 15] + l[U & 15] + l[B >> 28 & 15] + l[B >> 24 & 15] + l[B >> 20 & 15] + l[B >> 16 & 15] + l[B >> 12 & 15] + l[B >> 8 & 15] + l[B >> 4 & 15] + l[B & 15] + l[I >> 28 & 15] + l[I >> 24 & 15] + l[I >> 20 & 15] + l[I >> 16 & 15] + l[I >> 12 & 15] + l[I >> 8 & 15] + l[I >> 4 & 15] + l[I & 15] + l[r >> 28 & 15] + l[r >> 24 & 15] + l[r >> 20 & 15] + l[r >> 16 & 15] + l[r >> 12 & 15] + l[r >> 8 & 15] + l[r >> 4 & 15] + l[r & 15];
      return V >= 256 && (G += l[s >> 28 & 15] + l[s >> 24 & 15] + l[s >> 20 & 15] + l[s >> 16 & 15] + l[s >> 12 & 15] + l[s >> 8 & 15] + l[s >> 4 & 15] + l[s & 15]), V >= 384 && (G += l[u >> 28 & 15] + l[u >> 24 & 15] + l[u >> 20 & 15] + l[u >> 16 & 15] + l[u >> 12 & 15] + l[u >> 8 & 15] + l[u >> 4 & 15] + l[u & 15] + l[g >> 28 & 15] + l[g >> 24 & 15] + l[g >> 20 & 15] + l[g >> 16 & 15] + l[g >> 12 & 15] + l[g >> 8 & 15] + l[g >> 4 & 15] + l[g & 15] + l[v >> 28 & 15] + l[v >> 24 & 15] + l[v >> 20 & 15] + l[v >> 16 & 15] + l[v >> 12 & 15] + l[v >> 8 & 15] + l[v >> 4 & 15] + l[v & 15] + l[A >> 28 & 15] + l[A >> 24 & 15] + l[A >> 20 & 15] + l[A >> 16 & 15] + l[A >> 12 & 15] + l[A >> 8 & 15] + l[A >> 4 & 15] + l[A & 15]), V == 512 && (G += l[L >> 28 & 15] + l[L >> 24 & 15] + l[L >> 20 & 15] + l[L >> 16 & 15] + l[L >> 12 & 15] + l[L >> 8 & 15] + l[L >> 4 & 15] + l[L & 15] + l[m >> 28 & 15] + l[m >> 24 & 15] + l[m >> 20 & 15] + l[m >> 16 & 15] + l[m >> 12 & 15] + l[m >> 8 & 15] + l[m >> 4 & 15] + l[m & 15] + l[a >> 28 & 15] + l[a >> 24 & 15] + l[a >> 20 & 15] + l[a >> 16 & 15] + l[a >> 12 & 15] + l[a >> 8 & 15] + l[a >> 4 & 15] + l[a & 15] + l[x >> 28 & 15] + l[x >> 24 & 15] + l[x >> 20 & 15] + l[x >> 16 & 15] + l[x >> 12 & 15] + l[x >> 8 & 15] + l[x >> 4 & 15] + l[x & 15]), G;
    }, j.prototype.toString = j.prototype.hex, j.prototype.digest = function() {
      this.finalize();
      var k = this.h0h, H = this.h0l, W = this.h1h, U = this.h1l, B = this.h2h, I = this.h2l, r = this.h3h, s = this.h3l, u = this.h4h, g = this.h4l, v = this.h5h, A = this.h5l, L = this.h6h, m = this.h6l, a = this.h7h, x = this.h7l, V = this.bits, G = [
        k >> 24 & 255,
        k >> 16 & 255,
        k >> 8 & 255,
        k & 255,
        H >> 24 & 255,
        H >> 16 & 255,
        H >> 8 & 255,
        H & 255,
        W >> 24 & 255,
        W >> 16 & 255,
        W >> 8 & 255,
        W & 255,
        U >> 24 & 255,
        U >> 16 & 255,
        U >> 8 & 255,
        U & 255,
        B >> 24 & 255,
        B >> 16 & 255,
        B >> 8 & 255,
        B & 255,
        I >> 24 & 255,
        I >> 16 & 255,
        I >> 8 & 255,
        I & 255,
        r >> 24 & 255,
        r >> 16 & 255,
        r >> 8 & 255,
        r & 255
      ];
      return V >= 256 && G.push(s >> 24 & 255, s >> 16 & 255, s >> 8 & 255, s & 255), V >= 384 && G.push(
        u >> 24 & 255,
        u >> 16 & 255,
        u >> 8 & 255,
        u & 255,
        g >> 24 & 255,
        g >> 16 & 255,
        g >> 8 & 255,
        g & 255,
        v >> 24 & 255,
        v >> 16 & 255,
        v >> 8 & 255,
        v & 255,
        A >> 24 & 255,
        A >> 16 & 255,
        A >> 8 & 255,
        A & 255
      ), V == 512 && G.push(
        L >> 24 & 255,
        L >> 16 & 255,
        L >> 8 & 255,
        L & 255,
        m >> 24 & 255,
        m >> 16 & 255,
        m >> 8 & 255,
        m & 255,
        a >> 24 & 255,
        a >> 16 & 255,
        a >> 8 & 255,
        a & 255,
        x >> 24 & 255,
        x >> 16 & 255,
        x >> 8 & 255,
        x & 255
      ), G;
    }, j.prototype.array = j.prototype.digest, j.prototype.arrayBuffer = function() {
      this.finalize();
      var k = this.bits, H = new ArrayBuffer(k / 8), W = new DataView(H);
      return W.setUint32(0, this.h0h), W.setUint32(4, this.h0l), W.setUint32(8, this.h1h), W.setUint32(12, this.h1l), W.setUint32(16, this.h2h), W.setUint32(20, this.h2l), W.setUint32(24, this.h3h), k >= 256 && W.setUint32(28, this.h3l), k >= 384 && (W.setUint32(32, this.h4h), W.setUint32(36, this.h4l), W.setUint32(40, this.h5h), W.setUint32(44, this.h5l)), k == 512 && (W.setUint32(48, this.h6h), W.setUint32(52, this.h6l), W.setUint32(56, this.h7h), W.setUint32(60, this.h7l)), H;
    }, j.prototype.clone = function() {
      var k = new j(this.bits, !1);
      return this.copyTo(k), k;
    }, j.prototype.copyTo = function(k) {
      var H = 0, W = [
        "h0h",
        "h0l",
        "h1h",
        "h1l",
        "h2h",
        "h2l",
        "h3h",
        "h3l",
        "h4h",
        "h4l",
        "h5h",
        "h5l",
        "h6h",
        "h6l",
        "h7h",
        "h7l",
        "start",
        "bytes",
        "hBytes",
        "finalized",
        "hashed",
        "lastByteIndex"
      ];
      for (H = 0; H < W.length; ++H)
        k[W[H]] = this[W[H]];
      for (H = 0; H < this.blocks.length; ++H)
        k.blocks[H] = this.blocks[H];
    };
    function O(k, H, W) {
      var U, B = typeof k;
      if (B !== "string") {
        if (B === "object") {
          if (k === null)
            throw new Error(t);
          if (p && k.constructor === ArrayBuffer)
            k = new Uint8Array(k);
          else if (!Array.isArray(k) && (!p || !ArrayBuffer.isView(k)))
            throw new Error(t);
        } else
          throw new Error(t);
        U = !0;
      }
      var I = k.length;
      if (!U) {
        for (var r = [], I = k.length, s = 0, u, g = 0; g < I; ++g)
          u = k.charCodeAt(g), u < 128 ? r[s++] = u : u < 2048 ? (r[s++] = 192 | u >> 6, r[s++] = 128 | u & 63) : u < 55296 || u >= 57344 ? (r[s++] = 224 | u >> 12, r[s++] = 128 | u >> 6 & 63, r[s++] = 128 | u & 63) : (u = 65536 + ((u & 1023) << 10 | k.charCodeAt(++g) & 1023), r[s++] = 240 | u >> 18, r[s++] = 128 | u >> 12 & 63, r[s++] = 128 | u >> 6 & 63, r[s++] = 128 | u & 63);
        k = r;
      }
      k.length > 128 && (k = new j(H, !0).update(k).array());
      for (var v = [], A = [], g = 0; g < 128; ++g) {
        var L = k[g] || 0;
        v[g] = 92 ^ L, A[g] = 54 ^ L;
      }
      j.call(this, H, W), this.update(A), this.oKeyPad = v, this.inner = !0, this.sharedMemory = W;
    }
    O.prototype = new j(), O.prototype.finalize = function() {
      if (j.prototype.finalize.call(this), this.inner) {
        this.inner = !1;
        var k = this.array();
        j.call(this, this.bits, this.sharedMemory), this.update(this.oKeyPad), this.update(k), j.prototype.finalize.call(this);
      }
    }, O.prototype.clone = function() {
      var k = new O([], this.bits, !1);
      this.copyTo(k), k.inner = this.inner;
      for (var H = 0; H < this.oKeyPad.length; ++H)
        k.oKeyPad[H] = this.oKeyPad[H];
      return k;
    };
    var z = S(512);
    z.sha512 = z, z.sha384 = S(384), z.sha512_256 = S(256), z.sha512_224 = S(224), z.sha512.hmac = E(512), z.sha384.hmac = E(384), z.sha512_256.hmac = E(256), z.sha512_224.hmac = E(224), f ? e.exports = z : (c.sha512 = z.sha512, c.sha384 = z.sha384, c.sha512_256 = z.sha512_256, c.sha512_224 = z.sha512_224);
  })();
})(_M);
var yT = _M.exports;
const MT = /* @__PURE__ */ Yi(yT);
var Jc = { exports: {} }, BM = { exports: {} }, FM = { exports: {} };
(function(e) {
  (function(t) {
    var o, i = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, c = Math.ceil, n = Math.floor, d = "[BigNumber Error] ", f = d + "Number primitive has more than 15 significant digits: ", p = 1e14, l = 14, h = 9007199254740991, y = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], M = 1e7, C = 1e9;
    function N(k) {
      var H, W, U, B = Z.prototype = { constructor: Z, toString: null, valueOf: null }, I = new Z(1), r = 20, s = 4, u = -7, g = 21, v = -1e7, A = 1e7, L = !1, m = 1, a = 0, x = {
        prefix: "",
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ",",
        decimalSeparator: ".",
        fractionGroupSize: 0,
        fractionGroupSeparator: " ",
        // non-breaking space
        suffix: ""
      }, V = "0123456789abcdefghijklmnopqrstuvwxyz", G = !0;
      function Z(F, P) {
        var _, X, le, ie, oe, pe, se, ce, me = this;
        if (!(me instanceof Z)) return new Z(F, P);
        if (P == null) {
          if (F && F._isBigNumber === !0) {
            me.s = F.s, !F.c || F.e > A ? me.c = me.e = null : F.e < v ? me.c = [me.e = 0] : (me.e = F.e, me.c = F.c.slice());
            return;
          }
          if ((pe = typeof F == "number") && F * 0 == 0) {
            if (me.s = 1 / F < 0 ? (F = -F, -1) : 1, F === ~~F) {
              for (ie = 0, oe = F; oe >= 10; oe /= 10, ie++) ;
              ie > A ? me.c = me.e = null : (me.e = ie, me.c = [F]);
              return;
            }
            ce = String(F);
          } else {
            if (!i.test(ce = String(F))) return U(me, ce, pe);
            me.s = ce.charCodeAt(0) == 45 ? (ce = ce.slice(1), -1) : 1;
          }
          (ie = ce.indexOf(".")) > -1 && (ce = ce.replace(".", "")), (oe = ce.search(/e/i)) > 0 ? (ie < 0 && (ie = oe), ie += +ce.slice(oe + 1), ce = ce.substring(0, oe)) : ie < 0 && (ie = ce.length);
        } else {
          if (E(P, 2, V.length, "Base"), P == 10 && G)
            return me = new Z(F), Q(me, r + me.e + 1, s);
          if (ce = String(F), pe = typeof F == "number") {
            if (F * 0 != 0) return U(me, ce, pe, P);
            if (me.s = 1 / F < 0 ? (ce = ce.slice(1), -1) : 1, Z.DEBUG && ce.replace(/^0\.0*|\./, "").length > 15)
              throw Error(f + F);
          } else
            me.s = ce.charCodeAt(0) === 45 ? (ce = ce.slice(1), -1) : 1;
          for (_ = V.slice(0, P), ie = oe = 0, se = ce.length; oe < se; oe++)
            if (_.indexOf(X = ce.charAt(oe)) < 0) {
              if (X == ".") {
                if (oe > ie) {
                  ie = se;
                  continue;
                }
              } else if (!le && (ce == ce.toUpperCase() && (ce = ce.toLowerCase()) || ce == ce.toLowerCase() && (ce = ce.toUpperCase()))) {
                le = !0, oe = -1, ie = 0;
                continue;
              }
              return U(me, String(F), pe, P);
            }
          pe = !1, ce = W(ce, P, 10, me.s), (ie = ce.indexOf(".")) > -1 ? ce = ce.replace(".", "") : ie = ce.length;
        }
        for (oe = 0; ce.charCodeAt(oe) === 48; oe++) ;
        for (se = ce.length; ce.charCodeAt(--se) === 48; ) ;
        if (ce = ce.slice(oe, ++se)) {
          if (se -= oe, pe && Z.DEBUG && se > 15 && (F > h || F !== n(F)))
            throw Error(f + me.s * F);
          if ((ie = ie - oe - 1) > A)
            me.c = me.e = null;
          else if (ie < v)
            me.c = [me.e = 0];
          else {
            if (me.e = ie, me.c = [], oe = (ie + 1) % l, ie < 0 && (oe += l), oe < se) {
              for (oe && me.c.push(+ce.slice(0, oe)), se -= l; oe < se; )
                me.c.push(+ce.slice(oe, oe += l));
              oe = l - (ce = ce.slice(oe)).length;
            } else
              oe -= se;
            for (; oe--; ce += "0") ;
            me.c.push(+ce);
          }
        } else
          me.c = [me.e = 0];
      }
      Z.clone = N, Z.ROUND_UP = 0, Z.ROUND_DOWN = 1, Z.ROUND_CEIL = 2, Z.ROUND_FLOOR = 3, Z.ROUND_HALF_UP = 4, Z.ROUND_HALF_DOWN = 5, Z.ROUND_HALF_EVEN = 6, Z.ROUND_HALF_CEIL = 7, Z.ROUND_HALF_FLOOR = 8, Z.EUCLID = 9, Z.config = Z.set = function(F) {
        var P, _;
        if (F != null)
          if (typeof F == "object") {
            if (F.hasOwnProperty(P = "DECIMAL_PLACES") && (_ = F[P], E(_, 0, C, P), r = _), F.hasOwnProperty(P = "ROUNDING_MODE") && (_ = F[P], E(_, 0, 8, P), s = _), F.hasOwnProperty(P = "EXPONENTIAL_AT") && (_ = F[P], _ && _.pop ? (E(_[0], -C, 0, P), E(_[1], 0, C, P), u = _[0], g = _[1]) : (E(_, -C, C, P), u = -(g = _ < 0 ? -_ : _))), F.hasOwnProperty(P = "RANGE"))
              if (_ = F[P], _ && _.pop)
                E(_[0], -C, -1, P), E(_[1], 1, C, P), v = _[0], A = _[1];
              else if (E(_, -C, C, P), _)
                v = -(A = _ < 0 ? -_ : _);
              else
                throw Error(d + P + " cannot be zero: " + _);
            if (F.hasOwnProperty(P = "CRYPTO"))
              if (_ = F[P], _ === !!_)
                if (_)
                  if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                    L = _;
                  else
                    throw L = !_, Error(d + "crypto unavailable");
                else
                  L = _;
              else
                throw Error(d + P + " not true or false: " + _);
            if (F.hasOwnProperty(P = "MODULO_MODE") && (_ = F[P], E(_, 0, 9, P), m = _), F.hasOwnProperty(P = "POW_PRECISION") && (_ = F[P], E(_, 0, C, P), a = _), F.hasOwnProperty(P = "FORMAT"))
              if (_ = F[P], typeof _ == "object") x = _;
              else throw Error(d + P + " not an object: " + _);
            if (F.hasOwnProperty(P = "ALPHABET"))
              if (_ = F[P], typeof _ == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(_))
                G = _.slice(0, 10) == "0123456789", V = _;
              else
                throw Error(d + P + " invalid: " + _);
          } else
            throw Error(d + "Object expected: " + F);
        return {
          DECIMAL_PLACES: r,
          ROUNDING_MODE: s,
          EXPONENTIAL_AT: [u, g],
          RANGE: [v, A],
          CRYPTO: L,
          MODULO_MODE: m,
          POW_PRECISION: a,
          FORMAT: x,
          ALPHABET: V
        };
      }, Z.isBigNumber = function(F) {
        if (!F || F._isBigNumber !== !0) return !1;
        if (!Z.DEBUG) return !0;
        var P, _, X = F.c, le = F.e, ie = F.s;
        e: if ({}.toString.call(X) == "[object Array]") {
          if ((ie === 1 || ie === -1) && le >= -C && le <= C && le === n(le)) {
            if (X[0] === 0) {
              if (le === 0 && X.length === 1) return !0;
              break e;
            }
            if (P = (le + 1) % l, P < 1 && (P += l), String(X[0]).length == P) {
              for (P = 0; P < X.length; P++)
                if (_ = X[P], _ < 0 || _ >= p || _ !== n(_)) break e;
              if (_ !== 0) return !0;
            }
          }
        } else if (X === null && le === null && (ie === null || ie === 1 || ie === -1))
          return !0;
        throw Error(d + "Invalid BigNumber: " + F);
      }, Z.maximum = Z.max = function() {
        return q(arguments, -1);
      }, Z.minimum = Z.min = function() {
        return q(arguments, 1);
      }, Z.random = function() {
        var F = 9007199254740992, P = Math.random() * F & 2097151 ? function() {
          return n(Math.random() * F);
        } : function() {
          return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
        };
        return function(_) {
          var X, le, ie, oe, pe, se = 0, ce = [], me = new Z(I);
          if (_ == null ? _ = r : E(_, 0, C), oe = c(_ / l), L)
            if (crypto.getRandomValues) {
              for (X = crypto.getRandomValues(new Uint32Array(oe *= 2)); se < oe; )
                pe = X[se] * 131072 + (X[se + 1] >>> 11), pe >= 9e15 ? (le = crypto.getRandomValues(new Uint32Array(2)), X[se] = le[0], X[se + 1] = le[1]) : (ce.push(pe % 1e14), se += 2);
              se = oe / 2;
            } else if (crypto.randomBytes) {
              for (X = crypto.randomBytes(oe *= 7); se < oe; )
                pe = (X[se] & 31) * 281474976710656 + X[se + 1] * 1099511627776 + X[se + 2] * 4294967296 + X[se + 3] * 16777216 + (X[se + 4] << 16) + (X[se + 5] << 8) + X[se + 6], pe >= 9e15 ? crypto.randomBytes(7).copy(X, se) : (ce.push(pe % 1e14), se += 7);
              se = oe / 7;
            } else
              throw L = !1, Error(d + "crypto unavailable");
          if (!L)
            for (; se < oe; )
              pe = P(), pe < 9e15 && (ce[se++] = pe % 1e14);
          for (oe = ce[--se], _ %= l, oe && _ && (pe = y[l - _], ce[se] = n(oe / pe) * pe); ce[se] === 0; ce.pop(), se--) ;
          if (se < 0)
            ce = [ie = 0];
          else {
            for (ie = -1; ce[0] === 0; ce.splice(0, 1), ie -= l) ;
            for (se = 1, pe = ce[0]; pe >= 10; pe /= 10, se++) ;
            se < l && (ie -= l - se);
          }
          return me.e = ie, me.c = ce, me;
        };
      }(), Z.sum = function() {
        for (var F = 1, P = arguments, _ = new Z(P[0]); F < P.length; ) _ = _.plus(P[F++]);
        return _;
      }, W = /* @__PURE__ */ function() {
        var F = "0123456789";
        function P(_, X, le, ie) {
          for (var oe, pe = [0], se, ce = 0, me = _.length; ce < me; ) {
            for (se = pe.length; se--; pe[se] *= X) ;
            for (pe[0] += ie.indexOf(_.charAt(ce++)), oe = 0; oe < pe.length; oe++)
              pe[oe] > le - 1 && (pe[oe + 1] == null && (pe[oe + 1] = 0), pe[oe + 1] += pe[oe] / le | 0, pe[oe] %= le);
          }
          return pe.reverse();
        }
        return function(_, X, le, ie, oe) {
          var pe, se, ce, me, de, ae, Le, ye, Me = _.indexOf("."), at = r, Ne = s;
          for (Me >= 0 && (me = a, a = 0, _ = _.replace(".", ""), ye = new Z(X), ae = ye.pow(_.length - Me), a = me, ye.c = P(
            z(S(ae.c), ae.e, "0"),
            10,
            le,
            F
          ), ye.e = ye.c.length), Le = P(_, X, le, oe ? (pe = V, F) : (pe = F, V)), ce = me = Le.length; Le[--me] == 0; Le.pop()) ;
          if (!Le[0]) return pe.charAt(0);
          if (Me < 0 ? --ce : (ae.c = Le, ae.e = ce, ae.s = ie, ae = H(ae, ye, at, Ne, le), Le = ae.c, de = ae.r, ce = ae.e), se = ce + at + 1, Me = Le[se], me = le / 2, de = de || se < 0 || Le[se + 1] != null, de = Ne < 4 ? (Me != null || de) && (Ne == 0 || Ne == (ae.s < 0 ? 3 : 2)) : Me > me || Me == me && (Ne == 4 || de || Ne == 6 && Le[se - 1] & 1 || Ne == (ae.s < 0 ? 8 : 7)), se < 1 || !Le[0])
            _ = de ? z(pe.charAt(1), -at, pe.charAt(0)) : pe.charAt(0);
          else {
            if (Le.length = se, de)
              for (--le; ++Le[--se] > le; )
                Le[se] = 0, se || (++ce, Le = [1].concat(Le));
            for (me = Le.length; !Le[--me]; ) ;
            for (Me = 0, _ = ""; Me <= me; _ += pe.charAt(Le[Me++])) ;
            _ = z(_, ce, pe.charAt(0));
          }
          return _;
        };
      }(), H = /* @__PURE__ */ function() {
        function F(X, le, ie) {
          var oe, pe, se, ce, me = 0, de = X.length, ae = le % M, Le = le / M | 0;
          for (X = X.slice(); de--; )
            se = X[de] % M, ce = X[de] / M | 0, oe = Le * se + ce * ae, pe = ae * se + oe % M * M + me, me = (pe / ie | 0) + (oe / M | 0) + Le * ce, X[de] = pe % ie;
          return me && (X = [me].concat(X)), X;
        }
        function P(X, le, ie, oe) {
          var pe, se;
          if (ie != oe)
            se = ie > oe ? 1 : -1;
          else
            for (pe = se = 0; pe < ie; pe++)
              if (X[pe] != le[pe]) {
                se = X[pe] > le[pe] ? 1 : -1;
                break;
              }
          return se;
        }
        function _(X, le, ie, oe) {
          for (var pe = 0; ie--; )
            X[ie] -= pe, pe = X[ie] < le[ie] ? 1 : 0, X[ie] = pe * oe + X[ie] - le[ie];
          for (; !X[0] && X.length > 1; X.splice(0, 1)) ;
        }
        return function(X, le, ie, oe, pe) {
          var se, ce, me, de, ae, Le, ye, Me, at, Ne, Ae, pt, ke, Te, Dt, De, je, At = X.s == le.s ? 1 : -1, xe = X.c, Ie = le.c;
          if (!xe || !xe[0] || !Ie || !Ie[0])
            return new Z(
              // Return NaN if either NaN, or both Infinity or 0.
              !X.s || !le.s || (xe ? Ie && xe[0] == Ie[0] : !Ie) ? NaN : (
                // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xe && xe[0] == 0 || !Ie ? At * 0 : At / 0
              )
            );
          for (Me = new Z(At), at = Me.c = [], ce = X.e - le.e, At = ie + ce + 1, pe || (pe = p, ce = w(X.e / l) - w(le.e / l), At = At / l | 0), me = 0; Ie[me] == (xe[me] || 0); me++) ;
          if (Ie[me] > (xe[me] || 0) && ce--, At < 0)
            at.push(1), de = !0;
          else {
            for (Te = xe.length, De = Ie.length, me = 0, At += 2, ae = n(pe / (Ie[0] + 1)), ae > 1 && (Ie = F(Ie, ae, pe), xe = F(xe, ae, pe), De = Ie.length, Te = xe.length), ke = De, Ne = xe.slice(0, De), Ae = Ne.length; Ae < De; Ne[Ae++] = 0) ;
            je = Ie.slice(), je = [0].concat(je), Dt = Ie[0], Ie[1] >= pe / 2 && Dt++;
            do {
              if (ae = 0, se = P(Ie, Ne, De, Ae), se < 0) {
                if (pt = Ne[0], De != Ae && (pt = pt * pe + (Ne[1] || 0)), ae = n(pt / Dt), ae > 1)
                  for (ae >= pe && (ae = pe - 1), Le = F(Ie, ae, pe), ye = Le.length, Ae = Ne.length; P(Le, Ne, ye, Ae) == 1; )
                    ae--, _(Le, De < ye ? je : Ie, ye, pe), ye = Le.length, se = 1;
                else
                  ae == 0 && (se = ae = 1), Le = Ie.slice(), ye = Le.length;
                if (ye < Ae && (Le = [0].concat(Le)), _(Ne, Le, Ae, pe), Ae = Ne.length, se == -1)
                  for (; P(Ie, Ne, De, Ae) < 1; )
                    ae++, _(Ne, De < Ae ? je : Ie, Ae, pe), Ae = Ne.length;
              } else se === 0 && (ae++, Ne = [0]);
              at[me++] = ae, Ne[0] ? Ne[Ae++] = xe[ke] || 0 : (Ne = [xe[ke]], Ae = 1);
            } while ((ke++ < Te || Ne[0] != null) && At--);
            de = Ne[0] != null, at[0] || at.splice(0, 1);
          }
          if (pe == p) {
            for (me = 1, At = at[0]; At >= 10; At /= 10, me++) ;
            Q(Me, ie + (Me.e = me + ce * l - 1) + 1, oe, de);
          } else
            Me.e = ce, Me.r = +de;
          return Me;
        };
      }();
      function te(F, P, _, X) {
        var le, ie, oe, pe, se;
        if (_ == null ? _ = s : E(_, 0, 8), !F.c) return F.toString();
        if (le = F.c[0], oe = F.e, P == null)
          se = S(F.c), se = X == 1 || X == 2 && (oe <= u || oe >= g) ? O(se, oe) : z(se, oe, "0");
        else if (F = Q(new Z(F), P, _), ie = F.e, se = S(F.c), pe = se.length, X == 1 || X == 2 && (P <= ie || ie <= u)) {
          for (; pe < P; se += "0", pe++) ;
          se = O(se, ie);
        } else if (P -= oe + (X === 2 && ie > oe), se = z(se, ie, "0"), ie + 1 > pe) {
          if (--P > 0) for (se += "."; P--; se += "0") ;
        } else if (P += ie - pe, P > 0)
          for (ie + 1 == pe && (se += "."); P--; se += "0") ;
        return F.s < 0 && le ? "-" + se : se;
      }
      function q(F, P) {
        for (var _, X, le = 1, ie = new Z(F[0]); le < F.length; le++)
          X = new Z(F[le]), (!X.s || (_ = T(ie, X)) === P || _ === 0 && ie.s === P) && (ie = X);
        return ie;
      }
      function R(F, P, _) {
        for (var X = 1, le = P.length; !P[--le]; P.pop()) ;
        for (le = P[0]; le >= 10; le /= 10, X++) ;
        return (_ = X + _ * l - 1) > A ? F.c = F.e = null : _ < v ? F.c = [F.e = 0] : (F.e = _, F.c = P), F;
      }
      U = /* @__PURE__ */ function() {
        var F = /^(-?)0([xbo])(?=\w[\w.]*$)/i, P = /^([^.]+)\.$/, _ = /^\.([^.]+)$/, X = /^-?(Infinity|NaN)$/, le = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
        return function(ie, oe, pe, se) {
          var ce, me = pe ? oe : oe.replace(le, "");
          if (X.test(me))
            ie.s = isNaN(me) ? null : me < 0 ? -1 : 1;
          else {
            if (!pe && (me = me.replace(F, function(de, ae, Le) {
              return ce = (Le = Le.toLowerCase()) == "x" ? 16 : Le == "b" ? 2 : 8, !se || se == ce ? ae : de;
            }), se && (ce = se, me = me.replace(P, "$1").replace(_, "0.$1")), oe != me))
              return new Z(me, ce);
            if (Z.DEBUG)
              throw Error(d + "Not a" + (se ? " base " + se : "") + " number: " + oe);
            ie.s = null;
          }
          ie.c = ie.e = null;
        };
      }();
      function Q(F, P, _, X) {
        var le, ie, oe, pe, se, ce, me, de = F.c, ae = y;
        if (de) {
          e: {
            for (le = 1, pe = de[0]; pe >= 10; pe /= 10, le++) ;
            if (ie = P - le, ie < 0)
              ie += l, oe = P, se = de[ce = 0], me = n(se / ae[le - oe - 1] % 10);
            else if (ce = c((ie + 1) / l), ce >= de.length)
              if (X) {
                for (; de.length <= ce; de.push(0)) ;
                se = me = 0, le = 1, ie %= l, oe = ie - l + 1;
              } else
                break e;
            else {
              for (se = pe = de[ce], le = 1; pe >= 10; pe /= 10, le++) ;
              ie %= l, oe = ie - l + le, me = oe < 0 ? 0 : n(se / ae[le - oe - 1] % 10);
            }
            if (X = X || P < 0 || // Are there any non-zero digits after the rounding digit?
            // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
            // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
            de[ce + 1] != null || (oe < 0 ? se : se % ae[le - oe - 1]), X = _ < 4 ? (me || X) && (_ == 0 || _ == (F.s < 0 ? 3 : 2)) : me > 5 || me == 5 && (_ == 4 || X || _ == 6 && // Check whether the digit to the left of the rounding digit is odd.
            (ie > 0 ? oe > 0 ? se / ae[le - oe] : 0 : de[ce - 1]) % 10 & 1 || _ == (F.s < 0 ? 8 : 7)), P < 1 || !de[0])
              return de.length = 0, X ? (P -= F.e + 1, de[0] = ae[(l - P % l) % l], F.e = -P || 0) : de[0] = F.e = 0, F;
            if (ie == 0 ? (de.length = ce, pe = 1, ce--) : (de.length = ce + 1, pe = ae[l - ie], de[ce] = oe > 0 ? n(se / ae[le - oe] % ae[oe]) * pe : 0), X)
              for (; ; )
                if (ce == 0) {
                  for (ie = 1, oe = de[0]; oe >= 10; oe /= 10, ie++) ;
                  for (oe = de[0] += pe, pe = 1; oe >= 10; oe /= 10, pe++) ;
                  ie != pe && (F.e++, de[0] == p && (de[0] = 1));
                  break;
                } else {
                  if (de[ce] += pe, de[ce] != p) break;
                  de[ce--] = 0, pe = 1;
                }
            for (ie = de.length; de[--ie] === 0; de.pop()) ;
          }
          F.e > A ? F.c = F.e = null : F.e < v && (F.c = [F.e = 0]);
        }
        return F;
      }
      function $(F) {
        var P, _ = F.e;
        return _ === null ? F.toString() : (P = S(F.c), P = _ <= u || _ >= g ? O(P, _) : z(P, _, "0"), F.s < 0 ? "-" + P : P);
      }
      return B.absoluteValue = B.abs = function() {
        var F = new Z(this);
        return F.s < 0 && (F.s = 1), F;
      }, B.comparedTo = function(F, P) {
        return T(this, new Z(F, P));
      }, B.decimalPlaces = B.dp = function(F, P) {
        var _, X, le, ie = this;
        if (F != null)
          return E(F, 0, C), P == null ? P = s : E(P, 0, 8), Q(new Z(ie), F + ie.e + 1, P);
        if (!(_ = ie.c)) return null;
        if (X = ((le = _.length - 1) - w(this.e / l)) * l, le = _[le]) for (; le % 10 == 0; le /= 10, X--) ;
        return X < 0 && (X = 0), X;
      }, B.dividedBy = B.div = function(F, P) {
        return H(this, new Z(F, P), r, s);
      }, B.dividedToIntegerBy = B.idiv = function(F, P) {
        return H(this, new Z(F, P), 0, 1);
      }, B.exponentiatedBy = B.pow = function(F, P) {
        var _, X, le, ie, oe, pe, se, ce, me, de = this;
        if (F = new Z(F), F.c && !F.isInteger())
          throw Error(d + "Exponent not an integer: " + $(F));
        if (P != null && (P = new Z(P)), pe = F.e > 14, !de.c || !de.c[0] || de.c[0] == 1 && !de.e && de.c.length == 1 || !F.c || !F.c[0])
          return me = new Z(Math.pow(+$(de), pe ? F.s * (2 - j(F)) : +$(F))), P ? me.mod(P) : me;
        if (se = F.s < 0, P) {
          if (P.c ? !P.c[0] : !P.s) return new Z(NaN);
          X = !se && de.isInteger() && P.isInteger(), X && (de = de.mod(P));
        } else {
          if (F.e > 9 && (de.e > 0 || de.e < -1 || (de.e == 0 ? de.c[0] > 1 || pe && de.c[1] >= 24e7 : de.c[0] < 8e13 || pe && de.c[0] <= 9999975e7)))
            return ie = de.s < 0 && j(F) ? -0 : 0, de.e > -1 && (ie = 1 / ie), new Z(se ? 1 / ie : ie);
          a && (ie = c(a / l + 2));
        }
        for (pe ? (_ = new Z(0.5), se && (F.s = 1), ce = j(F)) : (le = Math.abs(+$(F)), ce = le % 2), me = new Z(I); ; ) {
          if (ce) {
            if (me = me.times(de), !me.c) break;
            ie ? me.c.length > ie && (me.c.length = ie) : X && (me = me.mod(P));
          }
          if (le) {
            if (le = n(le / 2), le === 0) break;
            ce = le % 2;
          } else if (F = F.times(_), Q(F, F.e + 1, 1), F.e > 14)
            ce = j(F);
          else {
            if (le = +$(F), le === 0) break;
            ce = le % 2;
          }
          de = de.times(de), ie ? de.c && de.c.length > ie && (de.c.length = ie) : X && (de = de.mod(P));
        }
        return X ? me : (se && (me = I.div(me)), P ? me.mod(P) : ie ? Q(me, a, s, oe) : me);
      }, B.integerValue = function(F) {
        var P = new Z(this);
        return F == null ? F = s : E(F, 0, 8), Q(P, P.e + 1, F);
      }, B.isEqualTo = B.eq = function(F, P) {
        return T(this, new Z(F, P)) === 0;
      }, B.isFinite = function() {
        return !!this.c;
      }, B.isGreaterThan = B.gt = function(F, P) {
        return T(this, new Z(F, P)) > 0;
      }, B.isGreaterThanOrEqualTo = B.gte = function(F, P) {
        return (P = T(this, new Z(F, P))) === 1 || P === 0;
      }, B.isInteger = function() {
        return !!this.c && w(this.e / l) > this.c.length - 2;
      }, B.isLessThan = B.lt = function(F, P) {
        return T(this, new Z(F, P)) < 0;
      }, B.isLessThanOrEqualTo = B.lte = function(F, P) {
        return (P = T(this, new Z(F, P))) === -1 || P === 0;
      }, B.isNaN = function() {
        return !this.s;
      }, B.isNegative = function() {
        return this.s < 0;
      }, B.isPositive = function() {
        return this.s > 0;
      }, B.isZero = function() {
        return !!this.c && this.c[0] == 0;
      }, B.minus = function(F, P) {
        var _, X, le, ie, oe = this, pe = oe.s;
        if (F = new Z(F, P), P = F.s, !pe || !P) return new Z(NaN);
        if (pe != P)
          return F.s = -P, oe.plus(F);
        var se = oe.e / l, ce = F.e / l, me = oe.c, de = F.c;
        if (!se || !ce) {
          if (!me || !de) return me ? (F.s = -P, F) : new Z(de ? oe : NaN);
          if (!me[0] || !de[0])
            return de[0] ? (F.s = -P, F) : new Z(me[0] ? oe : (
              // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
              s == 3 ? -0 : 0
            ));
        }
        if (se = w(se), ce = w(ce), me = me.slice(), pe = se - ce) {
          for ((ie = pe < 0) ? (pe = -pe, le = me) : (ce = se, le = de), le.reverse(), P = pe; P--; le.push(0)) ;
          le.reverse();
        } else
          for (X = (ie = (pe = me.length) < (P = de.length)) ? pe : P, pe = P = 0; P < X; P++)
            if (me[P] != de[P]) {
              ie = me[P] < de[P];
              break;
            }
        if (ie && (le = me, me = de, de = le, F.s = -F.s), P = (X = de.length) - (_ = me.length), P > 0) for (; P--; me[_++] = 0) ;
        for (P = p - 1; X > pe; ) {
          if (me[--X] < de[X]) {
            for (_ = X; _ && !me[--_]; me[_] = P) ;
            --me[_], me[X] += p;
          }
          me[X] -= de[X];
        }
        for (; me[0] == 0; me.splice(0, 1), --ce) ;
        return me[0] ? R(F, me, ce) : (F.s = s == 3 ? -1 : 1, F.c = [F.e = 0], F);
      }, B.modulo = B.mod = function(F, P) {
        var _, X, le = this;
        return F = new Z(F, P), !le.c || !F.s || F.c && !F.c[0] ? new Z(NaN) : !F.c || le.c && !le.c[0] ? new Z(le) : (m == 9 ? (X = F.s, F.s = 1, _ = H(le, F, 0, 3), F.s = X, _.s *= X) : _ = H(le, F, 0, m), F = le.minus(_.times(F)), !F.c[0] && m == 1 && (F.s = le.s), F);
      }, B.multipliedBy = B.times = function(F, P) {
        var _, X, le, ie, oe, pe, se, ce, me, de, ae, Le, ye, Me, at, Ne = this, Ae = Ne.c, pt = (F = new Z(F, P)).c;
        if (!Ae || !pt || !Ae[0] || !pt[0])
          return !Ne.s || !F.s || Ae && !Ae[0] && !pt || pt && !pt[0] && !Ae ? F.c = F.e = F.s = null : (F.s *= Ne.s, !Ae || !pt ? F.c = F.e = null : (F.c = [0], F.e = 0)), F;
        for (X = w(Ne.e / l) + w(F.e / l), F.s *= Ne.s, se = Ae.length, de = pt.length, se < de && (ye = Ae, Ae = pt, pt = ye, le = se, se = de, de = le), le = se + de, ye = []; le--; ye.push(0)) ;
        for (Me = p, at = M, le = de; --le >= 0; ) {
          for (_ = 0, ae = pt[le] % at, Le = pt[le] / at | 0, oe = se, ie = le + oe; ie > le; )
            ce = Ae[--oe] % at, me = Ae[oe] / at | 0, pe = Le * ce + me * ae, ce = ae * ce + pe % at * at + ye[ie] + _, _ = (ce / Me | 0) + (pe / at | 0) + Le * me, ye[ie--] = ce % Me;
          ye[ie] = _;
        }
        return _ ? ++X : ye.splice(0, 1), R(F, ye, X);
      }, B.negated = function() {
        var F = new Z(this);
        return F.s = -F.s || null, F;
      }, B.plus = function(F, P) {
        var _, X = this, le = X.s;
        if (F = new Z(F, P), P = F.s, !le || !P) return new Z(NaN);
        if (le != P)
          return F.s = -P, X.minus(F);
        var ie = X.e / l, oe = F.e / l, pe = X.c, se = F.c;
        if (!ie || !oe) {
          if (!pe || !se) return new Z(le / 0);
          if (!pe[0] || !se[0]) return se[0] ? F : new Z(pe[0] ? X : le * 0);
        }
        if (ie = w(ie), oe = w(oe), pe = pe.slice(), le = ie - oe) {
          for (le > 0 ? (oe = ie, _ = se) : (le = -le, _ = pe), _.reverse(); le--; _.push(0)) ;
          _.reverse();
        }
        for (le = pe.length, P = se.length, le - P < 0 && (_ = se, se = pe, pe = _, P = le), le = 0; P; )
          le = (pe[--P] = pe[P] + se[P] + le) / p | 0, pe[P] = p === pe[P] ? 0 : pe[P] % p;
        return le && (pe = [le].concat(pe), ++oe), R(F, pe, oe);
      }, B.precision = B.sd = function(F, P) {
        var _, X, le, ie = this;
        if (F != null && F !== !!F)
          return E(F, 1, C), P == null ? P = s : E(P, 0, 8), Q(new Z(ie), F, P);
        if (!(_ = ie.c)) return null;
        if (le = _.length - 1, X = le * l + 1, le = _[le]) {
          for (; le % 10 == 0; le /= 10, X--) ;
          for (le = _[0]; le >= 10; le /= 10, X++) ;
        }
        return F && ie.e + 1 > X && (X = ie.e + 1), X;
      }, B.shiftedBy = function(F) {
        return E(F, -h, h), this.times("1e" + F);
      }, B.squareRoot = B.sqrt = function() {
        var F, P, _, X, le, ie = this, oe = ie.c, pe = ie.s, se = ie.e, ce = r + 4, me = new Z("0.5");
        if (pe !== 1 || !oe || !oe[0])
          return new Z(!pe || pe < 0 && (!oe || oe[0]) ? NaN : oe ? ie : 1 / 0);
        if (pe = Math.sqrt(+$(ie)), pe == 0 || pe == 1 / 0 ? (P = S(oe), (P.length + se) % 2 == 0 && (P += "0"), pe = Math.sqrt(+P), se = w((se + 1) / 2) - (se < 0 || se % 2), pe == 1 / 0 ? P = "5e" + se : (P = pe.toExponential(), P = P.slice(0, P.indexOf("e") + 1) + se), _ = new Z(P)) : _ = new Z(pe + ""), _.c[0]) {
          for (se = _.e, pe = se + ce, pe < 3 && (pe = 0); ; )
            if (le = _, _ = me.times(le.plus(H(ie, le, ce, 1))), S(le.c).slice(0, pe) === (P = S(_.c)).slice(0, pe))
              if (_.e < se && --pe, P = P.slice(pe - 3, pe + 1), P == "9999" || !X && P == "4999") {
                if (!X && (Q(le, le.e + r + 2, 0), le.times(le).eq(ie))) {
                  _ = le;
                  break;
                }
                ce += 4, pe += 4, X = 1;
              } else {
                (!+P || !+P.slice(1) && P.charAt(0) == "5") && (Q(_, _.e + r + 2, 1), F = !_.times(_).eq(ie));
                break;
              }
        }
        return Q(_, _.e + r + 1, s, F);
      }, B.toExponential = function(F, P) {
        return F != null && (E(F, 0, C), F++), te(this, F, P, 1);
      }, B.toFixed = function(F, P) {
        return F != null && (E(F, 0, C), F = F + this.e + 1), te(this, F, P);
      }, B.toFormat = function(F, P, _) {
        var X, le = this;
        if (_ == null)
          F != null && P && typeof P == "object" ? (_ = P, P = null) : F && typeof F == "object" ? (_ = F, F = P = null) : _ = x;
        else if (typeof _ != "object")
          throw Error(d + "Argument not an object: " + _);
        if (X = le.toFixed(F, P), le.c) {
          var ie, oe = X.split("."), pe = +_.groupSize, se = +_.secondaryGroupSize, ce = _.groupSeparator || "", me = oe[0], de = oe[1], ae = le.s < 0, Le = ae ? me.slice(1) : me, ye = Le.length;
          if (se && (ie = pe, pe = se, se = ie, ye -= ie), pe > 0 && ye > 0) {
            for (ie = ye % pe || pe, me = Le.substr(0, ie); ie < ye; ie += pe) me += ce + Le.substr(ie, pe);
            se > 0 && (me += ce + Le.slice(ie)), ae && (me = "-" + me);
          }
          X = de ? me + (_.decimalSeparator || "") + ((se = +_.fractionGroupSize) ? de.replace(
            new RegExp("\\d{" + se + "}\\B", "g"),
            "$&" + (_.fractionGroupSeparator || "")
          ) : de) : me;
        }
        return (_.prefix || "") + X + (_.suffix || "");
      }, B.toFraction = function(F) {
        var P, _, X, le, ie, oe, pe, se, ce, me, de, ae, Le = this, ye = Le.c;
        if (F != null && (pe = new Z(F), !pe.isInteger() && (pe.c || pe.s !== 1) || pe.lt(I)))
          throw Error(d + "Argument " + (pe.isInteger() ? "out of range: " : "not an integer: ") + $(pe));
        if (!ye) return new Z(Le);
        for (P = new Z(I), ce = _ = new Z(I), X = se = new Z(I), ae = S(ye), ie = P.e = ae.length - Le.e - 1, P.c[0] = y[(oe = ie % l) < 0 ? l + oe : oe], F = !F || pe.comparedTo(P) > 0 ? ie > 0 ? P : ce : pe, oe = A, A = 1 / 0, pe = new Z(ae), se.c[0] = 0; me = H(pe, P, 0, 1), le = _.plus(me.times(X)), le.comparedTo(F) != 1; )
          _ = X, X = le, ce = se.plus(me.times(le = ce)), se = le, P = pe.minus(me.times(le = P)), pe = le;
        return le = H(F.minus(_), X, 0, 1), se = se.plus(le.times(ce)), _ = _.plus(le.times(X)), se.s = ce.s = Le.s, ie = ie * 2, de = H(ce, X, ie, s).minus(Le).abs().comparedTo(
          H(se, _, ie, s).minus(Le).abs()
        ) < 1 ? [ce, X] : [se, _], A = oe, de;
      }, B.toNumber = function() {
        return +$(this);
      }, B.toPrecision = function(F, P) {
        return F != null && E(F, 1, C), te(this, F, P, 2);
      }, B.toString = function(F) {
        var P, _ = this, X = _.s, le = _.e;
        return le === null ? X ? (P = "Infinity", X < 0 && (P = "-" + P)) : P = "NaN" : (F == null ? P = le <= u || le >= g ? O(S(_.c), le) : z(S(_.c), le, "0") : F === 10 && G ? (_ = Q(new Z(_), r + le + 1, s), P = z(S(_.c), _.e, "0")) : (E(F, 2, V.length, "Base"), P = W(z(S(_.c), le, "0"), 10, F, X, !0)), X < 0 && _.c[0] && (P = "-" + P)), P;
      }, B.valueOf = B.toJSON = function() {
        return $(this);
      }, B._isBigNumber = !0, k != null && Z.set(k), Z;
    }
    function w(k) {
      var H = k | 0;
      return k > 0 || k === H ? H : H - 1;
    }
    function S(k) {
      for (var H, W, U = 1, B = k.length, I = k[0] + ""; U < B; ) {
        for (H = k[U++] + "", W = l - H.length; W--; H = "0" + H) ;
        I += H;
      }
      for (B = I.length; I.charCodeAt(--B) === 48; ) ;
      return I.slice(0, B + 1 || 1);
    }
    function T(k, H) {
      var W, U, B = k.c, I = H.c, r = k.s, s = H.s, u = k.e, g = H.e;
      if (!r || !s) return null;
      if (W = B && !B[0], U = I && !I[0], W || U) return W ? U ? 0 : -s : r;
      if (r != s) return r;
      if (W = r < 0, U = u == g, !B || !I) return U ? 0 : !B ^ W ? 1 : -1;
      if (!U) return u > g ^ W ? 1 : -1;
      for (s = (u = B.length) < (g = I.length) ? u : g, r = 0; r < s; r++) if (B[r] != I[r]) return B[r] > I[r] ^ W ? 1 : -1;
      return u == g ? 0 : u > g ^ W ? 1 : -1;
    }
    function E(k, H, W, U) {
      if (k < H || k > W || k !== n(k))
        throw Error(d + (U || "Argument") + (typeof k == "number" ? k < H || k > W ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(k));
    }
    function j(k) {
      var H = k.c.length - 1;
      return w(k.e / l) == H && k.c[H] % 2 != 0;
    }
    function O(k, H) {
      return (k.length > 1 ? k.charAt(0) + "." + k.slice(1) : k) + (H < 0 ? "e" : "e+") + H;
    }
    function z(k, H, W) {
      var U, B;
      if (H < 0) {
        for (B = W + "."; ++H; B += W) ;
        k = B + k;
      } else if (U = k.length, ++H > U) {
        for (B = W, H -= U; --H; B += W) ;
        k += B;
      } else H < U && (k = k.slice(0, H) + "." + k.slice(H));
      return k;
    }
    o = N(), o.default = o.BigNumber = o, e.exports ? e.exports = o : (t || (t = typeof self < "u" && self ? self : window), t.BigNumber = o);
  })(Wt);
})(FM);
var RM = FM.exports;
(function(e) {
  var t = RM, o = e.exports;
  (function() {
    var i = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, c, n, d = {
      // table of character substitutions
      "\b": "\\b",
      "	": "\\t",
      "\n": "\\n",
      "\f": "\\f",
      "\r": "\\r",
      '"': '\\"',
      "\\": "\\\\"
    }, f;
    function p(h) {
      return i.lastIndex = 0, i.test(h) ? '"' + h.replace(i, function(y) {
        var M = d[y];
        return typeof M == "string" ? M : "\\u" + ("0000" + y.charCodeAt(0).toString(16)).slice(-4);
      }) + '"' : '"' + h + '"';
    }
    function l(h, y) {
      var M, C, N, w, S = c, T, E = y[h], j = E != null && (E instanceof t || t.isBigNumber(E));
      switch (E && typeof E == "object" && typeof E.toJSON == "function" && (E = E.toJSON(h)), typeof f == "function" && (E = f.call(y, h, E)), typeof E) {
        case "string":
          return j ? E : p(E);
        case "number":
          return isFinite(E) ? String(E) : "null";
        case "boolean":
        case "null":
        case "bigint":
          return String(E);
        case "object":
          if (!E)
            return "null";
          if (c += n, T = [], Object.prototype.toString.apply(E) === "[object Array]") {
            for (w = E.length, M = 0; M < w; M += 1)
              T[M] = l(M, E) || "null";
            return N = T.length === 0 ? "[]" : c ? `[
` + c + T.join(`,
` + c) + `
` + S + "]" : "[" + T.join(",") + "]", c = S, N;
          }
          if (f && typeof f == "object")
            for (w = f.length, M = 0; M < w; M += 1)
              typeof f[M] == "string" && (C = f[M], N = l(C, E), N && T.push(p(C) + (c ? ": " : ":") + N));
          else
            Object.keys(E).forEach(function(O) {
              var z = l(O, E);
              z && T.push(p(O) + (c ? ": " : ":") + z);
            });
          return N = T.length === 0 ? "{}" : c ? `{
` + c + T.join(`,
` + c) + `
` + S + "}" : "{" + T.join(",") + "}", c = S, N;
      }
    }
    typeof o.stringify != "function" && (o.stringify = function(h, y, M) {
      var C;
      if (c = "", n = "", typeof M == "number")
        for (C = 0; C < M; C += 1)
          n += " ";
      else typeof M == "string" && (n = M);
      if (f = y, y && typeof y != "function" && (typeof y != "object" || typeof y.length != "number"))
        throw new Error("JSON.stringify");
      return l("", { "": h });
    });
  })();
})(BM);
var mT = BM.exports, m0 = null;
const vT = /(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])/, bT = /(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)/;
var xT = function(e) {
  var t = {
    strict: !1,
    // not being strict means do not generate syntax errors for "duplicate key"
    storeAsString: !1,
    // toggles whether the values should be stored as BigNumber (default) or a string
    alwaysParseAsBig: !1,
    // toggles whether all numbers should be Big
    useNativeBigInt: !1,
    // toggles whether to use native BigInt instead of bignumber.js
    protoAction: "error",
    constructorAction: "error"
  };
  if (e != null) {
    if (e.strict === !0 && (t.strict = !0), e.storeAsString === !0 && (t.storeAsString = !0), t.alwaysParseAsBig = e.alwaysParseAsBig === !0 ? e.alwaysParseAsBig : !1, t.useNativeBigInt = e.useNativeBigInt === !0 ? e.useNativeBigInt : !1, typeof e.constructorAction < "u")
      if (e.constructorAction === "error" || e.constructorAction === "ignore" || e.constructorAction === "preserve")
        t.constructorAction = e.constructorAction;
      else
        throw new Error(
          `Incorrect value for constructorAction option, must be "error", "ignore" or undefined but passed ${e.constructorAction}`
        );
    if (typeof e.protoAction < "u")
      if (e.protoAction === "error" || e.protoAction === "ignore" || e.protoAction === "preserve")
        t.protoAction = e.protoAction;
      else
        throw new Error(
          `Incorrect value for protoAction option, must be "error", "ignore" or undefined but passed ${e.protoAction}`
        );
  }
  var o, i, c = {
    '"': '"',
    "\\": "\\",
    "/": "/",
    b: "\b",
    f: "\f",
    n: `
`,
    r: "\r",
    t: "	"
  }, n, d = function(w) {
    throw {
      name: "SyntaxError",
      message: w,
      at: o,
      text: n
    };
  }, f = function(w) {
    return w && w !== i && d("Expected '" + w + "' instead of '" + i + "'"), i = n.charAt(o), o += 1, i;
  }, p = function() {
    var w, S = "";
    for (i === "-" && (S = "-", f("-")); i >= "0" && i <= "9"; )
      S += i, f();
    if (i === ".")
      for (S += "."; f() && i >= "0" && i <= "9"; )
        S += i;
    if (i === "e" || i === "E")
      for (S += i, f(), (i === "-" || i === "+") && (S += i, f()); i >= "0" && i <= "9"; )
        S += i, f();
    if (w = +S, !isFinite(w))
      d("Bad number");
    else
      return m0 == null && (m0 = RM), S.length > 15 ? t.storeAsString ? S : t.useNativeBigInt ? BigInt(S) : new m0(S) : t.alwaysParseAsBig ? t.useNativeBigInt ? BigInt(w) : new m0(w) : w;
  }, l = function() {
    var w, S, T = "", E;
    if (i === '"')
      for (var j = o; f(); ) {
        if (i === '"')
          return o - 1 > j && (T += n.substring(j, o - 1)), f(), T;
        if (i === "\\") {
          if (o - 1 > j && (T += n.substring(j, o - 1)), f(), i === "u") {
            for (E = 0, S = 0; S < 4 && (w = parseInt(f(), 16), !!isFinite(w)); S += 1)
              E = E * 16 + w;
            T += String.fromCharCode(E);
          } else if (typeof c[i] == "string")
            T += c[i];
          else
            break;
          j = o;
        }
      }
    d("Bad string");
  }, h = function() {
    for (; i && i <= " "; )
      f();
  }, y = function() {
    switch (i) {
      case "t":
        return f("t"), f("r"), f("u"), f("e"), !0;
      case "f":
        return f("f"), f("a"), f("l"), f("s"), f("e"), !1;
      case "n":
        return f("n"), f("u"), f("l"), f("l"), null;
    }
    d("Unexpected '" + i + "'");
  }, M, C = function() {
    var w = [];
    if (i === "[") {
      if (f("["), h(), i === "]")
        return f("]"), w;
      for (; i; ) {
        if (w.push(M()), h(), i === "]")
          return f("]"), w;
        f(","), h();
      }
    }
    d("Bad array");
  }, N = function() {
    var w, S = /* @__PURE__ */ Object.create(null);
    if (i === "{") {
      if (f("{"), h(), i === "}")
        return f("}"), S;
      for (; i; ) {
        if (w = l(), h(), f(":"), t.strict === !0 && Object.hasOwnProperty.call(S, w) && d('Duplicate key "' + w + '"'), vT.test(w) === !0 ? t.protoAction === "error" ? d("Object contains forbidden prototype property") : t.protoAction === "ignore" ? M() : S[w] = M() : bT.test(w) === !0 ? t.constructorAction === "error" ? d("Object contains forbidden constructor property") : t.constructorAction === "ignore" ? M() : S[w] = M() : S[w] = M(), h(), i === "}")
          return f("}"), S;
        f(","), h();
      }
    }
    d("Bad object");
  };
  return M = function() {
    switch (h(), i) {
      case "{":
        return N();
      case "[":
        return C();
      case '"':
        return l();
      case "-":
        return p();
      default:
        return i >= "0" && i <= "9" ? p() : y();
    }
  }, function(w, S) {
    var T;
    return n = w + "", o = 0, i = " ", T = M(), h(), i && d("Syntax error"), typeof S == "function" ? function E(j, O) {
      var z, k = j[O];
      return k && typeof k == "object" && Object.keys(k).forEach(function(H) {
        z = E(k, H), z !== void 0 ? k[H] = z : delete k[H];
      }), S.call(j, O, k);
    }({ "": T }, "") : T;
  };
}, wT = xT, PM = mT.stringify, UM = wT;
Jc.exports = function(e) {
  return {
    parse: UM(e),
    stringify: PM
  };
};
Jc.exports.parse = UM();
Jc.exports.stringify = PM;
var CT = Jc.exports;
const IT = /* @__PURE__ */ Yi(CT);
var N5;
(function(e) {
  e.DEFAULT = "default", e.SAFE = "safe", e.MIXED = "mixed", e.BIGINT = "bigint";
})(N5 || (N5 = {}));
IT({ useNativeBigInt: !0, strict: !0 });
function NT(e, t) {
  return e.length !== t.length ? !1 : Array.from(e).every((o, i) => o === t[i]);
}
function AT(...e) {
  const t = e.reduce((c, n) => c + n.length, 0), o = new Uint8Array(t);
  let i = 0;
  for (let c = 0; c < e.length; c++)
    o.set(e[c], i), i += e[c].length;
  return o;
}
function YM(e) {
  return MT.sha512_256.array(e);
}
const p1 = kM.sign.publicKeyLength;
kM.sign.secretKeyLength;
const A5 = 32;
var WM = { exports: {} };
(function(e) {
  (function() {
    var t = typeof window == "object" ? window : {}, o = !t.HI_BASE32_NO_NODE_JS && typeof fe.process == "object" && fe.process.versions && fe.process.versions.node;
    o && (t = Wt);
    var i = !t.HI_BASE32_NO_COMMON_JS && !0 && e.exports, c = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567".split(""), n = {
      A: 0,
      B: 1,
      C: 2,
      D: 3,
      E: 4,
      F: 5,
      G: 6,
      H: 7,
      I: 8,
      J: 9,
      K: 10,
      L: 11,
      M: 12,
      N: 13,
      O: 14,
      P: 15,
      Q: 16,
      R: 17,
      S: 18,
      T: 19,
      U: 20,
      V: 21,
      W: 22,
      X: 23,
      Y: 24,
      Z: 25,
      2: 26,
      3: 27,
      4: 28,
      5: 29,
      6: 30,
      7: 31
    }, d = [0, 0, 0, 0, 0, 0, 0, 0], f = function(S, T) {
      T.length > 10 && (T = "..." + T.substr(-10));
      var E = new Error("Decoded data is not valid UTF-8. Maybe try base32.decode.asBytes()? Partial data after reading " + S + " bytes: " + T + " <-");
      throw E.position = S, E;
    }, p = function(S) {
      for (var T = "", E = S.length, j = 0, O = 0, z, k; j < E; ) {
        if (z = S[j++], z <= 127) {
          T += String.fromCharCode(z);
          continue;
        } else z > 191 && z <= 223 ? (k = z & 31, O = 1) : z <= 239 ? (k = z & 15, O = 2) : z <= 247 ? (k = z & 7, O = 3) : f(j, T);
        for (var H = 0; H < O; ++H)
          z = S[j++], (z < 128 || z > 191) && f(j, T), k <<= 6, k += z & 63;
        k >= 55296 && k <= 57343 && f(j, T), k > 1114111 && f(j, T), k <= 65535 ? T += String.fromCharCode(k) : (k -= 65536, T += String.fromCharCode((k >> 10) + 55296), T += String.fromCharCode((k & 1023) + 56320));
      }
      return T;
    }, l = function(S) {
      if (S === "")
        return [];
      if (!/^[A-Z2-7=]+$/.test(S))
        throw new Error("Invalid base32 characters");
      S = S.replace(/=/g, "");
      for (var T, E, j, O, z, k, H, W, U = [], B = 0, I = S.length, r = 0, s = I >> 3 << 3; r < s; )
        T = n[S.charAt(r++)], E = n[S.charAt(r++)], j = n[S.charAt(r++)], O = n[S.charAt(r++)], z = n[S.charAt(r++)], k = n[S.charAt(r++)], H = n[S.charAt(r++)], W = n[S.charAt(r++)], U[B++] = (T << 3 | E >>> 2) & 255, U[B++] = (E << 6 | j << 1 | O >>> 4) & 255, U[B++] = (O << 4 | z >>> 1) & 255, U[B++] = (z << 7 | k << 2 | H >>> 3) & 255, U[B++] = (H << 5 | W) & 255;
      var u = I - s;
      return u === 2 ? (T = n[S.charAt(r++)], E = n[S.charAt(r++)], U[B++] = (T << 3 | E >>> 2) & 255) : u === 4 ? (T = n[S.charAt(r++)], E = n[S.charAt(r++)], j = n[S.charAt(r++)], O = n[S.charAt(r++)], U[B++] = (T << 3 | E >>> 2) & 255, U[B++] = (E << 6 | j << 1 | O >>> 4) & 255) : u === 5 ? (T = n[S.charAt(r++)], E = n[S.charAt(r++)], j = n[S.charAt(r++)], O = n[S.charAt(r++)], z = n[S.charAt(r++)], U[B++] = (T << 3 | E >>> 2) & 255, U[B++] = (E << 6 | j << 1 | O >>> 4) & 255, U[B++] = (O << 4 | z >>> 1) & 255) : u === 7 && (T = n[S.charAt(r++)], E = n[S.charAt(r++)], j = n[S.charAt(r++)], O = n[S.charAt(r++)], z = n[S.charAt(r++)], k = n[S.charAt(r++)], H = n[S.charAt(r++)], U[B++] = (T << 3 | E >>> 2) & 255, U[B++] = (E << 6 | j << 1 | O >>> 4) & 255, U[B++] = (O << 4 | z >>> 1) & 255, U[B++] = (z << 7 | k << 2 | H >>> 3) & 255), U;
    }, h = function(S) {
      for (var T, E, j, O, z, k = "", H = S.length, W = 0, U = parseInt(H / 5) * 5; W < U; )
        T = S.charCodeAt(W++), E = S.charCodeAt(W++), j = S.charCodeAt(W++), O = S.charCodeAt(W++), z = S.charCodeAt(W++), k += c[T >>> 3] + c[(T << 2 | E >>> 6) & 31] + c[E >>> 1 & 31] + c[(E << 4 | j >>> 4) & 31] + c[(j << 1 | O >>> 7) & 31] + c[O >>> 2 & 31] + c[(O << 3 | z >>> 5) & 31] + c[z & 31];
      var B = H - U;
      return B === 1 ? (T = S.charCodeAt(W), k += c[T >>> 3] + c[T << 2 & 31] + "======") : B === 2 ? (T = S.charCodeAt(W++), E = S.charCodeAt(W), k += c[T >>> 3] + c[(T << 2 | E >>> 6) & 31] + c[E >>> 1 & 31] + c[E << 4 & 31] + "====") : B === 3 ? (T = S.charCodeAt(W++), E = S.charCodeAt(W++), j = S.charCodeAt(W), k += c[T >>> 3] + c[(T << 2 | E >>> 6) & 31] + c[E >>> 1 & 31] + c[(E << 4 | j >>> 4) & 31] + c[j << 1 & 31] + "===") : B === 4 && (T = S.charCodeAt(W++), E = S.charCodeAt(W++), j = S.charCodeAt(W++), O = S.charCodeAt(W), k += c[T >>> 3] + c[(T << 2 | E >>> 6) & 31] + c[E >>> 1 & 31] + c[(E << 4 | j >>> 4) & 31] + c[(j << 1 | O >>> 7) & 31] + c[O >>> 2 & 31] + c[O << 3 & 31] + "="), k;
    }, y = function(S) {
      var T, E, j, O, z, k, H = !1, W = "", U = 0, B, I = 0, r = S.length;
      if (S === "")
        return W;
      do {
        for (d[0] = d[5], d[1] = d[6], d[2] = d[7], B = I; U < r && B < 5; ++U)
          k = S.charCodeAt(U), k < 128 ? d[B++] = k : k < 2048 ? (d[B++] = 192 | k >> 6, d[B++] = 128 | k & 63) : k < 55296 || k >= 57344 ? (d[B++] = 224 | k >> 12, d[B++] = 128 | k >> 6 & 63, d[B++] = 128 | k & 63) : (k = 65536 + ((k & 1023) << 10 | S.charCodeAt(++U) & 1023), d[B++] = 240 | k >> 18, d[B++] = 128 | k >> 12 & 63, d[B++] = 128 | k >> 6 & 63, d[B++] = 128 | k & 63);
        I = B - 5, U === r && ++U, U > r && B < 6 && (H = !0), T = d[0], B > 4 ? (E = d[1], j = d[2], O = d[3], z = d[4], W += c[T >>> 3] + c[(T << 2 | E >>> 6) & 31] + c[E >>> 1 & 31] + c[(E << 4 | j >>> 4) & 31] + c[(j << 1 | O >>> 7) & 31] + c[O >>> 2 & 31] + c[(O << 3 | z >>> 5) & 31] + c[z & 31]) : B === 1 ? W += c[T >>> 3] + c[T << 2 & 31] + "======" : B === 2 ? (E = d[1], W += c[T >>> 3] + c[(T << 2 | E >>> 6) & 31] + c[E >>> 1 & 31] + c[E << 4 & 31] + "====") : B === 3 ? (E = d[1], j = d[2], W += c[T >>> 3] + c[(T << 2 | E >>> 6) & 31] + c[E >>> 1 & 31] + c[(E << 4 | j >>> 4) & 31] + c[j << 1 & 31] + "===") : (E = d[1], j = d[2], O = d[3], W += c[T >>> 3] + c[(T << 2 | E >>> 6) & 31] + c[E >>> 1 & 31] + c[(E << 4 | j >>> 4) & 31] + c[(j << 1 | O >>> 7) & 31] + c[O >>> 2 & 31] + c[O << 3 & 31] + "=");
      } while (!H);
      return W;
    }, M = function(S) {
      for (var T, E, j, O, z, k = "", H = S.length, W = 0, U = parseInt(H / 5) * 5; W < U; )
        T = S[W++], E = S[W++], j = S[W++], O = S[W++], z = S[W++], k += c[T >>> 3] + c[(T << 2 | E >>> 6) & 31] + c[E >>> 1 & 31] + c[(E << 4 | j >>> 4) & 31] + c[(j << 1 | O >>> 7) & 31] + c[O >>> 2 & 31] + c[(O << 3 | z >>> 5) & 31] + c[z & 31];
      var B = H - U;
      return B === 1 ? (T = S[W], k += c[T >>> 3] + c[T << 2 & 31] + "======") : B === 2 ? (T = S[W++], E = S[W], k += c[T >>> 3] + c[(T << 2 | E >>> 6) & 31] + c[E >>> 1 & 31] + c[E << 4 & 31] + "====") : B === 3 ? (T = S[W++], E = S[W++], j = S[W], k += c[T >>> 3] + c[(T << 2 | E >>> 6) & 31] + c[E >>> 1 & 31] + c[(E << 4 | j >>> 4) & 31] + c[j << 1 & 31] + "===") : B === 4 && (T = S[W++], E = S[W++], j = S[W++], O = S[W], k += c[T >>> 3] + c[(T << 2 | E >>> 6) & 31] + c[E >>> 1 & 31] + c[(E << 4 | j >>> 4) & 31] + c[(j << 1 | O >>> 7) & 31] + c[O >>> 2 & 31] + c[O << 3 & 31] + "="), k;
    }, C = function(S, T) {
      var E = typeof S != "string";
      return E && S.constructor === ArrayBuffer && (S = new Uint8Array(S)), E ? M(S) : T ? h(S) : y(S);
    }, N = function(S, T) {
      if (!T)
        return p(l(S));
      if (S === "")
        return "";
      if (!/^[A-Z2-7=]+$/.test(S))
        throw new Error("Invalid base32 characters");
      var E, j, O, z, k, H, W, U, B = "", I = S.indexOf("=");
      I === -1 && (I = S.length);
      for (var r = 0, s = I >> 3 << 3; r < s; )
        E = n[S.charAt(r++)], j = n[S.charAt(r++)], O = n[S.charAt(r++)], z = n[S.charAt(r++)], k = n[S.charAt(r++)], H = n[S.charAt(r++)], W = n[S.charAt(r++)], U = n[S.charAt(r++)], B += String.fromCharCode((E << 3 | j >>> 2) & 255) + String.fromCharCode((j << 6 | O << 1 | z >>> 4) & 255) + String.fromCharCode((z << 4 | k >>> 1) & 255) + String.fromCharCode((k << 7 | H << 2 | W >>> 3) & 255) + String.fromCharCode((W << 5 | U) & 255);
      var u = I - s;
      return u === 2 ? (E = n[S.charAt(r++)], j = n[S.charAt(r++)], B += String.fromCharCode((E << 3 | j >>> 2) & 255)) : u === 4 ? (E = n[S.charAt(r++)], j = n[S.charAt(r++)], O = n[S.charAt(r++)], z = n[S.charAt(r++)], B += String.fromCharCode((E << 3 | j >>> 2) & 255) + String.fromCharCode((j << 6 | O << 1 | z >>> 4) & 255)) : u === 5 ? (E = n[S.charAt(r++)], j = n[S.charAt(r++)], O = n[S.charAt(r++)], z = n[S.charAt(r++)], k = n[S.charAt(r++)], B += String.fromCharCode((E << 3 | j >>> 2) & 255) + String.fromCharCode((j << 6 | O << 1 | z >>> 4) & 255) + String.fromCharCode((z << 4 | k >>> 1) & 255)) : u === 7 && (E = n[S.charAt(r++)], j = n[S.charAt(r++)], O = n[S.charAt(r++)], z = n[S.charAt(r++)], k = n[S.charAt(r++)], H = n[S.charAt(r++)], W = n[S.charAt(r++)], B += String.fromCharCode((E << 3 | j >>> 2) & 255) + String.fromCharCode((j << 6 | O << 1 | z >>> 4) & 255) + String.fromCharCode((z << 4 | k >>> 1) & 255) + String.fromCharCode((k << 7 | H << 2 | W >>> 3) & 255)), B;
    }, w = {
      encode: C,
      decode: N
    };
    N.asBytes = l, i ? e.exports = w : t.base32 = w;
  })();
})(WM);
var TT = WM.exports;
const HM = /* @__PURE__ */ Yi(TT), Ld = 36, g1 = 4, ZM = 58;
Wr.Buffer.from("appID");
const T5 = "address seems to be malformed", LT = "wrong checksum for address";
function QM(e) {
  if (typeof e != "string" || e.length !== ZM)
    throw new Error(T5);
  const t = HM.decode.asBytes(e.toString());
  if (t.length !== Ld)
    throw new Error(T5);
  const o = new Uint8Array(t.slice(0, Ld - g1)), i = new Uint8Array(t.slice(p1, Ld)), c = YM(o).slice(A5 - g1, A5);
  if (!NT(c, i))
    throw new Error(LT);
  return { publicKey: o, checksum: i };
}
function ST(e) {
  try {
    QM(e);
  } catch {
    return !1;
  }
  return !0;
}
function ET(e) {
  const t = YM(e).slice(p1 - g1, p1);
  return HM.encode(AT(e, t)).toString().slice(0, ZM);
}
var L5;
(function(e) {
  e.pay = "pay", e.keyreg = "keyreg", e.acfg = "acfg", e.axfer = "axfer", e.afrz = "afrz", e.appl = "appl", e.stpf = "stpf";
})(L5 || (L5 = {}));
var S5;
(function(e) {
  e[e.NoOpOC = 0] = "NoOpOC", e[e.OptInOC = 1] = "OptInOC", e[e.CloseOutOC = 2] = "CloseOutOC", e[e.ClearStateOC = 3] = "ClearStateOC", e[e.UpdateApplicationOC = 4] = "UpdateApplicationOC", e[e.DeleteApplicationOC = 5] = "DeleteApplicationOC";
})(S5 || (S5 = {}));
Wr.Buffer.from("ProgData");
"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".split("").forEach(function(e, t) {
});
var E5;
(function(e) {
  e.any = "txn", e.pay = "pay", e.keyreg = "keyreg", e.acfg = "acfg", e.axfer = "axfer", e.afrz = "afrz", e.appl = "appl";
})(E5 || (E5 = {}));
var D5;
(function(e) {
  e.account = "account", e.application = "application", e.asset = "asset";
})(D5 || (D5 = {}));
Wr.Buffer.from([21, 31, 124, 117]);
var j5;
(function(e) {
  e[e.BUILDING = 0] = "BUILDING", e[e.BUILT = 1] = "BUILT", e[e.SIGNED = 2] = "SIGNED", e[e.SUBMITTED = 3] = "SUBMITTED", e[e.COMMITTED = 4] = "COMMITTED";
})(j5 || (j5 = {}));
Wr.Buffer.from([77, 88]);
const y1 = "Algorand";
function DT(e) {
  if (e < BigInt(Number.MIN_SAFE_INTEGER) || e > BigInt(Number.MAX_SAFE_INTEGER))
    throw new Error("Integer is unsafe");
  return Number(e);
}
const ei = class ei {
  constructor(t) {
    zt(this, "type", "Native");
    zt(this, "address");
    if (ei.instanceof(t))
      this.address = t.address;
    else if (lo.instanceof(t))
      this.address = t.toUint8Array();
    else if (t instanceof Uint8Array && t.byteLength === ei.byteSize)
      this.address = t;
    else if (typeof t == "string" && ST(t))
      this.address = QM(t).publicKey;
    else if (typeof t == "string" && !isNaN(parseInt(t)))
      this.address = Ll.zpad(Sl.toBytes(BigInt(t), 8), ei.byteSize);
    else if (typeof t == "bigint")
      this.address = Ll.zpad(Sl.toBytes(t, 8), ei.byteSize);
    else if (t instanceof Uint8Array && t.byteLength === 8)
      this.address = Ll.zpad(t, ei.byteSize);
    else
      throw new Error(`Invalid Algorand address or ASA ID: ${t}`);
  }
  unwrap() {
    return this.toString();
  }
  toString() {
    return ET(this.address);
  }
  toNative() {
    return this;
  }
  toUint8Array() {
    return this.address;
  }
  toUniversalAddress() {
    return new lo(this.toUint8Array());
  }
  toBigInt() {
    return Sl.decode(this.toUint8Array().slice(24, 32));
  }
  toInt() {
    return DT(this.toBigInt());
  }
  equals(t) {
    return ei.instanceof(t) ? t.address === this.address : this.toUniversalAddress().equals(t);
  }
  static instanceof(t) {
    return t.constructor.platform === y1;
  }
};
zt(ei, "byteSize", 32), zt(ei, "platform", y1);
let M1 = ei;
sg(y1, M1);
const VM = [
  ["Cosmoshub", "cosmos"],
  ["Evmos", "evmos"],
  ["Injective", "inj"],
  ["Kujira", "kuji"],
  ["Osmosis", "osmo"],
  ["Sei", "sei"],
  ["Terra2", "terra"],
  ["Wormchain", "wormhole"],
  ["Celestia", "celestia"],
  ["Stargaze", "stars"],
  ["Dymension", "dym"],
  ["Neutron", "neutron"],
  ["Seda", "seda"],
  ["Provenance", "pb"],
  ["Noble", "noble"]
], jT = Do(VM);
Do(VM, [1, [0]]);
const GM = [
  [
    "Mainnet",
    [
      ["Cosmoshub", "uatom"],
      ["Evmos", "aevmos"],
      ["Injective", "inj"],
      ["Kujira", "kuji"],
      ["Osmosis", "uosmo"],
      ["Sei", "usei"],
      ["Terra2", "uluna"],
      ["Wormchain", "uworm"],
      ["Celestia", "utia"],
      ["Dymension", "adym"],
      ["Stargaze", "ustars"],
      ["Neutron", "untrn"],
      ["Provenance", "nhash"],
      ["Noble", "uusdc"]
    ]
  ],
  [
    "Testnet",
    [
      ["Cosmoshub", "uatom"],
      ["Evmos", "atevmos"],
      ["Injective", "inj"],
      ["Kujira", "kuji"],
      ["Osmosis", "uosmo"],
      ["Sei", "usei"],
      ["Terra2", "uluna"],
      ["Wormchain", "uworm"],
      ["Seda", "aseda"]
    ]
  ],
  [
    "Devnet",
    [
      ["Cosmoshub", "uatom"],
      ["Evmos", "atevmos"],
      ["Injective", "inj"],
      ["Kujira", "kuji"],
      ["Osmosis", "uosmo"],
      ["Sei", "usei"],
      ["Terra2", "uluna"],
      ["Wormchain", "uworm"]
    ]
  ]
];
Do(GM);
Do(GM, [[0, 2], [1]]);
const OT = [
  [
    "Mainnet",
    [
      [
        "Wormchain",
        {
          Osmosis: "channel-3",
          Evmos: "channel-5",
          Kujira: "channel-9",
          Stargaze: "channel-12",
          Injective: "channel-13",
          Dymension: "channel-15"
        }
      ],
      ["Osmosis", { Wormchain: "channel-2186" }],
      ["Evmos", { Wormchain: "channel-94" }],
      ["Kujira", { Wormchain: "channel-113" }],
      ["Injective", { Wormchain: "channel-183" }],
      ["Dymension", { Wormchain: "channel-36" }],
      ["Stargaze", { Wormchain: "channel-278" }]
    ]
  ],
  [
    "Testnet",
    [
      [
        "Wormchain",
        {
          Cosmoshub: "channel-5",
          Injective: "channel-15",
          Kujira: "channel-16",
          Stargaze: "channel-17",
          Osmosis: "channel-19",
          Dymension: "channel-18",
          Evmos: "channel-20"
        }
      ],
      ["Cosmoshub", { Wormchain: "channel-3086" }],
      ["Injective", { Wormchain: "channel-76973" }],
      ["Kujira", { Wormchain: "channel-114" }],
      ["Osmosis", { Wormchain: "channel-7904" }],
      ["Stargaze", { Wormchain: "channel-949" }],
      ["Evmos", { Wormchain: "channel-240" }],
      ["Dymension", { Wormchain: "channel-23" }]
    ]
  ],
  [
    "Devnet",
    [
      ["Wormchain", { Cosmoshub: "channel-1", Osmosis: "channel-2" }],
      ["Cosmoshub", { Wormchain: "channel-1" }],
      ["Osmosis", { Wormchain: "channel-1" }]
    ]
  ]
];
Do(OT);
const zT = [
  [
    "Mainnet",
    [
      ["Injective", "https://lcd.injective.network"],
      ["Evmos", "https://rest.bd.evmos.org:1317"]
    ]
  ],
  [
    "Testnet",
    [
      ["Injective", "https://k8s.testnet.lcd.injective.network"],
      ["Evmos", "https://rest.bd.evmos.dev:1317"]
    ]
  ],
  [
    "Devnet",
    [
      ["Injective", "https://localhost:1234"],
      ["Evmos", "https://localhost:1233"]
    ]
  ]
];
Do(zT);
const kT = [
  [
    "Mainnet",
    [
      ["Terra2", "0.015"],
      ["Osmosis", "0.025"],
      ["Sei", "0.02"],
      ["Cosmoshub", "0.025"],
      ["Kujira", "0.0051"],
      ["Neutron", "0.075"],
      ["Celestia", "0.02"],
      ["Stargaze", "1.1"],
      ["Injective", "700000000"],
      ["Evmos", "25000000000"],
      ["Dymension", "5000000000"],
      ["Provenance", "2100"],
      ["Noble", "0.1"]
    ]
  ]
];
Do(kT);
const $M = "Cosmwasm";
function O5(e) {
  try {
    const t = Ya.decodeToBytes(e);
    return { data: t.bytes, prefix: t.prefix };
  } catch {
  }
  try {
    return { data: Ic.decode(e) };
  } catch {
  }
  try {
    return { data: d9.decode(e) };
  } catch {
  }
  throw new Error(`Cannot decode: ${e}`);
}
const qr = class qr {
  constructor(t) {
    // the actual bytes of the address
    zt(this, "address");
    // The domain is the prefix for the address, like "cosmos" or "ibc"
    zt(this, "domain");
    // The denom is the token name, like "uatom" or "usdc"
    zt(this, "denom");
    // The denomType is "native", "ibc", or "factory"
    zt(this, "denomType");
    if (qr.instanceof(t)) {
      const o = t;
      this.address = o.address, this.domain = o.domain, this.denom = o.denom, this.denomType = o.denomType;
      return;
    }
    if (typeof t == "string") {
      if (t.length <= 8) {
        this.address = new Uint8Array(0), this.denom = t, this.denomType = "native";
        return;
      }
      if (t.indexOf("/") !== -1) {
        const o = t.split("/");
        if (o.length >= 3) {
          const { data: i, prefix: c } = O5(o[o.length - 2]);
          this.address = i, this.domain = c, this.denom = o[o.length - 1], this.denomType = o.slice(0, o.length - 2).join("/");
        } else {
          const { data: i } = O5(o[1]);
          this.address = i, this.denomType = o[0];
        }
      } else {
        if (!qr.isValidAddress(t))
          throw new Error(`Invalid Cosmwasm address:  ${t}`);
        const { bytes: o, prefix: i } = Ya.decodeToBytes(t);
        this.address = o, this.domain = i;
      }
    } else if (t instanceof Uint8Array)
      this.address = t;
    else if (lo.instanceof(t))
      this.address = t.toUint8Array();
    else
      throw new Error(`Invalid Cosmwasm address ${t}`);
    if (!qr.validAddressLength(this.address))
      throw new Error("Expected 20 or 32 bytes address");
  }
  unwrap() {
    return this.toString();
  }
  toString() {
    return this.denomType !== void 0 ? this.denomType === "native" ? this.denom : this.denomType === "ibc" ? `${this.denomType.toLowerCase()}/${Ic.encode(this.address).toUpperCase()}` : `${this.denomType}/${qr.encode(this.domain, this.address)}/${this.denom}` : qr.encode(this.domain, this.address);
  }
  toNative() {
    return this;
  }
  toUint8Array() {
    return this.address;
  }
  toUniversalAddress() {
    const t = new Uint8Array(lo.byteSize);
    return t.set(this.address, lo.byteSize - this.address.length), new lo(t);
  }
  setChain(t) {
    this.domain = jT.get(t);
  }
  static isValidAddress(t) {
    try {
      const o = Ya.decodeToBytes(t);
      return qr.validAddressLength(o.bytes);
    } catch {
    }
    return !1;
  }
  static encode(t, o) {
    return Ya.encode(t, Ya.toWords(o));
  }
  static validAddressLength(t) {
    if (t.length !== qr.contractAddressByteSize && t.length !== qr.accountAddressByteSize)
      throw new Error(`Invalid Cosmwasm address, expected ${qr.contractAddressByteSize} or ${qr.accountAddressByteSize} bytes but got ${t.length}`);
    return !0;
  }
  static instanceof(t) {
    return t.constructor.platform === qr.platform;
  }
  equals(t) {
    return qr.instanceof(t) ? this.toString() === t.toString() : t.equals(this.toUniversalAddress());
  }
};
zt(qr, "contractAddressByteSize", 32), zt(qr, "accountAddressByteSize", 20), zt(qr, "platform", $M);
let m1 = qr;
sg($M, m1);
async function _T(e) {
  try {
    const t = await Promise.all(e.map(async (o) => o()));
    return await Promise.all(t.map(async (o) => await BT(o))), t;
  } catch (t) {
    throw console.error("Failed to load required packages", t), t;
  }
}
async function BT(e, t) {
  try {
    let o = Object.entries(e.protocols);
    await Promise.all(o.map(([, i]) => i()));
  } catch (o) {
    throw console.error("Failed to load required packages", o), o;
  }
}
async function FT(e, t, o) {
  const i = (await _T(t)).map((c) => c.Platform);
  return new un(e, i, o);
}
const RT = async () => (await import("./evm-C7EJC6tH.mjs")).default, PT = async () => (await import("./solana-Dt62nVQj.mjs")).default, UT = async () => (await import("./aptos-BpDuEuNq.mjs")).default, YT = async () => (await import("./sui-Cag7qq4D.mjs")).default, WT = "https://api.coingecko.com", HT = "https://pro-api.coingecko.com", z5 = {
  Solana: "solana",
  Ethereum: "ethereum",
  Arbitrum: "ethereum",
  Optimism: "ethereum",
  Base: "ethereum",
  Scroll: "ethereum",
  Bsc: "binancecoin",
  Polygon: "matic-network",
  Avalanche: "avalanche-2",
  Fantom: "fantom",
  Moonbeam: "moonbeam",
  Klaytn: "kaia",
  Xlayer: "okb",
  Mantle: "mantle",
  Aptos: "aptos",
  Sui: "sui",
  Berachain: "berachain-bera",
  Unichain: "ethereum",
  Sonic: "sonic-3",
  Linea: "ethereum",
  Worldchain: "ethereum"
  // TODO: add Mezo when available
}, ZT = {
  Bsc: "binance-smart-chain",
  Arbitrum: "arbitrum-one",
  Optimism: "optimistic-ethereum",
  Polygon: "polygon-pos",
  Klaytn: "klay-token",
  Xlayer: "x-layer",
  Worldchain: "world-chain"
}, v1 = async (e, t) => {
  var c, n, d, f;
  const o = new Headers({
    ...(c = ge.coingecko) != null && c.apiKey ? { "x-cg-pro-api-key": ge.coingecko.apiKey } : {}
  }), i = (n = ge.coingecko) != null && n.customUrl ? ge.coingecko.customUrl : (d = ge.coingecko) != null && d.apiKey ? HT : WT;
  return fetch(`${i}${e}`, {
    signal: (f = t == null ? void 0 : t.abort) == null ? void 0 : f.signal,
    headers: o
  }).then((p) => p.json()).catch((p) => (console.error("Error fetching from Coingecko", p), null));
}, QT = async (e, t) => ge.network !== "Mainnet" ? null : v1(
  `/api/v3/coins/${e.chain.toLowerCase()}/contract/${e.address.toString()}`,
  t
), VT = async (e, t) => {
  const o = new Ys();
  if (ge.network !== "Mainnet") return o;
  const i = {}, c = [];
  for (const f of e)
    Wi(f.address) ? c.push(f) : (i[f.chain] === void 0 && (i[f.chain] = []), i[f.chain].push(f.address.toString()));
  const n = Object.keys(i).map((f) => {
    const p = i[f];
    return new Promise((l, h) => {
      const y = p.join(","), M = ZT[f] || f.toLowerCase();
      v1(
        `/api/v3/simple/token_price/${M}?contract_addresses=${y}&vs_currencies=usd`,
        t
      ).then((C) => {
        C.error !== void 0 || C.error_code !== void 0 ? h(C.error) : l(
          Object.keys(C).map((N) => {
            try {
              const w = un.tokenId(f, N);
              return C[N] ? {
                tokenId: w,
                price: C[N].usd
              } : null;
            } catch (w) {
              return console.error("Coingecko error", w), null;
            }
          }).filter((N) => N !== null)
        );
      }).catch(h);
    });
  });
  c.length > 0 && n.push(
    new Promise((f, p) => {
      const l = [];
      for (const h of c) {
        const y = z5[h.chain];
        y ? l.push(y) : console.error(
          `Don't know a coingecko ID for native token for chain ${h.chain}`
        );
      }
      v1(
        `/api/v3/simple/price?ids=${l.join(",")}&vs_currencies=usd`,
        t
      ).then(
        (h) => f(
          c.map((y) => {
            const M = z5[y.chain];
            if (M) {
              const { usd: C } = h[M];
              return {
                tokenId: y,
                price: C
              };
            } else
              return null;
          }).filter((y) => !!y)
        )
      ).catch(p);
    })
  );
  const d = (await Promise.allSettled(n)).map((f) => f.status === "fulfilled" ? f.value : null).filter((f) => !!f).flat();
  for (const { tokenId: f, price: p } of d)
    o.add(f, p);
  return o;
}, GT = 1, k5 = typeof localStorage < "u";
class To {
  constructor(t, o) {
    zt(this, "chain");
    zt(this, "addressString");
    zt(this, "_address");
    this.chain = t, this.addressString = o;
  }
  get address() {
    return Wi(this.addressString) ? this.addressString : (this._address || (this._address = ki(
      this.chain,
      this.addressString
    )), this._address);
  }
  static fromTokenTuple(t) {
    return new To(t[0], t[1]);
  }
}
class ha extends To {
  constructor(o, i, c, n, d, f, p, l) {
    super(o, i);
    zt(this, "decimals");
    zt(this, "symbol");
    zt(this, "name");
    // Display info
    zt(this, "icon");
    // If this is a Wormhole Token Bridge wrapped token, tokenBridgeOriginalTokenId
    // is the original token's TokenId. Otherwise, it's just undefined.
    zt(this, "tokenBridgeOriginalTokenId");
    // web_slug in Coingecko API response
    // Corresponds to URLs like https://www.coingecko.com/en/coins/:id
    zt(this, "coingeckoWebId");
    // Flag that's set to true if the token was built in to Connect via config
    // Used when filtering out unknown/unverified tokens
    zt(this, "isBuiltin");
    this.decimals = c, this.symbol = n, this.name = d, this.icon = f, this.tokenBridgeOriginalTokenId = p, this.coingeckoWebId = l;
  }
  get display() {
    return this.name ? this.name : this.symbol !== "" ? this.symbol : this.shortAddress;
  }
  get shortAddress() {
    const o = this.addressString;
    return `${o.substring(0, 5)}...${o.substring(o.length - 6)}`;
  }
  get tuple() {
    return [this.chain, this.addressString];
  }
  get key() {
    return Bn(this.tokenId);
  }
  get tokenId() {
    return {
      chain: this.chain,
      address: this.address
    };
  }
  get isNativeGasToken() {
    return Wi(this.address);
  }
  get isTokenBridgeWrappedToken() {
    return !!this.tokenBridgeOriginalTokenId;
  }
  get nativeChain() {
    var o;
    return ((o = this.tokenBridgeOriginalTokenId) == null ? void 0 : o.chain) || this.chain;
  }
  equals(o) {
    return Th(this, o);
  }
  toJson() {
    return {
      chain: this.chain,
      address: this.addressString,
      decimals: this.decimals,
      symbol: this.symbol,
      name: this.name ?? "",
      icon: this.icon ? this.icon : "",
      tokenBridgeOriginalTokenId: this.tokenBridgeOriginalTokenId ? qM(this.tokenBridgeOriginalTokenId) : void 0,
      coingeckoWebId: this.coingeckoWebId
    };
  }
  static fromJson({
    chain: o,
    address: i,
    decimals: c,
    symbol: n,
    name: d,
    icon: f,
    tokenBridgeOriginalTokenId: p,
    coingeckoWebId: l
  }) {
    return new ha(
      o,
      i,
      c,
      n,
      d,
      f === "" ? void 0 : f,
      p ? Xc(p) : void 0,
      l
    );
  }
}
class Ys {
  constructor() {
    zt(this, "lastUpdate");
    zt(this, "_localStorageKey");
    // Mapping of Chain -> token address -> T
    zt(this, "_mapping");
    zt(this, "size");
    this.lastUpdate = /* @__PURE__ */ new Date(), this._mapping = /* @__PURE__ */ new Map(), this.size = 0;
  }
  add(t, o) {
    this._mapping.has(t.chain) || this._mapping.set(t.chain, /* @__PURE__ */ new Map()), this._mapping.get(t.chain).set(ds(t).toLowerCase(), o), this.lastUpdate = /* @__PURE__ */ new Date(), this.size += 1;
  }
  get(t, o) {
    var i, c, n, d, f;
    if (typeof t == "string" && typeof o == "string" && cg(t))
      return (i = this._mapping.get(t)) == null ? void 0 : i.get(o.toLowerCase());
    if (t instanceof To)
      return (c = this._mapping.get(t.chain)) == null ? void 0 : c.get(t.addressString.toLowerCase());
    if (p9(t))
      return (n = this._mapping.get(t.chain)) == null ? void 0 : n.get(t.address.toString().toLowerCase());
    if (Ah(t))
      return (d = this._mapping.get(t[0])) == null ? void 0 : d.get(t[1].toLowerCase());
    {
      const p = JM(t);
      return (f = this._mapping.get(p.chain)) == null ? void 0 : f.get(ds(p).toLowerCase());
    }
  }
  mustGet(t, o) {
    const i = this.get(t, o);
    if (!i)
      throw new Error("Failed to get token");
    return i;
  }
  getList(t) {
    return t.map((o) => this.get(o)).filter((o) => o !== void 0);
  }
  getAllForChain(t) {
    const o = this._mapping.get(t);
    return o ? Array.from(o.values()) : [];
  }
  getAll() {
    return Array.from(this._mapping.values()).flatMap(
      (t) => Array.from(t.values())
    );
  }
  get chains() {
    return Array.from(this._mapping.keys());
  }
  // Merge values from another TokenMapping into this one
  merge(t) {
    t.forEach(this.add);
  }
  // Removes all records from the TokenMapping
  clear() {
    this.lastUpdate = /* @__PURE__ */ new Date(), this._mapping = /* @__PURE__ */ new Map(), this.size = 0;
  }
  forEach(t) {
    this._mapping.forEach((o, i) => {
      o.forEach((c, n) => {
        const d = new To(i, n);
        t(d, c);
      });
    });
  }
  get empty() {
    return this.size === 0;
  }
  // Create a deep copy of this TokenMapping
  clone() {
    const t = new Ys();
    return this.forEach((o, i) => {
      t.add(o, i);
    }), t;
  }
}
class sc extends Ys {
  add(t) {
    if (t.tokenBridgeOriginalTokenId) {
      const o = this.get(t.tokenBridgeOriginalTokenId);
      o && (t.icon = o.icon, t.name = o.name, t.symbol = o.symbol);
    }
    super.add(t, t);
  }
  // Fetches token metadata (decimals, symbol)
  getGasToken(t) {
    return t === "Celo" ? this.findBySymbol("Celo", "CELO") : this.get(t, "native");
  }
  findByAddressOrSymbol(t, o) {
    const i = this.get(t, o);
    if (i) return i;
    const c = this.findBySymbol(t, o);
    if (c) return c;
  }
  // Queries tokens by symbol. If query is 1 or 2 characters, we look only for prefix matches
  queryBySymbol(t, o) {
    return this.getAllForChain(t).filter((i) => {
      var c;
      return i.symbol.toLowerCase().startsWith(o.toLowerCase()) || ((c = i.name) == null ? void 0 : c.toLowerCase().startsWith(o.toLowerCase()));
    });
  }
  // This should be used sparingly/never... use addresses instead.
  // Excludes wrapped tokens
  findBySymbol(t, o) {
    let i = this.getAllForChain(t).filter(
      (c) => c.symbol.toLowerCase() === o.toLowerCase()
    );
    if (i.length > 1 && (i = i.filter((c) => !c.isTokenBridgeWrappedToken)), i.length === 1)
      return i[0];
    i.length > 1 && console.error(`Ambiguous token symbol: ${o}`);
  }
  setLocalStorageKey(t) {
    this._localStorageKey = t;
  }
  async addFromTokenId(t) {
    var C, N;
    if (t.chain === "Sui" && !z9(t.address.toString()))
      throw new Error(
        `Not a valid Sui token address: ${t.address.toString()}`
      );
    const o = await gn(), i = o.getChain(t.chain), c = await i.getDecimals(t.address), n = await QT(t);
    let d = ((C = n == null ? void 0 : n.symbol) == null ? void 0 : C.toUpperCase()) || "", f = (n == null ? void 0 : n.name) || "", p = ((N = n == null ? void 0 : n.image) == null ? void 0 : N.large) || null;
    const l = n == null ? void 0 : n.web_slug;
    if (!d) {
      const { getTokenMetadataFromRpc: w } = await import("./tokens-ljeiMA4W.mjs"), S = await w(t);
      S && (console.info("Got metadata from RPC", S), d = S.symbol, f = S.name, p = S.icon);
    }
    let h;
    const y = await i.getTokenBridge();
    if (await y.isWrappedAsset(t.address) && (h = await y.getOriginalAsset(t.address), lo.instanceof(h.address) && (h.address = await o.getTokenNativeAddress(
      h.chain,
      h.chain,
      h.address
    )), h)) {
      const w = this.get(h);
      w && w.icon && (p = w.icon, d = w.symbol);
    }
    const M = new ha(
      t.chain,
      h9(t),
      c,
      d,
      f,
      p,
      h,
      l
    );
    return this.add(M), M;
  }
  persist() {
    if (k5 && this._localStorageKey) {
      const t = {
        version: GT,
        tokens: {}
      };
      this.forEach((i, c) => {
        t.tokens[Bn(i)] = c.toJson();
      });
      const o = JSON.stringify(t);
      localStorage.setItem(this._localStorageKey, o);
    }
  }
  static load(t) {
    if (k5) {
      const i = localStorage.getItem(t);
      if (i)
        try {
          const c = JSON.parse(i), n = new sc();
          n.setLocalStorageKey(t);
          for (const [, d] of Object.entries(c.tokens)) {
            const f = ha.fromJson(d);
            n.add(f);
          }
          return n;
        } catch (c) {
          console.error("Error parsing cached TokenCache", c);
        }
    }
    const o = new sc();
    return o.setLocalStorageKey(t), o;
  }
}
function $T(e, t, o) {
  const i = sc.load(o);
  for (const { tokenId: c, symbol: n, name: d, icon: f, decimals: p } of e) {
    const l = new ha(
      c.chain,
      c.address.toString(),
      p,
      n,
      d,
      f
    );
    l.isBuiltin = !0, i.add(l);
  }
  for (const c in t)
    for (const n in t[c]) {
      const d = t[c][n];
      for (const f in d) {
        const p = i.get(c, n);
        if (p) {
          const l = d[f];
          let h = Vr(f) === "Evm" ? 18 : 8;
          h = Math.min(h, p.decimals);
          const y = new ha(
            f,
            l,
            h,
            p.symbol,
            p.name,
            p.icon,
            p
          );
          y.isBuiltin = !0, i.add(y);
        }
      }
    }
  return i.persist(), i;
}
function Ah(e) {
  return Array.isArray(e) && e.length == 2 && cg(e[0]);
}
function qM(e) {
  return [e.chain, ds(e)];
}
function Xc(e) {
  return To.fromTokenTuple(e);
}
function Bn(e, t) {
  return JSON.stringify(typeof e == "string" ? [e, t] : qM(e));
}
function JM(e) {
  const t = JSON.parse(e);
  if (Ah(t))
    return Xc(t);
  throw new Error(`Invalid token key "${e}"; couldn't parse`);
}
function ds(e) {
  return e instanceof To ? e.addressString : e.address.toString();
}
function Th(e, t) {
  return e.chain === t.chain && e.addressString === t.addressString;
}
const qT = "insufficient_allowance", SR = "swap_failed", ER = "source_contract_paused", DR = "destination_contract_paused", jR = "unsupported_abi_version", _5 = "insufficient_gas", JT = "amount_too_large", XT = "amount_too_small", XM = "user_rejected", KT = "user_timeout", eL = "unknown", tL = "relay_failed", rL = /insufficient token allowance/im, B5 = /insufficient lamports.*?(\d+).*?(\d+)/im, nL = new RegExp(
  "user rejected|rejected the request|rejected from user|user cancel|aborted by user|plugin closed|denied request signature",
  "mi"
), iL = new RegExp("AmountInTooSmall", "m");
function b1(e, t) {
  let o = "Error with transfer, please try again", i = eL;
  if (e.message) {
    if (e instanceof lg)
      o = e.message, i = tL;
    else if (rL.test(e == null ? void 0 : e.message))
      o = "Error with transfer, please try again", i = qT;
    else if (e.name === "TransactionExpiredTimeoutError" || e.name === "TransactionExpiredBlockheightExceededError")
      o = "Transfer timed out, please try again", i = KT;
    else if (o1.MESSAGE_REGEX.test(e == null ? void 0 : e.message))
      o = "Insufficient funds", i = _5;
    else if (nL.test(e == null ? void 0 : e.message))
      o = "Transfer rejected in wallet, please try again", i = XM;
    else if (iL.test(e == null ? void 0 : e.message))
      o = "Amount is too small for the selected route", i = XT;
    else if (t.route.includes("CCTP") && /burn.*exceed/i.test(e == null ? void 0 : e.toString())) {
      const { amount: n } = t;
      o = `Amount exceeds Circle limit${n !== void 0 && oi(n) > 1e6 ? " of 1,000,000" : ""}. Please reduce transfer amount.`, i = JT;
    } else if (B5.test(e == null ? void 0 : e.message)) {
      const c = e == null ? void 0 : e.message.match(B5), n = c == null ? void 0 : c[1], d = c == null ? void 0 : c[2];
      if (o = "Insufficient funds for gas.", n && d) {
        const f = yn(n, 9), p = yn(d, 9);
        o += ` Current balance is ${cr(
          f
        )} SOL, but required ${cr(p)} SOL`;
      }
      i = _5;
    }
  }
  return [o, { type: i, original: e }];
}
function KM(e, t) {
  e instanceof Error && e.message.startsWith("No protocols registered for") || console.error(t ? `${t}: ${e}` : e);
}
class OR extends Error {
  constructor() {
    super("Not supported");
  }
}
class zR extends Error {
  constructor() {
    super("Not connected");
  }
}
var F5;
(function(e) {
  e.SignTransaction = "SignTransaction", e.SendTransaction = "SendTransaction", e.SignAndSendTransaction = "SignAndSendTransaction", e.SignMessage = "SignMessage";
})(F5 || (F5 = {}));
var hs;
(function(e) {
  e.Installed = "Installed", e.NotDetected = "NotDetected", e.Loadable = "Loadable", e.Unsupported = "Unsupported";
})(hs || (hs = {}));
class oL extends g9 {
  /**
   * Retrieve the wallet's current state
   *
   * The possible states are as those used by the {@link https://github.com/solana-labs/wallet-adapter solana} and {@link https://github.com/aptos-labs/aptos-wallet-adapter aptos} libraries, summarized as follows:
   *  * `Installed`: the wallet was detected through the global scope or any other mechanism and can be interacted with. Example: `window.ethereum` for Metamask or `window.phantom` for Phantom wallet)
   *  * `NotDetected`: as opposed to `Installed`, no point of interaction with the wallet was found, and thus it is not available. Users can be redirected to the project url offered by `getUrl`
   *  * `Loadable`: the wallet might not require installation, and thus can be interacted with after being loaded
   *  * `Unsupported`: the wallet is not supported by the environment
   *
   * @returns The wallet's state. Defaults to Installed.
   */
  getWalletState() {
    return hs.Installed;
  }
  /**
   * Query whether a feature or set of features is supported by the wallet.
   * For a list of features see {@link BaseFeatures}.
   * Some chains might add additional features of their own.
   */
  supportsFeature(t) {
    const o = this.getFeatures();
    return Array.isArray(t) ? t.every((i) => o.includes(i)) : o.includes(t);
  }
}
const vr = {
  unset: 0,
  solana: 1,
  ethereum: 2,
  terra: 3,
  bsc: 4,
  polygon: 5,
  avalanche: 6,
  oasis: 7,
  algorand: 8,
  aurora: 9,
  fantom: 10,
  karura: 11,
  acala: 12,
  klaytn: 13,
  celo: 14,
  near: 15,
  moonbeam: 16,
  neon: 17,
  terra2: 18,
  injective: 19,
  osmosis: 20,
  sui: 21,
  aptos: 22,
  arbitrum: 23,
  optimism: 24,
  gnosis: 25,
  pythnet: 26,
  xpla: 28,
  btc: 29,
  base: 30,
  sei: 32,
  rootstock: 33,
  //
  scroll: 34,
  mantle: 35,
  blast: 36,
  xlayer: 37,
  linea: 38,
  berachain: 39,
  seievm: 40,
  unichain: 44,
  worldchain: 45,
  monad: 48,
  wormchain: 3104,
  cosmoshub: 4e3,
  evmos: 4001,
  kujira: 4002,
  neutron: 4003,
  celestia: 4004,
  stargaze: 4005,
  seda: 4006,
  dymension: 4007,
  provenance: 4008,
  sepolia: 10002,
  arbitrum_sepolia: 10003,
  base_sepolia: 10004,
  optimism_sepolia: 10005,
  holesky: 10006,
  polygon_sepolia: 10007
};
Object.entries(vr).reduce(
  (e, [t, o]) => (e[o] = t, e),
  {}
  // eslint-disable-line
);
const kR = vr.solana, aL = vr.ethereum, sL = vr.bsc, cL = vr.polygon, lL = vr.avalanche, fL = vr.oasis, uL = vr.aurora, dL = vr.fantom, hL = vr.karura, pL = vr.acala, gL = vr.klaytn, yL = vr.celo, ML = vr.moonbeam, mL = vr.neon, _R = vr.sui, BR = vr.aptos, vL = vr.arbitrum, bL = vr.optimism, xL = vr.gnosis, wL = vr.base, CL = vr.scroll, IL = vr.mantle, NL = vr.blast, AL = vr.xlayer, TL = vr.worldchain, LL = vr.unichain, SL = vr.monad;
function FR(e) {
  return e === aL || e === sL || e === lL || e === cL || e === fL || e === uL || e === dL || e === hL || e === pL || e === gL || e === yL || e === ML || e === mL || e === vL || e === bL || e === xL || e === wL || e === CL || e === TL || e === NL || e === AL || e === IL || e === LL || e === SL;
}
const Cc = class Cc extends oL {
  constructor(o, i) {
    super();
    zt(this, "_isConnected", !0);
    this._address = o, this._chain = i;
  }
  getName() {
    return Cc.NAME;
  }
  getUrl() {
    return "";
  }
  async connect() {
    return this._isConnected = !0, this.emit("connect"), [this._address.toString()];
  }
  async disconnect() {
    this._isConnected = !1, this.emit("disconnect");
  }
  getChainId() {
    return y9(this._chain);
  }
  getNetworkInfo() {
    throw new Error("Method not implemented.");
  }
  getAddress() {
    return this._address.toString();
  }
  getAddresses() {
    return [this.getAddress()];
  }
  setMainAddress(o) {
  }
  async getBalance() {
    throw new Error("Address only wallet cannot fetch balance");
  }
  isConnected() {
    return this._isConnected;
  }
  getIcon() {
    return "";
  }
  async signTransaction(o) {
    throw new Error("Address only wallet cannot sign transactions");
  }
  async sendTransaction(o) {
    throw new Error("Address only wallet cannot send transactions");
  }
  async signMessage(o) {
    throw new Error("Address only wallet cannot sign messages");
  }
  async signAndSendTransaction(o) {
    throw new Error("Address only wallet cannot sign or send transactions");
  }
  getFeatures() {
    return [];
  }
  supportsChain(o) {
    return this.getChainId() === o;
  }
};
zt(Cc, "NAME", "ReadOnlyWallet");
let Lo = Cc;
const Xa = {
  address: "",
  type: void 0,
  currentAddress: "",
  error: "",
  icon: void 0,
  name: ""
}, R5 = {
  sending: Xa,
  receiving: Xa
}, e8 = Ca({
  name: "wallet",
  initialState: R5,
  reducers: {
    connectWallet: (e, { payload: t }) => {
      e.sending.address = t.address, e.sending.currentAddress = t.address, e.sending.type = t.type, e.sending.name = t.name, e.sending.error = "", e.sending.icon = t.icon;
    },
    connectReceivingWallet: (e, { payload: t }) => {
      e.receiving.address = t.address, e.receiving.currentAddress = t.address, e.receiving.type = t.type, e.receiving.name = t.name, e.receiving.error = "", e.receiving.icon = t.icon;
    },
    clearWallet: (e, { payload: t }) => {
      e[t] = Xa;
    },
    disconnectWallet: (e, { payload: t }) => {
      U5(t), e[t] = Xa;
    },
    setWalletError: (e, { payload: t }) => {
      const { type: o, error: i } = t;
      e[o].error = i;
    },
    setAddress: (e, { payload: t }) => {
      const { type: o, address: i } = t;
      e[o].address = i, e[o].currentAddress = i;
    },
    clearWallets: (e) => {
      Object.keys(e).forEach((t) => {
        e[t] = R5[t];
      });
    },
    swapWallets: (e) => {
      const t = e.sending;
      e.sending = e.receiving, e.receiving = t, _L(), e.sending.name === Lo.NAME && (U5(ar.SENDING), e[ar.SENDING] = Xa);
    }
  }
}), {
  connectWallet: EL,
  connectReceivingWallet: DL,
  clearWallet: pa,
  setAddress: RR,
  setWalletError: jL,
  clearWallets: OL,
  disconnectWallet: t8,
  swapWallets: r8
} = e8.actions, zL = e8.reducer;
var ar = /* @__PURE__ */ ((e) => (e.SENDING = "sending", e.RECEIVING = "receiving", e))(ar || {});
const ho = {
  sending: void 0,
  receiving: void 0
}, n8 = (e) => e ? ge.chainsArr.filter((t) => Vr(t.sdkName) === e).map((t) => t.sdkName) : ge.chainsArr.map((t) => t.sdkName), kL = (e, t) => {
  ho[e] = t;
}, ps = async (e, t, o, i) => {
  const { wallet: c, name: n } = o;
  if (kL(e, c), !ge.chains[t])
    throw new Error(`Unable to find wallets for chain ${t}`);
  const f = Vr(t), p = M9.get(
    ge.network,
    t
  );
  try {
    const y = typeof p == "bigint" ? Number(p) : p;
    await c.connect({ chainId: y });
  } catch (y) {
    if (y.message && y.message.toLowerCase().includes("rejected"))
      return console.info("User rejected wallet connection"), !1;
    throw y;
  }
  ge.triggerEvent({
    type: "wallet.connect",
    details: {
      side: e,
      chain: t,
      wallet: o.name.toLowerCase()
    }
  });
  const l = c.getAddress(), h = {
    address: l,
    type: o.type,
    icon: c.getIcon(),
    name: c.getName()
  };
  return i(e === "sending" ? EL(h) : DL(h)), c.on("disconnect", () => {
    c.removeAllListeners(), setTimeout(() => {
      i(pa(e));
    }, 0), localStorage.removeItem(ge.cacheKey(`wallet:${f}`));
  }), c.on("accountsChanged", (y) => {
    (y.length === 0 || y.length && l && y[0] !== l) && c.disconnect();
  }), n !== Lo.NAME && localStorage.setItem(ge.cacheKey(`wallet:${f}`), n), !0;
}, P5 = async (e, t, o) => {
  const i = ge.chains[t], c = ge.cacheKey(
    `wallet:${Vr(i.sdkName)}`
  ), n = localStorage.getItem(c);
  if (n && n !== "WalletConnect") {
    const f = (await i8(i)).find((p) => p.name === n);
    if (f)
      try {
        await ps(e, t, f, o) || localStorage.removeItem(c);
      } catch (p) {
        throw localStorage.removeItem(c), new Error(
          `Failed to autoconnect to wallet ${n} for ${t}: ${p.message}`
        );
      }
  }
}, Lh = (e, t) => {
  const o = Cr(), [i, c] = Xe(!1);
  return St(() => {
    if (!e && !t)
      return;
    let n = !1;
    const d = async () => {
      try {
        e && !n && await P5(
          "sending",
          e,
          o
        ), t && !n && await P5(
          "receiving",
          t,
          o
        );
      } finally {
        c(!1);
      }
    };
    return c(!0), d(), () => {
      n = !0;
    };
  }, [e, t, o]), { isConnecting: i };
}, _L = () => {
  const e = ho.sending;
  ho.sending = ho.receiving, ho.receiving = e;
}, U5 = async (e) => {
  const t = ho[e];
  t && await t.disconnect();
}, BL = async (e, t, o, i = {}) => {
  const c = ge.chains[e], n = ho[o];
  if (!n)
    throw new Error("wallet is undefined");
  const d = Vr(c.sdkName);
  if (d === "Evm")
    return await (await import("./evm-BJBY7l-e.mjs")).signAndSendTransaction(
      t,
      n,
      e
    );
  if (d === "Solana")
    return await (await import("./solana-BHx4qnxI.mjs").then((l) => l.V)).signAndSendTransaction(
      t,
      n,
      i
    );
  if (d === "Sui")
    return (await (await import("./sui-uF5G-yQ5.mjs")).signAndSendTransaction(
      t,
      n
    )).id;
  if (d === "Aptos")
    return (await (await import("./aptos-C3IAPkHA.mjs")).signAndSendTransaction(
      t,
      n
    )).id;
  throw new Error("unimplemented");
}, FL = (e) => {
  const t = e.getWalletState();
  return t !== hs.Unsupported && t !== hs.NotDetected;
}, v0 = (e, t, o = []) => Object.values(e).filter(
  (i, c, n) => c === n.findIndex((d) => d.getName() === i.getName())
).filter((i) => !o.includes(i.getName())).map((i) => ({
  wallet: i,
  type: t,
  name: i.getName(),
  icon: i.getIcon(),
  isReady: FL(i)
}));
function RL() {
  return typeof window < "u" && window.ethereum && window.ethereum.isNightly === !0;
}
const i8 = async (e) => {
  if (e === void 0)
    return [];
  const t = Vr(e.sdkName);
  if (t === "Evm") {
    const o = await import("./evm-BJBY7l-e.mjs");
    let i = Object.values(v0(o.getWallets(), t));
    return RL() && (i = i.filter((c) => c.name !== "Injected Wallet")), i;
  } else if (t === "Solana") {
    const i = (await import("./solana-BHx4qnxI.mjs").then((c) => c.V)).fetchOptions();
    return Object.values(v0(i, t));
  } else if (t === "Sui") {
    const i = await (await import("./sui-uF5G-yQ5.mjs")).fetchOptions();
    return Object.values(v0(i, t));
  } else if (t === "Aptos") {
    const i = await (await import("./aptos-C3IAPkHA.mjs")).fetchOptions();
    return Object.values(v0(i, t));
  }
  return [];
};
class gs {
  constructor(t, o, i, c, n) {
    zt(this, "_chain");
    zt(this, "_chainContextV2");
    zt(this, "_address");
    zt(this, "_options");
    zt(this, "_walletType");
    this._chain = t, this._chainContextV2 = o, this._address = i, this._options = c, this._walletType = n;
  }
  static async fromChain(t, o, i, c) {
    const d = (await gn()).getPlatform(Vr(t)).getChain(t);
    return new gs(t, d, o, i, c);
  }
  static async fromPrivateKey(t) {
    const c = (await gn()).getPlatform(Vr(t)).getChain(t).platform.utils()._platform;
    switch (c) {
      case "Evm":
        throw new Error("Missing Ethereum private key");
      case "Solana":
        throw new Error("Missing Solana private key");
      case "Sui":
        throw new Error("Missing Sui private key");
      default:
        throw new Error(`Unrecognized platform: ${c}`);
    }
  }
  async signAndSend(t) {
    const o = [];
    for (const i of t) {
      const c = await BL(
        this._chain,
        i,
        this._walletType,
        this._options
      );
      o.push(c);
    }
    return o;
  }
  chain() {
    return this._chainContextV2.chain;
  }
  address() {
    return this._address;
  }
}
class PL {
  constructor(t) {
    zt(this, "cache", /* @__PURE__ */ new Map());
    zt(this, "pendingRequests", /* @__PURE__ */ new Map());
    this.TTLms = t;
  }
  // TODO: Make TTL configurable per request
  async requestWithCache(t, o) {
    const i = Date.now(), c = this.cache.get(t);
    if (c && i - c.timestamp < this.TTLms) {
      if (console.debug("[Cache Debug] Cache HIT - using cached value"), c.isError)
        throw c.value;
      return c.value;
    }
    let n = this.pendingRequests.get(t);
    return n ? console.debug("[Cache Debug] Cache MISS - using pending request") : (console.debug("[Cache Debug] Cache MISS - initiating new request"), n = o().then((d) => (this.cache.set(t, {
      value: d,
      timestamp: Date.now(),
      isError: !1
    }), this.pendingRequests.delete(t), d)).catch((d) => {
      throw console.debug("[Cache Debug] Cache ERROR - storing error"), this.cache.set(t, {
        value: d,
        timestamp: Date.now(),
        isError: !0
      }), this.pendingRequests.delete(t), d;
    }), this.pendingRequests.set(t, n)), n;
  }
}
function UL(e) {
  return e.length === 22 ? e : `0x${e.slice(e.length - 40, e.length)}`;
}
function ji(e, t = 6) {
  return e.slice(0, t) + "..." + e.slice(e.length - 4, e.length);
}
function o8(e, t = 6, o = 4) {
  const i = e.slice(0, t), c = e.slice(e.length - o, e.length);
  return `${i}...${c}`;
}
function Kc(e, t) {
  return e ? e === "Evm" ? ji(UL(t)) : e === "Solana" ? ji(t, 4) : ji(t) : "";
}
function Y5(e) {
  const t = ge.tokens.getGasToken(e);
  if (!t) throw new Error(`gas token not found for ${e}`);
  return t;
}
function a8(e) {
  const t = ge.chains[e];
  return t ? t.displayName : e;
}
function W5(e) {
  const t = document.createElement("textarea");
  t.value = e, t.style.top = "0", t.style.left = "0", t.style.position = "fixed", document.body.appendChild(t), t.focus(), t.select();
  try {
    return document.execCommand("copy"), !0;
  } catch {
    return !1;
  } finally {
    document.body.removeChild(t);
  }
}
function el(e) {
  return navigator.clipboard && navigator.clipboard.writeText(e).then(
    function() {
      return !0;
    },
    function() {
      return W5(e);
    }
  ), W5(e);
}
function YL(e) {
  return e.startsWith("0x") ? e : `0x${e}`;
}
function WL(e, t) {
  return e === "Sui" ? k9(t) : e === "Sei" ? fg(YL(t), 32) : t.startsWith("0x") && t.length === 66 ? !0 : t.length > 70 && t.length < 100;
}
function HL(e) {
  const t = _r(void 0);
  return St(() => {
    t.current = e;
  }), t.current;
}
async function cc(e) {
  return new Promise((t) => setTimeout(t, e));
}
const Ws = (e) => typeof e > "u" ? "" : e === 0 ? "$0" : Intl.NumberFormat("en-EN", {
  style: "currency",
  currency: "USD"
}).format(e), ri = (e, t, o) => {
  if (typeof t > "u" || !o)
    return;
  const i = typeof e == "function" ? e(o) : e;
  if (i)
    return typeof t == "number" ? t * i : oi(t) * i;
}, In = (e, t, o) => Ws(ri(e, t, o)), s8 = (e) => {
  if (e == null)
    return !0;
  for (const t in e)
    if (e.hasOwnProperty.call(e, t))
      return !1;
  return !0;
}, bo = (e, t, o) => {
  const i = ge.chains[e];
  if (!(i != null && i.explorerUrl))
    return;
  const c = i.explorerUrl;
  switch (o) {
    case "wallet":
      return e === "Aptos" ? `${c}account/${t}` : `${c}address/${t}`;
    case "tx":
      return e === "Aptos" ? `${c}txn/${t}` : `${c}tx/${t}`;
    default:
      switch (e) {
        case "Sui":
          return `${c}coin/${t}`;
        case "Aptos":
          return `${c}${fg(t) ? "fungible_asset" : "coin"}/${t}`;
        case "Fantom":
        case "Solana":
          return `${c}address/${t}`;
        default:
          return `${c}token/${t}`;
      }
  }
}, c8 = (e, t) => {
  if (!e.isTokenBridgeWrappedToken)
    return !1;
  const { nativeChain: o, symbol: i } = e;
  return i === "USDC" && o === "Ethereum" && t === "Fantom" || e.symbol === "tBTC" ? !0 : !["Ethereum", "Sepolia"].includes(o) && ["ETH", "WETH", "wstETH", "USDT", "USDC", "USDC.e"].includes(i);
}, tl = (e) => e >= 2 * 6e4 ? `~${Math.ceil(e / 6e4)} min` : `~${Math.ceil(e / 1e3)} sec`, l8 = (e) => {
  if (e > 864e5) {
    const c = Math.floor(e / 864e5);
    return `~${c} ${c === 1 ? "day" : "days"} ago`;
  } else if (e > 36e5) {
    const c = Math.floor(e / 36e5);
    return `~${c} ${c === 1 ? "hour" : "hours"} ago`;
  } else if (e > 6e4) {
    const c = Math.floor(e / 6e4);
    return `~${c} ${c === 1 ? "minute" : "minutes"} ago`;
  } else
    return "~1 minute ago";
}, f8 = (e) => {
  if (e < 60)
    return e === 1 ? `${e} second` : `${e} seconds`;
  if (e < 3600) {
    const t = Math.floor(e / 60);
    return t === 1 ? `${t} minute` : `${t} minutes`;
  } else {
    const t = Math.floor(e / 3600);
    return t === 1 ? `${t} hour` : `${t} hours`;
  }
}, ia = (e) => e ? e.endsWith("ExecutorRoute") : !1, u8 = [
  "ManualNtt",
  "AutomaticNtt",
  "M0AutomaticRoute",
  "NttExecutorRoute"
], d8 = (e) => {
  var i;
  const t = ge.routes.get(e);
  if (!t) return;
  const o = t.rc.config;
  if (o)
    return e === "NttExecutorRoute" ? (i = o.ntt) == null ? void 0 : i.tokens : o.tokens;
}, lc = (e) => {
  const t = ds(e);
  for (const o of u8) {
    const i = d8(o);
    if (i)
      for (const c in i) {
        const n = i[c];
        if (!n) continue;
        if (n.some(
          (f) => f.chain === e.chain && f.token === t
        )) return !0;
      }
  }
  return !1;
}, H5 = (e) => {
  const t = [], o = ds(e);
  for (const i of u8) {
    const c = d8(i);
    if (c)
      for (const n in c) {
        const d = c[n];
        if (!d) continue;
        if (d.some(
          (p) => p.chain === e.chain && p.token === o
        )) {
          for (const p of d)
            if (p.chain !== e.chain || p.token !== o) {
              const l = ge.tokens.get(p.chain, p.token);
              l && t.push(l);
            }
          return t;
        }
      }
  }
  return t;
};
class ZL {
  constructor(t) {
    // TODO: remove this
    zt(this, "IS_TOKEN_BRIDGE_ROUTE", !1);
    zt(this, "tokenCache", new PL(24 * 60 * 60 * 1e3));
    this.rc = t, this.IS_TOKEN_BRIDGE_ROUTE = [
      "ManualTokenBridge",
      "AutomaticTokenBridge",
      "TokenBridgeExecutorRoute"
    ].includes(t.meta.name);
  }
  // 24 hour TTL
  get AUTOMATIC_DEPOSIT() {
    return this.rc.IS_AUTOMATIC;
  }
  get NATIVE_GAS_DROPOFF_SUPPORTED() {
    return this.rc.NATIVE_GAS_DROPOFF_SUPPORTED;
  }
  async getV2ChainContext(t) {
    const i = (await gn()).getPlatform(Vr(t)).getChain(t);
    return {
      chain: t,
      context: i
    };
  }
  async isRouteSupported(t, o, i, c) {
    const n = await this.getV2ChainContext(i), d = await this.getV2ChainContext(c), f = this.rc.supportedChains(ge.network), p = f.includes(n.chain), l = f.includes(d.chain);
    if (!p || !l)
      return !1;
    try {
      return !!(await this.supportedDestTokens(
        t,
        i,
        c
      )).find((y) => Pd(y, o));
    } catch (h) {
      return console.error("Error checking route support:", h), !1;
    }
  }
  isSupportedChain(t) {
    return this.rc.supportedChains(ge.network).includes(t);
  }
  async supportedDestTokens(t, o, i) {
    if (!o || !i || !t) return [];
    const c = await this.getV2ChainContext(o), n = await this.getV2ChainContext(i);
    if (await this.isIlliquidDestToken(
      t,
      n.context
    )) return [];
    const f = `supportedDestTokens-${t.address}-${o}-${i}`;
    return (await this.tokenCache.requestWithCache(
      f,
      () => this.rc.supportedDestinationTokens(
        t.tokenId,
        c.context,
        n.context
      )
    )).filter((l) => {
      const h = ge.tokens.get(l);
      return !(h && c8(h, n.chain));
    });
  }
  async getQuote(t, o, i, c, n, d, f) {
    const p = await this.createRequest(
      o,
      i,
      c,
      n,
      f
    ), l = await gn(), h = new this.rc(l), y = await h.validate(p, {
      amount: cr(t),
      options: d
    });
    if (!y.valid)
      throw y.error;
    const M = await h.quote(p, y.params);
    return [h, M, p];
  }
  async createRequest(t, o, i, c, n) {
    const d = (await this.getV2ChainContext(i)).context, f = (await this.getV2ChainContext(c)).context, p = await gn();
    return await A9.create(
      p,
      /* @ts-ignore */
      {
        source: t.tokenId,
        destination: o.tokenId,
        recipient: n ? un.chainAddress(c, n) : void 0
      },
      d,
      f
    );
  }
  async computeQuote(t, o, i, c, n, d, f) {
    if (!c || !n)
      throw new Error("Need both chains to get a quote from SDKv2");
    const [, p] = await this.getQuote(
      t,
      o,
      i,
      c,
      n,
      d,
      f
    );
    if (!p.success)
      throw p.error;
    return p;
  }
  async send(t, o, i, c, n, d, f, p) {
    var T;
    const [l, h, y] = await this.getQuote(
      o,
      t,
      f,
      i,
      n,
      p,
      d
    );
    if (!h.success)
      throw h.error;
    let M;
    (T = ge.ui.testOptions) != null && T.enableHeadlessSigner ? M = await gs.fromPrivateKey(i) : M = await gs.fromChain(
      i,
      c,
      {},
      ar.SENDING
    );
    let C = await l.initiate(
      y,
      M,
      h,
      un.chainAddress(n, d)
    );
    if (C.state === Xo.SourceInitiated || C.state === Xo.SourceFinalized)
      return [l, C];
    let N = 0;
    const w = 5, S = 1e3;
    for (; N < w; )
      try {
        for await (C of l.track(C, 120 * 1e3))
          if (C.state >= Xo.SourceInitiated)
            return [l, C];
      } catch (E) {
        console.error(
          `Error tracking transfer (attempt ${N + 1} / ${w}):`,
          E
        );
        const j = S * Math.pow(2, N);
        await cc(j), N++;
      }
    throw new Error("Never got a SourceInitiated state in receipt");
  }
  async resumeIfManual(t) {
    const o = await gn(), i = new this.rc(o);
    return Ud(i) || Yd(i) ? i.resume(t) : null;
  }
  // Prevent receiving illiquid wormhole-wrapped tokens
  // This is not a perfect solution or an exhaustive list of all illiquid tokens,
  // but it should cover the most common cases
  async isIlliquidDestToken(t, o) {
    if (!this.IS_TOKEN_BRIDGE_ROUTE) return !1;
    const { symbol: i, nativeChain: c } = t;
    return !!(lc(t) || ["ETH", "WETH"].includes(i) && c === "Ethereum" && ["Scroll", "Xlayer", "Mantle", "Unichain"].includes(
      o.chain
    ));
  }
}
const QL = [
  T9,
  L9,
  S9,
  E9,
  D9,
  j9
];
class VL {
  constructor(t = QL) {
    zt(this, "preference");
    zt(this, "routes");
    zt(this, "quoteCache");
    const o = {}, i = [];
    for (const c of t) {
      const n = c.meta.name;
      if (n === "")
        throw new Error("Route has empty meta.name");
      if (n in o)
        throw new Error(`Route has duplicate meta.name: ${n}`);
      i.push(n), o[n] = new ZL(c);
    }
    this.routes = o, this.preference = i, this.quoteCache = new GL();
  }
  get(t) {
    return this.routes[t];
  }
  async forEach(t) {
    return Promise.all(
      this.preference.map((o) => t(o, this.routes[o]))
    );
  }
  async resumeFromTx(t) {
    return new Promise((o, i) => {
      const c = Object.keys(this.routes).length;
      let n = 0;
      this.forEach((d, f) => {
        f.resumeIfManual(t).then((p) => {
          p !== null ? o({ route: d, receipt: p }) : n += 1;
        }).catch((p) => {
          n += 1;
        }).finally(() => {
          n === c && o(null);
        });
      });
    });
  }
  allSupportedChains() {
    const t = /* @__PURE__ */ new Set();
    for (const o in ge.chains) {
      const i = o;
      this.forEach(async (c, n) => {
        t.has(i) || n.isSupportedChain(i) && t.add(i);
      });
    }
    return Array.from(t);
  }
  async allSupportedDestTokens(t, o, i) {
    const c = /* @__PURE__ */ new Set();
    return await this.forEach(async (n, d) => {
      try {
        if (n.includes("Mayan")) {
          c.add(Bn(un.tokenId(i, "native")));
          const f = Co.get(ge.network, i);
          f && c.add(Bn(un.tokenId(i, f)));
        } else {
          const f = await d.supportedDestTokens(
            t,
            o,
            i
          );
          for (const p of f)
            c.add(Bn(p));
        }
      } catch (f) {
        KM(f);
      }
    }), Array.from(c).map(JM);
  }
  async getQuotes(t, o) {
    const i = await Promise.allSettled(
      t.map((n) => {
        const d = this.quoteCache.get(n, o);
        return d || this.quoteCache.fetch(n, o, this.get(n));
      })
    ), c = {};
    for (let n = 0; n < t.length; n++) {
      const d = t[n], f = i[n];
      f.status === "rejected" ? c[d] = {
        success: !1,
        error: f.reason
      } : c[d] = f.value;
    }
    return c;
  }
}
class GL {
  constructor() {
    zt(this, "cache");
    zt(this, "pending");
    this.cache = {}, this.pending = {};
  }
  quoteParamsKey(t, o) {
    return `${t}:${o.sourceChain}:${o.sourceToken.address.toString()}:${o.destChain}:${o.destToken.address.toString()}:${ai(
      o.amount
    )}:${o.nativeGas}:${o.recipient}`;
  }
  get(t, o) {
    const i = this.quoteParamsKey(t, o), c = this.cache[i];
    if (c) {
      if (c.ttl() > 5)
        return c.result;
      delete this.cache[i];
    }
    return null;
  }
  async fetch(t, o, i) {
    console.debug("Fetching quote", t, o);
    const c = this.quoteParamsKey(t, o), n = this.pending[c];
    if (n)
      return new Promise((d, f) => {
        n.push({ resolve: d, reject: f });
      });
    {
      const d = new Promise(
        (f, p) => {
          this.pending[c] = [{ resolve: f, reject: p }];
        }
      );
      return i.computeQuote(
        o.amount,
        o.sourceToken,
        o.destToken,
        o.sourceChain,
        o.destChain,
        { nativeGas: o.nativeGas },
        o.recipient
      ).then((f) => {
        const p = this.pending[c];
        for (const { resolve: l } of p)
          l(f);
        delete this.pending[c], f.success && f.expires === void 0 && (f.expires = new Date(Date.now() + 6e4)), console.debug("Fetched quote", t, f), this.cache[c] = new Z5(f);
      }).catch((f) => {
        console.debug("Error fetching quote", t, f);
        const p = this.pending[c];
        for (const { reject: l } of p)
          l(f);
        delete this.pending[c], this.cache[c] = new Z5({
          success: !1,
          error: f
        });
      }), d;
    }
  }
  nextExpiry(t, o) {
    const i = t.map((c) => {
      const n = this.quoteParamsKey(c, o);
      if (this.cache[n])
        return this.cache[n].expires();
    }).filter((c) => c !== void 0).sort((c, n) => c.valueOf() - n.valueOf());
    if (i.length > 0)
      return i[0];
  }
}
class Z5 {
  constructor(t) {
    // Last quote we received (the cached value)
    zt(this, "result");
    // Last time we fetched a quote
    zt(this, "timestamp");
    this.result = t, this.timestamp = /* @__PURE__ */ new Date();
  }
  // Number of seconds this quote is still valid for before we should fetch a new one
  expires() {
    return this.result.success ? this.result.expires ?? new Date(this.timestamp.valueOf() + 6e4) : new Date(this.timestamp.valueOf() + 12e4);
  }
  // TTL in seconds before quote expires
  ttl() {
    return (this.expires().valueOf() - Date.now().valueOf()) / 1e3;
  }
}
function h8(e = {}) {
  var l;
  const t = rw(
    e.network || void 0 || "Mainnet"
  );
  if (!["Mainnet", "Testnet", "Devnet"].includes(t))
    throw new Error(
      `Invalid env "${t}": Use "Testnet", "Devnet", or "Mainnet"`
    );
  const o = { MAINNET: jw, DEVNET: hC, TESTNET: sC }[t.toUpperCase()], i = ew(
    o.wrappedTokens,
    e.wrappedTokens
  ), c = (h) => e.cacheNamespace ? `wormhole-connect:${e.cacheNamespace}:${h}` : `wormhole-connect:${h}`, n = $T(
    [
      ...o.tokens,
      ...e.tokensConfig ? Object.values(e.tokensConfig) : []
    ],
    i,
    c(`token-cache:${t}`)
  ), d = Xx[t.toUpperCase()], f = Object.assign(
    {},
    d.rpcs,
    o.rpcs,
    e.rpcs
  );
  (l = e.ui) != null && l.defaultInputs && tw(e.ui.defaultInputs, o.chains, n);
  const p = a1(e.ui ?? {});
  return e.tokens && e.tokens.length > 0 && p.disableUserInputtedTokens === void 0 && (p.disableUserInputtedTokens = !0), {
    sdkConfig: d,
    network: t,
    isMainnet: t === "Mainnet",
    // External resources
    rpcs: f,
    evmIndexers: e.evmIndexers,
    mayanApi: "https://explorer-api.mayan.finance",
    wormholeApi: {
      Mainnet: "https://api.wormholescan.io/",
      Testnet: "https://api.testnet.wormholescan.io/",
      Devnet: ""
    }[t],
    wormholeRpcHosts: {
      Mainnet: [
        "https://wormhole-v2-mainnet-api.mcf.rocks",
        "https://wormhole-v2-mainnet-api.chainlayer.network",
        "https://wormhole-v2-mainnet-api.staking.fund"
      ],
      Testnet: [
        "https://guardian.testnet.xlabs.xyz",
        "https://guardian-01.testnet.xlabs.xyz",
        "https://guardian-02.testnet.xlabs.xyz"
      ],
      Devnet: ["http://localhost:7071"]
    }[t],
    coingecko: e.coingecko,
    // Callbacks
    triggerEvent: pC(e.eventHandler),
    validateTransfer: e.validateTransferHandler,
    isRouteSupportedHandler: e.isRouteSupportedHandler,
    isTokenSupportedHandler: e.isTokenSupportedHandler,
    filterRoutes: e.filterRoutes,
    // White lists
    chains: o.chains,
    chainsArr: Object.values(o.chains).filter((h) => e.chains ? e.chains.includes(h.sdkName) : !0).sort((h, y) => {
      const M = l2.indexOf(h.sdkName), C = l2.indexOf(y.sdkName);
      return M >= 0 && C >= 0 ? M - C : M === -1 ? 1 : C === -1 ? -1 : 0;
    }),
    tokens: n,
    tokenWhitelist: e.tokens,
    routes: new VL(e.routes),
    // UI details
    ui: a1({ ...e.ui }),
    // Used to namespace localStorage caches
    cacheKey: c,
    // Guardian Set
    guardianSet: o.guardianSet,
    // Transaction settings
    transactionSettings: (e == null ? void 0 : e.transactionSettings) || {}
  };
}
const ge = h8();
async function gn() {
  return ge._v2Wormhole || (ge._v2Wormhole = await qL()), ge._v2Wormhole;
}
async function $L() {
  delete ge._v2Wormhole;
}
async function qL() {
  const e = { chains: {} };
  for (const t in ge.chains) {
    const o = t, i = ge.rpcs[o], c = {};
    for (const n of ge.tokens.getAllForChain(o)) {
      const d = {
        key: n.key,
        chain: o,
        symbol: n.symbol,
        address: n.address.toString(),
        decimals: n.decimals
      };
      c[n.address.toString()] = d;
    }
    e.chains[o] = { rpc: i, tokenMap: c };
  }
  return await FT(
    ge.network,
    [RT, PT, UT, YT],
    e
  );
}
function JL(e = {}) {
  const t = h8(e);
  for (const o in t)
    ge[o] = t[o];
  typeof window < "u" && (window._connectConfig = ge);
}
function XL() {
  return {
    data: null,
    error: null,
    isFetching: !1,
    receivedAt: null
  };
}
function KL(e) {
  return {
    data: e,
    error: null,
    isFetching: !1,
    receivedAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}
function eS(e) {
  return {
    data: null,
    error: e,
    isFetching: !1,
    receivedAt: null
  };
}
function tS() {
  return {
    data: null,
    error: null,
    isFetching: !0,
    receivedAt: null
  };
}
function Q5() {
  var d, f, p;
  const { fromChain: e, toChain: t, fromToken: o, toToken: i } = ge.ui.defaultInputs || {}, c = e && o ? (d = ge.tokens.findByAddressOrSymbol(e, o)) == null ? void 0 : d.tuple : void 0, n = t && i ? (f = ge.tokens.findByAddressOrSymbol(t, i)) == null ? void 0 : f.tuple : void 0;
  return {
    showValidationState: !1,
    validations: {
      fromChain: "",
      toChain: "",
      amount: "",
      toNativeToken: "",
      sendingWallet: "",
      receivingWallet: "",
      relayerFee: "",
      receiveAmount: ""
    },
    fromChain: e,
    toChain: t,
    token: c,
    destToken: n,
    amount: void 0,
    receiveAmount: XL(),
    preferredRouteName: (p = ge.ui.defaultInputs) == null ? void 0 : p.preferredRouteName,
    route: void 0,
    foreignAsset: "",
    associatedTokenAddress: "",
    gasEst: {
      send: "",
      claim: ""
    },
    isTransactionInProgress: !1,
    receiverNativeBalance: ""
  };
}
const V5 = (e) => {
  const { fromChain: t } = e;
  if (e.token) {
    const o = ge.tokens.get(e.token);
    if (o && t && o.chain !== t && o.symbol) {
      const i = ge.tokens.findBySymbol(
        t,
        o.symbol
      );
      i && (e.token = i.tuple);
    }
  }
}, G5 = (e) => {
  const { toChain: t } = e;
  if (e.destToken) {
    const o = ge.tokens.get(e.destToken);
    if (o && t && o.chain !== t && o.symbol) {
      const i = ge.tokens.findBySymbol(
        t,
        o.symbol
      );
      i && (e.destToken = i.tuple);
    }
  }
}, p8 = Ca({
  name: "transfer",
  initialState: Q5(),
  reducers: {
    // validations
    setValidations: (e, {
      payload: { showValidationState: t, validations: o }
    }) => {
      Object.keys(o).forEach((i) => {
        e.validations[i] = o[i];
      }), e.showValidationState = t;
    },
    // user input
    setToken: (e, { payload: t }) => {
      e.token = t;
    },
    clearToken: (e) => {
      e.token = void 0;
    },
    setDestToken: (e, { payload: t }) => {
      e.destToken = t;
    },
    clearDestToken: (e) => {
      e.destToken = void 0;
    },
    setFromChain: (e, { payload: t }) => {
      e.fromChain = t, V5(e);
    },
    setToChain: (e, { payload: t }) => {
      e.toChain = t, G5(e);
    },
    setAmount: (e, { payload: t }) => {
      if (e.token && e.fromChain) {
        const o = ge.tokens.get(e.token);
        if (o) {
          const { decimals: i } = o, c = W1(t, i);
          ai(c) === 0n ? e.amount = void 0 : e.amount = c;
        }
      } else
        console.warn("Can't call setAmount without a fromChain and token");
    },
    setReceiveAmount: (e, { payload: t }) => {
      e.receiveAmount = KL(t);
    },
    setFetchingReceiveAmount: (e) => {
      e.receiveAmount = tS();
    },
    setReceiveAmountError: (e, { payload: t }) => {
      e.receiveAmount = eS(t);
    },
    setTransferRoute: (e, { payload: t }) => {
      if (!t) {
        e.route = void 0;
        return;
      }
      e.route = t;
    },
    // clear inputs
    clearTransfer: (e) => {
      const t = Q5();
      Object.keys(e).forEach((o) => {
        e[o] = t[o];
      });
    },
    setIsTransactionInProgress: (e, { payload: t }) => {
      e.isTransactionInProgress = t;
    },
    swapInputs: (e) => {
      const t = e.fromChain;
      e.fromChain = e.toChain, e.toChain = t;
      const o = e.token;
      e.token = e.destToken, e.destToken = o, V5(e), G5(e);
    }
  }
}), Sh = (e, t) => !n8(t.type).includes(e), g8 = async (e, t, o) => {
  M8(ar.SENDING, e, t, o);
}, y8 = async (e, t, o) => {
  M8(ar.RECEIVING, e, t, o);
}, M8 = async (e, t, o, i) => {
  Sh(o, i) && (t(pa(e)), t(jL({
    type: e,
    error: "Wallet disconnected, please connect a supported wallet"
  }))), ge.chains[o] && t(
    e === ar.SENDING ? nS(o) : rl(o)
  );
}, {
  setValidations: rS,
  setToken: m8,
  clearToken: v8,
  setDestToken: Eh,
  clearDestToken: b8,
  setFromChain: nS,
  setToChain: rl,
  setAmount: Hs,
  setTransferRoute: Di,
  clearTransfer: x8,
  setIsTransactionInProgress: $5,
  swapInputs: w8
} = p8.actions, iS = p8.reducer, q5 = {
  maxSwapAmt: void 0,
  toNativeToken: 0,
  receiveNativeAmt: void 0,
  relayerFee: void 0,
  receiverNativeBalance: ""
}, C8 = Ca({
  name: "transfer",
  initialState: q5,
  reducers: {
    setToNativeToken: (e, { payload: t }) => {
      e.toNativeToken = t;
    },
    // clear relay state
    clearRelay: (e) => {
      Object.keys(e).forEach((t) => {
        e[t] = q5[t];
      });
    }
  }
}), { setToNativeToken: I8 } = C8.actions, oS = C8.reducer, aS = {
  route: "bridge",
  showFromChainsModal: !1,
  showToChainsModal: !1,
  showTokensModal: !1,
  showWalletModal: !1
}, N8 = Ca({
  name: "router",
  initialState: aS,
  reducers: {
    setRoute: (e, { payload: t }) => {
      e.route = t;
    }
  }
}), { setRoute: Nn } = N8.actions, sS = N8.reducer, cS = {
  txHash: void 0,
  chain: void 0
}, A8 = Ca({
  name: "search",
  initialState: cS,
  reducers: {
    setSearch(e, t) {
      e.txHash = t.payload.txHash, e.chain = t.payload.chain;
    },
    clearSearch(e) {
      e.txHash = void 0, e.chain = void 0;
    }
  }
}), { setSearch: T8, clearSearch: L8 } = A8.actions, lS = A8.reducer, J5 = kx({
  reducer: {
    redeem: Gx,
    transferInput: iS,
    router: sS,
    wallet: zL,
    relay: oS,
    search: lS
  }
});
function fS(e, t = !1) {
  var o;
  return !((o = ge.ui) != null && o.experimental) || ge.ui.experimental[e] === void 0 ? t : ge.ui.experimental[e];
}
const uS = Ft("MuiBox", ["root"]), dS = kc(), wt = G9({
  themeId: ni,
  defaultTheme: dS,
  defaultClassName: uS.root,
  generateClassName: Og.generate
});
fe.process.env.NODE_ENV !== "production" && (wt.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: b.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object])
});
function Zs(e) {
  const t = er(), o = Ce(
    () => ({
      fontSize: `${e.size || 42}px`,
      width: "100%",
      textAlign: e.align || "center",
      fontFamily: t.typography.fontFamily,
      [t.breakpoints.down("sm")]: {
        fontSize: "24px"
      }
    }),
    [t, e.align, e.size]
  );
  return /* @__PURE__ */ D(ut, { sx: o, "data-testid": e.testId, children: e.text });
}
const hS = dn(
  /* @__PURE__ */ D(
    "path",
    {
      d: "M7 9L12 14L17 9",
      fill: "none",
      stroke: "currentColor",
      strokeOpacity: "0.9",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  "Down"
);
function La({
  back: e,
  title: t,
  align: o = "left",
  description: i,
  testId: c
}) {
  const n = or(), d = Cr(), f = Ce(
    () => ({
      container: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        marginBottom: "0px",
        [n.breakpoints.down("sm")]: {
          marginBottom: "20px"
        }
      },
      header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%"
      },
      left: {
        display: "flex",
        flexGrow: 1,
        alignItems: "center",
        textAlign: o
      },
      arrowBack: {
        transform: "rotate(90deg)",
        marginRight: "16px",
        cursor: "pointer"
      },
      description: {
        fontWeight: "300",
        fontSize: "14px",
        opacity: "0.6",
        marginBottom: "40px"
      }
    }),
    [n, o]
  );
  function p() {
    d(Nn("bridge"));
  }
  return /* @__PURE__ */ ne(wt, { sx: f.container, children: [
    /* @__PURE__ */ D(wt, { sx: f.header, children: /* @__PURE__ */ ne(wt, { sx: f.left, children: [
      e && /* @__PURE__ */ D(hS, { sx: f.arrowBack, fontSize: "large", onClick: p }),
      /* @__PURE__ */ D(Zs, { text: t, align: o, testId: c })
    ] }) }),
    i && /* @__PURE__ */ D(wt, { sx: f.description, children: i })
  ] });
}
const cn = {
  0: "00",
  5: "0C",
  7: "0F",
  10: "19",
  15: "26",
  20: "33",
  25: "3F",
  30: "4C",
  35: "59",
  40: "66",
  45: "72",
  50: "7F",
  55: "8C",
  60: "99",
  65: "A5",
  70: "B2",
  75: "BF",
  80: "CC",
  85: "D8",
  90: "E5",
  95: "F2",
  100: "FF"
}, nl = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}, pS = {
  width: "40px",
  height: "40px",
  ...nl,
  cursor: "pointer"
}, gS = (e, t) => e.length === 7 ? e + cn[t] : e.length === 9 ? e.slice(0, 7) + cn[t] : e, S8 = () => {
  const e = er();
  return Ce(
    () => ({
      "&::-webkit-scrollbar": {
        display: "none"
      },
      "&::-webkit-scrollbar-track": {
        display: "none",
        backgroundColor: "transparent"
      },
      "&::-webkit-scrollbar-thumb": {
        display: "none",
        backgroundColor: "transparent"
      },
      "&:hover::-webkit-scrollbar-thumb": {
        display: "none",
        backgroundColor: `${e.palette.text.primary}1a`
      },
      "&::-webkit-scrollbar-button": {
        display: "none"
      }
    }),
    [e]
  );
};
function yS(e, t) {
  const { order: o = e.length, target: i = "_black", href: c, label: n } = t;
  return e.splice(o, 0, { label: n, handleClick: () => window.open(c, i) }), e;
}
function MS(e) {
  return [
    { label: "Resume Transaction", handleClick: () => e("search") },
    { label: "Terms of Service", handleClick: () => e("terms") }
  ];
}
function il() {
  var n;
  const e = er(), t = Ce(
    () => ({
      menuIcon: pS,
      menu: {
        display: "flex",
        [e.breakpoints.down("md")]: {
          flexDirection: "column"
        },
        flexDirection: "row",
        gap: "8px",
        padding: "8px",
        width: "100%"
      },
      menuItem: {
        padding: "16px 0",
        textAlign: "center",
        fontSize: "14px",
        margin: "auto",
        cursor: "pointer",
        "&:hover": {
          textDecoration: "underline"
        }
      }
    }),
    [e]
  ), o = Cr(), i = ht(
    (d) => {
      o(Nn(d));
    },
    [o]
  ), c = (((n = ge.ui) == null ? void 0 : n.menu) ?? []).reduce(
    yS,
    MS(i)
  );
  return /* @__PURE__ */ D(ut, { sx: t.menu, children: c.map(({ label: d, handleClick: f }, p) => /* @__PURE__ */ D(
    ut,
    {
      sx: t.menuItem,
      onClick: f,
      children: d
    },
    `${d.toLowerCase()}_${p}`
  )) });
}
function mS() {
  const e = {
    terms: {
      width: "100%",
      maxWidth: "700px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    body: {
      textAlign: "left",
      display: "flex",
      flexDirection: "column",
      fontWeight: "300",
      ol: {
        marginBottom: "8px"
      },
      li: {
        marginBottom: "8px"
      }
    }
  };
  return /* @__PURE__ */ ne(wt, { sx: e.terms, children: [
    /* @__PURE__ */ D(La, { title: "Terms of Service", back: !0 }),
    /* @__PURE__ */ ne(wt, { sx: e.body, children: [
      /* @__PURE__ */ D("p", { children: "Last Updated: April 18, 2025" }),
      /* @__PURE__ */ ne("p", { children: [
        'These Terms of Service (the "Agreement") explain the terms and conditions by which you may access and use the Services provided by W7, LLC (d.b.a. Wormhole Labs) (the "Company," "we," "us," or "our"). The "Services" shall include, but not limited to, the website located at',
        " ",
        /* @__PURE__ */ D(
          "a",
          {
            href: "https://portalbridge.com",
            target: "_blank",
            style: { whiteSpace: "nowrap" },
            children: "https://portalbridge.com"
          }
        ),
        " ",
        '(the "Interface"), and any app, content, functionality, and services offered on or through the Interface, and all technologies made available from the Interface, together with all of the existing and any updated or new features, functionalities and technologies.'
      ] }),
      /* @__PURE__ */ D("p", { children: "You assume all risks associated with using the SDK, the Wormhole protocol, and digital assets and decentralized systems generally, including but not limited to, that: (a) digital assets are highly volatile; (b) using digital assets is inherently risky due to both features of such assets and the potential unauthorized acts of third parties; (c) you may not have ready access to assets; and (d) you may lose some or all of your tokens or other assets. You agree that you will have no recourse against anyone else for any losses due to the use of the SDK or the Wormhole protocol. For example, these losses may arise from or relate to: (i) incorrect information; (ii) software or network failures; (iii) corrupted cryptocurrency wallet files; (iv) unauthorized access; (v) errors, mistakes, or inaccuracies; or (vi) third-party activities." }),
      /* @__PURE__ */ D("p", { children: "You must read this Agreement carefully as it governs your use of the Services. By accessing or using any of the Services, you (on behalf of yourself or the entity that you represent) signify that you have read, understand, and agree to be bound by, this Agreement and our Privacy Policy in its entirety, and you represent and warrant that you have the willingness, right, authority, and capacity lawfully to enter into this Agreement (on behalf of yourself or the entity that you represent). If you do not agree, you are not authorized to access or use any of our Services and should not use our Services." }),
      /* @__PURE__ */ D("p", { children: "To access or use any of our Services, you must be able to form a legally binding contract with us. Accordingly, you represent that you are at least the age of majority in your jurisdiction (e.g., 18 years old in the United States) and have the full right, power, and authority to enter into and comply with the terms and conditions of this Agreement on behalf of yourself and any company or legal entity for which you may access or use the Interface. If you are entering into this Agreement on behalf of an entity, you represent to us that you have the legal authority to bind such entity." }),
      /* @__PURE__ */ D("p", { children: "You further represent that you are not (a) the subject of economic or trade sanctions administered or enforced by any governmental authority or otherwise designated on any list of prohibited or restricted parties (including but not limited to the list maintained by the Office of Foreign Assets Control of the U.S. Department of the Treasury) or (b) a citizen, resident, or organized in a jurisdiction or territory that is the subject of comprehensive country-wide, territory-wide, or regional economic sanctions by the United States. Finally, you represent that your access and use of any of our Services will fully comply with all applicable laws and regulations, and that you will not access or use any of our Services to conduct, promote, or otherwise facilitate any illegal activity." }),
      /* @__PURE__ */ D("p", { children: "NOTICE: This Agreement contains important information, including a binding arbitration provision and a class action waiver, both of which impact your rights as to how disputes are resolved. Our Services are only available to you — and you should only access any of our Services — if you agree completely with these terms." }),
      /* @__PURE__ */ ne("ol", { children: [
        /* @__PURE__ */ ne("li", { children: [
          "Modifications of this Agreement or our Services",
          " ",
          /* @__PURE__ */ ne("ol", { type: "a", children: [
            /* @__PURE__ */ D("li", { children: "Modifications of this Agreement. We reserve the right, in our sole discretion, to modify this Agreement from time to time. If we make any material modifications, we will notify you by updating the date at the top of the Agreement and by maintaining a current version of the Agreement at https://portalbridge.com/terms-of-use. All modifications will be effective when they are posted, and your continued accessing or use of any of the Services will serve as confirmation of your acceptance of those modifications. If you do not agree with any modifications to this Agreement, you must immediately stop accessing and using all of our Services." }),
            /* @__PURE__ */ D("li", { children: "Modifications of our Services. We reserve the following rights, which do not constitute obligations of ours: (a) with or without notice to you, to modify, substitute, eliminate or add to any of the Services; (b) to review, modify, filter, disable, delete, and remove any and all content and information from any of the Services." })
          ] })
        ] }),
        /* @__PURE__ */ ne("li", { children: [
          "Intellectual Property Rights",
          /* @__PURE__ */ ne("ol", { type: "a", children: [
            /* @__PURE__ */ ne("li", { children: [
              "General",
              /* @__PURE__ */ ne("ol", { type: "i", children: [
                /* @__PURE__ */ D("li", { children: "The Services and their entire contents, features, and functionality (including but not limited to all information, software, text, displays, images, video and audio, and the design, selection, and arrangement thereof), are owned by us, our licensors or other providers of such material and are protected by copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws. Neither the Agreement (nor your use of the Services) transfers to you or any third party any rights, title, or interest in or to such intellectual property rights, except as indicated otherwise." }),
                /* @__PURE__ */ D("li", { children: "Subject to the terms of this Agreement, we grant you a limited, revocable, non-exclusive, non-sublicensable, non-transferable license to access and use our Services solely in accordance with this Agreement. You agree that you will not use, modify, distribute, tamper with, reverse engineer, disassemble or decompile any of our Services for any purpose other than as expressly permitted pursuant to this Agreement. Except as set forth in this Agreement, we grant you no rights to any of our Services, including any intellectual property rights." })
              ] })
            ] }),
            /* @__PURE__ */ D("li", { children: 'Feedback. If you provide us with any feedback or suggestions regarding the Services (“Feedback"), you hereby assign to us all rights in such Feedback and agree that we have the right to use and fully exploit such Feedback and related information in any manner we deem appropriate. Any Feedback you provide will be treated as non-confidential and non-proprietary, and we will be entitled to the unrestricted use and dissemination of such Feedback for any purpose, commercial or otherwise, without acknowledgment, attribution, or compensation to you.' })
          ] })
        ] }),
        /* @__PURE__ */ ne("li", { children: [
          "Your Use of the Services",
          /* @__PURE__ */ ne("ol", { type: "a", children: [
            /* @__PURE__ */ ne("li", { children: [
              "Prohibited Uses. You may use the Services only for lawful purposes and in accordance with the Agreement. You agree not to:",
              /* @__PURE__ */ ne("ol", { type: "i", children: [
                /* @__PURE__ */ D("li", { children: "use the Services in any way that violates any applicable federal, state, local, or international law or regulation, including, without limitation, any applicable sanctions laws, export control laws, securities or other financial regulatory laws, anti-money laundering laws, or privacy laws;" }),
                /* @__PURE__ */ D("li", { children: "use any device, software or routine that interferes with the proper working of any Service;" }),
                /* @__PURE__ */ D("li", { children: "attempt to probe, scan or test the vulnerability of the Services, or otherwise seek to interfere with or compromise the integrity, security, or proper functioning of the Services;" }),
                /* @__PURE__ */ D("li", { children: "attempt to interfere with the proper working of the Services, or interfere with, damage, or disrupt any parts of the Services, the server(s) on which the Services is stored, or any server, computer or database connected to the Services;" }),
                /* @__PURE__ */ D("li", { children: "engage in any other conduct that restricts or inhibits anyone's use or enjoyment of the Services, or which, as determined by us, may harm us or users of the Services or expose them to liability; or" }),
                /* @__PURE__ */ D("li", { children: "encourage or enable any other individual to do any of the foregoing." })
              ] })
            ] }),
            /* @__PURE__ */ ne("li", { children: [
              "Your Responsibilities. By using the Services, you agree and understand that:",
              /* @__PURE__ */ ne("ol", { type: "i", children: [
                /* @__PURE__ */ D("li", { children: "You are solely responsible for your use of the Services and interactions with the Protocol, including all of your transfers of digital assets; all transactions you submit to the Protocol are considered unsolicited, which means that they are solely initiated by you;" }),
                /* @__PURE__ */ D("li", { children: "to the fullest extent not prohibited by applicable laws, we owe no fiduciary duties or liabilities to you or any other party, and that to the extent any such duties or liabilities may exist at law or in equity, you hereby irrevocably disclaim, waive, and eliminate those duties and liabilities;" }),
                /* @__PURE__ */ D("li", { children: "You are solely responsible for reporting and paying any taxes applicable to your use of the Services;" }),
                /* @__PURE__ */ D("li", { children: "We have no control over, or liability for, the delivery, quality, safety, legality, or any other aspect of any digital assets that you may transfer to or from a third party, and we are not responsible for ensuring that a counterparty with whom you transact completes the transaction or is authorized to do so;" }),
                /* @__PURE__ */ D("li", { children: "The Services are non-custodial application, meaning we do not ever have custody, possession, or control of your digital assets at any time; we accept no responsibility for, or liability to you, in connection with your use of a wallet and make no representations or warranties regarding how any of our Services will operate with any specific wallet; likewise, you are solely responsible for any associated wallet and we are not liable for any acts or omissions by you in connection with or as a result of your wallet being compromised; and" }),
                /* @__PURE__ */ D("li", { children: 'Transactions that take place on a blockchain network require the payment of transaction fees to the validators or node operators of the relevant network ("Gas Fees"); you will be solely responsible to pay the Gas Fees for any transaction that you initiate via any of our Services.' })
              ] })
            ] }),
            /* @__PURE__ */ D("li", { children: "Release of Claims. You expressly agree that you assume all risks in connection with your use of the Services. You further expressly waive and release us, as well as its affiliates and service providers, and each of their respective past, present and future officers, directors, members, employees, consultants, representatives and agents, and each of their respective successors and assigns from any and all liability, claims, causes of action, or damages arising from or in any way relating to your use of the Services." })
          ] })
        ] }),
        /* @__PURE__ */ ne("li", { children: [
          "Disclaimers",
          /* @__PURE__ */ ne("ol", { type: "a", children: [
            /* @__PURE__ */ D("li", { children: 'EACH OF OUR SERVICES IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ANY REPRESENTATIONS AND WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING, BUT NOT LIMITED TO, THE WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. YOU ACKNOWLEDGE AND AGREE THAT YOUR USE OF EACH OF OUR SERVICES IS AT YOUR OWN RISK. WE DO NOT REPRESENT OR WARRANT THAT ACCESS TO ANY OF OUR SERVICES WILL BE CONTINUOUS, UNINTERRUPTED, TIMELY, OR SECURE; THAT THE INFORMATION CONTAINED IN ANY OF OUR SERVICES WILL BE ACCURATE, RELIABLE, COMPLETE, OR CURRENT; OR THAT ANY OF OUR SERVICES WILL BE FREE FROM ERRORS, DEFECTS, VIRUSES, OR OTHER HARMFUL ELEMENTS. NO ADVICE, INFORMATION, OR STATEMENT THAT WE MAKE SHOULD BE TREATED AS CREATING ANY WARRANTY CONCERNING ANY OF OUR SERVICES.' }),
            /* @__PURE__ */ D("li", { children: 'SIMILARLY, THE PROTOCOL IS PROVIDED "AS IS", AT YOUR OWN RISK, AND WITHOUT WARRANTIES OF ANY KIND. WE DO NOT PROVIDE, OWN OR CONTROL THE PROTOCOL, WHICH OPERATES AUTONOMOUSLY ON BLOCKCHAINS SUBJECT TO GOVERNANCE BY A DECENTRALIZED SET OF VALIDATORS. NO DEVELOPER OR ENTITY INVOLVED IN CREATING THE PROTOCOL WILL BE LIABLE FOR ANY CLAIMS OR DAMAGES WHATSOEVER ASSOCIATED WITH YOUR USE, INABILITY TO USE, OR YOUR INTERACTION WITH OTHER USERS OF, THE PROTOCOL, INCLUDING ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, PUNITIVE OR CONSEQUENTIAL DAMAGES, OR LOSS OF PROFITS, CRYPTOCURRENCIES, TOKENS, OR ANYTHING ELSE OF VALUE. WE DO NOT ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY ADVERTISEMENTS, OFFERS, OR STATEMENTS MADE BY THIRD PARTIES CONCERNING ANY OF OUR SERVICES.' }),
            /* @__PURE__ */ D("li", { children: "Information Only. You agree that the information presented on or through the Services are for general informational purposes only. We do not warrant the accuracy, completeness or usefulness of this information. Any reliance you place on such information is strictly at your own risk. We disclaim all liability and responsibility arising from any reliance placed on such materials by you or any other visitor to our Services, or by anyone who may be informed of any of its contents." }),
            /* @__PURE__ */ D("li", { children: "Third Party Information. The Services may include content provided by third parties, including materials provided by other users, bloggers and third-party licensors, syndicators, aggregators, and/or reporting services. All statements and/or opinions expressed in these materials, and all articles and responses to questions and other content are solely the opinions and the responsibility of the person or entity providing those materials. These materials do not necessarily reflect our opinion. We are not responsible, or liable to you or any third party, for the content or accuracy of any materials provided by any third parties." })
          ] })
        ] }),
        /* @__PURE__ */ ne("li", { children: [
          "Indemnification",
          /* @__PURE__ */ D("ol", { type: "a", children: /* @__PURE__ */ D("li", { children: `To the fullest extent permitted by applicable laws, you agree to indemnify, defend and hold harmless us, as well as its affiliates and service providers, and each of their respective past, present and future officers, directors, members, employees, consultants, representatives and agents, and each of their respective successors and assigns ("Indemnified Parties") from and against all actual or alleged third party claims, damages, awards, judgments, losses, liabilities, obligations, taxes, penalties, interest, fees, expenses (including, without limitation, attorneys' fees and expenses) and costs (including, without limitation, court costs, costs of settlement and costs of pursuing indemnification and insurance), of every kind and nature whatsoever, whether known or unknown, foreseen or unforeseen, matured or unmatured, or suspected or unsuspected, in law or equity, whether in tort, contract or otherwise ("Claims"), including, but not limited to, damages to property or personal injury, that are caused by, arise out of or are related to: (a) your access and use of any of our Services; (b) your violation of any term or condition of this Agreement, the right of any third party, or any other applicable law, rule, or regulation; (c) any other party's access and use of any of our Services with your assistance or using any device or account that you own or control; (d) any dispute between you and (i) any other user of any of the Services or (ii) any of your own customers or users; and (e) your negligence or willful misconduct. You agree to promptly notify us of any third-party Claims and cooperate with the Indemnified Parties in defending such Claims. You further agree that the Indemnified Parties shall have the right to control the defense or settlement of any third-party Claims as they relate to us, if it so chooses.` }) })
        ] }),
        /* @__PURE__ */ ne("li", { children: [
          "LIMITATION OF LIABILITY",
          /* @__PURE__ */ D("ol", { type: "a", children: /* @__PURE__ */ D("li", { children: "TO THE FULLEST EXTENT ALLOWED BY APPLICABLE LAW, UNDER NO CIRCUMSTANCES AND UNDER NO LEGAL THEORY (INCLUDING, WITHOUT LIMITATION, TORT, CONTRACT, STRICT LIABILITY, OR OTHERWISE) SHALL THE INDEMNIFIED PARTIES OR ANY OF THEM BE LIABLE TO YOU OR TO ANY OTHER PERSON FOR: (A) ANY INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE OR CONSEQUENTIAL DAMAGES OF ANY KIND, INCLUDING DAMAGES FOR LOST PROFITS, BUSINESS INTERRUPTION, LOSS OF DATA, LOSS OF GOODWILL, WORK STOPPAGE, ACCURACY OF RESULTS, OR COMPUTER FAILURE OR MALFUNCTION; (B) ANY SUBSTITUTE GOODS, SERVICES OR TECHNOLOGY; (C) ANY AMOUNT, IN THE AGGREGATE, IN EXCESS OF ONE-HUNDRED ($100) DOLLARS; OR (D) ANY MATTER BEYOND THE REASONABLE CONTROL OF THE INDEMNIFIED PARTIES OR ANY OF THEM. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL OR CERTAIN OTHER DAMAGES, SO THE ABOVE LIMITATIONS AND EXCLUSIONS MAY NOT APPLY TO YOU." }) })
        ] }),
        /* @__PURE__ */ ne("li", { children: [
          "Governing Law, Dispute Resolution and Class Action Waivers",
          /* @__PURE__ */ ne("ol", { type: "a", children: [
            /* @__PURE__ */ D("li", { children: "Governing Law: You agree that the laws of the State of New York, without regard to principles of conflict of laws, govern this Agreement and any Dispute between you and us. You further agree that each of our Service shall be deemed to be based solely in the State of New York, and that although Service may be available in other jurisdictions, its availability does not give rise to general or specific personal jurisdiction in any forum outside the State of New York. The parties acknowledge that this Agreement evidences interstate commerce. Any arbitration conducted pursuant to this Agreement shall be governed by the Federal Arbitration Act. You agree that the federal and state courts of New York County, New York are the proper forum for any appeals of an arbitration award or for court proceedings in the event that this Agreement's binding arbitration clause is found to be unenforceable." }),
            /* @__PURE__ */ D("li", { children: `Dispute Resolution: Any claim or controversy arising out of or relating to any of our Services, this Agreement, or any other acts or omissions for which you may contend that we are liable, including, but not limited to, any claim or controversy as to arbitrability ("**Dispute**"), shall be finally and exclusively settled by arbitration under the JAMS Optional Expedited Arbitration Procedures. You understand that you are required to resolve all Disputes by binding arbitration. The arbitration shall be held on a confidential basis before a single arbitrator, who shall be selected pursuant to JAMS rules, including where applicable the JAMS' Mass Arbitration Procedures and Guidelines. The arbitration will be held in New York, New York, unless you and we both agree to hold it elsewhere. Unless we agree otherwise, the arbitrator may not consolidate your claims with those of any other party. Any judgment on the award rendered by the arbitrator may be entered in any court of competent jurisdiction. If for any reason a claim by law or equity must proceed in court rather than in arbitration you agree to waive any right to a jury trial and any claim may be brought only in a Federal District Court or a New York state court located in New York County, New York.` }),
            /* @__PURE__ */ D("li", { children: "Class Action and Jury Trial Waiver: You must bring any and all Disputes against us in your individual capacity and not as a plaintiff in or member of any purported class action, collective action, private attorney general action, or other representative proceeding. This provision applies to class arbitration. You and we both agree to waive the right to demand a trial by jury." })
          ] })
        ] }),
        /* @__PURE__ */ ne("li", { children: [
          "Miscellaneous",
          /* @__PURE__ */ ne("ol", { type: "a", children: [
            /* @__PURE__ */ D("li", { children: "Entire Agreement. These terms, together with the Privacy Policy, constitute the entire agreement between you and us with respect to the subject matter hereof. This Agreement supersedes any and all prior or contemporaneous written and oral agreements, communications and other understandings (if any) relating to the subject matter of the terms." }),
            /* @__PURE__ */ D("li", { children: "Assignment. You may not assign or transfer this Agreement, by operation of law or otherwise, without our prior written consent. Any attempt by you to assign or transfer this Agreement without our prior written consent shall be null and void. We may freely assign or transfer this Agreement. Subject to the foregoing, this Agreement will bind and inure to the benefit of the parties, their successors and permitted assigns." }),
            /* @__PURE__ */ D("li", { children: "Not Registered with Any Governmental Agency. We are not registered with any governmental agency in any other capacity. You understand and acknowledge that we do not broker trading orders on your behalf. We also do not facilitate the execution or settlement of your trades, which occur entirely on public distributed blockchains like Ethereum. As a result, we do not (and cannot) guarantee market best pricing or best execution through our Services." }),
            /* @__PURE__ */ D("li", { children: "Notice. We may provide any notice to you under this Agreement using commercially reasonable means, including using public communication channels. Notices we provide by using public communication channels will be effective upon posting. You can contact us at contact@wormholelabs.xyz." }),
            /* @__PURE__ */ D("li", { children: "Severability. If any provision of this Agreement shall be determined to be invalid or unenforceable under any rule, law, or regulation of any local, state, or federal government agency, such provision will be changed and interpreted to accomplish the objectives of the provision to the greatest extent possible under any applicable law and the validity or enforceability of any other provision of this Agreement shall not be affected." })
          ] })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ D(il, {})
  ] });
}
const vS = /^\d*\.?\d*$/, bS = /[^0-9.]/g;
function xS(e) {
  const t = Ce(
    () => ({
      input: {
        width: "100%",
        border: "none",
        backgroundImage: "none",
        backgroundColor: "transparent",
        fontSize: "inherit",
        boxShadow: "none",
        outline: "none",
        flexGrow: 1,
        textAlign: e.align || "left"
      }
    }),
    [e.align]
  ), o = (c) => {
    e.type === "number" && !vS.test(c.target.value) && (c.target.value = c.target.value.replace(bS, "")), e.onChange && e.onChange(c);
  }, i = (c) => {
    c.key === "Enter" && e.onEnter && e.onEnter(c);
  };
  return /* @__PURE__ */ D(
    "input",
    {
      ref: e.inputRef,
      id: e.id,
      style: t.input,
      placeholder: e.placeholder,
      min: e.min,
      max: e.max,
      step: e.step,
      onChange: o,
      onKeyDown: i,
      readOnly: e.disabled,
      value: e.value,
      "data-testid": e.testId
    }
  );
}
const Dh = dn(
  /* @__PURE__ */ D(
    "path",
    {
      d: "M21.0008 21.0008L15.8038 15.8038M15.8038 15.8038C17.2104 14.3972 18.0006 12.4895 18.0006 10.5003C18.0006 8.51108 17.2104 6.60336 15.8038 5.19678C14.3972 3.79021 12.4895 3 10.5003 3C8.51108 3 6.60336 3.79021 5.19678 5.19678C3.79021 6.60336 3 8.51108 3 10.5003C3 12.4895 3.79021 14.3972 5.19678 15.8038C6.60336 17.2104 8.51108 18.0006 10.5003 18.0006C12.4895 18.0006 14.3972 17.2104 15.8038 15.8038V15.8038Z",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  "Search"
);
function wS(e) {
  const t = er(), o = Ce(
    () => ({
      searchContent: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between"
      },
      container: {
        width: "100%",
        padding: "16px",
        borderRadius: "8px",
        backgroundColor: t.palette.card.secondary
      },
      input: {
        flexGrow: 1
      },
      searchBorder: {
        border: `1px solid ${gS(t.palette.divider, 50)}`,
        borderRadius: "8px"
      },
      clickable: {
        cursor: "pointer"
      }
    }),
    [t]
  ), i = _r(null), c = () => {
    i.current && i.current.focus();
  };
  return St(() => {
    c();
  }, []), /* @__PURE__ */ D(ut, { sx: o.searchBorder, children: /* @__PURE__ */ D(ut, { sx: o.container, onClick: c, children: /* @__PURE__ */ ne(ut, { sx: o.searchContent, children: [
    /* @__PURE__ */ D(ut, { sx: o.input, children: /* @__PURE__ */ D(
      xS,
      {
        value: e.value,
        inputRef: i,
        placeholder: e.placeholder,
        onChange: e.onChange,
        onEnter: e.onSearch
      }
    ) }),
    /* @__PURE__ */ D(ut, { onClick: e.onSearch, sx: e.onSearch && o.clickable, children: /* @__PURE__ */ D(Dh, {}) })
  ] }) }) });
}
function CS(e) {
  const t = er(), o = Ce(
    () => ({
      button: {
        width: "100%",
        backgroundColor: t.palette.button.primary,
        color: t.palette.button.primaryText,
        borderRadius: "8px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "12px 64px",
        cursor: "pointer",
        textAlign: "center"
      },
      disabled: {
        cursor: "not-allowed",
        pointerEvents: "none",
        backgroundColor: `${t.palette.button.disabled} !important`,
        color: `${t.palette.button.disabledText} !important`
      },
      elevated: {
        boxShadow: t.palette.card.elevation
      },
      action: {
        backgroundColor: t.palette.button.action,
        color: t.palette.button.actionText
      },
      link: {
        backgroundColor: "transparent"
      }
    }),
    [t]
  ), i = (c) => {
    e.onClick && !e.disabled && e.onClick(c);
  };
  return /* @__PURE__ */ D(
    ut,
    {
      sx: [
        o.button,
        !!e.elevated && o.elevated,
        !!e.action && o.action,
        !!e.link && o.link,
        !!e.disabled && o.disabled
      ],
      onClick: i,
      "data-testid": e.testId,
      children: e.children
    }
  );
}
function IS(e) {
  return /* @__PURE__ */ D("div", { style: { height: `${e.height || 24}px` } });
}
const NS = dn(
  /* @__PURE__ */ D(
    "path",
    {
      d: "M12.0003 9.99993V13.7499M2.69731 17.1259C1.83131 18.6259 2.91431 20.4999 4.64531 20.4999H19.3553C21.0853 20.4999 22.1683 18.6259 21.3033 17.1259L13.9493 4.37793C13.0833 2.87793 10.9173 2.87793 10.0513 4.37793L2.69731 17.1259ZM12.0003 16.7499H12.0073V16.7579H12.0003V16.7499Z",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  "Alert"
);
function AS(e) {
  const t = er(), o = Ce(
    () => ({
      base: {
        width: "100%",
        padding: "8px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
        borderRadius: "8px"
      },
      error: {
        backgroundColor: t.palette.error.main + cn[25]
      },
      warning: {
        backgroundColor: t.palette.warning.main + cn[25]
      }
    }),
    [t]
  );
  return /* @__PURE__ */ D(hg, { in: e.show && !!e.content, unmountOnExit: !0, children: /* @__PURE__ */ ne(
    ut,
    {
      sx: [
        o.base,
        !!e.warning && o.warning,
        !!e.error && o.error
      ],
      style: { margin: e.margin || 0 },
      "data-testid": e.testId,
      children: [
        /* @__PURE__ */ D(NS, {}),
        e.content
      ]
    }
  ) });
}
const Vi = sr.createContext({
  route: null,
  receipt: null,
  setRoute: () => {
  },
  setReceipt: () => {
  },
  clear: () => {
  }
}), TS = ({
  children: e
}) => {
  const [t, o] = sr.useState(null), [i, c] = sr.useState(null), n = ht(() => {
    o(null), c(null);
  }, []);
  return /* @__PURE__ */ D(
    Vi.Provider,
    {
      value: { route: t, receipt: i, setRoute: o, setReceipt: c, clear: n },
      children: e
    }
  );
}, X5 = ["Linea", "Sonic"];
function LS(e, t, o, i) {
  const c = typeof e == "string" ? e : e.constructor.meta.name;
  return c.startsWith("MayanSwap") ? {
    url: `https://explorer.mayan.finance/swap/${t}`,
    name: "Mayan Explorer"
  } : ia(c) && (X5.includes(o) || X5.includes(i)) ? {
    url: ge.isMainnet ? `https://usdc.range.org/usdc/status/${t}` : "",
    name: "USDC.range Explorer"
  } : {
    url: `${dg}tx/${t}${ge.isMainnet ? "" : "?network=TESTNET"}`,
    name: "Wormholescan"
  };
}
async function SS(e, t) {
  switch (e) {
    case "ManualTokenBridge":
      return await E8(
        t
      );
    case "TokenBridgeExecutorRoute":
      return await ES(
        t
      );
    case "ManualCCTP":
      return await DS(
        t
      );
    case "ManualNtt":
    case "NttExecutorRoute":
      return K5(
        t
      );
    case "AutomaticNtt":
      return K5(
        t
      );
    case "ManualTBTC":
      return jS(
        t
      );
    case "CCTPv2StandardExecutorRoute":
    case "CCTPv2FastExecutorRoute":
      return OS(
        t
      );
    default:
      throw new Error(`Unknown route type ${e}`);
  }
}
const E8 = async (e) => {
  const t = {
    toChain: e.to,
    fromChain: e.from
  };
  if ("originTxs" in e && e.originTxs.length > 0)
    t.sendTx = e.originTxs[e.originTxs.length - 1].txid;
  else
    throw new Error("Can't find txid in receipt");
  const { payload: o } = e.attestation.attestation;
  if (!o.token)
    throw new Error("Attestation is missing token.");
  if (o.token) {
    const i = await gn(), c = i.getChain(e.from), n = i.getChain(e.to), d = await x1(c, o.token);
    if (!d) throw new Error("Unknown source token");
    const f = await x1(n, o.token);
    if (!f) throw new Error("Unknown destination token");
    t.tokenDecimals = d.decimals, t.amount = yn(
      o.token.amount,
      // VAAs are truncated to a max of 8 decimal places
      Math.min(8, d.decimals)
    ), t.tokenAddress = d.address.toString(), t.token = d.tuple, t.receivedToken = f.tuple, t.receiveAmount = t.amount;
  }
  if (o.to)
    if (e.to === "Solana") {
      if (!ge.rpcs.Solana)
        throw new Error("Missing Solana RPC");
      const i = o.to.address.toNative(e.to).toString(), c = new H1(ge.rpcs.Solana);
      try {
        const n = await q0(
          c,
          new Ko(i)
        );
        t.recipient = n.owner.toBase58();
      } catch (n) {
        console.error(n), t.recipient = i;
      }
    } else
      t.recipient = o.to.address.toNative(e.to).toString();
  return t;
}, ES = async (e) => {
  const t = await E8(
    // This is fine since the VAA type is transfer with payload
    e
  );
  return t.recipient = // @ts-ignore
  e.attestation.attestation.payload.payload.targetRecipient.toNative(t.toChain).toString(), t;
}, DS = async (e) => {
  const t = {
    toChain: e.to,
    fromChain: e.from
  };
  if ("originTxs" in e && e.originTxs.length > 0)
    t.sendTx = e.originTxs[e.originTxs.length - 1].txid;
  else
    throw new Error("Can't find txid in receipt");
  if (!e.attestation.attestation)
    throw new Error("Missing Circle attestation");
  const { payload: o } = e.attestation.attestation.message, i = un.tokenId(
    e.from,
    e.from === "Sui" ? (
      // The `burnToken` from Sui is the keccak256 hash of the USDC token address,
      // so we need to override it with the actual USDC address
      Co.get(ge.network, e.from)
    ) : o.burnToken.toNative(e.from).toString()
  ), c = ge.tokens.get(i);
  if (!c)
    throw new Error("Couldn't find USDC for source chain");
  if (t.tokenAddress = i.address.toString(), t.token = c.tuple, t.tokenDecimals = c.decimals, t.amount = yn(o.amount, c.decimals), t.receiveAmount = t.amount, t.sender = o.messageSender.toNative(e.from).toString(), e.to === "Solana") {
    if (!ge.rpcs.Solana)
      throw new Error("Missing Solana RPC");
    const n = o.mintRecipient.toNative(e.to).toString(), d = new H1(ge.rpcs.Solana);
    try {
      const f = await q0(d, new Ko(n));
      t.recipient = f.owner.toBase58();
    } catch (f) {
      console.error(f), t.recipient = n;
    }
  } else
    t.recipient = o.mintRecipient.toNative(e.to).toString();
  if (t.toChain) {
    const n = Co.get(
      ge.network,
      t.toChain
    );
    if (!n)
      throw new Error("Couldn't find USDC for destination chain");
    const d = ge.tokens.get(
      t.toChain,
      n
    );
    if (!d)
      throw new Error("Couldn't find USDC for destination chain");
    t.receivedToken = d.tuple;
  }
  return t;
}, K5 = (e) => {
  let t = "";
  if ("originTxs" in e && e.originTxs.length > 0)
    t = e.originTxs[e.originTxs.length - 1].txid;
  else
    throw new Error("Can't find txid in receipt");
  const o = un.tokenId(
    e.from,
    e.params.normalizedParams.sourceContracts.token
  ), i = ge.tokens.get(o);
  if (!i)
    throw new Error("Unknown src token");
  const c = un.tokenId(
    e.to,
    e.params.normalizedParams.destinationContracts.token
  ), n = ge.tokens.get(c);
  if (!n)
    throw new Error("Unknown dst token");
  const { attestation: d } = e.attestation, { payload: f } = d.payloadName === "WormholeTransfer" ? d : d.payload, { trimmedAmount: p } = f.nttManagerPayload.payload, l = yn(
    p.amount,
    p.decimals
  );
  return {
    toChain: e.to,
    fromChain: e.from,
    sendTx: t,
    sender: f.nttManagerPayload.sender.toNative(e.from).toString(),
    recipient: f.nttManagerPayload.payload.recipientAddress.toNative(e.to).toString(),
    amount: l,
    tokenAddress: i.tokenId.address.toString(),
    token: i.tuple,
    tokenDecimals: p.decimals,
    receivedToken: n.tuple,
    receiveAmount: l,
    relayerFee: void 0
    // TODO: how to get?
  };
}, jS = async (e) => {
  var l;
  const t = {
    toChain: e.to,
    fromChain: e.from
  };
  if ("originTxs" in e && e.originTxs.length > 0)
    t.sendTx = e.originTxs[e.originTxs.length - 1].txid;
  else
    throw new Error("Can't find txid in receipt");
  const { payload: o } = e.attestation.attestation;
  if (!o.token)
    throw new Error("Attestation is missing token.");
  const i = await gn(), c = i.getChain(e.from), n = i.getChain(e.to), d = async (h, y) => {
    const M = m9.getNativeTbtcToken(h.chain);
    return M ? ge.tokens.get(M) : await x1(h, y);
  }, f = await d(c, o.token);
  if (!f) throw new Error("Unknown source token");
  const p = await d(n, o.token);
  if (!p) throw new Error("Unknown destination token");
  return t.tokenDecimals = f.decimals, t.amount = yn(
    o.token.amount,
    // VAAs are truncated to a max of 8 decimal places
    Math.min(8, f.decimals)
  ), t.tokenAddress = f.address.toString(), t.token = f.tuple, t.receivedToken = p.tuple, t.receiveAmount = t.amount, t.recipient = (((l = o.payload) == null ? void 0 : l.recipient) ?? o.to.address).toNative(e.to).toString(), t;
}, OS = async (e) => {
  const t = {
    toChain: e.to,
    fromChain: e.from
  };
  if ("originTxs" in e && e.originTxs.length > 0)
    t.sendTx = e.originTxs[e.originTxs.length - 1].txid;
  else
    throw new Error("Can't find txid in receipt");
  if (!e.attestation.attestation)
    throw new Error("Missing Circle attestation");
  const { messageBody: o } = e.attestation.attestation.message, i = un.tokenId(
    e.from,
    o.burnToken.toNative(e.from).toString()
  ), c = ge.tokens.get(i);
  if (!c)
    throw new Error("Couldn't find USDC for source chain");
  if (t.tokenAddress = i.address.toString(), t.token = c.tuple, t.tokenDecimals = c.decimals, t.amount = yn(
    o.amount,
    c.decimals
  ), t.receiveAmount = t.amount, t.recipient = o.mintRecipient.toNative(e.to).toString(), t.toChain) {
    const n = Co.get(
      ge.network,
      t.toChain
    );
    if (!n)
      throw new Error("Couldn't find USDC for destination chain");
    const d = ge.tokens.get(t.toChain, n);
    if (!d)
      throw new Error("Couldn't find USDC for destination chain");
    t.receivedToken = d.tuple;
  }
  return t;
}, zS = (e) => typeof e == "object" && typeof e.amount == "string" && typeof e.decimals == "number", kS = (e) => {
  const t = e;
  return zS(t == null ? void 0 : t.min);
}, x1 = async (e, t) => {
  const o = await e.getTokenBridge(), { chain: i } = e, c = t.chain === i ? await o.getTokenNativeAddress(t.chain, t.address) : await o.getWrappedAsset({
    chain: t.chain,
    address: t.address
  }), d = (await o.getWrappedNative()).toString() === c.toString() ? v9(i) : un.tokenId(i, c.toString());
  return ge.tokens.get(d);
};
function _S() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", fill: "white" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M29.8809 18.0146C29.8809 11.5195 24.5917 6.25427 18.0682 6.25427C11.5446 6.25427 6.25415 11.5195 6.25415 18.0146C6.25415 19.3574 6.4807 20.6472 6.89662 21.8493C6.8992 21.8547 6.92193 21.9236 6.92193 21.9236C7.08986 22.4557 6.25673 22.664 6.25673 22.9825C6.25673 23.4814 8.01354 23.4138 8.01354 23.9936C8.01354 24.4992 6.27541 24.6558 6.27541 25.1652C6.27541 25.8699 10.1237 25.6244 10.173 26.2294C10.2104 26.6965 8.84943 26.7257 8.84142 27.2246C8.82808 28.0221 14.0933 27.7607 14.0933 28.2914C14.0933 28.6935 11.6979 28.5475 11.6979 29.0226C11.6979 29.4976 14.8504 29.7975 18.3254 29.7975C21.8005 29.7975 24.1971 29.4127 24.1971 28.9973C24.1971 28.582 21.9604 28.667 22.0071 28.2927C22.087 27.6386 27.0523 27.973 27.0523 27.2153C27.0523 26.8159 25.6874 26.723 25.7314 26.2931C25.7941 25.6854 29.8809 25.7756 29.8809 25.1441C29.8809 24.6478 27.8548 24.5257 27.8588 24.0095C27.8615 23.4827 29.8809 23.5054 29.8675 23.0117C29.8569 22.6322 28.9638 22.6415 29.2437 21.8374C29.668 20.6075 29.8843 19.3155 29.8835 18.0146H29.8809ZM26.1273 21.3544C25.7167 22.2793 24.7943 22.0935 24.6903 22.4823C24.5824 22.8843 25.8274 22.9427 25.8274 23.3633C25.8274 23.8742 22.0324 23.6698 22.0697 24.3439C22.0938 24.7685 24.765 24.8401 24.7143 25.2833C24.641 25.9256 20.5755 25.6045 20.5355 26.2202C20.5062 26.6713 22.5203 26.6872 22.5243 27.0986C22.5283 27.4449 20.9434 27.6333 17.9069 27.6333C14.4492 27.6333 12.767 27.4476 12.9589 27.0614C13.1376 26.7005 16.1994 26.7669 16.1687 26.1989C16.1381 25.6324 10.7316 25.7982 10.5689 25.2475C10.433 24.7898 12.3457 24.6955 12.3338 24.2603C12.3217 23.8171 9.88509 23.918 9.83181 23.3806C9.79712 23.0289 11.1048 23.0502 11.0488 22.607C11.0074 22.2845 10.4676 22.3296 10.1477 21.6649C9.61569 20.5211 9.3404 19.2747 9.34118 18.0133C9.34118 13.2152 13.2495 9.32477 18.0695 9.32477C22.8895 9.32477 26.7977 13.2152 26.7977 18.0133C26.7977 19.1969 26.5591 20.3248 26.1286 21.3531L26.1273 21.3544Z",
            fill: "black"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.89666 21.8493C6.48075 20.6472 6.25419 19.3574 6.25419 18.0145C6.25419 11.5194 11.5447 6.25422 18.0682 6.25422C24.5917 6.25422 29.8809 11.5194 29.8809 18.0145H29.8836C29.8843 19.3155 29.6681 20.6075 29.2438 21.8373C29.0703 22.336 29.3477 22.5218 29.586 22.6816C29.7321 22.7794 29.8635 22.8675 29.8676 23.0117C29.8742 23.2549 29.387 23.3728 28.8909 23.4929C28.3803 23.6164 27.8602 23.7424 27.8588 24.0095C27.8569 24.2703 28.373 24.4304 28.8843 24.5891C29.385 24.7445 29.8809 24.8984 29.8809 25.144C29.8809 25.4639 28.8325 25.5986 27.7896 25.7326C26.7734 25.8633 25.7624 25.9932 25.7315 26.293C25.7088 26.514 26.0584 26.646 26.4035 26.7762C26.7299 26.8995 27.0524 27.0212 27.0524 27.2153C27.0524 27.6089 25.7124 27.7078 24.4135 27.8036C23.212 27.8923 22.0455 27.9784 22.0071 28.2927C21.9843 28.4758 22.5077 28.5489 23.0486 28.6245C23.6134 28.7035 24.1972 28.7851 24.1972 28.9973C24.1972 29.4126 21.8005 29.7975 18.3255 29.7975C14.8504 29.7975 11.698 29.4976 11.698 29.0225C11.698 28.7751 12.3478 28.6961 12.9704 28.6205C13.5434 28.5509 14.0933 28.484 14.0933 28.2914C14.0933 28.053 13.0312 27.9745 11.8623 27.8879C10.4285 27.7818 8.83415 27.6639 8.84146 27.2246C8.84542 26.9732 9.19283 26.8411 9.53179 26.7121C9.86577 26.5851 10.1916 26.4612 10.1731 26.2293C10.1494 25.939 9.25084 25.8445 8.32243 25.7469C7.31646 25.6411 6.27554 25.5317 6.27554 25.1652C6.27554 24.91 6.71169 24.7432 7.14715 24.5769C7.5808 24.4113 8.01367 24.2458 8.01367 23.9935C8.01367 23.6928 7.54086 23.5662 7.08577 23.4444C6.66366 23.3314 6.25686 23.2225 6.25686 22.9825C6.25686 22.8523 6.39587 22.7406 6.549 22.6176C6.77056 22.4397 7.0213 22.2383 6.92197 21.9236C6.92197 21.9236 6.89933 21.8546 6.89666 21.8493ZM6.83176 21.9528C6.86499 22.0584 6.84898 22.1443 6.80585 22.223C6.76023 22.3063 6.6832 22.3829 6.59127 22.4606C6.56131 22.4859 6.52843 22.5123 6.49512 22.5392C6.43315 22.589 6.36928 22.6404 6.31866 22.689C6.24085 22.7639 6.16201 22.8609 6.16201 22.9825C6.16201 23.0764 6.20453 23.1531 6.26607 23.2132C6.32581 23.2718 6.40612 23.3178 6.49305 23.3562C6.65247 23.4268 6.85888 23.482 7.05943 23.5356L7.11074 23.5494C7.33229 23.6089 7.54206 23.6681 7.69657 23.7459C7.85478 23.8257 7.9189 23.9062 7.9189 23.9935C7.9189 24.0271 7.90513 24.0633 7.86812 24.1052C7.83024 24.1479 7.77214 24.1915 7.69485 24.2359C7.53974 24.3252 7.3304 24.4053 7.11082 24.4892L7.10798 24.4903C6.89382 24.5721 6.66985 24.6577 6.49968 24.7561C6.41395 24.8057 6.33614 24.8616 6.27907 24.9266C6.22105 24.9925 6.18068 25.0721 6.18068 25.1652C6.18068 25.3039 6.277 25.4022 6.39295 25.4703C6.51061 25.5395 6.67218 25.5926 6.85578 25.636C7.22427 25.7232 7.71318 25.7781 8.19581 25.829L8.31141 25.8412C8.75763 25.8881 9.19111 25.9338 9.52482 26C9.70653 26.0362 9.85157 26.0772 9.95064 26.1245C10.0558 26.1748 10.0769 26.2163 10.0786 26.2371C10.0835 26.298 10.0468 26.3596 9.93187 26.4311C9.81903 26.5014 9.66237 26.5609 9.49134 26.626L9.49056 26.6262C9.3247 26.6894 9.14548 26.7577 9.00794 26.8438C8.87185 26.9289 8.74954 27.0485 8.7467 27.223C8.74403 27.3829 8.87417 27.4904 9.02145 27.5628C9.17561 27.6387 9.3902 27.6978 9.63827 27.7463C10.1363 27.8434 10.7986 27.9023 11.4552 27.9527C11.5897 27.9629 11.7241 27.9729 11.8568 27.9827C12.3748 28.021 12.8686 28.0576 13.259 28.1071C13.5046 28.1383 13.7033 28.1739 13.8388 28.2165C13.9071 28.2379 13.9527 28.2591 13.9793 28.2781C13.9898 28.2856 13.9951 28.291 13.9976 28.2941C13.9964 28.2962 13.9951 28.2981 13.9935 28.2999C13.9865 28.3084 13.972 28.3208 13.9453 28.3352C13.8916 28.3643 13.8084 28.3911 13.6984 28.4158C13.4974 28.4608 13.2335 28.4929 12.9579 28.5264L12.8842 28.5353C12.5863 28.5717 12.2801 28.6112 12.0481 28.6726C11.9326 28.7032 11.8276 28.741 11.7496 28.7914C11.6718 28.8416 11.6032 28.9165 11.6032 29.0225C11.6032 29.1379 11.6966 29.2189 11.7929 29.2745C11.8964 29.3342 12.0424 29.3874 12.22 29.4356C12.577 29.5324 13.0854 29.6151 13.6982 29.6825C14.9252 29.8173 16.5858 29.8923 18.3255 29.8923C20.0659 29.8923 21.5385 29.796 22.5779 29.6471C23.0968 29.5727 23.5116 29.4847 23.7988 29.3875C23.9417 29.3391 24.0585 29.2866 24.1415 29.2289C24.2206 29.1739 24.2919 29.0977 24.2919 28.9973C24.2919 28.8963 24.2227 28.8272 24.1514 28.7826C24.0783 28.7369 23.9803 28.7019 23.8731 28.673C23.6573 28.6148 23.3728 28.5741 23.0978 28.5356L23.0647 28.5309C22.7976 28.4936 22.5419 28.4579 22.3527 28.4102C22.2535 28.3852 22.1811 28.3589 22.1368 28.3321C22.115 28.3189 22.1055 28.3088 22.102 28.3038L22.1014 28.3028C22.1029 28.2936 22.1096 28.2773 22.1373 28.2544C22.1669 28.2299 22.2138 28.204 22.2808 28.1784C22.4144 28.1272 22.6067 28.0848 22.8434 28.0488C23.2792 27.9825 23.8438 27.9409 24.4216 27.8982L24.5668 27.8875C25.1912 27.8411 25.8197 27.7912 26.2923 27.7047C26.5279 27.6616 26.7321 27.6081 26.8795 27.538C27.0203 27.4711 27.1472 27.37 27.1472 27.2153C27.1472 27.1357 27.1125 27.0689 27.0644 27.0152C27.0173 26.9626 26.9541 26.9186 26.8863 26.8803C26.7595 26.8091 26.5955 26.7472 26.4394 26.6883L26.4089 26.6768C26.2389 26.6126 26.0816 26.5513 25.9691 26.4816C25.8517 26.4089 25.8208 26.351 25.8257 26.3028C25.828 26.2813 25.8535 26.2364 25.9689 26.1806C26.0766 26.1286 26.2328 26.0816 26.4267 26.0387C26.8042 25.955 27.3008 25.8912 27.8047 25.8264L27.8418 25.8216C28.355 25.7557 28.8731 25.6882 29.263 25.597C29.4572 25.5515 29.6267 25.4987 29.7495 25.4338C29.8659 25.3721 29.9757 25.2804 29.9757 25.144C29.9757 25.0463 29.9251 24.9668 29.8586 24.9046C29.7927 24.8428 29.7033 24.7904 29.6047 24.744C29.4128 24.6537 29.1608 24.5756 28.9163 24.4997L28.8965 24.4935C28.6413 24.4144 28.396 24.3373 28.2144 24.2493C28.1236 24.2053 28.0552 24.1615 28.0108 24.1181C27.967 24.0755 27.9533 24.0404 27.9536 24.0102V24.01C27.9538 23.9784 27.968 23.9445 28.0104 23.9057C28.0542 23.8655 28.1219 23.8264 28.2124 23.7883C28.3934 23.7121 28.6376 23.6519 28.8915 23.5904L28.917 23.5842C29.1582 23.5259 29.4064 23.4658 29.5952 23.3898C29.6928 23.3505 29.7821 23.304 29.848 23.2459C29.9152 23.1864 29.965 23.1079 29.9624 23.0091V23.009C29.9585 22.8714 29.8729 22.7774 29.7856 22.7071C29.7415 22.6716 29.6918 22.6382 29.6445 22.6064L29.6397 22.6032C29.5928 22.5718 29.5475 22.5414 29.5044 22.5084C29.4154 22.4401 29.3458 22.3672 29.3103 22.2732C29.2756 22.1809 29.2686 22.0544 29.3333 21.8686L29.3334 21.8683C29.7611 20.6285 29.979 19.326 29.9784 18.0145V17.9197H29.9754C29.9241 11.4152 24.6117 6.15936 18.0682 6.15936C11.4929 6.15936 6.15942 11.4664 6.15942 18.0145C6.15942 19.3681 6.38778 20.6684 6.80706 21.8804L6.80913 21.8863L6.80999 21.888L6.81214 21.8943C6.81455 21.901 6.81747 21.9098 6.82049 21.9187L6.82841 21.9426L6.83099 21.9503L6.83159 21.9522M13.9997 28.2972C13.9997 28.2972 13.9994 28.2971 13.9992 28.2964L13.9997 28.2972ZM26.1286 21.3531C26.5592 20.3247 26.7978 19.1969 26.7978 18.0132C26.7978 13.2152 22.8896 9.32472 18.0696 9.32472C13.2496 9.32472 9.34131 13.2152 9.34131 18.0132C9.34131 19.3175 9.6319 20.5543 10.1478 21.6648C10.3259 22.0351 10.5724 22.1852 10.7629 22.3012C10.9143 22.3934 11.0305 22.4641 11.0488 22.6069C11.0785 22.8418 10.7252 22.9462 10.3918 23.0449C10.0959 23.1323 9.8155 23.2152 9.83186 23.3806C9.85966 23.6614 10.5386 23.7679 11.1821 23.8689C11.7699 23.9612 12.3281 24.0487 12.3338 24.2603C12.3396 24.471 11.8941 24.6018 11.4484 24.7327C10.9737 24.872 10.4989 25.0114 10.5689 25.2475C10.6493 25.5197 12.0108 25.6167 13.371 25.7138C14.7627 25.8131 16.1533 25.9123 16.1688 26.1989C16.1861 26.5197 15.2165 26.6381 14.3373 26.7455C13.6602 26.8282 13.0366 26.9044 12.959 27.0614C12.767 27.4475 14.4492 27.6332 17.9069 27.6332C20.9434 27.6332 22.5283 27.4448 22.5244 27.0985C22.5224 26.8984 22.0449 26.7919 21.5583 26.6833C21.0445 26.5687 20.5205 26.4519 20.5356 26.2201C20.5554 25.9153 21.5623 25.84 22.5827 25.7639C23.623 25.6862 24.6774 25.6075 24.7144 25.2833C24.7402 25.0576 24.0597 24.9282 23.3826 24.7995C22.7305 24.6755 22.0816 24.5522 22.0698 24.3439C22.0498 23.983 23.1279 23.8739 24.1342 23.7721C25.0079 23.6837 25.8274 23.6007 25.8274 23.3633C25.8274 23.1559 25.5247 23.0365 25.2308 22.9207C24.9286 22.8015 24.6356 22.686 24.6904 22.4822C24.7322 22.3259 24.9064 22.2625 25.1264 22.1823C25.4535 22.0632 25.8819 21.9072 26.1273 21.3544L26.1286 21.3531ZM26.0485 21.299C26.4697 20.2867 26.703 19.1773 26.703 18.0132C26.703 13.2681 22.8378 9.41966 18.0696 9.41966C13.3013 9.41966 9.43608 13.2681 9.43608 18.0132C9.43526 19.2606 9.7074 20.4931 10.2334 21.6242C10.3822 21.9331 10.58 22.0761 10.7528 22.1837C10.7709 22.195 10.7894 22.2062 10.8079 22.2174C10.8751 22.2583 10.9429 22.2996 10.9964 22.3444C11.0695 22.4057 11.1285 22.4832 11.1428 22.5949L11.1429 22.5951C11.1643 22.7648 11.0486 22.8762 10.9247 22.9476C10.7993 23.0199 10.6313 23.0726 10.4754 23.1191L10.4186 23.1359C10.2788 23.1773 10.1512 23.2151 10.0551 23.2597C10.001 23.2849 9.96536 23.3087 9.94504 23.3301C9.92705 23.3489 9.92516 23.361 9.92611 23.3711C9.92895 23.3992 9.94763 23.4346 10.008 23.4763C10.068 23.5178 10.157 23.5563 10.2715 23.5917C10.5 23.6624 10.803 23.7131 11.113 23.762L11.1977 23.7752C11.4762 23.819 11.7544 23.8626 11.9696 23.9197C12.0876 23.9509 12.1943 23.9882 12.2737 24.0358C12.3509 24.0821 12.4257 24.1529 12.4285 24.2577M12.4285 24.2577C12.4311 24.351 12.3807 24.4249 12.3187 24.4799C12.2569 24.5347 12.1732 24.5806 12.0821 24.6207C11.9118 24.6956 11.6905 24.7606 11.477 24.8231L11.4316 24.8365C11.1994 24.9047 10.9823 24.9707 10.8314 25.0462C10.7555 25.0842 10.7059 25.12 10.6791 25.1522C10.6559 25.1802 10.6536 25.1995 10.6598 25.2205C10.6597 25.2201 10.6607 25.2241 10.668 25.2317C10.6755 25.2396 10.6878 25.2497 10.7071 25.2613C10.746 25.2847 10.804 25.3087 10.8823 25.3324C11.0384 25.3793 11.2569 25.4195 11.5208 25.4547C12.0358 25.5234 12.7058 25.5712 13.3797 25.6192L13.4251 25.6225C14.1119 25.6715 14.7993 25.7213 15.317 25.7947C15.5751 25.8312 15.7965 25.8743 15.9562 25.9279C16.0354 25.9546 16.1056 25.9858 16.1583 26.0241C16.2101 26.0617 16.2592 26.1172 16.2634 26.1937C16.2699 26.3148 16.1912 26.403 16.0989 26.4636C16.0054 26.5249 15.8764 26.5735 15.7306 26.6139C15.4376 26.6953 15.0456 26.7523 14.6543 26.8019C14.5511 26.815 14.4481 26.8276 14.3466 26.84C14.0593 26.8751 13.7845 26.9087 13.5561 26.9477C13.4017 26.9743 13.2733 27.0025 13.1795 27.034C13.1326 27.0497 13.0977 27.0652 13.0737 27.0797C13.0484 27.095 13.0435 27.1042 13.0439 27.1035L13.0438 27.1037C13.0384 27.1144 13.0389 27.1193 13.039 27.1204C13.0392 27.1216 13.04 27.1269 13.0479 27.1366C13.0665 27.1593 13.1112 27.191 13.1991 27.2251C13.3718 27.2921 13.6618 27.3506 14.0751 27.3977C14.8982 27.4918 16.1787 27.5383 17.9069 27.5383C19.4242 27.5383 20.5751 27.4912 21.3449 27.4014C21.7307 27.3565 22.0153 27.3013 22.2011 27.2382C22.2945 27.2066 22.3565 27.1749 22.3933 27.1461C22.4297 27.1176 22.4296 27.1018 22.4296 27.0996V27.0994C22.4295 27.0915 22.4253 27.0707 22.3804 27.0377C22.3364 27.0053 22.2679 26.9729 22.1764 26.9408C22.0033 26.8799 21.774 26.8288 21.5351 26.7754L21.4968 26.7669C21.2485 26.7114 20.9919 26.6528 20.7992 26.5784C20.7032 26.5414 20.6154 26.4975 20.5511 26.4429C20.4857 26.3873 20.4346 26.3111 20.441 26.2139C20.4498 26.079 20.5661 25.9957 20.685 25.9427C20.8112 25.8863 20.983 25.8443 21.1791 25.8108C21.564 25.7447 22.0697 25.707 22.5724 25.6694L22.6054 25.667C23.1222 25.6284 23.6332 25.5894 24.0196 25.5206C24.2133 25.4861 24.3689 25.4452 24.4762 25.3963C24.5896 25.3446 24.6172 25.299 24.6202 25.2725C24.6204 25.2706 24.6209 25.2667 24.6147 25.2574C24.6073 25.2464 24.5922 25.231 24.564 25.2123C24.5072 25.1747 24.4173 25.137 24.2979 25.0999C24.0604 25.0262 23.7362 24.9634 23.4024 24.8999L23.3626 24.8923C23.0449 24.8319 22.7218 24.7705 22.4739 24.6987C22.3452 24.6613 22.2303 24.6195 22.145 24.5702C22.0657 24.5244 21.9811 24.4543 21.9752 24.3492V24.3491C21.9675 24.2116 22.0608 24.1141 22.172 24.0477C22.2847 23.9802 22.4412 23.9282 22.6192 23.8858C22.9769 23.8005 23.4541 23.7463 23.9249 23.6979L24.1252 23.6775C24.5293 23.6367 24.9172 23.5974 25.2184 23.5438C25.3945 23.5124 25.5337 23.4773 25.6271 23.4372C25.6738 23.4171 25.703 23.3982 25.7192 23.3826C25.7241 23.3783 25.7283 23.373 25.7315 23.3672C25.7326 23.3649 25.7327 23.364 25.7327 23.3633C25.7327 23.3111 25.6947 23.2532 25.5849 23.1855C25.4803 23.1211 25.34 23.0658 25.1911 23.007L25.1837 23.0041C25.0378 22.9466 24.8815 22.8847 24.7695 22.809C24.7129 22.7709 24.6602 22.7243 24.6263 22.666C24.6079 22.6349 24.5959 22.6004 24.5912 22.5646C24.5865 22.5288 24.5891 22.4924 24.5989 22.4576C24.6359 22.3194 24.745 22.2418 24.86 22.1864C24.9183 22.1585 24.9835 22.1336 25.0499 22.1092L25.0948 22.0928C25.1498 22.0731 25.2045 22.0525 25.2588 22.0312C25.5424 21.9179 25.8496 21.7463 26.0407 21.3158L26.048 21.2995L26.0485 21.299",
            fill: "black"
          }
        )
      ]
    }
  );
}
function BS() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", fill: "#E84142" }),
        /* @__PURE__ */ D(
          "ellipse",
          {
            cx: "18.2683",
            cy: "18.2682",
            rx: "12.0875",
            ry: "12.0875",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M35.5131 18.2567C35.5131 27.7873 27.7873 35.5131 18.2567 35.5131C8.72631 35.5131 1.00037 27.7873 1.00037 18.2567C1.00037 8.72631 8.72631 1.00037 18.2567 1.00037C27.7873 1.00037 35.5131 8.72631 35.5131 18.2567ZM13.3668 25.1239H10.0178C9.31408 25.1239 8.96647 25.1239 8.75452 24.9883C8.52559 24.8399 8.3857 24.594 8.36875 24.3227C8.35602 24.0727 8.52984 23.7673 8.87745 23.1569L17.1465 8.58157C17.4984 7.96264 17.6764 7.65317 17.9011 7.53872C18.1427 7.41579 18.431 7.41579 18.6726 7.53872C18.8973 7.65317 19.0754 7.96264 19.4272 8.58157L21.1271 11.549L21.1358 11.5642C21.5158 12.2282 21.7085 12.5649 21.7927 12.9183C21.8859 13.304 21.8859 13.711 21.7927 14.0968C21.7079 14.4529 21.5171 14.792 21.1314 15.4661L16.7878 23.1442L16.7766 23.1639C16.3941 23.8333 16.2002 24.1726 15.9315 24.4286C15.639 24.7085 15.2872 24.9118 14.9014 25.0265C14.5495 25.1239 14.1553 25.1239 13.3668 25.1239ZM21.8241 25.1239H26.6228C27.3307 25.1239 27.6869 25.1239 27.8989 24.9842C28.1278 24.8358 28.2719 24.5855 28.2847 24.3144C28.2969 24.0724 28.1269 23.779 27.7937 23.204C27.7822 23.1845 27.7707 23.1645 27.759 23.1443L25.3553 19.0322L25.328 18.9859C24.9902 18.4148 24.8197 18.1263 24.6007 18.0148C24.3592 17.8919 24.075 17.8919 23.8334 18.0148C23.613 18.1293 23.435 18.4303 23.0831 19.0365L20.6879 23.1485L20.6797 23.1627C20.3291 23.7679 20.1539 24.0704 20.1665 24.3185C20.1835 24.5899 20.3234 24.8399 20.5523 24.9883C20.76 25.1239 21.1161 25.1239 21.8241 25.1239Z",
            fill: "#E84142"
          }
        )
      ]
    }
  );
}
function FS() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", fill: "#FCFF52" }),
        /* @__PURE__ */ D(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M27.9986 8H8V28H28V21.0184H24.6812C23.5373 23.5658 20.962 25.3389 18.015 25.3389C13.9527 25.3389 10.6625 22.02 10.6625 17.9865C10.6625 13.9516 13.9527 10.6611 18.015 10.6611C21.0192 10.6611 23.5945 12.4924 24.7384 15.0953H28V8H27.9986Z",
            fill: "black"
          }
        )
      ]
    }
  );
}
function RS() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", fill: "white" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M17.8051 5L17.6345 5.5795V22.3938L17.8051 22.564L25.61 17.9505L17.8051 5Z",
            fill: "#343434"
          }
        ),
        /* @__PURE__ */ D("path", { d: "M17.805 5L10 17.9505L17.805 22.564V14.4028V5Z", fill: "#8C8C8C" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M17.8051 24.0417L17.709 24.1589V30.1484L17.8051 30.4291L25.6148 19.4306L17.8051 24.0417Z",
            fill: "#3C3C3B"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M17.805 30.4291V24.0417L10 19.4306L17.805 30.4291Z",
            fill: "#8C8C8C"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M17.8051 22.564L25.6099 17.9505L17.8051 14.4028V22.564Z",
            fill: "#141414"
          }
        ),
        /* @__PURE__ */ D("path", { d: "M10 17.9505L17.805 22.564V14.4028L10 17.9505Z", fill: "#393939" })
      ]
    }
  );
}
function PS() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", fill: "#13B5EC" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M16.7073 6.23963C17.3111 5.92012 18.2345 5.92012 18.8384 6.23963L25.0178 9.49782C25.3829 9.69093 25.583 9.97532 25.6181 10.2738H25.6252V26.649C25.6181 26.972 25.4145 27.2915 25.0178 27.5022L18.8384 30.7604C18.2345 31.0799 17.3111 31.0799 16.7073 30.7604L10.5279 27.5022C10.1347 27.295 9.94509 26.972 9.93456 26.649C9.93456 26.6174 9.93456 26.5893 9.93456 26.5683V10.3861C9.93456 10.365 9.93456 10.3405 9.93456 10.3194V10.2773H9.93807C9.96615 9.97883 10.1557 9.69795 10.5279 9.50133L16.7073 6.23963ZM24.6421 19.3777L18.8349 22.4499C18.231 22.7694 17.3111 22.7694 16.7037 22.4499L10.9106 19.3848V26.5999L16.7037 29.6474C17.0478 29.83 17.4024 30.009 17.75 30.016H17.7711C18.1187 30.016 18.4522 29.8405 18.7928 29.6755L24.6421 26.5718V19.3777ZM8.96201 26.2944C8.96201 26.9229 9.03574 27.3337 9.17618 27.6251C9.29556 27.8673 9.47462 28.0499 9.80114 28.2746L9.81869 28.2886C9.88891 28.3378 9.96966 28.3869 10.0645 28.4466L10.1768 28.5169L10.5244 28.7275L10.0294 29.5596L9.63963 29.3244L9.57292 29.2822C9.46057 29.212 9.36577 29.1523 9.28151 29.0927C8.3511 28.4607 8.00702 27.7725 8 26.3365V26.2944H8.96201ZM17.3041 15.0241C17.2585 15.0382 17.2163 15.0592 17.1777 15.0768L11.0089 18.3455C11.0019 18.349 10.9949 18.3525 10.9914 18.356L10.9843 18.3596L10.9949 18.3666L11.0089 18.3736L17.1777 21.6423C17.2163 21.6634 17.2585 21.681 17.3041 21.695V15.0241ZM18.2872 15.0241V21.695C18.3328 21.681 18.375 21.6599 18.4136 21.6423L24.5824 18.3736C24.5894 18.3701 24.5964 18.3666 24.6 18.3631L24.6035 18.3596L24.5929 18.3525L24.5789 18.3455L18.4101 15.0768C18.375 15.0592 18.3328 15.0382 18.2872 15.0241ZM24.6421 11.4429L19.0947 14.357L24.6421 17.2712V11.4429ZM10.9141 11.4429V17.2712L16.4615 14.357L10.9141 11.4429ZM18.4066 7.11035C18.0871 6.94182 17.5042 6.94182 17.1847 7.11035L11.0089 10.3756C11.0019 10.3791 10.9949 10.3826 10.9914 10.3861L10.9843 10.3896L10.9949 10.3966L11.0089 10.4037L17.1847 13.6689C17.5042 13.8374 18.0871 13.8374 18.4066 13.6689L24.5824 10.4037C24.5894 10.4001 24.5964 10.3966 24.6 10.3931L24.6035 10.3896L24.5929 10.3826L24.5789 10.3756L18.4066 7.11035ZM25.562 7.44038L25.9517 7.67562L26.0184 7.71775C26.1307 7.78797 26.2255 7.84766 26.3098 7.90735C27.2402 8.53932 27.5843 9.22748 27.5913 10.6635V10.7056H26.6293C26.6293 10.0771 26.5556 9.66635 26.4151 9.37494C26.2958 9.13268 26.1167 8.95011 25.7902 8.72541L25.7726 8.71136C25.7024 8.66221 25.6217 8.61305 25.5269 8.55337L25.4145 8.48315L25.0669 8.27249L25.562 7.44038Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function US() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", fill: "black" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M10.4854 22.4808C10.6216 22.3449 10.8064 22.2687 10.999 22.2687H28.7693C29.093 22.2687 29.255 22.6593 29.026 22.8877L25.5147 26.3893C25.3784 26.5252 25.1937 26.6015 25.0011 26.6015H7.23081C6.9071 26.6015 6.74507 26.2108 6.97406 25.9825L10.4854 22.4808Z",
            fill: "url(#linearGradient_icons_chains_sol_0)"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M10.4854 9.39895C10.6216 9.26308 10.8064 9.18677 10.999 9.18677H28.7693C29.093 9.18677 29.255 9.57744 29.026 9.80581L25.5147 13.3074C25.3784 13.4433 25.1937 13.5196 25.0011 13.5196H7.23081C6.9071 13.5196 6.74507 13.129 6.97406 12.9006L10.4854 9.39895Z",
            fill: "url(#linearGradient_icons_chains_sol_1)"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M25.5147 15.8982C25.3784 15.7624 25.1937 15.686 25.0011 15.686H7.23081C6.9071 15.686 6.74507 16.0767 6.97406 16.305L10.4854 19.8067C10.6216 19.9425 10.8064 20.0189 10.999 20.0189H28.7693C29.093 20.0189 29.255 19.6282 29.026 19.3998L25.5147 15.8982Z",
            fill: "url(#linearGradient_icons_chains_sol_2)"
          }
        )
      ]
    }
  );
}
function YS() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", fill: "white" }),
        /* @__PURE__ */ ne("g", { clipPath: "url(#icons_chains_apt_clipPath_0)", children: [
          /* @__PURE__ */ D(
            "path",
            {
              d: "M36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36C27.9411 36 36 27.9411 36 18Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ D(
            "path",
            {
              d: "M6 16.9982L6.65314 14.2624C6.696 14.1538 6.97886 14.021 7.15371 14.021H17.7497C18.468 14.0434 19.0337 13.8245 19.4897 13.2332C20.2954 12.2264 20.5337 12.2264 21.3617 13.2108C21.5667 13.4867 21.8379 13.7058 22.15 13.8475C22.4621 13.9892 22.8049 14.0489 23.1463 14.021L28.8463 13.9986C29.1943 13.9986 29.3897 14.0865 29.4549 14.4365L30 16.9775H29.3263C26.6709 16.9775 24.0394 16.9551 21.384 17C21.1328 17.0156 20.8816 16.9679 20.6535 16.861C20.4253 16.7541 20.2274 16.5915 20.0777 16.388C19.272 15.3588 18.9686 15.0761 17.9246 16.3225C17.4891 16.8483 17.0109 17 16.38 16.9793L6.76286 16.9569C6.588 17 6.39257 17 6.00171 17L6 16.9982ZM6.17486 20.2375H13.5514C14.2251 20.2375 14.7909 20.0841 15.2057 19.4928C15.3137 19.3393 15.4457 19.2307 15.576 19.0773C16.0337 18.5739 16.4469 18.5308 16.8377 19.0773C17.4909 20.041 18.3171 20.2582 19.428 20.2375L29.088 20.2151H29.8714L28.8703 23.0372C28.8274 23.1251 28.6097 23.1906 28.4571 23.1906H16.7726C16.512 23.1906 16.2291 23.0147 16.032 22.8406C15.7491 22.5993 15.5314 22.2717 15.2709 22.0097C14.9451 21.6821 14.5749 21.6597 14.2269 21.9873L14.184 22.0304C13.488 23.1906 12.4217 23.3216 11.1806 23.2561C10.0269 23.1682 8.87486 23.213 7.69886 23.2561C7.32857 23.2561 7.13314 23.1251 7.02514 22.7958L6.17657 20.2358L6.17486 20.2375ZM8.48229 10.8059C13.0303 4.50492 22.7554 4.30667 27.5211 10.7628C26.6726 10.7628 25.8463 10.8507 25.0406 10.7197C24.6926 10.6766 24.3874 10.2387 24.1269 9.93185C23.3657 9.10091 23.148 9.05609 22.4297 9.90944C21.864 10.5663 21.2554 10.8283 20.3623 10.8283L9.17829 10.8059H8.48229ZM9.31029 26.1661C10.0286 26.1437 10.3543 25.6196 10.7469 25.1817C11.3554 24.4818 11.7257 24.4387 12.2691 25.1817C12.8349 25.992 13.5531 26.1885 14.4891 26.1661L26.064 26.1437H26.6726C22.8 30.9138 14.1823 31.6361 9.30857 26.1661H9.31029Z",
              fill: "black"
            }
          )
        ] })
      ]
    }
  );
}
function WS() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", fill: "#4DA2FF" }),
        /* @__PURE__ */ D("g", { clipPath: "url(#icons_chains_sui_clipPath_0)", children: /* @__PURE__ */ D(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M23.406 16.0068C24.342 17.2334 24.906 18.7916 24.906 20.4813C24.906 22.171 24.33 23.7731 23.364 25.0122L23.28 25.1186L23.256 24.9809C23.238 24.8683 23.214 24.7494 23.19 24.6305C22.71 22.4214 21.138 20.5251 18.546 18.9856C16.8 17.953 15.798 16.7077 15.534 15.2933C15.366 14.3796 15.492 13.4597 15.732 12.6712C15.978 11.8826 16.338 11.2255 16.644 10.8313L17.652 9.54835C17.826 9.32306 18.162 9.32306 18.336 9.54835L23.406 16.0068ZM24.996 14.7238L18.252 6.12515C18.126 5.96243 17.88 5.96243 17.754 6.12515L11.004 14.7238L10.98 14.7551C9.744 16.3635 9 18.4036 9 20.6253C9 25.8008 13.032 30 18 30C22.968 30 27 25.8008 27 20.6253C27 18.4036 26.256 16.3635 25.014 14.7551L24.996 14.7238ZM12.618 15.9817L13.218 15.212L13.236 15.3559C13.248 15.4686 13.266 15.5812 13.29 15.6939C13.68 17.8279 15.078 19.6115 17.406 20.9882C19.434 22.1898 20.61 23.5729 20.952 25.0936C21.096 25.7257 21.12 26.3515 21.06 26.8959L21.054 26.9272L21.024 26.9398C20.112 27.4029 19.08 27.6657 17.994 27.6657C14.184 27.6657 11.094 24.449 11.094 20.4813C11.094 18.7791 11.664 17.2083 12.618 15.9817Z",
            fill: "white"
          }
        ) })
      ]
    }
  );
}
function HS() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", fill: "#0052FF" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M17.9773 31C25.1695 31 31 25.1797 31 18C31 10.8203 25.1695 5 17.9773 5C11.1537 5 5.55599 10.2388 5 16.9072H22.2131V19.0928H5C5.55599 25.761 11.1537 31 17.9773 31Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function ZS() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "360",
      height: "360",
      viewBox: "0 0 360 360",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "360", height: "360", rx: "30", fill: "#6C00F6" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M218.804 99.5819L168.572 128.432V218.473L140.856 234.539L112.97 218.46V186.313L140.856 170.39L158.786 180.788V154.779L140.699 144.511L90.4795 173.687V231.399L140.869 260.418L191.088 231.399V141.371L218.974 125.291L246.846 141.371V173.374L218.974 189.597L200.887 179.107V204.986L218.804 215.319L269.519 186.47V128.432L218.804 99.5819Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function QS() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", fill: "#F0B90B" }),
        /* @__PURE__ */ D(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18 0C27.9418 0 36 8.05817 36 18C36 27.9418 27.9418 36 18 36C8.05817 36 0 27.9418 0 18C0 8.05817 8.05817 0 18 0Z",
            fill: "#F0B90B"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M9.89289 18L9.90587 22.7596L13.9501 25.1394V27.9259L7.53904 24.1658V16.6081L9.89289 18ZM9.89289 13.2403V16.0139L7.5376 14.6206V11.8471L9.89289 10.4538L12.2597 11.8471L9.89289 13.2403ZM15.639 11.8471L17.9943 10.4538L20.3612 11.8471L17.9943 13.2403L15.639 11.8471Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M11.5948 21.773V18.9865L13.9501 20.3798V23.1533L11.5948 21.773ZM15.6391 26.1374L17.9944 27.5307L20.3612 26.1374V28.911L17.9944 30.3043L15.6391 28.911V26.1374ZM23.7391 11.8471L26.0944 10.4538L28.4612 11.8471V14.6206L26.0944 16.0139V13.2403L23.7391 11.8471ZM26.0944 22.7596L26.1073 18L28.4626 16.6067V24.1644L22.0516 27.9245V25.1379L26.0944 22.7596Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M24.4053 21.7731L22.05 23.1534V20.3798L24.4053 18.9865V21.7731Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M24.4054 14.227L24.4184 17.0135L20.3626 19.3933V24.1645L18.0073 25.5447L15.6521 24.1645V19.3933L11.5963 17.0135V14.227L13.9617 12.8337L17.9929 15.225L22.0487 12.8337L24.4155 14.227H24.4054ZM11.5948 9.46879L17.9944 5.69571L24.4054 9.46879L22.0501 10.8621L17.9944 8.47071L13.9501 10.8621L11.5948 9.46879Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function VS() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", fill: "#213147" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M7.35034 12.904V23.096C7.35034 23.7512 7.69354 24.344 8.26554 24.6768L17.0951 29.7728C17.6567 30.0952 18.3535 30.0952 18.9151 29.7728L27.7447 24.6768C28.3063 24.3544 28.6599 23.7512 28.6599 23.096V12.904C28.6599 12.2488 28.3167 11.656 27.7447 11.3232L18.9151 6.2272C18.3535 5.9048 17.6567 5.9048 17.0951 6.2272L8.26554 11.3232C7.70394 11.6456 7.36074 12.2488 7.36074 12.904H7.35034Z",
            fill: "#213147"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M19.924 19.976L18.6656 23.4288C18.6344 23.5224 18.6344 23.6264 18.6656 23.7304L20.8288 29.6688L23.3352 28.2232L20.3296 19.976C20.2568 19.7888 19.9968 19.7888 19.924 19.976Z",
            fill: "#12AAFF"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M22.4512 14.1728C22.3784 13.9856 22.1184 13.9856 22.0456 14.1728L20.7872 17.6256C20.756 17.7192 20.756 17.8232 20.7872 17.9272L24.3336 27.6512L26.84 26.2056L22.4512 14.1832V14.1728Z",
            fill: "#12AAFF"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M18 6.612C18.0624 6.612 18.1248 6.6328 18.1768 6.664L27.724 12.176C27.8384 12.2384 27.9008 12.3632 27.9008 12.488V23.512C27.9008 23.6368 27.828 23.7616 27.724 23.824L18.1768 29.336C18.1248 29.3672 18.0624 29.388 18 29.388C17.9376 29.388 17.8752 29.3672 17.8232 29.336L8.27601 23.824C8.16161 23.7616 8.09921 23.6368 8.09921 23.512V12.4776C8.09921 12.3528 8.17201 12.228 8.27601 12.1656L17.8232 6.6536C17.8752 6.6224 17.9376 6.6016 18 6.6016V6.612ZM18 5C17.6568 5 17.324 5.0832 17.012 5.26L7.46481 10.772C6.85121 11.1256 6.47681 11.7704 6.47681 12.4776V23.5016C6.47681 24.2088 6.85121 24.8536 7.46481 25.2072L17.012 30.7192C17.3136 30.896 17.6568 30.9792 18 30.9792C18.3432 30.9792 18.676 30.896 18.988 30.7192L28.5352 25.2072C29.1488 24.8536 29.5232 24.2088 29.5232 23.5016V12.4776C29.5232 11.7704 29.1488 11.1256 28.5352 10.772L18.9776 5.26C18.676 5.0832 18.3328 5 17.9896 5H18Z",
            fill: "#9DCCED"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M11.6768 27.6616L12.5608 25.2488L14.3288 26.7152L12.6752 28.2336L11.6768 27.6616Z",
            fill: "#213147"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M17.1888 11.6976H14.7656C14.5888 11.6976 14.4224 11.812 14.36 11.9784L9.17041 26.2056L11.6768 27.6512L17.3968 11.9784C17.4488 11.8328 17.3448 11.6872 17.1992 11.6872L17.1888 11.6976Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M21.4321 11.6976H19.0089C18.8321 11.6976 18.6657 11.812 18.6033 11.9784L12.6753 28.2232L15.1817 29.6688L21.6297 11.9784C21.6817 11.8328 21.5777 11.6872 21.4321 11.6872V11.6976Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function GS() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "7", fill: "#FF0420" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M11.4903 24C10.1707 24 9.09018 23.6891 8.24879 23.0674C7.41626 22.4367 7 21.5307 7 20.3671C7 20.1184 7.02657 19.8253 7.07971 19.47C7.22142 18.6706 7.42512 17.7113 7.69082 16.5833C8.44364 13.5278 10.3921 12 13.5274 12C14.3776 12 15.1481 12.1421 15.8213 12.4352C16.4944 12.7106 17.0258 13.1369 17.4155 13.7054C17.8052 14.265 18 14.9312 18 15.7039C18 15.9349 17.9734 16.228 17.9203 16.5833C17.752 17.5692 17.5572 18.5374 17.318 19.47C16.9283 20.9889 16.2641 22.1347 15.3076 22.8897C14.3599 23.6358 13.0845 24 11.4903 24ZM11.7295 21.6018C12.3494 21.6018 12.872 21.4152 13.306 21.0511C13.7488 20.6869 14.0676 20.1273 14.2536 19.3634C14.5105 18.3153 14.7053 17.4093 14.8382 16.6277C14.8824 16.3967 14.909 16.1569 14.909 15.9082C14.909 14.8956 14.3865 14.3893 13.3325 14.3893C12.7126 14.3893 12.1812 14.5759 11.7383 14.94C11.3043 15.3042 10.9944 15.8638 10.8084 16.6277C10.6047 17.3738 10.4098 18.2798 10.2061 19.3634C10.1618 19.5855 10.1353 19.8164 10.1353 20.0651C10.1264 21.0955 10.6667 21.6018 11.7295 21.6018Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M18.3639 24C18.2324 24 18.1385 23.9635 18.0634 23.8813C18.007 23.79 17.9883 23.6895 18.007 23.5708L20.4394 12.4292C20.4582 12.3014 20.524 12.2009 20.6367 12.1187C20.74 12.0365 20.8527 12 20.9748 12H25.6611C26.9665 12 28.009 12.2648 28.7979 12.7854C29.5962 13.3151 30 14.0731 30 15.0685C30 15.3516 29.9624 15.653 29.8967 15.9635C29.6056 17.2785 29.0139 18.2466 28.1123 18.8767C27.2295 19.5068 26.018 19.8174 24.4778 19.8174H22.1017L21.2941 23.5708C21.2659 23.6986 21.2095 23.7991 21.0968 23.8813C20.9935 23.9635 20.8808 24 20.7588 24H18.3639ZM24.5999 17.4521C25.0976 17.4521 25.5202 17.3242 25.8865 17.0594C26.2622 16.7945 26.5064 16.4201 26.6284 15.9269C26.666 15.7352 26.6848 15.5616 26.6848 15.4155C26.6848 15.0868 26.5815 14.8311 26.3843 14.6575C26.187 14.4749 25.8396 14.3836 25.3606 14.3836H23.2475L22.5807 17.4521H24.5999Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function $S() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", fill: "black" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M17.7211 11.2061C17.7211 10.2099 18.5249 9.39834 19.5117 9.39834H22.7158V5H19.5117C16.117 5 13.3643 7.77901 13.3643 11.2061C13.3643 12.1004 13.553 12.9505 13.8901 13.7178C11.2538 14.8429 9.50303 17.2334 9.09538 20.2586C8.61909 23.5799 9.93735 27.1628 12.8082 28.8937C15.3703 30.5226 19.3765 30.4149 21.5404 28.1552V29.6553H26V13.0139H19.5136C18.5268 13.0139 17.7229 12.2023 17.7229 11.2061H17.7211ZM21.6394 17.4142V21.5913C21.6394 23.8992 19.786 25.7686 17.5019 25.7686C15.218 25.7686 13.3643 23.8972 13.3643 21.5913C13.3643 19.2854 15.218 17.4142 17.5019 17.4142H21.6394Z",
            fill: "#BFF009"
          }
        )
      ]
    }
  );
}
function qS() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", fill: "#FFEEDA" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M27.4 21.6933V8.92C27.3733 7.85333 26.52 7 25.4533 7H12.1733C9.29333 7.05333 7 9.4 7 12.28C7 13.24 7.26667 14.0933 7.66667 14.8133C8.01333 15.4267 8.54667 15.9867 9.05333 16.4133C9.21333 16.5467 9.13333 16.4933 9.58667 16.76C10.2 17.1333 10.92 17.32 10.92 17.32V24.9467C10.9467 25.32 10.9733 25.6667 11.08 25.9867C11.3733 27.0533 12.12 27.88 13.1333 28.28C13.56 28.44 14.04 28.5467 14.5467 28.5733L25.1333 28.6267C27.24 28.6267 28.9733 26.92 28.9733 24.7867C28.9733 23.5333 28.36 22.3867 27.4 21.6933Z",
            fill: "#FFEEDA"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M27.6667 24.8666C27.6133 26.2266 26.4933 27.3199 25.1333 27.3199L17.8267 27.2932C18.4133 26.6266 18.76 25.7466 18.76 24.7866C18.76 23.2932 17.88 22.2532 17.88 22.2532H25.16C26.5467 22.2532 27.6933 23.3999 27.6933 24.7866L27.6667 24.8666Z",
            fill: "#EBC28E"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M9.74667 15.3467C8.89333 14.5467 8.30667 13.5067 8.30667 12.28V12.1467C8.38667 10.0667 10.0933 8.36 12.1733 8.30667H25.48C25.8267 8.33333 26.0933 8.57333 26.0933 8.92V20.2C26.3867 20.2533 26.5467 20.3067 26.84 20.3867C27.08 20.4667 27.4 20.6533 27.4 20.6533V8.92C27.3733 7.85333 26.52 7 25.4533 7H12.1733C9.29333 7.05333 7 9.4 7 12.28C7 13.96 7.77333 15.4 9 16.3867C9.08 16.4667 9.16 16.5467 9.4 16.5467C9.8 16.5467 10.0667 16.2267 10.04 15.9067C10.04 15.6133 9.93333 15.5067 9.74667 15.3467Z",
            fill: "#101010"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M25.1333 20.9466H14.7066C14.0133 20.9466 13.4533 21.5066 13.4533 22.2266V23.7199C13.4799 24.4133 14.0666 24.9999 14.7599 24.9999H15.5333V23.7199H14.7599V22.2533C14.7599 22.2533 14.9466 22.2533 15.1866 22.2533C16.4933 22.2533 17.4799 23.4799 17.4799 24.7866C17.4799 25.9599 16.4133 27.4266 14.6533 27.3199C13.0799 27.2133 12.2266 25.8266 12.2266 24.7866V12.0666C12.2266 11.5066 11.7466 11.0266 11.1866 11.0266H10.1466V12.3333H10.9199V24.8133C10.8666 27.3466 12.7333 28.6266 14.6533 28.6266L25.1599 28.6533C27.2666 28.6533 28.9999 26.9466 28.9999 24.8133C28.9733 22.6799 27.2666 20.9466 25.1333 20.9466ZM27.6666 24.8666C27.6133 26.2266 26.4933 27.3199 25.1333 27.3199L17.8266 27.2933C18.4133 26.6266 18.7599 25.7466 18.7599 24.7866C18.7599 23.2933 17.8799 22.2533 17.8799 22.2533H25.1599C26.5466 22.2533 27.6933 23.3999 27.6933 24.7866L27.6666 24.8666Z",
            fill: "#101010"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M22.3335 12.5467H14.4668V11.2667H22.3335C22.6801 11.2667 22.9735 11.56 22.9735 11.9067C22.9735 12.2533 22.7068 12.5467 22.3335 12.5467Z",
            fill: "#101010"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M22.3335 18.6801H14.4668V17.3734H22.3335C22.6801 17.3734 22.9735 17.6667 22.9735 18.0134C22.9735 18.3867 22.7068 18.6801 22.3335 18.6801Z",
            fill: "#101010"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M23.7201 15.6134H14.4668V14.3067H23.7201C24.0668 14.3067 24.3601 14.6 24.3601 14.9467C24.3601 15.32 24.0668 15.6134 23.7201 15.6134Z",
            fill: "#101010"
          }
        )
      ]
    }
  );
}
function JS() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", fill: "black" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M18.0484 31V26.573C17.6028 26.573 17.1475 26.5343 16.7019 26.4665L16.0045 30.8353C16.6826 30.9516 17.3703 31 18.0484 31ZM20.0827 30.845C20.7608 30.7385 21.4292 30.5835 22.0782 30.3703L20.7124 26.1565C20.2861 26.2921 19.8405 26.3987 19.3949 26.4665L20.0827 30.845ZM14.0186 30.3703L15.3845 26.1662C14.9583 26.0306 14.5417 25.8562 14.1349 25.6528L12.12 29.5954C12.7303 29.8957 13.3696 30.1572 14.0186 30.3703ZM23.9672 29.5954C24.5775 29.2854 25.1587 28.927 25.7109 28.5298L23.0954 24.9553C22.737 25.2168 22.3495 25.459 21.9426 25.6528L23.9672 29.5954ZM10.3763 28.5201L12.9918 24.9456C12.6334 24.6841 12.2846 24.3934 11.965 24.0738L8.82638 27.2027C9.31073 27.6773 9.83383 28.123 10.3763 28.5201ZM27.2511 27.2221L27.2802 27.193C27.7645 26.7183 28.2101 26.1952 28.6073 25.6528L25.0231 23.0469C24.7616 23.4054 24.4613 23.7541 24.1513 24.0641L24.1028 24.1125L25.614 25.5365L27.2511 27.2221ZM7.49925 25.6431L11.0835 23.0373C10.8219 22.6788 10.5797 22.2914 10.3763 21.8942L6.42399 23.8994C6.73398 24.5097 7.0924 25.0909 7.49925 25.6431ZM29.6729 23.9091C29.9829 23.3085 30.2444 22.6692 30.4575 22.0201L26.234 20.6639C26.0984 21.0902 25.924 21.5067 25.7206 21.9039L29.6729 23.9091ZM5.63934 22.0201L9.86289 20.6542C9.72727 20.228 9.62072 19.7921 9.55291 19.3465L5.16468 20.0343C5.27124 20.7027 5.43592 21.3711 5.63934 22.0201ZM30.9322 20.044C31.0388 19.3756 31.0969 18.6878 31.0969 18.0097H26.6602C26.6602 18.4553 26.6215 18.9106 26.5537 19.3562L30.9322 20.044ZM9.44635 18C9.44635 17.5544 9.4851 17.0991 9.55291 16.6535L5.16468 15.9657C5.05812 16.6341 5.00969 17.3219 5 18H9.44635ZM26.5537 16.6632L30.9419 15.9754C30.8353 15.307 30.6803 14.6386 30.4672 13.9896L26.2437 15.3458C26.3793 15.7817 26.4858 16.2176 26.5537 16.6632ZM9.86289 15.3458C9.99851 14.9195 10.1729 14.503 10.3763 14.1058L6.42399 12.1006C6.11401 12.7012 5.85246 13.3405 5.63934 13.9896L9.86289 15.3458ZM25.7303 14.1155L29.6923 12.1103C29.3823 11.5 29.0238 10.9188 28.617 10.3666L25.0231 12.9724C25.2847 13.3309 25.5268 13.7183 25.7303 14.1155ZM11.0835 12.9627C11.345 12.6043 11.6453 12.2556 11.965 11.9359L11.9747 11.9262L8.83607 8.79732L8.82638 8.807C8.34203 9.29136 7.89642 9.80477 7.49925 10.3569L11.0835 12.9627ZM24.1513 11.9553L25.1006 10.9963L27.2802 8.82638L27.2705 8.81669C26.7861 8.34203 26.2727 7.89642 25.7303 7.49925L23.1148 11.0738C23.4732 11.3353 23.8219 11.6259 24.1319 11.9456L24.1513 11.9553ZM13.0015 11.0544C13.3599 10.7928 13.7474 10.5604 14.1542 10.3569L12.1393 6.41431C11.5291 6.72429 10.9478 7.08271 10.3957 7.47988L13.0015 11.0544ZM21.9717 10.3666L23.9963 6.42399C23.386 6.11401 22.7563 5.85246 22.1073 5.63934L20.7317 9.84352C21.1483 9.98882 21.5648 10.1632 21.9717 10.3666ZM15.4039 9.84352C15.8301 9.7079 16.2757 9.60134 16.7213 9.53353L16.0335 5.16468C15.3651 5.27124 14.687 5.42623 14.038 5.63934L15.4039 9.84352ZM19.4046 9.53353L20.1021 5.16468C19.4337 5.05812 18.7459 5 18.0678 5V9.42697C18.5134 9.42697 18.9687 9.46572 19.4046 9.53353Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M18.0483 26.7765V22.3302C17.6705 22.3302 17.3024 22.2818 16.9343 22.1849L15.7719 26.4762C16.5178 26.67 17.283 26.7765 18.0483 26.7765ZM20.3248 26.4762C21.0707 26.2825 21.7778 25.9919 22.4462 25.6044L20.1988 21.7586C19.8792 21.9427 19.5304 22.088 19.172 22.1849L20.3248 26.4762ZM13.6601 25.6044L15.9075 21.7586C15.5878 21.5746 15.2875 21.3421 15.0163 21.0806L14.9775 21.0418L13.5632 22.5239L11.8195 24.1998L11.8486 24.2288C12.3911 24.7616 13.0014 25.2266 13.6601 25.6044ZM24.2577 24.2288C24.8002 23.6864 25.2748 23.0858 25.6526 22.4271L21.7681 20.199C21.5841 20.5187 21.3516 20.8093 21.0803 21.0806L24.2577 24.2288ZM10.444 22.4174L14.3285 20.199C14.1444 19.8794 13.9991 19.5403 13.9023 19.1819L9.57215 20.325C9.76589 21.0515 10.0662 21.7587 10.444 22.4174ZM26.5341 20.3347C26.7279 19.5984 26.8344 18.8429 26.8344 18.0873H22.3493C22.3493 18.4554 22.3009 18.8332 22.204 19.1916L26.5341 20.3347ZM13.7666 18.0776C13.7666 17.7095 13.8151 17.3317 13.9119 16.9733L9.57215 15.8302C9.37841 16.5664 9.27185 17.322 9.27185 18.0776H13.7666ZM22.1944 16.9829L26.5341 15.8399C26.3404 15.1037 26.0401 14.3965 25.6623 13.7378L21.7778 15.9561C21.9522 16.2855 22.0975 16.6245 22.1944 16.9829ZM14.3382 15.9561C14.5222 15.6461 14.745 15.3458 15.0163 15.0843L15.0259 15.0746L13.4179 13.4859L11.8777 11.9069L11.8486 11.936C11.3061 12.4688 10.8411 13.0791 10.4537 13.7281L14.3382 15.9561ZM21.0803 15.0843L22.669 13.5053L24.2964 11.9747L24.2577 11.936C23.7152 11.3935 23.1049 10.9382 22.4462 10.5507L20.1988 14.3965C20.5185 14.5806 20.8091 14.8034 21.0803 15.0649V15.0843ZM15.9075 14.3965C16.2271 14.2124 16.5759 14.0671 16.9343 13.9703L15.7912 9.67892C15.0453 9.87266 14.3382 10.1633 13.6698 10.5507L15.9075 14.3965ZM19.1623 13.98L20.3248 9.6886C19.5885 9.49486 18.8233 9.38831 18.058 9.38831V13.8347C18.4261 13.8347 18.8039 13.8831 19.1623 13.98Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function XS() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "38",
      height: "38",
      viewBox: "0 0 38 38",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D(
          "rect",
          {
            y: "0.999573",
            width: "36",
            height: "36",
            rx: "6",
            fill: "url(#icons_chains_xlayer_linearGradient_0)"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M27.1921 22.667V29.2442H28.9861C29.1021 29.2437 29.2132 29.1974 29.2952 29.1151C29.3771 29.0329 29.4231 28.9216 29.4231 28.8056V23.1056C29.4231 22.9895 29.3771 22.8782 29.2952 22.796C29.2132 22.7138 29.1021 22.6674 28.9861 22.667H27.1921ZM27.1921 9.5V16.0772H28.9861C29.1021 16.0767 29.2132 16.0304 29.2952 15.9481C29.3771 15.8659 29.4231 15.7546 29.4231 15.6386V9.93858C29.4231 9.82254 29.3771 9.71122 29.2952 9.62902C29.2132 9.54681 29.1021 9.50042 28.9861 9.5H27.1921Z",
            fill: "#898989"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M30.5536 9.5V16.0772H31.2249C31.341 16.0767 31.4521 16.0304 31.534 15.9481C31.6159 15.8659 31.6619 15.7546 31.6619 15.6386V9.93858C31.6619 9.82281 31.6162 9.71173 31.5346 9.62957C31.453 9.54741 31.3423 9.50084 31.2265 9.5H30.5536ZM30.5583 22.667V29.2442H31.2281C31.2857 29.2442 31.3427 29.2328 31.3959 29.2108C31.4491 29.1887 31.4975 29.1564 31.5382 29.1157C31.5789 29.075 31.6112 29.0266 31.6333 28.9734C31.6553 28.9202 31.6667 28.8632 31.6667 28.8056V23.1056C31.6667 23.048 31.6553 22.991 31.6333 22.9377C31.6112 22.8845 31.5789 22.8362 31.5382 22.7955C31.4975 22.7547 31.4491 22.7224 31.3959 22.7004C31.3427 22.6783 31.2857 22.667 31.2281 22.667H30.5583Z",
            fill: "#575757"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M19.038 16.0914H13.3634C13.3062 16.0912 13.2495 16.1023 13.1966 16.124C13.1437 16.1456 13.0956 16.1775 13.055 16.2178C13.0144 16.2581 12.9822 16.306 12.9601 16.3587C12.938 16.4115 12.9266 16.4681 12.9264 16.5253V22.1572C12.9264 22.3963 13.1227 22.591 13.3634 22.591H19.0349C19.0921 22.5912 19.1487 22.5802 19.2016 22.5585C19.2545 22.5368 19.3026 22.5049 19.3432 22.4646C19.3838 22.4243 19.4161 22.3764 19.4381 22.3237C19.4602 22.2709 19.4717 22.2143 19.4719 22.1572V16.5253C19.4715 16.41 19.4254 16.2997 19.3438 16.2184C19.2622 16.1371 19.1517 16.0914 19.0365 16.0914M12.472 9.5H6.77196C6.65564 9.5 6.54408 9.54621 6.46183 9.62846C6.37958 9.71071 6.33337 9.82226 6.33337 9.93858V15.6386C6.33337 15.8808 6.52971 16.0772 6.77196 16.0772H12.472C12.5883 16.0772 12.6998 16.031 12.7821 15.9487C12.8643 15.8665 12.9105 15.7549 12.9105 15.6386V9.93858C12.9105 9.82226 12.8643 9.71071 12.7821 9.62846C12.6998 9.54621 12.5883 9.5 12.472 9.5ZM25.6215 9.5H19.9215C19.8052 9.5 19.6937 9.54621 19.6114 9.62846C19.5292 9.71071 19.483 9.82226 19.483 9.93858V15.6386C19.483 15.8808 19.6809 16.0772 19.9215 16.0772H25.6215C25.7379 16.0772 25.8494 16.031 25.9317 15.9487C26.0139 15.8665 26.0601 15.7549 26.0601 15.6386V9.93858C26.0601 9.82226 26.0139 9.71071 25.9317 9.62846C25.8494 9.54621 25.7379 9.5 25.6215 9.5ZM12.472 22.6528H6.77196C6.65564 22.6528 6.54408 22.699 6.46183 22.7812C6.37958 22.8635 6.33337 22.975 6.33337 23.0913V28.7913C6.33337 29.0336 6.52971 29.2283 6.77196 29.2283H12.472C12.588 29.2283 12.6993 29.1823 12.7815 29.1004C12.8637 29.0185 12.9101 28.9074 12.9105 28.7913V23.0913C12.9105 22.975 12.8643 22.8635 12.7821 22.7812C12.6998 22.699 12.5883 22.6528 12.472 22.6528ZM25.6215 22.6528H19.9215C19.8052 22.6528 19.6937 22.699 19.6114 22.7812C19.5292 22.8635 19.483 22.975 19.483 23.0913V28.7913C19.483 29.0336 19.6809 29.2283 19.9215 29.2283H25.6215C25.7376 29.2283 25.8489 29.1823 25.9311 29.1004C26.0133 29.0185 26.0597 28.9074 26.0601 28.7913V23.0913C26.0601 22.975 26.0139 22.8635 25.9317 22.7812C25.8494 22.699 25.7379 22.6528 25.6215 22.6528Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function KS() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", fill: "black" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M29.1239 11.0384L18.375 11.0554C14.8158 11.0554 11.9303 13.9408 11.9303 17.5C11.9303 21.0592 14.8158 23.9447 18.375 23.9447H28.726",
            stroke: "white",
            strokeWidth: "2.25944",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M6.17065 17.5H31.0001",
            stroke: "white",
            strokeWidth: "2.25944",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M18.5 5C25.4036 5 31 10.5964 31 17.5C31 24.4036 25.4036 30 18.5 30C11.5964 30 6 24.4036 6 17.5C6 10.5964 11.5964 5 18.5 5Z",
            stroke: "white",
            strokeWidth: "2.25944",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
          }
        )
      ]
    }
  );
}
function eE() {
  return /* @__PURE__ */ D(
    "svg",
    {
      width: "37",
      height: "36",
      viewBox: "0 0 37 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ ne("g", { clipPath: "url(#icons_chains_uni_clipPath_0)", children: [
        /* @__PURE__ */ D(
          "path",
          {
            d: "M30.3597 0H6.49976C3.18605 0 0.499756 2.68629 0.499756 6V30C0.499756 33.3137 3.18605 36 6.49976 36H30.3597C33.6734 36 36.3597 33.3137 36.3597 30V6C36.3597 2.68629 33.6734 0 30.3597 0Z",
            fill: "url(#icons_chains_uni_radialGradient_0)"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M33.3037 17.7159C25.2415 17.7159 18.7127 11.155 18.7127 3.06787H18.1467V17.7159H3.55566V18.2841C11.6179 18.2841 18.1467 24.8449 18.1467 32.9321H18.7127V18.2841H33.3037V17.7159Z",
            fill: "white"
          }
        )
      ] })
    }
  );
}
function tE() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", fill: "#814625" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M24.0394 22.037V20.5602C24.9485 20.2484 25.6104 19.2803 25.6104 18.1344C25.6104 16.9884 24.9485 16.0176 24.0394 15.7085V14.2317C24.8955 13.939 25.5339 13.0611 25.6045 12H24.5631V12.4513C24.5631 12.7986 24.3513 13.1049 24.0394 13.258V13.0474C24.0394 12.7385 23.7688 12.4868 23.4364 12.4868H23.3835C23.0511 12.4868 22.7804 12.7385 22.7804 13.0474V13.258C22.4686 13.1049 22.2567 12.8013 22.2567 12.4513V12H21.2154C21.286 13.0611 21.9243 13.939 22.7804 14.2317V15.7085C21.8743 16.0176 21.2095 16.9857 21.2095 18.1344C21.2095 19.283 21.8713 20.2511 22.7804 20.5602V22.037C21.9243 22.3297 21.286 23.2076 21.2154 24.2687H22.2567V23.8174C22.2567 23.4701 22.4686 23.1638 22.7804 23.0107V23.2213C22.7804 23.5303 23.0511 23.7819 23.3835 23.7819H23.4364C23.7688 23.7819 24.0394 23.5303 24.0394 23.2213V23.0107C24.3513 23.1638 24.5631 23.4674 24.5631 23.8174V24.2687H25.6045C25.5339 23.2076 24.8955 22.3297 24.0394 22.037ZM22.2567 18.7798V17.4862C22.2567 17.1389 22.4686 16.8326 22.7804 16.6794V16.89C22.7804 17.199 23.0511 17.4507 23.3835 17.4507H23.4364C23.7688 17.4507 24.0394 17.199 24.0394 16.89V16.6794C24.3513 16.8326 24.5631 17.1362 24.5631 17.4862V18.7798C24.5631 19.1271 24.3513 19.4334 24.0394 19.5865V19.376C24.0394 19.067 23.7688 18.8154 23.4364 18.8154H23.3835C23.0511 18.8154 22.7804 19.067 22.7804 19.376V19.5865C22.4715 19.4334 22.2567 19.1298 22.2567 18.7798Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M30.4291 18.9193V17.3468C31.3381 17.035 32.0001 16.0668 32.0001 14.9209C32.0001 13.775 31.3381 12.804 30.4291 12.495V12H29.1729V12.495C28.2639 12.8068 27.6021 13.775 27.6021 14.9209C27.6021 16.0668 28.2639 17.0377 29.1729 17.3468V18.9193C28.2639 19.231 27.6021 20.1992 27.6021 21.3451C27.6021 22.491 28.2639 23.4619 29.1729 23.771V24.266H30.4291V23.771C31.3381 23.4592 32.0001 22.491 32.0001 21.3451C32.0001 20.1992 31.3381 19.231 30.4291 18.9193ZM28.6463 15.5663V14.2727C28.6463 13.9253 28.8582 13.619 29.17 13.4659V13.6765C29.17 13.9856 29.4407 14.2371 29.7731 14.2371H29.8231C30.1555 14.2371 30.4261 13.9856 30.4261 13.6765V13.4659C30.738 13.619 30.9498 13.9226 30.9498 14.2727V15.5663C30.9498 15.9136 30.738 16.22 30.4261 16.3731V16.1625C30.4261 15.8534 30.1555 15.6018 29.8231 15.6018H29.7702C29.4378 15.6018 29.167 15.8534 29.167 16.1625V16.3731C28.8611 16.22 28.6463 15.9164 28.6463 15.5663ZM30.9527 21.9933C30.9527 22.3406 30.741 22.647 30.4291 22.8001V22.491C30.4291 22.182 30.1585 21.9303 29.8261 21.9303H29.776C29.4436 21.9303 29.1729 22.182 29.1729 22.491V22.8001C28.8611 22.647 28.6493 22.3434 28.6493 21.9933V20.6996C28.6493 20.3523 28.8611 20.0461 29.1729 19.8929V20.005C29.1729 20.3141 29.4436 20.5657 29.776 20.5657H29.829C30.1614 20.5657 30.432 20.3141 30.432 20.005V19.8929C30.7439 20.0461 30.9557 20.3496 30.9557 20.6996V21.9933H30.9527Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M16.841 16.8815C16.8292 16.8187 16.8145 16.7585 16.791 16.7011C16.7998 16.6874 18.7531 14.1576 16.944 12.5932C15.1377 11.0289 13.0284 13.0692 13.0166 13.0801C12.6813 12.9816 12.343 12.9214 12.0076 12.8941C12.0076 12.8941 12.0076 12.8941 12.0047 12.8941C11.3162 12.7874 10.3514 12.8941 10.3514 12.8941C10.0189 12.9214 9.68358 12.9816 9.35115 13.0774C9.33938 13.0663 7.2301 11.0261 5.42384 12.5905C3.61757 14.1549 5.56798 16.6874 5.57681 16.6983C5.55622 16.7585 5.53857 16.8187 5.5268 16.8788C5.33264 17.9618 4 18.2955 4 20.1826C4 22.1052 5.39147 23.6203 8.23327 23.6203H9.39822C9.4041 23.6258 9.8542 24.222 10.7838 24.2575C10.7838 24.2575 10.9986 24.2794 11.4928 24.263C12.4783 24.263 12.9578 23.6312 12.9608 23.623H14.1257C16.9674 23.623 18.3589 22.1079 18.3589 20.1853C18.3678 18.301 17.0351 17.9646 16.841 16.8815Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function rE() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", fill: "#FF004D" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M10.0747 20.8363L13.0093 18.0058V17.9933L15.93 20.8238C16.774 21.6379 17.8062 22 18.8245 22C20.9551 22 23.0047 20.3979 23.0047 17.9933L25.9253 20.8238C26.7693 21.6379 27.8015 22 28.8198 22C30.9504 22 33 20.3979 33 17.9933H30.494L27.5733 15.1762C26.7293 14.3621 25.6841 14 24.6657 14C22.5351 14 20.4986 15.5896 20.4986 17.9933L17.578 15.1762C16.734 14.3621 15.6887 14 14.6704 14C12.5398 14 10.5033 15.5896 10.5033 17.9933L3 18.0058C3 20.423 5.07658 21.9865 7.2072 21.9865C8.22545 21.9865 9.25769 21.6244 10.0747 20.8363Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function nE() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", fill: "#0052FF" }),
        /* @__PURE__ */ D("path", { fill: "#fff", d: "M25.7,29.9H6.8V10h4.3v16.1h14.6v3.9h0Z" }),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M25.7,13.8c2.1,0,3.9-1.7,3.9-3.9s-1.7-3.9-3.9-3.9-3.9,1.7-3.9,3.9,1.7,3.9,3.9,3.9Z"
          }
        )
      ]
    }
  );
}
function D8() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", ry: "6", fill: "#000" }),
        /* @__PURE__ */ D("path", { fill: "#fff", d: "M20.85,21.39h0s0,0,0,0h0,0Z" }),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M20.85,21.39c-5.28,1.59-9.65,3.9-12.38,6.61l-.12.12c.73.69,1.52,1.3,2.39,1.83l.18-.23c.75-.91,1.55-1.79,2.38-2.62,2.24-2.23,4.79-4.16,7.55-5.71h0Z"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M21.46,19.04H4.03c.21,2.83,1.26,5.42,2.91,7.53l.08-.08c1.69-1.67,3.9-3.19,6.56-4.51,2.33-1.16,5.01-2.16,7.89-2.94Z"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M14.78,7.42c4.72,4.71,10.67,7.82,17.19,9-.79-6.98-6.73-12.41-13.95-12.41-1.91,0-3.72.38-5.38,1.07.67.81,1.39,1.6,2.13,2.34h0Z"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M8.47,8c2.74,2.71,7.1,5.02,12.38,6.61-2.76-1.55-5.32-3.48-7.55-5.71-.83-.83-1.63-1.71-2.38-2.62l-.18-.23c-.86.52-1.66,1.14-2.38,1.83l.12.12s0,0,0,0Z"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M14.78,28.58c-.74.74-1.46,1.53-2.13,2.34,1.66.69,3.48,1.07,5.38,1.07,7.22,0,13.16-5.43,13.95-12.41-6.52,1.18-12.47,4.29-17.19,9h0s0,0,0,0Z"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M13.56,14.01h0c-2.66-1.32-4.86-2.84-6.55-4.51l-.08-.08c-1.65,2.11-2.7,4.7-2.91,7.53h17.43c-2.88-.79-5.56-1.78-7.89-2.95h0Z"
          }
        )
      ]
    }
  );
}
function iE() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 130 130",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "130", height: "130", rx: "16.66%", fill: "#8CABA9" }),
        /* @__PURE__ */ D("g", { transform: "scale(0.8) translate(17,17)", children: /* @__PURE__ */ D(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M64.9642 129.695C84.1796 129.695 101.443 121.338 113.318 108.059C107.794 103.258 99.4696 102.966 93.5889 107.712L92.4654 108.618C81.6982 117.306 66.009 116.023 56.7965 105.701C51.7718 100.071 43.1667 99.4967 37.438 104.408L24.485 115.513C35.5791 124.388 49.6518 129.695 64.9642 129.695ZM85.9896 98.2938C96.2452 90.0184 110.66 90.3152 120.524 98.3078C126.42 88.5391 129.812 77.0895 129.812 64.8475C129.812 51.2447 125.624 38.6203 118.466 28.1932C113.852 27.2105 108.851 28.3582 105.054 31.7224L103.974 32.6799C93.6189 41.8559 77.8874 41.2982 68.2083 31.4123C62.9293 26.0206 54.3067 25.8435 48.8108 31.0141L33.7373 45.195L25.4452 36.3811L40.5187 22.2001C50.8139 12.5144 66.9661 12.8461 76.8551 22.9462C82.0221 28.2237 90.4202 28.5214 95.948 23.6229L97.0283 22.6654C100.384 19.692 104.266 17.6874 108.331 16.6332C96.8419 6.29289 81.638 0 64.9642 0C32.045 0 4.85497 24.529 0.674023 56.3066C10.6729 51.5085 23.0064 53.3548 31.1591 61.7035C36.3059 66.974 44.593 67.5303 50.3981 62.9951L58.826 56.4108C69.4177 48.136 84.3907 48.5365 94.5248 57.3661L110.933 71.6615L102.984 80.7856L86.5755 66.4902C80.8129 61.4696 72.299 61.2417 66.276 65.9471L57.8483 72.5312C47.1827 80.8637 31.957 79.8415 22.501 70.1582C17.0024 64.5273 8.00934 64.3309 2.27007 69.7163L0.446289 71.4275C1.81116 84.9719 7.34388 97.286 15.7424 107.068L29.5615 95.2208C40.2929 86.0206 56.4126 87.0973 65.825 97.6432C70.743 103.153 79.1181 103.838 84.8662 99.2004L85.9896 98.2938Z",
            fill: "url(#paint0_linear_109_191)"
          }
        ) }),
        /* @__PURE__ */ D("defs", { children: /* @__PURE__ */ ne(
          "linearGradient",
          {
            id: "paint0_linear_109_191",
            x1: "65.0205",
            y1: "129.148",
            x2: "65.0205",
            y2: "-2.87836e-07",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ D("stop", { stopColor: "#B52A2A" }),
              /* @__PURE__ */ D("stop", { offset: "1", stopColor: "#780000" })
            ]
          }
        ) })
      ]
    }
  );
}
function oE() {
  return /* @__PURE__ */ D(
    "svg",
    {
      width: "41",
      height: "40",
      viewBox: "0 0 41 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ D(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 0.00291959V15.9042L5.6765 21.587V5.68569L21.4992 5.73875L15.8256 0.0530768L0.00302147 0L0 0.00291959ZM28.7868 12.7214V27.0783L23.1104 21.3956V7.03861L28.7868 12.7214ZM12.9607 28.5724H27.2944L21.6208 22.8867H7.28708L12.9607 28.5724ZM36.854 35.0866V20.8018L31.1777 15.1191V31.0204L15.3549 30.9674L21.0285 36.653L35.3373 36.7009L38.3549 39.7233L40.2871 40L39.9191 38.1568L36.854 35.0866",
          fill: "#282828"
        }
      )
    }
  );
}
const w1 = {
  Moonbeam: _S(),
  Avalanche: BS(),
  Bsc: QS(),
  Celo: FS(),
  Ethereum: RS(),
  Fantom: PS(),
  Polygon: ZS(),
  Solana: US(),
  Sui: WS(),
  Aptos: YS(),
  Arbitrum: VS(),
  Optimism: GS(),
  Base: HS(),
  Klaytn: $S(),
  Scroll: qS(),
  Xlayer: XS(),
  Mantle: JS(),
  Worldchain: KS(),
  Unichain: eE(),
  Berachain: tE(),
  Mezo: rE(),
  Linea: nE(),
  Sonic: D8(),
  Seievm: iE(),
  Plume: oE()
};
function aE(e) {
  return Object.keys(w1).includes(e);
}
function sE(e) {
  const t = er(), { size: o } = e, i = Ce(() => {
    const c = {
      width: o,
      height: o,
      borderRadius: "3px"
    };
    return t.palette.text && t.palette.input ? {
      emptyIcon: {
        ...c,
        background: `color-mix(in hsl, ${t.palette.text.secondary}, ${t.palette.input.background} 80%)`
      }
    } : {
      emptyIcon: c
    };
  }, [o, t]);
  return /* @__PURE__ */ D(ut, { sx: i.emptyIcon });
}
function Un(e) {
  const t = e.height || 36, o = Ce(
    () => ({
      container: {
        height: t,
        width: t,
        ...nl
      },
      iconImage: {
        width: t,
        height: t
      }
    }),
    [t]
  );
  return aE(e.icon) && w1[e.icon] ? /* @__PURE__ */ D(ut, { sx: o.container, children: w1[e.icon] }) : typeof e.icon == "string" ? /* @__PURE__ */ D(ut, { sx: o.container, children: /* @__PURE__ */ D("img", { style: o.iconImage, src: e.icon, alt: "chain icon" }) }) : /* @__PURE__ */ D(ut, { sx: o.container, children: /* @__PURE__ */ D(sE, { size: t }) });
}
const b0 = "";
function cE() {
  const e = Cr(), [t, o] = Xe({
    chain: b0,
    tx: b0,
    autoSearch: !1
  }), [i, c] = Xe(""), [n, d] = Xe(!1), f = Ut((w) => w.search), p = er(), l = wa(Vi);
  function h(w) {
    o((S) => ({ ...S, chain: w.target.value }));
  }
  function y(w) {
    o((S) => ({ ...S, tx: w.target.value }));
  }
  async function M() {
    if (!t.tx || !t.chain)
      return c("Enter the source chain and transaction ID");
    if (!WL(t.chain, t.tx))
      return c("Invalid transaction ID");
    d(!0);
    const w = await ge.routes.resumeFromTx({
      chain: t.chain,
      txid: t.tx
    });
    if (w === null) {
      c(
        "Transfer not found, check that you have the correct chain and transaction ID"
      ), d(!1);
      return;
    }
    const { route: S } = w;
    let { receipt: T } = w;
    const E = await gn(), j = new (ge.routes.get(S)).rc(E);
    if (c(""), T.state < Xo.Attested) {
      for await (T of j.track(T))
        if (T.state >= Xo.Attested)
          break;
    }
    const O = await SS(
      S,
      T
    );
    O ? (e(Pc(O)), e(oh(!0)), e(Uc(S)), e(Nn("redeem")), e(rl(T.to)), l.setRoute(j), l.setReceipt(T)) : console.error("Failed to parse receipt", T), d(!1);
  }
  St(() => {
    f.chain && f.txHash && (o({
      chain: f.chain,
      tx: f.txHash,
      autoSearch: !0
    }), e(L8()));
  }, [e, f]);
  const C = ht(() => M(), [t]);
  St(() => {
    const { chain: w, tx: S, autoSearch: T } = t;
    T && w !== b0 && S !== b0 && !n && (o((E) => ({ ...E, autoSearch: !1 })), C());
  }, [C, t, n]);
  const N = Ce(() => [...ge.chainsArr].sort((w, S) => w.displayName < S.displayName ? -1 : w.displayName > S.displayName ? 1 : 0), [ge.chainsArr]);
  return /* @__PURE__ */ ne(
    ut,
    {
      sx: (w) => ({
        maxWidth: "650px"
      }),
      children: [
        /* @__PURE__ */ D(
          La,
          {
            title: "Resume transaction",
            description: "Bridging can require a manual redemption process on the designation chain. If you did not complete the redemption during your initial transaction, you may do so here.",
            back: !0
          }
        ),
        /* @__PURE__ */ ne(
          ut,
          {
            sx: (w) => ({
              display: "flex",
              flexDirection: "row",
              gap: "16px",
              [w.breakpoints.down("sm")]: {
                flexDirection: "column"
              }
            }),
            children: [
              /* @__PURE__ */ D(
                ut,
                {
                  sx: (w) => ({
                    width: "175px",
                    [w.breakpoints.down("sm")]: {
                      width: "100%"
                    }
                  }),
                  children: /* @__PURE__ */ ne(
                    B9,
                    {
                      sx: { width: "100%", height: "100%", minHeight: "64.5px" },
                      value: t.chain,
                      displayEmpty: !0,
                      onChange: (w) => h(w),
                      children: [
                        /* @__PURE__ */ D(f2, { disabled: !0, value: "", children: /* @__PURE__ */ D("em", { children: "Select Network" }) }, 0),
                        N.map((w) => /* @__PURE__ */ D(f2, { value: w.sdkName, children: /* @__PURE__ */ ne(
                          ut,
                          {
                            sx: { display: "flex", alignItems: "center", gap: "8px" },
                            children: [
                              /* @__PURE__ */ D(Un, { icon: w.sdkName, height: 24 }),
                              w.displayName
                            ]
                          }
                        ) }, w.sdkName))
                      ]
                    }
                  )
                }
              ),
              /* @__PURE__ */ D(
                ut,
                {
                  sx: {
                    flexGrow: 1
                  },
                  children: /* @__PURE__ */ D(
                    wS,
                    {
                      placeholder: "Source chain transaction hash",
                      onChange: y,
                      onSearch: M,
                      value: t.tx
                    }
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ D(IS, {}),
        /* @__PURE__ */ D(AS, { show: !!i, content: i, error: !0, margin: "0 0 16px 0" }),
        /* @__PURE__ */ D(CS, { disabled: !t.chain || !t.tx, elevated: !0, onClick: M, children: n ? /* @__PURE__ */ D(
          Z1,
          {
            size: 24,
            sx: {
              color: p.palette.primary.contrastText
            }
          }
        ) : "Search" }),
        /* @__PURE__ */ D(
          ut,
          {
            sx: {
              width: "100%",
              maxWidth: "700px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "20px"
            },
            children: /* @__PURE__ */ D(il, {})
          }
        )
      ]
    }
  );
}
function lE() {
  const e = Cr(), { txHash: t, chain: o } = Ut((i) => i.search);
  return St(() => {
    var i, c;
    if ((i = ge.ui.searchTx) != null && i.chainName && ((c = ge.ui.searchTx) != null && c.txHash)) {
      const n = ge.ui.searchTx.chainName.toLowerCase(), d = ge.chainsArr.find(
        (f) => f.sdkName.toLowerCase() === n
      );
      d && e(
        T8({
          txHash: ge.ui.searchTx.txHash,
          chain: d.sdkName
        })
      );
    }
  }, [e]), {
    hasExternalSearch: !!(t && o),
    txHash: t,
    chain: o,
    clear: () => {
      e(L8()), ge.ui.searchTx && (ge.ui.searchTx.chainName = void 0, ge.ui.searchTx.txHash = void 0);
    }
  };
}
function fE(e) {
  return typeof e.main == "string";
}
function uE(e, t = []) {
  if (!fE(e))
    return !1;
  for (const o of t)
    if (!e.hasOwnProperty(o) || typeof e[o] != "string")
      return !1;
  return !0;
}
function Gr(e = []) {
  return ([, t]) => t && uE(t, e);
}
function dE(e) {
  return Bt("MuiCircularProgress", e);
}
Ft("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const Ai = 44, C1 = fi`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, I1 = fi`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`, hE = typeof C1 != "string" ? jo`
        animation: ${C1} 1.4s linear infinite;
      ` : null, pE = typeof I1 != "string" ? jo`
        animation: ${I1} 1.4s ease-in-out infinite;
      ` : null, gE = (e) => {
  const {
    classes: t,
    variant: o,
    color: i,
    disableShrink: c
  } = e, n = {
    root: ["root", o, `color${it(i)}`],
    svg: ["svg"],
    circle: ["circle", `circle${it(o)}`, c && "circleDisableShrink"]
  };
  return Rt(n, dE, t);
}, yE = Ke("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.variant], t[`color${it(o.color)}`]];
  }
})(kt(({
  theme: e
}) => ({
  display: "inline-block",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("transform")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: hE || {
      animation: `${C1} 1.4s linear infinite`
    }
  }, ...Object.entries(e.palette).filter(Gr()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  }))]
}))), ME = Ke("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, t) => t.svg
})({
  display: "block"
  // Keeps the progress centered
}), mE = Ke("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.circle, t[`circle${it(o.variant)}`], o.disableShrink && t.circleDisableShrink];
  }
})(kt(({
  theme: e
}) => ({
  stroke: "currentColor",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("stroke-dashoffset")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: 0
      // Add the unit to fix a Edge 16 and below bug.
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" && !t.disableShrink,
    style: pE || {
      // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
      animation: `${I1} 1.4s ease-in-out infinite`
    }
  }]
}))), Or = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: c,
    color: n = "primary",
    disableShrink: d = !1,
    size: f = 40,
    style: p,
    thickness: l = 3.6,
    value: h = 0,
    variant: y = "indeterminate",
    ...M
  } = i, C = {
    ...i,
    color: n,
    disableShrink: d,
    size: f,
    thickness: l,
    value: h,
    variant: y
  }, N = gE(C), w = {}, S = {}, T = {};
  if (y === "determinate") {
    const E = 2 * Math.PI * ((Ai - l) / 2);
    w.strokeDasharray = E.toFixed(3), T["aria-valuenow"] = Math.round(h), w.strokeDashoffset = `${((100 - h) / 100 * E).toFixed(3)}px`, S.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ D(yE, {
    className: It(N.root, c),
    style: {
      width: f,
      height: f,
      ...S,
      ...p
    },
    ownerState: C,
    ref: o,
    role: "progressbar",
    ...T,
    ...M,
    children: /* @__PURE__ */ D(ME, {
      className: N.svg,
      ownerState: C,
      viewBox: `${Ai / 2} ${Ai / 2} ${Ai} ${Ai}`,
      children: /* @__PURE__ */ D(mE, {
        className: N.circle,
        style: w,
        ownerState: C,
        cx: Ai,
        cy: Ai,
        r: (Ai - l) / 2,
        fill: "none",
        strokeWidth: l
      })
    })
  });
});
fe.process.env.NODE_ENV !== "production" && (Or.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: b.oneOfType([b.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), b.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: qn(b.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: b.oneOfType([b.number, b.string]),
  /**
   * @ignore
   */
  style: b.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: b.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: b.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: b.oneOf(["determinate", "indeterminate"])
});
function vE(e) {
  return Bt("MuiSvgIcon", e);
}
Ft("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const bE = (e) => {
  const {
    color: t,
    fontSize: o,
    classes: i
  } = e, c = {
    root: ["root", t !== "inherit" && `color${it(t)}`, `fontSize${it(o)}`]
  };
  return Rt(c, vE, i);
}, xE = Ke("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.color !== "inherit" && t[`color${it(o.color)}`], t[`fontSize${it(o.fontSize)}`]];
  }
})(kt(({
  theme: e
}) => {
  var t, o, i, c, n, d, f, p, l, h, y, M, C, N;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (c = (t = e.transitions) == null ? void 0 : t.create) == null ? void 0 : c.call(t, "fill", {
      duration: (i = (o = (e.vars ?? e).transitions) == null ? void 0 : o.duration) == null ? void 0 : i.shorter
    }),
    variants: [
      {
        props: (w) => !w.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((d = (n = e.typography) == null ? void 0 : n.pxToRem) == null ? void 0 : d.call(n, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((p = (f = e.typography) == null ? void 0 : f.pxToRem) == null ? void 0 : p.call(f, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((h = (l = e.typography) == null ? void 0 : l.pxToRem) == null ? void 0 : h.call(l, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries((e.vars ?? e).palette).filter(([, w]) => w && w.main).map(([w]) => {
        var S, T;
        return {
          props: {
            color: w
          },
          style: {
            color: (T = (S = (e.vars ?? e).palette) == null ? void 0 : S[w]) == null ? void 0 : T.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (M = (y = (e.vars ?? e).palette) == null ? void 0 : y.action) == null ? void 0 : M.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (N = (C = (e.vars ?? e).palette) == null ? void 0 : C.action) == null ? void 0 : N.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), fc = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: c,
    className: n,
    color: d = "inherit",
    component: f = "svg",
    fontSize: p = "medium",
    htmlColor: l,
    inheritViewBox: h = !1,
    titleAccess: y,
    viewBox: M = "0 0 24 24",
    ...C
  } = i, N = /* @__PURE__ */ ue.isValidElement(c) && c.type === "svg", w = {
    ...i,
    color: d,
    component: f,
    fontSize: p,
    instanceFontSize: t.fontSize,
    inheritViewBox: h,
    viewBox: M,
    hasSvgAsChild: N
  }, S = {};
  h || (S.viewBox = M);
  const T = bE(w);
  return /* @__PURE__ */ ne(xE, {
    as: f,
    className: It(T.root, n),
    focusable: "false",
    color: l,
    "aria-hidden": y ? void 0 : !0,
    role: y ? "img" : void 0,
    ref: o,
    ...S,
    ...C,
    ...N && c.props,
    ownerState: w,
    children: [N ? c.props.children : c, y ? /* @__PURE__ */ D("title", {
      children: y
    }) : null]
  });
});
fe.process.env.NODE_ENV !== "production" && (fc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: b.oneOfType([b.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), b.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: b.oneOfType([b.oneOf(["inherit", "large", "medium", "small"]), b.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: b.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: b.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: b.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: b.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: b.string
});
fc.muiName = "SvgIcon";
function an(e, t) {
  function o(i, c) {
    return /* @__PURE__ */ D(fc, {
      "data-testid": `${t}Icon`,
      ref: c,
      ...i,
      children: e
    });
  }
  return fe.process.env.NODE_ENV !== "production" && (o.displayName = `${t}Icon`), o.muiName = fc.muiName, /* @__PURE__ */ ue.memo(/* @__PURE__ */ ue.forwardRef(o));
}
function uc(e, t) {
  if (!e)
    return t;
  if (typeof e == "function" || typeof t == "function")
    return (c) => {
      const n = typeof t == "function" ? t(c) : t, d = typeof e == "function" ? e({
        ...c,
        ...n
      }) : e, f = It(c == null ? void 0 : c.className, n == null ? void 0 : n.className, d == null ? void 0 : d.className);
      return {
        ...n,
        ...d,
        ...!!f && {
          className: f
        },
        ...(n == null ? void 0 : n.style) && (d == null ? void 0 : d.style) && {
          style: {
            ...n.style,
            ...d.style
          }
        },
        ...(n == null ? void 0 : n.sx) && (d == null ? void 0 : d.sx) && {
          sx: [...Array.isArray(n.sx) ? n.sx : [n.sx], ...Array.isArray(d.sx) ? d.sx : [d.sx]]
        }
      };
    };
  const o = t, i = It(o == null ? void 0 : o.className, e == null ? void 0 : e.className);
  return {
    ...t,
    ...e,
    ...!!i && {
      className: i
    },
    ...(o == null ? void 0 : o.style) && (e == null ? void 0 : e.style) && {
      style: {
        ...o.style,
        ...e.style
      }
    },
    ...(o == null ? void 0 : o.sx) && (e == null ? void 0 : e.sx) && {
      sx: [...Array.isArray(o.sx) ? o.sx : [o.sx], ...Array.isArray(e.sx) ? e.sx : [e.sx]]
    }
  };
}
class dc {
  constructor() {
    zt(this, "mountEffect", () => {
      this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
    });
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new dc();
  }
  static use() {
    const t = Lg(dc.create).current, [o, i] = ue.useState(!1);
    return t.shouldMount = o, t.setShouldMount = i, ue.useEffect(t.mountEffect, [o]), t;
  }
  mount() {
    return this.mounted || (this.mounted = CE(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  /* Ripple API */
  start(...t) {
    this.mount().then(() => {
      var o;
      return (o = this.ref.current) == null ? void 0 : o.start(...t);
    });
  }
  stop(...t) {
    this.mount().then(() => {
      var o;
      return (o = this.ref.current) == null ? void 0 : o.stop(...t);
    });
  }
  pulsate(...t) {
    this.mount().then(() => {
      var o;
      return (o = this.ref.current) == null ? void 0 : o.pulsate(...t);
    });
  }
}
function wE() {
  return dc.use();
}
function CE() {
  let e, t;
  const o = new Promise((i, c) => {
    e = i, t = c;
  });
  return o.resolve = e, o.reject = t, o;
}
function N1() {
  return N1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];
      for (var i in o) ({}).hasOwnProperty.call(o, i) && (e[i] = o[i]);
    }
    return e;
  }, N1.apply(null, arguments);
}
function j8(e, t) {
  if (e == null) return {};
  var o = {};
  for (var i in e) if ({}.hasOwnProperty.call(e, i)) {
    if (t.indexOf(i) !== -1) continue;
    o[i] = e[i];
  }
  return o;
}
function A1(e, t) {
  return A1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, i) {
    return o.__proto__ = i, o;
  }, A1(e, t);
}
function O8(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, A1(e, t);
}
var T1 = { exports: {} }, rn = {};
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e6;
function IE() {
  if (e6) return rn;
  e6 = 1;
  var e = sr;
  function t(p) {
    var l = "https://react.dev/errors/" + p;
    if (1 < arguments.length) {
      l += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var h = 2; h < arguments.length; h++)
        l += "&args[]=" + encodeURIComponent(arguments[h]);
    }
    return "Minified React error #" + p + "; visit " + l + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function o() {
  }
  var i = {
    d: {
      f: o,
      r: function() {
        throw Error(t(522));
      },
      D: o,
      C: o,
      L: o,
      m: o,
      X: o,
      S: o,
      M: o
    },
    p: 0,
    findDOMNode: null
  }, c = Symbol.for("react.portal");
  function n(p, l, h) {
    var y = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: c,
      key: y == null ? null : "" + y,
      children: p,
      containerInfo: l,
      implementation: h
    };
  }
  var d = e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function f(p, l) {
    if (p === "font") return "";
    if (typeof l == "string")
      return l === "use-credentials" ? l : "";
  }
  return rn.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = i, rn.createPortal = function(p, l) {
    var h = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!l || l.nodeType !== 1 && l.nodeType !== 9 && l.nodeType !== 11)
      throw Error(t(299));
    return n(p, l, null, h);
  }, rn.flushSync = function(p) {
    var l = d.T, h = i.p;
    try {
      if (d.T = null, i.p = 2, p) return p();
    } finally {
      d.T = l, i.p = h, i.d.f();
    }
  }, rn.preconnect = function(p, l) {
    typeof p == "string" && (l ? (l = l.crossOrigin, l = typeof l == "string" ? l === "use-credentials" ? l : "" : void 0) : l = null, i.d.C(p, l));
  }, rn.prefetchDNS = function(p) {
    typeof p == "string" && i.d.D(p);
  }, rn.preinit = function(p, l) {
    if (typeof p == "string" && l && typeof l.as == "string") {
      var h = l.as, y = f(h, l.crossOrigin), M = typeof l.integrity == "string" ? l.integrity : void 0, C = typeof l.fetchPriority == "string" ? l.fetchPriority : void 0;
      h === "style" ? i.d.S(
        p,
        typeof l.precedence == "string" ? l.precedence : void 0,
        {
          crossOrigin: y,
          integrity: M,
          fetchPriority: C
        }
      ) : h === "script" && i.d.X(p, {
        crossOrigin: y,
        integrity: M,
        fetchPriority: C,
        nonce: typeof l.nonce == "string" ? l.nonce : void 0
      });
    }
  }, rn.preinitModule = function(p, l) {
    if (typeof p == "string")
      if (typeof l == "object" && l !== null) {
        if (l.as == null || l.as === "script") {
          var h = f(
            l.as,
            l.crossOrigin
          );
          i.d.M(p, {
            crossOrigin: h,
            integrity: typeof l.integrity == "string" ? l.integrity : void 0,
            nonce: typeof l.nonce == "string" ? l.nonce : void 0
          });
        }
      } else l == null && i.d.M(p);
  }, rn.preload = function(p, l) {
    if (typeof p == "string" && typeof l == "object" && l !== null && typeof l.as == "string") {
      var h = l.as, y = f(h, l.crossOrigin);
      i.d.L(p, h, {
        crossOrigin: y,
        integrity: typeof l.integrity == "string" ? l.integrity : void 0,
        nonce: typeof l.nonce == "string" ? l.nonce : void 0,
        type: typeof l.type == "string" ? l.type : void 0,
        fetchPriority: typeof l.fetchPriority == "string" ? l.fetchPriority : void 0,
        referrerPolicy: typeof l.referrerPolicy == "string" ? l.referrerPolicy : void 0,
        imageSrcSet: typeof l.imageSrcSet == "string" ? l.imageSrcSet : void 0,
        imageSizes: typeof l.imageSizes == "string" ? l.imageSizes : void 0,
        media: typeof l.media == "string" ? l.media : void 0
      });
    }
  }, rn.preloadModule = function(p, l) {
    if (typeof p == "string")
      if (l) {
        var h = f(l.as, l.crossOrigin);
        i.d.m(p, {
          as: typeof l.as == "string" && l.as !== "script" ? l.as : void 0,
          crossOrigin: h,
          integrity: typeof l.integrity == "string" ? l.integrity : void 0
        });
      } else i.d.m(p);
  }, rn.requestFormReset = function(p) {
    i.d.r(p);
  }, rn.unstable_batchedUpdates = function(p, l) {
    return p(l);
  }, rn.useFormState = function(p, l, h) {
    return d.H.useFormState(p, l, h);
  }, rn.useFormStatus = function() {
    return d.H.useHostTransitionStatus();
  }, rn.version = "19.1.0", rn;
}
var nn = {}, t6;
function NE() {
  return t6 || (t6 = 1, fe.process.env.NODE_ENV !== "production" && function() {
    function e() {
    }
    function t(y) {
      return "" + y;
    }
    function o(y, M, C) {
      var N = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
      try {
        t(N);
        var w = !1;
      } catch {
        w = !0;
      }
      return w && (console.error(
        "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
        typeof Symbol == "function" && Symbol.toStringTag && N[Symbol.toStringTag] || N.constructor.name || "Object"
      ), t(N)), {
        $$typeof: l,
        key: N == null ? null : "" + N,
        children: y,
        containerInfo: M,
        implementation: C
      };
    }
    function i(y, M) {
      if (y === "font") return "";
      if (typeof M == "string")
        return M === "use-credentials" ? M : "";
    }
    function c(y) {
      return y === null ? "`null`" : y === void 0 ? "`undefined`" : y === "" ? "an empty string" : 'something with type "' + typeof y + '"';
    }
    function n(y) {
      return y === null ? "`null`" : y === void 0 ? "`undefined`" : y === "" ? "an empty string" : typeof y == "string" ? JSON.stringify(y) : typeof y == "number" ? "`" + y + "`" : 'something with type "' + typeof y + '"';
    }
    function d() {
      var y = h.H;
      return y === null && console.error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      ), y;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var f = sr, p = {
      d: {
        f: e,
        r: function() {
          throw Error(
            "Invalid form element. requestFormReset must be passed a form that was rendered by React."
          );
        },
        D: e,
        C: e,
        L: e,
        m: e,
        X: e,
        S: e,
        M: e
      },
      p: 0,
      findDOMNode: null
    }, l = Symbol.for("react.portal"), h = f.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"
    ), nn.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = p, nn.createPortal = function(y, M) {
      var C = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      if (!M || M.nodeType !== 1 && M.nodeType !== 9 && M.nodeType !== 11)
        throw Error("Target container is not a DOM element.");
      return o(y, M, null, C);
    }, nn.flushSync = function(y) {
      var M = h.T, C = p.p;
      try {
        if (h.T = null, p.p = 2, y)
          return y();
      } finally {
        h.T = M, p.p = C, p.d.f() && console.error(
          "flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."
        );
      }
    }, nn.preconnect = function(y, M) {
      typeof y == "string" && y ? M != null && typeof M != "object" ? console.error(
        "ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.",
        n(M)
      ) : M != null && typeof M.crossOrigin != "string" && console.error(
        "ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.",
        c(M.crossOrigin)
      ) : console.error(
        "ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        c(y)
      ), typeof y == "string" && (M ? (M = M.crossOrigin, M = typeof M == "string" ? M === "use-credentials" ? M : "" : void 0) : M = null, p.d.C(y, M));
    }, nn.prefetchDNS = function(y) {
      if (typeof y != "string" || !y)
        console.error(
          "ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
          c(y)
        );
      else if (1 < arguments.length) {
        var M = arguments[1];
        typeof M == "object" && M.hasOwnProperty("crossOrigin") ? console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          n(M)
        ) : console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          n(M)
        );
      }
      typeof y == "string" && p.d.D(y);
    }, nn.preinit = function(y, M) {
      if (typeof y == "string" && y ? M == null || typeof M != "object" ? console.error(
        "ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.",
        n(M)
      ) : M.as !== "style" && M.as !== "script" && console.error(
        'ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are "style" and "script".',
        n(M.as)
      ) : console.error(
        "ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        c(y)
      ), typeof y == "string" && M && typeof M.as == "string") {
        var C = M.as, N = i(C, M.crossOrigin), w = typeof M.integrity == "string" ? M.integrity : void 0, S = typeof M.fetchPriority == "string" ? M.fetchPriority : void 0;
        C === "style" ? p.d.S(
          y,
          typeof M.precedence == "string" ? M.precedence : void 0,
          {
            crossOrigin: N,
            integrity: w,
            fetchPriority: S
          }
        ) : C === "script" && p.d.X(y, {
          crossOrigin: N,
          integrity: w,
          fetchPriority: S,
          nonce: typeof M.nonce == "string" ? M.nonce : void 0
        });
      }
    }, nn.preinitModule = function(y, M) {
      var C = "";
      if (typeof y == "string" && y || (C += " The `href` argument encountered was " + c(y) + "."), M !== void 0 && typeof M != "object" ? C += " The `options` argument encountered was " + c(M) + "." : M && "as" in M && M.as !== "script" && (C += " The `as` option encountered was " + n(M.as) + "."), C)
        console.error(
          "ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s",
          C
        );
      else
        switch (C = M && typeof M.as == "string" ? M.as : "script", C) {
          case "script":
            break;
          default:
            C = n(C), console.error(
              'ReactDOM.preinitModule(): Currently the only supported "as" type for this function is "script" but received "%s" instead. This warning was generated for `href` "%s". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)',
              C,
              y
            );
        }
      typeof y == "string" && (typeof M == "object" && M !== null ? (M.as == null || M.as === "script") && (C = i(
        M.as,
        M.crossOrigin
      ), p.d.M(y, {
        crossOrigin: C,
        integrity: typeof M.integrity == "string" ? M.integrity : void 0,
        nonce: typeof M.nonce == "string" ? M.nonce : void 0
      })) : M == null && p.d.M(y));
    }, nn.preload = function(y, M) {
      var C = "";
      if (typeof y == "string" && y || (C += " The `href` argument encountered was " + c(y) + "."), M == null || typeof M != "object" ? C += " The `options` argument encountered was " + c(M) + "." : typeof M.as == "string" && M.as || (C += " The `as` option encountered was " + c(M.as) + "."), C && console.error(
        'ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel="preload" as="..." />` tag.%s',
        C
      ), typeof y == "string" && typeof M == "object" && M !== null && typeof M.as == "string") {
        C = M.as;
        var N = i(
          C,
          M.crossOrigin
        );
        p.d.L(y, C, {
          crossOrigin: N,
          integrity: typeof M.integrity == "string" ? M.integrity : void 0,
          nonce: typeof M.nonce == "string" ? M.nonce : void 0,
          type: typeof M.type == "string" ? M.type : void 0,
          fetchPriority: typeof M.fetchPriority == "string" ? M.fetchPriority : void 0,
          referrerPolicy: typeof M.referrerPolicy == "string" ? M.referrerPolicy : void 0,
          imageSrcSet: typeof M.imageSrcSet == "string" ? M.imageSrcSet : void 0,
          imageSizes: typeof M.imageSizes == "string" ? M.imageSizes : void 0,
          media: typeof M.media == "string" ? M.media : void 0
        });
      }
    }, nn.preloadModule = function(y, M) {
      var C = "";
      typeof y == "string" && y || (C += " The `href` argument encountered was " + c(y) + "."), M !== void 0 && typeof M != "object" ? C += " The `options` argument encountered was " + c(M) + "." : M && "as" in M && typeof M.as != "string" && (C += " The `as` option encountered was " + c(M.as) + "."), C && console.error(
        'ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel="modulepreload" as="..." />` tag.%s',
        C
      ), typeof y == "string" && (M ? (C = i(
        M.as,
        M.crossOrigin
      ), p.d.m(y, {
        as: typeof M.as == "string" && M.as !== "script" ? M.as : void 0,
        crossOrigin: C,
        integrity: typeof M.integrity == "string" ? M.integrity : void 0
      })) : p.d.m(y));
    }, nn.requestFormReset = function(y) {
      p.d.r(y);
    }, nn.unstable_batchedUpdates = function(y, M) {
      return y(M);
    }, nn.useFormState = function(y, M, C) {
      return d().useFormState(y, M, C);
    }, nn.useFormStatus = function() {
      return d().useHostTransitionStatus();
    }, nn.version = "19.1.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), nn;
}
function z8() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (fe.process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(z8);
    } catch (e) {
      console.error(e);
    }
  }
}
fe.process.env.NODE_ENV === "production" ? (z8(), T1.exports = IE()) : T1.exports = NE();
var hc = T1.exports;
const x0 = /* @__PURE__ */ Yi(hc), r6 = {
  disabled: !1
};
var AE = fe.process.env.NODE_ENV !== "production" ? b.oneOfType([b.number, b.shape({
  enter: b.number,
  exit: b.number,
  appear: b.number
}).isRequired]) : null;
fe.process.env.NODE_ENV !== "production" && b.oneOfType([b.string, b.shape({
  enter: b.string,
  exit: b.string,
  active: b.string
}), b.shape({
  enter: b.string,
  enterDone: b.string,
  enterActive: b.string,
  exit: b.string,
  exitDone: b.string,
  exitActive: b.string
})]);
const pc = sr.createContext(null);
var TE = function(t) {
  return t.scrollTop;
}, Qa = "unmounted", io = "exited", oo = "entering", $o = "entered", L1 = "exiting", Vn = /* @__PURE__ */ function(e) {
  O8(t, e);
  function t(i, c) {
    var n;
    n = e.call(this, i, c) || this;
    var d = c, f = d && !d.isMounting ? i.enter : i.appear, p;
    return n.appearStatus = null, i.in ? f ? (p = io, n.appearStatus = oo) : p = $o : i.unmountOnExit || i.mountOnEnter ? p = Qa : p = io, n.state = {
      status: p
    }, n.nextCallback = null, n;
  }
  t.getDerivedStateFromProps = function(c, n) {
    var d = c.in;
    return d && n.status === Qa ? {
      status: io
    } : null;
  };
  var o = t.prototype;
  return o.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, o.componentDidUpdate = function(c) {
    var n = null;
    if (c !== this.props) {
      var d = this.state.status;
      this.props.in ? d !== oo && d !== $o && (n = oo) : (d === oo || d === $o) && (n = L1);
    }
    this.updateStatus(!1, n);
  }, o.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, o.getTimeouts = function() {
    var c = this.props.timeout, n, d, f;
    return n = d = f = c, c != null && typeof c != "number" && (n = c.exit, d = c.enter, f = c.appear !== void 0 ? c.appear : d), {
      exit: n,
      enter: d,
      appear: f
    };
  }, o.updateStatus = function(c, n) {
    if (c === void 0 && (c = !1), n !== null)
      if (this.cancelNextCallback(), n === oo) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var d = this.props.nodeRef ? this.props.nodeRef.current : x0.findDOMNode(this);
          d && TE(d);
        }
        this.performEnter(c);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === io && this.setState({
      status: Qa
    });
  }, o.performEnter = function(c) {
    var n = this, d = this.props.enter, f = this.context ? this.context.isMounting : c, p = this.props.nodeRef ? [f] : [x0.findDOMNode(this), f], l = p[0], h = p[1], y = this.getTimeouts(), M = f ? y.appear : y.enter;
    if (!c && !d || r6.disabled) {
      this.safeSetState({
        status: $o
      }, function() {
        n.props.onEntered(l);
      });
      return;
    }
    this.props.onEnter(l, h), this.safeSetState({
      status: oo
    }, function() {
      n.props.onEntering(l, h), n.onTransitionEnd(M, function() {
        n.safeSetState({
          status: $o
        }, function() {
          n.props.onEntered(l, h);
        });
      });
    });
  }, o.performExit = function() {
    var c = this, n = this.props.exit, d = this.getTimeouts(), f = this.props.nodeRef ? void 0 : x0.findDOMNode(this);
    if (!n || r6.disabled) {
      this.safeSetState({
        status: io
      }, function() {
        c.props.onExited(f);
      });
      return;
    }
    this.props.onExit(f), this.safeSetState({
      status: L1
    }, function() {
      c.props.onExiting(f), c.onTransitionEnd(d.exit, function() {
        c.safeSetState({
          status: io
        }, function() {
          c.props.onExited(f);
        });
      });
    });
  }, o.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, o.safeSetState = function(c, n) {
    n = this.setNextCallback(n), this.setState(c, n);
  }, o.setNextCallback = function(c) {
    var n = this, d = !0;
    return this.nextCallback = function(f) {
      d && (d = !1, n.nextCallback = null, c(f));
    }, this.nextCallback.cancel = function() {
      d = !1;
    }, this.nextCallback;
  }, o.onTransitionEnd = function(c, n) {
    this.setNextCallback(n);
    var d = this.props.nodeRef ? this.props.nodeRef.current : x0.findDOMNode(this), f = c == null && !this.props.addEndListener;
    if (!d || f) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var p = this.props.nodeRef ? [this.nextCallback] : [d, this.nextCallback], l = p[0], h = p[1];
      this.props.addEndListener(l, h);
    }
    c != null && setTimeout(this.nextCallback, c);
  }, o.render = function() {
    var c = this.state.status;
    if (c === Qa)
      return null;
    var n = this.props, d = n.children;
    n.in, n.mountOnEnter, n.unmountOnExit, n.appear, n.enter, n.exit, n.timeout, n.addEndListener, n.onEnter, n.onEntering, n.onEntered, n.onExit, n.onExiting, n.onExited, n.nodeRef;
    var f = j8(n, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ sr.createElement(pc.Provider, {
        value: null
      }, typeof d == "function" ? d(c, f) : sr.cloneElement(sr.Children.only(d), f))
    );
  }, t;
}(sr.Component);
Vn.contextType = pc;
Vn.propTypes = fe.process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: b.shape({
    current: typeof Element > "u" ? b.any : function(e, t, o, i, c, n) {
      var d = e[t];
      return b.instanceOf(d && "ownerDocument" in d ? d.ownerDocument.defaultView.Element : Element)(e, t, o, i, c, n);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: b.oneOfType([b.func.isRequired, b.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: b.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: b.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: b.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: b.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: b.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: b.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var o = AE;
    t.addEndListener || (o = o.isRequired);
    for (var i = arguments.length, c = new Array(i > 1 ? i - 1 : 0), n = 1; n < i; n++)
      c[n - 1] = arguments[n];
    return o.apply(void 0, [t].concat(c));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: b.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: b.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: b.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: b.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: b.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: b.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: b.func
} : {};
function Vo() {
}
Vn.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Vo,
  onEntering: Vo,
  onEntered: Vo,
  onExit: Vo,
  onExiting: Vo,
  onExited: Vo
};
Vn.UNMOUNTED = Qa;
Vn.EXITED = io;
Vn.ENTERING = oo;
Vn.ENTERED = $o;
Vn.EXITING = L1;
function LE(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function jh(e, t) {
  var o = function(n) {
    return t && j0(n) ? t(n) : n;
  }, i = /* @__PURE__ */ Object.create(null);
  return e && s9.map(e, function(c) {
    return c;
  }).forEach(function(c) {
    i[c.key] = o(c);
  }), i;
}
function SE(e, t) {
  e = e || {}, t = t || {};
  function o(h) {
    return h in t ? t[h] : e[h];
  }
  var i = /* @__PURE__ */ Object.create(null), c = [];
  for (var n in e)
    n in t ? c.length && (i[n] = c, c = []) : c.push(n);
  var d, f = {};
  for (var p in t) {
    if (i[p])
      for (d = 0; d < i[p].length; d++) {
        var l = i[p][d];
        f[i[p][d]] = o(l);
      }
    f[p] = o(p);
  }
  for (d = 0; d < c.length; d++)
    f[c[d]] = o(c[d]);
  return f;
}
function po(e, t, o) {
  return o[t] != null ? o[t] : e.props[t];
}
function EE(e, t) {
  return jh(e.children, function(o) {
    return O0(o, {
      onExited: t.bind(null, o),
      in: !0,
      appear: po(o, "appear", e),
      enter: po(o, "enter", e),
      exit: po(o, "exit", e)
    });
  });
}
function DE(e, t, o) {
  var i = jh(e.children), c = SE(t, i);
  return Object.keys(c).forEach(function(n) {
    var d = c[n];
    if (j0(d)) {
      var f = n in t, p = n in i, l = t[n], h = j0(l) && !l.props.in;
      p && (!f || h) ? c[n] = O0(d, {
        onExited: o.bind(null, d),
        in: !0,
        exit: po(d, "exit", e),
        enter: po(d, "enter", e)
      }) : !p && f && !h ? c[n] = O0(d, {
        in: !1
      }) : p && f && j0(l) && (c[n] = O0(d, {
        onExited: o.bind(null, d),
        in: l.props.in,
        exit: po(d, "exit", e),
        enter: po(d, "enter", e)
      }));
    }
  }), c;
}
var jE = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, OE = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, Oh = /* @__PURE__ */ function(e) {
  O8(t, e);
  function t(i, c) {
    var n;
    n = e.call(this, i, c) || this;
    var d = n.handleExited.bind(LE(n));
    return n.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: d,
      firstRender: !0
    }, n;
  }
  var o = t.prototype;
  return o.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, o.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(c, n) {
    var d = n.children, f = n.handleExited, p = n.firstRender;
    return {
      children: p ? EE(c, f) : DE(c, d, f),
      firstRender: !1
    };
  }, o.handleExited = function(c, n) {
    var d = jh(this.props.children);
    c.key in d || (c.props.onExited && c.props.onExited(n), this.mounted && this.setState(function(f) {
      var p = N1({}, f.children);
      return delete p[c.key], {
        children: p
      };
    }));
  }, o.render = function() {
    var c = this.props, n = c.component, d = c.childFactory, f = j8(c, ["component", "childFactory"]), p = this.state.contextValue, l = jE(this.state.children).map(d);
    return delete f.appear, delete f.enter, delete f.exit, n === null ? /* @__PURE__ */ sr.createElement(pc.Provider, {
      value: p
    }, l) : /* @__PURE__ */ sr.createElement(pc.Provider, {
      value: p
    }, /* @__PURE__ */ sr.createElement(n, f, l));
  }, t;
}(sr.Component);
Oh.propTypes = fe.process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: b.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: b.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: b.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: b.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: b.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: b.func
} : {};
Oh.defaultProps = OE;
function k8(e) {
  const {
    className: t,
    classes: o,
    pulsate: i = !1,
    rippleX: c,
    rippleY: n,
    rippleSize: d,
    in: f,
    onExited: p,
    timeout: l
  } = e, [h, y] = ue.useState(!1), M = It(t, o.ripple, o.rippleVisible, i && o.ripplePulsate), C = {
    width: d,
    height: d,
    top: -(d / 2) + n,
    left: -(d / 2) + c
  }, N = It(o.child, h && o.childLeaving, i && o.childPulsate);
  return !f && !h && y(!0), ue.useEffect(() => {
    if (!f && p != null) {
      const w = setTimeout(p, l);
      return () => {
        clearTimeout(w);
      };
    }
  }, [p, f, l]), /* @__PURE__ */ D("span", {
    className: M,
    style: C,
    children: /* @__PURE__ */ D("span", {
      className: N
    })
  });
}
fe.process.env.NODE_ENV !== "production" && (k8.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object.isRequired,
  className: b.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: b.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: b.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: b.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: b.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: b.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: b.number,
  /**
   * exit delay
   */
  timeout: b.number.isRequired
});
const zn = Ft("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), S1 = 550, zE = 80, kE = fi`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, _E = fi`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, BE = fi`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, FE = Ke("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), RE = Ke(k8, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${zn.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${kE};
    animation-duration: ${S1}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  &.${zn.ripplePulsate} {
    animation-duration: ${({
  theme: e
}) => e.transitions.duration.shorter}ms;
  }

  & .${zn.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${zn.childLeaving} {
    opacity: 0;
    animation-name: ${_E};
    animation-duration: ${S1}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  & .${zn.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${BE};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, _8 = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: c = !1,
    classes: n = {},
    className: d,
    ...f
  } = i, [p, l] = ue.useState([]), h = ue.useRef(0), y = ue.useRef(null);
  ue.useEffect(() => {
    y.current && (y.current(), y.current = null);
  }, [p]);
  const M = ue.useRef(!1), C = uo(), N = ue.useRef(null), w = ue.useRef(null), S = ue.useCallback((O) => {
    const {
      pulsate: z,
      rippleX: k,
      rippleY: H,
      rippleSize: W,
      cb: U
    } = O;
    l((B) => [...B, /* @__PURE__ */ D(RE, {
      classes: {
        ripple: It(n.ripple, zn.ripple),
        rippleVisible: It(n.rippleVisible, zn.rippleVisible),
        ripplePulsate: It(n.ripplePulsate, zn.ripplePulsate),
        child: It(n.child, zn.child),
        childLeaving: It(n.childLeaving, zn.childLeaving),
        childPulsate: It(n.childPulsate, zn.childPulsate)
      },
      timeout: S1,
      pulsate: z,
      rippleX: k,
      rippleY: H,
      rippleSize: W
    }, h.current)]), h.current += 1, y.current = U;
  }, [n]), T = ue.useCallback((O = {}, z = {}, k = () => {
  }) => {
    const {
      pulsate: H = !1,
      center: W = c || z.pulsate,
      fakeElement: U = !1
      // For test purposes
    } = z;
    if ((O == null ? void 0 : O.type) === "mousedown" && M.current) {
      M.current = !1;
      return;
    }
    (O == null ? void 0 : O.type) === "touchstart" && (M.current = !0);
    const B = U ? null : w.current, I = B ? B.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let r, s, u;
    if (W || O === void 0 || O.clientX === 0 && O.clientY === 0 || !O.clientX && !O.touches)
      r = Math.round(I.width / 2), s = Math.round(I.height / 2);
    else {
      const {
        clientX: g,
        clientY: v
      } = O.touches && O.touches.length > 0 ? O.touches[0] : O;
      r = Math.round(g - I.left), s = Math.round(v - I.top);
    }
    if (W)
      u = Math.sqrt((2 * I.width ** 2 + I.height ** 2) / 3), u % 2 === 0 && (u += 1);
    else {
      const g = Math.max(Math.abs((B ? B.clientWidth : 0) - r), r) * 2 + 2, v = Math.max(Math.abs((B ? B.clientHeight : 0) - s), s) * 2 + 2;
      u = Math.sqrt(g ** 2 + v ** 2);
    }
    O != null && O.touches ? N.current === null && (N.current = () => {
      S({
        pulsate: H,
        rippleX: r,
        rippleY: s,
        rippleSize: u,
        cb: k
      });
    }, C.start(zE, () => {
      N.current && (N.current(), N.current = null);
    })) : S({
      pulsate: H,
      rippleX: r,
      rippleY: s,
      rippleSize: u,
      cb: k
    });
  }, [c, S, C]), E = ue.useCallback(() => {
    T({}, {
      pulsate: !0
    });
  }, [T]), j = ue.useCallback((O, z) => {
    if (C.clear(), (O == null ? void 0 : O.type) === "touchend" && N.current) {
      N.current(), N.current = null, C.start(0, () => {
        j(O, z);
      });
      return;
    }
    N.current = null, l((k) => k.length > 0 ? k.slice(1) : k), y.current = z;
  }, [C]);
  return ue.useImperativeHandle(o, () => ({
    pulsate: E,
    start: T,
    stop: j
  }), [E, T, j]), /* @__PURE__ */ D(FE, {
    className: It(zn.root, n.root, d),
    ref: w,
    ...f,
    children: /* @__PURE__ */ D(Oh, {
      component: null,
      exit: !0,
      children: p
    })
  });
});
fe.process.env.NODE_ENV !== "production" && (_8.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: b.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string
});
function PE(e) {
  return Bt("MuiButtonBase", e);
}
const UE = Ft("MuiButtonBase", ["root", "disabled", "focusVisible"]), YE = (e) => {
  const {
    disabled: t,
    focusVisible: o,
    focusVisibleClassName: i,
    classes: c
  } = e, d = Rt({
    root: ["root", t && "disabled", o && "focusVisible"]
  }, PE, c);
  return o && i && (d.root += ` ${i}`), d;
}, WE = Ke("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${UE.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), ko = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: c,
    centerRipple: n = !1,
    children: d,
    className: f,
    component: p = "button",
    disabled: l = !1,
    disableRipple: h = !1,
    disableTouchRipple: y = !1,
    focusRipple: M = !1,
    focusVisibleClassName: C,
    LinkComponent: N = "a",
    onBlur: w,
    onClick: S,
    onContextMenu: T,
    onDragLeave: E,
    onFocus: j,
    onFocusVisible: O,
    onKeyDown: z,
    onKeyUp: k,
    onMouseDown: H,
    onMouseLeave: W,
    onMouseUp: U,
    onTouchEnd: B,
    onTouchMove: I,
    onTouchStart: r,
    tabIndex: s = 0,
    TouchRippleProps: u,
    touchRippleRef: g,
    type: v,
    ...A
  } = i, L = ue.useRef(null), m = wE(), a = zr(m.ref, g), [x, V] = ue.useState(!1);
  l && x && V(!1), ue.useImperativeHandle(c, () => ({
    focusVisible: () => {
      V(!0), L.current.focus();
    }
  }), []);
  const G = m.shouldMount && !h && !l;
  ue.useEffect(() => {
    x && M && !h && m.pulsate();
  }, [h, M, x, m]);
  const Z = gi(m, "start", H, y), te = gi(m, "stop", T, y), q = gi(m, "stop", E, y), R = gi(m, "stop", U, y), Q = gi(m, "stop", (ae) => {
    x && ae.preventDefault(), W && W(ae);
  }, y), $ = gi(m, "start", r, y), F = gi(m, "stop", B, y), P = gi(m, "stop", I, y), _ = gi(m, "stop", (ae) => {
    ca(ae.target) || V(!1), w && w(ae);
  }, !1), X = _n((ae) => {
    L.current || (L.current = ae.currentTarget), ca(ae.target) && (V(!0), O && O(ae)), j && j(ae);
  }), le = () => {
    const ae = L.current;
    return p && p !== "button" && !(ae.tagName === "A" && ae.href);
  }, ie = _n((ae) => {
    M && !ae.repeat && x && ae.key === " " && m.stop(ae, () => {
      m.start(ae);
    }), ae.target === ae.currentTarget && le() && ae.key === " " && ae.preventDefault(), z && z(ae), ae.target === ae.currentTarget && le() && ae.key === "Enter" && !l && (ae.preventDefault(), S && S(ae));
  }), oe = _n((ae) => {
    M && ae.key === " " && x && !ae.defaultPrevented && m.stop(ae, () => {
      m.pulsate(ae);
    }), k && k(ae), S && ae.target === ae.currentTarget && le() && ae.key === " " && !ae.defaultPrevented && S(ae);
  });
  let pe = p;
  pe === "button" && (A.href || A.to) && (pe = N);
  const se = {};
  pe === "button" ? (se.type = v === void 0 ? "button" : v, se.disabled = l) : (!A.href && !A.to && (se.role = "button"), l && (se["aria-disabled"] = l));
  const ce = zr(o, L), me = {
    ...i,
    centerRipple: n,
    component: p,
    disabled: l,
    disableRipple: h,
    disableTouchRipple: y,
    focusRipple: M,
    tabIndex: s,
    focusVisible: x
  }, de = YE(me);
  return /* @__PURE__ */ ne(WE, {
    as: pe,
    className: It(de.root, f),
    ownerState: me,
    onBlur: _,
    onClick: S,
    onContextMenu: te,
    onFocus: X,
    onKeyDown: ie,
    onKeyUp: oe,
    onMouseDown: Z,
    onMouseLeave: Q,
    onMouseUp: R,
    onDragLeave: q,
    onTouchEnd: F,
    onTouchMove: P,
    onTouchStart: $,
    ref: ce,
    tabIndex: l ? -1 : s,
    type: v,
    ...se,
    ...A,
    children: [d, G ? /* @__PURE__ */ D(_8, {
      ref: a,
      center: n,
      ...u
    }) : null]
  });
});
function gi(e, t, o, i = !1) {
  return _n((c) => (o && o(c), i || e[t](c), !0));
}
fe.process.env.NODE_ENV !== "production" && (ko.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: En,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: b.bool,
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Fi,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: b.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: b.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: b.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: b.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: b.string,
  /**
   * @ignore
   */
  href: b.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: b.elementType,
  /**
   * @ignore
   */
  onBlur: b.func,
  /**
   * @ignore
   */
  onClick: b.func,
  /**
   * @ignore
   */
  onContextMenu: b.func,
  /**
   * @ignore
   */
  onDragLeave: b.func,
  /**
   * @ignore
   */
  onFocus: b.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: b.func,
  /**
   * @ignore
   */
  onKeyDown: b.func,
  /**
   * @ignore
   */
  onKeyUp: b.func,
  /**
   * @ignore
   */
  onMouseDown: b.func,
  /**
   * @ignore
   */
  onMouseLeave: b.func,
  /**
   * @ignore
   */
  onMouseUp: b.func,
  /**
   * @ignore
   */
  onTouchEnd: b.func,
  /**
   * @ignore
   */
  onTouchMove: b.func,
  /**
   * @ignore
   */
  onTouchStart: b.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * @default 0
   */
  tabIndex: b.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: b.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: b.oneOfType([b.func, b.shape({
    current: b.shape({
      pulsate: b.func.isRequired,
      start: b.func.isRequired,
      stop: b.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: b.oneOfType([b.oneOf(["button", "reset", "submit"]), b.string])
});
function HE(e) {
  return Bt("MuiIconButton", e);
}
const n6 = Ft("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge", "loading", "loadingIndicator", "loadingWrapper"]), ZE = (e) => {
  const {
    classes: t,
    disabled: o,
    color: i,
    edge: c,
    size: n,
    loading: d
  } = e, f = {
    root: ["root", d && "loading", o && "disabled", i !== "default" && `color${it(i)}`, c && `edge${it(c)}`, `size${it(n)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  };
  return Rt(f, HE, t);
}, QE = Ke(ko, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.loading && t.loading, o.color !== "default" && t[`color${it(o.color)}`], o.edge && t[`edge${it(o.edge)}`], t[`size${it(o.size)}`]];
  }
})(kt(({
  theme: e
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: (t) => !t.disableRipple,
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : ur(e.palette.action.active, e.palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), kt(({
  theme: e
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(e.palette).filter(Gr()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), ...Object.entries(e.palette).filter(Gr()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${(e.vars || e).palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : ur((e.vars || e).palette[t].main, e.palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: e.typography.pxToRem(28)
    }
  }],
  [`&.${n6.disabled}`]: {
    backgroundColor: "transparent",
    color: (e.vars || e).palette.action.disabled
  },
  [`&.${n6.loading}`]: {
    color: "transparent"
  }
}))), VE = Ke("span", {
  name: "MuiIconButton",
  slot: "LoadingIndicator",
  overridesResolver: (e, t) => t.loadingIndicator
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  color: (e.vars || e).palette.action.disabled,
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }]
})), di = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: c = !1,
    children: n,
    className: d,
    color: f = "default",
    disabled: p = !1,
    disableFocusRipple: l = !1,
    size: h = "medium",
    id: y,
    loading: M = null,
    loadingIndicator: C,
    ...N
  } = i, w = Ls(y), S = C ?? /* @__PURE__ */ D(Or, {
    "aria-labelledby": w,
    color: "inherit",
    size: 16
  }), T = {
    ...i,
    edge: c,
    color: f,
    disabled: p,
    disableFocusRipple: l,
    loading: M,
    loadingIndicator: S,
    size: h
  }, E = ZE(T);
  return /* @__PURE__ */ ne(QE, {
    id: M ? w : y,
    className: It(E.root, d),
    centerRipple: !0,
    focusRipple: !l,
    disabled: p || M,
    ref: o,
    ...N,
    ownerState: T,
    children: [typeof M == "boolean" && // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ D("span", {
      className: E.loadingWrapper,
      style: {
        display: "contents"
      },
      children: /* @__PURE__ */ D(VE, {
        className: E.loadingIndicator,
        ownerState: T,
        children: M && S
      })
    }), n]
  });
});
fe.process.env.NODE_ENV !== "production" && (di.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: qn(b.node, (e) => ue.Children.toArray(e.children).some((o) => /* @__PURE__ */ ue.isValidElement(o) && o.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: b.oneOfType([b.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), b.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: b.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: b.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: b.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: b.oneOf(["end", "start", !1]),
  /**
   * @ignore
   */
  id: b.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: b.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: b.node,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: b.oneOfType([b.oneOf(["small", "medium", "large"]), b.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object])
});
const zh = (e) => e.scrollTop;
function wi(e, t) {
  const {
    timeout: o,
    easing: i,
    style: c = {}
  } = e;
  return {
    duration: c.transitionDuration ?? (typeof o == "number" ? o : o[t.mode] || 0),
    easing: c.transitionTimingFunction ?? (typeof i == "object" ? i[t.mode] : i),
    delay: c.transitionDelay
  };
}
function E1(e) {
  return `scale(${e}, ${e ** 2})`;
}
const GE = {
  entering: {
    opacity: 1,
    transform: E1(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, Sd = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), ys = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const {
    addEndListener: i,
    appear: c = !0,
    children: n,
    easing: d,
    in: f,
    onEnter: p,
    onEntered: l,
    onEntering: h,
    onExit: y,
    onExited: M,
    onExiting: C,
    style: N,
    timeout: w = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: S = Vn,
    ...T
  } = t, E = uo(), j = ue.useRef(), O = or(), z = ue.useRef(null), k = zr(z, zo(n), o), H = (g) => (v) => {
    if (g) {
      const A = z.current;
      v === void 0 ? g(A) : g(A, v);
    }
  }, W = H(h), U = H((g, v) => {
    zh(g);
    const {
      duration: A,
      delay: L,
      easing: m
    } = wi({
      style: N,
      timeout: w,
      easing: d
    }, {
      mode: "enter"
    });
    let a;
    w === "auto" ? (a = O.transitions.getAutoHeightDuration(g.clientHeight), j.current = a) : a = A, g.style.transition = [O.transitions.create("opacity", {
      duration: a,
      delay: L
    }), O.transitions.create("transform", {
      duration: Sd ? a : a * 0.666,
      delay: L,
      easing: m
    })].join(","), p && p(g, v);
  }), B = H(l), I = H(C), r = H((g) => {
    const {
      duration: v,
      delay: A,
      easing: L
    } = wi({
      style: N,
      timeout: w,
      easing: d
    }, {
      mode: "exit"
    });
    let m;
    w === "auto" ? (m = O.transitions.getAutoHeightDuration(g.clientHeight), j.current = m) : m = v, g.style.transition = [O.transitions.create("opacity", {
      duration: m,
      delay: A
    }), O.transitions.create("transform", {
      duration: Sd ? m : m * 0.666,
      delay: Sd ? A : A || m * 0.333,
      easing: L
    })].join(","), g.style.opacity = 0, g.style.transform = E1(0.75), y && y(g);
  }), s = H(M);
  return /* @__PURE__ */ D(S, {
    appear: c,
    in: f,
    nodeRef: z,
    onEnter: U,
    onEntered: B,
    onEntering: W,
    onExit: r,
    onExited: s,
    onExiting: I,
    addEndListener: (g) => {
      w === "auto" && E.start(j.current || 0, g), i && i(z.current, g);
    },
    timeout: w === "auto" ? null : w,
    ...T,
    children: (g, {
      ownerState: v,
      ...A
    }) => /* @__PURE__ */ ue.cloneElement(n, {
      style: {
        opacity: 0,
        transform: E1(0.75),
        visibility: g === "exited" && !f ? "hidden" : void 0,
        ...GE[g],
        ...N,
        ...n.props.style
      },
      ref: k,
      ...A
    })
  });
});
fe.process.env.NODE_ENV !== "production" && (ys.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: b.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: b.bool,
  /**
   * A single child content element.
   */
  children: Oo.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: b.oneOfType([b.shape({
    enter: b.string,
    exit: b.string
  }), b.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: b.bool,
  /**
   * @ignore
   */
  onEnter: b.func,
  /**
   * @ignore
   */
  onEntered: b.func,
  /**
   * @ignore
   */
  onEntering: b.func,
  /**
   * @ignore
   */
  onExit: b.func,
  /**
   * @ignore
   */
  onExited: b.func,
  /**
   * @ignore
   */
  onExiting: b.func,
  /**
   * @ignore
   */
  style: b.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: b.oneOfType([b.oneOf(["auto"]), b.number, b.shape({
    appear: b.number,
    enter: b.number,
    exit: b.number
  })])
});
ys && (ys.muiSupportAuto = !0);
var Mn = "top", Yn = "bottom", Wn = "right", mn = "left", kh = "auto", Qs = [Mn, Yn, Wn, mn], ga = "start", Ms = "end", $E = "clippingParents", B8 = "viewport", Oa = "popper", qE = "reference", i6 = /* @__PURE__ */ Qs.reduce(function(e, t) {
  return e.concat([t + "-" + ga, t + "-" + Ms]);
}, []), F8 = /* @__PURE__ */ [].concat(Qs, [kh]).reduce(function(e, t) {
  return e.concat([t, t + "-" + ga, t + "-" + Ms]);
}, []), JE = "beforeRead", XE = "read", KE = "afterRead", eD = "beforeMain", tD = "main", rD = "afterMain", nD = "beforeWrite", iD = "write", oD = "afterWrite", aD = [JE, XE, KE, eD, tD, rD, nD, iD, oD];
function li(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Ln(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function So(e) {
  var t = Ln(e).Element;
  return e instanceof t || e instanceof Element;
}
function Fn(e) {
  var t = Ln(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function _h(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Ln(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function sD(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(o) {
    var i = t.styles[o] || {}, c = t.attributes[o] || {}, n = t.elements[o];
    !Fn(n) || !li(n) || (Object.assign(n.style, i), Object.keys(c).forEach(function(d) {
      var f = c[d];
      f === !1 ? n.removeAttribute(d) : n.setAttribute(d, f === !0 ? "" : f);
    }));
  });
}
function cD(e) {
  var t = e.state, o = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, o.popper), t.styles = o, t.elements.arrow && Object.assign(t.elements.arrow.style, o.arrow), function() {
    Object.keys(t.elements).forEach(function(i) {
      var c = t.elements[i], n = t.attributes[i] || {}, d = Object.keys(t.styles.hasOwnProperty(i) ? t.styles[i] : o[i]), f = d.reduce(function(p, l) {
        return p[l] = "", p;
      }, {});
      !Fn(c) || !li(c) || (Object.assign(c.style, f), Object.keys(n).forEach(function(p) {
        c.removeAttribute(p);
      }));
    });
  };
}
const lD = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: sD,
  effect: cD,
  requires: ["computeStyles"]
};
function ii(e) {
  return e.split("-")[0];
}
var xo = Math.max, gc = Math.min, ya = Math.round;
function D1() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function R8() {
  return !/^((?!chrome|android).)*safari/i.test(D1());
}
function Ma(e, t, o) {
  t === void 0 && (t = !1), o === void 0 && (o = !1);
  var i = e.getBoundingClientRect(), c = 1, n = 1;
  t && Fn(e) && (c = e.offsetWidth > 0 && ya(i.width) / e.offsetWidth || 1, n = e.offsetHeight > 0 && ya(i.height) / e.offsetHeight || 1);
  var d = So(e) ? Ln(e) : window, f = d.visualViewport, p = !R8() && o, l = (i.left + (p && f ? f.offsetLeft : 0)) / c, h = (i.top + (p && f ? f.offsetTop : 0)) / n, y = i.width / c, M = i.height / n;
  return {
    width: y,
    height: M,
    top: h,
    right: l + y,
    bottom: h + M,
    left: l,
    x: l,
    y: h
  };
}
function Bh(e) {
  var t = Ma(e), o = e.offsetWidth, i = e.offsetHeight;
  return Math.abs(t.width - o) <= 1 && (o = t.width), Math.abs(t.height - i) <= 1 && (i = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: o,
    height: i
  };
}
function P8(e, t) {
  var o = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (o && _h(o)) {
    var i = t;
    do {
      if (i && e.isSameNode(i))
        return !0;
      i = i.parentNode || i.host;
    } while (i);
  }
  return !1;
}
function Ci(e) {
  return Ln(e).getComputedStyle(e);
}
function fD(e) {
  return ["table", "td", "th"].indexOf(li(e)) >= 0;
}
function Gi(e) {
  return ((So(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function ol(e) {
  return li(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (_h(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Gi(e)
  );
}
function o6(e) {
  return !Fn(e) || // https://github.com/popperjs/popper-core/issues/837
  Ci(e).position === "fixed" ? null : e.offsetParent;
}
function uD(e) {
  var t = /firefox/i.test(D1()), o = /Trident/i.test(D1());
  if (o && Fn(e)) {
    var i = Ci(e);
    if (i.position === "fixed")
      return null;
  }
  var c = ol(e);
  for (_h(c) && (c = c.host); Fn(c) && ["html", "body"].indexOf(li(c)) < 0; ) {
    var n = Ci(c);
    if (n.transform !== "none" || n.perspective !== "none" || n.contain === "paint" || ["transform", "perspective"].indexOf(n.willChange) !== -1 || t && n.willChange === "filter" || t && n.filter && n.filter !== "none")
      return c;
    c = c.parentNode;
  }
  return null;
}
function Vs(e) {
  for (var t = Ln(e), o = o6(e); o && fD(o) && Ci(o).position === "static"; )
    o = o6(o);
  return o && (li(o) === "html" || li(o) === "body" && Ci(o).position === "static") ? t : o || uD(e) || t;
}
function Fh(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Ka(e, t, o) {
  return xo(e, gc(t, o));
}
function dD(e, t, o) {
  var i = Ka(e, t, o);
  return i > o ? o : i;
}
function U8() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Y8(e) {
  return Object.assign({}, U8(), e);
}
function W8(e, t) {
  return t.reduce(function(o, i) {
    return o[i] = e, o;
  }, {});
}
var hD = function(t, o) {
  return t = typeof t == "function" ? t(Object.assign({}, o.rects, {
    placement: o.placement
  })) : t, Y8(typeof t != "number" ? t : W8(t, Qs));
};
function pD(e) {
  var t, o = e.state, i = e.name, c = e.options, n = o.elements.arrow, d = o.modifiersData.popperOffsets, f = ii(o.placement), p = Fh(f), l = [mn, Wn].indexOf(f) >= 0, h = l ? "height" : "width";
  if (!(!n || !d)) {
    var y = hD(c.padding, o), M = Bh(n), C = p === "y" ? Mn : mn, N = p === "y" ? Yn : Wn, w = o.rects.reference[h] + o.rects.reference[p] - d[p] - o.rects.popper[h], S = d[p] - o.rects.reference[p], T = Vs(n), E = T ? p === "y" ? T.clientHeight || 0 : T.clientWidth || 0 : 0, j = w / 2 - S / 2, O = y[C], z = E - M[h] - y[N], k = E / 2 - M[h] / 2 + j, H = Ka(O, k, z), W = p;
    o.modifiersData[i] = (t = {}, t[W] = H, t.centerOffset = H - k, t);
  }
}
function gD(e) {
  var t = e.state, o = e.options, i = o.element, c = i === void 0 ? "[data-popper-arrow]" : i;
  c != null && (typeof c == "string" && (c = t.elements.popper.querySelector(c), !c) || P8(t.elements.popper, c) && (t.elements.arrow = c));
}
const yD = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: pD,
  effect: gD,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ma(e) {
  return e.split("-")[1];
}
var MD = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function mD(e, t) {
  var o = e.x, i = e.y, c = t.devicePixelRatio || 1;
  return {
    x: ya(o * c) / c || 0,
    y: ya(i * c) / c || 0
  };
}
function a6(e) {
  var t, o = e.popper, i = e.popperRect, c = e.placement, n = e.variation, d = e.offsets, f = e.position, p = e.gpuAcceleration, l = e.adaptive, h = e.roundOffsets, y = e.isFixed, M = d.x, C = M === void 0 ? 0 : M, N = d.y, w = N === void 0 ? 0 : N, S = typeof h == "function" ? h({
    x: C,
    y: w
  }) : {
    x: C,
    y: w
  };
  C = S.x, w = S.y;
  var T = d.hasOwnProperty("x"), E = d.hasOwnProperty("y"), j = mn, O = Mn, z = window;
  if (l) {
    var k = Vs(o), H = "clientHeight", W = "clientWidth";
    if (k === Ln(o) && (k = Gi(o), Ci(k).position !== "static" && f === "absolute" && (H = "scrollHeight", W = "scrollWidth")), k = k, c === Mn || (c === mn || c === Wn) && n === Ms) {
      O = Yn;
      var U = y && k === z && z.visualViewport ? z.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        k[H]
      );
      w -= U - i.height, w *= p ? 1 : -1;
    }
    if (c === mn || (c === Mn || c === Yn) && n === Ms) {
      j = Wn;
      var B = y && k === z && z.visualViewport ? z.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        k[W]
      );
      C -= B - i.width, C *= p ? 1 : -1;
    }
  }
  var I = Object.assign({
    position: f
  }, l && MD), r = h === !0 ? mD({
    x: C,
    y: w
  }, Ln(o)) : {
    x: C,
    y: w
  };
  if (C = r.x, w = r.y, p) {
    var s;
    return Object.assign({}, I, (s = {}, s[O] = E ? "0" : "", s[j] = T ? "0" : "", s.transform = (z.devicePixelRatio || 1) <= 1 ? "translate(" + C + "px, " + w + "px)" : "translate3d(" + C + "px, " + w + "px, 0)", s));
  }
  return Object.assign({}, I, (t = {}, t[O] = E ? w + "px" : "", t[j] = T ? C + "px" : "", t.transform = "", t));
}
function vD(e) {
  var t = e.state, o = e.options, i = o.gpuAcceleration, c = i === void 0 ? !0 : i, n = o.adaptive, d = n === void 0 ? !0 : n, f = o.roundOffsets, p = f === void 0 ? !0 : f, l = {
    placement: ii(t.placement),
    variation: ma(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: c,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, a6(Object.assign({}, l, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: d,
    roundOffsets: p
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, a6(Object.assign({}, l, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: p
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const bD = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: vD,
  data: {}
};
var w0 = {
  passive: !0
};
function xD(e) {
  var t = e.state, o = e.instance, i = e.options, c = i.scroll, n = c === void 0 ? !0 : c, d = i.resize, f = d === void 0 ? !0 : d, p = Ln(t.elements.popper), l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return n && l.forEach(function(h) {
    h.addEventListener("scroll", o.update, w0);
  }), f && p.addEventListener("resize", o.update, w0), function() {
    n && l.forEach(function(h) {
      h.removeEventListener("scroll", o.update, w0);
    }), f && p.removeEventListener("resize", o.update, w0);
  };
}
const wD = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: xD,
  data: {}
};
var CD = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function G0(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return CD[t];
  });
}
var ID = {
  start: "end",
  end: "start"
};
function s6(e) {
  return e.replace(/start|end/g, function(t) {
    return ID[t];
  });
}
function Rh(e) {
  var t = Ln(e), o = t.pageXOffset, i = t.pageYOffset;
  return {
    scrollLeft: o,
    scrollTop: i
  };
}
function Ph(e) {
  return Ma(Gi(e)).left + Rh(e).scrollLeft;
}
function ND(e, t) {
  var o = Ln(e), i = Gi(e), c = o.visualViewport, n = i.clientWidth, d = i.clientHeight, f = 0, p = 0;
  if (c) {
    n = c.width, d = c.height;
    var l = R8();
    (l || !l && t === "fixed") && (f = c.offsetLeft, p = c.offsetTop);
  }
  return {
    width: n,
    height: d,
    x: f + Ph(e),
    y: p
  };
}
function AD(e) {
  var t, o = Gi(e), i = Rh(e), c = (t = e.ownerDocument) == null ? void 0 : t.body, n = xo(o.scrollWidth, o.clientWidth, c ? c.scrollWidth : 0, c ? c.clientWidth : 0), d = xo(o.scrollHeight, o.clientHeight, c ? c.scrollHeight : 0, c ? c.clientHeight : 0), f = -i.scrollLeft + Ph(e), p = -i.scrollTop;
  return Ci(c || o).direction === "rtl" && (f += xo(o.clientWidth, c ? c.clientWidth : 0) - n), {
    width: n,
    height: d,
    x: f,
    y: p
  };
}
function Uh(e) {
  var t = Ci(e), o = t.overflow, i = t.overflowX, c = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(o + c + i);
}
function H8(e) {
  return ["html", "body", "#document"].indexOf(li(e)) >= 0 ? e.ownerDocument.body : Fn(e) && Uh(e) ? e : H8(ol(e));
}
function es(e, t) {
  var o;
  t === void 0 && (t = []);
  var i = H8(e), c = i === ((o = e.ownerDocument) == null ? void 0 : o.body), n = Ln(i), d = c ? [n].concat(n.visualViewport || [], Uh(i) ? i : []) : i, f = t.concat(d);
  return c ? f : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    f.concat(es(ol(d)))
  );
}
function j1(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function TD(e, t) {
  var o = Ma(e, !1, t === "fixed");
  return o.top = o.top + e.clientTop, o.left = o.left + e.clientLeft, o.bottom = o.top + e.clientHeight, o.right = o.left + e.clientWidth, o.width = e.clientWidth, o.height = e.clientHeight, o.x = o.left, o.y = o.top, o;
}
function c6(e, t, o) {
  return t === B8 ? j1(ND(e, o)) : So(t) ? TD(t, o) : j1(AD(Gi(e)));
}
function LD(e) {
  var t = es(ol(e)), o = ["absolute", "fixed"].indexOf(Ci(e).position) >= 0, i = o && Fn(e) ? Vs(e) : e;
  return So(i) ? t.filter(function(c) {
    return So(c) && P8(c, i) && li(c) !== "body";
  }) : [];
}
function SD(e, t, o, i) {
  var c = t === "clippingParents" ? LD(e) : [].concat(t), n = [].concat(c, [o]), d = n[0], f = n.reduce(function(p, l) {
    var h = c6(e, l, i);
    return p.top = xo(h.top, p.top), p.right = gc(h.right, p.right), p.bottom = gc(h.bottom, p.bottom), p.left = xo(h.left, p.left), p;
  }, c6(e, d, i));
  return f.width = f.right - f.left, f.height = f.bottom - f.top, f.x = f.left, f.y = f.top, f;
}
function Z8(e) {
  var t = e.reference, o = e.element, i = e.placement, c = i ? ii(i) : null, n = i ? ma(i) : null, d = t.x + t.width / 2 - o.width / 2, f = t.y + t.height / 2 - o.height / 2, p;
  switch (c) {
    case Mn:
      p = {
        x: d,
        y: t.y - o.height
      };
      break;
    case Yn:
      p = {
        x: d,
        y: t.y + t.height
      };
      break;
    case Wn:
      p = {
        x: t.x + t.width,
        y: f
      };
      break;
    case mn:
      p = {
        x: t.x - o.width,
        y: f
      };
      break;
    default:
      p = {
        x: t.x,
        y: t.y
      };
  }
  var l = c ? Fh(c) : null;
  if (l != null) {
    var h = l === "y" ? "height" : "width";
    switch (n) {
      case ga:
        p[l] = p[l] - (t[h] / 2 - o[h] / 2);
        break;
      case Ms:
        p[l] = p[l] + (t[h] / 2 - o[h] / 2);
        break;
    }
  }
  return p;
}
function ms(e, t) {
  t === void 0 && (t = {});
  var o = t, i = o.placement, c = i === void 0 ? e.placement : i, n = o.strategy, d = n === void 0 ? e.strategy : n, f = o.boundary, p = f === void 0 ? $E : f, l = o.rootBoundary, h = l === void 0 ? B8 : l, y = o.elementContext, M = y === void 0 ? Oa : y, C = o.altBoundary, N = C === void 0 ? !1 : C, w = o.padding, S = w === void 0 ? 0 : w, T = Y8(typeof S != "number" ? S : W8(S, Qs)), E = M === Oa ? qE : Oa, j = e.rects.popper, O = e.elements[N ? E : M], z = SD(So(O) ? O : O.contextElement || Gi(e.elements.popper), p, h, d), k = Ma(e.elements.reference), H = Z8({
    reference: k,
    element: j,
    placement: c
  }), W = j1(Object.assign({}, j, H)), U = M === Oa ? W : k, B = {
    top: z.top - U.top + T.top,
    bottom: U.bottom - z.bottom + T.bottom,
    left: z.left - U.left + T.left,
    right: U.right - z.right + T.right
  }, I = e.modifiersData.offset;
  if (M === Oa && I) {
    var r = I[c];
    Object.keys(B).forEach(function(s) {
      var u = [Wn, Yn].indexOf(s) >= 0 ? 1 : -1, g = [Mn, Yn].indexOf(s) >= 0 ? "y" : "x";
      B[s] += r[g] * u;
    });
  }
  return B;
}
function ED(e, t) {
  t === void 0 && (t = {});
  var o = t, i = o.placement, c = o.boundary, n = o.rootBoundary, d = o.padding, f = o.flipVariations, p = o.allowedAutoPlacements, l = p === void 0 ? F8 : p, h = ma(i), y = h ? f ? i6 : i6.filter(function(N) {
    return ma(N) === h;
  }) : Qs, M = y.filter(function(N) {
    return l.indexOf(N) >= 0;
  });
  M.length === 0 && (M = y);
  var C = M.reduce(function(N, w) {
    return N[w] = ms(e, {
      placement: w,
      boundary: c,
      rootBoundary: n,
      padding: d
    })[ii(w)], N;
  }, {});
  return Object.keys(C).sort(function(N, w) {
    return C[N] - C[w];
  });
}
function DD(e) {
  if (ii(e) === kh)
    return [];
  var t = G0(e);
  return [s6(e), t, s6(t)];
}
function jD(e) {
  var t = e.state, o = e.options, i = e.name;
  if (!t.modifiersData[i]._skip) {
    for (var c = o.mainAxis, n = c === void 0 ? !0 : c, d = o.altAxis, f = d === void 0 ? !0 : d, p = o.fallbackPlacements, l = o.padding, h = o.boundary, y = o.rootBoundary, M = o.altBoundary, C = o.flipVariations, N = C === void 0 ? !0 : C, w = o.allowedAutoPlacements, S = t.options.placement, T = ii(S), E = T === S, j = p || (E || !N ? [G0(S)] : DD(S)), O = [S].concat(j).reduce(function(Z, te) {
      return Z.concat(ii(te) === kh ? ED(t, {
        placement: te,
        boundary: h,
        rootBoundary: y,
        padding: l,
        flipVariations: N,
        allowedAutoPlacements: w
      }) : te);
    }, []), z = t.rects.reference, k = t.rects.popper, H = /* @__PURE__ */ new Map(), W = !0, U = O[0], B = 0; B < O.length; B++) {
      var I = O[B], r = ii(I), s = ma(I) === ga, u = [Mn, Yn].indexOf(r) >= 0, g = u ? "width" : "height", v = ms(t, {
        placement: I,
        boundary: h,
        rootBoundary: y,
        altBoundary: M,
        padding: l
      }), A = u ? s ? Wn : mn : s ? Yn : Mn;
      z[g] > k[g] && (A = G0(A));
      var L = G0(A), m = [];
      if (n && m.push(v[r] <= 0), f && m.push(v[A] <= 0, v[L] <= 0), m.every(function(Z) {
        return Z;
      })) {
        U = I, W = !1;
        break;
      }
      H.set(I, m);
    }
    if (W)
      for (var a = N ? 3 : 1, x = function(te) {
        var q = O.find(function(R) {
          var Q = H.get(R);
          if (Q)
            return Q.slice(0, te).every(function($) {
              return $;
            });
        });
        if (q)
          return U = q, "break";
      }, V = a; V > 0; V--) {
        var G = x(V);
        if (G === "break") break;
      }
    t.placement !== U && (t.modifiersData[i]._skip = !0, t.placement = U, t.reset = !0);
  }
}
const OD = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: jD,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function l6(e, t, o) {
  return o === void 0 && (o = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - o.y,
    right: e.right - t.width + o.x,
    bottom: e.bottom - t.height + o.y,
    left: e.left - t.width - o.x
  };
}
function f6(e) {
  return [Mn, Wn, Yn, mn].some(function(t) {
    return e[t] >= 0;
  });
}
function zD(e) {
  var t = e.state, o = e.name, i = t.rects.reference, c = t.rects.popper, n = t.modifiersData.preventOverflow, d = ms(t, {
    elementContext: "reference"
  }), f = ms(t, {
    altBoundary: !0
  }), p = l6(d, i), l = l6(f, c, n), h = f6(p), y = f6(l);
  t.modifiersData[o] = {
    referenceClippingOffsets: p,
    popperEscapeOffsets: l,
    isReferenceHidden: h,
    hasPopperEscaped: y
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": h,
    "data-popper-escaped": y
  });
}
const kD = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: zD
};
function _D(e, t, o) {
  var i = ii(e), c = [mn, Mn].indexOf(i) >= 0 ? -1 : 1, n = typeof o == "function" ? o(Object.assign({}, t, {
    placement: e
  })) : o, d = n[0], f = n[1];
  return d = d || 0, f = (f || 0) * c, [mn, Wn].indexOf(i) >= 0 ? {
    x: f,
    y: d
  } : {
    x: d,
    y: f
  };
}
function BD(e) {
  var t = e.state, o = e.options, i = e.name, c = o.offset, n = c === void 0 ? [0, 0] : c, d = F8.reduce(function(h, y) {
    return h[y] = _D(y, t.rects, n), h;
  }, {}), f = d[t.placement], p = f.x, l = f.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += p, t.modifiersData.popperOffsets.y += l), t.modifiersData[i] = d;
}
const FD = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: BD
};
function RD(e) {
  var t = e.state, o = e.name;
  t.modifiersData[o] = Z8({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const PD = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: RD,
  data: {}
};
function UD(e) {
  return e === "x" ? "y" : "x";
}
function YD(e) {
  var t = e.state, o = e.options, i = e.name, c = o.mainAxis, n = c === void 0 ? !0 : c, d = o.altAxis, f = d === void 0 ? !1 : d, p = o.boundary, l = o.rootBoundary, h = o.altBoundary, y = o.padding, M = o.tether, C = M === void 0 ? !0 : M, N = o.tetherOffset, w = N === void 0 ? 0 : N, S = ms(t, {
    boundary: p,
    rootBoundary: l,
    padding: y,
    altBoundary: h
  }), T = ii(t.placement), E = ma(t.placement), j = !E, O = Fh(T), z = UD(O), k = t.modifiersData.popperOffsets, H = t.rects.reference, W = t.rects.popper, U = typeof w == "function" ? w(Object.assign({}, t.rects, {
    placement: t.placement
  })) : w, B = typeof U == "number" ? {
    mainAxis: U,
    altAxis: U
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, U), I = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, r = {
    x: 0,
    y: 0
  };
  if (k) {
    if (n) {
      var s, u = O === "y" ? Mn : mn, g = O === "y" ? Yn : Wn, v = O === "y" ? "height" : "width", A = k[O], L = A + S[u], m = A - S[g], a = C ? -W[v] / 2 : 0, x = E === ga ? H[v] : W[v], V = E === ga ? -W[v] : -H[v], G = t.elements.arrow, Z = C && G ? Bh(G) : {
        width: 0,
        height: 0
      }, te = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : U8(), q = te[u], R = te[g], Q = Ka(0, H[v], Z[v]), $ = j ? H[v] / 2 - a - Q - q - B.mainAxis : x - Q - q - B.mainAxis, F = j ? -H[v] / 2 + a + Q + R + B.mainAxis : V + Q + R + B.mainAxis, P = t.elements.arrow && Vs(t.elements.arrow), _ = P ? O === "y" ? P.clientTop || 0 : P.clientLeft || 0 : 0, X = (s = I == null ? void 0 : I[O]) != null ? s : 0, le = A + $ - X - _, ie = A + F - X, oe = Ka(C ? gc(L, le) : L, A, C ? xo(m, ie) : m);
      k[O] = oe, r[O] = oe - A;
    }
    if (f) {
      var pe, se = O === "x" ? Mn : mn, ce = O === "x" ? Yn : Wn, me = k[z], de = z === "y" ? "height" : "width", ae = me + S[se], Le = me - S[ce], ye = [Mn, mn].indexOf(T) !== -1, Me = (pe = I == null ? void 0 : I[z]) != null ? pe : 0, at = ye ? ae : me - H[de] - W[de] - Me + B.altAxis, Ne = ye ? me + H[de] + W[de] - Me - B.altAxis : Le, Ae = C && ye ? dD(at, me, Ne) : Ka(C ? at : ae, me, C ? Ne : Le);
      k[z] = Ae, r[z] = Ae - me;
    }
    t.modifiersData[i] = r;
  }
}
const WD = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: YD,
  requiresIfExists: ["offset"]
};
function HD(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function ZD(e) {
  return e === Ln(e) || !Fn(e) ? Rh(e) : HD(e);
}
function QD(e) {
  var t = e.getBoundingClientRect(), o = ya(t.width) / e.offsetWidth || 1, i = ya(t.height) / e.offsetHeight || 1;
  return o !== 1 || i !== 1;
}
function VD(e, t, o) {
  o === void 0 && (o = !1);
  var i = Fn(t), c = Fn(t) && QD(t), n = Gi(t), d = Ma(e, c, o), f = {
    scrollLeft: 0,
    scrollTop: 0
  }, p = {
    x: 0,
    y: 0
  };
  return (i || !i && !o) && ((li(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Uh(n)) && (f = ZD(t)), Fn(t) ? (p = Ma(t, !0), p.x += t.clientLeft, p.y += t.clientTop) : n && (p.x = Ph(n))), {
    x: d.left + f.scrollLeft - p.x,
    y: d.top + f.scrollTop - p.y,
    width: d.width,
    height: d.height
  };
}
function GD(e) {
  var t = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Set(), i = [];
  e.forEach(function(n) {
    t.set(n.name, n);
  });
  function c(n) {
    o.add(n.name);
    var d = [].concat(n.requires || [], n.requiresIfExists || []);
    d.forEach(function(f) {
      if (!o.has(f)) {
        var p = t.get(f);
        p && c(p);
      }
    }), i.push(n);
  }
  return e.forEach(function(n) {
    o.has(n.name) || c(n);
  }), i;
}
function $D(e) {
  var t = GD(e);
  return aD.reduce(function(o, i) {
    return o.concat(t.filter(function(c) {
      return c.phase === i;
    }));
  }, []);
}
function qD(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(o) {
      Promise.resolve().then(function() {
        t = void 0, o(e());
      });
    })), t;
  };
}
function JD(e) {
  var t = e.reduce(function(o, i) {
    var c = o[i.name];
    return o[i.name] = c ? Object.assign({}, c, i, {
      options: Object.assign({}, c.options, i.options),
      data: Object.assign({}, c.data, i.data)
    }) : i, o;
  }, {});
  return Object.keys(t).map(function(o) {
    return t[o];
  });
}
var u6 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function d6() {
  for (var e = arguments.length, t = new Array(e), o = 0; o < e; o++)
    t[o] = arguments[o];
  return !t.some(function(i) {
    return !(i && typeof i.getBoundingClientRect == "function");
  });
}
function XD(e) {
  e === void 0 && (e = {});
  var t = e, o = t.defaultModifiers, i = o === void 0 ? [] : o, c = t.defaultOptions, n = c === void 0 ? u6 : c;
  return function(f, p, l) {
    l === void 0 && (l = n);
    var h = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, u6, n),
      modifiersData: {},
      elements: {
        reference: f,
        popper: p
      },
      attributes: {},
      styles: {}
    }, y = [], M = !1, C = {
      state: h,
      setOptions: function(T) {
        var E = typeof T == "function" ? T(h.options) : T;
        w(), h.options = Object.assign({}, n, h.options, E), h.scrollParents = {
          reference: So(f) ? es(f) : f.contextElement ? es(f.contextElement) : [],
          popper: es(p)
        };
        var j = $D(JD([].concat(i, h.options.modifiers)));
        return h.orderedModifiers = j.filter(function(O) {
          return O.enabled;
        }), N(), C.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!M) {
          var T = h.elements, E = T.reference, j = T.popper;
          if (d6(E, j)) {
            h.rects = {
              reference: VD(E, Vs(j), h.options.strategy === "fixed"),
              popper: Bh(j)
            }, h.reset = !1, h.placement = h.options.placement, h.orderedModifiers.forEach(function(B) {
              return h.modifiersData[B.name] = Object.assign({}, B.data);
            });
            for (var O = 0; O < h.orderedModifiers.length; O++) {
              if (h.reset === !0) {
                h.reset = !1, O = -1;
                continue;
              }
              var z = h.orderedModifiers[O], k = z.fn, H = z.options, W = H === void 0 ? {} : H, U = z.name;
              typeof k == "function" && (h = k({
                state: h,
                options: W,
                name: U,
                instance: C
              }) || h);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: qD(function() {
        return new Promise(function(S) {
          C.forceUpdate(), S(h);
        });
      }),
      destroy: function() {
        w(), M = !0;
      }
    };
    if (!d6(f, p))
      return C;
    C.setOptions(l).then(function(S) {
      !M && l.onFirstUpdate && l.onFirstUpdate(S);
    });
    function N() {
      h.orderedModifiers.forEach(function(S) {
        var T = S.name, E = S.options, j = E === void 0 ? {} : E, O = S.effect;
        if (typeof O == "function") {
          var z = O({
            state: h,
            name: T,
            instance: C,
            options: j
          }), k = function() {
          };
          y.push(z || k);
        }
      });
    }
    function w() {
      y.forEach(function(S) {
        return S();
      }), y = [];
    }
    return C;
  };
}
var KD = [wD, PD, bD, lD, FD, OD, WD, yD, kD], ej = /* @__PURE__ */ XD({
  defaultModifiers: KD
});
function tj(e) {
  return typeof e == "function" ? e() : e;
}
const vs = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const {
    children: i,
    container: c,
    disablePortal: n = !1
  } = t, [d, f] = ue.useState(null), p = zr(/* @__PURE__ */ ue.isValidElement(i) ? zo(i) : null, o);
  if (Rn(() => {
    n || f(tj(c) || document.body);
  }, [c, n]), Rn(() => {
    if (d && !n)
      return D2(o, d), () => {
        D2(o, null);
      };
  }, [o, d, n]), n) {
    if (/* @__PURE__ */ ue.isValidElement(i)) {
      const l = {
        ref: p
      };
      return /* @__PURE__ */ ue.cloneElement(i, l);
    }
    return i;
  }
  return d && /* @__PURE__ */ hc.createPortal(i, d);
});
fe.process.env.NODE_ENV !== "production" && (vs.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: b.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: b.oneOfType([ci, b.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: b.bool
});
fe.process.env.NODE_ENV !== "production" && (vs.propTypes = X1(vs.propTypes));
function rj(e) {
  return Bt("MuiPopper", e);
}
Ft("MuiPopper", ["root"]);
function nj(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function yc(e) {
  return typeof e == "function" ? e() : e;
}
function al(e) {
  return e.nodeType !== void 0;
}
function ij(e) {
  return !al(e);
}
const oj = (e) => {
  const {
    classes: t
  } = e;
  return Rt({
    root: ["root"]
  }, rj, t);
}, aj = {}, sj = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const {
    anchorEl: i,
    children: c,
    direction: n,
    disablePortal: d,
    modifiers: f,
    open: p,
    placement: l,
    popperOptions: h,
    popperRef: y,
    slotProps: M = {},
    slots: C = {},
    TransitionProps: N,
    // @ts-ignore internal logic
    ownerState: w,
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...S
  } = t, T = ue.useRef(null), E = zr(T, o), j = ue.useRef(null), O = zr(j, y), z = ue.useRef(O);
  Rn(() => {
    z.current = O;
  }, [O]), ue.useImperativeHandle(y, () => j.current, []);
  const k = nj(l, n), [H, W] = ue.useState(k), [U, B] = ue.useState(yc(i));
  ue.useEffect(() => {
    j.current && j.current.forceUpdate();
  }), ue.useEffect(() => {
    i && B(yc(i));
  }, [i]), Rn(() => {
    if (!U || !p)
      return;
    const g = (L) => {
      W(L.placement);
    };
    if (fe.process.env.NODE_ENV !== "production" && U && al(U) && U.nodeType === 1) {
      const L = U.getBoundingClientRect();
      fe.process.env.NODE_ENV !== "test" && L.top === 0 && L.left === 0 && L.right === 0 && L.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let v = [{
      name: "preventOverflow",
      options: {
        altBoundary: d
      }
    }, {
      name: "flip",
      options: {
        altBoundary: d
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: L
      }) => {
        g(L);
      }
    }];
    f != null && (v = v.concat(f)), h && h.modifiers != null && (v = v.concat(h.modifiers));
    const A = ej(U, T.current, {
      placement: k,
      ...h,
      modifiers: v
    });
    return z.current(A), () => {
      A.destroy(), z.current(null);
    };
  }, [U, d, f, p, h, k]);
  const I = {
    placement: H
  };
  N !== null && (I.TransitionProps = N);
  const r = oj(t), s = C.root ?? "div", u = Rg({
    elementType: s,
    externalSlotProps: M.root,
    externalForwardedProps: S,
    additionalProps: {
      role: "tooltip",
      ref: E
    },
    ownerState: t,
    className: r.root
  });
  return /* @__PURE__ */ D(s, {
    ...u,
    children: typeof c == "function" ? c(I) : c
  });
}), Q8 = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const {
    anchorEl: i,
    children: c,
    container: n,
    direction: d = "ltr",
    disablePortal: f = !1,
    keepMounted: p = !1,
    modifiers: l,
    open: h,
    placement: y = "bottom",
    popperOptions: M = aj,
    popperRef: C,
    style: N,
    transition: w = !1,
    slotProps: S = {},
    slots: T = {},
    ...E
  } = t, [j, O] = ue.useState(!0), z = () => {
    O(!1);
  }, k = () => {
    O(!0);
  };
  if (!p && !h && (!w || j))
    return null;
  let H;
  if (n)
    H = n;
  else if (i) {
    const B = yc(i);
    H = B && al(B) ? Xr(B).body : Xr(null).body;
  }
  const W = !h && p && (!w || j) ? "none" : void 0, U = w ? {
    in: h,
    onEnter: z,
    onExited: k
  } : void 0;
  return /* @__PURE__ */ D(vs, {
    disablePortal: f,
    container: H,
    children: /* @__PURE__ */ D(sj, {
      anchorEl: i,
      direction: d,
      disablePortal: f,
      modifiers: l,
      ref: o,
      open: w ? !j : h,
      placement: y,
      popperOptions: M,
      popperRef: C,
      slotProps: S,
      slots: T,
      ...E,
      style: {
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: W,
        ...N
      },
      TransitionProps: U,
      children: c
    })
  });
});
fe.process.env.NODE_ENV !== "production" && (Q8.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: qn(b.oneOfType([ci, b.object, b.func]), (e) => {
    if (e.open) {
      const t = yc(e.anchorEl);
      if (t && al(t) && t.nodeType === 1) {
        const o = t.getBoundingClientRect();
        if (fe.process.env.NODE_ENV !== "test" && o.top === 0 && o.left === 0 && o.right === 0 && o.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || ij(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: b.oneOfType([b.node, b.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: b.oneOfType([ci, b.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: b.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: b.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: b.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: b.arrayOf(b.shape({
    data: b.object,
    effect: b.func,
    enabled: b.bool,
    fn: b.func,
    name: b.any,
    options: b.object,
    phase: b.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: b.arrayOf(b.string),
    requiresIfExists: b.arrayOf(b.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: b.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: b.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: b.shape({
    modifiers: b.array,
    onFirstUpdate: b.func,
    placement: b.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: b.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: En,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: b.shape({
    root: b.oneOfType([b.func, b.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: b.shape({
    root: b.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: b.bool
});
const cj = Ke(Q8, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Yh = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Ss(), c = Pt({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: n,
    component: d,
    components: f,
    componentsProps: p,
    container: l,
    disablePortal: h,
    keepMounted: y,
    modifiers: M,
    open: C,
    placement: N,
    popperOptions: w,
    popperRef: S,
    transition: T,
    slots: E,
    slotProps: j,
    ...O
  } = c, z = (E == null ? void 0 : E.root) ?? (f == null ? void 0 : f.Root), k = {
    anchorEl: n,
    container: l,
    disablePortal: h,
    keepMounted: y,
    modifiers: M,
    open: C,
    placement: N,
    popperOptions: w,
    popperRef: S,
    transition: T,
    ...O
  };
  return /* @__PURE__ */ D(cj, {
    as: d,
    direction: i ? "rtl" : "ltr",
    slots: {
      root: z
    },
    slotProps: j ?? p,
    ...k,
    ref: o
  });
});
fe.process.env.NODE_ENV !== "production" && (Yh.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: b.oneOfType([ci, b.object, b.func]),
  /**
   * Popper render function or node.
   */
  children: b.oneOfType([b.node, b.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  components: b.shape({
    Root: b.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  componentsProps: b.shape({
    root: b.oneOfType([b.func, b.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: b.oneOfType([ci, b.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: b.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: b.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: b.arrayOf(b.shape({
    data: b.object,
    effect: b.func,
    enabled: b.bool,
    fn: b.func,
    name: b.any,
    options: b.object,
    phase: b.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: b.arrayOf(b.string),
    requiresIfExists: b.arrayOf(b.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: b.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: b.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: b.shape({
    modifiers: b.array,
    onFirstUpdate: b.func,
    placement: b.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: b.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: En,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: b.shape({
    root: b.oneOfType([b.func, b.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: b.shape({
    root: b.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: b.bool
});
function qt(e, t) {
  const {
    className: o,
    elementType: i,
    ownerState: c,
    externalForwardedProps: n,
    internalForwardedProps: d,
    shouldForwardComponentProp: f = !1,
    ...p
  } = t, {
    component: l,
    slots: h = {
      [e]: void 0
    },
    slotProps: y = {
      [e]: void 0
    },
    ...M
  } = n, C = h[e] || i, N = Fg(y[e], c), {
    props: {
      component: w,
      ...S
    },
    internalRef: T
  } = Bg({
    className: o,
    ...p,
    externalForwardedProps: e === "root" ? M : void 0,
    externalSlotProps: N
  }), E = zr(T, N == null ? void 0 : N.ref, t.ref), j = e === "root" ? w || l : w, O = zg(C, {
    ...e === "root" && !l && !h[e] && d,
    ...e !== "root" && !h[e] && d,
    ...S,
    ...j && !f && {
      as: j
    },
    ...j && f && {
      component: j
    },
    ref: E
  }, c);
  return [C, O];
}
function lj(e) {
  return Bt("MuiTooltip", e);
}
const jr = Ft("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]);
function fj(e) {
  return Math.round(e * 1e5) / 1e5;
}
const uj = (e) => {
  const {
    classes: t,
    disableInteractive: o,
    arrow: i,
    touch: c,
    placement: n
  } = e, d = {
    popper: ["popper", !o && "popperInteractive", i && "popperArrow"],
    tooltip: ["tooltip", i && "tooltipArrow", c && "touch", `tooltipPlacement${it(n.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return Rt(d, lj, t);
}, dj = Ke(Yh, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.popper, !o.disableInteractive && t.popperInteractive, o.arrow && t.popperArrow, !o.open && t.popperClose];
  }
})(kt(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableInteractive,
    style: {
      pointerEvents: "auto"
    }
  }, {
    props: ({
      open: t
    }) => !t,
    style: {
      pointerEvents: "none"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      [`&[data-popper-placement*="bottom"] .${jr.arrow}`]: {
        top: 0,
        marginTop: "-0.71em",
        "&::before": {
          transformOrigin: "0 100%"
        }
      },
      [`&[data-popper-placement*="top"] .${jr.arrow}`]: {
        bottom: 0,
        marginBottom: "-0.71em",
        "&::before": {
          transformOrigin: "100% 0"
        }
      },
      [`&[data-popper-placement*="right"] .${jr.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "100% 100%"
        }
      },
      [`&[data-popper-placement*="left"] .${jr.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "0 0"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${jr.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${jr.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${jr.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${jr.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }]
}))), hj = Ke("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.tooltip, o.touch && t.touch, o.arrow && t.tooltipArrow, t[`tooltipPlacement${it(o.placement.split("-")[0])}`]];
  }
})(kt(({
  theme: e
}) => ({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : ur(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium,
  [`.${jr.popper}[data-popper-placement*="left"] &`]: {
    transformOrigin: "right center"
  },
  [`.${jr.popper}[data-popper-placement*="right"] &`]: {
    transformOrigin: "left center"
  },
  [`.${jr.popper}[data-popper-placement*="top"] &`]: {
    transformOrigin: "center bottom",
    marginBottom: "14px"
  },
  [`.${jr.popper}[data-popper-placement*="bottom"] &`]: {
    transformOrigin: "center top",
    marginTop: "14px"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      position: "relative",
      margin: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      padding: "8px 16px",
      fontSize: e.typography.pxToRem(14),
      lineHeight: `${fj(16 / 14)}em`,
      fontWeight: e.typography.fontWeightRegular
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl,
    style: {
      [`.${jr.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "14px"
      },
      [`.${jr.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl && t.touch,
    style: {
      [`.${jr.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "24px"
      },
      [`.${jr.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl,
    style: {
      [`.${jr.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "14px"
      },
      [`.${jr.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl && t.touch,
    style: {
      [`.${jr.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "24px"
      },
      [`.${jr.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${jr.popper}[data-popper-placement*="top"] &`]: {
        marginBottom: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${jr.popper}[data-popper-placement*="bottom"] &`]: {
        marginTop: "24px"
      }
    }
  }]
}))), pj = Ke("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, t) => t.arrow
})(kt(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : ur(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
})));
let C0 = !1;
const h6 = new zc();
let za = {
  x: 0,
  y: 0
};
function I0(e, t) {
  return (o, ...i) => {
    t && t(o, ...i), e(o, ...i);
  };
}
const $n = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: c = !1,
    children: n,
    classes: d,
    components: f = {},
    componentsProps: p = {},
    describeChild: l = !1,
    disableFocusListener: h = !1,
    disableHoverListener: y = !1,
    disableInteractive: M = !1,
    disableTouchListener: C = !1,
    enterDelay: N = 100,
    enterNextDelay: w = 0,
    enterTouchDelay: S = 700,
    followCursor: T = !1,
    id: E,
    leaveDelay: j = 0,
    leaveTouchDelay: O = 1500,
    onClose: z,
    onOpen: k,
    open: H,
    placement: W = "bottom",
    PopperComponent: U,
    PopperProps: B = {},
    slotProps: I = {},
    slots: r = {},
    title: s,
    TransitionComponent: u,
    TransitionProps: g,
    ...v
  } = i, A = /* @__PURE__ */ ue.isValidElement(n) ? n : /* @__PURE__ */ D("span", {
    children: n
  }), L = or(), m = Ss(), [a, x] = ue.useState(), [V, G] = ue.useState(null), Z = ue.useRef(!1), te = M || T, q = uo(), R = uo(), Q = uo(), $ = uo(), [F, P] = X0({
    controlled: H,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let _ = F;
  if (fe.process.env.NODE_ENV !== "production") {
    const {
      current: Ct
    } = ue.useRef(H !== void 0);
    ue.useEffect(() => {
      a && a.disabled && !Ct && s !== "" && a.tagName.toLowerCase() === "button" && console.warn(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [s, a, Ct]);
  }
  const X = Ls(E), le = ue.useRef(), ie = _n(() => {
    le.current !== void 0 && (document.body.style.WebkitUserSelect = le.current, le.current = void 0), $.clear();
  });
  ue.useEffect(() => ie, [ie]);
  const oe = (Ct) => {
    h6.clear(), C0 = !0, P(!0), k && !_ && k(Ct);
  }, pe = _n(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (Ct) => {
      h6.start(800 + j, () => {
        C0 = !1;
      }), P(!1), z && _ && z(Ct), q.start(L.transitions.duration.shortest, () => {
        Z.current = !1;
      });
    }
  ), se = (Ct) => {
    Z.current && Ct.type !== "touchstart" || (a && a.removeAttribute("title"), R.clear(), Q.clear(), N || C0 && w ? R.start(C0 ? w : N, () => {
      oe(Ct);
    }) : oe(Ct));
  }, ce = (Ct) => {
    R.clear(), Q.start(j, () => {
      pe(Ct);
    });
  }, [, me] = ue.useState(!1), de = (Ct) => {
    ca(Ct.target) || (me(!1), ce(Ct));
  }, ae = (Ct) => {
    a || x(Ct.currentTarget), ca(Ct.target) && (me(!0), se(Ct));
  }, Le = (Ct) => {
    Z.current = !0;
    const Ue = A.props;
    Ue.onTouchStart && Ue.onTouchStart(Ct);
  }, ye = (Ct) => {
    Le(Ct), Q.clear(), q.clear(), ie(), le.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", $.start(S, () => {
      document.body.style.WebkitUserSelect = le.current, se(Ct);
    });
  }, Me = (Ct) => {
    A.props.onTouchEnd && A.props.onTouchEnd(Ct), ie(), Q.start(O, () => {
      pe(Ct);
    });
  };
  ue.useEffect(() => {
    if (!_)
      return;
    function Ct(Ue) {
      Ue.key === "Escape" && pe(Ue);
    }
    return document.addEventListener("keydown", Ct), () => {
      document.removeEventListener("keydown", Ct);
    };
  }, [pe, _]);
  const at = zr(zo(A), x, o);
  !s && s !== 0 && (_ = !1);
  const Ne = ue.useRef(), Ae = (Ct) => {
    const Ue = A.props;
    Ue.onMouseMove && Ue.onMouseMove(Ct), za = {
      x: Ct.clientX,
      y: Ct.clientY
    }, Ne.current && Ne.current.update();
  }, pt = {}, ke = typeof s == "string";
  l ? (pt.title = !_ && ke && !y ? s : null, pt["aria-describedby"] = _ ? X : null) : (pt["aria-label"] = ke ? s : null, pt["aria-labelledby"] = _ && !ke ? X : null);
  const Te = {
    ...pt,
    ...v,
    ...A.props,
    className: It(v.className, A.props.className),
    onTouchStart: Le,
    ref: at,
    ...T ? {
      onMouseMove: Ae
    } : {}
  };
  fe.process.env.NODE_ENV !== "production" && (Te["data-mui-internal-clone-element"] = !0, ue.useEffect(() => {
    a && !a.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [a]));
  const Dt = {};
  C || (Te.onTouchStart = ye, Te.onTouchEnd = Me), y || (Te.onMouseOver = I0(se, Te.onMouseOver), Te.onMouseLeave = I0(ce, Te.onMouseLeave), te || (Dt.onMouseOver = se, Dt.onMouseLeave = ce)), h || (Te.onFocus = I0(ae, Te.onFocus), Te.onBlur = I0(de, Te.onBlur), te || (Dt.onFocus = ae, Dt.onBlur = de)), fe.process.env.NODE_ENV !== "production" && A.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${A.props.title}\` or the Tooltip component.`].join(`
`));
  const De = {
    ...i,
    isRtl: m,
    arrow: c,
    disableInteractive: te,
    placement: W,
    PopperComponentProp: U,
    touch: Z.current
  }, je = typeof I.popper == "function" ? I.popper(De) : I.popper, At = ue.useMemo(() => {
    var Ue, Ze;
    let Ct = [{
      name: "arrow",
      enabled: !!V,
      options: {
        element: V,
        padding: 4
      }
    }];
    return (Ue = B.popperOptions) != null && Ue.modifiers && (Ct = Ct.concat(B.popperOptions.modifiers)), (Ze = je == null ? void 0 : je.popperOptions) != null && Ze.modifiers && (Ct = Ct.concat(je.popperOptions.modifiers)), {
      ...B.popperOptions,
      ...je == null ? void 0 : je.popperOptions,
      modifiers: Ct
    };
  }, [V, B.popperOptions, je == null ? void 0 : je.popperOptions]), xe = uj(De), Ie = typeof I.transition == "function" ? I.transition(De) : I.transition, Nt = {
    slots: {
      popper: f.Popper,
      transition: f.Transition ?? u,
      tooltip: f.Tooltip,
      arrow: f.Arrow,
      ...r
    },
    slotProps: {
      arrow: I.arrow ?? p.arrow,
      popper: {
        ...B,
        ...je ?? p.popper
      },
      // resolvedPopperProps can be spread because it's already an object
      tooltip: I.tooltip ?? p.tooltip,
      transition: {
        ...g,
        ...Ie ?? p.transition
      }
    }
  }, [_e, Be] = qt("popper", {
    elementType: dj,
    externalForwardedProps: Nt,
    ownerState: De,
    className: It(xe.popper, B == null ? void 0 : B.className)
  }), [Xt, Re] = qt("transition", {
    elementType: ys,
    externalForwardedProps: Nt,
    ownerState: De
  }), [Pe, dr] = qt("tooltip", {
    elementType: hj,
    className: xe.tooltip,
    externalForwardedProps: Nt,
    ownerState: De
  }), [We, He] = qt("arrow", {
    elementType: pj,
    className: xe.arrow,
    externalForwardedProps: Nt,
    ownerState: De,
    ref: G
  });
  return /* @__PURE__ */ ne(ue.Fragment, {
    children: [/* @__PURE__ */ ue.cloneElement(A, Te), /* @__PURE__ */ D(_e, {
      as: U ?? Yh,
      placement: W,
      anchorEl: T ? {
        getBoundingClientRect: () => ({
          top: za.y,
          left: za.x,
          right: za.x,
          bottom: za.y,
          width: 0,
          height: 0
        })
      } : a,
      popperRef: Ne,
      open: a ? _ : !1,
      id: X,
      transition: !0,
      ...Dt,
      ...Be,
      popperOptions: At,
      children: ({
        TransitionProps: Ct
      }) => /* @__PURE__ */ D(Xt, {
        timeout: L.transitions.duration.shorter,
        ...Ct,
        ...Re,
        children: /* @__PURE__ */ ne(Pe, {
          ...dr,
          children: [s, c ? /* @__PURE__ */ D(We, {
            ...He
          }) : null]
        })
      })
    })]
  });
});
fe.process.env.NODE_ENV !== "production" && ($n.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: b.bool,
  /**
   * Tooltip reference element.
   */
  children: Oo.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: b.shape({
    Arrow: b.elementType,
    Popper: b.elementType,
    Tooltip: b.elementType,
    Transition: b.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: b.shape({
    arrow: b.object,
    popper: b.object,
    tooltip: b.object,
    transition: b.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: b.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: b.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: b.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: b.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: b.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: b.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: b.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: b.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: b.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: b.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: b.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: b.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: b.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: b.func,
  /**
   * If `true`, the component is shown.
   */
  open: b.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: b.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @deprecated use the `slots.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: b.elementType,
  /**
   * Props applied to the [`Popper`](https://mui.com/material-ui/api/popper/) element.
   * @deprecated use the `slotProps.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  PopperProps: b.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: b.shape({
    arrow: b.oneOfType([b.func, b.object]),
    popper: b.oneOfType([b.func, b.object]),
    tooltip: b.oneOfType([b.func, b.object]),
    transition: b.oneOfType([b.func, b.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: b.shape({
    arrow: b.elementType,
    popper: b.elementType,
    tooltip: b.elementType,
    transition: b.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: b.node,
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: b.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: b.object
});
function gj(e) {
  return Bt("MuiTypography", e);
}
const p6 = Ft("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]), yj = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, Mj = Ub(), mj = (e) => {
  const {
    align: t,
    gutterBottom: o,
    noWrap: i,
    paragraph: c,
    variant: n,
    classes: d
  } = e, f = {
    root: ["root", n, e.align !== "inherit" && `align${it(t)}`, o && "gutterBottom", i && "noWrap", c && "paragraph"]
  };
  return Rt(f, gj, d);
}, vj = Ke("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.variant && t[o.variant], o.align !== "inherit" && t[`align${it(o.align)}`], o.noWrap && t.noWrap, o.gutterBottom && t.gutterBottom, o.paragraph && t.paragraph];
  }
})(kt(({
  theme: e
}) => {
  var t;
  return {
    margin: 0,
    variants: [{
      props: {
        variant: "inherit"
      },
      style: {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit",
        lineHeight: "inherit",
        letterSpacing: "inherit"
      }
    }, ...Object.entries(e.typography).filter(([o, i]) => o !== "inherit" && i && typeof i == "object").map(([o, i]) => ({
      props: {
        variant: o
      },
      style: i
    })), ...Object.entries(e.palette).filter(Gr()).map(([o]) => ({
      props: {
        color: o
      },
      style: {
        color: (e.vars || e).palette[o].main
      }
    })), ...Object.entries(((t = e.palette) == null ? void 0 : t.text) || {}).filter(([, o]) => typeof o == "string").map(([o]) => ({
      props: {
        color: `text${it(o)}`
      },
      style: {
        color: (e.vars || e).palette.text[o]
      }
    })), {
      props: ({
        ownerState: o
      }) => o.align !== "inherit",
      style: {
        textAlign: "var(--Typography-textAlign)"
      }
    }, {
      props: ({
        ownerState: o
      }) => o.noWrap,
      style: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, {
      props: ({
        ownerState: o
      }) => o.gutterBottom,
      style: {
        marginBottom: "0.35em"
      }
    }, {
      props: ({
        ownerState: o
      }) => o.paragraph,
      style: {
        marginBottom: 16
      }
    }]
  };
})), g6 = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, Fe = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const {
    color: i,
    ...c
  } = Pt({
    props: t,
    name: "MuiTypography"
  }), n = !yj[i], d = Mj({
    ...c,
    ...n && {
      color: i
    }
  }), {
    align: f = "inherit",
    className: p,
    component: l,
    gutterBottom: h = !1,
    noWrap: y = !1,
    paragraph: M = !1,
    variant: C = "body1",
    variantMapping: N = g6,
    ...w
  } = d, S = {
    ...d,
    align: f,
    color: i,
    className: p,
    component: l,
    gutterBottom: h,
    noWrap: y,
    paragraph: M,
    variant: C,
    variantMapping: N
  }, T = l || (M ? "p" : N[C] || g6[C]) || "span", E = mj(S);
  return /* @__PURE__ */ D(vj, {
    as: T,
    ref: o,
    className: It(E.root, p),
    ...w,
    ownerState: S,
    style: {
      ...f !== "inherit" && {
        "--Typography-textAlign": f
      },
      ...w.style
    }
  });
});
fe.process.env.NODE_ENV !== "production" && (Fe.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: b.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: b.oneOfType([b.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), b.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: b.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: b.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   * @deprecated Use the `component` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  paragraph: b.bool,
  /**
   * @ignore
   */
  style: b.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: b.oneOfType([b.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), b.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: b.object
});
const V8 = an(/* @__PURE__ */ D("path", {
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), "ContentCopy"), G8 = an(/* @__PURE__ */ D("path", {
  d: "M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"
}), "Done"), $8 = an(/* @__PURE__ */ D("path", {
  d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9m-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8z"
}), "History"), bj = an(/* @__PURE__ */ D("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "ErrorOutline");
function Gs(e) {
  const t = er(), o = Ce(
    () => ({
      container: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        gap: "8px"
      }
    }),
    []
  );
  let i;
  return e.color ? i = e.color : e.warning ? i = t.palette.warning.main : e.error && (i = t.palette.error.main), /* @__PURE__ */ D(
    hg,
    {
      className: e.className,
      sx: e.sx,
      in: e.show && !!e.content,
      unmountOnExit: !0,
      children: /* @__PURE__ */ ne(
        ut,
        {
          sx: o.container,
          style: e.style || {},
          "data-testid": e.testId,
          children: [
            /* @__PURE__ */ D(
              bj,
              {
                fontSize: "small",
                htmlColor: i,
                sx: { paddingTop: "2px" }
              }
            ),
            /* @__PURE__ */ D(ln, { color: i, fontSize: 14, children: e.content })
          ]
        }
      )
    }
  );
}
function xj(e) {
  return Bt("MuiButton", e);
}
const to = Ft("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge", "loading", "loadingWrapper", "loadingIconPlaceholder", "loadingIndicator", "loadingPositionCenter", "loadingPositionStart", "loadingPositionEnd"]), q8 = /* @__PURE__ */ ue.createContext({});
fe.process.env.NODE_ENV !== "production" && (q8.displayName = "ButtonGroupContext");
const J8 = /* @__PURE__ */ ue.createContext(void 0);
fe.process.env.NODE_ENV !== "production" && (J8.displayName = "ButtonGroupButtonContext");
const wj = (e) => {
  const {
    color: t,
    disableElevation: o,
    fullWidth: i,
    size: c,
    variant: n,
    loading: d,
    loadingPosition: f,
    classes: p
  } = e, l = {
    root: ["root", d && "loading", n, `${n}${it(t)}`, `size${it(c)}`, `${n}Size${it(c)}`, `color${it(t)}`, o && "disableElevation", i && "fullWidth", d && `loadingPosition${it(f)}`],
    startIcon: ["icon", "startIcon", `iconSize${it(c)}`],
    endIcon: ["icon", "endIcon", `iconSize${it(c)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  }, h = Rt(l, xj, p);
  return {
    ...p,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...h
  };
}, X8 = [{
  props: {
    size: "small"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 18
    }
  }
}, {
  props: {
    size: "medium"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 20
    }
  }
}, {
  props: {
    size: "large"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 22
    }
  }
}], Cj = Ke(ko, {
  shouldForwardProp: (e) => hn(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.variant], t[`${o.variant}${it(o.color)}`], t[`size${it(o.size)}`], t[`${o.variant}Size${it(o.size)}`], o.color === "inherit" && t.colorInherit, o.disableElevation && t.disableElevation, o.fullWidth && t.fullWidth, o.loading && t.loading];
  }
})(kt(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], o = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return {
    ...e.typography.button,
    minWidth: 64,
    padding: "6px 16px",
    border: 0,
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": {
      textDecoration: "none"
    },
    [`&.${to.disabled}`]: {
      color: (e.vars || e).palette.action.disabled
    },
    variants: [{
      props: {
        variant: "contained"
      },
      style: {
        color: "var(--variant-containedColor)",
        backgroundColor: "var(--variant-containedBg)",
        boxShadow: (e.vars || e).shadows[2],
        "&:hover": {
          boxShadow: (e.vars || e).shadows[4],
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            boxShadow: (e.vars || e).shadows[2]
          }
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[8]
        },
        [`&.${to.focusVisible}`]: {
          boxShadow: (e.vars || e).shadows[6]
        },
        [`&.${to.disabled}`]: {
          color: (e.vars || e).palette.action.disabled,
          boxShadow: (e.vars || e).shadows[0],
          backgroundColor: (e.vars || e).palette.action.disabledBackground
        }
      }
    }, {
      props: {
        variant: "outlined"
      },
      style: {
        padding: "5px 15px",
        border: "1px solid currentColor",
        borderColor: "var(--variant-outlinedBorder, currentColor)",
        backgroundColor: "var(--variant-outlinedBg)",
        color: "var(--variant-outlinedColor)",
        [`&.${to.disabled}`]: {
          border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
        }
      }
    }, {
      props: {
        variant: "text"
      },
      style: {
        padding: "6px 8px",
        color: "var(--variant-textColor)",
        backgroundColor: "var(--variant-textBg)"
      }
    }, ...Object.entries(e.palette).filter(Gr()).map(([i]) => ({
      props: {
        color: i
      },
      style: {
        "--variant-textColor": (e.vars || e).palette[i].main,
        "--variant-outlinedColor": (e.vars || e).palette[i].main,
        "--variant-outlinedBorder": e.vars ? `rgba(${e.vars.palette[i].mainChannel} / 0.5)` : ur(e.palette[i].main, 0.5),
        "--variant-containedColor": (e.vars || e).palette[i].contrastText,
        "--variant-containedBg": (e.vars || e).palette[i].main,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": (e.vars || e).palette[i].dark,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette[i].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : ur(e.palette[i].main, e.palette.action.hoverOpacity),
            "--variant-outlinedBorder": (e.vars || e).palette[i].main,
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette[i].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : ur(e.palette[i].main, e.palette.action.hoverOpacity)
          }
        }
      }
    })), {
      props: {
        color: "inherit"
      },
      style: {
        color: "inherit",
        borderColor: "currentColor",
        "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedBg : t,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedHoverBg : o,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : ur(e.palette.text.primary, e.palette.action.hoverOpacity),
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : ur(e.palette.text.primary, e.palette.action.hoverOpacity)
          }
        }
      }
    }, {
      props: {
        size: "small",
        variant: "text"
      },
      style: {
        padding: "4px 5px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "text"
      },
      style: {
        padding: "8px 11px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "outlined"
      },
      style: {
        padding: "3px 9px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "outlined"
      },
      style: {
        padding: "7px 21px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "contained"
      },
      style: {
        padding: "4px 10px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "contained"
      },
      style: {
        padding: "8px 22px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        disableElevation: !0
      },
      style: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none"
        },
        [`&.${to.focusVisible}`]: {
          boxShadow: "none"
        },
        "&:active": {
          boxShadow: "none"
        },
        [`&.${to.disabled}`]: {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        fullWidth: !0
      },
      style: {
        width: "100%"
      }
    }, {
      props: {
        loadingPosition: "center"
      },
      style: {
        transition: e.transitions.create(["background-color", "box-shadow", "border-color"], {
          duration: e.transitions.duration.short
        }),
        [`&.${to.loading}`]: {
          color: "transparent"
        }
      }
    }]
  };
})), Ij = Ke("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.startIcon, o.loading && t.startIconLoadingStart, t[`iconSize${it(o.size)}`]];
  }
})(({
  theme: e
}) => ({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginLeft: -2
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: !0
    },
    style: {
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: !0,
      fullWidth: !0
    },
    style: {
      marginRight: -8
    }
  }, ...X8]
})), Nj = Ke("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.endIcon, o.loading && t.endIconLoadingEnd, t[`iconSize${it(o.size)}`]];
  }
})(({
  theme: e
}) => ({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginRight: -2
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: !0
    },
    style: {
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: !0,
      fullWidth: !0
    },
    style: {
      marginLeft: -8
    }
  }, ...X8]
})), Aj = Ke("span", {
  name: "MuiButton",
  slot: "LoadingIndicator",
  overridesResolver: (e, t) => t.loadingIndicator
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }, {
    props: {
      loadingPosition: "start"
    },
    style: {
      left: 14
    }
  }, {
    props: {
      loadingPosition: "start",
      size: "small"
    },
    style: {
      left: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "start"
    },
    style: {
      left: 6
    }
  }, {
    props: {
      loadingPosition: "center"
    },
    style: {
      left: "50%",
      transform: "translate(-50%)",
      color: (e.vars || e).palette.action.disabled
    }
  }, {
    props: {
      loadingPosition: "end"
    },
    style: {
      right: 14
    }
  }, {
    props: {
      loadingPosition: "end",
      size: "small"
    },
    style: {
      right: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "end"
    },
    style: {
      right: 6
    }
  }, {
    props: {
      loadingPosition: "start",
      fullWidth: !0
    },
    style: {
      position: "relative",
      left: -10
    }
  }, {
    props: {
      loadingPosition: "end",
      fullWidth: !0
    },
    style: {
      position: "relative",
      right: -10
    }
  }]
})), y6 = Ke("span", {
  name: "MuiButton",
  slot: "LoadingIconPlaceholder",
  overridesResolver: (e, t) => t.loadingIconPlaceholder
})({
  display: "inline-block",
  width: "1em",
  height: "1em"
}), Oi = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = ue.useContext(q8), c = ue.useContext(J8), n = cs(i, t), d = Pt({
    props: n,
    name: "MuiButton"
  }), {
    children: f,
    color: p = "primary",
    component: l = "button",
    className: h,
    disabled: y = !1,
    disableElevation: M = !1,
    disableFocusRipple: C = !1,
    endIcon: N,
    focusVisibleClassName: w,
    fullWidth: S = !1,
    id: T,
    loading: E = null,
    loadingIndicator: j,
    loadingPosition: O = "center",
    size: z = "medium",
    startIcon: k,
    type: H,
    variant: W = "text",
    ...U
  } = d, B = Ls(T), I = j ?? /* @__PURE__ */ D(Or, {
    "aria-labelledby": B,
    color: "inherit",
    size: 16
  }), r = {
    ...d,
    color: p,
    component: l,
    disabled: y,
    disableElevation: M,
    disableFocusRipple: C,
    fullWidth: S,
    loading: E,
    loadingIndicator: I,
    loadingPosition: O,
    size: z,
    type: H,
    variant: W
  }, s = wj(r), u = (k || E && O === "start") && /* @__PURE__ */ D(Ij, {
    className: s.startIcon,
    ownerState: r,
    children: k || /* @__PURE__ */ D(y6, {
      className: s.loadingIconPlaceholder,
      ownerState: r
    })
  }), g = (N || E && O === "end") && /* @__PURE__ */ D(Nj, {
    className: s.endIcon,
    ownerState: r,
    children: N || /* @__PURE__ */ D(y6, {
      className: s.loadingIconPlaceholder,
      ownerState: r
    })
  }), v = c || "", A = typeof E == "boolean" ? (
    // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ D("span", {
      className: s.loadingWrapper,
      style: {
        display: "contents"
      },
      children: E && /* @__PURE__ */ D(Aj, {
        className: s.loadingIndicator,
        ownerState: r,
        children: I
      })
    })
  ) : null;
  return /* @__PURE__ */ ne(Cj, {
    ownerState: r,
    className: It(i.className, s.root, h, v),
    component: l,
    disabled: y || E,
    focusRipple: !C,
    focusVisibleClassName: It(s.focusVisible, w),
    ref: o,
    type: H,
    id: E ? B : T,
    ...U,
    classes: s,
    children: [u, O !== "end" && A, f, O === "end" && A, g]
  });
});
fe.process.env.NODE_ENV !== "production" && (Oi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: b.oneOfType([b.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), b.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: b.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: b.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: b.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: b.bool,
  /**
   * Element placed after the children.
   */
  endIcon: b.node,
  /**
   * @ignore
   */
  focusVisibleClassName: b.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: b.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: b.string,
  /**
   * @ignore
   */
  id: b.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: b.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: b.node,
  /**
   * The loading indicator can be positioned on the start, end, or the center of the button.
   * @default 'center'
   */
  loadingPosition: b.oneOf(["center", "end", "start"]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: b.oneOfType([b.oneOf(["small", "medium", "large"]), b.string]),
  /**
   * Element placed before the children.
   */
  startIcon: b.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * @ignore
   */
  type: b.oneOfType([b.oneOf(["button", "reset", "submit"]), b.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: b.oneOfType([b.oneOf(["contained", "outlined", "text"]), b.string])
});
const M6 = {
  padding: "8px 16px",
  borderRadius: "8px",
  height: "48px",
  margin: "auto",
  maxWidth: "420px",
  width: "100%",
  boxShadow: "none"
}, so = c9((e, t) => {
  const { variant: o, sx: i, ...c } = e;
  return o === "primary" ? /* @__PURE__ */ D(
    Oi,
    {
      ref: t,
      variant: "contained",
      ...c,
      sx: {
        ...M6,
        backgroundColor: "button.primary",
        color: "button.primaryText",
        "&.Mui-disabled": {
          backgroundColor: "button.disabled",
          color: "button.disabledText"
        },
        "&:hover": {
          boxShadow: "none",
          backgroundColor: "button.hover",
          "&:disabled": {
            backgroundColor: "button.disabled",
            color: "button.disabledText"
          }
        },
        "&:active": {
          boxShadow: "none",
          backgroundColor: "button.action",
          color: "button.actionText"
        },
        ...i
      }
    }
  ) : o === "error" ? /* @__PURE__ */ D(
    Oi,
    {
      ref: t,
      variant: "contained",
      ...c,
      sx: {
        ...M6,
        backgroundColor: "error.main",
        color: "error.contrastText",
        "&:disabled": {
          backgroundColor: "error.main",
          color: "error.contrastText",
          opacity: 0.4
        },
        ...i
      }
    }
  ) : /* @__PURE__ */ D(Oi, { ref: t, sx: i, ...c });
});
function sl(e, t, o) {
  var i = this, c = _r(null), n = _r(0), d = _r(null), f = _r([]), p = _r(), l = _r(), h = _r(e), y = _r(!0);
  St(function() {
    h.current = e;
  }, [e]);
  var M = !t && t !== 0 && typeof window < "u";
  if (typeof e != "function") throw new TypeError("Expected a function");
  t = +t || 0;
  var C = !!(o = o || {}).leading, N = !("trailing" in o) || !!o.trailing, w = "maxWait" in o, S = w ? Math.max(+o.maxWait || 0, t) : null;
  St(function() {
    return y.current = !0, function() {
      y.current = !1;
    };
  }, []);
  var T = Ce(function() {
    var E = function(W) {
      var U = f.current, B = p.current;
      return f.current = p.current = null, n.current = W, l.current = h.current.apply(B, U);
    }, j = function(W, U) {
      M && cancelAnimationFrame(d.current), d.current = M ? requestAnimationFrame(W) : setTimeout(W, U);
    }, O = function(W) {
      if (!y.current) return !1;
      var U = W - c.current;
      return !c.current || U >= t || U < 0 || w && W - n.current >= S;
    }, z = function(W) {
      return d.current = null, N && f.current ? E(W) : (f.current = p.current = null, l.current);
    }, k = function W() {
      var U = Date.now();
      if (O(U)) return z(U);
      if (y.current) {
        var B = t - (U - c.current), I = w ? Math.min(B, S - (U - n.current)) : B;
        j(W, I);
      }
    }, H = function() {
      var W = Date.now(), U = O(W);
      if (f.current = [].slice.call(arguments), p.current = i, c.current = W, U) {
        if (!d.current && y.current) return n.current = c.current, j(k, t), C ? E(c.current) : l.current;
        if (w) return j(k, t), E(c.current);
      }
      return d.current || j(k, t), l.current;
    };
    return H.cancel = function() {
      d.current && (M ? cancelAnimationFrame(d.current) : clearTimeout(d.current)), n.current = 0, f.current = c.current = p.current = d.current = null;
    }, H.isPending = function() {
      return !!d.current;
    }, H.flush = function() {
      return d.current ? z(Date.now()) : l.current;
    }, H;
  }, [C, w, t, S, N, M]);
  return T;
}
function Tj(e, t) {
  return e === t;
}
function m6(e) {
  return typeof e == "function" ? function() {
    return e;
  } : e;
}
function Lj(e, t, o) {
  var i, c, n = Tj, d = (i = Xe(m6(e)), c = i[1], [i[0], ht(function(y) {
    return c(m6(y));
  }, [])]), f = d[0], p = d[1], l = sl(ht(function(y) {
    return p(y);
  }, [p]), t, o), h = _r(e);
  return n(h.current, e) || (l(e), h.current = e), [f, l];
}
const K8 = l9(
  void 0
), Sj = ({ children: e }) => {
  const [t, o] = Xe(!1), [i, c] = Xe(
    ge.tokens.lastUpdate
  ), [n, d] = Xe({
    prices: new Ys(),
    isFetching: !1,
    lastUpdate: /* @__PURE__ */ new Date()
  }), f = _r(/* @__PURE__ */ new Set()), p = _r(/* @__PURE__ */ new Set()), l = ht(
    async (w) => {
      if (!Wi(w.address) && Vr(w.chain) === "Evm") {
        const T = w.address.toString(), E = ug(T);
        T !== E && (console.warn(
          `Correcting improperly checksummed EVM address: ${T} -> ${E}`
        ), w.address = ki(w.chain, E));
      }
      const S = ge.tokens.get(w);
      if (S) return S;
      try {
        o(!0);
        const T = await ge.tokens.addFromTokenId(w);
        return c(ge.tokens.lastUpdate), console.info(
          "Added new token to cache",
          T,
          i,
          ge.tokens.lastUpdate
        ), ge.tokens.persist(), $L(), T;
      } catch (T) {
        console.error("Error getting token", T);
        return;
      } finally {
        o(!1);
      }
    },
    [i]
  ), h = ht(
    (w) => {
      const S = Co.get(ge.network, w.chain);
      if (S && w.addressString === S)
        return { price: 1, needsFetch: !1 };
      const T = w.tokenBridgeOriginalTokenId ?? w, E = n.prices.get(T);
      return E ? { price: E.price, needsFetch: !1 } : { price: void 0, needsFetch: !0 };
    },
    [n.prices]
  ), y = ht(
    (w, S, T, E) => {
      for (const j of w) {
        const O = S.get(j);
        if (!(O != null && O.price) && lc(j)) {
          const z = H5(j);
          for (const k of z) {
            let H = T == null ? void 0 : T.get(k);
            if (!H) {
              const W = S.get(k);
              H = W == null ? void 0 : W.price;
            }
            if (H !== void 0) {
              S.add(j, {
                timestamp: E,
                price: H
              });
              break;
            }
          }
        }
      }
    },
    []
  ), M = sl(async () => {
    if (f.current.size === 0) return;
    const w = [];
    for (const S of f.current) {
      const T = ge.tokens.get(S);
      T && (w.push(T), p.current.add(S));
    }
    if (f.current.clear(), w.length !== 0)
      try {
        console.info("Fetching prices for", w.length, "tokens");
        const S = /* @__PURE__ */ new Date();
        d((E) => ({ ...E, isFetching: !0 }));
        const T = await VT(w);
        d((E) => {
          const j = E.prices.clone();
          for (const O of w) {
            const z = O.tokenBridgeOriginalTokenId ?? O, k = T.get(z);
            j.add(z, {
              timestamp: S,
              price: k ?? void 0
            }), p.current.delete(Bn(z));
          }
          return y(w, j, T, S), {
            prices: j,
            isFetching: !1,
            lastUpdate: /* @__PURE__ */ new Date()
          };
        });
      } catch (S) {
        console.error("Error fetching token prices:", S);
        const T = /* @__PURE__ */ new Date();
        d((E) => {
          const j = E.prices.clone();
          for (const O of w) {
            const z = O.tokenBridgeOriginalTokenId ?? O;
            j.add(z, {
              timestamp: T,
              price: void 0
            }), p.current.delete(Bn(z));
          }
          return y(w, j, void 0, T), {
            prices: j,
            isFetching: !1,
            lastUpdate: /* @__PURE__ */ new Date()
          };
        });
      }
  }, 250), C = ht(
    (w) => {
      const S = /* @__PURE__ */ new Map();
      for (const T of w) {
        const { price: E, needsFetch: j } = h(T);
        if (S.set(T.key, E), j) {
          const O = T.tokenBridgeOriginalTokenId ?? T, z = Bn(O);
          !p.current.has(z) && !f.current.has(z) && f.current.add(z);
        }
      }
      return f.current.size > 0 && M(), S;
    },
    [h, M]
  ), N = ht(
    (w) => {
      let T = C([w]).get(w.key);
      if (T === void 0 && lc(w)) {
        const E = H5(w);
        if (E.length > 0) {
          const j = C(E);
          for (const O of E) {
            const z = j.get(O.key);
            if (z !== void 0) {
              T = z;
              break;
            }
          }
        }
      }
      return T;
    },
    [C]
  );
  return /* @__PURE__ */ D(
    K8.Provider,
    {
      value: {
        lastTokenCacheUpdate: i,
        getOrFetchToken: l,
        isFetchingToken: t,
        getTokenPrice: N,
        getTokenPrices: C,
        isFetchingTokenPrices: n.isFetching,
        lastTokenPriceUpdate: n.lastUpdate
      },
      children: e
    }
  );
}, Hr = () => {
  const e = wa(K8);
  if (e === void 0)
    throw new Error("useToken must be used within a TokensProvider");
  return e;
}, em = (e) => {
  const { sourceChain: t, destChain: o, sourceToken: i } = e, c = Cr(), [n, d] = Xe([]), [f, p] = Xe(!1), { getOrFetchToken: l, lastTokenCacheUpdate: h } = Hr();
  return St(() => {
    if (!o)
      return;
    let y = !0;
    return (async () => {
      let C = [];
      if (d([]), !t && o)
        C = ge.tokens.getAllForChain(o);
      else if (t && o) {
        let N = [];
        p(!0);
        try {
          N = await ge.routes.allSupportedDestTokens(
            i,
            t,
            o
          );
        } catch (w) {
          console.error(w);
        }
        await Promise.all(
          N.map(async (w) => {
            const S = await l(w);
            S && C.push(S);
          })
        ), p(!1);
      } else
        return;
      y && (d(C), o && C.length === 1 && c(Eh(C[0].tuple)));
    })(), () => {
      y = !1;
    };
  }, [
    i,
    t,
    o,
    c,
    h,
    l
  ]), {
    supportedDestTokens: n,
    isFetching: f
  };
}, Ej = {
  SHUTTLE: 1e4
}, Dj = (e, t) => {
  const [o, i] = Xe((/* @__PURE__ */ new Date()).valueOf()), c = _r(
    void 0
  ), [n, d] = Xe(!1), [f, p] = Xe({}), [l, h] = Xe(!0);
  St(() => {
    const N = () => {
      h(!document.hidden);
    };
    return document.addEventListener("visibilitychange", N), () => {
      document.removeEventListener("visibilitychange", N);
    };
  }, []);
  const { getTokenPrice: y } = Hr(), { isTransactionInProgress: M } = Ut(
    (N) => N.transferInput
  );
  return St(() => {
    if (e.length === 0) return;
    let N = 0;
    if (Object.keys(f).length > 0) {
      const w = t;
      if (!w.amount || !w.sourceToken || !w.destToken || !w.sourceChain || !w.destChain)
        return;
      const S = ge.routes.quoteCache.nextExpiry(e, w);
      if (!S)
        return;
      N = S.valueOf() - Date.now() - 5e3;
    }
    if (N)
      return c && clearTimeout(c.current), console.debug(
        `Waiting ${N / 1e3}s until next quote fetch`,
        e,
        t
      ), c.current = setTimeout(
        () => i(Date.now()),
        N
      ), () => {
        c && clearTimeout(c.current);
      };
  }, [f, e, t]), St(() => {
    let N = !1;
    const w = () => {
      N = !0;
    };
    if (e.length === 0 || !t.sourceChain || !t.sourceToken || !t.destChain || !t.destToken || !t.amount)
      return p({}), d(!1), w;
    if (M || !l)
      return w;
    const S = t, T = Object.values(f).filter(
      (E) => E.success
    );
    if (T.length > 0) {
      const { sourceToken: E, destinationToken: j } = T[0];
      (!Pd(E.token, S.sourceToken) || !Pd(j.token, S.destToken)) && p({});
    }
    return Object.keys(f).length === 0 && e.length !== 0 && d(!0), ge.routes.getQuotes(e, S).then((E) => {
      N || (p(E), d(!1));
    }), w;
  }, [
    e,
    o,
    t.amount,
    t.nativeGas,
    t.recipient,
    l
  ]), {
    quotes: Ce(() => {
      var S;
      const N = ri(
        y,
        t.amount,
        t.sourceToken
      );
      let w = Object.assign({}, f);
      for (const T in w) {
        const E = w[T];
        if (E !== void 0 && E.success) {
          const j = ri(
            y,
            E.destinationToken.amount,
            t.destToken
          );
          if (N !== void 0 && j !== void 0) {
            const O = j / N;
            N >= 1e3 && O <= 0.9 && (console.debug(
              `Filtering out ${T} quote with valueRatio=${O} USD delta=${N - j}`
            ), delete w[T]);
          } else if (t.amount && t.sourceToken && t.destToken && t.sourceToken.symbol === t.destToken.symbol) {
            const O = parseFloat(cr(E.destinationToken.amount)) / parseFloat(cr(t.amount));
            O <= 0.9 && (console.debug(
              `Filtering out ${T} quote with valueRatio=${O} (for same-symbol tokens)`
            ), delete w[T]);
          }
        }
      }
      for (const T in w)
        if (T.startsWith("MayanSwap")) {
          const E = w[T];
          if (E !== void 0 && E.success) {
            const j = Ej[(S = E.details) == null ? void 0 : S.type.toUpperCase()];
            if (j && N !== void 0 && N > j)
              delete w[T], console.warn(
                `Filtering out ${T} quote which exceeds $${j} USD`
              );
            else {
              const O = ri(
                y,
                t.amount,
                t.sourceToken
              ), z = ri(
                y,
                E.destinationToken.amount,
                t.destToken
              );
              if (O && z) {
                const k = O - z;
                !isNaN(k) && k > 0 && (w[T].relayFee = {
                  token: {
                    chain: "Solana",
                    address: un.parseAddress(
                      "Solana",
                      Co.get("Mainnet", "Solana")
                    )
                  },
                  amount: W1(
                    b9(k, 6),
                    6
                  )
                });
              }
            }
          }
        }
      if (ge.ui.onlyOfferManualRoutesAsFallback) {
        let T = !1;
        const E = {};
        for (const j in w) {
          const O = w[j];
          ge.routes.get(j).AUTOMATIC_DEPOSIT && (T = !0, E[j] = O);
        }
        T && (w = E);
      }
      if (typeof ge.filterRoutes == "function") {
        const T = Object.entries(w).filter(([E, j]) => j.success).map(([E, j]) => E);
        try {
          const E = ge.filterRoutes([...T]);
          if (Array.isArray(E) && E.every(
            (j) => typeof j == "string" && T.includes(j)
          ))
            for (const j in w)
              E.includes(j) || delete w[j];
          else
            console.warn(
              "config.filterRoutes returned one or more invalid route names",
              E,
              "Falling back to all supported routes",
              T
            );
        } catch (E) {
          console.warn(
            "Error when filtering routes",
            E,
            "Falling back to all supported routes",
            T
          );
        }
      }
      return w;
    }, [f]),
    isFetchingInitialQuotes: n
  };
};
function va(e) {
  return {
    symbol: e.symbol,
    tokenId: {
      chain: e.chain,
      address: e.address.toString()
    }
  };
}
function tm(e, t, o, i, c, n, d) {
  return {
    route: e,
    fromToken: va(t),
    toToken: va(o),
    fromChain: i,
    toChain: c,
    amount: n,
    USDAmount: d({ token: t, amount: n })
  };
}
const jj = ({
  fromChain: e,
  toChain: t,
  sourceToken: o,
  destToken: i,
  toNativeToken: c,
  receivingWallet: n
}) => {
  const [d, f] = Xe([]), [p, l] = Xe(!1);
  return St(() => {
    if (!e || !t || !o || !i) {
      f([]), l(!1);
      return;
    }
    let h = !0;
    return (async () => {
      l(!0);
      let M = [];
      await ge.routes.forEach(async (C, N) => {
        if (!N.AUTOMATIC_DEPOSIT && (n == null ? void 0 : n.name) === Lo.NAME)
          return;
        let w = !1;
        try {
          w = await N.isRouteSupported(
            o,
            i,
            e,
            t
          ), w && ge.isRouteSupportedHandler && (w = await ge.isRouteSupportedHandler({
            route: C,
            fromChain: e,
            toChain: t,
            fromToken: va(o),
            toToken: va(i)
          }));
        } catch (S) {
          KM(
            S,
            `Error when checking route (${C}) is supported`
          );
        }
        N.rc.name.includes("Mayan") && N.rc.name !== "MayanRouteSHUTTLE" && (w = !0), w && M.push(C);
      }), M.includes("ManualTBTC") && (M = M.filter(
        (C) => ![
          "ManualTokenBridge",
          "AutomaticTokenBridge",
          "TokenBridgeExecutorRoute"
        ].includes(C)
      )), h && (l(!1), f(M));
    })(), () => {
      h = !1;
    };
  }, [
    o,
    i,
    e,
    t,
    c,
    n
  ]), {
    supportedRoutes: d,
    isFetching: p
  };
}, rm = ({
  amount: e,
  fromChain: t,
  toChain: o,
  preferredRouteName: i,
  toNativeToken: c,
  sourceToken: n,
  destToken: d,
  receivingWallet: f
}) => {
  const { supportedRoutes: p, isFetching: l } = jj({
    fromChain: t,
    toChain: o,
    sourceToken: n,
    destToken: d,
    toNativeToken: c,
    receivingWallet: f
  }), h = Ce(
    () => ({
      amount: e,
      sourceChain: t,
      sourceToken: n,
      destChain: o,
      destToken: d,
      nativeGas: c,
      recipient: f == null ? void 0 : f.address
    }),
    [
      e,
      t,
      n,
      d,
      o,
      c,
      f == null ? void 0 : f.address
    ]
  ), { quotes: y, isFetchingInitialQuotes: M } = Dj(
    p,
    h
  ), C = Ce(() => p.map((S) => {
    const T = y[S];
    if (T != null && T.success)
      return {
        route: S,
        quote: T
      };
  }).filter(Boolean), [p, y]), N = Ce(() => Oj(C).map((S) => S.sort((T, E) => {
    const j = ge.routes.get(T.route), O = ge.routes.get(E.route);
    if (i) {
      if (T.route === i)
        return -1;
      if (E.route === i)
        return 1;
    }
    if (j.AUTOMATIC_DEPOSIT && !O.AUTOMATIC_DEPOSIT)
      return -1;
    if (!j.AUTOMATIC_DEPOSIT && O.AUTOMATIC_DEPOSIT)
      return 1;
    const z = BigInt(
      T.quote.destinationToken.amount.amount
    ), k = BigInt(
      E.quote.destinationToken.amount.amount
    );
    return Number(k - z);
  })).flat(), [i, C]), w = Ce(
    () => N.map((S) => S.route),
    [N]
  );
  return Ce(
    () => ({
      allSupportedRoutes: p,
      sortedRoutes: w,
      sortedRoutesWithQuotes: N,
      quotes: y,
      isFetching: l || M
    }),
    [
      p,
      w,
      N,
      y,
      l,
      M
    ]
  );
}, Oj = (e) => {
  const t = [6e4, 1 / 0], o = [];
  for (let i = 0; i < t.length; i++)
    o.push([]);
  for (const i of e) {
    const { quote: c } = i;
    for (let n = 0; n < t.length; n++) {
      const d = t[n];
      if ((c.eta ?? 1 / 0) <= d) {
        o[n].push(i);
        break;
      }
    }
  }
  return o;
}, nm = (e) => {
  const { amount: t } = Ut((c) => c.transferInput), o = Ce(
    () => Object.values(e.quotes).reduce((c, n) => {
      if (n != null && n.success || !kS(n == null ? void 0 : n.error))
        return c;
      if (!c)
        return n.error.min;
      const d = BigInt(n.error.min.amount), f = BigInt(c.amount);
      return d < f ? n.error.min : c;
    }, void 0),
    [e.quotes]
  ), i = Ce(() => Object.keys(e.quotes).length === 0 ? !1 : e.routes.every((c) => {
    var n;
    return ((n = e.quotes[c]) == null ? void 0 : n.success) === !1;
  }), [e.routes, e.quotes]);
  return !t || e.disabled ? {} : e.balance && ai(t) > ai(e.balance) ? {
    error: "Amount exceeds available balance."
  } : i ? o ? {
    error: `Amount too small (min ~${cr(o)} ${e.tokenSymbol})`
  } : {
    error: "No routes found for this transaction amount."
  } : o ? {
    warning: `More routes available for ${cr(o)} ${e.tokenSymbol} or more.`
  } : {};
}, im = () => {
  const { getTokenPrice: e, lastTokenPriceUpdate: t } = Hr();
  return ht(
    ({ token: o, amount: i }) => {
      const c = oi(i);
      if (!o) return;
      const d = Number(e(o)) * c;
      return isNaN(d) ? void 0 : parseFloat(d.toFixed(2));
    },
    // ES Lint complains that lastTokenPriceUpdate is unused/unnecessary here... but that's wrong.
    // We want to recompute the price after we update conversion rates.
    //
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, e]
  );
}, _o = () => {
  const { token: e, destToken: t } = Ut(
    (c) => c.transferInput
  ), o = Ce(
    () => e ? ge.tokens.get(e) : void 0,
    [e]
  ), i = Ce(
    () => t ? ge.tokens.get(t) : void 0,
    [t]
  );
  return { sourceToken: o, destToken: i };
}, zj = () => {
  const { txData: e } = Ut((i) => i.redeem), t = Ce(
    () => e != null && e.token ? ge.tokens.get(e == null ? void 0 : e.token) : void 0,
    [e]
  ), o = Ce(
    () => e != null && e.receivedToken ? ge.tokens.get(e == null ? void 0 : e.receivedToken) : void 0,
    [e]
  );
  return { sourceToken: t, destToken: o };
};
function kj(e, t, o) {
  return cr(
    {
      amount: e.toString(),
      decimals: t
    },
    o
  );
}
function _j(e, t) {
  if (typeof e != "string")
    throw new Error("Invalid argument");
  return e === "0.0" ? "0" : e.includes(".") ? parseFloat(e).toFixed(t) : e;
}
const Gn = "transactions:inprogress", Bj = 3, Wh = (e, t) => typeof t == "bigint" ? t.toString() : t, N0 = (e, t) => {
  if (s8(e))
    return !1;
  for (const o in t)
    if (e[o] === null || // Line below is an explicit check for undefined values as well
    typeof e[o] !== t[o])
      return !1;
  return !0;
}, Fj = (e) => !(!N0(e, {
  receipt: "object",
  route: "string",
  timestamp: "number",
  txDetails: "object",
  txHash: "string"
}) || !N0(e.txDetails, {
  amount: "object",
  eta: "number",
  fromChain: "string",
  toChain: "string",
  token: "object"
}) || !N0(e.txDetails.amount, {
  amount: "string",
  decimals: "number"
}) || !N0(e.txDetails.token, {
  0: "string",
  1: "string"
})), Rj = (e) => {
  if (!Array.isArray(e))
    return !1;
  for (const t of e)
    if (!Fj(t))
      return !1;
  return !0;
}, $s = () => {
  const e = window.localStorage;
  for (let t = 0; t < e.length; t++) {
    const o = e.key(t);
    if ((o == null ? void 0 : o.toLowerCase()) === ge.cacheKey(Gn).toLowerCase()) {
      const i = e.getItem(o);
      if (i)
        try {
          const c = JSON.parse(i);
          if (Rj(c))
            return c;
          console.log(
            `Error while parsing localStorage item ${Gn}: Not an array of valid transactions`
          ), e.removeItem(ge.cacheKey(Gn));
          return;
        } catch (c) {
          console.log(
            `Error while parsing localStorage item ${Gn}: ${c}`
          ), e.removeItem(ge.cacheKey(Gn));
          return;
        }
    }
  }
}, Pj = (e) => {
  const t = window.localStorage, o = $s();
  let i;
  o ? o.length < Bj ? i = o.concat([e]) : (o.splice(0, 1), i = o.concat([e])) : i = [e];
  try {
    t.setItem(
      ge.cacheKey(Gn),
      JSON.stringify(i, Wh)
    );
  } catch (c) {
    console.log(
      `Error while adding item to localStorage ${Gn}: ${c}`
    );
  }
}, Hh = (e) => {
  const t = window.localStorage, o = $s();
  if (o && o.length > 0) {
    const i = o.findIndex((c) => c.txHash === e);
    if (i > -1) {
      o.splice(i, 1);
      try {
        t.setItem(
          ge.cacheKey(Gn),
          JSON.stringify(o, Wh)
        );
      } catch (c) {
        console.log(
          `Error while removing item from localStorage ${Gn}: ${c}`
        );
      }
    }
  }
}, Uj = (e, t, o) => {
  const i = window.localStorage, c = $s();
  if (c && c.length > 0) {
    const n = c.findIndex((d) => d.txHash === e);
    if (n > -1) {
      c[n][t] = o;
      try {
        i.setItem(
          ge.cacheKey(Gn),
          JSON.stringify(c, Wh)
        );
      } catch (d) {
        console.log(
          `Error while updating item in localStorage ${Gn}: ${d}`
        );
      }
    }
  }
}, Mc = Object.freeze(
  /* @__PURE__ */ new Set([
    "3",
    "1Gq",
    "1N6XqS",
    "1B64QRxf",
    "1B11Ezqg3AXj",
    "bc1qtnr3t28l",
    "3F6bbvS1krsc1qR8FsbTDfYQyvkMm",
    "125W5ek3DT6Zqy5S2iPt4FHQdNMCbZA3FU",
    "1295rkVyNfFpqZpXvKGhDqwhP1jZcNNDMV",
    "129zKFLoVad9JtxSmDKeJoLCsjhGR7b3vr",
    "12HQDsicffSBaYdJ6BhnE22sfjTESmmzKx",
    "12NpCkhddSNiDkD9rRYUCHsTT9ReMNiJjG",
    "12QtD5BFwRsdNsAZY76UVE1xyCGNTojH9h",
    "12udabs2TkX7NXCSj6KpqXfakjE52ZPLhz",
    "12w6v1qAaBc4W8h8C2Cu5SKFaKDSv3erUW",
    "12YCfVAEzkEZXBYhUTyJJaRkgMXiFxJgcu",
    "12YyR9EpvHxBjjKjTWqfKqeyoWnvcraxpW",
    "134r8iHv69xdT6p5qVKTsHrcUEuBVZAYak",
    "13f59kUM5FU8MfTG7DCEugYarDhSD7XCoC",
    "13fhnkmpBBWXUQucJd6efWvXdEj78DKavk",
    "13JtX4h7G5ZuNK5mFudKGq9DHLvvMFuNuz",
    "13mnk8SvDGqsQTHbiGiHBXqtaQCUKfcsnP",
    "13RH4JaFhaCxDGPyYE9emjp2aDxdX18uBA",
    "13YBQr2Cp1YY3xqq2qngaPb7ca1o4ugeq6",
    "149w62rY42aZBox8fGcmqNsXUzSStKeq8C",
    "14gM1HuLVDELNHaFU22qpabjtiWek4HhV1",
    "14kqryJUxM3a7aEi117KX9hoLUw592WsMR",
    "14rjAD8ZP5xaL571cMRE98qgxxbg1S8mAN",
    "158treVZBGMBThoaympxccPdZPtqUfYrT9",
    "15cRqR3TXS1JehBGWERuxFE8NhWZzfoeeU",
    "15kZobLkD6HZgEECtz4oS2Vz21XHTnNfSg",
    "15Pt4NwZaUmMUwS2bQbyyncc7mzgWShtv8",
    "15qyVrZvvVGvB7GWiAZ82TNcZ6QWMKu3kx",
    "15uqdxqNXQwVf5H7yZPz4TmEGeSccCwdor",
    "15YK647qtoZQDzNrvY6HJL6QwXduLHfT28",
    "15yqWQ4sqr7jzCwDtZ3U1KaCa8WMEy7Mm2",
    "16PhXY3hNNMTo8kpuJx2emh713KbWpkqci",
    "17a5bpKvEp1j1Trs4qTbcNZrby53JbaS9C",
    "17ezuJoT3XBbdcwFZbkTnrXbup11F4uhiy",
    "17mhyeBX617ABZ1ffThhUTJkHUcMvCkfd5",
    "17UVSMegvrzfobKC82dHXpZLtLcqzW9stF",
    "17V7THwHMiDJmDwZK4unhE5HgKFJKx7VCe",
    "182NGZbPJXwg2WDrhrPpR7tpiGQkNPF844",
    "18gaXypKj9M23S2zT9qZfL9iPbLFM372Q5",
    "18Qj1THHuETfYhuRDZycXJbWwDMGw73Poa",
    "18uKfaUjgG52rVeXEi3wxnveww7zZuECtE",
    "18yWCu6agTxYqAerMxiz9sgHrK3ViezzGa",
    "1986rYHckYbJpGQJy6ornuMyD2N5MTqwDt",
    "19D1iGzDr7FyAdiy3ZZdxMd6ttHj1kj6WW",
    "19D8PHBjZH29uS1uPZ4m3sVyqqfF8UFG9o",
    "19GrL5jnUkGmHXVcraB1Etv5rXCANeLWpq",
    "1A7SKE2dQtezLktCY8peLsdAtkqxV9r1dC",
    "1AeSq93WDNdLoEJ92sex7T8xQZoYYm8BtS",
    "1AjZPMsnmpdK2Rv9KQNfMurTXinscVro9V",
    "1AoxtfiBQ22DvbhqAN9Ctb8sULMRhrdwTr",
    "1AXUTu9y3H8w4wYx4BjyFWgRhZKDhmcMrn",
    "1BiUFjzH6wsT73U3tfy4aXHCQsYQHzjk5h",
    "1CF46Rfbp97absrs7zb7dFfZS6qBXUm9EP",
    "1CPJak9ZyddbawMGJPyEhCiJLXXb4sYv8N",
    "1D6gG9iKEhPitTcWRJiniuj1jYM2hNeAfJ",
    "1DbShx4r8i2XesthoDBf5EkYWz5dsKEusV",
    "1DbvK8P6imBuLcwh2Vruis4xsUb8YAwJQF",
    "1DDA93oZPn7wte2eR1ABwcFoxUFxkKMwCf",
    "1Df883c96LVauVsx9FEgnsourD8DELwCUQ",
    "1DH2xDH7TngrDU6LXciprKCBKNcPA1xX8A",
    "1DJoEMvp95yJYWyxAZy8DDBzuvjnrTVrsN",
    "1DJoVLgn1foJHHngduRPJvRbwpaFEKxvxd",
    "1DT3tenf14cxz9WFNxmYrXFbB6TFiVWA9U",
    "1DYFJ6CuBvrxyoQSuBzVsNcetY9tvdsrag",
    "1ECeZBxCVJ8Wm2JSN3Cyc6rge2gnvD3W5K",
    "1Edue8XZCWNoDBNZgnQkCCivDyr9GEo4x6",
    "1EfMVkxQQuZfBdocpJu6RUsCJvenQWbQyE",
    "1EpMiZkQVekM5ij12nMiEwttFPcDK9XhX6",
    "1EYitrwBYNWuTBcjZFbEUdqHppe2raLpaF",
    "1F2Gdug9ib9NQMhKMGGJczzMk5SuENoqrp",
    "1FCNgfZWpYMeYhy9t18AAkTBu8AsdoAc1Z",
    "1FE2cuvkq8n5VGwj5hi8YYQxskwJpovPyV",
    "1FjubFHV4mpYjBmvjsEhZssyiiA4TNmnm2",
    "1FRyL9gmFGbzfYDAB4iY9836DJe3KSnjP9",
    "1Fz29BQp82pE3vXXcsZoMNQ3KSHfMzfMe3",
    "1G6DuwDKNHiUWqks2Lgu44cesu7ffFbLK7",
    "1G9A8WRjGXdnYY4TNEVRrcaHsMtana4ncF",
    "1G9CKRHA3mx22DoT1QyNYrh85VSQ19Y1em",
    "1Gekw8ACSs37oXcc5XQHvoux3iKoVFtpF4",
    "1GYuu9d5HPikafbys3k5Q3DRJq6debGsoB",
    "1H939dom7i4WDLCKyGbXUp3fs9CSTNRzgL",
    "1Hn9ErTCPRP6j5UDBeuXPGuq5RtRjFJxJQ",
    "1Hpj6qm9i7nMF3VkKfBFtjhEDpEjxHWvgv",
    "1J9oGoAiHeRfeMZeUnJ9W7RpV55CdKtgYE",
    "1JHdQHkBZiim1cb4hyUh2PbzEbbg6z2TrF",
    "1JPfVv5cWRLx1js9NWxg46dG2CGbeRz4th",
    "1JREJdZupiFhE7ZzQPtASuMCvvpXC7wRsC",
    "1Js6goCey2NaqPQptiLANLQGuk4d6mowjP",
    "1Kc6egXevyLEaeTxLFA1Zyw7GuhCN8jQtt",
    "1KctQENEX5QkQMpnMC3Zh9yRAzkMBLpPcr",
    "1KgudqxMfYaGzqAA7MS4DcsqejtMteqhix",
    "1KSAbh5trMCTZwhiNsuUQvfTtSSTT8zqRk",
    "1Kuf2Rd8mDyAViwBozGTNYnvWL8uYFrkVo",
    "1KUUJPkyDhamZXgpsyXqNGc3x1QPXtdhgz",
    "1Kys8fqDen8NGFUJ6AFcXfFW5qquuTH4eh",
    "1L4ncif9hh9TnUveqWq77HfWWt6CJWtrnb",
    "1LAh7PQwpd1uGiLHae5C5Xz9QXse3y2phq",
    "1LiNmTUPSJEd92ZgVJjAV3RT9BzUjvUCkx",
    "1Ljk8RNNabkZ9bfDYQBn98XfFozJhTjqcZ",
    "1LpYKb3SXZPve9hsH2QEJZFX279wJVGowi",
    "1LrxsRd7zNuxPJcL5rttnoeJFy1y4AffYY",
    "1M5N4sJ1NHb4fviLVZA5MZLKhLZqU4CPZz",
    "1MkCnCa9agS5t6V1B15bzusBgYECB4LfWp",
    "1MLPqwaFFUBZePTjpR3nxRoK19Cv9mPCc7",
    "1MnbhWe5wr7Ut45ReyQsm96PwnM9jD7KaH",
    "1NayLEVF3bEEbDtdF2Cwso1VdEtvVNh2qX",
    "1NE2NiGhhbkFPSEyNWwj7hKGhGDedBtSrQ",
    "1NuBZQXJPyYQGfoBib8wWBDpZmbtkJa5Ba",
    "1P3ZfGFLezzYGg9k5SVzQmnjyh7nrUmF2y",
    "1PfwHNxUnkpfkK9MKjMqzR3Xq3KCtq9u17",
    "1PhqQpaGCrqSxQ6QDXcv14QCd1U98Zp34E",
    "1PJp8diNa89cVHpiT1VPu7EQ8LxYM5HX6v",
    "1Q6saNmqKkyFB9mFR68Ck8F7Dp7dTopF2W",
    "1Q9UAQbcDezmyouFrzt94t4dSMxgsUfW1X",
    "31p6woV4e55HUfC2aGynFhzQnGoJFW26cD",
    "32DaxSzUhLBHY2WGSWQYiBSHnRsfQZrrRp",
    "32jgFkZsTEjMFaBvxJnYvJEeTNKTmq5b32",
    "32pTjxTNi7snk8sodrgfmdKao3DEn1nVJM",
    "32wdqwX3zCEX3DhAVEcKwXCEGdzgBnx1R9",
    "33Kja69SQVc8kozpoP7Qw6HFtGxHkiWzTz",
    "33xWfziVZesgo83U5izdNCBVTnrtBpSwK7",
    "347QFbejDBdMZFTxpmn6evvvqyXiqZTCd7",
    "34pFGsSYbWEritXncW9unZtQQE9dKSvKku",
    "35KAdTa2vqnJzitF2xiUzZn1Gmcas2Y465",
    "35LScRJ8hzDvvWh9t9UA8bHGnGNVz3YEfa",
    "35QpLWYkvD3ALhjbge5bK2kd7HfHYcDMu3",
    "35qwVtMEohWDdBWRiCSR7azoP5cbY8SG1Q",
    "3685sEusmTwZBiKJ4cgV73EAhpVD1nbgbe",
    "372Wk9NLrMkJzKgqJdatWJy4bYRfxFjgat",
    "389Sft4nJFkPGhbagk9FN4jXncA9piYTuU",
    "38ncxqt932N9CcfNfYuHGZgCyR85hDkWBW",
    "38TftW1heYPqvKbiAhT4ttNBqkUPpooXad",
    "39eboeqYNFe2VoLC3mUGx4dh6GNhLB3D2q",
    "39fhoB2DohisGBbHvvfmkdPdShT75CNHdX",
    "39NG2LcGRHXxSr1irpEVnJMw4ydL231sEn",
    "39p8qWp1bkBNhi4vPpFTetKPtH7goqNDZf",
    "39Te8MbphSgs7npDJPj2hbNzhke61NTcnB",
    "3AjyprBY5yhijiCjUC5NUJutGbwhd3AQdE",
    "3AQSmMk5n3c6TKEg9B2WyzYAPm33gJJAA4",
    "3B7S6zrgxQVQUHTU8wstM23tB9afE7ojuX",
    "3BsyZ7qRFSi3NsaoV1Ff724qAgrEpjVUHm",
    "3DNsaQnaUz7wkQny1ZDSmtz6QfbEShxoDD",
    "3E6rY4dSCDW6y2bzJNwrjvTtdmMQjB6yeh",
    "3E6ZCKRrsdPc35chA9Eftp1h3DLW18NFNV",
    "3E7YbpXuhh3CWFks1jmvWoV8y5DvsfzE6n",
    "3EeR8FbcPbkcGj77D6ttneJxmsr3Nu7KGV",
    "3EPqGUw2q89pwPZ1UF8FJspE2AyojSTjdu",
    "3F2sZ4jbhvDKQdGbHYPC6ZxFXEau2m5Lqj",
    "3F6bbvS1krsc1qR8FsbTDfYQyvkMm3QvmR",
    "3FfRvC3kSo2SxiQe5e7SSuNdegwgq8iusL",
    "3Gbs4rjcVUtQd8p3CiFUCxPLZwRqurezRZ",
    "3GXdtA6kbb4M5aqzZm5qqxcFDFRMW8LqdJ",
    "3H3rh85qPaGLy2w6618yZNaH7i8asHv46B",
    "3He6EyDaCUgmdr4GXqhxbeTQukaGLCByU2",
    "3HePkztPU6UsdENxnyQHFrdZA6eVKeMtvz",
    "3HqA7i3ttECLvgqvq69HNxxUP5BL7Z5YgA",
    "3HQRveQzPifZorZLDXHernc5zjoZax8U9f",
    "3JHMz3mTna1gVCZSPp8NgRFiY7phkv5mA8",
    "3JXKQ81JzBqVbB8VHdV9Jtd7auWokkdPgY",
    "3K35dyL85fR9ht7UgzPfd1gLRRXQtNTqE3",
    "3K4rjdh8A5yi6LWvft2rbmyZvqEbPSSSX4",
    "3K7PMJyMNVnxqsfpmK9r9nJDtzDw9wNwNV",
    "3KHfXU24Bt3YD5Ef4J7uNp2buCuhrxfGen",
    "3LbDu1rUXHNyiz4i8eb3KwkSSBMf7C583D",
    "3LhnVMcBq4gsR7aDaRr9XmUo17CuYBV4FN",
    "3Lpoy53K625zVeE47ZasiG5jGkAxJ27kh1",
    "3MkUNScqf21EcfWq6T4x2MFgBeSTqhB5t6",
    "3MN8nYo1tt5hLxMwMbxDkXWd7Xu522hb9P",
    "3MTrJTFhYK9v1C6pjHtuweZSopfZa4b1wb",
    "3MTRvM5QrYZHKo8gh5qKcrPK3RLjxcDCZE",
    "3N6WeZ6i34taX8Ditser6LKWBcXmt2XXL4",
    "3N9YcPBDky9UsMx1RTk33tL4jDkZfSnsPk",
    "3NNcbBcMZokPB2JC2dxYuZrpgcetvyGeJn",
    "3NQ1aa9ceirMJ1JvRq3eXefvXj1L639fzX",
    "3NRJ8aXdUiZdHaiFX9ePX3DhGHzcEi14Fq",
    "3NU9zkD8CCVGVmYnNNSN7PbU9sSFQBm5UV",
    "3PiCnZrBvGfWAKQ9hr4cCpfaDjy64yNSpE",
    "3PKiHs4GY4rFg8dpppNVPXGPqMX6K2cBML",
    "3Q5dGfLKkWqWSwYtbMUyc8xGjN5LrRviK4",
    "3Q8H2ZWMtc4R1M3mkmhnTjCoYKTeCFigDP",
    "DFFJhnQNZf8rf67tYnesPu7MuGUpYtzv7Z",
    "GPwg61XoHqQPNmAucFACuQ5H9sGCDv9TpS",
    "LaizKtS5DUhPuP1nTQcc83MS7HwK6vk85z",
    "LeKvNdNEzgQkzVVnRdV3fAu2DSF1nLsNw6",
    "Leo3j36nn1JcsUQruytQhFUdCdCH5YHMR3",
    "LNwgtMxcKUQ51dw7bQL1yPQjBVZh6QEqsd",
    "M8yFL6SFC6TreATegTyuSYkDfDRbisdpT3",
    "TC4VsFHJdZ66BdwobZxkudVZBVmQZgCP65",
    "TDdbRFoBTEmE3qiR69Y6rKRSG1hoF65QaE",
    "TDprk9jeYPVm6khkBp1u7fwuyJcEJFrPWD",
    "TDwN1Eq62bqvVhfGAjdRRJjE46jsi5KNMV",
    "TEAqwfMhXLaomXhZ8KeMhx3njGmQEDnsUR",
    "TEFph7dZoUN5233cGEzF6XFwRpjPF8fQDS",
    "TFdTr9C3BqQrzKBXqSxJfAZFTh8UwBAfSg",
    "TFFvv7NAWmbcVfA7QN81mMvUC25TWj1WJx",
    "TGJVc32ig2u8tQsYMLE7KXHT5NDQroaVNU",
    "TGUPpmW2bAnMCLe5ih2CFisfCHk4gTFDsx",
    "TH96tFMn8KGiYSLiwcV3E2UiaJc8jmcbz3",
    "THh5woR8qfmDsNknQ3agPYzQSiRtMnKsTh",
    "TLM3zA3EWycoDX4ZX4gKze7sgfbdkntTum",
    "TLNRT524dzL5FF1nJHDhYEMFpeWjLjRbz1",
    "TM6Kix9wH8cYQ4rLpFifsQ4ddH3rPX3f8p",
    "TMGLqRQ4twjW8wJhVH1mQR7nUThpGHUsN3",
    "TMStbg5fgb4uTV7fK1gEYF9hKAzP3siPsG",
    "TNmRfnSUXZoWWzxcDDbf95eGQYXt1mJDt8",
    "TQ5mpZPbQMSq2s1vSM3RJgiB1AsTsiTpFZ",
    "TRBACioxdrdsYEZHvJWiUDZcMdBPpEe5Ub",
    "TTAHMdqoom4f2VTWniroPWQHcTRZ4caoH4",
    "TTgcTTNbNuFdbrhvbjMZVrdU5KALyzDaPw",
    "TTKnV2S1295UrPr7N67Tp9ykNL7xX2Z4Uj",
    "TTUDyVhhpCC1xJoPmWzdjLAzeoPwbSABdr",
    "TU4tDFRvcKhAZ1jdihojmBWZqvJhQCnJ4F",
    "TUCsTq7TofTCJRRoHk6RvhMoS2mJLm5Yzq",
    "TV5ZTpKDszLTF6XcMnPongS33pwBgF91by",
    "TVacWx7F5wgMgn49L5frDf9KLgdYy8nPHL",
    "TVn4q7L4fKEPbygi7UHq1CKfZxtbeuMV5q",
    "TWBAPzpPiZarfVsY2BLXeaLhNHurn4wkWG",
    "TX5GV4DyfxNB3rPkzZJhmqZ1efVmL4rEqG",
    "TXEaKf4rT3rMoD3Vuqnuhwr6vLq6BL5t33",
    "TXEsK1sEsKjZ1xtHitnyAAoqw3WLdYdRNW",
    "XnPFsRWTaSgiVauosEwQ6dEitGYXgwznz2",
    "Xs3vzQmNvAxRa3Xo8XzQqUb3BMgb9EogF4",
    "XyARKoupuArYtToA2S6yMdnoquDCDaBsaT",
    "t1g7wowvQ8gn2v8jrU1biyJ26sieNqNsBJy",
    "t1MMXtBrSp1XG38Lx9cePcNUCJj5vdWfUWL",
    "0x01e2919679362dFBC9ee1644Ba9C6da6D6245BB1",
    "0x03893a7c7463AE47D46bc7f091665f1893656003",
    "0x04DBA1194ee10112fE6C3207C0687DEf0e78baCf",
    "0x05E0b5B40B7b66098C2161A5EE11C5740A3A7C45",
    "0x07687e702b410Fa43f4cB4Af7FA097918ffD2730",
    "0x0836222F2B2B24A3F36f98668Ed8F0B38D1a872f",
    "0x08723392Ed15743cc38513C4925f5e6be5c17243",
    "0x08b2eFdcdB8822EfE5ad0Eae55517cf5DC544251",
    "0x09193888b3f38C82dEdfda55259A82C0E7De875E",
    "0x09278b36863bE4cCd3d0c22d643E8062D7a11377",
    "0x0931cA4D13BB4ba75D9B7132AB690265D749a5E7",
    "0x098B716B8Aaf21512996dC57EB0615e2383E2f96",
    "0x0D8BB3Cd639399A77170d92511DFd54b5f372AAe",
    "0x0E3A09dDA6B20aFbB34aC7cD4A6881493f3E7bf7",
    "0x0e8C1E2881F35Ef20343264862A242FB749d6b35",
    "0x0Ee5067b06776A89CcC7dC8Ee369984AD7Db5e06",
    "0x12D66f87A04A9E220743712cE6d9bB1B5616B8Fc",
    "0x1356c899D8C9467C7f71C195612F8A395aBf2f0a",
    "0x140c9Ab92347734641b1A7c124ffDeE58c20C3E3",
    "0x1512fcb09463A61862B73ec09B9b354aF1790268",
    "0x1542368a03ad1f03d96D51B414f4738961Cf4443",
    "0x169AD27A470D064DEDE56a2D3ff727986b15D52B",
    "0x175d44451403Edf28469dF03A9280c1197ADb92c",
    "0x178169B423a011fff22B9e3F3abeA13414dDD0F1",
    "0x179f48C78f57A3A78f0608cC9197B8972921d1D2",
    "0x1967D8Af5Bd86A497fb3DD7899A020e47560dAAF",
    "0x1999EF52700c34De7EC2b68a28aAFB37db0C5ade",
    "0x19Aa5Fe80D33a56D56c78e82eA5E50E5d80b4Dff",
    "0x19F8f2B0915Daa12a3f5C9CF01dF9E24D53794F7",
    "0x1bb0970508316DC735329752a4581E0a4bAbc6B4",
    "0x1da5821544e25c636c1417Ba96Ade4Cf6D2f9B5A",
    "0x1E34A77868E19A6647b1f2F47B51ed72dEDE95DD",
    "0x1eB27f136BFe7947f80d6ceE3Cf0bfDf92b45e57",
    "0x21032176B43d9f7E9410fB37290a78f4fEd6044C",
    "0x21B8d56BDA776bbE68655A16895afd96F5534feD",
    "0x2290937A4498C96eFfb87b8371a33D108F8D433f",
    "0x22aaA7720ddd5388A3c0A3333430953C68f1849b",
    "0x23173fE8b96A4Ad8d2E17fB83EA5dcccdCa1Ae52",
    "0x23773E65ed146A459791799d01336DB287f25334",
    "0x23b9596eb4ff2Aa35Edc7fBCEbD4d0b03275630D",
    "0x23Db729908137cb60852f2936D2b5c6De0e1c887",
    "0x242654336ca2205714071898f67E254EB49ACdCe",
    "0x2573BAc39EBe2901B4389CD468F2872cF7767FAF",
    "0x26903a5a198D571422b2b4EA08b56a37cbD68c89",
    "0x2717c5e28cf931547B621a5dddb772Ab6A35B701",
    "0x2b53a4AbE6C4f9a227813b40a6BB05f3a6f71aAe",
    "0x2e487A23423F6Fec4bF2bF03aeA35e9368d4581E",
    "0x2f389cE8bD8ff92De3402FFCe4691d17fC4f6535",
    "0x2F50508a8a3D323B91336FA3eA6ae50E55f32185",
    "0x2Fa99c748B16b5EbAfcbfC3AB54db71AE6Eef6e6",
    "0x2FC93484614a34f26F7970CBB94615bA109BB4bf",
    "0x308eD4B7b49797e1A98D3818bFF6fe5385410370",
    "0x30a822CDD2782D2B2A12a08526452e885978FA1D",
    "0x330bdFADE01eE9bF63C209Ee33102DD334618e0a",
    "0x35fB6f6DB4fb05e6A4cE86f2C93691425626d4b1",
    "0x36ed3C0213565530C35115d93A80F9c04d94E4Cb",
    "0x38735f03b30FbC022DdD06ABED01F0Ca823C6a94",
    "0x39D908dac893CBCB53Cc86e0ECc369aA4DeF1A29",
    "0x3A21F4E6Bbe527D347ca7c157F4233c935779847",
    "0x3aac1cC67c2ec5Db4eA850957b967Ba153aD6279",
    "0x3AD9dB589d201A710Ed237c829c7860Ba86510Fc",
    "0x3B8446b684075F2AaE0b5c16387A5cBbBEd62142",
    "0x3CBdeD43EFdAf0FC77b9C55F6fC9988fCC9b757d",
    "0x3Cffd56B47B7b41c56258D9C7731ABaDc360E073",
    "0x3e37627dEAA754090fBFbb8bd226c1CE66D255e9",
    "0x3eFA30704D2b8BBAc821307230376556cF8CC39e",
    "0x407CcEeaA7c95d2FE2250Bf9F2c105aA7AAFB512",
    "0x40e98FeEEbaD7Ddb0F0534Ccaa617427eA10187e",
    "0x43fa21d92141BA9db43052492E0DeEE5aa5f0A93",
    "0x4571bD67d14280E40BF3910Bd39FBF60834F900A",
    "0x4736dCf1b7A3d580672CcE6E7c65cd5cc9cFBa9D",
    "0x47666Fab8bd0Ac7003bce3f5C3585383F09486E2",
    "0x47CE0C6eD5B0Ce3d3A51fdb1C52DC66a7c3c2936",
    "0x48549A34AE37b12F6a30566245176994e17C6b4A",
    "0x4C198B3B5F3a4b1Aa706daC73D826c2B795ccd67",
    "0x4F47Bc496083C727c5fbe3CE9CDf2B0f6496270c",
    "0x502371699497d08D5339c870851898D6D72521Dd",
    "0x51E9d833Ecae4E8D9D8Be17300AEE6D3398C135D",
    "0x52207Ec7B1b43AA5DB116931a904371ae2C1619e",
    "0x5270434029f2fE10f7DD81bcE079280Cb8c749d4",
    "0x527653eA119F3E6a1F5BD18fbF4714081D7B31ce",
    "0x530A64c0Ce595026a4A556b703644228179E2d57",
    "0x538Ab61E8A9fc1b2f93b3dd9011d662d89bE6FE6",
    "0x53b6936513e738f44FB50d2b9476730C0Ab3Bfc1",
    "0x5512d943eD1f7c8a43F3435C85F7aB68b30121b0",
    "0x55CCa2f5eB07907696afe4b9Db5102bcE5feB734",
    "0x57b2B8c82F065de8Ef5573f9730fC1449B403C9f",
    "0x57c93f99823D58547257FE8d49cDa6b96b0568e7",
    "0x58E8dCC13BE9780fC42E8723D8EaD4CF46943dF2",
    "0x5A14E72060c11313E38738009254a90968F58f51",
    "0x5A7a51bFb49F190e5A6060a5bc6052Ac14a3b59f",
    "0x5Af75eAB6BEC227657fA3E749a8BFd55f02e4b1D",
    "0x5cab7692D4E94096462119ab7bF57319726Eed2A",
    "0x5efda50f22d34F262c29268506C5Fa42cB56A1Ce",
    "0x5f48C2A71B2CC96e3F0CCae4E39318Ff0dc375b2",
    "0x5f6c97C6AD7bdd0AE7E0Dd4ca33A4ED3fDabD4D7",
    "0x610B717796ad172B316836AC95a2ffad065CeaB4",
    "0x653477c392c16b0765603074f157314Cc4f40c32",
    "0x660BfcEa3A5FAF823e8f8bF57dd558db034dea1d",
    "0x67d40EE1A85bf4a4Bb7Ffae16De985e8427B6b45",
    "0x684d4b58Dc32af786BF6D572A792fF7A883428B9",
    "0x6aCDFBA02D390b97Ac2b2d42A63E85293BCc160e",
    "0x6Be0aE71e6c41f2f9D0D1A3B8d0f75E6f6A0b46e",
    "0x6Bf694a291DF3FeC1f7e69701E3ab6c592435Ae7",
    "0x6d46bd3AfF100f23C194e5312f93507978a6DC91",
    "0x6DC6B2080E9C2ab173A4276ced46360F37006eB3",
    "0x6F1cA141A28907F78Ebaa64fb83A9088b02A8352",
    "0x722122dF12D4e14e13Ac3b6895a86e84145b6967",
    "0x723a7084028421994d4a7829108D63aB44658315",
    "0x723B78e67497E85279CB204544566F4dC5d2acA0",
    "0x72a5843cc08275C8171E582972Aa4fDa8C397B2A",
    "0x743494b60097A2230018079c02fe21a7B687EAA5",
    "0x746Aebc06D2aE31B71ac51429A19D54E797878E9",
    "0x756C4628E57F7e7f8a459EC2752968360Cf4D1AA",
    "0x76D85B4C0Fc497EeCc38902397aC608000A06607",
    "0x776198CCF446DFa168347089d7338879273172cF",
    "0x77777FeDdddFfC19Ff86DB637967013e6C6A116C",
    "0x797d7Ae72EbddCDea2a346c1834E04d1F8dF102b",
    "0x7Db418b5D567A4e0E8c59Ad71BE1FcE48f3E6107",
    "0x7F19720A857F834887FC9A7bC0a0fBe7Fc7f8102",
    "0x7F367cC41522cE07553e823bf3be79A889DEbe1B",
    "0x7FF9cFad3877F21d41Da833E2F775dB0569eE3D9",
    "0x8281Aa6795aDE17C8973e1aedcA380258Bc124F9",
    "0x833481186f16Cece3f1Eeea1a694c42034c3a0dB",
    "0x83c7678492D623fb98834F0fbcb2E7b7f5Af8950",
    "0x83E5bC4Ffa856BB84Bb88581f5Dd62A433A25e0D",
    "0x83Ef5E80faD88288F770152875Ab0bb16641a09E",
    "0x84443CFd09A48AF6eF360C6976C5392aC5023a1F",
    "0x8576aCC5C05D6Ce88f4e49bf65BdF0C62F91353C",
    "0x8589427373D6D84E98730D7795D8f6f8731FDA16",
    "0x88fd245fEdeC4A936e700f9173454D1931B4C307",
    "0x8c7235e1A6EeF91b980D0FcA083347FBb7EE1806",
    "0x901bb9583b24D97e995513C6778dc6888AB6870e",
    "0x905b63Fff465B9fFBF41DeA908CEb12478ec7601",
    "0x910Cbd523D972eb0a6f4cAe4618aD62622b39DbF",
    "0x9271EDdda0F0f2bB7b1A0c712bdF8dbD0A38d1Ab",
    "0x931546D9e66836AbF687d2bc64B30407bAc8C568",
    "0x94A1B5CdB22c43faab4AbEb5c74999895464Ddaf",
    "0x94Be88213a387E992Dd87DE56950a9aef34b9448",
    "0x94C92F096437ab9958fC0A37F09348f30389Ae79",
    "0x959c4CA19c4532C97A657D82d97acCBAb70e6fb4",
    "0x961C5Be54a2ffC17CF4Cb021d863c42daCd47Fc1",
    "0x96244D83DC15d36847C35209bBDc5bdDE9bEc3D8",
    "0x97B1043ABD9E6FC31681635166d430a458D14F9C",
    "0x983a81ca6FB1e441266D2FbcB7D8E530AC2E05A2",
    "0x9AD122c22B14202B4490eDAf288FDb3C7cb3ff5E",
    "0x9C2Bc757B66F24D60F016B6237F8CdD414a879Fa",
    "0x9eF42873Ae015AA3da0c4354AeF94a18D2B3407b",
    "0x9F4cda013E354b8fC285BF4b9A60460cEe7f7Ea9",
    "0xa0e1c89Ef1a489c9C7dE96311eD5Ce5D32c20E4B",
    "0xA160cdAB225685dA1d56aa342Ad8841c3b53f291",
    "0xA3ba80897D905aB5B0B801765A2B44B180137F30",
    "0xA4B2Fd68593B6F34E51cB9eDB66E71c1B4Ab449e",
    "0xA5A023E052243b7cce34Cbd4ba20180e8Dea6Ad6",
    "0xa5C2254e4253490C54cef0a4347fddb8f75A4998",
    "0xa5cAb1Db0E0D1F77eD3a34830B8294f5Fe697A93",
    "0xA60C772958a3eD56c1F15dD055bA37AC8e523a0D",
    "0xA7e5d5A720f06526557c513402f2e6B5fA20b008",
    "0xA924eAe4A5787ebbeFC716154FFB1b9B97e4B412",
    "0xad6298D2E4aE175b1d526f37e516c93f21a17edC",
    "0xaEaaC358560e11f52454D997AAFF2c5731B6f8a6",
    "0xaf4c0B70B2Ea9FB7487C7CbB37aDa259579fe040",
    "0xAf5b8eAB7049Ef4f5BE2f890D758D6353ac57FD0",
    "0xaf620e6d32b1c67f3396ef5d2f7d7642dc2e6ce9",
    "0xaf8d1839c3c67cf571aa74B5c12398d4901147B3",
    "0xb04E030140b30C27bcdfaafFFA98C57d80eDa7B4",
    "0xb172F7e99452446f18FF49A71bfEeCf0873003b4",
    "0xb1C8094B234DcE6e03f10a5b673c1d8C69739A00",
    "0xB20c66C4DE72433F3cE747b58B86830c459CA911",
    "0xB4a862A81aBB2f952FcA4C6f5510962e18c7f1A2",
    "0xb541fc07bC7619fD4062A54d96268525cBC6FfEF",
    "0xb6f5ec1A0a9cd1526536D3F0426c429529471F40",
    "0xB72334cB9D0b614D30C4c60e2bd12fF5Ed03c305",
    "0xBA214C1c1928a32Bffe790263E38B4Af9bFCD659",
    "0xbB93e510BbCD0B7beb5A853875f9eC60275CF498",
    "0xBC3e5e8C10897a81b63933348f53f2e052F89a7E",
    "0xBCA02B395747D62626a65016F2e64A20bd254A39",
    "0xbdE2Cc5375fa9E0383309A2cA31213f2D6cabcbd",
    "0xc2a3829F459B3Edd87791c74cD45402BA0a20Be3",
    "0xC455f7fd3e0e12afd51fba5c106909934D8A0e4a",
    "0xCa0840578f57fE71599D29375e16783424023357",
    "0xCC84179FFD19A1627E79F8648d09e095252Bc418",
    "0xCd1a4A457cA8b0931c3BF81Df3CFa227ADBdb6E9",
    "0xCd7eC020121Ead6f99855cbB972dF502dB5bC63a",
    "0xCEe71753C9820f063b38FDbE4cFDAf1d3D928A80",
    "0xD0975B32cEa532eaDDdFC9c60481976e39dB3472",
    "0xD21be7248e0197Ee08E0c20D4a96DEBdaC3D20Af",
    "0xD3C611AeD139107DEC2294032da3913BC26507fb",
    "0xd47438C816c9E7f2E2888E060936a499Af9582b3",
    "0xD4B88Df4D29F5CedD6857912842cff3b20C8Cfa3",
    "0xD5b58Cf7813c1eDC412367b97876bD400ea5c489",
    "0xD5d6f8D9e784d0e26222ad3834500801a68D027D",
    "0xd5ED34b52AC4ab84d8FA8A231a3218bbF01Ed510",
    "0xD691F27f38B395864Ea86CfC7253969B409c362d",
    "0xD692Fd2D0b2Fbd2e52CFa5B5b9424bC981C30696",
    "0xD82ed8786D7c69DC7e052F7A542AB047971E73d2",
    "0xd882cFc20F52f2599D84b8e8D58C7FB62cfE344b",
    "0xd8D7DE3349ccaA0Fde6298fe6D7b7d0d34586193",
    "0xd90e2f925DA726b50C4Ed8D0Fb90Ad053324F31b",
    "0xd96f2B1c14Db8458374d9Aca76E26c3D18364307",
    "0xdcbEfFBECcE100cCE9E4b153C4e15cB885643193",
    "0xDD4c48C0B24039969fC16D1cdF626eaB821d3384",
    "0xdD90071D52F20e85c89802e5Dc1eC0A7B6475f92",
    "0xdf231d99Ff8b6c6CBF4E9B9a945CBAcEF9339178",
    "0xDF3A408c53E5078af6e8fb2A85088D46Ee09A61b",
    "0xe69753Ddfbedbd249E703EB374452E78dae1ae49",
    "0xe7aa314c77F4233C18C6CC84384A9247c0cf367B",
    "0xE950DC316b836e4EeFb8308bf32Bf7C72a1358FF",
    "0xE9bc552fdFa54b30296d95F147e3e0280FF7f7e6",
    "0xEB0bAA3A556586192590CAD296b1e48dF62a8549",
    "0xeD6e0A7e4Ac94D976eeBfB82ccf777A3c6baD921",
    "0xeDC5d01286f99A066559F60a585406f3878a033e",
    "0xEFE301d259F525cA1ba74A7977b80D5b060B3ccA",
    "0xf03AfB1c6A11A7E370920ad42e6eE735dBedF0b1",
    "0xf0a16603289eAF35F64077Ba3681af41194a1c09",
    "0xF302572594a68aA8F951faE64ED3aE7DA41c72Be",
    "0xf3701F445b6BDaFeDbcA97D1e477357839e4120D",
    "0xf4B067dD14e95Bab89Be928c07Cb22E3c94E0DAA",
    "0xF60dD140cFf0706bAE9Cd734Ac3ae76AD9eBC32A",
    "0xF67721A2D8F736E75a49FdD7FAd2e31D8676542a",
    "0xF7B31119c2682c88d88D455dBb9d5932c65Cf1bE",
    "0xfa3FcCCB897079fD83bfBA690E7D47Eb402d6c49",
    "0xFAC583C0cF07Ea434052c49115a4682172aB6b4F",
    "0xFc926659Dd8808f6e3e0a8d61B20B871F3Fa6465",
    "0xFD8610d20aA15b7B2E3Be39B396a1bC3516c7144",
    "0xfEC8A60023265364D066a1212fDE3930F6Ae8da7",
    "0xffbaC21a641Dcfe4552920138D90F3638B3c9fba",
    "bc1q048fxd02dcchrzv9t4t0s5jvd3uvexm9lxufs0",
    "bc1q2lpgjntr348pfvxhfy33ehmdzy3gmx8w4052z6",
    "bc1q3q2lz3cmt4u2f49ugxz5q34xrs0m2z4w2gmkp5",
    "bc1q3y5v2khlyvemcz042wl98dzflywr8ghglqws6s",
    "bc1q45cxufu7x6s5v9adzm9t38k80gwawse75xffwe",
    "bc1q4namcagg5wljs0u20z6h2sqgsq4q5lts8rt2rr",
    "bc1q4yzd2rjmshm8ucrwy6dzj5rna20j0zlf8hf8vz",
    "bc1q5jqgm7nvrhaw2rh2vk0dk8e4gg5g373g0vz07r",
    "bc1q8ew45w2agdffrnwp6adt2gqrc9n4mkev9ns29c",
    "bc1q9lvynkfpaw330uhqmunzdz6gmafsvapv7y3zty",
    "bc1qagp0gy58v8hqvw4p2wsphcxg067rrppp45hexr",
    "bc1qardcxz845jw83vgfvcmewhuxa0ag9gchjwmcfd",
    "bc1qdpazd6smrkq5hmw6lupq98za2fqtgmq3azv3av",
    "bc1qdt3gml5z5n50y5hm04u2yjdphefkm0fl2zdj68",
    "bc1qfg4gfg0y6t6xjnpmlhuwx5k0wlw6nmfzxn2psc",
    "bc1qgdsx5mt5xxqymuu5sfzdnq6wtw4wsh2raytanx",
    "bc1qj2ffj6pepc80sfqpx2k2pd3q278q72dpqv2ens",
    "bc1qjwr3rgww7a8ut7a4x8jqh3vswcue3xvp6dm7qe",
    "bc1ql7dlyh8xz6tpqk92vztrhqh88dmjvcwrmsemrm",
    "bc1qlu4a33zjspefa3tnq566xszcr0fvwz05ewhqfq",
    "bc1qmzmx8res2fgzd2wttyvf2ajqqqtcnxxrgkqc2t",
    "bc1qn6segn8km4nfdp9vueu6msfjsaxaqgun9h60n9",
    "bc1qnykkrlk67f9kdqvzyw2ndu3xmef5z2e52886yl",
    "bc1qpaly5nm7pfka9v92d6qvl4fc2l9xzee8a6ys3s",
    "bc1qsxf77cvwcd6jv6j8d8j3uhh4g0xqw4meswmwuc",
    "bc1qtdupwe722vcc5e0vh94cgwfs0ep4gzwyfsf75q",
    "bc1qte9ret332gwrk6e7vqc87d807npzvdj5savg4h",
    "bc1qtrrfhr0f3ufsrjxfv8a7p3yuqj0spe4cm6vaws",
    "bc1qtsl3ufenrv3zgrgm9z8xarcx22x8mfztuartyn",
    "bc1qu5vngdtcx8nc9d68pq8nv7pzcjrswsy87s66gk",
    "bc1qv4krhj2qmpd9qz9xj9nhvj99fq8s9xsw05d485",
    "bc1qv7k70u2zynvem59u88ctdlaw7hc735d8xep9rq",
    "bc1qvhnfknw852ephxyc5hm4q520zmvf9maphetc9z",
    "bc1qvxlwpgcw260sc97a0u6dm0cjxv027clhd67fvx",
    "bc1qw4cxpe6sxa5dg6sdwxjph959cw6yztrzl4r54s",
    "bc1qw8evftpgc8wsmkemd8yl5fg2husza5z802xaym",
    "bc1qwtswqzvaxl6lyw3keqqzwt8z937psta3wg9sjy",
    "bc1qwz0l2ceddckwdy5rh6zyrm3x4ha6gn5f2da5zg",
    "bc1qx3e2axj3wsfn0ndtvlwmkghmmgm4583nqg8ngk",
    "bc1qx9upga7f09tsetqf78wa3qrmcjar58mkwz6ng6",
    "bc1qyqvyupkpl6tm60zdecef925y220ssjuagpxsm0",
    "qpf2cphc5dkuclkqur7lhj2yuqq9pk3hmukle77vhq",
    "qzjv8hrdvz6edu4gkzpnd4w6jc7zf296g5e9kkq4lx",
    "bc1q86tl9255vg5wldamfymaaz36uqxzm30gs7fhkljvzdlt9t38s3lqgdwdfq",
    "bc1q90zrdysy4flyacw7hsury3ajs9yzwtwp6guqpypx94w0d3p58hysvz6pde",
    "bc1qkfqh5p2qsakseg5gnwen6zh5xf3elmku2xaup29mw3l0wnncy3es880dss",
    "bc1qq7p0es3dv5hcynjjf40f2xjjr6qp5py47d2f6n847vduuq9gvnyq7y9ecd",
    "bc1qw7vfgv3r5vnehafl0y95sclg3uqsj87wxs9ad628yjjcq33cwessr6ndyw",
    "5be5543ff73456ab9f2d207887e2af87322c651ea1a873c5b25b7ffae456c320",
    "49HqitRzdnhYjgTEAhgGpCfsjdTeMbUTU6cyR4JV1R7k2Eej9rGT8JpFiYDa4tZM6RZiFrHmMzgSrhHEqpDYKBe5B2ufNsL",
    "884Bz8UH63aYsjVdkfWfScRYWZGGNbjFL7pztqvWNSrtYT4reFSwyvkCj9KEGUtheHhhMUj87ciTBFyzoesrMJ4L1FvSoxL"
  ])
), Yj = (e) => !e || !ge.chains[e] ? "Select a source chain" : "", Wj = (e, t) => {
  if (!e || !ge.chains[e]) return "Select a destination chain";
  if (t && e === t)
    return "Source chain and destination chain cannot be the same";
  if (ge.ui.defaultInputs && ge.ui.defaultInputs.requiredChain && e && t) {
    const { requiredChain: i } = ge.ui.defaultInputs, c = ge.chains[i];
    if (c && e !== i && t !== i)
      return `Must select ${c.displayName} as either the source or destination chain`;
  }
  return "";
}, Hj = (e, t) => e && ai(e) === 0n ? "Amount must be greater than 0" : "", Zj = (e) => Mc.has(e) || Mc.has("0x" + e), v6 = async (e, t) => {
  if (!e.address) return "Wallet not connected";
  try {
    if (Zj(e.address))
      return "This address is sanctioned, bridging is not available";
  } catch (i) {
    console.error(i);
  }
  if (e.currentAddress && e.currentAddress !== e.address)
    return "Switch to connected wallet";
  const o = n8(e.type);
  return t && !o.includes(t) ? `Connected wallet is not supported for ${t}` : "";
}, Qj = (e, t) => e < 0 ? "Amount must be equal to or greater than zero" : t && e > t ? "Amount exceeds maximum amount" : "", Vj = (e) => {
  if (!e) return !1;
  const t = ge.routes.get(e);
  return t ? t.AUTOMATIC_DEPOSIT : !1;
}, Gj = async (e, t, o) => {
  const { fromChain: i, toChain: c, amount: n, route: d } = e, { maxSwapAmt: f, toNativeToken: p } = t, { sending: l, receiving: h } = o, y = Vj(d), M = {
    sendingWallet: await v6(l, i),
    receivingWallet: await v6(h, c),
    fromChain: Yj(i),
    toChain: Wj(c, i),
    amount: Hj(n),
    toNativeToken: "",
    relayerFee: "",
    receiveAmount: ""
  };
  return y ? d === "AutomaticNtt" ? M : {
    ...M,
    toNativeToken: Qj(p, f)
  } : M;
}, Zh = (e) => {
  for (const t of Object.values(e))
    if (t)
      return !1;
  return !0;
}, om = async ({
  transferInput: e,
  relay: t,
  wallet: o
}, i, c) => {
  const n = await Gj(e, t, o), d = o.sending.address && o.receiving.address && e.fromChain && e.toChain && e.token && e.destToken && e.amount;
  c() || i(
    rS({
      validations: n,
      showValidationState: !!d
    })
  );
}, $j = 250, am = () => {
  const e = Cr(), t = Ut((d) => d.transferInput), o = Ut((d) => d.relay), i = Ut((d) => d.wallet), c = Ce(
    () => ({ transferInput: t, relay: o, wallet: i }),
    [t, o, i]
  ), [n] = Lj(
    c,
    $j
  );
  St(() => {
    let d = !1;
    return om(n, e, () => d), () => {
      d = !0;
    };
  }, [n, e]);
}, cl = (e, t) => {
  const o = e.toString().padStart(2, "0"), i = t.toString().padStart(2, "0");
  return `${o}:${i}`;
}, qj = (e) => {
  const t = Math.floor(e / 6e4), o = Math.floor(e % 6e4 / 1e3);
  return cl(t, o);
}, sm = (e) => {
  const t = Cr(), [o, i] = Xe(void 0), [c, n] = Xe(
    void 0
  ), d = wa(Vi), f = Ut((U) => U.transferInput), {
    amount: p,
    fromChain: l,
    toChain: h,
    route: y,
    validations: M
  } = f, { sourceToken: C, destToken: N } = _o(), w = Ut((U) => U.wallet), { sending: S, receiving: T } = w, E = Ut((U) => U.relay), { toNativeToken: j } = E, O = e.quotes[y ?? ""], z = O != null && O.success ? O : void 0, k = z == null ? void 0 : z.destinationNativeGas, H = im();
  return {
    onConfirm: async () => {
      if (o && i(void 0), ge.ui.previewMode) {
        i("Connect is in preview mode");
        return;
      }
      if (!l || !C || !h || !N || !p || !y || !z || (await om({ transferInput: f, relay: E, wallet: w }, t, () => !1), !Zh(M) || !y))
        return;
      const B = tm(
        y,
        C,
        N,
        l,
        h,
        p,
        H
      );
      if (ge.validateTransfer)
        try {
          const { isValid: I, error: r } = await ge.validateTransfer({
            ...B,
            fromWalletAddress: S.address,
            toWalletAddress: T.address
          });
          if (!I) {
            i(r ?? "Transfer validation failed");
            return;
          }
        } catch (I) {
          i("Error validating transfer"), n(I), console.error(I);
          return;
        }
      t($5(!0));
      try {
        ge.triggerEvent({
          type: "transfer.initiate",
          details: B
        });
        const [I, r] = await ge.routes.get(y).send(
          C,
          p,
          l,
          S.address,
          h,
          T.address,
          N,
          { nativeGas: j }
        ), s = "originTxs" in r ? r.originTxs[r.originTxs.length - 1].txid : void 0;
        if (ge.triggerEvent({
          type: "transfer.start",
          details: { ...B, txId: s }
        }), !s) throw new Error("Can't find txid in receipt");
        let u;
        if (z.relayFee) {
          const { token: A, amount: L } = z.relayFee, m = ge.tokens.get(A);
          u = {
            fee: Number.parseFloat(
              kj(L.amount, L.decimals, 6)
            ),
            token: m == null ? void 0 : m.tuple
          };
        }
        const g = Date.now(), v = {
          sendTx: s,
          sender: S.address,
          amount: p,
          recipient: T.address,
          toChain: r.to,
          fromChain: r.from,
          receivedToken: N.tuple,
          token: C.tuple,
          tokenAddress: C.tuple[1],
          tokenKey: C.key,
          tokenDecimals: C.decimals,
          relayerFee: u,
          receiveAmount: z.destinationToken.amount,
          receiveNativeAmount: k,
          eta: z.eta || 0
        };
        Pj({
          txDetails: v,
          txHash: s,
          timestamp: g,
          receipt: r,
          route: y
        }), t(ah(g)), t(Pc(v)), t(Hs("")), d.setRoute(I), d.setReceipt(r), t(Vx(s)), t(Uc(y)), t(Nn("redeem")), i(void 0);
      } catch (I) {
        const [r, s] = b1(
          I,
          B
        );
        s.type === XM || (console.error("Wormhole Connect: error completing transfer", I), i(r), n(I), ge.triggerEvent({
          type: "transfer.error",
          error: s,
          details: B
        }));
      } finally {
        t($5(!1));
      }
    },
    error: o,
    errorInternal: c
  };
};
async function b6(e, t, o) {
  const { batchSize: i, delayMs: c, maxItems: n } = o, d = n ? e.slice(0, n) : e, f = [];
  for (let p = 0; p < d.length; p += i) {
    const l = d.slice(p, p + i), h = await Promise.all(l.map(t));
    f.push(...h), p + i < d.length && await cc(c);
  }
  return f;
}
const Ed = 5 * 60 * 1e3, x6 = 5, w6 = 250, Jj = 100, ka = (e, t) => `${e}-${t.address}`, Xj = () => {
  const e = _r({}), t = _r(/* @__PURE__ */ new Set()), o = ht(
    (d, f, p) => {
      const l = `${d}-${f.address}-${p.key}`, h = e.current[l], y = Date.now();
      return h && h.lastUpdated > y - Ed ? h : null;
    },
    []
  ), i = ht(
    (d, f, p, l) => {
      const h = `${d}-${f.address}-${p.key}`;
      e.current[h] = {
        balance: l,
        lastUpdated: Date.now()
      };
    },
    []
  ), c = ht((d, f) => {
    t.current.add(Bn(d, f));
  }, []), n = ht((d, f) => t.current.has(Bn(d, f)), []);
  return St(() => {
    const f = setInterval(() => {
      const p = Date.now(), l = e.current;
      for (const h in l)
        l[h].lastUpdated < p - Ed * 2 && delete l[h];
    }, Ed);
    return () => clearInterval(f);
  }, []), { getCached: o, setCached: i, markFailed: c, isFailed: n };
}, cm = ({
  source: e,
  destination: t
}) => {
  var j, O;
  const [o, i] = Xe({}), [c, n] = Xe(/* @__PURE__ */ new Set()), { getOrFetchToken: d } = Hr(), { getCached: f, setCached: p, markFailed: l, isFailed: h } = Xj(), y = _r(/* @__PURE__ */ new Set()), M = ht(
    async (z, k, H, W) => {
      const U = Object.entries(z).filter(([I, r]) => r !== null && r > 1n).sort(([, I], [, r]) => {
        const s = I ?? 0n, u = r ?? 0n;
        return s > u ? -1 : s < u ? 1 : 0;
      }), B = [];
      for (const [I, r] of U) {
        if (r === null) continue;
        const s = ge.tokens.get(k, I);
        if (s) {
          const u = yn(r, s.decimals), g = {
            balance: u,
            lastUpdated: Date.now()
          };
          W[s.key] = g, p(k, H, s, u);
        } else h(k, I) || B.push([I, r]);
      }
      B.length > 0 && await b6(
        B,
        async ([I, r]) => {
          try {
            const s = await d(
              un.tokenId(k, I)
            );
            if (s) {
              const u = yn(r, s.decimals), g = {
                balance: u,
                lastUpdated: Date.now()
              };
              W[s.key] = g, p(k, H, s, u);
            } else
              l(k, I);
          } catch (s) {
            console.error(
              `Failed to fetch token metadata for ${I}:`,
              s
            ), l(k, I);
          }
        },
        {
          batchSize: x6,
          delayMs: w6,
          maxItems: Jj
        }
      );
    },
    [d, p, h, l]
  ), C = ht(
    async (z, k, H) => {
      const W = ge.chains[z];
      if (!W || Vr(W.sdkName) !== k.type)
        return {};
      const U = {}, B = [];
      for (const v of H) {
        const A = f(z, k, v);
        A ? U[v.key] = A : B.push(v);
      }
      const I = await gn(), r = Vr(z), s = I.getPlatform(r), u = s.getRpc(z), g = s.utils();
      if (x9(g) && (r !== "Evm" || ge.evmIndexers && (ge.evmIndexers.alchemy || ge.evmIndexers.goldRush)))
        try {
          const A = await g.getBalances(
            ge.network,
            z,
            u,
            k.address,
            r === "Evm" ? ge.evmIndexers : void 0
          );
          return await M(A, z, k, U), U;
        } catch (A) {
          console.error(`Error calling getBalances on ${z}:`, A);
        }
      return B.length === 0 || await b6(
        B,
        async (v) => {
          try {
            const A = await g.getBalance(
              ge.network,
              z,
              u,
              k.address,
              v.address
            ), L = yn(
              A ?? 0n,
              v.decimals
            );
            U[v.key] = {
              balance: L,
              lastUpdated: Date.now()
            }, p(z, k, v, L);
          } catch (A) {
            console.error(`Failed to fetch balance for token ${v.key}`, A);
          }
        },
        {
          batchSize: x6,
          delayMs: w6
        }
      ), U;
    },
    [f, p, M]
  );
  St(() => {
    const z = /* @__PURE__ */ new Set();
    if (e && z.add(ka(e.chain, e.wallet)), t && z.add(ka(t.chain, t.wallet)), y.current = z, n((H) => {
      const W = new Set(H);
      for (const U of H)
        z.has(U) || W.delete(U);
      return W;
    }), z.size === 0)
      return;
    (async () => {
      const H = [];
      e && H.push(e), t && H.push(t), n(new Set(z));
      try {
        const W = await Promise.all(
          H.map(async (U) => {
            const B = ka(U.chain, U.wallet);
            if (!y.current.has(B))
              return { key: B, balances: {} };
            const I = await C(
              U.chain,
              U.wallet,
              U.tokens
            );
            return { key: B, balances: I };
          })
        );
        i((U) => {
          const B = { ...U };
          for (const { key: I, balances: r } of W)
            y.current.has(I) && Object.keys(r).length > 0 && (B[I] = r);
          for (const I in B)
            y.current.has(I) || delete B[I];
          return B;
        });
      } finally {
        n((W) => {
          const U = new Set(W);
          for (const B of z)
            U.delete(B);
          return U;
        });
      }
    })();
  }, [
    e == null ? void 0 : e.chain,
    (j = e == null ? void 0 : e.wallet) == null ? void 0 : j.address,
    t == null ? void 0 : t.chain,
    (O = t == null ? void 0 : t.wallet) == null ? void 0 : O.address
  ]);
  const N = e ? ka(e.chain, e.wallet) : null, w = t ? ka(t.chain, t.wallet) : null, S = {
    balances: N ? o[N] || {} : {}
  }, T = {
    balances: w ? o[w] || {} : {}
  };
  return {
    isFetching: c.size > 0,
    source: S,
    destination: T
  };
};
function Kj(e) {
  return Bt("MuiLink", e);
}
const eO = Ft("MuiLink", ["root", "underlineNone", "underlineHover", "underlineAlways", "button", "focusVisible"]), tO = ({
  theme: e,
  ownerState: t
}) => {
  const o = t.color, i = Ei(e, `palette.${o}.main`, !1) || Ei(e, `palette.${o}`, !1) || t.color, c = Ei(e, `palette.${o}.mainChannel`) || Ei(e, `palette.${o}Channel`);
  return "vars" in e && c ? `rgba(${c} / 0.4)` : ur(i, 0.4);
}, C6 = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, rO = (e) => {
  const {
    classes: t,
    component: o,
    focusVisible: i,
    underline: c
  } = e, n = {
    root: ["root", `underline${it(c)}`, o === "button" && "button", i && "focusVisible"]
  };
  return Rt(n, Kj, t);
}, nO = Ke(Fe, {
  name: "MuiLink",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[`underline${it(o.underline)}`], o.component === "button" && t.button];
  }
})(kt(({
  theme: e
}) => ({
  variants: [{
    props: {
      underline: "none"
    },
    style: {
      textDecoration: "none"
    }
  }, {
    props: {
      underline: "hover"
    },
    style: {
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline"
      }
    }
  }, {
    props: {
      underline: "always"
    },
    style: {
      textDecoration: "underline",
      "&:hover": {
        textDecorationColor: "inherit"
      }
    }
  }, {
    props: ({
      underline: t,
      ownerState: o
    }) => t === "always" && o.color !== "inherit",
    style: {
      textDecorationColor: "var(--Link-underlineColor)"
    }
  }, ...Object.entries(e.palette).filter(Gr()).map(([t]) => ({
    props: {
      underline: "always",
      color: t
    },
    style: {
      "--Link-underlineColor": e.vars ? `rgba(${e.vars.palette[t].mainChannel} / 0.4)` : ur(e.palette[t].main, 0.4)
    }
  })), {
    props: {
      underline: "always",
      color: "textPrimary"
    },
    style: {
      "--Link-underlineColor": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : ur(e.palette.text.primary, 0.4)
    }
  }, {
    props: {
      underline: "always",
      color: "textSecondary"
    },
    style: {
      "--Link-underlineColor": e.vars ? `rgba(${e.vars.palette.text.secondaryChannel} / 0.4)` : ur(e.palette.text.secondary, 0.4)
    }
  }, {
    props: {
      underline: "always",
      color: "textDisabled"
    },
    style: {
      "--Link-underlineColor": (e.vars || e).palette.text.disabled
    }
  }, {
    props: {
      component: "button"
    },
    style: {
      position: "relative",
      WebkitTapHighlightColor: "transparent",
      backgroundColor: "transparent",
      // Reset default value
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      border: 0,
      margin: 0,
      // Remove the margin in Safari
      borderRadius: 0,
      padding: 0,
      // Remove the padding in Firefox
      cursor: "pointer",
      userSelect: "none",
      verticalAlign: "middle",
      MozAppearance: "none",
      // Reset
      WebkitAppearance: "none",
      // Reset
      "&::-moz-focus-inner": {
        borderStyle: "none"
        // Remove Firefox dotted outline.
      },
      [`&.${eO.focusVisible}`]: {
        outline: "auto"
      }
    }
  }]
}))), $i = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiLink"
  }), c = or(), {
    className: n,
    color: d = "primary",
    component: f = "a",
    onBlur: p,
    onFocus: l,
    TypographyClasses: h,
    underline: y = "always",
    variant: M = "inherit",
    sx: C,
    ...N
  } = i, [w, S] = ue.useState(!1), T = (z) => {
    ca(z.target) || S(!1), p && p(z);
  }, E = (z) => {
    ca(z.target) && S(!0), l && l(z);
  }, j = {
    ...i,
    color: d,
    component: f,
    focusVisible: w,
    underline: y,
    variant: M
  }, O = rO(j);
  return /* @__PURE__ */ D(nO, {
    color: d,
    className: It(O.root, n),
    classes: h,
    component: f,
    onBlur: T,
    onFocus: E,
    ref: o,
    ownerState: j,
    variant: M,
    ...N,
    sx: [...C6[d] === void 0 ? [{
      color: d
    }] : [], ...Array.isArray(C) ? C : [C]],
    style: {
      ...N.style,
      ...y === "always" && d !== "inherit" && !C6[d] && {
        "--Link-underlineColor": tO({
          theme: c,
          ownerState: j
        })
      }
    }
  });
});
fe.process.env.NODE_ENV !== "production" && ($i.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The color of the link.
   * @default 'primary'
   */
  color: b.oneOfType([b.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), b.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Fi,
  /**
   * @ignore
   */
  onBlur: b.func,
  /**
   * @ignore
   */
  onFocus: b.func,
  /**
   * @ignore
   */
  style: b.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * `classes` prop applied to the [`Typography`](https://mui.com/material-ui/api/typography/) element.
   */
  TypographyClasses: b.object,
  /**
   * Controls when the link should have an underline.
   * @default 'always'
   */
  underline: b.oneOf(["always", "hover", "none"]),
  /**
   * Applies the theme typography styles.
   * @default 'inherit'
   */
  variant: b.oneOfType([b.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), b.string])
});
const Tt = $9({
  createStyledComponent: Ke("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (e, t) => t.root
  }),
  useThemeProps: (e) => Pt({
    props: e,
    name: "MuiStack"
  })
});
fe.process.env.NODE_ENV !== "production" && (Tt.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: b.oneOfType([b.oneOf(["column-reverse", "column", "row-reverse", "row"]), b.arrayOf(b.oneOf(["column-reverse", "column", "row-reverse", "row"])), b.object]),
  /**
   * Add an element between each child.
   */
  divider: b.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: b.oneOfType([b.arrayOf(b.oneOfType([b.number, b.string])), b.number, b.object, b.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: b.bool
});
function iO(e) {
  const t = or(), o = Ce(
    () => ({
      separator: {
        display: "flex",
        paddingLeft: t.spacing(1),
        paddingRight: t.spacing(1)
      }
    }),
    [t]
  );
  return /* @__PURE__ */ D(wt, { sx: o.separator, children: /* @__PURE__ */ D(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 27 38",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ D(
        "path",
        {
          fill: e.color,
          d: "M24.536 37.864C22.376 37.72 20.6 37.288 18.728 35.416C17.432 36.328 15.416 37.432 12.008 37.432H11.624C5.096 37.432 0.632 33.832 0.632 27.64V26.824C0.632 22.024 3.608 19.528 6.68 17.464C4.808 14.392 3.176 11.848 3.176 8.632V8.056C3.176 3.832 5.72 0.951998 11.336 0.951998H12.104C18.008 0.951998 20.024 4.072 20.024 8.056V8.248C20.024 12.136 17.864 14.92 13.64 17.992L19.016 26.728C19.448 23.992 19.688 20.872 19.688 16.6H25.448C25.4 21.784 24.536 26.872 22.616 31.24C24.2 32.392 25.592 32.392 26.888 32.536L24.536 37.864ZM9.224 8.392C9.224 10.168 9.848 11.8 11.432 14.44C13.496 11.992 14.072 10.696 14.072 8.632V8.44C14.072 6.184 13.208 5.464 11.672 5.464C10.088 5.464 9.224 6.232 9.224 8.296V8.392ZM12.632 32.536C14.024 32.536 15.032 32.248 15.848 31.72L9.032 21.16C7.928 22.456 6.824 23.896 6.824 26.344V26.584C6.824 30.04 9.032 32.536 12.632 32.536Z"
        }
      )
    }
  ) });
}
function I6(e) {
  return /* @__PURE__ */ ne(
    Tt,
    {
      alignItems: "center",
      direction: "row",
      justifyContent: "space-between",
      gap: "4px",
      children: [
        /* @__PURE__ */ D(Fe, { fontSize: "12px", sx: { opacity: 0.6 }, children: "Powered by" }),
        /* @__PURE__ */ D(
          $i,
          {
            href: "https://wormhole.com/products/connect",
            paddingBottom: "2px",
            target: "_blank",
            children: /* @__PURE__ */ ne(
              "svg",
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: "78",
                height: "8",
                viewBox: "0 0 78 8",
                fill: "none",
                children: [
                  /* @__PURE__ */ ne("g", { clipPath: "url(#icons_poweredBy_clipPath_0)", children: [
                    /* @__PURE__ */ D(
                      "path",
                      {
                        d: "M58.9654 0.5H55.3552C53.9676 0.5 52.8438 1.59108 52.8438 2.93817V5.06183C52.8438 6.40892 53.9676 7.5 55.3552 7.5H59.0508V7.49634C60.3982 7.45246 61.4769 6.38088 61.4769 5.06183V2.93817C61.4769 1.59108 60.353 0.5 58.9654 0.5ZM58.5762 6.33699H55.7445V1.66301H58.5762V6.33699Z",
                        fill: e.color
                      }
                    ),
                    /* @__PURE__ */ D(
                      "path",
                      {
                        d: "M18.8612 0.5H15.251C13.8634 0.5 12.7395 1.59108 12.7395 2.93817V5.06183C12.7395 6.40892 13.8634 7.5 15.251 7.5H18.9466V7.49634C20.294 7.45246 21.3726 6.38088 21.3726 5.06183V2.93817C21.3726 1.59108 20.2488 0.5 18.8612 0.5ZM18.4719 6.33699H15.6402V1.66301H18.4719V6.33699Z",
                        fill: e.color
                      }
                    ),
                    /* @__PURE__ */ D(
                      "path",
                      {
                        d: "M39.0683 1.71909L36.9713 5.24469V0.5H35.5184C34.6206 0.5 33.7918 0.964472 33.3435 1.71909L30.3046 6.82828L28.9673 4.58029C29.9279 4.56931 30.7039 3.80982 30.7039 2.87478V2.20672C30.7039 1.26437 29.9166 0.5 28.9459 0.5H22.0708V7.5H24.9715V4.5815H25.6195L27.3549 7.5H31.2452L34.0705 2.748V7.5H36.9713V7.49756L39.7841 2.7675V7.5H42.6848V0.5H41.242C40.3442 0.5 39.5154 0.964472 39.0671 1.71909H39.0683ZM27.8032 3.4185H24.9715V1.66301H27.8032V3.4185Z",
                        fill: e.color
                      }
                    ),
                    /* @__PURE__ */ D(
                      "path",
                      {
                        d: "M49.2273 3.4185H46.3956V0.5H43.4949V7.5H46.3956V4.5815H49.2273V7.5H52.128V0.5H49.2273V3.4185Z",
                        fill: e.color
                      }
                    ),
                    /* @__PURE__ */ D(
                      "path",
                      {
                        d: "M65.0934 0.5H62.1926V5.06183C62.1926 6.40892 63.3165 7.5 64.7041 7.5H68.8379V6.33699H65.0934V0.5Z",
                        fill: e.color
                      }
                    ),
                    /* @__PURE__ */ D(
                      "path",
                      {
                        d: "M77.5001 1.66301V0.5H72.4847H69.584V1.66301V3.4185V4.5815V6.33699V7.5H72.4847H77.5001V6.33699H72.4847V4.5815H76.4541V3.4185H72.4847V1.66301H77.5001Z",
                        fill: e.color
                      }
                    ),
                    /* @__PURE__ */ D(
                      "path",
                      {
                        d: "M11.9409 0.5L9.11555 5.252V0.5H6.21482V0.502438L3.40199 5.2325V0.5H0.5V7.5H1.94283C2.84068 7.5 3.66946 7.03553 4.11775 6.28091L6.21482 2.75531V7.5H7.6677C8.56554 7.5 9.39432 7.03553 9.84262 6.28091L13.2808 0.5H11.9409Z",
                        fill: e.color
                      }
                    )
                  ] }),
                  /* @__PURE__ */ D("defs", { children: /* @__PURE__ */ D("clipPath", { id: "icons_poweredBy_clipPath_0", children: /* @__PURE__ */ D(
                    "rect",
                    {
                      width: "77",
                      height: "7",
                      fill: e.color,
                      transform: "translate(0.5 0.5)"
                    }
                  ) }) })
                ]
              }
            )
          }
        )
      ]
    }
  );
}
function oO(e) {
  const t = or(), o = Ce(
    () => ({
      partnerLogo: {
        maxHeight: t.spacing(3)
      }
    }),
    [t]
  );
  return /* @__PURE__ */ D("img", { src: e.src, alt: "partner", style: o.partnerLogo });
}
function ll(e) {
  const t = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      alignItems: "center",
      flexDirection: "row",
      maxWidth: "100%",
      flexWrap: "wrap",
      gap: "20px 4px"
    }
  };
  return ge.ui.partnerLogo ? /* @__PURE__ */ ne(wt, { sx: t.container, children: [
    /* @__PURE__ */ D(I6, { color: e.color }),
    /* @__PURE__ */ D(iO, { color: e.color }),
    /* @__PURE__ */ D(oO, { src: ge.ui.partnerLogo })
  ] }) : /* @__PURE__ */ D(I6, { color: e.color });
}
function aO(e) {
  const t = Xr(e);
  return t.body === e ? fn(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function ts(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function N6(e) {
  return parseInt(fn(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function sO(e) {
  const o = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].includes(e.tagName), i = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return o || i;
}
function A6(e, t, o, i, c) {
  const n = [t, o, ...i];
  [].forEach.call(e.children, (d) => {
    const f = !n.includes(d), p = !sO(d);
    f && p && ts(d, c);
  });
}
function Dd(e, t) {
  let o = -1;
  return e.some((i, c) => t(i) ? (o = c, !0) : !1), o;
}
function cO(e, t) {
  const o = [], i = e.container;
  if (!t.disableScrollLock) {
    if (aO(i)) {
      const d = Sg(fn(i));
      o.push({
        value: i.style.paddingRight,
        property: "padding-right",
        el: i
      }), i.style.paddingRight = `${N6(i) + d}px`;
      const f = Xr(i).querySelectorAll(".mui-fixed");
      [].forEach.call(f, (p) => {
        o.push({
          value: p.style.paddingRight,
          property: "padding-right",
          el: p
        }), p.style.paddingRight = `${N6(p) + d}px`;
      });
    }
    let n;
    if (i.parentNode instanceof DocumentFragment)
      n = Xr(i).body;
    else {
      const d = i.parentElement, f = fn(i);
      n = (d == null ? void 0 : d.nodeName) === "HTML" && f.getComputedStyle(d).overflowY === "scroll" ? d : i;
    }
    o.push({
      value: n.style.overflow,
      property: "overflow",
      el: n
    }, {
      value: n.style.overflowX,
      property: "overflow-x",
      el: n
    }, {
      value: n.style.overflowY,
      property: "overflow-y",
      el: n
    }), n.style.overflow = "hidden";
  }
  return () => {
    o.forEach(({
      value: n,
      el: d,
      property: f
    }) => {
      n ? d.style.setProperty(f, n) : d.style.removeProperty(f);
    });
  };
}
function lO(e) {
  const t = [];
  return [].forEach.call(e.children, (o) => {
    o.getAttribute("aria-hidden") === "true" && t.push(o);
  }), t;
}
class fO {
  constructor() {
    this.modals = [], this.containers = [];
  }
  add(t, o) {
    let i = this.modals.indexOf(t);
    if (i !== -1)
      return i;
    i = this.modals.length, this.modals.push(t), t.modalRef && ts(t.modalRef, !1);
    const c = lO(o);
    A6(o, t.mount, t.modalRef, c, !0);
    const n = Dd(this.containers, (d) => d.container === o);
    return n !== -1 ? (this.containers[n].modals.push(t), i) : (this.containers.push({
      modals: [t],
      container: o,
      restore: null,
      hiddenSiblings: c
    }), i);
  }
  mount(t, o) {
    const i = Dd(this.containers, (n) => n.modals.includes(t)), c = this.containers[i];
    c.restore || (c.restore = cO(c, o));
  }
  remove(t, o = !0) {
    const i = this.modals.indexOf(t);
    if (i === -1)
      return i;
    const c = Dd(this.containers, (d) => d.modals.includes(t)), n = this.containers[c];
    if (n.modals.splice(n.modals.indexOf(t), 1), this.modals.splice(i, 1), n.modals.length === 0)
      n.restore && n.restore(), t.modalRef && ts(t.modalRef, o), A6(n.container, t.mount, t.modalRef, n.hiddenSiblings, !1), this.containers.splice(c, 1);
    else {
      const d = n.modals[n.modals.length - 1];
      d.modalRef && ts(d.modalRef, !1);
    }
    return i;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
const uO = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function dO(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function hO(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (i) => e.ownerDocument.querySelector(`input[type="radio"]${i}`);
  let o = t(`[name="${e.name}"]:checked`);
  return o || (o = t(`[name="${e.name}"]`)), o !== e;
}
function pO(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || hO(e));
}
function gO(e) {
  const t = [], o = [];
  return Array.from(e.querySelectorAll(uO)).forEach((i, c) => {
    const n = dO(i);
    n === -1 || !pO(i) || (n === 0 ? t.push(i) : o.push({
      documentOrder: c,
      tabIndex: n,
      node: i
    }));
  }), o.sort((i, c) => i.tabIndex === c.tabIndex ? i.documentOrder - c.documentOrder : i.tabIndex - c.tabIndex).map((i) => i.node).concat(t);
}
function yO() {
  return !0;
}
function mc(e) {
  const {
    children: t,
    disableAutoFocus: o = !1,
    disableEnforceFocus: i = !1,
    disableRestoreFocus: c = !1,
    getTabbable: n = gO,
    isEnabled: d = yO,
    open: f
  } = e, p = ue.useRef(!1), l = ue.useRef(null), h = ue.useRef(null), y = ue.useRef(null), M = ue.useRef(null), C = ue.useRef(!1), N = ue.useRef(null), w = zr(zo(t), N), S = ue.useRef(null);
  ue.useEffect(() => {
    !f || !N.current || (C.current = !o);
  }, [o, f]), ue.useEffect(() => {
    if (!f || !N.current)
      return;
    const j = Xr(N.current);
    return N.current.contains(j.activeElement) || (N.current.hasAttribute("tabIndex") || (fe.process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), N.current.setAttribute("tabIndex", "-1")), C.current && N.current.focus()), () => {
      c || (y.current && y.current.focus && (p.current = !0, y.current.focus()), y.current = null);
    };
  }, [f]), ue.useEffect(() => {
    if (!f || !N.current)
      return;
    const j = Xr(N.current), O = (H) => {
      S.current = H, !(i || !d() || H.key !== "Tab") && j.activeElement === N.current && H.shiftKey && (p.current = !0, h.current && h.current.focus());
    }, z = () => {
      var U, B;
      const H = N.current;
      if (H === null)
        return;
      if (!j.hasFocus() || !d() || p.current) {
        p.current = !1;
        return;
      }
      if (H.contains(j.activeElement) || i && j.activeElement !== l.current && j.activeElement !== h.current)
        return;
      if (j.activeElement !== M.current)
        M.current = null;
      else if (M.current !== null)
        return;
      if (!C.current)
        return;
      let W = [];
      if ((j.activeElement === l.current || j.activeElement === h.current) && (W = n(N.current)), W.length > 0) {
        const I = !!((U = S.current) != null && U.shiftKey && ((B = S.current) == null ? void 0 : B.key) === "Tab"), r = W[0], s = W[W.length - 1];
        typeof r != "string" && typeof s != "string" && (I ? s.focus() : r.focus());
      } else
        H.focus();
    };
    j.addEventListener("focusin", z), j.addEventListener("keydown", O, !0);
    const k = setInterval(() => {
      j.activeElement && j.activeElement.tagName === "BODY" && z();
    }, 50);
    return () => {
      clearInterval(k), j.removeEventListener("focusin", z), j.removeEventListener("keydown", O, !0);
    };
  }, [o, i, c, d, f, n]);
  const T = (j) => {
    y.current === null && (y.current = j.relatedTarget), C.current = !0, M.current = j.target;
    const O = t.props.onFocus;
    O && O(j);
  }, E = (j) => {
    y.current === null && (y.current = j.relatedTarget), C.current = !0;
  };
  return /* @__PURE__ */ ne(ue.Fragment, {
    children: [/* @__PURE__ */ D("div", {
      tabIndex: f ? 0 : -1,
      onFocus: E,
      ref: l,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ ue.cloneElement(t, {
      ref: w,
      onFocus: T
    }), /* @__PURE__ */ D("div", {
      tabIndex: f ? 0 : -1,
      onFocus: E,
      ref: h,
      "data-testid": "sentinelEnd"
    })]
  });
}
fe.process.env.NODE_ENV !== "production" && (mc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: Oo,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: b.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: b.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: b.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: b.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: b.func,
  /**
   * If `true`, focus is locked.
   */
  open: b.bool.isRequired
});
fe.process.env.NODE_ENV !== "production" && (mc.propTypes = X1(mc.propTypes));
const MO = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, lm = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = or(), c = {
    enter: i.transitions.duration.enteringScreen,
    exit: i.transitions.duration.leavingScreen
  }, {
    addEndListener: n,
    appear: d = !0,
    children: f,
    easing: p,
    in: l,
    onEnter: h,
    onEntered: y,
    onEntering: M,
    onExit: C,
    onExited: N,
    onExiting: w,
    style: S,
    timeout: T = c,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: E = Vn,
    ...j
  } = t, O = ue.useRef(null), z = zr(O, zo(f), o), k = (u) => (g) => {
    if (u) {
      const v = O.current;
      g === void 0 ? u(v) : u(v, g);
    }
  }, H = k(M), W = k((u, g) => {
    zh(u);
    const v = wi({
      style: S,
      timeout: T,
      easing: p
    }, {
      mode: "enter"
    });
    u.style.webkitTransition = i.transitions.create("opacity", v), u.style.transition = i.transitions.create("opacity", v), h && h(u, g);
  }), U = k(y), B = k(w), I = k((u) => {
    const g = wi({
      style: S,
      timeout: T,
      easing: p
    }, {
      mode: "exit"
    });
    u.style.webkitTransition = i.transitions.create("opacity", g), u.style.transition = i.transitions.create("opacity", g), C && C(u);
  }), r = k(N);
  return /* @__PURE__ */ D(E, {
    appear: d,
    in: l,
    nodeRef: O,
    onEnter: W,
    onEntered: U,
    onEntering: H,
    onExit: I,
    onExited: r,
    onExiting: B,
    addEndListener: (u) => {
      n && n(O.current, u);
    },
    timeout: T,
    ...j,
    children: (u, {
      ownerState: g,
      ...v
    }) => /* @__PURE__ */ ue.cloneElement(f, {
      style: {
        opacity: 0,
        visibility: u === "exited" && !l ? "hidden" : void 0,
        ...MO[u],
        ...S,
        ...f.props.style
      },
      ref: z,
      ...v
    })
  });
});
fe.process.env.NODE_ENV !== "production" && (lm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: b.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: b.bool,
  /**
   * A single child content element.
   */
  children: Oo.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: b.oneOfType([b.shape({
    enter: b.string,
    exit: b.string
  }), b.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: b.bool,
  /**
   * @ignore
   */
  onEnter: b.func,
  /**
   * @ignore
   */
  onEntered: b.func,
  /**
   * @ignore
   */
  onEntering: b.func,
  /**
   * @ignore
   */
  onExit: b.func,
  /**
   * @ignore
   */
  onExited: b.func,
  /**
   * @ignore
   */
  onExiting: b.func,
  /**
   * @ignore
   */
  style: b.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: b.oneOfType([b.number, b.shape({
    appear: b.number,
    enter: b.number,
    exit: b.number
  })])
});
function mO(e) {
  return Bt("MuiBackdrop", e);
}
Ft("MuiBackdrop", ["root", "invisible"]);
const vO = (e) => {
  const {
    classes: t,
    invisible: o
  } = e;
  return Rt({
    root: ["root", o && "invisible"]
  }, mO, t);
}, bO = Ke("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.invisible && t.invisible];
  }
})({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent",
  variants: [{
    props: {
      invisible: !0
    },
    style: {
      backgroundColor: "transparent"
    }
  }]
}), Qh = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: c,
    className: n,
    component: d = "div",
    invisible: f = !1,
    open: p,
    components: l = {},
    componentsProps: h = {},
    slotProps: y = {},
    slots: M = {},
    TransitionComponent: C,
    transitionDuration: N,
    ...w
  } = i, S = {
    ...i,
    component: d,
    invisible: f
  }, T = vO(S), E = {
    transition: C,
    root: l.Root,
    ...M
  }, j = {
    ...h,
    ...y
  }, O = {
    slots: E,
    slotProps: j
  }, [z, k] = qt("root", {
    elementType: bO,
    externalForwardedProps: O,
    className: It(T.root, n),
    ownerState: S
  }), [H, W] = qt("transition", {
    elementType: lm,
    externalForwardedProps: O,
    ownerState: S
  });
  return /* @__PURE__ */ D(H, {
    in: p,
    timeout: N,
    ...w,
    ...W,
    children: /* @__PURE__ */ D(z, {
      "aria-hidden": !0,
      ...k,
      classes: T,
      ref: o,
      children: c
    })
  });
});
fe.process.env.NODE_ENV !== "production" && (Qh.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: b.shape({
    Root: b.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: b.shape({
    root: b.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: b.bool,
  /**
   * If `true`, the component is shown.
   */
  open: b.bool.isRequired,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: b.shape({
    root: b.oneOfType([b.func, b.object]),
    transition: b.oneOfType([b.func, b.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: b.shape({
    root: b.elementType,
    transition: b.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: b.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: b.oneOfType([b.number, b.shape({
    appear: b.number,
    enter: b.number,
    exit: b.number
  })])
});
function xO(e) {
  return typeof e == "function" ? e() : e;
}
function wO(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const T6 = () => {
}, A0 = new fO();
function CO(e) {
  const {
    container: t,
    disableEscapeKeyDown: o = !1,
    disableScrollLock: i = !1,
    closeAfterTransition: c = !1,
    onTransitionEnter: n,
    onTransitionExited: d,
    children: f,
    onClose: p,
    open: l,
    rootRef: h
  } = e, y = ue.useRef({}), M = ue.useRef(null), C = ue.useRef(null), N = zr(C, h), [w, S] = ue.useState(!l), T = wO(f);
  let E = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (E = !1);
  const j = () => Xr(M.current), O = () => (y.current.modalRef = C.current, y.current.mount = M.current, y.current), z = () => {
    A0.mount(O(), {
      disableScrollLock: i
    }), C.current && (C.current.scrollTop = 0);
  }, k = _n(() => {
    const g = xO(t) || j().body;
    A0.add(O(), g), C.current && z();
  }), H = () => A0.isTopModal(O()), W = _n((g) => {
    M.current = g, g && (l && H() ? z() : C.current && ts(C.current, E));
  }), U = ue.useCallback(() => {
    A0.remove(O(), E);
  }, [E]);
  ue.useEffect(() => () => {
    U();
  }, [U]), ue.useEffect(() => {
    l ? k() : (!T || !c) && U();
  }, [l, U, T, c, k]);
  const B = (g) => (v) => {
    var A;
    (A = g.onKeyDown) == null || A.call(g, v), !(v.key !== "Escape" || v.which === 229 || // Wait until IME is settled.
    !H()) && (o || (v.stopPropagation(), p && p(v, "escapeKeyDown")));
  }, I = (g) => (v) => {
    var A;
    (A = g.onClick) == null || A.call(g, v), v.target === v.currentTarget && p && p(v, "backdropClick");
  };
  return {
    getRootProps: (g = {}) => {
      const v = _g(e);
      delete v.onTransitionEnter, delete v.onTransitionExited;
      const A = {
        ...v,
        ...g
      };
      return {
        /*
         * Marking an element with the role presentation indicates to assistive technology
         * that this element should be ignored; it exists to support the web application and
         * is not meant for humans to interact with directly.
         * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
         */
        role: "presentation",
        ...A,
        onKeyDown: B(A),
        ref: N
      };
    },
    getBackdropProps: (g = {}) => {
      const v = g;
      return {
        "aria-hidden": !0,
        ...v,
        onClick: I(v),
        open: l
      };
    },
    getTransitionProps: () => {
      const g = () => {
        S(!1), n && n();
      }, v = () => {
        S(!0), d && d(), c && U();
      };
      return {
        onEnter: E2(g, (f == null ? void 0 : f.props.onEnter) ?? T6),
        onExited: E2(v, (f == null ? void 0 : f.props.onExited) ?? T6)
      };
    },
    rootRef: N,
    portalRef: W,
    isTopModal: H,
    exited: w,
    hasTransition: T
  };
}
function IO(e) {
  return Bt("MuiModal", e);
}
Ft("MuiModal", ["root", "hidden", "backdrop"]);
const NO = (e) => {
  const {
    open: t,
    exited: o,
    classes: i
  } = e;
  return Rt({
    root: ["root", !t && o && "hidden"],
    backdrop: ["backdrop"]
  }, IO, i);
}, AO = Ke("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, !o.open && o.exited && t.hidden];
  }
})(kt(({
  theme: e
}) => ({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  variants: [{
    props: ({
      ownerState: t
    }) => !t.open && t.exited,
    style: {
      visibility: "hidden"
    }
  }]
}))), TO = Ke(Qh, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), fl = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: c = TO,
    BackdropProps: n,
    classes: d,
    className: f,
    closeAfterTransition: p = !1,
    children: l,
    container: h,
    component: y,
    components: M = {},
    componentsProps: C = {},
    disableAutoFocus: N = !1,
    disableEnforceFocus: w = !1,
    disableEscapeKeyDown: S = !1,
    disablePortal: T = !1,
    disableRestoreFocus: E = !1,
    disableScrollLock: j = !1,
    hideBackdrop: O = !1,
    keepMounted: z = !1,
    onBackdropClick: k,
    onClose: H,
    onTransitionEnter: W,
    onTransitionExited: U,
    open: B,
    slotProps: I = {},
    slots: r = {},
    // eslint-disable-next-line react/prop-types
    theme: s,
    ...u
  } = i, g = {
    ...i,
    closeAfterTransition: p,
    disableAutoFocus: N,
    disableEnforceFocus: w,
    disableEscapeKeyDown: S,
    disablePortal: T,
    disableRestoreFocus: E,
    disableScrollLock: j,
    hideBackdrop: O,
    keepMounted: z
  }, {
    getRootProps: v,
    getBackdropProps: A,
    getTransitionProps: L,
    portalRef: m,
    isTopModal: a,
    exited: x,
    hasTransition: V
  } = CO({
    ...g,
    rootRef: o
  }), G = {
    ...g,
    exited: x
  }, Z = NO(G), te = {};
  if (l.props.tabIndex === void 0 && (te.tabIndex = "-1"), V) {
    const {
      onEnter: P,
      onExited: _
    } = L();
    te.onEnter = P, te.onExited = _;
  }
  const q = {
    slots: {
      root: M.Root,
      backdrop: M.Backdrop,
      ...r
    },
    slotProps: {
      ...C,
      ...I
    }
  }, [R, Q] = qt("root", {
    ref: o,
    elementType: AO,
    externalForwardedProps: {
      ...q,
      ...u,
      component: y
    },
    getSlotProps: v,
    ownerState: G,
    className: It(f, Z == null ? void 0 : Z.root, !G.open && G.exited && (Z == null ? void 0 : Z.hidden))
  }), [$, F] = qt("backdrop", {
    ref: n == null ? void 0 : n.ref,
    elementType: c,
    externalForwardedProps: q,
    shouldForwardComponentProp: !0,
    additionalProps: n,
    getSlotProps: (P) => A({
      ...P,
      onClick: (_) => {
        k && k(_), P != null && P.onClick && P.onClick(_);
      }
    }),
    className: It(n == null ? void 0 : n.className, Z == null ? void 0 : Z.backdrop),
    ownerState: G
  });
  return !z && !B && (!V || x) ? null : /* @__PURE__ */ D(vs, {
    ref: m,
    container: h,
    disablePortal: T,
    children: /* @__PURE__ */ ne(R, {
      ...Q,
      children: [!O && c ? /* @__PURE__ */ D($, {
        ...F
      }) : null, /* @__PURE__ */ D(mc, {
        disableEnforceFocus: w,
        disableAutoFocus: N,
        disableRestoreFocus: E,
        isEnabled: a,
        open: B,
        children: /* @__PURE__ */ ue.cloneElement(l, te)
      })]
    })
  });
});
fe.process.env.NODE_ENV !== "production" && (fl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: b.elementType,
  /**
   * Props applied to the [`Backdrop`](https://mui.com/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: b.object,
  /**
   * A single child content element.
   */
  children: Oo.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: b.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: b.shape({
    Backdrop: b.elementType,
    Root: b.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: b.shape({
    backdrop: b.oneOfType([b.func, b.object]),
    root: b.oneOfType([b.func, b.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: b.oneOfType([ci, b.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: b.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: b.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: b.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: b.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: b.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: b.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: b.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: b.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: b.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: b.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: b.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: b.func,
  /**
   * If `true`, the component is shown.
   */
  open: b.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: b.shape({
    backdrop: b.oneOfType([b.func, b.object]),
    root: b.oneOfType([b.func, b.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: b.shape({
    backdrop: b.elementType,
    root: b.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object])
});
function LO(e, t, o) {
  const i = t.getBoundingClientRect(), c = o && o.getBoundingClientRect(), n = fn(t);
  let d;
  if (t.fakeTransform)
    d = t.fakeTransform;
  else {
    const l = n.getComputedStyle(t);
    d = l.getPropertyValue("-webkit-transform") || l.getPropertyValue("transform");
  }
  let f = 0, p = 0;
  if (d && d !== "none" && typeof d == "string") {
    const l = d.split("(")[1].split(")")[0].split(",");
    f = parseInt(l[4], 10), p = parseInt(l[5], 10);
  }
  return e === "left" ? c ? `translateX(${c.right + f - i.left}px)` : `translateX(${n.innerWidth + f - i.left}px)` : e === "right" ? c ? `translateX(-${i.right - c.left - f}px)` : `translateX(-${i.left + i.width - f}px)` : e === "up" ? c ? `translateY(${c.bottom + p - i.top}px)` : `translateY(${n.innerHeight + p - i.top}px)` : c ? `translateY(-${i.top - c.top + i.height - p}px)` : `translateY(-${i.top + i.height - p}px)`;
}
function fm(e) {
  return typeof e == "function" ? e() : e;
}
function T0(e, t, o) {
  const i = fm(o), c = LO(e, t, i);
  c && (t.style.webkitTransform = c, t.style.transform = c);
}
const um = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = or(), c = {
    enter: i.transitions.easing.easeOut,
    exit: i.transitions.easing.sharp
  }, n = {
    enter: i.transitions.duration.enteringScreen,
    exit: i.transitions.duration.leavingScreen
  }, {
    addEndListener: d,
    appear: f = !0,
    children: p,
    container: l,
    direction: h = "down",
    easing: y = c,
    in: M,
    onEnter: C,
    onEntered: N,
    onEntering: w,
    onExit: S,
    onExited: T,
    onExiting: E,
    style: j,
    timeout: O = n,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: z = Vn,
    ...k
  } = t, H = ue.useRef(null), W = zr(zo(p), H, o), U = (L) => (m) => {
    L && (m === void 0 ? L(H.current) : L(H.current, m));
  }, B = U((L, m) => {
    T0(h, L, l), zh(L), C && C(L, m);
  }), I = U((L, m) => {
    const a = wi({
      timeout: O,
      style: j,
      easing: y
    }, {
      mode: "enter"
    });
    L.style.webkitTransition = i.transitions.create("-webkit-transform", {
      ...a
    }), L.style.transition = i.transitions.create("transform", {
      ...a
    }), L.style.webkitTransform = "none", L.style.transform = "none", w && w(L, m);
  }), r = U(N), s = U(E), u = U((L) => {
    const m = wi({
      timeout: O,
      style: j,
      easing: y
    }, {
      mode: "exit"
    });
    L.style.webkitTransition = i.transitions.create("-webkit-transform", m), L.style.transition = i.transitions.create("transform", m), T0(h, L, l), S && S(L);
  }), g = U((L) => {
    L.style.webkitTransition = "", L.style.transition = "", T && T(L);
  }), v = (L) => {
    d && d(H.current, L);
  }, A = ue.useCallback(() => {
    H.current && T0(h, H.current, l);
  }, [h, l]);
  return ue.useEffect(() => {
    if (M || h === "down" || h === "right")
      return;
    const L = K1(() => {
      H.current && T0(h, H.current, l);
    }), m = fn(H.current);
    return m.addEventListener("resize", L), () => {
      L.clear(), m.removeEventListener("resize", L);
    };
  }, [h, M, l]), ue.useEffect(() => {
    M || A();
  }, [M, A]), /* @__PURE__ */ D(z, {
    nodeRef: H,
    onEnter: B,
    onEntered: r,
    onEntering: I,
    onExit: u,
    onExited: g,
    onExiting: s,
    addEndListener: v,
    appear: f,
    in: M,
    timeout: O,
    ...k,
    children: (L, {
      ownerState: m,
      ...a
    }) => /* @__PURE__ */ ue.cloneElement(p, {
      ref: W,
      style: {
        visibility: L === "exited" && !M ? "hidden" : void 0,
        ...j,
        ...p.props.style
      },
      ...a
    })
  });
});
fe.process.env.NODE_ENV !== "production" && (um.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: b.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: b.bool,
  /**
   * A single child content element.
   */
  children: Oo.isRequired,
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the container the Slide is transitioning from.
   */
  container: qn(b.oneOfType([ci, b.func]), (e) => {
    if (e.open) {
      const t = fm(e.container);
      if (t && t.nodeType === 1) {
        const o = t.getBoundingClientRect();
        if (fe.process.env.NODE_ENV !== "test" && o.top === 0 && o.left === 0 && o.right === 0 && o.bottom === 0)
          return new Error(["MUI: The `container` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `container` prop provided to the component is invalid.", "It should be an HTML element instance."].join(`
`));
    }
    return null;
  }),
  /**
   * Direction the child node will enter from.
   * @default 'down'
   */
  direction: b.oneOf(["down", "left", "right", "up"]),
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   * @default {
   *   enter: theme.transitions.easing.easeOut,
   *   exit: theme.transitions.easing.sharp,
   * }
   */
  easing: b.oneOfType([b.shape({
    enter: b.string,
    exit: b.string
  }), b.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: b.bool,
  /**
   * @ignore
   */
  onEnter: b.func,
  /**
   * @ignore
   */
  onEntered: b.func,
  /**
   * @ignore
   */
  onEntering: b.func,
  /**
   * @ignore
   */
  onExit: b.func,
  /**
   * @ignore
   */
  onExited: b.func,
  /**
   * @ignore
   */
  onExiting: b.func,
  /**
   * @ignore
   */
  style: b.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: b.oneOfType([b.number, b.shape({
    appear: b.number,
    enter: b.number,
    exit: b.number
  })])
});
function SO(e) {
  return Bt("MuiPaper", e);
}
Ft("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const EO = (e) => {
  const {
    square: t,
    elevation: o,
    variant: i,
    classes: c
  } = e, n = {
    root: ["root", i, !t && "rounded", i === "elevation" && `elevation${o}`]
  };
  return Rt(n, SO, c);
}, DO = Ke("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.variant], !o.square && t.rounded, o.variant === "elevation" && t[`elevation${o.elevation}`]];
  }
})(kt(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  color: (e.vars || e).palette.text.primary,
  transition: e.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState: t
    }) => !t.square,
    style: {
      borderRadius: e.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), ul = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  var C;
  const i = Pt({
    props: t,
    name: "MuiPaper"
  }), c = or(), {
    className: n,
    component: d = "div",
    elevation: f = 1,
    square: p = !1,
    variant: l = "elevation",
    ...h
  } = i, y = {
    ...i,
    component: d,
    elevation: f,
    square: p,
    variant: l
  }, M = EO(y);
  return fe.process.env.NODE_ENV !== "production" && c.shadows[f] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${f}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${f}]\` is defined.`].join(`
`)), /* @__PURE__ */ D(DO, {
    as: d,
    ownerState: y,
    className: It(M.root, n),
    ref: o,
    ...h,
    style: {
      ...l === "elevation" && {
        "--Paper-shadow": (c.vars || c).shadows[f],
        ...c.vars && {
          "--Paper-overlay": (C = c.vars.overlays) == null ? void 0 : C[f]
        },
        ...!c.vars && c.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${ur("#fff", $d(f))}, ${ur("#fff", $d(f))})`
        }
      },
      ...h.style
    }
  });
});
fe.process.env.NODE_ENV !== "production" && (ul.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: qn(eh, (e) => {
    const {
      elevation: t,
      variant: o
    } = e;
    return t > 0 && o === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${o}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: b.bool,
  /**
   * @ignore
   */
  style: b.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: b.oneOfType([b.oneOf(["elevation", "outlined"]), b.string])
});
function jO(e) {
  return Bt("MuiDrawer", e);
}
Ft("MuiDrawer", ["root", "docked", "paper", "anchorLeft", "anchorRight", "anchorTop", "anchorBottom", "paperAnchorLeft", "paperAnchorRight", "paperAnchorTop", "paperAnchorBottom", "paperAnchorDockedLeft", "paperAnchorDockedRight", "paperAnchorDockedTop", "paperAnchorDockedBottom", "modal"]);
const dm = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.root, (o.variant === "permanent" || o.variant === "persistent") && t.docked, t.modal];
}, OO = (e) => {
  const {
    classes: t,
    anchor: o,
    variant: i
  } = e, c = {
    root: ["root", `anchor${it(o)}`],
    docked: [(i === "permanent" || i === "persistent") && "docked"],
    modal: ["modal"],
    paper: ["paper", `paperAnchor${it(o)}`, i !== "temporary" && `paperAnchorDocked${it(o)}`]
  };
  return Rt(c, jO, t);
}, zO = Ke(fl, {
  name: "MuiDrawer",
  slot: "Root",
  overridesResolver: dm
})(kt(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.drawer
}))), kO = Ke("div", {
  shouldForwardProp: hn,
  name: "MuiDrawer",
  slot: "Docked",
  skipVariantsResolver: !1,
  overridesResolver: dm
})({
  flex: "0 0 auto"
}), _O = Ke(ul, {
  name: "MuiDrawer",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.paper, t[`paperAnchor${it(o.anchor)}`], o.variant !== "temporary" && t[`paperAnchorDocked${it(o.anchor)}`]];
  }
})(kt(({
  theme: e
}) => ({
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  flex: "1 0 auto",
  zIndex: (e.vars || e).zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  // temporary style
  position: "fixed",
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0,
  variants: [{
    props: {
      anchor: "left"
    },
    style: {
      left: 0
    }
  }, {
    props: {
      anchor: "top"
    },
    style: {
      top: 0,
      left: 0,
      right: 0,
      height: "auto",
      maxHeight: "100%"
    }
  }, {
    props: {
      anchor: "right"
    },
    style: {
      right: 0
    }
  }, {
    props: {
      anchor: "bottom"
    },
    style: {
      top: "auto",
      left: 0,
      bottom: 0,
      right: 0,
      height: "auto",
      maxHeight: "100%"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "left" && t.variant !== "temporary",
    style: {
      borderRight: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "top" && t.variant !== "temporary",
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "right" && t.variant !== "temporary",
    style: {
      borderLeft: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "bottom" && t.variant !== "temporary",
    style: {
      borderTop: `1px solid ${(e.vars || e).palette.divider}`
    }
  }]
}))), hm = {
  left: "right",
  right: "left",
  top: "down",
  bottom: "up"
};
function co(e) {
  return ["left", "right"].includes(e);
}
function Va({
  direction: e
}, t) {
  return e === "rtl" && co(t) ? hm[t] : t;
}
const dl = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiDrawer"
  }), c = or(), n = Ss(), d = {
    enter: c.transitions.duration.enteringScreen,
    exit: c.transitions.duration.leavingScreen
  }, {
    anchor: f = "left",
    BackdropProps: p,
    children: l,
    className: h,
    elevation: y = 16,
    hideBackdrop: M = !1,
    ModalProps: {
      BackdropProps: C,
      ...N
    } = {},
    onClose: w,
    open: S = !1,
    PaperProps: T = {},
    SlideProps: E,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: j,
    transitionDuration: O = d,
    variant: z = "temporary",
    slots: k = {},
    slotProps: H = {},
    ...W
  } = i, U = ue.useRef(!1);
  ue.useEffect(() => {
    U.current = !0;
  }, []);
  const B = Va({
    direction: n ? "rtl" : "ltr"
  }, f), r = {
    ...i,
    anchor: f,
    elevation: y,
    open: S,
    variant: z,
    ...W
  }, s = OO(r), u = {
    slots: {
      transition: j,
      ...k
    },
    slotProps: {
      paper: T,
      transition: E,
      ...H,
      backdrop: uc(H.backdrop || {
        ...p,
        ...C
      }, {
        transitionDuration: O
      })
    }
  }, [g, v] = qt("root", {
    ref: o,
    elementType: zO,
    className: It(s.root, s.modal, h),
    shouldForwardComponentProp: !0,
    ownerState: r,
    externalForwardedProps: {
      ...u,
      ...W,
      ...N
    },
    additionalProps: {
      open: S,
      onClose: w,
      hideBackdrop: M,
      slots: {
        backdrop: u.slots.backdrop
      },
      slotProps: {
        backdrop: u.slotProps.backdrop
      }
    }
  }), [A, L] = qt("paper", {
    elementType: _O,
    shouldForwardComponentProp: !0,
    className: It(s.paper, T.className),
    ownerState: r,
    externalForwardedProps: u,
    additionalProps: {
      elevation: z === "temporary" ? y : 0,
      square: !0
    }
  }), [m, a] = qt("docked", {
    elementType: kO,
    ref: o,
    className: It(s.root, s.docked, h),
    ownerState: r,
    externalForwardedProps: u,
    additionalProps: W
    // pass `other` here because `DockedSlot` is also a root slot for some variants
  }), [x, V] = qt("transition", {
    elementType: um,
    ownerState: r,
    externalForwardedProps: u,
    additionalProps: {
      in: S,
      direction: hm[B],
      timeout: O,
      appear: U.current
    }
  }), G = /* @__PURE__ */ D(A, {
    ...L,
    children: l
  });
  if (z === "permanent")
    return /* @__PURE__ */ D(m, {
      ...a,
      children: G
    });
  const Z = /* @__PURE__ */ D(x, {
    ...V,
    children: G
  });
  return z === "persistent" ? /* @__PURE__ */ D(m, {
    ...a,
    children: Z
  }) : /* @__PURE__ */ D(g, {
    ...v,
    children: Z
  });
});
fe.process.env.NODE_ENV !== "production" && (dl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Side from which the drawer will appear.
   * @default 'left'
   */
  anchor: b.oneOf(["bottom", "left", "right", "top"]),
  /**
   * @ignore
   */
  BackdropProps: b.object,
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The elevation of the drawer.
   * @default 16
   */
  elevation: eh,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: b.bool,
  /**
   * Props applied to the [`Modal`](https://mui.com/material-ui/api/modal/) element.
   * @default {}
   */
  ModalProps: b.object,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: b.func,
  /**
   * If `true`, the component is shown.
   * @default false
   */
  open: b.bool,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @deprecated use the `slotProps.paper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  PaperProps: b.object,
  /**
   * Props applied to the [`Slide`](https://mui.com/material-ui/api/slide/) element.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SlideProps: b.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: b.shape({
    backdrop: b.oneOfType([b.func, b.object]),
    docked: b.oneOfType([b.func, b.object]),
    paper: b.oneOfType([b.func, b.object]),
    root: b.oneOfType([b.func, b.object]),
    transition: b.oneOfType([b.func, b.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: b.shape({
    backdrop: b.elementType,
    docked: b.elementType,
    paper: b.elementType,
    root: b.elementType,
    transition: b.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: b.oneOfType([b.number, b.shape({
    appear: b.number,
    enter: b.number,
    exit: b.number
  })]),
  /**
   * The variant to use.
   * @default 'temporary'
   */
  variant: b.oneOf(["permanent", "persistent", "temporary"])
});
const qs = /* @__PURE__ */ ue.createContext(void 0);
fe.process.env.NODE_ENV !== "production" && (qs.displayName = "FormControlContext");
function qi() {
  return ue.useContext(qs);
}
function BO(e) {
  return Bt("MuiInputAdornment", e);
}
const L6 = Ft("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var S6;
const FO = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.root, t[`position${it(o.position)}`], o.disablePointerEvents === !0 && t.disablePointerEvents, t[o.variant]];
}, RO = (e) => {
  const {
    classes: t,
    disablePointerEvents: o,
    hiddenLabel: i,
    position: c,
    size: n,
    variant: d
  } = e, f = {
    root: ["root", o && "disablePointerEvents", c && `position${it(c)}`, d, i && "hiddenLabel", n && `size${it(n)}`]
  };
  return Rt(f, BO, t);
}, PO = Ke("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: FO
})(kt(({
  theme: e
}) => ({
  display: "flex",
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active,
  variants: [{
    props: {
      variant: "filled"
    },
    style: {
      [`&.${L6.positionStart}&:not(.${L6.hiddenLabel})`]: {
        marginTop: 16
      }
    }
  }, {
    props: {
      position: "start"
    },
    style: {
      marginRight: 8
    }
  }, {
    props: {
      position: "end"
    },
    style: {
      marginLeft: 8
    }
  }, {
    props: {
      disablePointerEvents: !0
    },
    style: {
      pointerEvents: "none"
    }
  }]
}))), Eo = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiInputAdornment"
  }), {
    children: c,
    className: n,
    component: d = "div",
    disablePointerEvents: f = !1,
    disableTypography: p = !1,
    position: l,
    variant: h,
    ...y
  } = i, M = qi() || {};
  let C = h;
  h && M.variant && fe.process.env.NODE_ENV !== "production" && h === M.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), M && !C && (C = M.variant);
  const N = {
    ...i,
    hiddenLabel: M.hiddenLabel,
    size: M.size,
    disablePointerEvents: f,
    position: l,
    variant: C
  }, w = RO(N);
  return /* @__PURE__ */ D(qs.Provider, {
    value: null,
    children: /* @__PURE__ */ D(PO, {
      as: d,
      ownerState: N,
      className: It(w.root, n),
      ref: o,
      ...y,
      children: typeof c == "string" && !p ? /* @__PURE__ */ D(Fe, {
        color: "textSecondary",
        children: c
      }) : /* @__PURE__ */ ne(ue.Fragment, {
        children: [l === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          S6 || (S6 = /* @__PURE__ */ D("span", {
            className: "notranslate",
            "aria-hidden": !0,
            children: "​"
          }))
        ) : null, c]
      })
    })
  });
});
fe.process.env.NODE_ENV !== "production" && (Eo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: b.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: b.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: b.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: b.oneOf(["filled", "outlined", "standard"])
});
const mi = /* @__PURE__ */ ue.createContext({});
fe.process.env.NODE_ENV !== "production" && (mi.displayName = "ListContext");
function UO(e) {
  return Bt("MuiList", e);
}
Ft("MuiList", ["root", "padding", "dense", "subheader"]);
const YO = (e) => {
  const {
    classes: t,
    disablePadding: o,
    dense: i,
    subheader: c
  } = e;
  return Rt({
    root: ["root", !o && "padding", i && "dense", c && "subheader"]
  }, UO, t);
}, WO = Ke("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, !o.disablePadding && t.padding, o.dense && t.dense, o.subheader && t.subheader];
  }
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: e
    }) => e.subheader,
    style: {
      paddingTop: 0
    }
  }]
}), hi = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiList"
  }), {
    children: c,
    className: n,
    component: d = "ul",
    dense: f = !1,
    disablePadding: p = !1,
    subheader: l,
    ...h
  } = i, y = ue.useMemo(() => ({
    dense: f
  }), [f]), M = {
    ...i,
    component: d,
    dense: f,
    disablePadding: p
  }, C = YO(M);
  return /* @__PURE__ */ D(mi.Provider, {
    value: y,
    children: /* @__PURE__ */ ne(WO, {
      as: d,
      className: It(C.root, n),
      ref: o,
      ownerState: M,
      ...h,
      children: [l, c]
    })
  });
});
fe.process.env.NODE_ENV !== "production" && (hi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: b.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: b.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: b.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object])
});
function bs(e) {
  return typeof e == "string";
}
function HO(e) {
  return Bt("MuiListItem", e);
}
Ft("MuiListItem", ["root", "container", "dense", "alignItemsFlexStart", "divider", "gutters", "padding", "secondaryAction"]);
function ZO(e) {
  return Bt("MuiListItemButton", e);
}
const qo = Ft("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]), QO = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.root, o.dense && t.dense, o.alignItems === "flex-start" && t.alignItemsFlexStart, o.divider && t.divider, !o.disableGutters && t.gutters];
}, VO = (e) => {
  const {
    alignItems: t,
    classes: o,
    dense: i,
    disabled: c,
    disableGutters: n,
    divider: d,
    selected: f
  } = e, l = Rt({
    root: ["root", i && "dense", !n && "gutters", d && "divider", c && "disabled", t === "flex-start" && "alignItemsFlexStart", f && "selected"]
  }, ZO, o);
  return {
    ...o,
    ...l
  };
}, GO = Ke(ko, {
  shouldForwardProp: (e) => hn(e) || e === "classes",
  name: "MuiListItemButton",
  slot: "Root",
  overridesResolver: QO
})(kt(({
  theme: e
}) => ({
  display: "flex",
  flexGrow: 1,
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minWidth: 0,
  boxSizing: "border-box",
  textAlign: "left",
  paddingTop: 8,
  paddingBottom: 8,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${qo.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : ur(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${qo.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : ur(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${qo.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : ur(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : ur(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${qo.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${qo.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }]
}))), Yr = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiListItemButton"
  }), {
    alignItems: c = "center",
    autoFocus: n = !1,
    component: d = "div",
    children: f,
    dense: p = !1,
    disableGutters: l = !1,
    divider: h = !1,
    focusVisibleClassName: y,
    selected: M = !1,
    className: C,
    ...N
  } = i, w = ue.useContext(mi), S = ue.useMemo(() => ({
    dense: p || w.dense || !1,
    alignItems: c,
    disableGutters: l
  }), [c, w.dense, p, l]), T = ue.useRef(null);
  Rn(() => {
    n && (T.current ? T.current.focus() : fe.process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a ListItemButton whose component has not been rendered."));
  }, [n]);
  const E = {
    ...i,
    alignItems: c,
    dense: S.dense,
    disableGutters: l,
    divider: h,
    selected: M
  }, j = VO(E), O = zr(T, o);
  return /* @__PURE__ */ D(mi.Provider, {
    value: S,
    children: /* @__PURE__ */ D(GO, {
      ref: O,
      href: N.href || N.to,
      component: (N.href || N.to) && d === "div" ? "button" : d,
      focusVisibleClassName: It(j.focusVisible, y),
      ownerState: E,
      className: It(j.root, C),
      ...N,
      classes: j,
      children: f
    })
  });
});
fe.process.env.NODE_ENV !== "production" && (Yr.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: b.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: b.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: b.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: b.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: b.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: b.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: b.string,
  /**
   * @ignore
   */
  href: b.string,
  /**
   * Use to apply selected styling.
   * @default false
   */
  selected: b.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object])
});
function $O(e) {
  return Bt("MuiListItemSecondaryAction", e);
}
Ft("MuiListItemSecondaryAction", ["root", "disableGutters"]);
const qO = (e) => {
  const {
    disableGutters: t,
    classes: o
  } = e;
  return Rt({
    root: ["root", t && "disableGutters"]
  }, $O, o);
}, JO = Ke("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.disableGutters && t.disableGutters];
  }
})({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)",
  variants: [{
    props: ({
      ownerState: e
    }) => e.disableGutters,
    style: {
      right: 0
    }
  }]
}), Vh = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiListItemSecondaryAction"
  }), {
    className: c,
    ...n
  } = i, d = ue.useContext(mi), f = {
    ...i,
    disableGutters: d.disableGutters
  }, p = qO(f);
  return /* @__PURE__ */ D(JO, {
    className: It(p.root, c),
    ownerState: f,
    ref: o,
    ...n
  });
});
fe.process.env.NODE_ENV !== "production" && (Vh.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object])
});
Vh.muiName = "ListItemSecondaryAction";
const XO = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.root, o.dense && t.dense, o.alignItems === "flex-start" && t.alignItemsFlexStart, o.divider && t.divider, !o.disableGutters && t.gutters, !o.disablePadding && t.padding, o.hasSecondaryAction && t.secondaryAction];
}, KO = (e) => {
  const {
    alignItems: t,
    classes: o,
    dense: i,
    disableGutters: c,
    disablePadding: n,
    divider: d,
    hasSecondaryAction: f
  } = e;
  return Rt({
    root: ["root", i && "dense", !c && "gutters", !n && "padding", d && "divider", t === "flex-start" && "alignItemsFlexStart", f && "secondaryAction"],
    container: ["container"]
  }, HO, o);
}, ez = Ke("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: XO
})(kt(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && t.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !!t.secondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.secondaryAction,
    style: {
      [`& > .${qo.root}`]: {
        paddingRight: 48
      }
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.button,
    style: {
      transition: e.transitions.create("background-color", {
        duration: e.transitions.duration.shortest
      }),
      "&:hover": {
        textDecoration: "none",
        backgroundColor: (e.vars || e).palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hasSecondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }]
}))), tz = Ke("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (e, t) => t.container
})({
  position: "relative"
}), Mi = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiListItem"
  }), {
    alignItems: c = "center",
    children: n,
    className: d,
    component: f,
    components: p = {},
    componentsProps: l = {},
    ContainerComponent: h = "li",
    ContainerProps: {
      className: y,
      ...M
    } = {},
    dense: C = !1,
    disableGutters: N = !1,
    disablePadding: w = !1,
    divider: S = !1,
    secondaryAction: T,
    slotProps: E = {},
    slots: j = {},
    ...O
  } = i, z = ue.useContext(mi), k = ue.useMemo(() => ({
    dense: C || z.dense || !1,
    alignItems: c,
    disableGutters: N
  }), [c, z.dense, C, N]), H = ue.useRef(null), W = ue.Children.toArray(n), U = W.length && qa(W[W.length - 1], ["ListItemSecondaryAction"]), B = {
    ...i,
    alignItems: c,
    dense: k.dense,
    disableGutters: N,
    disablePadding: w,
    divider: S,
    hasSecondaryAction: U
  }, I = KO(B), r = zr(H, o), s = j.root || p.Root || ez, u = E.root || l.root || {}, g = {
    className: It(I.root, u.className, d),
    ...O
  };
  let v = f || "li";
  return U ? (v = !g.component && !f ? "div" : v, h === "li" && (v === "li" ? v = "div" : g.component === "li" && (g.component = "div")), /* @__PURE__ */ D(mi.Provider, {
    value: k,
    children: /* @__PURE__ */ ne(tz, {
      as: h,
      className: It(I.container, y),
      ref: r,
      ownerState: B,
      ...M,
      children: [/* @__PURE__ */ D(s, {
        ...u,
        ...!bs(s) && {
          as: v,
          ownerState: {
            ...B,
            ...u.ownerState
          }
        },
        ...g,
        children: W
      }), W.pop()]
    })
  })) : /* @__PURE__ */ D(mi.Provider, {
    value: k,
    children: /* @__PURE__ */ ne(s, {
      ...u,
      as: v,
      ref: r,
      ...!bs(s) && {
        ownerState: {
          ...B,
          ...u.ownerState
        }
      },
      ...g,
      children: [W, T && /* @__PURE__ */ D(Vh, {
        children: T
      })]
    })
  });
});
fe.process.env.NODE_ENV !== "production" && (Mi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: b.oneOf(["center", "flex-start"]),
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: qn(b.node, (e) => {
    const t = ue.Children.toArray(e.children);
    let o = -1;
    for (let i = t.length - 1; i >= 0; i -= 1) {
      const c = t[i];
      if (qa(c, ["ListItemSecondaryAction"])) {
        o = i;
        break;
      }
    }
    return o !== -1 && o !== t.length - 1 ? new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  components: b.shape({
    Root: b.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  componentsProps: b.shape({
    root: b.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated Use the `component` or `slots.root` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerComponent: Fi,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated Use the `slotProps.root` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerProps: b.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: b.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: b.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: b.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: b.bool,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: b.node,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: b.shape({
    root: b.object
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: b.shape({
    root: b.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object])
});
function rz(e) {
  return Bt("MuiListItemIcon", e);
}
Ft("MuiListItemIcon", ["root", "alignItemsFlexStart"]);
const nz = (e) => {
  const {
    alignItems: t,
    classes: o
  } = e;
  return Rt({
    root: ["root", t === "flex-start" && "alignItemsFlexStart"]
  }, rz, o);
}, iz = Ke("div", {
  name: "MuiListItemIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.alignItems === "flex-start" && t.alignItemsFlexStart];
  }
})(kt(({
  theme: e
}) => ({
  minWidth: 56,
  color: (e.vars || e).palette.action.active,
  flexShrink: 0,
  display: "inline-flex",
  variants: [{
    props: {
      alignItems: "flex-start"
    },
    style: {
      marginTop: 8
    }
  }]
}))), Bo = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiListItemIcon"
  }), {
    className: c,
    ...n
  } = i, d = ue.useContext(mi), f = {
    ...i,
    alignItems: d.alignItems
  }, p = nz(f);
  return /* @__PURE__ */ D(iz, {
    className: It(p.root, c),
    ownerState: f,
    ref: o,
    ...n
  });
});
fe.process.env.NODE_ENV !== "production" && (Bo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object])
});
function L0(e) {
  return parseInt(e, 10) || 0;
}
const oz = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function az(e) {
  for (const t in e)
    return !1;
  return !0;
}
function E6(e) {
  return az(e) || e.outerHeightStyle === 0 && !e.overflowing;
}
const pm = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const {
    onChange: i,
    maxRows: c,
    minRows: n = 1,
    style: d,
    value: f,
    ...p
  } = t, {
    current: l
  } = ue.useRef(f != null), h = ue.useRef(null), y = zr(o, h), M = ue.useRef(null), C = ue.useRef(null), N = ue.useCallback(() => {
    const j = h.current, O = C.current;
    if (!j || !O)
      return;
    const k = fn(j).getComputedStyle(j);
    if (k.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    O.style.width = k.width, O.value = j.value || t.placeholder || "x", O.value.slice(-1) === `
` && (O.value += " ");
    const H = k.boxSizing, W = L0(k.paddingBottom) + L0(k.paddingTop), U = L0(k.borderBottomWidth) + L0(k.borderTopWidth), B = O.scrollHeight;
    O.value = "x";
    const I = O.scrollHeight;
    let r = B;
    n && (r = Math.max(Number(n) * I, r)), c && (r = Math.min(Number(c) * I, r)), r = Math.max(r, I);
    const s = r + (H === "border-box" ? W + U : 0), u = Math.abs(r - B) <= 1;
    return {
      outerHeightStyle: s,
      overflowing: u
    };
  }, [c, n, t.placeholder]), w = _n(() => {
    const j = h.current, O = N();
    if (!j || !O || E6(O))
      return !1;
    const z = O.outerHeightStyle;
    return M.current != null && M.current !== z;
  }), S = ue.useCallback(() => {
    const j = h.current, O = N();
    if (!j || !O || E6(O))
      return;
    const z = O.outerHeightStyle;
    M.current !== z && (M.current = z, j.style.height = `${z}px`), j.style.overflow = O.overflowing ? "hidden" : "";
  }, [N]), T = ue.useRef(-1);
  Rn(() => {
    const j = K1(S), O = h == null ? void 0 : h.current;
    if (!O)
      return;
    const z = fn(O);
    z.addEventListener("resize", j);
    let k;
    return typeof ResizeObserver < "u" && (k = new ResizeObserver(() => {
      w() && (k.unobserve(O), cancelAnimationFrame(T.current), S(), T.current = requestAnimationFrame(() => {
        k.observe(O);
      }));
    }), k.observe(O)), () => {
      j.clear(), cancelAnimationFrame(T.current), z.removeEventListener("resize", j), k && k.disconnect();
    };
  }, [N, S, w]), Rn(() => {
    S();
  });
  const E = (j) => {
    l || S(), i && i(j);
  };
  return /* @__PURE__ */ ne(ue.Fragment, {
    children: [/* @__PURE__ */ D("textarea", {
      value: f,
      onChange: E,
      ref: y,
      rows: n,
      style: d,
      ...p
    }), /* @__PURE__ */ D("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: C,
      tabIndex: -1,
      style: {
        ...oz.shadow,
        ...d,
        paddingTop: 0,
        paddingBottom: 0
      }
    })]
  });
});
fe.process.env.NODE_ENV !== "production" && (pm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: b.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: b.oneOfType([b.number, b.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: b.oneOfType([b.number, b.string]),
  /**
   * @ignore
   */
  onChange: b.func,
  /**
   * @ignore
   */
  placeholder: b.string,
  /**
   * @ignore
   */
  style: b.object,
  /**
   * @ignore
   */
  value: b.oneOfType([b.arrayOf(b.string), b.number, b.string])
});
function Sa({
  props: e,
  states: t,
  muiFormControl: o
}) {
  return t.reduce((i, c) => (i[c] = e[c], o && typeof e[c] > "u" && (i[c] = o[c]), i), {});
}
function D6(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function vc(e, t = !1) {
  return e && (D6(e.value) && e.value !== "" || t && D6(e.defaultValue) && e.defaultValue !== "");
}
function sz(e) {
  return e.startAdornment;
}
function cz(e) {
  return Bt("MuiInputBase", e);
}
const ba = Ft("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]);
var j6;
const hl = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.root, o.formControl && t.formControl, o.startAdornment && t.adornedStart, o.endAdornment && t.adornedEnd, o.error && t.error, o.size === "small" && t.sizeSmall, o.multiline && t.multiline, o.color && t[`color${it(o.color)}`], o.fullWidth && t.fullWidth, o.hiddenLabel && t.hiddenLabel];
}, pl = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.input, o.size === "small" && t.inputSizeSmall, o.multiline && t.inputMultiline, o.type === "search" && t.inputTypeSearch, o.startAdornment && t.inputAdornedStart, o.endAdornment && t.inputAdornedEnd, o.hiddenLabel && t.inputHiddenLabel];
}, lz = (e) => {
  const {
    classes: t,
    color: o,
    disabled: i,
    error: c,
    endAdornment: n,
    focused: d,
    formControl: f,
    fullWidth: p,
    hiddenLabel: l,
    multiline: h,
    readOnly: y,
    size: M,
    startAdornment: C,
    type: N
  } = e, w = {
    root: ["root", `color${it(o)}`, i && "disabled", c && "error", p && "fullWidth", d && "focused", f && "formControl", M && M !== "medium" && `size${it(M)}`, h && "multiline", C && "adornedStart", n && "adornedEnd", l && "hiddenLabel", y && "readOnly"],
    input: ["input", i && "disabled", N === "search" && "inputTypeSearch", h && "inputMultiline", M === "small" && "inputSizeSmall", l && "inputHiddenLabel", C && "inputAdornedStart", n && "inputAdornedEnd", y && "readOnly"]
  };
  return Rt(w, cz, t);
}, gl = Ke("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: hl
})(kt(({
  theme: e
}) => ({
  ...e.typography.body1,
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${ba.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: "4px 0 5px"
    }
  }, {
    props: ({
      ownerState: t,
      size: o
    }) => t.multiline && o === "small",
    style: {
      paddingTop: 1
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "100%"
    }
  }]
}))), yl = Ke("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: pl
})(kt(({
  theme: e
}) => {
  const t = e.palette.mode === "light", o = {
    color: "currentColor",
    ...e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: t ? 0.42 : 0.5
    },
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }, i = {
    opacity: "0 !important"
  }, c = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: t ? 0.42 : 0.5
  };
  return {
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    "&::-webkit-input-placeholder": o,
    "&::-moz-placeholder": o,
    // Firefox 19+
    "&::-ms-input-placeholder": o,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${ba.formControl} &`]: {
      "&::-webkit-input-placeholder": i,
      "&::-moz-placeholder": i,
      // Firefox 19+
      "&::-ms-input-placeholder": i,
      // Edge
      "&:focus::-webkit-input-placeholder": c,
      "&:focus::-moz-placeholder": c,
      // Firefox 19+
      "&:focus::-ms-input-placeholder": c
      // Edge
    },
    [`&.${ba.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    variants: [{
      props: ({
        ownerState: n
      }) => !n.disableInjectingGlobalStyles,
      style: {
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&:-webkit-autofill": {
          animationDuration: "5000s",
          animationName: "mui-auto-fill"
        }
      }
    }, {
      props: {
        size: "small"
      },
      style: {
        paddingTop: 1
      }
    }, {
      props: ({
        ownerState: n
      }) => n.multiline,
      style: {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
      }
    }, {
      props: {
        type: "search"
      },
      style: {
        MozAppearance: "textfield"
        // Improve type search style.
      }
    }]
  };
})), O6 = Pb({
  "@keyframes mui-auto-fill": {
    from: {
      display: "block"
    }
  },
  "@keyframes mui-auto-fill-cancel": {
    from: {
      display: "block"
    }
  }
}), Ml = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": c,
    autoComplete: n,
    autoFocus: d,
    className: f,
    color: p,
    components: l = {},
    componentsProps: h = {},
    defaultValue: y,
    disabled: M,
    disableInjectingGlobalStyles: C,
    endAdornment: N,
    error: w,
    fullWidth: S = !1,
    id: T,
    inputComponent: E = "input",
    inputProps: j = {},
    inputRef: O,
    margin: z,
    maxRows: k,
    minRows: H,
    multiline: W = !1,
    name: U,
    onBlur: B,
    onChange: I,
    onClick: r,
    onFocus: s,
    onKeyDown: u,
    onKeyUp: g,
    placeholder: v,
    readOnly: A,
    renderSuffix: L,
    rows: m,
    size: a,
    slotProps: x = {},
    slots: V = {},
    startAdornment: G,
    type: Z = "text",
    value: te,
    ...q
  } = i, R = j.value != null ? j.value : te, {
    current: Q
  } = ue.useRef(R != null), $ = ue.useRef(), F = ue.useCallback((Te) => {
    fe.process.env.NODE_ENV !== "production" && Te && Te.nodeName !== "INPUT" && !Te.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), P = zr($, O, j.ref, F), [_, X] = ue.useState(!1), le = qi();
  fe.process.env.NODE_ENV !== "production" && ue.useEffect(() => {
    if (le)
      return le.registerEffect();
  }, [le]);
  const ie = Sa({
    props: i,
    muiFormControl: le,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  ie.focused = le ? le.focused : _, ue.useEffect(() => {
    !le && M && _ && (X(!1), B && B());
  }, [le, M, _, B]);
  const oe = le && le.onFilled, pe = le && le.onEmpty, se = ue.useCallback((Te) => {
    vc(Te) ? oe && oe() : pe && pe();
  }, [oe, pe]);
  Rn(() => {
    Q && se({
      value: R
    });
  }, [R, se, Q]);
  const ce = (Te) => {
    s && s(Te), j.onFocus && j.onFocus(Te), le && le.onFocus ? le.onFocus(Te) : X(!0);
  }, me = (Te) => {
    B && B(Te), j.onBlur && j.onBlur(Te), le && le.onBlur ? le.onBlur(Te) : X(!1);
  }, de = (Te, ...Dt) => {
    if (!Q) {
      const De = Te.target || $.current;
      if (De == null)
        throw new Error(fe.process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : si(1));
      se({
        value: De.value
      });
    }
    j.onChange && j.onChange(Te, ...Dt), I && I(Te, ...Dt);
  };
  ue.useEffect(() => {
    se($.current);
  }, []);
  const ae = (Te) => {
    $.current && Te.currentTarget === Te.target && $.current.focus(), r && r(Te);
  };
  let Le = E, ye = j;
  W && Le === "input" && (m ? (fe.process.env.NODE_ENV !== "production" && (H || k) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), ye = {
    type: void 0,
    minRows: m,
    maxRows: m,
    ...ye
  }) : ye = {
    type: void 0,
    maxRows: k,
    minRows: H,
    ...ye
  }, Le = pm);
  const Me = (Te) => {
    se(Te.animationName === "mui-auto-fill-cancel" ? $.current : {
      value: "x"
    });
  };
  ue.useEffect(() => {
    le && le.setAdornedStart(!!G);
  }, [le, G]);
  const at = {
    ...i,
    color: ie.color || "primary",
    disabled: ie.disabled,
    endAdornment: N,
    error: ie.error,
    focused: ie.focused,
    formControl: le,
    fullWidth: S,
    hiddenLabel: ie.hiddenLabel,
    multiline: W,
    size: ie.size,
    startAdornment: G,
    type: Z
  }, Ne = lz(at), Ae = V.root || l.Root || gl, pt = x.root || h.root || {}, ke = V.input || l.Input || yl;
  return ye = {
    ...ye,
    ...x.input ?? h.input
  }, /* @__PURE__ */ ne(ue.Fragment, {
    children: [!C && typeof O6 == "function" && // For Emotion/Styled-components, InputGlobalStyles will be a function
    // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
    (j6 || (j6 = /* @__PURE__ */ D(O6, {}))), /* @__PURE__ */ ne(Ae, {
      ...pt,
      ref: o,
      onClick: ae,
      ...q,
      ...!bs(Ae) && {
        ownerState: {
          ...at,
          ...pt.ownerState
        }
      },
      className: It(Ne.root, pt.className, f, A && "MuiInputBase-readOnly"),
      children: [G, /* @__PURE__ */ D(qs.Provider, {
        value: null,
        children: /* @__PURE__ */ D(ke, {
          "aria-invalid": ie.error,
          "aria-describedby": c,
          autoComplete: n,
          autoFocus: d,
          defaultValue: y,
          disabled: ie.disabled,
          id: T,
          onAnimationStart: Me,
          name: U,
          placeholder: v,
          readOnly: A,
          required: ie.required,
          rows: m,
          value: R,
          onKeyDown: u,
          onKeyUp: g,
          type: Z,
          ...ye,
          ...!bs(ke) && {
            as: Le,
            ownerState: {
              ...at,
              ...ye.ownerState
            }
          },
          ref: P,
          className: It(Ne.input, ye.className, A && "MuiInputBase-readOnly"),
          onBlur: me,
          onChange: de,
          onFocus: ce
        })
      }), N, L ? L({
        ...ie,
        startAdornment: G
      }) : null]
    })]
  });
});
fe.process.env.NODE_ENV !== "production" && (Ml.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": b.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: b.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: b.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: b.oneOfType([b.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), b.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: b.shape({
    Input: b.elementType,
    Root: b.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: b.shape({
    input: b.object,
    root: b.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: b.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: b.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: b.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: b.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: b.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: b.bool,
  /**
   * The id of the `input` element.
   */
  id: b.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: Fi,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: b.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: En,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: b.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: b.oneOfType([b.number, b.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: b.oneOfType([b.number, b.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: b.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: b.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: b.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: b.func,
  /**
   * @ignore
   */
  onClick: b.func,
  /**
   * @ignore
   */
  onFocus: b.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: b.func,
  /**
   * @ignore
   */
  onKeyDown: b.func,
  /**
   * @ignore
   */
  onKeyUp: b.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: b.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: b.bool,
  /**
   * @ignore
   */
  renderSuffix: b.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: b.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: b.oneOfType([b.number, b.string]),
  /**
   * The size of the component.
   */
  size: b.oneOfType([b.oneOf(["medium", "small"]), b.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: b.shape({
    input: b.object,
    root: b.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: b.shape({
    input: b.elementType,
    root: b.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: b.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: b.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: b.any
});
function fz(e) {
  return Bt("MuiInput", e);
}
const _a = {
  ...ba,
  ...Ft("MuiInput", ["root", "underline", "input"])
}, uz = (e) => {
  const {
    classes: t,
    disableUnderline: o
  } = e, c = Rt({
    root: ["root", !o && "underline"],
    input: ["input"]
  }, fz, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...c
  };
}, dz = Ke(gl, {
  shouldForwardProp: (e) => hn(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [...hl(e, t), !o.disableUnderline && t.underline];
  }
})(kt(({
  theme: e
}) => {
  let o = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (o = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), {
    position: "relative",
    variants: [{
      props: ({
        ownerState: i
      }) => i.formControl,
      style: {
        "label + &": {
          marginTop: 16
        }
      }
    }, {
      props: ({
        ownerState: i
      }) => !i.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${_a.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${_a.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${o}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${_a.disabled}, .${_a.error}):before`]: {
          borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${o}`
          }
        },
        [`&.${_a.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(Gr()).map(([i]) => ({
      props: {
        color: i,
        disableUnderline: !1
      },
      style: {
        "&::after": {
          borderBottom: `2px solid ${(e.vars || e).palette[i].main}`
        }
      }
    }))]
  };
})), hz = Ke(yl, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: pl
})({}), ml = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: c = !1,
    components: n = {},
    componentsProps: d,
    fullWidth: f = !1,
    inputComponent: p = "input",
    multiline: l = !1,
    slotProps: h,
    slots: y = {},
    type: M = "text",
    ...C
  } = i, N = uz(i), S = {
    root: {
      ownerState: {
        disableUnderline: c
      }
    }
  }, T = h ?? d ? on(h ?? d, S) : S, E = y.root ?? n.Root ?? dz, j = y.input ?? n.Input ?? hz;
  return /* @__PURE__ */ D(Ml, {
    slots: {
      root: E,
      input: j
    },
    slotProps: T,
    fullWidth: f,
    inputComponent: p,
    multiline: l,
    ref: o,
    type: M,
    ...C,
    classes: N
  });
});
fe.process.env.NODE_ENV !== "production" && (ml.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: b.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: b.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: b.oneOfType([b.oneOf(["primary", "secondary"]), b.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: b.shape({
    Input: b.elementType,
    Root: b.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: b.shape({
    input: b.object,
    root: b.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: b.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: b.bool,
  /**
   * If `true`, the `input` will not have an underline.
   * @default false
   */
  disableUnderline: b.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: b.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: b.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: b.bool,
  /**
   * The id of the `input` element.
   */
  id: b.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: b.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: b.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: En,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: b.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: b.oneOfType([b.number, b.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: b.oneOfType([b.number, b.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: b.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: b.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: b.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: b.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: b.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: b.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: b.oneOfType([b.number, b.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: b.shape({
    input: b.object,
    root: b.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: b.shape({
    input: b.elementType,
    root: b.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: b.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: b.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: b.any
});
ml.muiName = "Input";
function pz(e) {
  return Bt("MuiFilledInput", e);
}
const ro = {
  ...ba,
  ...Ft("MuiFilledInput", ["root", "underline", "input", "adornedStart", "adornedEnd", "sizeSmall", "multiline", "hiddenLabel"])
}, gz = (e) => {
  const {
    classes: t,
    disableUnderline: o,
    startAdornment: i,
    endAdornment: c,
    size: n,
    hiddenLabel: d,
    multiline: f
  } = e, p = {
    root: ["root", !o && "underline", i && "adornedStart", c && "adornedEnd", n === "small" && `size${it(n)}`, d && "hiddenLabel", f && "multiline"],
    input: ["input"]
  }, l = Rt(p, pz, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...l
  };
}, yz = Ke(gl, {
  shouldForwardProp: (e) => hn(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [...hl(e, t), !o.disableUnderline && t.underline];
  }
})(kt(({
  theme: e
}) => {
  const t = e.palette.mode === "light", o = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", i = t ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", c = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", n = t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : i,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : c,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : i
      }
    },
    [`&.${ro.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : i
    },
    [`&.${ro.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : n
    },
    variants: [{
      props: ({
        ownerState: d
      }) => !d.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${ro.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${ro.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : o}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${ro.disabled}, .${ro.error}):before`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
        },
        [`&.${ro.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(Gr()).map(([d]) => {
      var f;
      return {
        props: {
          disableUnderline: !1,
          color: d
        },
        style: {
          "&::after": {
            borderBottom: `2px solid ${(f = (e.vars || e).palette[d]) == null ? void 0 : f.main}`
          }
        }
      };
    }), {
      props: ({
        ownerState: d
      }) => d.startAdornment,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        ownerState: d
      }) => d.endAdornment,
      style: {
        paddingRight: 12
      }
    }, {
      props: ({
        ownerState: d
      }) => d.multiline,
      style: {
        padding: "25px 12px 8px"
      }
    }, {
      props: ({
        ownerState: d,
        size: f
      }) => d.multiline && f === "small",
      style: {
        paddingTop: 21,
        paddingBottom: 4
      }
    }, {
      props: ({
        ownerState: d
      }) => d.multiline && d.hiddenLabel,
      style: {
        paddingTop: 16,
        paddingBottom: 17
      }
    }, {
      props: ({
        ownerState: d
      }) => d.multiline && d.hiddenLabel && d.size === "small",
      style: {
        paddingTop: 8,
        paddingBottom: 9
      }
    }]
  };
})), Mz = Ke(yl, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: pl
})(kt(({
  theme: e
}) => ({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel,
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel && t.size === "small",
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
  }]
}))), vl = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiFilledInput"
  }), {
    disableUnderline: c = !1,
    components: n = {},
    componentsProps: d,
    fullWidth: f = !1,
    hiddenLabel: p,
    // declare here to prevent spreading to DOM
    inputComponent: l = "input",
    multiline: h = !1,
    slotProps: y,
    slots: M = {},
    type: C = "text",
    ...N
  } = i, w = {
    ...i,
    disableUnderline: c,
    fullWidth: f,
    inputComponent: l,
    multiline: h,
    type: C
  }, S = gz(i), T = {
    root: {
      ownerState: w
    },
    input: {
      ownerState: w
    }
  }, E = y ?? d ? on(T, y ?? d) : T, j = M.root ?? n.Root ?? yz, O = M.input ?? n.Input ?? Mz;
  return /* @__PURE__ */ D(Ml, {
    slots: {
      root: j,
      input: O
    },
    slotProps: E,
    fullWidth: f,
    inputComponent: l,
    multiline: h,
    ref: o,
    type: C,
    ...N,
    classes: S
  });
});
fe.process.env.NODE_ENV !== "production" && (vl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: b.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: b.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: b.oneOfType([b.oneOf(["primary", "secondary"]), b.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: b.shape({
    Input: b.elementType,
    Root: b.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: b.shape({
    input: b.object,
    root: b.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: b.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: b.bool,
  /**
   * If `true`, the input will not have an underline.
   * @default false
   */
  disableUnderline: b.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: b.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: b.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: b.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: b.bool,
  /**
   * The id of the `input` element.
   */
  id: b.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: b.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: b.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: En,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: b.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: b.oneOfType([b.number, b.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: b.oneOfType([b.number, b.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: b.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: b.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: b.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: b.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: b.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: b.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: b.oneOfType([b.number, b.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: b.shape({
    input: b.object,
    root: b.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: b.shape({
    input: b.elementType,
    root: b.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: b.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: b.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: b.any
});
vl.muiName = "Input";
var z6;
const mz = Ke("fieldset", {
  name: "MuiNotchedOutlined",
  shouldForwardProp: hn
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), vz = Ke("legend", {
  name: "MuiNotchedOutlined",
  shouldForwardProp: hn
})(kt(({
  theme: e
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: ({
      ownerState: t
    }) => !t.withLabel,
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: e.transitions.create("width", {
        duration: 150,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel,
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: e.transitions.create("max-width", {
        duration: 50,
        easing: e.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel && t.notched,
    style: {
      maxWidth: "100%",
      transition: e.transitions.create("max-width", {
        duration: 100,
        easing: e.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
})));
function gm(e) {
  const {
    children: t,
    classes: o,
    className: i,
    label: c,
    notched: n,
    ...d
  } = e, f = c != null && c !== "", p = {
    ...e,
    notched: n,
    withLabel: f
  };
  return /* @__PURE__ */ D(mz, {
    "aria-hidden": !0,
    className: i,
    ownerState: p,
    ...d,
    children: /* @__PURE__ */ D(vz, {
      ownerState: p,
      children: f ? /* @__PURE__ */ D("span", {
        children: c
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        z6 || (z6 = /* @__PURE__ */ D("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      )
    })
  });
}
fe.process.env.NODE_ENV !== "production" && (gm.propTypes = {
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The label.
   */
  label: b.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: b.bool.isRequired,
  /**
   * @ignore
   */
  style: b.object
});
function bz(e) {
  return Bt("MuiOutlinedInput", e);
}
const Kn = {
  ...ba,
  ...Ft("MuiOutlinedInput", ["root", "notchedOutline", "input"])
}, xz = (e) => {
  const {
    classes: t
  } = e, i = Rt({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, bz, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...i
  };
}, wz = Ke(gl, {
  shouldForwardProp: (e) => hn(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: hl
})(kt(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${Kn.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${Kn.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
      }
    },
    [`&.${Kn.focused} .${Kn.notchedOutline}`]: {
      borderWidth: 2
    },
    variants: [...Object.entries(e.palette).filter(Gr()).map(([o]) => ({
      props: {
        color: o
      },
      style: {
        [`&.${Kn.focused} .${Kn.notchedOutline}`]: {
          borderColor: (e.vars || e).palette[o].main
        }
      }
    })), {
      props: {},
      // to overide the above style
      style: {
        [`&.${Kn.error} .${Kn.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.error.main
        },
        [`&.${Kn.disabled} .${Kn.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.action.disabled
        }
      }
    }, {
      props: ({
        ownerState: o
      }) => o.startAdornment,
      style: {
        paddingLeft: 14
      }
    }, {
      props: ({
        ownerState: o
      }) => o.endAdornment,
      style: {
        paddingRight: 14
      }
    }, {
      props: ({
        ownerState: o
      }) => o.multiline,
      style: {
        padding: "16.5px 14px"
      }
    }, {
      props: ({
        ownerState: o,
        size: i
      }) => o.multiline && i === "small",
      style: {
        padding: "8.5px 14px"
      }
    }]
  };
})), Cz = Ke(gm, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(kt(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
})), Iz = Ke(yl, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: pl
})(kt(({
  theme: e
}) => ({
  padding: "16.5px 14px",
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 14px"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }]
}))), bl = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: c = {},
    fullWidth: n = !1,
    inputComponent: d = "input",
    label: f,
    multiline: p = !1,
    notched: l,
    slots: h = {},
    slotProps: y = {},
    type: M = "text",
    ...C
  } = i, N = xz(i), w = qi(), S = Sa({
    props: i,
    muiFormControl: w,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), T = {
    ...i,
    color: S.color || "primary",
    disabled: S.disabled,
    error: S.error,
    focused: S.focused,
    formControl: w,
    fullWidth: n,
    hiddenLabel: S.hiddenLabel,
    multiline: p,
    size: S.size,
    type: M
  }, E = h.root ?? c.Root ?? wz, j = h.input ?? c.Input ?? Iz, [O, z] = qt("notchedOutline", {
    elementType: Cz,
    className: N.notchedOutline,
    shouldForwardComponentProp: !0,
    ownerState: T,
    externalForwardedProps: {
      slots: h,
      slotProps: y
    },
    additionalProps: {
      label: f != null && f !== "" && S.required ? /* @__PURE__ */ ne(ue.Fragment, {
        children: [f, " ", "*"]
      }) : f
    }
  });
  return /* @__PURE__ */ D(Ml, {
    slots: {
      root: E,
      input: j
    },
    slotProps: y,
    renderSuffix: (k) => /* @__PURE__ */ D(O, {
      ...z,
      notched: typeof l < "u" ? l : !!(k.startAdornment || k.filled || k.focused)
    }),
    fullWidth: n,
    inputComponent: d,
    multiline: p,
    ref: o,
    type: M,
    ...C,
    classes: {
      ...N,
      notchedOutline: null
    }
  });
});
fe.process.env.NODE_ENV !== "production" && (bl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: b.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: b.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: b.oneOfType([b.oneOf(["primary", "secondary"]), b.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: b.shape({
    Input: b.elementType,
    Root: b.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: b.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: b.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: b.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: b.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: b.bool,
  /**
   * The id of the `input` element.
   */
  id: b.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: b.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: b.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: En,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: b.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: b.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: b.oneOfType([b.number, b.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: b.oneOfType([b.number, b.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: b.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: b.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: b.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: b.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: b.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: b.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: b.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: b.oneOfType([b.number, b.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: b.shape({
    input: b.object,
    notchedOutline: b.oneOfType([b.func, b.object]),
    root: b.object
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: b.shape({
    input: b.elementType,
    notchedOutline: b.elementType,
    root: b.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: b.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: b.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: b.any
});
bl.muiName = "Input";
function Nz(e) {
  return Bt("MuiFormLabel", e);
}
const rs = Ft("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), Az = (e) => {
  const {
    classes: t,
    color: o,
    focused: i,
    disabled: c,
    error: n,
    filled: d,
    required: f
  } = e, p = {
    root: ["root", `color${it(o)}`, c && "disabled", n && "error", d && "filled", i && "focused", f && "required"],
    asterisk: ["asterisk", n && "error"]
  };
  return Rt(p, Nz, t);
}, Tz = Ke("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.color === "secondary" && t.colorSecondary, o.filled && t.filled];
  }
})(kt(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.body1,
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  variants: [...Object.entries(e.palette).filter(Gr()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${rs.focused}`]: {
        color: (e.vars || e).palette[t].main
      }
    }
  })), {
    props: {},
    style: {
      [`&.${rs.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      },
      [`&.${rs.error}`]: {
        color: (e.vars || e).palette.error.main
      }
    }
  }]
}))), Lz = Ke("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(kt(({
  theme: e
}) => ({
  [`&.${rs.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), ym = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiFormLabel"
  }), {
    children: c,
    className: n,
    color: d,
    component: f = "label",
    disabled: p,
    error: l,
    filled: h,
    focused: y,
    required: M,
    ...C
  } = i, N = qi(), w = Sa({
    props: i,
    muiFormControl: N,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), S = {
    ...i,
    color: w.color || "primary",
    component: f,
    disabled: w.disabled,
    error: w.error,
    filled: w.filled,
    focused: w.focused,
    required: w.required
  }, T = Az(S);
  return /* @__PURE__ */ ne(Tz, {
    as: f,
    ownerState: S,
    className: It(T.root, n),
    ref: o,
    ...C,
    children: [c, w.required && /* @__PURE__ */ ne(Lz, {
      ownerState: S,
      "aria-hidden": !0,
      className: T.asterisk,
      children: [" ", "*"]
    })]
  });
});
fe.process.env.NODE_ENV !== "production" && (ym.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: b.oneOfType([b.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), b.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: b.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: b.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: b.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: b.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: b.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object])
});
function Sz(e) {
  return Bt("MuiInputLabel", e);
}
Ft("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const Ez = (e) => {
  const {
    classes: t,
    formControl: o,
    size: i,
    shrink: c,
    disableAnimation: n,
    variant: d,
    required: f
  } = e, p = {
    root: ["root", o && "formControl", !n && "animated", c && "shrink", i && i !== "normal" && `size${it(i)}`, d],
    asterisk: [f && "asterisk"]
  }, l = Rt(p, Sz, t);
  return {
    ...t,
    // forward the focused, disabled, etc. classes to the FormLabel
    ...l
  };
}, Dz = Ke(ym, {
  shouldForwardProp: (e) => hn(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [{
      [`& .${rs.asterisk}`]: t.asterisk
    }, t.root, o.formControl && t.formControl, o.size === "small" && t.sizeSmall, o.shrink && t.shrink, !o.disableAnimation && t.animated, o.focused && t.focused, t[o.variant]];
  }
})(kt(({
  theme: e
}) => ({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
  variants: [{
    props: ({
      ownerState: t
    }) => t.formControl,
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: "translate(0, 20px) scale(1)"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      // Compensation for the `Input.inputSizeSmall` style.
      transform: "translate(0, 17px) scale(1)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.shrink,
    style: {
      transform: "translate(0, -1.5px) scale(0.75)",
      transformOrigin: "top left",
      maxWidth: "133%"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableAnimation,
    style: {
      transition: e.transitions.create(["color", "transform", "max-width"], {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(12px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "filled",
      size: "small"
    },
    style: {
      transform: "translate(12px, 13px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: o
    }) => t === "filled" && o.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      transform: "translate(12px, 7px) scale(0.75)",
      maxWidth: "calc(133% - 24px)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: o,
      size: i
    }) => t === "filled" && o.shrink && i === "small",
    style: {
      transform: "translate(12px, 4px) scale(0.75)"
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(14px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "outlined",
      size: "small"
    },
    style: {
      transform: "translate(14px, 9px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: o
    }) => t === "outlined" && o.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      // Theoretically, we should have (8+5)*2/0.75 = 34px
      // but it feels a better when it bleeds a bit on the left, so 32px.
      maxWidth: "calc(133% - 32px)",
      transform: "translate(14px, -9px) scale(0.75)"
    }
  }]
}))), Mm = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    name: "MuiInputLabel",
    props: t
  }), {
    disableAnimation: c = !1,
    margin: n,
    shrink: d,
    variant: f,
    className: p,
    ...l
  } = i, h = qi();
  let y = d;
  typeof y > "u" && h && (y = h.filled || h.focused || h.adornedStart);
  const M = Sa({
    props: i,
    muiFormControl: h,
    states: ["size", "variant", "required", "focused"]
  }), C = {
    ...i,
    disableAnimation: c,
    formControl: h,
    shrink: y,
    size: M.size,
    variant: M.variant,
    required: M.required,
    focused: M.focused
  }, N = Ez(C);
  return /* @__PURE__ */ D(Dz, {
    "data-shrink": y,
    ref: o,
    className: It(N.root, p),
    ...l,
    ownerState: C,
    classes: N
  });
});
fe.process.env.NODE_ENV !== "production" && (Mm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: b.oneOfType([b.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), b.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: b.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: b.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: b.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: b.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: b.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: b.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: b.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: b.oneOfType([b.oneOf(["normal", "small"]), b.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The variant to use.
   */
  variant: b.oneOf(["filled", "outlined", "standard"])
});
function jz(e) {
  return Bt("MuiFormControl", e);
}
Ft("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const Oz = (e) => {
  const {
    classes: t,
    margin: o,
    fullWidth: i
  } = e, c = {
    root: ["root", o !== "none" && `margin${it(o)}`, i && "fullWidth"]
  };
  return Rt(c, jz, t);
}, zz = Ke("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[`margin${it(o.margin)}`], o.fullWidth && t.fullWidth];
  }
})({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top",
  // Fix alignment issue on Safari.
  variants: [{
    props: {
      margin: "normal"
    },
    style: {
      marginTop: 16,
      marginBottom: 8
    }
  }, {
    props: {
      margin: "dense"
    },
    style: {
      marginTop: 8,
      marginBottom: 4
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
}), mm = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiFormControl"
  }), {
    children: c,
    className: n,
    color: d = "primary",
    component: f = "div",
    disabled: p = !1,
    error: l = !1,
    focused: h,
    fullWidth: y = !1,
    hiddenLabel: M = !1,
    margin: C = "none",
    required: N = !1,
    size: w = "medium",
    variant: S = "outlined",
    ...T
  } = i, E = {
    ...i,
    color: d,
    component: f,
    disabled: p,
    error: l,
    fullWidth: y,
    hiddenLabel: M,
    margin: C,
    required: N,
    size: w,
    variant: S
  }, j = Oz(E), [O, z] = ue.useState(() => {
    let v = !1;
    return c && ue.Children.forEach(c, (A) => {
      if (!qa(A, ["Input", "Select"]))
        return;
      const L = qa(A, ["Select"]) ? A.props.input : A;
      L && sz(L.props) && (v = !0);
    }), v;
  }), [k, H] = ue.useState(() => {
    let v = !1;
    return c && ue.Children.forEach(c, (A) => {
      qa(A, ["Input", "Select"]) && (vc(A.props, !0) || vc(A.props.inputProps, !0)) && (v = !0);
    }), v;
  }), [W, U] = ue.useState(!1);
  p && W && U(!1);
  const B = h !== void 0 && !p ? h : W;
  let I;
  const r = ue.useRef(!1);
  fe.process.env.NODE_ENV !== "production" && (I = () => (r.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), r.current = !0, () => {
    r.current = !1;
  }));
  const s = ue.useCallback(() => {
    H(!0);
  }, []), u = ue.useCallback(() => {
    H(!1);
  }, []), g = ue.useMemo(() => ({
    adornedStart: O,
    setAdornedStart: z,
    color: d,
    disabled: p,
    error: l,
    filled: k,
    focused: B,
    fullWidth: y,
    hiddenLabel: M,
    size: w,
    onBlur: () => {
      U(!1);
    },
    onFocus: () => {
      U(!0);
    },
    onEmpty: u,
    onFilled: s,
    registerEffect: I,
    required: N,
    variant: S
  }), [O, d, p, l, k, B, y, M, I, u, s, N, w, S]);
  return /* @__PURE__ */ D(qs.Provider, {
    value: g,
    children: /* @__PURE__ */ D(zz, {
      as: f,
      ownerState: E,
      className: It(j.root, n),
      ref: o,
      ...T,
      children: c
    })
  });
});
fe.process.env.NODE_ENV !== "production" && (mm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: b.oneOfType([b.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), b.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: b.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: b.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: b.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: b.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: b.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: b.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: b.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: b.oneOfType([b.oneOf(["medium", "small"]), b.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: b.oneOf(["filled", "outlined", "standard"])
});
function kz(e) {
  return Bt("MuiFormHelperText", e);
}
const k6 = Ft("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var _6;
const _z = (e) => {
  const {
    classes: t,
    contained: o,
    size: i,
    disabled: c,
    error: n,
    filled: d,
    focused: f,
    required: p
  } = e, l = {
    root: ["root", c && "disabled", n && "error", i && `size${it(i)}`, o && "contained", f && "focused", d && "filled", p && "required"]
  };
  return Rt(l, kz, t);
}, Bz = Ke("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.size && t[`size${it(o.size)}`], o.contained && t.contained, o.filled && t.filled];
  }
})(kt(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.caption,
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${k6.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${k6.error}`]: {
    color: (e.vars || e).palette.error.main
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginTop: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.contained,
    style: {
      marginLeft: 14,
      marginRight: 14
    }
  }]
}))), vm = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiFormHelperText"
  }), {
    children: c,
    className: n,
    component: d = "p",
    disabled: f,
    error: p,
    filled: l,
    focused: h,
    margin: y,
    required: M,
    variant: C,
    ...N
  } = i, w = qi(), S = Sa({
    props: i,
    muiFormControl: w,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), T = {
    ...i,
    component: d,
    contained: S.variant === "filled" || S.variant === "outlined",
    variant: S.variant,
    size: S.size,
    disabled: S.disabled,
    error: S.error,
    filled: S.filled,
    focused: S.focused,
    required: S.required
  };
  delete T.ownerState;
  const E = _z(T);
  return /* @__PURE__ */ D(Bz, {
    as: d,
    className: It(E.root, n),
    ref: o,
    ...N,
    ownerState: T,
    children: c === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      _6 || (_6 = /* @__PURE__ */ D("span", {
        className: "notranslate",
        "aria-hidden": !0,
        children: "​"
      }))
    ) : c
  });
});
fe.process.env.NODE_ENV !== "production" && (vm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: b.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: b.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: b.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: b.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: b.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: b.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The variant to use.
   */
  variant: b.oneOfType([b.oneOf(["filled", "outlined", "standard"]), b.string])
});
function jd(e, t, o) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : o ? null : e.firstChild;
}
function B6(e, t, o) {
  return e === t ? o ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : o ? null : e.lastChild;
}
function bm(e, t) {
  if (t === void 0)
    return !0;
  let o = e.innerText;
  return o === void 0 && (o = e.textContent), o = o.trim().toLowerCase(), o.length === 0 ? !1 : t.repeating ? o[0] === t.keys[0] : o.startsWith(t.keys.join(""));
}
function Ba(e, t, o, i, c, n) {
  let d = !1, f = c(e, t, t ? o : !1);
  for (; f; ) {
    if (f === e.firstChild) {
      if (d)
        return !1;
      d = !0;
    }
    const p = i ? !1 : f.disabled || f.getAttribute("aria-disabled") === "true";
    if (!f.hasAttribute("tabindex") || !bm(f, n) || p)
      f = c(e, f, o);
    else
      return f.focus(), !0;
  }
  return !1;
}
const xm = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: i,
    autoFocus: c = !1,
    autoFocusItem: n = !1,
    children: d,
    className: f,
    disabledItemsFocusable: p = !1,
    disableListWrap: l = !1,
    onKeyDown: h,
    variant: y = "selectedMenu",
    ...M
  } = t, C = ue.useRef(null), N = ue.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  Rn(() => {
    c && C.current.focus();
  }, [c]), ue.useImperativeHandle(i, () => ({
    adjustStyleForScrollbar: (j, {
      direction: O
    }) => {
      const z = !C.current.style.width;
      if (j.clientHeight < C.current.clientHeight && z) {
        const k = `${Sg(fn(j))}px`;
        C.current.style[O === "rtl" ? "paddingLeft" : "paddingRight"] = k, C.current.style.width = `calc(100% + ${k})`;
      }
      return C.current;
    }
  }), []);
  const w = (j) => {
    const O = C.current, z = j.key;
    if (j.ctrlKey || j.metaKey || j.altKey) {
      h && h(j);
      return;
    }
    const H = Xr(O).activeElement;
    if (z === "ArrowDown")
      j.preventDefault(), Ba(O, H, l, p, jd);
    else if (z === "ArrowUp")
      j.preventDefault(), Ba(O, H, l, p, B6);
    else if (z === "Home")
      j.preventDefault(), Ba(O, null, l, p, jd);
    else if (z === "End")
      j.preventDefault(), Ba(O, null, l, p, B6);
    else if (z.length === 1) {
      const W = N.current, U = z.toLowerCase(), B = performance.now();
      W.keys.length > 0 && (B - W.lastTime > 500 ? (W.keys = [], W.repeating = !0, W.previousKeyMatched = !0) : W.repeating && U !== W.keys[0] && (W.repeating = !1)), W.lastTime = B, W.keys.push(U);
      const I = H && !W.repeating && bm(H, W);
      W.previousKeyMatched && (I || Ba(O, H, !1, p, jd, W)) ? j.preventDefault() : W.previousKeyMatched = !1;
    }
    h && h(j);
  }, S = zr(C, o);
  let T = -1;
  ue.Children.forEach(d, (j, O) => {
    if (!/* @__PURE__ */ ue.isValidElement(j)) {
      T === O && (T += 1, T >= d.length && (T = -1));
      return;
    }
    fe.process.env.NODE_ENV !== "production" && _i.isFragment(j) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), j.props.disabled || (y === "selectedMenu" && j.props.selected || T === -1) && (T = O), T === O && (j.props.disabled || j.props.muiSkipListHighlight || j.type.muiSkipListHighlight) && (T += 1, T >= d.length && (T = -1));
  });
  const E = ue.Children.map(d, (j, O) => {
    if (O === T) {
      const z = {};
      return n && (z.autoFocus = !0), j.props.tabIndex === void 0 && y === "selectedMenu" && (z.tabIndex = 0), /* @__PURE__ */ ue.cloneElement(j, z);
    }
    return j;
  });
  return /* @__PURE__ */ D(hi, {
    role: "menu",
    ref: S,
    className: f,
    onKeyDown: w,
    tabIndex: c ? 0 : -1,
    ...M,
    children: E
  });
});
fe.process.env.NODE_ENV !== "production" && (xm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: b.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: b.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: b.node,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: b.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: b.bool,
  /**
   * @ignore
   */
  onKeyDown: b.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: b.oneOf(["menu", "selectedMenu"])
});
function Fz(e) {
  return Bt("MuiPopover", e);
}
Ft("MuiPopover", ["root", "paper"]);
function F6(e, t) {
  let o = 0;
  return typeof t == "number" ? o = t : t === "center" ? o = e.height / 2 : t === "bottom" && (o = e.height), o;
}
function R6(e, t) {
  let o = 0;
  return typeof t == "number" ? o = t : t === "center" ? o = e.width / 2 : t === "right" && (o = e.width), o;
}
function P6(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function Ga(e) {
  return typeof e == "function" ? e() : e;
}
const Rz = (e) => {
  const {
    classes: t
  } = e;
  return Rt({
    root: ["root"],
    paper: ["paper"]
  }, Fz, t);
}, Pz = Ke(fl, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), wm = Ke(ul, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Ea = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiPopover"
  }), {
    action: c,
    anchorEl: n,
    anchorOrigin: d = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: f,
    anchorReference: p = "anchorEl",
    children: l,
    className: h,
    container: y,
    elevation: M = 8,
    marginThreshold: C = 16,
    open: N,
    PaperProps: w = {},
    // TODO: remove in v7
    slots: S = {},
    slotProps: T = {},
    transformOrigin: E = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: j,
    // TODO: remove in v7
    transitionDuration: O = "auto",
    TransitionProps: z = {},
    // TODO: remove in v7
    disableScrollLock: k = !1,
    ...H
  } = i, W = ue.useRef(), U = {
    ...i,
    anchorOrigin: d,
    anchorReference: p,
    elevation: M,
    marginThreshold: C,
    transformOrigin: E,
    TransitionComponent: j,
    transitionDuration: O,
    TransitionProps: z
  }, B = Rz(U), I = ue.useCallback(() => {
    if (p === "anchorPosition")
      return fe.process.env.NODE_ENV !== "production" && (f || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), f;
    const F = Ga(n), P = F && F.nodeType === 1 ? F : Xr(W.current).body, _ = P.getBoundingClientRect();
    if (fe.process.env.NODE_ENV !== "production") {
      const X = P.getBoundingClientRect();
      fe.process.env.NODE_ENV !== "test" && X.top === 0 && X.left === 0 && X.right === 0 && X.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: _.top + F6(_, d.vertical),
      left: _.left + R6(_, d.horizontal)
    };
  }, [n, d.horizontal, d.vertical, f, p]), r = ue.useCallback((F) => ({
    vertical: F6(F, E.vertical),
    horizontal: R6(F, E.horizontal)
  }), [E.horizontal, E.vertical]), s = ue.useCallback((F) => {
    const P = {
      width: F.offsetWidth,
      height: F.offsetHeight
    }, _ = r(P);
    if (p === "none")
      return {
        top: null,
        left: null,
        transformOrigin: P6(_)
      };
    const X = I();
    let le = X.top - _.vertical, ie = X.left - _.horizontal;
    const oe = le + P.height, pe = ie + P.width, se = fn(Ga(n)), ce = se.innerHeight - C, me = se.innerWidth - C;
    if (C !== null && le < C) {
      const de = le - C;
      le -= de, _.vertical += de;
    } else if (C !== null && oe > ce) {
      const de = oe - ce;
      le -= de, _.vertical += de;
    }
    if (fe.process.env.NODE_ENV !== "production" && P.height > ce && P.height && ce && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${P.height - ce}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), C !== null && ie < C) {
      const de = ie - C;
      ie -= de, _.horizontal += de;
    } else if (pe > me) {
      const de = pe - me;
      ie -= de, _.horizontal += de;
    }
    return {
      top: `${Math.round(le)}px`,
      left: `${Math.round(ie)}px`,
      transformOrigin: P6(_)
    };
  }, [n, p, I, r, C]), [u, g] = ue.useState(N), v = ue.useCallback(() => {
    const F = W.current;
    if (!F)
      return;
    const P = s(F);
    P.top !== null && F.style.setProperty("top", P.top), P.left !== null && (F.style.left = P.left), F.style.transformOrigin = P.transformOrigin, g(!0);
  }, [s]);
  ue.useEffect(() => (k && window.addEventListener("scroll", v), () => window.removeEventListener("scroll", v)), [n, k, v]);
  const A = () => {
    v();
  }, L = () => {
    g(!1);
  };
  ue.useEffect(() => {
    N && v();
  }), ue.useImperativeHandle(c, () => N ? {
    updatePosition: () => {
      v();
    }
  } : null, [N, v]), ue.useEffect(() => {
    if (!N)
      return;
    const F = K1(() => {
      v();
    }), P = fn(Ga(n));
    return P.addEventListener("resize", F), () => {
      F.clear(), P.removeEventListener("resize", F);
    };
  }, [n, N, v]);
  let m = O;
  const a = {
    slots: {
      transition: j,
      ...S
    },
    slotProps: {
      transition: z,
      paper: w,
      ...T
    }
  }, [x, V] = qt("transition", {
    elementType: ys,
    externalForwardedProps: a,
    ownerState: U,
    getSlotProps: (F) => ({
      ...F,
      onEntering: (P, _) => {
        var X;
        (X = F.onEntering) == null || X.call(F, P, _), A();
      },
      onExited: (P) => {
        var _;
        (_ = F.onExited) == null || _.call(F, P), L();
      }
    }),
    additionalProps: {
      appear: !0,
      in: N
    }
  });
  O === "auto" && !x.muiSupportAuto && (m = void 0);
  const G = y || (n ? Xr(Ga(n)).body : void 0), [Z, {
    slots: te,
    slotProps: q,
    ...R
  }] = qt("root", {
    ref: o,
    elementType: Pz,
    externalForwardedProps: {
      ...a,
      ...H
    },
    shouldForwardComponentProp: !0,
    additionalProps: {
      slots: {
        backdrop: S.backdrop
      },
      slotProps: {
        backdrop: uc(typeof T.backdrop == "function" ? T.backdrop(U) : T.backdrop, {
          invisible: !0
        })
      },
      container: G,
      open: N
    },
    ownerState: U,
    className: It(B.root, h)
  }), [Q, $] = qt("paper", {
    ref: W,
    className: B.paper,
    elementType: wm,
    externalForwardedProps: a,
    shouldForwardComponentProp: !0,
    additionalProps: {
      elevation: M,
      style: u ? void 0 : {
        opacity: 0
      }
    },
    ownerState: U
  });
  return /* @__PURE__ */ D(Z, {
    ...R,
    ...!bs(Z) && {
      slots: te,
      slotProps: q,
      disableScrollLock: k
    },
    children: /* @__PURE__ */ D(x, {
      ...V,
      timeout: m,
      children: /* @__PURE__ */ D(Q, {
        ...$,
        children: l
      })
    })
  });
});
fe.process.env.NODE_ENV !== "production" && (Ea.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: En,
  /**
   * An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: qn(b.oneOfType([ci, b.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = Ga(e.anchorEl);
      if (t && t.nodeType === 1) {
        const o = t.getBoundingClientRect();
        if (fe.process.env.NODE_ENV !== "test" && o.top === 0 && o.left === 0 && o.right === 0 && o.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: b.shape({
    horizontal: b.oneOfType([b.oneOf(["center", "left", "right"]), b.number]).isRequired,
    vertical: b.oneOfType([b.oneOf(["bottom", "center", "top"]), b.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: b.shape({
    left: b.number.isRequired,
    top: b.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: b.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: b.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  BackdropProps: b.object,
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: b.oneOfType([ci, b.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: b.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: eh,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: b.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: b.func,
  /**
   * If `true`, the component is shown.
   */
  open: b.bool.isRequired,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: b.shape({
    component: Fi
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: b.shape({
    backdrop: b.oneOfType([b.func, b.object]),
    paper: b.oneOfType([b.func, b.object]),
    root: b.oneOfType([b.func, b.object]),
    transition: b.oneOfType([b.func, b.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: b.shape({
    backdrop: b.elementType,
    paper: b.elementType,
    root: b.elementType,
    transition: b.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: b.shape({
    horizontal: b.oneOfType([b.oneOf(["center", "left", "right"]), b.number]).isRequired,
    vertical: b.oneOfType([b.oneOf(["bottom", "center", "top"]), b.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default Grow
   */
  TransitionComponent: b.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: b.oneOfType([b.oneOf(["auto"]), b.number, b.shape({
    appear: b.number,
    enter: b.number,
    exit: b.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: b.object
});
function Uz(e) {
  return Bt("MuiMenu", e);
}
Ft("MuiMenu", ["root", "paper", "list"]);
const Yz = {
  vertical: "top",
  horizontal: "right"
}, Wz = {
  vertical: "top",
  horizontal: "left"
}, Hz = (e) => {
  const {
    classes: t
  } = e;
  return Rt({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, Uz, t);
}, Zz = Ke(Ea, {
  shouldForwardProp: (e) => hn(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Qz = Ke(wm, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), Vz = Ke(xm, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Cm = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: c = !0,
    children: n,
    className: d,
    disableAutoFocusItem: f = !1,
    MenuListProps: p = {},
    onClose: l,
    open: h,
    PaperProps: y = {},
    PopoverClasses: M,
    transitionDuration: C = "auto",
    TransitionProps: {
      onEntering: N,
      ...w
    } = {},
    variant: S = "selectedMenu",
    slots: T = {},
    slotProps: E = {},
    ...j
  } = i, O = Ss(), z = {
    ...i,
    autoFocus: c,
    disableAutoFocusItem: f,
    MenuListProps: p,
    onEntering: N,
    PaperProps: y,
    transitionDuration: C,
    TransitionProps: w,
    variant: S
  }, k = Hz(z), H = c && !f && h, W = ue.useRef(null), U = (m, a) => {
    W.current && W.current.adjustStyleForScrollbar(m, {
      direction: O ? "rtl" : "ltr"
    }), N && N(m, a);
  }, B = (m) => {
    m.key === "Tab" && (m.preventDefault(), l && l(m, "tabKeyDown"));
  };
  let I = -1;
  ue.Children.map(n, (m, a) => {
    /* @__PURE__ */ ue.isValidElement(m) && (fe.process.env.NODE_ENV !== "production" && _i.isFragment(m) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), m.props.disabled || (S === "selectedMenu" && m.props.selected || I === -1) && (I = a));
  });
  const r = {
    slots: T,
    slotProps: {
      list: p,
      transition: w,
      paper: y,
      ...E
    }
  }, s = Rg({
    elementType: T.root,
    externalSlotProps: E.root,
    ownerState: z,
    className: [k.root, d]
  }), [u, g] = qt("paper", {
    className: k.paper,
    elementType: Qz,
    externalForwardedProps: r,
    shouldForwardComponentProp: !0,
    ownerState: z
  }), [v, A] = qt("list", {
    className: It(k.list, p.className),
    elementType: Vz,
    shouldForwardComponentProp: !0,
    externalForwardedProps: r,
    getSlotProps: (m) => ({
      ...m,
      onKeyDown: (a) => {
        var x;
        B(a), (x = m.onKeyDown) == null || x.call(m, a);
      }
    }),
    ownerState: z
  }), L = typeof r.slotProps.transition == "function" ? r.slotProps.transition(z) : r.slotProps.transition;
  return /* @__PURE__ */ D(Zz, {
    onClose: l,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: O ? "right" : "left"
    },
    transformOrigin: O ? Yz : Wz,
    slots: {
      root: T.root,
      paper: u,
      backdrop: T.backdrop,
      ...T.transition && {
        // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
        transition: T.transition
      }
    },
    slotProps: {
      root: s,
      paper: g,
      backdrop: typeof E.backdrop == "function" ? E.backdrop(z) : E.backdrop,
      transition: {
        ...L,
        onEntering: (...m) => {
          var a;
          U(...m), (a = L == null ? void 0 : L.onEntering) == null || a.call(L, ...m);
        }
      }
    },
    open: h,
    ref: o,
    transitionDuration: C,
    ownerState: z,
    ...j,
    classes: M,
    children: /* @__PURE__ */ D(v, {
      actions: W,
      autoFocus: c && (I === -1 || f),
      autoFocusItem: H,
      variant: S,
      ...A,
      children: n
    })
  });
});
fe.process.env.NODE_ENV !== "production" && (Cm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: b.oneOfType([ci, b.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: b.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: b.bool,
  /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @deprecated use the `slotProps.list` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  MenuListProps: b.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: b.func,
  /**
   * If `true`, the component is shown.
   */
  open: b.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: b.object,
  /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */
  PopoverClasses: b.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: b.shape({
    backdrop: b.oneOfType([b.func, b.object]),
    list: b.oneOfType([b.func, b.object]),
    paper: b.oneOfType([b.func, b.object]),
    root: b.oneOfType([b.func, b.object]),
    transition: b.oneOfType([b.func, b.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: b.shape({
    backdrop: b.elementType,
    list: b.elementType,
    paper: b.elementType,
    root: b.elementType,
    transition: b.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: b.oneOfType([b.oneOf(["auto"]), b.number, b.shape({
    appear: b.number,
    enter: b.number,
    exit: b.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: b.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: b.oneOf(["menu", "selectedMenu"])
});
function Gz(e) {
  return Bt("MuiNativeSelect", e);
}
const Gh = Ft("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), $z = (e) => {
  const {
    classes: t,
    variant: o,
    disabled: i,
    multiple: c,
    open: n,
    error: d
  } = e, f = {
    select: ["select", o, i && "disabled", c && "multiple", d && "error"],
    icon: ["icon", `icon${it(o)}`, n && "iconOpen", i && "disabled"]
  };
  return Rt(f, Gz, t);
}, Im = Ke("select", {
  name: "MuiNativeSelect"
})(({
  theme: e
}) => ({
  // Reset
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  // Reset
  borderRadius: 0,
  cursor: "pointer",
  "&:focus": {
    // Reset Chrome style
    borderRadius: 0
  },
  [`&.${Gh.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.variant !== "filled" && t.variant !== "outlined",
    style: {
      // Bump specificity to allow extending custom inputs
      "&&&": {
        paddingRight: 24,
        minWidth: 16
        // So it doesn't collapse.
      }
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      "&&&": {
        paddingRight: 32
      }
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius,
      "&:focus": {
        borderRadius: (e.vars || e).shape.borderRadius
        // Reset the reset for Chrome style
      },
      "&&&": {
        paddingRight: 32
      }
    }
  }]
})), qz = Ke(Im, {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: hn,
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.select, t[o.variant], o.error && t.error, {
      [`&.${Gh.multiple}`]: t.multiple
    }];
  }
})({}), Nm = Ke("svg", {
  name: "MuiNativeSelect"
})(({
  theme: e
}) => ({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  // Center vertically, height is 1em
  top: "calc(50% - .5em)",
  // Don't block pointer events on the select under the icon.
  pointerEvents: "none",
  color: (e.vars || e).palette.action.active,
  [`&.${Gh.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.open,
    style: {
      transform: "rotate(180deg)"
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      right: 7
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      right: 7
    }
  }]
})), Jz = Ke(Nm, {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.icon, o.variant && t[`icon${it(o.variant)}`], o.open && t.iconOpen];
  }
})({}), Am = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const {
    className: i,
    disabled: c,
    error: n,
    IconComponent: d,
    inputRef: f,
    variant: p = "standard",
    ...l
  } = t, h = {
    ...t,
    disabled: c,
    variant: p,
    error: n
  }, y = $z(h);
  return /* @__PURE__ */ ne(ue.Fragment, {
    children: [/* @__PURE__ */ D(qz, {
      ownerState: h,
      className: It(y.select, i),
      disabled: c,
      ref: f || o,
      ...l
    }), t.multiple ? null : /* @__PURE__ */ D(Jz, {
      as: d,
      ownerState: h,
      className: y.icon
    })]
  });
});
fe.process.env.NODE_ENV !== "production" && (Am.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * The CSS class name of the select element.
   */
  className: b.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: b.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: b.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: b.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: En,
  /**
   * @ignore
   */
  multiple: b.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: b.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: b.func,
  /**
   * The input value.
   */
  value: b.any,
  /**
   * The variant to use.
   */
  variant: b.oneOf(["standard", "outlined", "filled"])
});
function Tm(e) {
  return Bt("MuiSelect", e);
}
const Fa = Ft("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var U6;
const Xz = Ke(Im, {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${Fa.select}`]: t.select
      },
      {
        [`&.${Fa.select}`]: t[o.variant]
      },
      {
        [`&.${Fa.error}`]: t.error
      },
      {
        [`&.${Fa.multiple}`]: t.multiple
      }
    ];
  }
})({
  // Win specificity over the input base
  [`&.${Fa.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), Kz = Ke(Nm, {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.icon, o.variant && t[`icon${it(o.variant)}`], o.open && t.iconOpen];
  }
})({}), ek = Ke("input", {
  shouldForwardProp: (e) => Zg(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function Y6(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function tk(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const rk = (e) => {
  const {
    classes: t,
    variant: o,
    disabled: i,
    multiple: c,
    open: n,
    error: d
  } = e, f = {
    select: ["select", o, i && "disabled", c && "multiple", d && "error"],
    icon: ["icon", `icon${it(o)}`, n && "iconOpen", i && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return Rt(f, Tm, t);
}, Lm = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  var At;
  const {
    "aria-describedby": i,
    "aria-label": c,
    autoFocus: n,
    autoWidth: d,
    children: f,
    className: p,
    defaultOpen: l,
    defaultValue: h,
    disabled: y,
    displayEmpty: M,
    error: C = !1,
    IconComponent: N,
    inputRef: w,
    labelId: S,
    MenuProps: T = {},
    multiple: E,
    name: j,
    onBlur: O,
    onChange: z,
    onClose: k,
    onFocus: H,
    onOpen: W,
    open: U,
    readOnly: B,
    renderValue: I,
    required: r,
    SelectDisplayProps: s = {},
    tabIndex: u,
    // catching `type` from Input which makes no sense for SelectInput
    type: g,
    value: v,
    variant: A = "standard",
    ...L
  } = t, [m, a] = X0({
    controlled: v,
    default: h,
    name: "Select"
  }), [x, V] = X0({
    controlled: U,
    default: l,
    name: "Select"
  }), G = ue.useRef(null), Z = ue.useRef(null), [te, q] = ue.useState(null), {
    current: R
  } = ue.useRef(U != null), [Q, $] = ue.useState(), F = zr(o, w), P = ue.useCallback((xe) => {
    Z.current = xe, xe && q(xe);
  }, []), _ = te == null ? void 0 : te.parentNode;
  ue.useImperativeHandle(F, () => ({
    focus: () => {
      Z.current.focus();
    },
    node: G.current,
    value: m
  }), [m]), ue.useEffect(() => {
    l && x && te && !R && ($(d ? null : _.clientWidth), Z.current.focus());
  }, [te, d]), ue.useEffect(() => {
    n && Z.current.focus();
  }, [n]), ue.useEffect(() => {
    if (!S)
      return;
    const xe = Xr(Z.current).getElementById(S);
    if (xe) {
      const Ie = () => {
        getSelection().isCollapsed && Z.current.focus();
      };
      return xe.addEventListener("click", Ie), () => {
        xe.removeEventListener("click", Ie);
      };
    }
  }, [S]);
  const X = (xe, Ie) => {
    xe ? W && W(Ie) : k && k(Ie), R || ($(d ? null : _.clientWidth), V(xe));
  }, le = (xe) => {
    xe.button === 0 && (xe.preventDefault(), Z.current.focus(), X(!0, xe));
  }, ie = (xe) => {
    X(!1, xe);
  }, oe = ue.Children.toArray(f), pe = (xe) => {
    const Ie = oe.find((Nt) => Nt.props.value === xe.target.value);
    Ie !== void 0 && (a(Ie.props.value), z && z(xe, Ie));
  }, se = (xe) => (Ie) => {
    let Nt;
    if (Ie.currentTarget.hasAttribute("tabindex")) {
      if (E) {
        Nt = Array.isArray(m) ? m.slice() : [];
        const _e = m.indexOf(xe.props.value);
        _e === -1 ? Nt.push(xe.props.value) : Nt.splice(_e, 1);
      } else
        Nt = xe.props.value;
      if (xe.props.onClick && xe.props.onClick(Ie), m !== Nt && (a(Nt), z)) {
        const _e = Ie.nativeEvent || Ie, Be = new _e.constructor(_e.type, _e);
        Object.defineProperty(Be, "target", {
          writable: !0,
          value: {
            value: Nt,
            name: j
          }
        }), z(Be, xe);
      }
      E || X(!1, Ie);
    }
  }, ce = (xe) => {
    B || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].includes(xe.key) && (xe.preventDefault(), X(!0, xe));
  }, me = te !== null && x, de = (xe) => {
    !me && O && (Object.defineProperty(xe, "target", {
      writable: !0,
      value: {
        value: m,
        name: j
      }
    }), O(xe));
  };
  delete L["aria-invalid"];
  let ae, Le;
  const ye = [];
  let Me = !1, at = !1;
  (vc({
    value: m
  }) || M) && (I ? ae = I(m) : Me = !0);
  const Ne = oe.map((xe) => {
    if (!/* @__PURE__ */ ue.isValidElement(xe))
      return null;
    fe.process.env.NODE_ENV !== "production" && _i.isFragment(xe) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let Ie;
    if (E) {
      if (!Array.isArray(m))
        throw new Error(fe.process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : si(2));
      Ie = m.some((Nt) => Y6(Nt, xe.props.value)), Ie && Me && ye.push(xe.props.children);
    } else
      Ie = Y6(m, xe.props.value), Ie && Me && (Le = xe.props.children);
    return Ie && (at = !0), /* @__PURE__ */ ue.cloneElement(xe, {
      "aria-selected": Ie ? "true" : "false",
      onClick: se(xe),
      onKeyUp: (Nt) => {
        Nt.key === " " && Nt.preventDefault(), xe.props.onKeyUp && xe.props.onKeyUp(Nt);
      },
      role: "option",
      selected: Ie,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": xe.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  fe.process.env.NODE_ENV !== "production" && ue.useEffect(() => {
    if (!at && !E && m !== "") {
      const xe = oe.map((Ie) => Ie.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${m}\` for the select ${j ? `(name="${j}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${xe.filter((Ie) => Ie != null).map((Ie) => `\`${Ie}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [at, oe, E, j, m]), Me && (E ? ye.length === 0 ? ae = null : ae = ye.reduce((xe, Ie, Nt) => (xe.push(Ie), Nt < ye.length - 1 && xe.push(", "), xe), []) : ae = Le);
  let Ae = Q;
  !d && R && te && (Ae = _.clientWidth);
  let pt;
  typeof u < "u" ? pt = u : pt = y ? null : 0;
  const ke = s.id || (j ? `mui-component-select-${j}` : void 0), Te = {
    ...t,
    variant: A,
    value: m,
    open: me,
    error: C
  }, Dt = rk(Te), De = {
    ...T.PaperProps,
    ...(At = T.slotProps) == null ? void 0 : At.paper
  }, je = Ls();
  return /* @__PURE__ */ ne(ue.Fragment, {
    children: [/* @__PURE__ */ D(Xz, {
      as: "div",
      ref: P,
      tabIndex: pt,
      role: "combobox",
      "aria-controls": me ? je : void 0,
      "aria-disabled": y ? "true" : void 0,
      "aria-expanded": me ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": c,
      "aria-labelledby": [S, ke].filter(Boolean).join(" ") || void 0,
      "aria-describedby": i,
      "aria-required": r ? "true" : void 0,
      "aria-invalid": C ? "true" : void 0,
      onKeyDown: ce,
      onMouseDown: y || B ? null : le,
      onBlur: de,
      onFocus: H,
      ...s,
      ownerState: Te,
      className: It(s.className, Dt.select, p),
      id: ke,
      children: tk(ae) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        U6 || (U6 = /* @__PURE__ */ D("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      ) : ae
    }), /* @__PURE__ */ D(ek, {
      "aria-invalid": C,
      value: Array.isArray(m) ? m.join(",") : m,
      name: j,
      ref: G,
      "aria-hidden": !0,
      onChange: pe,
      tabIndex: -1,
      disabled: y,
      className: Dt.nativeInput,
      autoFocus: n,
      required: r,
      ...L,
      ownerState: Te
    }), /* @__PURE__ */ D(Kz, {
      as: N,
      className: Dt.icon,
      ownerState: Te
    }), /* @__PURE__ */ D(Cm, {
      id: `menu-${j || ""}`,
      anchorEl: _,
      open: me,
      onClose: ie,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      ...T,
      slotProps: {
        ...T.slotProps,
        list: {
          "aria-labelledby": S,
          role: "listbox",
          "aria-multiselectable": E ? "true" : void 0,
          disableListWrap: !0,
          id: je,
          ...T.MenuListProps
        },
        paper: {
          ...De,
          style: {
            minWidth: Ae,
            ...De != null ? De.style : null
          }
        }
      },
      children: Ne
    })]
  });
});
fe.process.env.NODE_ENV !== "production" && (Lm.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": b.string,
  /**
   * @ignore
   */
  "aria-label": b.string,
  /**
   * @ignore
   */
  autoFocus: b.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: b.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * The CSS class name of the select element.
   */
  className: b.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: b.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: b.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: b.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: b.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: b.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: b.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: En,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: b.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: b.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: b.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: b.string,
  /**
   * @ignore
   */
  onBlur: b.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: b.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: b.func,
  /**
   * @ignore
   */
  onFocus: b.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: b.func,
  /**
   * If `true`, the component is shown.
   */
  open: b.bool,
  /**
   * @ignore
   */
  readOnly: b.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: b.func,
  /**
   * If `true`, the component is required.
   */
  required: b.bool,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: b.object,
  /**
   * @ignore
   */
  tabIndex: b.oneOfType([b.number, b.string]),
  /**
   * @ignore
   */
  type: b.any,
  /**
   * The input value.
   */
  value: b.any,
  /**
   * The variant to use.
   */
  variant: b.oneOf(["standard", "outlined", "filled"])
});
const nk = an(/* @__PURE__ */ D("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), ik = (e) => {
  const {
    classes: t
  } = e, i = Rt({
    root: ["root"]
  }, Tm, t);
  return {
    ...t,
    ...i
  };
}, $h = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => hn(e) && e !== "variant",
  slot: "Root"
}, ok = Ke(ml, $h)(""), ak = Ke(bl, $h)(""), sk = Ke(vl, $h)(""), qh = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: c = !1,
    children: n,
    classes: d = {},
    className: f,
    defaultOpen: p = !1,
    displayEmpty: l = !1,
    IconComponent: h = nk,
    id: y,
    input: M,
    inputProps: C,
    label: N,
    labelId: w,
    MenuProps: S,
    multiple: T = !1,
    native: E = !1,
    onClose: j,
    onOpen: O,
    open: z,
    renderValue: k,
    SelectDisplayProps: H,
    variant: W = "outlined",
    ...U
  } = i, B = E ? Am : Lm, I = qi(), r = Sa({
    props: i,
    muiFormControl: I,
    states: ["variant", "error"]
  }), s = r.variant || W, u = {
    ...i,
    variant: s,
    classes: d
  }, g = ik(u), {
    root: v,
    ...A
  } = g, L = M || {
    standard: /* @__PURE__ */ D(ok, {
      ownerState: u
    }),
    outlined: /* @__PURE__ */ D(ak, {
      label: N,
      ownerState: u
    }),
    filled: /* @__PURE__ */ D(sk, {
      ownerState: u
    })
  }[s], m = zr(o, zo(L));
  return /* @__PURE__ */ D(ue.Fragment, {
    children: /* @__PURE__ */ ue.cloneElement(L, {
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: B,
      inputProps: {
        children: n,
        error: r.error,
        IconComponent: h,
        variant: s,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: T,
        ...E ? {
          id: y
        } : {
          autoWidth: c,
          defaultOpen: p,
          displayEmpty: l,
          labelId: w,
          MenuProps: S,
          onClose: j,
          onOpen: O,
          open: z,
          renderValue: k,
          SelectDisplayProps: {
            id: y,
            ...H
          }
        },
        ...C,
        classes: C ? on(A, C.classes) : A,
        ...M ? M.props.inputProps : {}
      },
      ...(T && E || l) && s === "outlined" ? {
        notched: !0
      } : {},
      ref: m,
      className: It(L.props.className, f, g.root),
      // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
      ...!M && {
        variant: s
      },
      ...U
    })
  });
});
fe.process.env.NODE_ENV !== "production" && (qh.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: b.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: b.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: b.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: b.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: b.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: b.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: b.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: b.object,
  /**
   * See [OutlinedInput#label](https://mui.com/material-ui/api/outlined-input/#props)
   */
  label: b.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: b.string,
  /**
   * Props applied to the [`Menu`](https://mui.com/material-ui/api/menu/) element.
   */
  MenuProps: b.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: b.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: b.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: b.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: b.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: b.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: b.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: b.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: b.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: b.oneOfType([b.oneOf([""]), b.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: b.oneOf(["filled", "outlined", "standard"])
});
qh.muiName = "Select";
function ck(e) {
  return Bt("MuiTextField", e);
}
Ft("MuiTextField", ["root"]);
const lk = {
  standard: ml,
  filled: vl,
  outlined: bl
}, fk = (e) => {
  const {
    classes: t
  } = e;
  return Rt({
    root: ["root"]
  }, ck, t);
}, uk = Ke(mm, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Ii = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiTextField"
  }), {
    autoComplete: c,
    autoFocus: n = !1,
    children: d,
    className: f,
    color: p = "primary",
    defaultValue: l,
    disabled: h = !1,
    error: y = !1,
    FormHelperTextProps: M,
    fullWidth: C = !1,
    helperText: N,
    id: w,
    InputLabelProps: S,
    inputProps: T,
    InputProps: E,
    inputRef: j,
    label: O,
    maxRows: z,
    minRows: k,
    multiline: H = !1,
    name: W,
    onBlur: U,
    onChange: B,
    onFocus: I,
    placeholder: r,
    required: s = !1,
    rows: u,
    select: g = !1,
    SelectProps: v,
    slots: A = {},
    slotProps: L = {},
    type: m,
    value: a,
    variant: x = "outlined",
    ...V
  } = i, G = {
    ...i,
    autoFocus: n,
    color: p,
    disabled: h,
    error: y,
    fullWidth: C,
    multiline: H,
    required: s,
    select: g,
    variant: x
  }, Z = fk(G);
  fe.process.env.NODE_ENV !== "production" && g && !d && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const te = Ls(w), q = N && te ? `${te}-helper-text` : void 0, R = O && te ? `${te}-label` : void 0, Q = lk[x], $ = {
    slots: A,
    slotProps: {
      input: E,
      inputLabel: S,
      htmlInput: T,
      formHelperText: M,
      select: v,
      ...L
    }
  }, F = {}, P = $.slotProps.inputLabel;
  x === "outlined" && (P && typeof P.shrink < "u" && (F.notched = P.shrink), F.label = O), g && ((!v || !v.native) && (F.id = void 0), F["aria-describedby"] = void 0);
  const [_, X] = qt("root", {
    elementType: uk,
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      ...$,
      ...V
    },
    ownerState: G,
    className: It(Z.root, f),
    ref: o,
    additionalProps: {
      disabled: h,
      error: y,
      fullWidth: C,
      required: s,
      color: p,
      variant: x
    }
  }), [le, ie] = qt("input", {
    elementType: Q,
    externalForwardedProps: $,
    additionalProps: F,
    ownerState: G
  }), [oe, pe] = qt("inputLabel", {
    elementType: Mm,
    externalForwardedProps: $,
    ownerState: G
  }), [se, ce] = qt("htmlInput", {
    elementType: "input",
    externalForwardedProps: $,
    ownerState: G
  }), [me, de] = qt("formHelperText", {
    elementType: vm,
    externalForwardedProps: $,
    ownerState: G
  }), [ae, Le] = qt("select", {
    elementType: qh,
    externalForwardedProps: $,
    ownerState: G
  }), ye = /* @__PURE__ */ D(le, {
    "aria-describedby": q,
    autoComplete: c,
    autoFocus: n,
    defaultValue: l,
    fullWidth: C,
    multiline: H,
    name: W,
    rows: u,
    maxRows: z,
    minRows: k,
    type: m,
    value: a,
    id: te,
    inputRef: j,
    onBlur: U,
    onChange: B,
    onFocus: I,
    placeholder: r,
    inputProps: ce,
    slots: {
      input: A.htmlInput ? se : void 0
    },
    ...ie
  });
  return /* @__PURE__ */ ne(_, {
    ...X,
    children: [O != null && O !== "" && /* @__PURE__ */ D(oe, {
      htmlFor: te,
      id: R,
      ...pe,
      children: O
    }), g ? /* @__PURE__ */ D(ae, {
      "aria-describedby": q,
      id: te,
      labelId: R,
      value: a,
      input: ye,
      ...Le,
      children: d
    }) : ye, N && /* @__PURE__ */ D(me, {
      id: q,
      ...de,
      children: N
    })]
  });
});
fe.process.env.NODE_ENV !== "production" && (Ii.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: b.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: b.bool,
  /**
   * @ignore
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: b.oneOfType([b.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), b.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: b.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: b.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: b.bool,
  /**
   * Props applied to the [`FormHelperText`](https://mui.com/material-ui/api/form-helper-text/) element.
   * @deprecated Use `slotProps.formHelperText` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  FormHelperTextProps: b.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: b.bool,
  /**
   * The helper text content.
   */
  helperText: b.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: b.string,
  /**
   * Props applied to the [`InputLabel`](https://mui.com/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   * @deprecated Use `slotProps.inputLabel` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputLabelProps: b.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.htmlInput` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: b.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](https://mui.com/material-ui/api/filled-input/),
   * [`OutlinedInput`](https://mui.com/material-ui/api/outlined-input/) or [`Input`](https://mui.com/material-ui/api/input/)
   * component depending on the `variant` prop value.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputProps: b.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: En,
  /**
   * The label content.
   */
  label: b.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: b.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: b.oneOfType([b.number, b.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: b.oneOfType([b.number, b.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: b.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: b.string,
  /**
   * @ignore
   */
  onBlur: b.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: b.func,
  /**
   * @ignore
   */
  onFocus: b.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: b.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: b.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: b.oneOfType([b.number, b.string]),
  /**
   * Render a [`Select`](https://mui.com/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: b.bool,
  /**
   * Props applied to the [`Select`](https://mui.com/material-ui/api/select/) element.
   * @deprecated Use `slotProps.select` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SelectProps: b.object,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: b.oneOfType([b.oneOf(["medium", "small"]), b.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: b.shape({
    formHelperText: b.oneOfType([b.func, b.object]),
    htmlInput: b.oneOfType([b.func, b.object]),
    input: b.oneOfType([b.func, b.object]),
    inputLabel: b.oneOfType([b.func, b.object]),
    select: b.oneOfType([b.func, b.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: b.shape({
    formHelperText: b.elementType,
    htmlInput: b.elementType,
    input: b.elementType,
    inputLabel: b.elementType,
    root: b.elementType,
    select: b.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: b.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: b.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: b.oneOf(["filled", "outlined", "standard"])
});
const Sm = an(/* @__PURE__ */ D("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), "Search"), xl = an(/* @__PURE__ */ D("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), dk = "Failed to load wallets. Please refresh and try again.", Em = (e) => {
  const { chain: t, supportedChains: o } = e, [i, c] = Xe(
    {
      state: "loading"
    }
  );
  return St(() => {
    let n = !1;
    async function d() {
      if (!t)
        return [];
      const f = ge.chains[t];
      return f && o.has(Vr(f.sdkName)) ? await i8(f) : [];
    }
    return (async () => {
      try {
        const f = await d();
        !n && f && c({
          state: "result",
          options: f
        });
      } catch (f) {
        console.error(`Error loading wallet options for ${t}: ${f}`), c({ state: "error", error: dk });
      }
    })(), () => {
      n = !0;
    };
  }, [t, o]), {
    walletOptionsResult: i
  };
};
function Jh(e) {
  const t = e.size || 32, { icon: o, name: i } = e, c = Ce(
    () => ({
      container: {
        height: t,
        width: t,
        ...nl
      },
      icon: {
        maxHeight: "100%",
        maxWidth: "100%"
      }
    }),
    [t]
  );
  return /* @__PURE__ */ D(ut, { sx: c.container, children: o && /* @__PURE__ */ D("img", { style: c.icon, src: o, alt: i }) });
}
function hk(e) {
  if (!e.startsWith("0x") || e.length !== 42 || !Ic.valid(e))
    return !1;
  try {
    return ug(e), !0;
  } catch {
    return !1;
  }
}
async function pk(e) {
  try {
    const t = new Ko(e);
    if (ge.rpcs.Solana) {
      const o = new H1(ge.rpcs.Solana);
      if ((await Promise.allSettled([
        q0(o, t, "finalized", J9),
        q0(o, t, "finalized", X9)
      ])).some((c) => c.status === "fulfilled")) return !1;
    }
    return !0;
  } catch {
    return !1;
  }
}
function gk(e) {
  return e.startsWith("0x") && e.length === 66 && Ic.valid(e);
}
async function Dm(e, t) {
  const o = Vr(e);
  switch (o) {
    case "Evm":
      if (!hk(t)) return null;
      break;
    case "Solana":
      if (!await pk(t)) return null;
      break;
    case "Sui":
      if (!_9(t)) return null;
      break;
    case "Aptos":
      if (!gk(t)) return null;
      break;
    default:
      return console.warn(`Unsupported platform: ${o}`), null;
  }
  try {
    return ki(e, t);
  } catch (i) {
    console.error(
      `Invalid address for chain ${e}: ${t}, error: ${i}`
    );
  }
  return null;
}
const Xh = (e) => {
  const t = Cr(), o = er(), i = Ce(
    () => ({
      listButton: {
        display: "flex",
        flexDirection: "row",
        padding: "12px 16px"
      },
      drawer: {
        width: "360px"
      },
      notInstalled: {
        opacity: 0.6
      },
      title: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
      },
      smOnly: {
        display: "none",
        [o.breakpoints.down("sm")]: {
          display: "block"
        }
      },
      addressInputContainer: {
        display: "flex",
        flexDirection: "row",
        gap: "8px",
        width: "100%",
        padding: "16px"
      },
      addressField: {
        flex: 1
      },
      submitButton: {
        width: "100%"
      }
    }),
    [o]
  ), { fromChain: c, toChain: n } = Ut(
    (z) => z.transferInput
  ), { onClose: d, type: f } = e, [p, l] = Xe(""), [h, y] = Xe(""), [M, C] = Xe(""), N = Ce(() => {
    const z = ge.chainsArr.map(
      (k) => Vr(k.sdkName)
    );
    return new Set(z);
  }, []), w = Ce(
    () => f === ar.SENDING ? c : n,
    [f, c, n]
  ), { walletOptionsResult: S } = Em({
    chain: w,
    supportedChains: N
  }), T = ht(
    async (z) => {
      w && (d == null || d(), await ps(f, w, z, t));
    },
    [w, f, d, t]
  ), E = ht(async () => {
    if (!w || !h) return;
    const z = ge.chains[w];
    if (!z) return;
    const k = await Dm(w, h);
    if (!k) {
      C("Invalid Address"), t(pa(ar.RECEIVING));
      return;
    }
    for (const U of Mc)
      if (k.toString().toLowerCase() === U.toLowerCase()) {
        C("Sanctioned Address"), t(pa(ar.RECEIVING));
        return;
      }
    const H = new Lo(k, w), W = {
      name: H.getName(),
      type: Vr(z.sdkName),
      icon: H.getIcon(),
      wallet: H
    };
    await ps(
      ar.RECEIVING,
      w,
      W,
      t
    ), d == null || d();
  }, [h, w, d, t]), j = ht(
    (z) => {
      const k = [...z].sort((W) => W.isReady ? -1 : 1), H = p ? k.filter(
        ({ name: W, type: U }) => [W, U].some(
          (B) => B.toLowerCase().includes(p.toLowerCase())
        )
      ) : k;
      return /* @__PURE__ */ D(Et, { children: H.length ? H.map((W) => /* @__PURE__ */ ne(
        Yr,
        {
          sx: i.listButton,
          dense: !0,
          onClick: () => W.isReady ? T(W) : window.open(W.wallet.getUrl()),
          children: [
            /* @__PURE__ */ D(Bo, { children: /* @__PURE__ */ D(Jh, { name: W.name, icon: W.icon }) }),
            /* @__PURE__ */ D(Fe, { component: "div", fontSize: 14, children: /* @__PURE__ */ ne(wt, { sx: W.isReady ? {} : i.notInstalled, children: [
              !W.isReady && "Install",
              " ",
              W.name
            ] }) })
          ]
        },
        W.name
      )) : /* @__PURE__ */ D(Mi, { children: /* @__PURE__ */ D(Fe, { children: "No results" }) }) });
    },
    [i.listButton, i.notInstalled, T, p]
  ), O = Ce(() => {
    var z;
    switch (S.state) {
      case "loading":
        return /* @__PURE__ */ D(Or, {});
      case "error":
        return /* @__PURE__ */ D(Gs, { error: !0, show: !0, content: S.error });
      case "result":
        return !!((z = S.options) != null && z.length) && /* @__PURE__ */ ne(hi, { children: [
          /* @__PURE__ */ D(Mi, { children: /* @__PURE__ */ ne(wt, { sx: i.title, children: [
            /* @__PURE__ */ D(Fe, { component: "div", fontSize: 16, children: e.type === ar.RECEIVING ? "Select destination wallet" : "Connect a wallet" }),
            /* @__PURE__ */ D(wt, { sx: i.smOnly, children: /* @__PURE__ */ D(di, { onClick: e.onClose, sx: { padding: 0 }, children: /* @__PURE__ */ D(xl, { sx: { height: "18px", width: "18px" } }) }) })
          ] }) }),
          /* @__PURE__ */ D(Mi, { children: /* @__PURE__ */ D(
            Ii,
            {
              fullWidth: !0,
              placeholder: "Search for a wallet",
              size: "small",
              variant: "outlined",
              value: p,
              onChange: (k) => l(k.target.value),
              InputProps: {
                startAdornment: /* @__PURE__ */ D(Eo, { position: "start", children: /* @__PURE__ */ D(Sm, {}) })
              }
            }
          ) }),
          j(S.options),
          e.showAddressInput && !p && /* @__PURE__ */ ne(Mi, { sx: i.addressInputContainer, children: [
            /* @__PURE__ */ D(
              Ii,
              {
                sx: i.addressField,
                fullWidth: !0,
                placeholder: "Send to a wallet address",
                size: "small",
                variant: "outlined",
                value: h,
                onChange: (k) => {
                  y(k.target.value), C("");
                },
                error: !!M,
                helperText: M
              }
            ),
            /* @__PURE__ */ D(
              Oi,
              {
                variant: "contained",
                color: "primary",
                onClick: E,
                disabled: !h,
                children: "Submit"
              }
            )
          ] })
        ] });
      default:
        return /* @__PURE__ */ D(Et, {});
    }
  }, [
    S,
    i.title,
    i.smOnly,
    i.addressInputContainer,
    i.addressField,
    i.submitButton,
    e.type,
    e.onClose,
    e.showAddressInput,
    p,
    j,
    h,
    M,
    E
  ]);
  return /* @__PURE__ */ D(
    dl,
    {
      anchor: "right",
      open: f && e.open,
      onClose: () => {
        var z;
        return (z = e.onClose) == null ? void 0 : z.call(e);
      },
      slotProps: {
        paper: {
          sx: i.drawer
        }
      },
      children: /* @__PURE__ */ D(wt, { sx: i.drawer, children: O })
    }
  );
}, W6 = (e) => {
  const { disabled: t = !1, type: o } = e, i = Ut((l) => l.wallet[o]), [c, n] = Xe(!1), d = ht(
    async (l) => {
      t || (l == null || l.close(), n(!0));
    },
    [t]
  ), f = Ce(() => i != null && i.address ? /* @__PURE__ */ D("div", { children: `Connected to ${Kc(
    i.type,
    i.address
  )}` }) : null, [i.address, i.type]), p = Ce(() => {
    const l = /* @__PURE__ */ D("span", { style: { width: "100%" }, children: /* @__PURE__ */ D(
      so,
      {
        disableRipple: !0,
        variant: "primary",
        "data-testid": `${e.side}-section-connect-wallet-button`,
        disabled: t,
        sx: {
          "&:disabled": {
            cursor: "not-allowed",
            pointerEvents: "all !important"
          }
        },
        onClick: () => d(),
        children: /* @__PURE__ */ D(Fe, { textTransform: "none", children: `Connect ${e.side} wallet` })
      }
    ) });
    return t ? /* @__PURE__ */ D($n, { title: `Please select a ${e.side} network`, children: l }) : /* @__PURE__ */ ne(Et, { children: [
      l,
      /* @__PURE__ */ D(
        Xh,
        {
          open: c,
          type: e.type,
          onClose: () => {
            n(!1);
          },
          showAddressInput: e.type === ar.RECEIVING
        }
      )
    ] });
  }, [t, c, e.side, e.type, d]);
  return i && i.address ? f : p;
};
function yk(e) {
  return Bt("MuiCard", e);
}
Ft("MuiCard", ["root"]);
const Mk = (e) => {
  const {
    classes: t
  } = e;
  return Rt({
    root: ["root"]
  }, yk, t);
}, mk = Ke(ul, {
  name: "MuiCard",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  overflow: "hidden"
}), bn = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiCard"
  }), {
    className: c,
    raised: n = !1,
    ...d
  } = i, f = {
    ...i,
    raised: n
  }, p = Mk(f);
  return /* @__PURE__ */ D(mk, {
    className: It(p.root, c),
    elevation: n ? 8 : void 0,
    ref: o,
    ownerState: f,
    ...d
  });
});
fe.process.env.NODE_ENV !== "production" && (bn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * If `true`, the card will use raised styling.
   * @default false
   */
  raised: qn(b.bool, (e) => e.raised && e.variant === "outlined" ? new Error('MUI: Combining `raised={true}` with `variant="outlined"` has no effect.') : null),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object])
});
function vk(e) {
  return Bt("MuiCardContent", e);
}
Ft("MuiCardContent", ["root"]);
const bk = (e) => {
  const {
    classes: t
  } = e;
  return Rt({
    root: ["root"]
  }, vk, t);
}, xk = Ke("div", {
  name: "MuiCardContent",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: 16,
  "&:last-child": {
    paddingBottom: 24
  }
}), xn = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiCardContent"
  }), {
    className: c,
    component: n = "div",
    ...d
  } = i, f = {
    ...i,
    component: n
  }, p = bk(f);
  return /* @__PURE__ */ D(xk, {
    as: n,
    className: It(p.root, c),
    ownerState: f,
    ref: o,
    ...d
  });
});
fe.process.env.NODE_ENV !== "production" && (xn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object])
});
function bc(e) {
  const {
    children: t,
    defer: o = !1,
    fallback: i = null
  } = e, [c, n] = ue.useState(!1);
  return Rn(() => {
    o || n(!0);
  }, [o]), ue.useEffect(() => {
    o && n(!0);
  }, [o]), c ? t : i;
}
fe.process.env.NODE_ENV !== "production" && (bc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * You can wrap a node.
   */
  children: b.node,
  /**
   * If `true`, the component will not only prevent server-side rendering.
   * It will also defer the rendering of the children into a different screen frame.
   * @default false
   */
  defer: b.bool,
  /**
   * The fallback content to display.
   * @default null
   */
  fallback: b.node
});
fe.process.env.NODE_ENV !== "production" && (bc.propTypes = X1(bc.propTypes));
const wk = Ke("div", {
  name: "MuiSwipeArea",
  shouldForwardProp: hn
})(kt(({
  theme: e
}) => ({
  position: "fixed",
  top: 0,
  left: 0,
  bottom: 0,
  zIndex: e.zIndex.drawer - 1,
  variants: [{
    props: {
      anchor: "left"
    },
    style: {
      right: "auto"
    }
  }, {
    props: {
      anchor: "right"
    },
    style: {
      left: "auto",
      right: 0
    }
  }, {
    props: {
      anchor: "top"
    },
    style: {
      bottom: "auto",
      right: 0
    }
  }, {
    props: {
      anchor: "bottom"
    },
    style: {
      top: "auto",
      bottom: 0,
      right: 0
    }
  }]
}))), jm = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const {
    anchor: i,
    classes: c = {},
    className: n,
    width: d,
    style: f,
    ...p
  } = t, l = t;
  return /* @__PURE__ */ D(wk, {
    className: It("PrivateSwipeArea-root", c.root, c[`anchor${it(i)}`], n),
    ref: o,
    style: {
      [co(i) ? "width" : "height"]: d,
      ...f
    },
    ownerState: l,
    ...p
  });
});
fe.process.env.NODE_ENV !== "production" && (jm.propTypes = {
  /**
   * Side on which to attach the discovery area.
   */
  anchor: b.oneOf(["left", "top", "right", "bottom"]).isRequired,
  /**
   * @ignore
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * @ignore
   */
  style: b.object,
  /**
   * The width of the left most (or right most) area in `px` where the
   * drawer can be swiped open from.
   */
  width: b.number.isRequired
});
const S0 = 3, Od = 20;
let yi = null;
function zd(e, t, o) {
  return e === "right" ? o.body.offsetWidth - t[0].pageX : t[0].pageX;
}
function kd(e, t, o) {
  return e === "bottom" ? o.innerHeight - t[0].clientY : t[0].clientY;
}
function Ra(e, t) {
  return e ? t.clientWidth : t.clientHeight;
}
function H6(e, t, o, i) {
  return Math.min(Math.max(o ? t - e : i + t - e, 0), i);
}
function Ck(e, t) {
  const o = [];
  for (; e && e !== t.parentElement; ) {
    const i = fn(t).getComputedStyle(e);
    // Ignore the scroll children if the element is absolute positioned.
    i.getPropertyValue("position") === "absolute" || // Ignore the scroll children if the element has an overflowX hidden
    i.getPropertyValue("overflow-x") === "hidden" || (e.clientWidth > 0 && e.scrollWidth > e.clientWidth || e.clientHeight > 0 && e.scrollHeight > e.clientHeight) && o.push(e), e = e.parentElement;
  }
  return o;
}
function Ik({
  domTreeShapes: e,
  start: t,
  current: o,
  anchor: i
}) {
  const c = {
    scrollPosition: {
      x: "scrollLeft",
      y: "scrollTop"
    },
    scrollLength: {
      x: "scrollWidth",
      y: "scrollHeight"
    },
    clientLength: {
      x: "clientWidth",
      y: "clientHeight"
    }
  };
  return e.some((n) => {
    let d = o >= t;
    (i === "top" || i === "left") && (d = !d);
    const f = i === "left" || i === "right" ? "x" : "y", p = Math.round(n[c.scrollPosition[f]]), l = p > 0, h = p + n[c.clientLength[f]] < n[c.scrollLength[f]];
    return !!(d && h || !d && l);
  });
}
const Nk = typeof navigator < "u" && /iPad|iPhone|iPod/.test(navigator.userAgent), wl = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    name: "MuiSwipeableDrawer",
    props: t
  }), c = or(), n = {
    enter: c.transitions.duration.enteringScreen,
    exit: c.transitions.duration.leavingScreen
  }, {
    anchor: d = "left",
    disableBackdropTransition: f = !1,
    disableDiscovery: p = !1,
    disableSwipeToOpen: l = Nk,
    hideBackdrop: h,
    hysteresis: y = 0.52,
    allowSwipeInChildren: M = !1,
    minFlingVelocity: C = 450,
    ModalProps: {
      BackdropProps: N,
      ...w
    } = {},
    onClose: S,
    onOpen: T,
    open: E = !1,
    PaperProps: j = {},
    SwipeAreaProps: O,
    swipeAreaWidth: z = 20,
    transitionDuration: k = n,
    variant: H = "temporary",
    // Mobile first.
    slots: W = {},
    slotProps: U = {},
    ...B
  } = i, [I, r] = ue.useState(!1), s = ue.useRef({
    isSwiping: null
  }), u = ue.useRef(), g = ue.useRef(), v = ue.useRef(), A = zr(j.ref, v), L = ue.useRef(!1), m = ue.useRef();
  Rn(() => {
    m.current = null;
  }, [E]);
  const a = ue.useCallback((R, Q = {}) => {
    const {
      mode: $ = null,
      changeTransition: F = !0
    } = Q, P = Va(c, d), _ = ["right", "bottom"].includes(P) ? 1 : -1, X = co(d), le = X ? `translate(${_ * R}px, 0)` : `translate(0, ${_ * R}px)`, ie = v.current.style;
    ie.webkitTransform = le, ie.transform = le;
    let oe = "";
    if ($ && (oe = c.transitions.create("all", wi({
      easing: void 0,
      style: void 0,
      timeout: k
    }, {
      mode: $
    }))), F && (ie.webkitTransition = oe, ie.transition = oe), !f && !h) {
      const pe = g.current.style;
      pe.opacity = 1 - R / Ra(X, v.current), F && (pe.webkitTransition = oe, pe.transition = oe);
    }
  }, [d, f, h, c, k]), x = _n((R) => {
    if (!L.current)
      return;
    if (yi = null, L.current = !1, hc.flushSync(() => {
      r(!1);
    }), !s.current.isSwiping) {
      s.current.isSwiping = null;
      return;
    }
    s.current.isSwiping = null;
    const Q = Va(c, d), $ = co(d);
    let F;
    $ ? F = zd(Q, R.changedTouches, Xr(R.currentTarget)) : F = kd(Q, R.changedTouches, fn(R.currentTarget));
    const P = $ ? s.current.startX : s.current.startY, _ = Ra($, v.current), X = H6(F, P, E, _), le = X / _;
    if (Math.abs(s.current.velocity) > C && (m.current = Math.abs((_ - X) / s.current.velocity) * 1e3), E) {
      s.current.velocity > C || le > y ? S() : a(0, {
        mode: "exit"
      });
      return;
    }
    s.current.velocity < -C || 1 - le > y ? T() : a(Ra($, v.current), {
      mode: "enter"
    });
  }), V = (R = !1) => {
    if (!I) {
      (R || !(p && M)) && hc.flushSync(() => {
        r(!0);
      });
      const Q = co(d);
      !E && v.current && a(Ra(Q, v.current) + (p ? 15 : -Od), {
        changeTransition: !1
      }), s.current.velocity = 0, s.current.lastTime = null, s.current.lastTranslate = null, s.current.paperHit = !1, L.current = !0;
    }
  }, G = _n((R) => {
    if (!v.current || !L.current || yi !== null && yi !== s.current)
      return;
    V(!0);
    const Q = Va(c, d), $ = co(d), F = zd(Q, R.touches, Xr(R.currentTarget)), P = kd(Q, R.touches, fn(R.currentTarget));
    if (E && v.current.contains(R.target) && yi === null) {
      const oe = Ck(R.target, v.current);
      if (Ik({
        domTreeShapes: oe,
        start: $ ? s.current.startX : s.current.startY,
        current: $ ? F : P,
        anchor: d
      })) {
        yi = !0;
        return;
      }
      yi = s.current;
    }
    if (s.current.isSwiping == null) {
      const oe = Math.abs(F - s.current.startX), pe = Math.abs(P - s.current.startY), se = $ ? oe > pe && oe > S0 : pe > oe && pe > S0;
      if (se && R.cancelable && R.preventDefault(), se === !0 || ($ ? pe > S0 : oe > S0)) {
        if (s.current.isSwiping = se, !se) {
          x(R);
          return;
        }
        s.current.startX = F, s.current.startY = P, !p && !E && ($ ? s.current.startX -= Od : s.current.startY -= Od);
      }
    }
    if (!s.current.isSwiping)
      return;
    const _ = Ra($, v.current);
    let X = $ ? s.current.startX : s.current.startY;
    E && !s.current.paperHit && (X = Math.min(X, _));
    const le = H6($ ? F : P, X, E, _);
    if (E)
      if (s.current.paperHit)
        le === 0 && (s.current.startX = F, s.current.startY = P);
      else if ($ ? F < _ : P < _)
        s.current.paperHit = !0, s.current.startX = F, s.current.startY = P;
      else
        return;
    s.current.lastTranslate === null && (s.current.lastTranslate = le, s.current.lastTime = performance.now() + 1);
    const ie = (le - s.current.lastTranslate) / (performance.now() - s.current.lastTime) * 1e3;
    s.current.velocity = s.current.velocity * 0.4 + ie * 0.6, s.current.lastTranslate = le, s.current.lastTime = performance.now(), R.cancelable && R.preventDefault(), a(le);
  }), Z = _n((R) => {
    var _;
    if (R.defaultPrevented || R.defaultMuiPrevented || E && (h || !g.current.contains(R.target)) && !v.current.contains(R.target))
      return;
    const Q = Va(c, d), $ = co(d), F = zd(Q, R.touches, Xr(R.currentTarget)), P = kd(Q, R.touches, fn(R.currentTarget));
    if (!E) {
      if (l || !(R.target === u.current || (_ = v.current) != null && _.contains(R.target) && (typeof M == "function" ? M(R, u.current, v.current) : M)))
        return;
      if ($) {
        if (F > z)
          return;
      } else if (P > z)
        return;
    }
    R.defaultMuiPrevented = !0, yi = null, s.current.startX = F, s.current.startY = P, V();
  });
  ue.useEffect(() => {
    if (H === "temporary") {
      const R = Xr(v.current);
      return R.addEventListener("touchstart", Z), R.addEventListener("touchmove", G, {
        passive: !E
      }), R.addEventListener("touchend", x), () => {
        R.removeEventListener("touchstart", Z), R.removeEventListener("touchmove", G, {
          passive: !E
        }), R.removeEventListener("touchend", x);
      };
    }
  }, [H, E, Z, G, x]), ue.useEffect(() => () => {
    yi === s.current && (yi = null);
  }, []), ue.useEffect(() => {
    E || r(!1);
  }, [E]);
  const [te, q] = qt("swipeArea", {
    ref: u,
    elementType: jm,
    ownerState: i,
    externalForwardedProps: {
      slots: W,
      slotProps: {
        swipeArea: O,
        ...U
      }
    },
    additionalProps: {
      width: z,
      anchor: d
    }
  });
  return /* @__PURE__ */ ne(ue.Fragment, {
    children: [/* @__PURE__ */ D(dl, {
      open: H === "temporary" && I ? !0 : E,
      variant: H,
      ModalProps: {
        BackdropProps: {
          ...N,
          ref: g
        },
        // Ensures that paperRef.current will be defined inside the touch start event handler
        // See https://github.com/mui/material-ui/issues/30414 for more information
        ...H === "temporary" && {
          keepMounted: !0
        },
        ...w
      },
      hideBackdrop: h,
      anchor: d,
      transitionDuration: m.current || k,
      onClose: S,
      ref: o,
      slots: W,
      slotProps: {
        ...U,
        backdrop: uc(U.backdrop ?? N, {
          ref: g
        }),
        paper: uc(U.paper ?? j, {
          style: {
            pointerEvents: H === "temporary" && !E && !M ? "none" : ""
          },
          ref: A
        })
      },
      ...B
    }), !l && H === "temporary" && /* @__PURE__ */ D(bc, {
      children: /* @__PURE__ */ D(te, {
        ...q
      })
    })]
  });
});
fe.process.env.NODE_ENV !== "production" && (wl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If set to true, the swipe event will open the drawer even if the user begins the swipe on one of the drawer's children.
   * This can be useful in scenarios where the drawer is partially visible.
   * You can customize it further with a callback that determines which children the user can drag over to open the drawer
   * (for example, to ignore other elements that handle touch move events, like sliders).
   *
   * @param {TouchEvent} event The 'touchstart' event
   * @param {HTMLDivElement} swipeArea The swipe area element
   * @param {HTMLDivElement} paper The drawer's paper element
   *
   * @default false
   */
  allowSwipeInChildren: b.oneOfType([b.func, b.bool]),
  /**
   * @ignore
   */
  anchor: b.oneOf(["bottom", "left", "right", "top"]),
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Disable the backdrop transition.
   * This can improve the FPS on low-end devices.
   * @default false
   */
  disableBackdropTransition: b.bool,
  /**
   * If `true`, touching the screen near the edge of the drawer will not slide in the drawer a bit
   * to promote accidental discovery of the swipe gesture.
   * @default false
   */
  disableDiscovery: b.bool,
  /**
   * If `true`, swipe to open is disabled. This is useful in browsers where swiping triggers
   * navigation actions. Swipe to open is disabled on iOS browsers by default.
   * @default typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent)
   */
  disableSwipeToOpen: b.bool,
  /**
   * @ignore
   */
  hideBackdrop: b.bool,
  /**
   * Affects how far the drawer must be opened/closed to change its state.
   * Specified as percent (0-1) of the width of the drawer
   * @default 0.52
   */
  hysteresis: b.number,
  /**
   * Defines, from which (average) velocity on, the swipe is
   * defined as complete although hysteresis isn't reached.
   * Good threshold is between 250 - 1000 px/s
   * @default 450
   */
  minFlingVelocity: b.number,
  /**
   * @ignore
   */
  ModalProps: b.shape({
    BackdropProps: b.shape({
      component: Fi
    })
  }),
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent<{}>} event The event source of the callback.
   */
  onClose: b.func.isRequired,
  /**
   * Callback fired when the component requests to be opened.
   *
   * @param {React.SyntheticEvent<{}>} event The event source of the callback.
   */
  onOpen: b.func.isRequired,
  /**
   * If `true`, the component is shown.
   * @default false
   */
  open: b.bool,
  /**
   * @ignore
   */
  PaperProps: b.shape({
    component: Fi,
    style: b.object
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: b.shape({
    backdrop: b.oneOfType([b.func, b.object]),
    docked: b.oneOfType([b.func, b.object]),
    paper: b.oneOfType([b.func, b.object]),
    root: b.oneOfType([b.func, b.object]),
    swipeArea: b.oneOfType([b.func, b.object]),
    transition: b.oneOfType([b.func, b.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: b.shape({
    backdrop: b.elementType,
    docked: b.elementType,
    paper: b.elementType,
    root: b.elementType,
    swipeArea: b.elementType,
    transition: b.elementType
  }),
  /**
   * The element is used to intercept the touch events on the edge.
   * @deprecated use the `slotProps.swipeArea` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SwipeAreaProps: b.object,
  /**
   * The width of the left most (or right most) area in `px` that
   * the drawer can be swiped open from.
   * @default 20
   */
  swipeAreaWidth: b.number,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: b.oneOfType([b.number, b.shape({
    appear: b.number,
    enter: b.number,
    exit: b.number
  })]),
  /**
   * @ignore
   */
  variant: b.oneOf(["permanent", "persistent", "temporary"])
});
function Pa(e) {
  if (typeof window > "u")
    return e;
  const t = ue.useRef(null);
  return ue.useLayoutEffect(() => {
    t.current = e;
  }), ue.useCallback((...o) => {
    var i;
    (i = t.current) === null || i === void 0 || i.call(t, ...o);
  }, []);
}
const Z6 = {};
function Ak(e, t) {
  Z6[e] || (Z6[e] = !0, console.error("[material-ui-popup-state] WARNING", t));
}
const Tk = {
  isOpen: !1,
  setAnchorElUsed: !1,
  anchorEl: void 0,
  anchorPosition: void 0,
  hovered: !1,
  focused: !1,
  _openEventType: null,
  _childPopupState: null,
  _deferNextOpen: !1,
  _deferNextClose: !1
}, Q6 = ue, Lk = "useId" in Q6 ? () => Q6.useId() : () => {
};
function Cl({
  parentPopupState: e,
  popupId: t = Lk(),
  variant: o,
  disableAutoFocus: i
}) {
  const c = _r(!0);
  St(() => (c.current = !0, () => {
    c.current = !1;
  }), []);
  const [n, d] = Xe(Tk), f = ht((E) => {
    c.current && d(E);
  }, []), p = ht((E) => f((j) => ({
    ...j,
    setAnchorElUsed: !0,
    anchorEl: E ?? void 0
  })), []), l = Pa((E) => (n.isOpen ? M(E) : h(E), n)), h = Pa((E) => {
    const j = E instanceof Element ? void 0 : E, O = E instanceof Element ? E : (E == null ? void 0 : E.currentTarget) instanceof Element ? E.currentTarget : void 0;
    if ((j == null ? void 0 : j.type) === "touchstart") {
      f((U) => ({
        ...U,
        _deferNextOpen: !0
      }));
      return;
    }
    const z = j == null ? void 0 : j.clientX, k = j == null ? void 0 : j.clientY, H = typeof z == "number" && typeof k == "number" ? {
      left: z,
      top: k
    } : void 0, W = (U) => {
      if (!E && !U.setAnchorElUsed && o !== "dialog" && Ak("missingEventOrAnchorEl", "eventOrAnchorEl should be defined if setAnchorEl is not used"), e) {
        if (!e.isOpen) return U;
        setTimeout(() => e._setChildPopupState(T));
      }
      const B = {
        ...U,
        isOpen: !0,
        anchorPosition: H,
        hovered: (j == null ? void 0 : j.type) === "mouseover" || U.hovered,
        focused: (j == null ? void 0 : j.type) === "focus" || U.focused,
        _openEventType: j == null ? void 0 : j.type
      };
      return U.setAnchorElUsed || (j != null && j.currentTarget ? B.anchorEl = j.currentTarget : O && (B.anchorEl = O)), B;
    };
    f((U) => U._deferNextOpen ? (setTimeout(() => f(W), 0), {
      ...U,
      _deferNextOpen: !1
    }) : W(U));
  }), y = (E) => {
    const {
      _childPopupState: j
    } = E;
    return setTimeout(() => {
      j == null || j.close(), e == null || e._setChildPopupState(null);
    }), {
      ...E,
      isOpen: !1,
      hovered: !1,
      focused: !1
    };
  }, M = Pa((E) => {
    const j = E instanceof Element ? void 0 : E;
    if ((j == null ? void 0 : j.type) === "touchstart") {
      f((O) => ({
        ...O,
        _deferNextClose: !0
      }));
      return;
    }
    f((O) => O._deferNextClose ? (setTimeout(() => f(y), 0), {
      ...O,
      _deferNextClose: !1
    }) : y(O));
  }), C = ht((E, j) => {
    E ? h(j) : M(j);
  }, []), N = Pa((E) => {
    const {
      relatedTarget: j
    } = E;
    f((O) => O.hovered && !(j instanceof Element && O1(j, T)) ? O.focused ? {
      ...O,
      hovered: !1
    } : y(O) : O);
  }), w = Pa((E) => {
    if (!E) return;
    const {
      relatedTarget: j
    } = E;
    f((O) => O.focused && !(j instanceof Element && O1(j, T)) ? O.hovered ? {
      ...O,
      focused: !1
    } : y(O) : O);
  }), S = ht((E) => f((j) => ({
    ...j,
    _childPopupState: E
  })), []), T = {
    ...n,
    setAnchorEl: p,
    popupId: t ?? void 0,
    variant: o,
    open: h,
    close: M,
    toggle: l,
    setOpen: C,
    onBlur: w,
    onMouseLeave: N,
    disableAutoFocus: i ?? !!(n.hovered || n.focused),
    _setChildPopupState: S
  };
  return T;
}
function Sk({
  isOpen: e,
  popupId: t,
  variant: o
}) {
  return {
    ...o === "popover" ? {
      "aria-haspopup": !0,
      "aria-controls": e ? t : void 0
    } : o === "popper" ? {
      "aria-describedby": e ? t : void 0
    } : void 0
  };
}
function Il(e) {
  return {
    ...Sk(e),
    onClick: e.open,
    onTouchStart: e.open
  };
}
function Nl({
  isOpen: e,
  anchorEl: t,
  anchorPosition: o,
  close: i,
  popupId: c,
  onMouseLeave: n,
  disableAutoFocus: d,
  _openEventType: f
}) {
  return {
    id: c,
    anchorEl: t,
    anchorPosition: o,
    anchorReference: f === "contextmenu" ? "anchorPosition" : "anchorEl",
    open: e,
    onClose: i,
    onMouseLeave: n,
    ...d && {
      disableAutoFocus: !0,
      disableEnforceFocus: !0,
      disableRestoreFocus: !0
    }
  };
}
function Ek(e, {
  popupId: t
}) {
  if (!t) return null;
  const o = typeof e.getRootNode == "function" ? e.getRootNode() : document;
  return typeof o.getElementById == "function" ? o.getElementById(t) : null;
}
function O1(e, t) {
  const {
    anchorEl: o,
    _childPopupState: i
  } = t;
  return V6(o, e) || V6(Ek(e, t), e) || i != null && O1(e, i);
}
function V6(e, t) {
  if (!e) return !1;
  for (; t; ) {
    if (t === e) return !0;
    t = t.parentElement;
  }
  return !1;
}
const Om = an(/* @__PURE__ */ D("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore"), zm = an(/* @__PURE__ */ D("path", {
  d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), "ExpandLess"), km = dn(
  /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "36", height: "36", rx: "6", fill: "#2E2E34" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M17.1429 17.6429V12.5H18.8571V17.6429H24V19.3571H18.8571V24.5H17.1429V19.3571H12V17.6429H17.1429Z",
            fill: "white"
          }
        )
      ]
    }
  ),
  "Plus"
);
function Dk(e) {
  const t = or(), o = Hi(t.breakpoints.down("sm")), i = Ce(
    () => ({
      input: {
        "& fieldset": {
          borderRadius: "100vh"
        },
        "& input::placeholder": {
          color: t.palette.text.primary,
          opacity: 0.2
        },
        "& .MuiOutlinedInput-root": {
          "& .MuiOutlinedInput-input::placeholder": {
            fontWeight: 300
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderWidth: "1px"
          }
        }
      },
      icon: {
        height: 20,
        width: 20,
        color: t.palette.text.primary,
        opacity: 0.2
      }
    }),
    [t]
  );
  return /* @__PURE__ */ D(ut, { sx: { padding: "0 16px" }, children: /* @__PURE__ */ D(
    Ii,
    {
      sx: i.input,
      ref: (c) => {
        !o && c && setTimeout(() => {
          var n;
          (n = c.querySelector("input")) == null || n.focus();
        }, 10);
      },
      "data-testid": `${e.dataTestId}-input`,
      fullWidth: !0,
      placeholder: e.placeholder,
      size: "small",
      variant: "outlined",
      value: e.value,
      onChange: (c) => e.onChange(c.target.value),
      slotProps: {
        input: {
          startAdornment: /* @__PURE__ */ D(Eo, { position: "start", children: /* @__PURE__ */ D(Dh, { sx: i.icon }) })
        },
        htmlInput: {
          style: {
            fontSize: 16,
            height: 22,
            lineHeight: 22
          }
        }
      }
    }
  ) });
}
function jk(e) {
  const t = S8(), o = {
    wrapper: {
      maxHeight: "240px",
      display: "flex",
      flexDirection: "column",
      padding: 0
    },
    searchList: {
      marginTop: "12px",
      overflow: "auto"
    }
  }, { items: i, filterFn: c, searchQuery: n } = e, d = Ce(() => i.filter((f) => c(f, n)), [i, c, n]);
  return /* @__PURE__ */ ne(
    wt,
    {
      sx: { ...o.wrapper, ...e.sx },
      className: (e == null ? void 0 : e.className) || "",
      children: [
        e.title,
        /* @__PURE__ */ D(
          Dk,
          {
            value: e.searchQuery,
            dataTestId: e.dataTestId,
            onChange: e.onQueryChange,
            placeholder: e.searchPlaceholder
          }
        ),
        /* @__PURE__ */ ne(
          hi,
          {
            sx: { ...o.searchList, ...t },
            "data-testid": e.dataTestId,
            children: [
              /* @__PURE__ */ D(wt, { sx: { padding: "0 16px" }, children: e.listTitle }),
              e.loading || d.map(e.renderFn)
            ]
          }
        )
      ]
    }
  );
}
const _m = Sn(jk), Ua = 5, G6 = (e) => {
  const t = or(), [o, i] = Xe(""), c = Ce(
    () => ({
      card: {
        background: t.palette.input.background,
        maxWidth: "420px",
        [t.breakpoints.down("sm")]: {
          width: "100vw"
        }
      },
      cardContent: {
        paddingBottom: "0!important",
        [t.breakpoints.down("sm")]: {
          padding: "16px 10px",
          ":last-child": {
            padding: "16px 10px"
          }
        }
      },
      title: {
        fontSize: "14px",
        marginBottom: "12px"
      },
      chainSearch: {
        maxHeight: "400px",
        [t.breakpoints.down("sm")]: {
          maxHeight: "600px"
        }
      },
      chainButton: {
        display: "flex",
        flexDirection: "column",
        padding: "8px",
        border: "1px solid transparent",
        borderRadius: "8px",
        "&.Mui-selected": {
          border: "1px solid",
          borderColor: t.palette.primary.main
        }
      },
      chainItem: {
        display: "flex",
        flexDirection: "row",
        padding: "8px",
        borderRadius: "8px"
      }
    }),
    [t]
  ), {
    chainList: n,
    selectedChainConfig: d,
    showSearch: f,
    setShowSearch: p,
    onChainSelect: l
  } = e, [h, y] = Ce(() => {
    const N = n ?? [], w = d, S = N.findIndex((T) => T.sdkName === (w == null ? void 0 : w.sdkName));
    return w && S && S >= Ua ? [
      [w, ...N.slice(0, Ua - 1)],
      N.length > Ua
    ] : [
      N.slice(0, Ua),
      N.length > Ua
    ];
  }, [n, d]), M = Ce(() => /* @__PURE__ */ ne(hi, { component: Tt, direction: "row", "data-testid": "chain-short-list", children: [
    h.map((N) => /* @__PURE__ */ D($n, { title: N.displayName, children: /* @__PURE__ */ ne(
      Yr,
      {
        selected: (d == null ? void 0 : d.sdkName) === N.sdkName,
        sx: c.chainButton,
        "data-testid": `chain-button-${N.sdkName.toLowerCase()}`,
        onClick: () => l(N.sdkName),
        children: [
          /* @__PURE__ */ D(Un, { icon: N.icon }),
          /* @__PURE__ */ D(
            Fe,
            {
              fontSize: "12px",
              lineHeight: "12px",
              marginTop: "8px",
              whiteSpace: "nowrap",
              children: N.symbol
            }
          )
        ]
      }
    ) }, N.sdkName)),
    y ? /* @__PURE__ */ ne(
      Yr,
      {
        sx: c.chainButton,
        onClick: () => {
          p(!0);
        },
        children: [
          /* @__PURE__ */ D(km, { sx: { height: "36px", width: "36px" } }),
          /* @__PURE__ */ D(
            Fe,
            {
              fontSize: "12px",
              lineHeight: "12px",
              marginTop: "8px",
              whiteSpace: "nowrap",
              children: "other"
            }
          )
        ]
      }
    ) : null
  ] }), [
    c.chainButton,
    l,
    d == null ? void 0 : d.sdkName,
    p,
    y,
    h
  ]), C = Ce(
    () => /* @__PURE__ */ D(
      _m,
      {
        searchPlaceholder: "Search for a chain",
        sx: c.chainSearch,
        items: n ?? [],
        searchQuery: o,
        onQueryChange: i,
        filterFn: (N, w) => !w || N.displayName.toLowerCase().includes(w.toLowerCase()),
        renderFn: (N) => /* @__PURE__ */ ne(
          Yr,
          {
            dense: !0,
            sx: c.chainItem,
            onClick: () => {
              l(N.sdkName), p(!1);
            },
            children: [
              /* @__PURE__ */ D(Bo, { sx: { minWidth: "50px" }, children: /* @__PURE__ */ D(Un, { icon: N.icon, height: 36 }) }),
              /* @__PURE__ */ D(Fe, { fontSize: "16px", fontWeight: 500, children: N.displayName })
            ]
          },
          N.sdkName
        )
      }
    ),
    [
      n,
      o,
      c.chainItem,
      c.chainSearch,
      l,
      p
    ]
  );
  return h.length < 2 ? null : /* @__PURE__ */ D(bn, { sx: c.card, variant: "elevation", children: /* @__PURE__ */ ne(xn, { sx: c.cardContent, children: [
    /* @__PURE__ */ D(Fe, { sx: c.title, fontSize: "16px", fontWeight: 500, children: "Select a network" }),
    f ? C : M
  ] }) });
}, Kh = an(/* @__PURE__ */ D("path", {
  d: "M6 6v2h8.59L5 17.59 6.41 19 16 9.41V18h2V6z"
}), "ArrowOutward"), jt = "data:image/svg+xml;base64,";
function $6(e) {
  if (e === "Solana")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5NiIgaGVpZ2h0PSI4NCIgZmlsbD0ibm9uZSI+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBmaWxsPSJ1cmwoI2IpIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy4zNjggNjQuMDUyQTMuMjE0IDMuMjE0IDAgMCAxIDE5Ljc0NCA2M2w3My4zMTIuMDZhMS42MTIgMS42MTIgMCAwIDEgMS4xODggMi42OThsLTE1LjYxMiAxNy4xOUEzLjIxMyAzLjIxMyAwIDAgMSA3Ni4yNTQgODRsLTczLjMxLS4wNmExLjYxMSAxLjYxMSAwIDAgMS0xLjE4OC0yLjY5OGwxNS42MTItMTcuMTlabTc2Ljg3Ni0xNC4zMWExLjYxMSAxLjYxMSAwIDAgMS0xLjE4OCAyLjY5OGwtNzMuMzEuMDZhMy4yMTMgMy4yMTMgMCAwIDEtMi4zNzgtMS4wNTJsLTE1LjYxMi0xNy4yYTEuNjEyIDEuNjEyIDAgMCAxIDEuMTg4LTIuNjk4bDczLjMxMi0uMDZhMy4yMTMgMy4yMTMgMCAwIDEgMi4zNzYgMS4wNTJsMTUuNjEyIDE3LjJaTTE3LjM2OCAxLjA1MkEzLjIxNSAzLjIxNSAwIDAgMSAxOS43NDQgMGw3My4zMTIuMDZhMS42MTIgMS42MTIgMCAwIDEgMS4xODggMi42OThsLTE1LjYxMiAxNy4xOUEzLjIxMyAzLjIxMyAwIDAgMSA3Ni4yNTQgMjFsLTczLjMxLS4wNmExLjYxMSAxLjYxMSAwIDAgMS0xLjE4OC0yLjY5OGwxNS42MTItMTcuMTlaIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L2c+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJiIiB4MT0iNC4xNjgiIHgyPSI5MS44MzIiIHkxPSI4NS44MzIiIHkyPSItMS44MzIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBzdG9wLWNvbG9yPSIjOTk0NUZGIi8+PHN0b3Agb2Zmc2V0PSIuMiIgc3RvcC1jb2xvcj0iIzc5NjJFNyIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzAwRDE4QyIvPjwvbGluZWFyR3JhZGllbnQ+PGNsaXBQYXRoIGlkPSJhIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDk2djg0SDB6Ii8+PC9jbGlwUGF0aD48L2RlZnM+PC9zdmc+";
  if (e === "Ethereum" || e === "Sepolia" || e === "Holesky")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHZpZXdCb3g9IjAgMCAxOTIwIDE5MjAiPjxwYXRoIGZpbGw9IiM4QTkyQjIiIGQ9Ik05NTkuOCA4MC43IDQyMC4xIDk3Ni4zIDk1OS44IDczMXoiLz48cGF0aCBmaWxsPSIjNjI2ODhGIiBkPSJNOTU5LjggNzMxIDQyMC4xIDk3Ni4zbDUzOS43IDMxOS4xem01MzkuOCAyNDUuM0w5NTkuOCA4MC43VjczMXoiLz48cGF0aCBmaWxsPSIjNDU0QTc1IiBkPSJtOTU5LjggMTI5NS40IDUzOS44LTMxOS4xTDk1OS44IDczMXoiLz48cGF0aCBmaWxsPSIjOEE5MkIyIiBkPSJtNDIwLjEgMTA3OC43IDUzOS43IDc2MC42di00NDEuN3oiLz48cGF0aCBmaWxsPSIjNjI2ODhGIiBkPSJNOTU5LjggMTM5Ny42djQ0MS43bDU0MC4xLTc2MC42eiIvPjwvc3ZnPg==";
  if (e === "Terra")
    return jt + "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";
  if (e === "Bsc")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iI0YwQjkwQiIgZD0iTTIwLjMwMiAwIDkuNjggNi4xMjdsMy45MDYgMi4yNjMgNi43MTctMy44NjNMMjcuMDIgOC4zOWwzLjkwNi0yLjI2M0wyMC4zMDMgMFptNi43MTggMTEuNTkgMy45MDYgMi4yNjR2NC41MjdsLTYuNzE4IDMuODYzdjcuNzI3bC0zLjkwNSAyLjI2My0zLjkwNi0yLjI2M3YtNy43MjdMOS42NzkgMTguMzh2LTQuNTI3bDMuOTA2LTIuMjY0IDYuNzE3IDMuODY0IDYuNzE4LTMuODY0WiIvPjxwYXRoIGZpbGw9IiNGMEI5MEIiIGQ9Ik0zMC45MjYgMjEuNTh2NC41MjdsLTMuOTA2IDIuMjY0di00LjUyN2wzLjkwNi0yLjI2NFoiLz48cGF0aCBmaWxsPSIjRjBCOTBCIiBkPSJtMjYuOTgxIDMxLjU3IDYuNzE4LTMuODYzVjE5Ljk4bDMuOTA2LTIuMjYzdjEyLjI1NGwtMTAuNjI0IDYuMTI3VjMxLjU3Wk0zMy43IDEyLjI1NCAyOS43OTIgOS45OSAzMy43IDcuNzI3bDMuOTA2IDIuMjYzdjQuNTI3TDMzLjcgMTYuNzgxdi00LjUyN1pNMTYuMzk3IDM3LjczN1YzMy4yMWwzLjkwNSAyLjI2MyAzLjkwNi0yLjI2M3Y0LjUyN0wyMC4zMDMgNDBsLTMuOTA2LTIuMjYzWm0tMi44MTItOS4zNjctMy45MDYtMi4yNjN2LTQuNTI2bDMuOTA2IDIuMjYzdjQuNTI3Wm02LjcxNy0xNi4xMTZMMTYuMzk3IDkuOTlsMy45MDUtMi4yNjMgMy45MDYgMi4yNjMtMy45MDUgMi4yNjRabS05LjQ5LTIuMjY0LTMuOTA2IDIuMjY0djQuNTI3TDMgMTQuNTE3VjkuOTlsMy45MDYtMi4yNjMgMy45MDYgMi4yNjNaIi8+PHBhdGggZmlsbD0iI0YwQjkwQiIgZD0ibTMgMTcuNzE3IDMuOTA2IDIuMjY0djcuNzI2bDYuNzE4IDMuODY0djQuNTI3TDMgMjkuOTdWMTcuNzE3WiIvPjwvc3ZnPg==";
  if (e === "Polygon" || e === "PolygonSepolia")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDM4LjQgMzMuNSIgdmlld0JveD0iMCAwIDM4LjQgMzMuNSI+PHBhdGggZD0iTTI5IDEwLjJjLS43LS40LTEuNi0uNC0yLjQgMEwyMSAxMy41bC0zLjggMi4xLTUuNSAzLjNjLS43LjQtMS42LjQtMi40IDBMNSAxNi4zYy0uNy0uNC0xLjItMS4yLTEuMi0yLjF2LTVjMC0uOC40LTEuNiAxLjItMi4xbDQuMy0yLjVjLjctLjQgMS42LS40IDIuNCAwTDE2IDcuMmMuNy40IDEuMiAxLjIgMS4yIDIuMXYzLjNsMy44LTIuMlY3YzAtLjgtLjQtMS42LTEuMi0yLjFsLTgtNC43Yy0uNy0uNC0xLjYtLjQtMi40IDBMMS4yIDVDLjQgNS40IDAgNi4yIDAgN3Y5LjRjMCAuOC40IDEuNiAxLjIgMi4xbDguMSA0LjdjLjcuNCAxLjYuNCAyLjQgMGw1LjUtMy4yIDMuOC0yLjIgNS41LTMuMmMuNy0uNCAxLjYtLjQgMi40IDBsNC4zIDIuNWMuNy40IDEuMiAxLjIgMS4yIDIuMXY1YzAgLjgtLjQgMS42LTEuMiAyLjFMMjkgMjguOGMtLjcuNC0xLjYuNC0yLjQgMGwtNC4zLTIuNWMtLjctLjQtMS4yLTEuMi0xLjItMi4xVjIxbC0zLjggMi4ydjMuM2MwIC44LjQgMS42IDEuMiAyLjFsOC4xIDQuN2MuNy40IDEuNi40IDIuNCAwbDguMS00LjdjLjctLjQgMS4yLTEuMiAxLjItMi4xVjE3YzAtLjgtLjQtMS42LTEuMi0yLjFMMjkgMTAuMnoiIHN0eWxlPSJmaWxsOiM4MjQ3ZTUiLz48L3N2Zz4=";
  if (e === "Avalanche")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI1NCAyNTQiIHZpZXdCb3g9IjAgMCAyNTQgMjU0Ij48Y2lyY2xlIGN4PSIxMjciIGN5PSIxMjciIHI9IjEyNyIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO2ZpbGw6I2U4NDE0MiIvPjxwYXRoIGQ9Ik0xNzEuOCAxMzAuM2M0LjQtNy42IDExLjUtNy42IDE1LjkgMGwyNy40IDQ4LjFjNC40IDcuNi44IDEzLjgtOCAxMy44aC01NS4yYy04LjcgMC0xMi4zLTYuMi04LTEzLjhsMjcuOS00OC4xem0tNTMtOTIuNmM0LjQtNy42IDExLjQtNy42IDE1LjggMGw2LjEgMTFMMTU1LjEgNzRjMy41IDcuMiAzLjUgMTUuNyAwIDIyLjlsLTQ4LjMgODMuN2MtNC40IDYuOC0xMS43IDExLjEtMTkuOCAxMS42SDQ2LjljLTguOCAwLTEyLjQtNi4xLTgtMTMuOGw3OS45LTE0MC43eiIgc3R5bGU9ImZpbGw6I2ZmZiIvPjwvc3ZnPg==";
  if (e === "Oasis")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMjggMTI4IiB2aWV3Qm94PSIwIDAgMTI4IDEyOCI+PGRlZnM+PHBhdGggaWQ9ImEiIGQ9Ik0wIDBoMTI4djEyOEgweiIvPjwvZGVmcz48Y2xpcFBhdGggaWQ9ImIiPjx1c2UgeGxpbms6aHJlZj0iI2EiIHN0eWxlPSJvdmVyZmxvdzp2aXNpYmxlIi8+PC9jbGlwUGF0aD48ZyBzdHlsZT0iY2xpcC1wYXRoOnVybCgjYikiPjxwYXRoIGQ9Ik0xMTUgMjUuNEMxMDUuMyAxMyA5MS4xIDUuMSA3NS40IDUuMSA0NSA1LjEgMjIuNyAzMy40IDIyLjcgNjRjMCAyMS4zIDE0LjIgMzcuMyAyOS45IDM3LjMgMS41IDAgMi45LS4xIDQuNC0uNEM0Ni40IDkzLjIgMzkuNyA3OS4yIDM5LjcgNjRjMC0yNC4yIDE2LjQtNDMuMSAzNS43LTQzLjEgMjEuMSAwIDM1LjcgMjAuOSAzNS43IDQzLjEtLjEgMTYuNC01LjkgMzIuNy0xNi4yIDQ0LjctOSAxMC41LTIwLjYgMTcuMS0zMy40IDE5LjIgMCAwIDEuMS4xIDIuNS4xIDM1LjMgMCA2NC0yOC43IDY0LTY0IDAtMTQuNS00LjgtMjcuOS0xMy0zOC42ek0xMDUuMyA2NGMwLTIxLjMtMTQuMi0zNy4zLTI5LjktMzcuMy0xLjUgMC0yLjkuMS00LjQuNEM4MS42IDM0LjggODguMyA0OC44IDg4LjMgNjRjMCAyNC4yLTE2LjQgNDMuMS0zNS43IDQzLjEtMjEuMSAwLTM1LjctMjAuOS0zNS43LTQzLjEuMS0xNi40IDUuOS0zMi43IDE2LjItNDQuN0M0Mi4xIDguOCA1My43IDIuMiA2Ni41LjFjMCAwLTEuMS0uMS0yLjUtLjFDMjguNyAwIDAgMjguNyAwIDY0YzAgMTQuNSA0LjggMjcuOSAxMyAzOC42IDkuNyAxMi40IDIzLjkgMjAuMiAzOS42IDIwLjIgMzAuNC4xIDUyLjctMjguMiA1Mi43LTU4Ljh6IiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7ZmlsbDojMDA4OWRiIi8+PC9nPjwvc3ZnPg==";
  if (e === "Algorand")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGRhdGEtbmFtZT0iTGF5ZXIgMSIgdmlld0JveD0iMCAwIDY1MCA2NTAiPjxwYXRoIGQ9Ik00NDQuMTggNDQ0LjMyaC0zNy4zN2wtMjQuMjctOTAuMjgtNTIuMTggOTAuMjloLTQxLjcybDgwLjY1LTEzOS43Ni0xMi45OC00OC41Mi0xMDguNzUgMTg4LjMxaC00MS43NGwxMzcuODItMjM4LjcyaDM2LjU0bDE2IDU5LjMxaDM3LjdsLTI1Ljc0IDQ0Ljc2IDM2LjA0IDEzNC42MXoiIHN0eWxlPSJmaWxsOiNmZmYiLz48L3N2Zz4=";
  if (e === "Aurora")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHZpZXdCb3g9IjAgMCAyODggMjg4Ij48cGF0aCBkPSJNMTQ0IDBjNzkuNSAwIDE0NCA2NC41IDE0NCAxNDRzLTY0LjUgMTQ0LTE0NCAxNDRTMCAyMjMuNSAwIDE0NCA2NC41IDAgMTQ0IDB6IiBzdHlsZT0iZmlsbDojNzBkNDRiIi8+PHBhdGggZD0iTTE0NCA1OC44YzcuNiAwIDE0LjUgNC4zIDE3LjkgMTEuMWw1Ni4yIDExMi41YzQuOSA5LjkuOSAyMS45LTkgMjYuOC0yLjggMS40LTUuOCAyLjEtOC45IDIuMUg4Ny44Yy0xMSAwLTIwLTktMjAtMjAgMC0zLjEuNy02LjIgMi4xLTguOWw1Ni4yLTExMi41YzMuNC02LjkgMTAuMy0xMS4yIDE3LjktMTEuMW0wLTEzLjhjLTEyLjggMC0yNC41IDcuMi0zMC4yIDE4LjdMNTcuNiAxNzYuMmMtOC4zIDE2LjctMS42IDM2LjkgMTUuMSA0NS4zIDQuNyAyLjMgOS45IDMuNiAxNS4xIDMuNmgxMTIuNWMxOC42IDAgMzMuOC0xNS4xIDMzLjgtMzMuNyAwLTUuMi0xLjItMTAuNC0zLjYtMTUuMUwxNzQuMiA2My43QzE2OC41IDUyLjIgMTU2LjggNDUgMTQ0IDQ1eiIgc3R5bGU9ImZpbGw6I2ZmZiIvPjwvc3ZnPg==";
  if (e === "Fantom")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7ZmlsbC1ydWxlOmV2ZW5vZGR9PC9zdHlsZT48bWFzayBpZD0ibWFzayIgd2lkdGg9IjkzLjEiIGhlaWdodD0iMjAiIHg9IjEwIiB5PSI2IiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIj48cGF0aCBpZD0iYSIgZD0iTTEwIDZoOTMuMXYyMEgxMFoiIGNsYXNzPSJjbHMtMSIvPjwvbWFzaz48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgc3R5bGU9ImZpbGw6IzEzYjVlYyIvPjxwYXRoIGQ9Im0xNy4yIDEyLjkgMy42LTIuMVYxNVptMy42IDlMMTYgMjQuN2wtNC44LTIuOFYxN2w0LjggMi44IDQuOC0yLjhabS05LjYtMTEuMSAzLjYgMi4xLTMuNiAyLjFabTUuNCAzLjEgMy42IDIuMS0zLjYgMi4xWm0tMS4yIDQuMkwxMS44IDE2bDMuNi0yLjFabTQuOC04LjNMMTYgMTIuMmwtNC4yLTIuNEwxNiA3LjNaTTEwIDkuNHYxMy4xbDYgMy40IDYtMy40VjkuNEwxNiA2WiIgY2xhc3M9ImNscy0xIiBzdHlsZT0ibWFzazp1cmwoI21hc2spIi8+PC9nPjwvZz48L3N2Zz4=";
  if (e === "Karura")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHN0eWxlPi5zdDB7ZmlsbDp1cmwoI3BhdGg5XzAwMDAwMTgzMjA3MjI2NDIxMjQzMjQ2MTMwMDAwMDAwNjQ5ODcxNTEzNjMzMzUwMDIwXyl9LnN0MXtmaWxsOnVybCgjcGF0aDExXzAwMDAwMTExOTA3NTExMTc3MTAzNTczNzQwMDAwMDA3Mjc3NzI2NzYwNDY4OTA4MTkxXyl9PC9zdHlsZT48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIzMC42MDMiIHgyPSI5LjA2NyIgeTE9IjMuMTE4IiB5Mj0iMjYuNTI3IiBncmFkaWVudFRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIC0xIDAgMzQpIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjRTQwQzVCIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRkY0QzNCIi8+PC9saW5lYXJHcmFkaWVudD48cGF0aCBmaWxsPSJ1cmwoI2EpIiBkPSJtMjIuMSAyLTguNiA3LjhjLS45LjgtMi4xIDEuMy0zLjMgMS4zSDcuNlYySDN2MjZoMi41YzEuNCAwIDIuNy0uOCAzLjQtMiAuNS0uOC43LTIuNS42LTMuNi0uMS0yLjUtLjUtMy4yLS41LTMuMiAwIDEuOC0xLjggMS45LTEuOCAxLjkgMS4zLTEuMi42LTIuMi42LTIuMi0yLjMgMS42LTIuOS0uMS0yLjktLjMuMS4xLjcuNiAyLTEuMSAxLjMtMS44IDMuMS00LjggNC4yLTUuNnMyLjItLjcgMi4yLS43LjYtLjggMi4yLTEuNSAyLjYuMyAyLjYuM2MtMS42IDEuMy0zLjkgMy41LTQgNi42LS4xIDIuNSA1LjQgNi45IDQuNCAxMy4zLjYtMS41LjgtMi45LjYtNC43LS4yLTEuNS0xLjEtNC41LTEuMS00LjVsNS4yIDcuMkgyOUwxNy43IDEyLjQgMjkgMmgtNi45eiIvPjxsaW5lYXJHcmFkaWVudCBpZD0iYiIgeDE9IjEyLjQxNCIgeDI9IjEwLjg4OSIgeTE9IjIwLjE4NSIgeTI9IjIxLjg1NSIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSAwIDM0KSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI0U0MEM1QiIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0ZGNEMzQiIvPjwvbGluZWFyR3JhZGllbnQ+PHBhdGggZmlsbD0idXJsKCNiKSIgZD0iTTEwLjkgMTIuOGMtLjQuNy0uNC45LS40LjlzMS41LS4yIDEuOS0yYy0uMSAwLTEgLjMtMS41IDEuMXoiLz48L3N2Zz4=";
  if (e === "Acala")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCA0OTAgNDkwIj48cGF0aCBmaWxsPSJ1cmwoI2EpIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNDUgNDkwYzEzNS4zMSAwIDI0NS0xMDkuNjkgMjQ1LTI0NVMzODAuMzEgMCAyNDUgMCAwIDEwOS42OSAwIDI0NXMxMDkuNjkgMjQ1IDI0NSAyNDV6bTEtMjNjMTIyLjYxIDAgMjIyLTk5LjM5MyAyMjItMjIyUzM2OC42MDcgMjMgMjQ2IDIzIDI0IDEyMi4zOTMgMjQgMjQ1czk5LjM5MyAyMjIgMjIyIDIyMnptLTEtMTdjMTEzLjIyIDAgMjA1LTkxLjc4MiAyMDUtMjA1UzM1OC4yMTggNDAgMjQ1IDQwIDQwIDEzMS43ODIgNDAgMjQ1czkxLjc4MiAyMDUgMjA1IDIwNXptLjUtMjVjOTkuNjg3IDAgMTgwLjUtODAuODEzIDE4MC41LTE4MC41UzM0NS4xODcgNjQgMjQ1LjUgNjQgNjUgMTQ0LjgxMyA2NSAyNDQuNSAxNDUuODEzIDQyNSAyNDUuNSA0MjV6TTIzNS4zMTMgOTguNjZsMTMwLjY4IDIyNi43IDE0LjAxMi0yNC4zMS0xMTYuNjYtMjAyLjM5em0tMTI1LjMxIDIwMS45OCAxMTEuODQtMTk0LjAzLjIzMS40LjIyLS4zODIgMTMyLjU0IDIyOS45M2gtMjguMDI1bC0zMy40ODQtNTguMDg4Yy0xNS4yMTUtNC44MS0zMS40MTQtNy40MDQtNDguMjItNy40MDQtOC42NjMgMC0xNy4xMTcuNjA1LTI1LjMzNiAxLjgxMmwxNi4xNC0yNy45NTZjMy4wNDctLjE0OSA2LjExMy0uMjI0IDkuMTk2LS4yMjQgMTAuMjY3IDAgMjAuMzM5LjgzMSAzMC4xNTQgMi40M2wtNTMuMTk1LTkyLjI4NC05OC4wNSAxNzAuMXptNzYuMDM1LTIuOTQ5IDUwLjI1Ni04Ny4xODYtMTQuMDEyLTI0LjMwOS04Ni42NzYgMTUwLjM3aDI4LjAyNWwuMjY2LS40NjJjMjQuMDM3LTE0LjQ3MiA1MS42MTktMjEuNzg3IDgxLjczNy0yMS43ODcgMTkuMjMyIDAgMzcuNjcgMy4zOTcgNTQuNzQ3IDkuNjI1bC0xOC43NzUtMzIuNTJhMTg3LjE0IDE4Ny4xNCAwIDAgMC0zNS45NzItMy40NzJjLTIwLjg0MiAwLTQwLjg4NSAzLjQyNS01OS41OTYgOS43NDR6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSI0NjIuNSIgeDI9IjEwMSIgeTE9IjQ5MCIgeTI9IjQzLjUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiM1QTgxRkYiLz48c3RvcCBvZmZzZXQ9Ii41MjQiIHN0b3AtY29sb3I9IiNFNDBDNUIiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGRjRDM0IiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48L3N2Zz4=";
  if (e === "Klaytn")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBkPSJtMjU0LjggMjg4LjEgMTYwIDE1OS43Yy04Ny45IDc1LjItMjI1LjkgNzguNC0zMTkuNy0xLjIgNTMuNC01Mi45IDEwNi42LTEwNS43IDE1OS43LTE1OC41eiIgc3R5bGU9ImZpbGw6I2JkMDcyZiIvPjxwYXRoIGQ9Ik0yOTEuNSAyNTUuOWMzNS4yLTM2LjIgNzAuOS03My4yIDEwNy0xMDkuOSAxNS0xNS4zIDMwLjUtMjkuOSA0Ni4xLTQ0LjYgMS4yLTEuMSA1LjItMS4zIDUuOS0uNCAyNy40IDM2IDQ3LjggNzUuMyA1My4yIDEyMC44IDguMiA2OS40LTcuNyAxMzIuNi01MS4zIDE4OC4xLTEuMiAxLjUtMi4zIDMuMi0yLjkgNC4xLTUzLjItNTMuMy0xMDYuNC0xMDYuNC0xNTgtMTU4LjF6IiBzdHlsZT0iZmlsbDojZmE0MjEyIi8+PHBhdGggZD0iTTEzOS4xIDMzNy44YzUuOS0xNS42IDExLjktMzEuMiAxNy44LTQ2LjggMjQuNS02NC41IDQ5LTEyOSA3My41LTE5My40IDcuNy0yMCAxNi40LTM5LjcgMjQuMy01OS43IDMtNy43IDUuMy0xNS43IDcuNy0yMy42IDEuOC01LjkgNS40LTguMSAxMS42LTcuNSAyNC40IDIuNCA0OC40IDYuMiA3MC45IDE2LjUgMTMgNiAyNi4zIDExLjQgMzguNyAxOC41IDEwLjEgNS44IDE4LjkgMTMuNyAzMC4xIDIyTDE0MC43IDMzOWwtMS42LTEuMnoiIHN0eWxlPSJmaWxsOiNmZjgwMDAiLz48cGF0aCBkPSJNMjAwLjIgNDcuN2MtNDUuOSAxMjEuNS05MS43IDI0Mi45LTEzOC41IDM2Ni45LTguOC0xMy40LTE3LTI0LjctMjMuOS0zNi43QzIyIDM1MC40IDExLjkgMzIwIDcuOSAyODguNWMtMS45LTE1LTEuNS0zMC40LTEuNi00NS42IDAtMi40IDIuMi01LjMgNC4xLTcuMkM2OS41IDE3Ni40IDEyOC44IDExNy4zIDE4OCA1OC4yYzMuNi0zLjYgNy4xLTcuNCAxMC43LTExLjJsMS41Ljd6IiBzdHlsZT0iZmlsbDojYjcwYzAyIi8+PC9zdmc+";
  if (e === "Celo")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDk1MCA5NTAiIHZpZXdCb3g9IjAgMCA5NTAgOTUwIj48cGF0aCBkPSJNMzc1IDg1MGMxNTEuOSAwIDI3NS0xMjMuMSAyNzUtMjc1UzUyNi45IDMwMCAzNzUgMzAwIDEwMCA0MjMuMSAxMDAgNTc1czEyMy4xIDI3NSAyNzUgMjc1em0wIDEwMEMxNjcuOSA5NTAgMCA3ODIuMSAwIDU3NXMxNjcuOS0zNzUgMzc1LTM3NSAzNzUgMTY3LjkgMzc1IDM3NS0xNjcuOSAzNzUtMzc1IDM3NXoiIHN0eWxlPSJmaWxsOiNmYmNjNWMiLz48cGF0aCBkPSJNNTc1IDY1MGMxNTEuOSAwIDI3NS0xMjMuMSAyNzUtMjc1UzcyNi45IDEwMCA1NzUgMTAwIDMwMCAyMjMuMSAzMDAgMzc1czEyMy4xIDI3NSAyNzUgMjc1em0wIDEwMGMtMjA3LjEgMC0zNzUtMTY3LjktMzc1LTM3NVMzNjcuOSAwIDU3NSAwczM3NSAxNjcuOSAzNzUgMzc1LTE2Ny45IDM3NS0zNzUgMzc1eiIgc3R5bGU9ImZpbGw6IzM1ZDA3ZiIvPjxwYXRoIGQ9Ik01ODcuNCA3NTBjMjYtMzEuNSA0NC42LTY4LjQgNTQuNS0xMDguMSAzOS42LTkuOSA3Ni41LTI4LjUgMTA4LjEtNTQuNS0xLjQgNDUuOS0xMS4zIDkxLjEtMjkuMiAxMzMuNS00Mi4zIDE3LjgtODcuNSAyNy43LTEzMy40IDI5LjF6TTMwOC4xIDMwOC4xYy0zOS42IDkuOS03Ni41IDI4LjUtMTA4LjEgNTQuNSAxLjQtNDUuOSAxMS4zLTkxLjEgMjkuMi0xMzMuNCA0Mi4zLTE3LjggODcuNi0yNy43IDEzMy40LTI5LjItMjYgMzEuNS00NC42IDY4LjQtNTQuNSAxMDguMXoiIHN0eWxlPSJmaWxsOiM1ZWEzM2IiLz48L3N2Zz4=";
  if (e === "Near")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDkwLjEgOTAiIHZpZXdCb3g9IjAgMCA5MC4xIDkwIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNNzIuMiA0LjYgNTMuNCAzMi41Yy0xLjMgMS45IDEuMiA0LjIgMyAyLjZMNzQuOSAxOWMuNS0uNCAxLjItLjEgMS4yLjZ2NTAuM2MwIC43LS45IDEtMS4zLjVsLTU2LTY3QzE3IDEuMiAxNC40IDAgMTEuNSAwaC0yQzQuMyAwIDAgNC4zIDAgOS42djcwLjhDMCA4NS43IDQuMyA5MCA5LjYgOTBjMy4zIDAgNi40LTEuNyA4LjItNC42bDE4LjgtMjcuOWMxLjMtMS45LTEuMi00LjItMy0yLjZsLTE4LjUgMTZjLS41LjQtMS4yLjEtMS4yLS42VjIwLjFjMC0uNy45LTEgMS4zLS41bDU2IDY3YzEuOCAyLjIgNC41IDMuNCA3LjMgMy40aDJjNS4zIDAgOS42LTQuMyA5LjYtOS42VjkuNmMwLTUuMy00LjMtOS42LTkuNi05LjYtMy40IDAtNi41IDEuNy04LjMgNC42eiIvPjwvc3ZnPg==";
  if (e === "Moonbeam")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIj48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDIwMHYyMDBIMHoiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDM3Ii8+PHBhdGggZmlsbD0iIzUzY2JjOCIgZD0iTTExOC42ODMgMTZhNjEuMyA2MS4zIDAgMCAwLTYxLjI3NiA2MS4zMTN2LjIyOGEzLjAxNiAzLjAxNiAwIDAgMCAzLjAxNyAyLjg0NWgxMTYuNTE3YTMuMDE1IDMuMDE1IDAgMCAwIDMuMDE2LTIuODQ1bC4wMDUtLjF2LS4xMjhBNjEuMyA2MS4zIDAgMCAwIDExOC42ODMgMTZaIiBkYXRhLW5hbWU9IlBhdGggMTg1Ii8+PHBhdGggZmlsbD0iI2UxMTQ3YiIgZD0iTTE2LjgzNyAxNDUuNzdhMy43MjkgMy43MjkgMCAxIDEtMy43My0zLjczMiAzLjczIDMuNzMgMCAwIDEgMy43MyAzLjczMloiIGRhdGEtbmFtZT0iUGF0aCAxODYiLz48cGF0aCBmaWxsPSIjZTExNDdiIiBkPSJNMTcyLjg4OCAxMjUuMTI2SDQ3Ljg2NWEzLjY3NyAzLjY3NyAwIDAgMC0zLjIzMSA1LjQyM2wuMDYyLjExNmEzLjY2OCAzLjY2OCAwIDAgMCAzLjIzMiAxLjkyNGgxMjQuOWEzLjY2OSAzLjY2OSAwIDAgMCAzLjIzMi0xLjkyNGwuMDYyLS4xMTZhMy42NzggMy42NzggMCAwIDAtMy4yMzQtNS40MjNaIiBkYXRhLW5hbWU9IlBhdGggMTg3Ii8+PHBhdGggZmlsbD0iI2UxMTQ3YiIgZD0iTTE4OS41IDkxLjNINDcuODYyYTMuNjgxIDMuNjgxIDAgMCAwLTMuNjY2IDMuODg3YzAgLjAzOSAwIC4wNzguMDA2LjExN2EzLjY2NSAzLjY2NSAwIDAgMCAzLjY2NyAzLjQ1OUgxODkuNWEzLjY2NiAzLjY2NiAwIDAgMCAzLjY2Ny0zLjQ1OWMwLS4wMzkgMC0uMDc4LjAwNi0uMTE3QTMuNjgxIDMuNjgxIDAgMCAwIDE4OS41IDkxLjNaIiBkYXRhLW5hbWU9IlBhdGggMTg4Ii8+PHBhdGggZmlsbD0iI2UxMTQ3YiIgZD0iTTEzNi4xNzEgMTc1Ljg2NEg3Mi4zMzhhMy42NzUgMy42NzUgMCAwIDAtMS42MzggNi45NjRsLjIzNC4xMTdhMy42NTcgMy42NTcgMCAwIDAgMS42MzcuMzgyaDYzLjM2NGEzLjY2MiAzLjY2MiAwIDAgMCAxLjYzOC0uMzgybC4yMzMtLjExN2EzLjY3NSAzLjY3NSAwIDAgMC0xLjYzNS02Ljk2NFoiIGRhdGEtbmFtZT0iUGF0aCAxODkiLz48cGF0aCBmaWxsPSIjZTExNDdiIiBkPSJNMTc1LjE2OSAxNTguOTUxaC02My44MzFhMy42NzYgMy42NzYgMCAwIDAtMS42MzcgNi45NjRsLjIzMy4xMTdhMy42NjggMy42NjggMCAwIDAgMS42MzguMzgxaDYzLjM2YTMuNjY1IDMuNjY1IDAgMCAwIDEuNjM4LS4zODFsLjIzMy0uMTE3YTMuNjc2IDMuNjc2IDAgMCAwLTEuNjM0LTYuOTY0WiIgZGF0YS1uYW1lPSJQYXRoIDE5MCIvPjxwYXRoIGZpbGw9IiNlMTE0N2IiIGQ9Im04OC4xMzEgMTQ4LjMyNi0uMTA4LS4xMTZhMy42NzQgMy42NzQgMCAwIDEgMi42OTQtNi4xNzNoMTAzLjZhMy42NzQgMy42NzQgMCAwIDEgMi42OTQgNi4xNzNsLS4xMDguMTE2YTMuNyAzLjcgMCAwIDEtMi42OTMgMS4xNzRIOTAuODI0YTMuNyAzLjcgMCAwIDEtMi42OTMtMS4xNzRaIiBkYXRhLW5hbWU9IlBhdGggMTkxIi8+PHBhdGggZmlsbD0iI2UxMTQ3YiIgZD0iTTI2LjQyNyAxNDIuMDM4aDQ5LjQ3MmEzLjY3NiAzLjY3NiAwIDAgMSAxLjYzNyA2Ljk2NGwtLjIzMy4xMTdhMy42NTcgMy42NTcgMCAwIDEtMS42MzcuMzgyaC00OWEzLjY1OCAzLjY1OCAwIDAgMS0xLjYzOC0uMzgybC0uMjMzLS4xMTdhMy42NzYgMy42NzYgMCAwIDEgMS42MzItNi45NjRaIiBkYXRhLW5hbWU9IlBhdGggMTkyIi8+PHBhdGggZmlsbD0iI2UxMTQ3YiIgZD0iTTM4LjI3MiA5NS4wMzFhMy43MjkgMy43MjkgMCAxIDEtMy43My0zLjczMSAzLjczIDMuNzMgMCAwIDEgMy43MyAzLjczMVoiIGRhdGEtbmFtZT0iUGF0aCAxOTMiLz48cGF0aCBmaWxsPSIjZTExNDdiIiBkPSJtMTI2LjE4MyAxMTIuOTUyLjAzMS0uMTE2YTMuNjcyIDMuNjcyIDAgMCAwLTMuNTQ5LTQuNjIySDE5LjA0OWEzLjY3MSAzLjY3MSAwIDAgMC0zLjU0OSA0LjYyMmwuMDMyLjExNmEzLjY4MSAzLjY4MSAwIDAgMCAzLjU0NyAyLjcyNGgxMDMuNTU2YTMuNjgzIDMuNjgzIDAgMCAwIDMuNTQ4LTIuNzI0IiBkYXRhLW5hbWU9IlBhdGggMTk0Ii8+PHBhdGggZmlsbD0iI2UxMTQ3YiIgZD0iTTkuNDU3IDExMS45NDRhMy43MjkgMy43MjkgMCAxIDEtMy43MjktMy43MzEgMy43MzEgMy43MzEgMCAwIDEgMy43MjkgMy43MzFaIiBkYXRhLW5hbWU9IlBhdGggMTk1Ii8+PHBhdGggZmlsbD0iI2UxMTQ3YiIgZD0iTTM4LjI3MiAxMjguODU3YTMuNzI5IDMuNzI5IDAgMSAxLTMuNzMtMy43MzEgMy43MzEgMy43MzEgMCAwIDEgMy43MyAzLjczMVoiIGRhdGEtbmFtZT0iUGF0aCAxOTYiLz48cGF0aCBmaWxsPSIjZTExNDdiIiBkPSJNMTAxLjc0OCAxNjIuNjgzYTMuNzI5IDMuNzI5IDAgMSAxLTMuNzMtMy43MzEgMy43MyAzLjczIDAgMCAxIDMuNzMgMy43MzFaIiBkYXRhLW5hbWU9IlBhdGggMTk3Ii8+PHBhdGggZmlsbD0iI2UxMTQ3YiIgZD0iTTYyLjc0NiAxNzkuNTk2YTMuNzI5IDMuNzI5IDAgMSAxLTMuNzI5LTMuNzMxIDMuNzMgMy43MyAwIDAgMSAzLjcyOSAzLjczMVoiIGRhdGEtbmFtZT0iUGF0aCAxOTgiLz48L3N2Zz4=";
  if (e === "Neon")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iI0RGNDJBQiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMjggMTRjMCA3LjczMi02LjI2OCAxNC0xNCAxNFMwIDIxLjczMiAwIDE0IDYuMjY4IDAgMTQgMHMxNCA2LjI2OCAxNCAxNFpNOC41ODUgOC4wNTJsNS4yMzggNS4yMzhWOC4zMTVhLjM3My4zNzMgMCAwIDEgLjM3Ny0uMzc0aDUuOTE4YS4zNzQuMzc0IDAgMCAxIC4zNjkuMzc0djUuODVhLjM4LjM4IDAgMCAxIC4wMDIuMDQzVjIwLjFhLjM3Ni4zNzYgMCAwIDEtLjUyNS4zNDguMzgyLjM4MiAwIDAgMS0uMTI4LS4wODVoLS4wMDNsLTUuMjM3LTUuMjM4VjIwLjFhLjM3NC4zNzQgMCAwIDEtLjM3NC4zNzdIOC4zMDZhLjM3My4zNzMgMCAwIDEtLjM3Ni0uMzc3di01Ljg5M2MwLS4wMy4wMDMtLjA2LjAxLS4wOVY4LjMxNWEuMzc3LjM3NyAwIDAgMSAuNjQ1LS4yNjNaIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
  if (e === "Terra2")
    return jt + "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";
  if (e === "Injective")
    return jt + "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";
  if (e === "Osmosis")
    return jt + "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";
  if (e === "Sui")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNjAiIGhlaWdodD0iMTYwIiBmaWxsPSJub25lIiB2aWV3Qm94PSIwIDAgMTEwIDE2MCI+PHBhdGggZmlsbD0iIzZGQkNGMCIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNy40NDQgMTMyLjIxNkMxNy4zNyAxNDkuNjE1IDM1LjE1IDE2MCA1NSAxNjBzMzcuNjI3LTEwLjM4NSA0Ny41NTYtMjcuNzg0YzkuOTI1LTE3LjM5NCA5LjkyNS0zOC4xNjUgMC01NS41NjNMNjAuNzMgMy4zNDdjLTIuNTQ3LTQuNDYzLTguOTEzLTQuNDYzLTExLjQ2IDBMNy40NDQgNzYuNjUzYy05LjkyNSAxNy4zOTQtOS45MjUgMzguMTY1IDAgNTUuNTYzWm0zNS43NzMtOTMuOTk0IDguOTE4LTE1LjYzYzEuMjczLTIuMjMyIDQuNDU3LTIuMjMyIDUuNzMgMGwzNC4zMDcgNjAuMTNjNi4zMDMgMTEuMDQ2IDcuNDg2IDIzLjgzMSAzLjU1IDM1LjUzMWEzNy43MDggMzcuNzA4IDAgMCAwLTEuNzU2LTUuODM1Yy00LjczOS0xMi4xMDEtMTUuNDU0LTIxLjQzOS0zMS44NTMtMjcuNzU3LTExLjI3NS00LjMyNy0xOC40NzItMTAuNjkyLTIxLjM5Ni0xOC45MTktMy43NjctMTAuNjAzLjE2Ny0yMi4xNjUgMi41LTI3LjUyWk0yOC4wMTIgNjQuODc0IDE3LjgyOCA4Mi43MjJjLTcuNzYgMTMuNTk5LTcuNzYgMjkuODMzIDAgNDMuNDMyIDcuNzYgMTMuNiAyMS42NTMgMjEuNzE1IDM3LjE3MiAyMS43MTUgMTAuMzA3IDAgMTkuOS0zLjU4MyAyNy40NTQtOS45NzUuOTg1LTIuNTA5IDQuMDM2LTExLjY5Ni4yNjctMjEuMTY1LTMuNDgtOC43NDMtMTEuODU4LTE1LjcyMy0yNC45LTIwLjc1LTE0Ljc0My01LjY1OS0yNC4zMjItMTQuNDkzLTI4LjQ2My0yNi4yNWEzNy4xNzQgMzcuMTc0IDAgMCAxLTEuMzQ3LTQuODU1WiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
  if (e === "Aptos")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIGJhc2VQcm9maWxlPSJ0aW55IiBvdmVyZmxvdz0idmlzaWJsZSIgdmVyc2lvbj0iMS4yIiB2aWV3Qm94PSIwIDAgMTEyIDExMiI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTg2LjYgMzcuNGgtOS45Yy0xLjEgMC0yLjItLjUtMy0xLjNsLTQtNC41Yy0xLjItMS4zLTMuMS0xLjQtNC41LS4zbC0uMy4zLTMuNCAzLjljLTEuMSAxLjMtMi44IDItNC41IDJIMi45QzEuNCA0MS45LjQgNDYuNiAwIDUxLjNoNTEuMmMuOSAwIDEuOC0uNCAyLjQtMWw0LjgtNWMuNi0uNiAxLjQtMSAyLjMtMWguMmMuOSAwIDEuOC40IDIuNCAxLjFsNCA0LjVjLjguOSAxLjkgMS40IDMgMS40SDExMmMtLjQtNC43LTEuNC05LjQtMi45LTEzLjhIODYuNnpNNTMuOCA2NWwtNC00LjVjLTEuMi0xLjMtMy4xLTEuNC00LjUtLjNsLS4zLjMtMy41IDMuOWMtMS4xIDEuMy0yLjcgMi00LjQgMkguOGMuOSA0LjggMi41IDkuNSA0LjYgMTRoMjUuNWMuOSAwIDEuNy0uNCAyLjQtMWw0LjgtNWMuNi0uNiAxLjQtMSAyLjMtMWguMmMuOSAwIDEuOC40IDIuNCAxLjFsNCA0LjVjLjguOSAxLjkgMS40IDMgMS40aDU2LjZjMi4xLTQuNCAzLjctOS4xIDQuNi0xNEg1Ni44Yy0xLjIgMC0yLjMtLjUtMy0xLjR6bTE5LjYtNDMuNiA0LjgtNWMuNi0uNiAxLjQtMSAyLjMtMWguMmMuOSAwIDEuOC40IDIuNCAxbDQgNC41Yy44LjkgMS45IDEuMyAzIDEuM2gxMC44Yy0xOC44LTI0LjgtNTQuMS0yOS43LTc5LTExLTQuMSAzLjEtNy44IDYuOC0xMSAxMUg3MWMxIC4yIDEuOC0uMiAyLjQtLjh6TTM0LjcgOTQuMmMtMS4yIDAtMi4zLS41LTMtMS4zbC00LTQuNWMtMS4yLTEuMy0zLjItMS40LTQuNS0uMmwtLjIuMi0zLjUgMy45Yy0xLjEgMS4zLTIuNyAyLTQuNCAyaC0uMkMzNiAxMTYuOSA3MS43IDExOCA5NC40IDk2LjdjLjktLjggMS43LTEuNyAyLjYtMi42SDM0Ljd6Ii8+PC9zdmc+";
  if (e === "Arbitrum" || e === "ArbitrumSepolia")
    return jt + "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";
  if (e === "Optimism" || e === "OptimismSepolia")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjIiIGhlaWdodD0iMTIyIj48Y2lyY2xlIGN4PSI2MSIgY3k9IjYxIiByPSI2MSIgZmlsbD0iI2ZmMDQyMCIgZGF0YS1uYW1lPSJFbGxpcHNlIDExIi8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTQzLjIwMSA3Ny4xNzdhMTQuNjU2IDE0LjY1NiAwIDAgMS04LjkyNC0yLjU2MyA4Ljc2MiA4Ljc2MiAwIDAgMS0zLjQzMi03LjQxMyAxNi40MzMgMTYuNDMzIDAgMCAxIC4yMjktMi40NzFxLjU5NS0zLjMgMS42OTMtNy45MTcgMy4xMTItMTIuNTg1IDE2LjA2Mi0xMi41ODVhMTUuOTY2IDE1Ljk2NiAwIDAgMSA2LjMxNSAxLjE5IDkuNiA5LjYgMCAwIDEgNC4zOTMgMy40NzggOS4zMzMgOS4zMzMgMCAwIDEgMS42IDUuNDkyIDE2LjI4OCAxNi4yODggMCAwIDEtLjIyOSAyLjQyNXEtLjY4NyA0LjA3My0xLjY0NyA3LjkxNy0xLjYgNi4yNjktNS41MzcgOS4zODEtMy45MzMgMy4wNjYtMTAuNTIzIDMuMDY2Wm0uNjQxLTYuNTlhNi41IDYuNSAwIDAgMCA0LjM0OC0xLjUxIDguNDI0IDguNDI0IDAgMCAwIDIuNjA4LTQuNjIycTEuMDUzLTQuMyAxLjYtNy41MDVhMTAuNSAxMC41IDAgMCAwIC4xODMtMS45NjhxMC00LjE2NS00LjM0Ny00LjE2NGE2LjY4MSA2LjY4MSAwIDAgMC00LjM5MyAxLjUxIDguNTczIDguNTczIDAgMCAwLTIuNTYzIDQuNjIycS0uODI0IDMuMDY2LTEuNjQ3IDcuNTA1YTkuNzkxIDkuNzkxIDAgMCAwLS4xODMgMS45MjJxMCA0LjIxIDQuMzk0IDQuMjFaIiBkYXRhLW5hbWU9IlBhdGggMTM5Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTYzLjI0NSA3Ni43MmEuOTcuOTcgMCAwIDEtLjc3OC0uMzIgMS4xIDEuMSAwIDAgMS0uMTM3LS44MjRsNi4zMTUtMjkuNzQ2YTEuMzEgMS4zMSAwIDAgMSAuNS0uODI0IDEuNCAxLjQgMCAwIDEgLjg3LS4zMmgxMi4xNzNhMTQuMTQ4IDE0LjE0OCAwIDAgMSA4LjE0NiAyLjEwNSA2LjkgNi45IDAgMCAxIDMuMTEyIDYuMDg3IDEwLjk1NSAxMC45NTUgMCAwIDEtLjI3NSAyLjM4IDEyLjM5IDEyLjM5IDAgMCAxLTQuNjIyIDcuNzhxLTMuNDMyIDIuNTE3LTkuNDI3IDIuNTE3aC02LjE3N0w3MC44NCA3NS41NzdhMS4zMTEgMS4zMTEgMCAwIDEtLjUuODI0IDEuNCAxLjQgMCAwIDEtLjg2OS4zMlptMTYuMi0xNy40ODJhNS40NTEgNS40NTEgMCAwIDAgMy4zNDEtMS4wNTIgNC45NDIgNC45NDIgMCAwIDAgMS45MjItMy4wMiA4LjAyMiA4LjAyMiAwIDAgMCAuMTM3LTEuMzczIDIuNTQzIDIuNTQzIDAgMCAwLS43NzgtMi4wMTQgMy44MzYgMy44MzYgMCAwIDAtMi42NTQtLjczMmgtNS40OTFsLTEuNzM5IDguMTkxWiIgZGF0YS1uYW1lPSJQYXRoIDE0MCIvPjwvc3ZnPg==";
  if (e === "Gnosis")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQyOCA0MjgiIHZpZXdCb3g9IjAgMCA0MjggNDI4Ij48cGF0aCBkPSJNMTI1LjggMjQzLjdjMTIuMyAwIDI0LjMtNC4xIDM0LTExLjZsLTc4LTc4Yy0xOC44IDI0LjMtMTQuMyA1OS4zIDEwIDc4LjEgOS44IDcuNCAyMS43IDExLjUgMzQgMTEuNXpNMzU3LjggMTg4YzAtMTIuMy00LjEtMjQuMy0xMS42LTM0bC03OCA3OGMyNC4zIDE4LjggNTkuMiAxNC4zIDc4LTEwIDcuNS05LjcgMTEuNi0yMS43IDExLjYtMzR6IiBzdHlsZT0iZmlsbDojMDAxOTNjIi8+PHBhdGggZD0ibTM5Ny4xIDEwMy4xLTM0LjUgMzQuNWMyNy44IDMzLjMgMjMuNCA4Mi45LTkuOSAxMTAuNy0yOS4yIDI0LjQtNzEuNiAyNC40LTEwMC44IDBMMjE0IDI4Ni4ybC0zNy44LTM3LjhjLTMzLjMgMjcuOC04Mi45IDIzLjQtMTEwLjctOS45LTI0LjQtMjkuMi0yNC40LTcxLjYgMC0xMDAuOEw0Ny44IDEyMCAzMSAxMDMuMUMxMC43IDEzNi41IDAgMTc0LjkgMCAyMTRjMCAxMTguMiA5NS44IDIxNCAyMTQgMjE0czIxNC05NS44IDIxNC0yMTRjLjEtMzkuMS0xMC43LTc3LjUtMzAuOS0xMTAuOXoiIHN0eWxlPSJmaWxsOiMwMDE5M2MiLz48cGF0aCBkPSJNMzY4LjggNjYuM2MtODEuNS04NS41LTIxNi45LTg4LjctMzAyLjQtNy4yLTIuNSAyLjQtNC45IDQuOC03LjIgNy4yLTUuMyA1LjYtMTAuMyAxMS40LTE1IDE3LjVMMjE0IDI1My43IDM4My44IDgzLjhjLTQuNi02LjEtOS43LTExLjktMTUtMTcuNXpNMjE0IDI4YzUwIDAgOTYuNiAxOS4zIDEzMS42IDU0LjVMMjE0IDIxNC4xIDgyLjQgODIuNUMxMTcuNCA0Ny4zIDE2NCAyOCAyMTQgMjh6IiBzdHlsZT0iZmlsbDojMDAxOTNjIi8+PC9zdmc+";
  if (e === "Pythnet")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNzIiIGhlaWdodD0iNDY2IiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMjMyLjQ5OSAxODYuNjMyYzAgMjUuNjk4LTIwLjgyMSA0Ni41MzUtNDYuNSA0Ni41MzV2NDYuNTM1YzUxLjM1OCAwIDkzLTQxLjY3MyA5My05My4wNyAwLTUxLjM5Ny00MS42NDItOTMuMDctOTMtOTMuMDctMTYuOTMxIDAtMzIuODMgNC41MjUtNDYuNSAxMi40Ni0yNy44MDQgMTYuMDgtNDYuNSA0Ni4xNTYtNDYuNSA4MC42MXYyMzIuNjc1bDQxLjgxIDQxLjg0MSA0LjY5IDQuNjkzVjE4Ni42MzJjMC0yNS42OTggMjAuODItNDYuNTM1IDQ2LjUtNDYuNTM1IDI1LjY3OSAwIDQ2LjUgMjAuODM3IDQ2LjUgNDYuNTM1WiIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xODYgLjVjLTMzLjg4MSAwLTY1LjYzOCA5LjA3MS05MyAyNC45MmExODYuMDA3IDE4Ni4wMDcgMCAwIDAtNDYuNSAzOC4xMTZDMTcuNTYxIDk2LjM0OCAwIDEzOS40NTIgMCAxODYuNjR2MTM5LjYwNGw0Ni41IDQ2LjUzNVYxODYuNjRjMC00MS4zMzcgMTcuOTYtNzguNDg1IDQ2LjUtMTA0LjA1NyAxMy40MTgtMTEuOTk2IDI5LjE3LTIxLjQ2OCA0Ni41LTI3LjU3MSAxNC41MzMtNS4xNzggMzAuMjAxLTcuOTc3IDQ2LjUtNy45NzcgNzcuMDM3IDAgMTM5LjUgNjIuNTA5IDEzOS41IDEzOS42MDUgMCA3Ny4wOTUtNjIuNDYzIDEzOS42MDQtMTM5LjUgMTM5LjYwNHY0Ni41MzVjMTAyLjczNyAwIDE4Ni04My4zNDYgMTg2LTE4Ni4xMzlDMzcyIDgzLjg0NiAyODguNzM3LjUgMTg2IC41WiIvPjwvc3ZnPg==";
  if (e === "Xpla")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzAwQjFGRiIgZD0iTTI0IDQ4YzEzLjI2IDAgMjQtMTAuNzQgMjQtMjRTMzcuMjYgMCAyNCAwIDAgMTAuNzQgMCAyNHMxMC43NCAyNCAyNCAyNFoiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJtMjcuNDM1IDI1LjcxLTEuNjk1IDEuNjk1IDExLjY0IDExLjY3IDEuNjk1LTEuNjk1LTExLjY0LTExLjY3Wk0xMC41OSA4Ljg5NSA4Ljg5NSAxMC41OWwxMS42NyAxMS42NyAxLjY5NS0xLjY5NS0xMS42Ny0xMS42N1ptMjYuNzc1LjAzLTExLjY0IDExLjY3IDEuNjk1IDEuNjk1IDExLjY0LTExLjY3LTEuNjk1LTEuNjk1Wk0yMC41OTUgMjUuNzQgOC45NTUgMzcuNDFsMS42OTUgMS42OTUgMTEuNjQtMTEuNjctMS42OTUtMS42OTVaIi8+PC9zdmc+";
  if (e === "Btc")
    return jt + "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";
  if (e === "Base" || e === "BaseSepolia")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSI+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBmaWxsPSIjMDA1MkZGIiBkPSJNOCAxNkE4IDggMCAxIDAgOC0uMDAxIDggOCAwIDAgMCA4IDE2WiIvPjxwYXRoIGZpbGw9IiNmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTcuOTgxIDEzLjYzNGE1LjYzNCA1LjYzNCAwIDEgMC01LjYxNC02LjEwOGg4LjM2di45MzhoLTguMzZhNS42MzQgNS42MzQgMCAwIDAgNS42MTQgNS4xN1oiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvZz48ZGVmcz48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoMTZ2MTZIMHoiLz48L2NsaXBQYXRoPjwvZGVmcz48L3N2Zz4=";
  if (e === "Sei" || e === "Seievm")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjZmZmIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMjcuNjc0IDI1NmMzOC4wMjUgMCA3Mi4xODgtMTYuNDk3IDk1LjY4Ny00Mi43MDctMTAuOTMyLTkuNDc2LTI3LjQwNS0xMC4wNTEtMzkuMDQyLS42ODVsLTIuMjIzIDEuNzljLTIxLjMwNyAxNy4xNDgtNTIuMzU1IDE0LjYxNi03MC41ODUtNS43NTgtOS45NDMtMTEuMTEyLTI2Ljk3Mi0xMi4yNDctMzguMzA5LTIuNTUzbC0yNS42MzIgMjEuOTJDNjkuNTI0IDI0NS41MjQgOTcuMzczIDI1NiAxMjcuNjc0IDI1NlptNDEuNjA3LTYxLjk4MWMyMC4yOTUtMTYuMzM1IDQ4LjgyLTE1Ljc0OSA2OC4zNC4wMjdDMjQ5LjI4NyAxNzQuNzY0IDI1NiAxNTIuMTY0IDI1NiAxMjhjMC0yNi44NS04LjI4OC01MS43Ny0yMi40NTEtNzIuMzUtOS4xMzEtMS45NC0xOS4wMjguMzI1LTI2LjU0IDYuOTY2bC0yLjE0IDEuODljLTIwLjQ5IDE4LjExMS01MS42MjEgMTcuMDEtNzAuNzc2LTIuNTAyLTEwLjQ0Ni0xMC42NDMtMjcuNTEtMTAuOTkyLTM4LjM4NS0uNzg3TDY1Ljg3OSA4OS4yMSA0OS40NyA3MS44MSA3OS4zIDQzLjgyYzIwLjM3My0xOS4xMTggNTIuMzM3LTE4LjQ2NCA3MS45MDYgMS40NzMgMTAuMjI1IDEwLjQxNyAyNi44NDQgMTEuMDA0IDM3Ljc4MiAxLjMzNWwyLjEzOS0xLjg5YTU0LjE5IDU0LjE5IDAgMCAxIDIyLjM2Ni0xMS45MDZDMTkwLjc1NiAxMi40MjIgMTYwLjY2OSAwIDEyNy42NzQgMCA2Mi41MyAwIDguNzI0IDQ4LjQxNy40NTEgMTExLjE0MmMxOS43ODYtOS40NzEgNDQuMTkzLTUuODI3IDYwLjMyNiAxMC42NTIgMTAuMTg1IDEwLjQwMyAyNi41ODUgMTEuNTAxIDM4LjA3MiAyLjU1bDE2LjY3OC0xMi45OTdjMjAuOTYtMTYuMzMzIDUwLjU5LTE1LjU0MiA3MC42NDQgMS44ODVsMzIuNDcgMjguMjE4LTE1LjczIDE4LjAxLTMyLjQ3LTI4LjIxN2MtMTEuNDA0LTkuOTEtMjguMjUyLTEwLjM2LTQwLjE3LTEuMDczbC0xNi42NzggMTIuOTk3Yy0yMS4xMDcgMTYuNDQ3LTUxLjIzNyAxNC40My02OS45NS00LjY4NC0xMC44OC0xMS4xMTUtMjguNjc3LTExLjUwMy00MC4wMzQtLjg3M0wwIDE0MC45ODhjMi43IDI2LjczNCAxMy42NSA1MS4wNDEgMzAuMjcgNzAuMzVsMjcuMzQ2LTIzLjM4NWMyMS4yMzYtMTguMTYgNTMuMTM1LTE2LjAzNSA3MS43NjEgNC43ODEgOS43MzMgMTAuODc3IDI2LjMwNiAxMi4yMjggMzcuNjggMy4wNzR6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIHN0eWxlPSJzdHJva2Utd2lkdGg6Ni44MjMzMyIvPjwvc3ZnPg==";
  if (e === "Scroll")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIGlkPSJMYXllcl8xIiB4PSIwIiB5PSIwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxzdHlsZT4uc3Qye2ZpbGw6IzEwMTAxMH08L3N0eWxlPjxwYXRoIGQ9Ik0yMS42IDE2VjIuN2MwLTEuMS0uOS0yLTItMkg2LjFDMy4yLjcuOCAzLjIuOCA2LjJjMCAxIC4zIDEuOS43IDIuNi4zLjYuOSAxLjIgMS40IDEuNy4xLjIuMS4xLjUuNC42LjQgMS40LjYgMS40LjZ2Ny45YzAgLjQuMS43LjIgMS4xLjMgMS4xIDEuMSAyIDIuMSAyLjQuNC4yLjkuMyAxLjQuM2gxMC44YzIuMiAwIDMuOS0xLjggMy45LTQgMC0xLjMtLjctMi40LTEuNi0zLjJ6IiBzdHlsZT0iZmlsbDojZmZlZWRhIi8+PHBhdGggZD0iTTIxLjkgMTkuM2MwIDEuNC0xLjIgMi42LTIuNiAyLjZoLTcuNGMuNi0uNyAxLTEuNiAxLTIuNiAwLTEuNi0uOS0yLjYtLjktMi42aDcuNGMxLjMtLjEgMi41IDEuMSAyLjUgMi42eiIgc3R5bGU9ImZpbGw6I2ViYzI4ZSIvPjxwYXRoIGQ9Ik0zLjYgOS40Yy0uOS0uOC0xLjUtMS45LTEuNS0zLjJ2LS4xYy4xLTIuMiAxLjgtMy45IDMuOS00aDEzLjVjLjQgMCAuNi4zLjYuNnYxMS43Yy4zLjEuNS4xLjguMmwuNi4zVjIuN2MwLTEuMS0uOS0yLTItMkg2LjFDMy4yLjcuOCAzLjIuOCA2LjJjMCAxLjcuOCAzLjIgMiA0LjMuMi4xLjIuMi41LjIuNCAwIC43LS4zLjctLjctLjEtLjMtLjItLjQtLjQtLjZ6IiBjbGFzcz0ic3QyIi8+PHBhdGggZD0iTTE5LjMgMTUuMkg4LjdjLS43IDAtMS4zLjYtMS4zIDEuM3YxLjZjMCAuNy42IDEuMyAxLjMgMS4zaC44di0xLjNoLS44di0xLjVoLjRjMS4zIDAgMi4zIDEuMyAyLjMgMi42IDAgMS4yLTEuMSAyLjgtMi45IDIuNi0xLjYtLjEtMi41LTEuNi0yLjUtMi42VjZjMC0uNi0uNS0xLjEtMS4xLTEuMUg0djEuNGguOHYxM2MwIDIuNiAxLjggNCAzLjggNGgxMC43YzIuMiAwIDMuOS0xLjggMy45LTQgMC0yLjMtMS44LTQuMS0zLjktNC4xem0yLjYgNC4xYzAgMS40LTEuMiAyLjYtMi42IDIuNmgtNy40Yy42LS43IDEtMS42IDEtMi42IDAtMS42LS45LTIuNi0uOS0yLjZoNy40YzEuMy0uMSAyLjUgMS4xIDIuNSAyLjZ6TTE2LjQgNi41aC04VjUuMmg4Yy40IDAgLjcuMy43LjcgMCAuMy0uMy42LS43LjZ6IiBjbGFzcz0ic3QyIi8+PHBhdGggZD0iTTE2LjQgMTIuOWgtOHYtMS40aDhjLjQgMCAuNy4zLjcuNyAwIC40LS4zLjctLjcuN3pNMTcuOCA5LjdIOC40VjguNGg5LjRjLjQgMCAuNy4zLjcuNyAwIC4zLS4zLjYtLjcuNnoiIGNsYXNzPSJzdDIiLz48L3N2Zz4=";
  if (e === "Mantle")
    return jt + "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";
  if (e === "Blast")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTIiIGhlaWdodD0iMTY2IiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjRkNGQzAzIiBkPSJtMTk3LjkwMiA4MS41MTMgMzkuNjA4LTE5LjczNiAxMy42NTMtNDEuOTA2TDIyMy44NTcgMEg0Mi4wNDFMMCAzMS4yMjZoMjEzLjcxOGwtMTEuMzU1IDM1LjE0N0gxMTYuNjZsLTguMjQ2IDI1LjY4NGg4NS43MDNMMTcwLjA1NSAxNjZsNDAuMTQ5LTE5Ljg3MSAxNC4zMjktNDQuMzM5LTI2LjkwMS0xOS43MzYuMjctLjU0MVoiLz48cGF0aCBmaWxsPSIjRkNGQzAzIiBkPSJtNjAuNDIyIDEzNC4yMzMgMjQuNzM3LTc3LjA1Mi0yNy40NDEtMjAuNTQ4TDE2LjQ4OCAxNjZoMTUzLjU2NGwxMC4yNzMtMzEuNzY3SDYwLjQyMloiLz48L3N2Zz4=";
  if (e === "Xlayer")
    return jt + "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";
  if (e === "Linea")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDEyOCAxMjgiPjxkZWZzPjxzdHlsZT4uY2xzLTJ7c3Ryb2tlLXdpZHRoOjA7ZmlsbDojZmZmfTwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik0wIDBoMTI4djEyOEgweiIgc3R5bGU9InN0cm9rZS13aWR0aDowO2ZpbGw6IzAwMCIvPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMS0yIj48cGF0aCBkPSJNMTAwLjYgMTIxLjhIOC43VjI1aDIxdjc4aDcwLjl2MTguOFoiIGNsYXNzPSJjbHMtMiIvPjxjaXJjbGUgY3g9IjEwMC42IiBjeT0iMjUiIHI9IjE4LjgiIGNsYXNzPSJjbHMtMiIvPjwvZz48L3N2Zz4=";
  if (e === "Berachain")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJMYXllcl8xIiBkYXRhLW5hbWU9IkxheWVyIDEiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDMyMCAzMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTJ7c3Ryb2tlLXdpZHRoOjA7ZmlsbDojMTcxNzE3fTwvc3R5bGU+PC9kZWZzPjxjaXJjbGUgY3g9IjE2MCIgY3k9IjE2MCIgcj0iMTYwIiBzdHlsZT0ic3Ryb2tlLXdpZHRoOjA7ZmlsbDojZjQ3MjI2Ii8+PHBhdGggZD0iTTIxNy4yIDE5N3YtMTQuMWM4LjctMyAxNC45LTEyLjIgMTQuOS0yMy4xcy02LjMtMjAuMS0xNC45LTIzLjF2LTE0LjFjOC4xLTIuOCAxNC4yLTExLjEgMTQuOS0yMS4yaC05Ljl2NC4zYzAgMy4zLTIgNi4yLTUgNy43di0yYzAtMi45LTIuNi01LjMtNS43LTUuM2gtLjVjLTMuMiAwLTUuNyAyLjQtNS43IDUuM3YyYy0zLTEuNS01LTQuMy01LTcuN3YtNC4zaC05LjljLjcgMTAuMSA2LjcgMTguNSAxNC45IDIxLjJ2MTQuMWMtOC42IDIuOS0xNC45IDEyLjItMTQuOSAyMy4xczYuMyAyMC4xIDE0LjkgMjMuMVYxOTdjLTguMSAyLjgtMTQuMiAxMS4xLTE0LjkgMjEuMmg5Ljl2LTQuM2MwLTMuMyAyLTYuMiA1LTcuN3YyYzAgMi45IDIuNiA1LjMgNS43IDUuM2guNWMzLjIgMCA1LjctMi40IDUuNy01LjN2LTJjMyAxLjUgNSA0LjMgNSA3Ljd2NC4zaDkuOWMtLjctMTAuMS02LjctMTguNS0xNC45LTIxLjJabS0xNy0zMXYtMTIuM2MwLTMuMyAyLTYuMiA1LTcuN3YyYzAgMi45IDIuNiA1LjMgNS43IDUuM2guNWMzLjIgMCA1LjctMi40IDUuNy01LjN2LTJjMyAxLjUgNSA0LjMgNSA3LjdWMTY2YzAgMy4zLTIgNi4yLTUgNy43di0yYzAtMi45LTIuNi01LjMtNS43LTUuM2gtLjVjLTMuMiAwLTUuNyAyLjQtNS43IDUuM3YyYy0yLjktMS41LTUtNC4zLTUtNy43Wk0yNzggMTY3LjN2LTE1YzguNy0zIDE0LjktMTIuMiAxNC45LTIzLjFzLTYuMy0yMC4xLTE0LjktMjMuMXYtNC43aC0xMnY0LjdjLTguNyAzLTE0LjkgMTIuMi0xNC45IDIzLjFzNi4zIDIwLjEgMTQuOSAyMy4xdjE1Yy04LjcgMy0xNC45IDEyLjItMTQuOSAyMy4xczYuMyAyMC4xIDE0LjkgMjMuMXY0LjdoMTJ2LTQuN2M4LjctMyAxNC45LTEyLjIgMTQuOS0yMy4xcy02LjMtMjAuMS0xNC45LTIzLjFabS0xNy0zMS45di0xMi4zYzAtMy4zIDItNi4yIDUtNy43djJjMCAyLjkgMi42IDUuMyA1LjcgNS4zaC41YzMuMiAwIDUuNy0yLjQgNS43LTUuM3YtMmMzIDEuNSA1IDQuMyA1IDcuN3YxMi4zYzAgMy4zLTIgNi4yLTUgNy43di0yYzAtMi45LTIuNi01LjMtNS43LTUuM2gtLjVjLTMuMiAwLTUuNyAyLjQtNS43IDUuM3YyYy0yLjktMS41LTUtNC4zLTUtNy43Wm0yMiA2MS4yYzAgMy4zLTIgNi4yLTUgNy43di0yLjljMC0yLjktMi42LTUuMy01LjctNS4zaC0uNWMtMy4yIDAtNS43IDIuNC01LjcgNS4zdjIuOWMtMy0xLjUtNS00LjMtNS03Ljd2LTEyLjNjMC0zLjMgMi02LjIgNS03Ljd2MS4xYzAgMi45IDIuNiA1LjMgNS43IDUuM2guNWMzLjIgMCA1LjctMi40IDUuNy01LjN2LTEuMWMzIDEuNSA1IDQuMyA1IDcuN3YxMi4zWk0xNDguNyAxNDhjLS4xLS42LS4zLTEuMi0uNS0xLjcgMC0uMSAxOC43LTI0LjIgMS41LTM5LjEtMTcuMi0xNC45LTM3LjMgNC41LTM3LjQgNC42LTMuMi0uOS02LjQtMS41LTkuNi0xLjgtNi42LTEtMTUuNyAwLTE1LjcgMC0zLjIuMy02LjQuOC05LjUgMS43LS4xLS4xLTIwLjItMTkuNS0zNy40LTQuNnMxLjQgMzkgMS41IDM5LjFjLS4yLjYtLjQgMS4xLS41IDEuNy0xLjggMTAuMy0xNC41IDEzLjUtMTQuNSAzMS40UzM5LjggMjEyIDY2LjkgMjEySDc4czQuMyA1LjcgMTMuMiA2LjFjMCAwIDIgLjIgNi43IDAgOS40IDAgMTMuOS02IDE0LTYuMUgxMjNjMjcgMCA0MC4zLTE0LjQgNDAuMy0zMi43IDAtMTcuOS0xMi42LTIxLjEtMTQuNC0zMS40WiIgY2xhc3M9ImNscy0yIi8+PC9zdmc+";
  if (e === "Snaxchain")
    return jt + "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";
  if (e === "Unichain")
    return jt + "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";
  if (e === "Worldchain")
    return jt + "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";
  if (e === "Ink")
    return jt + "PHN2ZyB3aWR0aD0iMjc1IiBoZWlnaHQ9IjI3NSIgdmlld0JveD0iMCAwIDI3NSAyNzUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+ICAgIDxwYXRoIGZpbGxSdWxlPSJldmVub2RkIiBjbGlwUnVsZT0iZXZlbm9kZCIgZD0iTTI3NSAxMzcuNUMyNzUgNjEuNTYwOCAyMTMuNDM5IC0zLjMxOTQxZS0wNiAxMzcuNSAwQzYxLjU2MDggMy4zMTk0MWUtMDYgLTMuMzE5NDFlLTA2IDYxLjU2MDggMCAxMzcuNUMzLjMxOTQxZS0wNiAyMTMuNDM5IDYxLjU2MDggMjc1IDEzNy41IDI3NUMyMTMuNDM5IDI3NSAyNzUgMjEzLjQzOSAyNzUgMTM3LjVaTTE1Ny4xMjUgMjQwLjQwN0MxNTcuMTI1IDI0OS43MzUgMTQ5LjQ2OSAyNTcuMzE3IDEzOC42MDIgMjU3LjUzNUMxMzguMzAxIDI1Ny41MzggMTM4IDI1Ny41MzkgMTM3LjY5OCAyNTcuNTRIMTM3LjMwMkM3MS4wOTY5IDI1Ny40MzMgMTcuNDYwMyAyMDMuNzMgMTcuNDYwMyAxMzcuNUMxNy40NjAzIDcxLjIwNDEgNzEuMjAzOSAxNy40NjA1IDEzNy41IDE3LjQ2MDVDMTM3Ljg1NyAxNy40NjA1IDEzOC4yMTUgMTcuNDYyMSAxMzguNTcxIDE3LjQ2NTJDMTUwLjgzNCAxNy42ODM2IDE1Ny4xMjUgMjUuMjY1NCAxNTcuMTI1IDM0LjU5MjlDMTU3LjEyNSA0NC4wODU5IDE0OC43MzMgNTEuMDcxNSAxMzkuODQzIDUxLjA3MTVDMTMwLjk1MiA1MS4wNzE1IDEzMC41MTYgNTEuMDcxNSAxMjIuMDA2IDUxLjc1MzRDMTEzLjQ5NSA1Mi40MzU0IDEwNC42OTUgNTkuNDIwOSAxMDQuNjk1IDY4Ljg4NTlDMTA0LjY5NSA3OC40MDcxIDExMi40MyA4Ni4wNzQ1IDEyMi4wMDYgODYuMDc0NUgxOTcuNDhDMjA3LjAyOCA4Ni4wNzQ1IDIxNC43NjIgOTMuNzQyIDIxNC43NjIgMTAzLjIwN0MyMTQuNzYyIDExMi42NzIgMjA3LjAyOCAxMjAuMzM5IDE5Ny40OCAxMjAuMzM5SDgxLjIyOThDNzEuNjUzOSAxMjAuMzM5IDYzLjkxOTUgMTI4LjAzNSA2My45MTk1IDEzNy41MjhDNjMuOTE5NSAxNDYuOTkzIDcxLjY1MzkgMTU0LjY2MSA4MS4yMjk4IDE1NC42NjFIMTM5Ljg0M0MxNDkuMzkxIDE1NC42NjEgMTU3LjEyNSAxNjIuMzI4IDE1Ny4xMjUgMTcxLjgyMUMxNTcuMTI1IDE4MS4yODYgMTQ5LjM5MSAxODguOTU0IDEzOS44NDMgMTg4Ljk1NEgxMjIuMDA2QzExMi40MyAxODguOTU0IDEwNC42OTUgMTk2LjYyMSAxMDQuNjk1IDIwNi4wODZDMTA0LjY5NSAyMTUuNTc5IDExMi42MjIgMjIyLjUwOSAxMjIuMDA2IDIyMy4yMTlDMTIyLjc0NSAyMjMuMjc1IDEyMy40MjIgMjIzLjMyNiAxMjQuMDQ1IDIyMy4zNzRDMTI3LjM0NyAyMjMuNjI1IDEyOS4xNTEgMjIzLjc2MyAxMzAuOTU4IDIyMy44MzhDMTMzLjEzNCAyMjMuOTI5IDEzNS4zMTQgMjIzLjkyOSAxNDAuMTE5IDIyMy45MjlDMTQ5LjY2NyAyMjMuOTI5IDE1Ny4xMjUgMjMwLjk0MiAxNTcuMTI1IDI0MC40MDdaIiBmaWxsPSIjNzEzMkY1Ii8+PC9zdmc+";
  if (e === "HyperEVM")
    return jt + "PHN2ZyB3aWR0aD0iMTQ0IiBoZWlnaHQ9IjE0NCIgdmlld0JveD0iMCAwIDE0NCAxNDQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE0NCA3MS42OTkxQzE0NCAxMTkuMzA2IDExNC44NjYgMTM0LjU4MiA5OS41MTU2IDEyMC45OEM4Ni44ODA0IDEwOS44ODkgODMuMTIxMSA4Ni40NTIxIDY0LjExNiA4NC4wNDU2QzM5Ljk5NDIgODEuMDExMyAzNy45MDU3IDExMy4xMzMgMjIuMDMzNCAxMTMuMTMzQzMuNTUwNCAxMTMuMTMzIDAgODYuMjQyOCAwIDcyLjQzMTVDMCA1OC4zMDYzIDMuOTY4MDkgMzkuMDU0MiAxOS43MzYgMzkuMDU0MkMzOC4xMTQ2IDM5LjA1NDIgMzkuMTU4OCA2Ni41NzIyIDYyLjEzMiA2NS4xMDczQzg1LjAwMDcgNjMuNTM3OSA4NS40MTg0IDM0Ljg2ODkgMTAwLjI0NyAyMi42MjcxQzExMy4xOTUgMTIuMDU5MyAxNDQgMjMuNDY0MSAxNDQgNzEuNjk5MVoiIGZpbGw9IiM5N0ZDRTQiLz48L3N2Zz4=";
  if (e === "Monad")
    return jt + "PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuOTk5OSAwQzExLjM3OTUgMCAwIDExLjM3OTIgMCAxNS45OTk5QzAgMjAuNjIwNiAxMS4zNzk1IDMyIDE1Ljk5OTkgMzJDMjAuNjIwMyAzMiAzMiAyMC42MjA0IDMyIDE1Ljk5OTlDMzIgMTEuMzc5NCAyMC42MjA1IDAgMTUuOTk5OSAwWk0xMy41MDY2IDI1LjE0OTJDMTEuNTU4MiAyNC42MTgzIDYuMzE5ODEgMTUuNDU1IDYuODUwODMgMTMuNTA2NkM3LjM4MTg1IDExLjU1ODEgMTYuNTQ1IDYuMzE5NzkgMTguNDkzMyA2Ljg1MDhDMjAuNDQxOCA3LjM4MTczIDI1LjY4MDIgMTYuNTQ0OSAyNS4xNDkyIDE4LjQ5MzRDMjQuNjE4MiAyMC40NDE4IDE1LjQ1NSAyNS42ODAyIDEzLjUwNjYgMjUuMTQ5MloiIGZpbGw9IiM4MzZFRjkiLz48L3N2Zz4=";
  if (e === "Mezo")
    return jt + "PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjIyMiIgdmlld0JveD0iMCAwIDQwMCAyMjIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExNC45NCAxNDIuMDhMMTQ2LjQ0IDExMC41OFYxMTAuNDRMMTc3Ljc5IDE0MS45NEMxODYuODUgMTUxIDE5Ny45MyAxNTUuMDMgMjA4Ljg2IDE1NS4wM0MyMzEuNzMgMTU1LjAzIDI1My43MyAxMzcuMiAyNTMuNzMgMTEwLjQ0TDI4NS4wOCAxNDEuOTRDMjk0LjE0IDE1MSAzMDUuMjIgMTU1LjAzIDMxNi4xNSAxNTUuMDNDMzM5LjAyIDE1NS4wMyAzNjEuMDIgMTM3LjIgMzYxLjAyIDExMC40NEgzMzQuMTJMMzAyLjc3IDc5LjA5QzI5My43MSA3MC4wMyAyODIuNDkgNjYgMjcxLjU2IDY2QzI0OC42OSA2NiAyMjYuODMgODMuNjkgMjI2LjgzIDExMC40NEwxOTUuNDggNzkuMDlDMTg2LjQyIDcwLjAzIDE3NS4yIDY2IDE2NC4yNyA2NkMxNDEuNCA2NiAxMTkuNTQgODMuNjkgMTE5LjU0IDExMC40NEwzOSAxMTAuNThDMzkgMTM3LjQ4IDYxLjI5IDE1NC44OCA4NC4xNiAxNTQuODhDOTUuMDkgMTU0Ljg4IDEwNi4xNyAxNTAuODUgMTE0Ljk0IDE0Mi4wOFoiIGZpbGw9IiNGRjAwNEQiLz48L3N2Zz4=";
  if (e === "Sonic")
    return jt + "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";
  if (e === "Wormchain")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgZmlsbD0ibm9uZSI+PGNpcmNsZSBjeD0iMTQiIGN5PSIxNCIgcj0iMTQiIGZpbGw9IiMwMDAiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMTQuMDM1IDIzLjMxYTkuMjc1IDkuMjc1IDAgMSAxIDkuMjc1LTkuMjc1IDkuMjgxIDkuMjgxIDAgMCAxLTkuMjc1IDkuMjc1Wm0wLTE4LjE0YTguODY1IDguODY1IDAgMSAwIDAgMTcuNzMgOC44NjUgOC44NjUgMCAwIDAgMC0xNy43M1oiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMTQuNzk0IDIyLjRhOC4zMzQgOC4zMzQgMCAxIDEgMC0xNi42NjkgOC4zMzQgOC4zMzQgMCAwIDEgMCAxNi42NjlabTAtMTYuMzA4YTcuOTggNy45OCAwIDEgMCA3Ljk4IDcuOTggNy45OTEgNy45OTEgMCAwIDAtNy45OC03Ljk4WiIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xNS41NTQgMjEuNDk2YTcuMzk1IDcuMzk1IDAgMSAxIDAtMTQuNzkgNy4zOTUgNy4zOTUgMCAwIDEgMCAxNC43OVptMC0xNC40NjRhNy4wOTMgNy4wOTMgMCAxIDAgNy4wOTMgNy4wNyA3LjEgNy4xIDAgMCAwLTcuMDkzLTcuMDg4Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE2LjMxMyAyMC41ODZhNi40NDggNi40NDggMCAxIDEgMC0xMi44OTcgNi40NDggNi40NDggMCAwIDEgMCAxMi44OTdabTAtMTIuNjU2YTYuMjA4IDYuMjA4IDAgMSAwIDAgMTIuNDE1IDYuMjA4IDYuMjA4IDAgMCAwIDAtMTIuNDE1WiIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xNy4wNzIgMTkuNjgyYTUuNTA4IDUuNTA4IDAgMSAxIDAtMTEuMDE2IDUuNTA4IDUuNTA4IDAgMCAxIDAgMTEuMDE2Wm0wLTEwLjg0OGE1LjMyMiA1LjMyMiAwIDEgMC0uMDEyIDEwLjY0MyA1LjMyMiA1LjMyMiAwIDAgMCAuMDEyLTEwLjY0M1oiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMTcuODMyIDE4Ljc3MmE0LjU2OCA0LjU2OCAwIDEgMSAwLTkuMTM3IDQuNTY4IDQuNTY4IDAgMCAxIDAgOS4xMzdabTAtOC45OThhNC40MzYgNC40MzYgMCAxIDAgNC40MDUgNC40MzYgNC40MzYgNC40MzYgMCAwIDAtNC40My00LjQzIi8+PC9zdmc+";
  if (e === "Cosmoshub")
    return jt + "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";
  if (e === "Evmos")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTYiIGhlaWdodD0iMTU2IiBmaWxsPSJub25lIj48Y2lyY2xlIGN4PSI3Ny41NzEiIGN5PSI3Ny41NzEiIHI9Ijc3LjU3MSIgZmlsbD0iI2VkNGUzMyIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik02My41ODcgNDEuNTQzQzQyLjQyNSA0OS42OCA0MC40ODcgNzAuNTE4IDM0LjQyIDgwLjI1Yy02LjE0IDkuODQ4LTIwLjIwNiAxNS4yODEtMTguMjgyIDIwLjMgMS45MjMgNS4wMTggMTYuMDA2LS4zNzIgMjcuMTQ3IDIuODMgMTEuMDEgMy4xNjQgMjYuMzcxIDE3LjM1MiA0Ny41MzMgOS4yMTUgMTAuNzgtNC4xNDUgMTguNTg2LTEyLjY3NyAyMi4xNzYtMjIuNzgyLjM4Ni0xLjA4NC0uMzM2LTIuMjQ0LTEuNDgxLTIuMzUyYTEuNzM3IDEuNzM3IDAgMCAwLTEuNzE2Ljk0NmMtMy4yNDcgNi40NzgtOC44MTcgMTEuODEzLTE2LjEwNyAxNC42MTUtMTIuMDMzIDQuNjI3LTI1LjIuOTk0LTMzLjI4Ny04LjExN2EzMC4wMTEgMzAuMDExIDAgMCAxLTQuNjQ4LTcuMDI3IDMwLjAwNiAzMC4wMDYgMCAwIDEtLjk1Mi0yLjE5OCAzMC40NjUgMzAuNDY1IDAgMCAxLS43Ni0yLjI3M2M2LjM2LTIuOTcgMTMuNy02LjExNCAyMi4wMi05LjMxMyA4LjE1OS0zLjEzNyAxNS41ODQtNS42ODEgMjIuMTk1LTcuNzE3YTI1MS44MDEgMjUxLjgwMSAwIDAgMSAxMi4yNzItMy40NTZsLjc5NC0uMmMuNTYtLjEzOCAxLjEzNS4xNjEgMS4zNDIuN2wuMDA0LjAxYy4xMjIuMzIuMjI3LjY0MS4zNC45NjNhMzguNDcxIDM4LjQ3MSAwIDAgMSAxLjY0MyA2LjI3IDEuMzYxIDEuMzYxIDAgMCAwIDEuOTg0Ljk3OCAxNjEuMjY0IDE2MS4yNjQgMCAwIDAgOC4zLTQuNzYxYzkuMjU0LTUuNzA4IDE0LjM4NC0xMC41NDkgMTMuMzMxLTEzLjI5Mi0xLjA1MS0yLjc0NS04LjA5Ny0yLjkwMy0xOC43ODctLjk0NC0zLjM5Ny42MjItNy4xNjQgMS40Ni0xMS4yMjMgMi40OTUtLjcwMi4xOC0xLjQxMi4zNjUtMi4xMzEuNTU2YTI3My43OTUgMjczLjc5NSAwIDAgMC0xMC43NyAzLjExYy02Ljk3OCAyLjE2NS0xNC40NjMgNC43NTctMjIuMTkgNy43MjlhMzYwLjQ5NiAzNjAuNDk2IDAgMCAwLTIwLjM2NCA4LjUzNWMtLjA3Ny0xMi4xOTEgNy4yOC0yMy43MTYgMTkuMzE1LTI4LjM0M2EyOS45MzUgMjkuOTM1IDAgMCAxIDIxLjczMy4wNjdjLjY2NS4yNjIgMS40MjIuMDggMS45MDgtLjQ0Ni43NzktLjg0Ni41NC0yLjE5Mi0uNDcxLTIuNzQtOS40MTktNS4xMDEtMjAuOTItNi4yMS0zMS43LTIuMDY1eiIvPjwvc3ZnPg==";
  if (e === "Kujira")
    return jt + "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";
  if (e === "Neutron")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iLTQgLTQgNjQgNjQiPjxwYXRoIGZpbGw9IiNmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTU2IDBIMy45NmwxNS4yOSAxOC4wMzJBMTMuMjEzIDEzLjIxMyAwIDAgMSAyOCAxNC43MzdjNy4zMjUgMCAxMy4yNjMgNS45MzggMTMuMjYzIDEzLjI2M2ExMy4yMSAxMy4yMSAwIDAgMS0zLjE5IDguNjI5TDU2IDUyLjEzMlY1NiAwWm0tNi43MjQgNTYtMTQuMjItMTYuNzY4QTEzLjIgMTMuMiAwIDAgMSAyOCA0MS4yNjNjLTcuMzI2IDAtMTMuMjY0LTUuOTM4LTEzLjI2NC0xMy4yNjMgMC0yLjU3OC43MzYtNC45ODUgMi4wMS03LjAyMkwwIDYuNTRWNTZoNDkuMjc2WiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
  if (e === "Celestia")
    return jt + "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";
  if (e === "Stargaze")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxODAiIGhlaWdodD0iMTgwIiBmaWxsPSJub25lIj48ZyBmaWxsPSIjZmZmIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05MCAxNzJjNDUuMjg3IDAgODItMzYuNzEzIDgyLTgyUzEzNS4yODcgOCA5MCA4IDggNDQuNzEzIDggOTBzMzYuNzEzIDgyIDgyIDgyem05MC04MmMwIDQ5LjcwNi00MC4yOTQgOTAtOTAgOTBTMCAxMzkuNzA2IDAgOTAgNDAuMjk0IDAgOTAgMHM5MCA0MC4yOTQgOTAgOTB6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48cGF0aCBkPSJtMTA2LjY5IDIyLjQ3IDMuNjMgNTAuNDFMMTU5LjM4IDg1bC00Ni44MiAxOS4wMyAzLjYzIDUwLjQxLTMyLjU2LTM4LjY1LTQ2LjgyIDE5LjA0TDYzLjUgOTEuOTEgMzAuOTMgNTMuMjZsNDkuMDYgMTIuMTN6Ii8+PC9nPjwvc3ZnPg==";
  if (e === "Seda")
    return jt + "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";
  if (e === "Dymension")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHZpZXdCb3g9IjAgMCAxNDQgMTQ0Ij48cGF0aCBmaWxsPSIjMjUyMTIwIiBkPSJNODggMTQ1SDEuMDM4VjEuMWgxNDMuOFYxNDVIODhNMzMuNTYxIDkzLjg4M2M5LjcyNC4xNDIgMTUuNDQ0LTYuNjc4IDIwLjk5OC0xMi40MThsMTEuNjM0IDEwLjQxOGMtMy4wMDMgMi4xNTgtNi4zNTIgMy40OTctNy45NzEgNS45Ny0yLjY0NSA0LjAzOS01LjI1IDguNjU4LTUuOTIzIDEzLjMxNS0xLjMxIDkuMDggNS4xNSAxOC4yMDggMTMuNTIzIDIxLjA1MyA5LjIgMy4xMjUgMTguODEtLjE0NiAyNC4xMzItOC4yMTIgNS4wODItNy43MDQgNC4zNDYtMTguNjAxLTEuODAyLTI1LjUyMi0yLjMtMi41ODktNC43NTUtNS4wNC03LjE1Ni03LjU3bDEwLjAxMS0xMC4wNGMyLjA5IDIuMjcgNC4wMjEgNC41NyA2LjE2IDYuNjU3IDguNTg4IDguMzc1IDIwLjgzNyA4LjM5IDI5LjA1Mi4xMSA4LjE3Ny04LjI0IDguMjE0LTIxLjQwNS4wODMtMjkuNjY4LTguMTU3LTguMjktMjAuNTA1LTguMzktMjkuMDMxLS4wOTYtMi4yMTQgMi4xNTItNC4wNTEgNC42OTEtNS43NDkgNi42ODVMODAuMDU4IDU0LjI1N2MyLjcwOC0yLjMxMyA1LjE2LTQuMDU4IDcuMTktNi4yMDIgOC4yMzYtOC42OTUgOC4wNjItMjEuOTctLjI1My0zMC4xMS04LjAxNi03Ljg0OS0yMC4zMS03LjkyMS0yOC4zNS0uMTY4LTguNiA4LjI5NC04LjgyOSAyMS4wMTMtLjUxOCAzMC4wMTYgMi4wOTcgMi4yNzIgNC4yNiA0LjQ4NCA1LjczMyA2LjAzMWwtOS4xMjUgMTAuODQ4Yy0yLjcxLTIuODY3LTQuODUzLTUuNDM4LTcuMzA0LTcuNjcxLTguMDM0LTcuMzIzLTIwLjMzOC03LjAxMi0yOC4wMS43LTYuMDg2IDYuMTE3LTcuODA4IDEzLjU4My01LjIgMjEuNjM1IDIuODM3IDguNzYzIDkuMzkgMTMuNDI0IDE5LjM0IDE0LjU0N3oiLz48cGF0aCBmaWxsPSIjRUNEREQwIiBkPSJNMzMuMTQgOTMuODcxYy05LjUyOS0xLjExLTE2LjA4Mi01Ljc3Mi0xOC45Mi0xNC41MzUtMi42MDctOC4wNTItLjg4NS0xNS41MTggNS4yMDEtMjEuNjM2IDcuNjcyLTcuNzEgMTkuOTc2LTguMDIyIDI4LjAxLS43IDIuNDUgMi4yMzQgNC41OTQgNC44MDUgNy4zMDQgNy42NzJsOS4xMjUtMTAuODQ4Yy0xLjQ3NC0xLjU0Ny0zLjYzNi0zLjc2LTUuNzMzLTYuMDMxLTguMzEtOS4wMDMtOC4wODItMjEuNzIyLjUxOC0zMC4wMTYgOC4wNC03Ljc1MyAyMC4zMzQtNy42OCAyOC4zNS4xNjcgOC4zMTUgOC4xNCA4LjQ4OSAyMS40MTYuMjUzIDMwLjExMS0yLjAzIDIuMTQ0LTQuNDgyIDMuODktNy4xOSA2LjIwMmwxMS40NjQgMTAuMzA4YzEuNjk4LTEuOTk0IDMuNTM1LTQuNTMzIDUuNzQ5LTYuNjg1IDguNTI2LTguMjkzIDIwLjg3NC04LjE5MyAyOS4wMzEuMDk2IDguMTMxIDguMjYzIDguMDk0IDIxLjQyOC0uMDgzIDI5LjY2OS04LjIxNSA4LjI3OC0yMC40NjQgOC4yNjQtMjkuMDUxLS4xMTEtMi4xNC0yLjA4Ny00LjA3LTQuMzg2LTYuMTYtNi42NTYtMy41MTIgMy41Mi02LjYzNCA2LjY1Mi0xMC4wMTIgMTAuMDQgMi40IDIuNTMgNC44NTYgNC45OCA3LjE1NiA3LjU2OSA2LjE0OCA2LjkyIDYuODg0IDE3LjgxOCAxLjgwMiAyNS41MjItNS4zMjIgOC4wNjYtMTQuOTMyIDExLjMzNy0yNC4xMzIgOC4yMTItOC4zNzMtMi44NDUtMTQuODM0LTExLjk3NC0xMy41MjMtMjEuMDUzLjY3My00LjY1NyAzLjI3OC05LjI3NiA1LjkyMy0xMy4zMTUgMS42MTktMi40NzMgNC45NjgtMy44MTIgNy45NzEtNS45N0w1NC41NiA4MS40NjVjLTUuNTU0IDUuNzQtMTEuMjc0IDEyLjU2LTIxLjQyIDEyLjQwNm03MS41NTItMjguOTc0LTguODU3IDguNzQyYzIuNDIyIDEuODM1IDQuNTYgMy40MyA2LjY3IDUuMDYyLjc4Ny42MDkgMS40NTQgMS4zODMgMi4yNyAxLjk0MyAzLjcwMSAyLjU0IDkuNzE4IDIuMjIgMTMuMDA4LS43NjEgMy41MzItMy4xOTkgNC4xNTQtNy4xNyAyLjI2Ny0xMS4zNzItMi4yNzItNS4wNi03LjUxMi02LjQtMTUuMzU4LTMuNjE0bS0zMC43NjYgMzUuMjI2Yy0yLjgxIDIuMTQzLTYuMDE0IDMuOTMyLTguMzM5IDYuNTEzLTMuNDQ4IDMuODI3LTIuNjc3IDkuNjkzIDEuMDg0IDEyLjk5OCAzLjU5NiAzLjE2IDguNzE0IDMuMDk1IDEyLjI4OC0uMTU1IDMuNzktMy40NDcgNC4zMDQtOC45NDQgMS4wMS0xMy4wNC0xLjY2Mi0yLjA2NS0zLjY3NS0zLjg0OC02LjA0My02LjMxNk0zMy41OSA2My4yNzZjLTUuMTk3LjM4OS04LjMwNyAzLjMyNC05LjA0NSA4LjI5OC0uNjQzIDQuMzI5IDEuMzA0IDcuNzY3IDUuMzEgOS43MiA0LjU1NCAyLjIyIDguMjkzLjY2NSAxMS41MjUtMi44MiAxLjc4NS0xLjkyNCAzLjYyNC0zLjc5OCA2LjM3Ny02LjY3NS00Ljc2OC0zLjAzLTkuMDg1LTUuNzc0LTE0LjE2Ny04LjUyM20zMS45NzgtMzYuMjA3Yy00LjEgNy4wMTItMi43MTcgMTAuNjgzIDcuNzMyIDE5LjM4NSAxLjgyNi0yLjAwNCAzLjcyMi00LjA2NSA1LjU5NS02LjE0NyA0LjEyMi00LjU4MiA0LjMyMy05Ljg2OC41NDItMTMuODQtMy41ODktMy43Ny04LjMwNC0zLjc2OC0xMy44Ny42MDJtMy45NTcgMzkuMDNjLTIuMzQyIDEuODMtNC42ODMgMy42NjItNy41NTQgNS45MDdsMTAuNzQxIDkuNjYyIDkuODM4LTguNzM5LTEwLjE4OC0xMC41MThjLS45NTMgMS4zMjItMS42MzQgMi4yNjgtMi44MzcgMy42ODd6Ii8+PHBhdGggZmlsbD0iIzJCMjcyNSIgZD0iTTEwNC45OTEgNjQuNjYyYzcuNTQ2LTIuNTUxIDEyLjc4Ni0xLjIxIDE1LjA1OCAzLjg1IDEuODg3IDQuMiAxLjI2NSA4LjE3Mi0yLjI2NyAxMS4zNy0zLjI5IDIuOTgxLTkuMzA3IDMuMzAyLTEzLjAwOC43NjItLjgxNi0uNTYtMS40ODMtMS4zMzQtMi4yNy0xLjk0My0yLjExLTEuNjMyLTQuMjQ4LTMuMjI3LTYuNjctNS4wNjIgMy43MDgtMy42NiA2LjI4Mi02LjIwMSA5LjE1Ny04Ljk3N3oiLz48cGF0aCBmaWxsPSIjMkEyNjI0IiBkPSJNNzQuMTgyIDEwMC40MDFjMi4xMSAyLjE5IDQuMTI0IDMuOTczIDUuNzg2IDYuMDM5IDMuMjk0IDQuMDk1IDIuNzggOS41OTItMS4wMSAxMy4wNC0zLjU3NCAzLjI0OS04LjY5MiAzLjMxMy0xMi4yODguMTU0LTMuNzYtMy4zMDUtNC41MzItOS4xNy0xLjA4NC0xMi45OTggMi4zMjUtMi41OCA1LjUyOC00LjM3IDguNTk2LTYuMjM1eiIvPjxwYXRoIGZpbGw9IiMyQTI2MjUiIGQ9Ik0zMy45NzMgNjMuMjc5YzQuNyAyLjc0NiA5LjAxNyA1LjQ5IDEzLjc4NSA4LjUyLTIuNzUzIDIuODc3LTQuNTkyIDQuNzUtNi4zNzcgNi42NzUtMy4yMzIgMy40ODUtNi45NyA1LjA0LTExLjUyNSAyLjgyLTQuMDA2LTEuOTUzLTUuOTUzLTUuMzkxLTUuMzEtOS43Mi43MzgtNC45NzQgMy44NDgtNy45MSA5LjQyNy04LjI5NXoiLz48cGF0aCBmaWxsPSIjMkEyNTI0IiBkPSJNNjUuODE4IDI2Ljc3YzUuMzE2LTQuMDcxIDEwLjAzMS00LjA3MyAxMy42Mi0uMzAzIDMuNzgxIDMuOTcyIDMuNTggOS4yNTgtLjU0MiAxMy44NC0xLjg3MyAyLjA4Mi0zLjc3IDQuMTQzLTUuNTk1IDYuMTQ3LTEwLjQ1LTguNzAyLTExLjgzMi0xMi4zNzMtNy40ODMtMTkuNjg0eiIvPjxwYXRoIGZpbGw9IiMyQzI3MjYiIGQ9Ik02OS43ODUgNjUuODYyYy45NDMtMS4xODMgMS42MjQtMi4xMyAyLjU3Ny0zLjQ1TDgyLjU1IDcyLjkyOGwtOS44MzggOC43NC0xMC43NDEtOS42NjNjMi44Ny0yLjI0NSA1LjIxMi00LjA3NiA3LjgxNC02LjE0NHoiLz48L3N2Zz4=";
  if (e === "Provenance")
    return jt + "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjMkE3REUxIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNjUuMjMzIDIuNTQ1YTE5LjI5OCAxOS4yOTggMCAwIDAtMTkuMTU2IDBsLTIwNS41IDExOC43MzRBMTkuMDIgMTkuMDIgMCAwIDAgMzEgMTM3Ljc1OHYyMzcuNDdhMTkuMDE3IDE5LjAxNyAwIDAgMCA5LjU3OCAxNi40NzlsODMuMjQyIDQ4LjE3VjE5OS4xNjhhMTkuMjkxIDE5LjI5MSAwIDAgMSA5LjAxNC0xNi4wNTdsNTYuMzQtMzQuOTMgNTYuMzQtMzQuNTA4YTE5LjAyMiAxOS4wMjIgMCAwIDEgMjAgMGw1Ni4zNCAzNC41MDggNTYuMzQgMzQuOTNhMTkuMyAxOS4zIDAgMCAxIDkuMDE0IDE2LjMzOXYxMTMuOTQ1YTE5LjAwNyAxOS4wMDcgMCAwIDEtOS4wMTQgMTYuMzM5bC01Ni4zNCAzNS4wNzEtNTYuMzQgMzQuMzY3Yy01LjM1MiAzLjM4LTEwLjcwNC0yLjExMy0xMC43MDQtOC40NTFWMzQ1LjY1YTE4LjQ1NyAxOC40NTcgMCAwIDEgMTAuNzA0LTE0LjA4NWw0Ny4xODUtMjkuMTU2YTE5LjI5NCAxOS4yOTQgMCAwIDAgOS4wMTQtMTYuMzM4VjIzOS40NWExOC44NjcgMTguODY3IDAgMCAwLTkuMDE0LTE1LjkxNWwtNDYuOTAzLTI4LjE3YTE5LjAxMyAxOS4wMTMgMCAwIDAtMjAgMGwtNDYuNzYzIDI4LjE3YTE4Ljc0MSAxOC43NDEgMCAwIDAtOS4yOTYgMTUuOTE1djIzNC43OTNjLjA3Ljg0NC4wNyAxLjY5MiAwIDIuNTM2bDU2LjM0IDMyLjY3NmExOS4yOTMgMTkuMjkzIDAgMCAwIDE5LjE1NiAwbDIwNS42NC0xMTguNzM0YTE5LjAxOCAxOS4wMTggMCAwIDAgOS41NzgtMTYuNDc5VjEzNy43NThhMTkuMDE0IDE5LjAxNCAwIDAgMC05LjU3OC0xNi40NzlMMjY1LjIzMyAyLjU0NVoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
  if (e === "Noble")
    return jt + "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";
  {
    const t = e;
    return "";
  }
}
function Ok() {
  return /* @__PURE__ */ D(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "201",
      viewBox: "0 0 200 201",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ ne("g", { clipPath: "url(#icons_tokens_wbtc_clipPath_0)", children: [
        /* @__PURE__ */ D(
          "path",
          {
            d: "M197.008 124.204C183.651 177.782 129.385 210.389 75.8004 197.028C22.2386 183.671 -10.3679 129.402 2.99519 75.8283C16.3465 22.2444 70.6123 -10.3645 124.18 2.99268C177.76 16.3499 210.365 70.625 197.006 124.205L197.007 124.204H197.008Z",
            fill: "#F7931A"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M144.1 85.7619C146.091 72.4526 135.958 65.2984 122.102 60.5258L126.597 42.4971L115.623 39.7625L111.247 57.3165C108.362 56.5969 105.399 55.9189 102.454 55.2467L106.862 37.5769L95.8939 34.8423L91.3965 52.8651C89.009 52.3215 86.664 51.7842 84.3889 51.2181L84.4016 51.1614L69.2674 47.3822L66.3481 59.1037C66.3481 59.1037 74.4903 60.9701 74.3187 61.085C78.7628 62.1942 79.5665 65.1361 79.433 67.4679L74.3128 88.0067C74.6188 88.0844 75.0158 88.1969 75.4538 88.3729C75.0876 88.2819 74.698 88.1827 74.2938 88.0859L67.117 116.858C66.5739 118.208 65.1954 120.234 62.0883 119.465C62.1982 119.624 54.1118 117.474 54.1118 117.474L48.6631 130.037L62.9447 133.597C65.6016 134.263 68.2052 134.96 70.7692 135.616L66.2278 153.851L77.1897 156.586L81.6871 138.544C84.6817 139.357 87.5879 140.107 90.433 140.814L85.9508 158.771L96.9258 161.505L101.467 143.304C120.181 146.846 134.252 145.418 140.175 128.491C144.948 114.863 139.937 107.002 130.092 101.876C137.263 100.222 142.664 95.5061 144.104 85.7634L144.101 85.7609L144.1 85.7619ZM119.026 120.923C115.634 134.551 92.689 127.184 85.2498 125.336L91.2763 101.178C98.715 103.035 122.571 106.71 119.027 120.923H119.026ZM122.42 85.5644C119.326 97.9606 100.228 91.6628 94.0333 90.1185L99.4972 68.208C105.692 69.7522 125.643 72.6345 122.421 85.5644H122.42Z",
            fill: "white"
          }
        )
      ] })
    }
  );
}
function zk() {
  return /* @__PURE__ */ D(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "200",
      viewBox: "0 0 200 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ ne("g", { clipPath: "url(#icons_tokens_busd_clipPath_0)", children: [
        /* @__PURE__ */ D(
          "path",
          {
            d: "M99.6979 0.420898L124.296 25.6121L62.3557 87.5527L37.7573 62.9542L99.6979 0.420898Z",
            fill: "#F0B90B",
            stroke: "#F0B90B"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M137.04 37.7632L161.639 62.9543L62.3557 162.237L37.7573 137.639L137.04 37.7632Z",
            fill: "#F0B90B",
            stroke: "#F0B90B"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M25.0135 75.1055L49.6119 100.297L25.0135 124.895L0.415039 100.297L25.0135 75.1055Z",
            fill: "#F0B90B",
            stroke: "#F0B90B"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M174.382 75.1055L198.981 100.297L99.698 199.579L75.0996 174.981L174.382 75.1055Z",
            fill: "#F0B90B",
            stroke: "#F0B90B"
          }
        )
      ] })
    }
  );
}
function kk() {
  return /* @__PURE__ */ D(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "230",
      height: "200",
      viewBox: "0 0 230 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ ne("g", { clipPath: "url(#icons_tokens_usdt_clipPath_0)", children: [
        /* @__PURE__ */ D(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M42.0972 0.982283L0.176253 89.0373C0.0167314 89.3648 -0.0338199 89.7348 0.0319915 90.0931C0.0978028 90.4514 0.276524 90.7792 0.54202 91.0287L113.76 199.519C114.082 199.828 114.51 200 114.956 200C115.402 200 115.83 199.828 116.151 199.519L229.37 91.0355C229.635 90.786 229.814 90.4582 229.88 90.0998C229.946 89.7415 229.895 89.3716 229.736 89.0441L187.815 0.989056C187.679 0.69333 187.462 0.442813 187.188 0.267445C186.914 0.0920761 186.596 -0.00072543 186.27 0.000131083H43.6551C43.3283 -0.00393409 43.0074 0.086632 42.731 0.260904C42.4545 0.435177 42.2344 0.68571 42.0972 0.982283Z",
            fill: "#50AF95"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M129.502 98.0801C128.689 98.1411 124.49 98.3917 115.122 98.3917C107.671 98.3917 102.381 98.1682 100.525 98.0801C71.7311 96.8135 50.2389 91.8011 50.2389 85.7998C50.2389 79.7985 71.7311 74.7929 100.525 73.506V93.0881C102.408 93.2235 107.8 93.5419 115.251 93.5419C124.192 93.5419 128.669 93.1693 129.475 93.0948V73.5195C158.208 74.7997 179.653 79.8121 179.653 85.7998C179.653 91.7876 158.215 96.7999 129.475 98.0733L129.502 98.0801ZM129.502 71.4943V53.9713H169.601V27.25H60.4262V53.9713H100.518V71.4875C67.9312 72.9844 43.4248 79.4395 43.4248 87.1748C43.4248 94.9101 67.9312 101.358 100.518 102.862V159.014H129.495V102.842C162.008 101.345 186.474 94.8966 186.474 87.1681C186.474 79.4395 162.028 72.9912 129.495 71.4875L129.502 71.4943Z",
            fill: "white"
          }
        )
      ] })
    }
  );
}
function _k() {
  return /* @__PURE__ */ D(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "200",
      viewBox: "0 0 200 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ ne("g", { clipPath: "url(#icons_tokens_dai_clipPath_0)", children: [
        /* @__PURE__ */ D(
          "path",
          {
            d: "M100 0C155.234 0 200 44.7754 200 100C200 155.234 155.234 200 100 200C44.7754 200 0 155.229 0 100C0 44.7754 44.7754 0 100 0Z",
            fill: "#F5AC37"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M103.686 107.06H141.684C142.494 107.06 142.877 107.06 142.935 105.998C143.246 102.133 143.246 98.2448 142.935 94.3748C142.935 93.6233 142.562 93.3128 141.747 93.3128H66.1237C65.1877 93.3128 64.9357 93.6233 64.9357 94.5008V105.625C64.9357 107.06 64.9357 107.06 66.4343 107.06H103.686ZM138.691 80.3121C138.799 80.0286 138.799 79.7181 138.691 79.4391C138.057 78.0576 137.305 76.7391 136.432 75.5016C135.118 73.3866 133.57 71.4381 131.806 69.6875C130.974 68.63 130.011 67.6805 128.931 66.875C123.522 62.2715 117.091 59.0134 110.179 57.3754C106.692 56.5924 103.128 56.2189 99.5546 56.2504H65.9932C65.0572 56.2504 64.9312 56.6239 64.9312 57.4384V79.6236C64.9312 80.5597 64.9312 80.8117 66.1192 80.8117H138.241C138.241 80.8117 138.867 80.6857 138.993 80.3121H138.687H138.691ZM138.691 120.061C137.629 119.944 136.558 119.944 135.496 120.061H66.1868C65.2507 120.061 64.9357 120.061 64.9357 121.312V143.002C64.9357 144.001 64.9357 144.253 66.1868 144.253H98.1866C99.7166 144.37 101.247 144.262 102.745 143.943C107.389 143.61 111.957 142.602 116.313 140.941C117.897 140.392 119.427 139.677 120.871 138.817H121.308C128.809 134.916 134.902 128.787 138.745 121.263C138.745 121.263 139.182 120.318 138.691 120.07V120.061ZM52.3761 155.499V155.125V140.563V135.627V120.939C52.3761 120.124 52.3761 120.003 51.3771 120.003H37.814C37.0625 120.003 36.752 120.003 36.752 119.004V107.128H51.2511C52.0611 107.128 52.3761 107.128 52.3761 106.066V94.3163C52.3761 93.5648 52.3761 93.3803 51.3771 93.3803H37.814C37.0625 93.3803 36.752 93.3803 36.752 92.3813V81.3832C36.752 80.6947 36.752 80.5102 37.751 80.5102H51.1881C52.1241 80.5102 52.3761 80.5102 52.3761 79.3221V45.6348C52.3761 44.6358 52.3761 44.3838 53.6271 44.3838H100.5C103.902 44.5188 107.281 44.8923 110.625 45.5088C117.514 46.7823 124.134 49.2438 130.186 52.7584C134.2 55.1209 137.895 57.9739 141.184 61.259C143.66 63.8285 145.892 66.6095 147.872 69.5705C149.838 72.5721 151.472 75.7806 152.754 79.1331C152.912 80.0061 153.749 80.5957 154.622 80.4472H165.809C167.244 80.4472 167.244 80.4472 167.307 81.8242V92.0753C167.307 93.0743 166.934 93.3263 165.93 93.3263H157.304C156.431 93.3263 156.179 93.3263 156.242 94.4513C156.584 98.2583 156.584 102.079 156.242 105.886C156.242 106.948 156.242 107.074 157.434 107.074H167.303C167.739 107.636 167.303 108.199 167.303 108.766C167.366 109.49 167.366 110.224 167.303 110.948V118.513C167.303 119.575 166.992 119.89 166.052 119.89H154.239C153.416 119.733 152.615 120.259 152.426 121.078C149.613 128.391 145.113 134.947 139.299 140.203C137.175 142.116 134.943 143.916 132.612 145.576C130.11 147.016 127.675 148.515 125.11 149.703C120.39 151.827 115.44 153.393 110.359 154.387C105.535 155.251 100.644 155.643 95.734 155.575H52.3581V155.512L52.3761 155.499Z",
            fill: "#FEFEFD"
          }
        )
      ] })
    }
  );
}
function Bk() {
  return /* @__PURE__ */ D(
    "svg",
    {
      width: "92",
      height: "91",
      viewBox: "0 0 92 91",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ D(
        "path",
        {
          d: "M91.3583 45.4564C91.3583 20.351 70.9064 0 45.6817 0C20.4571 0 0 20.351 0 45.4564C0 50.6467 0.876215 55.6319 2.48433 60.2786C2.49464 60.2991 2.58226 60.5658 2.58226 60.5658C3.23169 62.6224 0.0103084 63.4277 0.0103084 64.6586C0.0103084 66.587 6.80355 66.3254 6.80355 68.5667C6.80355 70.5208 0.0824673 71.126 0.0824673 73.0954C0.0824673 75.8188 14.9627 74.87 15.1534 77.2087C15.2977 79.014 10.0352 79.1269 10.0043 81.0553C9.95277 84.1377 30.3119 83.1273 30.3119 85.1788C30.3119 86.7329 21.0498 86.1687 21.0498 88.0048C21.0498 89.8409 33.2395 91 46.6765 91C60.1135 91 69.3808 89.5127 69.3808 87.9073C69.3808 86.302 60.732 86.6303 60.9124 85.184C61.2217 82.6555 80.4211 83.9479 80.4211 81.0194C80.4211 79.4756 75.1432 79.1166 75.3133 77.4549C75.5555 75.1059 91.3583 75.4547 91.3583 73.0134C91.3583 71.0952 83.5239 70.6233 83.5394 68.6283C83.5497 66.5921 91.3583 66.6793 91.3068 64.7714C91.2655 63.3046 87.8122 63.3405 88.8946 60.2324C90.4924 55.6011 91.3686 50.6313 91.3686 45.4564H91.3583ZM76.8441 58.3656C75.2566 61.9403 71.6899 61.2223 71.2878 62.725C70.8704 64.279 75.6844 64.5047 75.6844 66.1305C75.6844 68.1051 61.0104 67.3153 61.1547 69.9207C61.2474 71.5619 71.5765 71.8389 71.3806 73.5519C71.0971 76.0342 55.3768 74.7931 55.2222 77.1728C55.1088 78.9166 62.8968 78.9781 62.9123 80.5681C62.9277 81.9067 56.7994 82.635 45.0581 82.635C31.6881 82.635 25.1835 81.9169 25.9257 80.4245C26.6163 79.0294 38.4555 79.2859 38.337 77.0907C38.2184 74.9008 17.313 75.5419 16.6842 73.4134C16.1584 71.644 23.5547 71.2798 23.5083 69.5976C23.462 67.8846 14.0401 68.2744 13.8339 66.1972C13.6999 64.8381 18.7562 64.9201 18.5397 63.2071C18.3799 61.9608 16.2924 62.1352 15.0554 59.5657C13.0608 55.2729 11.9371 50.4929 11.9371 45.4513C11.9371 26.9056 27.0493 11.868 45.6869 11.868C64.3245 11.868 79.4366 26.9056 79.4366 45.4513C79.4366 50.0262 78.514 54.3856 76.8492 58.3604L76.8441 58.3656Z",
          fill: "white"
        }
      )
    }
  );
}
function Fk() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      xmlns: "http://www.w3.org/2000/svg",
      enableBackground: "new 0 0 254 254",
      width: "254",
      height: "254",
      viewBox: "0 0 254 254",
      children: [
        /* @__PURE__ */ D(
          "circle",
          {
            cx: "127",
            cy: "127",
            r: "127",
            fill: "#e84142",
            fillRule: "evenodd",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M171.8 130.3c4.4-7.6 11.5-7.6 15.9 0l27.4 48.1c4.4 7.6.8 13.8-8 13.8h-55.2c-8.7 0-12.3-6.2-8-13.8l27.9-48.1zm-53-92.6c4.4-7.6 11.4-7.6 15.8 0l6.1 11L155.1 74c3.5 7.2 3.5 15.7 0 22.9l-48.3 83.7c-4.4 6.8-11.7 11.1-19.8 11.6H46.9c-8.8 0-12.4-6.1-8-13.8l79.9-140.7z"
          }
        )
      ]
    }
  );
}
function Rk() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      id: "icons_tokens_bnb_svg",
      style: { maxHeight: "100%", maxWidth: "100%" },
      xmlns: "http://www.w3.org/2000/svg",
      width: "511.97",
      height: "511.97",
      viewBox: "0 0 511.97 511.97",
      children: [
        /* @__PURE__ */ D("title", { children: "binance-coin-bnb" }),
        /* @__PURE__ */ D("g", { id: "icons_tokens_bnb_g_0", "data-name": "icons_tokens_bnb_g_0", children: /* @__PURE__ */ ne("g", { id: "icons_tokens_bnb_g_1", "data-name": "icons_tokens_bnb_g_1", children: [
          /* @__PURE__ */ D(
            "path",
            {
              fill: "#f3ba2f",
              d: "M156.56,215.14,256,115.71l99.47,99.47,57.86-57.85L256,0,98.71,157.28l57.85,57.85M0,256l57.86-57.87L115.71,256,57.85,313.83Zm156.56,40.85L256,396.27l99.47-99.47,57.89,57.82,0,0L256,512,98.71,354.7l-.08-.09,57.93-57.77M396.27,256l57.85-57.85L512,256l-57.85,57.85Z"
            }
          ),
          /* @__PURE__ */ D(
            "path",
            {
              fill: "#f3ba2f",
              d: "M314.66,256h0L256,197.25,212.6,240.63h0l-5,5L197.33,255.9l-.08.08.08.08L256,314.72l58.7-58.7,0,0-.05,0"
            }
          )
        ] }) })
      ]
    }
  );
}
function Pk() {
  return /* @__PURE__ */ D(
    "svg",
    {
      version: "1.1",
      id: "Symbol",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 384 383",
      style: { width: "100%", height: "100%" },
      xmlSpace: "preserve",
      children: /* @__PURE__ */ D(
        "path",
        {
          fill: "#FFF572",
          d: `M383.5,0H0.5v383h383V249.3h-63.6C298,298.1,248.7,332,192.3,332c-77.8,0-140.8-63.6-140.8-140.8
  C51.4,114,114.5,51,192.3,51c57.5,0,106.8,35,128.7,84.9h62.5V0z`
        }
      )
    }
  );
}
function Uk() {
  return /* @__PURE__ */ D(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      height: "182",
      width: "182",
      viewBox: "0 0 182 182",
      style: { maxHeight: "100%", maxWidth: "100%" },
      children: /* @__PURE__ */ D("g", { children: /* @__PURE__ */ D("g", { id: "Layer_1", focusable: "false", children: /* @__PURE__ */ ne("g", { children: [
        /* @__PURE__ */ D(
          "path",
          {
            d: "M90.9,181v-45.2l-55.9-32.7,55.9,77.8Z",
            fill: "#f0cdc2",
            stroke: "#1616b4",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M91.1,181v-45.2l55.9-32.7-55.9,77.8Z",
            fill: "#c9b3f5",
            stroke: "#1616b4",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M90.9,124.6v-57.6l-56.5,25.3,56.5,32.3Z",
            fill: "#88aaf1",
            stroke: "#1616b4",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M91.1,124.6v-57.6l56.5,25.3-56.5,32.3Z",
            fill: "#c9b3f5",
            stroke: "#1616b4",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M34.4,92.3L90.9,1v66l-56.5,25.3Z",
            fill: "#f0cdc2",
            stroke: "#1616b4",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M147.6,92.3L91.1,1v66l56.5,25.3Z",
            fill: "#b8faf6",
            stroke: "#1616b4",
            strokeLinejoin: "round"
          }
        )
      ] }) }) })
    }
  );
}
function Yk() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "100",
      height: "100",
      viewBox: "0 0 100 100",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D(
          "path",
          {
            d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
            fill: "#13B5EC"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M53.75 40.3125L65 33.75V46.875L53.75 40.3125ZM65 68.4375L50 77.1875L35 68.4375V53.125L50 61.875L65 53.125V68.4375ZM35 33.75L46.25 40.3125L35 46.875V33.75ZM51.875 43.4375L63.125 50L51.875 56.5625V43.4375ZM48.125 56.5625L36.875 50L48.125 43.4375V56.5625ZM63.125 30.625L50 38.125L36.875 30.625L50 22.8125L63.125 30.625ZM31.25 29.375V70.3125L50 80.9375L68.75 70.3125V29.375L50 18.75L31.25 29.375Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function Wk() {
  return /* @__PURE__ */ D(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "96",
      height: "84",
      viewBox: "0 0 96 84",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ D("g", { clipPath: "url(#icons_tokens_sol_clipPath_0)", children: /* @__PURE__ */ D(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.368 64.052A3.214 3.214 0 0 1 19.744 63l73.312.06a1.612 1.612 0 0 1 1.188 2.698l-15.612 17.19A3.213 3.213 0 0 1 76.254 84l-73.31-.06a1.611 1.611 0 0 1-1.188-2.698l15.612-17.19Zm76.876-14.31a1.611 1.611 0 0 1-1.188 2.698l-73.31.06a3.213 3.213 0 0 1-2.378-1.052l-15.612-17.2a1.612 1.612 0 0 1 1.188-2.698l73.312-.06a3.213 3.213 0 0 1 2.376 1.052l15.612 17.2ZM17.368 1.052A3.215 3.215 0 0 1 19.744 0l73.312.06a1.612 1.612 0 0 1 1.188 2.698l-15.612 17.19A3.213 3.213 0 0 1 76.254 21l-73.31-.06a1.611 1.611 0 0 1-1.188-2.698l15.612-17.19Z",
          fill: "url(#icons_tokens_sol_linearGradient_0)"
        }
      ) })
    }
  );
}
function Hk() {
  return /* @__PURE__ */ D(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "200",
      version: "1.2",
      baseProfile: "tiny",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 112 112",
      overflow: "visible",
      xmlSpace: "preserve",
      children: /* @__PURE__ */ D(
        "path",
        {
          fill: "currentColor",
          d: "M86.6 37.4h-9.9c-1.1 0-2.2-.5-3-1.3l-4-4.5c-1.2-1.3-3.1-1.4-4.5-.3l-.3.3-3.4 3.9c-1.1 1.3-2.8 2-4.5 2H2.9C1.4 41.9.4 46.6 0 51.3h51.2c.9 0 1.8-.4 2.4-1l4.8-5c.6-.6 1.4-1 2.3-1h.2c.9 0 1.8.4 2.4 1.1l4 4.5c.8.9 1.9 1.4 3 1.4H112c-.4-4.7-1.4-9.4-2.9-13.8H86.6zM53.8 65l-4-4.5c-1.2-1.3-3.1-1.4-4.5-.3l-.3.3-3.5 3.9c-1.1 1.3-2.7 2-4.4 2H.8c.9 4.8 2.5 9.5 4.6 14h25.5c.9 0 1.7-.4 2.4-1l4.8-5c.6-.6 1.4-1 2.3-1h.2c.9 0 1.8.4 2.4 1.1l4 4.5c.8.9 1.9 1.4 3 1.4h56.6c2.1-4.4 3.7-9.1 4.6-14H56.8c-1.2 0-2.3-.5-3-1.4zm19.6-43.6 4.8-5c.6-.6 1.4-1 2.3-1h.2c.9 0 1.8.4 2.4 1l4 4.5c.8.9 1.9 1.3 3 1.3h10.8c-18.8-24.8-54.1-29.7-79-11-4.1 3.1-7.8 6.8-11 11H71c1 .2 1.8-.2 2.4-.8zM34.7 94.2c-1.2 0-2.3-.5-3-1.3l-4-4.5c-1.2-1.3-3.2-1.4-4.5-.2l-.2.2-3.5 3.9c-1.1 1.3-2.7 2-4.4 2h-.2C36 116.9 71.7 118 94.4 96.7c.9-.8 1.7-1.7 2.6-2.6H34.7z"
        }
      )
    }
  );
}
function Zk() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "200",
      height: "200",
      viewBox: "0 0 200 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("circle", { cx: "100", cy: "100", r: "100", fill: "#6FBCEF" }),
        /* @__PURE__ */ D(
          "mask",
          {
            id: "mask0_309_9859",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "200",
            height: "200",
            children: /* @__PURE__ */ D(
              "path",
              {
                d: "M200 100C200 155.228 155.228 200 100 200C44.7715 200 0 155.228 0 100C0 44.7715 44.7715 0 100 0C155.228 0 200 44.7715 200 100Z",
                fill: "#8DCBF5"
              }
            )
          }
        ),
        /* @__PURE__ */ ne("g", { mask: "url(#mask0_309_9859)", children: [
          /* @__PURE__ */ D(
            "path",
            {
              d: "M113 -4L174 19L196 63.5C196 63.5 169.5 40.5 138.5 24.5C107.5 8.5 58.5 4 58.5 4L113 -4Z",
              fill: "#7AC1F2"
            }
          ),
          /* @__PURE__ */ D(
            "path",
            {
              d: "M15.8341 34.0023C15.8341 34.0023 72.9887 50.5017 103.494 64.5009C134 78.5001 144.388 89.0206 163.495 112.001C175.611 126.574 189.379 153.053 189.379 153.053L165.999 179.499C165.999 179.499 158.272 146.022 145.999 128.499C129.42 104.828 107.493 94.0004 86.4965 84.5002C65.5 75 -0.00518256 57.0917 -0.00518256 57.0917L15.8341 34.0023Z",
              fill: "#7AC1F2"
            }
          ),
          /* @__PURE__ */ D(
            "path",
            {
              d: "M2.49892 130.498L-1.50005 100.5C-1.50005 100.5 45.5 117.5 75.5 138.5C105.5 159.5 123.499 199.998 123.499 199.998L89.9989 201.498C89.9989 201.498 86.5 192 62.5 165.5C38.5 139 2.49892 130.498 2.49892 130.498Z",
              fill: "#7AC1F2"
            }
          )
        ] }),
        /* @__PURE__ */ D(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M45.4743 158.743C56.7736 178.317 77.0124 190 99.6108 190C122.209 190 142.444 178.317 153.747 158.743C165.047 139.175 165.047 115.807 153.747 96.2343L106.133 13.7657C103.234 8.74477 95.9873 8.74478 93.0885 13.7657L45.4743 96.2343C34.1752 115.803 34.1752 139.17 45.4743 158.743ZM86.1978 52.9996L96.3497 35.416C97.799 32.9054 101.423 32.9054 102.872 35.416L141.927 103.062C149.102 115.489 150.448 129.872 145.967 143.034C145.501 140.887 144.848 138.69 143.969 136.47C138.575 122.856 126.377 112.351 107.708 105.244C94.8728 100.375 86.6799 93.2146 83.3509 83.96C79.063 72.0315 83.5416 59.0237 86.1978 52.9996ZM68.8873 82.9829L57.2949 103.062C48.4619 118.361 48.4619 136.624 57.2949 151.924C66.128 167.222 81.9447 176.352 99.6108 176.352C111.344 176.352 122.265 172.321 130.864 165.131C131.986 162.307 135.458 151.973 131.168 141.32C127.205 131.484 117.669 123.632 102.821 117.976C86.0386 111.61 75.1351 101.671 70.4201 88.4448C69.7707 86.6237 69.2662 84.7988 68.8873 82.9829Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function Qk() {
  return /* @__PURE__ */ D(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "256",
      height: "256",
      viewBox: "0 0 256 256",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ D(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "m 127.67411,256 c 38.02499,0 72.18784,-16.49691 95.68658,-42.70676 -10.93123,-9.47577 -27.40461,-10.05162 -39.04159,-0.68556 l -2.22314,1.78953 c -21.30703,17.14908 -52.35448,14.61676 -70.58505,-5.7577 -9.94332,-11.11197 -26.972141,-12.24661 -38.308517,-2.55277 L 47.570215,228.00608 C 69.524032,245.52451 97.372724,256 127.67411,256 Z m 41.60702,-61.98133 C 189.57566,177.68394 218.1014,178.27 237.62049,194.0459 249.28754,174.76386 256,152.16374 256,128.00034 c 0,-26.85042 -8.28793,-51.769568 -22.45139,-72.350916 -9.131,-1.939587 -19.02787,0.325741 -26.54036,6.966212 l -2.13843,1.889976 C 184.37854,82.617466 153.24774,81.516899 134.09348,62.003681 123.64732,51.36103 106.58366,51.011574 95.70776,61.217474 L 65.879285,89.2086 49.470132,71.811468 79.298607,43.820001 C 99.6717,24.70176 131.636,25.356444 151.20497,45.292785 c 10.2248,10.416813 26.8437,11.004304 37.78245,1.335536 l 2.13842,-1.889909 c 6.64005,-5.869189 14.32197,-9.825846 22.366,-11.906837 C 190.75623,12.421275 160.66937,0 127.67411,0 62.5305,0 8.7242884,48.41669 0.45065936,111.14157 20.23734,101.67056 44.644196,105.31504 60.77713,121.79424 c 10.185043,10.40324 26.584631,11.50108 38.071994,2.54936 l 16.677656,-12.99623 c 20.96064,-16.333367 50.58976,-15.542866 70.64448,1.88493 l 32.46987,28.21744 -15.73073,18.00977 -32.46987,-28.21675 c -11.40333,-9.91056 -28.25178,-10.36033 -40.17025,-1.07263 l -16.67765,12.9969 C 92.486461,159.61353 62.356352,157.59639 43.643919,138.48264 32.762761,127.36794 14.966434,126.98019 3.609064,137.61037 L 0,140.98839 c 2.7009241,26.73389 13.649562,51.04108 30.269414,70.34973 l 27.34647,-23.38517 c 21.235909,-18.16038 53.135306,-16.03488 71.761456,4.78115 9.73221,10.87688 26.30602,12.22823 37.67997,3.07342 z",
          fill: "#ffffff",
          id: "path1050",
          style: { strokeWidth: 6.82333 }
        }
      )
    }
  );
}
function Vk() {
  return /* @__PURE__ */ D(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "111",
      height: "111",
      viewBox: "0 0 111 111",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ D(
        "path",
        {
          d: "M54.921 110.034C85.359 110.034 110.034 85.402 110.034 55.017C110.034 24.6319 85.359 0 54.921 0C26.0432 0 2.35281 22.1714 0 50.3923H72.8467V59.6416H3.9565e-07C2.35281 87.8625 26.0432 110.034 54.921 110.034Z",
          fill: "#0052FF"
        }
      )
    }
  );
}
function Gk() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "360",
      height: "360",
      viewBox: "0 0 360 360",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "360", height: "360", rx: "180", fill: "#6C00F6" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M218.804 99.5819L168.572 128.432V218.473L140.856 234.539L112.97 218.46V186.313L140.856 170.39L158.786 180.788V154.779L140.699 144.511L90.4795 173.687V231.399L140.869 260.418L191.088 231.399V141.371L218.974 125.291L246.846 141.371V173.374L218.974 189.597L200.887 179.107V204.986L218.804 215.319L269.519 186.47V128.432L218.804 99.5819Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function $k() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "100",
      height: "100",
      viewBox: "0 0 100 100",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D(
          "path",
          {
            d: "M50.7548 0L24.1998 15.3175L33.9648 20.975L50.7573 11.3175L67.5498 20.975L77.3148 15.3175L50.7548 0ZM67.5498 28.975L77.3148 34.635V45.9525L60.5198 55.61V74.9275L50.7573 80.585L40.9923 74.9275V55.61L24.1973 45.95V34.6325L33.9623 28.9725L50.7548 38.6325L67.5498 28.9725V28.975Z",
            fill: "#F0B90B"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M77.3148 53.95V65.2675L67.5498 70.9275V59.61L77.3148 53.95Z",
            fill: "#F0B90B"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M67.4525 78.925L84.2475 69.2675V49.95L94.0125 44.2925V74.9275L67.4525 90.245V78.925ZM84.25 30.635L74.48 24.975L84.25 19.3175L94.015 24.975V36.2925L84.25 41.9525V30.635ZM40.9925 94.3425V83.025L50.755 88.6825L60.52 83.025V94.3425L50.7575 100L40.9925 94.3425ZM33.9625 70.925L24.1975 65.2675V53.9525L33.9625 59.61V70.925ZM50.755 30.635L40.9925 24.975L50.755 19.3175L60.52 24.975L50.755 30.635ZM27.03 24.975L17.265 30.635V41.9525L7.5 36.2925V24.975L17.265 19.3175L27.03 24.975Z",
            fill: "#F0B90B"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M7.5 44.2925L17.265 49.9525V69.2675L34.06 78.9275V90.245L7.5 74.925V44.2925Z",
            fill: "#F0B90B"
          }
        )
      ]
    }
  );
}
function qk() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      xmlns: "http://www.w3.org/2000/svg",
      "data-name": "86977684-12db-4850-8f30-233a7c267d11",
      width: "2000",
      height: "2000",
      viewBox: "0 0 2000 2000",
      children: [
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#2775ca",
            d: "M1000 2000c554.17 0 1000-445.83 1000-1000S1554.17 0 1000 0 0 445.83 0 1000s445.83 1000 1000 1000z"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M1275 1158.33c0-145.83-87.5-195.83-262.5-216.66-125-16.67-150-50-150-108.34s41.67-95.83 125-95.83c75 0 116.67 25 137.5 87.5 4.17 12.5 16.67 20.83 29.17 20.83h66.66c16.67 0 29.17-12.5 29.17-29.16v-4.17c-16.67-91.67-91.67-162.5-187.5-170.83v-100c0-16.67-12.5-29.17-33.33-33.34h-62.5c-16.67 0-29.17 12.5-33.34 33.34v95.83c-125 16.67-204.16 100-204.16 204.17 0 137.5 83.33 191.66 258.33 212.5 116.67 20.83 154.17 45.83 154.17 112.5s-58.34 112.5-137.5 112.5c-108.34 0-145.84-45.84-158.34-108.34-4.16-16.66-16.66-25-29.16-25h-70.84c-16.66 0-29.16 12.5-29.16 29.17v4.17c16.66 104.16 83.33 179.16 220.83 200v100c0 16.66 12.5 29.16 33.33 33.33h62.5c16.67 0 29.17-12.5 33.34-33.33v-100c125-20.84 208.33-108.34 208.33-220.84z"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M787.5 1595.83c-325-116.66-491.67-479.16-370.83-800 62.5-175 200-308.33 370.83-370.83 16.67-8.33 25-20.83 25-41.67V325c0-16.67-8.33-29.17-25-33.33-4.17 0-12.5 0-16.67 4.16-395.83 125-612.5 545.84-487.5 941.67 75 233.33 254.17 412.5 487.5 487.5 16.67 8.33 33.34 0 37.5-16.67 4.17-4.16 4.17-8.33 4.17-16.66v-58.34c0-12.5-12.5-29.16-25-37.5zm441.67-1300c-16.67-8.33-33.34 0-37.5 16.67-4.17 4.17-4.17 8.33-4.17 16.67v58.33c0 16.67 12.5 33.33 25 41.67 325 116.66 491.67 479.16 370.83 800-62.5 175-200 308.33-370.83 370.83-16.67 8.33-25 20.83-25 41.67V1700c0 16.67 8.33 29.17 25 33.33 4.17 0 12.5 0 16.67-4.16 395.83-125 612.5-545.84 487.5-941.67-75-237.5-258.34-416.67-487.5-491.67z"
          }
        )
      ]
    }
  );
}
function Jk() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "470.29",
      height: "514.25",
      viewBox: "0 0 470.29 514.25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D(
          "path",
          {
            d: "m291.13 237.47 35.654-60.5 96.103 149.68 0.046 28.727-0.313-197.67c-0.228-4.832-2.794-9.252-6.887-11.859l-173.02-99.525c-4.045-1.99-9.18-1.967-13.22 0.063-0.546 0.272-1.06 0.57-1.548 0.895l-0.604 0.379-167.94 97.322-0.651 0.296c-0.838 0.385-1.686 0.875-2.48 1.444-3.185 2.283-5.299 5.66-5.983 9.448-0.103 0.574-0.179 1.158-0.214 1.749l0.264 161.08 89.515-138.74c11.271-18.397 35.825-24.323 58.62-24.001l26.753 0.706-157.64 252.8 18.582 10.697 159.52-263.24 70.51-0.256-159.11 269.88 66.306 38.138 7.922 4.556c3.351 1.362 7.302 1.431 10.681 0.21l175.45-101.68-33.544 19.438-92.775-150.04zm13.602 195.93-66.969-105.11 40.881-69.371 87.952 138.63-61.864 35.851z",
            fill: "#2D374B"
          }
        ),
        /* @__PURE__ */ D(
          "polygon",
          {
            points: "237.77 328.29 304.74 433.4 366.6 397.54 278.65 258.92",
            fill: "#28A0F0"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "m422.94 355.38-0.046-28.727-96.103-149.68-35.654 60.5 92.774 150.04 33.544-19.438c3.29-2.673 5.281-6.594 5.49-10.825l-5e-3 -1.869z",
            fill: "#28A0F0"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "m20.219 382.47 47.369 27.296 157.63-252.8-26.753-0.706c-22.795-0.322-47.35 5.604-58.62 24.001l-89.515 138.74-30.115 46.271v17.194z",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ D(
          "polygon",
          {
            points: "316.2 156.96 245.69 157.22 86.17 420.46 141.93 452.56 157.09 426.85",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "m452.65 156.6c-0.59-14.746-8.574-28.245-21.08-36.104l-175.29-100.8c-12.371-6.229-27.825-6.237-40.218-4e-3 -1.465 0.739-170.46 98.752-170.46 98.752-2.339 1.122-4.592 2.458-6.711 3.975-11.164 8.001-17.969 20.435-18.668 34.095v208.76l30.115-46.271-0.263-161.08c0.035-0.589 0.109-1.169 0.214-1.741 0.681-3.79 2.797-7.171 5.983-9.456 0.795-0.569 172.68-100.06 173.23-100.34 4.04-2.029 9.175-2.053 13.22-0.063l173.02 99.523c4.093 2.607 6.659 7.027 6.887 11.859v199.54c-0.209 4.231-1.882 8.152-5.172 10.825l-33.544 19.438-17.308 10.031-61.864 35.852-62.737 36.357c-3.379 1.221-7.33 1.152-10.681-0.21l-74.228-42.693-15.163 25.717 66.706 38.406c2.206 1.255 4.171 2.367 5.784 3.272 2.497 1.4 4.199 2.337 4.8 2.629 4.741 2.303 11.563 3.643 17.71 3.643 5.636 0 11.132-1.035 16.332-3.072l182.22-105.53c10.459-8.104 16.612-20.325 17.166-33.564v-201.75z",
            fill: "#96BEDC"
          }
        )
      ]
    }
  );
}
function Xk() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      xmlns: "http://www.w3.org/2000/svg",
      id: "optimism-logo-circle",
      width: "122",
      height: "122",
      viewBox: "0 0 122 122",
      children: [
        /* @__PURE__ */ D(
          "circle",
          {
            id: "Ellipse_11",
            "data-name": "Ellipse 11",
            cx: "61",
            cy: "61",
            r: "61",
            fill: "#ff0420"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            id: "Path_139",
            "data-name": "Path 139",
            d: "M113.533,178.026a14.656,14.656,0,0,1-8.924-2.563,8.762,8.762,0,0,1-3.432-7.413,16.433,16.433,0,0,1,.229-2.471q.595-3.3,1.693-7.917,3.112-12.585,16.062-12.585a15.966,15.966,0,0,1,6.315,1.19,9.6,9.6,0,0,1,4.393,3.478,9.333,9.333,0,0,1,1.6,5.492,16.288,16.288,0,0,1-.229,2.425q-.687,4.073-1.647,7.917-1.6,6.269-5.537,9.381Q120.123,178.026,113.533,178.026Zm.641-6.59a6.5,6.5,0,0,0,4.348-1.51,8.424,8.424,0,0,0,2.608-4.622q1.053-4.3,1.6-7.505a10.5,10.5,0,0,0,.183-1.968q0-4.165-4.347-4.164a6.681,6.681,0,0,0-4.393,1.51,8.573,8.573,0,0,0-2.563,4.622q-.824,3.066-1.647,7.505a9.791,9.791,0,0,0-.183,1.922Q109.78,171.436,114.174,171.436Z",
            transform: "translate(-70.332 -100.849)",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            id: "Path_140",
            "data-name": "Path 140",
            d: "M205.3,178.612a.97.97,0,0,1-.778-.32,1.1,1.1,0,0,1-.137-.824l6.315-29.746a1.31,1.31,0,0,1,.5-.824,1.4,1.4,0,0,1,.87-.32h12.173a14.148,14.148,0,0,1,8.146,2.105,6.9,6.9,0,0,1,3.112,6.087,10.955,10.955,0,0,1-.275,2.38,12.39,12.39,0,0,1-4.622,7.78q-3.432,2.517-9.427,2.517H215l-2.105,10.022a1.311,1.311,0,0,1-.5.824,1.4,1.4,0,0,1-.869.32Zm16.2-17.482a5.451,5.451,0,0,0,3.341-1.052,4.942,4.942,0,0,0,1.922-3.02,8.022,8.022,0,0,0,.137-1.373,2.543,2.543,0,0,0-.778-2.014,3.836,3.836,0,0,0-2.654-.732h-5.491l-1.739,8.191Z",
            transform: "translate(-142.055 -101.892)",
            fill: "#fff"
          }
        )
      ]
    }
  );
}
function Kk() {
  return /* @__PURE__ */ D(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "256",
      height: "256",
      fill: "none",
      viewBox: "0 0 800 800",
      children: /* @__PURE__ */ ne("g", { clipPath: "url(#icons_chains_osmo_clipPath_0)", children: [
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#5E12A0",
            d: "M673.964 193.237C667.62 168.805 647.227 144.373 610.519 117.174C581.062 95.5081 549.792 83.0615 524.867 83.0615C519.882 83.0615 515.35 83.5225 510.819 84.4445C499.489 86.7494 489.519 95.0471 483.174 107.494C475.47 122.245 473.658 142.068 478.643 154.053C480.455 157.741 482.721 162.351 485.44 166.5C461.422 181.251 447.826 185.4 446.013 185.861C508.553 207.067 560.669 251.321 593.298 308.944L593.751 303.413C595.111 288.2 599.642 270.683 605.987 252.704C612.332 254.548 618.676 255.47 625.021 255.47C641.788 255.47 656.29 248.555 665.354 236.109C674.418 223.662 678.043 207.067 673.964 193.237Z"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "url(#icons_chains_osmo_radialGradient_0)",
            d: "M608.706 239.342C649.945 250.867 666.713 218.598 661.275 196.932C655.383 175.265 636.35 153.138 602.814 128.245C569.279 103.352 535.29 93.2098 513.537 97.8197C491.784 102.43 485.44 136.081 490.878 148.989C493.144 154.06 498.129 161.436 504.927 169.733C496.316 175.726 488.159 180.336 481.361 184.485C523.054 203.385 559.309 232.888 586.5 269.767C589.672 257.321 594.204 246.257 598.282 236.576C601.455 237.037 605.08 237.959 608.706 239.342Z"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "url(#icons_chains_osmo_radialGradient_1)",
            d: "M372.594 691.101C512.504 691.101 625.924 575.729 625.924 433.41C625.924 291.091 512.504 175.719 372.594 175.719C232.685 175.719 119.265 291.091 119.265 433.41C119.265 575.729 232.685 691.101 372.594 691.101Z"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#A98698",
            d: "M640.427 175.721C605.985 138.842 576.982 129.161 542.087 121.325C514.896 114.871 522.146 99.1973 555.229 102.424C539.367 96.8924 524.412 95.5094 513.536 97.8143C491.783 102.424 485.439 136.076 490.877 148.984C493.143 154.055 498.128 161.43 504.925 169.728C492.69 178.026 482.266 184.019 473.656 188.629C477.735 190.472 482.72 192.777 488.611 196.004C504.019 204.302 520.787 218.132 520.787 218.132C495.409 196.004 500.847 185.863 535.742 160.969C546.618 153.133 566.558 154.055 585.139 163.735C603.719 173.416 625.472 197.848 625.472 197.848L604.626 238.415C605.985 238.876 607.345 239.337 608.704 239.798C621.847 243.486 632.27 242.564 640.427 239.337C649.944 233.344 674.869 213.061 640.427 175.721Z",
            opacity: ".6"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#5E12A0",
            d: "M541.631 143.45C550.695 147.138 562.478 153.592 576.979 163.273C594.2 174.797 609.155 187.705 618.672 197.847C602.811 219.052 592.388 248.094 586.043 268.377C589.215 272.987 592.841 277.597 596.013 282.207C599.185 270.682 604.624 253.626 611.875 236.569C613.687 237.03 615.953 237.03 618.219 237.03C623.657 237.03 630.002 236.108 634.987 231.96C638.612 229.194 642.691 224.123 642.238 214.903C642.238 206.144 635.44 195.081 621.391 181.712C611.421 172.031 597.826 161.429 584.23 151.748C545.257 125.472 518.066 118.096 505.83 130.543C497.672 138.84 498.579 148.982 501.298 156.358C486.796 166.039 474.56 172.953 466.403 177.563C471.841 179.407 476.826 181.712 482.264 184.017C496.766 176.18 517.613 162.812 541.631 143.45ZM627.283 209.371C628.642 211.676 629.095 213.981 629.095 215.364C629.095 219.513 627.736 220.896 626.83 221.818C625.017 223.201 621.391 224.123 618.219 224.123C620.938 218.591 624.11 213.981 627.283 209.371ZM515.347 140.684C516.706 139.301 520.332 138.379 526.223 139.301C521.691 142.989 517.159 146.216 512.628 149.443C512.174 146.216 512.627 142.989 515.347 140.684Z"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#5E12A0",
            d: "M372.596 160.503C224.405 160.503 104.311 282.664 104.311 433.406C104.311 584.149 224.405 706.31 372.596 706.31C520.786 706.31 640.88 584.149 640.88 433.406C640.88 282.664 520.333 160.503 372.596 160.503ZM372.596 691.098C232.562 691.098 119.266 575.851 119.266 433.406C119.266 290.962 232.562 175.715 372.596 175.715C512.629 175.715 625.925 290.962 625.925 433.406C625.925 575.851 512.176 691.098 372.596 691.098Z"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "url(#icons_chains_osmo_linearGradient_0)",
            d: "M372.594 691.101C512.504 691.101 625.924 575.729 625.924 433.41C625.924 291.091 512.504 175.719 372.594 175.719C232.685 175.719 119.265 291.091 119.265 433.41C119.265 575.729 232.685 691.101 372.594 691.101Z",
            opacity: ".6"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#A98698",
            d: "M370.783 659.75C232.562 637.161 138.754 504.858 161.413 364.258C171.383 302.025 202.199 249.011 245.705 210.75C182.259 248.089 135.128 313.088 122.439 392.378C100.233 532.978 194.042 665.281 331.809 687.87C408.851 700.777 483.173 676.345 538.008 628.403C489.517 656.984 430.603 669.43 370.783 659.75Z",
            opacity: ".6"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "url(#icons_chains_osmo_linearGradient_1)",
            d: "M412.93 179.411C349.031 168.808 286.945 183.56 236.189 216.29C235.282 217.212 234.376 218.133 234.376 218.133C253.863 206.148 282.413 195.545 282.413 195.545C208.998 238.878 186.339 288.203 186.339 288.203C214.889 231.963 298.728 192.318 364.439 189.552C430.151 186.786 473.203 206.609 525.772 249.481C578.342 292.813 610.064 381.322 606.892 451.392C604.173 521.462 567.918 578.163 567.918 578.163C592.844 545.433 607.799 521.462 617.315 497.03C619.128 489.654 620.941 482.278 621.847 474.441C644.506 334.302 551.151 201.999 412.93 179.411Z",
            opacity: ".6"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "url(#icons_chains_osmo_linearGradient_2)",
            d: "M613.235 431.104C613.235 566.173 505.377 675.887 372.595 675.887C239.812 675.887 131.501 566.173 131.501 431.104H613.235Z"
          }
        ),
        /* @__PURE__ */ D("g", { opacity: ".6", children: /* @__PURE__ */ D(
          "path",
          {
            fill: "url(#icons_chains_osmo_linearGradient_3)",
            d: "M594.201 431.104C594.201 562.946 491.781 670.817 363.077 675.887C366.25 675.887 369.422 675.887 372.594 675.887C505.377 675.887 613.234 566.173 613.234 431.104H594.201Z",
            opacity: ".6"
          }
        ) }),
        /* @__PURE__ */ D("g", { opacity: ".7", children: /* @__PURE__ */ D(
          "path",
          {
            fill: "url(#icons_chains_osmo_linearGradient_4)",
            d: "M165.49 431.104H131.501C131.501 566.173 239.359 675.887 372.142 675.887C378.033 675.887 383.471 675.887 388.909 675.426C264.284 666.207 165.49 560.18 165.49 431.104Z",
            opacity: ".7"
          }
        ) }),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "url(#icons_chains_osmo_linearGradient_5)",
            d: "M612.781 433.407C612.781 405.287 564.744 389.153 500.845 383.621C454.621 379.933 407.943 384.543 354.467 401.138C308.243 414.968 266.55 412.663 236.187 408.975C168.662 401.138 131.501 400.216 131.501 433.407C131.501 481.35 227.576 541.278 371.688 520.533C444.651 509.931 482.265 488.264 525.317 473.513C571.995 457.839 612.781 458.3 612.781 433.407Z"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M451.448 317.236C473.974 317.236 492.234 298.661 492.234 275.747C492.234 252.833 473.974 234.258 451.448 234.258C428.922 234.258 410.661 252.833 410.661 275.747C410.661 298.661 428.922 317.236 451.448 317.236Z"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M518.067 348.13C527.578 348.13 535.288 340.287 535.288 330.612C535.288 320.938 527.578 313.095 518.067 313.095C508.556 313.095 500.846 320.938 500.846 330.612C500.846 340.287 508.556 348.13 518.067 348.13Z"
          }
        ),
        /* @__PURE__ */ D("g", { opacity: ".6", children: /* @__PURE__ */ D(
          "path",
          {
            fill: "url(#icons_chains_osmo_linearGradient_6)",
            d: "M579.703 242.563C579.25 242.563 578.796 242.563 578.796 242.563C576.077 242.102 574.265 239.336 574.718 236.109C578.796 214.904 596.017 194.62 596.924 193.698C598.736 191.393 602.362 191.393 604.175 193.237C606.441 195.081 606.44 198.769 604.628 200.613C604.175 201.074 588.313 219.975 584.688 238.414C584.235 241.18 581.969 242.563 579.703 242.563Z",
            opacity: ".6"
          }
        ) }),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M355.905 625.64C362.913 625.64 368.594 619.861 368.594 612.732C368.594 605.604 362.913 599.825 355.905 599.825C348.897 599.825 343.216 605.604 343.216 612.732C343.216 619.861 348.897 625.64 355.905 625.64Z",
            opacity: ".2"
          }
        ),
        /* @__PURE__ */ D("g", { opacity: ".4", children: /* @__PURE__ */ D(
          "path",
          {
            fill: "url(#icons_chains_osmo_linearGradient_7)",
            d: "M348.577 621.135C343.592 616.065 343.592 607.767 348.577 602.696C349.484 601.774 350.39 601.313 351.296 600.391C349.484 600.852 348.124 601.774 346.765 603.157C341.78 608.228 341.78 616.526 346.765 621.596C350.843 625.745 357.188 626.667 362.173 623.901C357.641 625.745 352.203 624.823 348.577 621.135Z",
            opacity: ".6"
          }
        ) }),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M360.361 609.042C361.863 609.042 363.08 607.804 363.08 606.276C363.08 604.749 361.863 603.51 360.361 603.51C358.859 603.51 357.642 604.749 357.642 606.276C357.642 607.804 358.859 609.042 360.361 609.042Z",
            opacity: ".3"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M422.07 619.19C429.078 619.19 434.759 613.411 434.759 606.282C434.759 599.153 429.078 593.375 422.07 593.375C415.062 593.375 409.381 599.153 409.381 606.282C409.381 613.411 415.062 619.19 422.07 619.19Z",
            opacity: ".2"
          }
        ),
        /* @__PURE__ */ D("g", { opacity: ".4", children: /* @__PURE__ */ D(
          "path",
          {
            fill: "url(#icons_chains_osmo_linearGradient_8)",
            d: "M414.742 614.685C409.757 609.614 409.757 601.317 414.742 596.246C415.648 595.324 416.555 594.863 417.461 593.941C415.648 594.402 414.289 595.324 412.929 596.707C407.944 601.778 407.944 610.075 412.929 615.146C417.008 619.295 423.352 620.217 428.337 617.451C423.806 619.295 418.367 618.373 414.742 614.685Z",
            opacity: ".6"
          }
        ) }),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M426.526 602.592C428.027 602.592 429.245 601.354 429.245 599.826C429.245 598.298 428.027 597.06 426.526 597.06C425.024 597.06 423.806 598.298 423.806 599.826C423.806 601.354 425.024 602.592 426.526 602.592Z",
            opacity: ".3"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M389.361 649.153C394.617 649.153 398.878 644.819 398.878 639.472C398.878 634.126 394.617 629.792 389.361 629.792C384.105 629.792 379.845 634.126 379.845 639.472C379.845 644.819 384.105 649.153 389.361 649.153Z",
            opacity: ".2"
          }
        ),
        /* @__PURE__ */ D("g", { opacity: ".4", children: /* @__PURE__ */ D(
          "path",
          {
            fill: "url(#icons_chains_osmo_linearGradient_9)",
            d: "M383.923 645.57C380.298 641.882 380.298 635.429 383.923 631.741C384.376 631.28 385.283 630.819 385.736 630.358C384.376 630.819 383.47 631.741 382.564 632.663C378.938 636.351 378.938 642.805 382.564 646.492C385.736 649.719 390.268 650.18 394.346 647.875C390.721 649.258 386.642 648.336 383.923 645.57Z",
            opacity: ".6"
          }
        ) }),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M392.532 636.243C393.534 636.243 394.345 635.418 394.345 634.4C394.345 633.381 393.534 632.556 392.532 632.556C391.531 632.556 390.72 633.381 390.72 634.4C390.72 635.418 391.531 636.243 392.532 636.243Z",
            opacity: ".3"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M447.825 642.238C453.081 642.238 457.342 637.904 457.342 632.558C457.342 627.211 453.081 622.877 447.825 622.877C442.569 622.877 438.308 627.211 438.308 632.558C438.308 637.904 442.569 642.238 447.825 642.238Z",
            opacity: ".2"
          }
        ),
        /* @__PURE__ */ D("g", { opacity: ".4", children: /* @__PURE__ */ D(
          "path",
          {
            fill: "url(#icons_chains_osmo_linearGradient_10)",
            d: "M442.387 638.656C438.761 634.968 438.761 628.514 442.387 624.826C442.84 624.365 443.746 623.904 444.199 623.443C442.84 623.904 441.934 624.826 441.027 625.748C437.402 629.436 437.402 635.89 441.027 639.578C444.199 642.805 448.731 643.266 452.81 640.961C449.184 642.344 445.106 641.422 442.387 638.656Z",
            opacity: ".6"
          }
        ) }),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M450.996 629.338C451.997 629.338 452.809 628.512 452.809 627.494C452.809 626.475 451.997 625.65 450.996 625.65C449.995 625.65 449.183 626.475 449.183 627.494C449.183 628.512 449.995 629.338 450.996 629.338Z",
            opacity: ".3"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M301.896 621.034C313.41 621.034 322.743 611.54 322.743 599.829C322.743 588.118 313.41 578.624 301.896 578.624C290.383 578.624 281.05 588.118 281.05 599.829C281.05 611.54 290.383 621.034 301.896 621.034Z",
            opacity: ".2"
          }
        ),
        /* @__PURE__ */ D("g", { opacity: ".4", children: /* @__PURE__ */ D(
          "path",
          {
            fill: "url(#icons_chains_osmo_linearGradient_11)",
            d: "M290.128 613.192C281.971 604.895 281.971 591.526 290.128 583.228C291.488 581.845 292.847 580.923 294.66 580.001C291.941 580.923 289.675 582.767 287.409 584.611C279.252 592.909 279.252 606.278 287.409 614.575C294.207 621.49 304.63 622.873 312.787 617.802C305.083 621.029 296.019 619.646 290.128 613.192Z",
            opacity: ".6"
          }
        ) }),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M309.15 593.372C311.653 593.372 313.682 591.308 313.682 588.762C313.682 586.216 311.653 584.152 309.15 584.152C306.647 584.152 304.618 586.216 304.618 588.762C304.618 591.308 306.647 593.372 309.15 593.372Z",
            opacity: ".3"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M488.23 568.936C499.743 568.936 509.076 559.442 509.076 547.731C509.076 536.019 499.743 526.525 488.23 526.525C476.717 526.525 467.383 536.019 467.383 547.731C467.383 559.442 476.717 568.936 488.23 568.936Z",
            opacity: ".2"
          }
        ),
        /* @__PURE__ */ D("g", { opacity: ".4", children: /* @__PURE__ */ D(
          "path",
          {
            fill: "url(#icons_chains_osmo_linearGradient_12)",
            d: "M475.92 561.103C467.763 552.805 467.763 539.436 475.92 531.139C477.28 529.756 478.639 528.834 480.452 527.912C477.733 528.834 475.467 530.678 473.201 532.521C465.044 540.819 465.044 554.188 473.201 562.486C479.999 569.4 490.422 570.783 498.579 565.713C490.875 568.939 482.265 567.556 475.92 561.103Z",
            opacity: ".6"
          }
        ) }),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#fff",
            d: "M495.407 541.282C497.91 541.282 499.939 539.218 499.939 536.672C499.939 534.126 497.91 532.062 495.407 532.062C492.904 532.062 490.875 534.126 490.875 536.672C490.875 539.218 492.904 541.282 495.407 541.282Z",
            opacity: ".3"
          }
        )
      ] })
    }
  );
}
function e_() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "144",
      height: "144",
      viewBox: "0 0 144 144",
      style: { maxHeight: "100%", maxWidth: "100%" },
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D(
          "path",
          {
            d: "M71.85 143.7C111.532 143.7 143.7 111.532 143.7 71.85C143.7 32.1683 111.532 0 71.85 0C32.1683 0 0 32.1683 0 71.85C0 111.532 32.1683 143.7 71.85 143.7Z",
            fill: "#1D2229"
          }
        ),
        /* @__PURE__ */ D("path", { d: "M59.5621 65.1122H47.531V77.1433H59.5621V65.1122Z", fill: "white" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M47.5309 53.081H35.4997V65.1121L47.531 65.1122L47.5309 53.081Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M35.4978 65.1122H23.4667V77.1433H35.4978V65.1122Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M47.531 77.1433L35.4997 77.1427V89.1738H47.5309L47.531 77.1433Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M115.922 55.6723C115.074 46.824 107.437 43.8538 97.791 43.0056V37.3377H90.3225V42.6822C88.3601 42.6822 86.3535 42.7198 84.3579 42.7575V37.3333H76.8938V42.9989C75.2769 43.0299 65.3433 43.0211 65.3433 43.0211L65.3211 49.6058L71.5538 49.6413V92.7977H65.3233L65.268 99.2895C67.0775 99.2895 75.1308 99.3249 76.8761 99.336V104.931H84.3401V99.4689C86.3867 99.5132 88.3712 99.5309 90.307 99.5287V104.933H97.7777V99.3626C110.338 98.6472 119.133 95.4866 120.225 83.6947C121.111 74.1974 116.646 69.9626 109.516 68.2394C113.849 66.0246 116.558 62.1463 115.926 55.6701L115.922 55.6723ZM105.457 82.2129C105.457 91.491 89.5739 90.4301 84.5063 90.4323V73.9847C89.5716 73.9847 105.448 72.5384 105.45 82.2129H105.457ZM101.99 59.0057C101.99 67.4465 88.7366 66.4565 84.5173 66.4565V51.5372C88.7433 51.5394 101.995 50.2016 101.99 59.0057Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function t_() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "512",
      height: "512",
      viewBox: "0 0 512 512",
      style: { maxHeight: "100%", maxWidth: "100%" },
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { width: "512", height: "512", rx: "256", fill: "#00A3FF" }),
        /* @__PURE__ */ D(
          "path",
          {
            opacity: "0.6",
            d: "M361.012 237.812L363.878 242.209C396.204 291.798 388.984 356.742 346.52 398.348C321.539 422.826 288.798 435.066 256.056 435.069C256.056 435.069 256.056 435.069 361.012 237.812Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            opacity: "0.2",
            d: "M256.044 297.764L361 237.812C256.045 435.069 256.044 435.069 256.044 435.069C256.044 392.108 256.044 342.88 256.044 297.764Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M150.988 237.812L148.122 242.209C115.796 291.798 123.016 356.742 165.48 398.348C190.461 422.826 223.202 435.066 255.944 435.069C255.944 435.069 255.944 435.069 150.988 237.812Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            opacity: "0.6",
            d: "M255.914 297.764L150.958 237.812C255.914 435.069 255.914 435.069 255.914 435.069C255.914 392.108 255.914 342.88 255.914 297.764Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            opacity: "0.2",
            d: "M256.083 163.833V267.233L346.491 215.566L256.083 163.833Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            opacity: "0.6",
            d: "M256.056 163.833L165.583 215.565L256.056 267.233V163.833Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M256.056 76.875L165.583 215.599L256.056 163.722V76.875Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            opacity: "0.6",
            d: "M256.083 163.706L346.56 215.585L256.083 76.7916V163.706Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function r_() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "156",
      height: "156",
      viewBox: "0 0 156 156",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("circle", { cx: "77.5713", cy: "77.5713", r: "77.5713", fill: "#ED4E33" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M63.5871 41.5434C42.4254 49.6802 40.4869 70.5184 34.419 80.2503C28.2792 90.0978 14.2132 95.5313 16.1367 100.55C18.0601 105.568 32.1429 100.178 43.2844 103.38C54.2939 106.544 69.655 120.732 90.8167 112.595C101.597 108.45 109.403 99.9185 112.993 89.8133C113.379 88.7286 112.657 87.5686 111.512 87.4614C110.8 87.3945 110.117 87.7678 109.796 88.4072C106.549 94.8851 100.979 100.22 93.6894 103.022C81.6555 107.649 68.4886 104.016 60.4019 94.9052C58.5653 92.8363 56.9944 90.4811 55.7544 87.8782C55.4135 87.1618 55.0893 86.4337 54.8019 85.6804C54.5128 84.9272 54.2671 84.1689 54.0415 83.4073C60.4019 80.4378 67.7415 77.2926 76.0622 74.0938C84.2207 70.9569 91.6456 68.4126 98.2566 66.3772C102.729 65.0012 106.828 63.8563 110.529 62.9206C110.797 62.8536 111.061 62.7867 111.323 62.7214C111.883 62.5825 112.458 62.8821 112.665 63.4211L112.669 63.4311C112.791 63.7508 112.896 64.0722 113.009 64.3936C113.741 66.4676 114.29 68.5633 114.652 70.664C114.811 71.583 115.814 72.0835 116.636 71.6416C119.674 70.0078 122.453 68.4143 124.936 66.881C134.19 61.1731 139.32 56.3322 138.267 53.5887C137.216 50.8435 130.17 50.6862 119.48 52.6446C116.083 53.2673 112.316 54.1042 108.257 55.1404C107.555 55.3195 106.845 55.5053 106.126 55.6961C102.71 56.6034 99.1072 57.6428 95.3555 58.8062C88.3785 60.9705 80.8934 63.5634 73.1661 66.5345C65.9367 69.3148 59.085 72.1973 52.8015 75.0697C52.7247 62.8788 60.0827 51.354 72.1166 46.7274C79.4045 43.9253 87.1084 44.1547 93.8498 46.7944C94.5149 47.0555 95.272 46.8747 95.7583 46.3475C96.537 45.5021 96.298 44.1563 95.287 43.6073C85.8684 38.507 74.3676 37.3989 63.5871 41.5434Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function n_() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      xmlns: "http://www.w3.org/2000/svg",
      width: "800",
      height: "800",
      fill: "none",
      viewBox: "0 0 800 800",
      children: [
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#2E3148",
            fillRule: "evenodd",
            d: "M400.012 0.768066C620.509 0.768066 799.257 179.501 799.257 399.98C799.257 620.458 620.509 799.192 400.012 799.192C179.516 799.192 0.767944 620.458 0.767944 399.98C0.767944 179.501 179.516 0.768066 400.012 0.768066Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#1B1E36",
            fillRule: "evenodd",
            d: "M399.226 169.68C526.431 169.68 629.552 272.801 629.552 400.007C629.552 527.212 526.431 630.333 399.226 630.333C272.02 630.333 168.899 527.212 168.899 400.007C168.899 272.801 272.02 169.68 399.226 169.68Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fillRule: "evenodd",
            stroke: "#6F7390",
            strokeWidth: "15",
            d: "M401.181 58.2666C394.32 58.2666 386.121 65.8115 377.843 81.5569C368.982 98.411 360.796 123.281 353.849 154.523C339.501 219.047 331.271 306.552 331.271 399.977C331.271 493.402 339.501 580.908 353.849 645.431C360.796 676.673 368.982 701.543 377.843 718.397C386.121 734.143 394.32 741.688 401.181 741.688C408.042 741.688 416.241 734.143 424.519 718.397C433.38 701.543 441.566 676.673 448.513 645.431C462.862 580.908 471.092 493.402 471.092 399.977C471.092 306.552 462.862 219.047 448.513 154.523C441.566 123.281 433.38 98.411 424.519 81.5569C416.241 65.8115 408.042 58.2666 401.181 58.2666Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fillRule: "evenodd",
            stroke: "#6F7390",
            strokeWidth: "15",
            d: "M697.298 229.144C693.869 223.208 683.229 219.884 665.444 220.592C646.407 221.351 620.761 226.702 590.213 236.311C527.123 256.157 447.177 292.789 366.216 339.504C285.255 386.219 213.538 437.098 164.797 481.78C141.196 503.415 123.737 522.936 113.562 539.033C104.057 554.069 101.618 564.935 105.046 570.868C108.475 576.804 119.115 580.129 136.9 579.42C155.937 578.662 181.583 573.311 212.131 563.701C275.221 543.856 355.167 507.224 436.129 460.508C517.09 413.793 588.806 362.915 637.547 318.233C661.148 296.598 678.607 277.077 688.783 260.98C698.287 245.944 700.726 235.078 697.298 229.144V229.144ZM697.298 229.144C697.298 229.144 697.298 229.144 697.298 229.144L697.298 229.144C697.298 229.144 697.298 229.144 697.298 229.144V229.144Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fillRule: "evenodd",
            stroke: "#6F7390",
            strokeWidth: "15",
            d: "M697.298 570.868L697.298 570.868C700.726 564.935 698.288 554.069 688.783 539.033C678.607 522.936 661.148 503.415 637.548 481.78C588.806 437.098 517.09 386.219 436.129 339.504C355.167 292.789 275.221 256.157 212.131 236.311C181.583 226.702 155.937 221.351 136.9 220.592C119.115 219.884 108.475 223.208 105.046 229.144C101.618 235.078 104.057 245.944 113.562 260.98C123.737 277.077 141.196 296.598 164.797 318.233C213.538 362.915 285.255 413.793 366.216 460.508C447.177 507.224 527.123 543.856 590.213 563.701C620.761 573.311 646.407 578.662 665.444 579.42C683.229 580.129 693.869 576.804 697.298 570.868Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#B7B9C8",
            fillRule: "evenodd",
            d: "M177.765 302.102C191.34 302.102 202.345 313.112 202.345 326.694C202.345 340.276 191.34 351.286 177.765 351.286C164.189 351.286 153.185 340.276 153.185 326.694C153.185 313.112 164.189 302.102 177.765 302.102Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#B7B9C8",
            fillRule: "evenodd",
            d: "M568.451 217.905C582.033 217.905 593.043 228.915 593.043 242.497C593.043 256.079 582.033 267.089 568.451 267.089C554.869 267.089 543.859 256.079 543.859 242.497C543.859 228.915 554.869 217.905 568.451 217.905Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#B7B9C8",
            fillRule: "evenodd",
            d: "M351.649 603.909C365.231 603.909 376.241 614.914 376.241 628.489C376.241 642.064 365.231 653.069 351.649 653.069C338.067 653.069 327.057 642.064 327.057 628.489C327.057 614.914 338.067 603.909 351.649 603.909Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#B7B9C8",
            fillRule: "evenodd",
            d: "M399.811 358.173C422.806 358.173 441.447 376.814 441.447 399.809C441.447 422.803 422.806 441.444 399.811 441.444C376.817 441.444 358.176 422.803 358.176 399.809C358.176 376.814 376.817 358.173 399.811 358.173Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
function i_() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "100px",
      height: "100px",
      viewBox: "0 0 100 100",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("title", { children: "kuji" }),
        /* @__PURE__ */ ne("g", { id: "kuji", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: [
          /* @__PURE__ */ D("circle", { id: "Oval", fill: "#22242F", cx: "50", cy: "50", r: "50" }),
          /* @__PURE__ */ D(
            "path",
            {
              d: "M50,2 C76.509668,2 98,23.490332 98,50 C98,76.509668 76.509668,98 50,98 C23.490332,98 2,76.509668 2,50 C2,23.490332 23.490332,2 50,2 Z M50,5.38823529 C25.3616027,5.38823529 5.38823529,25.3616027 5.38823529,50 C5.38823529,74.6383973 25.3616027,94.6117647 50,94.6117647 C74.6383973,94.6117647 94.6117647,74.6383973 94.6117647,50 C94.6117647,25.3616027 74.6383973,5.38823529 50,5.38823529 Z",
              id: "Oval",
              fill: "#E53935",
              fillRule: "nonzero"
            }
          ),
          /* @__PURE__ */ D(
            "path",
            {
              d: "M80.2507798,31.0832298 L80.2507798,26.7229814 L66.4391765,26.7229814 C65.6980661,23.9055901 64.9569557,21.4236025 64.1484716,19.1428571 L59.4996881,19.9478261 C60.3081722,21.9602484 61.1166563,24.2409938 61.8577667,26.7229814 L47.2376794,26.7229814 L47.2376794,31.0832298 L80.2507798,31.0832298 Z M44.8796007,63.4832298 L44.8796007,35.6447205 L38.0748596,35.6447205 C39.4897068,33.5652174 40.904554,31.0161491 42.3194011,27.9304348 L42.3194011,24.710559 L31.2027449,24.710559 C31.8091079,23.3689441 32.3480973,22.0273292 32.8870867,20.6186335 L28.5751716,19.2770186 C26.5539613,25.8509317 23.3873986,31.1503106 19.1428571,35.242236 L20.1534623,40.0049689 C21.02932,39.2 21.9051778,38.3950311 22.7136619,37.5229814 L22.7136619,63.4832298 L44.8796007,63.4832298 Z M33.4260761,35.6447205 L24.3980037,35.6447205 C26.1497193,33.4981366 27.8340611,31.0832298 29.316282,28.5341615 L37.8053649,28.5341615 C36.3231441,31.2173913 34.9082969,33.6322981 33.4260761,35.6447205 Z M61.1840299,80.8571429 C64.5527137,80.8571429 66.3044292,78.978882 66.3044292,75.289441 L66.3044292,56.1714286 L77.0168434,56.1714286 L77.0168434,37.1204969 L50.8084841,37.1204969 L50.8084841,56.1714286 L61.588272,56.1714286 L61.588272,74.1490683 C61.588272,75.826087 60.9145352,76.6981366 59.5670618,76.6981366 C58.0174672,76.6981366 56.4004991,76.5639752 54.7835309,76.3627329 L55.7267623,80.8571429 L61.1840299,80.8571429 Z M31.8764816,47.5850932 L26.8908297,47.5850932 L26.8908297,39.6024845 L31.8764816,39.6024845 L31.8764816,47.5850932 Z M40.7024329,47.5850932 L35.7841547,47.5850932 L35.7841547,39.6024845 L40.7024329,39.6024845 L40.7024329,47.5850932 Z M72.4354336,51.9453416 L55.3898939,51.9453416 L55.3898939,41.4136646 L72.4354336,41.4136646 L72.4354336,51.9453416 Z M40.7024329,59.4583851 L35.7841547,59.4583851 L35.7841547,51.4757764 L40.7024329,51.4757764 L40.7024329,59.4583851 Z M31.8764816,59.4583851 L26.8908297,59.4583851 L26.8908297,51.4757764 L31.8764816,51.4757764 L31.8764816,59.4583851 Z M77.2863381,77.7714286 L80.8571429,75.289441 C79.0380536,70.9962733 76.477854,66.0322981 73.1091703,60.3304348 L69.5383656,62.4770186 C72.7723019,68.0447205 75.3998752,73.1428571 77.2863381,77.7714286 Z M49.0567686,78.9118012 C52.0212102,74.2832298 54.5814099,68.7826087 56.7373674,62.4770186 L52.8296943,60.5987578 C50.7411104,66.6360248 48.2482845,71.868323 45.4185901,76.2956522 L49.0567686,78.9118012 Z M43.4647536,74.3503106 L46.7660636,73.5453416 C45.8228322,70.3254658 44.8796007,67.5080745 43.801622,65.0931677 L40.6350593,66.0322981 C41.7130381,68.715528 42.6562695,71.4658385 43.4647536,74.3503106 Z M36.3231441,78.2409938 L39.8265752,77.8385093 C39.4223331,72.7403727 38.6812227,68.715528 37.6032439,65.7639752 L34.2345602,66.1664596 C35.312539,68.9838509 35.9862757,73.0086957 36.3231441,78.2409938 Z M23.4547723,80.0521739 C24.8696195,76.0944099 25.7454772,71.6 26.1497193,66.5018634 L22.5115409,66.0322981 C22.1746725,70.8621118 21.231441,75.1552795 19.7492202,78.9118012 L23.4547723,80.0521739 Z M29.1141609,79.247205 L32.617592,78.8447205 C32.4828447,73.5453416 32.1459763,69.3192547 31.6743606,66.2335404 L28.4404242,66.6360248 C28.7772926,69.5875776 28.9794136,73.8136646 29.1141609,79.247205 Z",
              id: "鯨",
              fill: "#E53935",
              fillRule: "nonzero"
            }
          )
        ] })
      ]
    }
  );
}
function o_() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "72",
      height: "72",
      viewBox: "0 0 72 72",
      fill: "none",
      children: [
        /* @__PURE__ */ D(
          "path",
          {
            d: "M0 35.9864C0 16.2622 15.9896 0 35.7138 0V0C55.438 0 71.4276 16.2622 71.4276 35.9864V35.9864C71.4276 55.7106 55.438 71.9728 35.7138 71.9728V71.9728C15.9896 71.9728 0 55.7106 0 35.9864V35.9864Z",
            fill: "#040404"
          }
        ),
        /* @__PURE__ */ D("g", { clipPath: "url(#clip0_2310_14480)", children: /* @__PURE__ */ D(
          "path",
          {
            d: "M34.6646 25.2973C34.6646 23.701 35.9571 22.4006 37.5438 22.4006H42.6955V15.353H40.1196H37.5438C32.0857 15.353 27.6598 19.8059 27.6598 25.2973C27.6598 26.7302 27.963 28.0923 28.5052 29.3217C24.2661 31.1245 21.4514 34.9549 20.7959 39.8022C20.0302 45.1241 22.1497 50.865 26.7655 53.6385C30.885 56.2486 37.3262 56.076 40.8057 52.4551V54.8588H47.9759V28.1939H37.5467C35.9602 28.1939 34.6646 26.8936 34.6646 25.2973ZM40.965 35.2446V41.9377C40.965 45.6356 37.9848 48.6309 34.3124 48.6309C30.64 48.6309 27.6598 45.6325 27.6598 41.9377C27.6598 38.2429 30.64 35.2446 34.3124 35.2446H40.965Z",
            fill: "#BFF009"
          }
        ) })
      ]
    }
  );
}
function a_() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "1000",
      height: "1000",
      viewBox: "0 0 1000 1000",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D(
          "path",
          {
            d: "M1000 500C1000 776.142 776.142 1000 500 1000C223.858 1000 0 776.142 0 500C0 223.858 223.858 0 500 0C776.142 0 1000 223.858 1000 500Z",
            fill: "#E6DAFE"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M575.336 459.157C575.336 494.675 546.559 523.473 511.068 523.473V587.789C582.05 587.789 639.604 530.193 639.604 459.157C639.604 388.122 582.05 330.526 511.068 330.526C487.669 330.526 465.695 336.78 446.801 347.746C408.374 369.97 382.533 411.539 382.533 459.157V780.736L446.801 845.052V459.157C446.801 423.64 475.577 394.841 511.068 394.841C546.559 394.841 575.336 423.64 575.336 459.157Z",
            fill: "#242235"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M511.07 201.904C464.243 201.904 420.352 214.442 382.535 236.346C358.322 250.338 336.638 268.169 318.268 289.026C278.271 334.376 254 393.95 254 459.168V652.115L318.268 716.431V459.168C318.268 402.037 343.091 350.695 382.535 315.351C401.08 298.771 422.851 285.681 446.803 277.245C466.888 270.089 488.543 266.22 511.07 266.22C617.543 266.22 703.873 352.614 703.873 459.168C703.873 565.721 617.543 652.115 511.07 652.115V716.431C653.063 716.431 768.14 601.238 768.14 459.168C768.14 317.097 653.063 201.904 511.07 201.904Z",
            fill: "#242235"
          }
        )
      ]
    }
  );
}
function s_() {
  return /* @__PURE__ */ ne("svg", { viewBox: "100 100 400 400", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ D(
      "path",
      {
        d: `M148.497 169.135C150.981 166.013 153.613 163.009 156.245
    160.005C156.363 159.856 156.63 159.826 156.748 159.677C156.985 159.38 157.37
    159.201 157.606 158.903L157.843 158.606C159.678 156.91 161.63 155.064
    163.881 153.456C171.845 147.41 180.11 142.817 188.825 139.795C216.778
    129.981 247.894 136.029 272.295 159.065C306.366 191.002 303.315 242.451
    276.117 276.647C241.748 327.625 182.684 398.748 264.463 462.46C279.167
    473.916 290.075 483.361 336.392 496.746C306.1 502.326 278.012 500.59 246.748
    492.605C224.634 480.123 189.866 453.397 178.037 417.3C160.159 362.562
    209.513 280.732 233.365 249.216C266.113 205.599 213.124 158.382 174.112
    211.095C153.72 238.566 118.044 316.303 130.442 373.965C137.691 406.664
    147.353 430.499 185.663 463.241C178.559 459.049 171.66 454.294 164.968
    448.974C75.957 366.06 86.2838 237.859 148.497 169.135Z`,
        fill: "url(#icons_tokens_inj_linearGradient_0)"
      }
    ),
    /* @__PURE__ */ D(
      "path",
      {
        d: `M451.503 430.865C449.019
    433.987 446.387 436.991 443.755 439.995C443.637 440.144 443.37 440.174
    443.252 440.323C443.015 440.62 442.63 440.799 442.394 441.097L442.157
    441.394C440.322 443.09 438.37 444.936 436.119 446.544C428.155 452.59 419.89
    457.183 411.175 460.205C383.222 470.019 352.106 463.971 327.705
    440.935C293.634 408.998 296.685 357.549 323.883 323.353C358.252 272.375
    417.316 201.252 335.537 137.54C320.833 126.084 309.925 116.639 263.608
    103.254C293.9 97.6736 321.988 99.4095 353.251 107.395C375.366 119.877
    410.134 146.603 421.963 182.7C439.841 237.438 390.487 319.268 366.635
    350.784C333.887 394.401 386.876 441.618 425.888 388.905C446.28 361.434
    481.956 283.697 469.558 226.035C462.309 193.336 452.647 169.501 414.337
    136.759C421.441 140.951 428.34 145.706 435.032 151.026C524.043 233.94
    513.716 362.141 451.503 430.865Z`,
        fill: "url(#icons_tokens_inj_linearGradient_1)"
      }
    )
  ] });
}
function c_() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      viewBox: "316.829 225.555 66.146 48.89",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D(
          "g",
          {
            filter: "url(#icons_tokens_ntt_filter_0)",
            transform: "matrix(1, 0, 0, 1, 307.15521240234375, 224.00100708007812)",
            children: /* @__PURE__ */ D(
              "path",
              {
                d: "M42.3874 29.5938C40.2035 29.5938 38.433 27.8234 38.433 25.6394C38.433 23.4555 40.2035 21.6851 42.3874 21.6851C44.5714 21.6851 46.3418 23.4555 46.3418 25.6394C46.3418 27.8234 44.5714 29.5938 42.3874 29.5938Z",
                fill: "white"
              }
            )
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M 316.829 249.281 L 382.975 249.281 L 382.975 250.719 L 316.829 250.719 L 316.829 249.281 Z",
            fill: "url(#icons_tokens_ntt_linearGradient_0)"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M 349.903 273.007 C 362.609 273.007 372.91 262.707 372.91 250 C 372.91 237.293 362.609 226.993 349.903 226.993 C 337.196 226.993 326.896 237.293 326.896 250 C 326.896 262.707 337.196 273.007 349.903 273.007 Z M 349.903 274.445 C 363.404 274.445 374.348 263.501 374.348 250 C 374.348 236.499 363.404 225.555 349.903 225.555 C 336.402 225.555 325.458 236.499 325.458 250 C 325.458 263.501 336.402 274.445 349.903 274.445 Z",
            fill: "url(#icons_tokens_ntt_linearGradient_1)"
          }
        )
      ]
    }
  );
}
function l_() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      width: "444",
      height: "444",
      viewBox: "0 0 444 444",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("style", { children: ".st0{fill:#ffeeda}.st2{fill:#101010}" }),
        /* @__PURE__ */ D("path", { d: "M0 0h444v444H0z", className: "st0" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M333.4 262V110.6c-.2-12.7-10.3-22.9-23-22.9h-158c-34.1.5-61.5 28.4-61.5 62.6 0 11.5 3.1 21.4 7.8 30.1 4 7.2 10.3 14 16.5 19.1 1.8 1.4.9.8 6.3 4.1 7.4 4.5 15.9 6.8 15.9 6.8l-.1 90.6c.2 4.3.6 8.4 1.8 12.3 3.5 12.8 12.4 22.6 24.4 27.3 5 2 10.7 3.3 16.8 3.4l126.2.4c25.1 0 45.5-20.4 45.5-45.6.1-15-7.4-28.4-18.6-36.8z",
            className: "st0"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M336.5 299.9C336 316 322.7 329 306.4 329l-86.8-.3c6.9-8 11.1-18.4 11.1-29.8 0-17.8-10.6-30.1-10.6-30.1h86.4c16.6 0 30.1 13.5 30.1 30.1l-.1 1z",
            style: {
              fill: "#ebc28e"
            }
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M123.5 186.7c-10-9.5-17-21.7-17-36.3v-1.5c.8-24.8 21.2-44.8 46-45.5h158c4.1.2 7.4 3.1 7.4 7.3v133.7c3.6.6 5.4 1.1 8.9 2.4 2.8 1 6.6 3.2 6.6 3.2V110.7c-.2-12.7-10.3-22.9-23-22.9h-158c-34.1.5-61.5 28.4-61.5 62.6 0 19.9 9.1 36.9 23.9 48.8 1 .8 2 1.9 4.6 1.9 4.6 0 7.9-3.7 7.7-7.7 0-3.4-1.5-4.6-3.6-6.7z",
            className: "st2"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M306.4 253.2H182.5c-8.3.1-15 6.8-15 15.1v17.8c.2 8.2 7.2 15.2 15.6 15.2h9.2v-15.2H183v-17.4h5c15.7 0 27.2 14.5 27.2 30.1 0 13.8-12.6 31.4-33.6 30-18.6-1.2-28.7-17.8-28.7-30v-151c0-6.8-5.6-12.4-12.4-12.4h-12.4v15.5h9.2v148c-.5 30.1 21.4 45.2 44.3 45.2l124.9.4c25.1 0 45.5-20.4 45.5-45.6.1-25.2-20.4-45.7-45.6-45.7zm30.1 46.7C336 316 322.7 329 306.4 329l-86.8-.3c6.9-8 11.1-18.4 11.1-29.8 0-17.8-10.6-30.1-10.6-30.1h86.4c16.6 0 30.1 13.5 30.1 30.1l-.1 1zM273 153.7h-93.4v-15.5H273c4.2 0 7.7 3.4 7.7 7.7.1 4.3-3.3 7.8-7.7 7.8z",
            className: "st2"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M273 226.4h-93.4V211H273c4.2 0 7.7 3.4 7.7 7.7.1 4.2-3.3 7.7-7.7 7.7zm16.5-36.4H179.6v-15.5h109.8c4.2 0 7.7 3.4 7.7 7.7.2 4.3-3.3 7.8-7.6 7.8z",
            className: "st2"
          }
        )
      ]
    }
  );
}
function f_() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("circle", { cx: "18", cy: "18", r: "18", fill: "black" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M28.3266 11.8302L17.9483 11.8466C14.5118 11.8466 11.7258 14.6326 11.7258 18.069C11.7258 21.5055 14.5118 24.2915 17.9483 24.2915H27.9424",
            stroke: "white",
            strokeWidth: "2.18153",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M6.16479 18.069H30.138",
            stroke: "white",
            strokeWidth: "2.18153",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M18.069 6C24.7345 6 30.1379 11.4035 30.1379 18.069C30.1379 24.7345 24.7345 30.1379 18.069 30.1379C11.4035 30.1379 6 24.7345 6 18.069C6 11.4035 11.4035 6 18.069 6Z",
            stroke: "white",
            strokeWidth: "2.18153",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
          }
        )
      ]
    }
  );
}
function u_() {
  return /* @__PURE__ */ ne(
    "svg",
    {
      width: "64",
      height: "64",
      viewBox: "0 0 64 64",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("circle", { cx: "32", cy: "32", r: "32", fill: "#814625" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M30.8066 30.3796C30.7714 30.2733 30.7468 30.1643 30.7278 30.0542C30.7191 30.0032 30.7089 29.9524 30.6974 29.902C30.6723 29.7925 30.6444 29.6836 30.6143 29.5753V29.575C31.1133 28.8474 33.4988 25.0525 30.7842 22.6167C27.7714 19.9133 24.2512 23.4567 24.2512 23.4567L24.2621 23.4724C22.6799 23.0093 20.9643 22.955 19.2952 23.4565C19.295 23.4565 19.2949 23.4565 19.2949 23.4565C19.2743 23.4358 15.7659 19.9212 12.762 22.6167C9.75706 25.313 13.0019 29.6752 13.0188 29.698C13.0188 29.698 13.0188 29.6981 13.0188 29.6983C12.9843 29.8008 12.9564 29.9054 12.938 30.0117C12.6129 31.8784 10.3999 32.4545 10.3999 35.7061C10.3999 38.9576 12.715 41.6321 17.4404 41.6321H19.3794C19.3794 41.6321 19.3796 41.6321 19.3797 41.6321C19.3884 41.644 20.1867 42.7339 21.826 42.7327C23.3478 42.7316 24.3528 41.6414 24.3615 41.6321C24.3615 41.6321 24.3615 41.6321 24.3618 41.6321H26.2117C30.9371 41.6321 33.2522 39.0204 33.2522 35.7061C33.2522 32.6781 31.3331 31.9702 30.8068 30.3796H30.8066Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M53.3886 26.6644C53.3886 26.6644 53.74 23.5305 51.0687 22.8571V21.6002H48.9999V22.8257C46.182 23.4261 46.5451 26.6644 46.5451 26.6644V27.2017C46.5451 27.2017 46.1818 30.4407 49.0009 31.0405H49.0006V33.7308C46.0304 34.252 46.4057 37.5966 46.4057 37.5966V38.1339C46.4057 38.1339 46.0424 41.3722 48.8604 41.9725V43.1981H50.9292V41.9412C53.6007 41.2678 53.2491 38.1339 53.2491 38.1339C53.3659 38.1339 53.4606 38.0427 53.4606 37.9303V37.8003C53.4606 37.6878 53.3659 37.5966 53.2491 37.5966C53.2491 37.5966 53.5977 34.4899 50.9638 33.7984V31.0405H50.9327C53.7518 30.4407 53.3885 27.2017 53.3885 27.2017C53.5052 27.2017 53.5999 27.1105 53.5999 26.998V26.868C53.5999 26.7556 53.5052 26.6644 53.3885 26.6644H53.3886ZM51.7027 37.5966H51.5134C51.3967 37.5966 51.302 37.6878 51.302 37.8003V37.9303C51.302 38.0427 51.3967 38.1339 51.5134 38.1339H51.7027C51.7027 40.0779 51.0324 40.405 50.8069 40.4601C50.7698 40.4691 50.7338 40.4426 50.7338 40.4058V39.7862C50.7338 39.4436 50.5072 39.256 50.2806 39.1539C49.9941 39.0249 49.6605 39.0249 49.3741 39.1539C49.1475 39.256 48.9208 39.4436 48.9208 39.7862V40.4058C48.9208 40.4421 48.8855 40.4692 48.849 40.4603C48.6248 40.4062 47.952 40.0817 47.952 38.1339V37.5966C47.952 35.6526 48.6222 35.3255 48.8478 35.2705C48.8848 35.2615 48.9208 35.2879 48.9208 35.3247V35.9444C48.9208 36.2869 49.1475 36.4746 49.3741 36.5767C49.6605 36.7056 49.9941 36.7056 50.2806 36.5767C50.5072 36.4746 50.7338 36.2869 50.7338 35.9444V35.3247C50.7338 35.2885 50.7691 35.2613 50.8056 35.2702C51.0299 35.3243 51.7027 35.6489 51.7027 37.5966ZM51.6529 27.2017H51.8421C51.8421 29.1494 51.1694 29.4741 50.9451 29.5281C50.9086 29.537 50.8733 29.5098 50.8733 29.4736V28.8539C50.8733 28.5114 50.6467 28.3237 50.42 28.2216C50.1336 28.0927 49.8 28.0927 49.5135 28.2216C49.2869 28.3237 49.0603 28.5114 49.0603 28.8539V29.4736C49.0603 29.5104 49.0243 29.5368 48.9872 29.5278C48.7617 29.4728 48.0915 29.1457 48.0915 27.2017V26.6644C48.0915 24.7166 48.7642 24.3919 48.9885 24.3379C49.025 24.3291 49.0603 24.3564 49.0603 24.3925V25.0121C49.0603 25.3547 49.2869 25.5423 49.5135 25.6444C49.8 25.7734 50.1336 25.7734 50.42 25.6444C50.6467 25.5423 50.8733 25.3547 50.8733 25.0121V24.3925C50.8733 24.3557 50.9093 24.3292 50.9464 24.3382C51.1719 24.3933 51.8421 24.7204 51.8421 26.6644H51.6529C51.5361 26.6644 51.4414 26.7556 51.4414 26.868V26.998C51.4414 27.1105 51.5361 27.2017 51.6529 27.2017Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M43.036 32.1987C43.036 32.1987 43.4013 28.9416 40.5566 28.355V25.4288C43.3256 24.8038 42.9663 21.6002 42.9663 21.6002C42.9663 21.6002 41.4134 21.6002 41.4198 21.6002C41.4198 23.548 40.7471 23.8726 40.5228 23.9266C40.4863 23.9355 40.451 23.9082 40.451 23.8721V23.2524C40.451 22.9099 40.2244 22.7223 39.9977 22.6202C39.7113 22.4912 39.3777 22.4912 39.0912 22.6202C38.8646 22.7223 38.638 22.9099 38.638 23.2524V23.8721C38.638 23.9089 38.602 23.9354 38.5649 23.9264C38.3394 23.8713 37.6692 23.5442 37.6692 21.6002C37.6757 21.6002 36.1227 21.6002 36.1227 21.6002C36.1227 21.6002 35.7499 24.9246 38.6908 25.4611V28.351C35.8255 28.927 36.1924 32.1985 36.1924 32.1985V32.7358C36.1924 32.7358 35.8255 36.0074 38.6908 36.5834V39.339C35.7499 39.8756 36.1227 43.1998 36.1227 43.1998C36.1227 43.1998 37.6756 43.1998 37.6692 43.1998C37.6692 41.2521 38.3419 40.9274 38.5662 40.8734C38.6027 40.8645 38.638 40.8917 38.638 40.9279V41.5476C38.638 41.8901 38.8646 42.0778 39.0912 42.1799C39.3777 42.3088 39.7113 42.3088 39.9977 42.1799C40.2244 42.0778 40.451 41.8901 40.451 41.5476V40.9279C40.451 40.8911 40.487 40.8647 40.5241 40.8737C40.7496 40.9287 41.4198 41.2558 41.4198 43.1998C41.4133 43.1998 42.9663 43.1998 42.9663 43.1998C42.9663 43.1998 43.3256 39.9962 40.5566 39.3712V36.5794C43.4013 35.9927 43.036 32.7357 43.036 32.7357C43.1528 32.7357 43.2475 32.6445 43.2475 32.5321V32.402C43.2475 32.2896 43.1528 32.1984 43.036 32.1984V32.1987ZM41.3003 32.736H41.4895C41.4895 34.6837 40.8168 35.0084 40.5925 35.0624C40.556 35.0713 40.5207 35.0441 40.5207 35.0079V34.3882C40.5207 34.0457 40.2941 33.858 40.0675 33.7559C39.781 33.627 39.4474 33.627 39.161 33.7559C38.9343 33.858 38.7077 34.0457 38.7077 34.3882V35.0079C38.7077 35.0447 38.6717 35.0711 38.6346 35.0621C38.4091 35.007 37.7389 34.68 37.7389 32.736V32.1987C37.7389 30.2509 38.4116 29.9262 38.6359 29.8722C38.6724 29.8634 38.7077 29.8906 38.7077 29.9268V30.5464C38.7077 30.889 38.9343 31.0766 39.161 31.1787C39.4474 31.3077 39.781 31.3077 40.0675 31.1787C40.2941 31.0766 40.5207 30.889 40.5207 30.5464V29.9268C40.5207 29.89 40.5567 29.8635 40.5938 29.8725C40.8193 29.9276 41.4895 30.2547 41.4895 32.1987H41.3003C41.1836 32.1987 41.0889 32.2899 41.0889 32.4023V32.5323C41.0889 32.6448 41.1836 32.736 41.3003 32.736Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function d_() {
  return /* @__PURE__ */ D(
    "svg",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      xmlns: "http://www.w3.org/2000/svg",
      height: "64",
      width: "64",
      viewBox: "0 0 64 64",
      children: /* @__PURE__ */ ne("g", { transform: "translate(0.00630876,-0.00301984)", children: [
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#f7931a",
            d: "m63.033,39.744c-4.274,17.143-21.637,27.576-38.782,23.301-17.138-4.274-27.571-21.638-23.295-38.78,4.272-17.145,21.635-27.579,38.775-23.305,17.144,4.274,27.576,21.64,23.302,38.784z"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            fill: "#FFF",
            d: "m46.103,27.444c0.637-4.258-2.605-6.547-7.038-8.074l1.438-5.768-3.511-0.875-1.4,5.616c-0.923-0.23-1.871-0.447-2.813-0.662l1.41-5.653-3.509-0.875-1.439,5.766c-0.764-0.174-1.514-0.346-2.242-0.527l0.004-0.018-4.842-1.209-0.934,3.75s2.605,0.597,2.55,0.634c1.422,0.355,1.679,1.296,1.636,2.042l-1.638,6.571c0.098,0.025,0.225,0.061,0.365,0.117-0.117-0.029-0.242-0.061-0.371-0.092l-2.296,9.205c-0.174,0.432-0.615,1.08-1.609,0.834,0.035,0.051-2.552-0.637-2.552-0.637l-1.743,4.019,4.569,1.139c0.85,0.213,1.683,0.436,2.503,0.646l-1.453,5.834,3.507,0.875,1.439-5.772c0.958,0.26,1.888,0.5,2.798,0.726l-1.434,5.745,3.511,0.875,1.453-5.823c5.987,1.133,10.489,0.676,12.384-4.739,1.527-4.36-0.076-6.875-3.226-8.515,2.294-0.529,4.022-2.038,4.483-5.155zm-8.022,11.249c-1.085,4.36-8.426,2.003-10.806,1.412l1.928-7.729c2.38,0.594,10.012,1.77,8.878,6.317zm1.086-11.312c-0.99,3.966-7.1,1.951-9.082,1.457l1.748-7.01c1.982,0.494,8.365,1.416,7.334,5.553z"
          }
        )
      ] })
    }
  );
}
function h_() {
  return /* @__PURE__ */ D(
    "svg",
    {
      width: "41",
      height: "40",
      viewBox: "0 0 41 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ D(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 0.00291959V15.9042L5.6765 21.587V5.68569L21.4992 5.73875L15.8256 0.0530768L0.00302147 0L0 0.00291959ZM28.7868 12.7214V27.0783L23.1104 21.3956V7.03861L28.7868 12.7214ZM12.9607 28.5724H27.2944L21.6208 22.8867H7.28708L12.9607 28.5724ZM36.854 35.0866V20.8018L31.1777 15.1191V31.0204L15.3549 30.9674L21.0285 36.653L35.3373 36.7009L38.3549 39.7233L40.2871 40L39.9191 38.1568L36.854 35.0866",
          fill: "#282828"
        }
      )
    }
  );
}
const q6 = {
  [Ee.WBTC]: Ok(),
  [Ee.BUSD]: zk(),
  [Ee.USDT]: kk(),
  [Ee.DAI]: _k(),
  [Ee.GLMR]: Bk(),
  [Ee.AVAX]: Fk(),
  [Ee.BNB]: Rk(),
  [Ee.BSC]: $k(),
  [Ee.CELO]: Pk(),
  [Ee.ETH]: Uk(),
  [Ee.FANTOM]: Yk(),
  [Ee.POLYGON]: Gk(),
  [Ee.SOLANA]: Wk(),
  [Ee.USDC]: qk(),
  [Ee.SUI]: Zk(),
  [Ee.APT]: Hk(),
  [Ee.ARBITRUM]: Jk(),
  [Ee.OPTIMISM]: Xk(),
  [Ee.SEI]: Qk(),
  [Ee.BASE]: Vk(),
  [Ee.OSMO]: Kk(),
  [Ee.TBTC]: e_(),
  [Ee.WSTETH]: t_(),
  [Ee.ATOM]: n_(),
  [Ee.EVMOS]: r_(),
  [Ee.KUJI]: i_(),
  [Ee.PYTH]: a_(),
  [Ee.KLAY]: o_(),
  [Ee.INJ]: s_(),
  [Ee.NTT]: c_(),
  [Ee.SCROLL]: l_(),
  [Ee.XLAYER]: /* @__PURE__ */ D(
    "img",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      src: $6("Xlayer")
    }
  ),
  [Ee.MANTLE]: /* @__PURE__ */ D(
    "img",
    {
      style: { maxHeight: "100%", maxWidth: "100%" },
      src: $6("Mantle")
    }
  ),
  [Ee.WORLDCHAIN]: f_(),
  [Ee.BERA]: u_(),
  [Ee.BTC]: d_(),
  [Ee.SONIC]: D8(),
  [Ee.PLUME]: h_()
};
function p_(e) {
  return Object.values(Ee).includes(e);
}
function g_(e) {
  const t = er(), o = Ce(() => t.palette.text && t.palette.input ? {
    ...e.style,
    background: `color-mix(in hsl, ${t.palette.text.secondary}, ${t.palette.input.background} 80%)`
  } : e.style, [e.style, t.palette.input, t.palette.text]);
  return /* @__PURE__ */ D(ut, { sx: o });
}
function Js(e) {
  const t = Ce(
    () => ({
      container: {
        ...e.style || { width: "36px", height: "36px" },
        ...nl
      },
      iconImage: {
        ...e.style || { width: "36px", height: "36px" },
        borderRadius: "50px"
      }
    }),
    [e.style]
    // Recompute styles only when style prop changes
  );
  return p_(e.icon) && q6[e.icon] ? /* @__PURE__ */ D(ut, { sx: t.container, children: q6[e.icon] }) : typeof e.icon == "string" ? /* @__PURE__ */ D(ut, { sx: t.container, children: /* @__PURE__ */ D("img", { style: t.iconImage, src: e.icon, alt: "token icon" }) }) : /* @__PURE__ */ D(ut, { sx: t.container, children: /* @__PURE__ */ D(g_, { style: t.iconImage }) });
}
const ns = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
}, Bm = /* @__PURE__ */ Object.create(null);
for (const e in ns)
  Object.hasOwn(ns, e) && (Bm[ns[e]] = e);
const Ur = {
  to: {},
  get: {}
};
Ur.get = function(e) {
  const t = e.slice(0, 3).toLowerCase();
  let o, i;
  switch (t) {
    case "hsl": {
      o = Ur.get.hsl(e), i = "hsl";
      break;
    }
    case "hwb": {
      o = Ur.get.hwb(e), i = "hwb";
      break;
    }
    default: {
      o = Ur.get.rgb(e), i = "rgb";
      break;
    }
  }
  return o ? { model: i, value: o } : null;
};
Ur.get.rgb = function(e) {
  if (!e)
    return null;
  const t = /^#([a-f\d]{3,4})$/i, o = /^#([a-f\d]{6})([a-f\d]{2})?$/i, i = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|/]\s*([+-]?[\d.]+)(%?)\s*)?\)$/, c = /^rgba?\(\s*([+-]?[\d.]+)%\s*,?\s*([+-]?[\d.]+)%\s*,?\s*([+-]?[\d.]+)%\s*(?:[,|/]\s*([+-]?[\d.]+)(%?)\s*)?\)$/, n = /^(\w+)$/;
  let d = [0, 0, 0, 1], f, p, l;
  if (f = e.match(o)) {
    for (l = f[2], f = f[1], p = 0; p < 3; p++) {
      const h = p * 2;
      d[p] = Number.parseInt(f.slice(h, h + 2), 16);
    }
    l && (d[3] = Number.parseInt(l, 16) / 255);
  } else if (f = e.match(t)) {
    for (f = f[1], l = f[3], p = 0; p < 3; p++)
      d[p] = Number.parseInt(f[p] + f[p], 16);
    l && (d[3] = Number.parseInt(l + l, 16) / 255);
  } else if (f = e.match(i)) {
    for (p = 0; p < 3; p++)
      d[p] = Number.parseInt(f[p + 1], 10);
    f[4] && (d[3] = f[5] ? Number.parseFloat(f[4]) * 0.01 : Number.parseFloat(f[4]));
  } else if (f = e.match(c)) {
    for (p = 0; p < 3; p++)
      d[p] = Math.round(Number.parseFloat(f[p + 1]) * 2.55);
    f[4] && (d[3] = f[5] ? Number.parseFloat(f[4]) * 0.01 : Number.parseFloat(f[4]));
  } else return (f = e.match(n)) ? f[1] === "transparent" ? [0, 0, 0, 0] : Object.hasOwn(ns, f[1]) ? (d = ns[f[1]], d[3] = 1, d) : null : null;
  for (p = 0; p < 3; p++)
    d[p] = zi(d[p], 0, 255);
  return d[3] = zi(d[3], 0, 1), d;
};
Ur.get.hsl = function(e) {
  if (!e)
    return null;
  const t = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d.]+)%\s*,?\s*([+-]?[\d.]+)%\s*(?:[,|/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, o = e.match(t);
  if (o) {
    const i = Number.parseFloat(o[4]), c = (Number.parseFloat(o[1]) % 360 + 360) % 360, n = zi(Number.parseFloat(o[2]), 0, 100), d = zi(Number.parseFloat(o[3]), 0, 100), f = zi(Number.isNaN(i) ? 1 : i, 0, 1);
    return [c, n, d, f];
  }
  return null;
};
Ur.get.hwb = function(e) {
  if (!e)
    return null;
  const t = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d.]+)%\s*,\s*([+-]?[\d.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, o = e.match(t);
  if (o) {
    const i = Number.parseFloat(o[4]), c = (Number.parseFloat(o[1]) % 360 + 360) % 360, n = zi(Number.parseFloat(o[2]), 0, 100), d = zi(Number.parseFloat(o[3]), 0, 100), f = zi(Number.isNaN(i) ? 1 : i, 0, 1);
    return [c, n, d, f];
  }
  return null;
};
Ur.to.hex = function(...e) {
  return "#" + E0(e[0]) + E0(e[1]) + E0(e[2]) + (e[3] < 1 ? E0(Math.round(e[3] * 255)) : "");
};
Ur.to.rgb = function(...e) {
  return e.length < 4 || e[3] === 1 ? "rgb(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ")" : "rgba(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ", " + e[3] + ")";
};
Ur.to.rgb.percent = function(...e) {
  const t = Math.round(e[0] / 255 * 100), o = Math.round(e[1] / 255 * 100), i = Math.round(e[2] / 255 * 100);
  return e.length < 4 || e[3] === 1 ? "rgb(" + t + "%, " + o + "%, " + i + "%)" : "rgba(" + t + "%, " + o + "%, " + i + "%, " + e[3] + ")";
};
Ur.to.hsl = function(...e) {
  return e.length < 4 || e[3] === 1 ? "hsl(" + e[0] + ", " + e[1] + "%, " + e[2] + "%)" : "hsla(" + e[0] + ", " + e[1] + "%, " + e[2] + "%, " + e[3] + ")";
};
Ur.to.hwb = function(...e) {
  let t = "";
  return e.length >= 4 && e[3] !== 1 && (t = ", " + e[3]), "hwb(" + e[0] + ", " + e[1] + "%, " + e[2] + "%" + t + ")";
};
Ur.to.keyword = function(...e) {
  return Bm[e.slice(0, 3)];
};
function zi(e, t, o) {
  return Math.min(Math.max(t, e), o);
}
function E0(e) {
  const t = Math.round(e).toString(16).toUpperCase();
  return t.length < 2 ? "0" + t : t;
}
const xs = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
}, Fm = {};
for (const e of Object.keys(xs))
  Fm[xs[e]] = e;
const dt = {
  rgb: { channels: 3, labels: "rgb" },
  hsl: { channels: 3, labels: "hsl" },
  hsv: { channels: 3, labels: "hsv" },
  hwb: { channels: 3, labels: "hwb" },
  cmyk: { channels: 4, labels: "cmyk" },
  xyz: { channels: 3, labels: "xyz" },
  lab: { channels: 3, labels: "lab" },
  oklab: { channels: 3, labels: ["okl", "oka", "okb"] },
  lch: { channels: 3, labels: "lch" },
  oklch: { channels: 3, labels: ["okl", "okc", "okh"] },
  hex: { channels: 1, labels: ["hex"] },
  keyword: { channels: 1, labels: ["keyword"] },
  ansi16: { channels: 1, labels: ["ansi16"] },
  ansi256: { channels: 1, labels: ["ansi256"] },
  hcg: { channels: 3, labels: ["h", "c", "g"] },
  apple: { channels: 3, labels: ["r16", "g16", "b16"] },
  gray: { channels: 1, labels: ["gray"] }
}, vi = (6 / 29) ** 3;
function oa(e) {
  const t = e > 31308e-7 ? 1.055 * e ** 0.4166666666666667 - 0.055 : e * 12.92;
  return Math.min(Math.max(0, t), 1);
}
function aa(e) {
  return e > 0.04045 ? ((e + 0.055) / 1.055) ** 2.4 : e / 12.92;
}
for (const e of Object.keys(dt)) {
  if (!("channels" in dt[e]))
    throw new Error("missing channels property: " + e);
  if (!("labels" in dt[e]))
    throw new Error("missing channel labels property: " + e);
  if (dt[e].labels.length !== dt[e].channels)
    throw new Error("channel and label counts mismatch: " + e);
  const { channels: t, labels: o } = dt[e];
  delete dt[e].channels, delete dt[e].labels, Object.defineProperty(dt[e], "channels", { value: t }), Object.defineProperty(dt[e], "labels", { value: o });
}
dt.rgb.hsl = function(e) {
  const t = e[0] / 255, o = e[1] / 255, i = e[2] / 255, c = Math.min(t, o, i), n = Math.max(t, o, i), d = n - c;
  let f, p;
  switch (n) {
    case c: {
      f = 0;
      break;
    }
    case t: {
      f = (o - i) / d;
      break;
    }
    case o: {
      f = 2 + (i - t) / d;
      break;
    }
    case i: {
      f = 4 + (t - o) / d;
      break;
    }
  }
  f = Math.min(f * 60, 360), f < 0 && (f += 360);
  const l = (c + n) / 2;
  return n === c ? p = 0 : l <= 0.5 ? p = d / (n + c) : p = d / (2 - n - c), [f, p * 100, l * 100];
};
dt.rgb.hsv = function(e) {
  let t, o, i, c, n;
  const d = e[0] / 255, f = e[1] / 255, p = e[2] / 255, l = Math.max(d, f, p), h = l - Math.min(d, f, p), y = function(M) {
    return (l - M) / 6 / h + 1 / 2;
  };
  if (h === 0)
    c = 0, n = 0;
  else {
    switch (n = h / l, t = y(d), o = y(f), i = y(p), l) {
      case d: {
        c = i - o;
        break;
      }
      case f: {
        c = 1 / 3 + t - i;
        break;
      }
      case p: {
        c = 2 / 3 + o - t;
        break;
      }
    }
    c < 0 ? c += 1 : c > 1 && (c -= 1);
  }
  return [
    c * 360,
    n * 100,
    l * 100
  ];
};
dt.rgb.hwb = function(e) {
  const t = e[0], o = e[1];
  let i = e[2];
  const c = dt.rgb.hsl(e)[0], n = 1 / 255 * Math.min(t, Math.min(o, i));
  return i = 1 - 1 / 255 * Math.max(t, Math.max(o, i)), [c, n * 100, i * 100];
};
dt.rgb.oklab = function(e) {
  const t = aa(e[0] / 255), o = aa(e[1] / 255), i = aa(e[2] / 255), c = Math.cbrt(0.4122214708 * t + 0.5363325363 * o + 0.0514459929 * i), n = Math.cbrt(0.2119034982 * t + 0.6806995451 * o + 0.1073969566 * i), d = Math.cbrt(0.0883024619 * t + 0.2817188376 * o + 0.6299787005 * i), f = 0.2104542553 * c + 0.793617785 * n - 0.0040720468 * d, p = 1.9779984951 * c - 2.428592205 * n + 0.4505937099 * d, l = 0.0259040371 * c + 0.7827717662 * n - 0.808675766 * d;
  return [f * 100, p * 100, l * 100];
};
dt.rgb.cmyk = function(e) {
  const t = e[0] / 255, o = e[1] / 255, i = e[2] / 255, c = Math.min(1 - t, 1 - o, 1 - i), n = (1 - t - c) / (1 - c) || 0, d = (1 - o - c) / (1 - c) || 0, f = (1 - i - c) / (1 - c) || 0;
  return [n * 100, d * 100, f * 100, c * 100];
};
function y_(e, t) {
  return (e[0] - t[0]) ** 2 + (e[1] - t[1]) ** 2 + (e[2] - t[2]) ** 2;
}
dt.rgb.keyword = function(e) {
  const t = Fm[e];
  if (t)
    return t;
  let o = Number.POSITIVE_INFINITY, i;
  for (const c of Object.keys(xs)) {
    const n = xs[c], d = y_(e, n);
    d < o && (o = d, i = c);
  }
  return i;
};
dt.keyword.rgb = function(e) {
  return xs[e];
};
dt.rgb.xyz = function(e) {
  const t = aa(e[0] / 255), o = aa(e[1] / 255), i = aa(e[2] / 255), c = t * 0.4124564 + o * 0.3575761 + i * 0.1804375, n = t * 0.2126729 + o * 0.7151522 + i * 0.072175, d = t * 0.0193339 + o * 0.119192 + i * 0.9503041;
  return [c * 100, n * 100, d * 100];
};
dt.rgb.lab = function(e) {
  const t = dt.rgb.xyz(e);
  let o = t[0], i = t[1], c = t[2];
  o /= 95.047, i /= 100, c /= 108.883, o = o > vi ? o ** (1 / 3) : 7.787 * o + 16 / 116, i = i > vi ? i ** (1 / 3) : 7.787 * i + 16 / 116, c = c > vi ? c ** (1 / 3) : 7.787 * c + 16 / 116;
  const n = 116 * i - 16, d = 500 * (o - i), f = 200 * (i - c);
  return [n, d, f];
};
dt.hsl.rgb = function(e) {
  const t = e[0] / 360, o = e[1] / 100, i = e[2] / 100;
  let c, n;
  if (o === 0)
    return n = i * 255, [n, n, n];
  const d = i < 0.5 ? i * (1 + o) : i + o - i * o, f = 2 * i - d, p = [0, 0, 0];
  for (let l = 0; l < 3; l++)
    c = t + 1 / 3 * -(l - 1), c < 0 && c++, c > 1 && c--, 6 * c < 1 ? n = f + (d - f) * 6 * c : 2 * c < 1 ? n = d : 3 * c < 2 ? n = f + (d - f) * (2 / 3 - c) * 6 : n = f, p[l] = n * 255;
  return p;
};
dt.hsl.hsv = function(e) {
  const t = e[0];
  let o = e[1] / 100, i = e[2] / 100, c = o;
  const n = Math.max(i, 0.01);
  i *= 2, o *= i <= 1 ? i : 2 - i, c *= n <= 1 ? n : 2 - n;
  const d = (i + o) / 2, f = i === 0 ? 2 * c / (n + c) : 2 * o / (i + o);
  return [t, f * 100, d * 100];
};
dt.hsv.rgb = function(e) {
  const t = e[0] / 60, o = e[1] / 100;
  let i = e[2] / 100;
  const c = Math.floor(t) % 6, n = t - Math.floor(t), d = 255 * i * (1 - o), f = 255 * i * (1 - o * n), p = 255 * i * (1 - o * (1 - n));
  switch (i *= 255, c) {
    case 0:
      return [i, p, d];
    case 1:
      return [f, i, d];
    case 2:
      return [d, i, p];
    case 3:
      return [d, f, i];
    case 4:
      return [p, d, i];
    case 5:
      return [i, d, f];
  }
};
dt.hsv.hsl = function(e) {
  const t = e[0], o = e[1] / 100, i = e[2] / 100, c = Math.max(i, 0.01);
  let n, d;
  d = (2 - o) * i;
  const f = (2 - o) * c;
  return n = o * c, n /= f <= 1 ? f : 2 - f, n = n || 0, d /= 2, [t, n * 100, d * 100];
};
dt.hwb.rgb = function(e) {
  const t = e[0] / 360;
  let o = e[1] / 100, i = e[2] / 100;
  const c = o + i;
  let n;
  c > 1 && (o /= c, i /= c);
  const d = Math.floor(6 * t), f = 1 - i;
  n = 6 * t - d, d & 1 && (n = 1 - n);
  const p = o + n * (f - o);
  let l, h, y;
  switch (d) {
    default:
    case 6:
    case 0: {
      l = f, h = p, y = o;
      break;
    }
    case 1: {
      l = p, h = f, y = o;
      break;
    }
    case 2: {
      l = o, h = f, y = p;
      break;
    }
    case 3: {
      l = o, h = p, y = f;
      break;
    }
    case 4: {
      l = p, h = o, y = f;
      break;
    }
    case 5: {
      l = f, h = o, y = p;
      break;
    }
  }
  return [l * 255, h * 255, y * 255];
};
dt.cmyk.rgb = function(e) {
  const t = e[0] / 100, o = e[1] / 100, i = e[2] / 100, c = e[3] / 100, n = 1 - Math.min(1, t * (1 - c) + c), d = 1 - Math.min(1, o * (1 - c) + c), f = 1 - Math.min(1, i * (1 - c) + c);
  return [n * 255, d * 255, f * 255];
};
dt.xyz.rgb = function(e) {
  const t = e[0] / 100, o = e[1] / 100, i = e[2] / 100;
  let c, n, d;
  return c = t * 3.2404542 + o * -1.5371385 + i * -0.4985314, n = t * -0.969266 + o * 1.8760108 + i * 0.041556, d = t * 0.0556434 + o * -0.2040259 + i * 1.0572252, c = oa(c), n = oa(n), d = oa(d), [c * 255, n * 255, d * 255];
};
dt.xyz.lab = function(e) {
  let t = e[0], o = e[1], i = e[2];
  t /= 95.047, o /= 100, i /= 108.883, t = t > vi ? t ** (1 / 3) : 7.787 * t + 16 / 116, o = o > vi ? o ** (1 / 3) : 7.787 * o + 16 / 116, i = i > vi ? i ** (1 / 3) : 7.787 * i + 16 / 116;
  const c = 116 * o - 16, n = 500 * (t - o), d = 200 * (o - i);
  return [c, n, d];
};
dt.xyz.oklab = function(e) {
  const t = e[0] / 100, o = e[1] / 100, i = e[2] / 100, c = Math.cbrt(0.8189330101 * t + 0.3618667424 * o - 0.1288597137 * i), n = Math.cbrt(0.0329845436 * t + 0.9293118715 * o + 0.0361456387 * i), d = Math.cbrt(0.0482003018 * t + 0.2643662691 * o + 0.633851707 * i), f = 0.2104542553 * c + 0.793617785 * n - 0.0040720468 * d, p = 1.9779984951 * c - 2.428592205 * n + 0.4505937099 * d, l = 0.0259040371 * c + 0.7827717662 * n - 0.808675766 * d;
  return [f * 100, p * 100, l * 100];
};
dt.oklab.oklch = function(e) {
  return dt.lab.lch(e);
};
dt.oklab.xyz = function(e) {
  const t = e[0] / 100, o = e[1] / 100, i = e[2] / 100, c = (0.999999998 * t + 0.396337792 * o + 0.215803758 * i) ** 3, n = (1.000000008 * t - 0.105561342 * o - 0.063854175 * i) ** 3, d = (1.000000055 * t - 0.089484182 * o - 1.291485538 * i) ** 3, f = 1.227013851 * c - 0.55779998 * n + 0.281256149 * d, p = -0.040580178 * c + 1.11225687 * n - 0.071676679 * d, l = -0.076381285 * c - 0.421481978 * n + 1.58616322 * d;
  return [f * 100, p * 100, l * 100];
};
dt.oklab.rgb = function(e) {
  const t = e[0] / 100, o = e[1] / 100, i = e[2] / 100, c = (t + 0.3963377774 * o + 0.2158037573 * i) ** 3, n = (t - 0.1055613458 * o - 0.0638541728 * i) ** 3, d = (t - 0.0894841775 * o - 1.291485548 * i) ** 3, f = oa(4.0767416621 * c - 3.3077115913 * n + 0.2309699292 * d), p = oa(-1.2684380046 * c + 2.6097574011 * n - 0.3413193965 * d), l = oa(-0.0041960863 * c - 0.7034186147 * n + 1.707614701 * d);
  return [f * 255, p * 255, l * 255];
};
dt.oklch.oklab = function(e) {
  return dt.lch.lab(e);
};
dt.lab.xyz = function(e) {
  const t = e[0], o = e[1], i = e[2];
  let c, n, d;
  n = (t + 16) / 116, c = o / 500 + n, d = n - i / 200;
  const f = n ** 3, p = c ** 3, l = d ** 3;
  return n = f > vi ? f : (n - 16 / 116) / 7.787, c = p > vi ? p : (c - 16 / 116) / 7.787, d = l > vi ? l : (d - 16 / 116) / 7.787, c *= 95.047, n *= 100, d *= 108.883, [c, n, d];
};
dt.lab.lch = function(e) {
  const t = e[0], o = e[1], i = e[2];
  let c;
  c = Math.atan2(i, o) * 360 / 2 / Math.PI, c < 0 && (c += 360);
  const d = Math.sqrt(o * o + i * i);
  return [t, d, c];
};
dt.lch.lab = function(e) {
  const t = e[0], o = e[1], c = e[2] / 360 * 2 * Math.PI, n = o * Math.cos(c), d = o * Math.sin(c);
  return [t, n, d];
};
dt.rgb.ansi16 = function(e, t = null) {
  const [o, i, c] = e;
  let n = t === null ? dt.rgb.hsv(e)[2] : t;
  if (n = Math.round(n / 50), n === 0)
    return 30;
  let d = 30 + (Math.round(c / 255) << 2 | Math.round(i / 255) << 1 | Math.round(o / 255));
  return n === 2 && (d += 60), d;
};
dt.hsv.ansi16 = function(e) {
  return dt.rgb.ansi16(dt.hsv.rgb(e), e[2]);
};
dt.rgb.ansi256 = function(e) {
  const t = e[0], o = e[1], i = e[2];
  return t >> 4 === o >> 4 && o >> 4 === i >> 4 ? t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.round(o / 255 * 5) + Math.round(i / 255 * 5);
};
dt.ansi16.rgb = function(e) {
  e = e[0];
  let t = e % 10;
  if (t === 0 || t === 7)
    return e > 50 && (t += 3.5), t = t / 10.5 * 255, [t, t, t];
  const o = (Math.trunc(e > 50) + 1) * 0.5, i = (t & 1) * o * 255, c = (t >> 1 & 1) * o * 255, n = (t >> 2 & 1) * o * 255;
  return [i, c, n];
};
dt.ansi256.rgb = function(e) {
  if (e = e[0], e >= 232) {
    const n = (e - 232) * 10 + 8;
    return [n, n, n];
  }
  e -= 16;
  let t;
  const o = Math.floor(e / 36) / 5 * 255, i = Math.floor((t = e % 36) / 6) / 5 * 255, c = t % 6 / 5 * 255;
  return [o, i, c];
};
dt.rgb.hex = function(e) {
  const o = (((Math.round(e[0]) & 255) << 16) + ((Math.round(e[1]) & 255) << 8) + (Math.round(e[2]) & 255)).toString(16).toUpperCase();
  return "000000".slice(o.length) + o;
};
dt.hex.rgb = function(e) {
  const t = e.toString(16).match(/[a-f\d]{6}|[a-f\d]{3}/i);
  if (!t)
    return [0, 0, 0];
  let o = t[0];
  t[0].length === 3 && (o = [...o].map((f) => f + f).join(""));
  const i = Number.parseInt(o, 16), c = i >> 16 & 255, n = i >> 8 & 255, d = i & 255;
  return [c, n, d];
};
dt.rgb.hcg = function(e) {
  const t = e[0] / 255, o = e[1] / 255, i = e[2] / 255, c = Math.max(Math.max(t, o), i), n = Math.min(Math.min(t, o), i), d = c - n;
  let f;
  const p = d < 1 ? n / (1 - d) : 0;
  return d <= 0 ? f = 0 : c === t ? f = (o - i) / d % 6 : c === o ? f = 2 + (i - t) / d : f = 4 + (t - o) / d, f /= 6, f %= 1, [f * 360, d * 100, p * 100];
};
dt.hsl.hcg = function(e) {
  const t = e[1] / 100, o = e[2] / 100, i = o < 0.5 ? 2 * t * o : 2 * t * (1 - o);
  let c = 0;
  return i < 1 && (c = (o - 0.5 * i) / (1 - i)), [e[0], i * 100, c * 100];
};
dt.hsv.hcg = function(e) {
  const t = e[1] / 100, o = e[2] / 100, i = t * o;
  let c = 0;
  return i < 1 && (c = (o - i) / (1 - i)), [e[0], i * 100, c * 100];
};
dt.hcg.rgb = function(e) {
  const t = e[0] / 360, o = e[1] / 100, i = e[2] / 100;
  if (o === 0)
    return [i * 255, i * 255, i * 255];
  const c = [0, 0, 0], n = t % 1 * 6, d = n % 1, f = 1 - d;
  let p = 0;
  switch (Math.floor(n)) {
    case 0: {
      c[0] = 1, c[1] = d, c[2] = 0;
      break;
    }
    case 1: {
      c[0] = f, c[1] = 1, c[2] = 0;
      break;
    }
    case 2: {
      c[0] = 0, c[1] = 1, c[2] = d;
      break;
    }
    case 3: {
      c[0] = 0, c[1] = f, c[2] = 1;
      break;
    }
    case 4: {
      c[0] = d, c[1] = 0, c[2] = 1;
      break;
    }
    default:
      c[0] = 1, c[1] = 0, c[2] = f;
  }
  return p = (1 - o) * i, [
    (o * c[0] + p) * 255,
    (o * c[1] + p) * 255,
    (o * c[2] + p) * 255
  ];
};
dt.hcg.hsv = function(e) {
  const t = e[1] / 100, o = e[2] / 100, i = t + o * (1 - t);
  let c = 0;
  return i > 0 && (c = t / i), [e[0], c * 100, i * 100];
};
dt.hcg.hsl = function(e) {
  const t = e[1] / 100, i = e[2] / 100 * (1 - t) + 0.5 * t;
  let c = 0;
  return i > 0 && i < 0.5 ? c = t / (2 * i) : i >= 0.5 && i < 1 && (c = t / (2 * (1 - i))), [e[0], c * 100, i * 100];
};
dt.hcg.hwb = function(e) {
  const t = e[1] / 100, o = e[2] / 100, i = t + o * (1 - t);
  return [e[0], (i - t) * 100, (1 - i) * 100];
};
dt.hwb.hcg = function(e) {
  const t = e[1] / 100, i = 1 - e[2] / 100, c = i - t;
  let n = 0;
  return c < 1 && (n = (i - c) / (1 - c)), [e[0], c * 100, n * 100];
};
dt.apple.rgb = function(e) {
  return [e[0] / 65535 * 255, e[1] / 65535 * 255, e[2] / 65535 * 255];
};
dt.rgb.apple = function(e) {
  return [e[0] / 255 * 65535, e[1] / 255 * 65535, e[2] / 255 * 65535];
};
dt.gray.rgb = function(e) {
  return [e[0] / 100 * 255, e[0] / 100 * 255, e[0] / 100 * 255];
};
dt.gray.hsl = function(e) {
  return [0, 0, e[0]];
};
dt.gray.hsv = dt.gray.hsl;
dt.gray.hwb = function(e) {
  return [0, 100, e[0]];
};
dt.gray.cmyk = function(e) {
  return [0, 0, 0, e[0]];
};
dt.gray.lab = function(e) {
  return [e[0], 0, 0];
};
dt.gray.hex = function(e) {
  const t = Math.round(e[0] / 100 * 255) & 255, i = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
  return "000000".slice(i.length) + i;
};
dt.rgb.gray = function(e) {
  return [(e[0] + e[1] + e[2]) / 3 / 255 * 100];
};
function M_() {
  const e = {}, t = Object.keys(dt);
  for (let { length: o } = t, i = 0; i < o; i++)
    e[t[i]] = {
      // http://jsperf.com/1-vs-infinity
      // micro-opt, but this is simple.
      distance: -1,
      parent: null
    };
  return e;
}
function m_(e) {
  const t = M_(), o = [e];
  for (t[e].distance = 0; o.length > 0; ) {
    const i = o.pop(), c = Object.keys(dt[i]);
    for (let { length: n } = c, d = 0; d < n; d++) {
      const f = c[d], p = t[f];
      p.distance === -1 && (p.distance = t[i].distance + 1, p.parent = i, o.unshift(f));
    }
  }
  return t;
}
function v_(e, t) {
  return function(o) {
    return t(e(o));
  };
}
function b_(e, t) {
  const o = [t[e].parent, e];
  let i = dt[t[e].parent][e], c = t[e].parent;
  for (; t[c].parent; )
    o.unshift(t[c].parent), i = v_(dt[t[c].parent][c], i), c = t[c].parent;
  return i.conversion = o, i;
}
function x_(e) {
  const t = m_(e), o = {}, i = Object.keys(t);
  for (let { length: c } = i, n = 0; n < c; n++) {
    const d = i[n];
    t[d].parent !== null && (o[d] = b_(d, t));
  }
  return o;
}
const Qr = {}, w_ = Object.keys(dt);
function C_(e) {
  const t = function(...o) {
    const i = o[0];
    return i == null ? i : (i.length > 1 && (o = i), e(o));
  };
  return "conversion" in e && (t.conversion = e.conversion), t;
}
function I_(e) {
  const t = function(...o) {
    const i = o[0];
    if (i == null)
      return i;
    i.length > 1 && (o = i);
    const c = e(o);
    if (typeof c == "object")
      for (let { length: n } = c, d = 0; d < n; d++)
        c[d] = Math.round(c[d]);
    return c;
  };
  return "conversion" in e && (t.conversion = e.conversion), t;
}
for (const e of w_) {
  Qr[e] = {}, Object.defineProperty(Qr[e], "channels", { value: dt[e].channels }), Object.defineProperty(Qr[e], "labels", { value: dt[e].labels });
  const t = x_(e), o = Object.keys(t);
  for (const i of o) {
    const c = t[i];
    Qr[e][i] = I_(c), Qr[e][i].raw = C_(c);
  }
}
const Rm = [
  // To be honest, I don't really feel like keyword belongs in color convert, but eh.
  "keyword",
  // Gray conflicts with some method names, and has its own method defined.
  "gray",
  // Shouldn't really be in color-convert either...
  "hex"
], z1 = {};
for (const e of Object.keys(Qr))
  z1[[...Qr[e].labels].sort().join("")] = e;
const is = {};
function Mr(e, t) {
  if (!(this instanceof Mr))
    return new Mr(e, t);
  if (t && t in Rm && (t = null), t && !(t in Qr))
    throw new Error("Unknown model: " + t);
  let o, i;
  if (e == null)
    this.model = "rgb", this.color = [0, 0, 0], this.valpha = 1;
  else if (e instanceof Mr)
    this.model = e.model, this.color = [...e.color], this.valpha = e.valpha;
  else if (typeof e == "string") {
    const c = Ur.get(e);
    if (c === null)
      throw new Error("Unable to parse color from string: " + e);
    this.model = c.model, i = Qr[this.model].channels, this.color = c.value.slice(0, i), this.valpha = typeof c.value[i] == "number" ? c.value[i] : 1;
  } else if (e.length > 0) {
    this.model = t || "rgb", i = Qr[this.model].channels;
    const c = Array.prototype.slice.call(e, 0, i);
    this.color = k1(c, i), this.valpha = typeof e[i] == "number" ? e[i] : 1;
  } else if (typeof e == "number")
    this.model = "rgb", this.color = [
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255
    ], this.valpha = 1;
  else {
    this.valpha = 1;
    const c = Object.keys(e);
    "alpha" in e && (c.splice(c.indexOf("alpha"), 1), this.valpha = typeof e.alpha == "number" ? e.alpha : 0);
    const n = c.sort().join("");
    if (!(n in z1))
      throw new Error("Unable to parse color from object: " + JSON.stringify(e));
    this.model = z1[n];
    const { labels: d } = Qr[this.model], f = [];
    for (o = 0; o < d.length; o++)
      f.push(e[d[o]]);
    this.color = k1(f);
  }
  if (is[this.model])
    for (i = Qr[this.model].channels, o = 0; o < i; o++) {
      const c = is[this.model][o];
      c && (this.color[o] = c(this.color[o]));
    }
  this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
}
Mr.prototype = {
  toString() {
    return this.string();
  },
  toJSON() {
    return this[this.model]();
  },
  string(e) {
    let t = this.model in Ur.to ? this : this.rgb();
    t = t.round(typeof e == "number" ? e : 1);
    const o = t.valpha === 1 ? t.color : [...t.color, this.valpha];
    return Ur.to[t.model](...o);
  },
  percentString(e) {
    const t = this.rgb().round(typeof e == "number" ? e : 1), o = t.valpha === 1 ? t.color : [...t.color, this.valpha];
    return Ur.to.rgb.percent(...o);
  },
  array() {
    return this.valpha === 1 ? [...this.color] : [...this.color, this.valpha];
  },
  object() {
    const e = {}, { channels: t } = Qr[this.model], { labels: o } = Qr[this.model];
    for (let i = 0; i < t; i++)
      e[o[i]] = this.color[i];
    return this.valpha !== 1 && (e.alpha = this.valpha), e;
  },
  unitArray() {
    const e = this.rgb().color;
    return e[0] /= 255, e[1] /= 255, e[2] /= 255, this.valpha !== 1 && e.push(this.valpha), e;
  },
  unitObject() {
    const e = this.rgb().object();
    return e.r /= 255, e.g /= 255, e.b /= 255, this.valpha !== 1 && (e.alpha = this.valpha), e;
  },
  round(e) {
    return e = Math.max(e || 0, 0), new Mr([...this.color.map(A_(e)), this.valpha], this.model);
  },
  alpha(e) {
    return e !== void 0 ? new Mr([...this.color, Math.max(0, Math.min(1, e))], this.model) : this.valpha;
  },
  // Rgb
  red: Sr("rgb", 0, Pr(255)),
  green: Sr("rgb", 1, Pr(255)),
  blue: Sr("rgb", 2, Pr(255)),
  hue: Sr(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, (e) => (e % 360 + 360) % 360),
  saturationl: Sr("hsl", 1, Pr(100)),
  lightness: Sr("hsl", 2, Pr(100)),
  saturationv: Sr("hsv", 1, Pr(100)),
  value: Sr("hsv", 2, Pr(100)),
  chroma: Sr("hcg", 1, Pr(100)),
  gray: Sr("hcg", 2, Pr(100)),
  white: Sr("hwb", 1, Pr(100)),
  wblack: Sr("hwb", 2, Pr(100)),
  cyan: Sr("cmyk", 0, Pr(100)),
  magenta: Sr("cmyk", 1, Pr(100)),
  yellow: Sr("cmyk", 2, Pr(100)),
  black: Sr("cmyk", 3, Pr(100)),
  x: Sr("xyz", 0, Pr(95.047)),
  y: Sr("xyz", 1, Pr(100)),
  z: Sr("xyz", 2, Pr(108.833)),
  l: Sr("lab", 0, Pr(100)),
  a: Sr("lab", 1),
  b: Sr("lab", 2),
  keyword(e) {
    return e !== void 0 ? new Mr(e) : Qr[this.model].keyword(this.color);
  },
  hex(e) {
    return e !== void 0 ? new Mr(e) : Ur.to.hex(...this.rgb().round().color);
  },
  hexa(e) {
    if (e !== void 0)
      return new Mr(e);
    const t = this.rgb().round().color;
    let o = Math.round(this.valpha * 255).toString(16).toUpperCase();
    return o.length === 1 && (o = "0" + o), Ur.to.hex(...t) + o;
  },
  rgbNumber() {
    const e = this.rgb().color;
    return (e[0] & 255) << 16 | (e[1] & 255) << 8 | e[2] & 255;
  },
  luminosity() {
    const e = this.rgb().color, t = [];
    for (const [o, i] of e.entries()) {
      const c = i / 255;
      t[o] = c <= 0.04045 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
    }
    return 0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2];
  },
  contrast(e) {
    const t = this.luminosity(), o = e.luminosity();
    return t > o ? (t + 0.05) / (o + 0.05) : (o + 0.05) / (t + 0.05);
  },
  level(e) {
    const t = this.contrast(e);
    return t >= 7 ? "AAA" : t >= 4.5 ? "AA" : "";
  },
  isDark() {
    const e = this.rgb().color;
    return (e[0] * 2126 + e[1] * 7152 + e[2] * 722) / 1e4 < 128;
  },
  isLight() {
    return !this.isDark();
  },
  negate() {
    const e = this.rgb();
    for (let t = 0; t < 3; t++)
      e.color[t] = 255 - e.color[t];
    return e;
  },
  lighten(e) {
    const t = this.hsl();
    return t.color[2] += t.color[2] * e, t;
  },
  darken(e) {
    const t = this.hsl();
    return t.color[2] -= t.color[2] * e, t;
  },
  saturate(e) {
    const t = this.hsl();
    return t.color[1] += t.color[1] * e, t;
  },
  desaturate(e) {
    const t = this.hsl();
    return t.color[1] -= t.color[1] * e, t;
  },
  whiten(e) {
    const t = this.hwb();
    return t.color[1] += t.color[1] * e, t;
  },
  blacken(e) {
    const t = this.hwb();
    return t.color[2] += t.color[2] * e, t;
  },
  grayscale() {
    const e = this.rgb().color, t = e[0] * 0.3 + e[1] * 0.59 + e[2] * 0.11;
    return Mr.rgb(t, t, t);
  },
  fade(e) {
    return this.alpha(this.valpha - this.valpha * e);
  },
  opaquer(e) {
    return this.alpha(this.valpha + this.valpha * e);
  },
  rotate(e) {
    const t = this.hsl();
    let o = t.color[0];
    return o = (o + e) % 360, o = o < 0 ? 360 + o : o, t.color[0] = o, t;
  },
  mix(e, t) {
    if (!e || !e.rgb)
      throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof e);
    const o = e.rgb(), i = this.rgb(), c = t === void 0 ? 0.5 : t, n = 2 * c - 1, d = o.alpha() - i.alpha(), f = ((n * d === -1 ? n : (n + d) / (1 + n * d)) + 1) / 2, p = 1 - f;
    return Mr.rgb(
      f * o.red() + p * i.red(),
      f * o.green() + p * i.green(),
      f * o.blue() + p * i.blue(),
      o.alpha() * c + i.alpha() * (1 - c)
    );
  }
};
for (const e of Object.keys(Qr)) {
  if (Rm.includes(e))
    continue;
  const { channels: t } = Qr[e];
  Mr.prototype[e] = function(...o) {
    return this.model === e ? new Mr(this) : o.length > 0 ? new Mr(o, e) : new Mr([...T_(Qr[this.model][e].raw(this.color)), this.valpha], e);
  }, Mr[e] = function(...o) {
    let i = o[0];
    return typeof i == "number" && (i = k1(o, t)), new Mr(i, e);
  };
}
function N_(e, t) {
  return Number(e.toFixed(t));
}
function A_(e) {
  return function(t) {
    return N_(t, e);
  };
}
function Sr(e, t, o) {
  e = Array.isArray(e) ? e : [e];
  for (const i of e)
    (is[i] || (is[i] = []))[t] = o;
  return e = e[0], function(i) {
    let c;
    return i !== void 0 ? (o && (i = o(i)), c = this[e](), c.color[t] = i, c) : (c = this[e]().color[t], o && (c = o(c)), c);
  };
}
function Pr(e) {
  return function(t) {
    return Math.max(0, Math.min(e, t));
  };
}
function T_(e) {
  return Array.isArray(e) ? e : [e];
}
function k1(e, t) {
  for (let o = 0; o < t; o++)
    typeof e[o] != "number" && (e[o] = 0);
  return e;
}
function L_(e) {
  var p;
  const t = or(), o = Ce(
    () => ({
      tokenListItem: {
        display: "flex",
        justifyContent: "space-between",
        padding: "8px 16px",
        borderRadius: 0,
        ":hover": {
          backgroundColor: Mr(t.palette.primary.main).alpha(0.07).hexa()
        }
      },
      tokenListItemSelected: {
        backgroundColor: Mr(t.palette.primary.main).alpha(0.07).hexa()
      },
      tokenDetails: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
      },
      addressLink: {
        display: "inline-flex",
        alignItems: "center",
        height: "10px",
        overflow: "hidden",
        color: t.palette.text.primary,
        opacity: 0.6
      },
      wormholeWrappedDisclaimer: {
        display: "inline",
        marginRight: 4
      }
    }),
    [t]
  ), { chain: i, token: c } = e, n = (p = c.tokenId) == null ? void 0 : p.address.toString(), d = n ? bo(i, n, "token") : void 0, f = `${c.shortAddress}`;
  return /* @__PURE__ */ ne(
    Yr,
    {
      sx: {
        ...o.tokenListItem,
        ...e.isSelected && o.tokenListItemSelected
      },
      dense: !0,
      "data-testid": `token-button-${i.toLowerCase()}-${c.address.toString()}`,
      onMouseDown: e.onClick,
      children: [
        /* @__PURE__ */ ne(ut, { sx: o.tokenDetails, children: [
          /* @__PURE__ */ D(Bo, { children: /* @__PURE__ */ D(Js, { icon: e.token.icon }) }),
          /* @__PURE__ */ ne("div", { children: [
            /* @__PURE__ */ D(Fe, { children: c.display }),
            /* @__PURE__ */ ne(ut, { display: "flex", children: [
              c.tokenBridgeOriginalTokenId ? /* @__PURE__ */ D(
                ws,
                {
                  title: `Wormhole-wrapped from ${a8(
                    c.tokenBridgeOriginalTokenId.chain
                  )}`,
                  children: /* @__PURE__ */ D(ut, { margin: "2px", marginRight: "5px", children: /* @__PURE__ */ D(
                    Un,
                    {
                      height: 10,
                      icon: c.tokenBridgeOriginalTokenId.chain
                    }
                  ) })
                }
              ) : null,
              c.symbol ? /* @__PURE__ */ D(Fe, { fontSize: 10, color: t.palette.text.secondary, children: c.symbol }) : null,
              c.symbol && !c.isNativeGasToken ? /* @__PURE__ */ D(
                Fe,
                {
                  fontSize: 10,
                  color: t.palette.text.secondary,
                  marginLeft: 1,
                  marginRight: 1,
                  children: "•"
                }
              ) : null,
              c.isNativeGasToken ? null : /* @__PURE__ */ D(Fe, { fontSize: 10, color: t.palette.text.secondary, children: !Wi(n) && /* @__PURE__ */ ne(
                $i,
                {
                  onMouseDown: (l) => l.stopPropagation(),
                  onClick: (l) => l.stopPropagation(),
                  sx: o.addressLink,
                  href: d,
                  rel: "noreferrer noopener",
                  target: "_blank",
                  children: [
                    f,
                    /* @__PURE__ */ D(
                      Kh,
                      {
                        sx: {
                          height: "10px",
                          width: "10px",
                          marginLeft: "2px"
                        }
                      }
                    )
                  ]
                }
              ) })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ ne(Tt, { alignItems: "flex-end", children: [
          /* @__PURE__ */ D(Fe, { fontSize: 14, children: e.isFetchingBalance && e.balance === null ? /* @__PURE__ */ D(Or, { size: 24 }) : e.balance ? cr(vn(e.balance, 6)) : "" }),
          e.price && /* @__PURE__ */ D(Fe, { color: t.palette.text.secondary, fontSize: "10px", children: e.price })
        ] })
      ]
    }
  );
}
const S_ = Sn(L_), J6 = (e) => {
  var T, E;
  const t = er(), o = ge.ui.disableUserInputtedTokens !== !0, [i, c] = Xe(/* @__PURE__ */ new Map()), {
    getOrFetchToken: n,
    isFetchingToken: d,
    getTokenPrices: f,
    lastTokenPriceUpdate: p
  } = Hr();
  St(() => {
    const j = f(e.tokenList);
    c(j);
  }, [e.tokenList, f, p]), St(() => {
    if (o)
      try {
        if (e.searchQuery !== "") {
          const j = e.selectedChainConfig.sdkName, O = ki(j, e.searchQuery);
          O && (ge.tokens.get(j, e.searchQuery) || n({ chain: j, address: O }));
        }
      } catch {
      }
  }, [e.searchQuery, e.selectedChainConfig.sdkName]);
  const l = e.tokenList, h = Ce(() => {
    var O;
    let j = "";
    return (O = e.wallet) != null && O.address ? e.isSource ? j = "No supported tokens found in wallet" : e.sourceToken ? j = "No supported destination tokens for this route" : j = "Please select a source token first" : j = "Connect wallet to see available tokens", /* @__PURE__ */ D(Fe, { variant: "body2", color: t.palette.grey.A400, children: j });
  }, [
    (T = e.wallet) == null ? void 0 : T.address,
    e.isSource,
    e.sourceToken,
    t.palette.grey.A400
  ]), y = `Search for a token${o ? " or paste an address" : ""}`, M = Ce(
    () => ({
      card: {
        background: t.palette.input.background,
        maxWidth: "420px"
      },
      tokenListContainer: {
        padding: "16px 0 0 0 !important"
      },
      title: {
        fontSize: 14,
        marginBottom: "8px"
      },
      tokenLoader: {
        padding: 0,
        display: "flex",
        justifyContent: "space-between"
      },
      tokenList: {
        maxHeight: "360px",
        [t.breakpoints.down("sm")]: {
          maxHeight: "480px"
        }
      }
    }),
    [t]
  ), C = Ce(() => {
    var j;
    return !((j = e.wallet) != null && j.address) && !e.isConnectingWallet ? "empty" : e.isFetching ? "loading" : l.length === 0 ? "empty" : "ready";
  }, [
    (E = e.wallet) == null ? void 0 : E.address,
    e.isConnectingWallet,
    e.isFetching,
    e.isFetchingBalances,
    e.isSource,
    e.balances,
    i,
    l.length
  ]), N = C === "loading", w = C === "empty", S = /* @__PURE__ */ D(
    _m,
    {
      searchPlaceholder: y,
      sx: M.tokenList,
      dataTestId: "token-search-list",
      searchQuery: e.searchQuery,
      listTitle: w ? h : /* @__PURE__ */ D(ut, { display: "flex", width: "100%", children: /* @__PURE__ */ ne(
        Fe,
        {
          style: { flexGrow: "2" },
          fontSize: 14,
          color: t.palette.text.secondary,
          children: [
            "Tokens on ",
            e.selectedChainConfig.displayName
          ]
        }
      ) }),
      loading: N && [1, 2, 3].map((j) => /* @__PURE__ */ D(Yr, { sx: M.tokenLoader, dense: !0, children: /* @__PURE__ */ D(ut, { padding: "8px 16px", children: /* @__PURE__ */ D(ea, { variant: "circular", width: "36px", height: "36px" }) }) }, j)),
      items: l,
      onQueryChange: (j) => {
        e.onSearchQueryChange(j);
      },
      filterFn: (j, O) => {
        if (O.length === 0) return !0;
        const z = O.toLowerCase();
        return !!([j.symbol, j.name].some(
          (H) => {
            var W, U;
            return (U = (W = H == null ? void 0 : H.toLowerCase()) == null ? void 0 : W.startsWith) == null ? void 0 : U.call(W, z);
          }
        ) || j.address.toString().toLowerCase() === z || j.tokenBridgeOriginalTokenId && j.tokenBridgeOriginalTokenId.address.toString().toLowerCase().includes(z));
      },
      renderFn: (j) => {
        var H, W, U;
        const O = (W = (H = e.balances) == null ? void 0 : H[j.key]) == null ? void 0 : W.balance, z = i.get(j.key), k = O && z !== void 0 ? Ws(ri(z, O, j)) : null;
        return /* @__PURE__ */ D(
          S_,
          {
            token: j,
            chain: e.selectedChainConfig.sdkName,
            onClick: () => {
              e.onSelectToken(j);
            },
            balance: O,
            price: k,
            isSelected: j.key === ((U = e.selectedToken) == null ? void 0 : U.key),
            isFetchingBalance: e.isFetchingBalances
          },
          j.key
        );
      }
    }
  );
  return /* @__PURE__ */ D(Q1, { sx: M.card, variant: "elevation", children: /* @__PURE__ */ ne(pg, { sx: M.tokenListContainer, children: [
    /* @__PURE__ */ ne(ut, { sx: { display: "flex", padding: "0 16px" }, children: [
      /* @__PURE__ */ D(Fe, { width: "100%", sx: M.title, children: "Select a token" }),
      d || e.isFetchingBalances ? /* @__PURE__ */ D(
        Or,
        {
          sx: { alignSelf: "flex-end", marginBottom: "12px" },
          size: 14
        }
      ) : null
    ] }),
    S
  ] }) });
};
function E_(e) {
  const {
    badgeContent: t,
    invisible: o = !1,
    max: i = 99,
    showZero: c = !1
  } = e, n = Eg({
    badgeContent: t,
    max: i
  });
  let d = o;
  o === !1 && t === 0 && !c && (d = !0);
  const {
    badgeContent: f,
    max: p = i
  } = d ? n : e, l = f && Number(f) > p ? `${p}+` : f;
  return {
    badgeContent: f,
    invisible: d,
    max: p,
    displayValue: l
  };
}
function D_(e) {
  return Bt("MuiBadge", e);
}
const Ti = Ft("MuiBadge", [
  "root",
  "badge",
  "dot",
  "standard",
  "anchorOriginTopRight",
  "anchorOriginBottomRight",
  "anchorOriginTopLeft",
  "anchorOriginBottomLeft",
  "invisible",
  "colorError",
  "colorInfo",
  "colorPrimary",
  "colorSecondary",
  "colorSuccess",
  "colorWarning",
  "overlapRectangular",
  "overlapCircular",
  // TODO: v6 remove the overlap value from these class keys
  "anchorOriginTopLeftCircular",
  "anchorOriginTopLeftRectangular",
  "anchorOriginTopRightCircular",
  "anchorOriginTopRightRectangular",
  "anchorOriginBottomLeftCircular",
  "anchorOriginBottomLeftRectangular",
  "anchorOriginBottomRightCircular",
  "anchorOriginBottomRightRectangular"
]), _d = 10, Bd = 4, j_ = (e) => {
  const {
    color: t,
    anchorOrigin: o,
    invisible: i,
    overlap: c,
    variant: n,
    classes: d = {}
  } = e, f = {
    root: ["root"],
    badge: ["badge", n, i && "invisible", `anchorOrigin${it(o.vertical)}${it(o.horizontal)}`, `anchorOrigin${it(o.vertical)}${it(o.horizontal)}${it(c)}`, `overlap${it(c)}`, t !== "default" && `color${it(t)}`]
  };
  return Rt(f, D_, d);
}, O_ = Ke("span", {
  name: "MuiBadge",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  position: "relative",
  display: "inline-flex",
  // For correct alignment with the text.
  verticalAlign: "middle",
  flexShrink: 0
}), z_ = Ke("span", {
  name: "MuiBadge",
  slot: "Badge",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.badge, t[o.variant], t[`anchorOrigin${it(o.anchorOrigin.vertical)}${it(o.anchorOrigin.horizontal)}${it(o.overlap)}`], o.color !== "default" && t[`color${it(o.color)}`], o.invisible && t.invisible];
  }
})(kt(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  position: "absolute",
  boxSizing: "border-box",
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(12),
  minWidth: _d * 2,
  lineHeight: 1,
  padding: "0 6px",
  height: _d * 2,
  borderRadius: _d,
  zIndex: 1,
  // Render the badge on top of potential ripples.
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeInOut,
    duration: e.transitions.duration.enteringScreen
  }),
  variants: [...Object.entries(e.palette).filter(Gr(["contrastText"])).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      backgroundColor: (e.vars || e).palette[t].main,
      color: (e.vars || e).palette[t].contrastText
    }
  })), {
    props: {
      variant: "dot"
    },
    style: {
      borderRadius: Bd,
      height: Bd * 2,
      minWidth: Bd * 2,
      padding: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "right" && t.overlap === "rectangular",
    style: {
      top: 0,
      right: 0,
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      [`&.${Ti.invisible}`]: {
        transform: "scale(0) translate(50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "right" && t.overlap === "rectangular",
    style: {
      bottom: 0,
      right: 0,
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      [`&.${Ti.invisible}`]: {
        transform: "scale(0) translate(50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "left" && t.overlap === "rectangular",
    style: {
      top: 0,
      left: 0,
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      [`&.${Ti.invisible}`]: {
        transform: "scale(0) translate(-50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "left" && t.overlap === "rectangular",
    style: {
      bottom: 0,
      left: 0,
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      [`&.${Ti.invisible}`]: {
        transform: "scale(0) translate(-50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "right" && t.overlap === "circular",
    style: {
      top: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      [`&.${Ti.invisible}`]: {
        transform: "scale(0) translate(50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "right" && t.overlap === "circular",
    style: {
      bottom: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      [`&.${Ti.invisible}`]: {
        transform: "scale(0) translate(50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "left" && t.overlap === "circular",
    style: {
      top: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      [`&.${Ti.invisible}`]: {
        transform: "scale(0) translate(-50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "left" && t.overlap === "circular",
    style: {
      bottom: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      [`&.${Ti.invisible}`]: {
        transform: "scale(0) translate(-50%, 50%)"
      }
    }
  }, {
    props: {
      invisible: !0
    },
    style: {
      transition: e.transitions.create("transform", {
        easing: e.transitions.easing.easeInOut,
        duration: e.transitions.duration.leavingScreen
      })
    }
  }]
})));
function X6(e) {
  return {
    vertical: (e == null ? void 0 : e.vertical) ?? "top",
    horizontal: (e == null ? void 0 : e.horizontal) ?? "right"
  };
}
const Pm = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiBadge"
  }), {
    anchorOrigin: c,
    className: n,
    classes: d,
    component: f,
    components: p = {},
    componentsProps: l = {},
    children: h,
    overlap: y = "rectangular",
    color: M = "default",
    invisible: C = !1,
    max: N = 99,
    badgeContent: w,
    slots: S,
    slotProps: T,
    showZero: E = !1,
    variant: j = "standard",
    ...O
  } = i, {
    badgeContent: z,
    invisible: k,
    max: H,
    displayValue: W
  } = E_({
    max: N,
    invisible: C,
    badgeContent: w,
    showZero: E
  }), U = Eg({
    anchorOrigin: X6(c),
    color: M,
    overlap: y,
    variant: j,
    badgeContent: w
  }), B = k || z == null && j !== "dot", {
    color: I = M,
    overlap: r = y,
    anchorOrigin: s,
    variant: u = j
  } = B ? U : i, g = X6(s), v = u !== "dot" ? W : void 0, A = {
    ...i,
    badgeContent: z,
    invisible: B,
    max: H,
    displayValue: v,
    showZero: E,
    anchorOrigin: g,
    color: I,
    overlap: r,
    variant: u
  }, L = j_(A), m = {
    slots: {
      root: (S == null ? void 0 : S.root) ?? p.Root,
      badge: (S == null ? void 0 : S.badge) ?? p.Badge
    },
    slotProps: {
      root: (T == null ? void 0 : T.root) ?? l.root,
      badge: (T == null ? void 0 : T.badge) ?? l.badge
    }
  }, [a, x] = qt("root", {
    elementType: O_,
    externalForwardedProps: {
      ...m,
      ...O
    },
    ownerState: A,
    className: It(L.root, n),
    ref: o,
    additionalProps: {
      as: f
    }
  }), [V, G] = qt("badge", {
    elementType: z_,
    externalForwardedProps: m,
    ownerState: A,
    className: L.badge
  });
  return /* @__PURE__ */ ne(a, {
    ...x,
    children: [h, /* @__PURE__ */ D(V, {
      ...G,
      children: v
    })]
  });
});
fe.process.env.NODE_ENV !== "production" && (Pm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */
  anchorOrigin: b.shape({
    horizontal: b.oneOf(["left", "right"]),
    vertical: b.oneOf(["bottom", "top"])
  }),
  /**
   * The content rendered within the badge.
   */
  badgeContent: b.node,
  /**
   * The badge will be added relative to this node.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: b.oneOfType([b.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), b.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: b.shape({
    Badge: b.elementType,
    Root: b.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: b.shape({
    badge: b.oneOfType([b.func, b.object]),
    root: b.oneOfType([b.func, b.object])
  }),
  /**
   * If `true`, the badge is invisible.
   * @default false
   */
  invisible: b.bool,
  /**
   * Max count to show.
   * @default 99
   */
  max: b.number,
  /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */
  overlap: b.oneOf(["circular", "rectangular"]),
  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */
  showZero: b.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: b.shape({
    badge: b.oneOfType([b.func, b.object]),
    root: b.oneOfType([b.func, b.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: b.shape({
    badge: b.elementType,
    root: b.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: b.oneOfType([b.oneOf(["dot", "standard"]), b.string])
});
function Pi(e) {
  const t = or(), { chainConfig: o, token: i } = e, c = Ce(
    () => ({
      badgeContent: {
        border: `1.5px solid ${t.palette.input.background}`,
        borderRadius: "4px"
      }
    }),
    [t]
  );
  return /* @__PURE__ */ D(
    Pm,
    {
      badgeContent: /* @__PURE__ */ D(wt, { sx: c.badgeContent, children: /* @__PURE__ */ D(Un, { icon: o == null ? void 0 : o.icon, height: 13 }) }),
      sx: {
        zIndex: 0,
        height: "38px",
        // Icon height (36px) + the distance from badge's bottom (2px)
        marginRight: "8px",
        "& .MuiBadge-badge": {
          right: 2,
          top: 32
        }
      },
      children: /* @__PURE__ */ D(
        Js,
        {
          icon: i == null ? void 0 : i.icon,
          style: { width: "36px", height: "36px", padding: "2px" }
        }
      )
    }
  );
}
const K6 = (e, t) => {
  if (t && Th(t, e))
    return 4;
  if (Wi(e.addressString))
    return 3;
  const o = Co.get(ge.network, e.chain);
  return o && e.addressString === o ? 2 : e.isTokenBridgeWrappedToken ? 0 : 1;
}, eg = (e, t, o) => {
  const i = t[Bn(e)];
  return !i || !i.balance ? 0 : ri(o, i.balance, e) ?? 0;
}, k_ = (e, t, o) => {
  if (!t) return [...e];
  const i = [...e];
  let c = [];
  const n = ge.tokens.get(o.sdkName, t);
  n && c.push(n);
  const d = ge.tokens.queryBySymbol(o.sdkName, t).filter((f) => !c8(f, o.sdkName));
  d.length > 0 && (c = c.concat(d));
  for (const f of c)
    e.find((p) => Th(f, p)) || i.push(f);
  return i;
}, __ = (e, t, o, i) => e.sort((c, n) => {
  const d = K6(c, t), f = K6(n, t);
  if (d > f) return -1;
  if (f > d) return 1;
  const p = eg(c, o, i), l = eg(n, o, i);
  return p !== l ? l - p : c.symbol.localeCompare(n.symbol);
}), B_ = (e, t) => {
  if (!ge.tokenWhitelist || ge.tokenWhitelist.length === 0)
    return e;
  const o = /* @__PURE__ */ new Set(), i = [];
  for (const c of ge.tokenWhitelist)
    if (typeof c == "string")
      i.push(c);
    else if (Ah(c)) {
      const n = Xc(c);
      n.chain === t.sdkName && o.add(n.address.toString());
    }
  for (const c of i) {
    let n = !1;
    const d = [];
    for (const f of e)
      f.symbol === c && (f.isTokenBridgeWrappedToken ? d.push(f) : (o.add(f.address.toString()), n = !0));
    if (!n && d.length > 0) {
      for (const { address: f } of d)
        o.add(f.toString());
      d.length > 1 && console.warn(
        `Ambiguous token whitelist item "${c}"; found ${d.length} matching wrapped tokens.`
      );
    }
  }
  return e.filter((c) => o.has(c.address.toString()));
}, F_ = (e, t) => {
  const o = ge.isTokenSupportedHandler;
  return o ? e.filter((i) => o(i, t)) : e;
}, R_ = (e) => e.filter((t) => {
  const o = t.isNativeGasToken || t.isBuiltin || t.coingeckoWebId || t.isTokenBridgeWrappedToken || lc(t);
  return o || console.debug("Filtering out token for likely being spam", t), o;
}), P_ = (e, t, o) => !o || Object.keys(t).length === 0 ? e : e.filter((i) => {
  var n;
  const c = (n = t[Bn(i)]) == null ? void 0 : n.balance;
  return c && ai(c) > 0;
}), Um = ({
  tokenList: e,
  searchQuery: t,
  selectedChainConfig: o,
  selectedToken: i,
  sourceToken: c,
  wallet: n,
  balances: d,
  isSourceList: f = !1
}) => {
  const { getTokenPrice: p, lastTokenPriceUpdate: l } = Hr();
  return Ce(() => {
    if (!e) return [];
    let h = k_(e, t, o);
    return h = __(
      h,
      i,
      d,
      p
    ), h = B_(h, o), h = F_(h, c), f && !t && (h = R_(h), h = P_(h, d, n.address)), h;
  }, [
    e,
    t,
    o,
    i,
    n.address,
    d,
    p,
    l,
    f,
    c
  ]);
}, tg = (e) => {
  const t = or(), o = Hi(t.breakpoints.down("sm")), [i, c] = Xe(!1), [n, d] = Xe(!1), [f, p] = Xe(""), l = Um({
    tokenList: e.tokenList || [],
    searchQuery: f,
    selectedChainConfig: e.chain ? ge.chains[e.chain] : {},
    selectedToken: e.token,
    sourceToken: e.sourceToken,
    wallet: e.wallet,
    balances: e.balances,
    isSourceList: e.isSource
    // true for source, false for destination
  }), h = Cl({
    variant: "popover",
    popupId: "asset-picker"
  });
  St(() => {
    (o && !n || !o && !h.isOpen) && setTimeout(() => {
      c(!1);
    }, 300);
  }, [n, o, h.isOpen]), St(() => {
    if (o && n && !e.chain || !o && h.isOpen && !e.chain) {
      const w = e.chainList.find(
        (S) => !Sh(S.sdkName, e.wallet)
      );
      w && e.setChain(w.sdkName);
    }
  }, [o, n, h.isOpen]);
  const y = Ce(() => e.chain ? ge.chains[e.chain] : void 0, [e.chain]), M = Ce(() => {
    if (!y && !e.token)
      return /* @__PURE__ */ D(Fe, { component: "div", fontSize: 16, children: "Select chain and token" });
    const w = e.token ? /* @__PURE__ */ D(Et, { children: e.token.display }) : /* @__PURE__ */ D(Et, { children: "Select token" });
    return /* @__PURE__ */ ne("div", { children: [
      /* @__PURE__ */ D(
        Fe,
        {
          component: "div",
          maxWidth: 300,
          fontSize: 16,
          fontWeight: 700,
          sx: {
            display: "flex",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          },
          children: w
        }
      ),
      /* @__PURE__ */ D(Fe, { component: "div", fontSize: 12, sx: { opacity: 0.6 }, children: y == null ? void 0 : y.displayName })
    ] });
  }, [y, e.token]), C = e.isTransactionInProgress || o ? {} : Il(h), N = Ce(
    () => ({
      inputArea: {
        width: "100%",
        cursor: "pointer",
        maxWidth: "420px",
        borderRadius: "8px",
        background: t.palette.input.fillTreatment ? "transparent" : t.palette.input.background,
        border: t.palette.input.fillTreatment ? `1px solid ${t.palette.input.border}` : "none"
      },
      inputAreaEmpty: {
        borderColor: t.palette.input.background,
        background: t.palette.input.background
      },
      cardContent: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "72px",
        padding: "16px 20px",
        ":last-child": {
          padding: "16px 20px"
        }
      },
      chainSelector: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
      },
      disabled: {
        opacity: "0.6",
        cursor: "default",
        pointerEvents: "none"
      },
      popover: {
        marginLeft: "-1px",
        marginTop: "-1px",
        width: "422px"
      },
      popoverSlot: {
        width: "100%",
        maxWidth: "422px",
        borderRadius: "8px",
        background: t.palette.input.background
      },
      backdrop: {
        backgroundColor: "rgba(0,0,0,0.2)"
      },
      drawer: {
        background: t.palette.input.background,
        borderRadius: "8px",
        height: "calc(100vh - 40px)",
        // Force full-height on small mobile devices with 40px padding at the top
        maxWidth: "100vw"
        // Force full-width on small mobile devices
      }
    }),
    [t]
  );
  return /* @__PURE__ */ ne(Et, { children: [
    /* @__PURE__ */ D(Qh, { open: h.isOpen, sx: N.backdrop }),
    /* @__PURE__ */ D(
      bn,
      {
        sx: [
          N.inputArea,
          !y && N.inputAreaEmpty,
          e.isTransactionInProgress && N.disabled
        ],
        "data-testid": e.dataTestId,
        variant: "elevation",
        onMouseDown: (w) => {
          o ? d(!0) : h.open(w);
        },
        onTouchEnd: (w) => {
          w.stopPropagation(), w.preventDefault(), o ? d(!0) : h.open(w);
        },
        ...C,
        children: /* @__PURE__ */ ne(xn, { sx: N.cardContent, children: [
          /* @__PURE__ */ ne(Fe, { sx: N.chainSelector, component: "div", gap: 1, children: [
            /* @__PURE__ */ D(Pi, { chainConfig: y, token: e.token }),
            M
          ] }),
          h.isOpen || n ? /* @__PURE__ */ D(zm, {}) : /* @__PURE__ */ D(Om, {})
        ] })
      }
    ),
    o ? /* @__PURE__ */ ne(
      wl,
      {
        anchor: "bottom",
        open: n,
        PaperProps: {
          sx: N.drawer
        },
        transitionDuration: 200,
        onOpen: () => d(!0),
        onClose: () => d(!1),
        children: [
          /* @__PURE__ */ D(yo, { alignItems: "center", paddingBottom: "4px", paddingTop: "8px", children: /* @__PURE__ */ D(
            ut,
            {
              sx: {
                width: "40px",
                height: "5px",
                backgroundColor: t.palette.text.secondary,
                borderRadius: "8px"
              }
            }
          ) }),
          /* @__PURE__ */ D(
            G6,
            {
              chainList: e.chainList,
              selectedChainConfig: y,
              showSearch: i,
              setShowSearch: c,
              wallet: e.wallet,
              onChainSelect: (w) => {
                e.setChain(w), p("");
              }
            }
          ),
          !i && y && /* @__PURE__ */ D(
            J6,
            {
              tokenList: l,
              balances: e.balances,
              isFetchingBalances: e.isFetchingBalances,
              isFetching: e.isFetching,
              isConnectingWallet: e.isConnectingWallet,
              selectedChainConfig: y,
              selectedToken: e.token,
              sourceToken: e.sourceToken,
              isSource: e.isSource,
              wallet: e.wallet,
              searchQuery: f,
              onSearchQueryChange: p,
              onSelectToken: (w) => {
                e.setToken(w), d(!1);
              }
            }
          )
        ]
      }
    ) : /* @__PURE__ */ ne(
      Ea,
      {
        ...Nl(h),
        transitionDuration: 200,
        anchorOrigin: {
          vertical: "top",
          horizontal: "center"
        },
        sx: N.popover,
        transformOrigin: {
          vertical: "top",
          horizontal: "center"
        },
        marginThreshold: 4,
        slotProps: {
          paper: {
            sx: [N.popoverSlot, { borderRadius: "8px" }]
          }
        },
        children: [
          /* @__PURE__ */ D(
            G6,
            {
              chainList: e.chainList,
              selectedChainConfig: y,
              showSearch: i,
              setShowSearch: c,
              wallet: e.wallet,
              onChainSelect: (w) => {
                e.setChain(w), p("");
              }
            }
          ),
          !i && y && /* @__PURE__ */ D(
            J6,
            {
              tokenList: l,
              isFetching: e.isFetching,
              balances: e.balances,
              isFetchingBalances: e.isFetchingBalances,
              isConnectingWallet: e.isConnectingWallet,
              selectedChainConfig: y,
              selectedToken: e.token,
              sourceToken: e.sourceToken,
              isSource: e.isSource,
              wallet: e.wallet,
              searchQuery: f,
              onSearchQueryChange: p,
              onSelectToken: (w) => {
                e.setToken(w), h.close();
              }
            }
          )
        ]
      }
    )
  ] });
}, U_ = (e) => {
  const {
    address: t,
    href: o,
    target: i = "_blank",
    label: c = "Transactions",
    sx: n
  } = e, d = ht(
    () => window.open(o.replace("{:address}", t), i),
    [t, o, i]
  );
  return /* @__PURE__ */ D(gg, { onClick: d, sx: n, children: /* @__PURE__ */ D(ln, { fontSize: 14, children: c }) });
}, Y_ = 1e3, rg = (e) => {
  const t = Cr(), o = or(), i = Ce(
    () => ({
      connectWallet: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "8px",
        cursor: "pointer",
        paddingTop: "2px",
        opacity: 1
      },
      walletAddress: {
        color: o.palette.text.secondary,
        marginLeft: "8px"
      },
      disabled: {
        opacity: "0.6",
        cursor: "default",
        pointerEvents: "none"
      }
    }),
    [o]
  ), { isTransactionInProgress: c } = Ut(
    (w) => w.transferInput
  ), n = Ut((w) => w.wallet[e.type]), [d, f] = Xe(!1), [p, l] = Xe(!1), h = Cl({
    variant: "popover",
    popupId: `connected-wallet-popover-${e.type}`
  }), y = ht(() => {
    h == null || h.close(), f(!0);
  }, [h]), M = ht(() => {
    el(n.address), h == null || h.close(), l(!0);
  }, [h, n.address]), C = ht(() => {
    t(t8(e.type)), h == null || h.close();
  }, [t, h, e.type]);
  St(() => {
    p && setTimeout(() => {
      l(!1);
    }, Y_);
  }, [p]);
  const N = c ? {} : Il(h);
  return /* @__PURE__ */ ne(Et, { children: [
    n != null && n.address ? /* @__PURE__ */ ne(Et, { children: [
      /* @__PURE__ */ ne(
        wt,
        {
          sx: [
            i.connectWallet,
            c && i.disabled
          ],
          ...N,
          children: [
            /* @__PURE__ */ D(Jh, { name: n.name, icon: n.icon, size: 20 }),
            /* @__PURE__ */ D(ws, { title: "Copied", open: p, placement: "top", arrow: !0, children: /* @__PURE__ */ D(
              Fe,
              {
                sx: i.walletAddress,
                fontSize: 14,
                fontWeight: 700,
                children: Kc(n.type, n.address)
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ D(
        Ea,
        {
          ...Nl(h),
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right"
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "right"
          },
          children: /* @__PURE__ */ ne(hi, { children: [
            /* @__PURE__ */ D(Yr, { onClick: M, children: /* @__PURE__ */ D(Fe, { fontSize: 14, children: "Copy address" }) }),
            ge.ui.explorer ? /* @__PURE__ */ D(
              U_,
              {
                address: n.address,
                href: ge.ui.explorer.href,
                target: ge.ui.explorer.target,
                label: ge.ui.explorer.label
              }
            ) : null,
            /* @__PURE__ */ D(Yr, { onClick: y, children: /* @__PURE__ */ D(Fe, { fontSize: 14, children: "Change wallet" }) }),
            /* @__PURE__ */ D(Yr, { onClick: C, children: /* @__PURE__ */ D(Fe, { fontSize: 14, children: "Disconnect" }) })
          ] })
        }
      )
    ] }) : null,
    /* @__PURE__ */ D(
      Xh,
      {
        open: d,
        type: e.type,
        onClose: () => {
          f(!1);
        },
        showAddressInput: e.type === ar.RECEIVING
      }
    )
  ] });
}, W_ = 500, H_ = Sn(
  ({
    value: e,
    onChange: t,
    onDebouncedChange: o,
    ...i
  }) => {
    const [c, n] = Xe(e), [d, f] = Xe(!1), p = sl(
      o,
      W_
    ), l = ht(
      (h) => {
        let y = h.target.value;
        y === "." && (y = "0.");
        const M = Number(y);
        isNaN(M) || M < 0 || (n(h.target.value), t(h.target.value), p(h.target.value));
      },
      [p, t]
    );
    return St(() => {
      d || n(e);
    }, [e]), /* @__PURE__ */ D(
      Ii,
      {
        ...i,
        "data-testid": "amount-input",
        value: c,
        focused: d,
        onChange: l,
        onFocus: () => f(!0),
        onBlur: () => f(!1)
      }
    );
  }
), Z_ = (e) => {
  const t = Cr(), o = er(), i = Ce(
    () => ({
      amountContainer: {
        width: "100%",
        maxWidth: "420px"
      },
      amountInput: {
        borderRadius: "8px",
        background: o.palette.input.fillTreatment ? "transparent" : o.palette.input.background,
        border: o.palette.input.fillTreatment ? `1px solid ${o.palette.input.border}` : "none"
      },
      amountInputEmpty: {
        background: o.palette.input.background,
        borderColor: o.palette.input.background
      },
      amountCardContent: {
        display: "flex",
        alignItems: "center",
        height: "72px",
        padding: "12px 20px",
        ":last-child": {
          padding: "12px 20px"
        }
      },
      amountTitle: {
        color: o.palette.text.secondary,
        display: "flex",
        minHeight: "40px",
        alignItems: "center",
        justifyContent: "space-between"
      },
      inputError: {
        marginTop: "12px"
      },
      balance: {
        color: o.palette.text.secondary,
        fontSize: "14px",
        lineHeight: "14px",
        textAlign: "right"
      }
    }),
    [o]
  ), { sending: c } = Ut(
    (O) => O.wallet
  ), { amount: n } = Ut((O) => O.transferInput), [d, f] = Xe(
    n ? cr(n) : ""
  ), [p, l] = Xe(
    n ? cr(n) : ""
  ), { fromChain: h, isTransactionInProgress: y } = Ut(
    (O) => O.transferInput
  ), { sourceToken: M } = _o(), { getTokenPrice: C } = Hr();
  St(() => {
    !n && (d || p) && (S(""), E(""));
  }, [n]);
  const N = Ce(
    () => y || !h || !M,
    [y, h, M]
  ), w = Ce(() => N || !c.address ? null : /* @__PURE__ */ ne(Tt, { direction: "row", alignItems: "center", children: [
    /* @__PURE__ */ D(
      Fe,
      {
        component: "span",
        sx: { ...i.balance, marginRight: "4px" },
        children: "Balance:"
      }
    ),
    e.isFetchingTokenBalance ? /* @__PURE__ */ D(Or, { size: 14 }) : /* @__PURE__ */ D(Fe, { fontSize: 14, textAlign: "right", sx: i.balance, children: e.tokenBalance ? cr(vn(e.tokenBalance, 6)) : "0" })
  ] }), [
    N,
    c.address,
    i.balance,
    e.isFetchingTokenBalance,
    e.tokenBalance
  ]), S = ht((O) => {
    f(O);
  }, []), T = Ce(() => {
    const O = In(
      C,
      Number(d === "." ? "0." : d),
      M
    );
    return O ? /* @__PURE__ */ D(
      Eo,
      {
        position: "end",
        sx: {
          position: "absolute",
          top: "38px",
          margin: 0
        },
        children: /* @__PURE__ */ D(Tt, { alignItems: "start", children: /* @__PURE__ */ D(
          Fe,
          {
            color: o.palette.text.secondary,
            component: "span",
            fontSize: "14px",
            lineHeight: "14px",
            children: O
          }
        ) })
      }
    ) : null;
  }, [d, C, M, o.palette.text.secondary]), E = ht(
    (O) => {
      t(Hs(O)), l(O);
    },
    [t]
  ), j = Ce(() => {
    const O = N || !c.address || !e.tokenBalance;
    return /* @__PURE__ */ D(
      Oi,
      {
        sx: { minWidth: "32px", padding: "4px" },
        disabled: O,
        onClick: () => {
          if (e.tokenBalance) {
            const z = cr(e.tokenBalance);
            S(z), E(z);
          }
        },
        children: /* @__PURE__ */ D(
          Fe,
          {
            fontSize: 14,
            fontWeight: O ? 400 : 600,
            textTransform: "none",
            children: "Max"
          }
        )
      }
    );
  }, [
    N,
    c.address,
    e.tokenBalance,
    S,
    E
  ]);
  return /* @__PURE__ */ ne(wt, { sx: i.amountContainer, children: [
    /* @__PURE__ */ D(wt, { sx: i.amountTitle, children: /* @__PURE__ */ D(Fe, { variant: "body2", children: "Amount" }) }),
    /* @__PURE__ */ D(
      bn,
      {
        sx: [i.amountInput, d === "" && i.amountInputEmpty],
        children: /* @__PURE__ */ D(xn, { sx: i.amountCardContent, children: /* @__PURE__ */ D(
          H_,
          {
            fullWidth: !0,
            disabled: N,
            inputProps: {
              style: {
                color: e.error ? o.palette.error.main : o.palette.text.primary,
                fontSize: 24,
                height: "28px",
                marginBottom: T ? "16px" : 0
                // make sure there is enough space for token price
              },
              onWheel: (O) => {
                O.currentTarget.blur();
              },
              step: "0.1"
            },
            placeholder: "0",
            variant: "standard",
            value: p,
            onChange: S,
            onDebouncedChange: E,
            InputProps: {
              disableUnderline: !0,
              startAdornment: T,
              endAdornment: /* @__PURE__ */ D(Eo, { position: "end", children: /* @__PURE__ */ ne(Tt, { alignItems: "end", justifyContent: "space-between", children: [
                j,
                w
              ] }) })
            }
          }
        ) })
      }
    ),
    /* @__PURE__ */ D(
      Gs,
      {
        error: !!e.error,
        content: e.error || e.warning,
        show: !!e.error || !!e.warning,
        color: e.error ? o.palette.error.main : o.palette.grey.A400,
        sx: i.inputError
      }
    )
  ] });
};
function Q_(e) {
  return Bt("MuiCardActionArea", e);
}
const Fd = Ft("MuiCardActionArea", ["root", "focusVisible", "focusHighlight"]), V_ = (e) => {
  const {
    classes: t
  } = e;
  return Rt({
    root: ["root"],
    focusHighlight: ["focusHighlight"]
  }, Q_, t);
}, G_ = Ke(ko, {
  name: "MuiCardActionArea",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(kt(({
  theme: e
}) => ({
  display: "block",
  textAlign: "inherit",
  borderRadius: "inherit",
  // for Safari to work https://github.com/mui/material-ui/issues/36285.
  width: "100%",
  [`&:hover .${Fd.focusHighlight}`]: {
    opacity: (e.vars || e).palette.action.hoverOpacity,
    "@media (hover: none)": {
      opacity: 0
    }
  },
  [`&.${Fd.focusVisible} .${Fd.focusHighlight}`]: {
    opacity: (e.vars || e).palette.action.focusOpacity
  }
}))), $_ = Ke("span", {
  name: "MuiCardActionArea",
  slot: "FocusHighlight",
  overridesResolver: (e, t) => t.focusHighlight
})(kt(({
  theme: e
}) => ({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit",
  opacity: 0,
  backgroundColor: "currentcolor",
  transition: e.transitions.create("opacity", {
    duration: e.transitions.duration.short
  })
}))), Fo = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiCardActionArea"
  }), {
    children: c,
    className: n,
    focusVisibleClassName: d,
    slots: f = {},
    slotProps: p = {},
    ...l
  } = i, h = i, y = V_(h), M = {
    slots: f,
    slotProps: p
  }, [C, N] = qt("root", {
    elementType: G_,
    externalForwardedProps: {
      ...M,
      ...l
    },
    shouldForwardComponentProp: !0,
    ownerState: h,
    ref: o,
    className: It(y.root, n),
    additionalProps: {
      focusVisibleClassName: It(d, y.focusVisible)
    }
  }), [w, S] = qt("focusHighlight", {
    elementType: $_,
    externalForwardedProps: M,
    ownerState: h,
    ref: o,
    className: y.focusHighlight
  });
  return /* @__PURE__ */ ne(C, {
    ...N,
    children: [c, /* @__PURE__ */ D(w, {
      ...S
    })]
  });
});
fe.process.env.NODE_ENV !== "production" && (Fo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * @ignore
   */
  focusVisibleClassName: b.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: b.shape({
    focusHighlight: b.oneOfType([b.func, b.object]),
    root: b.oneOfType([b.func, b.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: b.shape({
    focusHighlight: b.elementType,
    root: b.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object])
});
function q_(e) {
  return Bt("MuiCardHeader", e);
}
const xc = Ft("MuiCardHeader", ["root", "avatar", "action", "content", "title", "subheader"]), J_ = (e) => {
  const {
    classes: t
  } = e;
  return Rt({
    root: ["root"],
    avatar: ["avatar"],
    action: ["action"],
    content: ["content"],
    title: ["title"],
    subheader: ["subheader"]
  }, q_, t);
}, X_ = Ke("div", {
  name: "MuiCardHeader",
  slot: "Root",
  overridesResolver: (e, t) => [{
    [`& .${xc.title}`]: t.title
  }, {
    [`& .${xc.subheader}`]: t.subheader
  }, t.root]
})({
  display: "flex",
  alignItems: "center",
  padding: 16
}), K_ = Ke("div", {
  name: "MuiCardHeader",
  slot: "Avatar",
  overridesResolver: (e, t) => t.avatar
})({
  display: "flex",
  flex: "0 0 auto",
  marginRight: 16
}), eB = Ke("div", {
  name: "MuiCardHeader",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  flex: "0 0 auto",
  alignSelf: "flex-start",
  marginTop: -4,
  marginRight: -8,
  marginBottom: -4
}), tB = Ke("div", {
  name: "MuiCardHeader",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})({
  flex: "1 1 auto",
  [`.${p6.root}:where(& .${xc.title})`]: {
    display: "block"
  },
  [`.${p6.root}:where(& .${xc.subheader})`]: {
    display: "block"
  }
}), Xs = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiCardHeader"
  }), {
    action: c,
    avatar: n,
    component: d = "div",
    disableTypography: f = !1,
    subheader: p,
    subheaderTypographyProps: l,
    title: h,
    titleTypographyProps: y,
    slots: M = {},
    slotProps: C = {},
    ...N
  } = i, w = {
    ...i,
    component: d,
    disableTypography: f
  }, S = J_(w), T = {
    slots: M,
    slotProps: {
      title: y,
      subheader: l,
      ...C
    }
  };
  let E = h;
  const [j, O] = qt("title", {
    className: S.title,
    elementType: Fe,
    externalForwardedProps: T,
    ownerState: w,
    additionalProps: {
      variant: n ? "body2" : "h5",
      component: "span"
    }
  });
  E != null && E.type !== Fe && !f && (E = /* @__PURE__ */ D(j, {
    ...O,
    children: E
  }));
  let z = p;
  const [k, H] = qt("subheader", {
    className: S.subheader,
    elementType: Fe,
    externalForwardedProps: T,
    ownerState: w,
    additionalProps: {
      variant: n ? "body2" : "body1",
      color: "textSecondary",
      component: "span"
    }
  });
  z != null && z.type !== Fe && !f && (z = /* @__PURE__ */ D(k, {
    ...H,
    children: z
  }));
  const [W, U] = qt("root", {
    ref: o,
    className: S.root,
    elementType: X_,
    externalForwardedProps: {
      ...T,
      ...N,
      component: d
    },
    ownerState: w
  }), [B, I] = qt("avatar", {
    className: S.avatar,
    elementType: K_,
    externalForwardedProps: T,
    ownerState: w
  }), [r, s] = qt("content", {
    className: S.content,
    elementType: tB,
    externalForwardedProps: T,
    ownerState: w
  }), [u, g] = qt("action", {
    className: S.action,
    elementType: eB,
    externalForwardedProps: T,
    ownerState: w
  });
  return /* @__PURE__ */ ne(W, {
    ...U,
    children: [n && /* @__PURE__ */ D(B, {
      ...I,
      children: n
    }), /* @__PURE__ */ ne(r, {
      ...s,
      children: [E, z]
    }), c && /* @__PURE__ */ D(u, {
      ...g,
      children: c
    })]
  });
});
fe.process.env.NODE_ENV !== "production" && (Xs.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display in the card header.
   */
  action: b.node,
  /**
   * The Avatar element to display.
   */
  avatar: b.node,
  /**
   * @ignore
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `title` text, and optional `subheader` text
   * with the Typography component.
   * @default false
   */
  disableTypography: b.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: b.shape({
    action: b.oneOfType([b.func, b.object]),
    avatar: b.oneOfType([b.func, b.object]),
    content: b.oneOfType([b.func, b.object]),
    root: b.oneOfType([b.func, b.object]),
    subheader: b.oneOfType([b.func, b.object]),
    title: b.oneOfType([b.func, b.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: b.shape({
    action: b.elementType,
    avatar: b.elementType,
    content: b.elementType,
    root: b.elementType,
    subheader: b.elementType,
    title: b.elementType
  }),
  /**
   * The content of the component.
   */
  subheader: b.node,
  /**
   * These props will be forwarded to the subheader
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.subheader` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  subheaderTypographyProps: b.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The content of the component.
   */
  title: b.node,
  /**
   * These props will be forwarded to the title
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.title` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  titleTypographyProps: b.object
});
function rB(e) {
  return Bt("MuiCollapse", e);
}
Ft("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
const nB = (e) => {
  const {
    orientation: t,
    classes: o
  } = e, i = {
    root: ["root", `${t}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${t}`],
    wrapperInner: ["wrapperInner", `${t}`]
  };
  return Rt(i, rB, o);
}, iB = Ke("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.orientation], o.state === "entered" && t.entered, o.state === "exited" && !o.in && o.collapsedSize === "0px" && t.hidden];
  }
})(kt(({
  theme: e
}) => ({
  height: 0,
  overflow: "hidden",
  transition: e.transitions.create("height"),
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      height: "auto",
      width: 0,
      transition: e.transitions.create("width")
    }
  }, {
    props: {
      state: "entered"
    },
    style: {
      height: "auto",
      overflow: "visible"
    }
  }, {
    props: {
      state: "entered",
      orientation: "horizontal"
    },
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.state === "exited" && !t.in && t.collapsedSize === "0px",
    style: {
      visibility: "hidden"
    }
  }]
}))), oB = Ke("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), aB = Ke("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (e, t) => t.wrapperInner
})({
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), xa = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiCollapse"
  }), {
    addEndListener: c,
    children: n,
    className: d,
    collapsedSize: f = "0px",
    component: p,
    easing: l,
    in: h,
    onEnter: y,
    onEntered: M,
    onEntering: C,
    onExit: N,
    onExited: w,
    onExiting: S,
    orientation: T = "vertical",
    style: E,
    timeout: j = Ug.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: O = Vn,
    ...z
  } = i, k = {
    ...i,
    orientation: T,
    collapsedSize: f
  }, H = nB(k), W = or(), U = uo(), B = ue.useRef(null), I = ue.useRef(), r = typeof f == "number" ? `${f}px` : f, s = T === "horizontal", u = s ? "width" : "height", g = ue.useRef(null), v = zr(o, g), A = (q) => (R) => {
    if (q) {
      const Q = g.current;
      R === void 0 ? q(Q) : q(Q, R);
    }
  }, L = () => B.current ? B.current[s ? "clientWidth" : "clientHeight"] : 0, m = A((q, R) => {
    B.current && s && (B.current.style.position = "absolute"), q.style[u] = r, y && y(q, R);
  }), a = A((q, R) => {
    const Q = L();
    B.current && s && (B.current.style.position = "");
    const {
      duration: $,
      easing: F
    } = wi({
      style: E,
      timeout: j,
      easing: l
    }, {
      mode: "enter"
    });
    if (j === "auto") {
      const P = W.transitions.getAutoHeightDuration(Q);
      q.style.transitionDuration = `${P}ms`, I.current = P;
    } else
      q.style.transitionDuration = typeof $ == "string" ? $ : `${$}ms`;
    q.style[u] = `${Q}px`, q.style.transitionTimingFunction = F, C && C(q, R);
  }), x = A((q, R) => {
    q.style[u] = "auto", M && M(q, R);
  }), V = A((q) => {
    q.style[u] = `${L()}px`, N && N(q);
  }), G = A(w), Z = A((q) => {
    const R = L(), {
      duration: Q,
      easing: $
    } = wi({
      style: E,
      timeout: j,
      easing: l
    }, {
      mode: "exit"
    });
    if (j === "auto") {
      const F = W.transitions.getAutoHeightDuration(R);
      q.style.transitionDuration = `${F}ms`, I.current = F;
    } else
      q.style.transitionDuration = typeof Q == "string" ? Q : `${Q}ms`;
    q.style[u] = r, q.style.transitionTimingFunction = $, S && S(q);
  });
  return /* @__PURE__ */ D(O, {
    in: h,
    onEnter: m,
    onEntered: x,
    onEntering: a,
    onExit: V,
    onExited: G,
    onExiting: Z,
    addEndListener: (q) => {
      j === "auto" && U.start(I.current || 0, q), c && c(g.current, q);
    },
    nodeRef: g,
    timeout: j === "auto" ? null : j,
    ...z,
    children: (q, {
      ownerState: R,
      ...Q
    }) => /* @__PURE__ */ D(iB, {
      as: p,
      className: It(H.root, d, {
        entered: H.entered,
        exited: !h && r === "0px" && H.hidden
      }[q]),
      style: {
        [s ? "minWidth" : "minHeight"]: r,
        ...E
      },
      ref: v,
      ownerState: {
        ...k,
        state: q
      },
      ...Q,
      children: /* @__PURE__ */ D(oB, {
        ownerState: {
          ...k,
          state: q
        },
        className: H.wrapper,
        ref: B,
        children: /* @__PURE__ */ D(aB, {
          ownerState: {
            ...k,
            state: q
          },
          className: H.wrapperInner,
          children: n
        })
      })
    })
  });
});
fe.process.env.NODE_ENV !== "production" && (xa.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: b.func,
  /**
   * The content node to be collapsed.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: b.oneOfType([b.number, b.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Fi,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: b.oneOfType([b.shape({
    enter: b.string,
    exit: b.string
  }), b.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: b.bool,
  /**
   * @ignore
   */
  onEnter: b.func,
  /**
   * @ignore
   */
  onEntered: b.func,
  /**
   * @ignore
   */
  onEntering: b.func,
  /**
   * @ignore
   */
  onExit: b.func,
  /**
   * @ignore
   */
  onExited: b.func,
  /**
   * @ignore
   */
  onExiting: b.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: b.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  style: b.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: b.oneOfType([b.oneOf(["auto"]), b.number, b.shape({
    appear: b.number,
    enter: b.number,
    exit: b.number
  })])
});
xa && (xa.muiSupportAuto = !0);
function sB(e) {
  return Bt("MuiDivider", e);
}
Ft("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]);
const cB = (e) => {
  const {
    absolute: t,
    children: o,
    classes: i,
    flexItem: c,
    light: n,
    orientation: d,
    textAlign: f,
    variant: p
  } = e;
  return Rt({
    root: ["root", t && "absolute", p, n && "light", d === "vertical" && "vertical", c && "flexItem", o && "withChildren", o && d === "vertical" && "withChildrenVertical", f === "right" && d !== "vertical" && "textAlignRight", f === "left" && d !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", d === "vertical" && "wrapperVertical"]
  }, sB, i);
}, lB = Ke("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.absolute && t.absolute, t[o.variant], o.light && t.light, o.orientation === "vertical" && t.vertical, o.flexItem && t.flexItem, o.children && t.withChildren, o.children && o.orientation === "vertical" && t.withChildrenVertical, o.textAlign === "right" && o.orientation !== "vertical" && t.textAlignRight, o.textAlign === "left" && o.orientation !== "vertical" && t.textAlignLeft];
  }
})(kt(({
  theme: e
}) => ({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (e.vars || e).palette.divider,
  borderBottomWidth: "thin",
  variants: [{
    props: {
      absolute: !0
    },
    style: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%"
    }
  }, {
    props: {
      light: !0
    },
    style: {
      borderColor: e.vars ? `rgba(${e.vars.palette.dividerChannel} / 0.08)` : ur(e.palette.divider, 0.08)
    }
  }, {
    props: {
      variant: "inset"
    },
    style: {
      marginLeft: 72
    }
  }, {
    props: {
      variant: "middle",
      orientation: "horizontal"
    },
    style: {
      marginLeft: e.spacing(2),
      marginRight: e.spacing(2)
    }
  }, {
    props: {
      variant: "middle",
      orientation: "vertical"
    },
    style: {
      marginTop: e.spacing(1),
      marginBottom: e.spacing(1)
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      borderBottomWidth: 0,
      borderRightWidth: "thin"
    }
  }, {
    props: {
      flexItem: !0
    },
    style: {
      alignSelf: "stretch",
      height: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.children,
    style: {
      display: "flex",
      textAlign: "center",
      border: 0,
      borderTopStyle: "solid",
      borderLeftStyle: "solid",
      "&::before, &::after": {
        content: '""',
        alignSelf: "center"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.children && t.orientation !== "vertical",
    style: {
      "&::before, &::after": {
        width: "100%",
        borderTop: `thin solid ${(e.vars || e).palette.divider}`,
        borderTopStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.orientation === "vertical" && t.children,
    style: {
      flexDirection: "column",
      "&::before, &::after": {
        height: "100%",
        borderLeft: `thin solid ${(e.vars || e).palette.divider}`,
        borderLeftStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "right" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "90%"
      },
      "&::after": {
        width: "10%"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "left" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "10%"
      },
      "&::after": {
        width: "90%"
      }
    }
  }]
}))), fB = Ke("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.wrapper, o.orientation === "vertical" && t.wrapperVertical];
  }
})(kt(({
  theme: e
}) => ({
  display: "inline-block",
  paddingLeft: `calc(${e.spacing(1)} * 1.2)`,
  paddingRight: `calc(${e.spacing(1)} * 1.2)`,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      paddingTop: `calc(${e.spacing(1)} * 1.2)`,
      paddingBottom: `calc(${e.spacing(1)} * 1.2)`
    }
  }]
}))), Ui = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiDivider"
  }), {
    absolute: c = !1,
    children: n,
    className: d,
    orientation: f = "horizontal",
    component: p = n || f === "vertical" ? "div" : "hr",
    flexItem: l = !1,
    light: h = !1,
    role: y = p !== "hr" ? "separator" : void 0,
    textAlign: M = "center",
    variant: C = "fullWidth",
    ...N
  } = i, w = {
    ...i,
    absolute: c,
    component: p,
    flexItem: l,
    light: h,
    orientation: f,
    role: y,
    textAlign: M,
    variant: C
  }, S = cB(w);
  return /* @__PURE__ */ D(lB, {
    as: p,
    className: It(S.root, d),
    role: y,
    ref: o,
    ownerState: w,
    "aria-orientation": y === "separator" && (p !== "hr" || f === "vertical") ? f : void 0,
    ...N,
    children: n ? /* @__PURE__ */ D(fB, {
      className: S.wrapper,
      ownerState: w,
      children: n
    }) : null
  });
});
Ui && (Ui.muiSkipListHighlight = !0);
fe.process.env.NODE_ENV !== "production" && (Ui.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: b.bool,
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: b.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  light: b.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: b.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: b.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: b.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: b.oneOfType([b.oneOf(["fullWidth", "inset", "middle"]), b.string])
});
const Ym = (e) => {
  const { destToken: t, route: o, isTransactionInProgress: i } = e, c = i, n = !!o && ge.routes.get(o).NATIVE_GAS_DROPOFF_SUPPORTED && !(t != null && t.isNativeGasToken);
  return {
    disabled: c,
    showGasSlider: n
  };
}, Wm = dn(
  /* @__PURE__ */ ne(
    "svg",
    {
      width: "34",
      height: "35",
      viewBox: "0 0 34 35",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("circle", { opacity: "0.1", cx: "17", cy: "17.5", r: "17", fill: "currentColor" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M17 11C13.1386 11 10 14.1386 10 18C10 21.8614 13.1386 25 17 25C20.8614 25 24 21.8614 24 18C24 14.1386 20.8614 11 17 11ZM17 24.0233C13.6791 24.0233 10.9767 21.3209 10.9767 18C10.9767 14.6791 13.6791 11.9767 17 11.9767C20.3209 11.9767 23.0233 14.6791 23.0233 18C23.0233 21.3209 20.3209 24.0233 17 24.0233ZM16.5116 18.6512V14.7442C16.5116 14.4772 16.733 14.2558 17 14.2558C17.267 14.2558 17.4884 14.4772 17.4884 14.7442V18.6512C17.4884 18.9181 17.267 19.1395 17 19.1395C16.733 19.1395 16.5116 18.9181 16.5116 18.6512ZM17.814 20.9302C17.814 21.3795 17.4493 21.7442 17 21.7442C16.5507 21.7442 16.186 21.3795 16.186 20.9302C16.186 20.4809 16.5507 20.1163 17 20.1163C17.4493 20.1163 17.814 20.4809 17.814 20.9302Z",
            fill: "currentColor"
          }
        )
      ]
    }
  ),
  "Error"
), sa = dn(
  /* @__PURE__ */ ne(
    "svg",
    {
      width: "34",
      height: "35",
      viewBox: "0 0 34 35",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("circle", { opacity: "0.1", cx: "17", cy: "17.5", r: "17", fill: "currentColor" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M17 10.5C13.1386 10.5 10 13.6386 10 17.5C10 21.3614 13.1386 24.5 17 24.5C20.8614 24.5 24 21.3614 24 17.5C24 13.6386 20.8614 10.5 17 10.5ZM17 23.5233C13.6791 23.5233 10.9767 20.8209 10.9767 17.5C10.9767 14.1791 13.6791 11.4767 17 11.4767C20.3209 11.4767 23.0233 14.1791 23.0233 17.5C23.0233 20.8209 20.3209 23.5233 17 23.5233ZM16.5116 18.1512V14.2442C16.5116 13.9772 16.733 13.7558 17 13.7558C17.267 13.7558 17.4884 13.9772 17.4884 14.2442V18.1512C17.4884 18.4181 17.267 18.6395 17 18.6395C16.733 18.6395 16.5116 18.4181 16.5116 18.1512ZM17.814 20.4302C17.814 20.8795 17.4493 21.2442 17 21.2442C16.5507 21.2442 16.186 20.8795 16.186 20.4302C16.186 19.9809 16.5507 19.6163 17 19.6163C17.4493 19.6163 17.814 19.9809 17.814 20.4302Z",
            fill: "currentColor"
          }
        )
      ]
    }
  ),
  "Warning"
), Hm = dn(
  /* @__PURE__ */ D(
    "svg",
    {
      width: "9",
      height: "14",
      viewBox: "0 0 9 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ D("path", { d: "M8.9,5.7c0-.1-.2-.2-.4-.2h-4c-.3,0-.5-.2-.5-.4V0L0,7.9c0,.1,0,.3,0,.4,0,.1.2.2.4.2h4c.3,0,.5.2.5.4v5.1l4-7.9c0-.1,0-.3,0-.4Z" })
    }
  ),
  "Fastest"
), Zm = dn(
  /* @__PURE__ */ D(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ D(
        "path",
        {
          d: "M8 0C3.58176 0 0 3.58175 0 8C0 12.4182 3.58176 16 8 16C12.4182 16 16 12.4182 16 8C16 3.58175 12.4182 0 8 0ZM8 3.2C8.35347 3.2 8.64 3.48653 8.64 3.84V4.24C9.47859 4.42669 10.1222 4.95047 10.47 5.53C10.5134 5.60223 10.5421 5.68231 10.5545 5.76562C10.5669 5.84894 10.5627 5.93388 10.5423 6.01561C10.5219 6.09733 10.4856 6.17423 10.4354 6.24191C10.3853 6.3096 10.3223 6.36674 10.25 6.41008C10.1778 6.45342 10.0977 6.48212 10.0144 6.49451C9.9311 6.50691 9.84615 6.50276 9.76443 6.48232C9.68271 6.46189 9.60581 6.42555 9.53813 6.37539C9.47045 6.32523 9.41332 6.26224 9.36998 6.19C9.23664 5.96766 8.98048 5.72765 8.64 5.58V7.54C8.96957 7.65606 9.30963 7.78298 9.64998 7.99002C10.1285 8.28109 10.56 8.87142 10.56 9.6C10.56 10.2691 10.2489 10.8727 9.76998 11.26C9.44806 11.5204 9.06211 11.6949 8.64 11.78V12.16C8.64 12.5135 8.35347 12.8 8 12.8C7.64656 12.8 7.36 12.5135 7.36 12.16V11.76C6.52138 11.5708 5.87776 11.0396 5.52998 10.46C5.44248 10.3141 5.41651 10.1395 5.45778 9.97445C5.49904 9.80943 5.60417 9.66755 5.75004 9.58004C5.8959 9.49252 6.07055 9.46654 6.23558 9.50779C6.4006 9.54904 6.54248 9.65415 6.63002 9.8C6.76342 10.0223 7.01949 10.2694 7.36 10.42V8.45002C7.0304 8.33396 6.69037 8.20707 6.35002 8C5.87149 7.7089 5.44 7.12858 5.44 6.4C5.44 5.73091 5.75114 5.11733 6.23002 4.73C6.55184 4.46974 6.93808 4.30211 7.36 4.22V3.84C7.36 3.48653 7.64656 3.2 8 3.2ZM7.36 5.55C7.23514 5.59806 7.1264 5.66014 7.04 5.73C6.82934 5.90037 6.72 6.09974 6.72 6.4C6.72 6.73619 6.77373 6.76018 7.02 6.91C7.10707 6.96296 7.22624 7.01659 7.36 7.07V5.55ZM8.64 8.92V10.44C8.76483 10.39 8.8736 10.3299 8.96 10.26C9.17062 10.0896 9.28 9.90026 9.28 9.6C9.28 9.26381 9.22627 9.22982 8.98 9.08C8.89293 9.02704 8.77373 8.97341 8.64 8.92Z",
          fill: "currentColor"
        }
      )
    }
  ),
  "CheapestRoute"
), Qm = an(/* @__PURE__ */ D("path", {
  d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), "InfoOutlined");
function uB(e) {
  return Bt("PrivateSwitchBase", e);
}
Ft("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const dB = (e) => {
  const {
    classes: t,
    checked: o,
    disabled: i,
    edge: c
  } = e, n = {
    root: ["root", o && "checked", i && "disabled", c && `edge${it(c)}`],
    input: ["input"]
  };
  return Rt(n, uB, t);
}, hB = Ke(ko, {
  name: "MuiSwitchBase"
})({
  padding: 9,
  borderRadius: "50%",
  variants: [{
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "start" && t.size !== "small",
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "end" && t.size !== "small",
    style: {
      marginRight: -12
    }
  }]
}), pB = Ke("input", {
  name: "MuiSwitchBase",
  shouldForwardProp: hn
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), Vm = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const {
    autoFocus: i,
    checked: c,
    checkedIcon: n,
    defaultChecked: d,
    disabled: f,
    disableFocusRipple: p = !1,
    edge: l = !1,
    icon: h,
    id: y,
    inputProps: M,
    inputRef: C,
    name: N,
    onBlur: w,
    onChange: S,
    onFocus: T,
    readOnly: E,
    required: j = !1,
    tabIndex: O,
    type: z,
    value: k,
    slots: H = {},
    slotProps: W = {},
    ...U
  } = t, [B, I] = X0({
    controlled: c,
    default: !!d,
    name: "SwitchBase",
    state: "checked"
  }), r = qi(), s = (te) => {
    T && T(te), r && r.onFocus && r.onFocus(te);
  }, u = (te) => {
    w && w(te), r && r.onBlur && r.onBlur(te);
  }, g = (te) => {
    if (te.nativeEvent.defaultPrevented)
      return;
    const q = te.target.checked;
    I(q), S && S(te, q);
  };
  let v = f;
  r && typeof v > "u" && (v = r.disabled);
  const A = z === "checkbox" || z === "radio", L = {
    ...t,
    checked: B,
    disabled: v,
    disableFocusRipple: p,
    edge: l
  }, m = dB(L), a = {
    slots: H,
    slotProps: {
      input: M,
      ...W
    }
  }, [x, V] = qt("root", {
    ref: o,
    elementType: hB,
    className: m.root,
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      ...a,
      component: "span",
      ...U
    },
    getSlotProps: (te) => ({
      ...te,
      onFocus: (q) => {
        var R;
        (R = te.onFocus) == null || R.call(te, q), s(q);
      },
      onBlur: (q) => {
        var R;
        (R = te.onBlur) == null || R.call(te, q), u(q);
      }
    }),
    ownerState: L,
    additionalProps: {
      centerRipple: !0,
      focusRipple: !p,
      disabled: v,
      role: void 0,
      tabIndex: null
    }
  }), [G, Z] = qt("input", {
    ref: C,
    elementType: pB,
    className: m.input,
    externalForwardedProps: a,
    getSlotProps: (te) => ({
      onChange: (q) => {
        var R;
        (R = te.onChange) == null || R.call(te, q), g(q);
      }
    }),
    ownerState: L,
    additionalProps: {
      autoFocus: i,
      checked: c,
      defaultChecked: d,
      disabled: v,
      id: A ? y : void 0,
      name: N,
      readOnly: E,
      required: j,
      tabIndex: O,
      type: z,
      ...z === "checkbox" && k === void 0 ? {} : {
        value: k
      }
    }
  });
  return /* @__PURE__ */ ne(x, {
    ...V,
    children: [/* @__PURE__ */ D(G, {
      ...Z
    }), B ? n : h]
  });
});
fe.process.env.NODE_ENV !== "production" && (Vm.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: b.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: b.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: b.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * @ignore
   */
  defaultChecked: b.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: b.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: b.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: b.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: b.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: b.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: b.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: En,
  /*
   * @ignore
   */
  name: b.string,
  /**
   * @ignore
   */
  onBlur: b.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: b.func,
  /**
   * @ignore
   */
  onFocus: b.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: b.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: b.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: b.shape({
    input: b.oneOfType([b.func, b.object]),
    root: b.oneOfType([b.func, b.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: b.shape({
    input: b.elementType,
    root: b.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.object,
  /**
   * @ignore
   */
  tabIndex: b.oneOfType([b.number, b.string]),
  /**
   * The input component prop `type`.
   */
  type: b.string.isRequired,
  /**
   * The value of the component.
   */
  value: b.any
});
function gB(e) {
  return Bt("MuiSwitch", e);
}
const sn = Ft("MuiSwitch", ["root", "edgeStart", "edgeEnd", "switchBase", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium", "checked", "disabled", "input", "thumb", "track"]), yB = (e) => {
  const {
    classes: t,
    edge: o,
    size: i,
    color: c,
    checked: n,
    disabled: d
  } = e, f = {
    root: ["root", o && `edge${it(o)}`, `size${it(i)}`],
    switchBase: ["switchBase", `color${it(c)}`, n && "checked", d && "disabled"],
    thumb: ["thumb"],
    track: ["track"],
    input: ["input"]
  }, p = Rt(f, gB, t);
  return {
    ...t,
    // forward the disabled and checked classes to the SwitchBase
    ...p
  };
}, MB = Ke("span", {
  name: "MuiSwitch",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.edge && t[`edge${it(o.edge)}`], t[`size${it(o.size)}`]];
  }
})({
  display: "inline-flex",
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: "hidden",
  padding: 12,
  boxSizing: "border-box",
  position: "relative",
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: "middle",
  // For correct alignment with the text.
  "@media print": {
    colorAdjust: "exact"
  },
  variants: [{
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -8
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -8
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      width: 40,
      height: 24,
      padding: 7,
      [`& .${sn.thumb}`]: {
        width: 16,
        height: 16
      },
      [`& .${sn.switchBase}`]: {
        padding: 4,
        [`&.${sn.checked}`]: {
          transform: "translateX(16px)"
        }
      }
    }
  }]
}), mB = Ke(Vm, {
  name: "MuiSwitch",
  slot: "SwitchBase",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.switchBase, {
      [`& .${sn.input}`]: t.input
    }, o.color !== "default" && t[`color${it(o.color)}`]];
  }
})(kt(({
  theme: e
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: e.vars ? e.vars.palette.Switch.defaultColor : `${e.palette.mode === "light" ? e.palette.common.white : e.palette.grey[300]}`,
  transition: e.transitions.create(["left", "transform"], {
    duration: e.transitions.duration.shortest
  }),
  [`&.${sn.checked}`]: {
    transform: "translateX(20px)"
  },
  [`&.${sn.disabled}`]: {
    color: e.vars ? e.vars.palette.Switch.defaultDisabledColor : `${e.palette.mode === "light" ? e.palette.grey[100] : e.palette.grey[600]}`
  },
  [`&.${sn.checked} + .${sn.track}`]: {
    opacity: 0.5
  },
  [`&.${sn.disabled} + .${sn.track}`]: {
    opacity: e.vars ? e.vars.opacity.switchTrackDisabled : `${e.palette.mode === "light" ? 0.12 : 0.2}`
  },
  [`& .${sn.input}`]: {
    left: "-100%",
    width: "300%"
  }
})), kt(({
  theme: e
}) => ({
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : ur(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  variants: [...Object.entries(e.palette).filter(Gr(["light"])).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${sn.checked}`]: {
        color: (e.vars || e).palette[t].main,
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : ur(e.palette[t].main, e.palette.action.hoverOpacity),
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        [`&.${sn.disabled}`]: {
          color: e.vars ? e.vars.palette.Switch[`${t}DisabledColor`] : `${e.palette.mode === "light" ? Ts(e.palette[t].main, 0.62) : As(e.palette[t].main, 0.55)}`
        }
      },
      [`&.${sn.checked} + .${sn.track}`]: {
        backgroundColor: (e.vars || e).palette[t].main
      }
    }
  }))]
}))), vB = Ke("span", {
  name: "MuiSwitch",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})(kt(({
  theme: e
}) => ({
  height: "100%",
  width: "100%",
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: e.transitions.create(["opacity", "background-color"], {
    duration: e.transitions.duration.shortest
  }),
  backgroundColor: e.vars ? e.vars.palette.common.onBackground : `${e.palette.mode === "light" ? e.palette.common.black : e.palette.common.white}`,
  opacity: e.vars ? e.vars.opacity.switchTrack : `${e.palette.mode === "light" ? 0.38 : 0.3}`
}))), bB = Ke("span", {
  name: "MuiSwitch",
  slot: "Thumb",
  overridesResolver: (e, t) => t.thumb
})(kt(({
  theme: e
}) => ({
  boxShadow: (e.vars || e).shadows[1],
  backgroundColor: "currentColor",
  width: 20,
  height: 20,
  borderRadius: "50%"
}))), e2 = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiSwitch"
  }), {
    className: c,
    color: n = "primary",
    edge: d = !1,
    size: f = "medium",
    sx: p,
    slots: l = {},
    slotProps: h = {},
    ...y
  } = i, M = {
    ...i,
    color: n,
    edge: d,
    size: f
  }, C = yB(M), N = {
    slots: l,
    slotProps: h
  }, [w, S] = qt("root", {
    className: It(C.root, c),
    elementType: MB,
    externalForwardedProps: N,
    ownerState: M,
    additionalProps: {
      sx: p
    }
  }), [T, E] = qt("thumb", {
    className: C.thumb,
    elementType: bB,
    externalForwardedProps: N,
    ownerState: M
  }), j = /* @__PURE__ */ D(T, {
    ...E
  }), [O, z] = qt("track", {
    className: C.track,
    elementType: vB,
    externalForwardedProps: N,
    ownerState: M
  });
  return /* @__PURE__ */ ne(w, {
    ...S,
    children: [/* @__PURE__ */ D(mB, {
      type: "checkbox",
      icon: j,
      checkedIcon: j,
      ref: o,
      ownerState: M,
      ...y,
      classes: {
        ...C,
        root: C.switchBase
      },
      slots: {
        ...l.switchBase && {
          root: l.switchBase
        },
        ...l.input && {
          input: l.input
        }
      },
      slotProps: {
        ...h.switchBase && {
          root: typeof h.switchBase == "function" ? h.switchBase(M) : h.switchBase
        },
        ...h.input && {
          input: typeof h.input == "function" ? h.input(M) : h.input
        }
      }
    }), /* @__PURE__ */ D(O, {
      ...z
    })]
  });
});
fe.process.env.NODE_ENV !== "production" && (e2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: b.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: b.oneOfType([b.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), b.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: b.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: b.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: b.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: b.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: b.node,
  /**
   * The id of the `input` element.
   */
  id: b.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: b.object,
  /**
   * Pass a ref to the `input` element.
   * @deprecated Use `slotProps.input.ref` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputRef: En,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: b.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: b.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: b.oneOfType([b.oneOf(["medium", "small"]), b.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: b.shape({
    input: b.oneOfType([b.func, b.object]),
    root: b.oneOfType([b.func, b.object]),
    switchBase: b.oneOfType([b.func, b.object]),
    thumb: b.oneOfType([b.func, b.object]),
    track: b.oneOfType([b.func, b.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: b.shape({
    input: b.elementType,
    root: b.elementType,
    switchBase: b.elementType,
    thumb: b.elementType,
    track: b.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: b.any
});
function xB(e) {
  return Bt("MuiToggleButton", e);
}
const go = Ft("MuiToggleButton", ["root", "disabled", "selected", "standard", "primary", "secondary", "sizeSmall", "sizeMedium", "sizeLarge", "fullWidth"]), t2 = /* @__PURE__ */ ue.createContext({});
fe.process.env.NODE_ENV !== "production" && (t2.displayName = "ToggleButtonGroupContext");
const r2 = /* @__PURE__ */ ue.createContext(void 0);
fe.process.env.NODE_ENV !== "production" && (r2.displayName = "ToggleButtonGroupButtonContext");
function wB(e, t) {
  return t === void 0 || e === void 0 ? !1 : Array.isArray(t) ? t.includes(e) : e === t;
}
const CB = (e) => {
  const {
    classes: t,
    fullWidth: o,
    selected: i,
    disabled: c,
    size: n,
    color: d
  } = e, f = {
    root: ["root", i && "selected", c && "disabled", o && "fullWidth", `size${it(n)}`, d]
  };
  return Rt(f, xB, t);
}, IB = Ke(ko, {
  name: "MuiToggleButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[`size${it(o.size)}`]];
  }
})(kt(({
  theme: e
}) => ({
  ...e.typography.button,
  borderRadius: (e.vars || e).shape.borderRadius,
  padding: 11,
  border: `1px solid ${(e.vars || e).palette.divider}`,
  color: (e.vars || e).palette.action.active,
  [`&.${go.disabled}`]: {
    color: (e.vars || e).palette.action.disabled,
    border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
  },
  "&:hover": {
    textDecoration: "none",
    // Reset on mouse devices
    backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : ur(e.palette.text.primary, e.palette.action.hoverOpacity),
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  variants: [{
    props: {
      color: "standard"
    },
    style: {
      [`&.${go.selected}`]: {
        color: (e.vars || e).palette.text.primary,
        backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.selectedOpacity})` : ur(e.palette.text.primary, e.palette.action.selectedOpacity),
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : ur(e.palette.text.primary, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.selectedOpacity})` : ur(e.palette.text.primary, e.palette.action.selectedOpacity)
          }
        }
      }
    }
  }, ...Object.entries(e.palette).filter(Gr()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${go.selected}`]: {
        color: (e.vars || e).palette[t].main,
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.selectedOpacity})` : ur(e.palette[t].main, e.palette.action.selectedOpacity),
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : ur(e.palette[t].main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.selectedOpacity})` : ur(e.palette[t].main, e.palette.action.selectedOpacity)
          }
        }
      }
    }
  })), {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      padding: 7,
      fontSize: e.typography.pxToRem(13)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 15,
      fontSize: e.typography.pxToRem(15)
    }
  }]
}))), wo = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const {
    value: i,
    ...c
  } = ue.useContext(t2), n = ue.useContext(r2), d = cs({
    ...c,
    selected: wB(t.value, i)
  }, t), f = Pt({
    props: d,
    name: "MuiToggleButton"
  }), {
    children: p,
    className: l,
    color: h = "standard",
    disabled: y = !1,
    disableFocusRipple: M = !1,
    fullWidth: C = !1,
    onChange: N,
    onClick: w,
    selected: S,
    size: T = "medium",
    value: E,
    ...j
  } = f, O = {
    ...f,
    color: h,
    disabled: y,
    disableFocusRipple: M,
    fullWidth: C,
    size: T
  }, z = CB(O), k = (W) => {
    w && (w(W, E), W.defaultPrevented) || N && N(W, E);
  }, H = n || "";
  return /* @__PURE__ */ D(IB, {
    className: It(c.className, z.root, l, H),
    disabled: y,
    focusRipple: !M,
    ref: o,
    onClick: k,
    onChange: N,
    value: E,
    ownerState: O,
    "aria-pressed": S,
    ...j,
    children: p
  });
});
fe.process.env.NODE_ENV !== "production" && (wo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The color of the button when it is in an active state.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: b.oneOfType([b.oneOf(["standard", "primary", "secondary", "error", "info", "success", "warning"]), b.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: b.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: b.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: b.bool,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: b.bool,
  /**
   * Callback fired when the state changes.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected button.
   */
  onChange: b.func,
  /**
   * Callback fired when the button is clicked.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected button.
   */
  onClick: b.func,
  /**
   * If `true`, the button is rendered in an active state.
   */
  selected: b.bool,
  /**
   * The size of the component.
   * The prop defaults to the value inherited from the parent ToggleButtonGroup component.
   * @default 'medium'
   */
  size: b.oneOfType([b.oneOf(["small", "medium", "large"]), b.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The value to associate with the button when selected in a
   * ToggleButtonGroup.
   */
  value: b.any.isRequired
});
function NB(e) {
  return Bt("MuiToggleButtonGroup", e);
}
const Ir = Ft("MuiToggleButtonGroup", ["root", "selected", "horizontal", "vertical", "disabled", "grouped", "groupedHorizontal", "groupedVertical", "fullWidth", "firstButton", "lastButton", "middleButton"]), AB = (e) => {
  const {
    classes: t,
    orientation: o,
    fullWidth: i,
    disabled: c
  } = e, n = {
    root: ["root", o, i && "fullWidth"],
    grouped: ["grouped", `grouped${it(o)}`, c && "disabled"],
    firstButton: ["firstButton"],
    lastButton: ["lastButton"],
    middleButton: ["middleButton"]
  };
  return Rt(n, NB, t);
}, TB = Ke("div", {
  name: "MuiToggleButtonGroup",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [{
      [`& .${Ir.grouped}`]: t.grouped
    }, {
      [`& .${Ir.grouped}`]: t[`grouped${it(o.orientation)}`]
    }, {
      [`& .${Ir.firstButton}`]: t.firstButton
    }, {
      [`& .${Ir.lastButton}`]: t.lastButton
    }, {
      [`& .${Ir.middleButton}`]: t.middleButton
    }, t.root, o.orientation === "vertical" && t.vertical, o.fullWidth && t.fullWidth];
  }
})(kt(({
  theme: e
}) => ({
  display: "inline-flex",
  borderRadius: (e.vars || e).shape.borderRadius,
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      flexDirection: "column",
      [`& .${Ir.grouped}`]: {
        [`&.${Ir.selected} + .${Ir.grouped}.${Ir.selected}`]: {
          borderTop: 0,
          marginTop: 0
        }
      },
      [`& .${Ir.firstButton},& .${Ir.middleButton}`]: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
      },
      [`& .${Ir.lastButton},& .${Ir.middleButton}`]: {
        marginTop: -1,
        borderTop: "1px solid transparent",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0
      },
      [`& .${Ir.lastButton}.${go.disabled},& .${Ir.middleButton}.${go.disabled}`]: {
        borderTop: "1px solid transparent"
      }
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      [`& .${Ir.grouped}`]: {
        [`&.${Ir.selected} + .${Ir.grouped}.${Ir.selected}`]: {
          borderLeft: 0,
          marginLeft: 0
        }
      },
      [`& .${Ir.firstButton},& .${Ir.middleButton}`]: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      },
      [`& .${Ir.lastButton},& .${Ir.middleButton}`]: {
        marginLeft: -1,
        borderLeft: "1px solid transparent",
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      [`& .${Ir.lastButton}.${go.disabled},& .${Ir.middleButton}.${go.disabled}`]: {
        borderLeft: "1px solid transparent"
      }
    }
  }]
}))), n2 = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiToggleButtonGroup"
  }), {
    children: c,
    className: n,
    color: d = "standard",
    disabled: f = !1,
    exclusive: p = !1,
    fullWidth: l = !1,
    onChange: h,
    orientation: y = "horizontal",
    size: M = "medium",
    value: C,
    ...N
  } = i, w = {
    ...i,
    disabled: f,
    fullWidth: l,
    orientation: y,
    size: M
  }, S = AB(w), T = ue.useCallback((H, W) => {
    if (!h)
      return;
    const U = C && C.indexOf(W);
    let B;
    C && U >= 0 ? (B = C.slice(), B.splice(U, 1)) : B = C ? C.concat(W) : [W], h(H, B);
  }, [h, C]), E = ue.useCallback((H, W) => {
    h && h(H, C === W ? null : W);
  }, [h, C]), j = ue.useMemo(() => ({
    className: S.grouped,
    onChange: p ? E : T,
    value: C,
    size: M,
    fullWidth: l,
    color: d,
    disabled: f
  }), [S.grouped, p, E, T, C, M, l, d, f]), O = Uv(c), z = O.length, k = (H) => {
    const W = H === 0, U = H === z - 1;
    return W && U ? "" : W ? S.firstButton : U ? S.lastButton : S.middleButton;
  };
  return /* @__PURE__ */ D(TB, {
    role: "group",
    className: It(S.root, n),
    ref: o,
    ownerState: w,
    ...N,
    children: /* @__PURE__ */ D(t2.Provider, {
      value: j,
      children: O.map((H, W) => (fe.process.env.NODE_ENV !== "production" && _i.isFragment(H) && console.error(["MUI: The ToggleButtonGroup component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), /* @__PURE__ */ D(r2.Provider, {
        value: k(W),
        children: H
      }, W)))
    })
  });
});
fe.process.env.NODE_ENV !== "production" && (n2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The color of the button when it is selected.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: b.oneOfType([b.oneOf(["standard", "primary", "secondary", "error", "info", "success", "warning"]), b.string]),
  /**
   * If `true`, the component is disabled. This implies that all ToggleButton children will be disabled.
   * @default false
   */
  disabled: b.bool,
  /**
   * If `true`, only allow one of the child ToggleButton values to be selected.
   * @default false
   */
  exclusive: b.bool,
  /**
   * If `true`, the button group will take up the full width of its container.
   * @default false
   */
  fullWidth: b.bool,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected buttons. When `exclusive` is true
   * this is a single value; when false an array of selected values. If no value
   * is selected and `exclusive` is true the value is null; when false an empty array.
   */
  onChange: b.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: b.oneOf(["horizontal", "vertical"]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: b.oneOfType([b.oneOf(["small", "medium", "large"]), b.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The currently selected value within the group or an array of selected
   * values when `exclusive` is false.
   *
   * The value must have reference equality with the option in order to be selected.
   */
  value: b.any
});
const LB = (e) => {
  const t = Cr(), o = or(), i = Ce(
    () => ({
      content: {
        width: "100%",
        cursor: "pointer",
        maxWidth: "420px",
        overflow: "visible",
        padding: "16px 20px"
      },
      container: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        width: "100%"
      },
      amounts: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: "8px",
        width: "100%"
      },
      toggleButton: {
        backgroundColor: Mr(o.palette.text.primary).alpha(0.1).hexa(),
        border: "1px solid transparent",
        borderRadius: "8px",
        "&.Mui-selected": {
          border: `1px solid ${o.palette.primary.main}`,
          borderRadius: "8px"
        },
        "&.MuiToggleButtonGroup-middleButton": {
          margin: "0 2px"
        },
        "&.MuiToggleButtonGroup-lastButton": {
          margin: "0"
        }
      }
    }),
    [o]
  ), { fromChain: c, toChain: n } = Ut(
    (S) => S.transferInput
  ), { getTokenPrice: d, lastTokenPriceUpdate: f } = Hr(), p = ge.tokens.getGasToken(n), l = ge.tokens.getGasToken(c), [h, y] = Xe(!1), [M, C] = Xe(0);
  St(() => {
    e.isSelected || (y(!1), C(0));
  }, [t, e.isSelected]), St(() => {
    t(I8(M / 100));
  }, [M, t]);
  const N = Ce(() => {
    if (!n || !p)
      return null;
    const S = cr(
      vn(e.destinationGasDrop, 6)
    ), T = In(
      d,
      e.destinationGasDrop,
      p
    ), E = T ? `(${T})` : "";
    return `+${S} ${p.symbol} ${E}`;
  }, [p, f, e.destinationGasDrop, n]), w = Ce(
    () => /* @__PURE__ */ ne(
      n2,
      {
        exclusive: !0,
        fullWidth: !0,
        value: M.toString(),
        onChange: (S) => {
          const T = Number(S.currentTarget.value);
          C(T === M ? 0 : T);
        },
        children: [
          /* @__PURE__ */ D(wo, { sx: i.toggleButton, disableRipple: !0, value: "5", children: "5%" }),
          /* @__PURE__ */ D(wo, { sx: i.toggleButton, disableRipple: !0, value: "10", children: "10%" }),
          /* @__PURE__ */ D(wo, { sx: i.toggleButton, disableRipple: !0, value: "15", children: "15%" })
        ]
      }
    ),
    [i.toggleButton, M]
  );
  return !l || !p ? /* @__PURE__ */ D(Et, {}) : /* @__PURE__ */ ne(ut, { sx: i.content, children: [
    /* @__PURE__ */ ne(yo, { direction: "row", alignItems: "center", justifyContent: "space-between", children: [
      /* @__PURE__ */ D(ln, { children: `Need extra ${p.symbol} on ${n}?` }),
      /* @__PURE__ */ D(
        e2,
        {
          sx: {
            padding: "9px 12px",
            right: "-9px",
            "& .MuiSwitch-switchBase.Mui-checked": {
              color: o.palette.primary.main
            },
            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
              backgroundColor: o.palette.primary.main
            },
            "& .MuiSwitch-track": {
              height: "20px",
              borderRadius: "9px"
            }
          },
          checked: h,
          disabled: e.disabled,
          onClick: (S) => {
            const { checked: T } = S.target;
            y(T), T ? e.isExecutorRoute && C(100) : C(0);
          }
        }
      )
    ] }),
    /* @__PURE__ */ D(xa, { in: h, unmountOnExit: !0, children: /* @__PURE__ */ D(ut, { sx: i.container, children: /* @__PURE__ */ ne(yo, { children: [
      !e.isExecutorRoute && w,
      /* @__PURE__ */ ne(ut, { sx: i.amounts, children: [
        /* @__PURE__ */ ne(yo, { alignItems: "center", flexDirection: "row", children: [
          /* @__PURE__ */ D(
            ln,
            {
              color: o.palette.text.secondary,
              fontSize: 14,
              marginRight: "4px",
              children: "Gas amount"
            }
          ),
          /* @__PURE__ */ D(
            $n,
            {
              title: e.isExecutorRoute ? `Add a small amount of ${l.symbol} to your transaction to receive ${N} on ${n}.` : "This additional gas is swapped from a percentage of your transfer amount.",
              children: /* @__PURE__ */ D(
                Qm,
                {
                  sx: {
                    color: o.palette.text.secondary,
                    fontSize: "16px"
                  }
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ D(ln, { color: o.palette.primary.main, fontSize: 14, children: N })
      ] })
    ] }) }) })
  ] });
}, SB = 20, EB = (e) => {
  const t = er(), o = Ce(
    () => ({
      container: {
        width: "100%",
        maxWidth: "420px",
        marginBottom: "8px"
      },
      card: {
        borderRadius: "8px",
        width: "100%",
        maxWidth: "420px"
      },
      cardSelected: {
        backgroundColor: t.palette.input.fillTreatment ? Mr(t.palette.primary.main).alpha(0.05).hexa() : t.palette.card.background,
        borderColor: t.palette.primary.main
      },
      cardHeader: {
        padding: "20px 20px 0px"
      },
      cardContent: {
        marginTop: "18px",
        padding: "0px 20px 20px"
      },
      errorIcon: {
        color: t.palette.error.main,
        height: "34px",
        width: "34px",
        marginRight: "24px"
      },
      fastestBadge: {
        width: "14px",
        height: "14px",
        position: "relative",
        top: "2px",
        marginRight: "4px",
        fill: t.palette.primary.main
      },
      cheapestBadge: {
        width: "12px",
        height: "12px",
        position: "relative",
        top: "1px",
        marginRight: "3px",
        fill: t.palette.primary.main
      },
      messageContainer: {
        padding: "12px 0px 0px"
      },
      warningIcon: {
        color: t.palette.warning.main,
        height: "34px",
        width: "34px",
        marginRight: "12px"
      },
      disabled: {
        opacity: "0.6",
        cursor: "default",
        pointerEvents: "none"
      }
    }),
    [t]
  ), i = ge.routes.get(e.route), {
    toChain: c,
    fromChain: n,
    isTransactionInProgress: d
  } = Ut((u) => u.transferInput), { getTokenPrice: f, lastTokenPriceUpdate: p } = Hr(), { quote: l, isSelected: h } = e, y = l == null ? void 0 : l.destinationNativeGas, { sourceToken: M, destToken: C } = _o(), { disabled: N, showGasSlider: w } = Ym({
    destToken: C,
    route: e.route,
    isTransactionInProgress: d
  }), S = Ce(() => {
    if (!(l != null && l.relayFee))
      return !1;
    const u = oi(l.relayFee.amount), g = ge.tokens.get(l.relayFee.token), v = ri(f, u, g);
    return v === void 0 ? !1 : v > SB;
  }, [f, l == null ? void 0 : l.relayFee]), T = Ce(() => {
    if (!c || e.destinationGasDrop === void 0 || ai(e.destinationGasDrop) === 0n)
      return /* @__PURE__ */ D(Et, {});
    const u = ge.chains[c], g = ge.tokens.getGasToken(c);
    if (!u || !g)
      return /* @__PURE__ */ D(Et, {});
    const v = In(
      f,
      e.destinationGasDrop,
      g
    ), A = cr(
      vn(e.destinationGasDrop, 6)
    ), L = v ? ` (${v})` : "";
    return /* @__PURE__ */ ne(Tt, { direction: "row", justifyContent: "space-between", children: [
      /* @__PURE__ */ D(
        Fe,
        {
          color: t.palette.text.secondary,
          component: "div",
          fontSize: "14px",
          lineHeight: "14px",
          children: "Additional gas"
        }
      ),
      /* @__PURE__ */ D(
        Fe,
        {
          color: t.palette.text.primary,
          component: "div",
          fontSize: "14px",
          lineHeight: "14px",
          children: `${A} ${g.symbol}${L}`
        }
      )
    ] });
  }, [
    c,
    p,
    e.destinationGasDrop,
    f,
    p,
    t.palette.text.secondary,
    t.palette.text.primary
  ]), E = Ce(
    () => /* @__PURE__ */ ne(Tt, { direction: "row", justifyContent: "space-between", children: [
      /* @__PURE__ */ D(
        Fe,
        {
          color: t.palette.text.secondary,
          component: "div",
          fontSize: "14px",
          lineHeight: "14px",
          children: `Time to ${c}`
        }
      ),
      /* @__PURE__ */ D(
        Fe,
        {
          component: "div",
          fontSize: "14px",
          lineHeight: "14px",
          sx: {
            color: l != null && l.eta && l.eta < 60 * 1e3 ? t.palette.success.main : t.palette.text.primary
          },
          children: l != null && l.eta ? tl(l.eta) : "N/A"
        }
      )
    ] }),
    [
      c,
      l == null ? void 0 : l.eta,
      t.palette.success.main,
      t.palette.text.primary,
      t.palette.text.secondary
    ]
  ), j = Ce(() => e.route ? !i.AUTOMATIC_DEPOSIT : !1, [e.route, i.AUTOMATIC_DEPOSIT]), O = Ce(
    () => /* @__PURE__ */ D(Ui, { flexItem: !0, sx: { marginTop: "24px" } }),
    []
  ), z = Ce(() => e.error ? /* @__PURE__ */ ne(Et, { children: [
    O,
    /* @__PURE__ */ ne(Tt, { sx: o.messageContainer, direction: "row", alignItems: "center", children: [
      /* @__PURE__ */ D(Wm, { sx: o.errorIcon }),
      /* @__PURE__ */ D(
        Fe,
        {
          color: t.palette.error.main,
          fontSize: "14px",
          lineHeight: "18px",
          children: e.error
        }
      )
    ] })
  ] }) : null, [
    o.errorIcon,
    o.messageContainer,
    O,
    e.error,
    t.palette.error.main
  ]), k = Ce(() => {
    const u = [];
    j && u.push(
      /* @__PURE__ */ ne("div", { children: [
        O,
        /* @__PURE__ */ ne(
          Tt,
          {
            sx: o.messageContainer,
            direction: "row",
            alignItems: "center",
            children: [
              /* @__PURE__ */ D(sa, { sx: o.warningIcon }),
              /* @__PURE__ */ ne(Tt, { children: [
                /* @__PURE__ */ D(
                  Fe,
                  {
                    color: t.palette.warning.main,
                    fontSize: 14,
                    lineHeight: "18px",
                    children: "This transfer requires two transactions."
                  }
                ),
                /* @__PURE__ */ D(
                  Fe,
                  {
                    color: t.palette.text.secondary,
                    fontSize: 14,
                    lineHeight: "18px",
                    children: "You will need to make two wallet approvals and have gas on the destination chain."
                  }
                )
              ] })
            ]
          }
        )
      ] }, "ManualTransactionWarning")
    );
    for (const g of (l == null ? void 0 : l.warnings) || [])
      if (g.type === "DestinationCapacityWarning" && g.delayDurationSec) {
        const v = f8(g.delayDurationSec);
        u.push(
          /* @__PURE__ */ ne("div", { children: [
            O,
            /* @__PURE__ */ ne(
              Tt,
              {
                sx: o.messageContainer,
                direction: "row",
                alignItems: "center",
                children: [
                  /* @__PURE__ */ D(sa, { sx: o.warningIcon }),
                  /* @__PURE__ */ D(
                    Fe,
                    {
                      color: t.palette.warning.main,
                      fontSize: 14,
                      lineHeight: "18px",
                      children: `Your transfer to ${c} may be delayed due to rate limits set by ${C.display}. If your transfer is delayed, you will need to return after ${v} to complete the transfer. Please consider this before proceeding.`
                    }
                  )
                ]
              }
            )
          ] }, `${g.type}-${g.delayDurationSec}`)
        );
      }
    return S && u.push(
      /* @__PURE__ */ ne("div", { children: [
        O,
        /* @__PURE__ */ ne(
          Tt,
          {
            sx: o.messageContainer,
            direction: "row",
            alignItems: "center",
            children: [
              /* @__PURE__ */ D(sa, { sx: o.warningIcon }),
              /* @__PURE__ */ ne(Tt, { children: [
                /* @__PURE__ */ D(
                  Fe,
                  {
                    color: t.palette.warning.main,
                    fontSize: 14,
                    lineHeight: "18px",
                    children: "Output amount is much lower than input amount."
                  }
                ),
                /* @__PURE__ */ D(
                  Fe,
                  {
                    color: t.palette.text.secondary,
                    fontSize: 14,
                    lineHeight: "18px",
                    children: "Double check before proceeding."
                  }
                )
              ] })
            ]
          }
        )
      ] }, "HighFee")
    ), u;
  }, [
    j,
    S,
    O,
    o.warningIcon,
    o.messageContainer,
    t.palette.warning.main,
    t.palette.text.secondary,
    l == null ? void 0 : l.warnings,
    C,
    c
  ]), H = Ce(() => M ? e.route === "AutomaticNtt" && (M == null ? void 0 : M.symbol) === "wstETH" && (n === "Ethereum" && c === "Bsc" || n === "Bsc" && c === "Ethereum") ? "via NTT: Wormhole + Axelar" : i.rc.meta.provider ? `via ${i.rc.meta.provider}` : "" : "", [e.route, i, n, M, c]), W = Ce(() => l ? oi(l == null ? void 0 : l.destinationToken.amount) : void 0, [l]), U = Ce(() => {
    if (l)
      return cr(vn(l.destinationToken.amount, 6));
  }, [l]), B = Ce(() => {
    if (e.error)
      return /* @__PURE__ */ D(Fe, { color: "error", children: "Route is unavailable" });
    if (W === void 0 || !C)
      return null;
    const u = S ? t.palette.warning.main : t.palette.text.primary;
    return /* @__PURE__ */ ne(
      Fe,
      {
        fontSize: "18px",
        lineHeight: "18px",
        color: u,
        component: "div",
        marginBottom: "6px",
        children: [
          U,
          " ",
          C.symbol
        ]
      }
    );
  }, [
    e.error,
    W,
    U,
    C,
    S,
    t.palette.warning.main,
    t.palette.text.primary
  ]), I = Ce(() => {
    if (e.error || !c || !C || W === void 0)
      return null;
    const u = In(f, W, C);
    return /* @__PURE__ */ D(
      Fe,
      {
        fontSize: "14px",
        lineHeight: "14px",
        color: t.palette.text.secondary,
        component: "div",
        children: `${u} ${H}`
      }
    );
  }, [
    c,
    C,
    f,
    p,
    e.error,
    H,
    W,
    t.palette.text.secondary
  ]), r = Ce(() => h || typeof e.onSelect != "function" ? "default" : e.error ? "not-allowed" : "pointer", [e.error, h, e.onSelect]), s = Ce(() => e.isFastest ? /* @__PURE__ */ ne(Et, { children: [
    /* @__PURE__ */ D(Hm, { sx: o.fastestBadge }),
    e.isOnlyChoice ? "Fast" : "Fastest"
  ] }) : e.isCheapest && !e.isOnlyChoice ? /* @__PURE__ */ ne(Et, { children: [
    /* @__PURE__ */ D(Zm, { sx: o.cheapestBadge }),
    " Cheapest"
  ] }) : null, [
    e.isFastest,
    e.isCheapest,
    e.isOnlyChoice,
    o.fastestBadge,
    o.cheapestBadge
  ]);
  return e.route ? /* @__PURE__ */ D(
    ut,
    {
      sx: {
        ...o.container
      },
      "data-testid": `route-${e.route}${h ? "-selected" : ""}`,
      children: /* @__PURE__ */ D(
        bn,
        {
          sx: {
            ...o.card,
            ...h && o.cardSelected,
            ...d && o.disabled,
            border: "1px solid",
            borderColor: h ? t.palette.primary.main : "transparent",
            opacity: 1
          },
          children: /* @__PURE__ */ ne(
            Fo,
            {
              component: "div",
              disabled: d || typeof e.onSelect != "function" || e.error !== void 0,
              disableTouchRipple: !0,
              sx: { cursor: r },
              onClick: () => {
                var u;
                (u = e.onSelect) == null || u.call(e, e.route);
              },
              children: [
                /* @__PURE__ */ D(
                  Xs,
                  {
                    sx: o.cardHeader,
                    avatar: /* @__PURE__ */ D(Js, { icon: C == null ? void 0 : C.icon }),
                    title: B,
                    subheader: I,
                    action: s
                  }
                ),
                /* @__PURE__ */ ne(xn, { sx: o.cardContent, children: [
                  /* @__PURE__ */ ne(Tt, { gap: "14px", children: [
                    i.AUTOMATIC_DEPOSIT ? null : `You pay gas on ${c}`,
                    T,
                    E
                  ] }),
                  z,
                  k
                ] }),
                w && /* @__PURE__ */ ne(Et, { children: [
                  /* @__PURE__ */ D(Ui, { flexItem: !0, sx: { margin: "0px 16px" } }),
                  /* @__PURE__ */ D(xa, { in: w, children: /* @__PURE__ */ D(
                    LB,
                    {
                      destinationGasDrop: y || yn(0n, 8),
                      disabled: N,
                      isExecutorRoute: ia(e.route),
                      isSelected: h
                    }
                  ) })
                ] })
              ]
            }
          )
        }
      )
    },
    e.route
  ) : /* @__PURE__ */ D(Et, {});
}, DB = ({ ...e }) => {
  const t = er(), [o, i] = Xe(!1), c = Ce(
    () => ({
      otherRoutesToggle: {
        display: "block",
        width: "100%",
        textAlign: "center",
        fontSize: 14,
        color: t.palette.text.secondary,
        textDecoration: "none",
        cursor: "pointer",
        "&:hover": {
          textDecoration: "underline"
        }
      }
    }),
    [t]
  ), n = Ce(() => e.routes.filter((h) => e.quotes[h] !== void 0), [e.routes, e.quotes]), d = Ce(() => n.reduce(
    (h, y) => {
      const M = e.quotes[y];
      return !M || !M.success ? h : M.eta !== void 0 && M.eta < h.eta && M.eta < 6e4 ? { name: y, eta: M.eta } : h;
    },
    { name: "", eta: 1 / 0 }
  ), [n, e.quotes]), f = Ce(() => n.reduce(
    (h, y) => {
      const M = e.quotes[y], C = ge.routes.get(y);
      if (!M || !M.success || !C.AUTOMATIC_DEPOSIT) return h;
      const N = BigInt(M.destinationToken.amount.amount);
      return N > h.amountOut ? { name: y, amountOut: N } : h;
    },
    { name: "", amountOut: 0n }
  ), [n, e.quotes]), p = Ce(() => {
    if (o)
      return n;
    const h = n.find((y) => y === e.selectedRoute);
    if (h) {
      const y = [];
      return h === d.name ? (y.push(h), f.name && f.name !== h && y.push(f.name)) : h === f.name ? (d.name && d.name !== h && y.push(d.name), y.push(h)) : (y.push(h), n.length > 2 && (d.name ? y.push(d.name) : f.name && y.push(f.name))), y;
    }
    return d.name && f.name ? n.slice(0, 2) : n.slice(0, 1);
  }, [o, n, d, f, e.selectedRoute]), l = Ce(() => n.length < 2 || n.length === 2 && d.name && f.name ? null : /* @__PURE__ */ D(
    $i,
    {
      sx: c.otherRoutesToggle,
      "data-testid": "other-routes-toggle",
      onClick: () => i((h) => !h),
      children: o ? "Hide other routes" : "View other routes"
    }
  ), [
    f.name,
    c.otherRoutesToggle,
    d.name,
    n.length,
    o
  ]);
  return /* @__PURE__ */ ne(Et, { children: [
    e.isLoading || p.length > 0 ? /* @__PURE__ */ ne(ut, { sx: { display: "flex", width: "100%" }, children: [
      /* @__PURE__ */ D(
        Fe,
        {
          align: "left",
          fontSize: 16,
          paddingBottom: 0,
          marginTop: "8px",
          marginBottom: 0,
          width: "100%",
          textAlign: "left",
          children: "Routes"
        }
      ),
      e.isLoading ? /* @__PURE__ */ D(Z1, { sx: { alignSelf: "flex-end" }, size: 20 }) : null
    ] }) : null,
    e.isLoading && p.length === 0 ? /* @__PURE__ */ D(ea, { variant: "rounded", height: 153, width: "100%" }) : p.map((h, y) => {
      var S;
      const M = h === e.selectedRoute, C = e.quotes[h], N = C != null && C.success ? C : void 0, w = (C == null ? void 0 : C.success) === !1 ? ((S = C == null ? void 0 : C.error) == null ? void 0 : S.message) ?? `Error while getting a quote for ${h}.` : void 0;
      return /* @__PURE__ */ D(
        EB,
        {
          route: h,
          error: w,
          isSelected: M && !w,
          isFastest: h === d.name,
          isCheapest: h === f.name,
          isOnlyChoice: n.length === 1,
          onSelect: e.onRouteChange,
          quote: N
        },
        h
      );
    }),
    l
  ] });
}, jB = an(/* @__PURE__ */ D("path", {
  d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99zM9 3 5 6.99h3V14h2V6.99h3z"
}), "SwapVert"), OB = {
  swapButton: {
    display: "block",
    position: "absolute",
    bottom: -44,
    left: "calc(50% - 20px)",
    width: 40,
    height: 40,
    zIndex: 1
  }
};
function zB() {
  const e = Cr(), [t, o] = Xe(""), { isTransactionInProgress: i, fromChain: c, toChain: n } = Ut(
    (p) => p.transferInput
  ), d = !i && c && n, f = ht(() => {
    !d || i || (o(
      (p) => p === "spinRight" ? "spinLeft" : "spinRight"
    ), e(w8()), e(r8()), e(Hs("")));
  }, [d, i, e]);
  return /* @__PURE__ */ D(
    di,
    {
      sx: {
        ...OB.swapButton,
        animation: `${t} 0.3s linear 1`,
        "@keyframes spinRight": {
          "0%": {
            transform: "rotate(-180deg)"
          },
          "100%": {
            transform: "rotate(0deg)"
          }
        },
        "@keyframes spinLeft": {
          "0%": {
            transform: "rotate(180deg)"
          },
          "100%": {
            transform: "rotate(0deg)"
          }
        }
      },
      onClick: f,
      disabled: !d,
      children: /* @__PURE__ */ D(jB, {})
    }
  );
}
var Gm = { exports: {} };
(function(e, t) {
  (function(o, i) {
    e.exports = i(sr);
  })(typeof self < "u" ? self : Wt, (o) => (() => {
    var i = { 155: (T) => {
      T.exports = o;
    } }, c = {};
    function n(T) {
      var E = c[T];
      if (E !== void 0) return E.exports;
      var j = c[T] = { exports: {} };
      return i[T](j, j.exports, n), j.exports;
    }
    n.d = (T, E) => {
      for (var j in E) n.o(E, j) && !n.o(T, j) && Object.defineProperty(T, j, { enumerable: !0, get: E[j] });
    }, n.o = (T, E) => Object.prototype.hasOwnProperty.call(T, E), n.r = (T) => {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(T, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(T, "__esModule", { value: !0 });
    };
    var d = {};
    n.r(d), n.d(d, { default: () => S, useStopwatch: () => N, useTime: () => w, useTimer: () => C });
    var f = n(155);
    class p {
      static expiryTimestamp(E) {
        const j = new Date(E).getTime() > 0;
        return j || console.warn("react-timer-hook: { useTimer } Invalid expiryTimestamp settings", E), j;
      }
      static onExpire(E) {
        const j = E && typeof E == "function";
        return E && !j && console.warn("react-timer-hook: { useTimer } Invalid onExpire settings function", E), j;
      }
    }
    class l {
      static getTimeFromSeconds(E) {
        const j = Math.ceil(E), O = Math.floor(j / 86400), z = Math.floor(j % 86400 / 3600), k = Math.floor(j % 3600 / 60);
        return { totalSeconds: j, seconds: Math.floor(j % 60), minutes: k, hours: z, days: O };
      }
      static getSecondsFromExpiry(E, j) {
        const O = E - (/* @__PURE__ */ new Date()).getTime();
        if (O > 0) {
          const z = O / 1e3;
          return j ? Math.round(z) : z;
        }
        return 0;
      }
      static getSecondsFromPrevTime(E, j) {
        const O = (/* @__PURE__ */ new Date()).getTime() - E;
        if (O > 0) {
          const z = O / 1e3;
          return j ? Math.round(z) : z;
        }
        return 0;
      }
      static getSecondsFromTimeNow() {
        const E = /* @__PURE__ */ new Date();
        return E.getTime() / 1e3 - 60 * E.getTimezoneOffset();
      }
      static getFormattedTimeFromSeconds(E, j) {
        const { seconds: O, minutes: z, hours: k } = l.getTimeFromSeconds(E);
        let H = "", W = k;
        return j === "12-hour" && (H = k >= 12 ? "pm" : "am", W = k % 12), { seconds: O, minutes: z, hours: W, ampm: H };
      }
    }
    function h(T, E) {
      const j = (0, f.useRef)();
      (0, f.useEffect)(() => {
        j.current = T;
      }), (0, f.useEffect)(() => {
        if (!E) return () => {
        };
        const O = setInterval(() => {
          j.current && j.current();
        }, E);
        return () => clearInterval(O);
      }, [E]);
    }
    const y = 1e3;
    function M(T) {
      if (!p.expiryTimestamp(T)) return null;
      const E = l.getSecondsFromExpiry(T), j = Math.floor(1e3 * (E - Math.floor(E)));
      return j > 0 ? j : y;
    }
    function C() {
      let { expiryTimestamp: T, onExpire: E, autoStart: j = !0 } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      const [O, z] = (0, f.useState)(T), [k, H] = (0, f.useState)(l.getSecondsFromExpiry(O)), [W, U] = (0, f.useState)(j), [B, I] = (0, f.useState)(j), [r, s] = (0, f.useState)(M(O)), u = (0, f.useCallback)(() => {
        p.onExpire(E) && E(), U(!1), s(null);
      }, [E]), g = (0, f.useCallback)(() => {
        U(!1);
      }, []), v = (0, f.useCallback)(function(m) {
        let a = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
        s(M(m)), I(a), U(a), z(m), H(l.getSecondsFromExpiry(m));
      }, []), A = (0, f.useCallback)(() => {
        const m = /* @__PURE__ */ new Date();
        m.setMilliseconds(m.getMilliseconds() + 1e3 * k), v(m);
      }, [k, v]), L = (0, f.useCallback)(() => {
        B ? (H(l.getSecondsFromExpiry(O)), U(!0)) : A();
      }, [O, B, A]);
      return h(() => {
        r !== y && s(y);
        const m = l.getSecondsFromExpiry(O);
        H(m), m <= 0 && u();
      }, W ? r : null), { ...l.getTimeFromSeconds(k), start: L, pause: g, resume: A, restart: v, isRunning: W };
    }
    function N() {
      let { autoStart: T, offsetTimestamp: E } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      const [j, O] = (0, f.useState)(l.getSecondsFromExpiry(E, !0) || 0), [z, k] = (0, f.useState)(/* @__PURE__ */ new Date()), [H, W] = (0, f.useState)(j + l.getSecondsFromPrevTime(z || 0, !0)), [U, B] = (0, f.useState)(T);
      h(() => {
        W(j + l.getSecondsFromPrevTime(z, !0));
      }, U ? 1e3 : null);
      const I = (0, f.useCallback)(() => {
        const u = /* @__PURE__ */ new Date();
        k(u), B(!0), W(j + l.getSecondsFromPrevTime(u, !0));
      }, [j]), r = (0, f.useCallback)(() => {
        O(H), B(!1);
      }, [H]), s = (0, f.useCallback)(function() {
        let u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, g = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
        const v = l.getSecondsFromExpiry(u, !0) || 0, A = /* @__PURE__ */ new Date();
        k(A), O(v), B(g), W(v + l.getSecondsFromPrevTime(A, !0));
      }, []);
      return { ...l.getTimeFromSeconds(H), start: I, pause: r, reset: s, isRunning: U };
    }
    function w() {
      let { format: T } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      const [E, j] = (0, f.useState)(l.getSecondsFromTimeNow());
      return h(() => {
        j(l.getSecondsFromTimeNow());
      }, 1e3), { ...l.getFormattedTimeFromSeconds(E, T) };
    }
    function S(T) {
      if ((0, f.useEffect)(() => {
        console.warn("react-timer-hook: default export useTimer is deprecated, use named exports { useTimer, useStopwatch, useTime } instead");
      }, []), T.expiryTimestamp) {
        const j = C(T);
        return { ...j, startTimer: j.start, stopTimer: j.pause, resetTimer: () => {
        } };
      }
      const E = N(T);
      return { ...E, startTimer: E.start, stopTimer: E.pause, resetTimer: E.reset };
    }
    return d;
  })());
})(Gm);
var i2 = Gm.exports;
function kB(e) {
  return Bt("MuiLinearProgress", e);
}
Ft("MuiLinearProgress", ["root", "colorPrimary", "colorSecondary", "determinate", "indeterminate", "buffer", "query", "dashed", "dashedColorPrimary", "dashedColorSecondary", "bar", "bar1", "bar2", "barColorPrimary", "barColorSecondary", "bar1Indeterminate", "bar1Determinate", "bar1Buffer", "bar2Indeterminate", "bar2Buffer"]);
const _1 = 4, B1 = fi`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`, _B = typeof B1 != "string" ? jo`
        animation: ${B1} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null, F1 = fi`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`, BB = typeof F1 != "string" ? jo`
        animation: ${F1} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null, R1 = fi`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`, FB = typeof R1 != "string" ? jo`
        animation: ${R1} 3s infinite linear;
      ` : null, RB = (e) => {
  const {
    classes: t,
    variant: o,
    color: i
  } = e, c = {
    root: ["root", `color${it(i)}`, o],
    dashed: ["dashed", `dashedColor${it(i)}`],
    bar1: ["bar", "bar1", `barColor${it(i)}`, (o === "indeterminate" || o === "query") && "bar1Indeterminate", o === "determinate" && "bar1Determinate", o === "buffer" && "bar1Buffer"],
    bar2: ["bar", "bar2", o !== "buffer" && `barColor${it(i)}`, o === "buffer" && `color${it(i)}`, (o === "indeterminate" || o === "query") && "bar2Indeterminate", o === "buffer" && "bar2Buffer"]
  };
  return Rt(c, kB, t);
}, o2 = (e, t) => e.vars ? e.vars.palette.LinearProgress[`${t}Bg`] : e.palette.mode === "light" ? Ts(e.palette[t].main, 0.62) : As(e.palette[t].main, 0.5), PB = Ke("span", {
  name: "MuiLinearProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[`color${it(o.color)}`], t[o.variant]];
  }
})(kt(({
  theme: e
}) => ({
  position: "relative",
  overflow: "hidden",
  display: "block",
  height: 4,
  // Fix Safari's bug during composition of different paint.
  zIndex: 0,
  "@media print": {
    colorAdjust: "exact"
  },
  variants: [...Object.entries(e.palette).filter(Gr()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      backgroundColor: o2(e, t)
    }
  })), {
    props: ({
      ownerState: t
    }) => t.color === "inherit" && t.variant !== "buffer",
    style: {
      "&::before": {
        content: '""',
        position: "absolute",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "currentColor",
        opacity: 0.3
      }
    }
  }, {
    props: {
      variant: "buffer"
    },
    style: {
      backgroundColor: "transparent"
    }
  }, {
    props: {
      variant: "query"
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}))), UB = Ke("span", {
  name: "MuiLinearProgress",
  slot: "Dashed",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.dashed, t[`dashedColor${it(o.color)}`]];
  }
})(kt(({
  theme: e
}) => ({
  position: "absolute",
  marginTop: 0,
  height: "100%",
  width: "100%",
  backgroundSize: "10px 10px",
  backgroundPosition: "0 -23px",
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      opacity: 0.3,
      backgroundImage: "radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)"
    }
  }, ...Object.entries(e.palette).filter(Gr()).map(([t]) => {
    const o = o2(e, t);
    return {
      props: {
        color: t
      },
      style: {
        backgroundImage: `radial-gradient(${o} 0%, ${o} 16%, transparent 42%)`
      }
    };
  })]
})), FB || {
  // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
  animation: `${R1} 3s infinite linear`
}), YB = Ke("span", {
  name: "MuiLinearProgress",
  slot: "Bar1",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.bar, t.bar1, t[`barColor${it(o.color)}`], (o.variant === "indeterminate" || o.variant === "query") && t.bar1Indeterminate, o.variant === "determinate" && t.bar1Determinate, o.variant === "buffer" && t.bar1Buffer];
  }
})(kt(({
  theme: e
}) => ({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      backgroundColor: "currentColor"
    }
  }, ...Object.entries(e.palette).filter(Gr()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      backgroundColor: (e.vars || e).palette[t].main
    }
  })), {
    props: {
      variant: "determinate"
    },
    style: {
      transition: `transform .${_1}s linear`
    }
  }, {
    props: {
      variant: "buffer"
    },
    style: {
      zIndex: 1,
      transition: `transform .${_1}s linear`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: _B || {
      animation: `${B1} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
    }
  }]
}))), WB = Ke("span", {
  name: "MuiLinearProgress",
  slot: "Bar2",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.bar, t.bar2, t[`barColor${it(o.color)}`], (o.variant === "indeterminate" || o.variant === "query") && t.bar2Indeterminate, o.variant === "buffer" && t.bar2Buffer];
  }
})(kt(({
  theme: e
}) => ({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  variants: [...Object.entries(e.palette).filter(Gr()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--LinearProgressBar2-barColor": (e.vars || e).palette[t].main
    }
  })), {
    props: ({
      ownerState: t
    }) => t.variant !== "buffer" && t.color !== "inherit",
    style: {
      backgroundColor: "var(--LinearProgressBar2-barColor, currentColor)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant !== "buffer" && t.color === "inherit",
    style: {
      backgroundColor: "currentColor"
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      opacity: 0.3
    }
  }, ...Object.entries(e.palette).filter(Gr()).map(([t]) => ({
    props: {
      color: t,
      variant: "buffer"
    },
    style: {
      backgroundColor: o2(e, t),
      transition: `transform .${_1}s linear`
    }
  })), {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: BB || {
      animation: `${F1} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
    }
  }]
}))), a2 = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiLinearProgress"
  }), {
    className: c,
    color: n = "primary",
    value: d,
    valueBuffer: f,
    variant: p = "indeterminate",
    ...l
  } = i, h = {
    ...i,
    color: n,
    variant: p
  }, y = RB(h), M = Ss(), C = {}, N = {
    bar1: {},
    bar2: {}
  };
  if (p === "determinate" || p === "buffer")
    if (d !== void 0) {
      C["aria-valuenow"] = Math.round(d), C["aria-valuemin"] = 0, C["aria-valuemax"] = 100;
      let w = d - 100;
      M && (w = -w), N.bar1.transform = `translateX(${w}%)`;
    } else fe.process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a value prop when using the determinate or buffer variant of LinearProgress .");
  if (p === "buffer")
    if (f !== void 0) {
      let w = (f || 0) - 100;
      M && (w = -w), N.bar2.transform = `translateX(${w}%)`;
    } else fe.process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a valueBuffer prop when using the buffer variant of LinearProgress.");
  return /* @__PURE__ */ ne(PB, {
    className: It(y.root, c),
    ownerState: h,
    role: "progressbar",
    ...C,
    ref: o,
    ...l,
    children: [p === "buffer" ? /* @__PURE__ */ D(UB, {
      className: y.dashed,
      ownerState: h
    }) : null, /* @__PURE__ */ D(YB, {
      className: y.bar1,
      ownerState: h,
      style: N.bar1
    }), p === "determinate" ? null : /* @__PURE__ */ D(WB, {
      className: y.bar2,
      ownerState: h,
      style: N.bar2
    })]
  });
});
fe.process.env.NODE_ENV !== "production" && (a2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: b.oneOfType([b.oneOf(["inherit", "primary", "secondary"]), b.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: b.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: b.number,
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */
  variant: b.oneOf(["buffer", "determinate", "indeterminate", "query"])
});
const ng = 60 * 1e3, HB = 120 * 1e3, s2 = (e) => {
  const [t, o] = Xe(!1), [i, c] = Xe(!1), [n, d] = Xe(), { eta: f, route: p } = e;
  return St(() => {
    e.receipt && d(e.receipt);
  }, [e.receipt]), St(() => {
    let l = !0;
    return (async () => {
      if (!p || !n)
        return;
      const y = ge.routes.get(p);
      if (!y)
        return;
      const M = (w) => w.valueOf() - (/* @__PURE__ */ new Date()).valueOf(), C = await gn(), N = new y.rc(C);
      for (; l && !Wd(n); ) {
        if (f !== void 0) {
          const S = M(f);
          S > ng && await cc(S - ng);
        }
        try {
          for await (const S of N.track(
            n,
            HB
          )) {
            if (!l)
              break;
            if (S.state !== n.state) {
              if (d(S), Wd(S)) {
                o(!0);
                break;
              }
              !y.AUTOMATIC_DEPOSIT && S.state >= Xo.Attested && c(!0);
            }
          }
        } catch (S) {
          console.error("Error tracking transfer:", S);
        }
        let w = 5e3;
        f !== void 0 && y.AUTOMATIC_DEPOSIT && M(f) < 1e4 && (w = 1e3), await cc(w);
      }
    })(), () => {
      l = !1;
    };
  }, [f, n, p]), {
    isCompleted: t,
    isReadyToClaim: i,
    receipt: n
  };
}, $m = dn(
  /* @__PURE__ */ D(
    "path",
    {
      d: "M4 12H20M20 12L13 5M20 12L13 19",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  "ArrowRight"
), c2 = dn(
  /* @__PURE__ */ ne(
    "svg",
    {
      width: "107",
      height: "106",
      viewBox: "0 0 107 106",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M53.2079 105.5C82.2486 105.5 105.791 81.9949 105.791 53C105.791 24.0051 82.2486 0.5 53.2079 0.5C24.1672 0.5 0.625 24.0051 0.625 53C0.625 81.9949 24.1672 105.5 53.2079 105.5ZM53.207 102.097C80.3654 102.097 102.382 80.1157 102.382 53.0001C102.382 25.8844 80.3654 3.90283 53.207 3.90283C26.0485 3.90283 4.03223 25.8844 4.03223 53.0001C4.03223 80.1157 26.0485 102.097 53.207 102.097Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M46.8789 68L32.628906 53.75L36.19141 50.1875L46.8789 60.875L69.8164 37.9375L73.3789 41.5L46.8789 68Z",
            fill: "currentColor"
          }
        )
      ]
    }
  ),
  "Alert"
), ZB = (e) => {
  var m, a;
  const [t, o] = Xe(""), [i, c] = Xe(!1), n = Cr(), d = wa(Vi), f = or(), p = Ce(
    () => ({
      alertBanner: {
        marginTop: "12px"
      },
      arrowIcon: {
        fontSize: "16px",
        margin: "0 4px"
      },
      card: {
        width: "100%",
        boxShadow: `0px 0px 3.5px 0px ${f.palette.primary.main}`
      },
      cardContent: {
        padding: "16px 20px",
        ":last-child": {
          padding: "16px 20px"
        }
      },
      cardActionArea: {
        height: "72px"
      },
      chainIconContainer: {
        border: `2px solid ${f.palette.input.background}`,
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2px"
      },
      completedIcon: {
        color: f.palette.success.main,
        height: "24px",
        width: "24px"
      },
      container: {
        width: "100%",
        maxWidth: "420px"
      },
      progressBar: {
        borderRadius: "4px",
        marginTop: "8px"
      }
    }),
    [f]
  ), { data: l } = e, {
    receipt: h,
    route: y,
    timestamp: M,
    txDetails: C,
    txHash: N
  } = l, {
    amount: w,
    eta: S,
    fromChain: T,
    toChain: E,
    token: j
  } = C || {}, O = ge.tokens.get(j), { seconds: z, minutes: k, totalSeconds: H, isRunning: W, restart: U } = i2.useTimer({
    expiryTimestamp: /* @__PURE__ */ new Date(),
    autoStart: !1,
    onExpire: () => c(!0)
  }), B = Ce(() => {
    if (S && M)
      return new Date(M + S);
  }, [S, M]), {
    isCompleted: I,
    isReadyToClaim: r,
    receipt: s
  } = s2({
    eta: B,
    receipt: h,
    route: y
  });
  St(() => {
    I && N && Hh(N);
  }, [I, N]);
  const u = s || h, g = Ce(() => {
    if (!S || !M)
      return 0;
    const x = Date.now() - M;
    return S < x ? 0 : S - x;
  }, [S, M, H]), v = Ce(() => r || l.isReadyToClaim ? "Ready to claim..." : i || g === 0 ? "Wrapping up..." : W ? cl(k, z) : /* @__PURE__ */ D(Or, { size: 16 }), [
    i,
    g,
    r,
    W,
    k,
    z,
    l
  ]), A = Ce(() => !S || g > S || !i && g === 0 ? 0 : i ? 100 : (S - g) / S * 100, [S, i, g]);
  St(() => {
    !W && !I && g && U(new Date(Date.now() + g), !0);
  }, [g, I, W, U]);
  const L = ht(async () => {
    if (o(""), !u) {
      o("No receipt found for this transaction");
      return;
    }
    try {
      const x = await gn(), V = new (ge.routes.get(y)).rc(x);
      n(ah(M)), n(Pc(C)), n(oh(!0)), n(Uc(y)), n(rl(C.toChain)), n(Nn("redeem")), d.setReceipt(u), d.setRoute(V);
    } catch {
      o(`Error resuming transaction: ${C.sendTx}`);
    }
  }, [n, u, y, d, M, C]);
  return !l || !O ? /* @__PURE__ */ D(Et, {}) : /* @__PURE__ */ ne(wt, { sx: p.container, children: [
    /* @__PURE__ */ D(bn, { sx: p.card, children: /* @__PURE__ */ D(
      Fo,
      {
        disableTouchRipple: !0,
        sx: p.cardActionArea,
        disabled: e.disabled || !C,
        onClick: L,
        children: /* @__PURE__ */ ne(xn, { sx: p.cardContent, children: [
          /* @__PURE__ */ ne(
            Tt,
            {
              direction: "row",
              alignItems: "center",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ D(Fe, { display: "flex", justifyContent: "space-between", children: I ? /* @__PURE__ */ D(c2, { sx: p.completedIcon }) : v }),
                /* @__PURE__ */ ne(Tt, { direction: "row", alignItems: "center", children: [
                  /* @__PURE__ */ D(Fe, { fontSize: 14, marginRight: "8px", children: `${cr(vn(w, 6))} ${O.symbol}` }),
                  /* @__PURE__ */ D(wt, { sx: p.chainIconContainer, children: /* @__PURE__ */ D(
                    Un,
                    {
                      icon: (m = ge.chains[T]) == null ? void 0 : m.icon,
                      height: 24
                    }
                  ) }),
                  /* @__PURE__ */ D($m, { sx: p.arrowIcon }),
                  /* @__PURE__ */ D(wt, { sx: p.chainIconContainer, children: /* @__PURE__ */ D(Un, { icon: (a = ge.chains[E]) == null ? void 0 : a.icon, height: 24 }) })
                ] })
              ]
            }
          ),
          !I && /* @__PURE__ */ D(
            a2,
            {
              variant: "determinate",
              value: A,
              sx: p.progressBar
            }
          )
        ] })
      }
    ) }),
    /* @__PURE__ */ D(
      Gs,
      {
        sx: p.alertBanner,
        color: t ? f.palette.error.light : f.palette.grey.A400,
        content: t,
        error: !!t,
        show: !!t
      }
    )
  ] });
}, QB = (e) => {
  const t = er(), [o, i] = Xe();
  return St(() => {
    const c = $s(), n = c == null ? void 0 : c.filter((d) => {
      var f, p;
      if (!((f = d == null ? void 0 : d.txDetails) != null && f.token))
        return !1;
      try {
        return !!ge.tokens.get((p = d == null ? void 0 : d.txDetails) == null ? void 0 : p.token);
      } catch (l) {
        return console.log(
          "Error while parsing token from local storage (in-progress widget):",
          l
        ), !1;
      }
    });
    i(n);
  }, []), !o || o.length === 0 ? /* @__PURE__ */ D(Et, {}) : /* @__PURE__ */ ne(
    ut,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        marginBottom: "16px",
        alignItems: "center",
        justifyContent: "center",
        width: "100%"
      },
      children: [
        /* @__PURE__ */ D(
          ut,
          {
            sx: {
              width: "100%",
              display: "flex",
              alignItems: "center"
            },
            children: /* @__PURE__ */ D(Fe, { color: t.palette.text.secondary, fontSize: 14, children: "Transactions in progress" })
          }
        ),
        o.map((c) => /* @__PURE__ */ D(ZB, { data: c, disabled: e.disabled }, c.txHash))
      ]
    }
  );
}, qm = ({
  sendingWallet: e,
  receivingWallet: t,
  sourceChain: o,
  destChain: i,
  routes: c
}) => Ce(() => {
  if (c.length === 1 && c[0] === "ManualCCTP") {
    const d = [
      "Petra",
      "Pontem Wallet",
      "Nightly",
      "Continue with Google",
      "Continue with Apple"
    ];
    if (o === "Aptos" && !d.includes(e.name) || i === "Aptos" && !d.includes(t.name))
      return {
        isCompatible: !1,
        warning: "Please use a compatible wallet for this route."
      };
  }
  return { isCompatible: !0 };
}, [e, t, o, i, c]), VB = () => {
  var pe, se;
  const e = er(), t = Cr(), { lastTokenCacheUpdate: o } = Hr(), [i, c] = Xe(!1), n = Hi(e.breakpoints.down("sm")), d = Ce(
    () => ({
      assetPickerContainer: {
        width: "100%",
        position: "relative"
      },
      assetPickerTitle: {
        color: e.palette.text.secondary,
        display: "flex",
        minHeight: "40px",
        alignItems: "center",
        justifyContent: "space-between"
      },
      bridgeContent: {
        margin: "auto",
        maxWidth: "420px"
      },
      bridgeHeader: {
        width: "100%",
        minHeight: "28px",
        display: "flex",
        alignItems: "center"
      },
      doneIcon: {
        fontSize: "14px",
        color: e.palette.success.main
      },
      confirmTransaction: {
        padding: "8px 16px",
        borderRadius: "8px",
        height: "48px",
        margin: "auto",
        maxWidth: "420px",
        width: "100%"
      },
      copyIcon: {
        fontSize: "14px"
      },
      ctaContainer: {
        marginTop: "8px",
        width: "100%"
      },
      spacer: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        alignItems: "center",
        justifyContent: "center",
        width: "100%"
      }
    }),
    [e]
  ), { sending: f, receiving: p } = Ut(
    (ce) => ce.wallet
  ), {
    fromChain: l,
    toChain: h,
    route: y,
    preferredRouteName: M,
    amount: C,
    toNativeToken: N,
    isTransactionInProgress: w,
    validations: S
  } = Ut((ce) => ({
    ...ce.transferInput,
    ...ce.relay
  })), { sourceToken: T, destToken: E } = _o(), {
    allSupportedRoutes: j,
    sortedRoutes: O,
    sortedRoutesWithQuotes: z,
    quotes: k,
    isFetching: H
  } = rm({
    amount: C,
    fromChain: l,
    toChain: h,
    preferredRouteName: M,
    sourceToken: T,
    destToken: E,
    toNativeToken: N,
    receivingWallet: p
  }), { isFetching: W, supportedDestTokens: U } = em({
    sourceChain: l,
    destChain: h,
    sourceToken: T
  }), {
    error: B,
    errorInternal: I,
    onConfirm: r
  } = sm({ quotes: k });
  St(() => {
    if (z.length === 0)
      t(Di(""));
    else {
      const ce = z.find(
        (Le) => Le.route === M
      ), me = y ?? (ce == null ? void 0 : ce.route) ?? z[0].route, de = z.findIndex((Le) => Le.route === me) > -1;
      if (de || t(Di("")), !me || y && de)
        return;
      const ae = z == null ? void 0 : z.find(
        (Le) => Le.route === me
      );
      ae && t(Di(ae.route));
    }
  }, [M, y, z, t]);
  const { isConnecting: s } = Lh(
    l,
    h
  );
  am();
  const u = Ce(() => Zh(S), [S]), g = Ce(
    () => ge.routes.allSupportedChains(),
    // Disabled because we're using the global cache and we have to monitor values that aren't directly used in this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ge.chains]
  ), v = Ce(() => l ? ge.tokens.getAllForChain(l) : [], [l, o]), A = Ce(() => ge.chainsArr.filter((ce) => ce.sdkName !== h && g.includes(ce.sdkName)), [h, g]), L = Ce(() => ge.chainsArr.filter(
    (ce) => ce.sdkName !== l && g.includes(ce.sdkName)
  ), [l, g]), m = Ce(() => {
    if (l && (f != null && f.address))
      return {
        chain: l,
        wallet: f,
        tokens: v
      };
  }, [l, f, v]), a = Ce(() => {
    if (h && (p != null && p.address))
      return {
        chain: h,
        wallet: p,
        tokens: ge.tokens.getAllForChain(h)
      };
  }, [h, p, U]), x = cm({
    source: m,
    destination: a
  }), V = nm({
    balance: T ? (pe = x.source.balances[T.key]) == null ? void 0 : pe.balance : null,
    routes: j,
    quotes: k,
    tokenSymbol: (T == null ? void 0 : T.symbol) ?? "",
    disabled: !l || !T
  }), G = Ce(() => {
    const ce = {
      text: "",
      align: "left"
    };
    let me;
    return typeof ge.ui.pageHeader == "string" ? me = { ...ce, text: ge.ui.pageHeader } : me = { ...ce, ...ge.ui.pageHeader }, /* @__PURE__ */ D(La, { title: me.text, align: me.align });
  }, []), Z = Ce(() => /* @__PURE__ */ ne(wt, { sx: d.assetPickerContainer, children: [
    /* @__PURE__ */ ne(wt, { sx: d.assetPickerTitle, children: [
      /* @__PURE__ */ D(Fe, { variant: "body2", children: "From" }),
      /* @__PURE__ */ D(rg, { type: ar.SENDING })
    ] }),
    /* @__PURE__ */ D(
      tg,
      {
        chain: l,
        chainList: A,
        token: T,
        tokenList: v,
        setChain: (ce) => {
          g8(t, ce, f), t(v8());
        },
        setToken: (ce) => {
          t(m8(ce.tuple));
        },
        wallet: f,
        isSource: !0,
        isTransactionInProgress: w,
        dataTestId: "source-asset-picker",
        isConnectingWallet: s,
        balances: x.source.balances,
        isFetchingBalances: x.isFetching
      }
    ),
    /* @__PURE__ */ D(zB, {})
  ] }), [
    d.assetPickerContainer,
    d.assetPickerTitle,
    l,
    A,
    T,
    v,
    w,
    s,
    f,
    t,
    x.source,
    x.isFetching
  ]), te = Ce(() => /* @__PURE__ */ ne(wt, { sx: d.assetPickerContainer, children: [
    /* @__PURE__ */ ne(wt, { sx: d.assetPickerTitle, children: [
      /* @__PURE__ */ D(Fe, { variant: "body2", children: "To" }),
      /* @__PURE__ */ D(rg, { type: ar.RECEIVING })
    ] }),
    /* @__PURE__ */ D(
      tg,
      {
        chain: h,
        chainList: L,
        token: E,
        sourceToken: T,
        tokenList: U,
        isFetching: U.length === 0 && W,
        setChain: (ce) => {
          y8(t, ce, p), t(b8());
        },
        setToken: (ce) => {
          t(Eh(ce.tuple));
        },
        wallet: p,
        isSource: !1,
        isTransactionInProgress: w,
        dataTestId: "dest-asset-picker",
        isConnectingWallet: s,
        balances: x.destination.balances,
        isFetchingBalances: x.isFetching
      }
    )
  ] }), [
    d.assetPickerContainer,
    d.assetPickerTitle,
    h,
    L,
    E,
    T,
    U,
    s,
    W,
    w,
    p,
    t,
    x.destination,
    x.isFetching
  ]), q = Ce(() => {
    const ce = !(f != null && f.address) || w;
    return /* @__PURE__ */ ne(wt, { sx: d.bridgeHeader, children: [
      /* @__PURE__ */ D(
        Zs,
        {
          align: "left",
          text: ge.ui.title ?? "Wormhole Connect",
          size: 18,
          testId: "bridge-view-header"
        }
      ),
      /* @__PURE__ */ D(
        $n,
        {
          title: f != null && f.address ? "" : "No connected wallets found",
          children: /* @__PURE__ */ D("span", { children: /* @__PURE__ */ D(
            di,
            {
              "data-testid": "history-button",
              sx: { padding: 0 },
              disabled: ce,
              onClick: () => {
                t(Nn("history")), ge.triggerEvent({
                  type: "history.load",
                  details: {
                    wallet: f == null ? void 0 : f.address
                  }
                });
              },
              children: /* @__PURE__ */ D($8, {})
            }
          ) })
        }
      )
    ] });
  }, [
    d.bridgeHeader,
    t,
    w,
    f == null ? void 0 : f.address,
    n
  ]), R = Ce(() => f != null && f.address && (p != null && p.address) ? null : f != null && f.address && !(p != null && p.address) ? /* @__PURE__ */ D(
    W6,
    {
      disabled: !h,
      side: "destination",
      type: ar.RECEIVING
    }
  ) : /* @__PURE__ */ D(
    W6,
    {
      disabled: !l,
      side: "source",
      type: ar.SENDING
    }
  ), [l, h, f, p]), { isCompatible: Q, warning: $ } = qm({
    sendingWallet: f,
    receivingWallet: p,
    sourceChain: l,
    destChain: h,
    routes: O
  }), F = Ce(() => B ? /* @__PURE__ */ ne(wt, { sx: { marginBottom: 2 }, children: [
    /* @__PURE__ */ D(
      Gs,
      {
        error: !0,
        content: B,
        show: !0,
        testId: "send-error-message"
      }
    ),
    I && I.message && ge.ui.getHelpUrl ? /* @__PURE__ */ ne(Fe, { fontSize: 14, sx: { marginTop: 1 }, children: [
      "Having trouble?",
      " ",
      /* @__PURE__ */ ne(
        "a",
        {
          href: "#",
          onClick: () => {
            el(I.message), c(!0), setTimeout(() => c(!1), 3e3);
          },
          children: [
            "Copy the error logs",
            " ",
            i ? /* @__PURE__ */ D(G8, { sx: d.doneIcon }) : /* @__PURE__ */ D(V8, { sx: d.copyIcon })
          ]
        }
      ),
      " and ",
      /* @__PURE__ */ D("a", { href: ge.ui.getHelpUrl, target: "_blank", children: "ask for help" }),
      "."
    ] }) : null
  ] }) : null, [d.copyIcon, d.doneIcon, i, B, I]), P = !!V.error, _ = C && oi(C) > 0, X = f.address && p.address, le = !l || !T || !h || !E || !X || !Q || !y || !u || H || !_ || w || P, ie = Ce(() => /* @__PURE__ */ D(
    so,
    {
      disabled: le,
      "data-testid": "confirm-transaction-button",
      variant: "primary",
      sx: d.confirmTransaction,
      onClick: () => r(),
      children: w ? /* @__PURE__ */ ne(
        Fe,
        {
          display: "flex",
          alignItems: "center",
          gap: 1,
          textTransform: "none",
          children: [
            /* @__PURE__ */ D(
              Or,
              {
                size: 16,
                sx: { color: e.palette.primary.contrastText }
              }
            ),
            n ? "Preparing" : "Preparing transaction"
          ]
        }
      ) : !w && H ? /* @__PURE__ */ ne(
        Fe,
        {
          display: "flex",
          alignItems: "center",
          gap: 1,
          textTransform: "none",
          children: [
            /* @__PURE__ */ D(Or, { color: "secondary", size: 16 }),
            n ? "Refreshing" : "Refreshing quote"
          ]
        }
      ) : /* @__PURE__ */ D(Fe, { textTransform: "none", children: n ? "Confirm" : "Confirm transaction" })
    }
  ), [
    le,
    d.confirmTransaction,
    w,
    e.palette.primary.contrastText,
    n,
    H,
    r
  ]), oe = !l || !T ? "Please select a source asset" : !h || !E ? "Please select a destination asset" : _ ? H ? "Loading quotes..." : y ? "" : "Please select a quote" : "Please enter an amount";
  return /* @__PURE__ */ ne(
    wt,
    {
      sx: { ...d.bridgeContent, ...d.spacer },
      "data-testid": "bridge-view",
      children: [
        G,
        ge.ui.showInProgressWidget && /* @__PURE__ */ D(QB, { disabled: w }),
        q,
        Z,
        te,
        /* @__PURE__ */ D(
          Z_,
          {
            sourceChain: l,
            supportedSourceTokens: v,
            tokenBalance: T ? (se = x.source.balances[T.key]) == null ? void 0 : se.balance : null,
            isFetchingTokenBalance: x.isFetching,
            error: V.error,
            warning: V.warning || $
          }
        ),
        _ && /* @__PURE__ */ D(
          DB,
          {
            routes: O,
            selectedRoute: y,
            onRouteChange: (ce) => {
              t(Di(ce));
            },
            quotes: k,
            isLoading: H || x.isFetching
          }
        ),
        F,
        /* @__PURE__ */ D(wt, { component: "span", sx: d.ctaContainer, children: X ? /* @__PURE__ */ D($n, { title: oe, children: /* @__PURE__ */ D("span", { children: ie }) }) : R }),
        /* @__PURE__ */ D(ll, { color: e.palette.text.primary }),
        /* @__PURE__ */ D(il, {})
      ]
    }
  );
}, GB = an(/* @__PURE__ */ D("path", {
  d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "ChevronLeft"), os = ({ url: e, text: t }) => {
  const o = or(), i = Ce(
    () => ({
      addressLink: {
        display: "inline-flex",
        alignItems: "center",
        overflow: "hidden",
        color: o.palette.text.primary,
        opacity: 0.6
      }
    }),
    [o]
  );
  return e && t ? /* @__PURE__ */ ne(
    $i,
    {
      onClick: (c) => c.stopPropagation(),
      sx: i.addressLink,
      href: e,
      rel: "noreferrer noopener",
      target: "_blank",
      children: [
        t,
        /* @__PURE__ */ D(
          Kh,
          {
            sx: {
              height: "10px",
              width: "10px",
              marginLeft: "2px"
            }
          }
        )
      ]
    }
  ) : null;
}, $B = () => {
  const e = er(), t = sr.useContext(Vi), o = Ce(
    () => ({
      container: {
        width: "100%",
        maxWidth: "420px",
        backgroundColor: e.palette.input.background
      },
      card: {
        width: "100%",
        backgroundColor: e.palette.input.background
      }
    }),
    [e]
  ), {
    sendTx: i,
    sender: c,
    amount: n,
    recipient: d,
    toChain: f,
    fromChain: p,
    token: l,
    receivedToken: h,
    receiveAmount: y,
    receiveNativeAmount: M,
    eta: C
  } = Ut((s) => s.redeem.txData), { route: N } = Ut((s) => s.redeem), w = ge.tokens.get(l), S = ge.tokens.get(h), { getTokenPrice: T, isFetchingTokenPrices: E, lastTokenPriceUpdate: j } = Hr(), O = Ce(
    () => /* @__PURE__ */ D(Fe, { component: "span", padding: "0px 8px", children: "·" }),
    []
  ), z = Ce(() => {
    if (!w || !p)
      return /* @__PURE__ */ D(Et, {});
    const s = ge.tokens.get(l), u = ge.chains[p], g = In(
      T,
      n,
      s
    ), v = c ? ji(c) : "", A = c ? bo(p, c, "wallet") : "", L = cr(vn(n, 6));
    return /* @__PURE__ */ ne(Tt, { alignItems: "center", direction: "row", justifyContent: "flex-start", children: [
      /* @__PURE__ */ D(Pi, { chainConfig: u, token: s }),
      /* @__PURE__ */ ne(Tt, { direction: "column", marginLeft: "12px", children: [
        /* @__PURE__ */ ne(Fe, { fontSize: 16, children: [
          L,
          " ",
          w.symbol
        ] }),
        /* @__PURE__ */ D(Fe, { color: e.palette.text.secondary, fontSize: 14, children: E ? /* @__PURE__ */ D(Or, { size: 14 }) : /* @__PURE__ */ ne(Et, { children: [
          g,
          g ? O : null,
          u.displayName,
          A ? /* @__PURE__ */ ne(Et, { children: [
            O,
            /* @__PURE__ */ D(os, { url: A, text: v })
          ] }) : null
        ] }) })
      ] })
    ] });
  }, [
    w,
    p,
    l,
    T,
    n,
    c,
    e.palette.text.secondary,
    E,
    O
  ]), k = Ce(() => {
    if (!S || !f)
      return /* @__PURE__ */ D(Et, {});
    const s = ge.chains[f], u = In(
      T,
      y,
      S
    ), g = d ? ji(d) : "", v = d ? bo(f, d, "wallet") : "", A = y ? cr(vn(y, 6)) : "-";
    return /* @__PURE__ */ ne(Tt, { alignItems: "center", direction: "row", justifyContent: "flex-start", children: [
      /* @__PURE__ */ D(Pi, { chainConfig: s, token: S }),
      /* @__PURE__ */ ne(Tt, { direction: "column", marginLeft: "12px", children: [
        /* @__PURE__ */ ne(Fe, { fontSize: 16, children: [
          A,
          " ",
          S.symbol
        ] }),
        /* @__PURE__ */ D(Fe, { color: e.palette.text.secondary, fontSize: 14, children: E ? /* @__PURE__ */ D(Or, { size: 14 }) : /* @__PURE__ */ ne(Et, { children: [
          u,
          u ? O : null,
          s.displayName,
          v ? /* @__PURE__ */ ne(Et, { children: [
            O,
            /* @__PURE__ */ D(os, { url: v, text: g })
          ] }) : null
        ] }) })
      ] })
    ] });
  }, [
    S,
    T,
    y,
    d,
    O,
    e.palette.text.secondary,
    f,
    E,
    j
  ]), H = Ce(
    () => /* @__PURE__ */ D(
      Tt,
      {
        height: "28px",
        borderLeft: "1px solid #8B919D",
        marginLeft: "16px"
      }
    ),
    []
  ), W = Ce(() => {
    if (!h || !M || ai(M) === 0n)
      return /* @__PURE__ */ D(Et, {});
    const s = ge.chains[f];
    if (!s)
      return /* @__PURE__ */ D(Et, {});
    const u = In(
      T,
      M,
      ge.tokens.getGasToken(s.sdkName)
    );
    return /* @__PURE__ */ ne(Tt, { direction: "row", justifyContent: "space-between", children: [
      /* @__PURE__ */ D(Fe, { color: e.palette.text.secondary, fontSize: 14, children: "Additional gas" }),
      E ? /* @__PURE__ */ D(Or, { size: 14 }) : /* @__PURE__ */ D(Fe, { fontSize: 14, children: u })
    ] });
  }, [
    M,
    e.palette.text.secondary,
    f,
    E,
    j
  ]), U = Ce(() => {
    const s = t.route ?? N;
    if (!s)
      return null;
    const { name: u, url: g } = LS(s, i, p, f);
    return URL.canParse(g) ? /* @__PURE__ */ D(Tt, { alignItems: "center", padding: "24px 12px", children: /* @__PURE__ */ D(
      $i,
      {
        display: "flex",
        gap: "8px",
        href: g,
        rel: "noreferrer",
        target: "_blank",
        underline: "none",
        children: /* @__PURE__ */ D(
          Fe,
          {
            color: e.palette.text.primary,
            fontSize: 14,
            children: `View on ${u}`
          }
        )
      }
    ) }) : null;
  }, [t.route, N, i, e.palette.text.primary]), B = Ce(() => {
    let s = /* @__PURE__ */ D(Or, { size: 14 });
    return C ? (s = tl(C), /* @__PURE__ */ ne(Tt, { direction: "row", justifyContent: "space-between", children: [
      /* @__PURE__ */ D(Fe, { color: e.palette.text.secondary, fontSize: 14, children: `Time to ${f}` }),
      /* @__PURE__ */ D(Fe, { fontSize: 14, children: s })
    ] })) : null;
  }, [C, e.palette.text.secondary, f]), I = i ? ji(i) : "", r = i ? bo(p, i, "tx") : "";
  return /* @__PURE__ */ D(ut, { sx: o.container, children: /* @__PURE__ */ ne(bn, { sx: o.card, children: [
    /* @__PURE__ */ ne(xn, { children: [
      /* @__PURE__ */ ne(Fe, { color: e.palette.text.secondary, marginBottom: "12px", children: [
        "Transaction #",
        r ? /* @__PURE__ */ D(os, { url: r, text: I }) : I
      ] }),
      z,
      H,
      k,
      /* @__PURE__ */ ne(
        Tt,
        {
          direction: "column",
          gap: "8px",
          justifyContent: "space-between",
          marginTop: "16px",
          children: [
            W,
            B
          ]
        }
      )
    ] }),
    /* @__PURE__ */ D(Ui, { flexItem: !0, sx: { margin: "0 16px", opacity: "50%" } }),
    U
  ] }) });
}, qB = dn(
  /* @__PURE__ */ D(
    "svg",
    {
      width: "107",
      height: "107",
      viewBox: "0 0 107 107",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ D(
        "path",
        {
          d: "M53.5 36.625V57.7188M104.125 53.5C104.125 60.1482 102.816 66.7312 100.271 72.8733C97.7273 79.0155 93.9982 84.5963 89.2973 89.2973C84.5963 93.9982 79.0155 97.7273 72.8733 100.271C66.7312 102.816 60.1482 104.125 53.5 104.125C46.8518 104.125 40.2688 102.816 34.1267 100.271C27.9845 97.7273 22.4037 93.9982 17.7027 89.2973C13.0018 84.5963 9.27274 79.0155 6.7286 72.8733C4.18445 66.7312 2.875 60.1482 2.875 53.5C2.875 40.0734 8.20869 27.1967 17.7027 17.7027C27.1967 8.20869 40.0734 2.875 53.5 2.875C66.9266 2.875 79.8032 8.20869 89.2973 17.7027C98.7913 27.1967 104.125 40.0734 104.125 53.5ZM53.5 74.5938H53.545V74.6388H53.5V74.5938Z",
          stroke: "currentColor",
          strokeWidth: "4",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  ),
  "Alert"
), JB = dn(
  /* @__PURE__ */ ne(
    "svg",
    {
      width: "106",
      height: "106",
      viewBox: "0 0 106 106",
      stroke: "none",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M52.5829 105C81.6236 105 105.166 81.4949 105.166 52.5C105.166 23.5051 81.6236 0 52.5829 0C23.5422 0 0 23.5051 0 52.5C0 81.4949 23.5422 105 52.5829 105ZM52.582 101.597C79.7404 101.597 101.757 79.6157 101.757 52.5001C101.757 25.3844 79.7404 3.40283 52.582 3.40283C25.4235 3.40283 3.40723 25.3844 3.40723 52.5001C3.40723 79.6157 25.4235 101.597 52.582 101.597Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M65.7583 39.2417L39.2418 65.7582",
            stroke: "currentColor",
            strokeWidth: "4"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M39.2417 39.2417L65.7582 65.7582",
            stroke: "currentColor",
            strokeWidth: "4"
          }
        )
      ]
    }
  ),
  "Alert"
), ig = dn(
  /* @__PURE__ */ ne(
    "svg",
    {
      width: "107",
      height: "106",
      viewBox: "0 0 107 106",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "currentColor",
            d: "M53.2,105.5c29,0,52.6-23.5,52.6-52.5S82.2.5,53.2.5.6,24,.6,53s23.5,52.5,52.6,52.5ZM53.2,102.1c27.2,0,49.2-22,49.2-49.1S80.4,3.9,53.2,3.9,4,25.9,4,53s22,49.1,49.2,49.1Z"
          }
        ),
        /* @__PURE__ */ D("rect", { fill: "currentColor", x: "51", y: "28.8", width: "5", height: "42.6" }),
        /* @__PURE__ */ D(
          "rect",
          {
            fill: "currentColor",
            x: "48",
            y: "63.9",
            width: "25.5",
            height: "5",
            transform: "translate(-29.2 62.4) rotate(-45)"
          }
        ),
        /* @__PURE__ */ D(
          "rect",
          {
            fill: "currentColor",
            x: "43.8",
            y: "53.7",
            width: "5",
            height: "25.5",
            transform: "translate(-33.4 52.2) rotate(-45)"
          }
        )
      ]
    }
  ),
  "Alert"
), XB = () => {
  const e = Cr(), t = or(), [o, i] = Xe(""), [c, n] = Xe(!1), [d, f] = Xe(!1), [p, l] = Xe(!1), [h, y] = Xe(!1), M = sr.useContext(Vi), { sourceToken: C, destToken: N } = zj(), w = Ce(
    () => ({
      spacer: {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        alignItems: "center",
        justifyContent: "center",
        width: "100%"
      },
      container: {
        margin: "auto",
        maxWidth: "650px"
      },
      header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%"
      },
      actionButton: {
        padding: "12px 16px",
        backgroundColor: t.palette.primary.main,
        borderRadius: "8px",
        margin: "auto",
        maxWidth: "420px",
        width: "100%"
      },
      backButton: {
        alignItems: "start",
        maxWidth: "420px",
        width: "100%"
      },
      claimButton: {
        backgroundColor: t.palette.warning.light,
        color: t.palette.warning.contrastText ?? t.palette.background.default,
        "&:hover": {
          backgroundColor: t.palette.warning.main
        }
      },
      circularProgressCircleIndeterminite: {
        stroke: "url(#circularGradient)",
        strokeDasharray: "100px, 200px",
        strokeLinecap: "round"
      },
      circularProgressCircleDeterminite: {
        strokeLinecap: "round",
        transitionDuration: "1s",
        transitionProperty: "all",
        transitionTimingFunction: "linear"
      },
      circularProgressRoot: {
        animationDuration: "1s"
      },
      errorBox: {
        maxWidth: "420px"
      },
      txStatusIcon: {
        width: "105px",
        height: "105px"
      },
      delayText: {
        maxWidth: "420px"
      }
    }),
    [t]
  ), {
    route: S,
    timestamp: T,
    isResumeTx: E,
    txData: j
  } = Ut((ae) => ae.redeem);
  Lh(j == null ? void 0 : j.fromChain, j == null ? void 0 : j.toChain);
  const [O, z] = Xe(void 0), { receipt: k } = M, H = k && w9(k), W = k && C9(k), U = k && El(k) || !!O, B = k && El(k) && k.error instanceof lg, I = k && Dl(k), {
    recipient: r,
    toChain: s,
    fromChain: u,
    token: g,
    receivedToken: v,
    amount: A,
    eta: L = 0,
    sendTx: m
  } = j, a = im(), x = Ce(() => {
    if (L && T)
      return new Date(T + L);
  }, [L, T]), { seconds: V, minutes: G, isRunning: Z, restart: te } = i2.useTimer({
    expiryTimestamp: /* @__PURE__ */ new Date(),
    autoStart: !1,
    onExpire: () => l(!0)
  });
  St(() => {
    !T || !L || Z || te(new Date(T + L), !0);
  }, [L, Z, te, T]);
  const q = s2({
    receipt: k,
    route: S,
    eta: x
  }), R = k && Wd(k) || q.isCompleted;
  St(() => {
    q.receipt && M.setReceipt(q.receipt);
  }, [M, q.receipt]);
  const Q = Ce(() => {
    if (!S)
      return !1;
    const ae = ge.routes.get(S);
    return ae ? ae.AUTOMATIC_DEPOSIT : !1;
  }, [S]), $ = tm(
    S,
    C,
    N,
    u,
    s,
    A,
    a
  );
  St(() => {
    const { receipt: ae } = M;
    if (ae)
      if (R)
        d || (f(!0), ge.triggerEvent({
          type: "transfer.success",
          details: $
        }), Q || ge.triggerEvent({
          type: "transfer.redeem.success",
          details: $
        }), n(!1), i(""), j != null && j.sendTx && Hh(j == null ? void 0 : j.sendTx));
      else if (W)
        ge.triggerEvent({
          type: "transfer.refunded",
          details: $
        });
      else if (El(ae)) {
        const [Le, ye] = b1(
          ae.error,
          $
        );
        i(Le), ge.triggerEvent({
          type: "transfer.error",
          details: $,
          error: ye
        }), console.error(
          `Transfer failed with error ${ye}: ${ae.error}`
        ), n(!1);
      } else if (O) {
        const [Le, ye] = b1(
          O,
          $
        );
        i(Le), ge.triggerEvent({
          type: "transfer.redeem.error",
          details: $,
          error: ye
        }), console.error(
          `Error while manually redeeming: ${ye.type} - ${O}`
        ), n(!1);
      } else H && !Q && (j != null && j.sendTx) && Uj(j == null ? void 0 : j.sendTx, "isReadyToClaim", !0);
  }, [
    k == null ? void 0 : k.state,
    R,
    W,
    H,
    O,
    d
  ]);
  const F = Ut(
    (ae) => ae.wallet.receiving
  ), P = Ce(() => {
    const ae = T + L, Le = Date.now();
    return ae > Le ? ae - Le : 0;
  }, [T, L, p, V]), _ = Ce(() => {
    const ae = {
      text: "",
      align: "left"
    };
    let Le;
    return typeof ge.ui.pageHeader == "string" ? Le = { ...ae, text: ge.ui.pageHeader } : Le = { ...ae, ...ge.ui.pageHeader }, /* @__PURE__ */ D(La, { title: Le.text, align: Le.align });
  }, []), X = Ce(() => {
    let ae = "Transaction submitted";
    return R ? ae = "Transaction completed" : W ? ae = "Transaction was refunded" : B && ia(S) ? ae = `Ready to claim on ${s}` : U ? ae = "Transaction failed" : I ? ae = "Transaction delayed" : H && !Q && (ae = `Ready to claim on ${s}`), /* @__PURE__ */ D(Tt, { children: /* @__PURE__ */ D(Fe, { "data-testid": "redeem-view-status-header", fontSize: 18, children: ae }) });
  }, [
    R,
    W,
    B,
    S,
    U,
    I,
    H,
    Q,
    s
  ]), le = Ce(() => {
    if (p)
      return /* @__PURE__ */ D(Tt, { children: /* @__PURE__ */ D(Fe, { color: t.palette.text.secondary, fontSize: 14, children: "Wrapping up..." }) });
    const ae = Z ? cl(G, V) : null;
    let Le = /* @__PURE__ */ D(Or, { size: 14 });
    return L && (Le = qj(L)), /* @__PURE__ */ ne(Tt, { alignItems: "center", justifyContent: "center", children: [
      /* @__PURE__ */ ne(Fe, { color: t.palette.text.secondary, fontSize: 14, children: [
        "ETA ",
        Le
      ] }),
      /* @__PURE__ */ D(Fe, { fontSize: 28, children: ae })
    ] });
  }, [
    L,
    p,
    Z,
    G,
    V,
    t.palette.text.secondary
  ]), ie = Ce(() => L ? (L - P) / L * 100 : 0, [L, P]), oe = Ce(() => /* @__PURE__ */ ne(Et, { children: [
    /* @__PURE__ */ D("svg", { width: 0, height: 0, children: /* @__PURE__ */ D("defs", { children: /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "circularGradient",
        x1: "0%",
        y1: "0%",
        x2: "100%",
        y2: "100%",
        children: [
          /* @__PURE__ */ D(
            "stop",
            {
              offset: "0%",
              stopColor: t.palette.primary.main,
              stopOpacity: "1"
            }
          ),
          /* @__PURE__ */ D(
            "stop",
            {
              offset: "100%",
              stopColor: t.palette.background.default,
              stopOpacity: "0.1"
            }
          )
        ]
      }
    ) }) }),
    /* @__PURE__ */ ne(wt, { sx: { position: "relative" }, children: [
      /* @__PURE__ */ D(
        Or,
        {
          variant: "determinate",
          sx: (ae) => ({
            color: ae.palette.primary.main,
            opacity: 0.2,
            position: "absolute"
          }),
          size: 140,
          thickness: 2,
          value: 100
        }
      ),
      /* @__PURE__ */ D(
        Or,
        {
          variant: p ? "indeterminate" : "determinate",
          sx: {
            "&.MuiCircularProgress-root": w.circularProgressRoot,
            "& .MuiCircularProgress-circle": p ? w.circularProgressCircleIndeterminite : w.circularProgressCircleDeterminite
          },
          disableShrink: p,
          size: 140,
          thickness: 2,
          value: ie
        }
      )
    ] }),
    /* @__PURE__ */ D(
      wt,
      {
        sx: {
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        children: le
      }
    )
  ] }), [
    w.circularProgressCircleDeterminite,
    w.circularProgressCircleIndeterminite,
    w.circularProgressRoot,
    le,
    p,
    ie,
    t.palette.background.default,
    t.palette.primary.main
  ]), pe = Ce(() => R ? /* @__PURE__ */ D(
    c2,
    {
      sx: { ...w.txStatusIcon, color: t.palette.primary.light }
    }
  ) : W || I ? /* @__PURE__ */ D(
    qB,
    {
      sx: { ...w.txStatusIcon, color: t.palette.warning.main }
    }
  ) : B && ia(S) ? /* @__PURE__ */ D(
    ig,
    {
      sx: { ...w.txStatusIcon, color: t.palette.warning.light }
    }
  ) : U ? /* @__PURE__ */ D(
    JB,
    {
      sx: { ...w.txStatusIcon, color: t.palette.error.light }
    }
  ) : !Q && H ? /* @__PURE__ */ D(
    ig,
    {
      sx: { ...w.txStatusIcon, color: t.palette.warning.light }
    }
  ) : oe, [
    R,
    W,
    I,
    B,
    S,
    U,
    Q,
    H,
    w.txStatusIcon,
    t.palette.primary.light,
    t.palette.warning.main,
    t.palette.warning.light,
    t.palette.error.light,
    oe
  ]);
  St(() => {
    let ae;
    if (M.receipt && Dl(M.receipt)) {
      n(!0);
      const ye = M.receipt.queueReleaseTime.getTime() - Date.now();
      ae = setTimeout(() => {
        n(!1);
      }, ye);
    }
    return () => {
      ae && clearTimeout(ae);
    };
  }, [M.receipt]);
  const se = Ce(() => {
    if (!r)
      return !1;
    if (E && s === "Solana" && F.address && F.type === "Solana" && F.address !== r && S && // These routes set the recipient address to the associated token address
    ["ManualTokenBridge", "ManualCCTP"].includes(S)) {
      const { address: Me } = Xc(v);
      return K9(
        new Ko(
          Wi(Me) ? e7 : Me.toString()
        ),
        new Ko(F.address)
      ).equals(new Ko(r)) ? (i(""), !0) : (i("Not connected to the receiving wallet"), !1);
    }
    const ae = F.address.toLowerCase(), Le = F.currentAddress.toLowerCase(), ye = r.toLowerCase();
    return ae === Le && ae === ye;
  }, [
    F,
    r,
    s,
    E,
    S,
    v
  ]), ce = ht(async () => {
    if (n(!0), i(""), z(void 0), !S)
      throw new Error("Unknown route, can not claim");
    if (!M.receipt)
      throw new Error("No receipt found, can not claim");
    const ae = {
      route: S,
      fromToken: va(ge.tokens.mustGet(g)),
      toToken: va(ge.tokens.mustGet(v)),
      fromChain: u,
      toChain: s
    };
    if (ge.triggerEvent({
      type: "transfer.redeem.initiate",
      details: ae
    }), !se)
      throw i("Not connected to the receiving wallet"), new Error("Not connected to the receiving wallet");
    if (!ge.chains[s])
      throw i("Your claim has failed, please try again"), new Error("invalid destination chain");
    const ye = M.route;
    try {
      if (!Ud(ye) && !Yd(ye))
        throw new Error("Route is not manual or finalizable");
      const Me = await gs.fromChain(
        s,
        F.address,
        {},
        ar.RECEIVING
      ), at = I && Yd(ye) ? ye.finalize(Me, M.receipt) : !I && Ud(ye) ? ye.complete(Me, M.receipt) : void 0;
      at && (ge.triggerEvent({
        type: "transfer.redeem.start",
        details: $
      }), await at);
    } catch (Me) {
      z(Me), n(!1);
    }
  }, [
    $,
    u,
    se,
    I,
    v,
    F.address,
    M.receipt,
    M.route,
    S,
    s,
    g
  ]), me = Ce(() => c ? /* @__PURE__ */ D(so, { disabled: !0, variant: "primary", sx: w.actionButton, children: /* @__PURE__ */ ne(
    Fe,
    {
      display: "flex",
      alignItems: "center",
      gap: 1,
      textTransform: "none",
      children: [
        /* @__PURE__ */ D(
          Or,
          {
            size: 16,
            sx: {
              color: t.palette.primary.contrastText
            }
          }
        ),
        "Transfer in progress"
      ]
    }
  ) }) : B && S === "CCTPExecutorRoute" && m ? /* @__PURE__ */ D(
    so,
    {
      variant: "primary",
      sx: w.actionButton,
      onClick: () => {
        e(i1()), e(Nn("search")), e(
          T8({
            txHash: m,
            chain: u
          })
        );
      },
      children: /* @__PURE__ */ D(Fe, { textTransform: "none", children: "Claim tokens to complete transfer" })
    }
  ) : I || !Q && H || ia(S) && B ? se ? /* @__PURE__ */ D(
    so,
    {
      sx: [w.actionButton, w.claimButton],
      variant: o ? "error" : "primary",
      onClick: ce,
      children: /* @__PURE__ */ D(Fe, { textTransform: "none", children: "Claim tokens to complete transfer" })
    }
  ) : /* @__PURE__ */ D(
    so,
    {
      variant: "primary",
      sx: w.actionButton,
      onClick: () => y(!0),
      children: /* @__PURE__ */ D(Fe, { textTransform: "none", children: "Connect receiving wallet" })
    }
  ) : /* @__PURE__ */ ne(Et, { children: [
    /* @__PURE__ */ D(
      so,
      {
        variant: "primary",
        sx: w.actionButton,
        onClick: () => {
          e(Nn("bridge"));
        },
        children: /* @__PURE__ */ D(Fe, { textTransform: "none", children: "Start a new transaction" })
      }
    ),
    !R && /* @__PURE__ */ D(Fe, { fontSize: "12px", sx: { margin: "auto", opacity: 0.6 }, children: "Your current transaction will continue to process in the background." })
  ] }), [
    c,
    I,
    Q,
    H,
    B,
    S,
    m,
    w.actionButton,
    w.claimButton,
    R,
    t.palette.primary.contrastText,
    se,
    o,
    ce,
    e,
    u
  ]), de = Ce(() => {
    var at;
    if (!M.receipt || !Dl(M.receipt))
      return null;
    const { to: ae, queueReleaseTime: Le } = M.receipt, ye = ((at = ge.tokens.get(v)) == null ? void 0 : at.symbol) || "", Me = Le.toLocaleString();
    return /* @__PURE__ */ D(
      Fe,
      {
        color: t.palette.text.secondary,
        fontSize: 14,
        sx: w.delayText,
        children: `Your transfer to ${ae} is delayed due to rate limits configured by ${ye}. After
        the delay ends on ${Me}, you will need to tap "Claim" to
        complete your transfer.`
      }
    );
  }, [
    w.delayText,
    v,
    M.receipt,
    t.palette.text.secondary
  ]);
  return /* @__PURE__ */ ne(
    wt,
    {
      sx: { ...w.container, ...w.spacer },
      "data-testid": "redeem-view",
      children: [
        _,
        /* @__PURE__ */ D(Tt, { sx: w.backButton, children: /* @__PURE__ */ D(
          di,
          {
            sx: { padding: 0 },
            onClick: () => e(Nn("bridge")),
            children: /* @__PURE__ */ D(GB, { sx: { fontSize: "32px" } })
          }
        ) }),
        X,
        /* @__PURE__ */ D(
          wt,
          {
            sx: {
              position: "relative",
              display: "inline-flex",
              alignItems: "center",
              marginBottom: "24px",
              height: "140px"
            },
            children: pe
          }
        ),
        /* @__PURE__ */ D($B, {}),
        me,
        de,
        /* @__PURE__ */ D(
          Gs,
          {
            error: !0,
            content: o,
            show: !!o,
            sx: w.errorBox
          }
        ),
        /* @__PURE__ */ D(ll, { color: t.palette.text.primary }),
        /* @__PURE__ */ D(
          Xh,
          {
            open: h,
            type: ar.RECEIVING,
            onClose: () => {
              y(!1);
            }
          }
        )
      ]
    }
  );
};
class wc extends f9 {
  constructor(t) {
    super(t), this.scrollListener = this.scrollListener.bind(this), this.eventListenerOptions = this.eventListenerOptions.bind(this), this.mousewheelListener = this.mousewheelListener.bind(this);
  }
  componentDidMount() {
    this.pageLoaded = this.props.pageStart, this.options = this.eventListenerOptions(), this.attachScrollListener();
  }
  componentDidUpdate() {
    if (this.props.isReverse && this.loadMore) {
      const t = this.getParentElement(this.scrollComponent);
      t.scrollTop = t.scrollHeight - this.beforeScrollHeight + this.beforeScrollTop, this.loadMore = !1;
    }
    this.attachScrollListener();
  }
  componentWillUnmount() {
    this.detachScrollListener(), this.detachMousewheelListener();
  }
  isPassiveSupported() {
    let t = !1;
    const o = {
      get passive() {
        t = !0;
      }
    };
    try {
      document.addEventListener("test", null, o), document.removeEventListener("test", null, o);
    } catch {
    }
    return t;
  }
  eventListenerOptions() {
    let t = this.props.useCapture;
    return this.isPassiveSupported() ? t = {
      useCapture: this.props.useCapture,
      passive: !0
    } : t = {
      passive: !1
    }, t;
  }
  // Set a defaut loader for all your `InfiniteScroll` components
  setDefaultLoader(t) {
    this.defaultLoader = t;
  }
  detachMousewheelListener() {
    let t = window;
    this.props.useWindow === !1 && (t = this.scrollComponent.parentNode), t.removeEventListener(
      "mousewheel",
      this.mousewheelListener,
      this.options ? this.options : this.props.useCapture
    );
  }
  detachScrollListener() {
    let t = window;
    this.props.useWindow === !1 && (t = this.getParentElement(this.scrollComponent)), t.removeEventListener(
      "scroll",
      this.scrollListener,
      this.options ? this.options : this.props.useCapture
    ), t.removeEventListener(
      "resize",
      this.scrollListener,
      this.options ? this.options : this.props.useCapture
    );
  }
  getParentElement(t) {
    const o = this.props.getScrollParent && this.props.getScrollParent();
    return o ?? (t && t.parentNode);
  }
  filterProps(t) {
    return t;
  }
  attachScrollListener() {
    const t = this.getParentElement(this.scrollComponent);
    if (!this.props.hasMore || !t)
      return;
    let o = window;
    this.props.useWindow === !1 && (o = t), o.addEventListener(
      "mousewheel",
      this.mousewheelListener,
      this.options ? this.options : this.props.useCapture
    ), o.addEventListener(
      "scroll",
      this.scrollListener,
      this.options ? this.options : this.props.useCapture
    ), o.addEventListener(
      "resize",
      this.scrollListener,
      this.options ? this.options : this.props.useCapture
    ), this.props.initialLoad && this.scrollListener();
  }
  mousewheelListener(t) {
    t.deltaY === 1 && !this.isPassiveSupported() && t.preventDefault();
  }
  scrollListener() {
    const t = this.scrollComponent, o = window, i = this.getParentElement(t);
    let c;
    if (this.props.useWindow) {
      const n = document.documentElement || document.body.parentNode || document.body, d = o.pageYOffset !== void 0 ? o.pageYOffset : n.scrollTop;
      this.props.isReverse ? c = d : c = this.calculateOffset(t, d);
    } else this.props.isReverse ? c = i.scrollTop : c = t.scrollHeight - i.scrollTop - i.clientHeight;
    c < Number(this.props.threshold) && t && t.offsetParent !== null && (this.detachScrollListener(), this.beforeScrollHeight = i.scrollHeight, this.beforeScrollTop = i.scrollTop, typeof this.props.loadMore == "function" && (this.props.loadMore(this.pageLoaded += 1), this.loadMore = !0));
  }
  calculateOffset(t, o) {
    return t ? this.calculateTopPosition(t) + (t.offsetHeight - o - window.innerHeight) : 0;
  }
  calculateTopPosition(t) {
    return t ? t.offsetTop + this.calculateTopPosition(t.offsetParent) : 0;
  }
  render() {
    const t = this.filterProps(this.props), {
      children: o,
      element: i,
      hasMore: c,
      initialLoad: n,
      isReverse: d,
      loader: f,
      loadMore: p,
      pageStart: l,
      ref: h,
      threshold: y,
      useCapture: M,
      useWindow: C,
      getScrollParent: N,
      ...w
    } = t;
    w.ref = (T) => {
      this.scrollComponent = T, h && h(T);
    };
    const S = [o];
    return c && (f ? d ? S.unshift(f) : S.push(f) : this.defaultLoader && (d ? S.unshift(this.defaultLoader) : S.push(this.defaultLoader))), sr.createElement(i, w, S);
  }
}
zt(wc, "propTypes", {
  children: b.node.isRequired,
  element: b.node,
  hasMore: b.bool,
  initialLoad: b.bool,
  isReverse: b.bool,
  loader: b.node,
  loadMore: b.func.isRequired,
  pageStart: b.number,
  ref: b.func,
  getScrollParent: b.func,
  threshold: b.number,
  useCapture: b.bool,
  useWindow: b.bool
}), zt(wc, "defaultProps", {
  element: "div",
  hasMore: !1,
  initialLoad: !0,
  pageStart: 0,
  ref: null,
  threshold: 250,
  useWindow: !0,
  isReverse: !1,
  useCapture: !1,
  loader: null,
  getScrollParent: null
});
const Jm = an(/* @__PURE__ */ D("path", {
  d: "M6.99 11 3 15l3.99 4v-3H14v-2H6.99zM21 9l-3.99-4v3H10v2h7.01v3z"
}), "SwapHoriz"), Rd = 8, KB = (e) => {
  const [t, o] = Xe(), [i, c] = Xe(""), [n, d] = Xe(!1), [f, p] = Xe(!0), { getOrFetchToken: l } = Hr(), { address: h, page: y = 0, pageSize: M = 30 } = e, C = ht(
    async (k) => {
      var q, R, Q, $, F;
      const { content: H, data: W, sourceChain: U, targetChain: B } = k, { standarizedProperties: I, payload: r } = H || {}, s = I.fromChain || (U == null ? void 0 : U.chainId), u = I.toChain || (B == null ? void 0 : B.chainId), g = I.tokenChain, v = ao(s);
      if (!v)
        return;
      const A = g ? ao(g) : ao(u);
      if (!A)
        return;
      let L;
      try {
        L = await l(
          un.tokenId(A, I.tokenAddress)
        );
      } catch {
      }
      if (!L) {
        const P = (W == null ? void 0 : W.symbol) && ge.tokens.findBySymbol(A, W.symbol);
        P && (L = P);
      }
      L || console.warn("Can't find token", k);
      const m = ao(u);
      let a, x, V;
      if (W && W.tokenAmount ? a = W.tokenAmount : I.amount && (a = cr(
        {
          amount: I.amount,
          decimals: I.normalizedDecimals ?? Rd
        },
        0
      )), I.amount) {
        const P = I.fee || r.fee || ((q = r.parsedPayload) == null ? void 0 : q.feeAmount) || ((R = r.parsedPayload) == null ? void 0 : R.relayerFee) || "0", _ = BigInt(I.amount) - BigInt(P);
        _ > 0 && (x = cr(
          {
            amount: _.toString(),
            decimals: Rd
          },
          0
        ));
      }
      W && W.usdAmount && (V = Number(W.usdAmount));
      const G = (Q = U.transaction) == null ? void 0 : Q.txHash, Z = (($ = U == null ? void 0 : U.status) == null ? void 0 : $.toLowerCase()) === "confirmed" && ((F = B == null ? void 0 : B.status) == null ? void 0 : F.toLowerCase()) !== "completed";
      return {
        txHash: G,
        sender: I.fromAddress || U.from,
        recipient: I.toAddress,
        amount: a,
        amountUsd: V,
        receiveAmount: x,
        fromChain: v,
        fromToken: L,
        toChain: m,
        toToken: L,
        senderTimestamp: U == null ? void 0 : U.timestamp,
        receiverTimestamp: B == null ? void 0 : B.timestamp,
        explorerLink: `${dg}tx/${G}${ge.isMainnet ? "" : "?network=TESTNET"}`,
        inProgress: Z
      };
    },
    [l]
  ), N = ht(
    (k) => C(k),
    [C]
  ), w = ht(
    (k) => C(k),
    [C]
  ), S = ht(
    (k) => C(k),
    [C]
  ), T = ht(
    (k) => C(k),
    [C]
  ), E = ht(
    async (k) => {
      var L;
      const H = await C(k);
      if (!H) return;
      const W = k.content.payload.parsedPayload, {
        finalTokenAddress: U,
        flagSet: B,
        minAmountFinish: I,
        recipientAddress: r,
        relayerFee: s
      } = W, u = ge.tokens.get(
        ao(k.content.standarizedProperties.tokenChain),
        k.content.standarizedProperties.tokenAddress
      );
      if (!u) return;
      const g = (L = B.flags) != null && L.shouldWrapNative ? Y5(H.fromChain) : u, v = ge.tokens.get(
        un.tokenId(
          H.toChain,
          ki(H.toChain, U).toString()
        )
      );
      if (!v) return;
      const A = BigInt(I) - BigInt(s);
      return H.fromToken = g, H.toToken = B.flags.shouldUnwrapNative ? Y5(H.toChain) : v, H.receiveAmount = A > 0 ? _j(
        cr(
          yn(A, v.decimals),
          0
        ),
        Rd
      ) : "", H.recipient = ki(H.toChain, r).toString(), H;
    },
    [C]
  ), j = ht(
    (k) => C(k),
    [C]
  ), O = Ce(
    () => ({
      PORTAL_TOKEN_BRIDGE: N,
      GENERIC_RELAYER: w,
      NATIVE_TOKEN_TRANSFER: S,
      CCTP_WORMHOLE_INTEGRATION: T,
      ETH_BRIDGE: E,
      USDT_BRIDGE: E,
      FAST_TRANSFERS: j,
      WORMHOLE_LIQUIDITY_LAYER: j
    }),
    [
      T,
      S,
      E,
      N,
      j,
      w
    ]
  ), z = ht(
    async (k) => (await Promise.all(
      k.map(async (H) => {
        var U, B;
        const W = ((B = (U = H.content) == null ? void 0 : U.standarizedProperties) == null ? void 0 : B.appIds) || [];
        if (W.includes("ETH_BRIDGE") || W.includes("USDT_BRIDGE"))
          return E(H);
        for (const I of W) {
          const r = O[I];
          if (r)
            return r(H);
        }
      })
    )).filter((H) => !!H),
    [O, E]
  );
  return St(() => {
    let k = !1;
    const H = new Headers({
      accept: "application/json"
    });
    return (async () => {
      d(!0);
      try {
        const U = await fetch(
          `${ge.wormholeApi}api/v1/operations?address=${h}&page=${y}&pageSize=${M}`,
          { headers: H }
        );
        if (U.status !== 200)
          o([]), p(!1), d(!1);
        else {
          const B = await U.json();
          if (!k) {
            const I = B == null ? void 0 : B.operations;
            if (I) {
              const r = await z(I);
              o((s) => {
                if (s && s.length > 0) {
                  const u = /* @__PURE__ */ new Set();
                  return s.forEach((g) => {
                    g != null && g.txHash && u.add(g.txHash);
                  }), s.concat(
                    r.filter(
                      (g) => !u.has(g.txHash)
                    )
                  );
                }
                return r;
              });
            }
            (I == null ? void 0 : I.length) < M && p(!1);
          }
        }
      } catch (U) {
        k || (p(!1), c(
          `Error fetching transaction history from WormholeScan: ${U}`
        ));
      } finally {
        d(!1);
      }
    })(), () => {
      k = !0;
    };
  }, [h, y, M, z]), {
    transactions: t,
    error: i,
    isFetching: n,
    hasMore: f
  };
}, eF = (e) => {
  const [t, o] = Xe(), [i, c] = Xe(""), [n, d] = Xe(!1), [f, p] = Xe(!0), { address: l, page: h = 0, pageSize: y = 30 } = e, M = (N) => {
    const {
      fromAmount: w,
      sourceChain: S,
      destChain: T,
      fromTokenPrice: E,
      fromTokenAddress: j,
      initiatedAt: O,
      toAmount: z,
      toTokenAddress: k,
      sourceTxHash: H,
      trader: W,
      destAddress: U,
      clientStatus: B
    } = N, I = ao(S), r = ao(T);
    if (!I || !r)
      return;
    let s, u;
    try {
      s = ge.tokens.get(
        og(I, j)
      ), u = ge.tokens.get(og(r, k));
    } catch (L) {
      console.error(L);
      return;
    }
    if (!s) {
      const L = ge.tokens.findBySymbol(
        I,
        N.fromTokenSymbol
      );
      L && (s = L);
    }
    if (!u) {
      const L = ge.tokens.findBySymbol(
        r,
        N.toTokenSymbol
      );
      L && (u = L);
    }
    if (!s || !u) {
      console.error("Cant find tokenz");
      return;
    }
    const g = B == null ? void 0 : B.toLowerCase(), v = g !== "completed" && g !== "refunded";
    return {
      txHash: H,
      sender: W,
      amount: w,
      amountUsd: Number(w) * E,
      recipient: U,
      fromChain: I,
      fromToken: s,
      toChain: r,
      toToken: u,
      receiveAmount: z,
      senderTimestamp: O,
      explorerLink: `https://explorer.mayan.finance/swap/${H}`,
      inProgress: v
    };
  }, C = ht(
    (N) => N.map((w) => M(w)).filter((w) => !!w),
    // Filter out unsupported transactions
    []
  );
  return St(() => {
    let N = !1;
    return (async () => {
      d(!0);
      const S = y, T = S * h;
      try {
        const E = await fetch(
          `${ge.mayanApi}/v3/swaps?trader=${l}&offset=${T}&limit=${S}`
        );
        if (E.status !== 200)
          o([]), p(!1), d(!1);
        else {
          const j = await E.json();
          if (!N) {
            const O = j == null ? void 0 : j.data;
            O && o((z) => {
              const k = C(O);
              if (z && z.length > 0) {
                const H = /* @__PURE__ */ new Set();
                return z.forEach((W) => {
                  W != null && W.txHash && H.add(W.txHash);
                }), z.concat(
                  k.filter(
                    (W) => !H.has(W.txHash)
                  )
                );
              }
              return k;
            }), (O == null ? void 0 : O.length) < S && p(!1);
          }
        }
      } catch (E) {
        N || (p(!1), c(`Error fetching transaction history from Mayan: ${E}`));
      } finally {
        d(!1);
      }
    })(), () => {
      N = !0;
    };
  }, [l, h, y, C]), {
    transactions: t,
    error: i,
    isFetching: n,
    hasMore: f
  };
};
function og(e, t) {
  if (t === "0x0000000000000000000000000000000000000000")
    return { chain: e, address: "native" };
  const o = ki(e, t);
  return { chain: e, address: o };
}
const Xm = (e) => {
  const { page: t = 0, pageSize: o = 30 } = e || {}, [i, c] = Xe(0), [n, d] = Xe(0), [f, p] = Xe(t), [l, h] = Xe(t), [y, M] = Xe(), { address: C } = Ut((U) => U.wallet.sending), {
    transactions: N,
    isFetching: w,
    hasMore: S,
    error: T
  } = KB({
    address: C,
    page: l,
    pageSize: o
  }), {
    transactions: E,
    isFetching: j,
    hasMore: O,
    error: z
  } = eF({
    address: C,
    page: f,
    pageSize: o
  }), k = ht(
    (U, B) => U ? U.concat(B) : B,
    []
  ), H = ht(
    (U) => {
      N && U <= (N == null ? void 0 : N.length) && d(U);
    },
    [N]
  ), W = ht(
    (U) => {
      E && U <= (E == null ? void 0 : E.length) && c(U);
    },
    [E]
  );
  return St(() => {
    O && f !== t && p(t), S && l !== t && h(t);
  }, [O, S, f, t, l]), St(() => {
    if (!N || !E)
      return;
    const U = [];
    let B = n, I = i;
    for (let u = 0; u < o; u++) {
      if (B === N.length && S || I === E.length && O) {
        H(B), W(I), M((A) => k(A, U));
        return;
      }
      const g = N[B], v = E[I];
      if (!g && !v) {
        H(B), W(I), M((A) => k(A, U));
        return;
      }
      if (!v)
        U.push(g), B += 1;
      else if (!g)
        U.push(v), I += 1;
      else {
        const A = new Date(g.senderTimestamp), L = new Date(v.senderTimestamp);
        A > L ? (U.push(g), B += 1) : (U.push(v), I += 1);
      }
    }
    H(B), W(I);
    const r = /* @__PURE__ */ new Set(), s = k(y, U).filter((u) => u.txHash && r.has(u.txHash) ? !1 : (r.add(u.txHash), !0));
    M((u) => s);
  }, [N, E]), {
    transactions: y,
    error: [T, z],
    isFetching: w || j,
    hasMore: S || O
  };
}, tF = (e) => {
  const t = or(), o = Ce(
    () => ({
      container: {
        width: "100%",
        maxWidth: "420px"
      },
      card: {
        width: "100%",
        borderRadius: "8px",
        border: `1px solid ${t.palette.input.border}`
      },
      cardHeader: {
        paddingBottom: 0
      }
    }),
    [t]
  ), {
    txHash: i,
    amount: c,
    amountUsd: n,
    fromChain: d,
    fromToken: f,
    toChain: p,
    toToken: l,
    receiveAmount: h,
    senderTimestamp: y,
    explorerLink: M
  } = e.data, C = Ce(
    () => /* @__PURE__ */ D(Fe, { component: "span", padding: "0px 8px", children: "·" }),
    []
  ), { getTokenPrice: N, lastTokenPriceUpdate: w } = Hr(), S = Ce(() => {
    const z = ge.chains[d];
    return /* @__PURE__ */ ne(Tt, { alignItems: "center", direction: "row", justifyContent: "flex-start", children: [
      /* @__PURE__ */ D(Pi, { chainConfig: z, token: f }),
      /* @__PURE__ */ ne(Tt, { direction: "column", marginLeft: "12px", children: [
        /* @__PURE__ */ ne(Fe, { fontSize: 16, children: [
          c,
          " ",
          f == null ? void 0 : f.symbol
        ] }),
        /* @__PURE__ */ ne(Fe, { color: t.palette.text.secondary, fontSize: 14, children: [
          n ? /* @__PURE__ */ ne(Et, { children: [
            Ws(n),
            C
          ] }) : null,
          z == null ? void 0 : z.displayName
        ] })
      ] })
    ] });
  }, [
    c,
    n,
    d,
    C,
    t.palette.text.secondary,
    f
  ]), T = Ce(() => {
    const z = ge.chains[p], k = l, H = h ? In(
      N,
      parseFloat(h),
      k
    ) : 0, W = H ? /* @__PURE__ */ ne(Et, { children: [
      H,
      C
    ] }) : null;
    return /* @__PURE__ */ ne(Tt, { alignItems: "center", direction: "row", justifyContent: "flex-start", children: [
      /* @__PURE__ */ D(Pi, { chainConfig: z, token: k }),
      /* @__PURE__ */ ne(Tt, { direction: "column", marginLeft: "12px", children: [
        /* @__PURE__ */ ne(Fe, { fontSize: 16, children: [
          h,
          " ",
          k == null ? void 0 : k.symbol
        ] }),
        /* @__PURE__ */ ne(Fe, { color: t.palette.text.secondary, fontSize: 14, children: [
          W,
          z == null ? void 0 : z.displayName
        ] })
      ] })
    ] });
  }, [
    w,
    p,
    l,
    h,
    N,
    C,
    t.palette.text.secondary
  ]), E = Ce(
    () => /* @__PURE__ */ D(
      Tt,
      {
        height: "24px",
        borderLeft: "1px solid #8B919D",
        marginLeft: "16px"
      }
    ),
    []
  ), j = Ce(() => {
    if (!y)
      return "Unknown time";
    const z = new Date(y), k = Date.now() - z.getTime();
    return k < 1e3 * 60 * 60 * 24 ? l8(k) : `${new Intl.DateTimeFormat("en-US", {
      dateStyle: "short",
      timeStyle: "short"
    }).format(z)}`;
  }, [y]), O = Ce(() => {
    const z = bo(d, i, "tx"), k = o8(i, 4, 4);
    return z ? /* @__PURE__ */ D(os, { url: z, text: k }) : k;
  }, [d, i]);
  return /* @__PURE__ */ D(wt, { sx: o.container, children: /* @__PURE__ */ D(bn, { sx: o.card, children: /* @__PURE__ */ ne(
    Fo,
    {
      disableTouchRipple: !0,
      onClick: () => {
        window.open(M, "_blank");
      },
      children: [
        /* @__PURE__ */ D(
          Xs,
          {
            sx: o.cardHeader,
            title: /* @__PURE__ */ ne(
              Fe,
              {
                justifyContent: "space-between",
                color: t.palette.text.secondary,
                display: "flex",
                children: [
                  /* @__PURE__ */ ne("span", { children: [
                    "Transaction #",
                    O
                  ] }),
                  /* @__PURE__ */ D("span", { children: j })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ ne(xn, { children: [
          S,
          E,
          T
        ] })
      ]
    }
  ) }) });
}, Li = {
  container: {
    margin: "auto",
    maxWidth: "420px"
  },
  infiniteScroller: {
    height: "640px",
    overflow: "auto",
    width: "100%"
  },
  txHistoryHeader: {
    width: "100%",
    display: "flex",
    alignItems: "center"
  },
  spacer: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    alignItems: "center",
    justifyContent: "center",
    width: "100%"
  }
}, rF = () => {
  const e = Cr(), t = er(), [o, i] = Xe(0), { transactions: c, isFetching: n, hasMore: d } = Xm({
    page: o
  }), f = Ut((y) => y.wallet.sending), p = Ce(() => {
    const y = {
      text: "",
      align: "left"
    };
    let M;
    return typeof ge.ui.pageHeader == "string" ? M = { ...y, text: ge.ui.pageHeader } : M = { ...y, ...ge.ui.pageHeader }, /* @__PURE__ */ D(La, { title: M.text, align: M.align });
  }, []), l = Ce(() => /* @__PURE__ */ ne(ut, { sx: Li.txHistoryHeader, children: [
    /* @__PURE__ */ D(Zs, { align: "left", size: 18, text: "Transaction history" }),
    /* @__PURE__ */ D(F9, { onClick: () => e(Nn("bridge")), children: /* @__PURE__ */ D(Jm, {}) })
  ] }), [Li.txHistoryHeader, e]), h = Ce(() => {
    if (c) {
      if (c.length === 0)
        return /* @__PURE__ */ D(ln, { color: t.palette.text.secondary, textAlign: "center", children: `No transactions found for the wallet ${ji(
          f.address
        )}` });
    } else return /* @__PURE__ */ D(Et, {});
    return /* @__PURE__ */ D(ut, { sx: Li.infiniteScroller, children: /* @__PURE__ */ D(
      wc,
      {
        hasMore: d,
        loadMore: (y) => i(y),
        useWindow: !1,
        style: { scrollbarWidth: "thin" },
        children: /* @__PURE__ */ D(ut, { sx: Li.spacer, children: c.map((y, M) => /* @__PURE__ */ D(tF, { data: y }, M)) })
      }
    ) });
  }, [
    Li.infiniteScroller,
    Li.spacer,
    d,
    f.address,
    t.palette.text.secondary,
    c
  ]);
  return /* @__PURE__ */ ne(ut, { sx: { ...Li.container, ...Li.spacer }, children: [
    p,
    l,
    h,
    (!c || n) && /* @__PURE__ */ D(Z1, {}),
    /* @__PURE__ */ D(ll, { color: t.palette.text.primary })
  ] });
}, nF = an(/* @__PURE__ */ D("path", {
  d: "M12 5.99 19.53 19H4.47zM2.74 18c-.77 1.33.19 3 1.73 3h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0zM11 11v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1m0 5h2v2h-2z"
}), "WarningAmberRounded");
function Al({
  children: e,
  warning: t = !1,
  error: o = !1,
  testId: i,
  color: c,
  sx: n,
  className: d
}) {
  const f = er(), p = c || t && f.palette.warning.main || o && f.palette.error.main || void 0;
  return /* @__PURE__ */ ne(
    ut,
    {
      className: d,
      sx: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        gap: "8px",
        ...n
      },
      "data-testid": i,
      role: "alert",
      "aria-live": "polite",
      children: [
        /* @__PURE__ */ D(
          nF,
          {
            fontSize: "small",
            htmlColor: p,
            "aria-hidden": "true"
          }
        ),
        /* @__PURE__ */ D(
          ln,
          {
            color: p,
            fontSize: "14px",
            fontWeight: 700,
            component: "div",
            children: e
          }
        )
      ]
    }
  );
}
const iF = {
  padding: "8px 16px",
  borderRadius: "48px",
  height: "48px",
  margin: "auto",
  maxWidth: "420px",
  width: "100%",
  boxShadow: "none"
}, oF = {
  backgroundColor: "button.primary",
  color: "button.primaryText",
  "&.Mui-disabled": {
    backgroundColor: "button.disabled",
    color: "button.disabledText"
  },
  "&:hover": {
    boxShadow: "none",
    backgroundColor: "button.hover",
    "&:disabled": {
      backgroundColor: "button.disabled",
      color: "button.disabledText"
    }
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "button.action",
    color: "button.actionText"
  }
}, aF = {
  backgroundColor: "error.main",
  color: "error.contrastText",
  "&:disabled": {
    backgroundColor: "error.main",
    color: "error.contrastText",
    opacity: 0.4
  }
}, sF = {
  primary: oF,
  error: aF
}, Tl = ({
  variant: e = "default",
  styleOverrides: t,
  ...o
}) => {
  const i = Ce(() => {
    if (e === "default")
      return t ?? {};
    const n = sF[e];
    return [iF, n, t].filter(
      Boolean
    );
  }, [e, t]);
  return /* @__PURE__ */ D(R9, { variant: e === "primary" || e === "error" ? "contained" : "text", sx: i, ...o });
}, Km = () => {
  const e = {
    text: "",
    align: "left"
  }, t = typeof ge.ui.pageHeader == "string" ? { ...e, text: ge.ui.pageHeader } : { ...e, ...ge.ui.pageHeader };
  return /* @__PURE__ */ D(La, { title: t.text, align: t.align });
}, e9 = (e) => {
  const t = Cr(), o = er(), i = Ce(
    () => ({
      listButton: {
        display: "flex",
        flexDirection: "row",
        padding: "12px 16px"
      },
      drawer: {
        width: "360px"
      },
      notInstalled: {
        opacity: 0.6
      },
      title: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
      },
      smOnly: {
        display: "none",
        [o.breakpoints.down("sm")]: {
          display: "block"
        }
      },
      addressInputContainer: {
        display: "flex",
        flexDirection: "row",
        gap: "8px",
        width: "100%",
        padding: "16px"
      },
      addressField: {
        flex: 1
      },
      submitButton: {
        width: "100%"
      }
    }),
    [o]
  ), { fromChain: c, toChain: n } = Ut(
    (z) => z.transferInput
  ), { onClose: d, type: f } = e, [p, l] = Xe(""), [h, y] = Xe(""), [M, C] = Xe(""), N = Ce(() => {
    const z = ge.chainsArr.map(
      (k) => Vr(k.sdkName)
    );
    return new Set(z);
  }, []), w = Ce(
    () => f === ar.SENDING ? c : n,
    [f, c, n]
  ), { walletOptionsResult: S } = Em({
    chain: w,
    supportedChains: N
  }), T = ht(
    async (z) => {
      w && (d == null || d(), await ps(f, w, z, t));
    },
    [w, f, d, t]
  ), E = ht(async () => {
    if (!w || !h) return;
    const z = ge.chains[w];
    if (!z) return;
    const k = await Dm(w, h);
    if (!k) {
      C("Invalid Address"), t(pa(ar.RECEIVING));
      return;
    }
    for (const U of Mc)
      if (k.toString().toLowerCase() === U.toLowerCase()) {
        C("Sanctioned Address"), t(pa(ar.RECEIVING));
        return;
      }
    const H = new Lo(k, w), W = {
      name: H.getName(),
      type: Vr(z.sdkName),
      icon: H.getIcon(),
      wallet: H
    };
    await ps(
      ar.RECEIVING,
      w,
      W,
      t
    ), d == null || d();
  }, [h, w, d, t]), j = ht(
    (z) => {
      const k = [...z].sort((W) => W.isReady ? -1 : 1), H = p ? k.filter(
        ({ name: W, type: U }) => [W, U].some(
          (B) => B.toLowerCase().includes(p.toLowerCase())
        )
      ) : k;
      return /* @__PURE__ */ D(Et, { children: H.length ? H.map((W) => /* @__PURE__ */ ne(
        Yr,
        {
          sx: i.listButton,
          dense: !0,
          onClick: () => W.isReady ? T(W) : window.open(W.wallet.getUrl()),
          children: [
            /* @__PURE__ */ D(Bo, { children: /* @__PURE__ */ D(Jh, { name: W.name, icon: W.icon }) }),
            /* @__PURE__ */ D(Fe, { component: "div", fontSize: 14, children: /* @__PURE__ */ ne(wt, { sx: W.isReady ? {} : i.notInstalled, children: [
              !W.isReady && "Install",
              " ",
              W.name
            ] }) })
          ]
        },
        W.name
      )) : /* @__PURE__ */ D(Mi, { children: /* @__PURE__ */ D(Fe, { children: "No results" }) }) });
    },
    [i.listButton, i.notInstalled, T, p]
  ), O = Ce(() => {
    var z;
    switch (S.state) {
      case "loading":
        return /* @__PURE__ */ D(Or, {});
      case "error":
        return /* @__PURE__ */ D(Al, { error: !0, children: S.error });
      case "result":
        return !!((z = S.options) != null && z.length) && /* @__PURE__ */ ne(hi, { children: [
          /* @__PURE__ */ D(Mi, { children: /* @__PURE__ */ ne(wt, { sx: i.title, children: [
            /* @__PURE__ */ D(Fe, { component: "div", fontSize: 16, children: e.type === ar.RECEIVING ? "Select destination wallet" : "Connect a wallet" }),
            /* @__PURE__ */ D(wt, { sx: i.smOnly, children: /* @__PURE__ */ D(di, { onClick: e.onClose, sx: { padding: 0 }, children: /* @__PURE__ */ D(xl, { sx: { height: "18px", width: "18px" } }) }) })
          ] }) }),
          /* @__PURE__ */ D(Mi, { children: /* @__PURE__ */ D(
            Ii,
            {
              fullWidth: !0,
              placeholder: "Search for a wallet",
              size: "small",
              variant: "outlined",
              value: p,
              onChange: (k) => l(k.target.value),
              InputProps: {
                startAdornment: /* @__PURE__ */ D(Eo, { position: "start", children: /* @__PURE__ */ D(Sm, {}) })
              }
            }
          ) }),
          j(S.options),
          e.showAddressInput && !p && /* @__PURE__ */ ne(Mi, { sx: i.addressInputContainer, children: [
            /* @__PURE__ */ D(
              Ii,
              {
                sx: i.addressField,
                fullWidth: !0,
                placeholder: "Send to a wallet address",
                size: "small",
                variant: "outlined",
                value: h,
                onChange: (k) => {
                  y(k.target.value), C("");
                },
                error: !!M,
                helperText: M
              }
            ),
            /* @__PURE__ */ D(
              Oi,
              {
                variant: "contained",
                color: "primary",
                onClick: E,
                disabled: !h,
                children: "Submit"
              }
            )
          ] })
        ] });
      default:
        return /* @__PURE__ */ D(Et, {});
    }
  }, [
    S,
    i.title,
    i.smOnly,
    i.addressInputContainer,
    i.addressField,
    e.type,
    e.onClose,
    e.showAddressInput,
    p,
    j,
    h,
    M,
    E
  ]);
  return /* @__PURE__ */ D(
    dl,
    {
      anchor: "right",
      open: f && e.open,
      onClose: () => {
        var z;
        return (z = e.onClose) == null ? void 0 : z.call(e);
      },
      slotProps: {
        paper: {
          sx: i.drawer
        }
      },
      children: /* @__PURE__ */ D(wt, { sx: i.drawer, children: O })
    }
  );
}, cF = (e) => {
  const { disabled: t = !1, type: o } = e, i = Ut((l) => l.wallet[o]), [c, n] = Xe(!1), d = ht(
    async (l) => {
      t || (l == null || l.close(), n(!0));
    },
    [t]
  ), f = Ce(() => i != null && i.address ? /* @__PURE__ */ D("div", { children: `Connected to ${Kc(
    i.type,
    i.address
  )}` }) : null, [i.address, i.type]), p = Ce(() => {
    const l = /* @__PURE__ */ D("span", { style: { width: "100%" }, children: /* @__PURE__ */ D(
      Tl,
      {
        disableRipple: !0,
        variant: "primary",
        "data-testid": `${e.side}-section-connect-wallet-button`,
        disabled: t,
        styleOverrides: {
          "&:disabled": {
            cursor: "not-allowed",
            pointerEvents: "all !important"
          }
        },
        onClick: () => d(),
        children: /* @__PURE__ */ D(Fe, { textTransform: "none", children: `Connect ${e.side} wallet` })
      }
    ) });
    return t ? /* @__PURE__ */ D($n, { title: `Please select a ${e.side} network`, children: l }) : /* @__PURE__ */ ne(Et, { children: [
      l,
      /* @__PURE__ */ D(
        e9,
        {
          open: c,
          type: e.type,
          onClose: () => {
            n(!1);
          },
          showAddressInput: e.type === ar.RECEIVING
        }
      )
    ] });
  }, [t, c, e.side, e.type, d]);
  return i && i.address ? f : p;
}, lF = sr.memo(cF), fF = (e) => {
  const {
    address: t,
    href: o,
    target: i = "_blank",
    label: c = "Transactions",
    sx: n
  } = e, d = ht(
    () => window.open(o.replace("{:address}", t), i),
    [t, o, i]
  );
  return /* @__PURE__ */ D(gg, { onClick: d, sx: n, children: /* @__PURE__ */ D(ln, { fontSize: 14, children: c }) });
}, uF = 1e3, dF = (e) => {
  const t = Cr(), o = or(), i = Ce(
    () => ({
      connectWallet: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "8px",
        cursor: "pointer",
        paddingTop: "2px",
        opacity: 1
      },
      walletAddress: {
        color: o.palette.text.secondary,
        marginLeft: "8px"
      },
      disabled: {
        opacity: "0.6",
        cursor: "default",
        pointerEvents: "none"
      }
    }),
    [o]
  ), { isTransactionInProgress: c } = Ut(
    (w) => w.transferInput
  ), n = Ut((w) => w.wallet[e.type]), [d, f] = Xe(!1), [p, l] = Xe(!1), h = Cl({
    variant: "popover",
    popupId: `connected-wallet-popover-${e.type}`
  }), y = ht(() => {
    h == null || h.close(), f(!0);
  }, [h]), M = ht(() => {
    el(n.address), h == null || h.close(), l(!0);
  }, [h, n.address]), C = ht(() => {
    t(t8(e.type)), h == null || h.close();
  }, [t, h, e.type]);
  St(() => {
    p && setTimeout(() => {
      l(!1);
    }, uF);
  }, [p]);
  const N = c ? {} : Il(h);
  return /* @__PURE__ */ ne(Et, { children: [
    n != null && n.address ? /* @__PURE__ */ ne(Et, { children: [
      /* @__PURE__ */ ne(
        wt,
        {
          sx: [
            i.connectWallet,
            c && i.disabled
          ],
          ...N,
          children: [
            /* @__PURE__ */ D(ws, { title: "Copied", open: p, placement: "top", arrow: !0, children: /* @__PURE__ */ D(
              Fe,
              {
                sx: i.walletAddress,
                fontSize: 12,
                fontWeight: 700,
                children: Kc(n.type, n.address)
              }
            ) }),
            h.isOpen ? /* @__PURE__ */ D(zm, { fontSize: "small" }) : /* @__PURE__ */ D(Om, { fontSize: "small" })
          ]
        }
      ),
      /* @__PURE__ */ D(
        Ea,
        {
          ...Nl(h),
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right"
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "right"
          },
          children: /* @__PURE__ */ ne(hi, { children: [
            /* @__PURE__ */ D(Yr, { onClick: M, children: /* @__PURE__ */ D(Fe, { fontSize: 14, children: "Copy address" }) }),
            ge.ui.explorer ? /* @__PURE__ */ D(
              fF,
              {
                address: n.address,
                href: ge.ui.explorer.href,
                target: ge.ui.explorer.target,
                label: ge.ui.explorer.label
              }
            ) : null,
            /* @__PURE__ */ D(Yr, { onClick: y, children: /* @__PURE__ */ D(Fe, { fontSize: 14, children: "Change wallet" }) }),
            /* @__PURE__ */ D(Yr, { onClick: C, children: /* @__PURE__ */ D(Fe, { fontSize: 14, children: "Disconnect" }) })
          ] })
        }
      )
    ] }) : null,
    /* @__PURE__ */ D(
      e9,
      {
        open: d,
        type: e.type,
        onClose: () => {
          f(!1);
        },
        showAddressInput: e.type === ar.RECEIVING
      }
    )
  ] });
}, hF = 500, pF = Sn(
  ({
    value: e,
    onChange: t,
    onDebouncedChange: o,
    ...i
  }) => {
    const [c, n] = Xe(e), [d, f] = Xe(!1), p = sl(
      o,
      hF
    ), l = ht(
      (h) => {
        let y = h.target.value;
        y === "." && (y = "0.");
        const M = Number(y);
        isNaN(M) || M < 0 || (n(h.target.value), t(h.target.value), p(h.target.value));
      },
      [p, t]
    );
    return St(() => {
      d || n(e);
    }, [e]), /* @__PURE__ */ D(
      Ii,
      {
        ...i,
        "data-testid": "amount-input",
        "aria-label": "Amount input",
        value: c,
        focused: d,
        onChange: l,
        onFocus: () => f(!0),
        onBlur: () => f(!1)
      }
    );
  }
);
function gF(e) {
  const t = er(), o = Ce(
    () => ({
      maxLength: 24,
      style: {
        color: e.error ? t.palette.error.main : t.palette.text.primary,
        fontSize: "32px",
        height: "32px"
      },
      onWheel: (h) => {
        h.currentTarget.blur();
      },
      step: "0.1"
    }),
    [e.error, t.palette.error.main, t.palette.text.primary]
  ), i = Ce(
    () => ({
      amountContainer: {
        width: "100%",
        maxWidth: "250px"
      },
      amountInput: {
        background: t.palette.input.background,
        borderRadius: "8px",
        border: "none"
      },
      amountCardContent: {
        display: "flex",
        alignItems: "center",
        height: "50px",
        padding: 0,
        ":last-child": {
          padding: 0
        }
      },
      balance: {
        color: t.palette.text.secondary,
        fontSize: "14px",
        lineHeight: "14px",
        textAlign: "right"
      }
    }),
    [t]
  ), {
    fromChain: c,
    toChain: n,
    isTransactionInProgress: d
  } = Ut((h) => h.transferInput), { sourceToken: f, destToken: p } = _o(), l = d || !c || !f || !n || !p;
  return /* @__PURE__ */ D(wt, { sx: i.amountContainer, children: /* @__PURE__ */ D(bn, { sx: i.amountInput, children: /* @__PURE__ */ D(xn, { sx: i.amountCardContent, children: /* @__PURE__ */ D(
    pF,
    {
      fullWidth: !0,
      disabled: l,
      placeholder: "0",
      slotProps: {
        htmlInput: o,
        input: {
          disableUnderline: !0
        }
      },
      variant: "standard",
      value: e.debouncedValue,
      onChange: e.onChange,
      onDebouncedChange: e.onDebouncedChange
    }
  ) }) }) });
}
const yF = Sn(gF);
function MF(e) {
  const t = or(), o = Hi(t.breakpoints.down("sm")), i = Ce(
    () => ({
      input: {
        "& fieldset": {
          borderRadius: "100vh"
        },
        "& input::placeholder": {
          color: t.palette.text.primary,
          opacity: 0.2
        },
        "& .MuiOutlinedInput-root": {
          "& .MuiOutlinedInput-input::placeholder": {
            fontWeight: 300
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderWidth: "1px"
          }
        }
      },
      icon: {
        height: 20,
        width: 20,
        color: t.palette.text.primary,
        opacity: 0.2
      }
    }),
    [t]
  );
  return /* @__PURE__ */ D(ut, { sx: { padding: "0 16px" }, children: /* @__PURE__ */ D(
    Ii,
    {
      sx: i.input,
      ref: (c) => {
        !o && c && setTimeout(() => {
          var n;
          (n = c.querySelector("input")) == null || n.focus();
        }, 10);
      },
      "data-testid": `${e.dataTestId}-input`,
      fullWidth: !0,
      placeholder: e.placeholder,
      size: "small",
      variant: "outlined",
      value: e.value,
      onChange: (c) => e.onChange(c.target.value),
      slotProps: {
        input: {
          startAdornment: /* @__PURE__ */ D(Eo, { position: "start", children: /* @__PURE__ */ D(Dh, { sx: i.icon }) })
        },
        htmlInput: {
          style: {
            fontSize: 16,
            height: 22,
            lineHeight: 22
          }
        }
      }
    }
  ) });
}
function mF(e) {
  const t = S8(), o = {
    wrapper: {
      maxHeight: "240px",
      display: "flex",
      flexDirection: "column",
      padding: 0
    },
    searchList: {
      marginTop: "12px",
      overflow: "auto"
    }
  }, { items: i, filterFn: c, searchQuery: n } = e, d = Ce(() => i.filter((f) => c(f, n)), [i, c, n]);
  return /* @__PURE__ */ ne(
    wt,
    {
      sx: { ...o.wrapper, ...e.sx },
      className: (e == null ? void 0 : e.className) || "",
      children: [
        e.title,
        /* @__PURE__ */ D(
          MF,
          {
            value: e.searchQuery,
            dataTestId: e.dataTestId,
            onChange: e.onQueryChange,
            placeholder: e.searchPlaceholder
          }
        ),
        /* @__PURE__ */ ne(
          hi,
          {
            sx: { ...o.searchList, ...t },
            "data-testid": e.dataTestId,
            children: [
              /* @__PURE__ */ D(wt, { sx: { padding: "0 16px" }, children: e.listTitle }),
              e.loading || d.map(e.renderFn)
            ]
          }
        )
      ]
    }
  );
}
const t9 = Sn(mF), D0 = 5;
function vF(e) {
  const t = or(), [o, i] = Xe(""), c = Ce(
    () => ({
      card: {
        background: t.palette.input.background,
        maxWidth: "420px",
        [t.breakpoints.down("sm")]: {
          width: "100vw"
        }
      },
      cardContent: {
        paddingBottom: "0!important",
        [t.breakpoints.down("sm")]: {
          padding: "16px 10px",
          ":last-child": {
            padding: "16px 10px"
          }
        }
      },
      title: {
        fontSize: "14px",
        marginBottom: "12px"
      },
      chainSearch: {
        maxHeight: "480px",
        [t.breakpoints.down("sm")]: {
          maxHeight: "640px"
        }
      },
      chainButton: {
        display: "flex",
        flexDirection: "column",
        padding: "8px",
        border: "1px solid transparent",
        borderRadius: "8px",
        "&.Mui-selected": {
          border: "1px solid",
          borderColor: t.palette.primary.main
        }
      },
      chainItem: {
        display: "flex",
        flexDirection: "row",
        padding: "8px",
        borderRadius: "8px"
      }
    }),
    [t]
  ), {
    chainList: n,
    selectedChainConfig: d,
    showSearch: f,
    setShowSearch: p,
    onChainSelect: l
  } = e, h = Ce(() => {
    const N = n ?? [], w = N.findIndex((S) => S.sdkName === (d == null ? void 0 : d.sdkName));
    return d && w && w >= D0 ? [d, ...N.slice(0, D0 - 1)] : N.slice(0, D0);
  }, [n, d]), y = ((n == null ? void 0 : n.length) ?? 0) > D0, M = Ce(() => /* @__PURE__ */ ne(hi, { component: Tt, direction: "row", "data-testid": "chain-short-list", children: [
    h.map((N) => /* @__PURE__ */ D($n, { title: N.displayName, children: /* @__PURE__ */ ne(
      Yr,
      {
        selected: (d == null ? void 0 : d.sdkName) === N.sdkName,
        sx: c.chainButton,
        "data-testid": `chain-button-${N.sdkName.toLowerCase()}`,
        onClick: () => l(N.sdkName),
        children: [
          /* @__PURE__ */ D(Un, { icon: N.icon }),
          /* @__PURE__ */ D(
            Fe,
            {
              fontSize: "12px",
              lineHeight: "12px",
              marginTop: "8px",
              whiteSpace: "nowrap",
              children: N.symbol
            }
          )
        ]
      }
    ) }, N.sdkName)),
    y ? /* @__PURE__ */ ne(
      Yr,
      {
        sx: c.chainButton,
        onClick: () => {
          p(!0);
        },
        children: [
          /* @__PURE__ */ D(km, { sx: { height: "36px", width: "36px" } }),
          /* @__PURE__ */ D(
            Fe,
            {
              fontSize: "12px",
              lineHeight: "12px",
              marginTop: "8px",
              whiteSpace: "nowrap",
              children: "other"
            }
          )
        ]
      }
    ) : null
  ] }), [
    c.chainButton,
    l,
    d == null ? void 0 : d.sdkName,
    p,
    y,
    h
  ]), C = Ce(
    () => /* @__PURE__ */ D(
      t9,
      {
        searchPlaceholder: "Search for a chain",
        sx: c.chainSearch,
        items: n ?? [],
        searchQuery: o,
        onQueryChange: i,
        filterFn: (N, w) => !w || N.displayName.toLowerCase().includes(w.toLowerCase()),
        renderFn: (N) => /* @__PURE__ */ ne(
          Yr,
          {
            dense: !0,
            sx: c.chainItem,
            onClick: () => {
              l(N.sdkName), p(!1);
            },
            children: [
              /* @__PURE__ */ D(Bo, { sx: { minWidth: "50px" }, children: /* @__PURE__ */ D(Un, { icon: N.icon, height: 36 }) }),
              /* @__PURE__ */ D(Fe, { fontSize: "16px", fontWeight: 500, children: N.displayName })
            ]
          },
          N.sdkName
        )
      }
    ),
    [
      n,
      o,
      c.chainItem,
      c.chainSearch,
      l,
      p
    ]
  );
  return h.length < 2 ? null : /* @__PURE__ */ D(bn, { sx: c.card, variant: "elevation", children: /* @__PURE__ */ ne(xn, { sx: c.cardContent, children: [
    /* @__PURE__ */ D(Fe, { sx: c.title, fontSize: "16px", fontWeight: 500, children: "Select a network" }),
    f ? C : M
  ] }) });
}
const r9 = sr.memo(vF);
function bF(e) {
  var p;
  const t = or(), o = Ce(
    () => ({
      tokenListItem: {
        display: "flex",
        justifyContent: "space-between",
        padding: "8px 16px",
        borderRadius: 0,
        ":hover": {
          backgroundColor: Mr(t.palette.primary.main).alpha(0.07).hexa()
        }
      },
      tokenListItemSelected: {
        backgroundColor: Mr(t.palette.primary.main).alpha(0.07).hexa()
      },
      tokenDetails: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
      },
      addressLink: {
        display: "inline-flex",
        alignItems: "center",
        height: "10px",
        overflow: "hidden",
        color: t.palette.text.primary,
        opacity: 0.6
      },
      wormholeWrappedDisclaimer: {
        display: "inline",
        marginRight: 4
      }
    }),
    [t]
  ), { chain: i, token: c } = e, n = (p = c.tokenId) == null ? void 0 : p.address.toString(), d = n ? bo(i, n, "token") : void 0, f = `${c.shortAddress}`;
  return /* @__PURE__ */ ne(
    Yr,
    {
      sx: {
        ...o.tokenListItem,
        ...e.isSelected && o.tokenListItemSelected
      },
      dense: !0,
      "data-testid": `token-button-${i.toLowerCase()}-${c.address.toString()}`,
      onMouseDown: e.onClick,
      children: [
        /* @__PURE__ */ ne(ut, { sx: o.tokenDetails, children: [
          /* @__PURE__ */ D(Bo, { children: /* @__PURE__ */ D(Js, { icon: e.token.icon }) }),
          /* @__PURE__ */ ne("div", { children: [
            /* @__PURE__ */ D(Fe, { children: c.display }),
            /* @__PURE__ */ ne(ut, { display: "flex", children: [
              c.tokenBridgeOriginalTokenId ? /* @__PURE__ */ D(
                ws,
                {
                  title: `Wormhole-wrapped from ${a8(
                    c.tokenBridgeOriginalTokenId.chain
                  )}`,
                  children: /* @__PURE__ */ D(ut, { margin: "2px", marginRight: "5px", children: /* @__PURE__ */ D(
                    Un,
                    {
                      height: 10,
                      icon: c.tokenBridgeOriginalTokenId.chain
                    }
                  ) })
                }
              ) : null,
              c.symbol ? /* @__PURE__ */ D(Fe, { fontSize: 10, color: t.palette.text.secondary, children: c.symbol }) : null,
              c.symbol && !c.isNativeGasToken ? /* @__PURE__ */ D(
                Fe,
                {
                  fontSize: 10,
                  color: t.palette.text.secondary,
                  marginLeft: 1,
                  marginRight: 1,
                  children: "•"
                }
              ) : null,
              c.isNativeGasToken ? null : /* @__PURE__ */ D(Fe, { fontSize: 10, color: t.palette.text.secondary, children: !Wi(n) && /* @__PURE__ */ ne(
                $i,
                {
                  onMouseDown: (l) => l.stopPropagation(),
                  onClick: (l) => l.stopPropagation(),
                  sx: o.addressLink,
                  href: d,
                  rel: "noreferrer noopener",
                  target: "_blank",
                  children: [
                    f,
                    /* @__PURE__ */ D(
                      Kh,
                      {
                        sx: {
                          height: "10px",
                          width: "10px",
                          marginLeft: "2px"
                        }
                      }
                    )
                  ]
                }
              ) })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ ne(Tt, { alignItems: "flex-end", children: [
          /* @__PURE__ */ D(Fe, { fontSize: 14, children: e.isFetchingBalance && e.balance === null ? /* @__PURE__ */ D(Or, { size: 24 }) : e.balance ? cr(vn(e.balance, 6)) : "" }),
          e.price && /* @__PURE__ */ D(Fe, { color: t.palette.text.secondary, fontSize: "10px", children: e.price })
        ] })
      ]
    }
  );
}
const xF = Sn(bF), wF = (e) => {
  var T, E;
  const t = er(), o = ge.ui.disableUserInputtedTokens !== !0, [i, c] = Xe(/* @__PURE__ */ new Map()), {
    getOrFetchToken: n,
    isFetchingToken: d,
    getTokenPrices: f,
    lastTokenPriceUpdate: p
  } = Hr();
  St(() => {
    const j = f(e.tokenList);
    c(j);
  }, [e.tokenList, f, p]), St(() => {
    if (o)
      try {
        if (e.searchQuery !== "") {
          const j = e.selectedChainConfig.sdkName, O = ki(j, e.searchQuery);
          O && (ge.tokens.get(j, e.searchQuery) || n({ chain: j, address: O }));
        }
      } catch {
      }
  }, [e.searchQuery, e.selectedChainConfig.sdkName]);
  const l = e.tokenList, h = Ce(() => {
    var O;
    let j = "";
    return (O = e.wallet) != null && O.address ? e.isSource ? j = "No supported tokens found in wallet" : e.sourceToken ? j = "No supported destination tokens for this route" : j = "Please select a source token first" : j = "Connect wallet to see available tokens", /* @__PURE__ */ D(Fe, { variant: "body2", color: t.palette.grey.A400, children: j });
  }, [
    (T = e.wallet) == null ? void 0 : T.address,
    e.isSource,
    e.sourceToken,
    t.palette.grey.A400
  ]), y = `Search for a token${o ? " or paste an address" : ""}`, M = Ce(
    () => ({
      card: {
        background: t.palette.input.background,
        maxWidth: "420px"
      },
      tokenListContainer: {
        padding: "16px 0 0 0 !important"
      },
      title: {
        fontSize: 14,
        marginBottom: "8px"
      },
      tokenLoader: {
        padding: 0,
        display: "flex",
        justifyContent: "space-between"
      },
      tokenList: {
        maxHeight: "360px",
        [t.breakpoints.down("sm")]: {
          maxHeight: "520px"
        }
      }
    }),
    [t]
  ), C = Ce(() => {
    var j;
    return !((j = e.wallet) != null && j.address) && !e.isConnectingWallet ? "empty" : e.isFetching ? "loading" : l.length === 0 ? "empty" : "ready";
  }, [
    (E = e.wallet) == null ? void 0 : E.address,
    e.isConnectingWallet,
    e.isFetching,
    l.length
  ]), N = C === "loading", w = C === "empty", S = /* @__PURE__ */ D(
    t9,
    {
      searchPlaceholder: y,
      sx: M.tokenList,
      dataTestId: "token-search-list",
      searchQuery: e.searchQuery,
      listTitle: w ? h : /* @__PURE__ */ D(ut, { display: "flex", width: "100%", children: /* @__PURE__ */ ne(
        Fe,
        {
          style: { flexGrow: "2" },
          fontSize: 14,
          color: t.palette.text.secondary,
          children: [
            "Tokens on ",
            e.selectedChainConfig.displayName
          ]
        }
      ) }),
      loading: N && [1, 2, 3].map((j) => /* @__PURE__ */ D(Yr, { sx: M.tokenLoader, dense: !0, children: /* @__PURE__ */ D(ut, { padding: "8px 16px", children: /* @__PURE__ */ D(ea, { variant: "circular", width: "36px", height: "36px" }) }) }, j)),
      items: l,
      onQueryChange: (j) => {
        e.onSearchQueryChange(j);
      },
      filterFn: (j, O) => {
        if (O.length === 0) return !0;
        const z = O.toLowerCase();
        return !!([j.symbol, j.name].some(
          (H) => {
            var W, U;
            return (U = (W = H == null ? void 0 : H.toLowerCase()) == null ? void 0 : W.startsWith) == null ? void 0 : U.call(W, z);
          }
        ) || j.address.toString().toLowerCase() === z || j.tokenBridgeOriginalTokenId && j.tokenBridgeOriginalTokenId.address.toString().toLowerCase().includes(z));
      },
      renderFn: (j) => {
        var H, W, U;
        const O = (W = (H = e.balances) == null ? void 0 : H[j.key]) == null ? void 0 : W.balance, z = i.get(j.key), k = O && z !== void 0 ? Ws(ri(z, O, j)) : null;
        return /* @__PURE__ */ D(
          xF,
          {
            token: j,
            chain: e.selectedChainConfig.sdkName,
            onClick: () => {
              e.onSelectToken(j);
            },
            balance: O,
            price: k,
            isSelected: j.key === ((U = e.selectedToken) == null ? void 0 : U.key),
            isFetchingBalance: e.isFetchingBalances
          },
          j.key
        );
      }
    }
  );
  return /* @__PURE__ */ D(Q1, { sx: M.card, variant: "elevation", children: /* @__PURE__ */ ne(pg, { sx: M.tokenListContainer, children: [
    /* @__PURE__ */ ne(ut, { sx: { display: "flex", padding: "0 16px" }, children: [
      /* @__PURE__ */ D(Fe, { width: "100%", sx: M.title, children: "Select a token" }),
      d || e.isFetchingBalances ? /* @__PURE__ */ D(
        Or,
        {
          sx: { alignSelf: "flex-end", marginBottom: "12px" },
          size: 14
        }
      ) : null
    ] }),
    S
  ] }) });
}, n9 = sr.memo(wF);
function CF({
  isDrawerOpen: e,
  setIsDrawerOpen: t,
  chainList: o,
  chainConfig: i,
  showChainSearch: c,
  setShowChainSearch: n,
  wallet: d,
  sortedTokens: f,
  balances: p,
  isFetchingBalances: l,
  isConnectingWallet: h,
  isFetchingTokens: y,
  token: M,
  sourceToken: C,
  isSource: N,
  searchQuery: w,
  setSearchQuery: S,
  onChainSelect: T,
  onTokenSelect: E
}) {
  const j = er(), O = /* @__PURE__ */ D(Tt, { alignItems: "center", paddingBottom: "4px", paddingTop: "8px", children: /* @__PURE__ */ D(
    wt,
    {
      sx: {
        width: "40px",
        height: "5px",
        backgroundColor: j.palette.text.secondary,
        borderRadius: "8px"
      }
    }
  ) });
  return /* @__PURE__ */ ne(
    wl,
    {
      anchor: "bottom",
      open: e,
      slotProps: {
        paper: {
          sx: {
            background: j.palette.input.background,
            borderRadius: "8px",
            height: "calc(100vh - 40px)",
            // Force full-height on small mobile devices with 40px padding at the top
            maxWidth: "100vw"
            // Force full-width on small mobile devices
          }
        }
      },
      transitionDuration: 200,
      onOpen: () => t(!0),
      onClose: () => t(!1),
      children: [
        O,
        /* @__PURE__ */ D(
          r9,
          {
            chainList: o,
            selectedChainConfig: i,
            showSearch: c,
            setShowSearch: n,
            wallet: d,
            onChainSelect: T
          }
        ),
        !c && i && /* @__PURE__ */ D(
          n9,
          {
            tokenList: f,
            balances: p,
            isFetchingBalances: l,
            isConnectingWallet: h,
            isFetching: y,
            selectedChainConfig: i,
            selectedToken: M,
            sourceToken: C,
            isSource: N,
            wallet: d,
            searchQuery: w,
            onSearchQueryChange: S,
            onSelectToken: E
          }
        )
      ]
    }
  );
}
const IF = Sn(CF);
function NF({
  popupState: e,
  anchorEl: t,
  chainList: o,
  chainConfig: i,
  showChainSearch: c,
  setShowChainSearch: n,
  wallet: d,
  sortedTokens: f,
  balances: p,
  isFetchingBalances: l,
  isConnectingWallet: h,
  isFetchingTokens: y,
  token: M,
  sourceToken: C,
  isSource: N,
  searchQuery: w,
  setSearchQuery: S,
  onChainSelect: T,
  onTokenSelect: E
}) {
  const j = er();
  return /* @__PURE__ */ ne(
    Ea,
    {
      ...Nl(e),
      transitionDuration: 200,
      anchorEl: t,
      anchorOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      marginThreshold: 4,
      slotProps: {
        paper: {
          sx: {
            width: "100%",
            maxWidth: "420px",
            borderRadius: "8px",
            background: j.palette.input.background,
            backdropFilter: "blur(4px)",
            WebkitBackdropFilter: "blur(4px)"
            // Safari support
          }
        },
        root: {
          sx: {
            backdropFilter: "blur(4px)",
            WebkitBackdropFilter: "blur(4px)"
            // Safari support
          }
        }
      },
      children: [
        /* @__PURE__ */ D(
          r9,
          {
            chainList: o,
            selectedChainConfig: i,
            showSearch: c,
            setShowSearch: n,
            wallet: d,
            onChainSelect: T
          }
        ),
        !c && i && /* @__PURE__ */ D(
          n9,
          {
            tokenList: f,
            balances: p,
            isFetchingBalances: l,
            isConnectingWallet: h,
            isFetching: y,
            selectedChainConfig: i,
            selectedToken: M,
            sourceToken: C,
            isSource: N,
            wallet: d,
            searchQuery: w,
            onSearchQueryChange: S,
            onSelectToken: E
          }
        )
      ]
    }
  );
}
const AF = Sn(NF);
function TF(e) {
  var A, L, m, a;
  const t = or(), o = Cr(), i = Hi(t.breakpoints.down("sm")), { amount: c } = Ut((x) => x.transferInput), { getTokenPrice: n } = Hr(), [d, f] = Xe(!1), [p, l] = Xe(!1), [h, y] = Xe(""), [M, C] = Xe(
    c ? cr(c) : ""
  ), [N, w] = Xe(
    c ? cr(c) : ""
  ), [S, T] = Xe(0), E = Um({
    tokenList: e.tokenList || [],
    searchQuery: h,
    selectedChainConfig: e.chain ? ge.chains[e.chain] : {},
    selectedToken: e.token,
    sourceToken: e.sourceToken,
    wallet: e.wallet,
    balances: e.balances,
    isSourceList: e.isSource
    // true for source, false for destination
  }), j = Cl({
    variant: "popover",
    popupId: "asset-picker"
  }), O = Ce(() => {
    var x;
    return e.isSource && e.balances && e.token ? (x = e.balances[e.token.key]) == null ? void 0 : x.balance : null;
  }, [e.isSource, e.balances, e.token]);
  St(() => {
    (i && !p || !i && !j.isOpen) && setTimeout(() => {
      f(!1);
    }, 300);
  }, [p, i, j.isOpen]), St(() => {
    if (i && p && !e.chain || !i && j.isOpen && !e.chain) {
      const x = e.chainList.find(
        (V) => !Sh(V.sdkName, e.wallet)
      );
      x && e.setChain(x.sdkName);
    }
  }, [i, p, j.isOpen]);
  const z = Ce(() => e.chain ? ge.chains[e.chain] : void 0, [e.chain]), k = Ce(() => {
    var V;
    const x = e.token ? /* @__PURE__ */ D(Et, { children: e.token.display }) : /* @__PURE__ */ D(Et, { children: "Select" });
    return /* @__PURE__ */ D(ws, { title: ((V = e.token) == null ? void 0 : V.display) ?? "Select a token", children: /* @__PURE__ */ D(
      Fe,
      {
        component: "div",
        fontSize: "16px",
        fontWeight: 500,
        maxWidth: "64px",
        noWrap: !0,
        children: x
      }
    ) });
  }, [e.token]), H = e.isTransactionInProgress || i ? {} : Il(j), W = Ce(
    () => ({
      root: {
        maxWidth: "420px",
        background: t.palette.input.background,
        borderRadius: "8px",
        padding: "16px"
      },
      container: {
        display: "flex",
        flexDirection: "column",
        height: "114px",
        maxWidth: "452px",
        gap: "16px"
      },
      title: {
        color: t.palette.text.secondary,
        display: "flex",
        height: "12px",
        justifyContent: "space-between"
      },
      selector: {
        cursor: "pointer",
        borderRadius: "50px",
        border: `1px solid ${t.palette.input.border}`,
        background: Mr(t.palette.input.background).darken(0.2).hex(),
        "&:hover": {
          borderColor: t.palette.primary.main
        }
      },
      cardContent: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingLeft: "8px",
        paddingRight: "12px",
        paddingTop: "6px",
        paddingBottom: "6px",
        ":last-child": {
          paddingLeft: "8px",
          paddingRight: "12px",
          paddingTop: "6px",
          paddingBottom: "6px"
        }
      },
      chainSelector: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
      },
      disabled: {
        opacity: "0.6",
        cursor: "default",
        pointerEvents: "none"
      },
      percentButton: {
        borderRadius: "50px",
        color: t.palette.text.primary,
        height: "24px",
        minWidth: "40px",
        backgroundColor: t.palette.text.primary + cn[10],
        opacity: 0.7
      },
      percentButtonSelected: {
        color: t.palette.background.form,
        backgroundColor: t.palette.primary.main,
        opacity: "unset"
      }
    }),
    [t]
  ), U = !c || c.amount === "" || c.amount === "0" ? 0 : e.quote ? oi((A = e.quote) == null ? void 0 : A.destinationToken.amount) : void 0, B = !e.isSource || !e.wallet.address ? null : /* @__PURE__ */ D(Fe, { color: t.palette.text.secondary, variant: "body2", children: O ? cr(vn(O, 6)) : "0" }), I = ht((x) => {
    C(x), T(0);
  }, []), r = ht(
    (x) => {
      o(Hs(x)), w(x);
    },
    [o]
  ), s = ht(
    (x) => {
      e.setChain(x), y("");
    },
    [e]
  );
  St(() => {
    !c && (M || N) && (I(""), r(""));
  }, [c]);
  const u = ht(
    (x) => /* @__PURE__ */ D(
      Oi,
      {
        sx: {
          ...W.percentButton,
          ...S === x ? W.percentButtonSelected : {}
        },
        disabled: e.isTransactionInProgress,
        onClick: () => {
          if (O) {
            const V = ai(O) * BigInt(x) / BigInt(100), G = cr(
              yn(V, O.decimals)
            );
            I(G), r(G), T(x);
          }
        },
        children: /* @__PURE__ */ D(Fe, { fontSize: 12, fontWeight: 600, textTransform: "none", children: x === 100 ? "Max" : `${x}%` })
      }
    ),
    [
      W.percentButton,
      W.percentButtonSelected,
      S,
      e.isTransactionInProgress,
      O,
      I,
      r
    ]
  ), g = Ce(() => {
    if (!e.token)
      return null;
    const x = In(
      n,
      W1("1", e.token.decimals),
      e.token
    );
    return x ? /* @__PURE__ */ D(
      ut,
      {
        sx: {
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          opacity: 0.7
        },
        children: /* @__PURE__ */ D(
          Fe,
          {
            color: t.palette.text.primary,
            fontSize: "14px",
            children: `1 ${e.token.symbol} = ${x}`
          }
        )
      }
    ) : null;
  }, [e.token, n, t.palette.text.primary]), v = !e.wallet.address || !O ? null : /* @__PURE__ */ ne(ut, { sx: { display: "flex", gap: "6px" }, children: [
    u(25),
    u(50),
    u(100)
  ] });
  return /* @__PURE__ */ ne(ut, { sx: W.root, children: [
    /* @__PURE__ */ ne(ut, { sx: W.container, children: [
      /* @__PURE__ */ ne(ut, { sx: W.title, children: [
        /* @__PURE__ */ D(Fe, { fontSize: 12, variant: "body2", children: e.isSource ? "From" : "To" }),
        /* @__PURE__ */ D(
          dF,
          {
            type: e.isSource ? ar.SENDING : ar.RECEIVING
          }
        )
      ] }),
      /* @__PURE__ */ ne(
        ut,
        {
          sx: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between"
          },
          children: [
            e.isSource ? /* @__PURE__ */ D(
              yF,
              {
                value: M,
                debouncedValue: N,
                receiveAmount: U,
                supportedSourceTokens: e.tokenList || [],
                tokenBalance: e.token ? (L = e.balances[e.token.key]) == null ? void 0 : L.balance : null,
                warning: (m = e.amountValidation) == null ? void 0 : m.warning,
                error: (a = e.amountValidation) == null ? void 0 : a.error,
                onChange: I,
                onDebouncedChange: r
              }
            ) : /* @__PURE__ */ D(
              ut,
              {
                sx: {
                  display: "flex",
                  alignContent: "center",
                  alignItems: "center",
                  width: "100%",
                  maxWidth: "250px",
                  height: "50px"
                },
                children: /* @__PURE__ */ D(
                  P9,
                  {
                    fullWidth: !0,
                    disabled: !0,
                    placeholder: "0",
                    slotProps: {
                      htmlInput: {
                        style: {
                          fontSize: "32px",
                          height: "32px"
                        }
                      },
                      input: {
                        disableUnderline: !0
                      }
                    },
                    variant: "standard",
                    value: U
                  }
                )
              }
            ),
            /* @__PURE__ */ D(
              bn,
              {
                sx: [
                  W.selector,
                  e.isTransactionInProgress && W.disabled
                ],
                "data-testid": e.dataTestId,
                variant: "elevation",
                onMouseDown: (x) => {
                  i ? l(!0) : j.open(x);
                },
                onTouchEnd: (x) => {
                  x.stopPropagation(), x.preventDefault(), i ? l(!0) : j.open(x);
                },
                ...H,
                children: /* @__PURE__ */ D(xn, { sx: W.cardContent, children: /* @__PURE__ */ ne(Fe, { sx: W.chainSelector, component: "div", gap: 1, children: [
                  /* @__PURE__ */ D(Pi, { chainConfig: z, token: e.token }),
                  k
                ] }) })
              }
            )
          ]
        }
      ),
      e.isSource ? /* @__PURE__ */ ne(
        ut,
        {
          sx: {
            height: "24px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "8px"
          },
          children: [
            /* @__PURE__ */ D(ut, { children: B }),
            /* @__PURE__ */ D(ut, { children: v })
          ]
        }
      ) : g
    ] }),
    i ? /* @__PURE__ */ D(
      IF,
      {
        isDrawerOpen: p,
        setIsDrawerOpen: l,
        chainList: e.chainList,
        chainConfig: z,
        showChainSearch: d,
        setShowChainSearch: f,
        wallet: e.wallet,
        sortedTokens: E,
        balances: e.balances,
        isFetchingBalances: e.isFetchingBalances,
        isConnectingWallet: e.isConnectingWallet,
        isFetchingTokens: e.isFetchingTokens,
        token: e.token,
        sourceToken: e.sourceToken,
        isSource: e.isSource,
        searchQuery: h,
        setSearchQuery: y,
        onChainSelect: s,
        onTokenSelect: (x) => {
          e.setToken(x), l(!1);
        }
      }
    ) : /* @__PURE__ */ D(
      AF,
      {
        popupState: j,
        anchorEl: e.anchorEl,
        chainList: e.chainList,
        chainConfig: z,
        showChainSearch: d,
        setShowChainSearch: f,
        wallet: e.wallet,
        sortedTokens: E,
        balances: e.balances,
        isFetchingBalances: e.isFetchingBalances,
        isConnectingWallet: e.isConnectingWallet,
        isFetchingTokens: e.isFetchingTokens,
        token: e.token,
        sourceToken: e.sourceToken,
        isSource: e.isSource,
        searchQuery: h,
        setSearchQuery: y,
        onChainSelect: s,
        onTokenSelect: (x) => {
          e.setToken(x), j.close();
        }
      }
    )
  ] });
}
const ag = Sn(TF);
function LF(e) {
  return Bt("MuiSkeleton", e);
}
Ft("MuiSkeleton", ["root", "text", "rectangular", "rounded", "circular", "pulse", "wave", "withChildren", "fitContent", "heightAuto"]);
const SF = (e) => {
  const {
    classes: t,
    variant: o,
    animation: i,
    hasChildren: c,
    width: n,
    height: d
  } = e;
  return Rt({
    root: ["root", o, i, c && "withChildren", c && !n && "fitContent", c && !d && "heightAuto"]
  }, LF, t);
}, P1 = fi`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`, U1 = fi`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`, EF = typeof P1 != "string" ? jo`
        animation: ${P1} 2s ease-in-out 0.5s infinite;
      ` : null, DF = typeof U1 != "string" ? jo`
        &::after {
          animation: ${U1} 2s linear 0.5s infinite;
        }
      ` : null, jF = Ke("span", {
  name: "MuiSkeleton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.variant], o.animation !== !1 && t[o.animation], o.hasChildren && t.withChildren, o.hasChildren && !o.width && t.fitContent, o.hasChildren && !o.height && t.heightAuto];
  }
})(kt(({
  theme: e
}) => {
  const t = Vb(e.shape.borderRadius) || "px", o = Gb(e.shape.borderRadius);
  return {
    display: "block",
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: e.vars ? e.vars.palette.Skeleton.bg : q9(e.palette.text.primary, e.palette.mode === "light" ? 0.11 : 0.13),
    height: "1.2em",
    variants: [{
      props: {
        variant: "text"
      },
      style: {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${o}${t}/${Math.round(o / 0.6 * 10) / 10}${t}`,
        "&:empty:before": {
          content: '"\\00a0"'
        }
      }
    }, {
      props: {
        variant: "circular"
      },
      style: {
        borderRadius: "50%"
      }
    }, {
      props: {
        variant: "rounded"
      },
      style: {
        borderRadius: (e.vars || e).shape.borderRadius
      }
    }, {
      props: ({
        ownerState: i
      }) => i.hasChildren,
      style: {
        "& > *": {
          visibility: "hidden"
        }
      }
    }, {
      props: ({
        ownerState: i
      }) => i.hasChildren && !i.width,
      style: {
        maxWidth: "fit-content"
      }
    }, {
      props: ({
        ownerState: i
      }) => i.hasChildren && !i.height,
      style: {
        height: "auto"
      }
    }, {
      props: {
        animation: "pulse"
      },
      style: EF || {
        animation: `${P1} 2s ease-in-out 0.5s infinite`
      }
    }, {
      props: {
        animation: "wave"
      },
      style: {
        position: "relative",
        overflow: "hidden",
        /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
        WebkitMaskImage: "-webkit-radial-gradient(white, black)",
        "&::after": {
          background: `linear-gradient(
                90deg,
                transparent,
                ${(e.vars || e).palette.action.hover},
                transparent
              )`,
          content: '""',
          position: "absolute",
          transform: "translateX(-100%)",
          bottom: 0,
          left: 0,
          right: 0,
          top: 0
        }
      }
    }, {
      props: {
        animation: "wave"
      },
      style: DF || {
        "&::after": {
          animation: `${U1} 2s linear 0.5s infinite`
        }
      }
    }]
  };
})), $0 = /* @__PURE__ */ ue.forwardRef(function(t, o) {
  const i = Pt({
    props: t,
    name: "MuiSkeleton"
  }), {
    animation: c = "pulse",
    className: n,
    component: d = "span",
    height: f,
    style: p,
    variant: l = "text",
    width: h,
    ...y
  } = i, M = {
    ...i,
    animation: c,
    component: d,
    variant: l,
    hasChildren: !!y.children
  }, C = SF(M);
  return /* @__PURE__ */ D(jF, {
    as: d,
    ref: o,
    className: It(C.root, n),
    ownerState: M,
    ...y,
    style: {
      width: h,
      height: f,
      ...p
    }
  });
});
fe.process.env.NODE_ENV !== "production" && ($0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The animation.
   * If `false` the animation effect is disabled.
   * @default 'pulse'
   */
  animation: b.oneOf(["pulse", "wave", !1]),
  /**
   * Optional children to infer width and height from.
   */
  children: b.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: b.object,
  /**
   * @ignore
   */
  className: b.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: b.elementType,
  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: b.oneOfType([b.number, b.string]),
  /**
   * @ignore
   */
  style: b.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: b.oneOfType([b.arrayOf(b.oneOfType([b.func, b.object, b.bool])), b.func, b.object]),
  /**
   * The type of content that will be rendered.
   * @default 'text'
   */
  variant: b.oneOfType([b.oneOf(["circular", "rectangular", "rounded", "text"]), b.string]),
  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: b.oneOfType([b.number, b.string])
});
const OF = an(/* @__PURE__ */ D("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "ChevronRight"), zF = dn(
  /* @__PURE__ */ D(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ D(
        "path",
        {
          d: "M6 0C4.81331 0 3.65327 0.351894 2.66658 1.01118C1.67989 1.67047 0.910851 2.60754 0.456725 3.7039C0.00259973 4.80026 -0.11622 6.00665 0.115291 7.17054C0.346802 8.33443 0.918247 9.40352 1.75736 10.2426C2.59648 11.0818 3.66557 11.6532 4.82946 11.8847C5.99335 12.1162 7.19974 11.9974 8.2961 11.5433C9.39246 11.0891 10.3295 10.3201 10.9888 9.33342C11.6481 8.34673 12 7.18669 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0ZM8.37805 6.87818H5.88071C5.69132 6.87818 5.50969 6.80295 5.37577 6.66903C5.24185 6.53512 5.16662 6.35349 5.16662 6.1641V2.32764C5.16662 2.13825 5.24185 1.95662 5.37577 1.8227C5.50969 1.68879 5.69132 1.61355 5.88071 1.61355C6.07009 1.61355 6.25172 1.68879 6.38564 1.8227C6.51956 1.95662 6.59479 2.13825 6.59479 2.32764V5.45001H8.37805C8.56743 5.45001 8.74906 5.52525 8.88298 5.65916C9.0169 5.79308 9.09213 5.97471 9.09213 6.1641C9.09213 6.35349 9.0169 6.53512 8.88298 6.66903C8.74906 6.80295 8.56743 6.87818 8.37805 6.87818Z",
          fill: "currentColor"
        }
      )
    }
  ),
  "Clock"
), kF = (e) => {
  const t = or(), o = Ce(
    () => ({
      content: {
        width: "100%",
        cursor: "pointer",
        maxWidth: "372px",
        overflow: "visible",
        padding: "16px 20px"
      },
      container: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        width: "100%"
      },
      amounts: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: "8px",
        width: "100%"
      },
      toggleButton: {
        backgroundColor: Mr(t.palette.text.primary).alpha(0.1).hexa(),
        border: "1px solid transparent",
        borderRadius: "8px",
        "&.Mui-selected": {
          border: `1px solid ${t.palette.primary.main}`,
          borderRadius: "8px"
        },
        "&.MuiToggleButtonGroup-middleButton": {
          margin: "0 2px"
        },
        "&.MuiToggleButtonGroup-lastButton": {
          margin: "0"
        }
      }
    }),
    [t]
  ), {
    destinationGasDrop: i,
    disabled: c,
    isExecutorRoute: n,
    isSelected: d,
    onGasChange: f
  } = e, { toNativeToken: p } = Ut((z) => ({
    ...z.relay
  })), { fromChain: l, toChain: h } = Ut(
    (z) => z.transferInput
  ), { getTokenPrice: y, lastTokenPriceUpdate: M } = Hr(), C = ge.tokens.getGasToken(h), N = ge.tokens.getGasToken(l), [w, S] = Xe(
    d && i.amount !== "0"
  ), [T, E] = Xe(p * 100);
  St(() => {
    d || (S(!1), E(0));
  }, [d]);
  const j = Ce(() => {
    if (!h || !C)
      return null;
    const z = cr(vn(i, 6)), k = In(
      y,
      i,
      C
    ), H = k ? `(${k})` : "";
    return `+${z} ${C.symbol} ${H}`;
  }, [C, M, i, h]), O = Ce(
    () => /* @__PURE__ */ ne(
      n2,
      {
        exclusive: !0,
        fullWidth: !0,
        value: T.toString(),
        onChange: (z) => {
          const k = Number(z.currentTarget.value);
          k === T ? (E(0), f(0)) : (E(k), f(k / 100));
        },
        children: [
          /* @__PURE__ */ D(wo, { sx: o.toggleButton, disableRipple: !0, value: "5", children: "5%" }),
          /* @__PURE__ */ D(wo, { sx: o.toggleButton, disableRipple: !0, value: "10", children: "10%" }),
          /* @__PURE__ */ D(wo, { sx: o.toggleButton, disableRipple: !0, value: "15", children: "15%" })
        ]
      }
    ),
    [T, o.toggleButton, f]
  );
  return !N || !C ? /* @__PURE__ */ D(Et, {}) : /* @__PURE__ */ ne(ut, { sx: o.content, children: [
    /* @__PURE__ */ ne(yo, { direction: "row", alignItems: "center", justifyContent: "space-between", children: [
      /* @__PURE__ */ D(ln, { children: `Need extra ${C.symbol} on ${h}?` }),
      /* @__PURE__ */ D(
        e2,
        {
          sx: {
            padding: "9px 12px",
            right: "-9px",
            "& .MuiSwitch-switchBase.Mui-checked": {
              color: t.palette.primary.main
            },
            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
              backgroundColor: t.palette.primary.main
            },
            "& .MuiSwitch-track": {
              height: "20px",
              borderRadius: "9px"
            }
          },
          checked: w,
          disabled: c,
          onClick: (z) => {
            const { checked: k } = z.target;
            S(k), k ? n && (E(100), f(1)) : (E(0), f(0));
          }
        }
      )
    ] }),
    /* @__PURE__ */ D(xa, { in: w, unmountOnExit: !0, children: /* @__PURE__ */ D(ut, { sx: o.container, children: /* @__PURE__ */ ne(yo, { children: [
      !n && O,
      /* @__PURE__ */ ne(ut, { sx: o.amounts, children: [
        /* @__PURE__ */ ne(yo, { alignItems: "center", flexDirection: "row", children: [
          /* @__PURE__ */ D(
            ln,
            {
              color: t.palette.text.secondary,
              fontSize: 14,
              marginRight: "4px",
              children: "Gas amount"
            }
          ),
          /* @__PURE__ */ D(
            $n,
            {
              title: n ? `Add a small amount of ${N.symbol} to your transaction to receive ${j} on ${h}.` : "This additional gas is swapped from a percentage of your transfer amount.",
              children: /* @__PURE__ */ D(
                Qm,
                {
                  sx: {
                    color: t.palette.text.secondary,
                    fontSize: "16px"
                  }
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ D(ln, { color: t.palette.primary.main, fontSize: 14, children: j })
      ] })
    ] }) }) })
  ] });
}, _F = ({ isFastest: e, isCheapest: t, isOnlyChoice: o }) => {
  const i = er();
  return e ? /* @__PURE__ */ ne(ut, { sx: { display: "flex", alignItems: "center" }, children: [
    /* @__PURE__ */ D(
      Hm,
      {
        sx: {
          width: "16px",
          height: "16px",
          marginRight: "4px",
          fill: i.palette.primary.main
        }
      }
    ),
    /* @__PURE__ */ D(ln, { component: "span", fontSize: "14px", lineHeight: "14px", children: o ? "Fast" : "Fastest" })
  ] }) : t && !o ? /* @__PURE__ */ ne(ut, { sx: { display: "flex", alignItems: "center" }, children: [
    /* @__PURE__ */ D(
      Zm,
      {
        sx: {
          width: "16px",
          height: "16px",
          marginRight: "4px",
          color: i.palette.primary.main
        }
      }
    ),
    /* @__PURE__ */ D(ln, { component: "span", fontSize: "14px", lineHeight: "14px", children: "Cheapest" })
  ] }) : null;
}, BF = sr.memo(_F), FF = 20, RF = (e) => {
  const t = er(), o = Ce(
    () => ({
      container: {
        width: "100%"
      },
      card: {
        borderRadius: "8px",
        width: "100%",
        maxWidth: "412px"
      },
      cardSelected: {
        backgroundColor: t.palette.card.background,
        borderColor: t.palette.primary.main
      },
      cardHeader: {
        padding: "20px 20px 0px"
      },
      cardContent: {
        marginTop: "18px",
        padding: "0px 20px 20px"
      },
      errorIcon: {
        color: t.palette.error.main,
        height: "34px",
        width: "34px",
        marginRight: "24px"
      },
      messageContainer: {
        padding: "12px 0px 0px"
      },
      warningIcon: {
        color: t.palette.warning.main,
        height: "34px",
        width: "34px",
        marginRight: "12px"
      },
      disabled: {
        opacity: "0.6",
        cursor: "default",
        pointerEvents: "none"
      }
    }),
    [t]
  ), i = ge.routes.get(e.route), {
    toChain: c,
    fromChain: n,
    isTransactionInProgress: d
  } = Ut((s) => s.transferInput), { getTokenPrice: f, lastTokenPriceUpdate: p } = Hr(), { quote: l, isSelected: h } = e, y = l == null ? void 0 : l.destinationNativeGas, { sourceToken: M, destToken: C } = _o(), { disabled: N, showGasSlider: w } = Ym({
    destToken: C,
    route: e.route,
    isTransactionInProgress: d
  }), S = Ce(() => {
    if (!(l != null && l.relayFee))
      return !1;
    const s = oi(l.relayFee.amount), u = ge.tokens.get(l.relayFee.token), g = ri(f, s, u);
    return g === void 0 ? !1 : g > FF;
  }, [f, l == null ? void 0 : l.relayFee]), T = Ce(() => {
    if (!c || e.destinationGasDrop === void 0 || ai(e.destinationGasDrop) === 0n)
      return /* @__PURE__ */ D(Et, {});
    const s = ge.chains[c], u = ge.tokens.getGasToken(c);
    if (!s || !u)
      return /* @__PURE__ */ D(Et, {});
    const g = In(
      f,
      e.destinationGasDrop,
      u
    ), v = cr(
      vn(e.destinationGasDrop, 6)
    ), A = g ? ` (${g})` : "";
    return /* @__PURE__ */ ne(Tt, { direction: "row", justifyContent: "space-between", children: [
      /* @__PURE__ */ D(
        Fe,
        {
          color: t.palette.text.secondary,
          component: "div",
          fontSize: "14px",
          lineHeight: "14px",
          children: "Additional gas"
        }
      ),
      /* @__PURE__ */ D(
        Fe,
        {
          color: t.palette.text.primary,
          component: "div",
          fontSize: "14px",
          lineHeight: "14px",
          children: `${v} ${u.symbol}${A}`
        }
      )
    ] });
  }, [
    c,
    p,
    e.destinationGasDrop,
    f,
    p,
    t.palette.text.secondary,
    t.palette.text.primary
  ]), E = Ce(
    () => /* @__PURE__ */ ne(Tt, { direction: "row", justifyContent: "space-between", children: [
      /* @__PURE__ */ D(
        Fe,
        {
          color: t.palette.text.secondary,
          component: "div",
          fontSize: "14px",
          lineHeight: "14px",
          children: `Time to ${c}`
        }
      ),
      /* @__PURE__ */ D(
        Fe,
        {
          component: "div",
          fontSize: "14px",
          lineHeight: "14px",
          sx: {
            color: l != null && l.eta && l.eta < 60 * 1e3 ? t.palette.success.main : t.palette.text.primary
          },
          children: l != null && l.eta ? tl(l.eta) : "N/A"
        }
      )
    ] }),
    [
      c,
      l == null ? void 0 : l.eta,
      t.palette.success.main,
      t.palette.text.primary,
      t.palette.text.secondary
    ]
  ), j = Ce(() => e.route ? !i.AUTOMATIC_DEPOSIT : !1, [e.route, i.AUTOMATIC_DEPOSIT]), O = Ce(
    () => /* @__PURE__ */ D(Ui, { flexItem: !0, sx: { marginTop: "24px" } }),
    []
  ), z = Ce(() => e.error ? /* @__PURE__ */ ne(Et, { children: [
    O,
    /* @__PURE__ */ ne(Tt, { sx: o.messageContainer, direction: "row", alignItems: "center", children: [
      /* @__PURE__ */ D(Wm, { sx: o.errorIcon }),
      /* @__PURE__ */ D(
        Fe,
        {
          color: t.palette.error.main,
          fontSize: "14px",
          lineHeight: "18px",
          children: e.error
        }
      )
    ] })
  ] }) : null, [
    o.errorIcon,
    o.messageContainer,
    O,
    e.error,
    t.palette.error.main
  ]), k = Ce(() => {
    const s = [];
    j && s.push(
      /* @__PURE__ */ ne("div", { children: [
        O,
        /* @__PURE__ */ ne(
          Tt,
          {
            sx: o.messageContainer,
            direction: "row",
            alignItems: "center",
            children: [
              /* @__PURE__ */ D(sa, { sx: o.warningIcon }),
              /* @__PURE__ */ ne(Tt, { children: [
                /* @__PURE__ */ D(
                  Fe,
                  {
                    color: t.palette.warning.main,
                    fontSize: 14,
                    lineHeight: "18px",
                    children: "This transfer requires two transactions."
                  }
                ),
                /* @__PURE__ */ D(
                  Fe,
                  {
                    color: t.palette.text.secondary,
                    fontSize: 14,
                    lineHeight: "18px",
                    children: "You will need to make two wallet approvals and have gas on the destination chain."
                  }
                )
              ] })
            ]
          }
        )
      ] }, "ManualTransactionWarning")
    );
    for (const u of (l == null ? void 0 : l.warnings) || [])
      if (u.type === "DestinationCapacityWarning" && u.delayDurationSec) {
        const g = f8(u.delayDurationSec);
        s.push(
          /* @__PURE__ */ ne("div", { children: [
            O,
            /* @__PURE__ */ ne(
              Tt,
              {
                sx: o.messageContainer,
                direction: "row",
                alignItems: "center",
                children: [
                  /* @__PURE__ */ D(sa, { sx: o.warningIcon }),
                  /* @__PURE__ */ D(
                    Fe,
                    {
                      color: t.palette.warning.main,
                      fontSize: 14,
                      lineHeight: "18px",
                      children: `Your transfer to ${c} may be delayed due to rate limits set by ${C.display}. If your transfer is delayed, you will need to return after ${g} to complete the transfer. Please consider this before proceeding.`
                    }
                  )
                ]
              }
            )
          ] }, `${u.type}-${u.delayDurationSec}`)
        );
      }
    return S && s.push(
      /* @__PURE__ */ ne("div", { children: [
        O,
        /* @__PURE__ */ ne(
          Tt,
          {
            sx: o.messageContainer,
            direction: "row",
            alignItems: "center",
            children: [
              /* @__PURE__ */ D(sa, { sx: o.warningIcon }),
              /* @__PURE__ */ ne(Tt, { children: [
                /* @__PURE__ */ D(
                  Fe,
                  {
                    color: t.palette.warning.main,
                    fontSize: 14,
                    lineHeight: "18px",
                    children: "Output amount is much lower than input amount."
                  }
                ),
                /* @__PURE__ */ D(
                  Fe,
                  {
                    color: t.palette.text.secondary,
                    fontSize: 14,
                    lineHeight: "18px",
                    children: "Double check before proceeding."
                  }
                )
              ] })
            ]
          }
        )
      ] }, "HighFee")
    ), s;
  }, [
    j,
    S,
    O,
    o.warningIcon,
    o.messageContainer,
    t.palette.warning.main,
    t.palette.text.secondary,
    l == null ? void 0 : l.warnings,
    C,
    c
  ]), H = Ce(() => M ? e.route === "AutomaticNtt" && (M == null ? void 0 : M.symbol) === "wstETH" && (n === "Ethereum" && c === "Bsc" || n === "Bsc" && c === "Ethereum") ? "via NTT: Wormhole + Axelar" : i.rc.meta.provider ? `via ${i.rc.meta.provider}` : "" : "", [e.route, i, n, M, c]), W = Ce(() => l ? oi(l == null ? void 0 : l.destinationToken.amount) : void 0, [l]), U = Ce(() => {
    if (l)
      return cr(vn(l.destinationToken.amount, 6));
  }, [l]), B = Ce(() => {
    if (e.error)
      return /* @__PURE__ */ D(Fe, { color: "error", children: "Route is unavailable" });
    if (W === void 0 || !C)
      return null;
    const s = S ? t.palette.warning.main : t.palette.text.primary;
    return /* @__PURE__ */ ne(
      Fe,
      {
        fontSize: "18px",
        lineHeight: "18px",
        color: s,
        component: "div",
        marginBottom: "6px",
        children: [
          U,
          " ",
          C.symbol
        ]
      }
    );
  }, [
    e.error,
    W,
    U,
    C,
    S,
    t.palette.warning.main,
    t.palette.text.primary
  ]), I = Ce(() => {
    if (e.error || !c || !C || W === void 0)
      return null;
    const s = In(f, W, C);
    return /* @__PURE__ */ D(
      Fe,
      {
        fontSize: "14px",
        lineHeight: "14px",
        color: t.palette.text.secondary,
        component: "div",
        children: `${s} ${H}`
      }
    );
  }, [
    c,
    C,
    f,
    p,
    e.error,
    H,
    W,
    t.palette.text.secondary
  ]), r = Ce(() => h || typeof e.onSelect != "function" ? "default" : e.error ? "not-allowed" : "pointer", [e.error, h, e.onSelect]);
  return e.route ? /* @__PURE__ */ D(
    ut,
    {
      sx: {
        ...o.container
      },
      "data-testid": `route-${e.route}${h ? "-selected" : ""}`,
      children: /* @__PURE__ */ D(
        bn,
        {
          sx: {
            ...o.card,
            ...h && o.cardSelected,
            ...d && o.disabled,
            border: "1px solid",
            borderColor: h ? t.palette.primary.main : "transparent",
            opacity: 1
          },
          children: /* @__PURE__ */ ne(
            Fo,
            {
              component: "div",
              disabled: d || typeof e.onSelect != "function" || e.error !== void 0,
              disableTouchRipple: !0,
              sx: { cursor: r },
              onClick: () => {
                var s;
                (s = e.onSelect) == null || s.call(e, e.route);
              },
              children: [
                /* @__PURE__ */ D(
                  Xs,
                  {
                    sx: o.cardHeader,
                    avatar: /* @__PURE__ */ D(Js, { icon: C == null ? void 0 : C.icon }),
                    title: B,
                    subheader: I,
                    action: /* @__PURE__ */ D(
                      BF,
                      {
                        isFastest: e.isFastest,
                        isCheapest: e.isCheapest,
                        isOnlyChoice: e.isOnlyChoice
                      }
                    )
                  }
                ),
                /* @__PURE__ */ ne(xn, { sx: o.cardContent, children: [
                  /* @__PURE__ */ ne(Tt, { gap: "14px", children: [
                    i.AUTOMATIC_DEPOSIT ? null : `You pay gas on ${c}`,
                    T,
                    E
                  ] }),
                  z,
                  k
                ] }),
                w && /* @__PURE__ */ ne(Et, { children: [
                  /* @__PURE__ */ D(Ui, { flexItem: !0, sx: { margin: "0px 16px" } }),
                  /* @__PURE__ */ D(
                    kF,
                    {
                      destinationGasDrop: y || yn(0n, 8),
                      disabled: N,
                      isExecutorRoute: ia(e.route),
                      isSelected: h,
                      onGasChange: (s) => {
                        typeof e.onGasChange == "function" && e.onGasChange(s);
                      }
                    }
                  )
                ] })
              ]
            }
          )
        }
      )
    },
    e.route
  ) : /* @__PURE__ */ D(Et, {});
}, PF = sr.memo(RF), UF = ({
  routesWithQuotes: e,
  highlightedRoute: t,
  quotes: o,
  fastestRoute: i,
  cheapestRoute: c,
  onRouteSelect: n,
  onGasChange: d
}) => /* @__PURE__ */ D(Tt, { sx: { gap: "16px", overflowY: "auto", maxHeight: "75vh" }, children: e.map((f) => {
  var M;
  const p = f === t, l = o[f], h = l != null && l.success ? l : void 0, y = (l == null ? void 0 : l.success) === !1 ? ((M = l == null ? void 0 : l.error) == null ? void 0 : M.message) ?? `Error while getting a quote for ${f}.` : void 0;
  return /* @__PURE__ */ D(
    PF,
    {
      route: f,
      error: y,
      isSelected: p && !y,
      isFastest: f === i.name,
      isCheapest: f === c.name,
      isOnlyChoice: e.length === 1,
      onSelect: n,
      onGasChange: d,
      quote: h
    },
    f
  );
}) }), i9 = sr.memo(UF);
function YF({
  open: e,
  onOpen: t,
  onClose: o,
  routesWithQuotes: i,
  highlightedRoute: c,
  quotes: n,
  fastestRoute: d,
  cheapestRoute: f,
  onRouteSelect: p,
  onGasChange: l,
  onSelectRoute: h,
  selectButtonDisabled: y
}) {
  const M = er(), C = /* @__PURE__ */ ne(
    wt,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%"
      },
      children: [
        /* @__PURE__ */ D(Fe, { component: "span", fontSize: "16px", fontWeight: 600, children: "Routes" }),
        /* @__PURE__ */ D(di, { sx: { opacity: 0.5, padding: 0 }, onClick: o, children: /* @__PURE__ */ D(xl, { sx: { height: "24px", width: "24px" } }) })
      ]
    }
  ), N = /* @__PURE__ */ D(
    Tl,
    {
      variant: "primary",
      styleOverrides: {
        padding: "16px 24px",
        height: "48px",
        borderRadius: "48px"
      },
      onClick: h,
      disabled: y,
      "data-testid": "select-route-button",
      fullWidth: !0,
      children: /* @__PURE__ */ D(Fe, { fontSize: "16px", fontWeight: 600, textTransform: "none", children: "Select" })
    }
  );
  return /* @__PURE__ */ D(
    wl,
    {
      anchor: "bottom",
      open: e,
      slotProps: {
        paper: {
          sx: {
            background: M.palette.input.background,
            borderRadius: "8px",
            height: "calc(100vh - 40px)",
            // Force full-height on small mobile devices with 40px padding at the top
            maxWidth: "100vw"
            // Force full-width on small mobile devices
          }
        }
      },
      transitionDuration: 200,
      onOpen: t,
      onClose: o,
      children: /* @__PURE__ */ ne(
        wt,
        {
          sx: {
            backgroundColor: M.palette.background.paper,
            padding: "8px",
            borderRadius: "12px",
            gap: "16px",
            display: "flex",
            flexDirection: "column",
            maxWidth: "420px"
          },
          children: [
            C,
            /* @__PURE__ */ D(
              i9,
              {
                routesWithQuotes: i,
                highlightedRoute: c,
                quotes: n,
                fastestRoute: d,
                cheapestRoute: f,
                onRouteSelect: p,
                onGasChange: l
              }
            ),
            N
          ]
        }
      )
    }
  );
}
const WF = Sn(YF);
function HF({
  open: e,
  onClose: t,
  routesWithQuotes: o,
  highlightedRoute: i,
  quotes: c,
  fastestRoute: n,
  cheapestRoute: d,
  onRouteSelect: f,
  onGasChange: p,
  onSelectRoute: l,
  selectButtonDisabled: h
}) {
  const y = er(), M = /* @__PURE__ */ ne(
    wt,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%"
      },
      children: [
        /* @__PURE__ */ D(Fe, { component: "span", fontSize: "16px", fontWeight: 600, children: "Routes" }),
        /* @__PURE__ */ D(di, { sx: { opacity: 0.5, padding: 0 }, onClick: t, children: /* @__PURE__ */ D(xl, { sx: { height: "24px", width: "24px" } }) })
      ]
    }
  ), C = /* @__PURE__ */ D(
    Tl,
    {
      variant: "primary",
      styleOverrides: {
        padding: "16px 24px",
        height: "48px",
        borderRadius: "48px"
      },
      onClick: l,
      disabled: h,
      "data-testid": "select-route-button",
      fullWidth: !0,
      children: /* @__PURE__ */ D(Fe, { fontSize: "16px", fontWeight: 600, textTransform: "none", children: "Select Route" })
    }
  );
  return /* @__PURE__ */ D(
    fl,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      open: e,
      onClose: t,
      slotProps: {
        backdrop: {
          sx: {
            backdropFilter: "blur(4px)",
            WebkitBackdropFilter: "blur(4px)"
            // Safari support
          }
        }
      },
      children: /* @__PURE__ */ ne(
        wt,
        {
          sx: {
            backgroundColor: y.palette.background.paper,
            padding: "24px",
            borderRadius: "12px",
            gap: "16px",
            display: "flex",
            flexDirection: "column",
            width: "420px",
            backdropFilter: "blur(4px)",
            WebkitBackdropFilter: "blur(4px)"
            // Safari support
          },
          children: [
            M,
            /* @__PURE__ */ D(
              i9,
              {
                routesWithQuotes: o,
                highlightedRoute: i,
                quotes: c,
                fastestRoute: n,
                cheapestRoute: d,
                onRouteSelect: f,
                onGasChange: p
              }
            ),
            C
          ]
        }
      )
    }
  );
}
const ZF = Sn(HF);
function QF({
  routes: e,
  selectedRoute: t,
  onRouteChange: o,
  quotes: i,
  isLoading: c
}) {
  const n = Cr(), d = er(), f = Hi(d.breakpoints.down("sm")), { toNativeToken: p } = Ut((u) => ({
    ...u.relay
  })), [l, h] = Xe(!1), [y, M] = Xe(!1), [C, N] = Xe(), [w, S] = Xe(
    p * 100
  );
  St(() => {
    t && t !== C && N(t);
  }, [t]);
  const T = ht(() => {
    N(t), h(!1);
  }, [t]), E = ht(() => {
    M(!1);
  }, []), j = ht(() => {
    f ? M(!0) : h((u) => !u);
  }, [f]), O = ht((u) => {
    N(u);
  }, []), z = ht((u) => {
    S(u);
  }, []), k = ht(() => {
    C && o(C), w !== p && n(I8(w)), f ? M(!1) : h(!1);
  }, [
    C,
    o,
    w,
    p,
    n,
    f
  ]), H = e.filter((u) => i[u] !== void 0), W = H.reduce(
    (u, g) => {
      const v = i[g];
      return !v || !v.success ? u : v.eta !== void 0 && v.eta < u.eta && v.eta < 6e4 ? { name: g, eta: v.eta } : u;
    },
    { name: "", eta: 1 / 0 }
  ), U = H.reduce(
    (u, g) => {
      const v = i[g], A = ge.routes.get(g);
      if (!v || !v.success || !A.AUTOMATIC_DEPOSIT) return u;
      const L = BigInt(v.destinationToken.amount.amount);
      return L > u.amountOut ? { name: g, amountOut: L } : u;
    },
    { name: "", amountOut: 0n }
  ), B = t ? (() => {
    const u = i[t];
    return u != null && u.success ? u : void 0;
  })() : void 0, I = W.name ? ge.routes.get(W.name) : U.name ? ge.routes.get(U.name) : void 0, r = Ce(() => {
    if (t && t !== (I == null ? void 0 : I.rc.meta.name)) {
      const u = ge.routes.get(t);
      return /* @__PURE__ */ ne(Et, { children: [
        "Route",
        u.rc.meta.provider && /* @__PURE__ */ D(
          "span",
          {
            style: { fontWeight: 500 },
            children: ` via ${u.rc.meta.provider}`
          }
        )
      ] });
    } else
      return /* @__PURE__ */ ne(Et, { children: [
        "Best route",
        (I == null ? void 0 : I.rc.meta.provider) && /* @__PURE__ */ D(
          "span",
          {
            style: { fontWeight: 500 },
            children: ` via ${I == null ? void 0 : I.rc.meta.provider}`
          }
        )
      ] });
  }, [t, I]), s = Ce(() => !!t && t === C && p === w / 100, [t, C, p, w]);
  return !c && e.length === 0 ? /* @__PURE__ */ D(Et, {}) : /* @__PURE__ */ D(Et, { children: c ? /* @__PURE__ */ ne(
    wt,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        height: "54px",
        width: "100%",
        gap: "12px"
      },
      children: [
        /* @__PURE__ */ ne(
          wt,
          {
            sx: {
              display: "flex",
              height: "20px",
              width: "100%",
              justifyContent: "space-between"
            },
            children: [
              /* @__PURE__ */ D(
                $0,
                {
                  variant: "rounded",
                  height: 20,
                  width: "70%",
                  sx: { borderRadius: "20px" }
                }
              ),
              /* @__PURE__ */ D(
                $0,
                {
                  variant: "rounded",
                  height: 20,
                  width: "25%",
                  sx: { borderRadius: "20px" }
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ D(
          $0,
          {
            variant: "rounded",
            height: 20,
            width: "100%",
            sx: { borderRadius: "20px" }
          }
        )
      ]
    }
  ) : /* @__PURE__ */ ne(Et, { children: [
    /* @__PURE__ */ ne(
      wt,
      {
        sx: {
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          gap: "12px"
        },
        children: [
          /* @__PURE__ */ ne(Tt, { spacing: "12px", children: [
            /* @__PURE__ */ D(
              wt,
              {
                sx: {
                  color: d.palette.text.primary,
                  fontSize: "14px",
                  fontWeight: 700,
                  opacity: 0.5
                },
                children: r
              }
            ),
            /* @__PURE__ */ D(wt, { children: /* @__PURE__ */ ne(
              $i,
              {
                component: "span",
                "data-testid": "other-routes-toggle",
                underline: "none",
                sx: {
                  display: "flex",
                  alignItems: "center",
                  color: d.palette.text.primary,
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: 700,
                  opacity: 0.5
                },
                onClick: j,
                children: [
                  "View other routes",
                  /* @__PURE__ */ D(
                    OF,
                    {
                      fontSize: "small",
                      sx: { marginLeft: "4px" }
                    }
                  )
                ]
              }
            ) })
          ] }),
          /* @__PURE__ */ D(
            wt,
            {
              sx: {
                display: "flex",
                fontSize: "14px",
                justifyContent: "flex-end",
                opacity: 0.5
              },
              children: /* @__PURE__ */ ne(
                wt,
                {
                  sx: {
                    display: "flex",
                    height: "21px",
                    alignItems: "center",
                    gap: "4px"
                  },
                  children: [
                    /* @__PURE__ */ D(
                      zF,
                      {
                        sx: { color: "#7A8390", width: "12px", height: "12px" }
                      }
                    ),
                    /* @__PURE__ */ D(
                      Fe,
                      {
                        component: "span",
                        fontSize: "14px",
                        lineHeight: "14px",
                        sx: {
                          color: B != null && B.eta && B.eta < 60 * 1e3 ? d.palette.success.main : d.palette.text.primary
                        },
                        children: B != null && B.eta ? tl(B.eta) : "N/A"
                      }
                    )
                  ]
                }
              )
            }
          )
        ]
      }
    ),
    f ? /* @__PURE__ */ D(
      WF,
      {
        open: y,
        onOpen: () => M(!0),
        onClose: E,
        routesWithQuotes: H,
        highlightedRoute: C,
        quotes: i,
        fastestRoute: W,
        cheapestRoute: U,
        onRouteSelect: O,
        onGasChange: z,
        onSelectRoute: k,
        selectButtonDisabled: s
      }
    ) : /* @__PURE__ */ D(
      ZF,
      {
        open: l,
        onClose: T,
        routesWithQuotes: H,
        highlightedRoute: C,
        quotes: i,
        fastestRoute: W,
        cheapestRoute: U,
        onRouteSelect: O,
        onGasChange: z,
        onSelectRoute: k,
        selectButtonDisabled: s
      }
    )
  ] }) });
}
const VF = Sn(QF), GF = dn(
  /* @__PURE__ */ ne(
    "svg",
    {
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ D("rect", { y: "0.5", width: "36", height: "36", rx: "8", fill: "none" }),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M18.5 14.8235L15 11.3235L11.5 14.8235",
            stroke: "currentColor",
            "stroke-width": "1.5"
          }
        ),
        /* @__PURE__ */ D(
          "path",
          {
            d: "M24.5 21.8235L21 25.3235L17.5 21.8235",
            stroke: "currentColor",
            "stroke-width": "1.5"
          }
        ),
        /* @__PURE__ */ D("path", { d: "M21 25.3235L21 16.3235", stroke: "currentColor", "stroke-width": "1.5" }),
        /* @__PURE__ */ D("path", { d: "M15 11.3235L15 20.3235", stroke: "currentColor", "stroke-width": "1.5" })
      ]
    }
  ),
  "SwapVertical"
);
function $F() {
  const e = Cr(), t = er(), [o, i] = Xe(""), { isTransactionInProgress: c, fromChain: n, toChain: d } = Ut(
    (h) => h.transferInput
  ), f = Ce(
    () => ({
      swapButton: {
        display: "flex",
        position: "absolute",
        backgroundColor: t.palette.input.background,
        border: `2px solid ${t.palette.background.form}`,
        borderRadius: "8px",
        left: "calc(50% - 18px)",
        top: "calc(50% - 18px)",
        width: 36,
        height: 36,
        zIndex: 1,
        transition: "background-color 0.2s ease-in-out",
        animation: `${o} 0.3s linear 1`,
        "@keyframes spinRight": {
          "0%": {
            transform: "rotate(-180deg)"
          },
          "100%": {
            transform: "rotate(0deg)"
          }
        },
        "@keyframes spinLeft": {
          "0%": {
            transform: "rotate(180deg)"
          },
          "100%": {
            transform: "rotate(0deg)"
          }
        },
        "&:disabled": {
          backgroundColor: t.palette.input.background
        },
        "&:hover:not(:disabled)": {
          backgroundColor: t.palette.mode === "dark" ? Mr(t.palette.input.background).lighten(0.1).hex() : Mr(t.palette.input.background).darken(0.1).hex()
        }
      }
    }),
    [
      t.palette.background.form,
      t.palette.input.background,
      t.palette.mode,
      o
    ]
  ), p = !c && n && d, l = ht(() => {
    !p || c || (i(
      (h) => h === "spinRight" ? "spinLeft" : "spinRight"
    ), e(w8()), e(r8()), e(Hs("")));
  }, [p, c, e]);
  return /* @__PURE__ */ D(
    di,
    {
      sx: f.swapButton,
      disabled: !p,
      disableRipple: !0,
      onClick: l,
      children: /* @__PURE__ */ D(
        GF,
        {
          sx: {
            width: "36px",
            height: "36px",
            color: p ? t.palette.text.primary : t.palette.text.disabled
          }
        }
      )
    }
  );
}
const qF = sr.memo($F), JF = (e) => {
  var m, a;
  const [t, o] = Xe(""), [i, c] = Xe(!1), n = Cr(), d = wa(Vi), f = or(), p = Ce(
    () => ({
      alertBanner: {
        marginTop: "12px"
      },
      arrowIcon: {
        fontSize: "16px",
        margin: "0 4px"
      },
      card: {
        width: "100%",
        boxShadow: `0px 0px 3.5px 0px ${f.palette.primary.main}`
      },
      cardContent: {
        padding: "16px 20px",
        ":last-child": {
          padding: "16px 20px"
        }
      },
      cardActionArea: {
        height: "72px"
      },
      chainIconContainer: {
        border: `2px solid ${f.palette.input.background}`,
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2px"
      },
      completedIcon: {
        color: f.palette.success.main,
        height: "24px",
        width: "24px"
      },
      container: {
        width: "100%",
        maxWidth: "420px"
      },
      progressBar: {
        borderRadius: "4px",
        marginTop: "8px"
      }
    }),
    [f]
  ), { data: l } = e, {
    receipt: h,
    route: y,
    timestamp: M,
    txDetails: C,
    txHash: N
  } = l, {
    amount: w,
    eta: S,
    fromChain: T,
    toChain: E,
    token: j
  } = C || {}, O = ge.tokens.get(j), { seconds: z, minutes: k, totalSeconds: H, isRunning: W, restart: U } = i2.useTimer({
    expiryTimestamp: /* @__PURE__ */ new Date(),
    autoStart: !1,
    onExpire: () => c(!0)
  }), B = Ce(() => {
    if (S && M)
      return new Date(M + S);
  }, [S, M]), {
    isCompleted: I,
    isReadyToClaim: r,
    receipt: s
  } = s2({
    eta: B,
    receipt: h,
    route: y
  });
  St(() => {
    I && N && Hh(N);
  }, [I, N]);
  const u = s || h, g = Ce(() => {
    if (!S || !M)
      return 0;
    const x = Date.now() - M;
    return S < x ? 0 : S - x;
  }, [S, M, H]), v = Ce(() => r || l.isReadyToClaim ? "Ready to claim..." : i || g === 0 ? "Wrapping up..." : W ? cl(k, z) : /* @__PURE__ */ D(Or, { size: 16 }), [
    i,
    g,
    r,
    W,
    k,
    z,
    l
  ]), A = Ce(() => !S || g > S || !i && g === 0 ? 0 : i ? 100 : (S - g) / S * 100, [S, i, g]);
  St(() => {
    !W && !I && g && U(new Date(Date.now() + g), !0);
  }, [g, I, W, U]);
  const L = ht(async () => {
    if (o(""), !u) {
      o("No receipt found for this transaction");
      return;
    }
    try {
      const x = await gn(), V = new (ge.routes.get(y)).rc(x);
      n(ah(M)), n(Pc(C)), n(oh(!0)), n(Uc(y)), n(rl(C.toChain)), n(Nn("redeem")), d.setReceipt(u), d.setRoute(V);
    } catch {
      o(`Error resuming transaction: ${C.sendTx}`);
    }
  }, [n, u, y, d, M, C]);
  return !l || !O ? /* @__PURE__ */ D(Et, {}) : /* @__PURE__ */ ne(wt, { sx: p.container, children: [
    /* @__PURE__ */ D(bn, { sx: p.card, children: /* @__PURE__ */ D(
      Fo,
      {
        disableTouchRipple: !0,
        sx: p.cardActionArea,
        disabled: e.disabled || !C,
        onClick: L,
        children: /* @__PURE__ */ ne(xn, { sx: p.cardContent, children: [
          /* @__PURE__ */ ne(
            Tt,
            {
              direction: "row",
              alignItems: "center",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ D(Fe, { display: "flex", justifyContent: "space-between", children: I ? /* @__PURE__ */ D(c2, { sx: p.completedIcon }) : v }),
                /* @__PURE__ */ ne(Tt, { direction: "row", alignItems: "center", children: [
                  /* @__PURE__ */ D(Fe, { fontSize: 14, marginRight: "8px", children: `${cr(vn(w, 6))} ${O.symbol}` }),
                  /* @__PURE__ */ D(wt, { sx: p.chainIconContainer, children: /* @__PURE__ */ D(
                    Un,
                    {
                      icon: (m = ge.chains[T]) == null ? void 0 : m.icon,
                      height: 24
                    }
                  ) }),
                  /* @__PURE__ */ D($m, { sx: p.arrowIcon }),
                  /* @__PURE__ */ D(wt, { sx: p.chainIconContainer, children: /* @__PURE__ */ D(Un, { icon: (a = ge.chains[E]) == null ? void 0 : a.icon, height: 24 }) })
                ] })
              ]
            }
          ),
          !I && /* @__PURE__ */ D(
            a2,
            {
              variant: "determinate",
              value: A,
              sx: p.progressBar
            }
          )
        ] })
      }
    ) }),
    t && /* @__PURE__ */ D(
      Al,
      {
        sx: p.alertBanner,
        color: t ? f.palette.error.light : f.palette.grey.A400,
        error: !!t,
        children: t
      }
    )
  ] });
}, XF = (e) => {
  const t = er(), [o, i] = Xe();
  return St(() => {
    const c = $s(), n = c == null ? void 0 : c.filter((d) => {
      var f, p;
      if (!((f = d == null ? void 0 : d.txDetails) != null && f.token))
        return !1;
      try {
        return !!ge.tokens.get((p = d == null ? void 0 : d.txDetails) == null ? void 0 : p.token);
      } catch (l) {
        return console.log(
          "Error while parsing token from local storage (in-progress widget):",
          l
        ), !1;
      }
    });
    i(n);
  }, []), !o || o.length === 0 ? /* @__PURE__ */ D(Et, {}) : /* @__PURE__ */ ne(
    ut,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        marginBottom: "16px",
        alignItems: "center",
        justifyContent: "center",
        width: "100%"
      },
      children: [
        /* @__PURE__ */ D(
          ut,
          {
            sx: {
              width: "100%",
              display: "flex",
              alignItems: "center"
            },
            children: /* @__PURE__ */ D(Fe, { color: t.palette.text.secondary, fontSize: 14, children: "Transactions in progress" })
          }
        ),
        o.map((c) => /* @__PURE__ */ D(JF, { data: c, disabled: e.disabled }, c.txHash))
      ]
    }
  );
}, KF = (e) => {
  const t = or(), o = Ce(
    () => ({
      container: {
        width: "100%",
        maxWidth: "420px"
      },
      card: {
        width: "100%",
        borderRadius: "8px",
        border: `1px solid ${t.palette.input.border}`
      },
      cardHeader: {
        paddingBottom: 0
      }
    }),
    [t]
  ), {
    txHash: i,
    amount: c,
    amountUsd: n,
    fromChain: d,
    fromToken: f,
    toChain: p,
    toToken: l,
    receiveAmount: h,
    senderTimestamp: y,
    explorerLink: M
  } = e.data, C = Ce(
    () => /* @__PURE__ */ D(Fe, { component: "span", padding: "0px 8px", children: "·" }),
    []
  ), { getTokenPrice: N, lastTokenPriceUpdate: w } = Hr(), S = Ce(() => {
    const z = ge.chains[d];
    return /* @__PURE__ */ ne(Tt, { alignItems: "center", direction: "row", justifyContent: "flex-start", children: [
      /* @__PURE__ */ D(Pi, { chainConfig: z, token: f }),
      /* @__PURE__ */ ne(Tt, { direction: "column", marginLeft: "12px", children: [
        /* @__PURE__ */ ne(Fe, { fontSize: 16, children: [
          c,
          " ",
          f == null ? void 0 : f.symbol
        ] }),
        /* @__PURE__ */ ne(Fe, { color: t.palette.text.secondary, fontSize: 14, children: [
          n ? /* @__PURE__ */ ne(Et, { children: [
            Ws(n),
            C
          ] }) : null,
          z == null ? void 0 : z.displayName
        ] })
      ] })
    ] });
  }, [
    c,
    n,
    d,
    C,
    t.palette.text.secondary,
    f
  ]), T = Ce(() => {
    const z = ge.chains[p], k = l, H = h ? In(
      N,
      parseFloat(h),
      k
    ) : 0, W = H ? /* @__PURE__ */ ne(Et, { children: [
      H,
      C
    ] }) : null;
    return /* @__PURE__ */ ne(Tt, { alignItems: "center", direction: "row", justifyContent: "flex-start", children: [
      /* @__PURE__ */ D(Pi, { chainConfig: z, token: k }),
      /* @__PURE__ */ ne(Tt, { direction: "column", marginLeft: "12px", children: [
        /* @__PURE__ */ ne(Fe, { fontSize: 16, children: [
          h,
          " ",
          k == null ? void 0 : k.symbol
        ] }),
        /* @__PURE__ */ ne(Fe, { color: t.palette.text.secondary, fontSize: 14, children: [
          W,
          z == null ? void 0 : z.displayName
        ] })
      ] })
    ] });
  }, [
    w,
    p,
    l,
    h,
    N,
    C,
    t.palette.text.secondary
  ]), E = Ce(
    () => /* @__PURE__ */ D(
      Tt,
      {
        height: "24px",
        borderLeft: "1px solid #8B919D",
        marginLeft: "16px"
      }
    ),
    []
  ), j = Ce(() => {
    if (!y)
      return "Unknown time";
    const z = new Date(y), k = Date.now() - z.getTime();
    return k < 1e3 * 60 * 60 * 24 ? l8(k) : `${new Intl.DateTimeFormat("en-US", {
      dateStyle: "short",
      timeStyle: "short"
    }).format(z)}`;
  }, [y]), O = Ce(() => {
    const z = bo(d, i, "tx"), k = o8(i, 4, 4);
    return z ? /* @__PURE__ */ D(os, { url: z, text: k }) : k;
  }, [d, i]);
  return /* @__PURE__ */ D(wt, { sx: o.container, children: /* @__PURE__ */ D(bn, { sx: o.card, children: /* @__PURE__ */ ne(
    Fo,
    {
      disableTouchRipple: !0,
      onClick: () => {
        window.open(M, "_blank");
      },
      children: [
        /* @__PURE__ */ D(
          Xs,
          {
            sx: o.cardHeader,
            title: /* @__PURE__ */ ne(
              Fe,
              {
                justifyContent: "space-between",
                color: t.palette.text.secondary,
                display: "flex",
                children: [
                  /* @__PURE__ */ ne("span", { children: [
                    "Transaction #",
                    O
                  ] }),
                  /* @__PURE__ */ D("span", { children: j })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ ne(xn, { children: [
          S,
          E,
          T
        ] })
      ]
    }
  ) }) });
}, eR = () => {
  const e = er(), t = Hi(e.breakpoints.down("sm")), [o, i] = Xe(0), { transactions: c, isFetching: n, hasMore: d } = Xm({
    page: o
  }), f = Ut((M) => M.wallet.sending), p = Ce(
    () => ({
      container: {
        maxWidth: "420px"
      },
      containerMobile: {
        display: "flex",
        flexDirection: "column"
      },
      header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%"
      },
      infiniteScroller: {
        height: "640px",
        overflow: "auto",
        width: "100%"
      },
      txHistoryHeader: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        marginBottom: "16px"
      },
      spacer: {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        alignItems: "center",
        justifyContent: "center"
      }
    }),
    []
  ), l = Ce(() => /* @__PURE__ */ D(ut, { sx: p.txHistoryHeader, children: /* @__PURE__ */ D(Zs, { align: "left", size: 18, text: "Transaction history" }) }), [p.txHistoryHeader]), h = Ce(() => {
    if (c) {
      if (c.length === 0)
        return /* @__PURE__ */ D(ln, { color: e.palette.text.secondary, textAlign: "center", children: `No transactions found for the wallet ${ji(
          f.address
        )}` });
    } else return /* @__PURE__ */ D(Et, {});
    return /* @__PURE__ */ D(ut, { sx: p.infiniteScroller, children: /* @__PURE__ */ D(
      wc,
      {
        hasMore: d,
        loadMore: (M) => i(M),
        useWindow: !1,
        style: { scrollbarWidth: "thin" },
        children: /* @__PURE__ */ D(ut, { sx: p.spacer, children: c.map((M, C) => /* @__PURE__ */ D(KF, { data: M }, C)) })
      }
    ) });
  }, [
    d,
    f.address,
    p.infiniteScroller,
    p.spacer,
    e.palette.text.secondary,
    c
  ]), y = Ce(() => t ? p.containerMobile : p.container, [t, p.container, p.containerMobile]);
  return /* @__PURE__ */ ne(ut, { sx: { ...y }, children: [
    /* @__PURE__ */ D(Km, {}),
    l,
    c && c.length && !n ? h : /* @__PURE__ */ ne(
      ut,
      {
        sx: {
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          padding: "16px",
          alignItems: "center",
          justifyContent: "center"
        },
        children: [
          /* @__PURE__ */ D(ea, { variant: "rounded", height: 24, width: "100%" }),
          /* @__PURE__ */ D(ea, { variant: "rounded", height: 48, width: "100%" }),
          /* @__PURE__ */ D(ea, { variant: "rounded", height: 48, width: "100%" })
        ]
      }
    )
  ] });
}, tR = sr.memo(eR), rR = ({ validation: e }) => {
  const t = er(), o = !!e.error, i = !!e.warning, c = e.error || e.warning;
  return !o && !i ? null : /* @__PURE__ */ D(
    Al,
    {
      warning: i,
      error: o,
      color: e.error ? t.palette.error.main : t.palette.warning.main,
      children: c
    }
  );
}, nR = sr.memo(rR);
function iR() {
  var ye;
  const e = er(), t = Cr(), [o, i] = Xe(!1), { lastTokenCacheUpdate: c } = Hr(), [n, d] = Xe(!1), f = Hi(e.breakpoints.down("sm")), p = _r(null), l = Ce(
    () => ({
      assetPickerTitle: {
        color: e.palette.text.secondary,
        display: "flex",
        minHeight: "40px",
        alignItems: "center",
        justifyContent: "space-between"
      },
      bridgeContent: {
        margin: "auto",
        maxWidth: "452px"
      },
      bridgeHeader: {
        width: "100%",
        minHeight: "28px",
        display: "flex",
        alignItems: "center",
        padding: "20px 0"
      },
      doneIcon: {
        fontSize: "14px",
        color: e.palette.success.main
      },
      confirmTransaction: {
        padding: "8px 16px",
        height: "48px",
        margin: "auto",
        maxWidth: "420px",
        width: "100%"
      },
      copyIcon: {
        fontSize: "14px"
      },
      ctaContainer: {
        width: "100%"
      },
      formContent: {
        backgroundColor: e.palette.background.form + cn[30],
        borderRadius: "8px",
        padding: "20px 16px",
        display: "flex",
        flexDirection: "column",
        width: "452px",
        gap: "16px",
        backdropFilter: "blur(4px)",
        WebkitBackdropFilter: "blur(4px)"
        // Safari support
      },
      formContentMobile: {
        display: "flex",
        flexDirection: "column",
        gap: "16px"
      },
      titleContent: {
        maxWidth: f ? "420px" : "452px"
      }
    }),
    [
      f,
      e.palette.background.form,
      e.palette.success.main,
      e.palette.text.secondary
    ]
  ), { sending: h, receiving: y } = Ut(
    (Me) => Me.wallet
  ), {
    fromChain: M,
    toChain: C,
    route: N,
    preferredRouteName: w,
    amount: S,
    toNativeToken: T,
    isTransactionInProgress: E,
    validations: j
  } = Ut((Me) => ({
    ...Me.transferInput,
    ...Me.relay
  })), { sourceToken: O, destToken: z } = _o(), {
    allSupportedRoutes: k,
    sortedRoutes: H,
    sortedRoutesWithQuotes: W,
    quotes: U,
    isFetching: B
  } = rm({
    amount: S,
    fromChain: M,
    toChain: C,
    preferredRouteName: w,
    sourceToken: O,
    destToken: z,
    toNativeToken: T,
    receivingWallet: y
  }), { isFetching: I, supportedDestTokens: r } = em({
    sourceChain: M,
    destChain: C,
    sourceToken: O
  }), {
    error: s,
    errorInternal: u,
    onConfirm: g
  } = sm({ quotes: U });
  St(() => {
    if (W.length === 0)
      t(Di(""));
    else {
      const Me = W.find(
        (pt) => pt.route === w
      ), at = N ?? (Me == null ? void 0 : Me.route) ?? W[0].route, Ne = W.findIndex((pt) => pt.route === at) > -1;
      if (Ne || t(Di("")), !at || N && Ne)
        return;
      const Ae = W == null ? void 0 : W.find(
        (pt) => pt.route === at
      );
      Ae && t(Di(Ae.route));
    }
  }, [w, N, W, t]);
  const { isConnecting: v } = Lh(
    M,
    C
  );
  am();
  const A = Ce(() => Zh(j), [j]), L = Ce(
    () => ge.routes.allSupportedChains(),
    // Disabled because we're using the global cache and we have to monitor values that aren't directly used in this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ge.chains]
  ), m = Ce(() => M ? ge.tokens.getAllForChain(M) : [], [M, c]), a = Ce(() => ge.chainsArr.filter((Me) => Me.sdkName !== C && L.includes(Me.sdkName)), [C, L]), x = Ce(() => ge.chainsArr.filter(
    (Me) => Me.sdkName !== M && L.includes(Me.sdkName)
  ), [M, L]), V = Ce(() => {
    if (M && (h != null && h.address))
      return {
        chain: M,
        wallet: h,
        tokens: m
      };
  }, [M, h, m]), G = Ce(() => {
    if (C && (y != null && y.address))
      return {
        chain: C,
        wallet: y,
        tokens: ge.tokens.getAllForChain(C)
      };
  }, [C, y]), Z = cm({
    source: V,
    destination: G
  }), te = nm({
    balance: O ? (ye = Z.source.balances[O.key]) == null ? void 0 : ye.balance : null,
    routes: k,
    quotes: U,
    tokenSymbol: (O == null ? void 0 : O.symbol) ?? "",
    disabled: !M || !O
  }), q = ht(
    (Me) => {
      g8(t, Me, h), t(v8());
    },
    [t, h]
  ), R = ht(
    (Me) => {
      t(m8(Me.tuple));
    },
    [t]
  ), Q = ht(
    (Me) => {
      y8(t, Me, y), t(b8());
    },
    [t, y]
  ), $ = ht(
    (Me) => {
      t(Eh(Me.tuple));
    },
    [t]
  ), F = U && N ? U[N] : void 0, P = ht(() => {
    i((Me) => !Me), ge.triggerEvent({
      type: "history.load",
      details: {
        wallet: h == null ? void 0 : h.address
      }
    });
  }, [h == null ? void 0 : h.address]), _ = !(h != null && h.address) || E, X = ht(
    (Me) => {
      t(Di(Me));
    },
    [t]
  ), le = Ce(() => h != null && h.address && (y != null && y.address) ? null : h != null && h.address && !(y != null && y.address) ? {
    disabled: !C,
    side: "destination",
    type: ar.RECEIVING
  } : {
    disabled: !M,
    side: "source",
    type: ar.SENDING
  }, [
    h == null ? void 0 : h.address,
    y == null ? void 0 : y.address,
    C,
    M
  ]), { isCompatible: ie } = qm({
    sendingWallet: h,
    receivingWallet: y,
    sourceChain: M,
    destChain: C,
    routes: H
  }), oe = Ce(() => s ? /* @__PURE__ */ ne(wt, { sx: { marginBottom: 2 }, children: [
    /* @__PURE__ */ D(Al, { error: !0, testId: "send-error-message", children: s }),
    u && u.message && ge.ui.getHelpUrl ? /* @__PURE__ */ ne(Fe, { fontSize: 14, sx: { marginTop: 1 }, children: [
      "Having trouble?",
      " ",
      /* @__PURE__ */ ne(
        "a",
        {
          href: "#",
          onClick: () => {
            el(u.message), d(!0), setTimeout(() => d(!1), 3e3);
          },
          children: [
            "Copy the error logs",
            " ",
            n ? /* @__PURE__ */ D(G8, { sx: l.doneIcon }) : /* @__PURE__ */ D(V8, { sx: l.copyIcon })
          ]
        }
      ),
      " and ",
      /* @__PURE__ */ D("a", { href: ge.ui.getHelpUrl, target: "_blank", children: "ask for help" }),
      "."
    ] }) : null
  ] }) : null, [l.copyIcon, l.doneIcon, n, s, u]), pe = S && oi(S) > 0, se = h.address && y.address, ce = !M || !O || !C || !z || !se || !ie || !N || !A || B || !pe || E || !!te.error, me = Ce(() => /* @__PURE__ */ D(
    Tl,
    {
      disabled: ce,
      "data-testid": "confirm-transaction-button",
      variant: "primary",
      styleOverrides: l.confirmTransaction,
      onClick: () => g(),
      children: E ? /* @__PURE__ */ D(
        Fe,
        {
          display: "flex",
          alignItems: "center",
          gap: 1,
          textTransform: "none",
          children: f ? "Preparing" : "Preparing transaction"
        }
      ) : !E && B ? /* @__PURE__ */ D(
        Fe,
        {
          display: "flex",
          alignItems: "center",
          gap: 1,
          textTransform: "none",
          children: f ? "Refreshing" : "Refreshing quote"
        }
      ) : /* @__PURE__ */ D(Fe, { textTransform: "none", children: f ? "Confirm" : "Confirm transaction" })
    }
  ), [
    ce,
    l.confirmTransaction,
    E,
    f,
    B,
    g
  ]), de = !M || !O ? "Please select a source asset" : !C || !z ? "Please select a destination asset" : pe ? B ? "Loading quotes..." : N ? "" : "Please select a quote" : "Please enter an amount", ae = /* @__PURE__ */ ne(Et, { children: [
    /* @__PURE__ */ ne(Tt, { sx: { gap: "4px", position: "relative" }, children: [
      /* @__PURE__ */ D(wt, { ref: p, children: /* @__PURE__ */ D(
        ag,
        {
          chain: M,
          chainList: a,
          token: O,
          tokenList: m,
          setChain: q,
          setToken: R,
          wallet: h,
          isSource: !0,
          isTransactionInProgress: E,
          dataTestId: "source-asset-picker",
          isConnectingWallet: v,
          balances: Z.source.balances,
          isFetchingBalances: Z.isFetching,
          anchorEl: p.current,
          amountValidation: te
        }
      ) }),
      /* @__PURE__ */ D(qF, {}),
      /* @__PURE__ */ D(
        ag,
        {
          chain: C,
          chainList: x,
          token: z,
          sourceToken: O,
          tokenList: r,
          isFetchingQuotes: B,
          isFetchingTokens: r.length === 0 && I,
          setChain: Q,
          setToken: $,
          wallet: y,
          isSource: !1,
          isTransactionInProgress: E,
          dataTestId: "dest-asset-picker",
          isConnectingWallet: v,
          balances: Z.destination.balances,
          isFetchingBalances: Z.isFetching,
          quote: F != null && F.success ? F : void 0,
          anchorEl: p.current
        }
      )
    ] }),
    /* @__PURE__ */ D(wt, { component: "span", sx: l.ctaContainer, children: se ? /* @__PURE__ */ D($n, { title: de, children: /* @__PURE__ */ D("span", { children: me }) }) : le ? /* @__PURE__ */ D(lF, { ...le }) : null }),
    oe,
    /* @__PURE__ */ D(nR, { validation: te }),
    pe && /* @__PURE__ */ D(
      VF,
      {
        routes: H,
        selectedRoute: N,
        onRouteChange: X,
        quotes: U,
        isLoading: B
      }
    )
  ] }), Le = !(h != null && h.address) && "No connected wallets found" || (o ? "Show bridge" : "Show history");
  return /* @__PURE__ */ ne(wt, { sx: { ...l.bridgeContent }, "data-testid": "bridge-view", children: [
    /* @__PURE__ */ ne(wt, { sx: l.titleContent, children: [
      /* @__PURE__ */ D(Km, {}),
      ge.ui.showInProgressWidget && /* @__PURE__ */ D(XF, { disabled: E }),
      /* @__PURE__ */ ne(wt, { sx: l.bridgeHeader, children: [
        /* @__PURE__ */ D(
          Zs,
          {
            align: "left",
            text: ge.ui.title ?? "Wormhole Connect",
            size: 18,
            testId: "bridge-view-header"
          }
        ),
        /* @__PURE__ */ D($n, { title: Le, children: /* @__PURE__ */ D("span", { children: /* @__PURE__ */ D(
          di,
          {
            "data-testid": "history-button",
            "aria-label": o ? "Show bridge" : "Show history",
            sx: { padding: 0 },
            disabled: _,
            onClick: P,
            children: o ? /* @__PURE__ */ D(Jm, {}) : /* @__PURE__ */ D($8, {})
          }
        ) }) })
      ] })
    ] }),
    /* @__PURE__ */ D(
      wt,
      {
        sx: f ? { ...l.formContentMobile } : { ...l.formContent },
        children: o ? /* @__PURE__ */ D(tR, {}) : ae
      }
    ),
    /* @__PURE__ */ D(ll, { color: e.palette.text.primary }),
    /* @__PURE__ */ D(il, {})
  ] });
}
const oR = sr.memo(iR), aR = () => /* @__PURE__ */ ne("svg", { width: "0", height: "0", viewBox: "0 0 0 0", children: [
  /* @__PURE__ */ ne("defs", { children: [
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_tokens_sol_linearGradient_0",
        x1: "4.168",
        y1: "85.832",
        x2: "91.832",
        y2: "-1.832",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "#9945FF" }),
          /* @__PURE__ */ D("stop", { offset: ".2", stopColor: "#7962E7" }),
          /* @__PURE__ */ D("stop", { offset: "1", stopColor: "#00D18C" })
        ]
      }
    ),
    /* @__PURE__ */ D("clipPath", { id: "icons_tokens_sol_clipPath_0", children: /* @__PURE__ */ D("path", { fill: "#fff", d: "M0 0h96v84H0z" }) })
  ] }),
  /* @__PURE__ */ D("defs", { children: /* @__PURE__ */ D("clipPath", { id: "icons_chains_apt_clipPath_0", children: /* @__PURE__ */ D("rect", { width: "36", height: "36", fill: "white" }) }) }),
  /* @__PURE__ */ ne("defs", { children: [
    /* @__PURE__ */ ne(
      "radialGradient",
      {
        id: "icons_chains_osmo_radialGradient_0",
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "translate(653.009 167.889) scale(202.547 206.035)",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "#FFEAFF", stopOpacity: ".6" }),
          /* @__PURE__ */ D("stop", { offset: ".681", stopColor: "#A087C9" }),
          /* @__PURE__ */ D("stop", { offset: "1", stopColor: "#10002F" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "radialGradient",
      {
        id: "icons_chains_osmo_radialGradient_1",
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "translate(540.32 255.753) scale(495.56 504.093)",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "#FFEAFF", stopOpacity: ".6" }),
          /* @__PURE__ */ D("stop", { offset: ".681", stopColor: "#A087C9" }),
          /* @__PURE__ */ D("stop", { offset: "1", stopColor: "#10002F" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_0",
        x1: "331.959",
        x2: "415.726",
        y1: "687.445",
        y2: "179.399",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "#81FFFF" }),
          /* @__PURE__ */ D("stop", { offset: ".62", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_1",
        x1: "551.129",
        x2: "338.385",
        y1: "258.408",
        y2: "450.302",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { offset: ".289", stopColor: "#fff" }),
          /* @__PURE__ */ D("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_2",
        x1: "131.705",
        x2: "613.118",
        y1: "553.353",
        y2: "553.353",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "#0002E9" }),
          /* @__PURE__ */ D("stop", { offset: ".995", stopColor: "#FF00C7" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_3",
        x1: "635.906",
        x2: "369.659",
        y1: "452.584",
        y2: "699.942",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { offset: ".289", stopColor: "#fff" }),
          /* @__PURE__ */ D("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_4",
        x1: "131.705",
        x2: "389.259",
        y1: "553.352",
        y2: "553.352",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "#000292" }),
          /* @__PURE__ */ D("stop", { offset: ".995", stopColor: "#7D00C7" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_5",
        x1: "132.029",
        x2: "612.795",
        y1: "453.743",
        y2: "453.743",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "#000292" }),
          /* @__PURE__ */ D("stop", { offset: ".995", stopColor: "#BE00C7" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_6",
        x1: "604.91",
        x2: "569.494",
        y1: "191.453",
        y2: "248.03",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { offset: ".289", stopColor: "#fff" }),
          /* @__PURE__ */ D("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_7",
        x1: "343.013",
        x2: "362.187",
        y1: "613.233",
        y2: "613.233",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { offset: ".289", stopColor: "#fff" }),
          /* @__PURE__ */ D("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_8",
        x1: "409.132",
        x2: "428.305",
        y1: "606.695",
        y2: "606.695",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { offset: ".289", stopColor: "#fff" }),
          /* @__PURE__ */ D("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_9",
        x1: "379.785",
        x2: "394.18",
        y1: "639.688",
        y2: "639.688",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { offset: ".289", stopColor: "#fff" }),
          /* @__PURE__ */ D("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_10",
        x1: "438.053",
        x2: "452.447",
        y1: "632.755",
        y2: "632.755",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { offset: ".289", stopColor: "#fff" }),
          /* @__PURE__ */ D("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_11",
        x1: "281.083",
        x2: "312.395",
        y1: "600.365",
        y2: "600.365",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { offset: ".289", stopColor: "#fff" }),
          /* @__PURE__ */ D("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_12",
        x1: "467.049",
        x2: "498.361",
        y1: "548.259",
        y2: "548.259",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { offset: ".289", stopColor: "#fff" }),
          /* @__PURE__ */ D("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ D("clipPath", { id: "icons_chains_osmo_clipPath_0", children: /* @__PURE__ */ D("rect", { width: "800", height: "800", fill: "#fff" }) })
  ] }),
  /* @__PURE__ */ ne("defs", { children: [
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "linearGradient_icons_chains_sol_0",
        x1: "21.9203",
        y1: "4.40983",
        x2: "9.65997",
        y2: "27.9398",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "#00FFA3" }),
          /* @__PURE__ */ D("stop", { offset: "1", stopColor: "#DC1FFF" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "linearGradient_icons_chains_sol_1",
        x1: "21.9203",
        y1: "4.40982",
        x2: "9.65999",
        y2: "27.9398",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "#00FFA3" }),
          /* @__PURE__ */ D("stop", { offset: "1", stopColor: "#DC1FFF" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "linearGradient_icons_chains_sol_2",
        x1: "21.9203",
        y1: "4.40983",
        x2: "9.66001",
        y2: "27.9398",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "#00FFA3" }),
          /* @__PURE__ */ D("stop", { offset: "1", stopColor: "#DC1FFF" })
        ]
      }
    )
  ] }),
  /* @__PURE__ */ D("defs", { children: /* @__PURE__ */ D("clipPath", { id: "icons_chains_sui_clipPath_0", children: /* @__PURE__ */ D("rect", { width: "18", height: "24", fill: "white", transform: "translate(9 6)" }) }) }),
  /* @__PURE__ */ ne("defs", { children: [
    /* @__PURE__ */ ne(
      "radialGradient",
      {
        id: "icons_chains_uni_radialGradient_0",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(18.4297 18) rotate(90) scale(18 17.93)",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "#FC74FE" }),
          /* @__PURE__ */ D("stop", { offset: "1", stopColor: "#F50DB4" })
        ]
      }
    ),
    /* @__PURE__ */ D("clipPath", { id: "icons_chains_uni_clipPath_0", children: /* @__PURE__ */ D(
      "rect",
      {
        width: "36",
        height: "36",
        fill: "white",
        transform: "translate(0.429688)"
      }
    ) })
  ] }),
  /* @__PURE__ */ D("defs", { children: /* @__PURE__ */ ne(
    "linearGradient",
    {
      id: "icons_chains_xlayer_linearGradient_0",
      x1: "34",
      y1: "35.4996",
      x2: "1.5",
      y2: "3.49957",
      gradientUnits: "userSpaceOnUse",
      children: [
        /* @__PURE__ */ D("stop", { stopColor: "#040404" }),
        /* @__PURE__ */ D("stop", { offset: "1", stopColor: "#282828" })
      ]
    }
  ) }),
  /* @__PURE__ */ D("defs", { children: /* @__PURE__ */ D("clipPath", { id: "icons_tokens_busd_clipPath_0", children: /* @__PURE__ */ D("rect", { width: "199.401", height: "200", fill: "white" }) }) }),
  /* @__PURE__ */ D("defs", { children: /* @__PURE__ */ D("clipPath", { id: "icons_tokens_dai_clipPath_0", children: /* @__PURE__ */ D("rect", { width: "200", height: "200", fill: "white" }) }) }),
  /* @__PURE__ */ ne("defs", { children: [
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_tokens_inj_linearGradient_0",
        x1: "100",
        y1: "300",
        x2: "500",
        y2: "300",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "#0082FA" }),
          /* @__PURE__ */ D("stop", { offset: "1", stopColor: "#00F2FE" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_tokens_inj_linearGradient_1",
        x1: "100",
        y1: "300",
        x2: "500",
        y2: "300",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "#0082FA" }),
          /* @__PURE__ */ D("stop", { offset: "1", stopColor: "#00F2FE" })
        ]
      }
    )
  ] }),
  /* @__PURE__ */ ne("defs", { children: [
    /* @__PURE__ */ ne(
      "filter",
      {
        id: "icons_tokens_ntt_filter_0",
        x: "36.0726",
        y: "19.3241",
        width: "12.6301",
        height: "12.6306",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [
          /* @__PURE__ */ D("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
          /* @__PURE__ */ D(
            "feBlend",
            {
              mode: "normal",
              in: "SourceGraphic",
              in2: "BackgroundImageFix",
              result: "shape"
            }
          ),
          /* @__PURE__ */ D(
            "feGaussianBlur",
            {
              stdDeviation: "1.18048",
              result: "effect1_foregroundBlur_4160_67832"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_tokens_ntt_linearGradient_0",
        x1: "76.3139",
        y1: "25.3915",
        x2: "10.1678",
        y2: "25.3915",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(1, 0, 0, 1, 307.155052, 224.001474)",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "white", stopOpacity: "0" }),
          /* @__PURE__ */ D("stop", { offset: "0.5142", stopColor: "white" }),
          /* @__PURE__ */ D("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_tokens_ntt_linearGradient_1",
        x1: "42.748",
        y1: "1.55322",
        x2: "42.748",
        y2: "50.4438",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(1, 0, 0, 1, 307.155052, 224.001474)",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "white" }),
          /* @__PURE__ */ D("stop", { offset: "0.4519", stopColor: "white", stopOpacity: "0" }),
          /* @__PURE__ */ D("stop", { offset: "0.5397", stopColor: "white", stopOpacity: "0" }),
          /* @__PURE__ */ D("stop", { offset: "1", stopColor: "white" })
        ]
      }
    )
  ] }),
  /* @__PURE__ */ ne("defs", { children: [
    /* @__PURE__ */ ne(
      "radialGradient",
      {
        id: "icons_chains_osmo_radialGradient_0",
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "translate(653.009 167.889) scale(202.547 206.035)",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "#FFEAFF", stopOpacity: ".6" }),
          /* @__PURE__ */ D("stop", { offset: ".681", stopColor: "#A087C9" }),
          /* @__PURE__ */ D("stop", { offset: "1", stopColor: "#10002F" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "radialGradient",
      {
        id: "icons_chains_osmo_radialGradient_1",
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "translate(540.32 255.753) scale(495.56 504.093)",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "#FFEAFF", stopOpacity: ".6" }),
          /* @__PURE__ */ D("stop", { offset: ".681", stopColor: "#A087C9" }),
          /* @__PURE__ */ D("stop", { offset: "1", stopColor: "#10002F" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_0",
        x1: "331.959",
        x2: "415.726",
        y1: "687.445",
        y2: "179.399",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "#81FFFF" }),
          /* @__PURE__ */ D("stop", { offset: ".62", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_1",
        x1: "551.129",
        x2: "338.385",
        y1: "258.408",
        y2: "450.302",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { offset: ".289", stopColor: "#fff" }),
          /* @__PURE__ */ D("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_2",
        x1: "131.705",
        x2: "613.118",
        y1: "553.353",
        y2: "553.353",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "#0002E9" }),
          /* @__PURE__ */ D("stop", { offset: ".995", stopColor: "#FF00C7" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_3",
        x1: "635.906",
        x2: "369.659",
        y1: "452.584",
        y2: "699.942",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { offset: ".289", stopColor: "#fff" }),
          /* @__PURE__ */ D("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_4",
        x1: "131.705",
        x2: "389.259",
        y1: "553.352",
        y2: "553.352",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "#000292" }),
          /* @__PURE__ */ D("stop", { offset: ".995", stopColor: "#7D00C7" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_5",
        x1: "132.029",
        x2: "612.795",
        y1: "453.743",
        y2: "453.743",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { stopColor: "#000292" }),
          /* @__PURE__ */ D("stop", { offset: ".995", stopColor: "#BE00C7" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_6",
        x1: "604.91",
        x2: "569.494",
        y1: "191.453",
        y2: "248.03",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { offset: ".289", stopColor: "#fff" }),
          /* @__PURE__ */ D("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_7",
        x1: "343.013",
        x2: "362.187",
        y1: "613.233",
        y2: "613.233",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { offset: ".289", stopColor: "#fff" }),
          /* @__PURE__ */ D("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_8",
        x1: "409.132",
        x2: "428.305",
        y1: "606.695",
        y2: "606.695",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { offset: ".289", stopColor: "#fff" }),
          /* @__PURE__ */ D("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_9",
        x1: "379.785",
        x2: "394.18",
        y1: "639.688",
        y2: "639.688",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { offset: ".289", stopColor: "#fff" }),
          /* @__PURE__ */ D("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_10",
        x1: "438.053",
        x2: "452.447",
        y1: "632.755",
        y2: "632.755",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { offset: ".289", stopColor: "#fff" }),
          /* @__PURE__ */ D("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_11",
        x1: "281.083",
        x2: "312.395",
        y1: "600.365",
        y2: "600.365",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { offset: ".289", stopColor: "#fff" }),
          /* @__PURE__ */ D("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ ne(
      "linearGradient",
      {
        id: "icons_chains_osmo_linearGradient_12",
        x1: "467.049",
        x2: "498.361",
        y1: "548.259",
        y2: "548.259",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ D("stop", { offset: ".289", stopColor: "#fff" }),
          /* @__PURE__ */ D("stop", { offset: ".78", stopColor: "#fff", stopOpacity: "0" })
        ]
      }
    ),
    /* @__PURE__ */ D("clipPath", { id: "icons_chains_osmo_clipPath_0", children: /* @__PURE__ */ D("rect", { width: "800", height: "800", fill: "#fff" }) })
  ] }),
  /* @__PURE__ */ D("defs", { children: /* @__PURE__ */ D("clipPath", { id: "icons_tokens_usdt_clipPath_0", children: /* @__PURE__ */ D("rect", { width: "229.912", height: "200", fill: "white" }) }) }),
  /* @__PURE__ */ D("defs", { children: /* @__PURE__ */ D("clipPath", { id: "icons_tokens_wbtc_clipPath_0", children: /* @__PURE__ */ D("rect", { width: "200", height: "200.022", fill: "white" }) }) })
] }), sR = () => {
  const e = or(), t = wa(Vi), o = Ut((f) => f.router.route), i = Cr(), c = HL(o), { hasExternalSearch: n } = lE();
  St(() => {
    const f = "redeem", p = "bridge";
    c === f && o !== f && (i(i1()), i(OL()), t.clear()), o === p && c !== p && c !== "history" && i(x8());
  }, [o, c, i, t]), St(() => {
    n && (i(i1()), i(Nn("search")));
  }, [n, i]);
  const d = Ce(() => fS("enableUIRefreshV3") ? /* @__PURE__ */ D(oR, {}) : /* @__PURE__ */ D(VB, {}), []);
  return /* @__PURE__ */ ne(
    ut,
    {
      sx: {
        textAlign: "left",
        margin: "40px auto",
        maxWidth: "900px",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        padding: "16px",
        fontFamily: e.typography.fontFamily,
        [e.breakpoints.down("sm")]: {
          margin: "0 auto"
        }
      },
      children: [
        /* @__PURE__ */ D(aR, {}),
        o === "bridge" && d,
        o === "redeem" && /* @__PURE__ */ D(XB, {}),
        o === "search" && /* @__PURE__ */ D(cE, {}),
        o === "history" && /* @__PURE__ */ D(rF, {}),
        o === "terms" && /* @__PURE__ */ D(mS, {})
      ]
    }
  );
};
function cR(e) {
  const t = Cr(), o = _r(!1), i = _r(!0), c = Ut((d) => d.router.route), n = ht((d) => {
    s8(d) || JL(d), o.current = !0, ge.triggerEvent({
      type: "config",
      config: d
    });
  }, []);
  return o.current || (e.config && n(e.config), c !== "bridge" && t(Nn("bridge"))), St(() => {
    i.current ? (i.current = !1, ge.triggerEvent({
      type: "load",
      config: e.config
    })) : e.config && (n(e.config), t(x8()));
  }, [e.config, n, t]), /* @__PURE__ */ D(sR, {});
}
const lR = {
  mode: "light",
  primary: { main: "#9892e6" },
  secondary: { main: "#cccccc" },
  divider: "#a0a2a9",
  background: {
    default: "transparent",
    form: "#ffffff"
  },
  text: {
    primary: k0[900],
    secondary: "#7d7d7d"
  },
  error: { main: "#f44336" },
  info: {
    main: "#A4C8F3"
  },
  success: { main: "#4caf50" },
  warning: { main: "#ff9800" },
  button: {
    primary: "#ffffff",
    primaryText: k0[900],
    disabled: "#c8cad1",
    disabledText: k0[800],
    action: "#F3A01E",
    actionText: "#000000",
    hover: "#b7b9c1"
  },
  options: {
    hover: "#f9f9fb",
    select: "#F0F0F5"
  },
  card: {
    background: "#ffffff",
    elevation: "10px 10px 30px 15px #CCD2E7",
    secondary: "#F0F0F5"
  },
  popover: {
    background: "#ffffff",
    elevation: "10px 10px 30px 15px #CCD2E7",
    secondary: "#F0F0F5"
  },
  input: {
    background: "#f9f9f9",
    border: "#DEE0E3",
    fillTreatment: !0
  },
  font: '"Inter", sans-serif',
  logo: "#000000"
}, fR = {
  mode: "dark",
  primary: { main: "#AFA7F6" },
  secondary: { main: "#667085" },
  divider: "#ffffff" + cn[20],
  background: {
    default: "transparent",
    form: "#333333"
  },
  text: {
    primary: "#ffffff",
    secondary: "#79859e"
  },
  info: {
    main: "#304C70"
  },
  error: {
    main: "#F04438"
  },
  success: {
    main: "#12B76A"
  },
  warning: {
    main: "#F79009"
  },
  button: {
    primary: "#ffffff" + cn[10],
    primaryText: "#ffffff",
    disabled: "#ffffff" + cn[7],
    disabledText: "#ffffff" + cn[40],
    action: "#ffffff",
    actionText: "#000000",
    hover: "#ffffff" + cn[7]
  },
  options: {
    hover: "#ffffff" + cn[7],
    select: "#ffffff" + cn[10]
  },
  card: {
    background: "#1b2033",
    secondary: "#ffffff" + cn[5],
    elevation: "none"
  },
  popover: {
    background: "#1b2033",
    secondary: "#ffffff" + cn[5],
    elevation: "none"
  },
  input: {
    background: "#1B1A21",
    border: "#2B2A2E",
    fillTreatment: !0
  },
  font: '"Inter", sans-serif',
  logo: "#ffffff"
}, uR = (e) => {
  const o = e.mode === "light" ? lR : fR, i = Object.assign({}, o);
  if (e) {
    e.background && (i.background = {
      default: e.background
    }), e.input && (i.input = {
      ...i.input,
      background: e.input,
      border: e.secondary || i.secondary.main
    }), e.inputFillTreatment !== void 0 && (i.input.fillTreatment = e.inputFillTreatment), e.primary && (i.primary = {
      main: e.primary
    }), e.secondary && (i.secondary = {
      main: e.secondary
    }), e.text && (i.text.primary = e.text), e.textSecondary && (i.text.secondary = e.textSecondary), e.error && (i.error = {
      main: e.error
    }), e.success && (i.success = {
      main: e.success
    });
    const c = Mr(e.primary || i.primary.main);
    let n, d, f, p, l, h;
    c.isDark() ? (n = c.lightness(95).hex(), d = c.alpha(0.5).hexa(), f = c.lightness(95).alpha(0.9).hexa(), p = c.darken(0.15).hex(), l = c.lightness(80).hex(), h = c.darken(0.05).hex()) : (n = c.lightness(5).hex(), d = c.alpha(0.5).hexa(), f = c.lightness(5).alpha(0.9).hexa(), p = c.lighten(0.05).hex(), l = c.lightness(0).hex(), h = c.lighten(0.05).hex()), i.button = {
      primary: c.hex(),
      primaryText: n,
      disabled: d,
      disabledText: f,
      action: p,
      actionText: l,
      hover: h
    };
  }
  return kc({
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            boxShadow: "none"
          }
        }
      },
      MuiCollapse: {
        styleOverrides: {
          root: {
            width: "100%"
          }
        }
      }
    },
    breakpoints: {
      values: {
        xs: 300,
        sm: 500,
        md: 650,
        lg: 900,
        xl: 1200
      }
    },
    typography: {
      fontFamily: e.font ?? '"Inter", sans-serif'
    },
    palette: {
      ...i
    }
  });
};
class dR extends sr.Component {
  constructor(t) {
    super(t), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError(t) {
    return { hasError: !0 };
  }
  componentDidCatch(t, o) {
    console.error(t, o);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ D(Q1, { children: /* @__PURE__ */ D(
      ln,
      {
        variant: "h5",
        style: { textAlign: "center", marginTop: 24, marginBottom: 24 },
        children: "An unexpected error has occurred. Please refresh the page."
      }
    ) }) : this.props.children;
  }
}
function PR({
  config: e,
  theme: t
}) {
  ue.useEffect(() => {
    globalThis.dispatchReduxAction || (window.dispatchReduxAction = (i) => {
      J5.dispatch(i);
    });
  }, []);
  const o = ue.useMemo(
    () => uR(t ?? { mode: "dark" }),
    [t]
  );
  return /* @__PURE__ */ D(kb, { store: J5, children: /* @__PURE__ */ D(Xb, { theme: o, children: /* @__PURE__ */ D($g, { enableColorScheme: !0, children: /* @__PURE__ */ D(dR, { children: /* @__PURE__ */ D(Sj, { children: /* @__PURE__ */ D(TS, { children: /* @__PURE__ */ D(cR, { config: e }) }) }) }) }) }) });
}
const {
  AutomaticTokenBridgeRoute: UR,
  TokenBridgeRoute: YR,
  AutomaticCCTPRoute: WR,
  CCTPRoute: HR,
  AutomaticPorticoRoute: ZR
} = O9;
export {
  tm as $,
  ge as A,
  F5 as B,
  vr as C,
  Ih as D,
  TR as E,
  kR as F,
  s8 as G,
  _R as H,
  gT as I,
  kM as J,
  BR as K,
  PR as L,
  jw as M,
  OR as N,
  h8 as O,
  ha as P,
  QL as Q,
  UR as R,
  LR as S,
  sC as T,
  YR as U,
  WR as V,
  oL as W,
  HR as X,
  ZR as Y,
  AR as Z,
  va as _,
  Ay as a,
  qT as a0,
  SR as a1,
  ER as a2,
  DR as a3,
  jR as a4,
  _5 as a5,
  JT as a6,
  XT as a7,
  XM as a8,
  KT as a9,
  eL as aa,
  tL as ab,
  c1 as b,
  Qy as c,
  aI as d,
  Na as e,
  Os as f,
  Wy as g,
  Py as h,
  Yt as i,
  CN as j,
  zy as k,
  jy as l,
  hN as m,
  iN as n,
  nN as o,
  Wc as p,
  gn as q,
  Ds as r,
  gN as s,
  js as t,
  aL as u,
  zR as v,
  xN as w,
  hs as x,
  FR as y,
  cc as z
};
